import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  date: any;
  geography: any;
  geometry: any;
  jsonb: any;
  numeric: any;
  smallint: any;
  time: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};

/** columns and relationships of "amenities" */
export type Amenities = {
  __typename?: 'Amenities';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "amenities". All fields are combined with a logical 'AND'. */
export type AmenitiesBoolExp = {
  _and?: InputMaybe<Array<AmenitiesBoolExp>>;
  _not?: InputMaybe<AmenitiesBoolExp>;
  _or?: InputMaybe<Array<AmenitiesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum AmenitiesEnum {
  AccessibleParking = 'ACCESSIBLE_PARKING',
  AirConditioning = 'AIR_CONDITIONING',
  Backboard = 'BACKBOARD',
  Bar = 'BAR',
  Cafe = 'CAFE',
  ChildFriendly = 'CHILD_FRIENDLY',
  DogFriendly = 'DOG_FRIENDLY',
  EquipmentRental = 'EQUIPMENT_RENTAL',
  Food = 'FOOD',
  FreeWifi = 'FREE_WIFI',
  Lights = 'LIGHTS',
  LockerRooms = 'LOCKER_ROOMS',
  OutdoorSeating = 'OUTDOOR_SEATING',
  Parking = 'PARKING',
  ProShop = 'PRO_SHOP',
  Restaurant = 'RESTAURANT',
  Restrooms = 'RESTROOMS',
  Shower = 'SHOWER',
  Training = 'TRAINING',
  Water = 'WATER',
  WheelchairAccessible = 'WHEELCHAIR_ACCESSIBLE'
}

/** Boolean expression to compare columns of type "AmenitiesEnum". All fields are combined with logical 'AND'. */
export type AmenitiesEnumComparisonExp = {
  _eq?: InputMaybe<AmenitiesEnum>;
  _in?: InputMaybe<Array<AmenitiesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<AmenitiesEnum>;
  _nin?: InputMaybe<Array<AmenitiesEnum>>;
};

/** Ordering options when selecting data from "amenities". */
export type AmenitiesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "amenities" */
export enum AmenitiesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "amenities" */
export type AmenitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AmenitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmenitiesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "app_personas" */
export type AppPersonas = {
  __typename?: 'AppPersonas';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "app_personas". All fields are combined with a logical 'AND'. */
export type AppPersonasBoolExp = {
  _and?: InputMaybe<Array<AppPersonasBoolExp>>;
  _not?: InputMaybe<AppPersonasBoolExp>;
  _or?: InputMaybe<Array<AppPersonasBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum AppPersonasEnum {
  Admin = 'ADMIN',
  Coach = 'COACH',
  Organizer = 'ORGANIZER',
  Player = 'PLAYER',
  System = 'SYSTEM'
}

/** Boolean expression to compare columns of type "AppPersonasEnum". All fields are combined with logical 'AND'. */
export type AppPersonasEnumComparisonExp = {
  _eq?: InputMaybe<AppPersonasEnum>;
  _in?: InputMaybe<Array<AppPersonasEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<AppPersonasEnum>;
  _nin?: InputMaybe<Array<AppPersonasEnum>>;
};

/** Ordering options when selecting data from "app_personas". */
export type AppPersonasOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "app_personas" */
export enum AppPersonasSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "app_personas" */
export type AppPersonasStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AppPersonasStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppPersonasStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "app_pings" */
export type AppPings = {
  __typename?: 'AppPings';
  id: Scalars['uuid'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** Boolean expression to filter rows from the table "app_pings". All fields are combined with a logical 'AND'. */
export type AppPingsBoolExp = {
  _and?: InputMaybe<Array<AppPingsBoolExp>>;
  _not?: InputMaybe<AppPingsBoolExp>;
  _or?: InputMaybe<Array<AppPingsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "app_pings" */
export enum AppPingsConstraint {
  /** unique or primary key constraint on columns "id" */
  AppPingsPkey = 'app_pings_pkey'
}

/** input type for inserting data into table "app_pings" */
export type AppPingsInsertInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  firebaseId?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  ipResponse?: InputMaybe<Scalars['jsonb']>;
  pathname?: InputMaybe<Scalars['String']>;
  /** iOS, Android, Web */
  platform?: InputMaybe<Scalars['String']>;
  queryString?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "app_pings" */
export type AppPingsMutationResponse = {
  __typename?: 'AppPingsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppPings>;
};

/** on_conflict condition type for table "app_pings" */
export type AppPingsOnConflict = {
  constraint: AppPingsConstraint;
  updateColumns?: Array<AppPingsUpdateColumn>;
  where?: InputMaybe<AppPingsBoolExp>;
};

/** Ordering options when selecting data from "app_pings". */
export type AppPingsOrderBy = {
  id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** select columns of table "app_pings" */
export enum AppPingsSelectColumn {
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "app_pings" */
export type AppPingsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AppPingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppPingsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** placeholder for update columns of table "app_pings" (current role has no relevant permissions) */
export enum AppPingsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "ball_types" */
export type BallTypes = {
  __typename?: 'BallTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "ball_types". All fields are combined with a logical 'AND'. */
export type BallTypesBoolExp = {
  _and?: InputMaybe<Array<BallTypesBoolExp>>;
  _not?: InputMaybe<BallTypesBoolExp>;
  _or?: InputMaybe<Array<BallTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum BallTypesEnum {
  Custom = 'CUSTOM',
  FranklinX_40Pickleball = 'FRANKLIN_X_40_PICKLEBALL',
  GammaPhotonPickleball = 'GAMMA_PHOTON_PICKLEBALL',
  NotSelected = 'NOT_SELECTED',
  OnixDuraFast_40Pickleball = 'ONIX_DURA_FAST_40_PICKLEBALL',
  OnixFuseG2Pickleball = 'ONIX_FUSE_G2_PICKLEBALL',
  SelkirkProS1Pickleball = 'SELKIRK_PRO_S1_PICKLEBALL'
}

/** Boolean expression to compare columns of type "BallTypesEnum". All fields are combined with logical 'AND'. */
export type BallTypesEnumComparisonExp = {
  _eq?: InputMaybe<BallTypesEnum>;
  _in?: InputMaybe<Array<BallTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BallTypesEnum>;
  _nin?: InputMaybe<Array<BallTypesEnum>>;
};

/** Ordering options when selecting data from "ball_types". */
export type BallTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "ball_types" */
export enum BallTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "ball_types" */
export type BallTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BallTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BallTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "birthday_visibility" */
export type BirthdayVisibility = {
  __typename?: 'BirthdayVisibility';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "birthday_visibility". All fields are combined with a logical 'AND'. */
export type BirthdayVisibilityBoolExp = {
  _and?: InputMaybe<Array<BirthdayVisibilityBoolExp>>;
  _not?: InputMaybe<BirthdayVisibilityBoolExp>;
  _or?: InputMaybe<Array<BirthdayVisibilityBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum BirthdayVisibilityEnum {
  HideYear = 'HIDE_YEAR',
  Visible = 'VISIBLE'
}

/** Boolean expression to compare columns of type "BirthdayVisibilityEnum". All fields are combined with logical 'AND'. */
export type BirthdayVisibilityEnumComparisonExp = {
  _eq?: InputMaybe<BirthdayVisibilityEnum>;
  _in?: InputMaybe<Array<BirthdayVisibilityEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BirthdayVisibilityEnum>;
  _nin?: InputMaybe<Array<BirthdayVisibilityEnum>>;
};

/** Ordering options when selecting data from "birthday_visibility". */
export type BirthdayVisibilityOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "birthday_visibility" */
export enum BirthdayVisibilitySelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "birthday_visibility" */
export type BirthdayVisibilityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BirthdayVisibilityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BirthdayVisibilityStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "booking_config_change_types" */
export type BookingConfigChangeTypes = {
  __typename?: 'BookingConfigChangeTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "booking_config_change_types". All fields are combined with a logical 'AND'. */
export type BookingConfigChangeTypesBoolExp = {
  _and?: InputMaybe<Array<BookingConfigChangeTypesBoolExp>>;
  _not?: InputMaybe<BookingConfigChangeTypesBoolExp>;
  _or?: InputMaybe<Array<BookingConfigChangeTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum BookingConfigChangeTypesEnum {
  /** Club approved the terms */
  Authorized = 'AUTHORIZED',
  /** Integration paused */
  Paused = 'PAUSED',
  /** Discount tiers changed */
  PricingUpdated = 'PRICING_UPDATED',
  /** Integration resumed */
  Resumed = 'RESUMED',
  /** Schedule mode or windows changed */
  ScheduleUpdated = 'SCHEDULE_UPDATED',
  /** Booking system changed */
  SystemChanged = 'SYSTEM_CHANGED'
}

/** Boolean expression to compare columns of type "BookingConfigChangeTypesEnum". All fields are combined with logical 'AND'. */
export type BookingConfigChangeTypesEnumComparisonExp = {
  _eq?: InputMaybe<BookingConfigChangeTypesEnum>;
  _in?: InputMaybe<Array<BookingConfigChangeTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingConfigChangeTypesEnum>;
  _nin?: InputMaybe<Array<BookingConfigChangeTypesEnum>>;
};

/** Ordering options when selecting data from "booking_config_change_types". */
export type BookingConfigChangeTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "booking_config_change_types" */
export enum BookingConfigChangeTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "booking_config_change_types" */
export type BookingConfigChangeTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BookingConfigChangeTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingConfigChangeTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "booking_connection_statuses" */
export type BookingConnectionStatuses = {
  __typename?: 'BookingConnectionStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "booking_connection_statuses". All fields are combined with a logical 'AND'. */
export type BookingConnectionStatusesBoolExp = {
  _and?: InputMaybe<Array<BookingConnectionStatusesBoolExp>>;
  _not?: InputMaybe<BookingConnectionStatusesBoolExp>;
  _or?: InputMaybe<Array<BookingConnectionStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum BookingConnectionStatusesEnum {
  /** Booking account could not be confirmed */
  Failed = 'FAILED',
  /** Waiting on ops to confirm the booking account */
  Pending = 'PENDING',
  /** Booking account confirmed */
  Verified = 'VERIFIED'
}

/** Boolean expression to compare columns of type "BookingConnectionStatusesEnum". All fields are combined with logical 'AND'. */
export type BookingConnectionStatusesEnumComparisonExp = {
  _eq?: InputMaybe<BookingConnectionStatusesEnum>;
  _in?: InputMaybe<Array<BookingConnectionStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingConnectionStatusesEnum>;
  _nin?: InputMaybe<Array<BookingConnectionStatusesEnum>>;
};

/** Ordering options when selecting data from "booking_connection_statuses". */
export type BookingConnectionStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "booking_connection_statuses" */
export enum BookingConnectionStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "booking_connection_statuses" */
export type BookingConnectionStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BookingConnectionStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingConnectionStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "booking_integration_statuses" */
export type BookingIntegrationStatuses = {
  __typename?: 'BookingIntegrationStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "booking_integration_statuses". All fields are combined with a logical 'AND'. */
export type BookingIntegrationStatusesBoolExp = {
  _and?: InputMaybe<Array<BookingIntegrationStatusesBoolExp>>;
  _not?: InputMaybe<BookingIntegrationStatusesBoolExp>;
  _or?: InputMaybe<Array<BookingIntegrationStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum BookingIntegrationStatusesEnum {
  /** Live */
  Active = 'ACTIVE',
  /** Wizard not finished; not live */
  Draft = 'DRAFT',
  /** Temporarily not live */
  Paused = 'PAUSED'
}

/** Boolean expression to compare columns of type "BookingIntegrationStatusesEnum". All fields are combined with logical 'AND'. */
export type BookingIntegrationStatusesEnumComparisonExp = {
  _eq?: InputMaybe<BookingIntegrationStatusesEnum>;
  _in?: InputMaybe<Array<BookingIntegrationStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingIntegrationStatusesEnum>;
  _nin?: InputMaybe<Array<BookingIntegrationStatusesEnum>>;
};

/** Ordering options when selecting data from "booking_integration_statuses". */
export type BookingIntegrationStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "booking_integration_statuses" */
export enum BookingIntegrationStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "booking_integration_statuses" */
export type BookingIntegrationStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BookingIntegrationStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingIntegrationStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "booking_inventory_types" */
export type BookingInventoryTypes = {
  __typename?: 'BookingInventoryTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "booking_inventory_types". All fields are combined with a logical 'AND'. */
export type BookingInventoryTypesBoolExp = {
  _and?: InputMaybe<Array<BookingInventoryTypesBoolExp>>;
  _not?: InputMaybe<BookingInventoryTypesBoolExp>;
  _or?: InputMaybe<Array<BookingInventoryTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum BookingInventoryTypesEnum {
  /** Court bookings */
  Court = 'COURT',
  /** Programming bookings */
  Program = 'PROGRAM'
}

/** Boolean expression to compare columns of type "BookingInventoryTypesEnum". All fields are combined with logical 'AND'. */
export type BookingInventoryTypesEnumComparisonExp = {
  _eq?: InputMaybe<BookingInventoryTypesEnum>;
  _in?: InputMaybe<Array<BookingInventoryTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingInventoryTypesEnum>;
  _nin?: InputMaybe<Array<BookingInventoryTypesEnum>>;
};

/** Ordering options when selecting data from "booking_inventory_types". */
export type BookingInventoryTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "booking_inventory_types" */
export enum BookingInventoryTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "booking_inventory_types" */
export type BookingInventoryTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BookingInventoryTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingInventoryTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "booking_schedule_modes" */
export type BookingScheduleModes = {
  __typename?: 'BookingScheduleModes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "booking_schedule_modes". All fields are combined with a logical 'AND'. */
export type BookingScheduleModesBoolExp = {
  _and?: InputMaybe<Array<BookingScheduleModesBoolExp>>;
  _not?: InputMaybe<BookingScheduleModesBoolExp>;
  _or?: InputMaybe<Array<BookingScheduleModesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum BookingScheduleModesEnum {
  /** Applies at all times */
  Always = 'ALWAYS',
  /** Applies only inside the configured windows */
  Scheduled = 'SCHEDULED'
}

/** Boolean expression to compare columns of type "BookingScheduleModesEnum". All fields are combined with logical 'AND'. */
export type BookingScheduleModesEnumComparisonExp = {
  _eq?: InputMaybe<BookingScheduleModesEnum>;
  _in?: InputMaybe<Array<BookingScheduleModesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingScheduleModesEnum>;
  _nin?: InputMaybe<Array<BookingScheduleModesEnum>>;
};

/** Ordering options when selecting data from "booking_schedule_modes". */
export type BookingScheduleModesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "booking_schedule_modes" */
export enum BookingScheduleModesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "booking_schedule_modes" */
export type BookingScheduleModesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BookingScheduleModesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingScheduleModesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "booking_systems" */
export type BookingSystems = {
  __typename?: 'BookingSystems';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "booking_systems". All fields are combined with a logical 'AND'. */
export type BookingSystemsBoolExp = {
  _and?: InputMaybe<Array<BookingSystemsBoolExp>>;
  _not?: InputMaybe<BookingSystemsBoolExp>;
  _or?: InputMaybe<Array<BookingSystemsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum BookingSystemsEnum {
  /** CourtReserve */
  CourtReserve = 'COURT_RESERVE',
  /** No booking system */
  None = 'NONE',
  /** Another booking system */
  Other = 'OTHER',
  /** PlayByPoint */
  Playbypoint = 'PLAYBYPOINT',
  /** PodPlay */
  Podplay = 'PODPLAY'
}

/** Boolean expression to compare columns of type "BookingSystemsEnum". All fields are combined with logical 'AND'. */
export type BookingSystemsEnumComparisonExp = {
  _eq?: InputMaybe<BookingSystemsEnum>;
  _in?: InputMaybe<Array<BookingSystemsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingSystemsEnum>;
  _nin?: InputMaybe<Array<BookingSystemsEnum>>;
};

/** Ordering options when selecting data from "booking_systems". */
export type BookingSystemsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "booking_systems" */
export enum BookingSystemsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "booking_systems" */
export type BookingSystemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BookingSystemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingSystemsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "booking_window_kinds" */
export type BookingWindowKinds = {
  __typename?: 'BookingWindowKinds';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "booking_window_kinds". All fields are combined with a logical 'AND'. */
export type BookingWindowKindsBoolExp = {
  _and?: InputMaybe<Array<BookingWindowKindsBoolExp>>;
  _not?: InputMaybe<BookingWindowKindsBoolExp>;
  _or?: InputMaybe<Array<BookingWindowKindsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum BookingWindowKindsEnum {
  /** When Bounce may book */
  Bookable = 'BOOKABLE',
  /** When the partner discount applies */
  Discount = 'DISCOUNT',
  /** When the peak rate applies */
  Peak = 'PEAK'
}

/** Boolean expression to compare columns of type "BookingWindowKindsEnum". All fields are combined with logical 'AND'. */
export type BookingWindowKindsEnumComparisonExp = {
  _eq?: InputMaybe<BookingWindowKindsEnum>;
  _in?: InputMaybe<Array<BookingWindowKindsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BookingWindowKindsEnum>;
  _nin?: InputMaybe<Array<BookingWindowKindsEnum>>;
};

/** Ordering options when selecting data from "booking_window_kinds". */
export type BookingWindowKindsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "booking_window_kinds" */
export enum BookingWindowKindsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "booking_window_kinds" */
export type BookingWindowKindsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BookingWindowKindsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingWindowKindsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** columns and relationships of "boost_channels" */
export type BoostChannels = {
  __typename?: 'BoostChannels';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "boost_channels". All fields are combined with a logical 'AND'. */
export type BoostChannelsBoolExp = {
  _and?: InputMaybe<Array<BoostChannelsBoolExp>>;
  _not?: InputMaybe<BoostChannelsBoolExp>;
  _or?: InputMaybe<Array<BoostChannelsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum BoostChannelsEnum {
  Marketplace = 'MARKETPLACE',
  Newsletter = 'NEWSLETTER'
}

/** Boolean expression to compare columns of type "BoostChannelsEnum". All fields are combined with logical 'AND'. */
export type BoostChannelsEnumComparisonExp = {
  _eq?: InputMaybe<BoostChannelsEnum>;
  _in?: InputMaybe<Array<BoostChannelsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BoostChannelsEnum>;
  _nin?: InputMaybe<Array<BoostChannelsEnum>>;
};

/** Ordering options when selecting data from "boost_channels". */
export type BoostChannelsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "boost_channels" */
export enum BoostChannelsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "boost_channels" */
export type BoostChannelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BoostChannelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BoostChannelsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "boost_statuses" */
export type BoostStatuses = {
  __typename?: 'BoostStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "boost_statuses". All fields are combined with a logical 'AND'. */
export type BoostStatusesBoolExp = {
  _and?: InputMaybe<Array<BoostStatusesBoolExp>>;
  _not?: InputMaybe<BoostStatusesBoolExp>;
  _or?: InputMaybe<Array<BoostStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum BoostStatusesEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "BoostStatusesEnum". All fields are combined with logical 'AND'. */
export type BoostStatusesEnumComparisonExp = {
  _eq?: InputMaybe<BoostStatusesEnum>;
  _in?: InputMaybe<Array<BoostStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BoostStatusesEnum>;
  _nin?: InputMaybe<Array<BoostStatusesEnum>>;
};

/** Ordering options when selecting data from "boost_statuses". */
export type BoostStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "boost_statuses" */
export enum BoostStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "boost_statuses" */
export type BoostStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BoostStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BoostStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "boosts" */
export type Boosts = {
  __typename?: 'Boosts';
  channel: BoostChannelsEnum;
  endsAt: Scalars['timestamptz'];
  entityType: EngagementEntityTypesEnum;
  /** An object relationship */
  event?: Maybe<Events>;
  eventId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson?: Maybe<Lessons>;
  lessonId?: Maybe<Scalars['uuid']>;
  startsAt: Scalars['timestamptz'];
  status: BoostStatusesEnum;
};

/** Boolean expression to filter rows from the table "boosts". All fields are combined with a logical 'AND'. */
export type BoostsBoolExp = {
  _and?: InputMaybe<Array<BoostsBoolExp>>;
  _not?: InputMaybe<BoostsBoolExp>;
  _or?: InputMaybe<Array<BoostsBoolExp>>;
  channel?: InputMaybe<BoostChannelsEnumComparisonExp>;
  endsAt?: InputMaybe<TimestamptzComparisonExp>;
  entityType?: InputMaybe<EngagementEntityTypesEnumComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  startsAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<BoostStatusesEnumComparisonExp>;
};

/** Ordering options when selecting data from "boosts". */
export type BoostsOrderBy = {
  channel?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  entityType?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** select columns of table "boosts" */
export enum BoostsSelectColumn {
  /** column name */
  Channel = 'channel',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  EntityType = 'entityType',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "boosts" */
export type BoostsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BoostsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BoostsStreamCursorValueInput = {
  channel?: InputMaybe<BoostChannelsEnum>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  entityType?: InputMaybe<EngagementEntityTypesEnum>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<BoostStatusesEnum>;
};

/** columns and relationships of "bracket_ranking_mechanism" */
export type BracketRankingMechanism = {
  __typename?: 'BracketRankingMechanism';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "bracket_ranking_mechanism". All fields are combined with a logical 'AND'. */
export type BracketRankingMechanismBoolExp = {
  _and?: InputMaybe<Array<BracketRankingMechanismBoolExp>>;
  _not?: InputMaybe<BracketRankingMechanismBoolExp>;
  _or?: InputMaybe<Array<BracketRankingMechanismBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum BracketRankingMechanismEnum {
  NetPoints = 'NET_POINTS',
  Wins = 'WINS'
}

/** Boolean expression to compare columns of type "BracketRankingMechanismEnum". All fields are combined with logical 'AND'. */
export type BracketRankingMechanismEnumComparisonExp = {
  _eq?: InputMaybe<BracketRankingMechanismEnum>;
  _in?: InputMaybe<Array<BracketRankingMechanismEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BracketRankingMechanismEnum>;
  _nin?: InputMaybe<Array<BracketRankingMechanismEnum>>;
};

/** Ordering options when selecting data from "bracket_ranking_mechanism". */
export type BracketRankingMechanismOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "bracket_ranking_mechanism" */
export enum BracketRankingMechanismSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "bracket_ranking_mechanism" */
export type BracketRankingMechanismStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BracketRankingMechanismStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BracketRankingMechanismStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "calendar_accounts" */
export type CalendarAccounts = {
  __typename?: 'CalendarAccounts';
  /** An array relationship */
  calendarPreferences: Array<CalendarPreferences>;
  connected: Scalars['Boolean'];
  createdAt: Scalars['timestamptz'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  provider: CalendarAuthProviderEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};


/** columns and relationships of "calendar_accounts" */
export type CalendarAccountsCalendarPreferencesArgs = {
  distinctOn?: InputMaybe<Array<CalendarPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarPreferencesOrderBy>>;
  where?: InputMaybe<CalendarPreferencesBoolExp>;
};

/** Boolean expression to filter rows from the table "calendar_accounts". All fields are combined with a logical 'AND'. */
export type CalendarAccountsBoolExp = {
  _and?: InputMaybe<Array<CalendarAccountsBoolExp>>;
  _not?: InputMaybe<CalendarAccountsBoolExp>;
  _or?: InputMaybe<Array<CalendarAccountsBoolExp>>;
  calendarPreferences?: InputMaybe<CalendarPreferencesBoolExp>;
  connected?: InputMaybe<BooleanComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  provider?: InputMaybe<CalendarAuthProviderEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** response of any mutation on the table "calendar_accounts" */
export type CalendarAccountsMutationResponse = {
  __typename?: 'CalendarAccountsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CalendarAccounts>;
};

/** Ordering options when selecting data from "calendar_accounts". */
export type CalendarAccountsOrderBy = {
  calendarPreferencesAggregate?: InputMaybe<CalendarPreferencesAggregateOrderBy>;
  connected?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: calendar_accounts */
export type CalendarAccountsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "calendar_accounts" */
export enum CalendarAccountsSelectColumn {
  /** column name */
  Connected = 'connected',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "calendar_accounts" */
export type CalendarAccountsSetInput = {
  connected?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "calendar_accounts" */
export type CalendarAccountsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CalendarAccountsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CalendarAccountsStreamCursorValueInput = {
  connected?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<CalendarAuthProviderEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

export type CalendarAccountsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CalendarAccountsSetInput>;
  /** filter the rows which have to be updated */
  where: CalendarAccountsBoolExp;
};

export enum CalendarAuthProviderEnum {
  Google = 'GOOGLE'
}

/** Boolean expression to compare columns of type "CalendarAuthProviderEnum". All fields are combined with logical 'AND'. */
export type CalendarAuthProviderEnumComparisonExp = {
  _eq?: InputMaybe<CalendarAuthProviderEnum>;
  _in?: InputMaybe<Array<CalendarAuthProviderEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CalendarAuthProviderEnum>;
  _nin?: InputMaybe<Array<CalendarAuthProviderEnum>>;
};

/** columns and relationships of "calendar_preferences" */
export type CalendarPreferences = {
  __typename?: 'CalendarPreferences';
  /** An object relationship */
  calendarAccount: CalendarAccounts;
  calendarAccountId: Scalars['uuid'];
  calendarId: Scalars['String'];
  calendarName: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  isDefault?: Maybe<Scalars['Boolean']>;
  isEnabled: Scalars['Boolean'];
  isWritable: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "calendar_preferences" */
export type CalendarPreferencesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CalendarPreferencesMaxOrderBy>;
  min?: InputMaybe<CalendarPreferencesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "calendar_preferences". All fields are combined with a logical 'AND'. */
export type CalendarPreferencesBoolExp = {
  _and?: InputMaybe<Array<CalendarPreferencesBoolExp>>;
  _not?: InputMaybe<CalendarPreferencesBoolExp>;
  _or?: InputMaybe<Array<CalendarPreferencesBoolExp>>;
  calendarAccount?: InputMaybe<CalendarAccountsBoolExp>;
  calendarAccountId?: InputMaybe<UuidComparisonExp>;
  calendarId?: InputMaybe<StringComparisonExp>;
  calendarName?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isDefault?: InputMaybe<BooleanComparisonExp>;
  isEnabled?: InputMaybe<BooleanComparisonExp>;
  isWritable?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "calendar_preferences" */
export type CalendarPreferencesMaxOrderBy = {
  calendarAccountId?: InputMaybe<OrderBy>;
  calendarId?: InputMaybe<OrderBy>;
  calendarName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "calendar_preferences" */
export type CalendarPreferencesMinOrderBy = {
  calendarAccountId?: InputMaybe<OrderBy>;
  calendarId?: InputMaybe<OrderBy>;
  calendarName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "calendar_preferences" */
export type CalendarPreferencesMutationResponse = {
  __typename?: 'CalendarPreferencesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CalendarPreferences>;
};

/** Ordering options when selecting data from "calendar_preferences". */
export type CalendarPreferencesOrderBy = {
  calendarAccount?: InputMaybe<CalendarAccountsOrderBy>;
  calendarAccountId?: InputMaybe<OrderBy>;
  calendarId?: InputMaybe<OrderBy>;
  calendarName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isDefault?: InputMaybe<OrderBy>;
  isEnabled?: InputMaybe<OrderBy>;
  isWritable?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: calendar_preferences */
export type CalendarPreferencesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "calendar_preferences" */
export enum CalendarPreferencesSelectColumn {
  /** column name */
  CalendarAccountId = 'calendarAccountId',
  /** column name */
  CalendarId = 'calendarId',
  /** column name */
  CalendarName = 'calendarName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'isDefault',
  /** column name */
  IsEnabled = 'isEnabled',
  /** column name */
  IsWritable = 'isWritable',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "calendar_preferences" */
export type CalendarPreferencesSetInput = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "calendar_preferences" */
export type CalendarPreferencesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CalendarPreferencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CalendarPreferencesStreamCursorValueInput = {
  calendarAccountId?: InputMaybe<Scalars['uuid']>;
  calendarId?: InputMaybe<Scalars['String']>;
  calendarName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  isWritable?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

export type CalendarPreferencesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CalendarPreferencesSetInput>;
  /** filter the rows which have to be updated */
  where: CalendarPreferencesBoolExp;
};

/** columns and relationships of "cities" */
export type Cities = {
  __typename?: 'Cities';
  citySlug: Scalars['String'];
  /** An array relationship */
  coachStarterProfiles: Array<CoachStarterProfiles>;
  /** An object relationship */
  countrySubdivision: CountrySubdivisions;
  countrySubdivisionId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  eventsAggregate: EventsAggregate;
  geometry?: Maybe<Scalars['geography']>;
  /** An array relationship */
  groups: Array<Groups>;
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  latitude: Scalars['numeric'];
  longitude: Scalars['numeric'];
  name: Scalars['String'];
  slug: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  users: Array<Users>;
  /** An array relationship */
  venues: Array<Venues>;
};


/** columns and relationships of "cities" */
export type CitiesCoachStarterProfilesArgs = {
  distinctOn?: InputMaybe<Array<CoachStarterProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStarterProfilesOrderBy>>;
  where?: InputMaybe<CoachStarterProfilesBoolExp>;
};


/** columns and relationships of "cities" */
export type CitiesEventsArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


/** columns and relationships of "cities" */
export type CitiesEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


/** columns and relationships of "cities" */
export type CitiesGroupsArgs = {
  distinctOn?: InputMaybe<Array<GroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
  where?: InputMaybe<GroupsBoolExp>;
};


/** columns and relationships of "cities" */
export type CitiesUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


/** columns and relationships of "cities" */
export type CitiesVenuesArgs = {
  distinctOn?: InputMaybe<Array<VenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuesOrderBy>>;
  where?: InputMaybe<VenuesBoolExp>;
};

/** order by aggregate values of table "cities" */
export type CitiesAggregateOrderBy = {
  avg?: InputMaybe<CitiesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CitiesMaxOrderBy>;
  min?: InputMaybe<CitiesMinOrderBy>;
  stddev?: InputMaybe<CitiesStddevOrderBy>;
  stddevPop?: InputMaybe<CitiesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<CitiesStddevSampOrderBy>;
  sum?: InputMaybe<CitiesSumOrderBy>;
  varPop?: InputMaybe<CitiesVarPopOrderBy>;
  varSamp?: InputMaybe<CitiesVarSampOrderBy>;
  variance?: InputMaybe<CitiesVarianceOrderBy>;
};

/** order by avg() on columns of table "cities" */
export type CitiesAvgOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cities". All fields are combined with a logical 'AND'. */
export type CitiesBoolExp = {
  _and?: InputMaybe<Array<CitiesBoolExp>>;
  _not?: InputMaybe<CitiesBoolExp>;
  _or?: InputMaybe<Array<CitiesBoolExp>>;
  citySlug?: InputMaybe<StringComparisonExp>;
  coachStarterProfiles?: InputMaybe<CoachStarterProfilesBoolExp>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsBoolExp>;
  countrySubdivisionId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  events?: InputMaybe<EventsBoolExp>;
  eventsAggregate?: InputMaybe<EventsAggregateBoolExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  groups?: InputMaybe<GroupsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  timezone?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  users?: InputMaybe<UsersBoolExp>;
  venues?: InputMaybe<VenuesBoolExp>;
};

/** order by max() on columns of table "cities" */
export type CitiesMaxOrderBy = {
  citySlug?: InputMaybe<OrderBy>;
  countrySubdivisionId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "cities" */
export type CitiesMinOrderBy = {
  citySlug?: InputMaybe<OrderBy>;
  countrySubdivisionId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "cities". */
export type CitiesOrderBy = {
  citySlug?: InputMaybe<OrderBy>;
  coachStarterProfilesAggregate?: InputMaybe<CoachStarterProfilesAggregateOrderBy>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsOrderBy>;
  countrySubdivisionId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventsAggregate?: InputMaybe<EventsAggregateOrderBy>;
  geometry?: InputMaybe<OrderBy>;
  groupsAggregate?: InputMaybe<GroupsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usersAggregate?: InputMaybe<UsersAggregateOrderBy>;
  venuesAggregate?: InputMaybe<VenuesAggregateOrderBy>;
};

/** select columns of table "cities" */
export enum CitiesSelectColumn {
  /** column name */
  CitySlug = 'citySlug',
  /** column name */
  CountrySubdivisionId = 'countrySubdivisionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** order by stddev() on columns of table "cities" */
export type CitiesStddevOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "cities" */
export type CitiesStddevPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "cities" */
export type CitiesStddevSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cities" */
export type CitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CitiesStreamCursorValueInput = {
  citySlug?: InputMaybe<Scalars['String']>;
  countrySubdivisionId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "cities" */
export type CitiesSumOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "cities" */
export type CitiesVarPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "cities" */
export type CitiesVarSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "cities" */
export type CitiesVarianceOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** columns and relationships of "coach_availability" */
export type CoachAvailability = {
  __typename?: 'CoachAvailability';
  /** An object relationship */
  coachAvailabilityCustomCourt?: Maybe<UserCustomCourts>;
  /** An object relationship */
  coachAvailabilityVenueId?: Maybe<Venues>;
  createdAt: Scalars['timestamptz'];
  dayOfWeek: DayOfWeekEnum;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endTimeMinutes: Scalars['Int'];
  id: Scalars['uuid'];
  startTimeMinutes: Scalars['Int'];
  status: CoachAvailabilityStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  userId: Scalars['uuid'];
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by aggregate values of table "coach_availability" */
export type CoachAvailabilityAggregateOrderBy = {
  avg?: InputMaybe<CoachAvailabilityAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CoachAvailabilityMaxOrderBy>;
  min?: InputMaybe<CoachAvailabilityMinOrderBy>;
  stddev?: InputMaybe<CoachAvailabilityStddevOrderBy>;
  stddevPop?: InputMaybe<CoachAvailabilityStddevPopOrderBy>;
  stddevSamp?: InputMaybe<CoachAvailabilityStddevSampOrderBy>;
  sum?: InputMaybe<CoachAvailabilitySumOrderBy>;
  varPop?: InputMaybe<CoachAvailabilityVarPopOrderBy>;
  varSamp?: InputMaybe<CoachAvailabilityVarSampOrderBy>;
  variance?: InputMaybe<CoachAvailabilityVarianceOrderBy>;
};

/** order by avg() on columns of table "coach_availability" */
export type CoachAvailabilityAvgOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "coach_availability". All fields are combined with a logical 'AND'. */
export type CoachAvailabilityBoolExp = {
  _and?: InputMaybe<Array<CoachAvailabilityBoolExp>>;
  _not?: InputMaybe<CoachAvailabilityBoolExp>;
  _or?: InputMaybe<Array<CoachAvailabilityBoolExp>>;
  coachAvailabilityCustomCourt?: InputMaybe<UserCustomCourtsBoolExp>;
  coachAvailabilityVenueId?: InputMaybe<VenuesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dayOfWeek?: InputMaybe<DayOfWeekEnumComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  endTimeMinutes?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  startTimeMinutes?: InputMaybe<IntComparisonExp>;
  status?: InputMaybe<CoachAvailabilityStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userCustomCourtId?: InputMaybe<UuidComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "coach_availability" */
export enum CoachAvailabilityConstraint {
  /** unique or primary key constraint on columns "id" */
  CoachAvailabilityPkey = 'coach_availability_pkey'
}

/** input type for incrementing numeric columns in table "coach_availability" */
export type CoachAvailabilityIncInput = {
  endTimeMinutes?: InputMaybe<Scalars['Int']>;
  startTimeMinutes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "coach_availability" */
export type CoachAvailabilityInsertInput = {
  coachAvailabilityCustomCourt?: InputMaybe<UserCustomCourtsObjRelInsertInput>;
  dayOfWeek?: InputMaybe<DayOfWeekEnum>;
  endTimeMinutes?: InputMaybe<Scalars['Int']>;
  startTimeMinutes?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CoachAvailabilityStatusesEnum>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "coach_availability" */
export type CoachAvailabilityMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endTimeMinutes?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "coach_availability" */
export type CoachAvailabilityMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endTimeMinutes?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "coach_availability" */
export type CoachAvailabilityMutationResponse = {
  __typename?: 'CoachAvailabilityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachAvailability>;
};

/** on_conflict condition type for table "coach_availability" */
export type CoachAvailabilityOnConflict = {
  constraint: CoachAvailabilityConstraint;
  updateColumns?: Array<CoachAvailabilityUpdateColumn>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};

/** Ordering options when selecting data from "coach_availability". */
export type CoachAvailabilityOrderBy = {
  coachAvailabilityCustomCourt?: InputMaybe<UserCustomCourtsOrderBy>;
  coachAvailabilityVenueId?: InputMaybe<VenuesOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endTimeMinutes?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_availability */
export type CoachAvailabilityPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "coach_availability" */
export enum CoachAvailabilitySelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DayOfWeek = 'dayOfWeek',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndTimeMinutes = 'endTimeMinutes',
  /** column name */
  Id = 'id',
  /** column name */
  StartTimeMinutes = 'startTimeMinutes',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  UserId = 'userId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "coach_availability" */
export type CoachAvailabilitySetInput = {
  endTimeMinutes?: InputMaybe<Scalars['Int']>;
  startTimeMinutes?: InputMaybe<Scalars['Int']>;
};

export enum CoachAvailabilityStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "CoachAvailabilityStatusesEnum". All fields are combined with logical 'AND'. */
export type CoachAvailabilityStatusesEnumComparisonExp = {
  _eq?: InputMaybe<CoachAvailabilityStatusesEnum>;
  _in?: InputMaybe<Array<CoachAvailabilityStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CoachAvailabilityStatusesEnum>;
  _nin?: InputMaybe<Array<CoachAvailabilityStatusesEnum>>;
};

/** order by stddev() on columns of table "coach_availability" */
export type CoachAvailabilityStddevOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "coach_availability" */
export type CoachAvailabilityStddevPopOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "coach_availability" */
export type CoachAvailabilityStddevSampOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "coach_availability" */
export type CoachAvailabilityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachAvailabilityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachAvailabilityStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<DayOfWeekEnum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endTimeMinutes?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  startTimeMinutes?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CoachAvailabilityStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "coach_availability" */
export type CoachAvailabilitySumOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** update columns of table "coach_availability" */
export enum CoachAvailabilityUpdateColumn {
  /** column name */
  EndTimeMinutes = 'endTimeMinutes',
  /** column name */
  StartTimeMinutes = 'startTimeMinutes'
}

export type CoachAvailabilityUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CoachAvailabilityIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachAvailabilitySetInput>;
  /** filter the rows which have to be updated */
  where: CoachAvailabilityBoolExp;
};

/** order by varPop() on columns of table "coach_availability" */
export type CoachAvailabilityVarPopOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "coach_availability" */
export type CoachAvailabilityVarSampOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "coach_availability" */
export type CoachAvailabilityVarianceOrderBy = {
  endTimeMinutes?: InputMaybe<OrderBy>;
  startTimeMinutes?: InputMaybe<OrderBy>;
};

/** columns and relationships of "coach_booking_requests" */
export type CoachBookingRequests = {
  __typename?: 'CoachBookingRequests';
  coachStarterProfileId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  coachUser?: Maybe<Users>;
  coachUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  coachUserProfile?: Maybe<UserProfiles>;
  contactedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  message?: Maybe<Scalars['String']>;
  /** An object relationship */
  playerUser: Users;
  playerUserId: Scalars['uuid'];
  /** An object relationship */
  playerUserProfile?: Maybe<UserProfiles>;
  updatedAt: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "coach_booking_requests". All fields are combined with a logical 'AND'. */
export type CoachBookingRequestsBoolExp = {
  _and?: InputMaybe<Array<CoachBookingRequestsBoolExp>>;
  _not?: InputMaybe<CoachBookingRequestsBoolExp>;
  _or?: InputMaybe<Array<CoachBookingRequestsBoolExp>>;
  coachStarterProfileId?: InputMaybe<UuidComparisonExp>;
  coachUser?: InputMaybe<UsersBoolExp>;
  coachUserId?: InputMaybe<UuidComparisonExp>;
  coachUserProfile?: InputMaybe<UserProfilesBoolExp>;
  contactedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<StringComparisonExp>;
  playerUser?: InputMaybe<UsersBoolExp>;
  playerUserId?: InputMaybe<UuidComparisonExp>;
  playerUserProfile?: InputMaybe<UserProfilesBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "coach_booking_requests" */
export enum CoachBookingRequestsConstraint {
  /** unique or primary key constraint on columns "id" */
  CoachBookingRequestsPkey = 'coach_booking_requests_pkey',
  /** unique or primary key constraint on columns "coach_user_id", "coach_starter_profile_id", "player_user_id" */
  CoachBookingRequestsPlayerUserIdCoachStarterProfileKey = 'coach_booking_requests_player_user_id_coach_starter_profile_key'
}

/** input type for inserting data into table "coach_booking_requests" */
export type CoachBookingRequestsInsertInput = {
  coachStarterProfileId?: InputMaybe<Scalars['uuid']>;
  coachUserId?: InputMaybe<Scalars['uuid']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
};

/** response of any mutation on the table "coach_booking_requests" */
export type CoachBookingRequestsMutationResponse = {
  __typename?: 'CoachBookingRequestsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachBookingRequests>;
};

/** on_conflict condition type for table "coach_booking_requests" */
export type CoachBookingRequestsOnConflict = {
  constraint: CoachBookingRequestsConstraint;
  updateColumns?: Array<CoachBookingRequestsUpdateColumn>;
  where?: InputMaybe<CoachBookingRequestsBoolExp>;
};

/** Ordering options when selecting data from "coach_booking_requests". */
export type CoachBookingRequestsOrderBy = {
  coachStarterProfileId?: InputMaybe<OrderBy>;
  coachUser?: InputMaybe<UsersOrderBy>;
  coachUserId?: InputMaybe<OrderBy>;
  coachUserProfile?: InputMaybe<UserProfilesOrderBy>;
  contactedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  playerUser?: InputMaybe<UsersOrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  playerUserProfile?: InputMaybe<UserProfilesOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_booking_requests */
export type CoachBookingRequestsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "coach_booking_requests" */
export enum CoachBookingRequestsSelectColumn {
  /** column name */
  CoachStarterProfileId = 'coachStarterProfileId',
  /** column name */
  CoachUserId = 'coachUserId',
  /** column name */
  ContactedAt = 'contactedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "coach_booking_requests" */
export type CoachBookingRequestsSetInput = {
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "coach_booking_requests" */
export type CoachBookingRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachBookingRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachBookingRequestsStreamCursorValueInput = {
  coachStarterProfileId?: InputMaybe<Scalars['uuid']>;
  coachUserId?: InputMaybe<Scalars['uuid']>;
  contactedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "coach_booking_requests" */
export enum CoachBookingRequestsUpdateColumn {
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CoachBookingRequestsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachBookingRequestsSetInput>;
  /** filter the rows which have to be updated */
  where: CoachBookingRequestsBoolExp;
};

export enum CoachExternalReviewSourcesEnum {
  Google = 'GOOGLE',
  Other = 'OTHER',
  Teachme = 'TEACHME'
}

/** Boolean expression to compare columns of type "CoachExternalReviewSourcesEnum". All fields are combined with logical 'AND'. */
export type CoachExternalReviewSourcesEnumComparisonExp = {
  _eq?: InputMaybe<CoachExternalReviewSourcesEnum>;
  _in?: InputMaybe<Array<CoachExternalReviewSourcesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CoachExternalReviewSourcesEnum>;
  _nin?: InputMaybe<Array<CoachExternalReviewSourcesEnum>>;
};

/** columns and relationships of "coach_faqs" */
export type CoachFaqs = {
  __typename?: 'CoachFaqs';
  answer: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  question: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** order by aggregate values of table "coach_faqs" */
export type CoachFaqsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CoachFaqsMaxOrderBy>;
  min?: InputMaybe<CoachFaqsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "coach_faqs". All fields are combined with a logical 'AND'. */
export type CoachFaqsBoolExp = {
  _and?: InputMaybe<Array<CoachFaqsBoolExp>>;
  _not?: InputMaybe<CoachFaqsBoolExp>;
  _or?: InputMaybe<Array<CoachFaqsBoolExp>>;
  answer?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  question?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "coach_faqs" */
export enum CoachFaqsConstraint {
  /** unique or primary key constraint on columns "id" */
  CoachFaqsPkey = 'coach_faqs_pkey'
}

/** input type for inserting data into table "coach_faqs" */
export type CoachFaqsInsertInput = {
  answer?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "coach_faqs" */
export type CoachFaqsMaxOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "coach_faqs" */
export type CoachFaqsMinOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "coach_faqs" */
export type CoachFaqsMutationResponse = {
  __typename?: 'CoachFaqsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachFaqs>;
};

/** on_conflict condition type for table "coach_faqs" */
export type CoachFaqsOnConflict = {
  constraint: CoachFaqsConstraint;
  updateColumns?: Array<CoachFaqsUpdateColumn>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};

/** Ordering options when selecting data from "coach_faqs". */
export type CoachFaqsOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: coach_faqs */
export type CoachFaqsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "coach_faqs" */
export enum CoachFaqsSelectColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "coach_faqs" */
export type CoachFaqsSetInput = {
  answer?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "coach_faqs" */
export type CoachFaqsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachFaqsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachFaqsStreamCursorValueInput = {
  answer?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "coach_faqs" */
export enum CoachFaqsUpdateColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  Question = 'question'
}

export type CoachFaqsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachFaqsSetInput>;
  /** filter the rows which have to be updated */
  where: CoachFaqsBoolExp;
};

/** columns and relationships of "coach_lesson_age_groups" */
export type CoachLessonAgeGroups = {
  __typename?: 'CoachLessonAgeGroups';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  lessonAgeGroup: LessonAgeGroupsEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** order by aggregate values of table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CoachLessonAgeGroupsMaxOrderBy>;
  min?: InputMaybe<CoachLessonAgeGroupsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "coach_lesson_age_groups". All fields are combined with a logical 'AND'. */
export type CoachLessonAgeGroupsBoolExp = {
  _and?: InputMaybe<Array<CoachLessonAgeGroupsBoolExp>>;
  _not?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
  _or?: InputMaybe<Array<CoachLessonAgeGroupsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonAgeGroup?: InputMaybe<LessonAgeGroupsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "coach_lesson_age_groups" */
export enum CoachLessonAgeGroupsConstraint {
  /** unique or primary key constraint on columns "id" */
  CoachLessonAgeGroupsPkey = 'coach_lesson_age_groups_pkey',
  /** unique or primary key constraint on columns "user_id", "lesson_age_group" */
  CoachLessonAgeGroupsUserIdLessonAgeGroupKey = 'coach_lesson_age_groups_user_id_lesson_age_group_key'
}

/** input type for inserting data into table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsInsertInput = {
  lessonAgeGroup?: InputMaybe<LessonAgeGroupsEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsMutationResponse = {
  __typename?: 'CoachLessonAgeGroupsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachLessonAgeGroups>;
};

/** on_conflict condition type for table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsOnConflict = {
  constraint: CoachLessonAgeGroupsConstraint;
  updateColumns?: Array<CoachLessonAgeGroupsUpdateColumn>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};

/** Ordering options when selecting data from "coach_lesson_age_groups". */
export type CoachLessonAgeGroupsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonAgeGroup?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: coach_lesson_age_groups */
export type CoachLessonAgeGroupsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "coach_lesson_age_groups" */
export enum CoachLessonAgeGroupsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonAgeGroup = 'lessonAgeGroup',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  lessonAgeGroup?: InputMaybe<LessonAgeGroupsEnum>;
};

/** Streaming cursor of the table "coach_lesson_age_groups" */
export type CoachLessonAgeGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachLessonAgeGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachLessonAgeGroupsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonAgeGroup?: InputMaybe<LessonAgeGroupsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "coach_lesson_age_groups" */
export enum CoachLessonAgeGroupsUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  LessonAgeGroup = 'lessonAgeGroup'
}

export type CoachLessonAgeGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachLessonAgeGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: CoachLessonAgeGroupsBoolExp;
};

/** columns and relationships of "coach_lesson_skill_levels" */
export type CoachLessonSkillLevels = {
  __typename?: 'CoachLessonSkillLevels';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  skillLevel: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** order by aggregate values of table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CoachLessonSkillLevelsMaxOrderBy>;
  min?: InputMaybe<CoachLessonSkillLevelsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "coach_lesson_skill_levels". All fields are combined with a logical 'AND'. */
export type CoachLessonSkillLevelsBoolExp = {
  _and?: InputMaybe<Array<CoachLessonSkillLevelsBoolExp>>;
  _not?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
  _or?: InputMaybe<Array<CoachLessonSkillLevelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  skillLevel?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "coach_lesson_skill_levels" */
export enum CoachLessonSkillLevelsConstraint {
  /** unique or primary key constraint on columns "id" */
  CoachLessonSkillLevelsPkey = 'coach_lesson_skill_levels_pkey',
  /** unique or primary key constraint on columns "user_id", "skill_level" */
  CoachLessonSkillLevelsSkillLevelUserIdKey = 'coach_lesson_skill_levels_skill_level_user_id_key'
}

/** input type for inserting data into table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsInsertInput = {
  skillLevel?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsMutationResponse = {
  __typename?: 'CoachLessonSkillLevelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachLessonSkillLevels>;
};

/** on_conflict condition type for table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsOnConflict = {
  constraint: CoachLessonSkillLevelsConstraint;
  updateColumns?: Array<CoachLessonSkillLevelsUpdateColumn>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};

/** Ordering options when selecting data from "coach_lesson_skill_levels". */
export type CoachLessonSkillLevelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: coach_lesson_skill_levels */
export type CoachLessonSkillLevelsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "coach_lesson_skill_levels" */
export enum CoachLessonSkillLevelsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  SkillLevel = 'skillLevel',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  skillLevel?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "coach_lesson_skill_levels" */
export type CoachLessonSkillLevelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachLessonSkillLevelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachLessonSkillLevelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "coach_lesson_skill_levels" */
export enum CoachLessonSkillLevelsUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  SkillLevel = 'skillLevel'
}

export type CoachLessonSkillLevelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachLessonSkillLevelsSetInput>;
  /** filter the rows which have to be updated */
  where: CoachLessonSkillLevelsBoolExp;
};

/** columns and relationships of "coach_qualification_groups" */
export type CoachQualificationGroups = {
  __typename?: 'CoachQualificationGroups';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "coach_qualification_groups". All fields are combined with a logical 'AND'. */
export type CoachQualificationGroupsBoolExp = {
  _and?: InputMaybe<Array<CoachQualificationGroupsBoolExp>>;
  _not?: InputMaybe<CoachQualificationGroupsBoolExp>;
  _or?: InputMaybe<Array<CoachQualificationGroupsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum CoachQualificationGroupsEnum {
  Certificate = 'CERTIFICATE',
  CurrentCollegePlayer = 'CURRENT_COLLEGE_PLAYER',
  FormerCollegePlayer = 'FORMER_COLLEGE_PLAYER'
}

/** Boolean expression to compare columns of type "CoachQualificationGroupsEnum". All fields are combined with logical 'AND'. */
export type CoachQualificationGroupsEnumComparisonExp = {
  _eq?: InputMaybe<CoachQualificationGroupsEnum>;
  _in?: InputMaybe<Array<CoachQualificationGroupsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CoachQualificationGroupsEnum>;
  _nin?: InputMaybe<Array<CoachQualificationGroupsEnum>>;
};

/** Ordering options when selecting data from "coach_qualification_groups". */
export type CoachQualificationGroupsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "coach_qualification_groups" */
export enum CoachQualificationGroupsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "coach_qualification_groups" */
export type CoachQualificationGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachQualificationGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachQualificationGroupsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export enum CoachQualificationStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "CoachQualificationStatusesEnum". All fields are combined with logical 'AND'. */
export type CoachQualificationStatusesEnumComparisonExp = {
  _eq?: InputMaybe<CoachQualificationStatusesEnum>;
  _in?: InputMaybe<Array<CoachQualificationStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CoachQualificationStatusesEnum>;
  _nin?: InputMaybe<Array<CoachQualificationStatusesEnum>>;
};

/** columns and relationships of "coach_qualifications" */
export type CoachQualifications = {
  __typename?: 'CoachQualifications';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  displayKey: Scalars['String'];
  groupId?: Maybe<CoachQualificationGroupsEnum>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  order: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "coach_qualifications". All fields are combined with a logical 'AND'. */
export type CoachQualificationsBoolExp = {
  _and?: InputMaybe<Array<CoachQualificationsBoolExp>>;
  _not?: InputMaybe<CoachQualificationsBoolExp>;
  _or?: InputMaybe<Array<CoachQualificationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  displayKey?: InputMaybe<StringComparisonExp>;
  groupId?: InputMaybe<CoachQualificationGroupsEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  order?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** Ordering options when selecting data from "coach_qualifications". */
export type CoachQualificationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  displayKey?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "coach_qualifications" */
export enum CoachQualificationsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DisplayKey = 'displayKey',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "coach_qualifications" */
export type CoachQualificationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachQualificationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachQualificationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  displayKey?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<CoachQualificationGroupsEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

export enum CoachReviewTypesEnum {
  Court = 'COURT',
  Remote = 'REMOTE'
}

/** Boolean expression to compare columns of type "CoachReviewTypesEnum". All fields are combined with logical 'AND'. */
export type CoachReviewTypesEnumComparisonExp = {
  _eq?: InputMaybe<CoachReviewTypesEnum>;
  _in?: InputMaybe<Array<CoachReviewTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CoachReviewTypesEnum>;
  _nin?: InputMaybe<Array<CoachReviewTypesEnum>>;
};

/** columns and relationships of "coach_sport_statuses" */
export type CoachSportStatuses = {
  __typename?: 'CoachSportStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "coach_sport_statuses". All fields are combined with a logical 'AND'. */
export type CoachSportStatusesBoolExp = {
  _and?: InputMaybe<Array<CoachSportStatusesBoolExp>>;
  _not?: InputMaybe<CoachSportStatusesBoolExp>;
  _or?: InputMaybe<Array<CoachSportStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum CoachSportStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "CoachSportStatusesEnum". All fields are combined with logical 'AND'. */
export type CoachSportStatusesEnumComparisonExp = {
  _eq?: InputMaybe<CoachSportStatusesEnum>;
  _in?: InputMaybe<Array<CoachSportStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CoachSportStatusesEnum>;
  _nin?: InputMaybe<Array<CoachSportStatusesEnum>>;
};

/** Ordering options when selecting data from "coach_sport_statuses". */
export type CoachSportStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "coach_sport_statuses" */
export enum CoachSportStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "coach_sport_statuses" */
export type CoachSportStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachSportStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachSportStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "coach_sports" */
export type CoachSports = {
  __typename?: 'CoachSports';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  sport: SportsEnum;
  status: CoachSportStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "coach_sports" */
export type CoachSportsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CoachSportsMaxOrderBy>;
  min?: InputMaybe<CoachSportsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "coach_sports". All fields are combined with a logical 'AND'. */
export type CoachSportsBoolExp = {
  _and?: InputMaybe<Array<CoachSportsBoolExp>>;
  _not?: InputMaybe<CoachSportsBoolExp>;
  _or?: InputMaybe<Array<CoachSportsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  status?: InputMaybe<CoachSportStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "coach_sports" */
export enum CoachSportsConstraint {
  /** unique or primary key constraint on columns "id" */
  CoachSportsPkey = 'coach_sports_pkey',
  /** unique or primary key constraint on columns "sport", "user_id" */
  CoachSportsUserIdSportKey = 'coach_sports_user_id_sport_key'
}

/** input type for inserting data into table "coach_sports" */
export type CoachSportsInsertInput = {
  sport?: InputMaybe<SportsEnum>;
  status?: InputMaybe<CoachSportStatusesEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "coach_sports" */
export type CoachSportsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "coach_sports" */
export type CoachSportsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "coach_sports" */
export type CoachSportsMutationResponse = {
  __typename?: 'CoachSportsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CoachSports>;
};

/** on_conflict condition type for table "coach_sports" */
export type CoachSportsOnConflict = {
  constraint: CoachSportsConstraint;
  updateColumns?: Array<CoachSportsUpdateColumn>;
  where?: InputMaybe<CoachSportsBoolExp>;
};

/** Ordering options when selecting data from "coach_sports". */
export type CoachSportsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sport?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: coach_sports */
export type CoachSportsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "coach_sports" */
export enum CoachSportsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Sport = 'sport',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "coach_sports" */
export type CoachSportsSetInput = {
  status?: InputMaybe<CoachSportStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "coach_sports" */
export type CoachSportsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachSportsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachSportsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  sport?: InputMaybe<SportsEnum>;
  status?: InputMaybe<CoachSportStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "coach_sports" */
export enum CoachSportsUpdateColumn {
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CoachSportsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoachSportsSetInput>;
  /** filter the rows which have to be updated */
  where: CoachSportsBoolExp;
};

/** columns and relationships of "coach_starter_profiles" */
export type CoachStarterProfiles = {
  __typename?: 'CoachStarterProfiles';
  aboutMe?: Maybe<Scalars['String']>;
  aboutPhotoImageUrl?: Maybe<Scalars['String']>;
  accountClaimedAt?: Maybe<Scalars['timestamptz']>;
  addressDisplay?: Maybe<Scalars['String']>;
  addressString?: Maybe<Scalars['String']>;
  addressType?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['String']>;
  /** An object relationship */
  city?: Maybe<Cities>;
  cityId?: Maybe<Scalars['uuid']>;
  cityName?: Maybe<Scalars['String']>;
  claimUserId?: Maybe<Scalars['uuid']>;
  company?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprProfile?: Maybe<Scalars['String']>;
  duprRating?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  geometry?: Maybe<Scalars['geography']>;
  id: Scalars['uuid'];
  latitude?: Maybe<Scalars['numeric']>;
  listingType?: Maybe<Scalars['String']>;
  logoImageUrl?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  needsReview?: Maybe<Scalars['Boolean']>;
  playerLevel?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  stateName?: Maybe<Scalars['String']>;
  teacherCertArr?: Maybe<Scalars['jsonb']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  usapRating?: Maybe<Scalars['String']>;
  /** An object relationship */
  user?: Maybe<Users>;
  verified?: Maybe<Scalars['Boolean']>;
  zipcode?: Maybe<Scalars['String']>;
};


/** columns and relationships of "coach_starter_profiles" */
export type CoachStarterProfilesTeacherCertArrArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "coach_starter_profiles" */
export type CoachStarterProfilesAggregateOrderBy = {
  avg?: InputMaybe<CoachStarterProfilesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CoachStarterProfilesMaxOrderBy>;
  min?: InputMaybe<CoachStarterProfilesMinOrderBy>;
  stddev?: InputMaybe<CoachStarterProfilesStddevOrderBy>;
  stddevPop?: InputMaybe<CoachStarterProfilesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<CoachStarterProfilesStddevSampOrderBy>;
  sum?: InputMaybe<CoachStarterProfilesSumOrderBy>;
  varPop?: InputMaybe<CoachStarterProfilesVarPopOrderBy>;
  varSamp?: InputMaybe<CoachStarterProfilesVarSampOrderBy>;
  variance?: InputMaybe<CoachStarterProfilesVarianceOrderBy>;
};

/** order by avg() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesAvgOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "coach_starter_profiles". All fields are combined with a logical 'AND'. */
export type CoachStarterProfilesBoolExp = {
  _and?: InputMaybe<Array<CoachStarterProfilesBoolExp>>;
  _not?: InputMaybe<CoachStarterProfilesBoolExp>;
  _or?: InputMaybe<Array<CoachStarterProfilesBoolExp>>;
  aboutMe?: InputMaybe<StringComparisonExp>;
  aboutPhotoImageUrl?: InputMaybe<StringComparisonExp>;
  accountClaimedAt?: InputMaybe<TimestamptzComparisonExp>;
  addressDisplay?: InputMaybe<StringComparisonExp>;
  addressString?: InputMaybe<StringComparisonExp>;
  addressType?: InputMaybe<StringComparisonExp>;
  age?: InputMaybe<StringComparisonExp>;
  birthdate?: InputMaybe<StringComparisonExp>;
  city?: InputMaybe<CitiesBoolExp>;
  cityId?: InputMaybe<UuidComparisonExp>;
  cityName?: InputMaybe<StringComparisonExp>;
  claimUserId?: InputMaybe<UuidComparisonExp>;
  company?: InputMaybe<StringComparisonExp>;
  countryName?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  duprProfile?: InputMaybe<StringComparisonExp>;
  duprRating?: InputMaybe<StringComparisonExp>;
  gender?: InputMaybe<StringComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  listingType?: InputMaybe<StringComparisonExp>;
  logoImageUrl?: InputMaybe<StringComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  needsReview?: InputMaybe<BooleanComparisonExp>;
  playerLevel?: InputMaybe<StringComparisonExp>;
  profileImageUrl?: InputMaybe<StringComparisonExp>;
  shortDescription?: InputMaybe<StringComparisonExp>;
  stateName?: InputMaybe<StringComparisonExp>;
  teacherCertArr?: InputMaybe<JsonbComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  usapRating?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  verified?: InputMaybe<BooleanComparisonExp>;
  zipcode?: InputMaybe<StringComparisonExp>;
};

/** order by max() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesMaxOrderBy = {
  aboutMe?: InputMaybe<OrderBy>;
  aboutPhotoImageUrl?: InputMaybe<OrderBy>;
  accountClaimedAt?: InputMaybe<OrderBy>;
  addressDisplay?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  addressType?: InputMaybe<OrderBy>;
  age?: InputMaybe<OrderBy>;
  birthdate?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  cityName?: InputMaybe<OrderBy>;
  claimUserId?: InputMaybe<OrderBy>;
  company?: InputMaybe<OrderBy>;
  countryName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duprProfile?: InputMaybe<OrderBy>;
  duprRating?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  listingType?: InputMaybe<OrderBy>;
  logoImageUrl?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  playerLevel?: InputMaybe<OrderBy>;
  profileImageUrl?: InputMaybe<OrderBy>;
  shortDescription?: InputMaybe<OrderBy>;
  stateName?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usapRating?: InputMaybe<OrderBy>;
  zipcode?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesMinOrderBy = {
  aboutMe?: InputMaybe<OrderBy>;
  aboutPhotoImageUrl?: InputMaybe<OrderBy>;
  accountClaimedAt?: InputMaybe<OrderBy>;
  addressDisplay?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  addressType?: InputMaybe<OrderBy>;
  age?: InputMaybe<OrderBy>;
  birthdate?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  cityName?: InputMaybe<OrderBy>;
  claimUserId?: InputMaybe<OrderBy>;
  company?: InputMaybe<OrderBy>;
  countryName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duprProfile?: InputMaybe<OrderBy>;
  duprRating?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  listingType?: InputMaybe<OrderBy>;
  logoImageUrl?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  playerLevel?: InputMaybe<OrderBy>;
  profileImageUrl?: InputMaybe<OrderBy>;
  shortDescription?: InputMaybe<OrderBy>;
  stateName?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usapRating?: InputMaybe<OrderBy>;
  zipcode?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "coach_starter_profiles". */
export type CoachStarterProfilesOrderBy = {
  aboutMe?: InputMaybe<OrderBy>;
  aboutPhotoImageUrl?: InputMaybe<OrderBy>;
  accountClaimedAt?: InputMaybe<OrderBy>;
  addressDisplay?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  addressType?: InputMaybe<OrderBy>;
  age?: InputMaybe<OrderBy>;
  birthdate?: InputMaybe<OrderBy>;
  city?: InputMaybe<CitiesOrderBy>;
  cityId?: InputMaybe<OrderBy>;
  cityName?: InputMaybe<OrderBy>;
  claimUserId?: InputMaybe<OrderBy>;
  company?: InputMaybe<OrderBy>;
  countryName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duprProfile?: InputMaybe<OrderBy>;
  duprRating?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  listingType?: InputMaybe<OrderBy>;
  logoImageUrl?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  needsReview?: InputMaybe<OrderBy>;
  playerLevel?: InputMaybe<OrderBy>;
  profileImageUrl?: InputMaybe<OrderBy>;
  shortDescription?: InputMaybe<OrderBy>;
  stateName?: InputMaybe<OrderBy>;
  teacherCertArr?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usapRating?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  verified?: InputMaybe<OrderBy>;
  zipcode?: InputMaybe<OrderBy>;
};

/** select columns of table "coach_starter_profiles" */
export enum CoachStarterProfilesSelectColumn {
  /** column name */
  AboutMe = 'aboutMe',
  /** column name */
  AboutPhotoImageUrl = 'aboutPhotoImageUrl',
  /** column name */
  AccountClaimedAt = 'accountClaimedAt',
  /** column name */
  AddressDisplay = 'addressDisplay',
  /** column name */
  AddressString = 'addressString',
  /** column name */
  AddressType = 'addressType',
  /** column name */
  Age = 'age',
  /** column name */
  Birthdate = 'birthdate',
  /** column name */
  CityId = 'cityId',
  /** column name */
  CityName = 'cityName',
  /** column name */
  ClaimUserId = 'claimUserId',
  /** column name */
  Company = 'company',
  /** column name */
  CountryName = 'countryName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DuprProfile = 'duprProfile',
  /** column name */
  DuprRating = 'duprRating',
  /** column name */
  Gender = 'gender',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  ListingType = 'listingType',
  /** column name */
  LogoImageUrl = 'logoImageUrl',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  NeedsReview = 'needsReview',
  /** column name */
  PlayerLevel = 'playerLevel',
  /** column name */
  ProfileImageUrl = 'profileImageUrl',
  /** column name */
  ShortDescription = 'shortDescription',
  /** column name */
  StateName = 'stateName',
  /** column name */
  TeacherCertArr = 'teacherCertArr',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsapRating = 'usapRating',
  /** column name */
  Verified = 'verified',
  /** column name */
  Zipcode = 'zipcode'
}

/** order by stddev() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesStddevOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesStddevPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesStddevSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "coach_starter_profiles" */
export type CoachStarterProfilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachStarterProfilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachStarterProfilesStreamCursorValueInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutPhotoImageUrl?: InputMaybe<Scalars['String']>;
  accountClaimedAt?: InputMaybe<Scalars['timestamptz']>;
  addressDisplay?: InputMaybe<Scalars['String']>;
  addressString?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  age?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  cityName?: InputMaybe<Scalars['String']>;
  claimUserId?: InputMaybe<Scalars['uuid']>;
  company?: InputMaybe<Scalars['String']>;
  countryName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  duprProfile?: InputMaybe<Scalars['String']>;
  duprRating?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  listingType?: InputMaybe<Scalars['String']>;
  logoImageUrl?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  needsReview?: InputMaybe<Scalars['Boolean']>;
  playerLevel?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  stateName?: InputMaybe<Scalars['String']>;
  teacherCertArr?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usapRating?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesSumOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesVarPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesVarSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "coach_starter_profiles" */
export type CoachStarterProfilesVarianceOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** columns and relationships of "coach_status" */
export type CoachStatus = {
  __typename?: 'CoachStatus';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "coach_status". All fields are combined with a logical 'AND'. */
export type CoachStatusBoolExp = {
  _and?: InputMaybe<Array<CoachStatusBoolExp>>;
  _not?: InputMaybe<CoachStatusBoolExp>;
  _or?: InputMaybe<Array<CoachStatusBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum CoachStatusEnum {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Inactive = 'INACTIVE',
  None = 'NONE'
}

/** Boolean expression to compare columns of type "CoachStatusEnum". All fields are combined with logical 'AND'. */
export type CoachStatusEnumComparisonExp = {
  _eq?: InputMaybe<CoachStatusEnum>;
  _in?: InputMaybe<Array<CoachStatusEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CoachStatusEnum>;
  _nin?: InputMaybe<Array<CoachStatusEnum>>;
};

/** Ordering options when selecting data from "coach_status". */
export type CoachStatusOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "coach_status" */
export enum CoachStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "coach_status" */
export type CoachStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CoachStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoachStatusStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "coach_tips". All fields are combined with a logical 'AND'. */
export type CoachTipsBoolExp = {
  _and?: InputMaybe<Array<CoachTipsBoolExp>>;
  _not?: InputMaybe<CoachTipsBoolExp>;
  _or?: InputMaybe<Array<CoachTipsBoolExp>>;
};

/** unique or primary key constraints on table "coach_tips" */
export enum CoachTipsConstraint {
  /** unique or primary key constraint on columns "external_stripe_payment_intent_id" */
  CoachTipsExternalStripePaymentIntentIdKey = 'coach_tips_external_stripe_payment_intent_id_key',
  /** unique or primary key constraint on columns "internal_stripe_payment_intent_id" */
  CoachTipsInternalStripePaymentIntentIdKey = 'coach_tips_internal_stripe_payment_intent_id_key',
  /** unique or primary key constraint on columns "id" */
  CoachTipsPkey = 'coach_tips_pkey'
}

/** input type for inserting data into table "coach_tips" */
export type CoachTipsInsertInput = {
  coachUserId?: InputMaybe<Scalars['uuid']>;
  customerUserId?: InputMaybe<Scalars['uuid']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
};

/** response of any mutation on the table "coach_tips" */
export type CoachTipsMutationResponse = {
  __typename?: 'CoachTipsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
};

/** on_conflict condition type for table "coach_tips" */
export type CoachTipsOnConflict = {
  constraint: CoachTipsConstraint;
  updateColumns?: Array<CoachTipsUpdateColumn>;
  where?: InputMaybe<CoachTipsBoolExp>;
};

/** placeholder for update columns of table "coach_tips" (current role has no relevant permissions) */
export enum CoachTipsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "comment_vote" */
export type CommentVote = {
  __typename?: 'CommentVote';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "comment_vote". All fields are combined with a logical 'AND'. */
export type CommentVoteBoolExp = {
  _and?: InputMaybe<Array<CommentVoteBoolExp>>;
  _not?: InputMaybe<CommentVoteBoolExp>;
  _or?: InputMaybe<Array<CommentVoteBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum CommentVoteEnum {
  Negative = 'NEGATIVE',
  None = 'NONE',
  Positive = 'POSITIVE'
}

/** Boolean expression to compare columns of type "CommentVoteEnum". All fields are combined with logical 'AND'. */
export type CommentVoteEnumComparisonExp = {
  _eq?: InputMaybe<CommentVoteEnum>;
  _in?: InputMaybe<Array<CommentVoteEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CommentVoteEnum>;
  _nin?: InputMaybe<Array<CommentVoteEnum>>;
};

/** Ordering options when selecting data from "comment_vote". */
export type CommentVoteOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "comment_vote" */
export enum CommentVoteSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "comment_vote" */
export type CommentVoteStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CommentVoteStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CommentVoteStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "communication_preference_statuses" */
export type CommunicationPreferenceStatuses = {
  __typename?: 'CommunicationPreferenceStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "communication_preference_statuses". All fields are combined with a logical 'AND'. */
export type CommunicationPreferenceStatusesBoolExp = {
  _and?: InputMaybe<Array<CommunicationPreferenceStatusesBoolExp>>;
  _not?: InputMaybe<CommunicationPreferenceStatusesBoolExp>;
  _or?: InputMaybe<Array<CommunicationPreferenceStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum CommunicationPreferenceStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "CommunicationPreferenceStatusesEnum". All fields are combined with logical 'AND'. */
export type CommunicationPreferenceStatusesEnumComparisonExp = {
  _eq?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  _in?: InputMaybe<Array<CommunicationPreferenceStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  _nin?: InputMaybe<Array<CommunicationPreferenceStatusesEnum>>;
};

/** Ordering options when selecting data from "communication_preference_statuses". */
export type CommunicationPreferenceStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "communication_preference_statuses" */
export enum CommunicationPreferenceStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "communication_preference_statuses" */
export type CommunicationPreferenceStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CommunicationPreferenceStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CommunicationPreferenceStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "competition_formats" */
export type CompetitionFormats = {
  __typename?: 'CompetitionFormats';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "competition_formats". All fields are combined with a logical 'AND'. */
export type CompetitionFormatsBoolExp = {
  _and?: InputMaybe<Array<CompetitionFormatsBoolExp>>;
  _not?: InputMaybe<CompetitionFormatsBoolExp>;
  _or?: InputMaybe<Array<CompetitionFormatsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum CompetitionFormatsEnum {
  Custom = 'CUSTOM',
  DoubleElimination = 'DOUBLE_ELIMINATION',
  RoundRobin = 'ROUND_ROBIN',
  SingleElimination = 'SINGLE_ELIMINATION'
}

/** Boolean expression to compare columns of type "CompetitionFormatsEnum". All fields are combined with logical 'AND'. */
export type CompetitionFormatsEnumComparisonExp = {
  _eq?: InputMaybe<CompetitionFormatsEnum>;
  _in?: InputMaybe<Array<CompetitionFormatsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CompetitionFormatsEnum>;
  _nin?: InputMaybe<Array<CompetitionFormatsEnum>>;
};

/** Ordering options when selecting data from "competition_formats". */
export type CompetitionFormatsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "competition_formats" */
export enum CompetitionFormatsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "competition_formats" */
export type CompetitionFormatsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompetitionFormatsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompetitionFormatsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "competition_gender" */
export type CompetitionGender = {
  __typename?: 'CompetitionGender';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "competition_gender". All fields are combined with a logical 'AND'. */
export type CompetitionGenderBoolExp = {
  _and?: InputMaybe<Array<CompetitionGenderBoolExp>>;
  _not?: InputMaybe<CompetitionGenderBoolExp>;
  _or?: InputMaybe<Array<CompetitionGenderBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum CompetitionGenderEnum {
  Coed = 'COED',
  Female = 'FEMALE',
  Male = 'MALE',
  Mixed = 'MIXED'
}

/** Boolean expression to compare columns of type "CompetitionGenderEnum". All fields are combined with logical 'AND'. */
export type CompetitionGenderEnumComparisonExp = {
  _eq?: InputMaybe<CompetitionGenderEnum>;
  _in?: InputMaybe<Array<CompetitionGenderEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CompetitionGenderEnum>;
  _nin?: InputMaybe<Array<CompetitionGenderEnum>>;
};

/** Ordering options when selecting data from "competition_gender". */
export type CompetitionGenderOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "competition_gender" */
export enum CompetitionGenderSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "competition_gender" */
export type CompetitionGenderStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompetitionGenderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompetitionGenderStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "content_reports" */
export type ContentReports = {
  __typename?: 'ContentReports';
  /** An object relationship */
  conversation?: Maybe<Conversations>;
  conversationId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  message?: Maybe<Messages>;
  messageId?: Maybe<Scalars['uuid']>;
  reason: ReportReasonsEnum;
  /** An object relationship */
  reportedUser?: Maybe<Users>;
  reportedUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  reporter: Users;
  reporterUserId: Scalars['uuid'];
  resolvedAt?: Maybe<Scalars['timestamptz']>;
  status: ReportStatusesEnum;
  updatedAt: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "content_reports". All fields are combined with a logical 'AND'. */
export type ContentReportsBoolExp = {
  _and?: InputMaybe<Array<ContentReportsBoolExp>>;
  _not?: InputMaybe<ContentReportsBoolExp>;
  _or?: InputMaybe<Array<ContentReportsBoolExp>>;
  conversation?: InputMaybe<ConversationsBoolExp>;
  conversationId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  messageId?: InputMaybe<UuidComparisonExp>;
  reason?: InputMaybe<ReportReasonsEnumComparisonExp>;
  reportedUser?: InputMaybe<UsersBoolExp>;
  reportedUserId?: InputMaybe<UuidComparisonExp>;
  reporter?: InputMaybe<UsersBoolExp>;
  reporterUserId?: InputMaybe<UuidComparisonExp>;
  resolvedAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<ReportStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** Ordering options when selecting data from "content_reports". */
export type ContentReportsOrderBy = {
  conversation?: InputMaybe<ConversationsOrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  messageId?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  reportedUser?: InputMaybe<UsersOrderBy>;
  reportedUserId?: InputMaybe<OrderBy>;
  reporter?: InputMaybe<UsersOrderBy>;
  reporterUserId?: InputMaybe<OrderBy>;
  resolvedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "content_reports" */
export enum ContentReportsSelectColumn {
  /** column name */
  ConversationId = 'conversationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'messageId',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReportedUserId = 'reportedUserId',
  /** column name */
  ReporterUserId = 'reporterUserId',
  /** column name */
  ResolvedAt = 'resolvedAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "content_reports" */
export type ContentReportsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ContentReportsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentReportsStreamCursorValueInput = {
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  messageId?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<ReportReasonsEnum>;
  reportedUserId?: InputMaybe<Scalars['uuid']>;
  reporterUserId?: InputMaybe<Scalars['uuid']>;
  resolvedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<ReportStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "conversation_participants" */
export type ConversationParticipants = {
  __typename?: 'ConversationParticipants';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  conversation: Conversations;
  conversationId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  lastReadAt?: Maybe<Scalars['timestamptz']>;
  role: ParticipantRolesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** order by aggregate values of table "conversation_participants" */
export type ConversationParticipantsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ConversationParticipantsMaxOrderBy>;
  min?: InputMaybe<ConversationParticipantsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "conversation_participants". All fields are combined with a logical 'AND'. */
export type ConversationParticipantsBoolExp = {
  _and?: InputMaybe<Array<ConversationParticipantsBoolExp>>;
  _not?: InputMaybe<ConversationParticipantsBoolExp>;
  _or?: InputMaybe<Array<ConversationParticipantsBoolExp>>;
  archivedAt?: InputMaybe<TimestamptzComparisonExp>;
  conversation?: InputMaybe<ConversationsBoolExp>;
  conversationId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lastReadAt?: InputMaybe<TimestamptzComparisonExp>;
  role?: InputMaybe<ParticipantRolesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** order by max() on columns of table "conversation_participants" */
export type ConversationParticipantsMaxOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastReadAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "conversation_participants" */
export type ConversationParticipantsMinOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastReadAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "conversation_participants" */
export type ConversationParticipantsMutationResponse = {
  __typename?: 'ConversationParticipantsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ConversationParticipants>;
};

/** Ordering options when selecting data from "conversation_participants". */
export type ConversationParticipantsOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  conversation?: InputMaybe<ConversationsOrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastReadAt?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: conversation_participants */
export type ConversationParticipantsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "conversation_participants" */
export enum ConversationParticipantsSelectColumn {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  ConversationId = 'conversationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LastReadAt = 'lastReadAt',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "conversation_participants" */
export type ConversationParticipantsSetInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  lastReadAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "conversation_participants" */
export type ConversationParticipantsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ConversationParticipantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ConversationParticipantsStreamCursorValueInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastReadAt?: InputMaybe<Scalars['timestamptz']>;
  role?: InputMaybe<ParticipantRolesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

export type ConversationParticipantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConversationParticipantsSetInput>;
  /** filter the rows which have to be updated */
  where: ConversationParticipantsBoolExp;
};

/** columns and relationships of "conversation_types" */
export type ConversationTypes = {
  __typename?: 'ConversationTypes';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "conversation_types". All fields are combined with a logical 'AND'. */
export type ConversationTypesBoolExp = {
  _and?: InputMaybe<Array<ConversationTypesBoolExp>>;
  _not?: InputMaybe<ConversationTypesBoolExp>;
  _or?: InputMaybe<Array<ConversationTypesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum ConversationTypesEnum {
  /** 1:1 thread */
  Direct = 'DIRECT',
  /** multi-party thread */
  Group = 'GROUP'
}

/** Boolean expression to compare columns of type "ConversationTypesEnum". All fields are combined with logical 'AND'. */
export type ConversationTypesEnumComparisonExp = {
  _eq?: InputMaybe<ConversationTypesEnum>;
  _in?: InputMaybe<Array<ConversationTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ConversationTypesEnum>;
  _nin?: InputMaybe<Array<ConversationTypesEnum>>;
};

/** Ordering options when selecting data from "conversation_types". */
export type ConversationTypesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "conversation_types" */
export enum ConversationTypesSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "conversation_types" */
export type ConversationTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ConversationTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ConversationTypesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "conversations" */
export type Conversations = {
  __typename?: 'Conversations';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdBy?: Maybe<Users>;
  createdByUserId?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  directKey?: Maybe<Scalars['String']>;
  /** An object relationship */
  event?: Maybe<Events>;
  eventId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  imagePath?: Maybe<Scalars['String']>;
  lastMessageAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  lesson?: Maybe<Lessons>;
  lessonId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An array relationship */
  participants: Array<ConversationParticipants>;
  title?: Maybe<Scalars['String']>;
  type: ConversationTypesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue?: Maybe<Venues>;
  venueId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "conversations" */
export type ConversationsMessagesArgs = {
  distinctOn?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


/** columns and relationships of "conversations" */
export type ConversationsParticipantsArgs = {
  distinctOn?: InputMaybe<Array<ConversationParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationParticipantsOrderBy>>;
  where?: InputMaybe<ConversationParticipantsBoolExp>;
};

/** order by aggregate values of table "conversations" */
export type ConversationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ConversationsMaxOrderBy>;
  min?: InputMaybe<ConversationsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "conversations". All fields are combined with a logical 'AND'. */
export type ConversationsBoolExp = {
  _and?: InputMaybe<Array<ConversationsBoolExp>>;
  _not?: InputMaybe<ConversationsBoolExp>;
  _or?: InputMaybe<Array<ConversationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UsersBoolExp>;
  createdByUserId?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  directKey?: InputMaybe<StringComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  imagePath?: InputMaybe<StringComparisonExp>;
  lastMessageAt?: InputMaybe<TimestamptzComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  messages?: InputMaybe<MessagesBoolExp>;
  participants?: InputMaybe<ConversationParticipantsBoolExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<ConversationTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "conversations" */
export type ConversationsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  directKey?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imagePath?: InputMaybe<OrderBy>;
  lastMessageAt?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "conversations" */
export type ConversationsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  directKey?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imagePath?: InputMaybe<OrderBy>;
  lastMessageAt?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "conversations". */
export type ConversationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<UsersOrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  directKey?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imagePath?: InputMaybe<OrderBy>;
  lastMessageAt?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  messagesAggregate?: InputMaybe<MessagesAggregateOrderBy>;
  participantsAggregate?: InputMaybe<ConversationParticipantsAggregateOrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** select columns of table "conversations" */
export enum ConversationsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedByUserId = 'createdByUserId',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DirectKey = 'directKey',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  ImagePath = 'imagePath',
  /** column name */
  LastMessageAt = 'lastMessageAt',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** Streaming cursor of the table "conversations" */
export type ConversationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ConversationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ConversationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  directKey?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  imagePath?: InputMaybe<Scalars['String']>;
  lastMessageAt?: InputMaybe<Scalars['timestamptz']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ConversationTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Note that this breaks from the standard and uses the country iso3 as a text field for the id */
export type Countries = {
  __typename?: 'Countries';
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  emoji: Scalars['String'];
  geometry?: Maybe<Scalars['geography']>;
  id: Scalars['String'];
  iso2: Scalars['String'];
  iso3: Scalars['String'];
  latitude: Scalars['numeric'];
  longitude: Scalars['numeric'];
  name: Scalars['String'];
  nameSlug: Scalars['String'];
  numericCode: Scalars['String'];
  phoneCode: Scalars['String'];
  slug: Scalars['String'];
  /** An array relationship */
  subdivisions: Array<CountrySubdivisions>;
  updatedAt: Scalars['timestamptz'];
};


/** Note that this breaks from the standard and uses the country iso3 as a text field for the id */
export type CountriesSubdivisionsArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};

/** Boolean expression to filter rows from the table "countries". All fields are combined with a logical 'AND'. */
export type CountriesBoolExp = {
  _and?: InputMaybe<Array<CountriesBoolExp>>;
  _not?: InputMaybe<CountriesBoolExp>;
  _or?: InputMaybe<Array<CountriesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  emoji?: InputMaybe<StringComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  iso2?: InputMaybe<StringComparisonExp>;
  iso3?: InputMaybe<StringComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  nameSlug?: InputMaybe<StringComparisonExp>;
  numericCode?: InputMaybe<StringComparisonExp>;
  phoneCode?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  subdivisions?: InputMaybe<CountrySubdivisionsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** Ordering options when selecting data from "countries". */
export type CountriesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  emoji?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  iso2?: InputMaybe<OrderBy>;
  iso3?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  nameSlug?: InputMaybe<OrderBy>;
  numericCode?: InputMaybe<OrderBy>;
  phoneCode?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  subdivisionsAggregate?: InputMaybe<CountrySubdivisionsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "countries" */
export enum CountriesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Emoji = 'emoji',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  Iso2 = 'iso2',
  /** column name */
  Iso3 = 'iso3',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  NameSlug = 'nameSlug',
  /** column name */
  NumericCode = 'numericCode',
  /** column name */
  PhoneCode = 'phoneCode',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "countries" */
export type CountriesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CountriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CountriesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  emoji?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['String']>;
  iso2?: InputMaybe<Scalars['String']>;
  iso3?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  nameSlug?: InputMaybe<Scalars['String']>;
  numericCode?: InputMaybe<Scalars['String']>;
  phoneCode?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "country_subdivisions" */
export type CountrySubdivisions = {
  __typename?: 'CountrySubdivisions';
  /** An array relationship */
  cities: Array<Cities>;
  code: Scalars['String'];
  /** An object relationship */
  country: Countries;
  countryId: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  geometry?: Maybe<Scalars['geography']>;
  id: Scalars['uuid'];
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "country_subdivisions" */
export type CountrySubdivisionsCitiesArgs = {
  distinctOn?: InputMaybe<Array<CitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CitiesOrderBy>>;
  where?: InputMaybe<CitiesBoolExp>;
};

/** order by aggregate values of table "country_subdivisions" */
export type CountrySubdivisionsAggregateOrderBy = {
  avg?: InputMaybe<CountrySubdivisionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CountrySubdivisionsMaxOrderBy>;
  min?: InputMaybe<CountrySubdivisionsMinOrderBy>;
  stddev?: InputMaybe<CountrySubdivisionsStddevOrderBy>;
  stddevPop?: InputMaybe<CountrySubdivisionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<CountrySubdivisionsStddevSampOrderBy>;
  sum?: InputMaybe<CountrySubdivisionsSumOrderBy>;
  varPop?: InputMaybe<CountrySubdivisionsVarPopOrderBy>;
  varSamp?: InputMaybe<CountrySubdivisionsVarSampOrderBy>;
  variance?: InputMaybe<CountrySubdivisionsVarianceOrderBy>;
};

/** order by avg() on columns of table "country_subdivisions" */
export type CountrySubdivisionsAvgOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "country_subdivisions". All fields are combined with a logical 'AND'. */
export type CountrySubdivisionsBoolExp = {
  _and?: InputMaybe<Array<CountrySubdivisionsBoolExp>>;
  _not?: InputMaybe<CountrySubdivisionsBoolExp>;
  _or?: InputMaybe<Array<CountrySubdivisionsBoolExp>>;
  cities?: InputMaybe<CitiesBoolExp>;
  code?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<CountriesBoolExp>;
  countryId?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "country_subdivisions" */
export type CountrySubdivisionsMaxOrderBy = {
  code?: InputMaybe<OrderBy>;
  countryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "country_subdivisions" */
export type CountrySubdivisionsMinOrderBy = {
  code?: InputMaybe<OrderBy>;
  countryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "country_subdivisions". */
export type CountrySubdivisionsOrderBy = {
  citiesAggregate?: InputMaybe<CitiesAggregateOrderBy>;
  code?: InputMaybe<OrderBy>;
  country?: InputMaybe<CountriesOrderBy>;
  countryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "country_subdivisions" */
export enum CountrySubdivisionsSelectColumn {
  /** column name */
  Code = 'code',
  /** column name */
  CountryId = 'countryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** order by stddev() on columns of table "country_subdivisions" */
export type CountrySubdivisionsStddevOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "country_subdivisions" */
export type CountrySubdivisionsStddevPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "country_subdivisions" */
export type CountrySubdivisionsStddevSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "country_subdivisions" */
export type CountrySubdivisionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CountrySubdivisionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CountrySubdivisionsStreamCursorValueInput = {
  code?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "country_subdivisions" */
export type CountrySubdivisionsSumOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "country_subdivisions" */
export type CountrySubdivisionsVarPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "country_subdivisions" */
export type CountrySubdivisionsVarSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "country_subdivisions" */
export type CountrySubdivisionsVarianceOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** columns and relationships of "court_surfaces" */
export type CourtSurfaces = {
  __typename?: 'CourtSurfaces';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "court_surfaces". All fields are combined with a logical 'AND'. */
export type CourtSurfacesBoolExp = {
  _and?: InputMaybe<Array<CourtSurfacesBoolExp>>;
  _not?: InputMaybe<CourtSurfacesBoolExp>;
  _or?: InputMaybe<Array<CourtSurfacesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum CourtSurfacesEnum {
  Acrylic = 'ACRYLIC',
  Asphalt = 'ASPHALT',
  Carpet = 'CARPET',
  Clay = 'CLAY',
  Concrete = 'CONCRETE',
  Grass = 'GRASS',
  Hard = 'HARD',
  Wood = 'WOOD'
}

/** Boolean expression to compare columns of type "CourtSurfacesEnum". All fields are combined with logical 'AND'. */
export type CourtSurfacesEnumComparisonExp = {
  _eq?: InputMaybe<CourtSurfacesEnum>;
  _in?: InputMaybe<Array<CourtSurfacesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CourtSurfacesEnum>;
  _nin?: InputMaybe<Array<CourtSurfacesEnum>>;
};

/** Ordering options when selecting data from "court_surfaces". */
export type CourtSurfacesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "court_surfaces" */
export enum CourtSurfacesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "court_surfaces" */
export type CourtSurfacesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CourtSurfacesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CourtSurfacesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** ordering argument of a cursor */
export enum CursorOrdering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type DateComparisonExp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "day_of_week" */
export type DayOfWeek = {
  __typename?: 'DayOfWeek';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "day_of_week". All fields are combined with a logical 'AND'. */
export type DayOfWeekBoolExp = {
  _and?: InputMaybe<Array<DayOfWeekBoolExp>>;
  _not?: InputMaybe<DayOfWeekBoolExp>;
  _or?: InputMaybe<Array<DayOfWeekBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum DayOfWeekEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** Boolean expression to compare columns of type "DayOfWeekEnum". All fields are combined with logical 'AND'. */
export type DayOfWeekEnumComparisonExp = {
  _eq?: InputMaybe<DayOfWeekEnum>;
  _in?: InputMaybe<Array<DayOfWeekEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<DayOfWeekEnum>;
  _nin?: InputMaybe<Array<DayOfWeekEnum>>;
};

/** Ordering options when selecting data from "day_of_week". */
export type DayOfWeekOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "day_of_week" */
export enum DayOfWeekSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "day_of_week" */
export type DayOfWeekStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DayOfWeekStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DayOfWeekStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "engagement_entity_types" */
export type EngagementEntityTypes = {
  __typename?: 'EngagementEntityTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "engagement_entity_types". All fields are combined with a logical 'AND'. */
export type EngagementEntityTypesBoolExp = {
  _and?: InputMaybe<Array<EngagementEntityTypesBoolExp>>;
  _not?: InputMaybe<EngagementEntityTypesBoolExp>;
  _or?: InputMaybe<Array<EngagementEntityTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EngagementEntityTypesEnum {
  ClubPage = 'CLUB_PAGE',
  CoachProfile = 'COACH_PROFILE',
  Event = 'EVENT',
  Lesson = 'LESSON'
}

/** Boolean expression to compare columns of type "EngagementEntityTypesEnum". All fields are combined with logical 'AND'. */
export type EngagementEntityTypesEnumComparisonExp = {
  _eq?: InputMaybe<EngagementEntityTypesEnum>;
  _in?: InputMaybe<Array<EngagementEntityTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EngagementEntityTypesEnum>;
  _nin?: InputMaybe<Array<EngagementEntityTypesEnum>>;
};

/** Ordering options when selecting data from "engagement_entity_types". */
export type EngagementEntityTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "engagement_entity_types" */
export enum EngagementEntityTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "engagement_entity_types" */
export type EngagementEntityTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EngagementEntityTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EngagementEntityTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "engagement_event_types" */
export type EngagementEventTypes = {
  __typename?: 'EngagementEventTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "engagement_event_types". All fields are combined with a logical 'AND'. */
export type EngagementEventTypesBoolExp = {
  _and?: InputMaybe<Array<EngagementEventTypesBoolExp>>;
  _not?: InputMaybe<EngagementEventTypesBoolExp>;
  _or?: InputMaybe<Array<EngagementEventTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** Ordering options when selecting data from "engagement_event_types". */
export type EngagementEventTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "engagement_event_types" */
export enum EngagementEventTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "engagement_event_types" */
export type EngagementEventTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EngagementEventTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EngagementEventTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "engagement_sources" */
export type EngagementSources = {
  __typename?: 'EngagementSources';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "engagement_sources". All fields are combined with a logical 'AND'. */
export type EngagementSourcesBoolExp = {
  _and?: InputMaybe<Array<EngagementSourcesBoolExp>>;
  _not?: InputMaybe<EngagementSourcesBoolExp>;
  _or?: InputMaybe<Array<EngagementSourcesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** Ordering options when selecting data from "engagement_sources". */
export type EngagementSourcesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "engagement_sources" */
export enum EngagementSourcesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "engagement_sources" */
export type EngagementSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EngagementSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EngagementSourcesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "equipment_availabilities" */
export type EquipmentAvailabilities = {
  __typename?: 'EquipmentAvailabilities';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "equipment_availabilities". All fields are combined with a logical 'AND'. */
export type EquipmentAvailabilitiesBoolExp = {
  _and?: InputMaybe<Array<EquipmentAvailabilitiesBoolExp>>;
  _not?: InputMaybe<EquipmentAvailabilitiesBoolExp>;
  _or?: InputMaybe<Array<EquipmentAvailabilitiesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EquipmentAvailabilitiesEnum {
  BringYourOwn = 'BRING_YOUR_OWN',
  ForRent = 'FOR_RENT',
  Provided = 'PROVIDED'
}

/** Boolean expression to compare columns of type "EquipmentAvailabilitiesEnum". All fields are combined with logical 'AND'. */
export type EquipmentAvailabilitiesEnumComparisonExp = {
  _eq?: InputMaybe<EquipmentAvailabilitiesEnum>;
  _in?: InputMaybe<Array<EquipmentAvailabilitiesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EquipmentAvailabilitiesEnum>;
  _nin?: InputMaybe<Array<EquipmentAvailabilitiesEnum>>;
};

/** Ordering options when selecting data from "equipment_availabilities". */
export type EquipmentAvailabilitiesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "equipment_availabilities" */
export enum EquipmentAvailabilitiesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "equipment_availabilities" */
export type EquipmentAvailabilitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EquipmentAvailabilitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EquipmentAvailabilitiesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_accepted_play_requests" */
export type EventAcceptedPlayRequests = {
  __typename?: 'EventAcceptedPlayRequests';
  /** An object relationship */
  event?: Maybe<Events>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  requesterProfile?: Maybe<UserProfiles>;
  requesterUserId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsAggregate = {
  __typename?: 'EventAcceptedPlayRequestsAggregate';
  aggregate?: Maybe<EventAcceptedPlayRequestsAggregateFields>;
  nodes: Array<EventAcceptedPlayRequests>;
};

export type EventAcceptedPlayRequestsAggregateBoolExp = {
  count?: InputMaybe<EventAcceptedPlayRequestsAggregateBoolExpCount>;
};

/** aggregate fields of "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsAggregateFields = {
  __typename?: 'EventAcceptedPlayRequestsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventAcceptedPlayRequestsMaxFields>;
  min?: Maybe<EventAcceptedPlayRequestsMinFields>;
};


/** aggregate fields of "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventAcceptedPlayRequestsMaxOrderBy>;
  min?: InputMaybe<EventAcceptedPlayRequestsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "event_accepted_play_requests". All fields are combined with a logical 'AND'. */
export type EventAcceptedPlayRequestsBoolExp = {
  _and?: InputMaybe<Array<EventAcceptedPlayRequestsBoolExp>>;
  _not?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
  _or?: InputMaybe<Array<EventAcceptedPlayRequestsBoolExp>>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  requesterProfile?: InputMaybe<UserProfilesBoolExp>;
  requesterUserId?: InputMaybe<UuidComparisonExp>;
  respondedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** aggregate max on columns */
export type EventAcceptedPlayRequestsMaxFields = {
  __typename?: 'EventAcceptedPlayRequestsMaxFields';
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  requesterUserId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsMaxOrderBy = {
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventAcceptedPlayRequestsMinFields = {
  __typename?: 'EventAcceptedPlayRequestsMinFields';
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  requesterUserId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsMinOrderBy = {
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_accepted_play_requests". */
export type EventAcceptedPlayRequestsOrderBy = {
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requesterProfile?: InputMaybe<UserProfilesOrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "event_accepted_play_requests" */
export enum EventAcceptedPlayRequestsSelectColumn {
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  RequesterUserId = 'requesterUserId',
  /** column name */
  RespondedAt = 'respondedAt'
}

/** Streaming cursor of the table "event_accepted_play_requests" */
export type EventAcceptedPlayRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventAcceptedPlayRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventAcceptedPlayRequestsStreamCursorValueInput = {
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  requesterUserId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "event_age_groups" */
export type EventAgeGroups = {
  __typename?: 'EventAgeGroups';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_age_groups". All fields are combined with a logical 'AND'. */
export type EventAgeGroupsBoolExp = {
  _and?: InputMaybe<Array<EventAgeGroupsBoolExp>>;
  _not?: InputMaybe<EventAgeGroupsBoolExp>;
  _or?: InputMaybe<Array<EventAgeGroupsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventAgeGroupsEnum {
  Adults = 'ADULTS',
  AllAges = 'ALL_AGES',
  Youth = 'YOUTH'
}

/** Boolean expression to compare columns of type "EventAgeGroupsEnum". All fields are combined with logical 'AND'. */
export type EventAgeGroupsEnumComparisonExp = {
  _eq?: InputMaybe<EventAgeGroupsEnum>;
  _in?: InputMaybe<Array<EventAgeGroupsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventAgeGroupsEnum>;
  _nin?: InputMaybe<Array<EventAgeGroupsEnum>>;
};

/** Ordering options when selecting data from "event_age_groups". */
export type EventAgeGroupsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_age_groups" */
export enum EventAgeGroupsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_age_groups" */
export type EventAgeGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventAgeGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventAgeGroupsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_collections" */
export type EventCollections = {
  __typename?: 'EventCollections';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  eventsAggregate: EventsAggregate;
  /** An object relationship */
  hostUser?: Maybe<Users>;
  hostUserId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  publishedAt?: Maybe<Scalars['timestamptz']>;
  recurrenceKind?: Maybe<RecurrenceKindsEnum>;
  slug: Scalars['String'];
  status: EventStatusesEnum;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "event_collections" */
export type EventCollectionsEventsArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


/** columns and relationships of "event_collections" */
export type EventCollectionsEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};

/** Boolean expression to filter rows from the table "event_collections". All fields are combined with a logical 'AND'. */
export type EventCollectionsBoolExp = {
  _and?: InputMaybe<Array<EventCollectionsBoolExp>>;
  _not?: InputMaybe<EventCollectionsBoolExp>;
  _or?: InputMaybe<Array<EventCollectionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  events?: InputMaybe<EventsBoolExp>;
  eventsAggregate?: InputMaybe<EventsAggregateBoolExp>;
  hostUser?: InputMaybe<UsersBoolExp>;
  hostUserId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  publishedAt?: InputMaybe<TimestamptzComparisonExp>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnumComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<EventStatusesEnumComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_collections" */
export enum EventCollectionsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventCollectionsPkey = 'event_collections_pkey',
  /** unique or primary key constraint on columns "slug" */
  EventCollectionsSlugKey = 'event_collections_slug_key'
}

/** input type for inserting data into table "event_collections" */
export type EventCollectionsInsertInput = {
  events?: InputMaybe<EventsArrRelInsertInput>;
  hostUserId?: InputMaybe<Scalars['uuid']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EventStatusesEnum>;
  title?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "event_collections" */
export type EventCollectionsMutationResponse = {
  __typename?: 'EventCollectionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventCollections>;
};

/** input type for inserting object relation for remote table "event_collections" */
export type EventCollectionsObjRelInsertInput = {
  data: EventCollectionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventCollectionsOnConflict>;
};

/** on_conflict condition type for table "event_collections" */
export type EventCollectionsOnConflict = {
  constraint: EventCollectionsConstraint;
  updateColumns?: Array<EventCollectionsUpdateColumn>;
  where?: InputMaybe<EventCollectionsBoolExp>;
};

/** Ordering options when selecting data from "event_collections". */
export type EventCollectionsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventsAggregate?: InputMaybe<EventsAggregateOrderBy>;
  hostUser?: InputMaybe<UsersOrderBy>;
  hostUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  recurrenceKind?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_collections */
export type EventCollectionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_collections" */
export enum EventCollectionsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  HostUserId = 'hostUserId',
  /** column name */
  Id = 'id',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RecurrenceKind = 'recurrenceKind',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_collections" */
export type EventCollectionsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EventStatusesEnum>;
  title?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_collections" */
export type EventCollectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCollectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCollectionsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  hostUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EventStatusesEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_collections" */
export enum EventCollectionsUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RecurrenceKind = 'recurrenceKind',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title'
}

export type EventCollectionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventCollectionsSetInput>;
  /** filter the rows which have to be updated */
  where: EventCollectionsBoolExp;
};

/** columns and relationships of "event_competitiveness" */
export type EventCompetitiveness = {
  __typename?: 'EventCompetitiveness';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_competitiveness". All fields are combined with a logical 'AND'. */
export type EventCompetitivenessBoolExp = {
  _and?: InputMaybe<Array<EventCompetitivenessBoolExp>>;
  _not?: InputMaybe<EventCompetitivenessBoolExp>;
  _or?: InputMaybe<Array<EventCompetitivenessBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventCompetitivenessEnum {
  Any = 'ANY',
  /** Recreational play */
  Casual = 'CASUAL',
  Competitive = 'COMPETITIVE',
  Drill = 'DRILL',
  MatchPrep = 'MATCH_PREP'
}

/** Boolean expression to compare columns of type "EventCompetitivenessEnum". All fields are combined with logical 'AND'. */
export type EventCompetitivenessEnumComparisonExp = {
  _eq?: InputMaybe<EventCompetitivenessEnum>;
  _in?: InputMaybe<Array<EventCompetitivenessEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventCompetitivenessEnum>;
  _nin?: InputMaybe<Array<EventCompetitivenessEnum>>;
};

/** Ordering options when selecting data from "event_competitiveness". */
export type EventCompetitivenessOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_competitiveness" */
export enum EventCompetitivenessSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_competitiveness" */
export type EventCompetitivenessStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCompetitivenessStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCompetitivenessStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_contact_details" */
export type EventContactDetails = {
  __typename?: 'EventContactDetails';
  contactUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  id: Scalars['uuid'];
  phoneNumber: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "event_contact_details". All fields are combined with a logical 'AND'. */
export type EventContactDetailsBoolExp = {
  _and?: InputMaybe<Array<EventContactDetailsBoolExp>>;
  _not?: InputMaybe<EventContactDetailsBoolExp>;
  _or?: InputMaybe<Array<EventContactDetailsBoolExp>>;
  contactUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** response of any mutation on the table "event_contact_details" */
export type EventContactDetailsMutationResponse = {
  __typename?: 'EventContactDetailsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventContactDetails>;
};

/** Ordering options when selecting data from "event_contact_details". */
export type EventContactDetailsOrderBy = {
  contactUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_contact_details */
export type EventContactDetailsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_contact_details" */
export enum EventContactDetailsSelectColumn {
  /** column name */
  ContactUrl = 'contactUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_contact_details" */
export type EventContactDetailsSetInput = {
  contactUrl?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_contact_details" */
export type EventContactDetailsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventContactDetailsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventContactDetailsStreamCursorValueInput = {
  contactUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

export type EventContactDetailsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventContactDetailsSetInput>;
  /** filter the rows which have to be updated */
  where: EventContactDetailsBoolExp;
};

/** columns and relationships of "event_coupon_groups" */
export type EventCouponGroups = {
  __typename?: 'EventCouponGroups';
  /** An object relationship */
  coupon: EventCoupons;
  couponId: Scalars['uuid'];
  /** An object relationship */
  eventGroup: EventGroups;
  eventGroupId: Scalars['uuid'];
  id: Scalars['uuid'];
};

/** order by aggregate values of table "event_coupon_groups" */
export type EventCouponGroupsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventCouponGroupsMaxOrderBy>;
  min?: InputMaybe<EventCouponGroupsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "event_coupon_groups". All fields are combined with a logical 'AND'. */
export type EventCouponGroupsBoolExp = {
  _and?: InputMaybe<Array<EventCouponGroupsBoolExp>>;
  _not?: InputMaybe<EventCouponGroupsBoolExp>;
  _or?: InputMaybe<Array<EventCouponGroupsBoolExp>>;
  coupon?: InputMaybe<EventCouponsBoolExp>;
  couponId?: InputMaybe<UuidComparisonExp>;
  eventGroup?: InputMaybe<EventGroupsBoolExp>;
  eventGroupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "event_coupon_groups" */
export type EventCouponGroupsMaxOrderBy = {
  couponId?: InputMaybe<OrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_coupon_groups" */
export type EventCouponGroupsMinOrderBy = {
  couponId?: InputMaybe<OrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_coupon_groups". */
export type EventCouponGroupsOrderBy = {
  coupon?: InputMaybe<EventCouponsOrderBy>;
  couponId?: InputMaybe<OrderBy>;
  eventGroup?: InputMaybe<EventGroupsOrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** select columns of table "event_coupon_groups" */
export enum EventCouponGroupsSelectColumn {
  /** column name */
  CouponId = 'couponId',
  /** column name */
  EventGroupId = 'eventGroupId',
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "event_coupon_groups" */
export type EventCouponGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCouponGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCouponGroupsStreamCursorValueInput = {
  couponId?: InputMaybe<Scalars['uuid']>;
  eventGroupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "event_coupon_redemptions" */
export type EventCouponRedemptions = {
  __typename?: 'EventCouponRedemptions';
  /** An object relationship */
  coupon: EventCoupons;
  couponId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  discountUnitAmount: Scalars['Int'];
  eventTransactionId?: Maybe<Scalars['uuid']>;
  eventTransactionItemId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  transaction?: Maybe<EventTransactions>;
  /** An object relationship */
  transactionItem?: Maybe<EventTransactionItems>;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "event_coupon_redemptions" */
export type EventCouponRedemptionsAggregate = {
  __typename?: 'EventCouponRedemptionsAggregate';
  aggregate?: Maybe<EventCouponRedemptionsAggregateFields>;
  nodes: Array<EventCouponRedemptions>;
};

export type EventCouponRedemptionsAggregateBoolExp = {
  count?: InputMaybe<EventCouponRedemptionsAggregateBoolExpCount>;
};

/** aggregate fields of "event_coupon_redemptions" */
export type EventCouponRedemptionsAggregateFields = {
  __typename?: 'EventCouponRedemptionsAggregateFields';
  avg?: Maybe<EventCouponRedemptionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventCouponRedemptionsMaxFields>;
  min?: Maybe<EventCouponRedemptionsMinFields>;
  stddev?: Maybe<EventCouponRedemptionsStddevFields>;
  stddevPop?: Maybe<EventCouponRedemptionsStddevPopFields>;
  stddevSamp?: Maybe<EventCouponRedemptionsStddevSampFields>;
  sum?: Maybe<EventCouponRedemptionsSumFields>;
  varPop?: Maybe<EventCouponRedemptionsVarPopFields>;
  varSamp?: Maybe<EventCouponRedemptionsVarSampFields>;
  variance?: Maybe<EventCouponRedemptionsVarianceFields>;
};


/** aggregate fields of "event_coupon_redemptions" */
export type EventCouponRedemptionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_coupon_redemptions" */
export type EventCouponRedemptionsAggregateOrderBy = {
  avg?: InputMaybe<EventCouponRedemptionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventCouponRedemptionsMaxOrderBy>;
  min?: InputMaybe<EventCouponRedemptionsMinOrderBy>;
  stddev?: InputMaybe<EventCouponRedemptionsStddevOrderBy>;
  stddevPop?: InputMaybe<EventCouponRedemptionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventCouponRedemptionsStddevSampOrderBy>;
  sum?: InputMaybe<EventCouponRedemptionsSumOrderBy>;
  varPop?: InputMaybe<EventCouponRedemptionsVarPopOrderBy>;
  varSamp?: InputMaybe<EventCouponRedemptionsVarSampOrderBy>;
  variance?: InputMaybe<EventCouponRedemptionsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type EventCouponRedemptionsAvgFields = {
  __typename?: 'EventCouponRedemptionsAvgFields';
  discountUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsAvgOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_coupon_redemptions". All fields are combined with a logical 'AND'. */
export type EventCouponRedemptionsBoolExp = {
  _and?: InputMaybe<Array<EventCouponRedemptionsBoolExp>>;
  _not?: InputMaybe<EventCouponRedemptionsBoolExp>;
  _or?: InputMaybe<Array<EventCouponRedemptionsBoolExp>>;
  coupon?: InputMaybe<EventCouponsBoolExp>;
  couponId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  discountUnitAmount?: InputMaybe<IntComparisonExp>;
  eventTransactionId?: InputMaybe<UuidComparisonExp>;
  eventTransactionItemId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  transaction?: InputMaybe<EventTransactionsBoolExp>;
  transactionItem?: InputMaybe<EventTransactionItemsBoolExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** aggregate max on columns */
export type EventCouponRedemptionsMaxFields = {
  __typename?: 'EventCouponRedemptionsMaxFields';
  couponId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  discountUnitAmount?: Maybe<Scalars['Int']>;
  eventTransactionId?: Maybe<Scalars['uuid']>;
  eventTransactionItemId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsMaxOrderBy = {
  couponId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  discountUnitAmount?: InputMaybe<OrderBy>;
  eventTransactionId?: InputMaybe<OrderBy>;
  eventTransactionItemId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventCouponRedemptionsMinFields = {
  __typename?: 'EventCouponRedemptionsMinFields';
  couponId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  discountUnitAmount?: Maybe<Scalars['Int']>;
  eventTransactionId?: Maybe<Scalars['uuid']>;
  eventTransactionItemId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsMinOrderBy = {
  couponId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  discountUnitAmount?: InputMaybe<OrderBy>;
  eventTransactionId?: InputMaybe<OrderBy>;
  eventTransactionItemId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_coupon_redemptions". */
export type EventCouponRedemptionsOrderBy = {
  coupon?: InputMaybe<EventCouponsOrderBy>;
  couponId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  discountUnitAmount?: InputMaybe<OrderBy>;
  eventTransactionId?: InputMaybe<OrderBy>;
  eventTransactionItemId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  transaction?: InputMaybe<EventTransactionsOrderBy>;
  transactionItem?: InputMaybe<EventTransactionItemsOrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "event_coupon_redemptions" */
export enum EventCouponRedemptionsSelectColumn {
  /** column name */
  CouponId = 'couponId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiscountUnitAmount = 'discountUnitAmount',
  /** column name */
  EventTransactionId = 'eventTransactionId',
  /** column name */
  EventTransactionItemId = 'eventTransactionItemId',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type EventCouponRedemptionsStddevFields = {
  __typename?: 'EventCouponRedemptionsStddevFields';
  discountUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsStddevOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventCouponRedemptionsStddevPopFields = {
  __typename?: 'EventCouponRedemptionsStddevPopFields';
  discountUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsStddevPopOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventCouponRedemptionsStddevSampFields = {
  __typename?: 'EventCouponRedemptionsStddevSampFields';
  discountUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsStddevSampOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_coupon_redemptions" */
export type EventCouponRedemptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCouponRedemptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCouponRedemptionsStreamCursorValueInput = {
  couponId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountUnitAmount?: InputMaybe<Scalars['Int']>;
  eventTransactionId?: InputMaybe<Scalars['uuid']>;
  eventTransactionItemId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type EventCouponRedemptionsSumFields = {
  __typename?: 'EventCouponRedemptionsSumFields';
  discountUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsSumOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varPop on columns */
export type EventCouponRedemptionsVarPopFields = {
  __typename?: 'EventCouponRedemptionsVarPopFields';
  discountUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsVarPopOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventCouponRedemptionsVarSampFields = {
  __typename?: 'EventCouponRedemptionsVarSampFields';
  discountUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsVarSampOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventCouponRedemptionsVarianceFields = {
  __typename?: 'EventCouponRedemptionsVarianceFields';
  discountUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_coupon_redemptions" */
export type EventCouponRedemptionsVarianceOrderBy = {
  discountUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_coupon_source" */
export type EventCouponSource = {
  __typename?: 'EventCouponSource';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_coupon_source". All fields are combined with a logical 'AND'. */
export type EventCouponSourceBoolExp = {
  _and?: InputMaybe<Array<EventCouponSourceBoolExp>>;
  _not?: InputMaybe<EventCouponSourceBoolExp>;
  _or?: InputMaybe<Array<EventCouponSourceBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventCouponSourceEnum {
  /** Time-based automatic pricing */
  EarlyBird = 'EARLY_BIRD',
  /** Organizer-created promo code */
  Manual = 'MANUAL'
}

/** Boolean expression to compare columns of type "EventCouponSourceEnum". All fields are combined with logical 'AND'. */
export type EventCouponSourceEnumComparisonExp = {
  _eq?: InputMaybe<EventCouponSourceEnum>;
  _in?: InputMaybe<Array<EventCouponSourceEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventCouponSourceEnum>;
  _nin?: InputMaybe<Array<EventCouponSourceEnum>>;
};

/** Ordering options when selecting data from "event_coupon_source". */
export type EventCouponSourceOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_coupon_source" */
export enum EventCouponSourceSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_coupon_source" */
export type EventCouponSourceStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCouponSourceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCouponSourceStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_coupon_type" */
export type EventCouponType = {
  __typename?: 'EventCouponType';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_coupon_type". All fields are combined with a logical 'AND'. */
export type EventCouponTypeBoolExp = {
  _and?: InputMaybe<Array<EventCouponTypeBoolExp>>;
  _not?: InputMaybe<EventCouponTypeBoolExp>;
  _or?: InputMaybe<Array<EventCouponTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventCouponTypeEnum {
  /** Subtract a fixed amount */
  AmountOff = 'AMOUNT_OFF',
  /** Override the price entirely */
  FixedPrice = 'FIXED_PRICE',
  /** Subtract a percentage */
  PercentOff = 'PERCENT_OFF'
}

/** Boolean expression to compare columns of type "EventCouponTypeEnum". All fields are combined with logical 'AND'. */
export type EventCouponTypeEnumComparisonExp = {
  _eq?: InputMaybe<EventCouponTypeEnum>;
  _in?: InputMaybe<Array<EventCouponTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventCouponTypeEnum>;
  _nin?: InputMaybe<Array<EventCouponTypeEnum>>;
};

/** Ordering options when selecting data from "event_coupon_type". */
export type EventCouponTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_coupon_type" */
export enum EventCouponTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_coupon_type" */
export type EventCouponTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCouponTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCouponTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_coupons" */
export type EventCoupons = {
  __typename?: 'EventCoupons';
  amountOff?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  /** An array relationship */
  couponGroups: Array<EventCouponGroups>;
  /** An object relationship */
  couponSourceDetails: EventCouponSource;
  couponType: EventCouponTypeEnum;
  /** An object relationship */
  couponTypeDetails: EventCouponType;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  fixedPrice?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  isAutoApply: Scalars['Boolean'];
  maxRedemptions?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  percentOff?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  redemptions: Array<EventCouponRedemptions>;
  /** An aggregate relationship */
  redemptionsAggregate: EventCouponRedemptionsAggregate;
  source: EventCouponSourceEnum;
  tierPriority: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  validFrom?: Maybe<Scalars['timestamptz']>;
  validUntil?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "event_coupons" */
export type EventCouponsCouponGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponGroupsOrderBy>>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};


/** columns and relationships of "event_coupons" */
export type EventCouponsRedemptionsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponRedemptionsOrderBy>>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};


/** columns and relationships of "event_coupons" */
export type EventCouponsRedemptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponRedemptionsOrderBy>>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};

/** order by aggregate values of table "event_coupons" */
export type EventCouponsAggregateOrderBy = {
  avg?: InputMaybe<EventCouponsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventCouponsMaxOrderBy>;
  min?: InputMaybe<EventCouponsMinOrderBy>;
  stddev?: InputMaybe<EventCouponsStddevOrderBy>;
  stddevPop?: InputMaybe<EventCouponsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventCouponsStddevSampOrderBy>;
  sum?: InputMaybe<EventCouponsSumOrderBy>;
  varPop?: InputMaybe<EventCouponsVarPopOrderBy>;
  varSamp?: InputMaybe<EventCouponsVarSampOrderBy>;
  variance?: InputMaybe<EventCouponsVarianceOrderBy>;
};

/** order by avg() on columns of table "event_coupons" */
export type EventCouponsAvgOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_coupons". All fields are combined with a logical 'AND'. */
export type EventCouponsBoolExp = {
  _and?: InputMaybe<Array<EventCouponsBoolExp>>;
  _not?: InputMaybe<EventCouponsBoolExp>;
  _or?: InputMaybe<Array<EventCouponsBoolExp>>;
  amountOff?: InputMaybe<IntComparisonExp>;
  code?: InputMaybe<StringComparisonExp>;
  couponGroups?: InputMaybe<EventCouponGroupsBoolExp>;
  couponSourceDetails?: InputMaybe<EventCouponSourceBoolExp>;
  couponType?: InputMaybe<EventCouponTypeEnumComparisonExp>;
  couponTypeDetails?: InputMaybe<EventCouponTypeBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  fixedPrice?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  isAutoApply?: InputMaybe<BooleanComparisonExp>;
  maxRedemptions?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  percentOff?: InputMaybe<NumericComparisonExp>;
  redemptions?: InputMaybe<EventCouponRedemptionsBoolExp>;
  redemptionsAggregate?: InputMaybe<EventCouponRedemptionsAggregateBoolExp>;
  source?: InputMaybe<EventCouponSourceEnumComparisonExp>;
  tierPriority?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  validFrom?: InputMaybe<TimestamptzComparisonExp>;
  validUntil?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "event_coupons" */
export type EventCouponsMaxOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  validFrom?: InputMaybe<OrderBy>;
  validUntil?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_coupons" */
export type EventCouponsMinOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  validFrom?: InputMaybe<OrderBy>;
  validUntil?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_coupons". */
export type EventCouponsOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  couponGroupsAggregate?: InputMaybe<EventCouponGroupsAggregateOrderBy>;
  couponSourceDetails?: InputMaybe<EventCouponSourceOrderBy>;
  couponType?: InputMaybe<OrderBy>;
  couponTypeDetails?: InputMaybe<EventCouponTypeOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  isAutoApply?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  redemptionsAggregate?: InputMaybe<EventCouponRedemptionsAggregateOrderBy>;
  source?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  validFrom?: InputMaybe<OrderBy>;
  validUntil?: InputMaybe<OrderBy>;
};

/** select columns of table "event_coupons" */
export enum EventCouponsSelectColumn {
  /** column name */
  AmountOff = 'amountOff',
  /** column name */
  Code = 'code',
  /** column name */
  CouponType = 'couponType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  FixedPrice = 'fixedPrice',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsAutoApply = 'isAutoApply',
  /** column name */
  MaxRedemptions = 'maxRedemptions',
  /** column name */
  Name = 'name',
  /** column name */
  PercentOff = 'percentOff',
  /** column name */
  Source = 'source',
  /** column name */
  TierPriority = 'tierPriority',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValidFrom = 'validFrom',
  /** column name */
  ValidUntil = 'validUntil'
}

/** order by stddev() on columns of table "event_coupons" */
export type EventCouponsStddevOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "event_coupons" */
export type EventCouponsStddevPopOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "event_coupons" */
export type EventCouponsStddevSampOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_coupons" */
export type EventCouponsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCouponsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCouponsStreamCursorValueInput = {
  amountOff?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  couponType?: InputMaybe<EventCouponTypeEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  fixedPrice?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAutoApply?: InputMaybe<Scalars['Boolean']>;
  maxRedemptions?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  percentOff?: InputMaybe<Scalars['numeric']>;
  source?: InputMaybe<EventCouponSourceEnum>;
  tierPriority?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validFrom?: InputMaybe<Scalars['timestamptz']>;
  validUntil?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "event_coupons" */
export type EventCouponsSumOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "event_coupons" */
export type EventCouponsVarPopOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "event_coupons" */
export type EventCouponsVarSampOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_coupons" */
export type EventCouponsVarianceOrderBy = {
  amountOff?: InputMaybe<OrderBy>;
  fixedPrice?: InputMaybe<OrderBy>;
  maxRedemptions?: InputMaybe<OrderBy>;
  percentOff?: InputMaybe<OrderBy>;
  tierPriority?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_court_statuses" */
export type EventCourtStatuses = {
  __typename?: 'EventCourtStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_court_statuses". All fields are combined with a logical 'AND'. */
export type EventCourtStatusesBoolExp = {
  _and?: InputMaybe<Array<EventCourtStatusesBoolExp>>;
  _not?: InputMaybe<EventCourtStatusesBoolExp>;
  _or?: InputMaybe<Array<EventCourtStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventCourtStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "EventCourtStatusesEnum". All fields are combined with logical 'AND'. */
export type EventCourtStatusesEnumComparisonExp = {
  _eq?: InputMaybe<EventCourtStatusesEnum>;
  _in?: InputMaybe<Array<EventCourtStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventCourtStatusesEnum>;
  _nin?: InputMaybe<Array<EventCourtStatusesEnum>>;
};

/** Ordering options when selecting data from "event_court_statuses". */
export type EventCourtStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_court_statuses" */
export enum EventCourtStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_court_statuses" */
export type EventCourtStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCourtStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCourtStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Note: This table may be overly structured with the foreign keys. Consider removing some if they're not needed. */
export type EventCourts = {
  __typename?: 'EventCourts';
  activeEventGroupId?: Maybe<Scalars['uuid']>;
  activeEventGroupPoolId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  activeGroup?: Maybe<EventGroups>;
  /** An object relationship */
  activeMatch?: Maybe<EventMatches>;
  activeMatchId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  activePool?: Maybe<EventGroupPools>;
  courtName?: Maybe<Scalars['String']>;
  courtNumber: Scalars['Int'];
  courtStatus: EventCourtStatusesEnum;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An array relationship */
  matches: Array<EventMatches>;
  updatedAt: Scalars['timestamptz'];
};


/** Note: This table may be overly structured with the foreign keys. Consider removing some if they're not needed. */
export type EventCourtsMatchesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};

/** order by aggregate values of table "event_courts" */
export type EventCourtsAggregateOrderBy = {
  avg?: InputMaybe<EventCourtsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventCourtsMaxOrderBy>;
  min?: InputMaybe<EventCourtsMinOrderBy>;
  stddev?: InputMaybe<EventCourtsStddevOrderBy>;
  stddevPop?: InputMaybe<EventCourtsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventCourtsStddevSampOrderBy>;
  sum?: InputMaybe<EventCourtsSumOrderBy>;
  varPop?: InputMaybe<EventCourtsVarPopOrderBy>;
  varSamp?: InputMaybe<EventCourtsVarSampOrderBy>;
  variance?: InputMaybe<EventCourtsVarianceOrderBy>;
};

/** order by avg() on columns of table "event_courts" */
export type EventCourtsAvgOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_courts". All fields are combined with a logical 'AND'. */
export type EventCourtsBoolExp = {
  _and?: InputMaybe<Array<EventCourtsBoolExp>>;
  _not?: InputMaybe<EventCourtsBoolExp>;
  _or?: InputMaybe<Array<EventCourtsBoolExp>>;
  activeEventGroupId?: InputMaybe<UuidComparisonExp>;
  activeEventGroupPoolId?: InputMaybe<UuidComparisonExp>;
  activeGroup?: InputMaybe<EventGroupsBoolExp>;
  activeMatch?: InputMaybe<EventMatchesBoolExp>;
  activeMatchId?: InputMaybe<UuidComparisonExp>;
  activePool?: InputMaybe<EventGroupPoolsBoolExp>;
  courtName?: InputMaybe<StringComparisonExp>;
  courtNumber?: InputMaybe<IntComparisonExp>;
  courtStatus?: InputMaybe<EventCourtStatusesEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  matches?: InputMaybe<EventMatchesBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "event_courts" */
export type EventCourtsMaxOrderBy = {
  activeEventGroupId?: InputMaybe<OrderBy>;
  activeEventGroupPoolId?: InputMaybe<OrderBy>;
  activeMatchId?: InputMaybe<OrderBy>;
  courtName?: InputMaybe<OrderBy>;
  courtNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_courts" */
export type EventCourtsMinOrderBy = {
  activeEventGroupId?: InputMaybe<OrderBy>;
  activeEventGroupPoolId?: InputMaybe<OrderBy>;
  activeMatchId?: InputMaybe<OrderBy>;
  courtName?: InputMaybe<OrderBy>;
  courtNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_courts" */
export type EventCourtsMutationResponse = {
  __typename?: 'EventCourtsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventCourts>;
};

/** Ordering options when selecting data from "event_courts". */
export type EventCourtsOrderBy = {
  activeEventGroupId?: InputMaybe<OrderBy>;
  activeEventGroupPoolId?: InputMaybe<OrderBy>;
  activeGroup?: InputMaybe<EventGroupsOrderBy>;
  activeMatch?: InputMaybe<EventMatchesOrderBy>;
  activeMatchId?: InputMaybe<OrderBy>;
  activePool?: InputMaybe<EventGroupPoolsOrderBy>;
  courtName?: InputMaybe<OrderBy>;
  courtNumber?: InputMaybe<OrderBy>;
  courtStatus?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matchesAggregate?: InputMaybe<EventMatchesAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_courts */
export type EventCourtsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_courts" */
export enum EventCourtsSelectColumn {
  /** column name */
  ActiveEventGroupId = 'activeEventGroupId',
  /** column name */
  ActiveEventGroupPoolId = 'activeEventGroupPoolId',
  /** column name */
  ActiveMatchId = 'activeMatchId',
  /** column name */
  CourtName = 'courtName',
  /** column name */
  CourtNumber = 'courtNumber',
  /** column name */
  CourtStatus = 'courtStatus',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_courts" */
export type EventCourtsSetInput = {
  activeEventGroupId?: InputMaybe<Scalars['uuid']>;
  activeEventGroupPoolId?: InputMaybe<Scalars['uuid']>;
  activeMatchId?: InputMaybe<Scalars['uuid']>;
  courtStatus?: InputMaybe<EventCourtStatusesEnum>;
};

/** order by stddev() on columns of table "event_courts" */
export type EventCourtsStddevOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "event_courts" */
export type EventCourtsStddevPopOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "event_courts" */
export type EventCourtsStddevSampOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_courts" */
export type EventCourtsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventCourtsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventCourtsStreamCursorValueInput = {
  activeEventGroupId?: InputMaybe<Scalars['uuid']>;
  activeEventGroupPoolId?: InputMaybe<Scalars['uuid']>;
  activeMatchId?: InputMaybe<Scalars['uuid']>;
  courtName?: InputMaybe<Scalars['String']>;
  courtNumber?: InputMaybe<Scalars['Int']>;
  courtStatus?: InputMaybe<EventCourtStatusesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "event_courts" */
export type EventCourtsSumOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

export type EventCourtsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventCourtsSetInput>;
  /** filter the rows which have to be updated */
  where: EventCourtsBoolExp;
};

/** order by varPop() on columns of table "event_courts" */
export type EventCourtsVarPopOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "event_courts" */
export type EventCourtsVarSampOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_courts" */
export type EventCourtsVarianceOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_faqs" */
export type EventFaqs = {
  __typename?: 'EventFaqs';
  answer: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  id: Scalars['uuid'];
  question: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "event_faqs" */
export type EventFaqsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventFaqsMaxOrderBy>;
  min?: InputMaybe<EventFaqsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_faqs" */
export type EventFaqsArrRelInsertInput = {
  data: Array<EventFaqsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventFaqsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_faqs". All fields are combined with a logical 'AND'. */
export type EventFaqsBoolExp = {
  _and?: InputMaybe<Array<EventFaqsBoolExp>>;
  _not?: InputMaybe<EventFaqsBoolExp>;
  _or?: InputMaybe<Array<EventFaqsBoolExp>>;
  answer?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  question?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_faqs" */
export enum EventFaqsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventFaqsPkey = 'event_faqs_pkey'
}

/** input type for inserting data into table "event_faqs" */
export type EventFaqsInsertInput = {
  answer?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "event_faqs" */
export type EventFaqsMaxOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_faqs" */
export type EventFaqsMinOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_faqs" */
export type EventFaqsMutationResponse = {
  __typename?: 'EventFaqsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventFaqs>;
};

/** on_conflict condition type for table "event_faqs" */
export type EventFaqsOnConflict = {
  constraint: EventFaqsConstraint;
  updateColumns?: Array<EventFaqsUpdateColumn>;
  where?: InputMaybe<EventFaqsBoolExp>;
};

/** Ordering options when selecting data from "event_faqs". */
export type EventFaqsOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_faqs */
export type EventFaqsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_faqs" */
export enum EventFaqsSelectColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_faqs" */
export type EventFaqsSetInput = {
  answer?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_faqs" */
export type EventFaqsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventFaqsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventFaqsStreamCursorValueInput = {
  answer?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_faqs" */
export enum EventFaqsUpdateColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  Question = 'question'
}

export type EventFaqsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventFaqsSetInput>;
  /** filter the rows which have to be updated */
  where: EventFaqsBoolExp;
};

/** NOTE: We are currently not using this table, but it was considered as there were many complex game and team structures discussed. For now we are storing scores in event_match_games, but we can backfill this one if needed. */
export type EventGameScores = {
  __typename?: 'EventGameScores';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  game: EventMatchGames;
  gameId: Scalars['uuid'];
  id: Scalars['uuid'];
  score: Scalars['Int'];
  /** An object relationship */
  team: EventTeams;
  teamId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "event_game_scores" */
export type EventGameScoresAggregateOrderBy = {
  avg?: InputMaybe<EventGameScoresAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGameScoresMaxOrderBy>;
  min?: InputMaybe<EventGameScoresMinOrderBy>;
  stddev?: InputMaybe<EventGameScoresStddevOrderBy>;
  stddevPop?: InputMaybe<EventGameScoresStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventGameScoresStddevSampOrderBy>;
  sum?: InputMaybe<EventGameScoresSumOrderBy>;
  varPop?: InputMaybe<EventGameScoresVarPopOrderBy>;
  varSamp?: InputMaybe<EventGameScoresVarSampOrderBy>;
  variance?: InputMaybe<EventGameScoresVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_game_scores" */
export type EventGameScoresArrRelInsertInput = {
  data: Array<EventGameScoresInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventGameScoresOnConflict>;
};

/** order by avg() on columns of table "event_game_scores" */
export type EventGameScoresAvgOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_game_scores". All fields are combined with a logical 'AND'. */
export type EventGameScoresBoolExp = {
  _and?: InputMaybe<Array<EventGameScoresBoolExp>>;
  _not?: InputMaybe<EventGameScoresBoolExp>;
  _or?: InputMaybe<Array<EventGameScoresBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  game?: InputMaybe<EventMatchGamesBoolExp>;
  gameId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  score?: InputMaybe<IntComparisonExp>;
  team?: InputMaybe<EventTeamsBoolExp>;
  teamId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_game_scores" */
export enum EventGameScoresConstraint {
  /** unique or primary key constraint on columns "game_id", "team_id" */
  EventGameScoresGameIdTeamIdKey = 'event_game_scores_game_id_team_id_key',
  /** unique or primary key constraint on columns "id" */
  EventGameScoresPkey = 'event_game_scores_pkey'
}

/** input type for incrementing numeric columns in table "event_game_scores" */
export type EventGameScoresIncInput = {
  score?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_game_scores" */
export type EventGameScoresInsertInput = {
  game?: InputMaybe<EventMatchGamesObjRelInsertInput>;
  gameId?: InputMaybe<Scalars['uuid']>;
  score?: InputMaybe<Scalars['Int']>;
  teamId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_game_scores" */
export type EventGameScoresMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  gameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  score?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_game_scores" */
export type EventGameScoresMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  gameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  score?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_game_scores" */
export type EventGameScoresMutationResponse = {
  __typename?: 'EventGameScoresMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGameScores>;
};

/** on_conflict condition type for table "event_game_scores" */
export type EventGameScoresOnConflict = {
  constraint: EventGameScoresConstraint;
  updateColumns?: Array<EventGameScoresUpdateColumn>;
  where?: InputMaybe<EventGameScoresBoolExp>;
};

/** Ordering options when selecting data from "event_game_scores". */
export type EventGameScoresOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  game?: InputMaybe<EventMatchGamesOrderBy>;
  gameId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  score?: InputMaybe<OrderBy>;
  team?: InputMaybe<EventTeamsOrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_game_scores */
export type EventGameScoresPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_game_scores" */
export enum EventGameScoresSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GameId = 'gameId',
  /** column name */
  Id = 'id',
  /** column name */
  Score = 'score',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_game_scores" */
export type EventGameScoresSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  score?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "event_game_scores" */
export type EventGameScoresStddevOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "event_game_scores" */
export type EventGameScoresStddevPopOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "event_game_scores" */
export type EventGameScoresStddevSampOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_game_scores" */
export type EventGameScoresStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGameScoresStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGameScoresStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  gameId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  score?: InputMaybe<Scalars['Int']>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "event_game_scores" */
export type EventGameScoresSumOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** update columns of table "event_game_scores" */
export enum EventGameScoresUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Score = 'score'
}

export type EventGameScoresUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventGameScoresIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGameScoresSetInput>;
  /** filter the rows which have to be updated */
  where: EventGameScoresBoolExp;
};

/** order by varPop() on columns of table "event_game_scores" */
export type EventGameScoresVarPopOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "event_game_scores" */
export type EventGameScoresVarSampOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_game_scores" */
export type EventGameScoresVarianceOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_group_formats" */
export type EventGroupFormats = {
  __typename?: 'EventGroupFormats';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_group_formats". All fields are combined with a logical 'AND'. */
export type EventGroupFormatsBoolExp = {
  _and?: InputMaybe<Array<EventGroupFormatsBoolExp>>;
  _not?: InputMaybe<EventGroupFormatsBoolExp>;
  _or?: InputMaybe<Array<EventGroupFormatsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventGroupFormatsEnum {
  Custom = 'CUSTOM',
  League = 'LEAGUE',
  RoundRobin = 'ROUND_ROBIN',
  RoundRobinSingleElimination = 'ROUND_ROBIN_SINGLE_ELIMINATION',
  SingleElimination = 'SINGLE_ELIMINATION',
  VairRoundRobin = 'VAIR_ROUND_ROBIN'
}

/** Boolean expression to compare columns of type "EventGroupFormatsEnum". All fields are combined with logical 'AND'. */
export type EventGroupFormatsEnumComparisonExp = {
  _eq?: InputMaybe<EventGroupFormatsEnum>;
  _in?: InputMaybe<Array<EventGroupFormatsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventGroupFormatsEnum>;
  _nin?: InputMaybe<Array<EventGroupFormatsEnum>>;
};

/** Ordering options when selecting data from "event_group_formats". */
export type EventGroupFormatsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_group_formats" */
export enum EventGroupFormatsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_group_formats" */
export type EventGroupFormatsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupFormatsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupFormatsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_group_merges" */
export type EventGroupMerges = {
  __typename?: 'EventGroupMerges';
  /** An object relationship */
  baseGroup: EventGroups;
  baseGroupId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  /** An array relationship */
  groups: Array<EventGroups>;
  id: Scalars['uuid'];
  unmergeForKnockout: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "event_group_merges" */
export type EventGroupMergesGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupsOrderBy>>;
  where?: InputMaybe<EventGroupsBoolExp>;
};

/** Boolean expression to filter rows from the table "event_group_merges". All fields are combined with a logical 'AND'. */
export type EventGroupMergesBoolExp = {
  _and?: InputMaybe<Array<EventGroupMergesBoolExp>>;
  _not?: InputMaybe<EventGroupMergesBoolExp>;
  _or?: InputMaybe<Array<EventGroupMergesBoolExp>>;
  baseGroup?: InputMaybe<EventGroupsBoolExp>;
  baseGroupId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  groups?: InputMaybe<EventGroupsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  unmergeForKnockout?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_group_merges" */
export enum EventGroupMergesConstraint {
  /** unique or primary key constraint on columns "id" */
  EventGroupMergesPkey = 'event_group_merges_pkey'
}

/** input type for inserting data into table "event_group_merges" */
export type EventGroupMergesInsertInput = {
  baseGroup?: InputMaybe<EventGroupsObjRelInsertInput>;
  baseGroupId?: InputMaybe<Scalars['uuid']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groups?: InputMaybe<EventGroupsArrRelInsertInput>;
  unmergeForKnockout?: InputMaybe<Scalars['Boolean']>;
};

/** response of any mutation on the table "event_group_merges" */
export type EventGroupMergesMutationResponse = {
  __typename?: 'EventGroupMergesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroupMerges>;
};

/** input type for inserting object relation for remote table "event_group_merges" */
export type EventGroupMergesObjRelInsertInput = {
  data: EventGroupMergesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupMergesOnConflict>;
};

/** on_conflict condition type for table "event_group_merges" */
export type EventGroupMergesOnConflict = {
  constraint: EventGroupMergesConstraint;
  updateColumns?: Array<EventGroupMergesUpdateColumn>;
  where?: InputMaybe<EventGroupMergesBoolExp>;
};

/** Ordering options when selecting data from "event_group_merges". */
export type EventGroupMergesOrderBy = {
  baseGroup?: InputMaybe<EventGroupsOrderBy>;
  baseGroupId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  groupsAggregate?: InputMaybe<EventGroupsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  unmergeForKnockout?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_group_merges */
export type EventGroupMergesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_group_merges" */
export enum EventGroupMergesSelectColumn {
  /** column name */
  BaseGroupId = 'baseGroupId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  UnmergeForKnockout = 'unmergeForKnockout',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_group_merges" */
export type EventGroupMergesSetInput = {
  baseGroupId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  unmergeForKnockout?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "event_group_merges" */
export type EventGroupMergesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupMergesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupMergesStreamCursorValueInput = {
  baseGroupId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  unmergeForKnockout?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_group_merges" */
export enum EventGroupMergesUpdateColumn {
  /** column name */
  BaseGroupId = 'baseGroupId',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  UnmergeForKnockout = 'unmergeForKnockout'
}

export type EventGroupMergesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupMergesSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupMergesBoolExp;
};

/** columns and relationships of "event_group_pools" */
export type EventGroupPools = {
  __typename?: 'EventGroupPools';
  /** An array relationship */
  courts: Array<EventCourts>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endsAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  group: EventGroups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An array relationship */
  matches: Array<EventMatches>;
  /** An array relationship */
  rounds: Array<EventPoolRounds>;
  /** An object relationship */
  sequence: EventGroupSequences;
  sequenceId: Scalars['uuid'];
  startsAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  teams: Array<EventPoolsTeams>;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "event_group_pools" */
export type EventGroupPoolsCourtsArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


/** columns and relationships of "event_group_pools" */
export type EventGroupPoolsMatchesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


/** columns and relationships of "event_group_pools" */
export type EventGroupPoolsRoundsArgs = {
  distinctOn?: InputMaybe<Array<EventPoolRoundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolRoundsOrderBy>>;
  where?: InputMaybe<EventPoolRoundsBoolExp>;
};


/** columns and relationships of "event_group_pools" */
export type EventGroupPoolsTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventPoolsTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolsTeamsOrderBy>>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};

/** order by aggregate values of table "event_group_pools" */
export type EventGroupPoolsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGroupPoolsMaxOrderBy>;
  min?: InputMaybe<EventGroupPoolsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "event_group_pools". All fields are combined with a logical 'AND'. */
export type EventGroupPoolsBoolExp = {
  _and?: InputMaybe<Array<EventGroupPoolsBoolExp>>;
  _not?: InputMaybe<EventGroupPoolsBoolExp>;
  _or?: InputMaybe<Array<EventGroupPoolsBoolExp>>;
  courts?: InputMaybe<EventCourtsBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  endsAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<EventGroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  matches?: InputMaybe<EventMatchesBoolExp>;
  rounds?: InputMaybe<EventPoolRoundsBoolExp>;
  sequence?: InputMaybe<EventGroupSequencesBoolExp>;
  sequenceId?: InputMaybe<UuidComparisonExp>;
  startsAt?: InputMaybe<TimestamptzComparisonExp>;
  teams?: InputMaybe<EventPoolsTeamsBoolExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "event_group_pools" */
export type EventGroupPoolsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sequenceId?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_group_pools" */
export type EventGroupPoolsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sequenceId?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_group_pools". */
export type EventGroupPoolsOrderBy = {
  courtsAggregate?: InputMaybe<EventCourtsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<EventGroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matchesAggregate?: InputMaybe<EventMatchesAggregateOrderBy>;
  roundsAggregate?: InputMaybe<EventPoolRoundsAggregateOrderBy>;
  sequence?: InputMaybe<EventGroupSequencesOrderBy>;
  sequenceId?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  teamsAggregate?: InputMaybe<EventPoolsTeamsAggregateOrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "event_group_pools" */
export enum EventGroupPoolsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  SequenceId = 'sequenceId',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "event_group_pools" */
export type EventGroupPoolsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupPoolsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupPoolsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  sequenceId?: InputMaybe<Scalars['uuid']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "event_group_rating_scales" */
export type EventGroupRatingScales = {
  __typename?: 'EventGroupRatingScales';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  eventGroup: EventGroups;
  eventGroupId: Scalars['uuid'];
  id: Scalars['uuid'];
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  padelRatingScale?: Maybe<PadelRatingScales>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  pickleballRatingScale?: Maybe<PickleballRatingScales>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  tennisRatingScale?: Maybe<TennisRatingScales>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "event_group_rating_scales" */
export type EventGroupRatingScalesAggregateOrderBy = {
  avg?: InputMaybe<EventGroupRatingScalesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGroupRatingScalesMaxOrderBy>;
  min?: InputMaybe<EventGroupRatingScalesMinOrderBy>;
  stddev?: InputMaybe<EventGroupRatingScalesStddevOrderBy>;
  stddevPop?: InputMaybe<EventGroupRatingScalesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventGroupRatingScalesStddevSampOrderBy>;
  sum?: InputMaybe<EventGroupRatingScalesSumOrderBy>;
  varPop?: InputMaybe<EventGroupRatingScalesVarPopOrderBy>;
  varSamp?: InputMaybe<EventGroupRatingScalesVarSampOrderBy>;
  variance?: InputMaybe<EventGroupRatingScalesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_group_rating_scales" */
export type EventGroupRatingScalesArrRelInsertInput = {
  data: Array<EventGroupRatingScalesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupRatingScalesOnConflict>;
};

/** order by avg() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesAvgOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_group_rating_scales". All fields are combined with a logical 'AND'. */
export type EventGroupRatingScalesBoolExp = {
  _and?: InputMaybe<Array<EventGroupRatingScalesBoolExp>>;
  _not?: InputMaybe<EventGroupRatingScalesBoolExp>;
  _or?: InputMaybe<Array<EventGroupRatingScalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  eventGroup?: InputMaybe<EventGroupsBoolExp>;
  eventGroupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  maximumRating?: InputMaybe<NumericComparisonExp>;
  minimumRating?: InputMaybe<NumericComparisonExp>;
  padelRatingScale?: InputMaybe<PadelRatingScalesBoolExp>;
  padelRatingScaleId?: InputMaybe<UuidComparisonExp>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesBoolExp>;
  pickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_group_rating_scales" */
export enum EventGroupRatingScalesConstraint {
  /** unique or primary key constraint on columns "padel_rating_scale_id", "event_group_id" */
  EventGroupRatingScalesEventGroupIdPadelRatingScaleKey = 'event_group_rating_scales_event_group_id_padel_rating_scale_key',
  /** unique or primary key constraint on columns "pickleball_rating_scale_id", "event_group_id" */
  EventGroupRatingScalesEventGroupIdPickleballRatingKey = 'event_group_rating_scales_event_group_id_pickleball_rating__key',
  /** unique or primary key constraint on columns "tennis_rating_scale_id", "event_group_id" */
  EventGroupRatingScalesEventGroupIdTennisRatingScalKey = 'event_group_rating_scales_event_group_id_tennis_rating_scal_key',
  /** unique or primary key constraint on columns "id" */
  EventGroupRatingScalesPkey = 'event_group_rating_scales_pkey'
}

/** input type for incrementing numeric columns in table "event_group_rating_scales" */
export type EventGroupRatingScalesIncInput = {
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "event_group_rating_scales" */
export type EventGroupRatingScalesInsertInput = {
  eventGroup?: InputMaybe<EventGroupsObjRelInsertInput>;
  eventGroupId?: InputMaybe<Scalars['uuid']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_group_rating_scales" */
export type EventGroupRatingScalesMutationResponse = {
  __typename?: 'EventGroupRatingScalesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroupRatingScales>;
};

/** on_conflict condition type for table "event_group_rating_scales" */
export type EventGroupRatingScalesOnConflict = {
  constraint: EventGroupRatingScalesConstraint;
  updateColumns?: Array<EventGroupRatingScalesUpdateColumn>;
  where?: InputMaybe<EventGroupRatingScalesBoolExp>;
};

/** Ordering options when selecting data from "event_group_rating_scales". */
export type EventGroupRatingScalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventGroup?: InputMaybe<EventGroupsOrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  padelRatingScale?: InputMaybe<PadelRatingScalesOrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesOrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_group_rating_scales */
export type EventGroupRatingScalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_group_rating_scales" */
export enum EventGroupRatingScalesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventGroupId = 'eventGroupId',
  /** column name */
  Id = 'id',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_group_rating_scales" */
export type EventGroupRatingScalesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
};

/** order by stddev() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesStddevOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesStddevPopOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesStddevSampOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_group_rating_scales" */
export type EventGroupRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupRatingScalesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventGroupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesSumOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** update columns of table "event_group_rating_scales" */
export enum EventGroupRatingScalesUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId'
}

export type EventGroupRatingScalesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventGroupRatingScalesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupRatingScalesSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupRatingScalesBoolExp;
};

/** order by varPop() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesVarPopOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesVarSampOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_group_rating_scales" */
export type EventGroupRatingScalesVarianceOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_group_registration_statuses" */
export type EventGroupRegistrationStatuses = {
  __typename?: 'EventGroupRegistrationStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_group_registration_statuses". All fields are combined with a logical 'AND'. */
export type EventGroupRegistrationStatusesBoolExp = {
  _and?: InputMaybe<Array<EventGroupRegistrationStatusesBoolExp>>;
  _not?: InputMaybe<EventGroupRegistrationStatusesBoolExp>;
  _or?: InputMaybe<Array<EventGroupRegistrationStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventGroupRegistrationStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "EventGroupRegistrationStatusesEnum". All fields are combined with logical 'AND'. */
export type EventGroupRegistrationStatusesEnumComparisonExp = {
  _eq?: InputMaybe<EventGroupRegistrationStatusesEnum>;
  _in?: InputMaybe<Array<EventGroupRegistrationStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventGroupRegistrationStatusesEnum>;
  _nin?: InputMaybe<Array<EventGroupRegistrationStatusesEnum>>;
};

/** Ordering options when selecting data from "event_group_registration_statuses". */
export type EventGroupRegistrationStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_group_registration_statuses" */
export enum EventGroupRegistrationStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_group_registration_statuses" */
export type EventGroupRegistrationStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupRegistrationStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupRegistrationStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_group_registrations" */
export type EventGroupRegistrations = {
  __typename?: 'EventGroupRegistrations';
  checkedInAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  group: EventGroups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An array relationship */
  invitations: Array<EventInvitations>;
  status: EventGroupRegistrationStatusesEnum;
  /** An object relationship */
  team?: Maybe<EventTeams>;
  teamId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  transactionItems: Array<EventTransactionItems>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};


/** columns and relationships of "event_group_registrations" */
export type EventGroupRegistrationsInvitationsArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationsOrderBy>>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};


/** columns and relationships of "event_group_registrations" */
export type EventGroupRegistrationsTransactionItemsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};

/** order by aggregate values of table "event_group_registrations" */
export type EventGroupRegistrationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGroupRegistrationsMaxOrderBy>;
  min?: InputMaybe<EventGroupRegistrationsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "event_group_registrations". All fields are combined with a logical 'AND'. */
export type EventGroupRegistrationsBoolExp = {
  _and?: InputMaybe<Array<EventGroupRegistrationsBoolExp>>;
  _not?: InputMaybe<EventGroupRegistrationsBoolExp>;
  _or?: InputMaybe<Array<EventGroupRegistrationsBoolExp>>;
  checkedInAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<EventGroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  invitations?: InputMaybe<EventInvitationsBoolExp>;
  status?: InputMaybe<EventGroupRegistrationStatusesEnumComparisonExp>;
  team?: InputMaybe<EventTeamsBoolExp>;
  teamId?: InputMaybe<UuidComparisonExp>;
  transactionItems?: InputMaybe<EventTransactionItemsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** order by max() on columns of table "event_group_registrations" */
export type EventGroupRegistrationsMaxOrderBy = {
  checkedInAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_group_registrations" */
export type EventGroupRegistrationsMinOrderBy = {
  checkedInAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_group_registrations". */
export type EventGroupRegistrationsOrderBy = {
  checkedInAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<EventGroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invitationsAggregate?: InputMaybe<EventInvitationsAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  team?: InputMaybe<EventTeamsOrderBy>;
  teamId?: InputMaybe<OrderBy>;
  transactionItemsAggregate?: InputMaybe<EventTransactionItemsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** select columns of table "event_group_registrations" */
export enum EventGroupRegistrationsSelectColumn {
  /** column name */
  CheckedInAt = 'checkedInAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "event_group_registrations" */
export type EventGroupRegistrationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupRegistrationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupRegistrationsStreamCursorValueInput = {
  checkedInAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<EventGroupRegistrationStatusesEnum>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "event_group_sequence_seeding" */
export type EventGroupSequenceSeeding = {
  __typename?: 'EventGroupSequenceSeeding';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventGroupSequenceId: Scalars['uuid'];
  eventTeamId: Scalars['uuid'];
  id: Scalars['uuid'];
  seed: Scalars['Int'];
  /** An object relationship */
  sequence: EventGroupSequences;
  /** An object relationship */
  team: EventTeams;
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingAggregateOrderBy = {
  avg?: InputMaybe<EventGroupSequenceSeedingAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGroupSequenceSeedingMaxOrderBy>;
  min?: InputMaybe<EventGroupSequenceSeedingMinOrderBy>;
  stddev?: InputMaybe<EventGroupSequenceSeedingStddevOrderBy>;
  stddevPop?: InputMaybe<EventGroupSequenceSeedingStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventGroupSequenceSeedingStddevSampOrderBy>;
  sum?: InputMaybe<EventGroupSequenceSeedingSumOrderBy>;
  varPop?: InputMaybe<EventGroupSequenceSeedingVarPopOrderBy>;
  varSamp?: InputMaybe<EventGroupSequenceSeedingVarSampOrderBy>;
  variance?: InputMaybe<EventGroupSequenceSeedingVarianceOrderBy>;
};

/** order by avg() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingAvgOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_group_sequence_seeding". All fields are combined with a logical 'AND'. */
export type EventGroupSequenceSeedingBoolExp = {
  _and?: InputMaybe<Array<EventGroupSequenceSeedingBoolExp>>;
  _not?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
  _or?: InputMaybe<Array<EventGroupSequenceSeedingBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  eventGroupSequenceId?: InputMaybe<UuidComparisonExp>;
  eventTeamId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  seed?: InputMaybe<IntComparisonExp>;
  sequence?: InputMaybe<EventGroupSequencesBoolExp>;
  team?: InputMaybe<EventTeamsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventGroupSequenceId?: InputMaybe<OrderBy>;
  eventTeamId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  seed?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventGroupSequenceId?: InputMaybe<OrderBy>;
  eventTeamId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  seed?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_group_sequence_seeding". */
export type EventGroupSequenceSeedingOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventGroupSequenceId?: InputMaybe<OrderBy>;
  eventTeamId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  seed?: InputMaybe<OrderBy>;
  sequence?: InputMaybe<EventGroupSequencesOrderBy>;
  team?: InputMaybe<EventTeamsOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "event_group_sequence_seeding" */
export enum EventGroupSequenceSeedingSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventGroupSequenceId = 'eventGroupSequenceId',
  /** column name */
  EventTeamId = 'eventTeamId',
  /** column name */
  Id = 'id',
  /** column name */
  Seed = 'seed',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** order by stddev() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingStddevOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingStddevPopOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingStddevSampOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupSequenceSeedingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupSequenceSeedingStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventGroupSequenceId?: InputMaybe<Scalars['uuid']>;
  eventTeamId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  seed?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingSumOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingVarPopOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingVarSampOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_group_sequence_seeding" */
export type EventGroupSequenceSeedingVarianceOrderBy = {
  seed?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_group_sequences" */
export type EventGroupSequences = {
  __typename?: 'EventGroupSequences';
  competitionFormat: CompetitionFormatsEnum;
  completeReason: EventSequenceCompleteReasonsEnum;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  group: EventGroups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  isSequenceComplete: Scalars['Boolean'];
  /** An object relationship */
  nextSequence?: Maybe<EventGroupSequences>;
  nextSequenceId?: Maybe<Scalars['uuid']>;
  order: Scalars['Int'];
  /** An array relationship */
  pools: Array<EventGroupPools>;
  /** An array relationship */
  seeding: Array<EventGroupSequenceSeeding>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "event_group_sequences" */
export type EventGroupSequencesPoolsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupPoolsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupPoolsOrderBy>>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};


/** columns and relationships of "event_group_sequences" */
export type EventGroupSequencesSeedingArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequenceSeedingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequenceSeedingOrderBy>>;
  where?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
};

/** order by aggregate values of table "event_group_sequences" */
export type EventGroupSequencesAggregateOrderBy = {
  avg?: InputMaybe<EventGroupSequencesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGroupSequencesMaxOrderBy>;
  min?: InputMaybe<EventGroupSequencesMinOrderBy>;
  stddev?: InputMaybe<EventGroupSequencesStddevOrderBy>;
  stddevPop?: InputMaybe<EventGroupSequencesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventGroupSequencesStddevSampOrderBy>;
  sum?: InputMaybe<EventGroupSequencesSumOrderBy>;
  varPop?: InputMaybe<EventGroupSequencesVarPopOrderBy>;
  varSamp?: InputMaybe<EventGroupSequencesVarSampOrderBy>;
  variance?: InputMaybe<EventGroupSequencesVarianceOrderBy>;
};

/** order by avg() on columns of table "event_group_sequences" */
export type EventGroupSequencesAvgOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_group_sequences". All fields are combined with a logical 'AND'. */
export type EventGroupSequencesBoolExp = {
  _and?: InputMaybe<Array<EventGroupSequencesBoolExp>>;
  _not?: InputMaybe<EventGroupSequencesBoolExp>;
  _or?: InputMaybe<Array<EventGroupSequencesBoolExp>>;
  competitionFormat?: InputMaybe<CompetitionFormatsEnumComparisonExp>;
  completeReason?: InputMaybe<EventSequenceCompleteReasonsEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<EventGroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isSequenceComplete?: InputMaybe<BooleanComparisonExp>;
  nextSequence?: InputMaybe<EventGroupSequencesBoolExp>;
  nextSequenceId?: InputMaybe<UuidComparisonExp>;
  order?: InputMaybe<IntComparisonExp>;
  pools?: InputMaybe<EventGroupPoolsBoolExp>;
  seeding?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "event_group_sequences" */
export type EventGroupSequencesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  nextSequenceId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_group_sequences" */
export type EventGroupSequencesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  nextSequenceId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_group_sequences" */
export type EventGroupSequencesMutationResponse = {
  __typename?: 'EventGroupSequencesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroupSequences>;
};

/** Ordering options when selecting data from "event_group_sequences". */
export type EventGroupSequencesOrderBy = {
  competitionFormat?: InputMaybe<OrderBy>;
  completeReason?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<EventGroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isSequenceComplete?: InputMaybe<OrderBy>;
  nextSequence?: InputMaybe<EventGroupSequencesOrderBy>;
  nextSequenceId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  poolsAggregate?: InputMaybe<EventGroupPoolsAggregateOrderBy>;
  seedingAggregate?: InputMaybe<EventGroupSequenceSeedingAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_group_sequences */
export type EventGroupSequencesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_group_sequences" */
export enum EventGroupSequencesSelectColumn {
  /** column name */
  CompetitionFormat = 'competitionFormat',
  /** column name */
  CompleteReason = 'completeReason',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  IsSequenceComplete = 'isSequenceComplete',
  /** column name */
  NextSequenceId = 'nextSequenceId',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_group_sequences" */
export type EventGroupSequencesSetInput = {
  completeReason?: InputMaybe<EventSequenceCompleteReasonsEnum>;
  isSequenceComplete?: InputMaybe<Scalars['Boolean']>;
};

/** order by stddev() on columns of table "event_group_sequences" */
export type EventGroupSequencesStddevOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "event_group_sequences" */
export type EventGroupSequencesStddevPopOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "event_group_sequences" */
export type EventGroupSequencesStddevSampOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_group_sequences" */
export type EventGroupSequencesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupSequencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupSequencesStreamCursorValueInput = {
  competitionFormat?: InputMaybe<CompetitionFormatsEnum>;
  completeReason?: InputMaybe<EventSequenceCompleteReasonsEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isSequenceComplete?: InputMaybe<Scalars['Boolean']>;
  nextSequenceId?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "event_group_sequences" */
export type EventGroupSequencesSumOrderBy = {
  order?: InputMaybe<OrderBy>;
};

export type EventGroupSequencesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupSequencesSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupSequencesBoolExp;
};

/** order by varPop() on columns of table "event_group_sequences" */
export type EventGroupSequencesVarPopOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "event_group_sequences" */
export type EventGroupSequencesVarSampOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_group_sequences" */
export type EventGroupSequencesVarianceOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_group_time_slots" */
export type EventGroupTimeSlots = {
  __typename?: 'EventGroupTimeSlots';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endsAt: Scalars['timestamptz'];
  externalBookingUrl?: Maybe<Scalars['String']>;
  /** An object relationship */
  group: EventGroups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  startsAt: Scalars['timestamptz'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "event_group_time_slots" */
export type EventGroupTimeSlotsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGroupTimeSlotsMaxOrderBy>;
  min?: InputMaybe<EventGroupTimeSlotsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_group_time_slots" */
export type EventGroupTimeSlotsArrRelInsertInput = {
  data: Array<EventGroupTimeSlotsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupTimeSlotsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_group_time_slots". All fields are combined with a logical 'AND'. */
export type EventGroupTimeSlotsBoolExp = {
  _and?: InputMaybe<Array<EventGroupTimeSlotsBoolExp>>;
  _not?: InputMaybe<EventGroupTimeSlotsBoolExp>;
  _or?: InputMaybe<Array<EventGroupTimeSlotsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  endsAt?: InputMaybe<TimestamptzComparisonExp>;
  externalBookingUrl?: InputMaybe<StringComparisonExp>;
  group?: InputMaybe<EventGroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  startsAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_group_time_slots" */
export enum EventGroupTimeSlotsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventGroupTimeSlotsPkey = 'event_group_time_slots_pkey'
}

/** input type for inserting data into table "event_group_time_slots" */
export type EventGroupTimeSlotsInsertInput = {
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<EventGroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_group_time_slots" */
export type EventGroupTimeSlotsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  externalBookingUrl?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_group_time_slots" */
export type EventGroupTimeSlotsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  externalBookingUrl?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_group_time_slots" */
export type EventGroupTimeSlotsMutationResponse = {
  __typename?: 'EventGroupTimeSlotsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroupTimeSlots>;
};

/** on_conflict condition type for table "event_group_time_slots" */
export type EventGroupTimeSlotsOnConflict = {
  constraint: EventGroupTimeSlotsConstraint;
  updateColumns?: Array<EventGroupTimeSlotsUpdateColumn>;
  where?: InputMaybe<EventGroupTimeSlotsBoolExp>;
};

/** Ordering options when selecting data from "event_group_time_slots". */
export type EventGroupTimeSlotsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  externalBookingUrl?: InputMaybe<OrderBy>;
  group?: InputMaybe<EventGroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_group_time_slots */
export type EventGroupTimeSlotsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_group_time_slots" */
export enum EventGroupTimeSlotsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  ExternalBookingUrl = 'externalBookingUrl',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_group_time_slots" */
export type EventGroupTimeSlotsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_group_time_slots" */
export type EventGroupTimeSlotsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupTimeSlotsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupTimeSlotsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_group_time_slots" */
export enum EventGroupTimeSlotsUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  ExternalBookingUrl = 'externalBookingUrl',
  /** column name */
  StartsAt = 'startsAt'
}

export type EventGroupTimeSlotsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupTimeSlotsSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupTimeSlotsBoolExp;
};

/** columns and relationships of "event_groups" */
export type EventGroups = {
  __typename?: 'EventGroups';
  bracketRankingMechanism?: Maybe<BracketRankingMechanismEnum>;
  competitiveness?: Maybe<EventCompetitivenessEnum>;
  /** An array relationship */
  couponGroups: Array<EventCouponGroups>;
  /** An array relationship */
  courts: Array<EventCourts>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  desiredNumberOfPools?: Maybe<Scalars['Int']>;
  endsAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  format?: Maybe<EventGroupFormatsEnum>;
  formatCustomName: Scalars['String'];
  gamesPerMatch: Scalars['Int'];
  gender: CompetitionGenderEnum;
  id: Scalars['uuid'];
  isAgeRestricted: Scalars['Boolean'];
  isMoneyBall?: Maybe<Scalars['Boolean']>;
  isRatingRequired: Scalars['Boolean'];
  isVairRatingSession?: Maybe<Scalars['Boolean']>;
  isVairVairifiedRequired?: Maybe<Scalars['Boolean']>;
  isWheelchair?: Maybe<Scalars['Boolean']>;
  maximumAge?: Maybe<Scalars['Int']>;
  maximumRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  merge?: Maybe<EventGroupMerges>;
  mergeId?: Maybe<Scalars['uuid']>;
  minimumAge?: Maybe<Scalars['Int']>;
  minimumNumberOfGames: Scalars['Int'];
  minimumRating?: Maybe<Scalars['numeric']>;
  moneyBallRewards?: Maybe<Scalars['jsonb']>;
  netStatus?: Maybe<GameNetStatusesEnum>;
  numberOfEliminationTeams?: Maybe<Scalars['Int']>;
  numberOfEstimatedCourts?: Maybe<Scalars['Int']>;
  /** An array relationship */
  pools: Array<EventGroupPools>;
  priceUnitAmount: Scalars['Int'];
  /** An array relationship */
  ratingScales: Array<EventGroupRatingScales>;
  /** An array relationship */
  registrations: Array<EventGroupRegistrations>;
  scoringFormat?: Maybe<ScoringFormatEnum>;
  /** An object relationship */
  selfRatedMaxSkillLevel?: Maybe<SkillLevels>;
  selfRatedMaxSkillLevelId?: Maybe<Scalars['String']>;
  /** An object relationship */
  selfRatedMinSkillLevel?: Maybe<SkillLevels>;
  selfRatedMinSkillLevelId?: Maybe<Scalars['String']>;
  /** An array relationship */
  sequences: Array<EventGroupSequences>;
  startsAt?: Maybe<Scalars['timestamptz']>;
  teamLimit?: Maybe<Scalars['Int']>;
  teamType?: Maybe<TeamTypesEnum>;
  /** An array relationship */
  teams: Array<EventTeams>;
  /** An array relationship */
  timeSlots: Array<EventGroupTimeSlots>;
  title: Scalars['String'];
  totalPoints?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['timestamptz'];
  winBy?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsCouponGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponGroupsOrderBy>>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsCourtsArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsMoneyBallRewardsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsPoolsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupPoolsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupPoolsOrderBy>>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRatingScalesOrderBy>>;
  where?: InputMaybe<EventGroupRatingScalesBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsRegistrationsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationsOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsSequencesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequencesOrderBy>>;
  where?: InputMaybe<EventGroupSequencesBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamsOrderBy>>;
  where?: InputMaybe<EventTeamsBoolExp>;
};


/** columns and relationships of "event_groups" */
export type EventGroupsTimeSlotsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupTimeSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupTimeSlotsOrderBy>>;
  where?: InputMaybe<EventGroupTimeSlotsBoolExp>;
};

/** order by aggregate values of table "event_groups" */
export type EventGroupsAggregateOrderBy = {
  avg?: InputMaybe<EventGroupsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventGroupsMaxOrderBy>;
  min?: InputMaybe<EventGroupsMinOrderBy>;
  stddev?: InputMaybe<EventGroupsStddevOrderBy>;
  stddevPop?: InputMaybe<EventGroupsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventGroupsStddevSampOrderBy>;
  sum?: InputMaybe<EventGroupsSumOrderBy>;
  varPop?: InputMaybe<EventGroupsVarPopOrderBy>;
  varSamp?: InputMaybe<EventGroupsVarSampOrderBy>;
  variance?: InputMaybe<EventGroupsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EventGroupsAppendInput = {
  moneyBallRewards?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "event_groups" */
export type EventGroupsArrRelInsertInput = {
  data: Array<EventGroupsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupsOnConflict>;
};

/** order by avg() on columns of table "event_groups" */
export type EventGroupsAvgOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_groups". All fields are combined with a logical 'AND'. */
export type EventGroupsBoolExp = {
  _and?: InputMaybe<Array<EventGroupsBoolExp>>;
  _not?: InputMaybe<EventGroupsBoolExp>;
  _or?: InputMaybe<Array<EventGroupsBoolExp>>;
  bracketRankingMechanism?: InputMaybe<BracketRankingMechanismEnumComparisonExp>;
  competitiveness?: InputMaybe<EventCompetitivenessEnumComparisonExp>;
  couponGroups?: InputMaybe<EventCouponGroupsBoolExp>;
  courts?: InputMaybe<EventCourtsBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  desiredNumberOfPools?: InputMaybe<IntComparisonExp>;
  endsAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  format?: InputMaybe<EventGroupFormatsEnumComparisonExp>;
  formatCustomName?: InputMaybe<StringComparisonExp>;
  gamesPerMatch?: InputMaybe<IntComparisonExp>;
  gender?: InputMaybe<CompetitionGenderEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isAgeRestricted?: InputMaybe<BooleanComparisonExp>;
  isMoneyBall?: InputMaybe<BooleanComparisonExp>;
  isRatingRequired?: InputMaybe<BooleanComparisonExp>;
  isVairRatingSession?: InputMaybe<BooleanComparisonExp>;
  isVairVairifiedRequired?: InputMaybe<BooleanComparisonExp>;
  isWheelchair?: InputMaybe<BooleanComparisonExp>;
  maximumAge?: InputMaybe<IntComparisonExp>;
  maximumRating?: InputMaybe<NumericComparisonExp>;
  merge?: InputMaybe<EventGroupMergesBoolExp>;
  mergeId?: InputMaybe<UuidComparisonExp>;
  minimumAge?: InputMaybe<IntComparisonExp>;
  minimumNumberOfGames?: InputMaybe<IntComparisonExp>;
  minimumRating?: InputMaybe<NumericComparisonExp>;
  moneyBallRewards?: InputMaybe<JsonbComparisonExp>;
  netStatus?: InputMaybe<GameNetStatusesEnumComparisonExp>;
  numberOfEliminationTeams?: InputMaybe<IntComparisonExp>;
  numberOfEstimatedCourts?: InputMaybe<IntComparisonExp>;
  pools?: InputMaybe<EventGroupPoolsBoolExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  ratingScales?: InputMaybe<EventGroupRatingScalesBoolExp>;
  registrations?: InputMaybe<EventGroupRegistrationsBoolExp>;
  scoringFormat?: InputMaybe<ScoringFormatEnumComparisonExp>;
  selfRatedMaxSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  selfRatedMaxSkillLevelId?: InputMaybe<StringComparisonExp>;
  selfRatedMinSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  selfRatedMinSkillLevelId?: InputMaybe<StringComparisonExp>;
  sequences?: InputMaybe<EventGroupSequencesBoolExp>;
  startsAt?: InputMaybe<TimestamptzComparisonExp>;
  teamLimit?: InputMaybe<IntComparisonExp>;
  teamType?: InputMaybe<TeamTypesEnumComparisonExp>;
  teams?: InputMaybe<EventTeamsBoolExp>;
  timeSlots?: InputMaybe<EventGroupTimeSlotsBoolExp>;
  title?: InputMaybe<StringComparisonExp>;
  totalPoints?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  winBy?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "event_groups" */
export enum EventGroupsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventGroupsPkey = 'event_groups_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EventGroupsDeleteAtPathInput = {
  moneyBallRewards?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EventGroupsDeleteElemInput = {
  moneyBallRewards?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EventGroupsDeleteKeyInput = {
  moneyBallRewards?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "event_groups" */
export type EventGroupsIncInput = {
  desiredNumberOfPools?: InputMaybe<Scalars['Int']>;
  gamesPerMatch?: InputMaybe<Scalars['Int']>;
  maximumAge?: InputMaybe<Scalars['Int']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  minimumNumberOfGames?: InputMaybe<Scalars['Int']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  numberOfEliminationTeams?: InputMaybe<Scalars['Int']>;
  numberOfEstimatedCourts?: InputMaybe<Scalars['Int']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  teamLimit?: InputMaybe<Scalars['Int']>;
  totalPoints?: InputMaybe<Scalars['Int']>;
  winBy?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_groups" */
export type EventGroupsInsertInput = {
  bracketRankingMechanism?: InputMaybe<BracketRankingMechanismEnum>;
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  desiredNumberOfPools?: InputMaybe<Scalars['Int']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  format?: InputMaybe<EventGroupFormatsEnum>;
  formatCustomName?: InputMaybe<Scalars['String']>;
  gamesPerMatch?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<CompetitionGenderEnum>;
  isAgeRestricted?: InputMaybe<Scalars['Boolean']>;
  isMoneyBall?: InputMaybe<Scalars['Boolean']>;
  isRatingRequired?: InputMaybe<Scalars['Boolean']>;
  isVairRatingSession?: InputMaybe<Scalars['Boolean']>;
  isVairVairifiedRequired?: InputMaybe<Scalars['Boolean']>;
  isWheelchair?: InputMaybe<Scalars['Boolean']>;
  maximumAge?: InputMaybe<Scalars['Int']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  merge?: InputMaybe<EventGroupMergesObjRelInsertInput>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  minimumNumberOfGames?: InputMaybe<Scalars['Int']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  moneyBallRewards?: InputMaybe<Scalars['jsonb']>;
  netStatus?: InputMaybe<GameNetStatusesEnum>;
  numberOfEliminationTeams?: InputMaybe<Scalars['Int']>;
  numberOfEstimatedCourts?: InputMaybe<Scalars['Int']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  ratingScales?: InputMaybe<EventGroupRatingScalesArrRelInsertInput>;
  scoringFormat?: InputMaybe<ScoringFormatEnum>;
  selfRatedMaxSkillLevelId?: InputMaybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  teamLimit?: InputMaybe<Scalars['Int']>;
  teamType?: InputMaybe<TeamTypesEnum>;
  timeSlots?: InputMaybe<EventGroupTimeSlotsArrRelInsertInput>;
  title?: InputMaybe<Scalars['String']>;
  totalPoints?: InputMaybe<Scalars['Int']>;
  winBy?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "event_groups" */
export type EventGroupsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  formatCustomName?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  mergeId?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  selfRatedMaxSkillLevelId?: InputMaybe<OrderBy>;
  selfRatedMinSkillLevelId?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_groups" */
export type EventGroupsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  formatCustomName?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  mergeId?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  selfRatedMaxSkillLevelId?: InputMaybe<OrderBy>;
  selfRatedMinSkillLevelId?: InputMaybe<OrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_groups" */
export type EventGroupsMutationResponse = {
  __typename?: 'EventGroupsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventGroups>;
};

/** input type for inserting object relation for remote table "event_groups" */
export type EventGroupsObjRelInsertInput = {
  data: EventGroupsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventGroupsOnConflict>;
};

/** on_conflict condition type for table "event_groups" */
export type EventGroupsOnConflict = {
  constraint: EventGroupsConstraint;
  updateColumns?: Array<EventGroupsUpdateColumn>;
  where?: InputMaybe<EventGroupsBoolExp>;
};

/** Ordering options when selecting data from "event_groups". */
export type EventGroupsOrderBy = {
  bracketRankingMechanism?: InputMaybe<OrderBy>;
  competitiveness?: InputMaybe<OrderBy>;
  couponGroupsAggregate?: InputMaybe<EventCouponGroupsAggregateOrderBy>;
  courtsAggregate?: InputMaybe<EventCourtsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  endsAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  format?: InputMaybe<OrderBy>;
  formatCustomName?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isAgeRestricted?: InputMaybe<OrderBy>;
  isMoneyBall?: InputMaybe<OrderBy>;
  isRatingRequired?: InputMaybe<OrderBy>;
  isVairRatingSession?: InputMaybe<OrderBy>;
  isVairVairifiedRequired?: InputMaybe<OrderBy>;
  isWheelchair?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  merge?: InputMaybe<EventGroupMergesOrderBy>;
  mergeId?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  moneyBallRewards?: InputMaybe<OrderBy>;
  netStatus?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  poolsAggregate?: InputMaybe<EventGroupPoolsAggregateOrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  ratingScalesAggregate?: InputMaybe<EventGroupRatingScalesAggregateOrderBy>;
  registrationsAggregate?: InputMaybe<EventGroupRegistrationsAggregateOrderBy>;
  scoringFormat?: InputMaybe<OrderBy>;
  selfRatedMaxSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  selfRatedMaxSkillLevelId?: InputMaybe<OrderBy>;
  selfRatedMinSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  selfRatedMinSkillLevelId?: InputMaybe<OrderBy>;
  sequencesAggregate?: InputMaybe<EventGroupSequencesAggregateOrderBy>;
  startsAt?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  teamType?: InputMaybe<OrderBy>;
  teamsAggregate?: InputMaybe<EventTeamsAggregateOrderBy>;
  timeSlotsAggregate?: InputMaybe<EventGroupTimeSlotsAggregateOrderBy>;
  title?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_groups */
export type EventGroupsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EventGroupsPrependInput = {
  moneyBallRewards?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "event_groups" */
export enum EventGroupsSelectColumn {
  /** column name */
  BracketRankingMechanism = 'bracketRankingMechanism',
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DesiredNumberOfPools = 'desiredNumberOfPools',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Format = 'format',
  /** column name */
  FormatCustomName = 'formatCustomName',
  /** column name */
  GamesPerMatch = 'gamesPerMatch',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsAgeRestricted = 'isAgeRestricted',
  /** column name */
  IsMoneyBall = 'isMoneyBall',
  /** column name */
  IsRatingRequired = 'isRatingRequired',
  /** column name */
  IsVairRatingSession = 'isVairRatingSession',
  /** column name */
  IsVairVairifiedRequired = 'isVairVairifiedRequired',
  /** column name */
  IsWheelchair = 'isWheelchair',
  /** column name */
  MaximumAge = 'maximumAge',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MergeId = 'mergeId',
  /** column name */
  MinimumAge = 'minimumAge',
  /** column name */
  MinimumNumberOfGames = 'minimumNumberOfGames',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  MoneyBallRewards = 'moneyBallRewards',
  /** column name */
  NetStatus = 'netStatus',
  /** column name */
  NumberOfEliminationTeams = 'numberOfEliminationTeams',
  /** column name */
  NumberOfEstimatedCourts = 'numberOfEstimatedCourts',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  ScoringFormat = 'scoringFormat',
  /** column name */
  SelfRatedMaxSkillLevelId = 'selfRatedMaxSkillLevelId',
  /** column name */
  SelfRatedMinSkillLevelId = 'selfRatedMinSkillLevelId',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  TeamLimit = 'teamLimit',
  /** column name */
  TeamType = 'teamType',
  /** column name */
  Title = 'title',
  /** column name */
  TotalPoints = 'totalPoints',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WinBy = 'winBy'
}

/** input type for updating data in table "event_groups" */
export type EventGroupsSetInput = {
  bracketRankingMechanism?: InputMaybe<BracketRankingMechanismEnum>;
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  desiredNumberOfPools?: InputMaybe<Scalars['Int']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  format?: InputMaybe<EventGroupFormatsEnum>;
  formatCustomName?: InputMaybe<Scalars['String']>;
  gamesPerMatch?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<CompetitionGenderEnum>;
  isAgeRestricted?: InputMaybe<Scalars['Boolean']>;
  isMoneyBall?: InputMaybe<Scalars['Boolean']>;
  isRatingRequired?: InputMaybe<Scalars['Boolean']>;
  isVairRatingSession?: InputMaybe<Scalars['Boolean']>;
  isVairVairifiedRequired?: InputMaybe<Scalars['Boolean']>;
  isWheelchair?: InputMaybe<Scalars['Boolean']>;
  maximumAge?: InputMaybe<Scalars['Int']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  minimumNumberOfGames?: InputMaybe<Scalars['Int']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  moneyBallRewards?: InputMaybe<Scalars['jsonb']>;
  netStatus?: InputMaybe<GameNetStatusesEnum>;
  numberOfEliminationTeams?: InputMaybe<Scalars['Int']>;
  numberOfEstimatedCourts?: InputMaybe<Scalars['Int']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  scoringFormat?: InputMaybe<ScoringFormatEnum>;
  selfRatedMaxSkillLevelId?: InputMaybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  teamLimit?: InputMaybe<Scalars['Int']>;
  teamType?: InputMaybe<TeamTypesEnum>;
  title?: InputMaybe<Scalars['String']>;
  totalPoints?: InputMaybe<Scalars['Int']>;
  winBy?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "event_groups" */
export type EventGroupsStddevOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "event_groups" */
export type EventGroupsStddevPopOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "event_groups" */
export type EventGroupsStddevSampOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_groups" */
export type EventGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventGroupsStreamCursorValueInput = {
  bracketRankingMechanism?: InputMaybe<BracketRankingMechanismEnum>;
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  desiredNumberOfPools?: InputMaybe<Scalars['Int']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  format?: InputMaybe<EventGroupFormatsEnum>;
  formatCustomName?: InputMaybe<Scalars['String']>;
  gamesPerMatch?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<CompetitionGenderEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  isAgeRestricted?: InputMaybe<Scalars['Boolean']>;
  isMoneyBall?: InputMaybe<Scalars['Boolean']>;
  isRatingRequired?: InputMaybe<Scalars['Boolean']>;
  isVairRatingSession?: InputMaybe<Scalars['Boolean']>;
  isVairVairifiedRequired?: InputMaybe<Scalars['Boolean']>;
  isWheelchair?: InputMaybe<Scalars['Boolean']>;
  maximumAge?: InputMaybe<Scalars['Int']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  mergeId?: InputMaybe<Scalars['uuid']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  minimumNumberOfGames?: InputMaybe<Scalars['Int']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  moneyBallRewards?: InputMaybe<Scalars['jsonb']>;
  netStatus?: InputMaybe<GameNetStatusesEnum>;
  numberOfEliminationTeams?: InputMaybe<Scalars['Int']>;
  numberOfEstimatedCourts?: InputMaybe<Scalars['Int']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  scoringFormat?: InputMaybe<ScoringFormatEnum>;
  selfRatedMaxSkillLevelId?: InputMaybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
  teamLimit?: InputMaybe<Scalars['Int']>;
  teamType?: InputMaybe<TeamTypesEnum>;
  title?: InputMaybe<Scalars['String']>;
  totalPoints?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  winBy?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_groups" */
export type EventGroupsSumOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** update columns of table "event_groups" */
export enum EventGroupsUpdateColumn {
  /** column name */
  BracketRankingMechanism = 'bracketRankingMechanism',
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DesiredNumberOfPools = 'desiredNumberOfPools',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  Format = 'format',
  /** column name */
  FormatCustomName = 'formatCustomName',
  /** column name */
  GamesPerMatch = 'gamesPerMatch',
  /** column name */
  Gender = 'gender',
  /** column name */
  IsAgeRestricted = 'isAgeRestricted',
  /** column name */
  IsMoneyBall = 'isMoneyBall',
  /** column name */
  IsRatingRequired = 'isRatingRequired',
  /** column name */
  IsVairRatingSession = 'isVairRatingSession',
  /** column name */
  IsVairVairifiedRequired = 'isVairVairifiedRequired',
  /** column name */
  IsWheelchair = 'isWheelchair',
  /** column name */
  MaximumAge = 'maximumAge',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MinimumAge = 'minimumAge',
  /** column name */
  MinimumNumberOfGames = 'minimumNumberOfGames',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  MoneyBallRewards = 'moneyBallRewards',
  /** column name */
  NetStatus = 'netStatus',
  /** column name */
  NumberOfEliminationTeams = 'numberOfEliminationTeams',
  /** column name */
  NumberOfEstimatedCourts = 'numberOfEstimatedCourts',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  ScoringFormat = 'scoringFormat',
  /** column name */
  SelfRatedMaxSkillLevelId = 'selfRatedMaxSkillLevelId',
  /** column name */
  SelfRatedMinSkillLevelId = 'selfRatedMinSkillLevelId',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  TeamLimit = 'teamLimit',
  /** column name */
  TeamType = 'teamType',
  /** column name */
  Title = 'title',
  /** column name */
  TotalPoints = 'totalPoints',
  /** column name */
  WinBy = 'winBy'
}

export type EventGroupsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EventGroupsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<EventGroupsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<EventGroupsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<EventGroupsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventGroupsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EventGroupsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: EventGroupsBoolExp;
};

/** order by varPop() on columns of table "event_groups" */
export type EventGroupsVarPopOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "event_groups" */
export type EventGroupsVarSampOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_groups" */
export type EventGroupsVarianceOrderBy = {
  desiredNumberOfPools?: InputMaybe<OrderBy>;
  gamesPerMatch?: InputMaybe<OrderBy>;
  maximumAge?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumAge?: InputMaybe<OrderBy>;
  minimumNumberOfGames?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  numberOfEliminationTeams?: InputMaybe<OrderBy>;
  numberOfEstimatedCourts?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  teamLimit?: InputMaybe<OrderBy>;
  totalPoints?: InputMaybe<OrderBy>;
  winBy?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_invitation_statuses" */
export type EventInvitationStatuses = {
  __typename?: 'EventInvitationStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_invitation_statuses". All fields are combined with a logical 'AND'. */
export type EventInvitationStatusesBoolExp = {
  _and?: InputMaybe<Array<EventInvitationStatusesBoolExp>>;
  _not?: InputMaybe<EventInvitationStatusesBoolExp>;
  _or?: InputMaybe<Array<EventInvitationStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventInvitationStatusesEnum {
  Accepted = 'ACCEPTED',
  Open = 'OPEN',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "EventInvitationStatusesEnum". All fields are combined with logical 'AND'. */
export type EventInvitationStatusesEnumComparisonExp = {
  _eq?: InputMaybe<EventInvitationStatusesEnum>;
  _in?: InputMaybe<Array<EventInvitationStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventInvitationStatusesEnum>;
  _nin?: InputMaybe<Array<EventInvitationStatusesEnum>>;
};

/** Ordering options when selecting data from "event_invitation_statuses". */
export type EventInvitationStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_invitation_statuses" */
export enum EventInvitationStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_invitation_statuses" */
export type EventInvitationStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventInvitationStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventInvitationStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_invitation_types" */
export type EventInvitationTypes = {
  __typename?: 'EventInvitationTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_invitation_types". All fields are combined with a logical 'AND'. */
export type EventInvitationTypesBoolExp = {
  _and?: InputMaybe<Array<EventInvitationTypesBoolExp>>;
  _not?: InputMaybe<EventInvitationTypesBoolExp>;
  _or?: InputMaybe<Array<EventInvitationTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventInvitationTypesEnum {
  Email = 'EMAIL',
  PartnerRequest = 'PARTNER_REQUEST'
}

/** Boolean expression to compare columns of type "EventInvitationTypesEnum". All fields are combined with logical 'AND'. */
export type EventInvitationTypesEnumComparisonExp = {
  _eq?: InputMaybe<EventInvitationTypesEnum>;
  _in?: InputMaybe<Array<EventInvitationTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventInvitationTypesEnum>;
  _nin?: InputMaybe<Array<EventInvitationTypesEnum>>;
};

/** Ordering options when selecting data from "event_invitation_types". */
export type EventInvitationTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_invitation_types" */
export enum EventInvitationTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_invitation_types" */
export type EventInvitationTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventInvitationTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventInvitationTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_invitations" */
export type EventInvitations = {
  __typename?: 'EventInvitations';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  /** An object relationship */
  group: EventGroups;
  groupId: Scalars['uuid'];
  /** An object relationship */
  groupRegistration?: Maybe<EventGroupRegistrations>;
  groupRegistrationId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  invitationEmail?: Maybe<Scalars['String']>;
  invitationName?: Maybe<Scalars['String']>;
  invitationType: EventInvitationTypesEnum;
  /** An object relationship */
  invitedUser?: Maybe<Users>;
  invitedUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invitedUserProfile?: Maybe<UserProfiles>;
  /** An object relationship */
  senderUser: Users;
  senderUserId: Scalars['uuid'];
  /** An object relationship */
  senderUserProfile?: Maybe<UserProfiles>;
  status: EventInvitationStatusesEnum;
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "event_invitations" */
export type EventInvitationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventInvitationsMaxOrderBy>;
  min?: InputMaybe<EventInvitationsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_invitations" */
export type EventInvitationsArrRelInsertInput = {
  data: Array<EventInvitationsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventInvitationsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_invitations". All fields are combined with a logical 'AND'. */
export type EventInvitationsBoolExp = {
  _and?: InputMaybe<Array<EventInvitationsBoolExp>>;
  _not?: InputMaybe<EventInvitationsBoolExp>;
  _or?: InputMaybe<Array<EventInvitationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  group?: InputMaybe<EventGroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  groupRegistration?: InputMaybe<EventGroupRegistrationsBoolExp>;
  groupRegistrationId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  invitationEmail?: InputMaybe<StringComparisonExp>;
  invitationName?: InputMaybe<StringComparisonExp>;
  invitationType?: InputMaybe<EventInvitationTypesEnumComparisonExp>;
  invitedUser?: InputMaybe<UsersBoolExp>;
  invitedUserId?: InputMaybe<UuidComparisonExp>;
  invitedUserProfile?: InputMaybe<UserProfilesBoolExp>;
  senderUser?: InputMaybe<UsersBoolExp>;
  senderUserId?: InputMaybe<UuidComparisonExp>;
  senderUserProfile?: InputMaybe<UserProfilesBoolExp>;
  status?: InputMaybe<EventInvitationStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_invitations" */
export enum EventInvitationsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventInvitationsPkey = 'event_invitations_pkey'
}

/** input type for inserting data into table "event_invitations" */
export type EventInvitationsInsertInput = {
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  group?: InputMaybe<EventGroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  groupRegistrationId?: InputMaybe<Scalars['uuid']>;
  invitationEmail?: InputMaybe<Scalars['String']>;
  invitationName?: InputMaybe<Scalars['String']>;
  invitationType?: InputMaybe<EventInvitationTypesEnum>;
  invitedUserId?: InputMaybe<Scalars['uuid']>;
  senderUserId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_invitations" */
export type EventInvitationsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  groupRegistrationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invitationEmail?: InputMaybe<OrderBy>;
  invitationName?: InputMaybe<OrderBy>;
  invitedUserId?: InputMaybe<OrderBy>;
  senderUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_invitations" */
export type EventInvitationsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  groupRegistrationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invitationEmail?: InputMaybe<OrderBy>;
  invitationName?: InputMaybe<OrderBy>;
  invitedUserId?: InputMaybe<OrderBy>;
  senderUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_invitations" */
export type EventInvitationsMutationResponse = {
  __typename?: 'EventInvitationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventInvitations>;
};

/** on_conflict condition type for table "event_invitations" */
export type EventInvitationsOnConflict = {
  constraint: EventInvitationsConstraint;
  updateColumns?: Array<EventInvitationsUpdateColumn>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};

/** Ordering options when selecting data from "event_invitations". */
export type EventInvitationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  group?: InputMaybe<EventGroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  groupRegistration?: InputMaybe<EventGroupRegistrationsOrderBy>;
  groupRegistrationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invitationEmail?: InputMaybe<OrderBy>;
  invitationName?: InputMaybe<OrderBy>;
  invitationType?: InputMaybe<OrderBy>;
  invitedUser?: InputMaybe<UsersOrderBy>;
  invitedUserId?: InputMaybe<OrderBy>;
  invitedUserProfile?: InputMaybe<UserProfilesOrderBy>;
  senderUser?: InputMaybe<UsersOrderBy>;
  senderUserId?: InputMaybe<OrderBy>;
  senderUserProfile?: InputMaybe<UserProfilesOrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "event_invitations" */
export enum EventInvitationsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  GroupRegistrationId = 'groupRegistrationId',
  /** column name */
  Id = 'id',
  /** column name */
  InvitationEmail = 'invitationEmail',
  /** column name */
  InvitationName = 'invitationName',
  /** column name */
  InvitationType = 'invitationType',
  /** column name */
  InvitedUserId = 'invitedUserId',
  /** column name */
  SenderUserId = 'senderUserId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "event_invitations" */
export type EventInvitationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventInvitationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventInvitationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  groupRegistrationId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invitationEmail?: InputMaybe<Scalars['String']>;
  invitationName?: InputMaybe<Scalars['String']>;
  invitationType?: InputMaybe<EventInvitationTypesEnum>;
  invitedUserId?: InputMaybe<Scalars['uuid']>;
  senderUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<EventInvitationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** placeholder for update columns of table "event_invitations" (current role has no relevant permissions) */
export enum EventInvitationsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "event_listing_fees" */
export type EventListingFees = {
  __typename?: 'EventListingFees';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  creditCard: UserCreditCards;
  /** An object relationship */
  customer: Users;
  /** An object relationship */
  customerProfile?: Maybe<UserProfiles>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  externalStripePaymentIntentId: Scalars['String'];
  id: Scalars['uuid'];
  internalStripePaymentIntentId: Scalars['uuid'];
  orderSubtotalUnitAmount: Scalars['Int'];
  orderTotalUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  paymentProcessor: PaymentProcessorsEnum;
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  status: OrderStatusesEnum;
  stripeCustomerId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  userCreditCardId: Scalars['uuid'];
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "event_listing_fees" */
export type EventListingFeesAggregateOrderBy = {
  avg?: InputMaybe<EventListingFeesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventListingFeesMaxOrderBy>;
  min?: InputMaybe<EventListingFeesMinOrderBy>;
  stddev?: InputMaybe<EventListingFeesStddevOrderBy>;
  stddevPop?: InputMaybe<EventListingFeesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventListingFeesStddevSampOrderBy>;
  sum?: InputMaybe<EventListingFeesSumOrderBy>;
  varPop?: InputMaybe<EventListingFeesVarPopOrderBy>;
  varSamp?: InputMaybe<EventListingFeesVarSampOrderBy>;
  variance?: InputMaybe<EventListingFeesVarianceOrderBy>;
};

/** order by avg() on columns of table "event_listing_fees" */
export type EventListingFeesAvgOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_listing_fees". All fields are combined with a logical 'AND'. */
export type EventListingFeesBoolExp = {
  _and?: InputMaybe<Array<EventListingFeesBoolExp>>;
  _not?: InputMaybe<EventListingFeesBoolExp>;
  _or?: InputMaybe<Array<EventListingFeesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  creditCard?: InputMaybe<UserCreditCardsBoolExp>;
  customer?: InputMaybe<UsersBoolExp>;
  customerProfile?: InputMaybe<UserProfilesBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  externalStripePaymentIntentId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalStripePaymentIntentId?: InputMaybe<UuidComparisonExp>;
  orderSubtotalUnitAmount?: InputMaybe<IntComparisonExp>;
  orderTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  paidUnitAmount?: InputMaybe<IntComparisonExp>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripePaymentStatus?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCreditCardId?: InputMaybe<UuidComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "event_listing_fees" */
export type EventListingFeesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_listing_fees" */
export type EventListingFeesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_listing_fees". */
export type EventListingFeesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  creditCard?: InputMaybe<UserCreditCardsOrderBy>;
  customer?: InputMaybe<UsersOrderBy>;
  customerProfile?: InputMaybe<UserProfilesOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  paymentProcessor?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "event_listing_fees" */
export enum EventListingFeesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId',
  /** column name */
  UserId = 'userId'
}

/** order by stddev() on columns of table "event_listing_fees" */
export type EventListingFeesStddevOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "event_listing_fees" */
export type EventListingFeesStddevPopOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "event_listing_fees" */
export type EventListingFeesStddevSampOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_listing_fees" */
export type EventListingFeesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventListingFeesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventListingFeesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "event_listing_fees" */
export type EventListingFeesSumOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "event_listing_fees" */
export type EventListingFeesVarPopOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "event_listing_fees" */
export type EventListingFeesVarSampOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_listing_fees" */
export type EventListingFeesVarianceOrderBy = {
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_match_games" */
export type EventMatchGames = {
  __typename?: 'EventMatchGames';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  losingTeam: EventTeams;
  losingTeamId: Scalars['uuid'];
  /** An object relationship */
  match: EventMatches;
  matchId: Scalars['uuid'];
  /** An array relationship */
  scores: Array<EventGameScores>;
  /** An object relationship */
  team1: EventTeams;
  team1Id: Scalars['uuid'];
  team1Score: Scalars['numeric'];
  /** An object relationship */
  team2: EventTeams;
  team2Id: Scalars['uuid'];
  team2Score: Scalars['numeric'];
  updatedAt: Scalars['timestamptz'];
  winReason: WinReasonsEnum;
  /** An object relationship */
  winningTeam: EventTeams;
  winningTeamId: Scalars['uuid'];
};


/** columns and relationships of "event_match_games" */
export type EventMatchGamesScoresArgs = {
  distinctOn?: InputMaybe<Array<EventGameScoresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGameScoresOrderBy>>;
  where?: InputMaybe<EventGameScoresBoolExp>;
};

/** order by aggregate values of table "event_match_games" */
export type EventMatchGamesAggregateOrderBy = {
  avg?: InputMaybe<EventMatchGamesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventMatchGamesMaxOrderBy>;
  min?: InputMaybe<EventMatchGamesMinOrderBy>;
  stddev?: InputMaybe<EventMatchGamesStddevOrderBy>;
  stddevPop?: InputMaybe<EventMatchGamesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventMatchGamesStddevSampOrderBy>;
  sum?: InputMaybe<EventMatchGamesSumOrderBy>;
  varPop?: InputMaybe<EventMatchGamesVarPopOrderBy>;
  varSamp?: InputMaybe<EventMatchGamesVarSampOrderBy>;
  variance?: InputMaybe<EventMatchGamesVarianceOrderBy>;
};

/** order by avg() on columns of table "event_match_games" */
export type EventMatchGamesAvgOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_match_games". All fields are combined with a logical 'AND'. */
export type EventMatchGamesBoolExp = {
  _and?: InputMaybe<Array<EventMatchGamesBoolExp>>;
  _not?: InputMaybe<EventMatchGamesBoolExp>;
  _or?: InputMaybe<Array<EventMatchGamesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  losingTeam?: InputMaybe<EventTeamsBoolExp>;
  losingTeamId?: InputMaybe<UuidComparisonExp>;
  match?: InputMaybe<EventMatchesBoolExp>;
  matchId?: InputMaybe<UuidComparisonExp>;
  scores?: InputMaybe<EventGameScoresBoolExp>;
  team1?: InputMaybe<EventTeamsBoolExp>;
  team1Id?: InputMaybe<UuidComparisonExp>;
  team1Score?: InputMaybe<NumericComparisonExp>;
  team2?: InputMaybe<EventTeamsBoolExp>;
  team2Id?: InputMaybe<UuidComparisonExp>;
  team2Score?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  winReason?: InputMaybe<WinReasonsEnumComparisonExp>;
  winningTeam?: InputMaybe<EventTeamsBoolExp>;
  winningTeamId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "event_match_games" */
export enum EventMatchGamesConstraint {
  /** unique or primary key constraint on columns "id" */
  EventMatchGamesPkey = 'event_match_games_pkey'
}

/** input type for incrementing numeric columns in table "event_match_games" */
export type EventMatchGamesIncInput = {
  team1Score?: InputMaybe<Scalars['numeric']>;
  team2Score?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "event_match_games" */
export type EventMatchGamesInsertInput = {
  losingTeamId?: InputMaybe<Scalars['uuid']>;
  matchId?: InputMaybe<Scalars['uuid']>;
  scores?: InputMaybe<EventGameScoresArrRelInsertInput>;
  team1Id?: InputMaybe<Scalars['uuid']>;
  team1Score?: InputMaybe<Scalars['numeric']>;
  team2Id?: InputMaybe<Scalars['uuid']>;
  team2Score?: InputMaybe<Scalars['numeric']>;
  winReason?: InputMaybe<WinReasonsEnum>;
  winningTeamId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_match_games" */
export type EventMatchGamesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  losingTeamId?: InputMaybe<OrderBy>;
  matchId?: InputMaybe<OrderBy>;
  team1Id?: InputMaybe<OrderBy>;
  team1Score?: InputMaybe<OrderBy>;
  team2Id?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winningTeamId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_match_games" */
export type EventMatchGamesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  losingTeamId?: InputMaybe<OrderBy>;
  matchId?: InputMaybe<OrderBy>;
  team1Id?: InputMaybe<OrderBy>;
  team1Score?: InputMaybe<OrderBy>;
  team2Id?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winningTeamId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_match_games" */
export type EventMatchGamesMutationResponse = {
  __typename?: 'EventMatchGamesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventMatchGames>;
};

/** input type for inserting object relation for remote table "event_match_games" */
export type EventMatchGamesObjRelInsertInput = {
  data: EventMatchGamesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventMatchGamesOnConflict>;
};

/** on_conflict condition type for table "event_match_games" */
export type EventMatchGamesOnConflict = {
  constraint: EventMatchGamesConstraint;
  updateColumns?: Array<EventMatchGamesUpdateColumn>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};

/** Ordering options when selecting data from "event_match_games". */
export type EventMatchGamesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  losingTeam?: InputMaybe<EventTeamsOrderBy>;
  losingTeamId?: InputMaybe<OrderBy>;
  match?: InputMaybe<EventMatchesOrderBy>;
  matchId?: InputMaybe<OrderBy>;
  scoresAggregate?: InputMaybe<EventGameScoresAggregateOrderBy>;
  team1?: InputMaybe<EventTeamsOrderBy>;
  team1Id?: InputMaybe<OrderBy>;
  team1Score?: InputMaybe<OrderBy>;
  team2?: InputMaybe<EventTeamsOrderBy>;
  team2Id?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winReason?: InputMaybe<OrderBy>;
  winningTeam?: InputMaybe<EventTeamsOrderBy>;
  winningTeamId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_match_games */
export type EventMatchGamesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_match_games" */
export enum EventMatchGamesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LosingTeamId = 'losingTeamId',
  /** column name */
  MatchId = 'matchId',
  /** column name */
  Team1Id = 'team1Id',
  /** column name */
  Team1Score = 'team1Score',
  /** column name */
  Team2Id = 'team2Id',
  /** column name */
  Team2Score = 'team2Score',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WinReason = 'winReason',
  /** column name */
  WinningTeamId = 'winningTeamId'
}

/** input type for updating data in table "event_match_games" */
export type EventMatchGamesSetInput = {
  losingTeamId?: InputMaybe<Scalars['uuid']>;
  team1Score?: InputMaybe<Scalars['numeric']>;
  team2Score?: InputMaybe<Scalars['numeric']>;
  winReason?: InputMaybe<WinReasonsEnum>;
  winningTeamId?: InputMaybe<Scalars['uuid']>;
};

/** order by stddev() on columns of table "event_match_games" */
export type EventMatchGamesStddevOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "event_match_games" */
export type EventMatchGamesStddevPopOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "event_match_games" */
export type EventMatchGamesStddevSampOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_match_games" */
export type EventMatchGamesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventMatchGamesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventMatchGamesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  losingTeamId?: InputMaybe<Scalars['uuid']>;
  matchId?: InputMaybe<Scalars['uuid']>;
  team1Id?: InputMaybe<Scalars['uuid']>;
  team1Score?: InputMaybe<Scalars['numeric']>;
  team2Id?: InputMaybe<Scalars['uuid']>;
  team2Score?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  winReason?: InputMaybe<WinReasonsEnum>;
  winningTeamId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "event_match_games" */
export type EventMatchGamesSumOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** update columns of table "event_match_games" */
export enum EventMatchGamesUpdateColumn {
  /** column name */
  LosingTeamId = 'losingTeamId',
  /** column name */
  Team1Score = 'team1Score',
  /** column name */
  Team2Score = 'team2Score',
  /** column name */
  WinReason = 'winReason',
  /** column name */
  WinningTeamId = 'winningTeamId'
}

export type EventMatchGamesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventMatchGamesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventMatchGamesSetInput>;
  /** filter the rows which have to be updated */
  where: EventMatchGamesBoolExp;
};

/** order by varPop() on columns of table "event_match_games" */
export type EventMatchGamesVarPopOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "event_match_games" */
export type EventMatchGamesVarSampOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_match_games" */
export type EventMatchGamesVarianceOrderBy = {
  team1Score?: InputMaybe<OrderBy>;
  team2Score?: InputMaybe<OrderBy>;
};

/** NOTE: In the product direction, the concept of a round is becoming less structured. Currently over-structuring this until we understand what columns aren't needing. May add or remove some foreign keys, and potentially tie to and event or group. */
export type EventMatches = {
  __typename?: 'EventMatches';
  /** An object relationship */
  court?: Maybe<EventCourts>;
  courtNumber?: Maybe<Scalars['Int']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventCourtId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  games: Array<EventMatchGames>;
  id: Scalars['uuid'];
  isBye: Scalars['Boolean'];
  isVairScoreSubmitted?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  losingTeam?: Maybe<EventTeams>;
  losingTeamId?: Maybe<Scalars['uuid']>;
  matchOrder: Scalars['Int'];
  /** An object relationship */
  pool?: Maybe<EventGroupPools>;
  poolId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  previousMatch1?: Maybe<EventMatches>;
  previousMatch1Id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  previousMatch2?: Maybe<EventMatches>;
  previousMatch2Id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  round: EventPoolRounds;
  roundId: Scalars['uuid'];
  selectionCriteriaPreviousMatch1?: Maybe<MatchSelectionCriteriaEnum>;
  selectionCriteriaPreviousMatch2?: Maybe<MatchSelectionCriteriaEnum>;
  /** An object relationship */
  team1?: Maybe<EventTeams>;
  team1Id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  team2?: Maybe<EventTeams>;
  team2Id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  teams: Array<EventMatchesTeams>;
  updatedAt: Scalars['timestamptz'];
  winReason?: Maybe<WinReasonsEnum>;
  /** An object relationship */
  winningTeam?: Maybe<EventTeams>;
  winningTeamId?: Maybe<Scalars['uuid']>;
};


/** NOTE: In the product direction, the concept of a round is becoming less structured. Currently over-structuring this until we understand what columns aren't needing. May add or remove some foreign keys, and potentially tie to and event or group. */
export type EventMatchesGamesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchGamesOrderBy>>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};


/** NOTE: In the product direction, the concept of a round is becoming less structured. Currently over-structuring this until we understand what columns aren't needing. May add or remove some foreign keys, and potentially tie to and event or group. */
export type EventMatchesTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesTeamsOrderBy>>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};

/** order by aggregate values of table "event_matches" */
export type EventMatchesAggregateOrderBy = {
  avg?: InputMaybe<EventMatchesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventMatchesMaxOrderBy>;
  min?: InputMaybe<EventMatchesMinOrderBy>;
  stddev?: InputMaybe<EventMatchesStddevOrderBy>;
  stddevPop?: InputMaybe<EventMatchesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventMatchesStddevSampOrderBy>;
  sum?: InputMaybe<EventMatchesSumOrderBy>;
  varPop?: InputMaybe<EventMatchesVarPopOrderBy>;
  varSamp?: InputMaybe<EventMatchesVarSampOrderBy>;
  variance?: InputMaybe<EventMatchesVarianceOrderBy>;
};

/** order by avg() on columns of table "event_matches" */
export type EventMatchesAvgOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_matches". All fields are combined with a logical 'AND'. */
export type EventMatchesBoolExp = {
  _and?: InputMaybe<Array<EventMatchesBoolExp>>;
  _not?: InputMaybe<EventMatchesBoolExp>;
  _or?: InputMaybe<Array<EventMatchesBoolExp>>;
  court?: InputMaybe<EventCourtsBoolExp>;
  courtNumber?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  eventCourtId?: InputMaybe<UuidComparisonExp>;
  games?: InputMaybe<EventMatchGamesBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isBye?: InputMaybe<BooleanComparisonExp>;
  isVairScoreSubmitted?: InputMaybe<BooleanComparisonExp>;
  losingTeam?: InputMaybe<EventTeamsBoolExp>;
  losingTeamId?: InputMaybe<UuidComparisonExp>;
  matchOrder?: InputMaybe<IntComparisonExp>;
  pool?: InputMaybe<EventGroupPoolsBoolExp>;
  poolId?: InputMaybe<UuidComparisonExp>;
  previousMatch1?: InputMaybe<EventMatchesBoolExp>;
  previousMatch1Id?: InputMaybe<UuidComparisonExp>;
  previousMatch2?: InputMaybe<EventMatchesBoolExp>;
  previousMatch2Id?: InputMaybe<UuidComparisonExp>;
  round?: InputMaybe<EventPoolRoundsBoolExp>;
  roundId?: InputMaybe<UuidComparisonExp>;
  selectionCriteriaPreviousMatch1?: InputMaybe<MatchSelectionCriteriaEnumComparisonExp>;
  selectionCriteriaPreviousMatch2?: InputMaybe<MatchSelectionCriteriaEnumComparisonExp>;
  team1?: InputMaybe<EventTeamsBoolExp>;
  team1Id?: InputMaybe<UuidComparisonExp>;
  team2?: InputMaybe<EventTeamsBoolExp>;
  team2Id?: InputMaybe<UuidComparisonExp>;
  teams?: InputMaybe<EventMatchesTeamsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  winReason?: InputMaybe<WinReasonsEnumComparisonExp>;
  winningTeam?: InputMaybe<EventTeamsBoolExp>;
  winningTeamId?: InputMaybe<UuidComparisonExp>;
};

/** input type for incrementing numeric columns in table "event_matches" */
export type EventMatchesIncInput = {
  courtNumber?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "event_matches" */
export type EventMatchesMaxOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventCourtId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  losingTeamId?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
  poolId?: InputMaybe<OrderBy>;
  previousMatch1Id?: InputMaybe<OrderBy>;
  previousMatch2Id?: InputMaybe<OrderBy>;
  roundId?: InputMaybe<OrderBy>;
  team1Id?: InputMaybe<OrderBy>;
  team2Id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winningTeamId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_matches" */
export type EventMatchesMinOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventCourtId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  losingTeamId?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
  poolId?: InputMaybe<OrderBy>;
  previousMatch1Id?: InputMaybe<OrderBy>;
  previousMatch2Id?: InputMaybe<OrderBy>;
  roundId?: InputMaybe<OrderBy>;
  team1Id?: InputMaybe<OrderBy>;
  team2Id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winningTeamId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_matches" */
export type EventMatchesMutationResponse = {
  __typename?: 'EventMatchesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventMatches>;
};

/** Ordering options when selecting data from "event_matches". */
export type EventMatchesOrderBy = {
  court?: InputMaybe<EventCourtsOrderBy>;
  courtNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventCourtId?: InputMaybe<OrderBy>;
  gamesAggregate?: InputMaybe<EventMatchGamesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  isBye?: InputMaybe<OrderBy>;
  isVairScoreSubmitted?: InputMaybe<OrderBy>;
  losingTeam?: InputMaybe<EventTeamsOrderBy>;
  losingTeamId?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
  pool?: InputMaybe<EventGroupPoolsOrderBy>;
  poolId?: InputMaybe<OrderBy>;
  previousMatch1?: InputMaybe<EventMatchesOrderBy>;
  previousMatch1Id?: InputMaybe<OrderBy>;
  previousMatch2?: InputMaybe<EventMatchesOrderBy>;
  previousMatch2Id?: InputMaybe<OrderBy>;
  round?: InputMaybe<EventPoolRoundsOrderBy>;
  roundId?: InputMaybe<OrderBy>;
  selectionCriteriaPreviousMatch1?: InputMaybe<OrderBy>;
  selectionCriteriaPreviousMatch2?: InputMaybe<OrderBy>;
  team1?: InputMaybe<EventTeamsOrderBy>;
  team1Id?: InputMaybe<OrderBy>;
  team2?: InputMaybe<EventTeamsOrderBy>;
  team2Id?: InputMaybe<OrderBy>;
  teamsAggregate?: InputMaybe<EventMatchesTeamsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  winReason?: InputMaybe<OrderBy>;
  winningTeam?: InputMaybe<EventTeamsOrderBy>;
  winningTeamId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_matches */
export type EventMatchesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_matches" */
export enum EventMatchesSelectColumn {
  /** column name */
  CourtNumber = 'courtNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventCourtId = 'eventCourtId',
  /** column name */
  Id = 'id',
  /** column name */
  IsBye = 'isBye',
  /** column name */
  IsVairScoreSubmitted = 'isVairScoreSubmitted',
  /** column name */
  LosingTeamId = 'losingTeamId',
  /** column name */
  MatchOrder = 'matchOrder',
  /** column name */
  PoolId = 'poolId',
  /** column name */
  PreviousMatch1Id = 'previousMatch1Id',
  /** column name */
  PreviousMatch2Id = 'previousMatch2Id',
  /** column name */
  RoundId = 'roundId',
  /** column name */
  SelectionCriteriaPreviousMatch1 = 'selectionCriteriaPreviousMatch1',
  /** column name */
  SelectionCriteriaPreviousMatch2 = 'selectionCriteriaPreviousMatch2',
  /** column name */
  Team1Id = 'team1Id',
  /** column name */
  Team2Id = 'team2Id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WinReason = 'winReason',
  /** column name */
  WinningTeamId = 'winningTeamId'
}

/** input type for updating data in table "event_matches" */
export type EventMatchesSetInput = {
  courtNumber?: InputMaybe<Scalars['Int']>;
  eventCourtId?: InputMaybe<Scalars['uuid']>;
  losingTeamId?: InputMaybe<Scalars['uuid']>;
  team1Id?: InputMaybe<Scalars['uuid']>;
  team2Id?: InputMaybe<Scalars['uuid']>;
  winReason?: InputMaybe<WinReasonsEnum>;
  winningTeamId?: InputMaybe<Scalars['uuid']>;
};

/** order by stddev() on columns of table "event_matches" */
export type EventMatchesStddevOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "event_matches" */
export type EventMatchesStddevPopOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "event_matches" */
export type EventMatchesStddevSampOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_matches" */
export type EventMatchesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventMatchesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventMatchesStreamCursorValueInput = {
  courtNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventCourtId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isBye?: InputMaybe<Scalars['Boolean']>;
  isVairScoreSubmitted?: InputMaybe<Scalars['Boolean']>;
  losingTeamId?: InputMaybe<Scalars['uuid']>;
  matchOrder?: InputMaybe<Scalars['Int']>;
  poolId?: InputMaybe<Scalars['uuid']>;
  previousMatch1Id?: InputMaybe<Scalars['uuid']>;
  previousMatch2Id?: InputMaybe<Scalars['uuid']>;
  roundId?: InputMaybe<Scalars['uuid']>;
  selectionCriteriaPreviousMatch1?: InputMaybe<MatchSelectionCriteriaEnum>;
  selectionCriteriaPreviousMatch2?: InputMaybe<MatchSelectionCriteriaEnum>;
  team1Id?: InputMaybe<Scalars['uuid']>;
  team2Id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  winReason?: InputMaybe<WinReasonsEnum>;
  winningTeamId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "event_matches" */
export type EventMatchesSumOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_matches_teams" */
export type EventMatchesTeams = {
  __typename?: 'EventMatchesTeams';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  match: EventMatches;
  matchId: Scalars['uuid'];
  order: Scalars['Int'];
  /** An object relationship */
  team: EventTeams;
  teamId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "event_matches_teams" */
export type EventMatchesTeamsAggregateOrderBy = {
  avg?: InputMaybe<EventMatchesTeamsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventMatchesTeamsMaxOrderBy>;
  min?: InputMaybe<EventMatchesTeamsMinOrderBy>;
  stddev?: InputMaybe<EventMatchesTeamsStddevOrderBy>;
  stddevPop?: InputMaybe<EventMatchesTeamsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventMatchesTeamsStddevSampOrderBy>;
  sum?: InputMaybe<EventMatchesTeamsSumOrderBy>;
  varPop?: InputMaybe<EventMatchesTeamsVarPopOrderBy>;
  varSamp?: InputMaybe<EventMatchesTeamsVarSampOrderBy>;
  variance?: InputMaybe<EventMatchesTeamsVarianceOrderBy>;
};

/** order by avg() on columns of table "event_matches_teams" */
export type EventMatchesTeamsAvgOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_matches_teams". All fields are combined with a logical 'AND'. */
export type EventMatchesTeamsBoolExp = {
  _and?: InputMaybe<Array<EventMatchesTeamsBoolExp>>;
  _not?: InputMaybe<EventMatchesTeamsBoolExp>;
  _or?: InputMaybe<Array<EventMatchesTeamsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  match?: InputMaybe<EventMatchesBoolExp>;
  matchId?: InputMaybe<UuidComparisonExp>;
  order?: InputMaybe<IntComparisonExp>;
  team?: InputMaybe<EventTeamsBoolExp>;
  teamId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "event_matches_teams" */
export type EventMatchesTeamsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matchId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_matches_teams" */
export type EventMatchesTeamsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matchId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_matches_teams". */
export type EventMatchesTeamsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  match?: InputMaybe<EventMatchesOrderBy>;
  matchId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  team?: InputMaybe<EventTeamsOrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "event_matches_teams" */
export enum EventMatchesTeamsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'matchId',
  /** column name */
  Order = 'order',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** order by stddev() on columns of table "event_matches_teams" */
export type EventMatchesTeamsStddevOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "event_matches_teams" */
export type EventMatchesTeamsStddevPopOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "event_matches_teams" */
export type EventMatchesTeamsStddevSampOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_matches_teams" */
export type EventMatchesTeamsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventMatchesTeamsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventMatchesTeamsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  matchId?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "event_matches_teams" */
export type EventMatchesTeamsSumOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "event_matches_teams" */
export type EventMatchesTeamsVarPopOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "event_matches_teams" */
export type EventMatchesTeamsVarSampOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_matches_teams" */
export type EventMatchesTeamsVarianceOrderBy = {
  order?: InputMaybe<OrderBy>;
};

export type EventMatchesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventMatchesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventMatchesSetInput>;
  /** filter the rows which have to be updated */
  where: EventMatchesBoolExp;
};

/** order by varPop() on columns of table "event_matches" */
export type EventMatchesVarPopOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "event_matches" */
export type EventMatchesVarSampOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_matches" */
export type EventMatchesVarianceOrderBy = {
  courtNumber?: InputMaybe<OrderBy>;
  matchOrder?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_organizer_account_types" */
export type EventOrganizerAccountTypes = {
  __typename?: 'EventOrganizerAccountTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_organizer_account_types". All fields are combined with a logical 'AND'. */
export type EventOrganizerAccountTypesBoolExp = {
  _and?: InputMaybe<Array<EventOrganizerAccountTypesBoolExp>>;
  _not?: InputMaybe<EventOrganizerAccountTypesBoolExp>;
  _or?: InputMaybe<Array<EventOrganizerAccountTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventOrganizerAccountTypesEnum {
  Club = 'CLUB',
  Inactive = 'INACTIVE',
  Individual = 'INDIVIDUAL',
  Other = 'OTHER',
  Tour = 'TOUR'
}

/** Boolean expression to compare columns of type "EventOrganizerAccountTypesEnum". All fields are combined with logical 'AND'. */
export type EventOrganizerAccountTypesEnumComparisonExp = {
  _eq?: InputMaybe<EventOrganizerAccountTypesEnum>;
  _in?: InputMaybe<Array<EventOrganizerAccountTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventOrganizerAccountTypesEnum>;
  _nin?: InputMaybe<Array<EventOrganizerAccountTypesEnum>>;
};

/** Ordering options when selecting data from "event_organizer_account_types". */
export type EventOrganizerAccountTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_organizer_account_types" */
export enum EventOrganizerAccountTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_organizer_account_types" */
export type EventOrganizerAccountTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventOrganizerAccountTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventOrganizerAccountTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_player_invite_statuses" */
export type EventPlayerInviteStatuses = {
  __typename?: 'EventPlayerInviteStatuses';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_player_invite_statuses". All fields are combined with a logical 'AND'. */
export type EventPlayerInviteStatusesBoolExp = {
  _and?: InputMaybe<Array<EventPlayerInviteStatusesBoolExp>>;
  _not?: InputMaybe<EventPlayerInviteStatusesBoolExp>;
  _or?: InputMaybe<Array<EventPlayerInviteStatusesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventPlayerInviteStatusesEnum {
  Accepted = 'ACCEPTED',
  /** host removed the invited player */
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  /** game started or was cancelled before a response */
  Expired = 'EXPIRED',
  /** awaiting the invited player */
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "EventPlayerInviteStatusesEnum". All fields are combined with logical 'AND'. */
export type EventPlayerInviteStatusesEnumComparisonExp = {
  _eq?: InputMaybe<EventPlayerInviteStatusesEnum>;
  _in?: InputMaybe<Array<EventPlayerInviteStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventPlayerInviteStatusesEnum>;
  _nin?: InputMaybe<Array<EventPlayerInviteStatusesEnum>>;
};

/** Ordering options when selecting data from "event_player_invite_statuses". */
export type EventPlayerInviteStatusesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_player_invite_statuses" */
export enum EventPlayerInviteStatusesSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_player_invite_statuses" */
export type EventPlayerInviteStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventPlayerInviteStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventPlayerInviteStatusesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_player_invites" */
export type EventPlayerInvites = {
  __typename?: 'EventPlayerInvites';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  invitedUser: Users;
  invitedUserId: Scalars['uuid'];
  /** An object relationship */
  invitedUserProfile?: Maybe<UserProfiles>;
  /** An object relationship */
  inviter: Users;
  /** An object relationship */
  inviterProfile?: Maybe<UserProfiles>;
  inviterUserId: Scalars['uuid'];
  /** An object relationship */
  playRequest?: Maybe<PlayRequests>;
  playRequestId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
  status: EventPlayerInviteStatusesEnum;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "event_player_invites" */
export type EventPlayerInvitesAggregate = {
  __typename?: 'EventPlayerInvitesAggregate';
  aggregate?: Maybe<EventPlayerInvitesAggregateFields>;
  nodes: Array<EventPlayerInvites>;
};

/** aggregate fields of "event_player_invites" */
export type EventPlayerInvitesAggregateFields = {
  __typename?: 'EventPlayerInvitesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventPlayerInvitesMaxFields>;
  min?: Maybe<EventPlayerInvitesMinFields>;
};


/** aggregate fields of "event_player_invites" */
export type EventPlayerInvitesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventPlayerInvitesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_player_invites". All fields are combined with a logical 'AND'. */
export type EventPlayerInvitesBoolExp = {
  _and?: InputMaybe<Array<EventPlayerInvitesBoolExp>>;
  _not?: InputMaybe<EventPlayerInvitesBoolExp>;
  _or?: InputMaybe<Array<EventPlayerInvitesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  invitedUser?: InputMaybe<UsersBoolExp>;
  invitedUserId?: InputMaybe<UuidComparisonExp>;
  invitedUserProfile?: InputMaybe<UserProfilesBoolExp>;
  inviter?: InputMaybe<UsersBoolExp>;
  inviterProfile?: InputMaybe<UserProfilesBoolExp>;
  inviterUserId?: InputMaybe<UuidComparisonExp>;
  playRequest?: InputMaybe<PlayRequestsBoolExp>;
  playRequestId?: InputMaybe<UuidComparisonExp>;
  respondedAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<EventPlayerInviteStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** aggregate max on columns */
export type EventPlayerInvitesMaxFields = {
  __typename?: 'EventPlayerInvitesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invitedUserId?: Maybe<Scalars['uuid']>;
  inviterUserId?: Maybe<Scalars['uuid']>;
  playRequestId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type EventPlayerInvitesMinFields = {
  __typename?: 'EventPlayerInvitesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invitedUserId?: Maybe<Scalars['uuid']>;
  inviterUserId?: Maybe<Scalars['uuid']>;
  playRequestId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "event_player_invites". */
export type EventPlayerInvitesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invitedUser?: InputMaybe<UsersOrderBy>;
  invitedUserId?: InputMaybe<OrderBy>;
  invitedUserProfile?: InputMaybe<UserProfilesOrderBy>;
  inviter?: InputMaybe<UsersOrderBy>;
  inviterProfile?: InputMaybe<UserProfilesOrderBy>;
  inviterUserId?: InputMaybe<OrderBy>;
  playRequest?: InputMaybe<PlayRequestsOrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "event_player_invites" */
export enum EventPlayerInvitesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedUserId = 'invitedUserId',
  /** column name */
  InviterUserId = 'inviterUserId',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  RespondedAt = 'respondedAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "event_player_invites" */
export type EventPlayerInvitesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventPlayerInvitesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventPlayerInvitesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invitedUserId?: InputMaybe<Scalars['uuid']>;
  inviterUserId?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<EventPlayerInviteStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "event_pool_rounds" */
export type EventPoolRounds = {
  __typename?: 'EventPoolRounds';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An array relationship */
  matches: Array<EventMatches>;
  /** An object relationship */
  pool: EventGroupPools;
  poolId: Scalars['uuid'];
  roundOrder: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "event_pool_rounds" */
export type EventPoolRoundsMatchesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};

/** order by aggregate values of table "event_pool_rounds" */
export type EventPoolRoundsAggregateOrderBy = {
  avg?: InputMaybe<EventPoolRoundsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventPoolRoundsMaxOrderBy>;
  min?: InputMaybe<EventPoolRoundsMinOrderBy>;
  stddev?: InputMaybe<EventPoolRoundsStddevOrderBy>;
  stddevPop?: InputMaybe<EventPoolRoundsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventPoolRoundsStddevSampOrderBy>;
  sum?: InputMaybe<EventPoolRoundsSumOrderBy>;
  varPop?: InputMaybe<EventPoolRoundsVarPopOrderBy>;
  varSamp?: InputMaybe<EventPoolRoundsVarSampOrderBy>;
  variance?: InputMaybe<EventPoolRoundsVarianceOrderBy>;
};

/** order by avg() on columns of table "event_pool_rounds" */
export type EventPoolRoundsAvgOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_pool_rounds". All fields are combined with a logical 'AND'. */
export type EventPoolRoundsBoolExp = {
  _and?: InputMaybe<Array<EventPoolRoundsBoolExp>>;
  _not?: InputMaybe<EventPoolRoundsBoolExp>;
  _or?: InputMaybe<Array<EventPoolRoundsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  matches?: InputMaybe<EventMatchesBoolExp>;
  pool?: InputMaybe<EventGroupPoolsBoolExp>;
  poolId?: InputMaybe<UuidComparisonExp>;
  roundOrder?: InputMaybe<IntComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "event_pool_rounds" */
export type EventPoolRoundsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  poolId?: InputMaybe<OrderBy>;
  roundOrder?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_pool_rounds" */
export type EventPoolRoundsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  poolId?: InputMaybe<OrderBy>;
  roundOrder?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_pool_rounds". */
export type EventPoolRoundsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  matchesAggregate?: InputMaybe<EventMatchesAggregateOrderBy>;
  pool?: InputMaybe<EventGroupPoolsOrderBy>;
  poolId?: InputMaybe<OrderBy>;
  roundOrder?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "event_pool_rounds" */
export enum EventPoolRoundsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PoolId = 'poolId',
  /** column name */
  RoundOrder = 'roundOrder',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** order by stddev() on columns of table "event_pool_rounds" */
export type EventPoolRoundsStddevOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "event_pool_rounds" */
export type EventPoolRoundsStddevPopOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "event_pool_rounds" */
export type EventPoolRoundsStddevSampOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_pool_rounds" */
export type EventPoolRoundsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventPoolRoundsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventPoolRoundsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  poolId?: InputMaybe<Scalars['uuid']>;
  roundOrder?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "event_pool_rounds" */
export type EventPoolRoundsSumOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "event_pool_rounds" */
export type EventPoolRoundsVarPopOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "event_pool_rounds" */
export type EventPoolRoundsVarSampOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_pool_rounds" */
export type EventPoolRoundsVarianceOrderBy = {
  roundOrder?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_pools_teams" */
export type EventPoolsTeams = {
  __typename?: 'EventPoolsTeams';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  pool: EventGroupPools;
  poolId: Scalars['uuid'];
  /** An object relationship */
  team: EventTeams;
  teamId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "event_pools_teams" */
export type EventPoolsTeamsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventPoolsTeamsMaxOrderBy>;
  min?: InputMaybe<EventPoolsTeamsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "event_pools_teams". All fields are combined with a logical 'AND'. */
export type EventPoolsTeamsBoolExp = {
  _and?: InputMaybe<Array<EventPoolsTeamsBoolExp>>;
  _not?: InputMaybe<EventPoolsTeamsBoolExp>;
  _or?: InputMaybe<Array<EventPoolsTeamsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  pool?: InputMaybe<EventGroupPoolsBoolExp>;
  poolId?: InputMaybe<UuidComparisonExp>;
  team?: InputMaybe<EventTeamsBoolExp>;
  teamId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "event_pools_teams" */
export type EventPoolsTeamsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  poolId?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_pools_teams" */
export type EventPoolsTeamsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  poolId?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_pools_teams". */
export type EventPoolsTeamsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pool?: InputMaybe<EventGroupPoolsOrderBy>;
  poolId?: InputMaybe<OrderBy>;
  team?: InputMaybe<EventTeamsOrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "event_pools_teams" */
export enum EventPoolsTeamsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PoolId = 'poolId',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "event_pools_teams" */
export type EventPoolsTeamsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventPoolsTeamsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventPoolsTeamsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  poolId?: InputMaybe<Scalars['uuid']>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "event_privacy" */
export type EventPrivacy = {
  __typename?: 'EventPrivacy';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_privacy". All fields are combined with a logical 'AND'. */
export type EventPrivacyBoolExp = {
  _and?: InputMaybe<Array<EventPrivacyBoolExp>>;
  _not?: InputMaybe<EventPrivacyBoolExp>;
  _or?: InputMaybe<Array<EventPrivacyBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventPrivacyEnum {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Unlisted = 'UNLISTED'
}

/** Boolean expression to compare columns of type "EventPrivacyEnum". All fields are combined with logical 'AND'. */
export type EventPrivacyEnumComparisonExp = {
  _eq?: InputMaybe<EventPrivacyEnum>;
  _in?: InputMaybe<Array<EventPrivacyEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventPrivacyEnum>;
  _nin?: InputMaybe<Array<EventPrivacyEnum>>;
};

/** Ordering options when selecting data from "event_privacy". */
export type EventPrivacyOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_privacy" */
export enum EventPrivacySelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_privacy" */
export type EventPrivacyStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventPrivacyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventPrivacyStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_registration_details" */
export type EventRegistrationDetails = {
  __typename?: 'EventRegistrationDetails';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprId?: Maybe<Scalars['String']>;
  eventRegistrationId: Scalars['uuid'];
  id: Scalars['uuid'];
  referredBy?: Maybe<Scalars['String']>;
  /** An object relationship */
  registration: EventRegistrations;
  updatedAt: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "event_registration_details". All fields are combined with a logical 'AND'. */
export type EventRegistrationDetailsBoolExp = {
  _and?: InputMaybe<Array<EventRegistrationDetailsBoolExp>>;
  _not?: InputMaybe<EventRegistrationDetailsBoolExp>;
  _or?: InputMaybe<Array<EventRegistrationDetailsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  duprId?: InputMaybe<StringComparisonExp>;
  eventRegistrationId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  referredBy?: InputMaybe<StringComparisonExp>;
  registration?: InputMaybe<EventRegistrationsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_registration_details" */
export enum EventRegistrationDetailsConstraint {
  /** unique or primary key constraint on columns "event_registration_id" */
  EventRegistrationDetailsEventRegistrationIdKey = 'event_registration_details_event_registration_id_key',
  /** unique or primary key constraint on columns "id" */
  EventRegistrationDetailsPkey = 'event_registration_details_pkey'
}

/** input type for inserting data into table "event_registration_details" */
export type EventRegistrationDetailsInsertInput = {
  duprId?: InputMaybe<Scalars['String']>;
  eventRegistrationId?: InputMaybe<Scalars['uuid']>;
};

/** response of any mutation on the table "event_registration_details" */
export type EventRegistrationDetailsMutationResponse = {
  __typename?: 'EventRegistrationDetailsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventRegistrationDetails>;
};

/** on_conflict condition type for table "event_registration_details" */
export type EventRegistrationDetailsOnConflict = {
  constraint: EventRegistrationDetailsConstraint;
  updateColumns?: Array<EventRegistrationDetailsUpdateColumn>;
  where?: InputMaybe<EventRegistrationDetailsBoolExp>;
};

/** Ordering options when selecting data from "event_registration_details". */
export type EventRegistrationDetailsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duprId?: InputMaybe<OrderBy>;
  eventRegistrationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  referredBy?: InputMaybe<OrderBy>;
  registration?: InputMaybe<EventRegistrationsOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "event_registration_details" */
export enum EventRegistrationDetailsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DuprId = 'duprId',
  /** column name */
  EventRegistrationId = 'eventRegistrationId',
  /** column name */
  Id = 'id',
  /** column name */
  ReferredBy = 'referredBy',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "event_registration_details" */
export type EventRegistrationDetailsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventRegistrationDetailsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventRegistrationDetailsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  duprId?: InputMaybe<Scalars['String']>;
  eventRegistrationId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  referredBy?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** placeholder for update columns of table "event_registration_details" (current role has no relevant permissions) */
export enum EventRegistrationDetailsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "event_registrations" */
export type EventRegistrations = {
  __typename?: 'EventRegistrations';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  registrationDetails?: Maybe<EventRegistrationDetails>;
  /** An array relationship */
  transactionItems: Array<EventTransactionItems>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};


/** columns and relationships of "event_registrations" */
export type EventRegistrationsTransactionItemsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};

/** aggregated selection of "event_registrations" */
export type EventRegistrationsAggregate = {
  __typename?: 'EventRegistrationsAggregate';
  aggregate?: Maybe<EventRegistrationsAggregateFields>;
  nodes: Array<EventRegistrations>;
};

export type EventRegistrationsAggregateBoolExp = {
  count?: InputMaybe<EventRegistrationsAggregateBoolExpCount>;
};

/** aggregate fields of "event_registrations" */
export type EventRegistrationsAggregateFields = {
  __typename?: 'EventRegistrationsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EventRegistrationsMaxFields>;
  min?: Maybe<EventRegistrationsMinFields>;
};


/** aggregate fields of "event_registrations" */
export type EventRegistrationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_registrations" */
export type EventRegistrationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventRegistrationsMaxOrderBy>;
  min?: InputMaybe<EventRegistrationsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "event_registrations". All fields are combined with a logical 'AND'. */
export type EventRegistrationsBoolExp = {
  _and?: InputMaybe<Array<EventRegistrationsBoolExp>>;
  _not?: InputMaybe<EventRegistrationsBoolExp>;
  _or?: InputMaybe<Array<EventRegistrationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  registrationDetails?: InputMaybe<EventRegistrationDetailsBoolExp>;
  transactionItems?: InputMaybe<EventTransactionItemsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** aggregate max on columns */
export type EventRegistrationsMaxFields = {
  __typename?: 'EventRegistrationsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_registrations" */
export type EventRegistrationsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventRegistrationsMinFields = {
  __typename?: 'EventRegistrationsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  eventId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_registrations" */
export type EventRegistrationsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_registrations". */
export type EventRegistrationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  registrationDetails?: InputMaybe<EventRegistrationDetailsOrderBy>;
  transactionItemsAggregate?: InputMaybe<EventTransactionItemsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** select columns of table "event_registrations" */
export enum EventRegistrationsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "event_registrations" */
export type EventRegistrationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventRegistrationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventRegistrationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "event_sequence_complete_reasons" */
export type EventSequenceCompleteReasons = {
  __typename?: 'EventSequenceCompleteReasons';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_sequence_complete_reasons". All fields are combined with a logical 'AND'. */
export type EventSequenceCompleteReasonsBoolExp = {
  _and?: InputMaybe<Array<EventSequenceCompleteReasonsBoolExp>>;
  _not?: InputMaybe<EventSequenceCompleteReasonsBoolExp>;
  _or?: InputMaybe<Array<EventSequenceCompleteReasonsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventSequenceCompleteReasonsEnum {
  AllScores = 'ALL_SCORES',
  OrganizerSelected = 'ORGANIZER_SELECTED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "EventSequenceCompleteReasonsEnum". All fields are combined with logical 'AND'. */
export type EventSequenceCompleteReasonsEnumComparisonExp = {
  _eq?: InputMaybe<EventSequenceCompleteReasonsEnum>;
  _in?: InputMaybe<Array<EventSequenceCompleteReasonsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventSequenceCompleteReasonsEnum>;
  _nin?: InputMaybe<Array<EventSequenceCompleteReasonsEnum>>;
};

/** Ordering options when selecting data from "event_sequence_complete_reasons". */
export type EventSequenceCompleteReasonsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_sequence_complete_reasons" */
export enum EventSequenceCompleteReasonsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_sequence_complete_reasons" */
export type EventSequenceCompleteReasonsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventSequenceCompleteReasonsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventSequenceCompleteReasonsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_skill_levels" */
export type EventSkillLevels = {
  __typename?: 'EventSkillLevels';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  id: Scalars['uuid'];
  skillLevel: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "event_skill_levels" */
export type EventSkillLevelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventSkillLevelsMaxOrderBy>;
  min?: InputMaybe<EventSkillLevelsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_skill_levels" */
export type EventSkillLevelsArrRelInsertInput = {
  data: Array<EventSkillLevelsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventSkillLevelsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_skill_levels". All fields are combined with a logical 'AND'. */
export type EventSkillLevelsBoolExp = {
  _and?: InputMaybe<Array<EventSkillLevelsBoolExp>>;
  _not?: InputMaybe<EventSkillLevelsBoolExp>;
  _or?: InputMaybe<Array<EventSkillLevelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  skillLevel?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_skill_levels" */
export enum EventSkillLevelsConstraint {
  /** unique or primary key constraint on columns "skill_level", "event_id" */
  EventSkillLevelsEventIdSkillLevelKey = 'event_skill_levels_event_id_skill_level_key',
  /** unique or primary key constraint on columns "id" */
  EventSkillLevelsPkey = 'event_skill_levels_pkey'
}

/** input type for inserting data into table "event_skill_levels" */
export type EventSkillLevelsInsertInput = {
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "event_skill_levels" */
export type EventSkillLevelsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_skill_levels" */
export type EventSkillLevelsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_skill_levels" */
export type EventSkillLevelsMutationResponse = {
  __typename?: 'EventSkillLevelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventSkillLevels>;
};

/** on_conflict condition type for table "event_skill_levels" */
export type EventSkillLevelsOnConflict = {
  constraint: EventSkillLevelsConstraint;
  updateColumns?: Array<EventSkillLevelsUpdateColumn>;
  where?: InputMaybe<EventSkillLevelsBoolExp>;
};

/** Ordering options when selecting data from "event_skill_levels". */
export type EventSkillLevelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "event_skill_levels" */
export enum EventSkillLevelsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  SkillLevel = 'skillLevel',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "event_skill_levels" */
export type EventSkillLevelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventSkillLevelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventSkillLevelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** placeholder for update columns of table "event_skill_levels" (current role has no relevant permissions) */
export enum EventSkillLevelsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "event_sponsors" */
export type EventSponsors = {
  __typename?: 'EventSponsors';
  categoryName: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  id: Scalars['uuid'];
  imageFileName: Scalars['String'];
  imageFileType: Scalars['String'];
  imageHost: Scalars['String'];
  imageOriginalFileName?: Maybe<Scalars['String']>;
  imagePath: Scalars['String'];
  imageProvider: Scalars['String'];
  imageProviderUrl: Scalars['String'];
  imageUrl: Scalars['String'];
  isTitleSponsor: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "event_sponsors" */
export type EventSponsorsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventSponsorsMaxOrderBy>;
  min?: InputMaybe<EventSponsorsMinOrderBy>;
};

/** input type for inserting array relation for remote table "event_sponsors" */
export type EventSponsorsArrRelInsertInput = {
  data: Array<EventSponsorsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventSponsorsOnConflict>;
};

/** Boolean expression to filter rows from the table "event_sponsors". All fields are combined with a logical 'AND'. */
export type EventSponsorsBoolExp = {
  _and?: InputMaybe<Array<EventSponsorsBoolExp>>;
  _not?: InputMaybe<EventSponsorsBoolExp>;
  _or?: InputMaybe<Array<EventSponsorsBoolExp>>;
  categoryName?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  imageFileName?: InputMaybe<StringComparisonExp>;
  imageFileType?: InputMaybe<StringComparisonExp>;
  imageHost?: InputMaybe<StringComparisonExp>;
  imageOriginalFileName?: InputMaybe<StringComparisonExp>;
  imagePath?: InputMaybe<StringComparisonExp>;
  imageProvider?: InputMaybe<StringComparisonExp>;
  imageProviderUrl?: InputMaybe<StringComparisonExp>;
  imageUrl?: InputMaybe<StringComparisonExp>;
  isTitleSponsor?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "event_sponsors" */
export enum EventSponsorsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventSponsorsPkey = 'event_sponsors_pkey'
}

/** input type for inserting data into table "event_sponsors" */
export type EventSponsorsInsertInput = {
  categoryName?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']>;
  imageFileName?: InputMaybe<Scalars['String']>;
  imageFileType?: InputMaybe<Scalars['String']>;
  imageHost?: InputMaybe<Scalars['String']>;
  imageOriginalFileName?: InputMaybe<Scalars['String']>;
  imagePath?: InputMaybe<Scalars['String']>;
  imageProvider?: InputMaybe<Scalars['String']>;
  imageProviderUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isTitleSponsor?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "event_sponsors" */
export type EventSponsorsMaxOrderBy = {
  categoryName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imageFileName?: InputMaybe<OrderBy>;
  imageFileType?: InputMaybe<OrderBy>;
  imageHost?: InputMaybe<OrderBy>;
  imageOriginalFileName?: InputMaybe<OrderBy>;
  imagePath?: InputMaybe<OrderBy>;
  imageProvider?: InputMaybe<OrderBy>;
  imageProviderUrl?: InputMaybe<OrderBy>;
  imageUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_sponsors" */
export type EventSponsorsMinOrderBy = {
  categoryName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imageFileName?: InputMaybe<OrderBy>;
  imageFileType?: InputMaybe<OrderBy>;
  imageHost?: InputMaybe<OrderBy>;
  imageOriginalFileName?: InputMaybe<OrderBy>;
  imagePath?: InputMaybe<OrderBy>;
  imageProvider?: InputMaybe<OrderBy>;
  imageProviderUrl?: InputMaybe<OrderBy>;
  imageUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_sponsors" */
export type EventSponsorsMutationResponse = {
  __typename?: 'EventSponsorsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventSponsors>;
};

/** on_conflict condition type for table "event_sponsors" */
export type EventSponsorsOnConflict = {
  constraint: EventSponsorsConstraint;
  updateColumns?: Array<EventSponsorsUpdateColumn>;
  where?: InputMaybe<EventSponsorsBoolExp>;
};

/** Ordering options when selecting data from "event_sponsors". */
export type EventSponsorsOrderBy = {
  categoryName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imageFileName?: InputMaybe<OrderBy>;
  imageFileType?: InputMaybe<OrderBy>;
  imageHost?: InputMaybe<OrderBy>;
  imageOriginalFileName?: InputMaybe<OrderBy>;
  imagePath?: InputMaybe<OrderBy>;
  imageProvider?: InputMaybe<OrderBy>;
  imageProviderUrl?: InputMaybe<OrderBy>;
  imageUrl?: InputMaybe<OrderBy>;
  isTitleSponsor?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_sponsors */
export type EventSponsorsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_sponsors" */
export enum EventSponsorsSelectColumn {
  /** column name */
  CategoryName = 'categoryName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  ImageFileName = 'imageFileName',
  /** column name */
  ImageFileType = 'imageFileType',
  /** column name */
  ImageHost = 'imageHost',
  /** column name */
  ImageOriginalFileName = 'imageOriginalFileName',
  /** column name */
  ImagePath = 'imagePath',
  /** column name */
  ImageProvider = 'imageProvider',
  /** column name */
  ImageProviderUrl = 'imageProviderUrl',
  /** column name */
  ImageUrl = 'imageUrl',
  /** column name */
  IsTitleSponsor = 'isTitleSponsor',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "event_sponsors" */
export type EventSponsorsSetInput = {
  categoryName?: InputMaybe<Scalars['String']>;
  imageFileName?: InputMaybe<Scalars['String']>;
  imageFileType?: InputMaybe<Scalars['String']>;
  imageHost?: InputMaybe<Scalars['String']>;
  imageOriginalFileName?: InputMaybe<Scalars['String']>;
  imagePath?: InputMaybe<Scalars['String']>;
  imageProvider?: InputMaybe<Scalars['String']>;
  imageProviderUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isTitleSponsor?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_sponsors" */
export type EventSponsorsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventSponsorsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventSponsorsStreamCursorValueInput = {
  categoryName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  imageFileName?: InputMaybe<Scalars['String']>;
  imageFileType?: InputMaybe<Scalars['String']>;
  imageHost?: InputMaybe<Scalars['String']>;
  imageOriginalFileName?: InputMaybe<Scalars['String']>;
  imagePath?: InputMaybe<Scalars['String']>;
  imageProvider?: InputMaybe<Scalars['String']>;
  imageProviderUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isTitleSponsor?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_sponsors" */
export enum EventSponsorsUpdateColumn {
  /** column name */
  CategoryName = 'categoryName',
  /** column name */
  ImageFileName = 'imageFileName',
  /** column name */
  ImageFileType = 'imageFileType',
  /** column name */
  ImageHost = 'imageHost',
  /** column name */
  ImageOriginalFileName = 'imageOriginalFileName',
  /** column name */
  ImagePath = 'imagePath',
  /** column name */
  ImageProvider = 'imageProvider',
  /** column name */
  ImageProviderUrl = 'imageProviderUrl',
  /** column name */
  ImageUrl = 'imageUrl',
  /** column name */
  IsTitleSponsor = 'isTitleSponsor',
  /** column name */
  Name = 'name'
}

export type EventSponsorsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventSponsorsSetInput>;
  /** filter the rows which have to be updated */
  where: EventSponsorsBoolExp;
};

/** columns and relationships of "event_statuses" */
export type EventStatuses = {
  __typename?: 'EventStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_statuses". All fields are combined with a logical 'AND'. */
export type EventStatusesBoolExp = {
  _and?: InputMaybe<Array<EventStatusesBoolExp>>;
  _not?: InputMaybe<EventStatusesBoolExp>;
  _or?: InputMaybe<Array<EventStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventStatusesEnum {
  Canceled = 'CANCELED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** Boolean expression to compare columns of type "EventStatusesEnum". All fields are combined with logical 'AND'. */
export type EventStatusesEnumComparisonExp = {
  _eq?: InputMaybe<EventStatusesEnum>;
  _in?: InputMaybe<Array<EventStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventStatusesEnum>;
  _nin?: InputMaybe<Array<EventStatusesEnum>>;
};

/** Ordering options when selecting data from "event_statuses". */
export type EventStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_statuses" */
export enum EventStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_statuses" */
export type EventStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_team_member_statuses" */
export type EventTeamMemberStatuses = {
  __typename?: 'EventTeamMemberStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_team_member_statuses". All fields are combined with a logical 'AND'. */
export type EventTeamMemberStatusesBoolExp = {
  _and?: InputMaybe<Array<EventTeamMemberStatusesBoolExp>>;
  _not?: InputMaybe<EventTeamMemberStatusesBoolExp>;
  _or?: InputMaybe<Array<EventTeamMemberStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventTeamMemberStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "EventTeamMemberStatusesEnum". All fields are combined with logical 'AND'. */
export type EventTeamMemberStatusesEnumComparisonExp = {
  _eq?: InputMaybe<EventTeamMemberStatusesEnum>;
  _in?: InputMaybe<Array<EventTeamMemberStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventTeamMemberStatusesEnum>;
  _nin?: InputMaybe<Array<EventTeamMemberStatusesEnum>>;
};

/** Ordering options when selecting data from "event_team_member_statuses". */
export type EventTeamMemberStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_team_member_statuses" */
export enum EventTeamMemberStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_team_member_statuses" */
export type EventTeamMemberStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTeamMemberStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTeamMemberStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_team_members" */
export type EventTeamMembers = {
  __typename?: 'EventTeamMembers';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  status: EventTeamMemberStatusesEnum;
  /** An object relationship */
  team: EventTeams;
  teamId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** order by aggregate values of table "event_team_members" */
export type EventTeamMembersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventTeamMembersMaxOrderBy>;
  min?: InputMaybe<EventTeamMembersMinOrderBy>;
};

/** Boolean expression to filter rows from the table "event_team_members". All fields are combined with a logical 'AND'. */
export type EventTeamMembersBoolExp = {
  _and?: InputMaybe<Array<EventTeamMembersBoolExp>>;
  _not?: InputMaybe<EventTeamMembersBoolExp>;
  _or?: InputMaybe<Array<EventTeamMembersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<EventTeamMemberStatusesEnumComparisonExp>;
  team?: InputMaybe<EventTeamsBoolExp>;
  teamId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** order by max() on columns of table "event_team_members" */
export type EventTeamMembersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_team_members" */
export type EventTeamMembersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_team_members". */
export type EventTeamMembersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  team?: InputMaybe<EventTeamsOrderBy>;
  teamId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** select columns of table "event_team_members" */
export enum EventTeamMembersSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "event_team_members" */
export type EventTeamMembersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTeamMembersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTeamMembersStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<EventTeamMemberStatusesEnum>;
  teamId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "event_team_statuses" */
export type EventTeamStatuses = {
  __typename?: 'EventTeamStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_team_statuses". All fields are combined with a logical 'AND'. */
export type EventTeamStatusesBoolExp = {
  _and?: InputMaybe<Array<EventTeamStatusesBoolExp>>;
  _not?: InputMaybe<EventTeamStatusesBoolExp>;
  _or?: InputMaybe<Array<EventTeamStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventTeamStatusesEnum {
  Active = 'ACTIVE',
  Forfeited = 'FORFEITED',
  Retired = 'RETIRED'
}

/** Boolean expression to compare columns of type "EventTeamStatusesEnum". All fields are combined with logical 'AND'. */
export type EventTeamStatusesEnumComparisonExp = {
  _eq?: InputMaybe<EventTeamStatusesEnum>;
  _in?: InputMaybe<Array<EventTeamStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventTeamStatusesEnum>;
  _nin?: InputMaybe<Array<EventTeamStatusesEnum>>;
};

/** Ordering options when selecting data from "event_team_statuses". */
export type EventTeamStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_team_statuses" */
export enum EventTeamStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_team_statuses" */
export type EventTeamStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTeamStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTeamStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_teams" */
export type EventTeams = {
  __typename?: 'EventTeams';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  gamesWon: Array<EventMatchGames>;
  /** An object relationship */
  group: EventGroups;
  groupId: Scalars['uuid'];
  /** An array relationship */
  groupRegistrations: Array<EventGroupRegistrations>;
  id: Scalars['uuid'];
  /** An array relationship */
  matches: Array<EventMatchesTeams>;
  /** An array relationship */
  matchesLost: Array<EventMatches>;
  /** An array relationship */
  matchesWon: Array<EventMatches>;
  /** An array relationship */
  members: Array<EventTeamMembers>;
  /** An array relationship */
  pools: Array<EventPoolsTeams>;
  status: EventTeamStatusesEnum;
  /** An object relationship */
  teamStatus: EventTeamStatuses;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "event_teams" */
export type EventTeamsGamesWonArgs = {
  distinctOn?: InputMaybe<Array<EventMatchGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchGamesOrderBy>>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsGroupRegistrationsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationsOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsMatchesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesTeamsOrderBy>>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsMatchesLostArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsMatchesWonArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsMembersArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMembersOrderBy>>;
  where?: InputMaybe<EventTeamMembersBoolExp>;
};


/** columns and relationships of "event_teams" */
export type EventTeamsPoolsArgs = {
  distinctOn?: InputMaybe<Array<EventPoolsTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolsTeamsOrderBy>>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};

/** order by aggregate values of table "event_teams" */
export type EventTeamsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventTeamsMaxOrderBy>;
  min?: InputMaybe<EventTeamsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "event_teams". All fields are combined with a logical 'AND'. */
export type EventTeamsBoolExp = {
  _and?: InputMaybe<Array<EventTeamsBoolExp>>;
  _not?: InputMaybe<EventTeamsBoolExp>;
  _or?: InputMaybe<Array<EventTeamsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  gamesWon?: InputMaybe<EventMatchGamesBoolExp>;
  group?: InputMaybe<EventGroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  groupRegistrations?: InputMaybe<EventGroupRegistrationsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  matches?: InputMaybe<EventMatchesTeamsBoolExp>;
  matchesLost?: InputMaybe<EventMatchesBoolExp>;
  matchesWon?: InputMaybe<EventMatchesBoolExp>;
  members?: InputMaybe<EventTeamMembersBoolExp>;
  pools?: InputMaybe<EventPoolsTeamsBoolExp>;
  status?: InputMaybe<EventTeamStatusesEnumComparisonExp>;
  teamStatus?: InputMaybe<EventTeamStatusesBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "event_teams" */
export type EventTeamsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_teams" */
export type EventTeamsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_teams". */
export type EventTeamsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  gamesWonAggregate?: InputMaybe<EventMatchGamesAggregateOrderBy>;
  group?: InputMaybe<EventGroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  groupRegistrationsAggregate?: InputMaybe<EventGroupRegistrationsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  matchesAggregate?: InputMaybe<EventMatchesTeamsAggregateOrderBy>;
  matchesLostAggregate?: InputMaybe<EventMatchesAggregateOrderBy>;
  matchesWonAggregate?: InputMaybe<EventMatchesAggregateOrderBy>;
  membersAggregate?: InputMaybe<EventTeamMembersAggregateOrderBy>;
  poolsAggregate?: InputMaybe<EventPoolsTeamsAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  teamStatus?: InputMaybe<EventTeamStatusesOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "event_teams" */
export enum EventTeamsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "event_teams" */
export type EventTeamsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTeamsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTeamsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<EventTeamStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "event_transaction_item_types" */
export type EventTransactionItemTypes = {
  __typename?: 'EventTransactionItemTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_transaction_item_types". All fields are combined with a logical 'AND'. */
export type EventTransactionItemTypesBoolExp = {
  _and?: InputMaybe<Array<EventTransactionItemTypesBoolExp>>;
  _not?: InputMaybe<EventTransactionItemTypesBoolExp>;
  _or?: InputMaybe<Array<EventTransactionItemTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventTransactionItemTypesEnum {
  /** Coupon discount applied at checkout */
  Coupon = 'COUPON',
  EventGroupRegistration = 'EVENT_GROUP_REGISTRATION',
  EventRegistration = 'EVENT_REGISTRATION'
}

/** Boolean expression to compare columns of type "EventTransactionItemTypesEnum". All fields are combined with logical 'AND'. */
export type EventTransactionItemTypesEnumComparisonExp = {
  _eq?: InputMaybe<EventTransactionItemTypesEnum>;
  _in?: InputMaybe<Array<EventTransactionItemTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventTransactionItemTypesEnum>;
  _nin?: InputMaybe<Array<EventTransactionItemTypesEnum>>;
};

/** Ordering options when selecting data from "event_transaction_item_types". */
export type EventTransactionItemTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_transaction_item_types" */
export enum EventTransactionItemTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_transaction_item_types" */
export type EventTransactionItemTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTransactionItemTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTransactionItemTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_transaction_items" */
export type EventTransactionItems = {
  __typename?: 'EventTransactionItems';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  groupRegistration?: Maybe<EventGroupRegistrations>;
  groupRegistrationId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  priceUnitAmount: Scalars['Int'];
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  /** An object relationship */
  registration?: Maybe<EventRegistrations>;
  registrationId?: Maybe<Scalars['uuid']>;
  status: OrderStatusesEnum;
  totalUnitAmount: Scalars['Int'];
  /** An object relationship */
  transaction: EventTransactions;
  transactionId: Scalars['uuid'];
  type: EventTransactionItemTypesEnum;
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "event_transaction_items" */
export type EventTransactionItemsAggregateOrderBy = {
  avg?: InputMaybe<EventTransactionItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventTransactionItemsMaxOrderBy>;
  min?: InputMaybe<EventTransactionItemsMinOrderBy>;
  stddev?: InputMaybe<EventTransactionItemsStddevOrderBy>;
  stddevPop?: InputMaybe<EventTransactionItemsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventTransactionItemsStddevSampOrderBy>;
  sum?: InputMaybe<EventTransactionItemsSumOrderBy>;
  varPop?: InputMaybe<EventTransactionItemsVarPopOrderBy>;
  varSamp?: InputMaybe<EventTransactionItemsVarSampOrderBy>;
  variance?: InputMaybe<EventTransactionItemsVarianceOrderBy>;
};

/** order by avg() on columns of table "event_transaction_items" */
export type EventTransactionItemsAvgOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_transaction_items". All fields are combined with a logical 'AND'. */
export type EventTransactionItemsBoolExp = {
  _and?: InputMaybe<Array<EventTransactionItemsBoolExp>>;
  _not?: InputMaybe<EventTransactionItemsBoolExp>;
  _or?: InputMaybe<Array<EventTransactionItemsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  groupRegistration?: InputMaybe<EventGroupRegistrationsBoolExp>;
  groupRegistrationId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  registration?: InputMaybe<EventRegistrationsBoolExp>;
  registrationId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  totalUnitAmount?: InputMaybe<IntComparisonExp>;
  transaction?: InputMaybe<EventTransactionsBoolExp>;
  transactionId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<EventTransactionItemTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "event_transaction_items" */
export type EventTransactionItemsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupRegistrationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  registrationId?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  transactionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_transaction_items" */
export type EventTransactionItemsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupRegistrationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  registrationId?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  transactionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_transaction_items". */
export type EventTransactionItemsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupRegistration?: InputMaybe<EventGroupRegistrationsOrderBy>;
  groupRegistrationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  registration?: InputMaybe<EventRegistrationsOrderBy>;
  registrationId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  transaction?: InputMaybe<EventTransactionsOrderBy>;
  transactionId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "event_transaction_items" */
export enum EventTransactionItemsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupRegistrationId = 'groupRegistrationId',
  /** column name */
  Id = 'id',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  RegistrationId = 'registrationId',
  /** column name */
  Status = 'status',
  /** column name */
  TotalUnitAmount = 'totalUnitAmount',
  /** column name */
  TransactionId = 'transactionId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** order by stddev() on columns of table "event_transaction_items" */
export type EventTransactionItemsStddevOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "event_transaction_items" */
export type EventTransactionItemsStddevPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "event_transaction_items" */
export type EventTransactionItemsStddevSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_transaction_items" */
export type EventTransactionItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTransactionItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTransactionItemsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupRegistrationId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  registrationId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  transactionId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<EventTransactionItemTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "event_transaction_items" */
export type EventTransactionItemsSumOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "event_transaction_items" */
export type EventTransactionItemsVarPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "event_transaction_items" */
export type EventTransactionItemsVarSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_transaction_items" */
export type EventTransactionItemsVarianceOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_transactions" */
export type EventTransactions = {
  __typename?: 'EventTransactions';
  applicationFeeTotalUnitAmount: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  customer: Users;
  customerApplicationFeeUnitAmount: Scalars['Int'];
  /** An object relationship */
  customerProfile?: Maybe<UserProfiles>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid'];
  externalStripePaymentIntentId: Scalars['String'];
  id: Scalars['uuid'];
  internalStripePaymentIntentId: Scalars['uuid'];
  orderSubtotalUnitAmount: Scalars['Int'];
  orderTotalUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  /** An object relationship */
  paymentMethodUsed?: Maybe<UserCreditCards>;
  paymentProcessor: PaymentProcessorsEnum;
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  /** An object relationship */
  seller: Users;
  sellerApplicationFeeUnitAmount: Scalars['Int'];
  /** An object relationship */
  sellerProfile?: Maybe<UserProfiles>;
  sellerUserId: Scalars['uuid'];
  status: OrderStatusesEnum;
  stripeCustomerId: Scalars['String'];
  stripeMerchantId?: Maybe<Scalars['String']>;
  stripePaymentStatus: Scalars['String'];
  /** An array relationship */
  transactionItems: Array<EventTransactionItems>;
  transferUnitAmount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  userCreditCardId?: Maybe<Scalars['uuid']>;
  userId: Scalars['uuid'];
};


/** columns and relationships of "event_transactions" */
export type EventTransactionsTransactionItemsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};

/** order by aggregate values of table "event_transactions" */
export type EventTransactionsAggregateOrderBy = {
  avg?: InputMaybe<EventTransactionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventTransactionsMaxOrderBy>;
  min?: InputMaybe<EventTransactionsMinOrderBy>;
  stddev?: InputMaybe<EventTransactionsStddevOrderBy>;
  stddevPop?: InputMaybe<EventTransactionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventTransactionsStddevSampOrderBy>;
  sum?: InputMaybe<EventTransactionsSumOrderBy>;
  varPop?: InputMaybe<EventTransactionsVarPopOrderBy>;
  varSamp?: InputMaybe<EventTransactionsVarSampOrderBy>;
  variance?: InputMaybe<EventTransactionsVarianceOrderBy>;
};

/** order by avg() on columns of table "event_transactions" */
export type EventTransactionsAvgOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_transactions". All fields are combined with a logical 'AND'. */
export type EventTransactionsBoolExp = {
  _and?: InputMaybe<Array<EventTransactionsBoolExp>>;
  _not?: InputMaybe<EventTransactionsBoolExp>;
  _or?: InputMaybe<Array<EventTransactionsBoolExp>>;
  applicationFeeTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customer?: InputMaybe<UsersBoolExp>;
  customerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  customerProfile?: InputMaybe<UserProfilesBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  externalStripePaymentIntentId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalStripePaymentIntentId?: InputMaybe<UuidComparisonExp>;
  orderSubtotalUnitAmount?: InputMaybe<IntComparisonExp>;
  orderTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  paidUnitAmount?: InputMaybe<IntComparisonExp>;
  paymentMethodUsed?: InputMaybe<UserCreditCardsBoolExp>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  seller?: InputMaybe<UsersBoolExp>;
  sellerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  sellerProfile?: InputMaybe<UserProfilesBoolExp>;
  sellerUserId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripeMerchantId?: InputMaybe<StringComparisonExp>;
  stripePaymentStatus?: InputMaybe<StringComparisonExp>;
  transactionItems?: InputMaybe<EventTransactionItemsBoolExp>;
  transferUnitAmount?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCreditCardId?: InputMaybe<UuidComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "event_transactions" */
export type EventTransactionsMaxOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_transactions" */
export type EventTransactionsMinOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_transactions". */
export type EventTransactionsOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customer?: InputMaybe<UsersOrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProfile?: InputMaybe<UserProfilesOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  paymentMethodUsed?: InputMaybe<UserCreditCardsOrderBy>;
  paymentProcessor?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  seller?: InputMaybe<UsersOrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProfile?: InputMaybe<UserProfilesOrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  transactionItemsAggregate?: InputMaybe<EventTransactionItemsAggregateOrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "event_transactions" */
export enum EventTransactionsSelectColumn {
  /** column name */
  ApplicationFeeTotalUnitAmount = 'applicationFeeTotalUnitAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerApplicationFeeUnitAmount = 'customerApplicationFeeUnitAmount',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  SellerApplicationFeeUnitAmount = 'sellerApplicationFeeUnitAmount',
  /** column name */
  SellerUserId = 'sellerUserId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  TransferUnitAmount = 'transferUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId',
  /** column name */
  UserId = 'userId'
}

/** order by stddev() on columns of table "event_transactions" */
export type EventTransactionsStddevOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "event_transactions" */
export type EventTransactionsStddevPopOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "event_transactions" */
export type EventTransactionsStddevSampOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_transactions" */
export type EventTransactionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTransactionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTransactionsStreamCursorValueInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "event_transactions" */
export type EventTransactionsSumOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "event_transactions" */
export type EventTransactionsVarPopOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "event_transactions" */
export type EventTransactionsVarSampOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_transactions" */
export type EventTransactionsVarianceOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_types" */
export type EventTypes = {
  __typename?: 'EventTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "event_types". All fields are combined with a logical 'AND'. */
export type EventTypesBoolExp = {
  _and?: InputMaybe<Array<EventTypesBoolExp>>;
  _not?: InputMaybe<EventTypesBoolExp>;
  _or?: InputMaybe<Array<EventTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum EventTypesEnum {
  GeneralEvent = 'GENERAL_EVENT',
  League = 'LEAGUE',
  OpenPlay = 'OPEN_PLAY',
  Social = 'SOCIAL',
  Tournament = 'TOURNAMENT'
}

/** Boolean expression to compare columns of type "EventTypesEnum". All fields are combined with logical 'AND'. */
export type EventTypesEnumComparisonExp = {
  _eq?: InputMaybe<EventTypesEnum>;
  _in?: InputMaybe<Array<EventTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<EventTypesEnum>;
  _nin?: InputMaybe<Array<EventTypesEnum>>;
};

/** Ordering options when selecting data from "event_types". */
export type EventTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "event_types" */
export enum EventTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "event_types" */
export type EventTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "events" */
export type Events = {
  __typename?: 'Events';
  /** An array relationship */
  acceptedPlayRequests: Array<EventAcceptedPlayRequests>;
  /** An aggregate relationship */
  acceptedPlayRequestsAggregate: EventAcceptedPlayRequestsAggregate;
  addressString?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  ballCustomName: Scalars['String'];
  ballType: BallTypesEnum;
  cancelReason: Scalars['String'];
  canceledAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  city?: Maybe<Cities>;
  cityId?: Maybe<Scalars['uuid']>;
  cityString: Scalars['String'];
  /** An object relationship */
  community?: Maybe<Groups>;
  communityGroupId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  contactDetails?: Maybe<EventContactDetails>;
  /** An array relationship */
  conversations: Array<Conversations>;
  countryString: Scalars['String'];
  /** An array relationship */
  coupons: Array<EventCoupons>;
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Int']>;
  /** An array relationship */
  courts: Array<EventCourts>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImageFileType?: Maybe<Scalars['String']>;
  coverImageHost?: Maybe<Scalars['String']>;
  coverImageOriginalFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  /** Fallback for when we don't have a city_id */
  displayLocation: Scalars['String'];
  endDate: Scalars['date'];
  endDateTime: Scalars['timestamptz'];
  /** An object relationship */
  eventCollection?: Maybe<EventCollections>;
  eventCollectionId?: Maybe<Scalars['uuid']>;
  externalUrl?: Maybe<Scalars['String']>;
  /** An array relationship */
  faqs: Array<EventFaqs>;
  geometry?: Maybe<Scalars['geography']>;
  groupFormat?: Maybe<EventGroupFormatsEnum>;
  /** An array relationship */
  groups: Array<EventGroups>;
  hasPrizes: Scalars['Boolean'];
  /** An object relationship */
  hostUser?: Maybe<Users>;
  hostUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  hostUserProfile?: Maybe<UserProfiles>;
  id: Scalars['uuid'];
  intendedAgeGroup?: Maybe<EventAgeGroupsEnum>;
  /** An array relationship */
  invitations: Array<EventInvitations>;
  isCourtBooked?: Maybe<Scalars['Boolean']>;
  isExternal: Scalars['Boolean'];
  isPlayerListed: Scalars['Boolean'];
  isQuickCreate: Scalars['Boolean'];
  isRatingRequired: Scalars['Boolean'];
  isRegisterOffPlatform: Scalars['Boolean'];
  isRfx: Scalars['Boolean'];
  isSanctioned: Scalars['Boolean'];
  isShowCourtAssignments: Scalars['Boolean'];
  isShowPlayersGoing: Scalars['Boolean'];
  isVairRequired?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  listingFees: Array<EventListingFees>;
  locale: Scalars['String'];
  longitude?: Maybe<Scalars['numeric']>;
  numberOfCourts?: Maybe<Scalars['numeric']>;
  organizerImageFileName?: Maybe<Scalars['String']>;
  organizerImageFileType?: Maybe<Scalars['String']>;
  organizerImageHost?: Maybe<Scalars['String']>;
  organizerImageOriginalFileName?: Maybe<Scalars['String']>;
  organizerImagePath?: Maybe<Scalars['String']>;
  organizerImageProvider?: Maybe<Scalars['String']>;
  organizerImageProviderUrl?: Maybe<Scalars['String']>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: Maybe<Scalars['String']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum;
  /** An object relationship */
  pickleballRatingScale?: Maybe<PickleballRatingScales>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  playRequests: Array<PlayRequests>;
  privacy: EventPrivacyEnum;
  prizeDescription: Scalars['String'];
  publishedAt?: Maybe<Scalars['timestamptz']>;
  regionString: Scalars['String'];
  registrationClosedAt?: Maybe<Scalars['timestamptz']>;
  registrationDeadlineDate: Scalars['date'];
  registrationDeadlineDateTime?: Maybe<Scalars['timestamptz']>;
  registrationOpenDate?: Maybe<Scalars['date']>;
  registrationOpenDateTime?: Maybe<Scalars['timestamptz']>;
  registrationPriceUnitAmount: Scalars['Int'];
  /** An array relationship */
  registrations: Array<EventRegistrations>;
  /** An aggregate relationship */
  registrationsAggregate: EventRegistrationsAggregate;
  scheduleInfo?: Maybe<Scalars['String']>;
  scoringFormat?: Maybe<ScoringFormatEnum>;
  showInPublicDate?: Maybe<Scalars['date']>;
  showInPublicDateTime?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  skillLevels: Array<EventSkillLevels>;
  slug: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  sourceOrganizerTitle?: Maybe<Scalars['String']>;
  sourceRegistrationCount: Scalars['Int'];
  /** An array relationship */
  sponsors: Array<EventSponsors>;
  sport: SportsEnum;
  startDate: Scalars['date'];
  startDateTime: Scalars['timestamptz'];
  status: EventStatusesEnum;
  streetPrimaryString: Scalars['String'];
  streetSecondaryString: Scalars['String'];
  /** An object relationship */
  tennisRatingScale?: Maybe<TennisRatingScales>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
  title: Scalars['String'];
  /** An array relationship */
  transactions: Array<EventTransactions>;
  type: EventTypesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue?: Maybe<Venues>;
  venueId?: Maybe<Scalars['uuid']>;
  zipcodeString: Scalars['String'];
};


/** columns and relationships of "events" */
export type EventsAcceptedPlayRequestsArgs = {
  distinctOn?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAcceptedPlayRequestsOrderBy>>;
  where?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsAcceptedPlayRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAcceptedPlayRequestsOrderBy>>;
  where?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsConversationsArgs = {
  distinctOn?: InputMaybe<Array<ConversationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
  where?: InputMaybe<ConversationsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsCouponsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponsOrderBy>>;
  where?: InputMaybe<EventCouponsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsCourtsArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsFaqsArgs = {
  distinctOn?: InputMaybe<Array<EventFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventFaqsOrderBy>>;
  where?: InputMaybe<EventFaqsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupsOrderBy>>;
  where?: InputMaybe<EventGroupsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsInvitationsArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationsOrderBy>>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsListingFeesArgs = {
  distinctOn?: InputMaybe<Array<EventListingFeesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventListingFeesOrderBy>>;
  where?: InputMaybe<EventListingFeesBoolExp>;
};


/** columns and relationships of "events" */
export type EventsPlayRequestsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestsOrderBy>>;
  where?: InputMaybe<PlayRequestsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsRegistrationsArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationsOrderBy>>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsRegistrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationsOrderBy>>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<EventSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSkillLevelsOrderBy>>;
  where?: InputMaybe<EventSkillLevelsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsSponsorsArgs = {
  distinctOn?: InputMaybe<Array<EventSponsorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSponsorsOrderBy>>;
  where?: InputMaybe<EventSponsorsBoolExp>;
};


/** columns and relationships of "events" */
export type EventsTransactionsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionsOrderBy>>;
  where?: InputMaybe<EventTransactionsBoolExp>;
};

/** aggregated selection of "events" */
export type EventsAggregate = {
  __typename?: 'EventsAggregate';
  aggregate?: Maybe<EventsAggregateFields>;
  nodes: Array<Events>;
};

export type EventsAggregateBoolExp = {
  bool_and?: InputMaybe<EventsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<EventsAggregateBoolExpBool_Or>;
  count?: InputMaybe<EventsAggregateBoolExpCount>;
};

/** aggregate fields of "events" */
export type EventsAggregateFields = {
  __typename?: 'EventsAggregateFields';
  avg?: Maybe<EventsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventsMaxFields>;
  min?: Maybe<EventsMinFields>;
  stddev?: Maybe<EventsStddevFields>;
  stddevPop?: Maybe<EventsStddevPopFields>;
  stddevSamp?: Maybe<EventsStddevSampFields>;
  sum?: Maybe<EventsSumFields>;
  varPop?: Maybe<EventsVarPopFields>;
  varSamp?: Maybe<EventsVarSampFields>;
  variance?: Maybe<EventsVarianceFields>;
};


/** aggregate fields of "events" */
export type EventsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "events" */
export type EventsAggregateOrderBy = {
  avg?: InputMaybe<EventsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventsMaxOrderBy>;
  min?: InputMaybe<EventsMinOrderBy>;
  stddev?: InputMaybe<EventsStddevOrderBy>;
  stddevPop?: InputMaybe<EventsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventsStddevSampOrderBy>;
  sum?: InputMaybe<EventsSumOrderBy>;
  varPop?: InputMaybe<EventsVarPopOrderBy>;
  varSamp?: InputMaybe<EventsVarSampOrderBy>;
  variance?: InputMaybe<EventsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "events" */
export type EventsArrRelInsertInput = {
  data: Array<EventsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventsOnConflict>;
};

/** aggregate avg on columns */
export type EventsAvgFields = {
  __typename?: 'EventsAvgFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  numberOfCourts?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Float']>;
  sourceRegistrationCount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "events" */
export type EventsAvgOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export type EventsBoolExp = {
  _and?: InputMaybe<Array<EventsBoolExp>>;
  _not?: InputMaybe<EventsBoolExp>;
  _or?: InputMaybe<Array<EventsBoolExp>>;
  acceptedPlayRequests?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
  acceptedPlayRequestsAggregate?: InputMaybe<EventAcceptedPlayRequestsAggregateBoolExp>;
  addressString?: InputMaybe<StringComparisonExp>;
  archivedAt?: InputMaybe<TimestamptzComparisonExp>;
  ballCustomName?: InputMaybe<StringComparisonExp>;
  ballType?: InputMaybe<BallTypesEnumComparisonExp>;
  cancelReason?: InputMaybe<StringComparisonExp>;
  canceledAt?: InputMaybe<TimestamptzComparisonExp>;
  city?: InputMaybe<CitiesBoolExp>;
  cityId?: InputMaybe<UuidComparisonExp>;
  cityString?: InputMaybe<StringComparisonExp>;
  community?: InputMaybe<GroupsBoolExp>;
  communityGroupId?: InputMaybe<UuidComparisonExp>;
  contactDetails?: InputMaybe<EventContactDetailsBoolExp>;
  conversations?: InputMaybe<ConversationsBoolExp>;
  countryString?: InputMaybe<StringComparisonExp>;
  coupons?: InputMaybe<EventCouponsBoolExp>;
  courtCostPerPlayerUnitAmount?: InputMaybe<IntComparisonExp>;
  courts?: InputMaybe<EventCourtsBoolExp>;
  coverImageFileName?: InputMaybe<StringComparisonExp>;
  coverImageFileType?: InputMaybe<StringComparisonExp>;
  coverImageHost?: InputMaybe<StringComparisonExp>;
  coverImageOriginalFileName?: InputMaybe<StringComparisonExp>;
  coverImagePath?: InputMaybe<StringComparisonExp>;
  coverImageProvider?: InputMaybe<StringComparisonExp>;
  coverImageProviderUrl?: InputMaybe<StringComparisonExp>;
  coverImageUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  displayLocation?: InputMaybe<StringComparisonExp>;
  endDate?: InputMaybe<DateComparisonExp>;
  endDateTime?: InputMaybe<TimestamptzComparisonExp>;
  eventCollection?: InputMaybe<EventCollectionsBoolExp>;
  eventCollectionId?: InputMaybe<UuidComparisonExp>;
  externalUrl?: InputMaybe<StringComparisonExp>;
  faqs?: InputMaybe<EventFaqsBoolExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  groupFormat?: InputMaybe<EventGroupFormatsEnumComparisonExp>;
  groups?: InputMaybe<EventGroupsBoolExp>;
  hasPrizes?: InputMaybe<BooleanComparisonExp>;
  hostUser?: InputMaybe<UsersBoolExp>;
  hostUserId?: InputMaybe<UuidComparisonExp>;
  hostUserProfile?: InputMaybe<UserProfilesBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnumComparisonExp>;
  invitations?: InputMaybe<EventInvitationsBoolExp>;
  isCourtBooked?: InputMaybe<BooleanComparisonExp>;
  isExternal?: InputMaybe<BooleanComparisonExp>;
  isPlayerListed?: InputMaybe<BooleanComparisonExp>;
  isQuickCreate?: InputMaybe<BooleanComparisonExp>;
  isRatingRequired?: InputMaybe<BooleanComparisonExp>;
  isRegisterOffPlatform?: InputMaybe<BooleanComparisonExp>;
  isRfx?: InputMaybe<BooleanComparisonExp>;
  isSanctioned?: InputMaybe<BooleanComparisonExp>;
  isShowCourtAssignments?: InputMaybe<BooleanComparisonExp>;
  isShowPlayersGoing?: InputMaybe<BooleanComparisonExp>;
  isVairRequired?: InputMaybe<BooleanComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  listingFees?: InputMaybe<EventListingFeesBoolExp>;
  locale?: InputMaybe<StringComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  numberOfCourts?: InputMaybe<NumericComparisonExp>;
  organizerImageFileName?: InputMaybe<StringComparisonExp>;
  organizerImageFileType?: InputMaybe<StringComparisonExp>;
  organizerImageHost?: InputMaybe<StringComparisonExp>;
  organizerImageOriginalFileName?: InputMaybe<StringComparisonExp>;
  organizerImagePath?: InputMaybe<StringComparisonExp>;
  organizerImageProvider?: InputMaybe<StringComparisonExp>;
  organizerImageProviderUrl?: InputMaybe<StringComparisonExp>;
  organizerImageUrl?: InputMaybe<StringComparisonExp>;
  padelRatingScaleId?: InputMaybe<UuidComparisonExp>;
  participantLimit?: InputMaybe<IntComparisonExp>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnumComparisonExp>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesBoolExp>;
  pickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  playRequests?: InputMaybe<PlayRequestsBoolExp>;
  privacy?: InputMaybe<EventPrivacyEnumComparisonExp>;
  prizeDescription?: InputMaybe<StringComparisonExp>;
  publishedAt?: InputMaybe<TimestamptzComparisonExp>;
  regionString?: InputMaybe<StringComparisonExp>;
  registrationClosedAt?: InputMaybe<TimestamptzComparisonExp>;
  registrationDeadlineDate?: InputMaybe<DateComparisonExp>;
  registrationDeadlineDateTime?: InputMaybe<TimestamptzComparisonExp>;
  registrationOpenDate?: InputMaybe<DateComparisonExp>;
  registrationOpenDateTime?: InputMaybe<TimestamptzComparisonExp>;
  registrationPriceUnitAmount?: InputMaybe<IntComparisonExp>;
  registrations?: InputMaybe<EventRegistrationsBoolExp>;
  registrationsAggregate?: InputMaybe<EventRegistrationsAggregateBoolExp>;
  scheduleInfo?: InputMaybe<StringComparisonExp>;
  scoringFormat?: InputMaybe<ScoringFormatEnumComparisonExp>;
  showInPublicDate?: InputMaybe<DateComparisonExp>;
  showInPublicDateTime?: InputMaybe<TimestamptzComparisonExp>;
  skillLevels?: InputMaybe<EventSkillLevelsBoolExp>;
  slug?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  sourceOrganizerTitle?: InputMaybe<StringComparisonExp>;
  sourceRegistrationCount?: InputMaybe<IntComparisonExp>;
  sponsors?: InputMaybe<EventSponsorsBoolExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  startDate?: InputMaybe<DateComparisonExp>;
  startDateTime?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<EventStatusesEnumComparisonExp>;
  streetPrimaryString?: InputMaybe<StringComparisonExp>;
  streetSecondaryString?: InputMaybe<StringComparisonExp>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  timezoneAbbreviation?: InputMaybe<StringComparisonExp>;
  timezoneName?: InputMaybe<StringComparisonExp>;
  timezoneOffsetMinutes?: InputMaybe<IntComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  transactions?: InputMaybe<EventTransactionsBoolExp>;
  type?: InputMaybe<EventTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
  zipcodeString?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "events" */
export enum EventsConstraint {
  /** unique or primary key constraint on columns "id" */
  EventsPkey = 'events_pkey',
  /** unique or primary key constraint on columns "slug" */
  EventsSlugKey = 'events_slug_key',
  /** unique or primary key constraint on columns "source_id" */
  EventsSourceIdKey = 'events_source_id_key'
}

/** input type for incrementing numeric columns in table "events" */
export type EventsIncInput = {
  courtCostPerPlayerUnitAmount?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  numberOfCourts?: InputMaybe<Scalars['numeric']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  registrationPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "events" */
export type EventsInsertInput = {
  addressString?: InputMaybe<Scalars['String']>;
  ballCustomName?: InputMaybe<Scalars['String']>;
  ballType?: InputMaybe<BallTypesEnum>;
  cityId?: InputMaybe<Scalars['uuid']>;
  cityString?: InputMaybe<Scalars['String']>;
  communityGroupId?: InputMaybe<Scalars['uuid']>;
  countryString?: InputMaybe<Scalars['String']>;
  courtCostPerPlayerUnitAmount?: InputMaybe<Scalars['Int']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImageFileType?: InputMaybe<Scalars['String']>;
  coverImageHost?: InputMaybe<Scalars['String']>;
  coverImageOriginalFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  /** Fallback for when we don't have a city_id */
  displayLocation?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['date']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  eventCollection?: InputMaybe<EventCollectionsObjRelInsertInput>;
  eventCollectionId?: InputMaybe<Scalars['uuid']>;
  externalUrl?: InputMaybe<Scalars['String']>;
  faqs?: InputMaybe<EventFaqsArrRelInsertInput>;
  geometry?: InputMaybe<Scalars['geography']>;
  groupFormat?: InputMaybe<EventGroupFormatsEnum>;
  groups?: InputMaybe<EventGroupsArrRelInsertInput>;
  hasPrizes?: InputMaybe<Scalars['Boolean']>;
  hostUserId?: InputMaybe<Scalars['uuid']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  invitations?: InputMaybe<EventInvitationsArrRelInsertInput>;
  isCourtBooked?: InputMaybe<Scalars['Boolean']>;
  isExternal?: InputMaybe<Scalars['Boolean']>;
  isPlayerListed?: InputMaybe<Scalars['Boolean']>;
  isQuickCreate?: InputMaybe<Scalars['Boolean']>;
  isRatingRequired?: InputMaybe<Scalars['Boolean']>;
  isRegisterOffPlatform?: InputMaybe<Scalars['Boolean']>;
  isRfx?: InputMaybe<Scalars['Boolean']>;
  isSanctioned?: InputMaybe<Scalars['Boolean']>;
  isShowCourtAssignments?: InputMaybe<Scalars['Boolean']>;
  isShowPlayersGoing?: InputMaybe<Scalars['Boolean']>;
  isVairRequired?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  locale?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  numberOfCourts?: InputMaybe<Scalars['numeric']>;
  organizerImageFileName?: InputMaybe<Scalars['String']>;
  organizerImageFileType?: InputMaybe<Scalars['String']>;
  organizerImageHost?: InputMaybe<Scalars['String']>;
  organizerImageOriginalFileName?: InputMaybe<Scalars['String']>;
  organizerImagePath?: InputMaybe<Scalars['String']>;
  organizerImageProvider?: InputMaybe<Scalars['String']>;
  organizerImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: InputMaybe<Scalars['String']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  privacy?: InputMaybe<EventPrivacyEnum>;
  prizeDescription?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  registrationDeadlineDate?: InputMaybe<Scalars['date']>;
  registrationDeadlineDateTime?: InputMaybe<Scalars['timestamptz']>;
  registrationOpenDate?: InputMaybe<Scalars['date']>;
  registrationOpenDateTime?: InputMaybe<Scalars['timestamptz']>;
  registrationPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  scheduleInfo?: InputMaybe<Scalars['String']>;
  showInPublicDate?: InputMaybe<Scalars['date']>;
  showInPublicDateTime?: InputMaybe<Scalars['timestamptz']>;
  skillLevels?: InputMaybe<EventSkillLevelsArrRelInsertInput>;
  slug?: InputMaybe<Scalars['String']>;
  sourceRegistrationCount?: InputMaybe<Scalars['Int']>;
  sponsors?: InputMaybe<EventSponsorsArrRelInsertInput>;
  sport?: InputMaybe<SportsEnum>;
  startDate?: InputMaybe<Scalars['date']>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<EventStatusesEnum>;
  streetPrimaryString?: InputMaybe<Scalars['String']>;
  streetSecondaryString?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EventTypesEnum>;
  venueId?: InputMaybe<Scalars['uuid']>;
  zipcodeString?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventsMaxFields = {
  __typename?: 'EventsMaxFields';
  addressString?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  ballCustomName?: Maybe<Scalars['String']>;
  cancelReason?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  cityId?: Maybe<Scalars['uuid']>;
  cityString?: Maybe<Scalars['String']>;
  communityGroupId?: Maybe<Scalars['uuid']>;
  countryString?: Maybe<Scalars['String']>;
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Int']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImageFileType?: Maybe<Scalars['String']>;
  coverImageHost?: Maybe<Scalars['String']>;
  coverImageOriginalFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** Fallback for when we don't have a city_id */
  displayLocation?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['date']>;
  endDateTime?: Maybe<Scalars['timestamptz']>;
  eventCollectionId?: Maybe<Scalars['uuid']>;
  externalUrl?: Maybe<Scalars['String']>;
  hostUserId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['numeric']>;
  locale?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  numberOfCourts?: Maybe<Scalars['numeric']>;
  organizerImageFileName?: Maybe<Scalars['String']>;
  organizerImageFileType?: Maybe<Scalars['String']>;
  organizerImageHost?: Maybe<Scalars['String']>;
  organizerImageOriginalFileName?: Maybe<Scalars['String']>;
  organizerImagePath?: Maybe<Scalars['String']>;
  organizerImageProvider?: Maybe<Scalars['String']>;
  organizerImageProviderUrl?: Maybe<Scalars['String']>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: Maybe<Scalars['String']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  prizeDescription?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  regionString?: Maybe<Scalars['String']>;
  registrationClosedAt?: Maybe<Scalars['timestamptz']>;
  registrationDeadlineDate?: Maybe<Scalars['date']>;
  registrationDeadlineDateTime?: Maybe<Scalars['timestamptz']>;
  registrationOpenDate?: Maybe<Scalars['date']>;
  registrationOpenDateTime?: Maybe<Scalars['timestamptz']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Int']>;
  scheduleInfo?: Maybe<Scalars['String']>;
  showInPublicDate?: Maybe<Scalars['date']>;
  showInPublicDateTime?: Maybe<Scalars['timestamptz']>;
  slug?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceOrganizerTitle?: Maybe<Scalars['String']>;
  sourceRegistrationCount?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['date']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  streetPrimaryString?: Maybe<Scalars['String']>;
  streetSecondaryString?: Maybe<Scalars['String']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
  zipcodeString?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "events" */
export type EventsMaxOrderBy = {
  addressString?: InputMaybe<OrderBy>;
  archivedAt?: InputMaybe<OrderBy>;
  ballCustomName?: InputMaybe<OrderBy>;
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  cityString?: InputMaybe<OrderBy>;
  communityGroupId?: InputMaybe<OrderBy>;
  countryString?: InputMaybe<OrderBy>;
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImageFileType?: InputMaybe<OrderBy>;
  coverImageHost?: InputMaybe<OrderBy>;
  coverImageOriginalFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  /** Fallback for when we don't have a city_id */
  displayLocation?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  eventCollectionId?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  hostUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  organizerImageFileName?: InputMaybe<OrderBy>;
  organizerImageFileType?: InputMaybe<OrderBy>;
  organizerImageHost?: InputMaybe<OrderBy>;
  organizerImageOriginalFileName?: InputMaybe<OrderBy>;
  organizerImagePath?: InputMaybe<OrderBy>;
  organizerImageProvider?: InputMaybe<OrderBy>;
  organizerImageProviderUrl?: InputMaybe<OrderBy>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  prizeDescription?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  regionString?: InputMaybe<OrderBy>;
  registrationClosedAt?: InputMaybe<OrderBy>;
  registrationDeadlineDate?: InputMaybe<OrderBy>;
  registrationDeadlineDateTime?: InputMaybe<OrderBy>;
  registrationOpenDate?: InputMaybe<OrderBy>;
  registrationOpenDateTime?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  scheduleInfo?: InputMaybe<OrderBy>;
  showInPublicDate?: InputMaybe<OrderBy>;
  showInPublicDateTime?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceOrganizerTitle?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  streetPrimaryString?: InputMaybe<OrderBy>;
  streetSecondaryString?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
  zipcodeString?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventsMinFields = {
  __typename?: 'EventsMinFields';
  addressString?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  ballCustomName?: Maybe<Scalars['String']>;
  cancelReason?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  cityId?: Maybe<Scalars['uuid']>;
  cityString?: Maybe<Scalars['String']>;
  communityGroupId?: Maybe<Scalars['uuid']>;
  countryString?: Maybe<Scalars['String']>;
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Int']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImageFileType?: Maybe<Scalars['String']>;
  coverImageHost?: Maybe<Scalars['String']>;
  coverImageOriginalFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** Fallback for when we don't have a city_id */
  displayLocation?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['date']>;
  endDateTime?: Maybe<Scalars['timestamptz']>;
  eventCollectionId?: Maybe<Scalars['uuid']>;
  externalUrl?: Maybe<Scalars['String']>;
  hostUserId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['numeric']>;
  locale?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  numberOfCourts?: Maybe<Scalars['numeric']>;
  organizerImageFileName?: Maybe<Scalars['String']>;
  organizerImageFileType?: Maybe<Scalars['String']>;
  organizerImageHost?: Maybe<Scalars['String']>;
  organizerImageOriginalFileName?: Maybe<Scalars['String']>;
  organizerImagePath?: Maybe<Scalars['String']>;
  organizerImageProvider?: Maybe<Scalars['String']>;
  organizerImageProviderUrl?: Maybe<Scalars['String']>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: Maybe<Scalars['String']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  prizeDescription?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  regionString?: Maybe<Scalars['String']>;
  registrationClosedAt?: Maybe<Scalars['timestamptz']>;
  registrationDeadlineDate?: Maybe<Scalars['date']>;
  registrationDeadlineDateTime?: Maybe<Scalars['timestamptz']>;
  registrationOpenDate?: Maybe<Scalars['date']>;
  registrationOpenDateTime?: Maybe<Scalars['timestamptz']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Int']>;
  scheduleInfo?: Maybe<Scalars['String']>;
  showInPublicDate?: Maybe<Scalars['date']>;
  showInPublicDateTime?: Maybe<Scalars['timestamptz']>;
  slug?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceOrganizerTitle?: Maybe<Scalars['String']>;
  sourceRegistrationCount?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['date']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  streetPrimaryString?: Maybe<Scalars['String']>;
  streetSecondaryString?: Maybe<Scalars['String']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
  zipcodeString?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "events" */
export type EventsMinOrderBy = {
  addressString?: InputMaybe<OrderBy>;
  archivedAt?: InputMaybe<OrderBy>;
  ballCustomName?: InputMaybe<OrderBy>;
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  cityString?: InputMaybe<OrderBy>;
  communityGroupId?: InputMaybe<OrderBy>;
  countryString?: InputMaybe<OrderBy>;
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImageFileType?: InputMaybe<OrderBy>;
  coverImageHost?: InputMaybe<OrderBy>;
  coverImageOriginalFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  /** Fallback for when we don't have a city_id */
  displayLocation?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  eventCollectionId?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  hostUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  organizerImageFileName?: InputMaybe<OrderBy>;
  organizerImageFileType?: InputMaybe<OrderBy>;
  organizerImageHost?: InputMaybe<OrderBy>;
  organizerImageOriginalFileName?: InputMaybe<OrderBy>;
  organizerImagePath?: InputMaybe<OrderBy>;
  organizerImageProvider?: InputMaybe<OrderBy>;
  organizerImageProviderUrl?: InputMaybe<OrderBy>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  prizeDescription?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  regionString?: InputMaybe<OrderBy>;
  registrationClosedAt?: InputMaybe<OrderBy>;
  registrationDeadlineDate?: InputMaybe<OrderBy>;
  registrationDeadlineDateTime?: InputMaybe<OrderBy>;
  registrationOpenDate?: InputMaybe<OrderBy>;
  registrationOpenDateTime?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  scheduleInfo?: InputMaybe<OrderBy>;
  showInPublicDate?: InputMaybe<OrderBy>;
  showInPublicDateTime?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceOrganizerTitle?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  streetPrimaryString?: InputMaybe<OrderBy>;
  streetSecondaryString?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
  zipcodeString?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "events" */
export type EventsMutationResponse = {
  __typename?: 'EventsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Events>;
};

/** input type for inserting object relation for remote table "events" */
export type EventsObjRelInsertInput = {
  data: EventsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EventsOnConflict>;
};

/** on_conflict condition type for table "events" */
export type EventsOnConflict = {
  constraint: EventsConstraint;
  updateColumns?: Array<EventsUpdateColumn>;
  where?: InputMaybe<EventsBoolExp>;
};

/** Ordering options when selecting data from "events". */
export type EventsOrderBy = {
  acceptedPlayRequestsAggregate?: InputMaybe<EventAcceptedPlayRequestsAggregateOrderBy>;
  addressString?: InputMaybe<OrderBy>;
  archivedAt?: InputMaybe<OrderBy>;
  ballCustomName?: InputMaybe<OrderBy>;
  ballType?: InputMaybe<OrderBy>;
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  city?: InputMaybe<CitiesOrderBy>;
  cityId?: InputMaybe<OrderBy>;
  cityString?: InputMaybe<OrderBy>;
  community?: InputMaybe<GroupsOrderBy>;
  communityGroupId?: InputMaybe<OrderBy>;
  contactDetails?: InputMaybe<EventContactDetailsOrderBy>;
  conversationsAggregate?: InputMaybe<ConversationsAggregateOrderBy>;
  countryString?: InputMaybe<OrderBy>;
  couponsAggregate?: InputMaybe<EventCouponsAggregateOrderBy>;
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  courtsAggregate?: InputMaybe<EventCourtsAggregateOrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImageFileType?: InputMaybe<OrderBy>;
  coverImageHost?: InputMaybe<OrderBy>;
  coverImageOriginalFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  displayLocation?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  eventCollection?: InputMaybe<EventCollectionsOrderBy>;
  eventCollectionId?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  faqsAggregate?: InputMaybe<EventFaqsAggregateOrderBy>;
  geometry?: InputMaybe<OrderBy>;
  groupFormat?: InputMaybe<OrderBy>;
  groupsAggregate?: InputMaybe<EventGroupsAggregateOrderBy>;
  hasPrizes?: InputMaybe<OrderBy>;
  hostUser?: InputMaybe<UsersOrderBy>;
  hostUserId?: InputMaybe<OrderBy>;
  hostUserProfile?: InputMaybe<UserProfilesOrderBy>;
  id?: InputMaybe<OrderBy>;
  intendedAgeGroup?: InputMaybe<OrderBy>;
  invitationsAggregate?: InputMaybe<EventInvitationsAggregateOrderBy>;
  isCourtBooked?: InputMaybe<OrderBy>;
  isExternal?: InputMaybe<OrderBy>;
  isPlayerListed?: InputMaybe<OrderBy>;
  isQuickCreate?: InputMaybe<OrderBy>;
  isRatingRequired?: InputMaybe<OrderBy>;
  isRegisterOffPlatform?: InputMaybe<OrderBy>;
  isRfx?: InputMaybe<OrderBy>;
  isSanctioned?: InputMaybe<OrderBy>;
  isShowCourtAssignments?: InputMaybe<OrderBy>;
  isShowPlayersGoing?: InputMaybe<OrderBy>;
  isVairRequired?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  listingFeesAggregate?: InputMaybe<EventListingFeesAggregateOrderBy>;
  locale?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  organizerImageFileName?: InputMaybe<OrderBy>;
  organizerImageFileType?: InputMaybe<OrderBy>;
  organizerImageHost?: InputMaybe<OrderBy>;
  organizerImageOriginalFileName?: InputMaybe<OrderBy>;
  organizerImagePath?: InputMaybe<OrderBy>;
  organizerImageProvider?: InputMaybe<OrderBy>;
  organizerImageProviderUrl?: InputMaybe<OrderBy>;
  organizerImageUrl?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  paymentFulfillmentChannel?: InputMaybe<OrderBy>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesOrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  playRequestsAggregate?: InputMaybe<PlayRequestsAggregateOrderBy>;
  privacy?: InputMaybe<OrderBy>;
  prizeDescription?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  regionString?: InputMaybe<OrderBy>;
  registrationClosedAt?: InputMaybe<OrderBy>;
  registrationDeadlineDate?: InputMaybe<OrderBy>;
  registrationDeadlineDateTime?: InputMaybe<OrderBy>;
  registrationOpenDate?: InputMaybe<OrderBy>;
  registrationOpenDateTime?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  registrationsAggregate?: InputMaybe<EventRegistrationsAggregateOrderBy>;
  scheduleInfo?: InputMaybe<OrderBy>;
  scoringFormat?: InputMaybe<OrderBy>;
  showInPublicDate?: InputMaybe<OrderBy>;
  showInPublicDateTime?: InputMaybe<OrderBy>;
  skillLevelsAggregate?: InputMaybe<EventSkillLevelsAggregateOrderBy>;
  slug?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceOrganizerTitle?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  sponsorsAggregate?: InputMaybe<EventSponsorsAggregateOrderBy>;
  sport?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  streetPrimaryString?: InputMaybe<OrderBy>;
  streetSecondaryString?: InputMaybe<OrderBy>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  transactionsAggregate?: InputMaybe<EventTransactionsAggregateOrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
  zipcodeString?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: events */
export type EventsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "events" */
export enum EventsSelectColumn {
  /** column name */
  AddressString = 'addressString',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BallCustomName = 'ballCustomName',
  /** column name */
  BallType = 'ballType',
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  CityId = 'cityId',
  /** column name */
  CityString = 'cityString',
  /** column name */
  CommunityGroupId = 'communityGroupId',
  /** column name */
  CountryString = 'countryString',
  /** column name */
  CourtCostPerPlayerUnitAmount = 'courtCostPerPlayerUnitAmount',
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImageFileType = 'coverImageFileType',
  /** column name */
  CoverImageHost = 'coverImageHost',
  /** column name */
  CoverImageOriginalFileName = 'coverImageOriginalFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayLocation = 'displayLocation',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  EventCollectionId = 'eventCollectionId',
  /** column name */
  ExternalUrl = 'externalUrl',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  GroupFormat = 'groupFormat',
  /** column name */
  HasPrizes = 'hasPrizes',
  /** column name */
  HostUserId = 'hostUserId',
  /** column name */
  Id = 'id',
  /** column name */
  IntendedAgeGroup = 'intendedAgeGroup',
  /** column name */
  IsCourtBooked = 'isCourtBooked',
  /** column name */
  IsExternal = 'isExternal',
  /** column name */
  IsPlayerListed = 'isPlayerListed',
  /** column name */
  IsQuickCreate = 'isQuickCreate',
  /** column name */
  IsRatingRequired = 'isRatingRequired',
  /** column name */
  IsRegisterOffPlatform = 'isRegisterOffPlatform',
  /** column name */
  IsRfx = 'isRfx',
  /** column name */
  IsSanctioned = 'isSanctioned',
  /** column name */
  IsShowCourtAssignments = 'isShowCourtAssignments',
  /** column name */
  IsShowPlayersGoing = 'isShowPlayersGoing',
  /** column name */
  IsVairRequired = 'isVairRequired',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Locale = 'locale',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  NumberOfCourts = 'numberOfCourts',
  /** column name */
  OrganizerImageFileName = 'organizerImageFileName',
  /** column name */
  OrganizerImageFileType = 'organizerImageFileType',
  /** column name */
  OrganizerImageHost = 'organizerImageHost',
  /** column name */
  OrganizerImageOriginalFileName = 'organizerImageOriginalFileName',
  /** column name */
  OrganizerImagePath = 'organizerImagePath',
  /** column name */
  OrganizerImageProvider = 'organizerImageProvider',
  /** column name */
  OrganizerImageProviderUrl = 'organizerImageProviderUrl',
  /** column name */
  OrganizerImageUrl = 'organizerImageUrl',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  PrizeDescription = 'prizeDescription',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RegionString = 'regionString',
  /** column name */
  RegistrationClosedAt = 'registrationClosedAt',
  /** column name */
  RegistrationDeadlineDate = 'registrationDeadlineDate',
  /** column name */
  RegistrationDeadlineDateTime = 'registrationDeadlineDateTime',
  /** column name */
  RegistrationOpenDate = 'registrationOpenDate',
  /** column name */
  RegistrationOpenDateTime = 'registrationOpenDateTime',
  /** column name */
  RegistrationPriceUnitAmount = 'registrationPriceUnitAmount',
  /** column name */
  ScheduleInfo = 'scheduleInfo',
  /** column name */
  ScoringFormat = 'scoringFormat',
  /** column name */
  ShowInPublicDate = 'showInPublicDate',
  /** column name */
  ShowInPublicDateTime = 'showInPublicDateTime',
  /** column name */
  Slug = 'slug',
  /** column name */
  Source = 'source',
  /** column name */
  SourceOrganizerTitle = 'sourceOrganizerTitle',
  /** column name */
  SourceRegistrationCount = 'sourceRegistrationCount',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  Status = 'status',
  /** column name */
  StreetPrimaryString = 'streetPrimaryString',
  /** column name */
  StreetSecondaryString = 'streetSecondaryString',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  ZipcodeString = 'zipcodeString'
}

/** select "eventsAggregateBoolExpBool_andArgumentsColumns" columns of table "events" */
export enum EventsSelectColumnEventsAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  HasPrizes = 'hasPrizes',
  /** column name */
  IsCourtBooked = 'isCourtBooked',
  /** column name */
  IsExternal = 'isExternal',
  /** column name */
  IsPlayerListed = 'isPlayerListed',
  /** column name */
  IsQuickCreate = 'isQuickCreate',
  /** column name */
  IsRatingRequired = 'isRatingRequired',
  /** column name */
  IsRegisterOffPlatform = 'isRegisterOffPlatform',
  /** column name */
  IsRfx = 'isRfx',
  /** column name */
  IsSanctioned = 'isSanctioned',
  /** column name */
  IsShowCourtAssignments = 'isShowCourtAssignments',
  /** column name */
  IsShowPlayersGoing = 'isShowPlayersGoing',
  /** column name */
  IsVairRequired = 'isVairRequired'
}

/** select "eventsAggregateBoolExpBool_orArgumentsColumns" columns of table "events" */
export enum EventsSelectColumnEventsAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  HasPrizes = 'hasPrizes',
  /** column name */
  IsCourtBooked = 'isCourtBooked',
  /** column name */
  IsExternal = 'isExternal',
  /** column name */
  IsPlayerListed = 'isPlayerListed',
  /** column name */
  IsQuickCreate = 'isQuickCreate',
  /** column name */
  IsRatingRequired = 'isRatingRequired',
  /** column name */
  IsRegisterOffPlatform = 'isRegisterOffPlatform',
  /** column name */
  IsRfx = 'isRfx',
  /** column name */
  IsSanctioned = 'isSanctioned',
  /** column name */
  IsShowCourtAssignments = 'isShowCourtAssignments',
  /** column name */
  IsShowPlayersGoing = 'isShowPlayersGoing',
  /** column name */
  IsVairRequired = 'isVairRequired'
}

/** input type for updating data in table "events" */
export type EventsSetInput = {
  addressString?: InputMaybe<Scalars['String']>;
  ballCustomName?: InputMaybe<Scalars['String']>;
  ballType?: InputMaybe<BallTypesEnum>;
  cityId?: InputMaybe<Scalars['uuid']>;
  cityString?: InputMaybe<Scalars['String']>;
  communityGroupId?: InputMaybe<Scalars['uuid']>;
  countryString?: InputMaybe<Scalars['String']>;
  courtCostPerPlayerUnitAmount?: InputMaybe<Scalars['Int']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImageFileType?: InputMaybe<Scalars['String']>;
  coverImageHost?: InputMaybe<Scalars['String']>;
  coverImageOriginalFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  /** Fallback for when we don't have a city_id */
  displayLocation?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['date']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  eventCollectionId?: InputMaybe<Scalars['uuid']>;
  externalUrl?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  groupFormat?: InputMaybe<EventGroupFormatsEnum>;
  hasPrizes?: InputMaybe<Scalars['Boolean']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  isCourtBooked?: InputMaybe<Scalars['Boolean']>;
  isPlayerListed?: InputMaybe<Scalars['Boolean']>;
  isRatingRequired?: InputMaybe<Scalars['Boolean']>;
  isRegisterOffPlatform?: InputMaybe<Scalars['Boolean']>;
  isRfx?: InputMaybe<Scalars['Boolean']>;
  isSanctioned?: InputMaybe<Scalars['Boolean']>;
  isShowCourtAssignments?: InputMaybe<Scalars['Boolean']>;
  isShowPlayersGoing?: InputMaybe<Scalars['Boolean']>;
  isVairRequired?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  locale?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  numberOfCourts?: InputMaybe<Scalars['numeric']>;
  organizerImageFileName?: InputMaybe<Scalars['String']>;
  organizerImageFileType?: InputMaybe<Scalars['String']>;
  organizerImageHost?: InputMaybe<Scalars['String']>;
  organizerImageOriginalFileName?: InputMaybe<Scalars['String']>;
  organizerImagePath?: InputMaybe<Scalars['String']>;
  organizerImageProvider?: InputMaybe<Scalars['String']>;
  organizerImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: InputMaybe<Scalars['String']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  privacy?: InputMaybe<EventPrivacyEnum>;
  prizeDescription?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  regionString?: InputMaybe<Scalars['String']>;
  registrationDeadlineDate?: InputMaybe<Scalars['date']>;
  registrationDeadlineDateTime?: InputMaybe<Scalars['timestamptz']>;
  registrationOpenDate?: InputMaybe<Scalars['date']>;
  registrationOpenDateTime?: InputMaybe<Scalars['timestamptz']>;
  registrationPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  scheduleInfo?: InputMaybe<Scalars['String']>;
  scoringFormat?: InputMaybe<ScoringFormatEnum>;
  sport?: InputMaybe<SportsEnum>;
  startDate?: InputMaybe<Scalars['date']>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  streetPrimaryString?: InputMaybe<Scalars['String']>;
  streetSecondaryString?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EventTypesEnum>;
  venueId?: InputMaybe<Scalars['uuid']>;
  zipcodeString?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type EventsStddevFields = {
  __typename?: 'EventsStddevFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  numberOfCourts?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Float']>;
  sourceRegistrationCount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "events" */
export type EventsStddevOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventsStddevPopFields = {
  __typename?: 'EventsStddevPopFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  numberOfCourts?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Float']>;
  sourceRegistrationCount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "events" */
export type EventsStddevPopOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventsStddevSampFields = {
  __typename?: 'EventsStddevSampFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  numberOfCourts?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Float']>;
  sourceRegistrationCount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "events" */
export type EventsStddevSampOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "events" */
export type EventsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventsStreamCursorValueInput = {
  addressString?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  ballCustomName?: InputMaybe<Scalars['String']>;
  ballType?: InputMaybe<BallTypesEnum>;
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  cityString?: InputMaybe<Scalars['String']>;
  communityGroupId?: InputMaybe<Scalars['uuid']>;
  countryString?: InputMaybe<Scalars['String']>;
  courtCostPerPlayerUnitAmount?: InputMaybe<Scalars['Int']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImageFileType?: InputMaybe<Scalars['String']>;
  coverImageHost?: InputMaybe<Scalars['String']>;
  coverImageOriginalFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  /** Fallback for when we don't have a city_id */
  displayLocation?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['date']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  eventCollectionId?: InputMaybe<Scalars['uuid']>;
  externalUrl?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  groupFormat?: InputMaybe<EventGroupFormatsEnum>;
  hasPrizes?: InputMaybe<Scalars['Boolean']>;
  hostUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  isCourtBooked?: InputMaybe<Scalars['Boolean']>;
  isExternal?: InputMaybe<Scalars['Boolean']>;
  isPlayerListed?: InputMaybe<Scalars['Boolean']>;
  isQuickCreate?: InputMaybe<Scalars['Boolean']>;
  isRatingRequired?: InputMaybe<Scalars['Boolean']>;
  isRegisterOffPlatform?: InputMaybe<Scalars['Boolean']>;
  isRfx?: InputMaybe<Scalars['Boolean']>;
  isSanctioned?: InputMaybe<Scalars['Boolean']>;
  isShowCourtAssignments?: InputMaybe<Scalars['Boolean']>;
  isShowPlayersGoing?: InputMaybe<Scalars['Boolean']>;
  isVairRequired?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  locale?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  numberOfCourts?: InputMaybe<Scalars['numeric']>;
  organizerImageFileName?: InputMaybe<Scalars['String']>;
  organizerImageFileType?: InputMaybe<Scalars['String']>;
  organizerImageHost?: InputMaybe<Scalars['String']>;
  organizerImageOriginalFileName?: InputMaybe<Scalars['String']>;
  organizerImagePath?: InputMaybe<Scalars['String']>;
  organizerImageProvider?: InputMaybe<Scalars['String']>;
  organizerImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** Note: Use this if it exists, otherwise check the organizer's profile to use their logo */
  organizerImageUrl?: InputMaybe<Scalars['String']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  privacy?: InputMaybe<EventPrivacyEnum>;
  prizeDescription?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  regionString?: InputMaybe<Scalars['String']>;
  registrationClosedAt?: InputMaybe<Scalars['timestamptz']>;
  registrationDeadlineDate?: InputMaybe<Scalars['date']>;
  registrationDeadlineDateTime?: InputMaybe<Scalars['timestamptz']>;
  registrationOpenDate?: InputMaybe<Scalars['date']>;
  registrationOpenDateTime?: InputMaybe<Scalars['timestamptz']>;
  registrationPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  scheduleInfo?: InputMaybe<Scalars['String']>;
  scoringFormat?: InputMaybe<ScoringFormatEnum>;
  showInPublicDate?: InputMaybe<Scalars['date']>;
  showInPublicDateTime?: InputMaybe<Scalars['timestamptz']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceOrganizerTitle?: InputMaybe<Scalars['String']>;
  sourceRegistrationCount?: InputMaybe<Scalars['Int']>;
  sport?: InputMaybe<SportsEnum>;
  startDate?: InputMaybe<Scalars['date']>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<EventStatusesEnum>;
  streetPrimaryString?: InputMaybe<Scalars['String']>;
  streetSecondaryString?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EventTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  zipcodeString?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type EventsSumFields = {
  __typename?: 'EventsSumFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  numberOfCourts?: Maybe<Scalars['numeric']>;
  participantLimit?: Maybe<Scalars['Int']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Int']>;
  sourceRegistrationCount?: Maybe<Scalars['Int']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "events" */
export type EventsSumOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** update columns of table "events" */
export enum EventsUpdateColumn {
  /** column name */
  AddressString = 'addressString',
  /** column name */
  BallCustomName = 'ballCustomName',
  /** column name */
  BallType = 'ballType',
  /** column name */
  CityId = 'cityId',
  /** column name */
  CityString = 'cityString',
  /** column name */
  CommunityGroupId = 'communityGroupId',
  /** column name */
  CountryString = 'countryString',
  /** column name */
  CourtCostPerPlayerUnitAmount = 'courtCostPerPlayerUnitAmount',
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImageFileType = 'coverImageFileType',
  /** column name */
  CoverImageHost = 'coverImageHost',
  /** column name */
  CoverImageOriginalFileName = 'coverImageOriginalFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayLocation = 'displayLocation',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  EventCollectionId = 'eventCollectionId',
  /** column name */
  ExternalUrl = 'externalUrl',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  GroupFormat = 'groupFormat',
  /** column name */
  HasPrizes = 'hasPrizes',
  /** column name */
  IntendedAgeGroup = 'intendedAgeGroup',
  /** column name */
  IsCourtBooked = 'isCourtBooked',
  /** column name */
  IsPlayerListed = 'isPlayerListed',
  /** column name */
  IsRatingRequired = 'isRatingRequired',
  /** column name */
  IsRegisterOffPlatform = 'isRegisterOffPlatform',
  /** column name */
  IsRfx = 'isRfx',
  /** column name */
  IsSanctioned = 'isSanctioned',
  /** column name */
  IsShowCourtAssignments = 'isShowCourtAssignments',
  /** column name */
  IsShowPlayersGoing = 'isShowPlayersGoing',
  /** column name */
  IsVairRequired = 'isVairRequired',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Locale = 'locale',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  NumberOfCourts = 'numberOfCourts',
  /** column name */
  OrganizerImageFileName = 'organizerImageFileName',
  /** column name */
  OrganizerImageFileType = 'organizerImageFileType',
  /** column name */
  OrganizerImageHost = 'organizerImageHost',
  /** column name */
  OrganizerImageOriginalFileName = 'organizerImageOriginalFileName',
  /** column name */
  OrganizerImagePath = 'organizerImagePath',
  /** column name */
  OrganizerImageProvider = 'organizerImageProvider',
  /** column name */
  OrganizerImageProviderUrl = 'organizerImageProviderUrl',
  /** column name */
  OrganizerImageUrl = 'organizerImageUrl',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  PrizeDescription = 'prizeDescription',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RegionString = 'regionString',
  /** column name */
  RegistrationDeadlineDate = 'registrationDeadlineDate',
  /** column name */
  RegistrationDeadlineDateTime = 'registrationDeadlineDateTime',
  /** column name */
  RegistrationOpenDate = 'registrationOpenDate',
  /** column name */
  RegistrationOpenDateTime = 'registrationOpenDateTime',
  /** column name */
  RegistrationPriceUnitAmount = 'registrationPriceUnitAmount',
  /** column name */
  ScheduleInfo = 'scheduleInfo',
  /** column name */
  ScoringFormat = 'scoringFormat',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  StreetPrimaryString = 'streetPrimaryString',
  /** column name */
  StreetSecondaryString = 'streetSecondaryString',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  ZipcodeString = 'zipcodeString'
}

export type EventsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventsSetInput>;
  /** filter the rows which have to be updated */
  where: EventsBoolExp;
};

/** aggregate varPop on columns */
export type EventsVarPopFields = {
  __typename?: 'EventsVarPopFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  numberOfCourts?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Float']>;
  sourceRegistrationCount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "events" */
export type EventsVarPopOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventsVarSampFields = {
  __typename?: 'EventsVarSampFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  numberOfCourts?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Float']>;
  sourceRegistrationCount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "events" */
export type EventsVarSampOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventsVarianceFields = {
  __typename?: 'EventsVarianceFields';
  courtCostPerPlayerUnitAmount?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  numberOfCourts?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  registrationPriceUnitAmount?: Maybe<Scalars['Float']>;
  sourceRegistrationCount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "events" */
export type EventsVarianceOrderBy = {
  courtCostPerPlayerUnitAmount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  numberOfCourts?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  registrationPriceUnitAmount?: InputMaybe<OrderBy>;
  sourceRegistrationCount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

export enum FeedbackSentimentEnum {
  Critical = 'CRITICAL',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

/** Boolean expression to compare columns of type "FeedbackSentimentEnum". All fields are combined with logical 'AND'. */
export type FeedbackSentimentEnumComparisonExp = {
  _eq?: InputMaybe<FeedbackSentimentEnum>;
  _in?: InputMaybe<Array<FeedbackSentimentEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<FeedbackSentimentEnum>;
  _nin?: InputMaybe<Array<FeedbackSentimentEnum>>;
};

/** columns and relationships of "file_category" */
export type FileCategory = {
  __typename?: 'FileCategory';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "file_category". All fields are combined with a logical 'AND'. */
export type FileCategoryBoolExp = {
  _and?: InputMaybe<Array<FileCategoryBoolExp>>;
  _not?: InputMaybe<FileCategoryBoolExp>;
  _or?: InputMaybe<Array<FileCategoryBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum FileCategoryEnum {
  Coach = 'COACH',
  Other = 'OTHER',
  PlayerGallery = 'PLAYER_GALLERY',
  Profile = 'PROFILE'
}

/** Boolean expression to compare columns of type "FileCategoryEnum". All fields are combined with logical 'AND'. */
export type FileCategoryEnumComparisonExp = {
  _eq?: InputMaybe<FileCategoryEnum>;
  _in?: InputMaybe<Array<FileCategoryEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<FileCategoryEnum>;
  _nin?: InputMaybe<Array<FileCategoryEnum>>;
};

/** Ordering options when selecting data from "file_category". */
export type FileCategoryOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "file_category" */
export enum FileCategorySelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "file_category" */
export type FileCategoryStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FileCategoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FileCategoryStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "file_format" */
export type FileFormat = {
  __typename?: 'FileFormat';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "file_format". All fields are combined with a logical 'AND'. */
export type FileFormatBoolExp = {
  _and?: InputMaybe<Array<FileFormatBoolExp>>;
  _not?: InputMaybe<FileFormatBoolExp>;
  _or?: InputMaybe<Array<FileFormatBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum FileFormatEnum {
  Audio = 'AUDIO',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

/** Boolean expression to compare columns of type "FileFormatEnum". All fields are combined with logical 'AND'. */
export type FileFormatEnumComparisonExp = {
  _eq?: InputMaybe<FileFormatEnum>;
  _in?: InputMaybe<Array<FileFormatEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<FileFormatEnum>;
  _nin?: InputMaybe<Array<FileFormatEnum>>;
};

/** Ordering options when selecting data from "file_format". */
export type FileFormatOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "file_format" */
export enum FileFormatSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "file_format" */
export type FileFormatStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FileFormatStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FileFormatStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export enum FollowStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "FollowStatusesEnum". All fields are combined with logical 'AND'. */
export type FollowStatusesEnumComparisonExp = {
  _eq?: InputMaybe<FollowStatusesEnum>;
  _in?: InputMaybe<Array<FollowStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<FollowStatusesEnum>;
  _nin?: InputMaybe<Array<FollowStatusesEnum>>;
};

/** columns and relationships of "game_net_statuses" */
export type GameNetStatuses = {
  __typename?: 'GameNetStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "game_net_statuses". All fields are combined with a logical 'AND'. */
export type GameNetStatusesBoolExp = {
  _and?: InputMaybe<Array<GameNetStatusesBoolExp>>;
  _not?: InputMaybe<GameNetStatusesBoolExp>;
  _or?: InputMaybe<Array<GameNetStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum GameNetStatusesEnum {
  /** The host is bringing a net */
  HostBrings = 'HOST_BRINGS',
  /** No net available */
  None = 'NONE',
  /** The venue provides a net */
  VenueProvided = 'VENUE_PROVIDED'
}

/** Boolean expression to compare columns of type "GameNetStatusesEnum". All fields are combined with logical 'AND'. */
export type GameNetStatusesEnumComparisonExp = {
  _eq?: InputMaybe<GameNetStatusesEnum>;
  _in?: InputMaybe<Array<GameNetStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<GameNetStatusesEnum>;
  _nin?: InputMaybe<Array<GameNetStatusesEnum>>;
};

/** Ordering options when selecting data from "game_net_statuses". */
export type GameNetStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "game_net_statuses" */
export enum GameNetStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "game_net_statuses" */
export type GameNetStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GameNetStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GameNetStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "gender" */
export type Gender = {
  __typename?: 'Gender';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "gender". All fields are combined with a logical 'AND'. */
export type GenderBoolExp = {
  _and?: InputMaybe<Array<GenderBoolExp>>;
  _not?: InputMaybe<GenderBoolExp>;
  _or?: InputMaybe<Array<GenderBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum GenderEnum {
  Female = 'FEMALE',
  Male = 'MALE',
  Nonbinary = 'NONBINARY',
  /** State your preference in a free text field */
  Preferred = 'PREFERRED',
  /** Choose not to disclose any gender */
  Private = 'PRIVATE'
}

/** Boolean expression to compare columns of type "GenderEnum". All fields are combined with logical 'AND'. */
export type GenderEnumComparisonExp = {
  _eq?: InputMaybe<GenderEnum>;
  _in?: InputMaybe<Array<GenderEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<GenderEnum>;
  _nin?: InputMaybe<Array<GenderEnum>>;
};

/** Ordering options when selecting data from "gender". */
export type GenderOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "gender" */
export enum GenderSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "gender" */
export type GenderStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GenderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GenderStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type GeographyCastExp = {
  geometry?: InputMaybe<GeometryComparisonExp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type GeographyComparisonExp = {
  _cast?: InputMaybe<GeographyCastExp>;
  _eq?: InputMaybe<Scalars['geography']>;
  _gt?: InputMaybe<Scalars['geography']>;
  _gte?: InputMaybe<Scalars['geography']>;
  _in?: InputMaybe<Array<Scalars['geography']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geography']>;
  _lte?: InputMaybe<Scalars['geography']>;
  _neq?: InputMaybe<Scalars['geography']>;
  _nin?: InputMaybe<Array<Scalars['geography']>>;
  /** is the column within a given distance from the given geography value */
  _stDWithin?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _stIntersects?: InputMaybe<Scalars['geography']>;
};

export type GeometryCastExp = {
  geography?: InputMaybe<GeographyComparisonExp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type GeometryComparisonExp = {
  _cast?: InputMaybe<GeometryCastExp>;
  _eq?: InputMaybe<Scalars['geometry']>;
  _gt?: InputMaybe<Scalars['geometry']>;
  _gte?: InputMaybe<Scalars['geometry']>;
  _in?: InputMaybe<Array<Scalars['geometry']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geometry']>;
  _lte?: InputMaybe<Scalars['geometry']>;
  _neq?: InputMaybe<Scalars['geometry']>;
  _nin?: InputMaybe<Array<Scalars['geometry']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st3dDWithin?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st3dIntersects?: InputMaybe<Scalars['geometry']>;
  /** does the column contain the given geometry value */
  _stContains?: InputMaybe<Scalars['geometry']>;
  /** does the column cross the given geometry value */
  _stCrosses?: InputMaybe<Scalars['geometry']>;
  /** is the column within a given distance from the given geometry value */
  _stDWithin?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _stEquals?: InputMaybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _stIntersects?: InputMaybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _stOverlaps?: InputMaybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _stTouches?: InputMaybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _stWithin?: InputMaybe<Scalars['geometry']>;
};

/** columns and relationships of "group_comment_votes" */
export type GroupCommentVotes = {
  __typename?: 'GroupCommentVotes';
  /** An object relationship */
  comment: GroupThreadComments;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupThreadCommentId: Scalars['uuid'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  vote: CommentVoteEnum;
};

/** aggregated selection of "group_comment_votes" */
export type GroupCommentVotesAggregate = {
  __typename?: 'GroupCommentVotesAggregate';
  aggregate?: Maybe<GroupCommentVotesAggregateFields>;
  nodes: Array<GroupCommentVotes>;
};

export type GroupCommentVotesAggregateBoolExp = {
  count?: InputMaybe<GroupCommentVotesAggregateBoolExpCount>;
};

/** aggregate fields of "group_comment_votes" */
export type GroupCommentVotesAggregateFields = {
  __typename?: 'GroupCommentVotesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<GroupCommentVotesMaxFields>;
  min?: Maybe<GroupCommentVotesMinFields>;
};


/** aggregate fields of "group_comment_votes" */
export type GroupCommentVotesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "group_comment_votes" */
export type GroupCommentVotesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupCommentVotesMaxOrderBy>;
  min?: InputMaybe<GroupCommentVotesMinOrderBy>;
};

/** input type for inserting array relation for remote table "group_comment_votes" */
export type GroupCommentVotesArrRelInsertInput = {
  data: Array<GroupCommentVotesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<GroupCommentVotesOnConflict>;
};

/** Boolean expression to filter rows from the table "group_comment_votes". All fields are combined with a logical 'AND'. */
export type GroupCommentVotesBoolExp = {
  _and?: InputMaybe<Array<GroupCommentVotesBoolExp>>;
  _not?: InputMaybe<GroupCommentVotesBoolExp>;
  _or?: InputMaybe<Array<GroupCommentVotesBoolExp>>;
  comment?: InputMaybe<GroupThreadCommentsBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  groupThreadCommentId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  vote?: InputMaybe<CommentVoteEnumComparisonExp>;
};

/** unique or primary key constraints on table "group_comment_votes" */
export enum GroupCommentVotesConstraint {
  /** unique or primary key constraint on columns "user_id", "group_thread_comment_id" */
  GroupCommentVotesGroupThreadCommentIdUserIdKey = 'group_comment_votes_group_thread_comment_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  GroupCommentVotesPkey = 'group_comment_votes_pkey'
}

/** input type for inserting data into table "group_comment_votes" */
export type GroupCommentVotesInsertInput = {
  comment?: InputMaybe<GroupThreadCommentsObjRelInsertInput>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
  vote?: InputMaybe<CommentVoteEnum>;
};

/** aggregate max on columns */
export type GroupCommentVotesMaxFields = {
  __typename?: 'GroupCommentVotesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupThreadCommentId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "group_comment_votes" */
export type GroupCommentVotesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupThreadCommentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GroupCommentVotesMinFields = {
  __typename?: 'GroupCommentVotesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupThreadCommentId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "group_comment_votes" */
export type GroupCommentVotesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupThreadCommentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "group_comment_votes" */
export type GroupCommentVotesMutationResponse = {
  __typename?: 'GroupCommentVotesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupCommentVotes>;
};

/** on_conflict condition type for table "group_comment_votes" */
export type GroupCommentVotesOnConflict = {
  constraint: GroupCommentVotesConstraint;
  updateColumns?: Array<GroupCommentVotesUpdateColumn>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};

/** Ordering options when selecting data from "group_comment_votes". */
export type GroupCommentVotesOrderBy = {
  comment?: InputMaybe<GroupThreadCommentsOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupThreadCommentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  vote?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: group_comment_votes */
export type GroupCommentVotesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "group_comment_votes" */
export enum GroupCommentVotesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupThreadCommentId = 'groupThreadCommentId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  Vote = 'vote'
}

/** input type for updating data in table "group_comment_votes" */
export type GroupCommentVotesSetInput = {
  vote?: InputMaybe<CommentVoteEnum>;
};

/** Streaming cursor of the table "group_comment_votes" */
export type GroupCommentVotesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupCommentVotesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupCommentVotesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  vote?: InputMaybe<CommentVoteEnum>;
};

/** update columns of table "group_comment_votes" */
export enum GroupCommentVotesUpdateColumn {
  /** column name */
  Vote = 'vote'
}

export type GroupCommentVotesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupCommentVotesSetInput>;
  /** filter the rows which have to be updated */
  where: GroupCommentVotesBoolExp;
};

/** columns and relationships of "group_members" */
export type GroupMembers = {
  __typename?: 'GroupMembers';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** aggregated selection of "group_members" */
export type GroupMembersAggregate = {
  __typename?: 'GroupMembersAggregate';
  aggregate?: Maybe<GroupMembersAggregateFields>;
  nodes: Array<GroupMembers>;
};

export type GroupMembersAggregateBoolExp = {
  bool_and?: InputMaybe<GroupMembersAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<GroupMembersAggregateBoolExpBool_Or>;
  count?: InputMaybe<GroupMembersAggregateBoolExpCount>;
};

/** aggregate fields of "group_members" */
export type GroupMembersAggregateFields = {
  __typename?: 'GroupMembersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<GroupMembersMaxFields>;
  min?: Maybe<GroupMembersMinFields>;
};


/** aggregate fields of "group_members" */
export type GroupMembersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GroupMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "group_members" */
export type GroupMembersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupMembersMaxOrderBy>;
  min?: InputMaybe<GroupMembersMinOrderBy>;
};

/** Boolean expression to filter rows from the table "group_members". All fields are combined with a logical 'AND'. */
export type GroupMembersBoolExp = {
  _and?: InputMaybe<Array<GroupMembersBoolExp>>;
  _not?: InputMaybe<GroupMembersBoolExp>;
  _or?: InputMaybe<Array<GroupMembersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "group_members" */
export enum GroupMembersConstraint {
  /** unique or primary key constraint on columns "user_id", "group_id" */
  GroupMembersGroupIdUserIdKey = 'group_members_group_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  GroupMembersPkey = 'group_members_pkey'
}

/** input type for inserting data into table "group_members" */
export type GroupMembersInsertInput = {
  groupId?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type GroupMembersMaxFields = {
  __typename?: 'GroupMembersMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "group_members" */
export type GroupMembersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GroupMembersMinFields = {
  __typename?: 'GroupMembersMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "group_members" */
export type GroupMembersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "group_members" */
export type GroupMembersMutationResponse = {
  __typename?: 'GroupMembersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupMembers>;
};

/** on_conflict condition type for table "group_members" */
export type GroupMembersOnConflict = {
  constraint: GroupMembersConstraint;
  updateColumns?: Array<GroupMembersUpdateColumn>;
  where?: InputMaybe<GroupMembersBoolExp>;
};

/** Ordering options when selecting data from "group_members". */
export type GroupMembersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: group_members */
export type GroupMembersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "group_members" */
export enum GroupMembersSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** select "groupMembersAggregateBoolExpBool_andArgumentsColumns" columns of table "group_members" */
export enum GroupMembersSelectColumnGroupMembersAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsActive = 'isActive'
}

/** select "groupMembersAggregateBoolExpBool_orArgumentsColumns" columns of table "group_members" */
export enum GroupMembersSelectColumnGroupMembersAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsActive = 'isActive'
}

/** input type for updating data in table "group_members" */
export type GroupMembersSetInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "group_members" */
export type GroupMembersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupMembersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupMembersStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "group_members" */
export enum GroupMembersUpdateColumn {
  /** column name */
  IsActive = 'isActive',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type GroupMembersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupMembersSetInput>;
  /** filter the rows which have to be updated */
  where: GroupMembersBoolExp;
};

/** columns and relationships of "group_thread_comment_files" */
export type GroupThreadCommentFiles = {
  __typename?: 'GroupThreadCommentFiles';
  /** An object relationship */
  comment: GroupThreadComments;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  groupThreadCommentId: Scalars['uuid'];
  host: Scalars['String'];
  id: Scalars['uuid'];
  isVisible: Scalars['Boolean'];
  originalFileName?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  provider: Scalars['String'];
  providerUrl: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "group_thread_comment_files" */
export type GroupThreadCommentFilesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupThreadCommentFilesMaxOrderBy>;
  min?: InputMaybe<GroupThreadCommentFilesMinOrderBy>;
};

/** input type for inserting array relation for remote table "group_thread_comment_files" */
export type GroupThreadCommentFilesArrRelInsertInput = {
  data: Array<GroupThreadCommentFilesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<GroupThreadCommentFilesOnConflict>;
};

/** Boolean expression to filter rows from the table "group_thread_comment_files". All fields are combined with a logical 'AND'. */
export type GroupThreadCommentFilesBoolExp = {
  _and?: InputMaybe<Array<GroupThreadCommentFilesBoolExp>>;
  _not?: InputMaybe<GroupThreadCommentFilesBoolExp>;
  _or?: InputMaybe<Array<GroupThreadCommentFilesBoolExp>>;
  comment?: InputMaybe<GroupThreadCommentsBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileType?: InputMaybe<StringComparisonExp>;
  groupThreadCommentId?: InputMaybe<UuidComparisonExp>;
  host?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isVisible?: InputMaybe<BooleanComparisonExp>;
  originalFileName?: InputMaybe<StringComparisonExp>;
  path?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "group_thread_comment_files" */
export enum GroupThreadCommentFilesConstraint {
  /** unique or primary key constraint on columns "id" */
  GroupThreadCommentFilesPkey = 'group_thread_comment_files_pkey'
}

/** input type for inserting data into table "group_thread_comment_files" */
export type GroupThreadCommentFilesInsertInput = {
  comment?: InputMaybe<GroupThreadCommentsObjRelInsertInput>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  host?: InputMaybe<Scalars['String']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "group_thread_comment_files" */
export type GroupThreadCommentFilesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  groupThreadCommentId?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "group_thread_comment_files" */
export type GroupThreadCommentFilesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  groupThreadCommentId?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "group_thread_comment_files" */
export type GroupThreadCommentFilesMutationResponse = {
  __typename?: 'GroupThreadCommentFilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupThreadCommentFiles>;
};

/** on_conflict condition type for table "group_thread_comment_files" */
export type GroupThreadCommentFilesOnConflict = {
  constraint: GroupThreadCommentFilesConstraint;
  updateColumns?: Array<GroupThreadCommentFilesUpdateColumn>;
  where?: InputMaybe<GroupThreadCommentFilesBoolExp>;
};

/** Ordering options when selecting data from "group_thread_comment_files". */
export type GroupThreadCommentFilesOrderBy = {
  comment?: InputMaybe<GroupThreadCommentsOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  groupThreadCommentId?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isVisible?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: group_thread_comment_files */
export type GroupThreadCommentFilesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "group_thread_comment_files" */
export enum GroupThreadCommentFilesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  GroupThreadCommentId = 'groupThreadCommentId',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  IsVisible = 'isVisible',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Path = 'path',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "group_thread_comment_files" */
export type GroupThreadCommentFilesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "group_thread_comment_files" */
export type GroupThreadCommentFilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupThreadCommentFilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupThreadCommentFilesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "group_thread_comment_files" */
export enum GroupThreadCommentFilesUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt'
}

export type GroupThreadCommentFilesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupThreadCommentFilesSetInput>;
  /** filter the rows which have to be updated */
  where: GroupThreadCommentFilesBoolExp;
};

/** columns and relationships of "group_thread_comments" */
export type GroupThreadComments = {
  __typename?: 'GroupThreadComments';
  /** An array relationship */
  allChildComments: Array<GroupThreadComments>;
  /** An aggregate relationship */
  allChildCommentsAggregate: GroupThreadCommentsAggregate;
  content: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  files: Array<GroupThreadCommentFiles>;
  groupCommentId?: Maybe<Scalars['uuid']>;
  groupRootCommentId?: Maybe<Scalars['uuid']>;
  groupThreadId: Scalars['uuid'];
  id: Scalars['uuid'];
  isOriginalThreadComment: Scalars['Boolean'];
  /** An object relationship */
  parentComment?: Maybe<GroupThreadComments>;
  /** An array relationship */
  replies: Array<GroupThreadComments>;
  /** An aggregate relationship */
  repliesAggregate: GroupThreadCommentsAggregate;
  /** An object relationship */
  rootComment?: Maybe<GroupThreadComments>;
  /** An object relationship */
  thread: GroupThreads;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
  /** An array relationship */
  votes: Array<GroupCommentVotes>;
  /** An aggregate relationship */
  votesAggregate: GroupCommentVotesAggregate;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsAllChildCommentsArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsAllChildCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsFilesArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentFilesOrderBy>>;
  where?: InputMaybe<GroupThreadCommentFilesBoolExp>;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsRepliesArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsRepliesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsVotesArgs = {
  distinctOn?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupCommentVotesOrderBy>>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};


/** columns and relationships of "group_thread_comments" */
export type GroupThreadCommentsVotesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupCommentVotesOrderBy>>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};

/** aggregated selection of "group_thread_comments" */
export type GroupThreadCommentsAggregate = {
  __typename?: 'GroupThreadCommentsAggregate';
  aggregate?: Maybe<GroupThreadCommentsAggregateFields>;
  nodes: Array<GroupThreadComments>;
};

export type GroupThreadCommentsAggregateBoolExp = {
  bool_and?: InputMaybe<GroupThreadCommentsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<GroupThreadCommentsAggregateBoolExpBool_Or>;
  count?: InputMaybe<GroupThreadCommentsAggregateBoolExpCount>;
};

/** aggregate fields of "group_thread_comments" */
export type GroupThreadCommentsAggregateFields = {
  __typename?: 'GroupThreadCommentsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<GroupThreadCommentsMaxFields>;
  min?: Maybe<GroupThreadCommentsMinFields>;
};


/** aggregate fields of "group_thread_comments" */
export type GroupThreadCommentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "group_thread_comments" */
export type GroupThreadCommentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupThreadCommentsMaxOrderBy>;
  min?: InputMaybe<GroupThreadCommentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "group_thread_comments" */
export type GroupThreadCommentsArrRelInsertInput = {
  data: Array<GroupThreadCommentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<GroupThreadCommentsOnConflict>;
};

/** Boolean expression to filter rows from the table "group_thread_comments". All fields are combined with a logical 'AND'. */
export type GroupThreadCommentsBoolExp = {
  _and?: InputMaybe<Array<GroupThreadCommentsBoolExp>>;
  _not?: InputMaybe<GroupThreadCommentsBoolExp>;
  _or?: InputMaybe<Array<GroupThreadCommentsBoolExp>>;
  allChildComments?: InputMaybe<GroupThreadCommentsBoolExp>;
  allChildCommentsAggregate?: InputMaybe<GroupThreadCommentsAggregateBoolExp>;
  content?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  files?: InputMaybe<GroupThreadCommentFilesBoolExp>;
  groupCommentId?: InputMaybe<UuidComparisonExp>;
  groupRootCommentId?: InputMaybe<UuidComparisonExp>;
  groupThreadId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isOriginalThreadComment?: InputMaybe<BooleanComparisonExp>;
  parentComment?: InputMaybe<GroupThreadCommentsBoolExp>;
  replies?: InputMaybe<GroupThreadCommentsBoolExp>;
  repliesAggregate?: InputMaybe<GroupThreadCommentsAggregateBoolExp>;
  rootComment?: InputMaybe<GroupThreadCommentsBoolExp>;
  thread?: InputMaybe<GroupThreadsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
  votes?: InputMaybe<GroupCommentVotesBoolExp>;
  votesAggregate?: InputMaybe<GroupCommentVotesAggregateBoolExp>;
};

/** unique or primary key constraints on table "group_thread_comments" */
export enum GroupThreadCommentsConstraint {
  /** unique or primary key constraint on columns "id" */
  GroupThreadCommentsPkey = 'group_thread_comments_pkey'
}

/** input type for inserting data into table "group_thread_comments" */
export type GroupThreadCommentsInsertInput = {
  allChildComments?: InputMaybe<GroupThreadCommentsArrRelInsertInput>;
  content?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<GroupThreadCommentFilesArrRelInsertInput>;
  groupCommentId?: InputMaybe<Scalars['uuid']>;
  groupRootCommentId?: InputMaybe<Scalars['uuid']>;
  groupThreadId?: InputMaybe<Scalars['uuid']>;
  isOriginalThreadComment?: InputMaybe<Scalars['Boolean']>;
  parentComment?: InputMaybe<GroupThreadCommentsObjRelInsertInput>;
  replies?: InputMaybe<GroupThreadCommentsArrRelInsertInput>;
  rootComment?: InputMaybe<GroupThreadCommentsObjRelInsertInput>;
  thread?: InputMaybe<GroupThreadsObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  votes?: InputMaybe<GroupCommentVotesArrRelInsertInput>;
};

/** aggregate max on columns */
export type GroupThreadCommentsMaxFields = {
  __typename?: 'GroupThreadCommentsMaxFields';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupCommentId?: Maybe<Scalars['uuid']>;
  groupRootCommentId?: Maybe<Scalars['uuid']>;
  groupThreadId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "group_thread_comments" */
export type GroupThreadCommentsMaxOrderBy = {
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupCommentId?: InputMaybe<OrderBy>;
  groupRootCommentId?: InputMaybe<OrderBy>;
  groupThreadId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GroupThreadCommentsMinFields = {
  __typename?: 'GroupThreadCommentsMinFields';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupCommentId?: Maybe<Scalars['uuid']>;
  groupRootCommentId?: Maybe<Scalars['uuid']>;
  groupThreadId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "group_thread_comments" */
export type GroupThreadCommentsMinOrderBy = {
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupCommentId?: InputMaybe<OrderBy>;
  groupRootCommentId?: InputMaybe<OrderBy>;
  groupThreadId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "group_thread_comments" */
export type GroupThreadCommentsMutationResponse = {
  __typename?: 'GroupThreadCommentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupThreadComments>;
};

/** input type for inserting object relation for remote table "group_thread_comments" */
export type GroupThreadCommentsObjRelInsertInput = {
  data: GroupThreadCommentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<GroupThreadCommentsOnConflict>;
};

/** on_conflict condition type for table "group_thread_comments" */
export type GroupThreadCommentsOnConflict = {
  constraint: GroupThreadCommentsConstraint;
  updateColumns?: Array<GroupThreadCommentsUpdateColumn>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};

/** Ordering options when selecting data from "group_thread_comments". */
export type GroupThreadCommentsOrderBy = {
  allChildCommentsAggregate?: InputMaybe<GroupThreadCommentsAggregateOrderBy>;
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  filesAggregate?: InputMaybe<GroupThreadCommentFilesAggregateOrderBy>;
  groupCommentId?: InputMaybe<OrderBy>;
  groupRootCommentId?: InputMaybe<OrderBy>;
  groupThreadId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isOriginalThreadComment?: InputMaybe<OrderBy>;
  parentComment?: InputMaybe<GroupThreadCommentsOrderBy>;
  repliesAggregate?: InputMaybe<GroupThreadCommentsAggregateOrderBy>;
  rootComment?: InputMaybe<GroupThreadCommentsOrderBy>;
  thread?: InputMaybe<GroupThreadsOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
  votesAggregate?: InputMaybe<GroupCommentVotesAggregateOrderBy>;
};

/** primary key columns input for table: group_thread_comments */
export type GroupThreadCommentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "group_thread_comments" */
export enum GroupThreadCommentsSelectColumn {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupCommentId = 'groupCommentId',
  /** column name */
  GroupRootCommentId = 'groupRootCommentId',
  /** column name */
  GroupThreadId = 'groupThreadId',
  /** column name */
  Id = 'id',
  /** column name */
  IsOriginalThreadComment = 'isOriginalThreadComment',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** select "groupThreadCommentsAggregateBoolExpBool_andArgumentsColumns" columns of table "group_thread_comments" */
export enum GroupThreadCommentsSelectColumnGroupThreadCommentsAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsOriginalThreadComment = 'isOriginalThreadComment'
}

/** select "groupThreadCommentsAggregateBoolExpBool_orArgumentsColumns" columns of table "group_thread_comments" */
export enum GroupThreadCommentsSelectColumnGroupThreadCommentsAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsOriginalThreadComment = 'isOriginalThreadComment'
}

/** input type for updating data in table "group_thread_comments" */
export type GroupThreadCommentsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "group_thread_comments" */
export type GroupThreadCommentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupThreadCommentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupThreadCommentsStreamCursorValueInput = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupCommentId?: InputMaybe<Scalars['uuid']>;
  groupRootCommentId?: InputMaybe<Scalars['uuid']>;
  groupThreadId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isOriginalThreadComment?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "group_thread_comments" */
export enum GroupThreadCommentsUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt'
}

export type GroupThreadCommentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupThreadCommentsSetInput>;
  /** filter the rows which have to be updated */
  where: GroupThreadCommentsBoolExp;
};

/** columns and relationships of "group_threads" */
export type GroupThreads = {
  __typename?: 'GroupThreads';
  /** An array relationship */
  comments: Array<GroupThreadComments>;
  /** An aggregate relationship */
  commentsAggregate: GroupThreadCommentsAggregate;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  creator: Users;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
};


/** columns and relationships of "group_threads" */
export type GroupThreadsCommentsArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


/** columns and relationships of "group_threads" */
export type GroupThreadsCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};

/** order by aggregate values of table "group_threads" */
export type GroupThreadsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupThreadsMaxOrderBy>;
  min?: InputMaybe<GroupThreadsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "group_threads". All fields are combined with a logical 'AND'. */
export type GroupThreadsBoolExp = {
  _and?: InputMaybe<Array<GroupThreadsBoolExp>>;
  _not?: InputMaybe<GroupThreadsBoolExp>;
  _or?: InputMaybe<Array<GroupThreadsBoolExp>>;
  comments?: InputMaybe<GroupThreadCommentsBoolExp>;
  commentsAggregate?: InputMaybe<GroupThreadCommentsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  creator?: InputMaybe<UsersBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "group_threads" */
export enum GroupThreadsConstraint {
  /** unique or primary key constraint on columns "id" */
  GroupThreadsPkey = 'group_threads_pkey'
}

/** input type for inserting data into table "group_threads" */
export type GroupThreadsInsertInput = {
  comments?: InputMaybe<GroupThreadCommentsArrRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "group_threads" */
export type GroupThreadsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "group_threads" */
export type GroupThreadsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "group_threads" */
export type GroupThreadsMutationResponse = {
  __typename?: 'GroupThreadsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupThreads>;
};

/** input type for inserting object relation for remote table "group_threads" */
export type GroupThreadsObjRelInsertInput = {
  data: GroupThreadsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<GroupThreadsOnConflict>;
};

/** on_conflict condition type for table "group_threads" */
export type GroupThreadsOnConflict = {
  constraint: GroupThreadsConstraint;
  updateColumns?: Array<GroupThreadsUpdateColumn>;
  where?: InputMaybe<GroupThreadsBoolExp>;
};

/** Ordering options when selecting data from "group_threads". */
export type GroupThreadsOrderBy = {
  commentsAggregate?: InputMaybe<GroupThreadCommentsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  creator?: InputMaybe<UsersOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "group_threads" */
export enum GroupThreadsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "group_threads" */
export type GroupThreadsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupThreadsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupThreadsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** placeholder for update columns of table "group_threads" (current role has no relevant permissions) */
export enum GroupThreadsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "group_types" */
export type GroupTypes = {
  __typename?: 'GroupTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "group_types". All fields are combined with a logical 'AND'. */
export type GroupTypesBoolExp = {
  _and?: InputMaybe<Array<GroupTypesBoolExp>>;
  _not?: InputMaybe<GroupTypesBoolExp>;
  _or?: InputMaybe<Array<GroupTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum GroupTypesEnum {
  College = 'COLLEGE',
  HighSchool = 'HIGH_SCHOOL',
  LocalCommunity = 'LOCAL_COMMUNITY',
  PrivateClub = 'PRIVATE_CLUB'
}

/** Boolean expression to compare columns of type "GroupTypesEnum". All fields are combined with logical 'AND'. */
export type GroupTypesEnumComparisonExp = {
  _eq?: InputMaybe<GroupTypesEnum>;
  _in?: InputMaybe<Array<GroupTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<GroupTypesEnum>;
  _nin?: InputMaybe<Array<GroupTypesEnum>>;
};

/** Ordering options when selecting data from "group_types". */
export type GroupTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "group_types" */
export enum GroupTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "group_types" */
export type GroupTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "group_venues" */
export type GroupVenues = {
  __typename?: 'GroupVenues';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "group_venues" */
export type GroupVenuesAggregate = {
  __typename?: 'GroupVenuesAggregate';
  aggregate?: Maybe<GroupVenuesAggregateFields>;
  nodes: Array<GroupVenues>;
};

export type GroupVenuesAggregateBoolExp = {
  count?: InputMaybe<GroupVenuesAggregateBoolExpCount>;
};

/** aggregate fields of "group_venues" */
export type GroupVenuesAggregateFields = {
  __typename?: 'GroupVenuesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<GroupVenuesMaxFields>;
  min?: Maybe<GroupVenuesMinFields>;
};


/** aggregate fields of "group_venues" */
export type GroupVenuesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "group_venues" */
export type GroupVenuesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupVenuesMaxOrderBy>;
  min?: InputMaybe<GroupVenuesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "group_venues". All fields are combined with a logical 'AND'. */
export type GroupVenuesBoolExp = {
  _and?: InputMaybe<Array<GroupVenuesBoolExp>>;
  _not?: InputMaybe<GroupVenuesBoolExp>;
  _or?: InputMaybe<Array<GroupVenuesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** aggregate max on columns */
export type GroupVenuesMaxFields = {
  __typename?: 'GroupVenuesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "group_venues" */
export type GroupVenuesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GroupVenuesMinFields = {
  __typename?: 'GroupVenuesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "group_venues" */
export type GroupVenuesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "group_venues". */
export type GroupVenuesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** select columns of table "group_venues" */
export enum GroupVenuesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** Streaming cursor of the table "group_venues" */
export type GroupVenuesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupVenuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupVenuesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "groups" */
export type Groups = {
  __typename?: 'Groups';
  accessCode?: Maybe<Scalars['String']>;
  actionUrl: Scalars['String'];
  addressString: Scalars['String'];
  allowMemberInvites: Scalars['Boolean'];
  allowMemberSessionInvites: Scalars['Boolean'];
  /** An object relationship */
  city?: Maybe<Cities>;
  cityId?: Maybe<Scalars['uuid']>;
  contactMessage?: Maybe<Scalars['String']>;
  contactUrl?: Maybe<Scalars['String']>;
  coverPhotoFileName: Scalars['String'];
  coverPhotoFileType?: Maybe<Scalars['String']>;
  coverPhotoHost: Scalars['String'];
  coverPhotoOriginalFileName: Scalars['String'];
  coverPhotoPath: Scalars['String'];
  coverPhotoProvider: Scalars['String'];
  coverPhotoProviderUrl: Scalars['String'];
  coverPhotoUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  directorName?: Maybe<Scalars['String']>;
  displayOwnerContactInfo: Scalars['Boolean'];
  duprUrl?: Maybe<Scalars['String']>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  eventsAggregate: EventsAggregate;
  facebookUrl: Scalars['String'];
  geometry?: Maybe<Scalars['geography']>;
  /** An array relationship */
  groupsPlaySessions: Array<GroupsPlaySessions>;
  headline: Scalars['String'];
  id: Scalars['uuid'];
  instagramUrl: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  memberDisplayCount?: Maybe<Scalars['Int']>;
  /** An array relationship */
  members: Array<GroupMembers>;
  /** An aggregate relationship */
  membersAggregate: GroupMembersAggregate;
  organizerName?: Maybe<Scalars['String']>;
  /** An object relationship */
  owner?: Maybe<Users>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  ownerUserProfile?: Maybe<UserProfiles>;
  /** An array relationship */
  playSessions: Array<PlaySessions>;
  /** An aggregate relationship */
  playSessionsAggregate: PlaySessionsAggregate;
  primarySport?: Maybe<SportsEnum>;
  profilePhotoFileName: Scalars['String'];
  profilePhotoFileType?: Maybe<Scalars['String']>;
  profilePhotoHost: Scalars['String'];
  profilePhotoOriginalFileName: Scalars['String'];
  profilePhotoPath: Scalars['String'];
  profilePhotoProvider: Scalars['String'];
  profilePhotoProviderUrl: Scalars['String'];
  profilePhotoUrl: Scalars['String'];
  skillLevelMaximum?: Maybe<Scalars['numeric']>;
  skillLevelMinimum?: Maybe<Scalars['numeric']>;
  slug: Scalars['String'];
  /** An array relationship */
  threads: Array<GroupThreads>;
  tiktokUrl: Scalars['String'];
  title: Scalars['String'];
  type: GroupTypesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  venues: Array<GroupVenues>;
  /** An aggregate relationship */
  venuesAggregate: GroupVenuesAggregate;
  websiteUrl: Scalars['String'];
  xUrl: Scalars['String'];
  youtubeUrl?: Maybe<Scalars['String']>;
};


/** columns and relationships of "groups" */
export type GroupsEventsArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsGroupsPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<GroupsPlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsPlaySessionsOrderBy>>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsMembersArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsMembersAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsPlaySessionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsThreadsArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadsOrderBy>>;
  where?: InputMaybe<GroupThreadsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsVenuesArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};

/** order by aggregate values of table "groups" */
export type GroupsAggregateOrderBy = {
  avg?: InputMaybe<GroupsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupsMaxOrderBy>;
  min?: InputMaybe<GroupsMinOrderBy>;
  stddev?: InputMaybe<GroupsStddevOrderBy>;
  stddevPop?: InputMaybe<GroupsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<GroupsStddevSampOrderBy>;
  sum?: InputMaybe<GroupsSumOrderBy>;
  varPop?: InputMaybe<GroupsVarPopOrderBy>;
  varSamp?: InputMaybe<GroupsVarSampOrderBy>;
  variance?: InputMaybe<GroupsVarianceOrderBy>;
};

/** order by avg() on columns of table "groups" */
export type GroupsAvgOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "groups". All fields are combined with a logical 'AND'. */
export type GroupsBoolExp = {
  _and?: InputMaybe<Array<GroupsBoolExp>>;
  _not?: InputMaybe<GroupsBoolExp>;
  _or?: InputMaybe<Array<GroupsBoolExp>>;
  accessCode?: InputMaybe<StringComparisonExp>;
  actionUrl?: InputMaybe<StringComparisonExp>;
  addressString?: InputMaybe<StringComparisonExp>;
  allowMemberInvites?: InputMaybe<BooleanComparisonExp>;
  allowMemberSessionInvites?: InputMaybe<BooleanComparisonExp>;
  city?: InputMaybe<CitiesBoolExp>;
  cityId?: InputMaybe<UuidComparisonExp>;
  contactMessage?: InputMaybe<StringComparisonExp>;
  contactUrl?: InputMaybe<StringComparisonExp>;
  coverPhotoFileName?: InputMaybe<StringComparisonExp>;
  coverPhotoFileType?: InputMaybe<StringComparisonExp>;
  coverPhotoHost?: InputMaybe<StringComparisonExp>;
  coverPhotoOriginalFileName?: InputMaybe<StringComparisonExp>;
  coverPhotoPath?: InputMaybe<StringComparisonExp>;
  coverPhotoProvider?: InputMaybe<StringComparisonExp>;
  coverPhotoProviderUrl?: InputMaybe<StringComparisonExp>;
  coverPhotoUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  directorName?: InputMaybe<StringComparisonExp>;
  displayOwnerContactInfo?: InputMaybe<BooleanComparisonExp>;
  duprUrl?: InputMaybe<StringComparisonExp>;
  events?: InputMaybe<EventsBoolExp>;
  eventsAggregate?: InputMaybe<EventsAggregateBoolExp>;
  facebookUrl?: InputMaybe<StringComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  groupsPlaySessions?: InputMaybe<GroupsPlaySessionsBoolExp>;
  headline?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  instagramUrl?: InputMaybe<StringComparisonExp>;
  isPrivate?: InputMaybe<BooleanComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  memberDisplayCount?: InputMaybe<IntComparisonExp>;
  members?: InputMaybe<GroupMembersBoolExp>;
  membersAggregate?: InputMaybe<GroupMembersAggregateBoolExp>;
  organizerName?: InputMaybe<StringComparisonExp>;
  owner?: InputMaybe<UsersBoolExp>;
  ownerUserId?: InputMaybe<UuidComparisonExp>;
  ownerUserProfile?: InputMaybe<UserProfilesBoolExp>;
  playSessions?: InputMaybe<PlaySessionsBoolExp>;
  playSessionsAggregate?: InputMaybe<PlaySessionsAggregateBoolExp>;
  primarySport?: InputMaybe<SportsEnumComparisonExp>;
  profilePhotoFileName?: InputMaybe<StringComparisonExp>;
  profilePhotoFileType?: InputMaybe<StringComparisonExp>;
  profilePhotoHost?: InputMaybe<StringComparisonExp>;
  profilePhotoOriginalFileName?: InputMaybe<StringComparisonExp>;
  profilePhotoPath?: InputMaybe<StringComparisonExp>;
  profilePhotoProvider?: InputMaybe<StringComparisonExp>;
  profilePhotoProviderUrl?: InputMaybe<StringComparisonExp>;
  profilePhotoUrl?: InputMaybe<StringComparisonExp>;
  skillLevelMaximum?: InputMaybe<NumericComparisonExp>;
  skillLevelMinimum?: InputMaybe<NumericComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  threads?: InputMaybe<GroupThreadsBoolExp>;
  tiktokUrl?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<GroupTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venues?: InputMaybe<GroupVenuesBoolExp>;
  venuesAggregate?: InputMaybe<GroupVenuesAggregateBoolExp>;
  websiteUrl?: InputMaybe<StringComparisonExp>;
  xUrl?: InputMaybe<StringComparisonExp>;
  youtubeUrl?: InputMaybe<StringComparisonExp>;
};

/** order by max() on columns of table "groups" */
export type GroupsMaxOrderBy = {
  accessCode?: InputMaybe<OrderBy>;
  actionUrl?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  contactMessage?: InputMaybe<OrderBy>;
  contactUrl?: InputMaybe<OrderBy>;
  coverPhotoFileName?: InputMaybe<OrderBy>;
  coverPhotoFileType?: InputMaybe<OrderBy>;
  coverPhotoHost?: InputMaybe<OrderBy>;
  coverPhotoOriginalFileName?: InputMaybe<OrderBy>;
  coverPhotoPath?: InputMaybe<OrderBy>;
  coverPhotoProvider?: InputMaybe<OrderBy>;
  coverPhotoProviderUrl?: InputMaybe<OrderBy>;
  coverPhotoUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  directorName?: InputMaybe<OrderBy>;
  duprUrl?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  headline?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  organizerName?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  profilePhotoFileName?: InputMaybe<OrderBy>;
  profilePhotoFileType?: InputMaybe<OrderBy>;
  profilePhotoHost?: InputMaybe<OrderBy>;
  profilePhotoOriginalFileName?: InputMaybe<OrderBy>;
  profilePhotoPath?: InputMaybe<OrderBy>;
  profilePhotoProvider?: InputMaybe<OrderBy>;
  profilePhotoProviderUrl?: InputMaybe<OrderBy>;
  profilePhotoUrl?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tiktokUrl?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  xUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "groups" */
export type GroupsMinOrderBy = {
  accessCode?: InputMaybe<OrderBy>;
  actionUrl?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  contactMessage?: InputMaybe<OrderBy>;
  contactUrl?: InputMaybe<OrderBy>;
  coverPhotoFileName?: InputMaybe<OrderBy>;
  coverPhotoFileType?: InputMaybe<OrderBy>;
  coverPhotoHost?: InputMaybe<OrderBy>;
  coverPhotoOriginalFileName?: InputMaybe<OrderBy>;
  coverPhotoPath?: InputMaybe<OrderBy>;
  coverPhotoProvider?: InputMaybe<OrderBy>;
  coverPhotoProviderUrl?: InputMaybe<OrderBy>;
  coverPhotoUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  directorName?: InputMaybe<OrderBy>;
  duprUrl?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  headline?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  organizerName?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  profilePhotoFileName?: InputMaybe<OrderBy>;
  profilePhotoFileType?: InputMaybe<OrderBy>;
  profilePhotoHost?: InputMaybe<OrderBy>;
  profilePhotoOriginalFileName?: InputMaybe<OrderBy>;
  profilePhotoPath?: InputMaybe<OrderBy>;
  profilePhotoProvider?: InputMaybe<OrderBy>;
  profilePhotoProviderUrl?: InputMaybe<OrderBy>;
  profilePhotoUrl?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tiktokUrl?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  xUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "groups". */
export type GroupsOrderBy = {
  accessCode?: InputMaybe<OrderBy>;
  actionUrl?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  allowMemberInvites?: InputMaybe<OrderBy>;
  allowMemberSessionInvites?: InputMaybe<OrderBy>;
  city?: InputMaybe<CitiesOrderBy>;
  cityId?: InputMaybe<OrderBy>;
  contactMessage?: InputMaybe<OrderBy>;
  contactUrl?: InputMaybe<OrderBy>;
  coverPhotoFileName?: InputMaybe<OrderBy>;
  coverPhotoFileType?: InputMaybe<OrderBy>;
  coverPhotoHost?: InputMaybe<OrderBy>;
  coverPhotoOriginalFileName?: InputMaybe<OrderBy>;
  coverPhotoPath?: InputMaybe<OrderBy>;
  coverPhotoProvider?: InputMaybe<OrderBy>;
  coverPhotoProviderUrl?: InputMaybe<OrderBy>;
  coverPhotoUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  directorName?: InputMaybe<OrderBy>;
  displayOwnerContactInfo?: InputMaybe<OrderBy>;
  duprUrl?: InputMaybe<OrderBy>;
  eventsAggregate?: InputMaybe<EventsAggregateOrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  groupsPlaySessionsAggregate?: InputMaybe<GroupsPlaySessionsAggregateOrderBy>;
  headline?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  isPrivate?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  membersAggregate?: InputMaybe<GroupMembersAggregateOrderBy>;
  organizerName?: InputMaybe<OrderBy>;
  owner?: InputMaybe<UsersOrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  ownerUserProfile?: InputMaybe<UserProfilesOrderBy>;
  playSessionsAggregate?: InputMaybe<PlaySessionsAggregateOrderBy>;
  primarySport?: InputMaybe<OrderBy>;
  profilePhotoFileName?: InputMaybe<OrderBy>;
  profilePhotoFileType?: InputMaybe<OrderBy>;
  profilePhotoHost?: InputMaybe<OrderBy>;
  profilePhotoOriginalFileName?: InputMaybe<OrderBy>;
  profilePhotoPath?: InputMaybe<OrderBy>;
  profilePhotoProvider?: InputMaybe<OrderBy>;
  profilePhotoProviderUrl?: InputMaybe<OrderBy>;
  profilePhotoUrl?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  threadsAggregate?: InputMaybe<GroupThreadsAggregateOrderBy>;
  tiktokUrl?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venuesAggregate?: InputMaybe<GroupVenuesAggregateOrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  xUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** columns and relationships of "groups_play_sessions" */
export type GroupsPlaySessions = {
  __typename?: 'GroupsPlaySessions';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  playSession: PlaySessions;
  playSessionId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "groups_play_sessions" */
export type GroupsPlaySessionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupsPlaySessionsMaxOrderBy>;
  min?: InputMaybe<GroupsPlaySessionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "groups_play_sessions" */
export type GroupsPlaySessionsArrRelInsertInput = {
  data: Array<GroupsPlaySessionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<GroupsPlaySessionsOnConflict>;
};

/** Boolean expression to filter rows from the table "groups_play_sessions". All fields are combined with a logical 'AND'. */
export type GroupsPlaySessionsBoolExp = {
  _and?: InputMaybe<Array<GroupsPlaySessionsBoolExp>>;
  _not?: InputMaybe<GroupsPlaySessionsBoolExp>;
  _or?: InputMaybe<Array<GroupsPlaySessionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  playSession?: InputMaybe<PlaySessionsBoolExp>;
  playSessionId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "groups_play_sessions" */
export enum GroupsPlaySessionsConstraint {
  /** unique or primary key constraint on columns "play_session_id", "group_id" */
  GroupsPlaySessionsGroupIdPlaySessionIdKey = 'groups_play_sessions_group_id_play_session_id_key',
  /** unique or primary key constraint on columns "id" */
  GroupsPlaySessionsPkey = 'groups_play_sessions_pkey'
}

/** input type for inserting data into table "groups_play_sessions" */
export type GroupsPlaySessionsInsertInput = {
  groupId?: InputMaybe<Scalars['uuid']>;
  playSession?: InputMaybe<PlaySessionsObjRelInsertInput>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "groups_play_sessions" */
export type GroupsPlaySessionsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "groups_play_sessions" */
export type GroupsPlaySessionsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "groups_play_sessions" */
export type GroupsPlaySessionsMutationResponse = {
  __typename?: 'GroupsPlaySessionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupsPlaySessions>;
};

/** on_conflict condition type for table "groups_play_sessions" */
export type GroupsPlaySessionsOnConflict = {
  constraint: GroupsPlaySessionsConstraint;
  updateColumns?: Array<GroupsPlaySessionsUpdateColumn>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};

/** Ordering options when selecting data from "groups_play_sessions". */
export type GroupsPlaySessionsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSession?: InputMaybe<PlaySessionsOrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: groups_play_sessions */
export type GroupsPlaySessionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "groups_play_sessions" */
export enum GroupsPlaySessionsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  PlaySessionId = 'playSessionId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "groups_play_sessions" */
export type GroupsPlaySessionsSetInput = {
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "groups_play_sessions" */
export type GroupsPlaySessionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupsPlaySessionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupsPlaySessionsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "groups_play_sessions" */
export enum GroupsPlaySessionsUpdateColumn {
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type GroupsPlaySessionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupsPlaySessionsSetInput>;
  /** filter the rows which have to be updated */
  where: GroupsPlaySessionsBoolExp;
};

/** select columns of table "groups" */
export enum GroupsSelectColumn {
  /** column name */
  AccessCode = 'accessCode',
  /** column name */
  ActionUrl = 'actionUrl',
  /** column name */
  AddressString = 'addressString',
  /** column name */
  AllowMemberInvites = 'allowMemberInvites',
  /** column name */
  AllowMemberSessionInvites = 'allowMemberSessionInvites',
  /** column name */
  CityId = 'cityId',
  /** column name */
  ContactMessage = 'contactMessage',
  /** column name */
  ContactUrl = 'contactUrl',
  /** column name */
  CoverPhotoFileName = 'coverPhotoFileName',
  /** column name */
  CoverPhotoFileType = 'coverPhotoFileType',
  /** column name */
  CoverPhotoHost = 'coverPhotoHost',
  /** column name */
  CoverPhotoOriginalFileName = 'coverPhotoOriginalFileName',
  /** column name */
  CoverPhotoPath = 'coverPhotoPath',
  /** column name */
  CoverPhotoProvider = 'coverPhotoProvider',
  /** column name */
  CoverPhotoProviderUrl = 'coverPhotoProviderUrl',
  /** column name */
  CoverPhotoUrl = 'coverPhotoUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  DirectorName = 'directorName',
  /** column name */
  DisplayOwnerContactInfo = 'displayOwnerContactInfo',
  /** column name */
  DuprUrl = 'duprUrl',
  /** column name */
  FacebookUrl = 'facebookUrl',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Headline = 'headline',
  /** column name */
  Id = 'id',
  /** column name */
  InstagramUrl = 'instagramUrl',
  /** column name */
  IsPrivate = 'isPrivate',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  MemberDisplayCount = 'memberDisplayCount',
  /** column name */
  OrganizerName = 'organizerName',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  PrimarySport = 'primarySport',
  /** column name */
  ProfilePhotoFileName = 'profilePhotoFileName',
  /** column name */
  ProfilePhotoFileType = 'profilePhotoFileType',
  /** column name */
  ProfilePhotoHost = 'profilePhotoHost',
  /** column name */
  ProfilePhotoOriginalFileName = 'profilePhotoOriginalFileName',
  /** column name */
  ProfilePhotoPath = 'profilePhotoPath',
  /** column name */
  ProfilePhotoProvider = 'profilePhotoProvider',
  /** column name */
  ProfilePhotoProviderUrl = 'profilePhotoProviderUrl',
  /** column name */
  ProfilePhotoUrl = 'profilePhotoUrl',
  /** column name */
  SkillLevelMaximum = 'skillLevelMaximum',
  /** column name */
  SkillLevelMinimum = 'skillLevelMinimum',
  /** column name */
  Slug = 'slug',
  /** column name */
  TiktokUrl = 'tiktokUrl',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WebsiteUrl = 'websiteUrl',
  /** column name */
  XUrl = 'xUrl',
  /** column name */
  YoutubeUrl = 'youtubeUrl'
}

/** order by stddev() on columns of table "groups" */
export type GroupsStddevOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "groups" */
export type GroupsStddevPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "groups" */
export type GroupsStddevSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "groups" */
export type GroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GroupsStreamCursorValueInput = {
  accessCode?: InputMaybe<Scalars['String']>;
  actionUrl?: InputMaybe<Scalars['String']>;
  addressString?: InputMaybe<Scalars['String']>;
  allowMemberInvites?: InputMaybe<Scalars['Boolean']>;
  allowMemberSessionInvites?: InputMaybe<Scalars['Boolean']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  contactMessage?: InputMaybe<Scalars['String']>;
  contactUrl?: InputMaybe<Scalars['String']>;
  coverPhotoFileName?: InputMaybe<Scalars['String']>;
  coverPhotoFileType?: InputMaybe<Scalars['String']>;
  coverPhotoHost?: InputMaybe<Scalars['String']>;
  coverPhotoOriginalFileName?: InputMaybe<Scalars['String']>;
  coverPhotoPath?: InputMaybe<Scalars['String']>;
  coverPhotoProvider?: InputMaybe<Scalars['String']>;
  coverPhotoProviderUrl?: InputMaybe<Scalars['String']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  directorName?: InputMaybe<Scalars['String']>;
  displayOwnerContactInfo?: InputMaybe<Scalars['Boolean']>;
  duprUrl?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  memberDisplayCount?: InputMaybe<Scalars['Int']>;
  organizerName?: InputMaybe<Scalars['String']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  primarySport?: InputMaybe<SportsEnum>;
  profilePhotoFileName?: InputMaybe<Scalars['String']>;
  profilePhotoFileType?: InputMaybe<Scalars['String']>;
  profilePhotoHost?: InputMaybe<Scalars['String']>;
  profilePhotoOriginalFileName?: InputMaybe<Scalars['String']>;
  profilePhotoPath?: InputMaybe<Scalars['String']>;
  profilePhotoProvider?: InputMaybe<Scalars['String']>;
  profilePhotoProviderUrl?: InputMaybe<Scalars['String']>;
  profilePhotoUrl?: InputMaybe<Scalars['String']>;
  skillLevelMaximum?: InputMaybe<Scalars['numeric']>;
  skillLevelMinimum?: InputMaybe<Scalars['numeric']>;
  slug?: InputMaybe<Scalars['String']>;
  tiktokUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<GroupTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  xUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "groups" */
export type GroupsSumOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "groups" */
export type GroupsVarPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "groups" */
export type GroupsVarSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "groups" */
export type GroupsVarianceOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  memberDisplayCount?: InputMaybe<OrderBy>;
  skillLevelMaximum?: InputMaybe<OrderBy>;
  skillLevelMinimum?: InputMaybe<OrderBy>;
};

/** columns and relationships of "identity_verification_providers" */
export type IdentityVerificationProviders = {
  __typename?: 'IdentityVerificationProviders';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "identity_verification_providers". All fields are combined with a logical 'AND'. */
export type IdentityVerificationProvidersBoolExp = {
  _and?: InputMaybe<Array<IdentityVerificationProvidersBoolExp>>;
  _not?: InputMaybe<IdentityVerificationProvidersBoolExp>;
  _or?: InputMaybe<Array<IdentityVerificationProvidersBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum IdentityVerificationProvidersEnum {
  /** Facebook account linked to the player's Bounce account. */
  Facebook = 'FACEBOOK',
  /** Government ID + selfie, checked by Stripe Identity. */
  StripeIdentity = 'STRIPE_IDENTITY'
}

/** Boolean expression to compare columns of type "IdentityVerificationProvidersEnum". All fields are combined with logical 'AND'. */
export type IdentityVerificationProvidersEnumComparisonExp = {
  _eq?: InputMaybe<IdentityVerificationProvidersEnum>;
  _in?: InputMaybe<Array<IdentityVerificationProvidersEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<IdentityVerificationProvidersEnum>;
  _nin?: InputMaybe<Array<IdentityVerificationProvidersEnum>>;
};

/** Ordering options when selecting data from "identity_verification_providers". */
export type IdentityVerificationProvidersOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "identity_verification_providers" */
export enum IdentityVerificationProvidersSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "identity_verification_providers" */
export type IdentityVerificationProvidersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IdentityVerificationProvidersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdentityVerificationProvidersStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "identity_verification_statuses" */
export type IdentityVerificationStatuses = {
  __typename?: 'IdentityVerificationStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "identity_verification_statuses". All fields are combined with a logical 'AND'. */
export type IdentityVerificationStatusesBoolExp = {
  _and?: InputMaybe<Array<IdentityVerificationStatusesBoolExp>>;
  _not?: InputMaybe<IdentityVerificationStatusesBoolExp>;
  _or?: InputMaybe<Array<IdentityVerificationStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum IdentityVerificationStatusesEnum {
  Failed = 'FAILED',
  NeedsReview = 'NEEDS_REVIEW',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Verified = 'VERIFIED'
}

/** Boolean expression to compare columns of type "IdentityVerificationStatusesEnum". All fields are combined with logical 'AND'. */
export type IdentityVerificationStatusesEnumComparisonExp = {
  _eq?: InputMaybe<IdentityVerificationStatusesEnum>;
  _in?: InputMaybe<Array<IdentityVerificationStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<IdentityVerificationStatusesEnum>;
  _nin?: InputMaybe<Array<IdentityVerificationStatusesEnum>>;
};

/** Ordering options when selecting data from "identity_verification_statuses". */
export type IdentityVerificationStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "identity_verification_statuses" */
export enum IdentityVerificationStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "identity_verification_statuses" */
export type IdentityVerificationStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IdentityVerificationStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdentityVerificationStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** columns and relationships of "invoices" */
export type Invoices = {
  __typename?: 'Invoices';
  amountDue: Scalars['numeric'];
  amountPaid: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalInvoiceId: Scalars['String'];
  externalSubscriptionId: Scalars['String'];
  id: Scalars['uuid'];
  paid: Scalars['Boolean'];
  peerSubscriptionId?: Maybe<Scalars['uuid']>;
  periodEnd: Scalars['timestamptz'];
  periodStart: Scalars['timestamptz'];
  /** An object relationship */
  platformSubscription?: Maybe<PlatformSubscriptions>;
  platformSubscriptionId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "invoices" */
export type InvoicesAggregateOrderBy = {
  avg?: InputMaybe<InvoicesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InvoicesMaxOrderBy>;
  min?: InputMaybe<InvoicesMinOrderBy>;
  stddev?: InputMaybe<InvoicesStddevOrderBy>;
  stddevPop?: InputMaybe<InvoicesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<InvoicesStddevSampOrderBy>;
  sum?: InputMaybe<InvoicesSumOrderBy>;
  varPop?: InputMaybe<InvoicesVarPopOrderBy>;
  varSamp?: InputMaybe<InvoicesVarSampOrderBy>;
  variance?: InputMaybe<InvoicesVarianceOrderBy>;
};

/** order by avg() on columns of table "invoices" */
export type InvoicesAvgOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "invoices". All fields are combined with a logical 'AND'. */
export type InvoicesBoolExp = {
  _and?: InputMaybe<Array<InvoicesBoolExp>>;
  _not?: InputMaybe<InvoicesBoolExp>;
  _or?: InputMaybe<Array<InvoicesBoolExp>>;
  amountDue?: InputMaybe<NumericComparisonExp>;
  amountPaid?: InputMaybe<NumericComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  externalInvoiceId?: InputMaybe<StringComparisonExp>;
  externalSubscriptionId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  paid?: InputMaybe<BooleanComparisonExp>;
  peerSubscriptionId?: InputMaybe<UuidComparisonExp>;
  periodEnd?: InputMaybe<TimestamptzComparisonExp>;
  periodStart?: InputMaybe<TimestamptzComparisonExp>;
  platformSubscription?: InputMaybe<PlatformSubscriptionsBoolExp>;
  platformSubscriptionId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "invoices" */
export type InvoicesMaxOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalInvoiceId?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  peerSubscriptionId?: InputMaybe<OrderBy>;
  periodEnd?: InputMaybe<OrderBy>;
  periodStart?: InputMaybe<OrderBy>;
  platformSubscriptionId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "invoices" */
export type InvoicesMinOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalInvoiceId?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  peerSubscriptionId?: InputMaybe<OrderBy>;
  periodEnd?: InputMaybe<OrderBy>;
  periodStart?: InputMaybe<OrderBy>;
  platformSubscriptionId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "invoices". */
export type InvoicesOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalInvoiceId?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  paid?: InputMaybe<OrderBy>;
  peerSubscriptionId?: InputMaybe<OrderBy>;
  periodEnd?: InputMaybe<OrderBy>;
  periodStart?: InputMaybe<OrderBy>;
  platformSubscription?: InputMaybe<PlatformSubscriptionsOrderBy>;
  platformSubscriptionId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "invoices" */
export enum InvoicesSelectColumn {
  /** column name */
  AmountDue = 'amountDue',
  /** column name */
  AmountPaid = 'amountPaid',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalInvoiceId = 'externalInvoiceId',
  /** column name */
  ExternalSubscriptionId = 'externalSubscriptionId',
  /** column name */
  Id = 'id',
  /** column name */
  Paid = 'paid',
  /** column name */
  PeerSubscriptionId = 'peerSubscriptionId',
  /** column name */
  PeriodEnd = 'periodEnd',
  /** column name */
  PeriodStart = 'periodStart',
  /** column name */
  PlatformSubscriptionId = 'platformSubscriptionId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** order by stddev() on columns of table "invoices" */
export type InvoicesStddevOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "invoices" */
export type InvoicesStddevPopOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "invoices" */
export type InvoicesStddevSampOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "invoices" */
export type InvoicesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoicesStreamCursorValueInput = {
  amountDue?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalInvoiceId?: InputMaybe<Scalars['String']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  peerSubscriptionId?: InputMaybe<Scalars['uuid']>;
  periodEnd?: InputMaybe<Scalars['timestamptz']>;
  periodStart?: InputMaybe<Scalars['timestamptz']>;
  platformSubscriptionId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "invoices" */
export type InvoicesSumOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "invoices" */
export type InvoicesVarPopOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "invoices" */
export type InvoicesVarSampOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "invoices" */
export type InvoicesVarianceOrderBy = {
  amountDue?: InputMaybe<OrderBy>;
  amountPaid?: InputMaybe<OrderBy>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _containedIn?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _hasKey?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** Tracks when a user watched each media category (lesson, drill, etc.) per schedule progress. Row exists with watched_at set = watched. */
export type LearningProgramEnrollmentScheduleMediaWatched = {
  __typename?: 'LearningProgramEnrollmentScheduleMediaWatched';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  learningProgramEnrollmentScheduleProgress: LearningProgramEnrollmentScheduleProgress;
  learningProgramEnrollmentScheduleProgressId: Scalars['uuid'];
  /** An object relationship */
  mediaCategory: LearningProgramMediaCategories;
  mediaCategoryId: Scalars['uuid'];
  watchedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedMaxOrderBy>;
  min?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedMinOrderBy>;
};

/** input type for inserting array relation for remote table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedArrRelInsertInput = {
  data: Array<LearningProgramEnrollmentScheduleMediaWatchedInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedOnConflict>;
};

/** Boolean expression to filter rows from the table "learning_program_enrollment_schedule_media_watched". All fields are combined with a logical 'AND'. */
export type LearningProgramEnrollmentScheduleMediaWatchedBoolExp = {
  _and?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>>;
  _not?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
  _or?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  learningProgramEnrollmentScheduleProgress?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
  learningProgramEnrollmentScheduleProgressId?: InputMaybe<UuidComparisonExp>;
  mediaCategory?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
  mediaCategoryId?: InputMaybe<UuidComparisonExp>;
  watchedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "learning_program_enrollment_schedule_media_watched" */
export enum LearningProgramEnrollmentScheduleMediaWatchedConstraint {
  /** unique or primary key constraint on columns "id" */
  LearningProgramEnrollmentScheduleMediaWatchedPkey = 'learning_program_enrollment_schedule_media_watched_pkey',
  /** unique or primary key constraint on columns "learning_program_enrollment_schedule_progress_id", "media_category_id" */
  UqEnrollmentScheduleMediaWatchedProgressCategory = 'uq_enrollment_schedule_media_watched_progress_category'
}

/** input type for inserting data into table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedInsertInput = {
  learningProgramEnrollmentScheduleProgress?: InputMaybe<LearningProgramEnrollmentScheduleProgressObjRelInsertInput>;
  learningProgramEnrollmentScheduleProgressId?: InputMaybe<Scalars['uuid']>;
  mediaCategoryId?: InputMaybe<Scalars['uuid']>;
  watchedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollmentScheduleProgressId?: InputMaybe<OrderBy>;
  mediaCategoryId?: InputMaybe<OrderBy>;
  watchedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollmentScheduleProgressId?: InputMaybe<OrderBy>;
  mediaCategoryId?: InputMaybe<OrderBy>;
  watchedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedMutationResponse = {
  __typename?: 'LearningProgramEnrollmentScheduleMediaWatchedMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningProgramEnrollmentScheduleMediaWatched>;
};

/** on_conflict condition type for table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedOnConflict = {
  constraint: LearningProgramEnrollmentScheduleMediaWatchedConstraint;
  updateColumns?: Array<LearningProgramEnrollmentScheduleMediaWatchedUpdateColumn>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
};

/** Ordering options when selecting data from "learning_program_enrollment_schedule_media_watched". */
export type LearningProgramEnrollmentScheduleMediaWatchedOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollmentScheduleProgress?: InputMaybe<LearningProgramEnrollmentScheduleProgressOrderBy>;
  learningProgramEnrollmentScheduleProgressId?: InputMaybe<OrderBy>;
  mediaCategory?: InputMaybe<LearningProgramMediaCategoriesOrderBy>;
  mediaCategoryId?: InputMaybe<OrderBy>;
  watchedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: learning_program_enrollment_schedule_media_watched */
export type LearningProgramEnrollmentScheduleMediaWatchedPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "learning_program_enrollment_schedule_media_watched" */
export enum LearningProgramEnrollmentScheduleMediaWatchedSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramEnrollmentScheduleProgressId = 'learningProgramEnrollmentScheduleProgressId',
  /** column name */
  MediaCategoryId = 'mediaCategoryId',
  /** column name */
  WatchedAt = 'watchedAt'
}

/** input type for updating data in table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedSetInput = {
  watchedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "learning_program_enrollment_schedule_media_watched" */
export type LearningProgramEnrollmentScheduleMediaWatchedStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramEnrollmentScheduleMediaWatchedStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramEnrollmentScheduleMediaWatchedStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramEnrollmentScheduleProgressId?: InputMaybe<Scalars['uuid']>;
  mediaCategoryId?: InputMaybe<Scalars['uuid']>;
  watchedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "learning_program_enrollment_schedule_media_watched" */
export enum LearningProgramEnrollmentScheduleMediaWatchedUpdateColumn {
  /** column name */
  WatchedAt = 'watchedAt'
}

export type LearningProgramEnrollmentScheduleMediaWatchedUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedSetInput>;
  /** filter the rows which have to be updated */
  where: LearningProgramEnrollmentScheduleMediaWatchedBoolExp;
};

/** Detailed progress tracking for each schedule period of an enrollment */
export type LearningProgramEnrollmentScheduleProgress = {
  __typename?: 'LearningProgramEnrollmentScheduleProgress';
  completedAt?: Maybe<Scalars['date']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  learningProgramEnrollment: LearningProgramEnrollments;
  learningProgramEnrollmentId: Scalars['uuid'];
  /** An object relationship */
  learningProgramSchedule: LearningProgramSchedules;
  learningProgramScheduleId: Scalars['uuid'];
  /** An array relationship */
  mediaWatched: Array<LearningProgramEnrollmentScheduleMediaWatched>;
  scheduleNumber: Scalars['Int'];
};


/** Detailed progress tracking for each schedule period of an enrollment */
export type LearningProgramEnrollmentScheduleProgressMediaWatchedArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
};

/** order by aggregate values of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressAggregateOrderBy = {
  avg?: InputMaybe<LearningProgramEnrollmentScheduleProgressAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LearningProgramEnrollmentScheduleProgressMaxOrderBy>;
  min?: InputMaybe<LearningProgramEnrollmentScheduleProgressMinOrderBy>;
  stddev?: InputMaybe<LearningProgramEnrollmentScheduleProgressStddevOrderBy>;
  stddevPop?: InputMaybe<LearningProgramEnrollmentScheduleProgressStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LearningProgramEnrollmentScheduleProgressStddevSampOrderBy>;
  sum?: InputMaybe<LearningProgramEnrollmentScheduleProgressSumOrderBy>;
  varPop?: InputMaybe<LearningProgramEnrollmentScheduleProgressVarPopOrderBy>;
  varSamp?: InputMaybe<LearningProgramEnrollmentScheduleProgressVarSampOrderBy>;
  variance?: InputMaybe<LearningProgramEnrollmentScheduleProgressVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressArrRelInsertInput = {
  data: Array<LearningProgramEnrollmentScheduleProgressInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramEnrollmentScheduleProgressOnConflict>;
};

/** order by avg() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressAvgOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "learning_program_enrollment_schedule_progress". All fields are combined with a logical 'AND'. */
export type LearningProgramEnrollmentScheduleProgressBoolExp = {
  _and?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressBoolExp>>;
  _not?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
  _or?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressBoolExp>>;
  completedAt?: InputMaybe<DateComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  learningProgramEnrollment?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
  learningProgramEnrollmentId?: InputMaybe<UuidComparisonExp>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesBoolExp>;
  learningProgramScheduleId?: InputMaybe<UuidComparisonExp>;
  mediaWatched?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
  scheduleNumber?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "learning_program_enrollment_schedule_progress" */
export enum LearningProgramEnrollmentScheduleProgressConstraint {
  /** unique or primary key constraint on columns "id" */
  LearningProgramEnrollmentScheduleProgressPkey = 'learning_program_enrollment_schedule_progress_pkey',
  /** unique or primary key constraint on columns "learning_program_enrollment_id", "learning_program_schedule_id" */
  UqEnrollmentScheduleProgressEnrollmentSchedule = 'uq_enrollment_schedule_progress_enrollment_schedule'
}

/** input type for incrementing numeric columns in table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressIncInput = {
  scheduleNumber?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressInsertInput = {
  learningProgramEnrollment?: InputMaybe<LearningProgramEnrollmentsObjRelInsertInput>;
  learningProgramEnrollmentId?: InputMaybe<Scalars['uuid']>;
  learningProgramScheduleId?: InputMaybe<Scalars['uuid']>;
  mediaWatched?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedArrRelInsertInput>;
  scheduleNumber?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressMaxOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollmentId?: InputMaybe<OrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressMinOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollmentId?: InputMaybe<OrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressMutationResponse = {
  __typename?: 'LearningProgramEnrollmentScheduleProgressMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningProgramEnrollmentScheduleProgress>;
};

/** input type for inserting object relation for remote table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressObjRelInsertInput = {
  data: LearningProgramEnrollmentScheduleProgressInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramEnrollmentScheduleProgressOnConflict>;
};

/** on_conflict condition type for table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressOnConflict = {
  constraint: LearningProgramEnrollmentScheduleProgressConstraint;
  updateColumns?: Array<LearningProgramEnrollmentScheduleProgressUpdateColumn>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};

/** Ordering options when selecting data from "learning_program_enrollment_schedule_progress". */
export type LearningProgramEnrollmentScheduleProgressOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollment?: InputMaybe<LearningProgramEnrollmentsOrderBy>;
  learningProgramEnrollmentId?: InputMaybe<OrderBy>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesOrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  mediaWatchedAggregate?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedAggregateOrderBy>;
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: learning_program_enrollment_schedule_progress */
export type LearningProgramEnrollmentScheduleProgressPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "learning_program_enrollment_schedule_progress" */
export enum LearningProgramEnrollmentScheduleProgressSelectColumn {
  /** column name */
  CompletedAt = 'completedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramEnrollmentId = 'learningProgramEnrollmentId',
  /** column name */
  LearningProgramScheduleId = 'learningProgramScheduleId',
  /** column name */
  ScheduleNumber = 'scheduleNumber'
}

/** input type for updating data in table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressSetInput = {
  completedAt?: InputMaybe<Scalars['date']>;
  learningProgramEnrollmentId?: InputMaybe<Scalars['uuid']>;
  learningProgramScheduleId?: InputMaybe<Scalars['uuid']>;
  scheduleNumber?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressStddevOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressStddevPopOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressStddevSampOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramEnrollmentScheduleProgressStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramEnrollmentScheduleProgressStreamCursorValueInput = {
  completedAt?: InputMaybe<Scalars['date']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramEnrollmentId?: InputMaybe<Scalars['uuid']>;
  learningProgramScheduleId?: InputMaybe<Scalars['uuid']>;
  scheduleNumber?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressSumOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** update columns of table "learning_program_enrollment_schedule_progress" */
export enum LearningProgramEnrollmentScheduleProgressUpdateColumn {
  /** column name */
  CompletedAt = 'completedAt',
  /** column name */
  LearningProgramEnrollmentId = 'learningProgramEnrollmentId',
  /** column name */
  LearningProgramScheduleId = 'learningProgramScheduleId',
  /** column name */
  ScheduleNumber = 'scheduleNumber'
}

export type LearningProgramEnrollmentScheduleProgressUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LearningProgramEnrollmentScheduleProgressIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LearningProgramEnrollmentScheduleProgressSetInput>;
  /** filter the rows which have to be updated */
  where: LearningProgramEnrollmentScheduleProgressBoolExp;
};

/** order by varPop() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressVarPopOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressVarSampOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "learning_program_enrollment_schedule_progress" */
export type LearningProgramEnrollmentScheduleProgressVarianceOrderBy = {
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** Tracks which players are enrolled in which programs */
export type LearningProgramEnrollments = {
  __typename?: 'LearningProgramEnrollments';
  completedAt?: Maybe<Scalars['date']>;
  createdAt: Scalars['timestamptz'];
  /** Current schedule period the player is on */
  currentSchedule: Scalars['Int'];
  enrolledAt: Scalars['date'];
  id: Scalars['uuid'];
  /** An object relationship */
  learningProgram: LearningPrograms;
  learningProgramId: Scalars['uuid'];
  pausedAt?: Maybe<Scalars['date']>;
  /** An array relationship */
  scheduleProgress: Array<LearningProgramEnrollmentScheduleProgress>;
  status: Scalars['String'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An array relationship */
  videoSubmissions: Array<LearningProgramScheduleVideoSubmissions>;
};


/** Tracks which players are enrolled in which programs */
export type LearningProgramEnrollmentsScheduleProgressArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};


/** Tracks which players are enrolled in which programs */
export type LearningProgramEnrollmentsVideoSubmissionsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};

/** order by aggregate values of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsAggregateOrderBy = {
  avg?: InputMaybe<LearningProgramEnrollmentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LearningProgramEnrollmentsMaxOrderBy>;
  min?: InputMaybe<LearningProgramEnrollmentsMinOrderBy>;
  stddev?: InputMaybe<LearningProgramEnrollmentsStddevOrderBy>;
  stddevPop?: InputMaybe<LearningProgramEnrollmentsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LearningProgramEnrollmentsStddevSampOrderBy>;
  sum?: InputMaybe<LearningProgramEnrollmentsSumOrderBy>;
  varPop?: InputMaybe<LearningProgramEnrollmentsVarPopOrderBy>;
  varSamp?: InputMaybe<LearningProgramEnrollmentsVarSampOrderBy>;
  variance?: InputMaybe<LearningProgramEnrollmentsVarianceOrderBy>;
};

/** order by avg() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsAvgOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "learning_program_enrollments". All fields are combined with a logical 'AND'. */
export type LearningProgramEnrollmentsBoolExp = {
  _and?: InputMaybe<Array<LearningProgramEnrollmentsBoolExp>>;
  _not?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
  _or?: InputMaybe<Array<LearningProgramEnrollmentsBoolExp>>;
  completedAt?: InputMaybe<DateComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currentSchedule?: InputMaybe<IntComparisonExp>;
  enrolledAt?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  learningProgram?: InputMaybe<LearningProgramsBoolExp>;
  learningProgramId?: InputMaybe<UuidComparisonExp>;
  pausedAt?: InputMaybe<DateComparisonExp>;
  scheduleProgress?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  videoSubmissions?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};

/** unique or primary key constraints on table "learning_program_enrollments" */
export enum LearningProgramEnrollmentsConstraint {
  /** unique or primary key constraint on columns "id" */
  LearningProgramEnrollmentsPkey = 'learning_program_enrollments_pkey',
  /** unique or primary key constraint on columns "learning_program_id", "user_id" */
  UqLearningProgramEnrollmentsProgramUser = 'uq_learning_program_enrollments_program_user'
}

/** input type for inserting data into table "learning_program_enrollments" */
export type LearningProgramEnrollmentsInsertInput = {
  completedAt?: InputMaybe<Scalars['date']>;
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<Scalars['Int']>;
  enrolledAt?: InputMaybe<Scalars['date']>;
  learningProgramId?: InputMaybe<Scalars['uuid']>;
  pausedAt?: InputMaybe<Scalars['date']>;
  scheduleProgress?: InputMaybe<LearningProgramEnrollmentScheduleProgressArrRelInsertInput>;
  status?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsMaxOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
  enrolledAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
  pausedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsMinOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
  enrolledAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
  pausedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "learning_program_enrollments" */
export type LearningProgramEnrollmentsMutationResponse = {
  __typename?: 'LearningProgramEnrollmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LearningProgramEnrollments>;
};

/** input type for inserting object relation for remote table "learning_program_enrollments" */
export type LearningProgramEnrollmentsObjRelInsertInput = {
  data: LearningProgramEnrollmentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LearningProgramEnrollmentsOnConflict>;
};

/** on_conflict condition type for table "learning_program_enrollments" */
export type LearningProgramEnrollmentsOnConflict = {
  constraint: LearningProgramEnrollmentsConstraint;
  updateColumns?: Array<LearningProgramEnrollmentsUpdateColumn>;
  where?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
};

/** Ordering options when selecting data from "learning_program_enrollments". */
export type LearningProgramEnrollmentsOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currentSchedule?: InputMaybe<OrderBy>;
  enrolledAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgram?: InputMaybe<LearningProgramsOrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
  pausedAt?: InputMaybe<OrderBy>;
  scheduleProgressAggregate?: InputMaybe<LearningProgramEnrollmentScheduleProgressAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  videoSubmissionsAggregate?: InputMaybe<LearningProgramScheduleVideoSubmissionsAggregateOrderBy>;
};

/** select columns of table "learning_program_enrollments" */
export enum LearningProgramEnrollmentsSelectColumn {
  /** column name */
  CompletedAt = 'completedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentSchedule = 'currentSchedule',
  /** column name */
  EnrolledAt = 'enrolledAt',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramId = 'learningProgramId',
  /** column name */
  PausedAt = 'pausedAt',
  /** column name */
  Status = 'status',
  /** column name */
  UserId = 'userId'
}

/** order by stddev() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsStddevOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsStddevPopOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsStddevSampOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "learning_program_enrollments" */
export type LearningProgramEnrollmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramEnrollmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramEnrollmentsStreamCursorValueInput = {
  completedAt?: InputMaybe<Scalars['date']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<Scalars['Int']>;
  enrolledAt?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramId?: InputMaybe<Scalars['uuid']>;
  pausedAt?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsSumOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "learning_program_enrollments" (current role has no relevant permissions) */
export enum LearningProgramEnrollmentsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by varPop() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsVarPopOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsVarSampOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "learning_program_enrollments" */
export type LearningProgramEnrollmentsVarianceOrderBy = {
  /** Current schedule period the player is on */
  currentSchedule?: InputMaybe<OrderBy>;
};

/** Media table for storing learning program video and image files */
export type LearningProgramMedia = {
  __typename?: 'LearningProgramMedia';
  createdAt: Scalars['timestamptz'];
  fileCategory: Scalars['String'];
  fileFormat: Scalars['String'];
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  host: Scalars['String'];
  id: Scalars['uuid'];
  originalFileName?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  providerId: Scalars['String'];
  providerUrl: Scalars['String'];
  /** An array relationship */
  scheduleMedia: Array<LearningProgramScheduleMedia>;
  url: Scalars['String'];
  /** An object relationship */
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['uuid']>;
};


/** Media table for storing learning program video and image files */
export type LearningProgramMediaScheduleMediaArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleMediaOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};

/** Boolean expression to filter rows from the table "learning_program_media". All fields are combined with a logical 'AND'. */
export type LearningProgramMediaBoolExp = {
  _and?: InputMaybe<Array<LearningProgramMediaBoolExp>>;
  _not?: InputMaybe<LearningProgramMediaBoolExp>;
  _or?: InputMaybe<Array<LearningProgramMediaBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  fileCategory?: InputMaybe<StringComparisonExp>;
  fileFormat?: InputMaybe<StringComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileType?: InputMaybe<StringComparisonExp>;
  host?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  originalFileName?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  scheduleMedia?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
  url?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** Enum table for program schedule media categories (lesson, drill) */
export type LearningProgramMediaCategories = {
  __typename?: 'LearningProgramMediaCategories';
  code: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  orderIndex: Scalars['Int'];
};

/** Boolean expression to filter rows from the table "learning_program_media_categories". All fields are combined with a logical 'AND'. */
export type LearningProgramMediaCategoriesBoolExp = {
  _and?: InputMaybe<Array<LearningProgramMediaCategoriesBoolExp>>;
  _not?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
  _or?: InputMaybe<Array<LearningProgramMediaCategoriesBoolExp>>;
  code?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  orderIndex?: InputMaybe<IntComparisonExp>;
};

/** Ordering options when selecting data from "learning_program_media_categories". */
export type LearningProgramMediaCategoriesOrderBy = {
  code?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  orderIndex?: InputMaybe<OrderBy>;
};

/** select columns of table "learning_program_media_categories" */
export enum LearningProgramMediaCategoriesSelectColumn {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrderIndex = 'orderIndex'
}

/** Streaming cursor of the table "learning_program_media_categories" */
export type LearningProgramMediaCategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramMediaCategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramMediaCategoriesStreamCursorValueInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  orderIndex?: InputMaybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "learning_program_media". */
export type LearningProgramMediaOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  fileCategory?: InputMaybe<OrderBy>;
  fileFormat?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  scheduleMediaAggregate?: InputMaybe<LearningProgramScheduleMediaAggregateOrderBy>;
  url?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "learning_program_media" */
export enum LearningProgramMediaSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "learning_program_media" */
export type LearningProgramMediaStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramMediaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramMediaStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<Scalars['String']>;
  fileFormat?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Links multiple lesson/drill videos to each schedule period */
export type LearningProgramScheduleMedia = {
  __typename?: 'LearningProgramScheduleMedia';
  id: Scalars['uuid'];
  /** An object relationship */
  learningProgramSchedule: LearningProgramSchedules;
  learningProgramScheduleId: Scalars['uuid'];
  /** An object relationship */
  media: LearningProgramMedia;
  /** An object relationship */
  mediaCategory: LearningProgramMediaCategories;
  mediaCategoryId: Scalars['uuid'];
  mediaId: Scalars['uuid'];
  /** Order within the media category */
  orderIndex: Scalars['Int'];
};

/** order by aggregate values of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaAggregateOrderBy = {
  avg?: InputMaybe<LearningProgramScheduleMediaAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LearningProgramScheduleMediaMaxOrderBy>;
  min?: InputMaybe<LearningProgramScheduleMediaMinOrderBy>;
  stddev?: InputMaybe<LearningProgramScheduleMediaStddevOrderBy>;
  stddevPop?: InputMaybe<LearningProgramScheduleMediaStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LearningProgramScheduleMediaStddevSampOrderBy>;
  sum?: InputMaybe<LearningProgramScheduleMediaSumOrderBy>;
  varPop?: InputMaybe<LearningProgramScheduleMediaVarPopOrderBy>;
  varSamp?: InputMaybe<LearningProgramScheduleMediaVarSampOrderBy>;
  variance?: InputMaybe<LearningProgramScheduleMediaVarianceOrderBy>;
};

/** order by avg() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaAvgOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "learning_program_schedule_media". All fields are combined with a logical 'AND'. */
export type LearningProgramScheduleMediaBoolExp = {
  _and?: InputMaybe<Array<LearningProgramScheduleMediaBoolExp>>;
  _not?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
  _or?: InputMaybe<Array<LearningProgramScheduleMediaBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesBoolExp>;
  learningProgramScheduleId?: InputMaybe<UuidComparisonExp>;
  media?: InputMaybe<LearningProgramMediaBoolExp>;
  mediaCategory?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
  mediaCategoryId?: InputMaybe<UuidComparisonExp>;
  mediaId?: InputMaybe<UuidComparisonExp>;
  orderIndex?: InputMaybe<IntComparisonExp>;
};

/** order by max() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  mediaCategoryId?: InputMaybe<OrderBy>;
  mediaId?: InputMaybe<OrderBy>;
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  mediaCategoryId?: InputMaybe<OrderBy>;
  mediaId?: InputMaybe<OrderBy>;
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "learning_program_schedule_media". */
export type LearningProgramScheduleMediaOrderBy = {
  id?: InputMaybe<OrderBy>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesOrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  media?: InputMaybe<LearningProgramMediaOrderBy>;
  mediaCategory?: InputMaybe<LearningProgramMediaCategoriesOrderBy>;
  mediaCategoryId?: InputMaybe<OrderBy>;
  mediaId?: InputMaybe<OrderBy>;
  orderIndex?: InputMaybe<OrderBy>;
};

/** select columns of table "learning_program_schedule_media" */
export enum LearningProgramScheduleMediaSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramScheduleId = 'learningProgramScheduleId',
  /** column name */
  MediaCategoryId = 'mediaCategoryId',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  OrderIndex = 'orderIndex'
}

/** order by stddev() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaStddevOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaStddevPopOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaStddevSampOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramScheduleMediaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramScheduleMediaStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramScheduleId?: InputMaybe<Scalars['uuid']>;
  mediaCategoryId?: InputMaybe<Scalars['uuid']>;
  mediaId?: InputMaybe<Scalars['uuid']>;
  /** Order within the media category */
  orderIndex?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaSumOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaVarPopOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaVarSampOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "learning_program_schedule_media" */
export type LearningProgramScheduleMediaVarianceOrderBy = {
  /** Order within the media category */
  orderIndex?: InputMaybe<OrderBy>;
};

/** days, weeks, months. */
export type LearningProgramScheduleUnits = {
  __typename?: 'LearningProgramScheduleUnits';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "learning_program_schedule_units". All fields are combined with a logical 'AND'. */
export type LearningProgramScheduleUnitsBoolExp = {
  _and?: InputMaybe<Array<LearningProgramScheduleUnitsBoolExp>>;
  _not?: InputMaybe<LearningProgramScheduleUnitsBoolExp>;
  _or?: InputMaybe<Array<LearningProgramScheduleUnitsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum LearningProgramScheduleUnitsEnum {
  /** Daily schedule periods */
  Day = 'DAY',
  /** Monthly schedule periods */
  Month = 'MONTH',
  /** Weekly schedule periods */
  Week = 'WEEK'
}

/** Boolean expression to compare columns of type "LearningProgramScheduleUnitsEnum". All fields are combined with logical 'AND'. */
export type LearningProgramScheduleUnitsEnumComparisonExp = {
  _eq?: InputMaybe<LearningProgramScheduleUnitsEnum>;
  _in?: InputMaybe<Array<LearningProgramScheduleUnitsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LearningProgramScheduleUnitsEnum>;
  _nin?: InputMaybe<Array<LearningProgramScheduleUnitsEnum>>;
};

/** Ordering options when selecting data from "learning_program_schedule_units". */
export type LearningProgramScheduleUnitsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "learning_program_schedule_units" */
export enum LearningProgramScheduleUnitsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "learning_program_schedule_units" */
export type LearningProgramScheduleUnitsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramScheduleUnitsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramScheduleUnitsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Player video submissions linked to existing video analysis system */
export type LearningProgramScheduleVideoSubmissions = {
  __typename?: 'LearningProgramScheduleVideoSubmissions';
  id: Scalars['uuid'];
  /** An object relationship */
  learningProgramEnrollment: LearningProgramEnrollments;
  /** An object relationship */
  learningProgramSchedule: LearningProgramSchedules;
  learningProgramScheduleId: Scalars['uuid'];
  /** An object relationship */
  videoAnalysis?: Maybe<VideoAnalysis>;
  /** One-to-one link to video_analysis table */
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by aggregate values of table "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LearningProgramScheduleVideoSubmissionsMaxOrderBy>;
  min?: InputMaybe<LearningProgramScheduleVideoSubmissionsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "learning_program_schedule_video_submissions". All fields are combined with a logical 'AND'. */
export type LearningProgramScheduleVideoSubmissionsBoolExp = {
  _and?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsBoolExp>>;
  _not?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
  _or?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  learningProgramEnrollment?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesBoolExp>;
  learningProgramScheduleId?: InputMaybe<UuidComparisonExp>;
  videoAnalysis?: InputMaybe<VideoAnalysisBoolExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  /** One-to-one link to video_analysis table */
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  /** One-to-one link to video_analysis table */
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "learning_program_schedule_video_submissions". */
export type LearningProgramScheduleVideoSubmissionsOrderBy = {
  id?: InputMaybe<OrderBy>;
  learningProgramEnrollment?: InputMaybe<LearningProgramEnrollmentsOrderBy>;
  learningProgramSchedule?: InputMaybe<LearningProgramSchedulesOrderBy>;
  learningProgramScheduleId?: InputMaybe<OrderBy>;
  videoAnalysis?: InputMaybe<VideoAnalysisOrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** select columns of table "learning_program_schedule_video_submissions" */
export enum LearningProgramScheduleVideoSubmissionsSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramScheduleId = 'learningProgramScheduleId',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

/** Streaming cursor of the table "learning_program_schedule_video_submissions" */
export type LearningProgramScheduleVideoSubmissionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramScheduleVideoSubmissionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramScheduleVideoSubmissionsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramScheduleId?: InputMaybe<Scalars['uuid']>;
  /** One-to-one link to video_analysis table */
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** Individual schedule periods within a learning program */
export type LearningProgramSchedules = {
  __typename?: 'LearningProgramSchedules';
  commonMistakes?: Maybe<Scalars['String']>;
  /** An array relationship */
  enrollmentProgress: Array<LearningProgramEnrollmentScheduleProgress>;
  /** Component 1: What technique fundamentals to work on */
  focus?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  learningProgram: LearningPrograms;
  learningProgramId: Scalars['uuid'];
  /** Component 2: What the player should achieve */
  lessonObjective?: Maybe<Scalars['String']>;
  /** An array relationship */
  media: Array<LearningProgramScheduleMedia>;
  /** Component 3: Structured drills and exercises */
  practicePlan?: Maybe<Scalars['String']>;
  /** An object relationship */
  primarySkill?: Maybe<LessonSkills>;
  primarySkillId?: Maybe<LessonSkillsEnum>;
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber: Scalars['Int'];
  title: Scalars['String'];
  /** An array relationship */
  videoSubmissions: Array<LearningProgramScheduleVideoSubmissions>;
};


/** Individual schedule periods within a learning program */
export type LearningProgramSchedulesEnrollmentProgressArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};


/** Individual schedule periods within a learning program */
export type LearningProgramSchedulesMediaArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleMediaOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};


/** Individual schedule periods within a learning program */
export type LearningProgramSchedulesVideoSubmissionsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};

/** order by aggregate values of table "learning_program_schedules" */
export type LearningProgramSchedulesAggregateOrderBy = {
  avg?: InputMaybe<LearningProgramSchedulesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LearningProgramSchedulesMaxOrderBy>;
  min?: InputMaybe<LearningProgramSchedulesMinOrderBy>;
  stddev?: InputMaybe<LearningProgramSchedulesStddevOrderBy>;
  stddevPop?: InputMaybe<LearningProgramSchedulesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LearningProgramSchedulesStddevSampOrderBy>;
  sum?: InputMaybe<LearningProgramSchedulesSumOrderBy>;
  varPop?: InputMaybe<LearningProgramSchedulesVarPopOrderBy>;
  varSamp?: InputMaybe<LearningProgramSchedulesVarSampOrderBy>;
  variance?: InputMaybe<LearningProgramSchedulesVarianceOrderBy>;
};

/** order by avg() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesAvgOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "learning_program_schedules". All fields are combined with a logical 'AND'. */
export type LearningProgramSchedulesBoolExp = {
  _and?: InputMaybe<Array<LearningProgramSchedulesBoolExp>>;
  _not?: InputMaybe<LearningProgramSchedulesBoolExp>;
  _or?: InputMaybe<Array<LearningProgramSchedulesBoolExp>>;
  commonMistakes?: InputMaybe<StringComparisonExp>;
  enrollmentProgress?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
  focus?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  learningProgram?: InputMaybe<LearningProgramsBoolExp>;
  learningProgramId?: InputMaybe<UuidComparisonExp>;
  lessonObjective?: InputMaybe<StringComparisonExp>;
  media?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
  practicePlan?: InputMaybe<StringComparisonExp>;
  primarySkill?: InputMaybe<LessonSkillsBoolExp>;
  primarySkillId?: InputMaybe<LessonSkillsEnumComparisonExp>;
  scheduleNumber?: InputMaybe<IntComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  videoSubmissions?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};

/** order by max() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesMaxOrderBy = {
  commonMistakes?: InputMaybe<OrderBy>;
  /** Component 1: What technique fundamentals to work on */
  focus?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
  /** Component 2: What the player should achieve */
  lessonObjective?: InputMaybe<OrderBy>;
  /** Component 3: Structured drills and exercises */
  practicePlan?: InputMaybe<OrderBy>;
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesMinOrderBy = {
  commonMistakes?: InputMaybe<OrderBy>;
  /** Component 1: What technique fundamentals to work on */
  focus?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
  /** Component 2: What the player should achieve */
  lessonObjective?: InputMaybe<OrderBy>;
  /** Component 3: Structured drills and exercises */
  practicePlan?: InputMaybe<OrderBy>;
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "learning_program_schedules". */
export type LearningProgramSchedulesOrderBy = {
  commonMistakes?: InputMaybe<OrderBy>;
  enrollmentProgressAggregate?: InputMaybe<LearningProgramEnrollmentScheduleProgressAggregateOrderBy>;
  focus?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgram?: InputMaybe<LearningProgramsOrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
  lessonObjective?: InputMaybe<OrderBy>;
  mediaAggregate?: InputMaybe<LearningProgramScheduleMediaAggregateOrderBy>;
  practicePlan?: InputMaybe<OrderBy>;
  primarySkill?: InputMaybe<LessonSkillsOrderBy>;
  primarySkillId?: InputMaybe<OrderBy>;
  scheduleNumber?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  videoSubmissionsAggregate?: InputMaybe<LearningProgramScheduleVideoSubmissionsAggregateOrderBy>;
};

/** select columns of table "learning_program_schedules" */
export enum LearningProgramSchedulesSelectColumn {
  /** column name */
  CommonMistakes = 'commonMistakes',
  /** column name */
  Focus = 'focus',
  /** column name */
  Id = 'id',
  /** column name */
  LearningProgramId = 'learningProgramId',
  /** column name */
  LessonObjective = 'lessonObjective',
  /** column name */
  PracticePlan = 'practicePlan',
  /** column name */
  PrimarySkillId = 'primarySkillId',
  /** column name */
  ScheduleNumber = 'scheduleNumber',
  /** column name */
  Title = 'title'
}

/** order by stddev() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesStddevOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesStddevPopOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesStddevSampOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "learning_program_schedules" */
export type LearningProgramSchedulesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramSchedulesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramSchedulesStreamCursorValueInput = {
  commonMistakes?: InputMaybe<Scalars['String']>;
  /** Component 1: What technique fundamentals to work on */
  focus?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  learningProgramId?: InputMaybe<Scalars['uuid']>;
  /** Component 2: What the player should achieve */
  lessonObjective?: InputMaybe<Scalars['String']>;
  /** Component 3: Structured drills and exercises */
  practicePlan?: InputMaybe<Scalars['String']>;
  primarySkillId?: InputMaybe<LessonSkillsEnum>;
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesSumOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesVarPopOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesVarSampOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "learning_program_schedules" */
export type LearningProgramSchedulesVarianceOrderBy = {
  /** Sequential period number (1, 2, 3, etc.) */
  scheduleNumber?: InputMaybe<OrderBy>;
};

/** columns and relationships of "learning_program_skill_level_values" */
export type LearningProgramSkillLevelValues = {
  __typename?: 'LearningProgramSkillLevelValues';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "learning_program_skill_level_values". All fields are combined with a logical 'AND'. */
export type LearningProgramSkillLevelValuesBoolExp = {
  _and?: InputMaybe<Array<LearningProgramSkillLevelValuesBoolExp>>;
  _not?: InputMaybe<LearningProgramSkillLevelValuesBoolExp>;
  _or?: InputMaybe<Array<LearningProgramSkillLevelValuesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum LearningProgramSkillLevelValuesEnum {
  Advanced = 'ADVANCED',
  AllLevels = 'ALL_LEVELS',
  Beginner = 'BEGINNER',
  Intermediate = 'INTERMEDIATE'
}

/** Boolean expression to compare columns of type "LearningProgramSkillLevelValuesEnum". All fields are combined with logical 'AND'. */
export type LearningProgramSkillLevelValuesEnumComparisonExp = {
  _eq?: InputMaybe<LearningProgramSkillLevelValuesEnum>;
  _in?: InputMaybe<Array<LearningProgramSkillLevelValuesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LearningProgramSkillLevelValuesEnum>;
  _nin?: InputMaybe<Array<LearningProgramSkillLevelValuesEnum>>;
};

/** Ordering options when selecting data from "learning_program_skill_level_values". */
export type LearningProgramSkillLevelValuesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "learning_program_skill_level_values" */
export enum LearningProgramSkillLevelValuesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "learning_program_skill_level_values" */
export type LearningProgramSkillLevelValuesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramSkillLevelValuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramSkillLevelValuesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Maps programs to the skills they target */
export type LearningProgramSkills = {
  __typename?: 'LearningProgramSkills';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** Indicates the primary focus skill of the program */
  isPrimary: Scalars['Boolean'];
  /** An object relationship */
  learningProgram: LearningPrograms;
  learningProgramId: Scalars['uuid'];
  /** An object relationship */
  skill: LessonSkills;
  skillId: LessonSkillsEnum;
};

/** order by aggregate values of table "learning_program_skills" */
export type LearningProgramSkillsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LearningProgramSkillsMaxOrderBy>;
  min?: InputMaybe<LearningProgramSkillsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "learning_program_skills". All fields are combined with a logical 'AND'. */
export type LearningProgramSkillsBoolExp = {
  _and?: InputMaybe<Array<LearningProgramSkillsBoolExp>>;
  _not?: InputMaybe<LearningProgramSkillsBoolExp>;
  _or?: InputMaybe<Array<LearningProgramSkillsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPrimary?: InputMaybe<BooleanComparisonExp>;
  learningProgram?: InputMaybe<LearningProgramsBoolExp>;
  learningProgramId?: InputMaybe<UuidComparisonExp>;
  skill?: InputMaybe<LessonSkillsBoolExp>;
  skillId?: InputMaybe<LessonSkillsEnumComparisonExp>;
};

/** order by max() on columns of table "learning_program_skills" */
export type LearningProgramSkillsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "learning_program_skills" */
export type LearningProgramSkillsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "learning_program_skills". */
export type LearningProgramSkillsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isPrimary?: InputMaybe<OrderBy>;
  learningProgram?: InputMaybe<LearningProgramsOrderBy>;
  learningProgramId?: InputMaybe<OrderBy>;
  skill?: InputMaybe<LessonSkillsOrderBy>;
  skillId?: InputMaybe<OrderBy>;
};

/** select columns of table "learning_program_skills" */
export enum LearningProgramSkillsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'isPrimary',
  /** column name */
  LearningProgramId = 'learningProgramId',
  /** column name */
  SkillId = 'skillId'
}

/** Streaming cursor of the table "learning_program_skills" */
export type LearningProgramSkillsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramSkillsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramSkillsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Indicates the primary focus skill of the program */
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  learningProgramId?: InputMaybe<Scalars['uuid']>;
  skillId?: InputMaybe<LessonSkillsEnum>;
};

/** Main container for all learning programs */
export type LearningPrograms = {
  __typename?: 'LearningPrograms';
  averageRating?: Maybe<Scalars['numeric']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  enrollments: Array<LearningProgramEnrollments>;
  id: Scalars['uuid'];
  /** Whether the program is published and visible to players */
  isPublished: Scalars['Boolean'];
  scheduleUnit: LearningProgramScheduleUnitsEnum;
  /** An array relationship */
  schedules: Array<LearningProgramSchedules>;
  /** An object relationship */
  skillLevel?: Maybe<LearningProgramSkillLevelValues>;
  skillLevelId?: Maybe<LearningProgramSkillLevelValuesEnum>;
  /** An array relationship */
  skills: Array<LearningProgramSkills>;
  /** An object relationship */
  sport: Sports;
  sportId: SportsEnum;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  totalEnrollments: Scalars['Int'];
  /** Total number of schedule periods in the program */
  totalSchedules: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};


/** Main container for all learning programs */
export type LearningProgramsEnrollmentsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentsOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
};


/** Main container for all learning programs */
export type LearningProgramsSchedulesArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSchedulesOrderBy>>;
  where?: InputMaybe<LearningProgramSchedulesBoolExp>;
};


/** Main container for all learning programs */
export type LearningProgramsSkillsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillsOrderBy>>;
  where?: InputMaybe<LearningProgramSkillsBoolExp>;
};

/** aggregated selection of "learning_programs" */
export type LearningProgramsAggregate = {
  __typename?: 'LearningProgramsAggregate';
  aggregate?: Maybe<LearningProgramsAggregateFields>;
  nodes: Array<LearningPrograms>;
};

/** aggregate fields of "learning_programs" */
export type LearningProgramsAggregateFields = {
  __typename?: 'LearningProgramsAggregateFields';
  avg?: Maybe<LearningProgramsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LearningProgramsMaxFields>;
  min?: Maybe<LearningProgramsMinFields>;
  stddev?: Maybe<LearningProgramsStddevFields>;
  stddevPop?: Maybe<LearningProgramsStddevPopFields>;
  stddevSamp?: Maybe<LearningProgramsStddevSampFields>;
  sum?: Maybe<LearningProgramsSumFields>;
  varPop?: Maybe<LearningProgramsVarPopFields>;
  varSamp?: Maybe<LearningProgramsVarSampFields>;
  variance?: Maybe<LearningProgramsVarianceFields>;
};


/** aggregate fields of "learning_programs" */
export type LearningProgramsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LearningProgramsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type LearningProgramsAvgFields = {
  __typename?: 'LearningProgramsAvgFields';
  averageRating?: Maybe<Scalars['Float']>;
  totalEnrollments?: Maybe<Scalars['Float']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "learning_programs". All fields are combined with a logical 'AND'. */
export type LearningProgramsBoolExp = {
  _and?: InputMaybe<Array<LearningProgramsBoolExp>>;
  _not?: InputMaybe<LearningProgramsBoolExp>;
  _or?: InputMaybe<Array<LearningProgramsBoolExp>>;
  averageRating?: InputMaybe<NumericComparisonExp>;
  coverImageUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  enrollments?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPublished?: InputMaybe<BooleanComparisonExp>;
  scheduleUnit?: InputMaybe<LearningProgramScheduleUnitsEnumComparisonExp>;
  schedules?: InputMaybe<LearningProgramSchedulesBoolExp>;
  skillLevel?: InputMaybe<LearningProgramSkillLevelValuesBoolExp>;
  skillLevelId?: InputMaybe<LearningProgramSkillLevelValuesEnumComparisonExp>;
  skills?: InputMaybe<LearningProgramSkillsBoolExp>;
  sport?: InputMaybe<SportsBoolExp>;
  sportId?: InputMaybe<SportsEnumComparisonExp>;
  thumbnailUrl?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  totalEnrollments?: InputMaybe<IntComparisonExp>;
  totalSchedules?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** aggregate max on columns */
export type LearningProgramsMaxFields = {
  __typename?: 'LearningProgramsMaxFields';
  averageRating?: Maybe<Scalars['numeric']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalEnrollments?: Maybe<Scalars['Int']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type LearningProgramsMinFields = {
  __typename?: 'LearningProgramsMinFields';
  averageRating?: Maybe<Scalars['numeric']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalEnrollments?: Maybe<Scalars['Int']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "learning_programs". */
export type LearningProgramsOrderBy = {
  averageRating?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  enrollmentsAggregate?: InputMaybe<LearningProgramEnrollmentsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  isPublished?: InputMaybe<OrderBy>;
  scheduleUnit?: InputMaybe<OrderBy>;
  schedulesAggregate?: InputMaybe<LearningProgramSchedulesAggregateOrderBy>;
  skillLevel?: InputMaybe<LearningProgramSkillLevelValuesOrderBy>;
  skillLevelId?: InputMaybe<OrderBy>;
  skillsAggregate?: InputMaybe<LearningProgramSkillsAggregateOrderBy>;
  sport?: InputMaybe<SportsOrderBy>;
  sportId?: InputMaybe<OrderBy>;
  thumbnailUrl?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  totalEnrollments?: InputMaybe<OrderBy>;
  totalSchedules?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "learning_programs" */
export enum LearningProgramsSelectColumn {
  /** column name */
  AverageRating = 'averageRating',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'isPublished',
  /** column name */
  ScheduleUnit = 'scheduleUnit',
  /** column name */
  SkillLevelId = 'skillLevelId',
  /** column name */
  SportId = 'sportId',
  /** column name */
  ThumbnailUrl = 'thumbnailUrl',
  /** column name */
  Title = 'title',
  /** column name */
  TotalEnrollments = 'totalEnrollments',
  /** column name */
  TotalSchedules = 'totalSchedules',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** aggregate stddev on columns */
export type LearningProgramsStddevFields = {
  __typename?: 'LearningProgramsStddevFields';
  averageRating?: Maybe<Scalars['Float']>;
  totalEnrollments?: Maybe<Scalars['Float']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type LearningProgramsStddevPopFields = {
  __typename?: 'LearningProgramsStddevPopFields';
  averageRating?: Maybe<Scalars['Float']>;
  totalEnrollments?: Maybe<Scalars['Float']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type LearningProgramsStddevSampFields = {
  __typename?: 'LearningProgramsStddevSampFields';
  averageRating?: Maybe<Scalars['Float']>;
  totalEnrollments?: Maybe<Scalars['Float']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "learning_programs" */
export type LearningProgramsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LearningProgramsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LearningProgramsStreamCursorValueInput = {
  averageRating?: InputMaybe<Scalars['numeric']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Whether the program is published and visible to players */
  isPublished?: InputMaybe<Scalars['Boolean']>;
  scheduleUnit?: InputMaybe<LearningProgramScheduleUnitsEnum>;
  skillLevelId?: InputMaybe<LearningProgramSkillLevelValuesEnum>;
  sportId?: InputMaybe<SportsEnum>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalEnrollments?: InputMaybe<Scalars['Int']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LearningProgramsSumFields = {
  __typename?: 'LearningProgramsSumFields';
  averageRating?: Maybe<Scalars['numeric']>;
  totalEnrollments?: Maybe<Scalars['Int']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Int']>;
};

/** aggregate varPop on columns */
export type LearningProgramsVarPopFields = {
  __typename?: 'LearningProgramsVarPopFields';
  averageRating?: Maybe<Scalars['Float']>;
  totalEnrollments?: Maybe<Scalars['Float']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type LearningProgramsVarSampFields = {
  __typename?: 'LearningProgramsVarSampFields';
  averageRating?: Maybe<Scalars['Float']>;
  totalEnrollments?: Maybe<Scalars['Float']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LearningProgramsVarianceFields = {
  __typename?: 'LearningProgramsVarianceFields';
  averageRating?: Maybe<Scalars['Float']>;
  totalEnrollments?: Maybe<Scalars['Float']>;
  /** Total number of schedule periods in the program */
  totalSchedules?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "lesson_age_groups" */
export type LessonAgeGroups = {
  __typename?: 'LessonAgeGroups';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "lesson_age_groups". All fields are combined with a logical 'AND'. */
export type LessonAgeGroupsBoolExp = {
  _and?: InputMaybe<Array<LessonAgeGroupsBoolExp>>;
  _not?: InputMaybe<LessonAgeGroupsBoolExp>;
  _or?: InputMaybe<Array<LessonAgeGroupsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum LessonAgeGroupsEnum {
  Adult = 'ADULT',
  Senior = 'SENIOR',
  Youth = 'YOUTH'
}

/** Boolean expression to compare columns of type "LessonAgeGroupsEnum". All fields are combined with logical 'AND'. */
export type LessonAgeGroupsEnumComparisonExp = {
  _eq?: InputMaybe<LessonAgeGroupsEnum>;
  _in?: InputMaybe<Array<LessonAgeGroupsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonAgeGroupsEnum>;
  _nin?: InputMaybe<Array<LessonAgeGroupsEnum>>;
};

/** Ordering options when selecting data from "lesson_age_groups". */
export type LessonAgeGroupsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_age_groups" */
export enum LessonAgeGroupsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "lesson_age_groups" */
export type LessonAgeGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonAgeGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonAgeGroupsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "lesson_collections" */
export type LessonCollections = {
  __typename?: 'LessonCollections';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An aggregate relationship */
  lessonsAggregate: LessonsAggregate;
  /** An object relationship */
  owner?: Maybe<Users>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  recurrenceKind?: Maybe<RecurrenceKindsEnum>;
  status: LessonStatusesEnum;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "lesson_collections" */
export type LessonCollectionsLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "lesson_collections" */
export type LessonCollectionsLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};

/** Boolean expression to filter rows from the table "lesson_collections". All fields are combined with a logical 'AND'. */
export type LessonCollectionsBoolExp = {
  _and?: InputMaybe<Array<LessonCollectionsBoolExp>>;
  _not?: InputMaybe<LessonCollectionsBoolExp>;
  _or?: InputMaybe<Array<LessonCollectionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessons?: InputMaybe<LessonsBoolExp>;
  lessonsAggregate?: InputMaybe<LessonsAggregateBoolExp>;
  owner?: InputMaybe<UsersBoolExp>;
  ownerUserId?: InputMaybe<UuidComparisonExp>;
  publishedAt?: InputMaybe<TimestamptzComparisonExp>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnumComparisonExp>;
  status?: InputMaybe<LessonStatusesEnumComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_collections" */
export enum LessonCollectionsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonCollectionsPkey = 'lesson_collections_pkey'
}

/** input type for inserting data into table "lesson_collections" */
export type LessonCollectionsInsertInput = {
  lessons?: InputMaybe<LessonsArrRelInsertInput>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  status?: InputMaybe<LessonStatusesEnum>;
  title?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "lesson_collections" */
export type LessonCollectionsMutationResponse = {
  __typename?: 'LessonCollectionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonCollections>;
};

/** input type for inserting object relation for remote table "lesson_collections" */
export type LessonCollectionsObjRelInsertInput = {
  data: LessonCollectionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonCollectionsOnConflict>;
};

/** on_conflict condition type for table "lesson_collections" */
export type LessonCollectionsOnConflict = {
  constraint: LessonCollectionsConstraint;
  updateColumns?: Array<LessonCollectionsUpdateColumn>;
  where?: InputMaybe<LessonCollectionsBoolExp>;
};

/** Ordering options when selecting data from "lesson_collections". */
export type LessonCollectionsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonsAggregate?: InputMaybe<LessonsAggregateOrderBy>;
  owner?: InputMaybe<UsersOrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  recurrenceKind?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_collections */
export type LessonCollectionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_collections" */
export enum LessonCollectionsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RecurrenceKind = 'recurrenceKind',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_collections" */
export type LessonCollectionsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  status?: InputMaybe<LessonStatusesEnum>;
  title?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "lesson_collections" */
export type LessonCollectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonCollectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonCollectionsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  status?: InputMaybe<LessonStatusesEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_collections" */
export enum LessonCollectionsUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RecurrenceKind = 'recurrenceKind',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title'
}

export type LessonCollectionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonCollectionsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonCollectionsBoolExp;
};

/** columns and relationships of "lesson_equipment" */
export type LessonEquipment = {
  __typename?: 'LessonEquipment';
  createdAt: Scalars['timestamptz'];
  customName?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  equipmentOptionId: LessonEquipmentOptionsEnum;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  lessonId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "lesson_equipment" */
export type LessonEquipmentAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonEquipmentMaxOrderBy>;
  min?: InputMaybe<LessonEquipmentMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_equipment" */
export type LessonEquipmentArrRelInsertInput = {
  data: Array<LessonEquipmentInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonEquipmentOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_equipment". All fields are combined with a logical 'AND'. */
export type LessonEquipmentBoolExp = {
  _and?: InputMaybe<Array<LessonEquipmentBoolExp>>;
  _not?: InputMaybe<LessonEquipmentBoolExp>;
  _or?: InputMaybe<Array<LessonEquipmentBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customName?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  equipmentOptionId?: InputMaybe<LessonEquipmentOptionsEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_equipment" */
export enum LessonEquipmentConstraint {
  /** unique or primary key constraint on columns "lesson_id", "equipment_option_id" */
  LessonEquipmentLessonIdEquipmentOptionIdKey = 'lesson_equipment_lesson_id_equipment_option_id_key',
  /** unique or primary key constraint on columns "id" */
  LessonEquipmentPkey = 'lesson_equipment_pkey'
}

/** input type for inserting data into table "lesson_equipment" */
export type LessonEquipmentInsertInput = {
  customName?: InputMaybe<Scalars['String']>;
  equipmentOptionId?: InputMaybe<LessonEquipmentOptionsEnum>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lesson_equipment" */
export type LessonEquipmentMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customName?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "lesson_equipment" */
export type LessonEquipmentMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customName?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_equipment" */
export type LessonEquipmentMutationResponse = {
  __typename?: 'LessonEquipmentMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonEquipment>;
};

/** on_conflict condition type for table "lesson_equipment" */
export type LessonEquipmentOnConflict = {
  constraint: LessonEquipmentConstraint;
  updateColumns?: Array<LessonEquipmentUpdateColumn>;
  where?: InputMaybe<LessonEquipmentBoolExp>;
};

/** columns and relationships of "lesson_equipment_options" */
export type LessonEquipmentOptions = {
  __typename?: 'LessonEquipmentOptions';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "lesson_equipment_options". All fields are combined with a logical 'AND'. */
export type LessonEquipmentOptionsBoolExp = {
  _and?: InputMaybe<Array<LessonEquipmentOptionsBoolExp>>;
  _not?: InputMaybe<LessonEquipmentOptionsBoolExp>;
  _or?: InputMaybe<Array<LessonEquipmentOptionsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum LessonEquipmentOptionsEnum {
  CourtShoes = 'COURT_SHOES',
  HeartRateMonitor = 'HEART_RATE_MONITOR',
  Racket = 'RACKET',
  Towel = 'TOWEL',
  WaterBottle = 'WATER_BOTTLE'
}

/** Boolean expression to compare columns of type "LessonEquipmentOptionsEnum". All fields are combined with logical 'AND'. */
export type LessonEquipmentOptionsEnumComparisonExp = {
  _eq?: InputMaybe<LessonEquipmentOptionsEnum>;
  _in?: InputMaybe<Array<LessonEquipmentOptionsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonEquipmentOptionsEnum>;
  _nin?: InputMaybe<Array<LessonEquipmentOptionsEnum>>;
};

/** Ordering options when selecting data from "lesson_equipment_options". */
export type LessonEquipmentOptionsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_equipment_options" */
export enum LessonEquipmentOptionsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "lesson_equipment_options" */
export type LessonEquipmentOptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonEquipmentOptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonEquipmentOptionsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Ordering options when selecting data from "lesson_equipment". */
export type LessonEquipmentOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customName?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  equipmentOptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_equipment */
export type LessonEquipmentPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_equipment" */
export enum LessonEquipmentSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomName = 'customName',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EquipmentOptionId = 'equipmentOptionId',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_equipment" */
export type LessonEquipmentSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "lesson_equipment" */
export type LessonEquipmentStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonEquipmentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonEquipmentStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customName?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  equipmentOptionId?: InputMaybe<LessonEquipmentOptionsEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_equipment" */
export enum LessonEquipmentUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt'
}

export type LessonEquipmentUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonEquipmentSetInput>;
  /** filter the rows which have to be updated */
  where: LessonEquipmentBoolExp;
};

/** columns and relationships of "lesson_order_items" */
export type LessonOrderItems = {
  __typename?: 'LessonOrderItems';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  lessonOrderId: Scalars['uuid'];
  /** An object relationship */
  lessonParticipant: LessonParticipants;
  lessonParticipantId: Scalars['uuid'];
  /** An object relationship */
  order: LessonOrders;
  priceUnitAmount: Scalars['Int'];
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  status: OrderStatusesEnum;
  totalUnitAmount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "lesson_order_items" */
export type LessonOrderItemsAggregateOrderBy = {
  avg?: InputMaybe<LessonOrderItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonOrderItemsMaxOrderBy>;
  min?: InputMaybe<LessonOrderItemsMinOrderBy>;
  stddev?: InputMaybe<LessonOrderItemsStddevOrderBy>;
  stddevPop?: InputMaybe<LessonOrderItemsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LessonOrderItemsStddevSampOrderBy>;
  sum?: InputMaybe<LessonOrderItemsSumOrderBy>;
  varPop?: InputMaybe<LessonOrderItemsVarPopOrderBy>;
  varSamp?: InputMaybe<LessonOrderItemsVarSampOrderBy>;
  variance?: InputMaybe<LessonOrderItemsVarianceOrderBy>;
};

/** order by avg() on columns of table "lesson_order_items" */
export type LessonOrderItemsAvgOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lesson_order_items". All fields are combined with a logical 'AND'. */
export type LessonOrderItemsBoolExp = {
  _and?: InputMaybe<Array<LessonOrderItemsBoolExp>>;
  _not?: InputMaybe<LessonOrderItemsBoolExp>;
  _or?: InputMaybe<Array<LessonOrderItemsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonOrderId?: InputMaybe<UuidComparisonExp>;
  lessonParticipant?: InputMaybe<LessonParticipantsBoolExp>;
  lessonParticipantId?: InputMaybe<UuidComparisonExp>;
  order?: InputMaybe<LessonOrdersBoolExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  totalUnitAmount?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "lesson_order_items" */
export type LessonOrderItemsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonOrderId?: InputMaybe<OrderBy>;
  lessonParticipantId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "lesson_order_items" */
export type LessonOrderItemsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonOrderId?: InputMaybe<OrderBy>;
  lessonParticipantId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "lesson_order_items". */
export type LessonOrderItemsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonOrderId?: InputMaybe<OrderBy>;
  lessonParticipant?: InputMaybe<LessonParticipantsOrderBy>;
  lessonParticipantId?: InputMaybe<OrderBy>;
  order?: InputMaybe<LessonOrdersOrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_order_items" */
export enum LessonOrderItemsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonOrderId = 'lessonOrderId',
  /** column name */
  LessonParticipantId = 'lessonParticipantId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  TotalUnitAmount = 'totalUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** order by stddev() on columns of table "lesson_order_items" */
export type LessonOrderItemsStddevOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "lesson_order_items" */
export type LessonOrderItemsStddevPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "lesson_order_items" */
export type LessonOrderItemsStddevSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lesson_order_items" */
export type LessonOrderItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonOrderItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonOrderItemsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonOrderId?: InputMaybe<Scalars['uuid']>;
  lessonParticipantId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "lesson_order_items" */
export type LessonOrderItemsSumOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "lesson_order_items" */
export type LessonOrderItemsVarPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "lesson_order_items" */
export type LessonOrderItemsVarSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "lesson_order_items" */
export type LessonOrderItemsVarianceOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "lesson_orders" */
export type LessonOrders = {
  __typename?: 'LessonOrders';
  applicationFeeTotalUnitAmount: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  creditCard?: Maybe<UserCreditCards>;
  /** An object relationship */
  customer: Users;
  customerApplicationFeeUnitAmount: Scalars['Int'];
  /** An object relationship */
  customerProfile?: Maybe<UserProfiles>;
  customerUserId: Scalars['uuid'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId: Scalars['String'];
  id: Scalars['uuid'];
  internalStripePaymentIntentId: Scalars['uuid'];
  /** An array relationship */
  items: Array<LessonOrderItems>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount: Scalars['Int'];
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  paymentProcessor: PaymentProcessorsEnum;
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  /** An object relationship */
  seller: Users;
  sellerApplicationFeeUnitAmount: Scalars['Int'];
  /** An object relationship */
  sellerProfile?: Maybe<UserProfiles>;
  sellerUserId: Scalars['uuid'];
  status: OrderStatusesEnum;
  stripeCustomerId: Scalars['String'];
  stripeMerchantId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  userCreditCardId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "lesson_orders" */
export type LessonOrdersItemsArgs = {
  distinctOn?: InputMaybe<Array<LessonOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrderItemsOrderBy>>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};

/** aggregated selection of "lesson_orders" */
export type LessonOrdersAggregate = {
  __typename?: 'LessonOrdersAggregate';
  aggregate?: Maybe<LessonOrdersAggregateFields>;
  nodes: Array<LessonOrders>;
};

export type LessonOrdersAggregateBoolExp = {
  count?: InputMaybe<LessonOrdersAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_orders" */
export type LessonOrdersAggregateFields = {
  __typename?: 'LessonOrdersAggregateFields';
  avg?: Maybe<LessonOrdersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LessonOrdersMaxFields>;
  min?: Maybe<LessonOrdersMinFields>;
  stddev?: Maybe<LessonOrdersStddevFields>;
  stddevPop?: Maybe<LessonOrdersStddevPopFields>;
  stddevSamp?: Maybe<LessonOrdersStddevSampFields>;
  sum?: Maybe<LessonOrdersSumFields>;
  varPop?: Maybe<LessonOrdersVarPopFields>;
  varSamp?: Maybe<LessonOrdersVarSampFields>;
  variance?: Maybe<LessonOrdersVarianceFields>;
};


/** aggregate fields of "lesson_orders" */
export type LessonOrdersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_orders" */
export type LessonOrdersAggregateOrderBy = {
  avg?: InputMaybe<LessonOrdersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonOrdersMaxOrderBy>;
  min?: InputMaybe<LessonOrdersMinOrderBy>;
  stddev?: InputMaybe<LessonOrdersStddevOrderBy>;
  stddevPop?: InputMaybe<LessonOrdersStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LessonOrdersStddevSampOrderBy>;
  sum?: InputMaybe<LessonOrdersSumOrderBy>;
  varPop?: InputMaybe<LessonOrdersVarPopOrderBy>;
  varSamp?: InputMaybe<LessonOrdersVarSampOrderBy>;
  variance?: InputMaybe<LessonOrdersVarianceOrderBy>;
};

/** aggregate avg on columns */
export type LessonOrdersAvgFields = {
  __typename?: 'LessonOrdersAvgFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lesson_orders" */
export type LessonOrdersAvgOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lesson_orders". All fields are combined with a logical 'AND'. */
export type LessonOrdersBoolExp = {
  _and?: InputMaybe<Array<LessonOrdersBoolExp>>;
  _not?: InputMaybe<LessonOrdersBoolExp>;
  _or?: InputMaybe<Array<LessonOrdersBoolExp>>;
  applicationFeeTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  creditCard?: InputMaybe<UserCreditCardsBoolExp>;
  customer?: InputMaybe<UsersBoolExp>;
  customerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  customerProfile?: InputMaybe<UserProfilesBoolExp>;
  customerUserId?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  externalStripePaymentIntentId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalStripePaymentIntentId?: InputMaybe<UuidComparisonExp>;
  items?: InputMaybe<LessonOrderItemsBoolExp>;
  orderSubtotalUnitAmount?: InputMaybe<IntComparisonExp>;
  orderTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  paidUnitAmount?: InputMaybe<IntComparisonExp>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  seller?: InputMaybe<UsersBoolExp>;
  sellerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  sellerProfile?: InputMaybe<UserProfilesBoolExp>;
  sellerUserId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripeMerchantId?: InputMaybe<StringComparisonExp>;
  stripePaymentStatus?: InputMaybe<StringComparisonExp>;
  transferUnitAmount?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCreditCardId?: InputMaybe<UuidComparisonExp>;
};

/** aggregate max on columns */
export type LessonOrdersMaxFields = {
  __typename?: 'LessonOrdersMaxFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  customerUserId?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  sellerUserId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lesson_orders" */
export type LessonOrdersMaxOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonOrdersMinFields = {
  __typename?: 'LessonOrdersMinFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  customerUserId?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: Maybe<Scalars['uuid']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  sellerUserId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCreditCardId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "lesson_orders" */
export type LessonOrdersMinOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "lesson_orders". */
export type LessonOrdersOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  creditCard?: InputMaybe<UserCreditCardsOrderBy>;
  customer?: InputMaybe<UsersOrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerProfile?: InputMaybe<UserProfilesOrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  itemsAggregate?: InputMaybe<LessonOrderItemsAggregateOrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  paymentProcessor?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  seller?: InputMaybe<UsersOrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerProfile?: InputMaybe<UserProfilesOrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_orders" */
export enum LessonOrdersSelectColumn {
  /** column name */
  ApplicationFeeTotalUnitAmount = 'applicationFeeTotalUnitAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerApplicationFeeUnitAmount = 'customerApplicationFeeUnitAmount',
  /** column name */
  CustomerUserId = 'customerUserId',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  SellerApplicationFeeUnitAmount = 'sellerApplicationFeeUnitAmount',
  /** column name */
  SellerUserId = 'sellerUserId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  TransferUnitAmount = 'transferUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId'
}

/** aggregate stddev on columns */
export type LessonOrdersStddevFields = {
  __typename?: 'LessonOrdersStddevFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lesson_orders" */
export type LessonOrdersStddevOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type LessonOrdersStddevPopFields = {
  __typename?: 'LessonOrdersStddevPopFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "lesson_orders" */
export type LessonOrdersStddevPopOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type LessonOrdersStddevSampFields = {
  __typename?: 'LessonOrdersStddevSampFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "lesson_orders" */
export type LessonOrdersStddevSampOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lesson_orders" */
export type LessonOrdersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonOrdersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonOrdersStreamCursorValueInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type LessonOrdersSumFields = {
  __typename?: 'LessonOrdersSumFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Int']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Int']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Int']>;
  paidUnitAmount?: Maybe<Scalars['Int']>;
  refundUnitAmount?: Maybe<Scalars['Int']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Int']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "lesson_orders" */
export type LessonOrdersSumOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varPop on columns */
export type LessonOrdersVarPopFields = {
  __typename?: 'LessonOrdersVarPopFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "lesson_orders" */
export type LessonOrdersVarPopOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type LessonOrdersVarSampFields = {
  __typename?: 'LessonOrdersVarSampFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "lesson_orders" */
export type LessonOrdersVarSampOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LessonOrdersVarianceFields = {
  __typename?: 'LessonOrdersVarianceFields';
  applicationFeeTotalUnitAmount?: Maybe<Scalars['Float']>;
  customerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: Maybe<Scalars['Float']>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: Maybe<Scalars['Float']>;
  paidUnitAmount?: Maybe<Scalars['Float']>;
  refundUnitAmount?: Maybe<Scalars['Float']>;
  sellerApplicationFeeUnitAmount?: Maybe<Scalars['Float']>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lesson_orders" */
export type LessonOrdersVarianceOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The sum of the items in the order. This doesn't include any discounts or fees. */
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  /** The total after fees and discounts. Note that the coaches fee is not added in. This is only what the player pays. The coaches fee is subtracted from their payout. */
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  /** The amount transferred to the coach as a payout. It is the price of the lesson minus the coaches fee. */
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "lesson_participant_statuses" */
export type LessonParticipantStatuses = {
  __typename?: 'LessonParticipantStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "lesson_participant_statuses". All fields are combined with a logical 'AND'. */
export type LessonParticipantStatusesBoolExp = {
  _and?: InputMaybe<Array<LessonParticipantStatusesBoolExp>>;
  _not?: InputMaybe<LessonParticipantStatusesBoolExp>;
  _or?: InputMaybe<Array<LessonParticipantStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum LessonParticipantStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "LessonParticipantStatusesEnum". All fields are combined with logical 'AND'. */
export type LessonParticipantStatusesEnumComparisonExp = {
  _eq?: InputMaybe<LessonParticipantStatusesEnum>;
  _in?: InputMaybe<Array<LessonParticipantStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonParticipantStatusesEnum>;
  _nin?: InputMaybe<Array<LessonParticipantStatusesEnum>>;
};

/** Ordering options when selecting data from "lesson_participant_statuses". */
export type LessonParticipantStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_participant_statuses" */
export enum LessonParticipantStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "lesson_participant_statuses" */
export type LessonParticipantStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonParticipantStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonParticipantStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "lesson_participants" */
export type LessonParticipants = {
  __typename?: 'LessonParticipants';
  addedAt?: Maybe<Scalars['timestamptz']>;
  addedByPersona?: Maybe<AppPersonasEnum>;
  addedByUserId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  lessonId: Scalars['uuid'];
  /** An array relationship */
  orderItems: Array<LessonOrderItems>;
  paidAt?: Maybe<Scalars['timestamptz']>;
  paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum;
  recapSkippedAt?: Maybe<Scalars['timestamptz']>;
  referralName?: Maybe<Scalars['String']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  removedAt?: Maybe<Scalars['timestamptz']>;
  removedByPersona?: Maybe<AppPersonasEnum>;
  status: LessonParticipantStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};


/** columns and relationships of "lesson_participants" */
export type LessonParticipantsOrderItemsArgs = {
  distinctOn?: InputMaybe<Array<LessonOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrderItemsOrderBy>>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};

/** aggregated selection of "lesson_participants" */
export type LessonParticipantsAggregate = {
  __typename?: 'LessonParticipantsAggregate';
  aggregate?: Maybe<LessonParticipantsAggregateFields>;
  nodes: Array<LessonParticipants>;
};

export type LessonParticipantsAggregateBoolExp = {
  count?: InputMaybe<LessonParticipantsAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_participants" */
export type LessonParticipantsAggregateFields = {
  __typename?: 'LessonParticipantsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonParticipantsMaxFields>;
  min?: Maybe<LessonParticipantsMinFields>;
};


/** aggregate fields of "lesson_participants" */
export type LessonParticipantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_participants" */
export type LessonParticipantsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonParticipantsMaxOrderBy>;
  min?: InputMaybe<LessonParticipantsMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_participants" */
export type LessonParticipantsArrRelInsertInput = {
  data: Array<LessonParticipantsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonParticipantsOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_participants". All fields are combined with a logical 'AND'. */
export type LessonParticipantsBoolExp = {
  _and?: InputMaybe<Array<LessonParticipantsBoolExp>>;
  _not?: InputMaybe<LessonParticipantsBoolExp>;
  _or?: InputMaybe<Array<LessonParticipantsBoolExp>>;
  addedAt?: InputMaybe<TimestamptzComparisonExp>;
  addedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  addedByUserId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  orderItems?: InputMaybe<LessonOrderItemsBoolExp>;
  paidAt?: InputMaybe<TimestamptzComparisonExp>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnumComparisonExp>;
  recapSkippedAt?: InputMaybe<TimestamptzComparisonExp>;
  referralName?: InputMaybe<StringComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  removedAt?: InputMaybe<TimestamptzComparisonExp>;
  removedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  status?: InputMaybe<LessonParticipantStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "lesson_participants" */
export enum LessonParticipantsConstraint {
  /** unique or primary key constraint on columns "lesson_id", "user_id" */
  LessonParticipantsLessonIdUserIdKey = 'lesson_participants_lesson_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  LessonParticipantsPkey = 'lesson_participants_pkey'
}

/** input type for inserting data into table "lesson_participants" */
export type LessonParticipantsInsertInput = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByPersona?: InputMaybe<AppPersonasEnum>;
  addedByUserId?: InputMaybe<Scalars['uuid']>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  paidAt?: InputMaybe<Scalars['timestamptz']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  recapSkippedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  removedAt?: InputMaybe<Scalars['timestamptz']>;
  removedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<LessonParticipantStatusesEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type LessonParticipantsMaxFields = {
  __typename?: 'LessonParticipantsMaxFields';
  addedAt?: Maybe<Scalars['timestamptz']>;
  addedByUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  paidAt?: Maybe<Scalars['timestamptz']>;
  recapSkippedAt?: Maybe<Scalars['timestamptz']>;
  referralName?: Maybe<Scalars['String']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  removedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lesson_participants" */
export type LessonParticipantsMaxOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  addedByUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  paidAt?: InputMaybe<OrderBy>;
  recapSkippedAt?: InputMaybe<OrderBy>;
  referralName?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  removedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonParticipantsMinFields = {
  __typename?: 'LessonParticipantsMinFields';
  addedAt?: Maybe<Scalars['timestamptz']>;
  addedByUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  paidAt?: Maybe<Scalars['timestamptz']>;
  recapSkippedAt?: Maybe<Scalars['timestamptz']>;
  referralName?: Maybe<Scalars['String']>;
  refundedAt?: Maybe<Scalars['timestamptz']>;
  removedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "lesson_participants" */
export type LessonParticipantsMinOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  addedByUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  paidAt?: InputMaybe<OrderBy>;
  recapSkippedAt?: InputMaybe<OrderBy>;
  referralName?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  removedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_participants" */
export type LessonParticipantsMutationResponse = {
  __typename?: 'LessonParticipantsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonParticipants>;
};

/** on_conflict condition type for table "lesson_participants" */
export type LessonParticipantsOnConflict = {
  constraint: LessonParticipantsConstraint;
  updateColumns?: Array<LessonParticipantsUpdateColumn>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};

/** Ordering options when selecting data from "lesson_participants". */
export type LessonParticipantsOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  addedByPersona?: InputMaybe<OrderBy>;
  addedByUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  orderItemsAggregate?: InputMaybe<LessonOrderItemsAggregateOrderBy>;
  paidAt?: InputMaybe<OrderBy>;
  paymentFulfillmentChannel?: InputMaybe<OrderBy>;
  recapSkippedAt?: InputMaybe<OrderBy>;
  referralName?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  removedAt?: InputMaybe<OrderBy>;
  removedByPersona?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: lesson_participants */
export type LessonParticipantsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_participants" */
export enum LessonParticipantsSelectColumn {
  /** column name */
  AddedAt = 'addedAt',
  /** column name */
  AddedByPersona = 'addedByPersona',
  /** column name */
  AddedByUserId = 'addedByUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PaidAt = 'paidAt',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  RecapSkippedAt = 'recapSkippedAt',
  /** column name */
  ReferralName = 'referralName',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  RemovedAt = 'removedAt',
  /** column name */
  RemovedByPersona = 'removedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "lesson_participants" */
export type LessonParticipantsSetInput = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByPersona?: InputMaybe<AppPersonasEnum>;
  addedByUserId?: InputMaybe<Scalars['uuid']>;
  paidAt?: InputMaybe<Scalars['timestamptz']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  recapSkippedAt?: InputMaybe<Scalars['timestamptz']>;
  referralName?: InputMaybe<Scalars['String']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  removedAt?: InputMaybe<Scalars['timestamptz']>;
  removedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<LessonParticipantStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "lesson_participants" */
export type LessonParticipantsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonParticipantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonParticipantsStreamCursorValueInput = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByPersona?: InputMaybe<AppPersonasEnum>;
  addedByUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  paidAt?: InputMaybe<Scalars['timestamptz']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  recapSkippedAt?: InputMaybe<Scalars['timestamptz']>;
  referralName?: InputMaybe<Scalars['String']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  removedAt?: InputMaybe<Scalars['timestamptz']>;
  removedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<LessonParticipantStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "lesson_participants" */
export enum LessonParticipantsUpdateColumn {
  /** column name */
  AddedAt = 'addedAt',
  /** column name */
  AddedByPersona = 'addedByPersona',
  /** column name */
  AddedByUserId = 'addedByUserId',
  /** column name */
  PaidAt = 'paidAt',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  RecapSkippedAt = 'recapSkippedAt',
  /** column name */
  ReferralName = 'referralName',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  RemovedAt = 'removedAt',
  /** column name */
  RemovedByPersona = 'removedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type LessonParticipantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonParticipantsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonParticipantsBoolExp;
};

export enum LessonPlayerSkillAssessmentCategoriesEnum {
  Negative = 'NEGATIVE',
  NextGoal = 'NEXT_GOAL',
  Positive = 'POSITIVE'
}

/** Boolean expression to compare columns of type "LessonPlayerSkillAssessmentCategoriesEnum". All fields are combined with logical 'AND'. */
export type LessonPlayerSkillAssessmentCategoriesEnumComparisonExp = {
  _eq?: InputMaybe<LessonPlayerSkillAssessmentCategoriesEnum>;
  _in?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonPlayerSkillAssessmentCategoriesEnum>;
  _nin?: InputMaybe<Array<LessonPlayerSkillAssessmentCategoriesEnum>>;
};

/** columns and relationships of "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessments = {
  __typename?: 'LessonPlayerSkillAssessments';
  coachUserId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  /** An object relationship */
  lessonCoach?: Maybe<UserProfiles>;
  lessonId: Scalars['uuid'];
  /** An object relationship */
  lessonPlayer?: Maybe<UserProfiles>;
  /** An array relationship */
  lessonPlayerSkillAssessmentsSkills: Array<LessonPlayerSkillAssessmentsSkills>;
  playerUserId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsLessonPlayerSkillAssessmentsSkillsArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
};

/** order by aggregate values of table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonPlayerSkillAssessmentsMaxOrderBy>;
  min?: InputMaybe<LessonPlayerSkillAssessmentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsArrRelInsertInput = {
  data: Array<LessonPlayerSkillAssessmentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentsOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_player_skill_assessments". All fields are combined with a logical 'AND'. */
export type LessonPlayerSkillAssessmentsBoolExp = {
  _and?: InputMaybe<Array<LessonPlayerSkillAssessmentsBoolExp>>;
  _not?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
  _or?: InputMaybe<Array<LessonPlayerSkillAssessmentsBoolExp>>;
  coachUserId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonCoach?: InputMaybe<UserProfilesBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  lessonPlayer?: InputMaybe<UserProfilesBoolExp>;
  lessonPlayerSkillAssessmentsSkills?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
  playerUserId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_player_skill_assessments" */
export enum LessonPlayerSkillAssessmentsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonPlayerSkillAssessmentsPkey = 'lesson_player_skill_assessments_pkey'
}

/** input type for inserting data into table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsInsertInput = {
  coachUserId?: InputMaybe<Scalars['uuid']>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  lessonPlayerSkillAssessmentsSkills?: InputMaybe<LessonPlayerSkillAssessmentsSkillsArrRelInsertInput>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsMaxOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsMinOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsMutationResponse = {
  __typename?: 'LessonPlayerSkillAssessmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonPlayerSkillAssessments>;
};

/** input type for inserting object relation for remote table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsObjRelInsertInput = {
  data: LessonPlayerSkillAssessmentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentsOnConflict>;
};

/** on_conflict condition type for table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsOnConflict = {
  constraint: LessonPlayerSkillAssessmentsConstraint;
  updateColumns?: Array<LessonPlayerSkillAssessmentsUpdateColumn>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
};

/** Ordering options when selecting data from "lesson_player_skill_assessments". */
export type LessonPlayerSkillAssessmentsOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonCoach?: InputMaybe<UserProfilesOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  lessonPlayer?: InputMaybe<UserProfilesOrderBy>;
  lessonPlayerSkillAssessmentsSkillsAggregate?: InputMaybe<LessonPlayerSkillAssessmentsSkillsAggregateOrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_player_skill_assessments */
export type LessonPlayerSkillAssessmentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_player_skill_assessments" */
export enum LessonPlayerSkillAssessmentsSelectColumn {
  /** column name */
  CoachUserId = 'coachUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkills = {
  __typename?: 'LessonPlayerSkillAssessmentsSkills';
  category: LessonPlayerSkillAssessmentCategoriesEnum;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lessonPlayerSkilAssessment: LessonPlayerSkillAssessments;
  lessonPlayerSkillAssessmentId: Scalars['uuid'];
  skill: LessonSkillsEnum;
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonPlayerSkillAssessmentsSkillsMaxOrderBy>;
  min?: InputMaybe<LessonPlayerSkillAssessmentsSkillsMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsArrRelInsertInput = {
  data: Array<LessonPlayerSkillAssessmentsSkillsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentsSkillsOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_player_skill_assessments_skills". All fields are combined with a logical 'AND'. */
export type LessonPlayerSkillAssessmentsSkillsBoolExp = {
  _and?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsBoolExp>>;
  _not?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
  _or?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsBoolExp>>;
  category?: InputMaybe<LessonPlayerSkillAssessmentCategoriesEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonPlayerSkilAssessment?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
  lessonPlayerSkillAssessmentId?: InputMaybe<UuidComparisonExp>;
  skill?: InputMaybe<LessonSkillsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_player_skill_assessments_skills" */
export enum LessonPlayerSkillAssessmentsSkillsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonPlayerSkillAssessmentsSkillsPkey = 'lesson_player_skill_assessments_skills_pkey'
}

/** input type for inserting data into table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsInsertInput = {
  category?: InputMaybe<LessonPlayerSkillAssessmentCategoriesEnum>;
  lessonPlayerSkilAssessment?: InputMaybe<LessonPlayerSkillAssessmentsObjRelInsertInput>;
  lessonPlayerSkillAssessmentId?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
};

/** order by max() on columns of table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonPlayerSkillAssessmentId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonPlayerSkillAssessmentId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsMutationResponse = {
  __typename?: 'LessonPlayerSkillAssessmentsSkillsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonPlayerSkillAssessmentsSkills>;
};

/** on_conflict condition type for table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsOnConflict = {
  constraint: LessonPlayerSkillAssessmentsSkillsConstraint;
  updateColumns?: Array<LessonPlayerSkillAssessmentsSkillsUpdateColumn>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
};

/** Ordering options when selecting data from "lesson_player_skill_assessments_skills". */
export type LessonPlayerSkillAssessmentsSkillsOrderBy = {
  category?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonPlayerSkilAssessment?: InputMaybe<LessonPlayerSkillAssessmentsOrderBy>;
  lessonPlayerSkillAssessmentId?: InputMaybe<OrderBy>;
  skill?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_player_skill_assessments_skills */
export type LessonPlayerSkillAssessmentsSkillsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_player_skill_assessments_skills" */
export enum LessonPlayerSkillAssessmentsSkillsSelectColumn {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonPlayerSkillAssessmentId = 'lessonPlayerSkillAssessmentId',
  /** column name */
  Skill = 'skill',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "lesson_player_skill_assessments_skills" */
export type LessonPlayerSkillAssessmentsSkillsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonPlayerSkillAssessmentsSkillsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonPlayerSkillAssessmentsSkillsStreamCursorValueInput = {
  category?: InputMaybe<LessonPlayerSkillAssessmentCategoriesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonPlayerSkillAssessmentId?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_player_skill_assessments_skills" */
export enum LessonPlayerSkillAssessmentsSkillsUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt'
}

export type LessonPlayerSkillAssessmentsSkillsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonPlayerSkillAssessmentsSkillsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonPlayerSkillAssessmentsSkillsBoolExp;
};

/** Streaming cursor of the table "lesson_player_skill_assessments" */
export type LessonPlayerSkillAssessmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonPlayerSkillAssessmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonPlayerSkillAssessmentsStreamCursorValueInput = {
  coachUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_player_skill_assessments" */
export enum LessonPlayerSkillAssessmentsUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt'
}

export type LessonPlayerSkillAssessmentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonPlayerSkillAssessmentsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonPlayerSkillAssessmentsBoolExp;
};

/** columns and relationships of "lesson_privacy" */
export type LessonPrivacy = {
  __typename?: 'LessonPrivacy';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "lesson_privacy". All fields are combined with a logical 'AND'. */
export type LessonPrivacyBoolExp = {
  _and?: InputMaybe<Array<LessonPrivacyBoolExp>>;
  _not?: InputMaybe<LessonPrivacyBoolExp>;
  _or?: InputMaybe<Array<LessonPrivacyBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum LessonPrivacyEnum {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/** Boolean expression to compare columns of type "LessonPrivacyEnum". All fields are combined with logical 'AND'. */
export type LessonPrivacyEnumComparisonExp = {
  _eq?: InputMaybe<LessonPrivacyEnum>;
  _in?: InputMaybe<Array<LessonPrivacyEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonPrivacyEnum>;
  _nin?: InputMaybe<Array<LessonPrivacyEnum>>;
};

/** Ordering options when selecting data from "lesson_privacy". */
export type LessonPrivacyOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_privacy" */
export enum LessonPrivacySelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "lesson_privacy" */
export type LessonPrivacyStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonPrivacyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonPrivacyStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "lesson_reflection_comment_types" */
export type LessonReflectionCommentTypes = {
  __typename?: 'LessonReflectionCommentTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "lesson_reflection_comment_types". All fields are combined with a logical 'AND'. */
export type LessonReflectionCommentTypesBoolExp = {
  _and?: InputMaybe<Array<LessonReflectionCommentTypesBoolExp>>;
  _not?: InputMaybe<LessonReflectionCommentTypesBoolExp>;
  _or?: InputMaybe<Array<LessonReflectionCommentTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum LessonReflectionCommentTypesEnum {
  Assignment = 'ASSIGNMENT',
  Completed = 'COMPLETED',
  Upcoming = 'UPCOMING'
}

/** Boolean expression to compare columns of type "LessonReflectionCommentTypesEnum". All fields are combined with logical 'AND'. */
export type LessonReflectionCommentTypesEnumComparisonExp = {
  _eq?: InputMaybe<LessonReflectionCommentTypesEnum>;
  _in?: InputMaybe<Array<LessonReflectionCommentTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonReflectionCommentTypesEnum>;
  _nin?: InputMaybe<Array<LessonReflectionCommentTypesEnum>>;
};

/** Ordering options when selecting data from "lesson_reflection_comment_types". */
export type LessonReflectionCommentTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_reflection_comment_types" */
export enum LessonReflectionCommentTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "lesson_reflection_comment_types" */
export type LessonReflectionCommentTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonReflectionCommentTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonReflectionCommentTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "lesson_reflection_comments" */
export type LessonReflectionComments = {
  __typename?: 'LessonReflectionComments';
  createdAt: Scalars['timestamptz'];
  customSkill?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['time']>;
  details?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lessonReflection: LessonReflections;
  /** An array relationship */
  lessonReflectionFiles: Array<LessonReflectionFiles>;
  lessonReflectionId: Scalars['uuid'];
  order?: Maybe<Scalars['Int']>;
  sentiment?: Maybe<FeedbackSentimentEnum>;
  skill?: Maybe<LessonSkillsEnum>;
  type: LessonReflectionCommentTypesEnum;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
  /** An object relationship */
  userReflectionComment: Users;
};


/** columns and relationships of "lesson_reflection_comments" */
export type LessonReflectionCommentsLessonReflectionFilesArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionFilesOrderBy>>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};

/** order by aggregate values of table "lesson_reflection_comments" */
export type LessonReflectionCommentsAggregateOrderBy = {
  avg?: InputMaybe<LessonReflectionCommentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonReflectionCommentsMaxOrderBy>;
  min?: InputMaybe<LessonReflectionCommentsMinOrderBy>;
  stddev?: InputMaybe<LessonReflectionCommentsStddevOrderBy>;
  stddevPop?: InputMaybe<LessonReflectionCommentsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LessonReflectionCommentsStddevSampOrderBy>;
  sum?: InputMaybe<LessonReflectionCommentsSumOrderBy>;
  varPop?: InputMaybe<LessonReflectionCommentsVarPopOrderBy>;
  varSamp?: InputMaybe<LessonReflectionCommentsVarSampOrderBy>;
  variance?: InputMaybe<LessonReflectionCommentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_reflection_comments" */
export type LessonReflectionCommentsArrRelInsertInput = {
  data: Array<LessonReflectionCommentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonReflectionCommentsOnConflict>;
};

/** order by avg() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsAvgOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lesson_reflection_comments". All fields are combined with a logical 'AND'. */
export type LessonReflectionCommentsBoolExp = {
  _and?: InputMaybe<Array<LessonReflectionCommentsBoolExp>>;
  _not?: InputMaybe<LessonReflectionCommentsBoolExp>;
  _or?: InputMaybe<Array<LessonReflectionCommentsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customSkill?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimeComparisonExp>;
  details?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonReflection?: InputMaybe<LessonReflectionsBoolExp>;
  lessonReflectionFiles?: InputMaybe<LessonReflectionFilesBoolExp>;
  lessonReflectionId?: InputMaybe<UuidComparisonExp>;
  order?: InputMaybe<IntComparisonExp>;
  sentiment?: InputMaybe<FeedbackSentimentEnumComparisonExp>;
  skill?: InputMaybe<LessonSkillsEnumComparisonExp>;
  type?: InputMaybe<LessonReflectionCommentTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userReflectionComment?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "lesson_reflection_comments" */
export enum LessonReflectionCommentsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonReflectionCommentsPkey = 'lesson_reflection_comments_pkey'
}

/** input type for incrementing numeric columns in table "lesson_reflection_comments" */
export type LessonReflectionCommentsIncInput = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lesson_reflection_comments" */
export type LessonReflectionCommentsInsertInput = {
  customSkill?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  lessonReflection?: InputMaybe<LessonReflectionsObjRelInsertInput>;
  lessonReflectionFiles?: InputMaybe<LessonReflectionFilesArrRelInsertInput>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  sentiment?: InputMaybe<FeedbackSentimentEnum>;
  skill?: InputMaybe<LessonSkillsEnum>;
  type?: InputMaybe<LessonReflectionCommentTypesEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customSkill?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customSkill?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_reflection_comments" */
export type LessonReflectionCommentsMutationResponse = {
  __typename?: 'LessonReflectionCommentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonReflectionComments>;
};

/** input type for inserting object relation for remote table "lesson_reflection_comments" */
export type LessonReflectionCommentsObjRelInsertInput = {
  data: LessonReflectionCommentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonReflectionCommentsOnConflict>;
};

/** on_conflict condition type for table "lesson_reflection_comments" */
export type LessonReflectionCommentsOnConflict = {
  constraint: LessonReflectionCommentsConstraint;
  updateColumns?: Array<LessonReflectionCommentsUpdateColumn>;
  where?: InputMaybe<LessonReflectionCommentsBoolExp>;
};

/** Ordering options when selecting data from "lesson_reflection_comments". */
export type LessonReflectionCommentsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customSkill?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonReflection?: InputMaybe<LessonReflectionsOrderBy>;
  lessonReflectionFilesAggregate?: InputMaybe<LessonReflectionFilesAggregateOrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  sentiment?: InputMaybe<OrderBy>;
  skill?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userReflectionComment?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: lesson_reflection_comments */
export type LessonReflectionCommentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_reflection_comments" */
export enum LessonReflectionCommentsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomSkill = 'customSkill',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id',
  /** column name */
  LessonReflectionId = 'lessonReflectionId',
  /** column name */
  Order = 'order',
  /** column name */
  Sentiment = 'sentiment',
  /** column name */
  Skill = 'skill',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "lesson_reflection_comments" */
export type LessonReflectionCommentsSetInput = {
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  details?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  sentiment?: InputMaybe<FeedbackSentimentEnum>;
  skill?: InputMaybe<LessonSkillsEnum>;
  type?: InputMaybe<LessonReflectionCommentTypesEnum>;
};

/** order by stddev() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsStddevOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsStddevPopOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsStddevSampOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lesson_reflection_comments" */
export type LessonReflectionCommentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonReflectionCommentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonReflectionCommentsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  sentiment?: InputMaybe<FeedbackSentimentEnum>;
  skill?: InputMaybe<LessonSkillsEnum>;
  type?: InputMaybe<LessonReflectionCommentTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsSumOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** update columns of table "lesson_reflection_comments" */
export enum LessonReflectionCommentsUpdateColumn {
  /** column name */
  CustomSkill = 'customSkill',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Details = 'details',
  /** column name */
  Order = 'order',
  /** column name */
  Sentiment = 'sentiment',
  /** column name */
  Skill = 'skill',
  /** column name */
  Type = 'type'
}

export type LessonReflectionCommentsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LessonReflectionCommentsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonReflectionCommentsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonReflectionCommentsBoolExp;
};

/** order by varPop() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsVarPopOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsVarSampOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "lesson_reflection_comments" */
export type LessonReflectionCommentsVarianceOrderBy = {
  order?: InputMaybe<OrderBy>;
};

/** columns and relationships of "lesson_reflection_files" */
export type LessonReflectionFiles = {
  __typename?: 'LessonReflectionFiles';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['time']>;
  fileCategory: Scalars['String'];
  fileFormat: Scalars['String'];
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  host: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  lessonReflection?: Maybe<LessonReflections>;
  /** An object relationship */
  lessonReflectionComment?: Maybe<LessonReflectionComments>;
  lessonReflectionCommentId?: Maybe<Scalars['uuid']>;
  lessonReflectionId?: Maybe<Scalars['uuid']>;
  originalFileName: Scalars['String'];
  provider: Scalars['String'];
  providerId: Scalars['String'];
  providerUrl: Scalars['String'];
  transcript: Scalars['String'];
  transcriptEndedAt?: Maybe<Scalars['timestamptz']>;
  transcriptStartedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  /** An object relationship */
  userFiles: Users;
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "lesson_reflection_files" */
export type LessonReflectionFilesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonReflectionFilesMaxOrderBy>;
  min?: InputMaybe<LessonReflectionFilesMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_reflection_files" */
export type LessonReflectionFilesArrRelInsertInput = {
  data: Array<LessonReflectionFilesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonReflectionFilesOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_reflection_files". All fields are combined with a logical 'AND'. */
export type LessonReflectionFilesBoolExp = {
  _and?: InputMaybe<Array<LessonReflectionFilesBoolExp>>;
  _not?: InputMaybe<LessonReflectionFilesBoolExp>;
  _or?: InputMaybe<Array<LessonReflectionFilesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimeComparisonExp>;
  fileCategory?: InputMaybe<StringComparisonExp>;
  fileFormat?: InputMaybe<StringComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileType?: InputMaybe<StringComparisonExp>;
  host?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonReflection?: InputMaybe<LessonReflectionsBoolExp>;
  lessonReflectionComment?: InputMaybe<LessonReflectionCommentsBoolExp>;
  lessonReflectionCommentId?: InputMaybe<UuidComparisonExp>;
  lessonReflectionId?: InputMaybe<UuidComparisonExp>;
  originalFileName?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  transcript?: InputMaybe<StringComparisonExp>;
  transcriptEndedAt?: InputMaybe<TimestamptzComparisonExp>;
  transcriptStartedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  userFiles?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "lesson_reflection_files" */
export enum LessonReflectionFilesConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonReflectionFilesPkey = 'lesson_reflection_files_pkey'
}

/** input type for inserting data into table "lesson_reflection_files" */
export type LessonReflectionFilesInsertInput = {
  fileCategory?: InputMaybe<Scalars['String']>;
  fileFormat?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  lessonReflection?: InputMaybe<LessonReflectionsObjRelInsertInput>;
  lessonReflectionComment?: InputMaybe<LessonReflectionCommentsObjRelInsertInput>;
  lessonReflectionCommentId?: InputMaybe<Scalars['uuid']>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lesson_reflection_files" */
export type LessonReflectionFilesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  fileCategory?: InputMaybe<OrderBy>;
  fileFormat?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonReflectionCommentId?: InputMaybe<OrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  transcript?: InputMaybe<OrderBy>;
  transcriptEndedAt?: InputMaybe<OrderBy>;
  transcriptStartedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "lesson_reflection_files" */
export type LessonReflectionFilesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  fileCategory?: InputMaybe<OrderBy>;
  fileFormat?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonReflectionCommentId?: InputMaybe<OrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  transcript?: InputMaybe<OrderBy>;
  transcriptEndedAt?: InputMaybe<OrderBy>;
  transcriptStartedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_reflection_files" */
export type LessonReflectionFilesMutationResponse = {
  __typename?: 'LessonReflectionFilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonReflectionFiles>;
};

/** on_conflict condition type for table "lesson_reflection_files" */
export type LessonReflectionFilesOnConflict = {
  constraint: LessonReflectionFilesConstraint;
  updateColumns?: Array<LessonReflectionFilesUpdateColumn>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};

/** Ordering options when selecting data from "lesson_reflection_files". */
export type LessonReflectionFilesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileCategory?: InputMaybe<OrderBy>;
  fileFormat?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonReflection?: InputMaybe<LessonReflectionsOrderBy>;
  lessonReflectionComment?: InputMaybe<LessonReflectionCommentsOrderBy>;
  lessonReflectionCommentId?: InputMaybe<OrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  transcript?: InputMaybe<OrderBy>;
  transcriptEndedAt?: InputMaybe<OrderBy>;
  transcriptStartedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userFiles?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_reflection_files */
export type LessonReflectionFilesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_reflection_files" */
export enum LessonReflectionFilesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  LessonReflectionCommentId = 'lessonReflectionCommentId',
  /** column name */
  LessonReflectionId = 'lessonReflectionId',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Transcript = 'transcript',
  /** column name */
  TranscriptEndedAt = 'transcriptEndedAt',
  /** column name */
  TranscriptStartedAt = 'transcriptStartedAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "lesson_reflection_files" */
export type LessonReflectionFilesSetInput = {
  deletedAt?: InputMaybe<Scalars['time']>;
  fileCategory?: InputMaybe<Scalars['String']>;
  fileFormat?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "lesson_reflection_files" */
export type LessonReflectionFilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonReflectionFilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonReflectionFilesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  fileCategory?: InputMaybe<Scalars['String']>;
  fileFormat?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonReflectionCommentId?: InputMaybe<Scalars['uuid']>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  transcript?: InputMaybe<Scalars['String']>;
  transcriptEndedAt?: InputMaybe<Scalars['timestamptz']>;
  transcriptStartedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "lesson_reflection_files" */
export enum LessonReflectionFilesUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Url = 'url'
}

export type LessonReflectionFilesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonReflectionFilesSetInput>;
  /** filter the rows which have to be updated */
  where: LessonReflectionFilesBoolExp;
};

/** columns and relationships of "lesson_reflections" */
export type LessonReflections = {
  __typename?: 'LessonReflections';
  assignmentCategory?: Maybe<LessonSkillCategoriesEnum>;
  assignmentSport?: Maybe<SportsEnum>;
  coachUserId: Scalars['uuid'];
  completedCategory?: Maybe<LessonSkillCategoriesEnum>;
  completedSport?: Maybe<SportsEnum>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['time']>;
  details?: Maybe<Scalars['String']>;
  /** An array relationship */
  files: Array<LessonReflectionFiles>;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  /** An object relationship */
  lessonCoach?: Maybe<UserProfiles>;
  lessonId: Scalars['uuid'];
  /** An object relationship */
  lessonPlayer?: Maybe<UserProfiles>;
  /** An array relationship */
  lessonReflectionComments: Array<LessonReflectionComments>;
  playerDismissedAt?: Maybe<Scalars['timestamptz']>;
  playerUserId: Scalars['uuid'];
  reviewStatus: VideoAnalysisReviewStatusesEnum;
  submissionRequestedFeedback?: Maybe<Scalars['String']>;
  upcomingCategory?: Maybe<LessonSkillCategoriesEnum>;
  upcomingSport?: Maybe<SportsEnum>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "lesson_reflections" */
export type LessonReflectionsFilesArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionFilesOrderBy>>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};


/** columns and relationships of "lesson_reflections" */
export type LessonReflectionsLessonReflectionCommentsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentsOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentsBoolExp>;
};

/** order by aggregate values of table "lesson_reflections" */
export type LessonReflectionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonReflectionsMaxOrderBy>;
  min?: InputMaybe<LessonReflectionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_reflections" */
export type LessonReflectionsArrRelInsertInput = {
  data: Array<LessonReflectionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonReflectionsOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_reflections". All fields are combined with a logical 'AND'. */
export type LessonReflectionsBoolExp = {
  _and?: InputMaybe<Array<LessonReflectionsBoolExp>>;
  _not?: InputMaybe<LessonReflectionsBoolExp>;
  _or?: InputMaybe<Array<LessonReflectionsBoolExp>>;
  assignmentCategory?: InputMaybe<LessonSkillCategoriesEnumComparisonExp>;
  assignmentSport?: InputMaybe<SportsEnumComparisonExp>;
  coachUserId?: InputMaybe<UuidComparisonExp>;
  completedCategory?: InputMaybe<LessonSkillCategoriesEnumComparisonExp>;
  completedSport?: InputMaybe<SportsEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimeComparisonExp>;
  details?: InputMaybe<StringComparisonExp>;
  files?: InputMaybe<LessonReflectionFilesBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonCoach?: InputMaybe<UserProfilesBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  lessonPlayer?: InputMaybe<UserProfilesBoolExp>;
  lessonReflectionComments?: InputMaybe<LessonReflectionCommentsBoolExp>;
  playerDismissedAt?: InputMaybe<TimestamptzComparisonExp>;
  playerUserId?: InputMaybe<UuidComparisonExp>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnumComparisonExp>;
  submissionRequestedFeedback?: InputMaybe<StringComparisonExp>;
  upcomingCategory?: InputMaybe<LessonSkillCategoriesEnumComparisonExp>;
  upcomingSport?: InputMaybe<SportsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_reflections" */
export enum LessonReflectionsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonReflectionsPkey = 'lesson_reflections_pkey'
}

/** input type for inserting data into table "lesson_reflections" */
export type LessonReflectionsInsertInput = {
  assignmentCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  assignmentSport?: InputMaybe<SportsEnum>;
  coachUserId?: InputMaybe<Scalars['uuid']>;
  completedCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  completedSport?: InputMaybe<SportsEnum>;
  details?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<LessonReflectionFilesArrRelInsertInput>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  lessonReflectionComments?: InputMaybe<LessonReflectionCommentsArrRelInsertInput>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  submissionRequestedFeedback?: InputMaybe<Scalars['String']>;
  upcomingCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  upcomingSport?: InputMaybe<SportsEnum>;
};

/** order by max() on columns of table "lesson_reflections" */
export type LessonReflectionsMaxOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  playerDismissedAt?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  submissionRequestedFeedback?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "lesson_reflections" */
export type LessonReflectionsMinOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  playerDismissedAt?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  submissionRequestedFeedback?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_reflections" */
export type LessonReflectionsMutationResponse = {
  __typename?: 'LessonReflectionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonReflections>;
};

/** input type for inserting object relation for remote table "lesson_reflections" */
export type LessonReflectionsObjRelInsertInput = {
  data: LessonReflectionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonReflectionsOnConflict>;
};

/** on_conflict condition type for table "lesson_reflections" */
export type LessonReflectionsOnConflict = {
  constraint: LessonReflectionsConstraint;
  updateColumns?: Array<LessonReflectionsUpdateColumn>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};

/** Ordering options when selecting data from "lesson_reflections". */
export type LessonReflectionsOrderBy = {
  assignmentCategory?: InputMaybe<OrderBy>;
  assignmentSport?: InputMaybe<OrderBy>;
  coachUserId?: InputMaybe<OrderBy>;
  completedCategory?: InputMaybe<OrderBy>;
  completedSport?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  filesAggregate?: InputMaybe<LessonReflectionFilesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonCoach?: InputMaybe<UserProfilesOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  lessonPlayer?: InputMaybe<UserProfilesOrderBy>;
  lessonReflectionCommentsAggregate?: InputMaybe<LessonReflectionCommentsAggregateOrderBy>;
  playerDismissedAt?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  reviewStatus?: InputMaybe<OrderBy>;
  submissionRequestedFeedback?: InputMaybe<OrderBy>;
  upcomingCategory?: InputMaybe<OrderBy>;
  upcomingSport?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_reflections */
export type LessonReflectionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_reflections" */
export enum LessonReflectionsSelectColumn {
  /** column name */
  AssignmentCategory = 'assignmentCategory',
  /** column name */
  AssignmentSport = 'assignmentSport',
  /** column name */
  CoachUserId = 'coachUserId',
  /** column name */
  CompletedCategory = 'completedCategory',
  /** column name */
  CompletedSport = 'completedSport',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PlayerDismissedAt = 'playerDismissedAt',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  ReviewStatus = 'reviewStatus',
  /** column name */
  SubmissionRequestedFeedback = 'submissionRequestedFeedback',
  /** column name */
  UpcomingCategory = 'upcomingCategory',
  /** column name */
  UpcomingSport = 'upcomingSport',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_reflections" */
export type LessonReflectionsSetInput = {
  assignmentCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  assignmentSport?: InputMaybe<SportsEnum>;
  completedCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  completedSport?: InputMaybe<SportsEnum>;
  deletedAt?: InputMaybe<Scalars['time']>;
  details?: InputMaybe<Scalars['String']>;
  playerDismissedAt?: InputMaybe<Scalars['timestamptz']>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  upcomingCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  upcomingSport?: InputMaybe<SportsEnum>;
};

/** Streaming cursor of the table "lesson_reflections" */
export type LessonReflectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonReflectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonReflectionsStreamCursorValueInput = {
  assignmentCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  assignmentSport?: InputMaybe<SportsEnum>;
  coachUserId?: InputMaybe<Scalars['uuid']>;
  completedCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  completedSport?: InputMaybe<SportsEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['time']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  playerDismissedAt?: InputMaybe<Scalars['timestamptz']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  submissionRequestedFeedback?: InputMaybe<Scalars['String']>;
  upcomingCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  upcomingSport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_reflections" */
export enum LessonReflectionsUpdateColumn {
  /** column name */
  AssignmentCategory = 'assignmentCategory',
  /** column name */
  AssignmentSport = 'assignmentSport',
  /** column name */
  CompletedCategory = 'completedCategory',
  /** column name */
  CompletedSport = 'completedSport',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Details = 'details',
  /** column name */
  PlayerDismissedAt = 'playerDismissedAt',
  /** column name */
  ReviewStatus = 'reviewStatus',
  /** column name */
  UpcomingCategory = 'upcomingCategory',
  /** column name */
  UpcomingSport = 'upcomingSport'
}

export type LessonReflectionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonReflectionsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonReflectionsBoolExp;
};

export enum LessonSkillCategoriesEnum {
  P4 = 'P4',
  Quatro = 'QUATRO'
}

/** Boolean expression to compare columns of type "LessonSkillCategoriesEnum". All fields are combined with logical 'AND'. */
export type LessonSkillCategoriesEnumComparisonExp = {
  _eq?: InputMaybe<LessonSkillCategoriesEnum>;
  _in?: InputMaybe<Array<LessonSkillCategoriesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonSkillCategoriesEnum>;
  _nin?: InputMaybe<Array<LessonSkillCategoriesEnum>>;
};

/** columns and relationships of "lesson_skill_display_names" */
export type LessonSkillDisplayNames = {
  __typename?: 'LessonSkillDisplayNames';
  createdAt: Scalars['timestamptz'];
  displayName: Scalars['String'];
  id: LessonSkillsEnum;
  updatedAt: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "lesson_skill_display_names". All fields are combined with a logical 'AND'. */
export type LessonSkillDisplayNamesBoolExp = {
  _and?: InputMaybe<Array<LessonSkillDisplayNamesBoolExp>>;
  _not?: InputMaybe<LessonSkillDisplayNamesBoolExp>;
  _or?: InputMaybe<Array<LessonSkillDisplayNamesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<LessonSkillsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** Ordering options when selecting data from "lesson_skill_display_names". */
export type LessonSkillDisplayNamesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_skill_display_names" */
export enum LessonSkillDisplayNamesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "lesson_skill_display_names" */
export type LessonSkillDisplayNamesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonSkillDisplayNamesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonSkillDisplayNamesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "lesson_skill_levels" */
export type LessonSkillLevels = {
  __typename?: 'LessonSkillLevels';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  lessonId: Scalars['uuid'];
  skillLevel: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "lesson_skill_levels" */
export type LessonSkillLevelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonSkillLevelsMaxOrderBy>;
  min?: InputMaybe<LessonSkillLevelsMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_skill_levels" */
export type LessonSkillLevelsArrRelInsertInput = {
  data: Array<LessonSkillLevelsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonSkillLevelsOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_skill_levels". All fields are combined with a logical 'AND'. */
export type LessonSkillLevelsBoolExp = {
  _and?: InputMaybe<Array<LessonSkillLevelsBoolExp>>;
  _not?: InputMaybe<LessonSkillLevelsBoolExp>;
  _or?: InputMaybe<Array<LessonSkillLevelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  skillLevel?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_skill_levels" */
export enum LessonSkillLevelsConstraint {
  /** unique or primary key constraint on columns "lesson_id", "skill_level" */
  LessonSkillLevelsLessonIdSkillLevelKey = 'lesson_skill_levels_lesson_id_skill_level_key',
  /** unique or primary key constraint on columns "id" */
  LessonSkillLevelsPkey = 'lesson_skill_levels_pkey'
}

/** input type for inserting data into table "lesson_skill_levels" */
export type LessonSkillLevelsInsertInput = {
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "lesson_skill_levels" */
export type LessonSkillLevelsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "lesson_skill_levels" */
export type LessonSkillLevelsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_skill_levels" */
export type LessonSkillLevelsMutationResponse = {
  __typename?: 'LessonSkillLevelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonSkillLevels>;
};

/** on_conflict condition type for table "lesson_skill_levels" */
export type LessonSkillLevelsOnConflict = {
  constraint: LessonSkillLevelsConstraint;
  updateColumns?: Array<LessonSkillLevelsUpdateColumn>;
  where?: InputMaybe<LessonSkillLevelsBoolExp>;
};

/** Ordering options when selecting data from "lesson_skill_levels". */
export type LessonSkillLevelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_skill_levels" */
export enum LessonSkillLevelsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  SkillLevel = 'skillLevel',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "lesson_skill_levels" */
export type LessonSkillLevelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonSkillLevelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonSkillLevelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** placeholder for update columns of table "lesson_skill_levels" (current role has no relevant permissions) */
export enum LessonSkillLevelsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "lesson_skill_mappings" */
export type LessonSkillMappings = {
  __typename?: 'LessonSkillMappings';
  category?: Maybe<LessonSkillCategoriesEnum>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  skill: LessonSkillsEnum;
  sport?: Maybe<SportsEnum>;
  updatedAt: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "lesson_skill_mappings". All fields are combined with a logical 'AND'. */
export type LessonSkillMappingsBoolExp = {
  _and?: InputMaybe<Array<LessonSkillMappingsBoolExp>>;
  _not?: InputMaybe<LessonSkillMappingsBoolExp>;
  _or?: InputMaybe<Array<LessonSkillMappingsBoolExp>>;
  category?: InputMaybe<LessonSkillCategoriesEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  skill?: InputMaybe<LessonSkillsEnumComparisonExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** Ordering options when selecting data from "lesson_skill_mappings". */
export type LessonSkillMappingsOrderBy = {
  category?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skill?: InputMaybe<OrderBy>;
  sport?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_skill_mappings" */
export enum LessonSkillMappingsSelectColumn {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Skill = 'skill',
  /** column name */
  Sport = 'sport',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "lesson_skill_mappings" */
export type LessonSkillMappingsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonSkillMappingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonSkillMappingsStreamCursorValueInput = {
  category?: InputMaybe<LessonSkillCategoriesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  sport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "lesson_skills" */
export type LessonSkills = {
  __typename?: 'LessonSkills';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "lesson_skills". All fields are combined with a logical 'AND'. */
export type LessonSkillsBoolExp = {
  _and?: InputMaybe<Array<LessonSkillsBoolExp>>;
  _not?: InputMaybe<LessonSkillsBoolExp>;
  _or?: InputMaybe<Array<LessonSkillsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum LessonSkillsEnum {
  Atp = 'ATP',
  Backhand = 'BACKHAND',
  BaselineQuad = 'BASELINE_QUAD',
  Communication = 'COMMUNICATION',
  CourtPositioning = 'COURT_POSITIONING',
  DepthQuads = 'DEPTH_QUADS',
  Dink = 'DINK',
  DirectionalQuads = 'DIRECTIONAL_QUADS',
  Drive = 'DRIVE',
  Drop = 'DROP',
  Ernie = 'ERNIE',
  Flick = 'FLICK',
  FootWork = 'FOOT_WORK',
  Forehand = 'FOREHAND',
  HalfVolley = 'HALF_VOLLEY',
  HeatQuad = 'HEAT_QUAD',
  InsideOut = 'INSIDE_OUT',
  KitchenQuad = 'KITCHEN_QUAD',
  Lob = 'LOB',
  MentalSkills = 'MENTAL_SKILLS',
  OutsideIn = 'OUTSIDE_IN',
  P4Atp = 'P4_ATP',
  P4BallSector = 'P4_BALL_SECTOR',
  P4BaselineZone = 'P4_BASELINE_ZONE',
  P4BodyZone = 'P4_BODY_ZONE',
  P4DepthZone = 'P4_DEPTH_ZONE',
  P4Dinks = 'P4_DINKS',
  P4DirectionalZone = 'P4_DIRECTIONAL_ZONE',
  P4Drips = 'P4_DRIPS',
  P4Drives = 'P4_DRIVES',
  P4Drops = 'P4_DROPS',
  P4EnergyBounce = 'P4_ENERGY_BOUNCE',
  P4EnergyTransitionZone = 'P4_ENERGY_TRANSITION_ZONE',
  P4EnergyVolley = 'P4_ENERGY_VOLLEY',
  P4Erne = 'P4_ERNE',
  P4Footwork = 'P4_FOOTWORK',
  P4HeatZone = 'P4_HEAT_ZONE',
  P4KitchenZone = 'P4_KITCHEN_ZONE',
  P4Lobs = 'P4_LOBS',
  P4Mindset = 'P4_MINDSET',
  P4Pod = 'P4_POD',
  P4ReadyPosition = 'P4_READY_POSITION',
  P4Resets = 'P4_RESETS',
  P4Returns = 'P4_RETURNS',
  P4Serves = 'P4_SERVES',
  P4ShallowDinks = 'P4_SHALLOW_DINKS',
  P4ShallowZonePro = 'P4_SHALLOW_ZONE_PRO',
  P4TransitionZone = 'P4_TRANSITION_ZONE',
  P4Volleys = 'P4_VOLLEYS',
  P4VolleyDinks = 'P4_VOLLEY_DINKS',
  QuatroAtp = 'QUATRO_ATP',
  QuatroBallQuads = 'QUATRO_BALL_QUADS',
  QuatroBodyQuads = 'QUATRO_BODY_QUADS',
  QuatroDinks = 'QUATRO_DINKS',
  QuatroDrips = 'QUATRO_DRIPS',
  QuatroDrives = 'QUATRO_DRIVES',
  QuatroDrops = 'QUATRO_DROPS',
  QuatroEnergyBounce = 'QUATRO_ENERGY_BOUNCE',
  QuatroEnergyTransitionQuad = 'QUATRO_ENERGY_TRANSITION_QUAD',
  QuatroEnergyVolley = 'QUATRO_ENERGY_VOLLEY',
  QuatroErne = 'QUATRO_ERNE',
  QuatroFootwork = 'QUATRO_FOOTWORK',
  QuatroLobs = 'QUATRO_LOBS',
  QuatroMindset = 'QUATRO_MINDSET',
  QuatroQuabble = 'QUATRO_QUABBLE',
  QuatroReadyPosition = 'QUATRO_READY_POSITION',
  QuatroResets = 'QUATRO_RESETS',
  QuatroReturns = 'QUATRO_RETURNS',
  QuatroServes = 'QUATRO_SERVES',
  QuatroShallowDinks = 'QUATRO_SHALLOW_DINKS',
  QuatroVolleys = 'QUATRO_VOLLEYS',
  QuatroVolleyDinks = 'QUATRO_VOLLEY_DINKS',
  Reset = 'RESET',
  Return = 'RETURN',
  SecondServe = 'SECOND_SERVE',
  Serve = 'SERVE',
  ShallowQuadPro = 'SHALLOW_QUAD_PRO',
  Slice = 'SLICE',
  Smash = 'SMASH',
  Spin = 'SPIN',
  StrategyAndTactics = 'STRATEGY_AND_TACTICS',
  TransitionQuad = 'TRANSITION_QUAD',
  Volley = 'VOLLEY'
}

/** Boolean expression to compare columns of type "LessonSkillsEnum". All fields are combined with logical 'AND'. */
export type LessonSkillsEnumComparisonExp = {
  _eq?: InputMaybe<LessonSkillsEnum>;
  _in?: InputMaybe<Array<LessonSkillsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonSkillsEnum>;
  _nin?: InputMaybe<Array<LessonSkillsEnum>>;
};

/** Ordering options when selecting data from "lesson_skills". */
export type LessonSkillsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_skills" */
export enum LessonSkillsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "lesson_skills" */
export type LessonSkillsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonSkillsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonSkillsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "lesson_statuses" */
export type LessonStatuses = {
  __typename?: 'LessonStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "lesson_statuses". All fields are combined with a logical 'AND'. */
export type LessonStatusesBoolExp = {
  _and?: InputMaybe<Array<LessonStatusesBoolExp>>;
  _not?: InputMaybe<LessonStatusesBoolExp>;
  _or?: InputMaybe<Array<LessonStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum LessonStatusesEnum {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "LessonStatusesEnum". All fields are combined with logical 'AND'. */
export type LessonStatusesEnumComparisonExp = {
  _eq?: InputMaybe<LessonStatusesEnum>;
  _in?: InputMaybe<Array<LessonStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonStatusesEnum>;
  _nin?: InputMaybe<Array<LessonStatusesEnum>>;
};

/** Ordering options when selecting data from "lesson_statuses". */
export type LessonStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_statuses" */
export enum LessonStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "lesson_statuses" */
export type LessonStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "lesson_template_skill_levels" */
export type LessonTemplateSkillLevels = {
  __typename?: 'LessonTemplateSkillLevels';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lessonTemplate: LessonTemplates;
  lessonTemplateId: Scalars['uuid'];
  skillLevel: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonTemplateSkillLevelsMaxOrderBy>;
  min?: InputMaybe<LessonTemplateSkillLevelsMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsArrRelInsertInput = {
  data: Array<LessonTemplateSkillLevelsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonTemplateSkillLevelsOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_template_skill_levels". All fields are combined with a logical 'AND'. */
export type LessonTemplateSkillLevelsBoolExp = {
  _and?: InputMaybe<Array<LessonTemplateSkillLevelsBoolExp>>;
  _not?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
  _or?: InputMaybe<Array<LessonTemplateSkillLevelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonTemplate?: InputMaybe<LessonTemplatesBoolExp>;
  lessonTemplateId?: InputMaybe<UuidComparisonExp>;
  skillLevel?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_template_skill_levels" */
export enum LessonTemplateSkillLevelsConstraint {
  /** unique or primary key constraint on columns "skill_level", "lesson_template_id" */
  LessonTemplateSkillLevelsLessonTemplateIdSkillLevelKey = 'lesson_template_skill_levels_lesson_template_id_skill_level_key',
  /** unique or primary key constraint on columns "id" */
  LessonTemplateSkillLevelsPkey = 'lesson_template_skill_levels_pkey'
}

/** input type for inserting data into table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsInsertInput = {
  lessonTemplate?: InputMaybe<LessonTemplatesObjRelInsertInput>;
  lessonTemplateId?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonTemplateId?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonTemplateId?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsMutationResponse = {
  __typename?: 'LessonTemplateSkillLevelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonTemplateSkillLevels>;
};

/** on_conflict condition type for table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsOnConflict = {
  constraint: LessonTemplateSkillLevelsConstraint;
  updateColumns?: Array<LessonTemplateSkillLevelsUpdateColumn>;
  where?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
};

/** Ordering options when selecting data from "lesson_template_skill_levels". */
export type LessonTemplateSkillLevelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonTemplate?: InputMaybe<LessonTemplatesOrderBy>;
  lessonTemplateId?: InputMaybe<OrderBy>;
  skillLevel?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_template_skill_levels" */
export enum LessonTemplateSkillLevelsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonTemplateId = 'lessonTemplateId',
  /** column name */
  SkillLevel = 'skillLevel',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "lesson_template_skill_levels" */
export type LessonTemplateSkillLevelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonTemplateSkillLevelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonTemplateSkillLevelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonTemplateId?: InputMaybe<Scalars['uuid']>;
  skillLevel?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** placeholder for update columns of table "lesson_template_skill_levels" (current role has no relevant permissions) */
export enum LessonTemplateSkillLevelsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "lesson_templates" */
export type LessonTemplates = {
  __typename?: 'LessonTemplates';
  competitiveness?: Maybe<EventCompetitivenessEnum>;
  coverImageUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  eventType?: Maybe<EventTypesEnum>;
  externalUrl?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  intendedAgeGroup?: Maybe<EventAgeGroupsEnum>;
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  originalEvent?: Maybe<Events>;
  originalEventId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  originalLesson?: Maybe<Lessons>;
  originalLessonId?: Maybe<Scalars['uuid']>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  participantLimit: Scalars['Int'];
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  priceUnitAmount: Scalars['Int'];
  privacy?: Maybe<LessonPrivacyEnum>;
  singlesDoubles?: Maybe<Scalars['String']>;
  /** An array relationship */
  skillLevels: Array<LessonTemplateSkillLevels>;
  sport?: Maybe<SportsEnum>;
  templateName: Scalars['String'];
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  title: Scalars['String'];
  type?: Maybe<LessonTypesEnum>;
  typeCustom: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "lesson_templates" */
export type LessonTemplatesSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplateSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplateSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
};

/** order by aggregate values of table "lesson_templates" */
export type LessonTemplatesAggregateOrderBy = {
  avg?: InputMaybe<LessonTemplatesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonTemplatesMaxOrderBy>;
  min?: InputMaybe<LessonTemplatesMinOrderBy>;
  stddev?: InputMaybe<LessonTemplatesStddevOrderBy>;
  stddevPop?: InputMaybe<LessonTemplatesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LessonTemplatesStddevSampOrderBy>;
  sum?: InputMaybe<LessonTemplatesSumOrderBy>;
  varPop?: InputMaybe<LessonTemplatesVarPopOrderBy>;
  varSamp?: InputMaybe<LessonTemplatesVarSampOrderBy>;
  variance?: InputMaybe<LessonTemplatesVarianceOrderBy>;
};

/** order by avg() on columns of table "lesson_templates" */
export type LessonTemplatesAvgOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lesson_templates". All fields are combined with a logical 'AND'. */
export type LessonTemplatesBoolExp = {
  _and?: InputMaybe<Array<LessonTemplatesBoolExp>>;
  _not?: InputMaybe<LessonTemplatesBoolExp>;
  _or?: InputMaybe<Array<LessonTemplatesBoolExp>>;
  competitiveness?: InputMaybe<EventCompetitivenessEnumComparisonExp>;
  coverImageUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  eventType?: InputMaybe<EventTypesEnumComparisonExp>;
  externalUrl?: InputMaybe<StringComparisonExp>;
  gender?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnumComparisonExp>;
  maximumRating?: InputMaybe<NumericComparisonExp>;
  minimumRating?: InputMaybe<NumericComparisonExp>;
  originalEvent?: InputMaybe<EventsBoolExp>;
  originalEventId?: InputMaybe<UuidComparisonExp>;
  originalLesson?: InputMaybe<LessonsBoolExp>;
  originalLessonId?: InputMaybe<UuidComparisonExp>;
  padelRatingScaleId?: InputMaybe<UuidComparisonExp>;
  participantLimit?: InputMaybe<IntComparisonExp>;
  pickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  privacy?: InputMaybe<LessonPrivacyEnumComparisonExp>;
  singlesDoubles?: InputMaybe<StringComparisonExp>;
  skillLevels?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  templateName?: InputMaybe<StringComparisonExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<LessonTypesEnumComparisonExp>;
  typeCustom?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userCustomCourtId?: InputMaybe<UuidComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "lesson_templates" */
export enum LessonTemplatesConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonTemplatesPkey = 'lesson_templates_pkey'
}

/** input type for incrementing numeric columns in table "lesson_templates" */
export type LessonTemplatesIncInput = {
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lesson_templates" */
export type LessonTemplatesInsertInput = {
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<EventTypesEnum>;
  externalUrl?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  originalEvent?: InputMaybe<EventsObjRelInsertInput>;
  originalEventId?: InputMaybe<Scalars['uuid']>;
  originalLesson?: InputMaybe<LessonsObjRelInsertInput>;
  originalLessonId?: InputMaybe<Scalars['uuid']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<LessonPrivacyEnum>;
  singlesDoubles?: InputMaybe<Scalars['String']>;
  skillLevels?: InputMaybe<LessonTemplateSkillLevelsArrRelInsertInput>;
  sport?: InputMaybe<SportsEnum>;
  templateName?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  typeCustom?: InputMaybe<Scalars['String']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lesson_templates" */
export type LessonTemplatesMaxOrderBy = {
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  originalEventId?: InputMaybe<OrderBy>;
  originalLessonId?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  singlesDoubles?: InputMaybe<OrderBy>;
  templateName?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  typeCustom?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "lesson_templates" */
export type LessonTemplatesMinOrderBy = {
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  originalEventId?: InputMaybe<OrderBy>;
  originalLessonId?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  singlesDoubles?: InputMaybe<OrderBy>;
  templateName?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  typeCustom?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_templates" */
export type LessonTemplatesMutationResponse = {
  __typename?: 'LessonTemplatesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonTemplates>;
};

/** input type for inserting object relation for remote table "lesson_templates" */
export type LessonTemplatesObjRelInsertInput = {
  data: LessonTemplatesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonTemplatesOnConflict>;
};

/** on_conflict condition type for table "lesson_templates" */
export type LessonTemplatesOnConflict = {
  constraint: LessonTemplatesConstraint;
  updateColumns?: Array<LessonTemplatesUpdateColumn>;
  where?: InputMaybe<LessonTemplatesBoolExp>;
};

/** Ordering options when selecting data from "lesson_templates". */
export type LessonTemplatesOrderBy = {
  competitiveness?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  eventType?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  intendedAgeGroup?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  originalEvent?: InputMaybe<EventsOrderBy>;
  originalEventId?: InputMaybe<OrderBy>;
  originalLesson?: InputMaybe<LessonsOrderBy>;
  originalLessonId?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  privacy?: InputMaybe<OrderBy>;
  singlesDoubles?: InputMaybe<OrderBy>;
  skillLevelsAggregate?: InputMaybe<LessonTemplateSkillLevelsAggregateOrderBy>;
  sport?: InputMaybe<OrderBy>;
  templateName?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  typeCustom?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_templates */
export type LessonTemplatesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_templates" */
export enum LessonTemplatesSelectColumn {
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  EventType = 'eventType',
  /** column name */
  ExternalUrl = 'externalUrl',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IntendedAgeGroup = 'intendedAgeGroup',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  OriginalEventId = 'originalEventId',
  /** column name */
  OriginalLessonId = 'originalLessonId',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  SinglesDoubles = 'singlesDoubles',
  /** column name */
  Sport = 'sport',
  /** column name */
  TemplateName = 'templateName',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  TypeCustom = 'typeCustom',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "lesson_templates" */
export type LessonTemplatesSetInput = {
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<EventTypesEnum>;
  externalUrl?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<LessonPrivacyEnum>;
  singlesDoubles?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<SportsEnum>;
  templateName?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  typeCustom?: InputMaybe<Scalars['String']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
};

/** order by stddev() on columns of table "lesson_templates" */
export type LessonTemplatesStddevOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "lesson_templates" */
export type LessonTemplatesStddevPopOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "lesson_templates" */
export type LessonTemplatesStddevSampOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lesson_templates" */
export type LessonTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonTemplatesStreamCursorValueInput = {
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<EventTypesEnum>;
  externalUrl?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  originalEventId?: InputMaybe<Scalars['uuid']>;
  originalLessonId?: InputMaybe<Scalars['uuid']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<LessonPrivacyEnum>;
  singlesDoubles?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<SportsEnum>;
  templateName?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  typeCustom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "lesson_templates" */
export type LessonTemplatesSumOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "lesson_templates" */
export enum LessonTemplatesUpdateColumn {
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  EventType = 'eventType',
  /** column name */
  ExternalUrl = 'externalUrl',
  /** column name */
  Gender = 'gender',
  /** column name */
  IntendedAgeGroup = 'intendedAgeGroup',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  SinglesDoubles = 'singlesDoubles',
  /** column name */
  Sport = 'sport',
  /** column name */
  TemplateName = 'templateName',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  TypeCustom = 'typeCustom',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId'
}

export type LessonTemplatesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LessonTemplatesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: LessonTemplatesBoolExp;
};

/** order by varPop() on columns of table "lesson_templates" */
export type LessonTemplatesVarPopOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "lesson_templates" */
export type LessonTemplatesVarSampOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "lesson_templates" */
export type LessonTemplatesVarianceOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** While thinking through how we handle events with multiple dates or times (ie. a camp), this table was made. It will be actively used once that logic has been thought through more. HOWEVER, another option would be to put an FK on lessons that points to a parent lesson that drives it. This would also allow for things like descriptions for each individual lesson. This is a little more complex though. */
export type LessonTimes = {
  __typename?: 'LessonTimes';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endDateTime: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  lessonId: Scalars['uuid'];
  startDateTime: Scalars['timestamptz'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "lesson_times" */
export type LessonTimesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonTimesMaxOrderBy>;
  min?: InputMaybe<LessonTimesMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_times" */
export type LessonTimesArrRelInsertInput = {
  data: Array<LessonTimesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonTimesOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_times". All fields are combined with a logical 'AND'. */
export type LessonTimesBoolExp = {
  _and?: InputMaybe<Array<LessonTimesBoolExp>>;
  _not?: InputMaybe<LessonTimesBoolExp>;
  _or?: InputMaybe<Array<LessonTimesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  endDateTime?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  startDateTime?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "lesson_times" */
export enum LessonTimesConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonTimesPkey = 'lesson_times_pkey'
}

/** input type for inserting data into table "lesson_times" */
export type LessonTimesInsertInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "lesson_times" */
export type LessonTimesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "lesson_times" */
export type LessonTimesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_times" */
export type LessonTimesMutationResponse = {
  __typename?: 'LessonTimesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonTimes>;
};

/** on_conflict condition type for table "lesson_times" */
export type LessonTimesOnConflict = {
  constraint: LessonTimesConstraint;
  updateColumns?: Array<LessonTimesUpdateColumn>;
  where?: InputMaybe<LessonTimesBoolExp>;
};

/** Ordering options when selecting data from "lesson_times". */
export type LessonTimesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lesson_times */
export type LessonTimesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_times" */
export enum LessonTimesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "lesson_times" */
export type LessonTimesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "lesson_times" */
export type LessonTimesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonTimesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonTimesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "lesson_times" */
export enum LessonTimesUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  StartDateTime = 'startDateTime'
}

export type LessonTimesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonTimesSetInput>;
  /** filter the rows which have to be updated */
  where: LessonTimesBoolExp;
};

/** columns and relationships of "lesson_types" */
export type LessonTypes = {
  __typename?: 'LessonTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "lesson_types". All fields are combined with a logical 'AND'. */
export type LessonTypesBoolExp = {
  _and?: InputMaybe<Array<LessonTypesBoolExp>>;
  _not?: InputMaybe<LessonTypesBoolExp>;
  _or?: InputMaybe<Array<LessonTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum LessonTypesEnum {
  Camp = 'CAMP',
  Cardio = 'CARDIO',
  Clinic = 'CLINIC',
  Custom = 'CUSTOM',
  Individual = 'INDIVIDUAL',
  OpenPlay = 'OPEN_PLAY',
  Retreat = 'RETREAT',
  Rfx = 'RFX'
}

/** Boolean expression to compare columns of type "LessonTypesEnum". All fields are combined with logical 'AND'. */
export type LessonTypesEnumComparisonExp = {
  _eq?: InputMaybe<LessonTypesEnum>;
  _in?: InputMaybe<Array<LessonTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonTypesEnum>;
  _nin?: InputMaybe<Array<LessonTypesEnum>>;
};

/** Ordering options when selecting data from "lesson_types". */
export type LessonTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_types" */
export enum LessonTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "lesson_types" */
export type LessonTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "lesson_waitlist_statuses" */
export type LessonWaitlistStatuses = {
  __typename?: 'LessonWaitlistStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "lesson_waitlist_statuses". All fields are combined with a logical 'AND'. */
export type LessonWaitlistStatusesBoolExp = {
  _and?: InputMaybe<Array<LessonWaitlistStatusesBoolExp>>;
  _not?: InputMaybe<LessonWaitlistStatusesBoolExp>;
  _or?: InputMaybe<Array<LessonWaitlistStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum LessonWaitlistStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "LessonWaitlistStatusesEnum". All fields are combined with logical 'AND'. */
export type LessonWaitlistStatusesEnumComparisonExp = {
  _eq?: InputMaybe<LessonWaitlistStatusesEnum>;
  _in?: InputMaybe<Array<LessonWaitlistStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<LessonWaitlistStatusesEnum>;
  _nin?: InputMaybe<Array<LessonWaitlistStatusesEnum>>;
};

/** Ordering options when selecting data from "lesson_waitlist_statuses". */
export type LessonWaitlistStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "lesson_waitlist_statuses" */
export enum LessonWaitlistStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "lesson_waitlist_statuses" */
export type LessonWaitlistStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonWaitlistStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonWaitlistStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "lesson_waitlists" */
export type LessonWaitlists = {
  __typename?: 'LessonWaitlists';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  lessonId: Scalars['uuid'];
  status: LessonWaitlistStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** aggregated selection of "lesson_waitlists" */
export type LessonWaitlistsAggregate = {
  __typename?: 'LessonWaitlistsAggregate';
  aggregate?: Maybe<LessonWaitlistsAggregateFields>;
  nodes: Array<LessonWaitlists>;
};

export type LessonWaitlistsAggregateBoolExp = {
  count?: InputMaybe<LessonWaitlistsAggregateBoolExpCount>;
};

/** aggregate fields of "lesson_waitlists" */
export type LessonWaitlistsAggregateFields = {
  __typename?: 'LessonWaitlistsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LessonWaitlistsMaxFields>;
  min?: Maybe<LessonWaitlistsMinFields>;
};


/** aggregate fields of "lesson_waitlists" */
export type LessonWaitlistsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lesson_waitlists" */
export type LessonWaitlistsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonWaitlistsMaxOrderBy>;
  min?: InputMaybe<LessonWaitlistsMinOrderBy>;
};

/** input type for inserting array relation for remote table "lesson_waitlists" */
export type LessonWaitlistsArrRelInsertInput = {
  data: Array<LessonWaitlistsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonWaitlistsOnConflict>;
};

/** Boolean expression to filter rows from the table "lesson_waitlists". All fields are combined with a logical 'AND'. */
export type LessonWaitlistsBoolExp = {
  _and?: InputMaybe<Array<LessonWaitlistsBoolExp>>;
  _not?: InputMaybe<LessonWaitlistsBoolExp>;
  _or?: InputMaybe<Array<LessonWaitlistsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<LessonWaitlistStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "lesson_waitlists" */
export enum LessonWaitlistsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonWaitlistsPkey = 'lesson_waitlists_pkey',
  /** unique or primary key constraint on columns "lesson_id", "user_id" */
  LessonWaitlistsUserIdLessonIdKey = 'lesson_waitlists_user_id_lesson_id_key'
}

/** input type for inserting data into table "lesson_waitlists" */
export type LessonWaitlistsInsertInput = {
  lesson?: InputMaybe<LessonsObjRelInsertInput>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<LessonWaitlistStatusesEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type LessonWaitlistsMaxFields = {
  __typename?: 'LessonWaitlistsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lesson_waitlists" */
export type LessonWaitlistsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonWaitlistsMinFields = {
  __typename?: 'LessonWaitlistsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "lesson_waitlists" */
export type LessonWaitlistsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lesson_waitlists" */
export type LessonWaitlistsMutationResponse = {
  __typename?: 'LessonWaitlistsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LessonWaitlists>;
};

/** on_conflict condition type for table "lesson_waitlists" */
export type LessonWaitlistsOnConflict = {
  constraint: LessonWaitlistsConstraint;
  updateColumns?: Array<LessonWaitlistsUpdateColumn>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};

/** Ordering options when selecting data from "lesson_waitlists". */
export type LessonWaitlistsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: lesson_waitlists */
export type LessonWaitlistsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lesson_waitlists" */
export enum LessonWaitlistsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "lesson_waitlists" */
export type LessonWaitlistsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<LessonWaitlistStatusesEnum>;
};

/** Streaming cursor of the table "lesson_waitlists" */
export type LessonWaitlistsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonWaitlistsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonWaitlistsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<LessonWaitlistStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "lesson_waitlists" */
export enum LessonWaitlistsUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Status = 'status'
}

export type LessonWaitlistsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonWaitlistsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonWaitlistsBoolExp;
};

/** columns and relationships of "lessons" */
export type Lessons = {
  __typename?: 'Lessons';
  cancelReason: Scalars['String'];
  canceledAt?: Maybe<Scalars['timestamptz']>;
  completionHasuraEventId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  conversations: Array<Conversations>;
  coverImageFileName: Scalars['String'];
  coverImagePath: Scalars['String'];
  coverImageProvider: Scalars['String'];
  coverImageProviderId: Scalars['String'];
  coverImageProviderUrl: Scalars['String'];
  coverImageUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  endDateTime?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  equipment: Array<LessonEquipment>;
  externalBookingUrl: Scalars['String'];
  externalSource?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  intendedAgeGroup?: Maybe<EventAgeGroupsEnum>;
  /** An object relationship */
  lessonCollection?: Maybe<LessonCollections>;
  lessonCollectionId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  lessonPlayerSkillAssessments: Array<LessonPlayerSkillAssessments>;
  lessonReflectionId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  lessonReflections: Array<LessonReflections>;
  locale: Scalars['String'];
  /** An array relationship */
  orders: Array<LessonOrders>;
  /** An aggregate relationship */
  ordersAggregate: LessonOrdersAggregate;
  /** An object relationship */
  owner?: Maybe<Users>;
  /** An object relationship */
  ownerProfile?: Maybe<UserProfiles>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  /** An array relationship */
  participants: Array<LessonParticipants>;
  /** An aggregate relationship */
  participantsAggregate: LessonParticipantsAggregate;
  paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount: Scalars['Int'];
  privacy: LessonPrivacyEnum;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  recurrenceKind?: Maybe<RecurrenceKindsEnum>;
  reminderEventId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  skillLevels: Array<LessonSkillLevels>;
  sport: SportsEnum;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  status: LessonStatusesEnum;
  /** An array relationship */
  times: Array<LessonTimes>;
  timezoneAbbreviation: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
  title: Scalars['String'];
  type: LessonTypesEnum;
  typeCustom: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  usedTemplate?: Maybe<LessonTemplates>;
  usedTemplateId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  userCustomCourt?: Maybe<UserCustomCourts>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  venue?: Maybe<Venues>;
  venueId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  waitlist: Array<LessonWaitlists>;
  /** An aggregate relationship */
  waitlistAggregate: LessonWaitlistsAggregate;
};


/** columns and relationships of "lessons" */
export type LessonsConversationsArgs = {
  distinctOn?: InputMaybe<Array<ConversationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
  where?: InputMaybe<ConversationsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsEquipmentArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOrderBy>>;
  where?: InputMaybe<LessonEquipmentBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsLessonPlayerSkillAssessmentsArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsLessonReflectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsOrdersArgs = {
  distinctOn?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrdersOrderBy>>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrdersOrderBy>>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsParticipantsArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonSkillLevelsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsTimesArgs = {
  distinctOn?: InputMaybe<Array<LessonTimesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTimesOrderBy>>;
  where?: InputMaybe<LessonTimesBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsWaitlistArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistsOrderBy>>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};


/** columns and relationships of "lessons" */
export type LessonsWaitlistAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistsOrderBy>>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};

/** aggregated selection of "lessons" */
export type LessonsAggregate = {
  __typename?: 'LessonsAggregate';
  aggregate?: Maybe<LessonsAggregateFields>;
  nodes: Array<Lessons>;
};

export type LessonsAggregateBoolExp = {
  count?: InputMaybe<LessonsAggregateBoolExpCount>;
};

/** aggregate fields of "lessons" */
export type LessonsAggregateFields = {
  __typename?: 'LessonsAggregateFields';
  avg?: Maybe<LessonsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LessonsMaxFields>;
  min?: Maybe<LessonsMinFields>;
  stddev?: Maybe<LessonsStddevFields>;
  stddevPop?: Maybe<LessonsStddevPopFields>;
  stddevSamp?: Maybe<LessonsStddevSampFields>;
  sum?: Maybe<LessonsSumFields>;
  varPop?: Maybe<LessonsVarPopFields>;
  varSamp?: Maybe<LessonsVarSampFields>;
  variance?: Maybe<LessonsVarianceFields>;
};


/** aggregate fields of "lessons" */
export type LessonsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LessonsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lessons" */
export type LessonsAggregateOrderBy = {
  avg?: InputMaybe<LessonsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LessonsMaxOrderBy>;
  min?: InputMaybe<LessonsMinOrderBy>;
  stddev?: InputMaybe<LessonsStddevOrderBy>;
  stddevPop?: InputMaybe<LessonsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LessonsStddevSampOrderBy>;
  sum?: InputMaybe<LessonsSumOrderBy>;
  varPop?: InputMaybe<LessonsVarPopOrderBy>;
  varSamp?: InputMaybe<LessonsVarSampOrderBy>;
  variance?: InputMaybe<LessonsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "lessons" */
export type LessonsArrRelInsertInput = {
  data: Array<LessonsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LessonsOnConflict>;
};

/** aggregate avg on columns */
export type LessonsAvgFields = {
  __typename?: 'LessonsAvgFields';
  participantLimit?: Maybe<Scalars['Float']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lessons" */
export type LessonsAvgOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lessons". All fields are combined with a logical 'AND'. */
export type LessonsBoolExp = {
  _and?: InputMaybe<Array<LessonsBoolExp>>;
  _not?: InputMaybe<LessonsBoolExp>;
  _or?: InputMaybe<Array<LessonsBoolExp>>;
  cancelReason?: InputMaybe<StringComparisonExp>;
  canceledAt?: InputMaybe<TimestamptzComparisonExp>;
  completionHasuraEventId?: InputMaybe<UuidComparisonExp>;
  conversations?: InputMaybe<ConversationsBoolExp>;
  coverImageFileName?: InputMaybe<StringComparisonExp>;
  coverImagePath?: InputMaybe<StringComparisonExp>;
  coverImageProvider?: InputMaybe<StringComparisonExp>;
  coverImageProviderId?: InputMaybe<StringComparisonExp>;
  coverImageProviderUrl?: InputMaybe<StringComparisonExp>;
  coverImageUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  endDateTime?: InputMaybe<TimestamptzComparisonExp>;
  equipment?: InputMaybe<LessonEquipmentBoolExp>;
  externalBookingUrl?: InputMaybe<StringComparisonExp>;
  externalSource?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnumComparisonExp>;
  lessonCollection?: InputMaybe<LessonCollectionsBoolExp>;
  lessonCollectionId?: InputMaybe<UuidComparisonExp>;
  lessonPlayerSkillAssessments?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
  lessonReflectionId?: InputMaybe<UuidComparisonExp>;
  lessonReflections?: InputMaybe<LessonReflectionsBoolExp>;
  locale?: InputMaybe<StringComparisonExp>;
  orders?: InputMaybe<LessonOrdersBoolExp>;
  ordersAggregate?: InputMaybe<LessonOrdersAggregateBoolExp>;
  owner?: InputMaybe<UsersBoolExp>;
  ownerProfile?: InputMaybe<UserProfilesBoolExp>;
  ownerUserId?: InputMaybe<UuidComparisonExp>;
  participantLimit?: InputMaybe<IntComparisonExp>;
  participants?: InputMaybe<LessonParticipantsBoolExp>;
  participantsAggregate?: InputMaybe<LessonParticipantsAggregateBoolExp>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnumComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  privacy?: InputMaybe<LessonPrivacyEnumComparisonExp>;
  publishedAt?: InputMaybe<TimestamptzComparisonExp>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnumComparisonExp>;
  reminderEventId?: InputMaybe<UuidComparisonExp>;
  skillLevels?: InputMaybe<LessonSkillLevelsBoolExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  startDateTime?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<LessonStatusesEnumComparisonExp>;
  times?: InputMaybe<LessonTimesBoolExp>;
  timezoneAbbreviation?: InputMaybe<StringComparisonExp>;
  timezoneName?: InputMaybe<StringComparisonExp>;
  timezoneOffsetMinutes?: InputMaybe<IntComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<LessonTypesEnumComparisonExp>;
  typeCustom?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  usedTemplate?: InputMaybe<LessonTemplatesBoolExp>;
  usedTemplateId?: InputMaybe<UuidComparisonExp>;
  userCustomCourt?: InputMaybe<UserCustomCourtsBoolExp>;
  userCustomCourtId?: InputMaybe<UuidComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
  waitlist?: InputMaybe<LessonWaitlistsBoolExp>;
  waitlistAggregate?: InputMaybe<LessonWaitlistsAggregateBoolExp>;
};

/** unique or primary key constraints on table "lessons" */
export enum LessonsConstraint {
  /** unique or primary key constraint on columns "id" */
  LessonsPkey = 'lessons_pkey'
}

/** input type for incrementing numeric columns in table "lessons" */
export type LessonsIncInput = {
  participantLimit?: InputMaybe<Scalars['Int']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lessons" */
export type LessonsInsertInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  equipment?: InputMaybe<LessonEquipmentArrRelInsertInput>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  lessonCollection?: InputMaybe<LessonCollectionsObjRelInsertInput>;
  lessonCollectionId?: InputMaybe<Scalars['uuid']>;
  lessonPlayerSkillAssessments?: InputMaybe<LessonPlayerSkillAssessmentsArrRelInsertInput>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  lessonReflections?: InputMaybe<LessonReflectionsArrRelInsertInput>;
  locale?: InputMaybe<Scalars['String']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  participants?: InputMaybe<LessonParticipantsArrRelInsertInput>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<LessonPrivacyEnum>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  skillLevels?: InputMaybe<LessonSkillLevelsArrRelInsertInput>;
  sport?: InputMaybe<SportsEnum>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<LessonStatusesEnum>;
  times?: InputMaybe<LessonTimesArrRelInsertInput>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  typeCustom?: InputMaybe<Scalars['String']>;
  usedTemplate?: InputMaybe<LessonTemplatesObjRelInsertInput>;
  usedTemplateId?: InputMaybe<Scalars['uuid']>;
  userCustomCourt?: InputMaybe<UserCustomCourtsObjRelInsertInput>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  waitlist?: InputMaybe<LessonWaitlistsArrRelInsertInput>;
};

/** aggregate max on columns */
export type LessonsMaxFields = {
  __typename?: 'LessonsMaxFields';
  cancelReason?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  completionHasuraEventId?: Maybe<Scalars['uuid']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderId?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['timestamptz']>;
  externalBookingUrl?: Maybe<Scalars['String']>;
  externalSource?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonCollectionId?: Maybe<Scalars['uuid']>;
  lessonReflectionId?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  reminderEventId?: Maybe<Scalars['uuid']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  typeCustom?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  usedTemplateId?: Maybe<Scalars['uuid']>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lessons" */
export type LessonsMaxOrderBy = {
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  completionHasuraEventId?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  externalBookingUrl?: InputMaybe<OrderBy>;
  externalSource?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonCollectionId?: InputMaybe<OrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  reminderEventId?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  typeCustom?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usedTemplateId?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LessonsMinFields = {
  __typename?: 'LessonsMinFields';
  cancelReason?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  completionHasuraEventId?: Maybe<Scalars['uuid']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderId?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['timestamptz']>;
  externalBookingUrl?: Maybe<Scalars['String']>;
  externalSource?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonCollectionId?: Maybe<Scalars['uuid']>;
  lessonReflectionId?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  ownerUserId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  reminderEventId?: Maybe<Scalars['uuid']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  typeCustom?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  usedTemplateId?: Maybe<Scalars['uuid']>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "lessons" */
export type LessonsMinOrderBy = {
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  completionHasuraEventId?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  externalBookingUrl?: InputMaybe<OrderBy>;
  externalSource?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonCollectionId?: InputMaybe<OrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  reminderEventId?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  typeCustom?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usedTemplateId?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lessons" */
export type LessonsMutationResponse = {
  __typename?: 'LessonsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Lessons>;
};

/** input type for inserting object relation for remote table "lessons" */
export type LessonsObjRelInsertInput = {
  data: LessonsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LessonsOnConflict>;
};

/** on_conflict condition type for table "lessons" */
export type LessonsOnConflict = {
  constraint: LessonsConstraint;
  updateColumns?: Array<LessonsUpdateColumn>;
  where?: InputMaybe<LessonsBoolExp>;
};

/** Ordering options when selecting data from "lessons". */
export type LessonsOrderBy = {
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  completionHasuraEventId?: InputMaybe<OrderBy>;
  conversationsAggregate?: InputMaybe<ConversationsAggregateOrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  equipmentAggregate?: InputMaybe<LessonEquipmentAggregateOrderBy>;
  externalBookingUrl?: InputMaybe<OrderBy>;
  externalSource?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  intendedAgeGroup?: InputMaybe<OrderBy>;
  lessonCollection?: InputMaybe<LessonCollectionsOrderBy>;
  lessonCollectionId?: InputMaybe<OrderBy>;
  lessonPlayerSkillAssessmentsAggregate?: InputMaybe<LessonPlayerSkillAssessmentsAggregateOrderBy>;
  lessonReflectionId?: InputMaybe<OrderBy>;
  lessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateOrderBy>;
  locale?: InputMaybe<OrderBy>;
  ordersAggregate?: InputMaybe<LessonOrdersAggregateOrderBy>;
  owner?: InputMaybe<UsersOrderBy>;
  ownerProfile?: InputMaybe<UserProfilesOrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  participantsAggregate?: InputMaybe<LessonParticipantsAggregateOrderBy>;
  paymentFulfillmentChannel?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  privacy?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  recurrenceKind?: InputMaybe<OrderBy>;
  reminderEventId?: InputMaybe<OrderBy>;
  skillLevelsAggregate?: InputMaybe<LessonSkillLevelsAggregateOrderBy>;
  sport?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  timesAggregate?: InputMaybe<LessonTimesAggregateOrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  typeCustom?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usedTemplate?: InputMaybe<LessonTemplatesOrderBy>;
  usedTemplateId?: InputMaybe<OrderBy>;
  userCustomCourt?: InputMaybe<UserCustomCourtsOrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
  waitlistAggregate?: InputMaybe<LessonWaitlistsAggregateOrderBy>;
};

/** primary key columns input for table: lessons */
export type LessonsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "lessons" */
export enum LessonsSelectColumn {
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  CompletionHasuraEventId = 'completionHasuraEventId',
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderId = 'coverImageProviderId',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  ExternalBookingUrl = 'externalBookingUrl',
  /** column name */
  ExternalSource = 'externalSource',
  /** column name */
  Id = 'id',
  /** column name */
  IntendedAgeGroup = 'intendedAgeGroup',
  /** column name */
  LessonCollectionId = 'lessonCollectionId',
  /** column name */
  LessonReflectionId = 'lessonReflectionId',
  /** column name */
  Locale = 'locale',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RecurrenceKind = 'recurrenceKind',
  /** column name */
  ReminderEventId = 'reminderEventId',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  Status = 'status',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  TypeCustom = 'typeCustom',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsedTemplateId = 'usedTemplateId',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "lessons" */
export type LessonsSetInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  lessonCollectionId?: InputMaybe<Scalars['uuid']>;
  locale?: InputMaybe<Scalars['String']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<LessonPrivacyEnum>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  sport?: InputMaybe<SportsEnum>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<LessonStatusesEnum>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  typeCustom?: InputMaybe<Scalars['String']>;
  usedTemplateId?: InputMaybe<Scalars['uuid']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type LessonsStddevFields = {
  __typename?: 'LessonsStddevFields';
  participantLimit?: Maybe<Scalars['Float']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lessons" */
export type LessonsStddevOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type LessonsStddevPopFields = {
  __typename?: 'LessonsStddevPopFields';
  participantLimit?: Maybe<Scalars['Float']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "lessons" */
export type LessonsStddevPopOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type LessonsStddevSampFields = {
  __typename?: 'LessonsStddevSampFields';
  participantLimit?: Maybe<Scalars['Float']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "lessons" */
export type LessonsStddevSampOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lessons" */
export type LessonsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LessonsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LessonsStreamCursorValueInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  completionHasuraEventId?: InputMaybe<Scalars['uuid']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  externalSource?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  lessonCollectionId?: InputMaybe<Scalars['uuid']>;
  lessonReflectionId?: InputMaybe<Scalars['uuid']>;
  locale?: InputMaybe<Scalars['String']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<LessonPrivacyEnum>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  recurrenceKind?: InputMaybe<RecurrenceKindsEnum>;
  reminderEventId?: InputMaybe<Scalars['uuid']>;
  sport?: InputMaybe<SportsEnum>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<LessonStatusesEnum>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  typeCustom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usedTemplateId?: InputMaybe<Scalars['uuid']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type LessonsSumFields = {
  __typename?: 'LessonsSumFields';
  participantLimit?: Maybe<Scalars['Int']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Int']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "lessons" */
export type LessonsSumOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** update columns of table "lessons" */
export enum LessonsUpdateColumn {
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderId = 'coverImageProviderId',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  ExternalBookingUrl = 'externalBookingUrl',
  /** column name */
  IntendedAgeGroup = 'intendedAgeGroup',
  /** column name */
  LessonCollectionId = 'lessonCollectionId',
  /** column name */
  Locale = 'locale',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  RecurrenceKind = 'recurrenceKind',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  Status = 'status',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  TypeCustom = 'typeCustom',
  /** column name */
  UsedTemplateId = 'usedTemplateId',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  VenueId = 'venueId'
}

export type LessonsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LessonsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LessonsSetInput>;
  /** filter the rows which have to be updated */
  where: LessonsBoolExp;
};

/** aggregate varPop on columns */
export type LessonsVarPopFields = {
  __typename?: 'LessonsVarPopFields';
  participantLimit?: Maybe<Scalars['Float']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "lessons" */
export type LessonsVarPopOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type LessonsVarSampFields = {
  __typename?: 'LessonsVarSampFields';
  participantLimit?: Maybe<Scalars['Float']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "lessons" */
export type LessonsVarSampOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LessonsVarianceFields = {
  __typename?: 'LessonsVarianceFields';
  participantLimit?: Maybe<Scalars['Float']>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lessons" */
export type LessonsVarianceOrderBy = {
  participantLimit?: InputMaybe<OrderBy>;
  /** This follows the standard from Stripe where a price is stored in its smallest denomination as an integer. In USD, this would be cents. For example, $42.23 is stored as 4223. */
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** columns and relationships of "match_selection_criteria" */
export type MatchSelectionCriteria = {
  __typename?: 'MatchSelectionCriteria';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "match_selection_criteria". All fields are combined with a logical 'AND'. */
export type MatchSelectionCriteriaBoolExp = {
  _and?: InputMaybe<Array<MatchSelectionCriteriaBoolExp>>;
  _not?: InputMaybe<MatchSelectionCriteriaBoolExp>;
  _or?: InputMaybe<Array<MatchSelectionCriteriaBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum MatchSelectionCriteriaEnum {
  Loser = 'LOSER',
  Winner = 'WINNER'
}

/** Boolean expression to compare columns of type "MatchSelectionCriteriaEnum". All fields are combined with logical 'AND'. */
export type MatchSelectionCriteriaEnumComparisonExp = {
  _eq?: InputMaybe<MatchSelectionCriteriaEnum>;
  _in?: InputMaybe<Array<MatchSelectionCriteriaEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<MatchSelectionCriteriaEnum>;
  _nin?: InputMaybe<Array<MatchSelectionCriteriaEnum>>;
};

/** Ordering options when selecting data from "match_selection_criteria". */
export type MatchSelectionCriteriaOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "match_selection_criteria" */
export enum MatchSelectionCriteriaSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "match_selection_criteria" */
export type MatchSelectionCriteriaStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MatchSelectionCriteriaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MatchSelectionCriteriaStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "messages" */
export type Messages = {
  __typename?: 'Messages';
  body: Scalars['String'];
  /** An object relationship */
  conversation: Conversations;
  conversationId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  editedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  sender: Users;
  /** An object relationship */
  senderProfile?: Maybe<UserProfiles>;
  senderUserId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "messages" */
export type MessagesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MessagesMaxOrderBy>;
  min?: InputMaybe<MessagesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "messages". All fields are combined with a logical 'AND'. */
export type MessagesBoolExp = {
  _and?: InputMaybe<Array<MessagesBoolExp>>;
  _not?: InputMaybe<MessagesBoolExp>;
  _or?: InputMaybe<Array<MessagesBoolExp>>;
  body?: InputMaybe<StringComparisonExp>;
  conversation?: InputMaybe<ConversationsBoolExp>;
  conversationId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  editedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  sender?: InputMaybe<UsersBoolExp>;
  senderProfile?: InputMaybe<UserProfilesBoolExp>;
  senderUserId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "messages" */
export type MessagesMaxOrderBy = {
  body?: InputMaybe<OrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  editedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  senderUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "messages" */
export type MessagesMinOrderBy = {
  body?: InputMaybe<OrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  editedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  senderUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "messages". */
export type MessagesOrderBy = {
  body?: InputMaybe<OrderBy>;
  conversation?: InputMaybe<ConversationsOrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  editedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sender?: InputMaybe<UsersOrderBy>;
  senderProfile?: InputMaybe<UserProfilesOrderBy>;
  senderUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "messages" */
export enum MessagesSelectColumn {
  /** column name */
  Body = 'body',
  /** column name */
  ConversationId = 'conversationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EditedAt = 'editedAt',
  /** column name */
  Id = 'id',
  /** column name */
  SenderUserId = 'senderUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "messages" */
export type MessagesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MessagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessagesStreamCursorValueInput = {
  body?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  editedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  senderUserId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "neighborhoods" */
export type Neighborhoods = {
  __typename?: 'Neighborhoods';
  /** An object relationship */
  city: Cities;
  cityId: Scalars['uuid'];
  geometry?: Maybe<Scalars['geography']>;
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  latitude: Scalars['numeric'];
  longitude: Scalars['numeric'];
  name: Scalars['String'];
  radiusMiles: Scalars['numeric'];
  slug: Scalars['String'];
  sortOrder: Scalars['Int'];
};

/** Boolean expression to filter rows from the table "neighborhoods". All fields are combined with a logical 'AND'. */
export type NeighborhoodsBoolExp = {
  _and?: InputMaybe<Array<NeighborhoodsBoolExp>>;
  _not?: InputMaybe<NeighborhoodsBoolExp>;
  _or?: InputMaybe<Array<NeighborhoodsBoolExp>>;
  city?: InputMaybe<CitiesBoolExp>;
  cityId?: InputMaybe<UuidComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  radiusMiles?: InputMaybe<NumericComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  sortOrder?: InputMaybe<IntComparisonExp>;
};

/** Ordering options when selecting data from "neighborhoods". */
export type NeighborhoodsOrderBy = {
  city?: InputMaybe<CitiesOrderBy>;
  cityId?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  radiusMiles?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  sortOrder?: InputMaybe<OrderBy>;
};

/** select columns of table "neighborhoods" */
export enum NeighborhoodsSelectColumn {
  /** column name */
  CityId = 'cityId',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  RadiusMiles = 'radiusMiles',
  /** column name */
  Slug = 'slug',
  /** column name */
  SortOrder = 'sortOrder'
}

/** Streaming cursor of the table "neighborhoods" */
export type NeighborhoodsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: NeighborhoodsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NeighborhoodsStreamCursorValueInput = {
  cityId?: InputMaybe<Scalars['uuid']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  radiusMiles?: InputMaybe<Scalars['numeric']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export enum NotificationActionTypesEnum {
  CompleteReflectionForCoach = 'COMPLETE_REFLECTION_FOR_COACH',
  /** A player accepted your connection request */
  ConnectionRequestAccepted = 'CONNECTION_REQUEST_ACCEPTED',
  /** A player wants to connect with you */
  ConnectionRequestReceived = 'CONNECTION_REQUEST_RECEIVED',
  /** The club confirmed your court booking */
  CourtBookingConfirmed = 'COURT_BOOKING_CONFIRMED',
  /** Your court could not be booked; the card was not charged */
  CourtBookingFailed = 'COURT_BOOKING_FAILED',
  FollowerUserNew = 'FOLLOWER_USER_NEW',
  /** A player accepted your game invite */
  GameInviteAccepted = 'GAME_INVITE_ACCEPTED',
  /** A player declined your game invite */
  GameInviteDeclined = 'GAME_INVITE_DECLINED',
  /** A host invited you to a game */
  GameInviteReceived = 'GAME_INVITE_RECEIVED',
  GroupCommentReply = 'GROUP_COMMENT_REPLY',
  GroupCommentUpvote = 'GROUP_COMMENT_UPVOTE',
  LessonCoachCancel = 'LESSON_COACH_CANCEL',
  LessonParticipantJoin = 'LESSON_PARTICIPANT_JOIN',
  LessonParticipantLeave = 'LESSON_PARTICIPANT_LEAVE',
  LessonStartReminder = 'LESSON_START_REMINDER',
  /** You received a new chat message */
  MessageReceived = 'MESSAGE_RECEIVED',
  NewReflectionForPlayer = 'NEW_REFLECTION_FOR_PLAYER',
  /** A host accepted your play request */
  PlayRequestAccepted = 'PLAY_REQUEST_ACCEPTED',
  /** Your pending request was cancelled because the game filled up */
  PlayRequestAutoCancelled = 'PLAY_REQUEST_AUTO_CANCELLED',
  /** A host declined your play request */
  PlayRequestDeclined = 'PLAY_REQUEST_DECLINED',
  /** A player sent a request to join your game or play from your availability */
  PlayRequestReceived = 'PLAY_REQUEST_RECEIVED',
  PlaySessionCommentSubmit = 'PLAY_SESSION_COMMENT_SUBMIT',
  PlaySessionDetailsUpdate = 'PLAY_SESSION_DETAILS_UPDATE',
  PlaySessionOrganizerCancel = 'PLAY_SESSION_ORGANIZER_CANCEL',
  PlaySessionParticipantJoin = 'PLAY_SESSION_PARTICIPANT_JOIN',
  PlaySessionParticipantLeave = 'PLAY_SESSION_PARTICIPANT_LEAVE',
  PlaySessionStartReminder = 'PLAY_SESSION_START_REMINDER',
  ReviewCoachNotification = 'REVIEW_COACH_NOTIFICATION',
  TournamentPartnerRequestReceived = 'TOURNAMENT_PARTNER_REQUEST_RECEIVED',
  VideoAnalysisCompletePlayer = 'VIDEO_ANALYSIS_COMPLETE_PLAYER',
  VideoSubmissionConfirmPlayer = 'VIDEO_SUBMISSION_CONFIRM_PLAYER',
  VideoSubmissionNotificationCoach = 'VIDEO_SUBMISSION_NOTIFICATION_COACH'
}

/** Boolean expression to compare columns of type "NotificationActionTypesEnum". All fields are combined with logical 'AND'. */
export type NotificationActionTypesEnumComparisonExp = {
  _eq?: InputMaybe<NotificationActionTypesEnum>;
  _in?: InputMaybe<Array<NotificationActionTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<NotificationActionTypesEnum>;
  _nin?: InputMaybe<Array<NotificationActionTypesEnum>>;
};

export enum NotificationStatusesEnum {
  Read = 'READ',
  Unread = 'UNREAD'
}

/** Boolean expression to compare columns of type "NotificationStatusesEnum". All fields are combined with logical 'AND'. */
export type NotificationStatusesEnumComparisonExp = {
  _eq?: InputMaybe<NotificationStatusesEnum>;
  _in?: InputMaybe<Array<NotificationStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<NotificationStatusesEnum>;
  _nin?: InputMaybe<Array<NotificationStatusesEnum>>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  Asc = 'ASC',
  /** in ascending order, nulls first */
  AscNullsFirst = 'ASC_NULLS_FIRST',
  /** in ascending order, nulls last */
  AscNullsLast = 'ASC_NULLS_LAST',
  /** in descending order, nulls first */
  Desc = 'DESC',
  /** in descending order, nulls first */
  DescNullsFirst = 'DESC_NULLS_FIRST',
  /** in descending order, nulls last */
  DescNullsLast = 'DESC_NULLS_LAST'
}

export enum OrderStatusesEnum {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Succeeded = 'SUCCEEDED'
}

/** Boolean expression to compare columns of type "OrderStatusesEnum". All fields are combined with logical 'AND'. */
export type OrderStatusesEnumComparisonExp = {
  _eq?: InputMaybe<OrderStatusesEnum>;
  _in?: InputMaybe<Array<OrderStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<OrderStatusesEnum>;
  _nin?: InputMaybe<Array<OrderStatusesEnum>>;
};

/** columns and relationships of "padel_rating_scales" */
export type PadelRatingScales = {
  __typename?: 'PadelRatingScales';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  maximum: Scalars['numeric'];
  minimum: Scalars['numeric'];
  name: Scalars['String'];
  order: Scalars['Int'];
  shortName: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "padel_rating_scales". All fields are combined with a logical 'AND'. */
export type PadelRatingScalesBoolExp = {
  _and?: InputMaybe<Array<PadelRatingScalesBoolExp>>;
  _not?: InputMaybe<PadelRatingScalesBoolExp>;
  _or?: InputMaybe<Array<PadelRatingScalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  maximum?: InputMaybe<NumericComparisonExp>;
  minimum?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  order?: InputMaybe<IntComparisonExp>;
  shortName?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** Ordering options when selecting data from "padel_rating_scales". */
export type PadelRatingScalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximum?: InputMaybe<OrderBy>;
  minimum?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  shortName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "padel_rating_scales" */
export enum PadelRatingScalesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Maximum = 'maximum',
  /** column name */
  Minimum = 'minimum',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "padel_rating_scales" */
export type PadelRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PadelRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PadelRatingScalesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shortName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "participant_roles" */
export type ParticipantRoles = {
  __typename?: 'ParticipantRoles';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "participant_roles". All fields are combined with a logical 'AND'. */
export type ParticipantRolesBoolExp = {
  _and?: InputMaybe<Array<ParticipantRolesBoolExp>>;
  _not?: InputMaybe<ParticipantRolesBoolExp>;
  _or?: InputMaybe<Array<ParticipantRolesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum ParticipantRolesEnum {
  /** can manage the group */
  Admin = 'ADMIN',
  /** standard participant */
  Member = 'MEMBER'
}

/** Boolean expression to compare columns of type "ParticipantRolesEnum". All fields are combined with logical 'AND'. */
export type ParticipantRolesEnumComparisonExp = {
  _eq?: InputMaybe<ParticipantRolesEnum>;
  _in?: InputMaybe<Array<ParticipantRolesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ParticipantRolesEnum>;
  _nin?: InputMaybe<Array<ParticipantRolesEnum>>;
};

/** Ordering options when selecting data from "participant_roles". */
export type ParticipantRolesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "participant_roles" */
export enum ParticipantRolesSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "participant_roles" */
export type ParticipantRolesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ParticipantRolesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ParticipantRolesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "partner_booking_order_statuses" */
export type PartnerBookingOrderStatuses = {
  __typename?: 'PartnerBookingOrderStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "partner_booking_order_statuses". All fields are combined with a logical 'AND'. */
export type PartnerBookingOrderStatusesBoolExp = {
  _and?: InputMaybe<Array<PartnerBookingOrderStatusesBoolExp>>;
  _not?: InputMaybe<PartnerBookingOrderStatusesBoolExp>;
  _or?: InputMaybe<Array<PartnerBookingOrderStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PartnerBookingOrderStatusesEnum {
  /** Cancelled by the player or ops */
  Cancelled = 'CANCELLED',
  /** Booking verified on the club's system */
  Confirmed = 'CONFIRMED',
  /** Could not be booked; nothing exists at the club */
  Failed = 'FAILED',
  /** Being booked on the club's system */
  Fulfilling = 'FULFILLING',
  /** Slot held at checkout, no booking attempt yet */
  Held = 'HELD',
  /** Outcome unclear or mismatched; ops must resolve */
  NeedsReview = 'NEEDS_REVIEW'
}

/** Boolean expression to compare columns of type "PartnerBookingOrderStatusesEnum". All fields are combined with logical 'AND'. */
export type PartnerBookingOrderStatusesEnumComparisonExp = {
  _eq?: InputMaybe<PartnerBookingOrderStatusesEnum>;
  _in?: InputMaybe<Array<PartnerBookingOrderStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PartnerBookingOrderStatusesEnum>;
  _nin?: InputMaybe<Array<PartnerBookingOrderStatusesEnum>>;
};

/** Ordering options when selecting data from "partner_booking_order_statuses". */
export type PartnerBookingOrderStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "partner_booking_order_statuses" */
export enum PartnerBookingOrderStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "partner_booking_order_statuses" */
export type PartnerBookingOrderStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerBookingOrderStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerBookingOrderStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "partner_booking_orders" */
export type PartnerBookingOrders = {
  __typename?: 'PartnerBookingOrders';
  authorizedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  bookingConfigVersion?: Maybe<VenueBookingConfigVersions>;
  capturedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  endAt: Scalars['timestamptz'];
  endLocal: Scalars['time'];
  failureReason?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  integration: VenueBookingIntegrations;
  inventoryType: BookingInventoryTypesEnum;
  localDate: Scalars['date'];
  maxPriceUnitAmount: Scalars['Int'];
  orderSubtotalUnitAmount: Scalars['Int'];
  orderTotalUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  /** An object relationship */
  player: Users;
  playerCount: Scalars['Int'];
  playerUserId: Scalars['uuid'];
  providerCourtId?: Maybe<Scalars['String']>;
  providerResourceId: Scalars['String'];
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  releasedAt?: Maybe<Scalars['timestamptz']>;
  startAt: Scalars['timestamptz'];
  startLocal: Scalars['time'];
  status: PartnerBookingOrderStatusesEnum;
  timezone: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userCreditCard?: Maybe<UserCreditCards>;
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** Boolean expression to filter rows from the table "partner_booking_orders". All fields are combined with a logical 'AND'. */
export type PartnerBookingOrdersBoolExp = {
  _and?: InputMaybe<Array<PartnerBookingOrdersBoolExp>>;
  _not?: InputMaybe<PartnerBookingOrdersBoolExp>;
  _or?: InputMaybe<Array<PartnerBookingOrdersBoolExp>>;
  authorizedAt?: InputMaybe<TimestamptzComparisonExp>;
  bookingConfigVersion?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
  capturedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  endAt?: InputMaybe<TimestamptzComparisonExp>;
  endLocal?: InputMaybe<TimeComparisonExp>;
  failureReason?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<VenueBookingIntegrationsBoolExp>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnumComparisonExp>;
  localDate?: InputMaybe<DateComparisonExp>;
  maxPriceUnitAmount?: InputMaybe<IntComparisonExp>;
  orderSubtotalUnitAmount?: InputMaybe<IntComparisonExp>;
  orderTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  paidUnitAmount?: InputMaybe<IntComparisonExp>;
  player?: InputMaybe<UsersBoolExp>;
  playerCount?: InputMaybe<IntComparisonExp>;
  playerUserId?: InputMaybe<UuidComparisonExp>;
  providerCourtId?: InputMaybe<StringComparisonExp>;
  providerResourceId?: InputMaybe<StringComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  releasedAt?: InputMaybe<TimestamptzComparisonExp>;
  startAt?: InputMaybe<TimestamptzComparisonExp>;
  startLocal?: InputMaybe<TimeComparisonExp>;
  status?: InputMaybe<PartnerBookingOrderStatusesEnumComparisonExp>;
  timezone?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCreditCard?: InputMaybe<UserCreditCardsBoolExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** Ordering options when selecting data from "partner_booking_orders". */
export type PartnerBookingOrdersOrderBy = {
  authorizedAt?: InputMaybe<OrderBy>;
  bookingConfigVersion?: InputMaybe<VenueBookingConfigVersionsOrderBy>;
  capturedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  endAt?: InputMaybe<OrderBy>;
  endLocal?: InputMaybe<OrderBy>;
  failureReason?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<VenueBookingIntegrationsOrderBy>;
  inventoryType?: InputMaybe<OrderBy>;
  localDate?: InputMaybe<OrderBy>;
  maxPriceUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  player?: InputMaybe<UsersOrderBy>;
  playerCount?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  providerCourtId?: InputMaybe<OrderBy>;
  providerResourceId?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  releasedAt?: InputMaybe<OrderBy>;
  startAt?: InputMaybe<OrderBy>;
  startLocal?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCard?: InputMaybe<UserCreditCardsOrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** select columns of table "partner_booking_orders" */
export enum PartnerBookingOrdersSelectColumn {
  /** column name */
  AuthorizedAt = 'authorizedAt',
  /** column name */
  CapturedAt = 'capturedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  EndAt = 'endAt',
  /** column name */
  EndLocal = 'endLocal',
  /** column name */
  FailureReason = 'failureReason',
  /** column name */
  Id = 'id',
  /** column name */
  InventoryType = 'inventoryType',
  /** column name */
  LocalDate = 'localDate',
  /** column name */
  MaxPriceUnitAmount = 'maxPriceUnitAmount',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PlayerCount = 'playerCount',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  ProviderCourtId = 'providerCourtId',
  /** column name */
  ProviderResourceId = 'providerResourceId',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  ReleasedAt = 'releasedAt',
  /** column name */
  StartAt = 'startAt',
  /** column name */
  StartLocal = 'startLocal',
  /** column name */
  Status = 'status',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** Streaming cursor of the table "partner_booking_orders" */
export type PartnerBookingOrdersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerBookingOrdersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerBookingOrdersStreamCursorValueInput = {
  authorizedAt?: InputMaybe<Scalars['timestamptz']>;
  capturedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  endAt?: InputMaybe<Scalars['timestamptz']>;
  endLocal?: InputMaybe<Scalars['time']>;
  failureReason?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnum>;
  localDate?: InputMaybe<Scalars['date']>;
  maxPriceUnitAmount?: InputMaybe<Scalars['Int']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  playerCount?: InputMaybe<Scalars['Int']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  providerCourtId?: InputMaybe<Scalars['String']>;
  providerResourceId?: InputMaybe<Scalars['String']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  releasedAt?: InputMaybe<Scalars['timestamptz']>;
  startAt?: InputMaybe<Scalars['timestamptz']>;
  startLocal?: InputMaybe<Scalars['time']>;
  status?: InputMaybe<PartnerBookingOrderStatusesEnum>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "payment_fulfillment_channels" */
export type PaymentFulfillmentChannels = {
  __typename?: 'PaymentFulfillmentChannels';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "payment_fulfillment_channels". All fields are combined with a logical 'AND'. */
export type PaymentFulfillmentChannelsBoolExp = {
  _and?: InputMaybe<Array<PaymentFulfillmentChannelsBoolExp>>;
  _not?: InputMaybe<PaymentFulfillmentChannelsBoolExp>;
  _or?: InputMaybe<Array<PaymentFulfillmentChannelsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PaymentFulfillmentChannelsEnum {
  OffPlatform = 'OFF_PLATFORM',
  OnPlatform = 'ON_PLATFORM',
  ParticipantsChoice = 'PARTICIPANTS_CHOICE'
}

/** Boolean expression to compare columns of type "PaymentFulfillmentChannelsEnum". All fields are combined with logical 'AND'. */
export type PaymentFulfillmentChannelsEnumComparisonExp = {
  _eq?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  _in?: InputMaybe<Array<PaymentFulfillmentChannelsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  _nin?: InputMaybe<Array<PaymentFulfillmentChannelsEnum>>;
};

/** Ordering options when selecting data from "payment_fulfillment_channels". */
export type PaymentFulfillmentChannelsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "payment_fulfillment_channels" */
export enum PaymentFulfillmentChannelsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "payment_fulfillment_channels" */
export type PaymentFulfillmentChannelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentFulfillmentChannelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentFulfillmentChannelsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export enum PaymentProcessorsEnum {
  Stripe = 'STRIPE'
}

/** Boolean expression to compare columns of type "PaymentProcessorsEnum". All fields are combined with logical 'AND'. */
export type PaymentProcessorsEnumComparisonExp = {
  _eq?: InputMaybe<PaymentProcessorsEnum>;
  _in?: InputMaybe<Array<PaymentProcessorsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PaymentProcessorsEnum>;
  _nin?: InputMaybe<Array<PaymentProcessorsEnum>>;
};

export enum PaymentStatusesEnum {
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

/** Boolean expression to compare columns of type "PaymentStatusesEnum". All fields are combined with logical 'AND'. */
export type PaymentStatusesEnumComparisonExp = {
  _eq?: InputMaybe<PaymentStatusesEnum>;
  _in?: InputMaybe<Array<PaymentStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PaymentStatusesEnum>;
  _nin?: InputMaybe<Array<PaymentStatusesEnum>>;
};

/** columns and relationships of "pickleball_rating_scales" */
export type PickleballRatingScales = {
  __typename?: 'PickleballRatingScales';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  maximum: Scalars['numeric'];
  minimum: Scalars['numeric'];
  name: Scalars['String'];
  order: Scalars['Int'];
  shortName: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "pickleball_rating_scales". All fields are combined with a logical 'AND'. */
export type PickleballRatingScalesBoolExp = {
  _and?: InputMaybe<Array<PickleballRatingScalesBoolExp>>;
  _not?: InputMaybe<PickleballRatingScalesBoolExp>;
  _or?: InputMaybe<Array<PickleballRatingScalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  maximum?: InputMaybe<NumericComparisonExp>;
  minimum?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  order?: InputMaybe<IntComparisonExp>;
  shortName?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** Ordering options when selecting data from "pickleball_rating_scales". */
export type PickleballRatingScalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximum?: InputMaybe<OrderBy>;
  minimum?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  shortName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "pickleball_rating_scales" */
export enum PickleballRatingScalesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Maximum = 'maximum',
  /** column name */
  Minimum = 'minimum',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "pickleball_rating_scales" */
export type PickleballRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PickleballRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PickleballRatingScalesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shortName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "platform_subscription_intervals" */
export type PlatformSubscriptionIntervals = {
  __typename?: 'PlatformSubscriptionIntervals';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "platform_subscription_intervals". All fields are combined with a logical 'AND'. */
export type PlatformSubscriptionIntervalsBoolExp = {
  _and?: InputMaybe<Array<PlatformSubscriptionIntervalsBoolExp>>;
  _not?: InputMaybe<PlatformSubscriptionIntervalsBoolExp>;
  _or?: InputMaybe<Array<PlatformSubscriptionIntervalsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PlatformSubscriptionIntervalsEnum {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Year = 'YEAR'
}

/** Boolean expression to compare columns of type "PlatformSubscriptionIntervalsEnum". All fields are combined with logical 'AND'. */
export type PlatformSubscriptionIntervalsEnumComparisonExp = {
  _eq?: InputMaybe<PlatformSubscriptionIntervalsEnum>;
  _in?: InputMaybe<Array<PlatformSubscriptionIntervalsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlatformSubscriptionIntervalsEnum>;
  _nin?: InputMaybe<Array<PlatformSubscriptionIntervalsEnum>>;
};

/** Ordering options when selecting data from "platform_subscription_intervals". */
export type PlatformSubscriptionIntervalsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "platform_subscription_intervals" */
export enum PlatformSubscriptionIntervalsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "platform_subscription_intervals" */
export type PlatformSubscriptionIntervalsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlatformSubscriptionIntervalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlatformSubscriptionIntervalsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "platform_subscription_personas" */
export type PlatformSubscriptionPersonas = {
  __typename?: 'PlatformSubscriptionPersonas';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "platform_subscription_personas". All fields are combined with a logical 'AND'. */
export type PlatformSubscriptionPersonasBoolExp = {
  _and?: InputMaybe<Array<PlatformSubscriptionPersonasBoolExp>>;
  _not?: InputMaybe<PlatformSubscriptionPersonasBoolExp>;
  _or?: InputMaybe<Array<PlatformSubscriptionPersonasBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PlatformSubscriptionPersonasEnum {
  Coach = 'COACH',
  Player = 'PLAYER'
}

/** Boolean expression to compare columns of type "PlatformSubscriptionPersonasEnum". All fields are combined with logical 'AND'. */
export type PlatformSubscriptionPersonasEnumComparisonExp = {
  _eq?: InputMaybe<PlatformSubscriptionPersonasEnum>;
  _in?: InputMaybe<Array<PlatformSubscriptionPersonasEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlatformSubscriptionPersonasEnum>;
  _nin?: InputMaybe<Array<PlatformSubscriptionPersonasEnum>>;
};

/** Ordering options when selecting data from "platform_subscription_personas". */
export type PlatformSubscriptionPersonasOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "platform_subscription_personas" */
export enum PlatformSubscriptionPersonasSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "platform_subscription_personas" */
export type PlatformSubscriptionPersonasStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlatformSubscriptionPersonasStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlatformSubscriptionPersonasStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPrices = {
  __typename?: 'PlatformSubscriptionPlanPrices';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  interval: PlatformSubscriptionIntervalsEnum;
  persona: PlatformSubscriptionPersonasEnum;
  /** An object relationship */
  plan: PlatformSubscriptionPlans;
  platformSubscriptionPlanId: Scalars['uuid'];
  priceUnitAmount: Scalars['Int'];
  stripePriceId: Scalars['String'];
  /** An array relationship */
  subscriptions: Array<PlatformSubscriptions>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};

/** order by aggregate values of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesAggregateOrderBy = {
  avg?: InputMaybe<PlatformSubscriptionPlanPricesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlatformSubscriptionPlanPricesMaxOrderBy>;
  min?: InputMaybe<PlatformSubscriptionPlanPricesMinOrderBy>;
  stddev?: InputMaybe<PlatformSubscriptionPlanPricesStddevOrderBy>;
  stddevPop?: InputMaybe<PlatformSubscriptionPlanPricesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PlatformSubscriptionPlanPricesStddevSampOrderBy>;
  sum?: InputMaybe<PlatformSubscriptionPlanPricesSumOrderBy>;
  varPop?: InputMaybe<PlatformSubscriptionPlanPricesVarPopOrderBy>;
  varSamp?: InputMaybe<PlatformSubscriptionPlanPricesVarSampOrderBy>;
  variance?: InputMaybe<PlatformSubscriptionPlanPricesVarianceOrderBy>;
};

/** order by avg() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesAvgOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "platform_subscription_plan_prices". All fields are combined with a logical 'AND'. */
export type PlatformSubscriptionPlanPricesBoolExp = {
  _and?: InputMaybe<Array<PlatformSubscriptionPlanPricesBoolExp>>;
  _not?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
  _or?: InputMaybe<Array<PlatformSubscriptionPlanPricesBoolExp>>;
  archivedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  interval?: InputMaybe<PlatformSubscriptionIntervalsEnumComparisonExp>;
  persona?: InputMaybe<PlatformSubscriptionPersonasEnumComparisonExp>;
  plan?: InputMaybe<PlatformSubscriptionPlansBoolExp>;
  platformSubscriptionPlanId?: InputMaybe<UuidComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  stripePriceId?: InputMaybe<StringComparisonExp>;
  subscriptions?: InputMaybe<PlatformSubscriptionsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesMaxOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  platformSubscriptionPlanId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesMinOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  platformSubscriptionPlanId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "platform_subscription_plan_prices". */
export type PlatformSubscriptionPlanPricesOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interval?: InputMaybe<OrderBy>;
  persona?: InputMaybe<OrderBy>;
  plan?: InputMaybe<PlatformSubscriptionPlansOrderBy>;
  platformSubscriptionPlanId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  subscriptionsAggregate?: InputMaybe<PlatformSubscriptionsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "platform_subscription_plan_prices" */
export enum PlatformSubscriptionPlanPricesSelectColumn {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval',
  /** column name */
  Persona = 'persona',
  /** column name */
  PlatformSubscriptionPlanId = 'platformSubscriptionPlanId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  StripePriceId = 'stripePriceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** order by stddev() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesStddevOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesStddevPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesStddevSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlatformSubscriptionPlanPricesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlatformSubscriptionPlanPricesStreamCursorValueInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  interval?: InputMaybe<PlatformSubscriptionIntervalsEnum>;
  persona?: InputMaybe<PlatformSubscriptionPersonasEnum>;
  platformSubscriptionPlanId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesSumOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesVarPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesVarSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "platform_subscription_plan_prices" */
export type PlatformSubscriptionPlanPricesVarianceOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "platform_subscription_plans" */
export type PlatformSubscriptionPlans = {
  __typename?: 'PlatformSubscriptionPlans';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  prices: Array<PlatformSubscriptionPlanPrices>;
  stripeProductId: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "platform_subscription_plans" */
export type PlatformSubscriptionPlansPricesArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlanPricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlanPricesOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
};

/** Boolean expression to filter rows from the table "platform_subscription_plans". All fields are combined with a logical 'AND'. */
export type PlatformSubscriptionPlansBoolExp = {
  _and?: InputMaybe<Array<PlatformSubscriptionPlansBoolExp>>;
  _not?: InputMaybe<PlatformSubscriptionPlansBoolExp>;
  _or?: InputMaybe<Array<PlatformSubscriptionPlansBoolExp>>;
  archivedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  prices?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
  stripeProductId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** Ordering options when selecting data from "platform_subscription_plans". */
export type PlatformSubscriptionPlansOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  pricesAggregate?: InputMaybe<PlatformSubscriptionPlanPricesAggregateOrderBy>;
  stripeProductId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "platform_subscription_plans" */
export enum PlatformSubscriptionPlansSelectColumn {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StripeProductId = 'stripeProductId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "platform_subscription_plans" */
export type PlatformSubscriptionPlansStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlatformSubscriptionPlansStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlatformSubscriptionPlansStreamCursorValueInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "platform_subscriptions" */
export type PlatformSubscriptions = {
  __typename?: 'PlatformSubscriptions';
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  currentPeriodEndAt?: Maybe<Scalars['timestamptz']>;
  currentPeriodStartAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endedAt?: Maybe<Scalars['timestamptz']>;
  externalSubscriptionId: Scalars['String'];
  externalSubscriptionProvider: PaymentProcessorsEnum;
  id: Scalars['uuid'];
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An object relationship */
  planPrice: PlatformSubscriptionPlanPrices;
  platformSubscriptionPlanPriceId: Scalars['uuid'];
  /** An array relationship */
  sales: Array<Sales>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status: SubscriptionStatusesEnum;
  statusChangedAt: Scalars['timestamptz'];
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  stripeStatus?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  trialEndAt?: Maybe<Scalars['timestamptz']>;
  trialStartAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};


/** columns and relationships of "platform_subscriptions" */
export type PlatformSubscriptionsInvoicesArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


/** columns and relationships of "platform_subscriptions" */
export type PlatformSubscriptionsSalesArgs = {
  distinctOn?: InputMaybe<Array<SalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SalesOrderBy>>;
  where?: InputMaybe<SalesBoolExp>;
};

/** order by aggregate values of table "platform_subscriptions" */
export type PlatformSubscriptionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlatformSubscriptionsMaxOrderBy>;
  min?: InputMaybe<PlatformSubscriptionsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "platform_subscriptions". All fields are combined with a logical 'AND'. */
export type PlatformSubscriptionsBoolExp = {
  _and?: InputMaybe<Array<PlatformSubscriptionsBoolExp>>;
  _not?: InputMaybe<PlatformSubscriptionsBoolExp>;
  _or?: InputMaybe<Array<PlatformSubscriptionsBoolExp>>;
  cancelAtPeriodEnd?: InputMaybe<BooleanComparisonExp>;
  canceledAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currentPeriodEndAt?: InputMaybe<TimestamptzComparisonExp>;
  currentPeriodStartAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  endedAt?: InputMaybe<TimestamptzComparisonExp>;
  externalSubscriptionId?: InputMaybe<StringComparisonExp>;
  externalSubscriptionProvider?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  invoices?: InputMaybe<InvoicesBoolExp>;
  planPrice?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
  platformSubscriptionPlanPriceId?: InputMaybe<UuidComparisonExp>;
  sales?: InputMaybe<SalesBoolExp>;
  startDate?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<SubscriptionStatusesEnumComparisonExp>;
  statusChangedAt?: InputMaybe<TimestamptzComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripePriceId?: InputMaybe<StringComparisonExp>;
  stripeProductId?: InputMaybe<StringComparisonExp>;
  stripeStatus?: InputMaybe<StringComparisonExp>;
  stripeSubscriptionId?: InputMaybe<StringComparisonExp>;
  trialEndAt?: InputMaybe<TimestamptzComparisonExp>;
  trialStartAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "platform_subscriptions" */
export type PlatformSubscriptionsMaxOrderBy = {
  canceledAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currentPeriodEndAt?: InputMaybe<OrderBy>;
  currentPeriodStartAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endedAt?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  platformSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  statusChangedAt?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  stripeProductId?: InputMaybe<OrderBy>;
  stripeStatus?: InputMaybe<OrderBy>;
  stripeSubscriptionId?: InputMaybe<OrderBy>;
  trialEndAt?: InputMaybe<OrderBy>;
  trialStartAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "platform_subscriptions" */
export type PlatformSubscriptionsMinOrderBy = {
  canceledAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currentPeriodEndAt?: InputMaybe<OrderBy>;
  currentPeriodStartAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endedAt?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  platformSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  statusChangedAt?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  stripeProductId?: InputMaybe<OrderBy>;
  stripeStatus?: InputMaybe<OrderBy>;
  stripeSubscriptionId?: InputMaybe<OrderBy>;
  trialEndAt?: InputMaybe<OrderBy>;
  trialStartAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "platform_subscriptions". */
export type PlatformSubscriptionsOrderBy = {
  cancelAtPeriodEnd?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currentPeriodEndAt?: InputMaybe<OrderBy>;
  currentPeriodStartAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endedAt?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  externalSubscriptionProvider?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoicesAggregate?: InputMaybe<InvoicesAggregateOrderBy>;
  planPrice?: InputMaybe<PlatformSubscriptionPlanPricesOrderBy>;
  platformSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  salesAggregate?: InputMaybe<SalesAggregateOrderBy>;
  startDate?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  statusChangedAt?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  stripeProductId?: InputMaybe<OrderBy>;
  stripeStatus?: InputMaybe<OrderBy>;
  stripeSubscriptionId?: InputMaybe<OrderBy>;
  trialEndAt?: InputMaybe<OrderBy>;
  trialStartAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "platform_subscriptions" */
export enum PlatformSubscriptionsSelectColumn {
  /** column name */
  CancelAtPeriodEnd = 'cancelAtPeriodEnd',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentPeriodEndAt = 'currentPeriodEndAt',
  /** column name */
  CurrentPeriodStartAt = 'currentPeriodStartAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndedAt = 'endedAt',
  /** column name */
  ExternalSubscriptionId = 'externalSubscriptionId',
  /** column name */
  ExternalSubscriptionProvider = 'externalSubscriptionProvider',
  /** column name */
  Id = 'id',
  /** column name */
  PlatformSubscriptionPlanPriceId = 'platformSubscriptionPlanPriceId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Status = 'status',
  /** column name */
  StatusChangedAt = 'statusChangedAt',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePriceId = 'stripePriceId',
  /** column name */
  StripeProductId = 'stripeProductId',
  /** column name */
  StripeStatus = 'stripeStatus',
  /** column name */
  StripeSubscriptionId = 'stripeSubscriptionId',
  /** column name */
  TrialEndAt = 'trialEndAt',
  /** column name */
  TrialStartAt = 'trialStartAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "platform_subscriptions" */
export type PlatformSubscriptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlatformSubscriptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlatformSubscriptionsStreamCursorValueInput = {
  cancelAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentPeriodEndAt?: InputMaybe<Scalars['timestamptz']>;
  currentPeriodStartAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  externalSubscriptionProvider?: InputMaybe<PaymentProcessorsEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  platformSubscriptionPlanPriceId?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<SubscriptionStatusesEnum>;
  statusChangedAt?: InputMaybe<Scalars['timestamptz']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  stripeStatus?: InputMaybe<Scalars['String']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  trialEndAt?: InputMaybe<Scalars['timestamptz']>;
  trialStartAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "play_request_neighborhoods" */
export type PlayRequestNeighborhoods = {
  __typename?: 'PlayRequestNeighborhoods';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  neighborhood: Neighborhoods;
  neighborhoodId: Scalars['uuid'];
  /** An object relationship */
  playRequest: PlayRequests;
  playRequestId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayRequestNeighborhoodsMaxOrderBy>;
  min?: InputMaybe<PlayRequestNeighborhoodsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "play_request_neighborhoods". All fields are combined with a logical 'AND'. */
export type PlayRequestNeighborhoodsBoolExp = {
  _and?: InputMaybe<Array<PlayRequestNeighborhoodsBoolExp>>;
  _not?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
  _or?: InputMaybe<Array<PlayRequestNeighborhoodsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  neighborhood?: InputMaybe<NeighborhoodsBoolExp>;
  neighborhoodId?: InputMaybe<UuidComparisonExp>;
  playRequest?: InputMaybe<PlayRequestsBoolExp>;
  playRequestId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  neighborhoodId?: InputMaybe<OrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  neighborhoodId?: InputMaybe<OrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "play_request_neighborhoods". */
export type PlayRequestNeighborhoodsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  neighborhood?: InputMaybe<NeighborhoodsOrderBy>;
  neighborhoodId?: InputMaybe<OrderBy>;
  playRequest?: InputMaybe<PlayRequestsOrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "play_request_neighborhoods" */
export enum PlayRequestNeighborhoodsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NeighborhoodId = 'neighborhoodId',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "play_request_neighborhoods" */
export type PlayRequestNeighborhoodsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayRequestNeighborhoodsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayRequestNeighborhoodsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  neighborhoodId?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "play_request_slots" */
export type PlayRequestSlots = {
  __typename?: 'PlayRequestSlots';
  /** An object relationship */
  availabilitySlot: PlayerAvailabilitySlots;
  availabilitySlotId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  playRequest: PlayRequests;
  playRequestId: Scalars['uuid'];
  requestedEndAt?: Maybe<Scalars['timestamptz']>;
  requestedStartAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "play_request_slots" */
export type PlayRequestSlotsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayRequestSlotsMaxOrderBy>;
  min?: InputMaybe<PlayRequestSlotsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "play_request_slots". All fields are combined with a logical 'AND'. */
export type PlayRequestSlotsBoolExp = {
  _and?: InputMaybe<Array<PlayRequestSlotsBoolExp>>;
  _not?: InputMaybe<PlayRequestSlotsBoolExp>;
  _or?: InputMaybe<Array<PlayRequestSlotsBoolExp>>;
  availabilitySlot?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
  availabilitySlotId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  playRequest?: InputMaybe<PlayRequestsBoolExp>;
  playRequestId?: InputMaybe<UuidComparisonExp>;
  requestedEndAt?: InputMaybe<TimestamptzComparisonExp>;
  requestedStartAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "play_request_slots" */
export type PlayRequestSlotsMaxOrderBy = {
  availabilitySlotId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  requestedEndAt?: InputMaybe<OrderBy>;
  requestedStartAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "play_request_slots" */
export type PlayRequestSlotsMinOrderBy = {
  availabilitySlotId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  requestedEndAt?: InputMaybe<OrderBy>;
  requestedStartAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "play_request_slots". */
export type PlayRequestSlotsOrderBy = {
  availabilitySlot?: InputMaybe<PlayerAvailabilitySlotsOrderBy>;
  availabilitySlotId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playRequest?: InputMaybe<PlayRequestsOrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  requestedEndAt?: InputMaybe<OrderBy>;
  requestedStartAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "play_request_slots" */
export enum PlayRequestSlotsSelectColumn {
  /** column name */
  AvailabilitySlotId = 'availabilitySlotId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  RequestedEndAt = 'requestedEndAt',
  /** column name */
  RequestedStartAt = 'requestedStartAt',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "play_request_slots" */
export type PlayRequestSlotsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayRequestSlotsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayRequestSlotsStreamCursorValueInput = {
  availabilitySlotId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  requestedEndAt?: InputMaybe<Scalars['timestamptz']>;
  requestedStartAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "play_request_statuses" */
export type PlayRequestStatuses = {
  __typename?: 'PlayRequestStatuses';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "play_request_statuses". All fields are combined with a logical 'AND'. */
export type PlayRequestStatusesBoolExp = {
  _and?: InputMaybe<Array<PlayRequestStatusesBoolExp>>;
  _not?: InputMaybe<PlayRequestStatusesBoolExp>;
  _or?: InputMaybe<Array<PlayRequestStatusesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PlayRequestStatusesEnum {
  Accepted = 'ACCEPTED',
  /** auto-cancelled when the game filled up (all spots taken) */
  AutoCancelled = 'AUTO_CANCELLED',
  /** withdrawn by requester */
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  /** no longer valid (e.g. time lapsed) */
  Expired = 'EXPIRED',
  /** awaiting host/player response */
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "PlayRequestStatusesEnum". All fields are combined with logical 'AND'. */
export type PlayRequestStatusesEnumComparisonExp = {
  _eq?: InputMaybe<PlayRequestStatusesEnum>;
  _in?: InputMaybe<Array<PlayRequestStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlayRequestStatusesEnum>;
  _nin?: InputMaybe<Array<PlayRequestStatusesEnum>>;
};

/** Ordering options when selecting data from "play_request_statuses". */
export type PlayRequestStatusesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "play_request_statuses" */
export enum PlayRequestStatusesSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "play_request_statuses" */
export type PlayRequestStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayRequestStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayRequestStatusesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "play_request_venues" */
export type PlayRequestVenues = {
  __typename?: 'PlayRequestVenues';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  playRequest: PlayRequests;
  playRequestId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** order by aggregate values of table "play_request_venues" */
export type PlayRequestVenuesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayRequestVenuesMaxOrderBy>;
  min?: InputMaybe<PlayRequestVenuesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "play_request_venues". All fields are combined with a logical 'AND'. */
export type PlayRequestVenuesBoolExp = {
  _and?: InputMaybe<Array<PlayRequestVenuesBoolExp>>;
  _not?: InputMaybe<PlayRequestVenuesBoolExp>;
  _or?: InputMaybe<Array<PlayRequestVenuesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  playRequest?: InputMaybe<PlayRequestsBoolExp>;
  playRequestId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "play_request_venues" */
export type PlayRequestVenuesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "play_request_venues" */
export type PlayRequestVenuesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "play_request_venues". */
export type PlayRequestVenuesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playRequest?: InputMaybe<PlayRequestsOrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** select columns of table "play_request_venues" */
export enum PlayRequestVenuesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** Streaming cursor of the table "play_request_venues" */
export type PlayRequestVenuesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayRequestVenuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayRequestVenuesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "play_requests" */
export type PlayRequests = {
  __typename?: 'PlayRequests';
  /** An object relationship */
  availability?: Maybe<PlayerAvailabilities>;
  availabilityId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  conversation?: Maybe<Conversations>;
  conversationId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event?: Maybe<Events>;
  eventId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An array relationship */
  neighborhoods: Array<PlayRequestNeighborhoods>;
  /** An object relationship */
  recipient: Users;
  /** An object relationship */
  recipientProfile?: Maybe<UserProfiles>;
  recipientUserId: Scalars['uuid'];
  requestMessage?: Maybe<Scalars['String']>;
  /** An object relationship */
  requester: Users;
  /** An object relationship */
  requesterProfile?: Maybe<UserProfiles>;
  requesterUserId: Scalars['uuid'];
  respondedAt?: Maybe<Scalars['timestamptz']>;
  responseMessage?: Maybe<Scalars['String']>;
  /** An object relationship */
  selectedVenue?: Maybe<Venues>;
  selectedVenueId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  slots: Array<PlayRequestSlots>;
  status: PlayRequestStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  venues: Array<PlayRequestVenues>;
};


/** columns and relationships of "play_requests" */
export type PlayRequestsNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
};


/** columns and relationships of "play_requests" */
export type PlayRequestsSlotsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestSlotsOrderBy>>;
  where?: InputMaybe<PlayRequestSlotsBoolExp>;
};


/** columns and relationships of "play_requests" */
export type PlayRequestsVenuesArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestVenuesOrderBy>>;
  where?: InputMaybe<PlayRequestVenuesBoolExp>;
};

/** order by aggregate values of table "play_requests" */
export type PlayRequestsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayRequestsMaxOrderBy>;
  min?: InputMaybe<PlayRequestsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "play_requests". All fields are combined with a logical 'AND'. */
export type PlayRequestsBoolExp = {
  _and?: InputMaybe<Array<PlayRequestsBoolExp>>;
  _not?: InputMaybe<PlayRequestsBoolExp>;
  _or?: InputMaybe<Array<PlayRequestsBoolExp>>;
  availability?: InputMaybe<PlayerAvailabilitiesBoolExp>;
  availabilityId?: InputMaybe<UuidComparisonExp>;
  conversation?: InputMaybe<ConversationsBoolExp>;
  conversationId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  neighborhoods?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
  recipient?: InputMaybe<UsersBoolExp>;
  recipientProfile?: InputMaybe<UserProfilesBoolExp>;
  recipientUserId?: InputMaybe<UuidComparisonExp>;
  requestMessage?: InputMaybe<StringComparisonExp>;
  requester?: InputMaybe<UsersBoolExp>;
  requesterProfile?: InputMaybe<UserProfilesBoolExp>;
  requesterUserId?: InputMaybe<UuidComparisonExp>;
  respondedAt?: InputMaybe<TimestamptzComparisonExp>;
  responseMessage?: InputMaybe<StringComparisonExp>;
  selectedVenue?: InputMaybe<VenuesBoolExp>;
  selectedVenueId?: InputMaybe<UuidComparisonExp>;
  slots?: InputMaybe<PlayRequestSlotsBoolExp>;
  status?: InputMaybe<PlayRequestStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venues?: InputMaybe<PlayRequestVenuesBoolExp>;
};

/** order by max() on columns of table "play_requests" */
export type PlayRequestsMaxOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  recipientUserId?: InputMaybe<OrderBy>;
  requestMessage?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
  responseMessage?: InputMaybe<OrderBy>;
  selectedVenueId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "play_requests" */
export type PlayRequestsMinOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  recipientUserId?: InputMaybe<OrderBy>;
  requestMessage?: InputMaybe<OrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
  responseMessage?: InputMaybe<OrderBy>;
  selectedVenueId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "play_requests". */
export type PlayRequestsOrderBy = {
  availability?: InputMaybe<PlayerAvailabilitiesOrderBy>;
  availabilityId?: InputMaybe<OrderBy>;
  conversation?: InputMaybe<ConversationsOrderBy>;
  conversationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  neighborhoodsAggregate?: InputMaybe<PlayRequestNeighborhoodsAggregateOrderBy>;
  recipient?: InputMaybe<UsersOrderBy>;
  recipientProfile?: InputMaybe<UserProfilesOrderBy>;
  recipientUserId?: InputMaybe<OrderBy>;
  requestMessage?: InputMaybe<OrderBy>;
  requester?: InputMaybe<UsersOrderBy>;
  requesterProfile?: InputMaybe<UserProfilesOrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
  responseMessage?: InputMaybe<OrderBy>;
  selectedVenue?: InputMaybe<VenuesOrderBy>;
  selectedVenueId?: InputMaybe<OrderBy>;
  slotsAggregate?: InputMaybe<PlayRequestSlotsAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venuesAggregate?: InputMaybe<PlayRequestVenuesAggregateOrderBy>;
};

/** select columns of table "play_requests" */
export enum PlayRequestsSelectColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  ConversationId = 'conversationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  RecipientUserId = 'recipientUserId',
  /** column name */
  RequestMessage = 'requestMessage',
  /** column name */
  RequesterUserId = 'requesterUserId',
  /** column name */
  RespondedAt = 'respondedAt',
  /** column name */
  ResponseMessage = 'responseMessage',
  /** column name */
  SelectedVenueId = 'selectedVenueId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "play_requests" */
export type PlayRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayRequestsStreamCursorValueInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  conversationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  recipientUserId?: InputMaybe<Scalars['uuid']>;
  requestMessage?: InputMaybe<Scalars['String']>;
  requesterUserId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
  responseMessage?: InputMaybe<Scalars['String']>;
  selectedVenueId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<PlayRequestStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "play_session_comments" */
export type PlaySessionComments = {
  __typename?: 'PlaySessionComments';
  /** An array relationship */
  allChildComments: Array<PlaySessionComments>;
  /** An aggregate relationship */
  allChildCommentsAggregate: PlaySessionCommentsAggregate;
  content: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  playSession: PlaySessions;
  playSessionCommentId?: Maybe<Scalars['uuid']>;
  playSessionId: Scalars['uuid'];
  playSessionRootCommentId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  replies: Array<PlaySessionComments>;
  /** An aggregate relationship */
  repliesAggregate: PlaySessionCommentsAggregate;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};


/** columns and relationships of "play_session_comments" */
export type PlaySessionCommentsAllChildCommentsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


/** columns and relationships of "play_session_comments" */
export type PlaySessionCommentsAllChildCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


/** columns and relationships of "play_session_comments" */
export type PlaySessionCommentsRepliesArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


/** columns and relationships of "play_session_comments" */
export type PlaySessionCommentsRepliesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};

/** aggregated selection of "play_session_comments" */
export type PlaySessionCommentsAggregate = {
  __typename?: 'PlaySessionCommentsAggregate';
  aggregate?: Maybe<PlaySessionCommentsAggregateFields>;
  nodes: Array<PlaySessionComments>;
};

export type PlaySessionCommentsAggregateBoolExp = {
  count?: InputMaybe<PlaySessionCommentsAggregateBoolExpCount>;
};

/** aggregate fields of "play_session_comments" */
export type PlaySessionCommentsAggregateFields = {
  __typename?: 'PlaySessionCommentsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlaySessionCommentsMaxFields>;
  min?: Maybe<PlaySessionCommentsMinFields>;
};


/** aggregate fields of "play_session_comments" */
export type PlaySessionCommentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "play_session_comments" */
export type PlaySessionCommentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlaySessionCommentsMaxOrderBy>;
  min?: InputMaybe<PlaySessionCommentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "play_session_comments" */
export type PlaySessionCommentsArrRelInsertInput = {
  data: Array<PlaySessionCommentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlaySessionCommentsOnConflict>;
};

/** Boolean expression to filter rows from the table "play_session_comments". All fields are combined with a logical 'AND'. */
export type PlaySessionCommentsBoolExp = {
  _and?: InputMaybe<Array<PlaySessionCommentsBoolExp>>;
  _not?: InputMaybe<PlaySessionCommentsBoolExp>;
  _or?: InputMaybe<Array<PlaySessionCommentsBoolExp>>;
  allChildComments?: InputMaybe<PlaySessionCommentsBoolExp>;
  allChildCommentsAggregate?: InputMaybe<PlaySessionCommentsAggregateBoolExp>;
  content?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  playSession?: InputMaybe<PlaySessionsBoolExp>;
  playSessionCommentId?: InputMaybe<UuidComparisonExp>;
  playSessionId?: InputMaybe<UuidComparisonExp>;
  playSessionRootCommentId?: InputMaybe<UuidComparisonExp>;
  replies?: InputMaybe<PlaySessionCommentsBoolExp>;
  repliesAggregate?: InputMaybe<PlaySessionCommentsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "play_session_comments" */
export enum PlaySessionCommentsConstraint {
  /** unique or primary key constraint on columns "id" */
  PlaySessionCommentsPkey = 'play_session_comments_pkey'
}

/** input type for inserting data into table "play_session_comments" */
export type PlaySessionCommentsInsertInput = {
  allChildComments?: InputMaybe<PlaySessionCommentsArrRelInsertInput>;
  content?: InputMaybe<Scalars['String']>;
  playSession?: InputMaybe<PlaySessionsObjRelInsertInput>;
  playSessionCommentId?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  playSessionRootCommentId?: InputMaybe<Scalars['uuid']>;
  replies?: InputMaybe<PlaySessionCommentsArrRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PlaySessionCommentsMaxFields = {
  __typename?: 'PlaySessionCommentsMaxFields';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  playSessionCommentId?: Maybe<Scalars['uuid']>;
  playSessionId?: Maybe<Scalars['uuid']>;
  playSessionRootCommentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "play_session_comments" */
export type PlaySessionCommentsMaxOrderBy = {
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSessionCommentId?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  playSessionRootCommentId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlaySessionCommentsMinFields = {
  __typename?: 'PlaySessionCommentsMinFields';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  playSessionCommentId?: Maybe<Scalars['uuid']>;
  playSessionId?: Maybe<Scalars['uuid']>;
  playSessionRootCommentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "play_session_comments" */
export type PlaySessionCommentsMinOrderBy = {
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSessionCommentId?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  playSessionRootCommentId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "play_session_comments" */
export type PlaySessionCommentsMutationResponse = {
  __typename?: 'PlaySessionCommentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlaySessionComments>;
};

/** on_conflict condition type for table "play_session_comments" */
export type PlaySessionCommentsOnConflict = {
  constraint: PlaySessionCommentsConstraint;
  updateColumns?: Array<PlaySessionCommentsUpdateColumn>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};

/** Ordering options when selecting data from "play_session_comments". */
export type PlaySessionCommentsOrderBy = {
  allChildCommentsAggregate?: InputMaybe<PlaySessionCommentsAggregateOrderBy>;
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSession?: InputMaybe<PlaySessionsOrderBy>;
  playSessionCommentId?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  playSessionRootCommentId?: InputMaybe<OrderBy>;
  repliesAggregate?: InputMaybe<PlaySessionCommentsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: play_session_comments */
export type PlaySessionCommentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "play_session_comments" */
export enum PlaySessionCommentsSelectColumn {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PlaySessionCommentId = 'playSessionCommentId',
  /** column name */
  PlaySessionId = 'playSessionId',
  /** column name */
  PlaySessionRootCommentId = 'playSessionRootCommentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "play_session_comments" */
export type PlaySessionCommentsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "play_session_comments" */
export type PlaySessionCommentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionCommentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionCommentsStreamCursorValueInput = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playSessionCommentId?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  playSessionRootCommentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "play_session_comments" */
export enum PlaySessionCommentsUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt'
}

export type PlaySessionCommentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlaySessionCommentsSetInput>;
  /** filter the rows which have to be updated */
  where: PlaySessionCommentsBoolExp;
};

/** columns and relationships of "play_session_court_booking_statuses" */
export type PlaySessionCourtBookingStatuses = {
  __typename?: 'PlaySessionCourtBookingStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "play_session_court_booking_statuses". All fields are combined with a logical 'AND'. */
export type PlaySessionCourtBookingStatusesBoolExp = {
  _and?: InputMaybe<Array<PlaySessionCourtBookingStatusesBoolExp>>;
  _not?: InputMaybe<PlaySessionCourtBookingStatusesBoolExp>;
  _or?: InputMaybe<Array<PlaySessionCourtBookingStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PlaySessionCourtBookingStatusesEnum {
  Booked = 'BOOKED',
  NotBooked = 'NOT_BOOKED'
}

/** Boolean expression to compare columns of type "PlaySessionCourtBookingStatusesEnum". All fields are combined with logical 'AND'. */
export type PlaySessionCourtBookingStatusesEnumComparisonExp = {
  _eq?: InputMaybe<PlaySessionCourtBookingStatusesEnum>;
  _in?: InputMaybe<Array<PlaySessionCourtBookingStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlaySessionCourtBookingStatusesEnum>;
  _nin?: InputMaybe<Array<PlaySessionCourtBookingStatusesEnum>>;
};

/** Ordering options when selecting data from "play_session_court_booking_statuses". */
export type PlaySessionCourtBookingStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "play_session_court_booking_statuses" */
export enum PlaySessionCourtBookingStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "play_session_court_booking_statuses" */
export type PlaySessionCourtBookingStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionCourtBookingStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionCourtBookingStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "play_session_formats" */
export type PlaySessionFormats = {
  __typename?: 'PlaySessionFormats';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "play_session_formats". All fields are combined with a logical 'AND'. */
export type PlaySessionFormatsBoolExp = {
  _and?: InputMaybe<Array<PlaySessionFormatsBoolExp>>;
  _not?: InputMaybe<PlaySessionFormatsBoolExp>;
  _or?: InputMaybe<Array<PlaySessionFormatsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PlaySessionFormatsEnum {
  Doubles = 'DOUBLES',
  OpenPlay = 'OPEN_PLAY',
  Singles = 'SINGLES'
}

/** Boolean expression to compare columns of type "PlaySessionFormatsEnum". All fields are combined with logical 'AND'. */
export type PlaySessionFormatsEnumComparisonExp = {
  _eq?: InputMaybe<PlaySessionFormatsEnum>;
  _in?: InputMaybe<Array<PlaySessionFormatsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlaySessionFormatsEnum>;
  _nin?: InputMaybe<Array<PlaySessionFormatsEnum>>;
};

/** Ordering options when selecting data from "play_session_formats". */
export type PlaySessionFormatsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "play_session_formats" */
export enum PlaySessionFormatsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "play_session_formats" */
export type PlaySessionFormatsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionFormatsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionFormatsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "play_session_match_competitiveness" */
export type PlaySessionMatchCompetitiveness = {
  __typename?: 'PlaySessionMatchCompetitiveness';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "play_session_match_competitiveness". All fields are combined with a logical 'AND'. */
export type PlaySessionMatchCompetitivenessBoolExp = {
  _and?: InputMaybe<Array<PlaySessionMatchCompetitivenessBoolExp>>;
  _not?: InputMaybe<PlaySessionMatchCompetitivenessBoolExp>;
  _or?: InputMaybe<Array<PlaySessionMatchCompetitivenessBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PlaySessionMatchCompetitivenessEnum {
  /** Recreational play */
  Casual = 'CASUAL',
  Match = 'MATCH',
  Practice = 'PRACTICE'
}

/** Boolean expression to compare columns of type "PlaySessionMatchCompetitivenessEnum". All fields are combined with logical 'AND'. */
export type PlaySessionMatchCompetitivenessEnumComparisonExp = {
  _eq?: InputMaybe<PlaySessionMatchCompetitivenessEnum>;
  _in?: InputMaybe<Array<PlaySessionMatchCompetitivenessEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlaySessionMatchCompetitivenessEnum>;
  _nin?: InputMaybe<Array<PlaySessionMatchCompetitivenessEnum>>;
};

/** Ordering options when selecting data from "play_session_match_competitiveness". */
export type PlaySessionMatchCompetitivenessOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "play_session_match_competitiveness" */
export enum PlaySessionMatchCompetitivenessSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "play_session_match_competitiveness" */
export type PlaySessionMatchCompetitivenessStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionMatchCompetitivenessStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionMatchCompetitivenessStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "play_session_participant_statuses" */
export type PlaySessionParticipantStatuses = {
  __typename?: 'PlaySessionParticipantStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "play_session_participant_statuses". All fields are combined with a logical 'AND'. */
export type PlaySessionParticipantStatusesBoolExp = {
  _and?: InputMaybe<Array<PlaySessionParticipantStatusesBoolExp>>;
  _not?: InputMaybe<PlaySessionParticipantStatusesBoolExp>;
  _or?: InputMaybe<Array<PlaySessionParticipantStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PlaySessionParticipantStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "PlaySessionParticipantStatusesEnum". All fields are combined with logical 'AND'. */
export type PlaySessionParticipantStatusesEnumComparisonExp = {
  _eq?: InputMaybe<PlaySessionParticipantStatusesEnum>;
  _in?: InputMaybe<Array<PlaySessionParticipantStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlaySessionParticipantStatusesEnum>;
  _nin?: InputMaybe<Array<PlaySessionParticipantStatusesEnum>>;
};

/** Ordering options when selecting data from "play_session_participant_statuses". */
export type PlaySessionParticipantStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "play_session_participant_statuses" */
export enum PlaySessionParticipantStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "play_session_participant_statuses" */
export type PlaySessionParticipantStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionParticipantStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionParticipantStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "play_session_participants" */
export type PlaySessionParticipants = {
  __typename?: 'PlaySessionParticipants';
  addedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  playSession: PlaySessions;
  playSessionId: Scalars['uuid'];
  removedAt?: Maybe<Scalars['timestamptz']>;
  status: PlaySessionParticipantStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** aggregated selection of "play_session_participants" */
export type PlaySessionParticipantsAggregate = {
  __typename?: 'PlaySessionParticipantsAggregate';
  aggregate?: Maybe<PlaySessionParticipantsAggregateFields>;
  nodes: Array<PlaySessionParticipants>;
};

export type PlaySessionParticipantsAggregateBoolExp = {
  count?: InputMaybe<PlaySessionParticipantsAggregateBoolExpCount>;
};

/** aggregate fields of "play_session_participants" */
export type PlaySessionParticipantsAggregateFields = {
  __typename?: 'PlaySessionParticipantsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PlaySessionParticipantsMaxFields>;
  min?: Maybe<PlaySessionParticipantsMinFields>;
};


/** aggregate fields of "play_session_participants" */
export type PlaySessionParticipantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "play_session_participants" */
export type PlaySessionParticipantsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlaySessionParticipantsMaxOrderBy>;
  min?: InputMaybe<PlaySessionParticipantsMinOrderBy>;
};

/** input type for inserting array relation for remote table "play_session_participants" */
export type PlaySessionParticipantsArrRelInsertInput = {
  data: Array<PlaySessionParticipantsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlaySessionParticipantsOnConflict>;
};

/** Boolean expression to filter rows from the table "play_session_participants". All fields are combined with a logical 'AND'. */
export type PlaySessionParticipantsBoolExp = {
  _and?: InputMaybe<Array<PlaySessionParticipantsBoolExp>>;
  _not?: InputMaybe<PlaySessionParticipantsBoolExp>;
  _or?: InputMaybe<Array<PlaySessionParticipantsBoolExp>>;
  addedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  playSession?: InputMaybe<PlaySessionsBoolExp>;
  playSessionId?: InputMaybe<UuidComparisonExp>;
  removedAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<PlaySessionParticipantStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "play_session_participants" */
export enum PlaySessionParticipantsConstraint {
  /** unique or primary key constraint on columns "id" */
  PlaySessionParticipantsPkey = 'play_session_participants_pkey',
  /** unique or primary key constraint on columns "user_id", "play_session_id" */
  PlaySessionParticipantsPlaySessionIdUserIdKey = 'play_session_participants_play_session_id_user_id_key'
}

/** input type for inserting data into table "play_session_participants" */
export type PlaySessionParticipantsInsertInput = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByPersona?: InputMaybe<AppPersonasEnum>;
  addedByUserId?: InputMaybe<Scalars['uuid']>;
  playSession?: InputMaybe<PlaySessionsObjRelInsertInput>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  removedAt?: InputMaybe<Scalars['timestamptz']>;
  removedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<PlaySessionParticipantStatusesEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PlaySessionParticipantsMaxFields = {
  __typename?: 'PlaySessionParticipantsMaxFields';
  addedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  playSessionId?: Maybe<Scalars['uuid']>;
  removedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "play_session_participants" */
export type PlaySessionParticipantsMaxOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  removedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlaySessionParticipantsMinFields = {
  __typename?: 'PlaySessionParticipantsMinFields';
  addedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  playSessionId?: Maybe<Scalars['uuid']>;
  removedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "play_session_participants" */
export type PlaySessionParticipantsMinOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  removedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "play_session_participants" */
export type PlaySessionParticipantsMutationResponse = {
  __typename?: 'PlaySessionParticipantsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlaySessionParticipants>;
};

/** on_conflict condition type for table "play_session_participants" */
export type PlaySessionParticipantsOnConflict = {
  constraint: PlaySessionParticipantsConstraint;
  updateColumns?: Array<PlaySessionParticipantsUpdateColumn>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};

/** Ordering options when selecting data from "play_session_participants". */
export type PlaySessionParticipantsOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  playSession?: InputMaybe<PlaySessionsOrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  removedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** select columns of table "play_session_participants" */
export enum PlaySessionParticipantsSelectColumn {
  /** column name */
  AddedAt = 'addedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PlaySessionId = 'playSessionId',
  /** column name */
  RemovedAt = 'removedAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "play_session_participants" */
export type PlaySessionParticipantsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionParticipantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionParticipantsStreamCursorValueInput = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  removedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<PlaySessionParticipantStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** placeholder for update columns of table "play_session_participants" (current role has no relevant permissions) */
export enum PlaySessionParticipantsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "play_session_privacy" */
export type PlaySessionPrivacy = {
  __typename?: 'PlaySessionPrivacy';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "play_session_privacy". All fields are combined with a logical 'AND'. */
export type PlaySessionPrivacyBoolExp = {
  _and?: InputMaybe<Array<PlaySessionPrivacyBoolExp>>;
  _not?: InputMaybe<PlaySessionPrivacyBoolExp>;
  _or?: InputMaybe<Array<PlaySessionPrivacyBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PlaySessionPrivacyEnum {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/** Boolean expression to compare columns of type "PlaySessionPrivacyEnum". All fields are combined with logical 'AND'. */
export type PlaySessionPrivacyEnumComparisonExp = {
  _eq?: InputMaybe<PlaySessionPrivacyEnum>;
  _in?: InputMaybe<Array<PlaySessionPrivacyEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlaySessionPrivacyEnum>;
  _nin?: InputMaybe<Array<PlaySessionPrivacyEnum>>;
};

/** Ordering options when selecting data from "play_session_privacy". */
export type PlaySessionPrivacyOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "play_session_privacy" */
export enum PlaySessionPrivacySelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "play_session_privacy" */
export type PlaySessionPrivacyStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionPrivacyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionPrivacyStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "play_session_statuses" */
export type PlaySessionStatuses = {
  __typename?: 'PlaySessionStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "play_session_statuses". All fields are combined with a logical 'AND'. */
export type PlaySessionStatusesBoolExp = {
  _and?: InputMaybe<Array<PlaySessionStatusesBoolExp>>;
  _not?: InputMaybe<PlaySessionStatusesBoolExp>;
  _or?: InputMaybe<Array<PlaySessionStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PlaySessionStatusesEnum {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "PlaySessionStatusesEnum". All fields are combined with logical 'AND'. */
export type PlaySessionStatusesEnumComparisonExp = {
  _eq?: InputMaybe<PlaySessionStatusesEnum>;
  _in?: InputMaybe<Array<PlaySessionStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlaySessionStatusesEnum>;
  _nin?: InputMaybe<Array<PlaySessionStatusesEnum>>;
};

/** Ordering options when selecting data from "play_session_statuses". */
export type PlaySessionStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "play_session_statuses" */
export enum PlaySessionStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "play_session_statuses" */
export type PlaySessionStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "play_sessions" */
export type PlaySessions = {
  __typename?: 'PlaySessions';
  cancelReason: Scalars['String'];
  canceledAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  comments: Array<PlaySessionComments>;
  /** An aggregate relationship */
  commentsAggregate: PlaySessionCommentsAggregate;
  competitiveness?: Maybe<PlaySessionMatchCompetitivenessEnum>;
  courtBookingStatus: PlaySessionCourtBookingStatusesEnum;
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  endDateTime?: Maybe<Scalars['timestamptz']>;
  extraRacketCount?: Maybe<Scalars['Int']>;
  format: PlaySessionFormatsEnum;
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  groupsPlaySessions: Array<GroupsPlaySessions>;
  id: Scalars['uuid'];
  isBringingNet: Scalars['Boolean'];
  locale: Scalars['String'];
  /** An object relationship */
  organizer?: Maybe<Users>;
  /** An object relationship */
  organizerProfile?: Maybe<UserProfiles>;
  organizerUserId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  /** An array relationship */
  participants: Array<PlaySessionParticipants>;
  /** An aggregate relationship */
  participantsAggregate: PlaySessionParticipantsAggregate;
  /** An object relationship */
  pickleballRatingScale?: Maybe<PickleballRatingScales>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  priceUnitAmount: Scalars['Int'];
  privacy: PlaySessionPrivacyEnum;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  reminderEventId?: Maybe<Scalars['uuid']>;
  skillRatingMaximum?: Maybe<Scalars['numeric']>;
  skillRatingMinimum?: Maybe<Scalars['numeric']>;
  sport: SportsEnum;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  status: PlaySessionStatusesEnum;
  targetSkillLevel?: Maybe<Scalars['String']>;
  /** An object relationship */
  tennisRatingScale?: Maybe<TennisRatingScales>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userCustomCourt?: Maybe<UserCustomCourts>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  venue?: Maybe<Venues>;
  venueId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "play_sessions" */
export type PlaySessionsCommentsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


/** columns and relationships of "play_sessions" */
export type PlaySessionsCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


/** columns and relationships of "play_sessions" */
export type PlaySessionsGroupsPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<GroupsPlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsPlaySessionsOrderBy>>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};


/** columns and relationships of "play_sessions" */
export type PlaySessionsParticipantsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantsOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};


/** columns and relationships of "play_sessions" */
export type PlaySessionsParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantsOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};

/** aggregated selection of "play_sessions" */
export type PlaySessionsAggregate = {
  __typename?: 'PlaySessionsAggregate';
  aggregate?: Maybe<PlaySessionsAggregateFields>;
  nodes: Array<PlaySessions>;
};

export type PlaySessionsAggregateBoolExp = {
  bool_and?: InputMaybe<PlaySessionsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<PlaySessionsAggregateBoolExpBool_Or>;
  count?: InputMaybe<PlaySessionsAggregateBoolExpCount>;
};

/** aggregate fields of "play_sessions" */
export type PlaySessionsAggregateFields = {
  __typename?: 'PlaySessionsAggregateFields';
  avg?: Maybe<PlaySessionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PlaySessionsMaxFields>;
  min?: Maybe<PlaySessionsMinFields>;
  stddev?: Maybe<PlaySessionsStddevFields>;
  stddevPop?: Maybe<PlaySessionsStddevPopFields>;
  stddevSamp?: Maybe<PlaySessionsStddevSampFields>;
  sum?: Maybe<PlaySessionsSumFields>;
  varPop?: Maybe<PlaySessionsVarPopFields>;
  varSamp?: Maybe<PlaySessionsVarSampFields>;
  variance?: Maybe<PlaySessionsVarianceFields>;
};


/** aggregate fields of "play_sessions" */
export type PlaySessionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "play_sessions" */
export type PlaySessionsAggregateOrderBy = {
  avg?: InputMaybe<PlaySessionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlaySessionsMaxOrderBy>;
  min?: InputMaybe<PlaySessionsMinOrderBy>;
  stddev?: InputMaybe<PlaySessionsStddevOrderBy>;
  stddevPop?: InputMaybe<PlaySessionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PlaySessionsStddevSampOrderBy>;
  sum?: InputMaybe<PlaySessionsSumOrderBy>;
  varPop?: InputMaybe<PlaySessionsVarPopOrderBy>;
  varSamp?: InputMaybe<PlaySessionsVarSampOrderBy>;
  variance?: InputMaybe<PlaySessionsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type PlaySessionsAvgFields = {
  __typename?: 'PlaySessionsAvgFields';
  extraRacketCount?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  skillRatingMaximum?: Maybe<Scalars['Float']>;
  skillRatingMinimum?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "play_sessions" */
export type PlaySessionsAvgOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "play_sessions". All fields are combined with a logical 'AND'. */
export type PlaySessionsBoolExp = {
  _and?: InputMaybe<Array<PlaySessionsBoolExp>>;
  _not?: InputMaybe<PlaySessionsBoolExp>;
  _or?: InputMaybe<Array<PlaySessionsBoolExp>>;
  cancelReason?: InputMaybe<StringComparisonExp>;
  canceledAt?: InputMaybe<TimestamptzComparisonExp>;
  comments?: InputMaybe<PlaySessionCommentsBoolExp>;
  commentsAggregate?: InputMaybe<PlaySessionCommentsAggregateBoolExp>;
  competitiveness?: InputMaybe<PlaySessionMatchCompetitivenessEnumComparisonExp>;
  courtBookingStatus?: InputMaybe<PlaySessionCourtBookingStatusesEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  endDateTime?: InputMaybe<TimestamptzComparisonExp>;
  extraRacketCount?: InputMaybe<IntComparisonExp>;
  format?: InputMaybe<PlaySessionFormatsEnumComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  groupsPlaySessions?: InputMaybe<GroupsPlaySessionsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isBringingNet?: InputMaybe<BooleanComparisonExp>;
  locale?: InputMaybe<StringComparisonExp>;
  organizer?: InputMaybe<UsersBoolExp>;
  organizerProfile?: InputMaybe<UserProfilesBoolExp>;
  organizerUserId?: InputMaybe<UuidComparisonExp>;
  participantLimit?: InputMaybe<IntComparisonExp>;
  participants?: InputMaybe<PlaySessionParticipantsBoolExp>;
  participantsAggregate?: InputMaybe<PlaySessionParticipantsAggregateBoolExp>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesBoolExp>;
  pickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  privacy?: InputMaybe<PlaySessionPrivacyEnumComparisonExp>;
  publishedAt?: InputMaybe<TimestamptzComparisonExp>;
  reminderEventId?: InputMaybe<UuidComparisonExp>;
  skillRatingMaximum?: InputMaybe<NumericComparisonExp>;
  skillRatingMinimum?: InputMaybe<NumericComparisonExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  startDateTime?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<PlaySessionStatusesEnumComparisonExp>;
  targetSkillLevel?: InputMaybe<StringComparisonExp>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  timezoneAbbreviation?: InputMaybe<StringComparisonExp>;
  timezoneName?: InputMaybe<StringComparisonExp>;
  timezoneOffsetMinutes?: InputMaybe<IntComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCustomCourt?: InputMaybe<UserCustomCourtsBoolExp>;
  userCustomCourtId?: InputMaybe<UuidComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "play_sessions" */
export enum PlaySessionsConstraint {
  /** unique or primary key constraint on columns "id" */
  PlaySessionsPkey = 'play_sessions_pkey'
}

/** input type for incrementing numeric columns in table "play_sessions" */
export type PlaySessionsIncInput = {
  extraRacketCount?: InputMaybe<Scalars['Int']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  skillRatingMaximum?: InputMaybe<Scalars['numeric']>;
  skillRatingMinimum?: InputMaybe<Scalars['numeric']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "play_sessions" */
export type PlaySessionsInsertInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<PlaySessionCommentsArrRelInsertInput>;
  competitiveness?: InputMaybe<PlaySessionMatchCompetitivenessEnum>;
  courtBookingStatus?: InputMaybe<PlaySessionCourtBookingStatusesEnum>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  extraRacketCount?: InputMaybe<Scalars['Int']>;
  format?: InputMaybe<PlaySessionFormatsEnum>;
  groupId?: InputMaybe<Scalars['uuid']>;
  groupsPlaySessions?: InputMaybe<GroupsPlaySessionsArrRelInsertInput>;
  isBringingNet?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  organizerUserId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  participants?: InputMaybe<PlaySessionParticipantsArrRelInsertInput>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<PlaySessionPrivacyEnum>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  skillRatingMaximum?: InputMaybe<Scalars['numeric']>;
  skillRatingMinimum?: InputMaybe<Scalars['numeric']>;
  sport?: InputMaybe<SportsEnum>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<PlaySessionStatusesEnum>;
  targetSkillLevel?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCustomCourt?: InputMaybe<UserCustomCourtsObjRelInsertInput>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PlaySessionsMaxFields = {
  __typename?: 'PlaySessionsMaxFields';
  cancelReason?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['timestamptz']>;
  extraRacketCount?: Maybe<Scalars['Int']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  organizerUserId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  reminderEventId?: Maybe<Scalars['uuid']>;
  skillRatingMaximum?: Maybe<Scalars['numeric']>;
  skillRatingMinimum?: Maybe<Scalars['numeric']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  targetSkillLevel?: Maybe<Scalars['String']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "play_sessions" */
export type PlaySessionsMaxOrderBy = {
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  extraRacketCount?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  organizerUserId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  reminderEventId?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  targetSkillLevel?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PlaySessionsMinFields = {
  __typename?: 'PlaySessionsMinFields';
  cancelReason?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['timestamptz']>;
  extraRacketCount?: Maybe<Scalars['Int']>;
  groupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  organizerUserId?: Maybe<Scalars['uuid']>;
  participantLimit?: Maybe<Scalars['Int']>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  reminderEventId?: Maybe<Scalars['uuid']>;
  skillRatingMaximum?: Maybe<Scalars['numeric']>;
  skillRatingMinimum?: Maybe<Scalars['numeric']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  targetSkillLevel?: Maybe<Scalars['String']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "play_sessions" */
export type PlaySessionsMinOrderBy = {
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  extraRacketCount?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  organizerUserId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  reminderEventId?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  targetSkillLevel?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "play_sessions" */
export type PlaySessionsMutationResponse = {
  __typename?: 'PlaySessionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlaySessions>;
};

/** input type for inserting object relation for remote table "play_sessions" */
export type PlaySessionsObjRelInsertInput = {
  data: PlaySessionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PlaySessionsOnConflict>;
};

/** on_conflict condition type for table "play_sessions" */
export type PlaySessionsOnConflict = {
  constraint: PlaySessionsConstraint;
  updateColumns?: Array<PlaySessionsUpdateColumn>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};

/** Ordering options when selecting data from "play_sessions". */
export type PlaySessionsOrderBy = {
  cancelReason?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  commentsAggregate?: InputMaybe<PlaySessionCommentsAggregateOrderBy>;
  competitiveness?: InputMaybe<OrderBy>;
  courtBookingStatus?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDateTime?: InputMaybe<OrderBy>;
  extraRacketCount?: InputMaybe<OrderBy>;
  format?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  groupsPlaySessionsAggregate?: InputMaybe<GroupsPlaySessionsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  isBringingNet?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  organizer?: InputMaybe<UsersOrderBy>;
  organizerProfile?: InputMaybe<UserProfilesOrderBy>;
  organizerUserId?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  participantsAggregate?: InputMaybe<PlaySessionParticipantsAggregateOrderBy>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesOrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  privacy?: InputMaybe<OrderBy>;
  publishedAt?: InputMaybe<OrderBy>;
  reminderEventId?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  sport?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  targetSkillLevel?: InputMaybe<OrderBy>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCustomCourt?: InputMaybe<UserCustomCourtsOrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: play_sessions */
export type PlaySessionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "play_sessions" */
export enum PlaySessionsSelectColumn {
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  CourtBookingStatus = 'courtBookingStatus',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  ExtraRacketCount = 'extraRacketCount',
  /** column name */
  Format = 'format',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  IsBringingNet = 'isBringingNet',
  /** column name */
  Locale = 'locale',
  /** column name */
  OrganizerUserId = 'organizerUserId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  ReminderEventId = 'reminderEventId',
  /** column name */
  SkillRatingMaximum = 'skillRatingMaximum',
  /** column name */
  SkillRatingMinimum = 'skillRatingMinimum',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  Status = 'status',
  /** column name */
  TargetSkillLevel = 'targetSkillLevel',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  VenueId = 'venueId'
}

/** select "playSessionsAggregateBoolExpBool_andArgumentsColumns" columns of table "play_sessions" */
export enum PlaySessionsSelectColumnPlaySessionsAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsBringingNet = 'isBringingNet'
}

/** select "playSessionsAggregateBoolExpBool_orArgumentsColumns" columns of table "play_sessions" */
export enum PlaySessionsSelectColumnPlaySessionsAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsBringingNet = 'isBringingNet'
}

/** input type for updating data in table "play_sessions" */
export type PlaySessionsSetInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  competitiveness?: InputMaybe<PlaySessionMatchCompetitivenessEnum>;
  courtBookingStatus?: InputMaybe<PlaySessionCourtBookingStatusesEnum>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  extraRacketCount?: InputMaybe<Scalars['Int']>;
  format?: InputMaybe<PlaySessionFormatsEnum>;
  groupId?: InputMaybe<Scalars['uuid']>;
  isBringingNet?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  organizerUserId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<PlaySessionPrivacyEnum>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  skillRatingMaximum?: InputMaybe<Scalars['numeric']>;
  skillRatingMinimum?: InputMaybe<Scalars['numeric']>;
  sport?: InputMaybe<SportsEnum>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<PlaySessionStatusesEnum>;
  targetSkillLevel?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type PlaySessionsStddevFields = {
  __typename?: 'PlaySessionsStddevFields';
  extraRacketCount?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  skillRatingMaximum?: Maybe<Scalars['Float']>;
  skillRatingMinimum?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "play_sessions" */
export type PlaySessionsStddevOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PlaySessionsStddevPopFields = {
  __typename?: 'PlaySessionsStddevPopFields';
  extraRacketCount?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  skillRatingMaximum?: Maybe<Scalars['Float']>;
  skillRatingMinimum?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "play_sessions" */
export type PlaySessionsStddevPopOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PlaySessionsStddevSampFields = {
  __typename?: 'PlaySessionsStddevSampFields';
  extraRacketCount?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  skillRatingMaximum?: Maybe<Scalars['Float']>;
  skillRatingMinimum?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "play_sessions" */
export type PlaySessionsStddevSampOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "play_sessions" */
export type PlaySessionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlaySessionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaySessionsStreamCursorValueInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  competitiveness?: InputMaybe<PlaySessionMatchCompetitivenessEnum>;
  courtBookingStatus?: InputMaybe<PlaySessionCourtBookingStatusesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['timestamptz']>;
  extraRacketCount?: InputMaybe<Scalars['Int']>;
  format?: InputMaybe<PlaySessionFormatsEnum>;
  groupId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  isBringingNet?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  organizerUserId?: InputMaybe<Scalars['uuid']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<PlaySessionPrivacyEnum>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  reminderEventId?: InputMaybe<Scalars['uuid']>;
  skillRatingMaximum?: InputMaybe<Scalars['numeric']>;
  skillRatingMinimum?: InputMaybe<Scalars['numeric']>;
  sport?: InputMaybe<SportsEnum>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<PlaySessionStatusesEnum>;
  targetSkillLevel?: InputMaybe<Scalars['String']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type PlaySessionsSumFields = {
  __typename?: 'PlaySessionsSumFields';
  extraRacketCount?: Maybe<Scalars['Int']>;
  participantLimit?: Maybe<Scalars['Int']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  skillRatingMaximum?: Maybe<Scalars['numeric']>;
  skillRatingMinimum?: Maybe<Scalars['numeric']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "play_sessions" */
export type PlaySessionsSumOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** update columns of table "play_sessions" */
export enum PlaySessionsUpdateColumn {
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  CourtBookingStatus = 'courtBookingStatus',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  EndDateTime = 'endDateTime',
  /** column name */
  ExtraRacketCount = 'extraRacketCount',
  /** column name */
  Format = 'format',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  IsBringingNet = 'isBringingNet',
  /** column name */
  Locale = 'locale',
  /** column name */
  OrganizerUserId = 'organizerUserId',
  /** column name */
  ParticipantLimit = 'participantLimit',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Privacy = 'privacy',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  SkillRatingMaximum = 'skillRatingMaximum',
  /** column name */
  SkillRatingMinimum = 'skillRatingMinimum',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  Status = 'status',
  /** column name */
  TargetSkillLevel = 'targetSkillLevel',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  Title = 'title',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  VenueId = 'venueId'
}

export type PlaySessionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PlaySessionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlaySessionsSetInput>;
  /** filter the rows which have to be updated */
  where: PlaySessionsBoolExp;
};

/** aggregate varPop on columns */
export type PlaySessionsVarPopFields = {
  __typename?: 'PlaySessionsVarPopFields';
  extraRacketCount?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  skillRatingMaximum?: Maybe<Scalars['Float']>;
  skillRatingMinimum?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "play_sessions" */
export type PlaySessionsVarPopOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PlaySessionsVarSampFields = {
  __typename?: 'PlaySessionsVarSampFields';
  extraRacketCount?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  skillRatingMaximum?: Maybe<Scalars['Float']>;
  skillRatingMinimum?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "play_sessions" */
export type PlaySessionsVarSampOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PlaySessionsVarianceFields = {
  __typename?: 'PlaySessionsVarianceFields';
  extraRacketCount?: Maybe<Scalars['Float']>;
  participantLimit?: Maybe<Scalars['Float']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  skillRatingMaximum?: Maybe<Scalars['Float']>;
  skillRatingMinimum?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "play_sessions" */
export type PlaySessionsVarianceOrderBy = {
  extraRacketCount?: InputMaybe<OrderBy>;
  participantLimit?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  skillRatingMaximum?: InputMaybe<OrderBy>;
  skillRatingMinimum?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** columns and relationships of "player_availabilities" */
export type PlayerAvailabilities = {
  __typename?: 'PlayerAvailabilities';
  competitiveness: EventCompetitivenessEnum;
  createdAt: Scalars['timestamptz'];
  description: Scalars['String'];
  gender: CompetitionGenderEnum;
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  /** An array relationship */
  neighborhoods: Array<PlayerAvailabilityNeighborhoods>;
  /** An array relationship */
  ratingScales: Array<PlayerAvailabilityRatingScales>;
  /** An object relationship */
  selfRatedMaxSkillLevel?: Maybe<SkillLevels>;
  selfRatedMaxSkillLevelId?: Maybe<Scalars['String']>;
  /** An object relationship */
  selfRatedMinSkillLevel?: Maybe<SkillLevels>;
  selfRatedMinSkillLevelId?: Maybe<Scalars['String']>;
  /** An array relationship */
  slots: Array<PlayerAvailabilitySlots>;
  sport: SportsEnum;
  teamType: TeamTypesEnum;
  travelRadiusMiles: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
  /** An array relationship */
  venues: Array<PlayerAvailabilityVenues>;
  wantsRegularPartner: Scalars['Boolean'];
};


/** columns and relationships of "player_availabilities" */
export type PlayerAvailabilitiesNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
};


/** columns and relationships of "player_availabilities" */
export type PlayerAvailabilitiesRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityRatingScalesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
};


/** columns and relationships of "player_availabilities" */
export type PlayerAvailabilitiesSlotsArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitySlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitySlotsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
};


/** columns and relationships of "player_availabilities" */
export type PlayerAvailabilitiesVenuesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityVenuesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
};

/** aggregated selection of "player_availabilities" */
export type PlayerAvailabilitiesAggregate = {
  __typename?: 'PlayerAvailabilitiesAggregate';
  aggregate?: Maybe<PlayerAvailabilitiesAggregateFields>;
  nodes: Array<PlayerAvailabilities>;
};

/** aggregate fields of "player_availabilities" */
export type PlayerAvailabilitiesAggregateFields = {
  __typename?: 'PlayerAvailabilitiesAggregateFields';
  avg?: Maybe<PlayerAvailabilitiesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PlayerAvailabilitiesMaxFields>;
  min?: Maybe<PlayerAvailabilitiesMinFields>;
  stddev?: Maybe<PlayerAvailabilitiesStddevFields>;
  stddevPop?: Maybe<PlayerAvailabilitiesStddevPopFields>;
  stddevSamp?: Maybe<PlayerAvailabilitiesStddevSampFields>;
  sum?: Maybe<PlayerAvailabilitiesSumFields>;
  varPop?: Maybe<PlayerAvailabilitiesVarPopFields>;
  varSamp?: Maybe<PlayerAvailabilitiesVarSampFields>;
  variance?: Maybe<PlayerAvailabilitiesVarianceFields>;
};


/** aggregate fields of "player_availabilities" */
export type PlayerAvailabilitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PlayerAvailabilitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PlayerAvailabilitiesAvgFields = {
  __typename?: 'PlayerAvailabilitiesAvgFields';
  travelRadiusMiles?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "player_availabilities". All fields are combined with a logical 'AND'. */
export type PlayerAvailabilitiesBoolExp = {
  _and?: InputMaybe<Array<PlayerAvailabilitiesBoolExp>>;
  _not?: InputMaybe<PlayerAvailabilitiesBoolExp>;
  _or?: InputMaybe<Array<PlayerAvailabilitiesBoolExp>>;
  competitiveness?: InputMaybe<EventCompetitivenessEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  gender?: InputMaybe<CompetitionGenderEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  neighborhoods?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
  ratingScales?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
  selfRatedMaxSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  selfRatedMaxSkillLevelId?: InputMaybe<StringComparisonExp>;
  selfRatedMinSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  selfRatedMinSkillLevelId?: InputMaybe<StringComparisonExp>;
  slots?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  teamType?: InputMaybe<TeamTypesEnumComparisonExp>;
  travelRadiusMiles?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
  venues?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
  wantsRegularPartner?: InputMaybe<BooleanComparisonExp>;
};

/** unique or primary key constraints on table "player_availabilities" */
export enum PlayerAvailabilitiesConstraint {
  /** unique or primary key constraint on columns "sport", "user_id" */
  PlayerAvailabilitiesOneActivePerUserPerSport = 'player_availabilities_one_active_per_user_per_sport',
  /** unique or primary key constraint on columns "id" */
  PlayerAvailabilitiesPkey = 'player_availabilities_pkey'
}

/** input type for incrementing numeric columns in table "player_availabilities" */
export type PlayerAvailabilitiesIncInput = {
  travelRadiusMiles?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "player_availabilities" */
export type PlayerAvailabilitiesInsertInput = {
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  description?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<CompetitionGenderEnum>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  neighborhoods?: InputMaybe<PlayerAvailabilityNeighborhoodsArrRelInsertInput>;
  ratingScales?: InputMaybe<PlayerAvailabilityRatingScalesArrRelInsertInput>;
  selfRatedMaxSkillLevelId?: InputMaybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: InputMaybe<Scalars['String']>;
  slots?: InputMaybe<PlayerAvailabilitySlotsArrRelInsertInput>;
  sport?: InputMaybe<SportsEnum>;
  teamType?: InputMaybe<TeamTypesEnum>;
  travelRadiusMiles?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venues?: InputMaybe<PlayerAvailabilityVenuesArrRelInsertInput>;
  wantsRegularPartner?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type PlayerAvailabilitiesMaxFields = {
  __typename?: 'PlayerAvailabilitiesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  selfRatedMaxSkillLevelId?: Maybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: Maybe<Scalars['String']>;
  travelRadiusMiles?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type PlayerAvailabilitiesMinFields = {
  __typename?: 'PlayerAvailabilitiesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  selfRatedMaxSkillLevelId?: Maybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: Maybe<Scalars['String']>;
  travelRadiusMiles?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "player_availabilities" */
export type PlayerAvailabilitiesMutationResponse = {
  __typename?: 'PlayerAvailabilitiesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayerAvailabilities>;
};

/** input type for inserting object relation for remote table "player_availabilities" */
export type PlayerAvailabilitiesObjRelInsertInput = {
  data: PlayerAvailabilitiesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PlayerAvailabilitiesOnConflict>;
};

/** on_conflict condition type for table "player_availabilities" */
export type PlayerAvailabilitiesOnConflict = {
  constraint: PlayerAvailabilitiesConstraint;
  updateColumns?: Array<PlayerAvailabilitiesUpdateColumn>;
  where?: InputMaybe<PlayerAvailabilitiesBoolExp>;
};

/** Ordering options when selecting data from "player_availabilities". */
export type PlayerAvailabilitiesOrderBy = {
  competitiveness?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  neighborhoodsAggregate?: InputMaybe<PlayerAvailabilityNeighborhoodsAggregateOrderBy>;
  ratingScalesAggregate?: InputMaybe<PlayerAvailabilityRatingScalesAggregateOrderBy>;
  selfRatedMaxSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  selfRatedMaxSkillLevelId?: InputMaybe<OrderBy>;
  selfRatedMinSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  selfRatedMinSkillLevelId?: InputMaybe<OrderBy>;
  slotsAggregate?: InputMaybe<PlayerAvailabilitySlotsAggregateOrderBy>;
  sport?: InputMaybe<OrderBy>;
  teamType?: InputMaybe<OrderBy>;
  travelRadiusMiles?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
  venuesAggregate?: InputMaybe<PlayerAvailabilityVenuesAggregateOrderBy>;
  wantsRegularPartner?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: player_availabilities */
export type PlayerAvailabilitiesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "player_availabilities" */
export enum PlayerAvailabilitiesSelectColumn {
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  SelfRatedMaxSkillLevelId = 'selfRatedMaxSkillLevelId',
  /** column name */
  SelfRatedMinSkillLevelId = 'selfRatedMinSkillLevelId',
  /** column name */
  Sport = 'sport',
  /** column name */
  TeamType = 'teamType',
  /** column name */
  TravelRadiusMiles = 'travelRadiusMiles',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  WantsRegularPartner = 'wantsRegularPartner'
}

/** input type for updating data in table "player_availabilities" */
export type PlayerAvailabilitiesSetInput = {
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  description?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<CompetitionGenderEnum>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  selfRatedMaxSkillLevelId?: InputMaybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<SportsEnum>;
  teamType?: InputMaybe<TeamTypesEnum>;
  travelRadiusMiles?: InputMaybe<Scalars['Int']>;
  wantsRegularPartner?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type PlayerAvailabilitiesStddevFields = {
  __typename?: 'PlayerAvailabilitiesStddevFields';
  travelRadiusMiles?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type PlayerAvailabilitiesStddevPopFields = {
  __typename?: 'PlayerAvailabilitiesStddevPopFields';
  travelRadiusMiles?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type PlayerAvailabilitiesStddevSampFields = {
  __typename?: 'PlayerAvailabilitiesStddevSampFields';
  travelRadiusMiles?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "player_availabilities" */
export type PlayerAvailabilitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayerAvailabilitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayerAvailabilitiesStreamCursorValueInput = {
  competitiveness?: InputMaybe<EventCompetitivenessEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<CompetitionGenderEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  selfRatedMaxSkillLevelId?: InputMaybe<Scalars['String']>;
  selfRatedMinSkillLevelId?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<SportsEnum>;
  teamType?: InputMaybe<TeamTypesEnum>;
  travelRadiusMiles?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  wantsRegularPartner?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type PlayerAvailabilitiesSumFields = {
  __typename?: 'PlayerAvailabilitiesSumFields';
  travelRadiusMiles?: Maybe<Scalars['Int']>;
};

/** update columns of table "player_availabilities" */
export enum PlayerAvailabilitiesUpdateColumn {
  /** column name */
  Competitiveness = 'competitiveness',
  /** column name */
  Description = 'description',
  /** column name */
  Gender = 'gender',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  SelfRatedMaxSkillLevelId = 'selfRatedMaxSkillLevelId',
  /** column name */
  SelfRatedMinSkillLevelId = 'selfRatedMinSkillLevelId',
  /** column name */
  Sport = 'sport',
  /** column name */
  TeamType = 'teamType',
  /** column name */
  TravelRadiusMiles = 'travelRadiusMiles',
  /** column name */
  WantsRegularPartner = 'wantsRegularPartner'
}

export type PlayerAvailabilitiesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PlayerAvailabilitiesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlayerAvailabilitiesSetInput>;
  /** filter the rows which have to be updated */
  where: PlayerAvailabilitiesBoolExp;
};

/** aggregate varPop on columns */
export type PlayerAvailabilitiesVarPopFields = {
  __typename?: 'PlayerAvailabilitiesVarPopFields';
  travelRadiusMiles?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type PlayerAvailabilitiesVarSampFields = {
  __typename?: 'PlayerAvailabilitiesVarSampFields';
  travelRadiusMiles?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PlayerAvailabilitiesVarianceFields = {
  __typename?: 'PlayerAvailabilitiesVarianceFields';
  travelRadiusMiles?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoods = {
  __typename?: 'PlayerAvailabilityNeighborhoods';
  /** An object relationship */
  availability: PlayerAvailabilities;
  availabilityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  neighborhood: Neighborhoods;
  neighborhoodId: Scalars['uuid'];
};

/** order by aggregate values of table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayerAvailabilityNeighborhoodsMaxOrderBy>;
  min?: InputMaybe<PlayerAvailabilityNeighborhoodsMinOrderBy>;
};

/** input type for inserting array relation for remote table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsArrRelInsertInput = {
  data: Array<PlayerAvailabilityNeighborhoodsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlayerAvailabilityNeighborhoodsOnConflict>;
};

/** Boolean expression to filter rows from the table "player_availability_neighborhoods". All fields are combined with a logical 'AND'. */
export type PlayerAvailabilityNeighborhoodsBoolExp = {
  _and?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsBoolExp>>;
  _not?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
  _or?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsBoolExp>>;
  availability?: InputMaybe<PlayerAvailabilitiesBoolExp>;
  availabilityId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  neighborhood?: InputMaybe<NeighborhoodsBoolExp>;
  neighborhoodId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "player_availability_neighborhoods" */
export enum PlayerAvailabilityNeighborhoodsConstraint {
  /** unique or primary key constraint on columns "neighborhood_id", "availability_id" */
  PlayerAvailabilityNeighborhoodsPkey = 'player_availability_neighborhoods_pkey'
}

/** input type for inserting data into table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsInsertInput = {
  availability?: InputMaybe<PlayerAvailabilitiesObjRelInsertInput>;
  availabilityId?: InputMaybe<Scalars['uuid']>;
  neighborhoodId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsMaxOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  neighborhoodId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsMinOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  neighborhoodId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsMutationResponse = {
  __typename?: 'PlayerAvailabilityNeighborhoodsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayerAvailabilityNeighborhoods>;
};

/** on_conflict condition type for table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsOnConflict = {
  constraint: PlayerAvailabilityNeighborhoodsConstraint;
  updateColumns?: Array<PlayerAvailabilityNeighborhoodsUpdateColumn>;
  where?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
};

/** Ordering options when selecting data from "player_availability_neighborhoods". */
export type PlayerAvailabilityNeighborhoodsOrderBy = {
  availability?: InputMaybe<PlayerAvailabilitiesOrderBy>;
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  neighborhood?: InputMaybe<NeighborhoodsOrderBy>;
  neighborhoodId?: InputMaybe<OrderBy>;
};

/** select columns of table "player_availability_neighborhoods" */
export enum PlayerAvailabilityNeighborhoodsSelectColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  NeighborhoodId = 'neighborhoodId'
}

/** Streaming cursor of the table "player_availability_neighborhoods" */
export type PlayerAvailabilityNeighborhoodsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayerAvailabilityNeighborhoodsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayerAvailabilityNeighborhoodsStreamCursorValueInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  neighborhoodId?: InputMaybe<Scalars['uuid']>;
};

/** placeholder for update columns of table "player_availability_neighborhoods" (current role has no relevant permissions) */
export enum PlayerAvailabilityNeighborhoodsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScales = {
  __typename?: 'PlayerAvailabilityRatingScales';
  /** An object relationship */
  availability: PlayerAvailabilities;
  availabilityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  maximumRating?: Maybe<Scalars['numeric']>;
  minimumRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  padelRatingScale?: Maybe<PadelRatingScales>;
  padelRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  pickleballRatingScale?: Maybe<PickleballRatingScales>;
  pickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  tennisRatingScale?: Maybe<TennisRatingScales>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesAggregateOrderBy = {
  avg?: InputMaybe<PlayerAvailabilityRatingScalesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayerAvailabilityRatingScalesMaxOrderBy>;
  min?: InputMaybe<PlayerAvailabilityRatingScalesMinOrderBy>;
  stddev?: InputMaybe<PlayerAvailabilityRatingScalesStddevOrderBy>;
  stddevPop?: InputMaybe<PlayerAvailabilityRatingScalesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PlayerAvailabilityRatingScalesStddevSampOrderBy>;
  sum?: InputMaybe<PlayerAvailabilityRatingScalesSumOrderBy>;
  varPop?: InputMaybe<PlayerAvailabilityRatingScalesVarPopOrderBy>;
  varSamp?: InputMaybe<PlayerAvailabilityRatingScalesVarSampOrderBy>;
  variance?: InputMaybe<PlayerAvailabilityRatingScalesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesArrRelInsertInput = {
  data: Array<PlayerAvailabilityRatingScalesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlayerAvailabilityRatingScalesOnConflict>;
};

/** order by avg() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesAvgOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "player_availability_rating_scales". All fields are combined with a logical 'AND'. */
export type PlayerAvailabilityRatingScalesBoolExp = {
  _and?: InputMaybe<Array<PlayerAvailabilityRatingScalesBoolExp>>;
  _not?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
  _or?: InputMaybe<Array<PlayerAvailabilityRatingScalesBoolExp>>;
  availability?: InputMaybe<PlayerAvailabilitiesBoolExp>;
  availabilityId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  maximumRating?: InputMaybe<NumericComparisonExp>;
  minimumRating?: InputMaybe<NumericComparisonExp>;
  padelRatingScale?: InputMaybe<PadelRatingScalesBoolExp>;
  padelRatingScaleId?: InputMaybe<UuidComparisonExp>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesBoolExp>;
  pickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "player_availability_rating_scales" */
export enum PlayerAvailabilityRatingScalesConstraint {
  /** unique or primary key constraint on columns "availability_id", "padel_rating_scale_id" */
  PlayerAvailabilityRatingScAvailabilityIdPadelRatingKey = 'player_availability_rating_sc_availability_id_padel_rating__key',
  /** unique or primary key constraint on columns "pickleball_rating_scale_id", "availability_id" */
  PlayerAvailabilityRatingScAvailabilityIdPickleballRaKey = 'player_availability_rating_sc_availability_id_pickleball_ra_key',
  /** unique or primary key constraint on columns "tennis_rating_scale_id", "availability_id" */
  PlayerAvailabilityRatingScAvailabilityIdTennisRatingKey = 'player_availability_rating_sc_availability_id_tennis_rating_key',
  /** unique or primary key constraint on columns "id" */
  PlayerAvailabilityRatingScalesPkey = 'player_availability_rating_scales_pkey'
}

/** input type for incrementing numeric columns in table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesIncInput = {
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesInsertInput = {
  availability?: InputMaybe<PlayerAvailabilitiesObjRelInsertInput>;
  availabilityId?: InputMaybe<Scalars['uuid']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesMaxOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesMinOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesMutationResponse = {
  __typename?: 'PlayerAvailabilityRatingScalesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayerAvailabilityRatingScales>;
};

/** on_conflict condition type for table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesOnConflict = {
  constraint: PlayerAvailabilityRatingScalesConstraint;
  updateColumns?: Array<PlayerAvailabilityRatingScalesUpdateColumn>;
  where?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
};

/** Ordering options when selecting data from "player_availability_rating_scales". */
export type PlayerAvailabilityRatingScalesOrderBy = {
  availability?: InputMaybe<PlayerAvailabilitiesOrderBy>;
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
  padelRatingScale?: InputMaybe<PadelRatingScalesOrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  pickleballRatingScale?: InputMaybe<PickleballRatingScalesOrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: player_availability_rating_scales */
export type PlayerAvailabilityRatingScalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "player_availability_rating_scales" */
export enum PlayerAvailabilityRatingScalesSelectColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
};

/** order by stddev() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesStddevOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesStddevPopOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesStddevSampOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayerAvailabilityRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayerAvailabilityRatingScalesStreamCursorValueInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximumRating?: InputMaybe<Scalars['numeric']>;
  minimumRating?: InputMaybe<Scalars['numeric']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesSumOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** update columns of table "player_availability_rating_scales" */
export enum PlayerAvailabilityRatingScalesUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  MaximumRating = 'maximumRating',
  /** column name */
  MinimumRating = 'minimumRating',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId'
}

export type PlayerAvailabilityRatingScalesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PlayerAvailabilityRatingScalesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlayerAvailabilityRatingScalesSetInput>;
  /** filter the rows which have to be updated */
  where: PlayerAvailabilityRatingScalesBoolExp;
};

/** order by varPop() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesVarPopOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesVarSampOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "player_availability_rating_scales" */
export type PlayerAvailabilityRatingScalesVarianceOrderBy = {
  maximumRating?: InputMaybe<OrderBy>;
  minimumRating?: InputMaybe<OrderBy>;
};

/** columns and relationships of "player_availability_slots" */
export type PlayerAvailabilitySlots = {
  __typename?: 'PlayerAvailabilitySlots';
  /** An object relationship */
  availability: PlayerAvailabilities;
  availabilityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  dayOfWeek: Scalars['String'];
  endTime: Scalars['time'];
  id: Scalars['uuid'];
  startTime: Scalars['time'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "player_availability_slots" */
export type PlayerAvailabilitySlotsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayerAvailabilitySlotsMaxOrderBy>;
  min?: InputMaybe<PlayerAvailabilitySlotsMinOrderBy>;
};

/** input type for inserting array relation for remote table "player_availability_slots" */
export type PlayerAvailabilitySlotsArrRelInsertInput = {
  data: Array<PlayerAvailabilitySlotsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlayerAvailabilitySlotsOnConflict>;
};

/** Boolean expression to filter rows from the table "player_availability_slots". All fields are combined with a logical 'AND'. */
export type PlayerAvailabilitySlotsBoolExp = {
  _and?: InputMaybe<Array<PlayerAvailabilitySlotsBoolExp>>;
  _not?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
  _or?: InputMaybe<Array<PlayerAvailabilitySlotsBoolExp>>;
  availability?: InputMaybe<PlayerAvailabilitiesBoolExp>;
  availabilityId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dayOfWeek?: InputMaybe<StringComparisonExp>;
  endTime?: InputMaybe<TimeComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  startTime?: InputMaybe<TimeComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "player_availability_slots" */
export enum PlayerAvailabilitySlotsConstraint {
  /** unique or primary key constraint on columns "id" */
  PlayerAvailabilitySlotsPkey = 'player_availability_slots_pkey'
}

/** input type for inserting data into table "player_availability_slots" */
export type PlayerAvailabilitySlotsInsertInput = {
  availability?: InputMaybe<PlayerAvailabilitiesObjRelInsertInput>;
  availabilityId?: InputMaybe<Scalars['uuid']>;
  dayOfWeek?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['time']>;
  startTime?: InputMaybe<Scalars['time']>;
};

/** order by max() on columns of table "player_availability_slots" */
export type PlayerAvailabilitySlotsMaxOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "player_availability_slots" */
export type PlayerAvailabilitySlotsMinOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "player_availability_slots" */
export type PlayerAvailabilitySlotsMutationResponse = {
  __typename?: 'PlayerAvailabilitySlotsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayerAvailabilitySlots>;
};

/** on_conflict condition type for table "player_availability_slots" */
export type PlayerAvailabilitySlotsOnConflict = {
  constraint: PlayerAvailabilitySlotsConstraint;
  updateColumns?: Array<PlayerAvailabilitySlotsUpdateColumn>;
  where?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
};

/** Ordering options when selecting data from "player_availability_slots". */
export type PlayerAvailabilitySlotsOrderBy = {
  availability?: InputMaybe<PlayerAvailabilitiesOrderBy>;
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  endTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "player_availability_slots" */
export enum PlayerAvailabilitySlotsSelectColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DayOfWeek = 'dayOfWeek',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  Id = 'id',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "player_availability_slots" */
export type PlayerAvailabilitySlotsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayerAvailabilitySlotsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayerAvailabilitySlotsStreamCursorValueInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['uuid']>;
  startTime?: InputMaybe<Scalars['time']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** placeholder for update columns of table "player_availability_slots" (current role has no relevant permissions) */
export enum PlayerAvailabilitySlotsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "player_availability_venues" */
export type PlayerAvailabilityVenues = {
  __typename?: 'PlayerAvailabilityVenues';
  /** An object relationship */
  availability: PlayerAvailabilities;
  availabilityId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  userCustomCourt?: Maybe<UserCustomCourts>;
  userCustomCourtId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  venue?: Maybe<Venues>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by aggregate values of table "player_availability_venues" */
export type PlayerAvailabilityVenuesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PlayerAvailabilityVenuesMaxOrderBy>;
  min?: InputMaybe<PlayerAvailabilityVenuesMinOrderBy>;
};

/** input type for inserting array relation for remote table "player_availability_venues" */
export type PlayerAvailabilityVenuesArrRelInsertInput = {
  data: Array<PlayerAvailabilityVenuesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PlayerAvailabilityVenuesOnConflict>;
};

/** Boolean expression to filter rows from the table "player_availability_venues". All fields are combined with a logical 'AND'. */
export type PlayerAvailabilityVenuesBoolExp = {
  _and?: InputMaybe<Array<PlayerAvailabilityVenuesBoolExp>>;
  _not?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
  _or?: InputMaybe<Array<PlayerAvailabilityVenuesBoolExp>>;
  availability?: InputMaybe<PlayerAvailabilitiesBoolExp>;
  availabilityId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  userCustomCourt?: InputMaybe<UserCustomCourtsBoolExp>;
  userCustomCourtId?: InputMaybe<UuidComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "player_availability_venues" */
export enum PlayerAvailabilityVenuesConstraint {
  /** unique or primary key constraint on columns "availability_id", "user_custom_court_id" */
  PlayerAvailabilityVenuesAvailabilityIdCustomCourtKey = 'player_availability_venues_availability_id_custom_court_key',
  /** unique or primary key constraint on columns "venue_id", "availability_id" */
  PlayerAvailabilityVenuesAvailabilityIdVenueIdKey = 'player_availability_venues_availability_id_venue_id_key',
  /** unique or primary key constraint on columns "id" */
  PlayerAvailabilityVenuesPkey = 'player_availability_venues_pkey'
}

/** input type for inserting data into table "player_availability_venues" */
export type PlayerAvailabilityVenuesInsertInput = {
  availability?: InputMaybe<PlayerAvailabilitiesObjRelInsertInput>;
  availabilityId?: InputMaybe<Scalars['uuid']>;
  userCustomCourt?: InputMaybe<UserCustomCourtsObjRelInsertInput>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "player_availability_venues" */
export type PlayerAvailabilityVenuesMaxOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "player_availability_venues" */
export type PlayerAvailabilityVenuesMinOrderBy = {
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "player_availability_venues" */
export type PlayerAvailabilityVenuesMutationResponse = {
  __typename?: 'PlayerAvailabilityVenuesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlayerAvailabilityVenues>;
};

/** on_conflict condition type for table "player_availability_venues" */
export type PlayerAvailabilityVenuesOnConflict = {
  constraint: PlayerAvailabilityVenuesConstraint;
  updateColumns?: Array<PlayerAvailabilityVenuesUpdateColumn>;
  where?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
};

/** Ordering options when selecting data from "player_availability_venues". */
export type PlayerAvailabilityVenuesOrderBy = {
  availability?: InputMaybe<PlayerAvailabilitiesOrderBy>;
  availabilityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userCustomCourt?: InputMaybe<UserCustomCourtsOrderBy>;
  userCustomCourtId?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** select columns of table "player_availability_venues" */
export enum PlayerAvailabilityVenuesSelectColumn {
  /** column name */
  AvailabilityId = 'availabilityId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UserCustomCourtId = 'userCustomCourtId',
  /** column name */
  VenueId = 'venueId'
}

/** Streaming cursor of the table "player_availability_venues" */
export type PlayerAvailabilityVenuesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayerAvailabilityVenuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayerAvailabilityVenuesStreamCursorValueInput = {
  availabilityId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** placeholder for update columns of table "player_availability_venues" (current role has no relevant permissions) */
export enum PlayerAvailabilityVenuesUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "player_finder_goals" */
export type PlayerFinderGoals = {
  __typename?: 'PlayerFinderGoals';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "player_finder_goals". All fields are combined with a logical 'AND'. */
export type PlayerFinderGoalsBoolExp = {
  _and?: InputMaybe<Array<PlayerFinderGoalsBoolExp>>;
  _not?: InputMaybe<PlayerFinderGoalsBoolExp>;
  _or?: InputMaybe<Array<PlayerFinderGoalsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PlayerFinderGoalsEnum {
  CasualPlay = 'CASUAL_PLAY',
  CompetitivePlay = 'COMPETITIVE_PLAY',
  MeetNewPeople = 'MEET_NEW_PEOPLE'
}

/** Boolean expression to compare columns of type "PlayerFinderGoalsEnum". All fields are combined with logical 'AND'. */
export type PlayerFinderGoalsEnumComparisonExp = {
  _eq?: InputMaybe<PlayerFinderGoalsEnum>;
  _in?: InputMaybe<Array<PlayerFinderGoalsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlayerFinderGoalsEnum>;
  _nin?: InputMaybe<Array<PlayerFinderGoalsEnum>>;
};

/** Ordering options when selecting data from "player_finder_goals". */
export type PlayerFinderGoalsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "player_finder_goals" */
export enum PlayerFinderGoalsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "player_finder_goals" */
export type PlayerFinderGoalsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayerFinderGoalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayerFinderGoalsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "player_finder_time_of_day" */
export type PlayerFinderTimeOfDay = {
  __typename?: 'PlayerFinderTimeOfDay';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "player_finder_time_of_day". All fields are combined with a logical 'AND'. */
export type PlayerFinderTimeOfDayBoolExp = {
  _and?: InputMaybe<Array<PlayerFinderTimeOfDayBoolExp>>;
  _not?: InputMaybe<PlayerFinderTimeOfDayBoolExp>;
  _or?: InputMaybe<Array<PlayerFinderTimeOfDayBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PlayerFinderTimeOfDayEnum {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Flexible = 'FLEXIBLE',
  Morning = 'MORNING'
}

/** Boolean expression to compare columns of type "PlayerFinderTimeOfDayEnum". All fields are combined with logical 'AND'. */
export type PlayerFinderTimeOfDayEnumComparisonExp = {
  _eq?: InputMaybe<PlayerFinderTimeOfDayEnum>;
  _in?: InputMaybe<Array<PlayerFinderTimeOfDayEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PlayerFinderTimeOfDayEnum>;
  _nin?: InputMaybe<Array<PlayerFinderTimeOfDayEnum>>;
};

/** Ordering options when selecting data from "player_finder_time_of_day". */
export type PlayerFinderTimeOfDayOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "player_finder_time_of_day" */
export enum PlayerFinderTimeOfDaySelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "player_finder_time_of_day" */
export type PlayerFinderTimeOfDayStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PlayerFinderTimeOfDayStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PlayerFinderTimeOfDayStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "recurrence_kinds" */
export type RecurrenceKinds = {
  __typename?: 'RecurrenceKinds';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "recurrence_kinds". All fields are combined with a logical 'AND'. */
export type RecurrenceKindsBoolExp = {
  _and?: InputMaybe<Array<RecurrenceKindsBoolExp>>;
  _not?: InputMaybe<RecurrenceKindsBoolExp>;
  _or?: InputMaybe<Array<RecurrenceKindsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum RecurrenceKindsEnum {
  Custom = 'CUSTOM',
  OneTime = 'ONE_TIME',
  Weekly = 'WEEKLY'
}

/** Boolean expression to compare columns of type "RecurrenceKindsEnum". All fields are combined with logical 'AND'. */
export type RecurrenceKindsEnumComparisonExp = {
  _eq?: InputMaybe<RecurrenceKindsEnum>;
  _in?: InputMaybe<Array<RecurrenceKindsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<RecurrenceKindsEnum>;
  _nin?: InputMaybe<Array<RecurrenceKindsEnum>>;
};

/** Ordering options when selecting data from "recurrence_kinds". */
export type RecurrenceKindsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "recurrence_kinds" */
export enum RecurrenceKindsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "recurrence_kinds" */
export type RecurrenceKindsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecurrenceKindsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecurrenceKindsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "report_reasons" */
export type ReportReasons = {
  __typename?: 'ReportReasons';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "report_reasons". All fields are combined with a logical 'AND'. */
export type ReportReasonsBoolExp = {
  _and?: InputMaybe<Array<ReportReasonsBoolExp>>;
  _not?: InputMaybe<ReportReasonsBoolExp>;
  _or?: InputMaybe<Array<ReportReasonsBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum ReportReasonsEnum {
  Harassment = 'HARASSMENT',
  /** inappropriate or offensive content */
  Inappropriate = 'INAPPROPRIATE',
  /** see description */
  Other = 'OTHER',
  /** safety concern */
  Safety = 'SAFETY',
  Spam = 'SPAM'
}

/** Boolean expression to compare columns of type "ReportReasonsEnum". All fields are combined with logical 'AND'. */
export type ReportReasonsEnumComparisonExp = {
  _eq?: InputMaybe<ReportReasonsEnum>;
  _in?: InputMaybe<Array<ReportReasonsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ReportReasonsEnum>;
  _nin?: InputMaybe<Array<ReportReasonsEnum>>;
};

/** Ordering options when selecting data from "report_reasons". */
export type ReportReasonsOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "report_reasons" */
export enum ReportReasonsSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "report_reasons" */
export type ReportReasonsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ReportReasonsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportReasonsStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "report_statuses" */
export type ReportStatuses = {
  __typename?: 'ReportStatuses';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "report_statuses". All fields are combined with a logical 'AND'. */
export type ReportStatusesBoolExp = {
  _and?: InputMaybe<Array<ReportStatusesBoolExp>>;
  _not?: InputMaybe<ReportStatusesBoolExp>;
  _or?: InputMaybe<Array<ReportStatusesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum ReportStatusesEnum {
  /** action taken */
  Actioned = 'ACTIONED',
  /** no action needed */
  Dismissed = 'DISMISSED',
  /** awaiting review */
  Pending = 'PENDING',
  Reviewing = 'REVIEWING'
}

/** Boolean expression to compare columns of type "ReportStatusesEnum". All fields are combined with logical 'AND'. */
export type ReportStatusesEnumComparisonExp = {
  _eq?: InputMaybe<ReportStatusesEnum>;
  _in?: InputMaybe<Array<ReportStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ReportStatusesEnum>;
  _nin?: InputMaybe<Array<ReportStatusesEnum>>;
};

/** Ordering options when selecting data from "report_statuses". */
export type ReportStatusesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "report_statuses" */
export enum ReportStatusesSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "report_statuses" */
export type ReportStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ReportStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportStatusesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "reviews" */
export type Reviews = {
  __typename?: 'Reviews';
  /** An object relationship */
  coach?: Maybe<UserProfiles>;
  coachUserId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamp']>;
  externalDomain?: Maybe<Scalars['String']>;
  externalFullName?: Maybe<Scalars['String']>;
  externalImageFileName?: Maybe<Scalars['String']>;
  externalImageUrl?: Maybe<Scalars['String']>;
  externalSource?: Maybe<CoachExternalReviewSourcesEnum>;
  externalUrl?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isPlayerSkillLevelAccurate?: Maybe<Scalars['Boolean']>;
  lessonId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  player?: Maybe<UserProfiles>;
  playerUserId?: Maybe<Scalars['uuid']>;
  rating: Scalars['Int'];
  review?: Maybe<Scalars['String']>;
  /** An object relationship */
  reviewer?: Maybe<UserProfiles>;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  type?: Maybe<CoachReviewTypesEnum>;
  updatedAt: Scalars['timestamptz'];
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "reviews" */
export type ReviewsAggregate = {
  __typename?: 'ReviewsAggregate';
  aggregate?: Maybe<ReviewsAggregateFields>;
  nodes: Array<Reviews>;
};

export type ReviewsAggregateBoolExp = {
  bool_and?: InputMaybe<ReviewsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<ReviewsAggregateBoolExpBool_Or>;
  count?: InputMaybe<ReviewsAggregateBoolExpCount>;
};

/** aggregate fields of "reviews" */
export type ReviewsAggregateFields = {
  __typename?: 'ReviewsAggregateFields';
  avg?: Maybe<ReviewsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ReviewsMaxFields>;
  min?: Maybe<ReviewsMinFields>;
  stddev?: Maybe<ReviewsStddevFields>;
  stddevPop?: Maybe<ReviewsStddevPopFields>;
  stddevSamp?: Maybe<ReviewsStddevSampFields>;
  sum?: Maybe<ReviewsSumFields>;
  varPop?: Maybe<ReviewsVarPopFields>;
  varSamp?: Maybe<ReviewsVarSampFields>;
  variance?: Maybe<ReviewsVarianceFields>;
};


/** aggregate fields of "reviews" */
export type ReviewsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reviews" */
export type ReviewsAggregateOrderBy = {
  avg?: InputMaybe<ReviewsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ReviewsMaxOrderBy>;
  min?: InputMaybe<ReviewsMinOrderBy>;
  stddev?: InputMaybe<ReviewsStddevOrderBy>;
  stddevPop?: InputMaybe<ReviewsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ReviewsStddevSampOrderBy>;
  sum?: InputMaybe<ReviewsSumOrderBy>;
  varPop?: InputMaybe<ReviewsVarPopOrderBy>;
  varSamp?: InputMaybe<ReviewsVarSampOrderBy>;
  variance?: InputMaybe<ReviewsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type ReviewsAvgFields = {
  __typename?: 'ReviewsAvgFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "reviews" */
export type ReviewsAvgOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "reviews". All fields are combined with a logical 'AND'. */
export type ReviewsBoolExp = {
  _and?: InputMaybe<Array<ReviewsBoolExp>>;
  _not?: InputMaybe<ReviewsBoolExp>;
  _or?: InputMaybe<Array<ReviewsBoolExp>>;
  coach?: InputMaybe<UserProfilesBoolExp>;
  coachUserId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestampComparisonExp>;
  externalDomain?: InputMaybe<StringComparisonExp>;
  externalFullName?: InputMaybe<StringComparisonExp>;
  externalImageFileName?: InputMaybe<StringComparisonExp>;
  externalImageUrl?: InputMaybe<StringComparisonExp>;
  externalSource?: InputMaybe<CoachExternalReviewSourcesEnumComparisonExp>;
  externalUrl?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPlayerSkillLevelAccurate?: InputMaybe<BooleanComparisonExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  player?: InputMaybe<UserProfilesBoolExp>;
  playerUserId?: InputMaybe<UuidComparisonExp>;
  rating?: InputMaybe<IntComparisonExp>;
  review?: InputMaybe<StringComparisonExp>;
  reviewer?: InputMaybe<UserProfilesBoolExp>;
  reviewerUserId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<CoachReviewTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "reviews" */
export enum ReviewsConstraint {
  /** unique or primary key constraint on columns "id" */
  ReviewsPkey = 'reviews_pkey'
}

/** input type for inserting data into table "reviews" */
export type ReviewsInsertInput = {
  coachUserId?: InputMaybe<Scalars['uuid']>;
  externalDomain?: InputMaybe<Scalars['String']>;
  externalImageFileName?: InputMaybe<Scalars['String']>;
  externalImageUrl?: InputMaybe<Scalars['String']>;
  externalSource?: InputMaybe<CoachExternalReviewSourcesEnum>;
  externalUrl?: InputMaybe<Scalars['String']>;
  isPlayerSkillLevelAccurate?: InputMaybe<Scalars['Boolean']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['Int']>;
  review?: InputMaybe<Scalars['String']>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<CoachReviewTypesEnum>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ReviewsMaxFields = {
  __typename?: 'ReviewsMaxFields';
  coachUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamp']>;
  externalDomain?: Maybe<Scalars['String']>;
  externalFullName?: Maybe<Scalars['String']>;
  externalImageFileName?: Maybe<Scalars['String']>;
  externalImageUrl?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  playerUserId?: Maybe<Scalars['uuid']>;
  rating?: Maybe<Scalars['Int']>;
  review?: Maybe<Scalars['String']>;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "reviews" */
export type ReviewsMaxOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalDomain?: InputMaybe<OrderBy>;
  externalFullName?: InputMaybe<OrderBy>;
  externalImageFileName?: InputMaybe<OrderBy>;
  externalImageUrl?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  review?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ReviewsMinFields = {
  __typename?: 'ReviewsMinFields';
  coachUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamp']>;
  externalDomain?: Maybe<Scalars['String']>;
  externalFullName?: Maybe<Scalars['String']>;
  externalImageFileName?: Maybe<Scalars['String']>;
  externalImageUrl?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  playerUserId?: Maybe<Scalars['uuid']>;
  rating?: Maybe<Scalars['Int']>;
  review?: Maybe<Scalars['String']>;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "reviews" */
export type ReviewsMinOrderBy = {
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalDomain?: InputMaybe<OrderBy>;
  externalFullName?: InputMaybe<OrderBy>;
  externalImageFileName?: InputMaybe<OrderBy>;
  externalImageUrl?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  review?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "reviews" */
export type ReviewsMutationResponse = {
  __typename?: 'ReviewsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Reviews>;
};

/** on_conflict condition type for table "reviews" */
export type ReviewsOnConflict = {
  constraint: ReviewsConstraint;
  updateColumns?: Array<ReviewsUpdateColumn>;
  where?: InputMaybe<ReviewsBoolExp>;
};

/** Ordering options when selecting data from "reviews". */
export type ReviewsOrderBy = {
  coach?: InputMaybe<UserProfilesOrderBy>;
  coachUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalDomain?: InputMaybe<OrderBy>;
  externalFullName?: InputMaybe<OrderBy>;
  externalImageFileName?: InputMaybe<OrderBy>;
  externalImageUrl?: InputMaybe<OrderBy>;
  externalSource?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isPlayerSkillLevelAccurate?: InputMaybe<OrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  player?: InputMaybe<UserProfilesOrderBy>;
  playerUserId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  review?: InputMaybe<OrderBy>;
  reviewer?: InputMaybe<UserProfilesOrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** select columns of table "reviews" */
export enum ReviewsSelectColumn {
  /** column name */
  CoachUserId = 'coachUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalDomain = 'externalDomain',
  /** column name */
  ExternalFullName = 'externalFullName',
  /** column name */
  ExternalImageFileName = 'externalImageFileName',
  /** column name */
  ExternalImageUrl = 'externalImageUrl',
  /** column name */
  ExternalSource = 'externalSource',
  /** column name */
  ExternalUrl = 'externalUrl',
  /** column name */
  Id = 'id',
  /** column name */
  IsPlayerSkillLevelAccurate = 'isPlayerSkillLevelAccurate',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  PlayerUserId = 'playerUserId',
  /** column name */
  Rating = 'rating',
  /** column name */
  Review = 'review',
  /** column name */
  ReviewerUserId = 'reviewerUserId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

/** select "reviewsAggregateBoolExpBool_andArgumentsColumns" columns of table "reviews" */
export enum ReviewsSelectColumnReviewsAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  IsPlayerSkillLevelAccurate = 'isPlayerSkillLevelAccurate'
}

/** select "reviewsAggregateBoolExpBool_orArgumentsColumns" columns of table "reviews" */
export enum ReviewsSelectColumnReviewsAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  IsPlayerSkillLevelAccurate = 'isPlayerSkillLevelAccurate'
}

/** aggregate stddev on columns */
export type ReviewsStddevFields = {
  __typename?: 'ReviewsStddevFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "reviews" */
export type ReviewsStddevOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ReviewsStddevPopFields = {
  __typename?: 'ReviewsStddevPopFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "reviews" */
export type ReviewsStddevPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ReviewsStddevSampFields = {
  __typename?: 'ReviewsStddevSampFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "reviews" */
export type ReviewsStddevSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "reviews" */
export type ReviewsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ReviewsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReviewsStreamCursorValueInput = {
  coachUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamp']>;
  externalDomain?: InputMaybe<Scalars['String']>;
  externalFullName?: InputMaybe<Scalars['String']>;
  externalImageFileName?: InputMaybe<Scalars['String']>;
  externalImageUrl?: InputMaybe<Scalars['String']>;
  externalSource?: InputMaybe<CoachExternalReviewSourcesEnum>;
  externalUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPlayerSkillLevelAccurate?: InputMaybe<Scalars['Boolean']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  playerUserId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['Int']>;
  review?: InputMaybe<Scalars['String']>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<CoachReviewTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ReviewsSumFields = {
  __typename?: 'ReviewsSumFields';
  rating?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "reviews" */
export type ReviewsSumOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "reviews" (current role has no relevant permissions) */
export enum ReviewsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** aggregate varPop on columns */
export type ReviewsVarPopFields = {
  __typename?: 'ReviewsVarPopFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "reviews" */
export type ReviewsVarPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ReviewsVarSampFields = {
  __typename?: 'ReviewsVarSampFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "reviews" */
export type ReviewsVarSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ReviewsVarianceFields = {
  __typename?: 'ReviewsVarianceFields';
  rating?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "reviews" */
export type ReviewsVarianceOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** columns and relationships of "sales" */
export type Sales = {
  __typename?: 'Sales';
  amountPaid: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  originalPrice?: Maybe<Scalars['numeric']>;
  paymentProcessor: PaymentProcessorsEnum;
  peerSubscriptionId?: Maybe<Scalars['uuid']>;
  peerSubscriptionPlanPriceId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  platformSubscription?: Maybe<PlatformSubscriptions>;
  platformSubscriptionId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  platformSubscriptionPlanPrice?: Maybe<PlatformSubscriptionPlanPrices>;
  platformSubscriptionPlanPriceId?: Maybe<Scalars['uuid']>;
  status: PaymentStatusesEnum;
  stripeCustomerId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  stripePriceId?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  stripeSessionId: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "sales" */
export type SalesAggregateOrderBy = {
  avg?: InputMaybe<SalesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SalesMaxOrderBy>;
  min?: InputMaybe<SalesMinOrderBy>;
  stddev?: InputMaybe<SalesStddevOrderBy>;
  stddevPop?: InputMaybe<SalesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<SalesStddevSampOrderBy>;
  sum?: InputMaybe<SalesSumOrderBy>;
  varPop?: InputMaybe<SalesVarPopOrderBy>;
  varSamp?: InputMaybe<SalesVarSampOrderBy>;
  variance?: InputMaybe<SalesVarianceOrderBy>;
};

/** order by avg() on columns of table "sales" */
export type SalesAvgOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sales". All fields are combined with a logical 'AND'. */
export type SalesBoolExp = {
  _and?: InputMaybe<Array<SalesBoolExp>>;
  _not?: InputMaybe<SalesBoolExp>;
  _or?: InputMaybe<Array<SalesBoolExp>>;
  amountPaid?: InputMaybe<NumericComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  originalPrice?: InputMaybe<NumericComparisonExp>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  peerSubscriptionId?: InputMaybe<UuidComparisonExp>;
  peerSubscriptionPlanPriceId?: InputMaybe<UuidComparisonExp>;
  platformSubscription?: InputMaybe<PlatformSubscriptionsBoolExp>;
  platformSubscriptionId?: InputMaybe<UuidComparisonExp>;
  platformSubscriptionPlanPrice?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
  platformSubscriptionPlanPriceId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<PaymentStatusesEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripePaymentStatus?: InputMaybe<StringComparisonExp>;
  stripePriceId?: InputMaybe<StringComparisonExp>;
  stripeProductId?: InputMaybe<StringComparisonExp>;
  stripeSessionId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "sales" */
export type SalesMaxOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
  peerSubscriptionId?: InputMaybe<OrderBy>;
  peerSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  platformSubscriptionId?: InputMaybe<OrderBy>;
  platformSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  stripeProductId?: InputMaybe<OrderBy>;
  stripeSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "sales" */
export type SalesMinOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
  peerSubscriptionId?: InputMaybe<OrderBy>;
  peerSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  platformSubscriptionId?: InputMaybe<OrderBy>;
  platformSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  stripeProductId?: InputMaybe<OrderBy>;
  stripeSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "sales". */
export type SalesOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
  paymentProcessor?: InputMaybe<OrderBy>;
  peerSubscriptionId?: InputMaybe<OrderBy>;
  peerSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  platformSubscription?: InputMaybe<PlatformSubscriptionsOrderBy>;
  platformSubscriptionId?: InputMaybe<OrderBy>;
  platformSubscriptionPlanPrice?: InputMaybe<PlatformSubscriptionPlanPricesOrderBy>;
  platformSubscriptionPlanPriceId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  stripePriceId?: InputMaybe<OrderBy>;
  stripeProductId?: InputMaybe<OrderBy>;
  stripeSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "sales" */
export enum SalesSelectColumn {
  /** column name */
  AmountPaid = 'amountPaid',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalPrice = 'originalPrice',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  PeerSubscriptionId = 'peerSubscriptionId',
  /** column name */
  PeerSubscriptionPlanPriceId = 'peerSubscriptionPlanPriceId',
  /** column name */
  PlatformSubscriptionId = 'platformSubscriptionId',
  /** column name */
  PlatformSubscriptionPlanPriceId = 'platformSubscriptionPlanPriceId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  StripePriceId = 'stripePriceId',
  /** column name */
  StripeProductId = 'stripeProductId',
  /** column name */
  StripeSessionId = 'stripeSessionId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** order by stddev() on columns of table "sales" */
export type SalesStddevOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "sales" */
export type SalesStddevPopOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "sales" */
export type SalesStddevSampOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sales" */
export type SalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SalesStreamCursorValueInput = {
  amountPaid?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalPrice?: InputMaybe<Scalars['numeric']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  peerSubscriptionId?: InputMaybe<Scalars['uuid']>;
  peerSubscriptionPlanPriceId?: InputMaybe<Scalars['uuid']>;
  platformSubscriptionId?: InputMaybe<Scalars['uuid']>;
  platformSubscriptionPlanPriceId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<PaymentStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  stripeSessionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "sales" */
export type SalesSumOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "sales" */
export type SalesVarPopOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "sales" */
export type SalesVarSampOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "sales" */
export type SalesVarianceOrderBy = {
  amountPaid?: InputMaybe<OrderBy>;
  originalPrice?: InputMaybe<OrderBy>;
};

/** columns and relationships of "scoring_format" */
export type ScoringFormat = {
  __typename?: 'ScoringFormat';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "scoring_format". All fields are combined with a logical 'AND'. */
export type ScoringFormatBoolExp = {
  _and?: InputMaybe<Array<ScoringFormatBoolExp>>;
  _not?: InputMaybe<ScoringFormatBoolExp>;
  _or?: InputMaybe<Array<ScoringFormatBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum ScoringFormatEnum {
  Rally = 'RALLY',
  Traditional = 'TRADITIONAL'
}

/** Boolean expression to compare columns of type "ScoringFormatEnum". All fields are combined with logical 'AND'. */
export type ScoringFormatEnumComparisonExp = {
  _eq?: InputMaybe<ScoringFormatEnum>;
  _in?: InputMaybe<Array<ScoringFormatEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ScoringFormatEnum>;
  _nin?: InputMaybe<Array<ScoringFormatEnum>>;
};

/** Ordering options when selecting data from "scoring_format". */
export type ScoringFormatOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "scoring_format" */
export enum ScoringFormatSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "scoring_format" */
export type ScoringFormatStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ScoringFormatStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ScoringFormatStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "signup_requests" */
export type SignupRequests = {
  __typename?: 'SignupRequests';
  id: Scalars['uuid'];
};

/** Boolean expression to filter rows from the table "signup_requests". All fields are combined with a logical 'AND'. */
export type SignupRequestsBoolExp = {
  _and?: InputMaybe<Array<SignupRequestsBoolExp>>;
  _not?: InputMaybe<SignupRequestsBoolExp>;
  _or?: InputMaybe<Array<SignupRequestsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "signup_requests" */
export enum SignupRequestsConstraint {
  /** unique or primary key constraint on columns "id" */
  SignupRequestsPkey = 'signup_requests_pkey'
}

/** input type for inserting data into table "signup_requests" */
export type SignupRequestsInsertInput = {
  accountType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<EventOrganizerAccountTypesEnum>;
  fullDetails?: InputMaybe<Scalars['jsonb']>;
  fullName?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "signup_requests" */
export type SignupRequestsMutationResponse = {
  __typename?: 'SignupRequestsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SignupRequests>;
};

/** on_conflict condition type for table "signup_requests" */
export type SignupRequestsOnConflict = {
  constraint: SignupRequestsConstraint;
  updateColumns?: Array<SignupRequestsUpdateColumn>;
  where?: InputMaybe<SignupRequestsBoolExp>;
};

/** Ordering options when selecting data from "signup_requests". */
export type SignupRequestsOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** select columns of table "signup_requests" */
export enum SignupRequestsSelectColumn {
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "signup_requests" */
export type SignupRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SignupRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SignupRequestsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** placeholder for update columns of table "signup_requests" (current role has no relevant permissions) */
export enum SignupRequestsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "skill_level_values" */
export type SkillLevelValues = {
  __typename?: 'SkillLevelValues';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "skill_level_values". All fields are combined with a logical 'AND'. */
export type SkillLevelValuesBoolExp = {
  _and?: InputMaybe<Array<SkillLevelValuesBoolExp>>;
  _not?: InputMaybe<SkillLevelValuesBoolExp>;
  _or?: InputMaybe<Array<SkillLevelValuesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum SkillLevelValuesEnum {
  Advanced = 'ADVANCED',
  Beginner = 'BEGINNER',
  BrandNew = 'BRAND_NEW',
  DoNotPlay = 'DO_NOT_PLAY',
  Intermediate = 'INTERMEDIATE',
  NoResponse = 'NO_RESPONSE',
  Pro = 'PRO'
}

/** Boolean expression to compare columns of type "SkillLevelValuesEnum". All fields are combined with logical 'AND'. */
export type SkillLevelValuesEnumComparisonExp = {
  _eq?: InputMaybe<SkillLevelValuesEnum>;
  _in?: InputMaybe<Array<SkillLevelValuesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<SkillLevelValuesEnum>;
  _nin?: InputMaybe<Array<SkillLevelValuesEnum>>;
};

/** Ordering options when selecting data from "skill_level_values". */
export type SkillLevelValuesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "skill_level_values" */
export enum SkillLevelValuesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "skill_level_values" */
export type SkillLevelValuesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SkillLevelValuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SkillLevelValuesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "skill_levels" */
export type SkillLevels = {
  __typename?: 'SkillLevels';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  displayName: Scalars['String'];
  id: SkillLevelValuesEnum;
  isDisplayed: Scalars['Boolean'];
  rank: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "skill_levels". All fields are combined with a logical 'AND'. */
export type SkillLevelsBoolExp = {
  _and?: InputMaybe<Array<SkillLevelsBoolExp>>;
  _not?: InputMaybe<SkillLevelsBoolExp>;
  _or?: InputMaybe<Array<SkillLevelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<SkillLevelValuesEnumComparisonExp>;
  isDisplayed?: InputMaybe<BooleanComparisonExp>;
  rank?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** Ordering options when selecting data from "skill_levels". */
export type SkillLevelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isDisplayed?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "skill_levels" */
export enum SkillLevelsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  IsDisplayed = 'isDisplayed',
  /** column name */
  Rank = 'rank',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "skill_levels" */
export type SkillLevelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SkillLevelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SkillLevelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<SkillLevelValuesEnum>;
  isDisplayed?: InputMaybe<Scalars['Boolean']>;
  rank?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type SmallintComparisonExp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

/** columns and relationships of "sports" */
export type Sports = {
  __typename?: 'Sports';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "sports". All fields are combined with a logical 'AND'. */
export type SportsBoolExp = {
  _and?: InputMaybe<Array<SportsBoolExp>>;
  _not?: InputMaybe<SportsBoolExp>;
  _or?: InputMaybe<Array<SportsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum SportsEnum {
  Padel = 'PADEL',
  Pickleball = 'PICKLEBALL',
  PlatformTennis = 'PLATFORM_TENNIS',
  Tennis = 'TENNIS'
}

/** Boolean expression to compare columns of type "SportsEnum". All fields are combined with logical 'AND'. */
export type SportsEnumComparisonExp = {
  _eq?: InputMaybe<SportsEnum>;
  _in?: InputMaybe<Array<SportsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<SportsEnum>;
  _nin?: InputMaybe<Array<SportsEnum>>;
};

/** Ordering options when selecting data from "sports". */
export type SportsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "sports" */
export enum SportsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "sports" */
export type SportsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SportsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SportsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "subscription_statuses" */
export type SubscriptionStatuses = {
  __typename?: 'SubscriptionStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "subscription_statuses". All fields are combined with a logical 'AND'. */
export type SubscriptionStatusesBoolExp = {
  _and?: InputMaybe<Array<SubscriptionStatusesBoolExp>>;
  _not?: InputMaybe<SubscriptionStatusesBoolExp>;
  _or?: InputMaybe<Array<SubscriptionStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum SubscriptionStatusesEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "SubscriptionStatusesEnum". All fields are combined with logical 'AND'. */
export type SubscriptionStatusesEnumComparisonExp = {
  _eq?: InputMaybe<SubscriptionStatusesEnum>;
  _in?: InputMaybe<Array<SubscriptionStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<SubscriptionStatusesEnum>;
  _nin?: InputMaybe<Array<SubscriptionStatusesEnum>>;
};

/** Ordering options when selecting data from "subscription_statuses". */
export type SubscriptionStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "subscription_statuses" */
export enum SubscriptionStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "subscription_statuses" */
export type SubscriptionStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SubscriptionStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SubscriptionStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "team_types" */
export type TeamTypes = {
  __typename?: 'TeamTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "team_types". All fields are combined with a logical 'AND'. */
export type TeamTypesBoolExp = {
  _and?: InputMaybe<Array<TeamTypesBoolExp>>;
  _not?: InputMaybe<TeamTypesBoolExp>;
  _or?: InputMaybe<Array<TeamTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum TeamTypesEnum {
  Doubles = 'DOUBLES',
  Singles = 'SINGLES'
}

/** Boolean expression to compare columns of type "TeamTypesEnum". All fields are combined with logical 'AND'. */
export type TeamTypesEnumComparisonExp = {
  _eq?: InputMaybe<TeamTypesEnum>;
  _in?: InputMaybe<Array<TeamTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<TeamTypesEnum>;
  _nin?: InputMaybe<Array<TeamTypesEnum>>;
};

/** Ordering options when selecting data from "team_types". */
export type TeamTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "team_types" */
export enum TeamTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "team_types" */
export type TeamTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TeamTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TeamTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "tennis_rating_scales" */
export type TennisRatingScales = {
  __typename?: 'TennisRatingScales';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  maximum: Scalars['numeric'];
  minimum: Scalars['numeric'];
  name: Scalars['String'];
  order: Scalars['Int'];
  shortName: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "tennis_rating_scales". All fields are combined with a logical 'AND'. */
export type TennisRatingScalesBoolExp = {
  _and?: InputMaybe<Array<TennisRatingScalesBoolExp>>;
  _not?: InputMaybe<TennisRatingScalesBoolExp>;
  _or?: InputMaybe<Array<TennisRatingScalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  maximum?: InputMaybe<NumericComparisonExp>;
  minimum?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  order?: InputMaybe<IntComparisonExp>;
  shortName?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** Ordering options when selecting data from "tennis_rating_scales". */
export type TennisRatingScalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maximum?: InputMaybe<OrderBy>;
  minimum?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrderBy>;
  shortName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "tennis_rating_scales" */
export enum TennisRatingScalesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Maximum = 'maximum',
  /** column name */
  Minimum = 'minimum',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "tennis_rating_scales" */
export type TennisRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TennisRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TennisRatingScalesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maximum?: InputMaybe<Scalars['numeric']>;
  minimum?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shortName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type TimeComparisonExp = {
  _eq?: InputMaybe<Scalars['time']>;
  _gt?: InputMaybe<Scalars['time']>;
  _gte?: InputMaybe<Scalars['time']>;
  _in?: InputMaybe<Array<Scalars['time']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['time']>;
  _lte?: InputMaybe<Scalars['time']>;
  _neq?: InputMaybe<Scalars['time']>;
  _nin?: InputMaybe<Array<Scalars['time']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type TimestampComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "twilio_group_texts" */
export type TwilioGroupTexts = {
  __typename?: 'TwilioGroupTexts';
  id: Scalars['uuid'];
  participantsKey: Scalars['String'];
  twilioConversationSid: Scalars['String'];
};

/** Boolean expression to filter rows from the table "twilio_group_texts". All fields are combined with a logical 'AND'. */
export type TwilioGroupTextsBoolExp = {
  _and?: InputMaybe<Array<TwilioGroupTextsBoolExp>>;
  _not?: InputMaybe<TwilioGroupTextsBoolExp>;
  _or?: InputMaybe<Array<TwilioGroupTextsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  participantsKey?: InputMaybe<StringComparisonExp>;
  twilioConversationSid?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "twilio_group_texts" */
export enum TwilioGroupTextsConstraint {
  /** unique or primary key constraint on columns "participants_key" */
  TwilioGroupTextsParticipantsIdKey = 'twilio_group_texts_participants_id_key',
  /** unique or primary key constraint on columns "id" */
  TwilioGroupTextsPkey = 'twilio_group_texts_pkey'
}

/** input type for inserting data into table "twilio_group_texts" */
export type TwilioGroupTextsInsertInput = {
  participantsKey?: InputMaybe<Scalars['String']>;
  twilioConversationSid?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "twilio_group_texts" */
export type TwilioGroupTextsMutationResponse = {
  __typename?: 'TwilioGroupTextsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TwilioGroupTexts>;
};

/** on_conflict condition type for table "twilio_group_texts" */
export type TwilioGroupTextsOnConflict = {
  constraint: TwilioGroupTextsConstraint;
  updateColumns?: Array<TwilioGroupTextsUpdateColumn>;
  where?: InputMaybe<TwilioGroupTextsBoolExp>;
};

/** Ordering options when selecting data from "twilio_group_texts". */
export type TwilioGroupTextsOrderBy = {
  id?: InputMaybe<OrderBy>;
  participantsKey?: InputMaybe<OrderBy>;
  twilioConversationSid?: InputMaybe<OrderBy>;
};

/** select columns of table "twilio_group_texts" */
export enum TwilioGroupTextsSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ParticipantsKey = 'participantsKey',
  /** column name */
  TwilioConversationSid = 'twilioConversationSid'
}

/** Streaming cursor of the table "twilio_group_texts" */
export type TwilioGroupTextsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TwilioGroupTextsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TwilioGroupTextsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
  participantsKey?: InputMaybe<Scalars['String']>;
  twilioConversationSid?: InputMaybe<Scalars['String']>;
};

/** placeholder for update columns of table "twilio_group_texts" (current role has no relevant permissions) */
export enum TwilioGroupTextsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "upload_review_requests" */
export type UploadReviewRequests = {
  __typename?: 'UploadReviewRequests';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  userId: Scalars['uuid'];
};

/** Boolean expression to filter rows from the table "upload_review_requests". All fields are combined with a logical 'AND'. */
export type UploadReviewRequestsBoolExp = {
  _and?: InputMaybe<Array<UploadReviewRequestsBoolExp>>;
  _not?: InputMaybe<UploadReviewRequestsBoolExp>;
  _or?: InputMaybe<Array<UploadReviewRequestsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "upload_review_requests" */
export enum UploadReviewRequestsConstraint {
  /** unique or primary key constraint on columns "id" */
  UploadReviewRequestsPkey = 'upload_review_requests_pkey'
}

/** input type for inserting data into table "upload_review_requests" */
export type UploadReviewRequestsInsertInput = {
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** response of any mutation on the table "upload_review_requests" */
export type UploadReviewRequestsMutationResponse = {
  __typename?: 'UploadReviewRequestsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UploadReviewRequests>;
};

/** on_conflict condition type for table "upload_review_requests" */
export type UploadReviewRequestsOnConflict = {
  constraint: UploadReviewRequestsConstraint;
  updateColumns?: Array<UploadReviewRequestsUpdateColumn>;
  where?: InputMaybe<UploadReviewRequestsBoolExp>;
};

/** Ordering options when selecting data from "upload_review_requests". */
export type UploadReviewRequestsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "upload_review_requests" */
export enum UploadReviewRequestsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "upload_review_requests" */
export type UploadReviewRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UploadReviewRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UploadReviewRequestsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** placeholder for update columns of table "upload_review_requests" (current role has no relevant permissions) */
export enum UploadReviewRequestsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "user_blocks" */
export type UserBlocks = {
  __typename?: 'UserBlocks';
  /** An object relationship */
  blocked: Users;
  /** An object relationship */
  blockedProfile?: Maybe<UserProfiles>;
  blockedUserId: Scalars['uuid'];
  /** An object relationship */
  blocker: Users;
  blockerUserId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "user_blocks". All fields are combined with a logical 'AND'. */
export type UserBlocksBoolExp = {
  _and?: InputMaybe<Array<UserBlocksBoolExp>>;
  _not?: InputMaybe<UserBlocksBoolExp>;
  _or?: InputMaybe<Array<UserBlocksBoolExp>>;
  blocked?: InputMaybe<UsersBoolExp>;
  blockedProfile?: InputMaybe<UserProfilesBoolExp>;
  blockedUserId?: InputMaybe<UuidComparisonExp>;
  blocker?: InputMaybe<UsersBoolExp>;
  blockerUserId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** Ordering options when selecting data from "user_blocks". */
export type UserBlocksOrderBy = {
  blocked?: InputMaybe<UsersOrderBy>;
  blockedProfile?: InputMaybe<UserProfilesOrderBy>;
  blockedUserId?: InputMaybe<OrderBy>;
  blocker?: InputMaybe<UsersOrderBy>;
  blockerUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "user_blocks" */
export enum UserBlocksSelectColumn {
  /** column name */
  BlockedUserId = 'blockedUserId',
  /** column name */
  BlockerUserId = 'blockerUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "user_blocks" */
export type UserBlocksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserBlocksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserBlocksStreamCursorValueInput = {
  blockedUserId?: InputMaybe<Scalars['uuid']>;
  blockerUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "user_coach_services" */
export type UserCoachServices = {
  __typename?: 'UserCoachServices';
  coverImageFileName: Scalars['String'];
  coverImagePath: Scalars['String'];
  coverImageProvider: Scalars['String'];
  coverImageProviderId: Scalars['String'];
  coverImageProviderUrl: Scalars['String'];
  coverImageUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  id: Scalars['uuid'];
  priceUnitAmount: Scalars['Int'];
  title: Scalars['String'];
  type?: Maybe<LessonTypesEnum>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
};

/** order by aggregate values of table "user_coach_services" */
export type UserCoachServicesAggregateOrderBy = {
  avg?: InputMaybe<UserCoachServicesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserCoachServicesMaxOrderBy>;
  min?: InputMaybe<UserCoachServicesMinOrderBy>;
  stddev?: InputMaybe<UserCoachServicesStddevOrderBy>;
  stddevPop?: InputMaybe<UserCoachServicesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserCoachServicesStddevSampOrderBy>;
  sum?: InputMaybe<UserCoachServicesSumOrderBy>;
  varPop?: InputMaybe<UserCoachServicesVarPopOrderBy>;
  varSamp?: InputMaybe<UserCoachServicesVarSampOrderBy>;
  variance?: InputMaybe<UserCoachServicesVarianceOrderBy>;
};

/** order by avg() on columns of table "user_coach_services" */
export type UserCoachServicesAvgOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_coach_services". All fields are combined with a logical 'AND'. */
export type UserCoachServicesBoolExp = {
  _and?: InputMaybe<Array<UserCoachServicesBoolExp>>;
  _not?: InputMaybe<UserCoachServicesBoolExp>;
  _or?: InputMaybe<Array<UserCoachServicesBoolExp>>;
  coverImageFileName?: InputMaybe<StringComparisonExp>;
  coverImagePath?: InputMaybe<StringComparisonExp>;
  coverImageProvider?: InputMaybe<StringComparisonExp>;
  coverImageProviderId?: InputMaybe<StringComparisonExp>;
  coverImageProviderUrl?: InputMaybe<StringComparisonExp>;
  coverImageUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<LessonTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** unique or primary key constraints on table "user_coach_services" */
export enum UserCoachServicesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserCoachServicesPkey = 'user_coach_services_pkey'
}

/** input type for incrementing numeric columns in table "user_coach_services" */
export type UserCoachServicesIncInput = {
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_coach_services" */
export type UserCoachServicesInsertInput = {
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_coach_services" */
export type UserCoachServicesMaxOrderBy = {
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_coach_services" */
export type UserCoachServicesMinOrderBy = {
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_coach_services" */
export type UserCoachServicesMutationResponse = {
  __typename?: 'UserCoachServicesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserCoachServices>;
};

/** on_conflict condition type for table "user_coach_services" */
export type UserCoachServicesOnConflict = {
  constraint: UserCoachServicesConstraint;
  updateColumns?: Array<UserCoachServicesUpdateColumn>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};

/** Ordering options when selecting data from "user_coach_services". */
export type UserCoachServicesOrderBy = {
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** primary key columns input for table: user_coach_services */
export type UserCoachServicesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_coach_services" */
export enum UserCoachServicesSelectColumn {
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderId = 'coverImageProviderId',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_coach_services" */
export type UserCoachServicesSetInput = {
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
};

/** order by stddev() on columns of table "user_coach_services" */
export type UserCoachServicesStddevOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "user_coach_services" */
export type UserCoachServicesStddevPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "user_coach_services" */
export type UserCoachServicesStddevSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_coach_services" */
export type UserCoachServicesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserCoachServicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserCoachServicesStreamCursorValueInput = {
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LessonTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "user_coach_services" */
export type UserCoachServicesSumOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** update columns of table "user_coach_services" */
export enum UserCoachServicesUpdateColumn {
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderId = 'coverImageProviderId',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type'
}

export type UserCoachServicesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserCoachServicesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserCoachServicesSetInput>;
  /** filter the rows which have to be updated */
  where: UserCoachServicesBoolExp;
};

/** order by varPop() on columns of table "user_coach_services" */
export type UserCoachServicesVarPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "user_coach_services" */
export type UserCoachServicesVarSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "user_coach_services" */
export type UserCoachServicesVarianceOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_communication_preferences" */
export type UserCommunicationPreferences = {
  __typename?: 'UserCommunicationPreferences';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** This will match the users UUID since it's 1-1 relationship */
  id: Scalars['uuid'];
  lessonBookedEmail: CommunicationPreferenceStatusesEnum;
  lessonBookedPush: CommunicationPreferenceStatusesEnum;
  lessonCanceledEmail: CommunicationPreferenceStatusesEnum;
  lessonCanceledPushed: CommunicationPreferenceStatusesEnum;
  lessonReminderEmail: CommunicationPreferenceStatusesEnum;
  lessonReminderPush: CommunicationPreferenceStatusesEnum;
  marketingEmail: CommunicationPreferenceStatusesEnum;
  marketingPush: CommunicationPreferenceStatusesEnum;
  newFollowerEmail: CommunicationPreferenceStatusesEnum;
  newFollowerPush: CommunicationPreferenceStatusesEnum;
  newLessonPublishedEmail: CommunicationPreferenceStatusesEnum;
  newLessonPublishedPush: CommunicationPreferenceStatusesEnum;
  participantLeftLessonEmail: CommunicationPreferenceStatusesEnum;
  participantLeftLessonPush: CommunicationPreferenceStatusesEnum;
  payoutEmail: CommunicationPreferenceStatusesEnum;
  payoutPush: CommunicationPreferenceStatusesEnum;
  playSessionCanceledEmail: CommunicationPreferenceStatusesEnum;
  playSessionCanceledPush: CommunicationPreferenceStatusesEnum;
  playSessionParticipantJoinedEmail: CommunicationPreferenceStatusesEnum;
  playSessionParticipantJoinedPush: CommunicationPreferenceStatusesEnum;
  playSessionParticipantLeftEmail: CommunicationPreferenceStatusesEnum;
  playSessionParticipantLeftPush: CommunicationPreferenceStatusesEnum;
  playSessionReminderEmail: CommunicationPreferenceStatusesEnum;
  playSessionReminderPush: CommunicationPreferenceStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
};

/** Boolean expression to filter rows from the table "user_communication_preferences". All fields are combined with a logical 'AND'. */
export type UserCommunicationPreferencesBoolExp = {
  _and?: InputMaybe<Array<UserCommunicationPreferencesBoolExp>>;
  _not?: InputMaybe<UserCommunicationPreferencesBoolExp>;
  _or?: InputMaybe<Array<UserCommunicationPreferencesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lessonBookedEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  lessonBookedPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  lessonCanceledEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  lessonCanceledPushed?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  lessonReminderEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  lessonReminderPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  marketingEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  marketingPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  newFollowerEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  newFollowerPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  newLessonPublishedEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  newLessonPublishedPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  participantLeftLessonEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  participantLeftLessonPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  payoutEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  payoutPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionCanceledEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionCanceledPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionParticipantJoinedEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionParticipantJoinedPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionParticipantLeftEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionParticipantLeftPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionReminderEmail?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  playSessionReminderPush?: InputMaybe<CommunicationPreferenceStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** response of any mutation on the table "user_communication_preferences" */
export type UserCommunicationPreferencesMutationResponse = {
  __typename?: 'UserCommunicationPreferencesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserCommunicationPreferences>;
};

/** Ordering options when selecting data from "user_communication_preferences". */
export type UserCommunicationPreferencesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lessonBookedEmail?: InputMaybe<OrderBy>;
  lessonBookedPush?: InputMaybe<OrderBy>;
  lessonCanceledEmail?: InputMaybe<OrderBy>;
  lessonCanceledPushed?: InputMaybe<OrderBy>;
  lessonReminderEmail?: InputMaybe<OrderBy>;
  lessonReminderPush?: InputMaybe<OrderBy>;
  marketingEmail?: InputMaybe<OrderBy>;
  marketingPush?: InputMaybe<OrderBy>;
  newFollowerEmail?: InputMaybe<OrderBy>;
  newFollowerPush?: InputMaybe<OrderBy>;
  newLessonPublishedEmail?: InputMaybe<OrderBy>;
  newLessonPublishedPush?: InputMaybe<OrderBy>;
  participantLeftLessonEmail?: InputMaybe<OrderBy>;
  participantLeftLessonPush?: InputMaybe<OrderBy>;
  payoutEmail?: InputMaybe<OrderBy>;
  payoutPush?: InputMaybe<OrderBy>;
  playSessionCanceledEmail?: InputMaybe<OrderBy>;
  playSessionCanceledPush?: InputMaybe<OrderBy>;
  playSessionParticipantJoinedEmail?: InputMaybe<OrderBy>;
  playSessionParticipantJoinedPush?: InputMaybe<OrderBy>;
  playSessionParticipantLeftEmail?: InputMaybe<OrderBy>;
  playSessionParticipantLeftPush?: InputMaybe<OrderBy>;
  playSessionReminderEmail?: InputMaybe<OrderBy>;
  playSessionReminderPush?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: user_communication_preferences */
export type UserCommunicationPreferencesPkColumnsInput = {
  /** This will match the users UUID since it's 1-1 relationship */
  id: Scalars['uuid'];
};

/** select columns of table "user_communication_preferences" */
export enum UserCommunicationPreferencesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LessonBookedEmail = 'lessonBookedEmail',
  /** column name */
  LessonBookedPush = 'lessonBookedPush',
  /** column name */
  LessonCanceledEmail = 'lessonCanceledEmail',
  /** column name */
  LessonCanceledPushed = 'lessonCanceledPushed',
  /** column name */
  LessonReminderEmail = 'lessonReminderEmail',
  /** column name */
  LessonReminderPush = 'lessonReminderPush',
  /** column name */
  MarketingEmail = 'marketingEmail',
  /** column name */
  MarketingPush = 'marketingPush',
  /** column name */
  NewFollowerEmail = 'newFollowerEmail',
  /** column name */
  NewFollowerPush = 'newFollowerPush',
  /** column name */
  NewLessonPublishedEmail = 'newLessonPublishedEmail',
  /** column name */
  NewLessonPublishedPush = 'newLessonPublishedPush',
  /** column name */
  ParticipantLeftLessonEmail = 'participantLeftLessonEmail',
  /** column name */
  ParticipantLeftLessonPush = 'participantLeftLessonPush',
  /** column name */
  PayoutEmail = 'payoutEmail',
  /** column name */
  PayoutPush = 'payoutPush',
  /** column name */
  PlaySessionCanceledEmail = 'playSessionCanceledEmail',
  /** column name */
  PlaySessionCanceledPush = 'playSessionCanceledPush',
  /** column name */
  PlaySessionParticipantJoinedEmail = 'playSessionParticipantJoinedEmail',
  /** column name */
  PlaySessionParticipantJoinedPush = 'playSessionParticipantJoinedPush',
  /** column name */
  PlaySessionParticipantLeftEmail = 'playSessionParticipantLeftEmail',
  /** column name */
  PlaySessionParticipantLeftPush = 'playSessionParticipantLeftPush',
  /** column name */
  PlaySessionReminderEmail = 'playSessionReminderEmail',
  /** column name */
  PlaySessionReminderPush = 'playSessionReminderPush',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "user_communication_preferences" */
export type UserCommunicationPreferencesSetInput = {
  lessonBookedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonBookedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonCanceledEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonCanceledPushed?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonReminderEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonReminderPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  marketingEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  marketingPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newFollowerEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newFollowerPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newLessonPublishedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newLessonPublishedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  participantLeftLessonEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  participantLeftLessonPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  payoutEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  payoutPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionCanceledEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionCanceledPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantJoinedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantJoinedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantLeftEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantLeftPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionReminderEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionReminderPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
};

/** Streaming cursor of the table "user_communication_preferences" */
export type UserCommunicationPreferencesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserCommunicationPreferencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserCommunicationPreferencesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** This will match the users UUID since it's 1-1 relationship */
  id?: InputMaybe<Scalars['uuid']>;
  lessonBookedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonBookedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonCanceledEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonCanceledPushed?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonReminderEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  lessonReminderPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  marketingEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  marketingPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newFollowerEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newFollowerPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newLessonPublishedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  newLessonPublishedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  participantLeftLessonEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  participantLeftLessonPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  payoutEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  payoutPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionCanceledEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionCanceledPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantJoinedEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantJoinedPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantLeftEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionParticipantLeftPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionReminderEmail?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  playSessionReminderPush?: InputMaybe<CommunicationPreferenceStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

export type UserCommunicationPreferencesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserCommunicationPreferencesSetInput>;
  /** filter the rows which have to be updated */
  where: UserCommunicationPreferencesBoolExp;
};

/** columns and relationships of "user_connection_request_statuses" */
export type UserConnectionRequestStatuses = {
  __typename?: 'UserConnectionRequestStatuses';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "user_connection_request_statuses". All fields are combined with a logical 'AND'. */
export type UserConnectionRequestStatusesBoolExp = {
  _and?: InputMaybe<Array<UserConnectionRequestStatusesBoolExp>>;
  _not?: InputMaybe<UserConnectionRequestStatusesBoolExp>;
  _or?: InputMaybe<Array<UserConnectionRequestStatusesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum UserConnectionRequestStatusesEnum {
  Accepted = 'ACCEPTED',
  /** withdrawn by the requester */
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  /** awaiting the recipient */
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "UserConnectionRequestStatusesEnum". All fields are combined with logical 'AND'. */
export type UserConnectionRequestStatusesEnumComparisonExp = {
  _eq?: InputMaybe<UserConnectionRequestStatusesEnum>;
  _in?: InputMaybe<Array<UserConnectionRequestStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<UserConnectionRequestStatusesEnum>;
  _nin?: InputMaybe<Array<UserConnectionRequestStatusesEnum>>;
};

/** Ordering options when selecting data from "user_connection_request_statuses". */
export type UserConnectionRequestStatusesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "user_connection_request_statuses" */
export enum UserConnectionRequestStatusesSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "user_connection_request_statuses" */
export type UserConnectionRequestStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserConnectionRequestStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserConnectionRequestStatusesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "user_connection_requests" */
export type UserConnectionRequests = {
  __typename?: 'UserConnectionRequests';
  attemptNumber: Scalars['smallint'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  message?: Maybe<Scalars['String']>;
  /** An object relationship */
  recipient: Users;
  /** An object relationship */
  recipientProfile?: Maybe<UserProfiles>;
  recipientUserId: Scalars['uuid'];
  /** An object relationship */
  requester: Users;
  /** An object relationship */
  requesterProfile?: Maybe<UserProfiles>;
  requesterUserId: Scalars['uuid'];
  respondedAt?: Maybe<Scalars['timestamptz']>;
  status: UserConnectionRequestStatusesEnum;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "user_connection_requests" */
export type UserConnectionRequestsAggregate = {
  __typename?: 'UserConnectionRequestsAggregate';
  aggregate?: Maybe<UserConnectionRequestsAggregateFields>;
  nodes: Array<UserConnectionRequests>;
};

/** aggregate fields of "user_connection_requests" */
export type UserConnectionRequestsAggregateFields = {
  __typename?: 'UserConnectionRequestsAggregateFields';
  avg?: Maybe<UserConnectionRequestsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserConnectionRequestsMaxFields>;
  min?: Maybe<UserConnectionRequestsMinFields>;
  stddev?: Maybe<UserConnectionRequestsStddevFields>;
  stddevPop?: Maybe<UserConnectionRequestsStddevPopFields>;
  stddevSamp?: Maybe<UserConnectionRequestsStddevSampFields>;
  sum?: Maybe<UserConnectionRequestsSumFields>;
  varPop?: Maybe<UserConnectionRequestsVarPopFields>;
  varSamp?: Maybe<UserConnectionRequestsVarSampFields>;
  variance?: Maybe<UserConnectionRequestsVarianceFields>;
};


/** aggregate fields of "user_connection_requests" */
export type UserConnectionRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserConnectionRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UserConnectionRequestsAvgFields = {
  __typename?: 'UserConnectionRequestsAvgFields';
  attemptNumber?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_connection_requests". All fields are combined with a logical 'AND'. */
export type UserConnectionRequestsBoolExp = {
  _and?: InputMaybe<Array<UserConnectionRequestsBoolExp>>;
  _not?: InputMaybe<UserConnectionRequestsBoolExp>;
  _or?: InputMaybe<Array<UserConnectionRequestsBoolExp>>;
  attemptNumber?: InputMaybe<SmallintComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<StringComparisonExp>;
  recipient?: InputMaybe<UsersBoolExp>;
  recipientProfile?: InputMaybe<UserProfilesBoolExp>;
  recipientUserId?: InputMaybe<UuidComparisonExp>;
  requester?: InputMaybe<UsersBoolExp>;
  requesterProfile?: InputMaybe<UserProfilesBoolExp>;
  requesterUserId?: InputMaybe<UuidComparisonExp>;
  respondedAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<UserConnectionRequestStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** aggregate max on columns */
export type UserConnectionRequestsMaxFields = {
  __typename?: 'UserConnectionRequestsMaxFields';
  attemptNumber?: Maybe<Scalars['smallint']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  recipientUserId?: Maybe<Scalars['uuid']>;
  requesterUserId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type UserConnectionRequestsMinFields = {
  __typename?: 'UserConnectionRequestsMinFields';
  attemptNumber?: Maybe<Scalars['smallint']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  recipientUserId?: Maybe<Scalars['uuid']>;
  requesterUserId?: Maybe<Scalars['uuid']>;
  respondedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "user_connection_requests". */
export type UserConnectionRequestsOrderBy = {
  attemptNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  recipient?: InputMaybe<UsersOrderBy>;
  recipientProfile?: InputMaybe<UserProfilesOrderBy>;
  recipientUserId?: InputMaybe<OrderBy>;
  requester?: InputMaybe<UsersOrderBy>;
  requesterProfile?: InputMaybe<UserProfilesOrderBy>;
  requesterUserId?: InputMaybe<OrderBy>;
  respondedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "user_connection_requests" */
export enum UserConnectionRequestsSelectColumn {
  /** column name */
  AttemptNumber = 'attemptNumber',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  RecipientUserId = 'recipientUserId',
  /** column name */
  RequesterUserId = 'requesterUserId',
  /** column name */
  RespondedAt = 'respondedAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** aggregate stddev on columns */
export type UserConnectionRequestsStddevFields = {
  __typename?: 'UserConnectionRequestsStddevFields';
  attemptNumber?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type UserConnectionRequestsStddevPopFields = {
  __typename?: 'UserConnectionRequestsStddevPopFields';
  attemptNumber?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type UserConnectionRequestsStddevSampFields = {
  __typename?: 'UserConnectionRequestsStddevSampFields';
  attemptNumber?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_connection_requests" */
export type UserConnectionRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserConnectionRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserConnectionRequestsStreamCursorValueInput = {
  attemptNumber?: InputMaybe<Scalars['smallint']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  recipientUserId?: InputMaybe<Scalars['uuid']>;
  requesterUserId?: InputMaybe<Scalars['uuid']>;
  respondedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<UserConnectionRequestStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type UserConnectionRequestsSumFields = {
  __typename?: 'UserConnectionRequestsSumFields';
  attemptNumber?: Maybe<Scalars['smallint']>;
};

/** aggregate varPop on columns */
export type UserConnectionRequestsVarPopFields = {
  __typename?: 'UserConnectionRequestsVarPopFields';
  attemptNumber?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type UserConnectionRequestsVarSampFields = {
  __typename?: 'UserConnectionRequestsVarSampFields';
  attemptNumber?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserConnectionRequestsVarianceFields = {
  __typename?: 'UserConnectionRequestsVarianceFields';
  attemptNumber?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_connections" */
export type UserConnections = {
  __typename?: 'UserConnections';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  removedByUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  request?: Maybe<UserConnectionRequests>;
  requestId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userA: Users;
  userAId: Scalars['uuid'];
  /** An object relationship */
  userAProfile?: Maybe<UserProfiles>;
  /** An object relationship */
  userB: Users;
  userBId: Scalars['uuid'];
  /** An object relationship */
  userBProfile?: Maybe<UserProfiles>;
};

/** aggregated selection of "user_connections" */
export type UserConnectionsAggregate = {
  __typename?: 'UserConnectionsAggregate';
  aggregate?: Maybe<UserConnectionsAggregateFields>;
  nodes: Array<UserConnections>;
};

/** aggregate fields of "user_connections" */
export type UserConnectionsAggregateFields = {
  __typename?: 'UserConnectionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserConnectionsMaxFields>;
  min?: Maybe<UserConnectionsMinFields>;
};


/** aggregate fields of "user_connections" */
export type UserConnectionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserConnectionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_connections". All fields are combined with a logical 'AND'. */
export type UserConnectionsBoolExp = {
  _and?: InputMaybe<Array<UserConnectionsBoolExp>>;
  _not?: InputMaybe<UserConnectionsBoolExp>;
  _or?: InputMaybe<Array<UserConnectionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  removedByUserId?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<UserConnectionRequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userA?: InputMaybe<UsersBoolExp>;
  userAId?: InputMaybe<UuidComparisonExp>;
  userAProfile?: InputMaybe<UserProfilesBoolExp>;
  userB?: InputMaybe<UsersBoolExp>;
  userBId?: InputMaybe<UuidComparisonExp>;
  userBProfile?: InputMaybe<UserProfilesBoolExp>;
};

/** aggregate max on columns */
export type UserConnectionsMaxFields = {
  __typename?: 'UserConnectionsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  removedByUserId?: Maybe<Scalars['uuid']>;
  requestId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userAId?: Maybe<Scalars['uuid']>;
  userBId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserConnectionsMinFields = {
  __typename?: 'UserConnectionsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  removedByUserId?: Maybe<Scalars['uuid']>;
  requestId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userAId?: Maybe<Scalars['uuid']>;
  userBId?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "user_connections". */
export type UserConnectionsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  removedByUserId?: InputMaybe<OrderBy>;
  request?: InputMaybe<UserConnectionRequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userA?: InputMaybe<UsersOrderBy>;
  userAId?: InputMaybe<OrderBy>;
  userAProfile?: InputMaybe<UserProfilesOrderBy>;
  userB?: InputMaybe<UsersOrderBy>;
  userBId?: InputMaybe<OrderBy>;
  userBProfile?: InputMaybe<UserProfilesOrderBy>;
};

/** select columns of table "user_connections" */
export enum UserConnectionsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  RemovedByUserId = 'removedByUserId',
  /** column name */
  RequestId = 'requestId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAId = 'userAId',
  /** column name */
  UserBId = 'userBId'
}

/** Streaming cursor of the table "user_connections" */
export type UserConnectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserConnectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserConnectionsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  removedByUserId?: InputMaybe<Scalars['uuid']>;
  requestId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userAId?: InputMaybe<Scalars['uuid']>;
  userBId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "user_content_beta_subscriptions" */
export type UserContentBetaSubscriptions = {
  __typename?: 'UserContentBetaSubscriptions';
  applicationFeeTotalUnitAmount: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  customerApplicationFeeUnitAmount: Scalars['Int'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId: Scalars['String'];
  id: Scalars['uuid'];
  internalStripePaymentIntentId: Scalars['uuid'];
  orderSubtotalUnitAmount: Scalars['Int'];
  /** An object relationship */
  owner: Users;
  /** An object relationship */
  ownerProfile?: Maybe<UserProfiles>;
  ownerUserId: Scalars['uuid'];
  paidUnitAmount: Scalars['Int'];
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount: Scalars['Int'];
  stripeCustomerId: Scalars['String'];
  stripeMerchantId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  /** An object relationship */
  subscriber: Users;
  subscriberUserId: Scalars['uuid'];
  transferUnitAmount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  userCreditCardId: Scalars['uuid'];
};

/** Boolean expression to filter rows from the table "user_content_beta_subscriptions". All fields are combined with a logical 'AND'. */
export type UserContentBetaSubscriptionsBoolExp = {
  _and?: InputMaybe<Array<UserContentBetaSubscriptionsBoolExp>>;
  _not?: InputMaybe<UserContentBetaSubscriptionsBoolExp>;
  _or?: InputMaybe<Array<UserContentBetaSubscriptionsBoolExp>>;
  applicationFeeTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  externalStripePaymentIntentId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalStripePaymentIntentId?: InputMaybe<UuidComparisonExp>;
  orderSubtotalUnitAmount?: InputMaybe<IntComparisonExp>;
  owner?: InputMaybe<UsersBoolExp>;
  ownerProfile?: InputMaybe<UserProfilesBoolExp>;
  ownerUserId?: InputMaybe<UuidComparisonExp>;
  paidUnitAmount?: InputMaybe<IntComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  sellerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripeMerchantId?: InputMaybe<StringComparisonExp>;
  stripePaymentStatus?: InputMaybe<StringComparisonExp>;
  subscriber?: InputMaybe<UsersBoolExp>;
  subscriberUserId?: InputMaybe<UuidComparisonExp>;
  transferUnitAmount?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCreditCardId?: InputMaybe<UuidComparisonExp>;
};

/** Ordering options when selecting data from "user_content_beta_subscriptions". */
export type UserContentBetaSubscriptionsOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  owner?: InputMaybe<UsersOrderBy>;
  ownerProfile?: InputMaybe<UserProfilesOrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  subscriber?: InputMaybe<UsersOrderBy>;
  subscriberUserId?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
};

/** select columns of table "user_content_beta_subscriptions" */
export enum UserContentBetaSubscriptionsSelectColumn {
  /** column name */
  ApplicationFeeTotalUnitAmount = 'applicationFeeTotalUnitAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerApplicationFeeUnitAmount = 'customerApplicationFeeUnitAmount',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OwnerUserId = 'ownerUserId',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  SellerApplicationFeeUnitAmount = 'sellerApplicationFeeUnitAmount',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  SubscriberUserId = 'subscriberUserId',
  /** column name */
  TransferUnitAmount = 'transferUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId'
}

/** Streaming cursor of the table "user_content_beta_subscriptions" */
export type UserContentBetaSubscriptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserContentBetaSubscriptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserContentBetaSubscriptionsStreamCursorValueInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  ownerUserId?: InputMaybe<Scalars['uuid']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  subscriberUserId?: InputMaybe<Scalars['uuid']>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "user_content_files" */
export type UserContentFiles = {
  __typename?: 'UserContentFiles';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  fileCategory: FileCategoryEnum;
  fileFormat: FileFormatEnum;
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  host: Scalars['String'];
  id: Scalars['uuid'];
  originalFileName?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  providerId: Scalars['String'];
  providerUrl: Scalars['String'];
  tier: UserContentTiersEnum;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  /** An object relationship */
  user?: Maybe<UserProfiles>;
  /** An array relationship */
  userContentFilesSkills: Array<UserContentFilesSkills>;
  userId: Scalars['uuid'];
};


/** columns and relationships of "user_content_files" */
export type UserContentFilesUserContentFilesSkillsArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesSkillsOrderBy>>;
  where?: InputMaybe<UserContentFilesSkillsBoolExp>;
};

/** Boolean expression to filter rows from the table "user_content_files". All fields are combined with a logical 'AND'. */
export type UserContentFilesBoolExp = {
  _and?: InputMaybe<Array<UserContentFilesBoolExp>>;
  _not?: InputMaybe<UserContentFilesBoolExp>;
  _or?: InputMaybe<Array<UserContentFilesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  fileCategory?: InputMaybe<FileCategoryEnumComparisonExp>;
  fileFormat?: InputMaybe<FileFormatEnumComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileType?: InputMaybe<StringComparisonExp>;
  host?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  originalFileName?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  tier?: InputMaybe<UserContentTiersEnumComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UserProfilesBoolExp>;
  userContentFilesSkills?: InputMaybe<UserContentFilesSkillsBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_content_files" */
export enum UserContentFilesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserContentFilesPkey = 'user_content_files_pkey'
}

/** input type for inserting data into table "user_content_files" */
export type UserContentFilesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<UserContentTiersEnum>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  userContentFilesSkills?: InputMaybe<UserContentFilesSkillsArrRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_content_files" */
export type UserContentFilesMutationResponse = {
  __typename?: 'UserContentFilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserContentFiles>;
};

/** input type for inserting object relation for remote table "user_content_files" */
export type UserContentFilesObjRelInsertInput = {
  data: UserContentFilesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserContentFilesOnConflict>;
};

/** on_conflict condition type for table "user_content_files" */
export type UserContentFilesOnConflict = {
  constraint: UserContentFilesConstraint;
  updateColumns?: Array<UserContentFilesUpdateColumn>;
  where?: InputMaybe<UserContentFilesBoolExp>;
};

/** Ordering options when selecting data from "user_content_files". */
export type UserContentFilesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  fileCategory?: InputMaybe<OrderBy>;
  fileFormat?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  tier?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  user?: InputMaybe<UserProfilesOrderBy>;
  userContentFilesSkillsAggregate?: InputMaybe<UserContentFilesSkillsAggregateOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_content_files */
export type UserContentFilesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_content_files" */
export enum UserContentFilesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Tier = 'tier',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_content_files" */
export type UserContentFilesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<UserContentTiersEnum>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "user_content_files_skills" */
export type UserContentFilesSkills = {
  __typename?: 'UserContentFilesSkills';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  userContentFileId: Scalars['uuid'];
  /** An object relationship */
  userContentFiles: UserContentFiles;
  userContentSkillId: Scalars['uuid'];
  /** An object relationship */
  userContentSkills: UserContentSkills;
};

/** order by aggregate values of table "user_content_files_skills" */
export type UserContentFilesSkillsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserContentFilesSkillsMaxOrderBy>;
  min?: InputMaybe<UserContentFilesSkillsMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_content_files_skills" */
export type UserContentFilesSkillsArrRelInsertInput = {
  data: Array<UserContentFilesSkillsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserContentFilesSkillsOnConflict>;
};

/** Boolean expression to filter rows from the table "user_content_files_skills". All fields are combined with a logical 'AND'. */
export type UserContentFilesSkillsBoolExp = {
  _and?: InputMaybe<Array<UserContentFilesSkillsBoolExp>>;
  _not?: InputMaybe<UserContentFilesSkillsBoolExp>;
  _or?: InputMaybe<Array<UserContentFilesSkillsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userContentFileId?: InputMaybe<UuidComparisonExp>;
  userContentFiles?: InputMaybe<UserContentFilesBoolExp>;
  userContentSkillId?: InputMaybe<UuidComparisonExp>;
  userContentSkills?: InputMaybe<UserContentSkillsBoolExp>;
};

/** unique or primary key constraints on table "user_content_files_skills" */
export enum UserContentFilesSkillsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserContentFilesSkillsPkey = 'user_content_files_skills_pkey'
}

/** input type for inserting data into table "user_content_files_skills" */
export type UserContentFilesSkillsInsertInput = {
  userContentFileId?: InputMaybe<Scalars['uuid']>;
  userContentFiles?: InputMaybe<UserContentFilesObjRelInsertInput>;
  userContentSkillId?: InputMaybe<Scalars['uuid']>;
  userContentSkills?: InputMaybe<UserContentSkillsObjRelInsertInput>;
};

/** order by max() on columns of table "user_content_files_skills" */
export type UserContentFilesSkillsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userContentFileId?: InputMaybe<OrderBy>;
  userContentSkillId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_content_files_skills" */
export type UserContentFilesSkillsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userContentFileId?: InputMaybe<OrderBy>;
  userContentSkillId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_content_files_skills" */
export type UserContentFilesSkillsMutationResponse = {
  __typename?: 'UserContentFilesSkillsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserContentFilesSkills>;
};

/** on_conflict condition type for table "user_content_files_skills" */
export type UserContentFilesSkillsOnConflict = {
  constraint: UserContentFilesSkillsConstraint;
  updateColumns?: Array<UserContentFilesSkillsUpdateColumn>;
  where?: InputMaybe<UserContentFilesSkillsBoolExp>;
};

/** Ordering options when selecting data from "user_content_files_skills". */
export type UserContentFilesSkillsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userContentFileId?: InputMaybe<OrderBy>;
  userContentFiles?: InputMaybe<UserContentFilesOrderBy>;
  userContentSkillId?: InputMaybe<OrderBy>;
  userContentSkills?: InputMaybe<UserContentSkillsOrderBy>;
};

/** select columns of table "user_content_files_skills" */
export enum UserContentFilesSkillsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserContentFileId = 'userContentFileId',
  /** column name */
  UserContentSkillId = 'userContentSkillId'
}

/** Streaming cursor of the table "user_content_files_skills" */
export type UserContentFilesSkillsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserContentFilesSkillsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserContentFilesSkillsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userContentFileId?: InputMaybe<Scalars['uuid']>;
  userContentSkillId?: InputMaybe<Scalars['uuid']>;
};

/** placeholder for update columns of table "user_content_files_skills" (current role has no relevant permissions) */
export enum UserContentFilesSkillsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** Streaming cursor of the table "user_content_files" */
export type UserContentFilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserContentFilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserContentFilesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<UserContentTiersEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_content_files" */
export enum UserContentFilesUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Tier = 'tier',
  /** column name */
  Title = 'title',
  /** column name */
  Url = 'url'
}

export type UserContentFilesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserContentFilesSetInput>;
  /** filter the rows which have to be updated */
  where: UserContentFilesBoolExp;
};

/** columns and relationships of "user_content_skills" */
export type UserContentSkills = {
  __typename?: 'UserContentSkills';
  createdAt: Scalars['timestamptz'];
  customSkill?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  skill?: Maybe<LessonSkillsEnum>;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
};

/** Boolean expression to filter rows from the table "user_content_skills". All fields are combined with a logical 'AND'. */
export type UserContentSkillsBoolExp = {
  _and?: InputMaybe<Array<UserContentSkillsBoolExp>>;
  _not?: InputMaybe<UserContentSkillsBoolExp>;
  _or?: InputMaybe<Array<UserContentSkillsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customSkill?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  skill?: InputMaybe<LessonSkillsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_content_skills" */
export enum UserContentSkillsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserContentSkillsPkey = 'user_content_skills_pkey'
}

/** input type for inserting data into table "user_content_skills" */
export type UserContentSkillsInsertInput = {
  customSkill?: InputMaybe<Scalars['String']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_content_skills" */
export type UserContentSkillsMutationResponse = {
  __typename?: 'UserContentSkillsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserContentSkills>;
};

/** input type for inserting object relation for remote table "user_content_skills" */
export type UserContentSkillsObjRelInsertInput = {
  data: UserContentSkillsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserContentSkillsOnConflict>;
};

/** on_conflict condition type for table "user_content_skills" */
export type UserContentSkillsOnConflict = {
  constraint: UserContentSkillsConstraint;
  updateColumns?: Array<UserContentSkillsUpdateColumn>;
  where?: InputMaybe<UserContentSkillsBoolExp>;
};

/** Ordering options when selecting data from "user_content_skills". */
export type UserContentSkillsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customSkill?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skill?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_content_skills */
export type UserContentSkillsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_content_skills" */
export enum UserContentSkillsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomSkill = 'customSkill',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Skill = 'skill',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_content_skills" */
export type UserContentSkillsSetInput = {
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  skill?: InputMaybe<LessonSkillsEnum>;
};

/** Streaming cursor of the table "user_content_skills" */
export type UserContentSkillsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserContentSkillsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserContentSkillsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_content_skills" */
export enum UserContentSkillsUpdateColumn {
  /** column name */
  CustomSkill = 'customSkill',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Skill = 'skill'
}

export type UserContentSkillsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserContentSkillsSetInput>;
  /** filter the rows which have to be updated */
  where: UserContentSkillsBoolExp;
};

export enum UserContentTiersEnum {
  Free = 'FREE',
  Premium = 'PREMIUM'
}

/** Boolean expression to compare columns of type "UserContentTiersEnum". All fields are combined with logical 'AND'. */
export type UserContentTiersEnumComparisonExp = {
  _eq?: InputMaybe<UserContentTiersEnum>;
  _in?: InputMaybe<Array<UserContentTiersEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<UserContentTiersEnum>;
  _nin?: InputMaybe<Array<UserContentTiersEnum>>;
};

/** columns and relationships of "user_credit_cards" */
export type UserCreditCards = {
  __typename?: 'UserCreditCards';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingLine1?: Maybe<Scalars['String']>;
  billingLine2?: Maybe<Scalars['String']>;
  billingName?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  billingPostalCode?: Maybe<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  brand: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  expireMonth: Scalars['Int'];
  expireYear: Scalars['Int'];
  fingerprint: Scalars['String'];
  funding: Scalars['String'];
  id: Scalars['uuid'];
  last4: Scalars['String'];
  provider: Scalars['String'];
  providerCardId: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "user_credit_cards" */
export type UserCreditCardsAggregateOrderBy = {
  avg?: InputMaybe<UserCreditCardsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserCreditCardsMaxOrderBy>;
  min?: InputMaybe<UserCreditCardsMinOrderBy>;
  stddev?: InputMaybe<UserCreditCardsStddevOrderBy>;
  stddevPop?: InputMaybe<UserCreditCardsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserCreditCardsStddevSampOrderBy>;
  sum?: InputMaybe<UserCreditCardsSumOrderBy>;
  varPop?: InputMaybe<UserCreditCardsVarPopOrderBy>;
  varSamp?: InputMaybe<UserCreditCardsVarSampOrderBy>;
  variance?: InputMaybe<UserCreditCardsVarianceOrderBy>;
};

/** order by avg() on columns of table "user_credit_cards" */
export type UserCreditCardsAvgOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_credit_cards". All fields are combined with a logical 'AND'. */
export type UserCreditCardsBoolExp = {
  _and?: InputMaybe<Array<UserCreditCardsBoolExp>>;
  _not?: InputMaybe<UserCreditCardsBoolExp>;
  _or?: InputMaybe<Array<UserCreditCardsBoolExp>>;
  archivedAt?: InputMaybe<TimestamptzComparisonExp>;
  billingCity?: InputMaybe<StringComparisonExp>;
  billingCountry?: InputMaybe<StringComparisonExp>;
  billingEmail?: InputMaybe<StringComparisonExp>;
  billingLine1?: InputMaybe<StringComparisonExp>;
  billingLine2?: InputMaybe<StringComparisonExp>;
  billingName?: InputMaybe<StringComparisonExp>;
  billingPhone?: InputMaybe<StringComparisonExp>;
  billingPostalCode?: InputMaybe<StringComparisonExp>;
  billingState?: InputMaybe<StringComparisonExp>;
  brand?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  expireMonth?: InputMaybe<IntComparisonExp>;
  expireYear?: InputMaybe<IntComparisonExp>;
  fingerprint?: InputMaybe<StringComparisonExp>;
  funding?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last4?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerCardId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "user_credit_cards" */
export type UserCreditCardsMaxOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  billingCity?: InputMaybe<OrderBy>;
  billingCountry?: InputMaybe<OrderBy>;
  billingEmail?: InputMaybe<OrderBy>;
  billingLine1?: InputMaybe<OrderBy>;
  billingLine2?: InputMaybe<OrderBy>;
  billingName?: InputMaybe<OrderBy>;
  billingPhone?: InputMaybe<OrderBy>;
  billingPostalCode?: InputMaybe<OrderBy>;
  billingState?: InputMaybe<OrderBy>;
  brand?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
  fingerprint?: InputMaybe<OrderBy>;
  funding?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last4?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerCardId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_credit_cards" */
export type UserCreditCardsMinOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  billingCity?: InputMaybe<OrderBy>;
  billingCountry?: InputMaybe<OrderBy>;
  billingEmail?: InputMaybe<OrderBy>;
  billingLine1?: InputMaybe<OrderBy>;
  billingLine2?: InputMaybe<OrderBy>;
  billingName?: InputMaybe<OrderBy>;
  billingPhone?: InputMaybe<OrderBy>;
  billingPostalCode?: InputMaybe<OrderBy>;
  billingState?: InputMaybe<OrderBy>;
  brand?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
  fingerprint?: InputMaybe<OrderBy>;
  funding?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last4?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerCardId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "user_credit_cards". */
export type UserCreditCardsOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  billingCity?: InputMaybe<OrderBy>;
  billingCountry?: InputMaybe<OrderBy>;
  billingEmail?: InputMaybe<OrderBy>;
  billingLine1?: InputMaybe<OrderBy>;
  billingLine2?: InputMaybe<OrderBy>;
  billingName?: InputMaybe<OrderBy>;
  billingPhone?: InputMaybe<OrderBy>;
  billingPostalCode?: InputMaybe<OrderBy>;
  billingState?: InputMaybe<OrderBy>;
  brand?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
  fingerprint?: InputMaybe<OrderBy>;
  funding?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last4?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerCardId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "user_credit_cards" */
export enum UserCreditCardsSelectColumn {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BillingCity = 'billingCity',
  /** column name */
  BillingCountry = 'billingCountry',
  /** column name */
  BillingEmail = 'billingEmail',
  /** column name */
  BillingLine1 = 'billingLine1',
  /** column name */
  BillingLine2 = 'billingLine2',
  /** column name */
  BillingName = 'billingName',
  /** column name */
  BillingPhone = 'billingPhone',
  /** column name */
  BillingPostalCode = 'billingPostalCode',
  /** column name */
  BillingState = 'billingState',
  /** column name */
  Brand = 'brand',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpireMonth = 'expireMonth',
  /** column name */
  ExpireYear = 'expireYear',
  /** column name */
  Fingerprint = 'fingerprint',
  /** column name */
  Funding = 'funding',
  /** column name */
  Id = 'id',
  /** column name */
  Last4 = 'last4',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderCardId = 'providerCardId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** order by stddev() on columns of table "user_credit_cards" */
export type UserCreditCardsStddevOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "user_credit_cards" */
export type UserCreditCardsStddevPopOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "user_credit_cards" */
export type UserCreditCardsStddevSampOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_credit_cards" */
export type UserCreditCardsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserCreditCardsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserCreditCardsStreamCursorValueInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  billingCity?: InputMaybe<Scalars['String']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingLine1?: InputMaybe<Scalars['String']>;
  billingLine2?: InputMaybe<Scalars['String']>;
  billingName?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  billingPostalCode?: InputMaybe<Scalars['String']>;
  billingState?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  fingerprint?: InputMaybe<Scalars['String']>;
  funding?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last4?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerCardId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "user_credit_cards" */
export type UserCreditCardsSumOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "user_credit_cards" */
export type UserCreditCardsVarPopOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "user_credit_cards" */
export type UserCreditCardsVarSampOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "user_credit_cards" */
export type UserCreditCardsVarianceOrderBy = {
  expireMonth?: InputMaybe<OrderBy>;
  expireYear?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_custom_courts" */
export type UserCustomCourts = {
  __typename?: 'UserCustomCourts';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fullAddress: Scalars['String'];
  geometry?: Maybe<Scalars['geography']>;
  id: Scalars['uuid'];
  latitude?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An aggregate relationship */
  lessonsAggregate: LessonsAggregate;
  longitude?: Maybe<Scalars['numeric']>;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};


/** columns and relationships of "user_custom_courts" */
export type UserCustomCourtsLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "user_custom_courts" */
export type UserCustomCourtsLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};

/** order by aggregate values of table "user_custom_courts" */
export type UserCustomCourtsAggregateOrderBy = {
  avg?: InputMaybe<UserCustomCourtsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserCustomCourtsMaxOrderBy>;
  min?: InputMaybe<UserCustomCourtsMinOrderBy>;
  stddev?: InputMaybe<UserCustomCourtsStddevOrderBy>;
  stddevPop?: InputMaybe<UserCustomCourtsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserCustomCourtsStddevSampOrderBy>;
  sum?: InputMaybe<UserCustomCourtsSumOrderBy>;
  varPop?: InputMaybe<UserCustomCourtsVarPopOrderBy>;
  varSamp?: InputMaybe<UserCustomCourtsVarSampOrderBy>;
  variance?: InputMaybe<UserCustomCourtsVarianceOrderBy>;
};

/** order by avg() on columns of table "user_custom_courts" */
export type UserCustomCourtsAvgOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_custom_courts". All fields are combined with a logical 'AND'. */
export type UserCustomCourtsBoolExp = {
  _and?: InputMaybe<Array<UserCustomCourtsBoolExp>>;
  _not?: InputMaybe<UserCustomCourtsBoolExp>;
  _or?: InputMaybe<Array<UserCustomCourtsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  fullAddress?: InputMaybe<StringComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  lessons?: InputMaybe<LessonsBoolExp>;
  lessonsAggregate?: InputMaybe<LessonsAggregateBoolExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_custom_courts" */
export enum UserCustomCourtsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserCustomCourtsPkey = 'user_custom_courts_pkey'
}

/** input type for incrementing numeric columns in table "user_custom_courts" */
export type UserCustomCourtsIncInput = {
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "user_custom_courts" */
export type UserCustomCourtsInsertInput = {
  fullAddress?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  lessons?: InputMaybe<LessonsArrRelInsertInput>;
  longitude?: InputMaybe<Scalars['numeric']>;
  title?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_custom_courts" */
export type UserCustomCourtsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fullAddress?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_custom_courts" */
export type UserCustomCourtsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fullAddress?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_custom_courts" */
export type UserCustomCourtsMutationResponse = {
  __typename?: 'UserCustomCourtsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserCustomCourts>;
};

/** input type for inserting object relation for remote table "user_custom_courts" */
export type UserCustomCourtsObjRelInsertInput = {
  data: UserCustomCourtsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserCustomCourtsOnConflict>;
};

/** on_conflict condition type for table "user_custom_courts" */
export type UserCustomCourtsOnConflict = {
  constraint: UserCustomCourtsConstraint;
  updateColumns?: Array<UserCustomCourtsUpdateColumn>;
  where?: InputMaybe<UserCustomCourtsBoolExp>;
};

/** Ordering options when selecting data from "user_custom_courts". */
export type UserCustomCourtsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fullAddress?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  lessonsAggregate?: InputMaybe<LessonsAggregateOrderBy>;
  longitude?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_custom_courts */
export type UserCustomCourtsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_custom_courts" */
export enum UserCustomCourtsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FullAddress = 'fullAddress',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_custom_courts" */
export type UserCustomCourtsSetInput = {
  fullAddress?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  title?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "user_custom_courts" */
export type UserCustomCourtsStddevOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "user_custom_courts" */
export type UserCustomCourtsStddevPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "user_custom_courts" */
export type UserCustomCourtsStddevSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_custom_courts" */
export type UserCustomCourtsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserCustomCourtsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserCustomCourtsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "user_custom_courts" */
export type UserCustomCourtsSumOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** update columns of table "user_custom_courts" */
export enum UserCustomCourtsUpdateColumn {
  /** column name */
  FullAddress = 'fullAddress',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Title = 'title'
}

export type UserCustomCourtsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserCustomCourtsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserCustomCourtsSetInput>;
  /** filter the rows which have to be updated */
  where: UserCustomCourtsBoolExp;
};

/** order by varPop() on columns of table "user_custom_courts" */
export type UserCustomCourtsVarPopOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "user_custom_courts" */
export type UserCustomCourtsVarSampOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "user_custom_courts" */
export type UserCustomCourtsVarianceOrderBy = {
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_files" */
export type UserFiles = {
  __typename?: 'UserFiles';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileCategory: FileCategoryEnum;
  fileFormat: FileFormatEnum;
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  host: Scalars['String'];
  id: Scalars['uuid'];
  originalFileName?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  provider: Scalars['String'];
  providerId: Scalars['String'];
  providerUrl: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "user_files" */
export type UserFilesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserFilesMaxOrderBy>;
  min?: InputMaybe<UserFilesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "user_files". All fields are combined with a logical 'AND'. */
export type UserFilesBoolExp = {
  _and?: InputMaybe<Array<UserFilesBoolExp>>;
  _not?: InputMaybe<UserFilesBoolExp>;
  _or?: InputMaybe<Array<UserFilesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  fileCategory?: InputMaybe<FileCategoryEnumComparisonExp>;
  fileFormat?: InputMaybe<FileFormatEnumComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileType?: InputMaybe<StringComparisonExp>;
  host?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  originalFileName?: InputMaybe<StringComparisonExp>;
  path?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_files" */
export enum UserFilesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserFilesPkey = 'user_files_pkey'
}

/** input type for inserting data into table "user_files" */
export type UserFilesInsertInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_files" */
export type UserFilesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_files" */
export type UserFilesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_files" */
export type UserFilesMutationResponse = {
  __typename?: 'UserFilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserFiles>;
};

/** on_conflict condition type for table "user_files" */
export type UserFilesOnConflict = {
  constraint: UserFilesConstraint;
  updateColumns?: Array<UserFilesUpdateColumn>;
  where?: InputMaybe<UserFilesBoolExp>;
};

/** Ordering options when selecting data from "user_files". */
export type UserFilesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileCategory?: InputMaybe<OrderBy>;
  fileFormat?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_files */
export type UserFilesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_files" */
export enum UserFilesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Path = 'path',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_files" */
export type UserFilesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_files" */
export type UserFilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserFilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserFilesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_files" */
export enum UserFilesUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Path = 'path',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Url = 'url'
}

export type UserFilesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserFilesSetInput>;
  /** filter the rows which have to be updated */
  where: UserFilesBoolExp;
};

/** columns and relationships of "user_follows" */
export type UserFollows = {
  __typename?: 'UserFollows';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  followedProfile?: Maybe<UserProfiles>;
  followedUserId: Scalars['uuid'];
  /** An object relationship */
  followerProfile?: Maybe<UserProfiles>;
  followerUserId: Scalars['uuid'];
  id: Scalars['uuid'];
  status: FollowStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userFollowerProfile: Users;
};

/** aggregated selection of "user_follows" */
export type UserFollowsAggregate = {
  __typename?: 'UserFollowsAggregate';
  aggregate?: Maybe<UserFollowsAggregateFields>;
  nodes: Array<UserFollows>;
};

export type UserFollowsAggregateBoolExp = {
  count?: InputMaybe<UserFollowsAggregateBoolExpCount>;
};

/** aggregate fields of "user_follows" */
export type UserFollowsAggregateFields = {
  __typename?: 'UserFollowsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserFollowsMaxFields>;
  min?: Maybe<UserFollowsMinFields>;
};


/** aggregate fields of "user_follows" */
export type UserFollowsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserFollowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_follows" */
export type UserFollowsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserFollowsMaxOrderBy>;
  min?: InputMaybe<UserFollowsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "user_follows". All fields are combined with a logical 'AND'. */
export type UserFollowsBoolExp = {
  _and?: InputMaybe<Array<UserFollowsBoolExp>>;
  _not?: InputMaybe<UserFollowsBoolExp>;
  _or?: InputMaybe<Array<UserFollowsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  followedProfile?: InputMaybe<UserProfilesBoolExp>;
  followedUserId?: InputMaybe<UuidComparisonExp>;
  followerProfile?: InputMaybe<UserProfilesBoolExp>;
  followerUserId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<FollowStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userFollowerProfile?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "user_follows" */
export enum UserFollowsConstraint {
  /** unique or primary key constraint on columns "followed_user_id", "follower_user_id" */
  UserFollowsFollowedUserIdFollowerUserIdKey = 'user_follows_followed_user_id_follower_user_id_key',
  /** unique or primary key constraint on columns "id" */
  UserFollowsPkey = 'user_follows_pkey'
}

/** input type for inserting data into table "user_follows" */
export type UserFollowsInsertInput = {
  followedUserId?: InputMaybe<Scalars['uuid']>;
  followerUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<FollowStatusesEnum>;
};

/** aggregate max on columns */
export type UserFollowsMaxFields = {
  __typename?: 'UserFollowsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  followedUserId?: Maybe<Scalars['uuid']>;
  followerUserId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "user_follows" */
export type UserFollowsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  followedUserId?: InputMaybe<OrderBy>;
  followerUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserFollowsMinFields = {
  __typename?: 'UserFollowsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  followedUserId?: Maybe<Scalars['uuid']>;
  followerUserId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "user_follows" */
export type UserFollowsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  followedUserId?: InputMaybe<OrderBy>;
  followerUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_follows" */
export type UserFollowsMutationResponse = {
  __typename?: 'UserFollowsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserFollows>;
};

/** on_conflict condition type for table "user_follows" */
export type UserFollowsOnConflict = {
  constraint: UserFollowsConstraint;
  updateColumns?: Array<UserFollowsUpdateColumn>;
  where?: InputMaybe<UserFollowsBoolExp>;
};

/** Ordering options when selecting data from "user_follows". */
export type UserFollowsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  followedProfile?: InputMaybe<UserProfilesOrderBy>;
  followedUserId?: InputMaybe<OrderBy>;
  followerProfile?: InputMaybe<UserProfilesOrderBy>;
  followerUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userFollowerProfile?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: user_follows */
export type UserFollowsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_follows" */
export enum UserFollowsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FollowedUserId = 'followedUserId',
  /** column name */
  FollowerUserId = 'followerUserId',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "user_follows" */
export type UserFollowsSetInput = {
  status?: InputMaybe<FollowStatusesEnum>;
};

/** Streaming cursor of the table "user_follows" */
export type UserFollowsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserFollowsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserFollowsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  followedUserId?: InputMaybe<Scalars['uuid']>;
  followerUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<FollowStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "user_follows" */
export enum UserFollowsUpdateColumn {
  /** column name */
  Status = 'status'
}

export type UserFollowsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserFollowsSetInput>;
  /** filter the rows which have to be updated */
  where: UserFollowsBoolExp;
};

/** columns and relationships of "user_identity_verifications" */
export type UserIdentityVerifications = {
  __typename?: 'UserIdentityVerifications';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  provider: IdentityVerificationProvidersEnum;
  status: IdentityVerificationStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
  verifiedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by aggregate values of table "user_identity_verifications" */
export type UserIdentityVerificationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserIdentityVerificationsMaxOrderBy>;
  min?: InputMaybe<UserIdentityVerificationsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "user_identity_verifications". All fields are combined with a logical 'AND'. */
export type UserIdentityVerificationsBoolExp = {
  _and?: InputMaybe<Array<UserIdentityVerificationsBoolExp>>;
  _not?: InputMaybe<UserIdentityVerificationsBoolExp>;
  _or?: InputMaybe<Array<UserIdentityVerificationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  provider?: InputMaybe<IdentityVerificationProvidersEnumComparisonExp>;
  status?: InputMaybe<IdentityVerificationStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  verifiedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "user_identity_verifications" */
export type UserIdentityVerificationsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  verifiedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_identity_verifications" */
export type UserIdentityVerificationsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  verifiedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "user_identity_verifications". */
export type UserIdentityVerificationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  verifiedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "user_identity_verifications" */
export enum UserIdentityVerificationsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VerifiedAt = 'verifiedAt'
}

/** Streaming cursor of the table "user_identity_verifications" */
export type UserIdentityVerificationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserIdentityVerificationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserIdentityVerificationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<IdentityVerificationProvidersEnum>;
  status?: InputMaybe<IdentityVerificationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "user_image_log" */
export type UserImageLog = {
  __typename?: 'UserImageLog';
  createdAt: Scalars['timestamptz'];
  fileName: Scalars['String'];
  id: Scalars['uuid'];
  path: Scalars['String'];
  provider: Scalars['String'];
  providerId: Scalars['String'];
  providerUrl: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  userId?: Maybe<Scalars['uuid']>;
};

/** Boolean expression to filter rows from the table "user_image_log". All fields are combined with a logical 'AND'. */
export type UserImageLogBoolExp = {
  _and?: InputMaybe<Array<UserImageLogBoolExp>>;
  _not?: InputMaybe<UserImageLogBoolExp>;
  _or?: InputMaybe<Array<UserImageLogBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  path?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_image_log" */
export enum UserImageLogConstraint {
  /** unique or primary key constraint on columns "id" */
  UserImageLogPkey = 'user_image_log_pkey'
}

/** input type for inserting data into table "user_image_log" */
export type UserImageLogInsertInput = {
  fileName?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_image_log" */
export type UserImageLogMutationResponse = {
  __typename?: 'UserImageLogMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserImageLog>;
};

/** on_conflict condition type for table "user_image_log" */
export type UserImageLogOnConflict = {
  constraint: UserImageLogConstraint;
  updateColumns?: Array<UserImageLogUpdateColumn>;
  where?: InputMaybe<UserImageLogBoolExp>;
};

/** Ordering options when selecting data from "user_image_log". */
export type UserImageLogOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "user_image_log" */
export enum UserImageLogSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileName = 'fileName',
  /** column name */
  Id = 'id',
  /** column name */
  Path = 'path',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "user_image_log" */
export type UserImageLogStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserImageLogStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserImageLogStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** placeholder for update columns of table "user_image_log" (current role has no relevant permissions) */
export enum UserImageLogUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "user_notification_details" */
export type UserNotificationDetails = {
  __typename?: 'UserNotificationDetails';
  actionType: NotificationActionTypesEnum;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  primaryEntity: UserNotificationEntities;
  updatedAt: Scalars['timestamptz'];
  userNotificationEntityId: Scalars['uuid'];
  /** An array relationship */
  userNotifications: Array<UserNotifications>;
  /** An aggregate relationship */
  userNotificationsAggregate: UserNotificationsAggregate;
};


/** columns and relationships of "user_notification_details" */
export type UserNotificationDetailsUserNotificationsArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


/** columns and relationships of "user_notification_details" */
export type UserNotificationDetailsUserNotificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};

/** Boolean expression to filter rows from the table "user_notification_details". All fields are combined with a logical 'AND'. */
export type UserNotificationDetailsBoolExp = {
  _and?: InputMaybe<Array<UserNotificationDetailsBoolExp>>;
  _not?: InputMaybe<UserNotificationDetailsBoolExp>;
  _or?: InputMaybe<Array<UserNotificationDetailsBoolExp>>;
  actionType?: InputMaybe<NotificationActionTypesEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  primaryEntity?: InputMaybe<UserNotificationEntitiesBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userNotificationEntityId?: InputMaybe<UuidComparisonExp>;
  userNotifications?: InputMaybe<UserNotificationsBoolExp>;
  userNotificationsAggregate?: InputMaybe<UserNotificationsAggregateBoolExp>;
};

/** Ordering options when selecting data from "user_notification_details". */
export type UserNotificationDetailsOrderBy = {
  actionType?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  primaryEntity?: InputMaybe<UserNotificationEntitiesOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userNotificationEntityId?: InputMaybe<OrderBy>;
  userNotificationsAggregate?: InputMaybe<UserNotificationsAggregateOrderBy>;
};

/** select columns of table "user_notification_details" */
export enum UserNotificationDetailsSelectColumn {
  /** column name */
  ActionType = 'actionType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserNotificationEntityId = 'userNotificationEntityId'
}

/** Streaming cursor of the table "user_notification_details" */
export type UserNotificationDetailsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserNotificationDetailsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserNotificationDetailsStreamCursorValueInput = {
  actionType?: InputMaybe<NotificationActionTypesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userNotificationEntityId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "user_notification_entities" */
export type UserNotificationEntities = {
  __typename?: 'UserNotificationEntities';
  /** An object relationship */
  actingUser?: Maybe<Users>;
  actingUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  actingUserProfile?: Maybe<UserProfiles>;
  /** An object relationship */
  connectionRequest?: Maybe<UserConnectionRequests>;
  connectionRequestId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  eventGroup?: Maybe<EventGroups>;
  eventGroupId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  eventPlayerInvite?: Maybe<EventPlayerInvites>;
  eventPlayerInviteId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  groupThread?: Maybe<GroupThreads>;
  /** An object relationship */
  groupThreadComment?: Maybe<GroupThreadComments>;
  groupThreadCommentId?: Maybe<Scalars['uuid']>;
  groupThreadId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  lesson?: Maybe<Lessons>;
  lessonId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  message?: Maybe<Messages>;
  messageId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  notificationDetails?: Maybe<UserNotificationDetails>;
  /** An object relationship */
  partnerBookingOrder?: Maybe<PartnerBookingOrders>;
  partnerBookingOrderId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  playRequest?: Maybe<PlayRequests>;
  playRequestId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  playSession?: Maybe<PlaySessions>;
  /** An object relationship */
  playSessionComment?: Maybe<PlaySessionComments>;
  playSessionCommentId?: Maybe<Scalars['uuid']>;
  playSessionId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  videoAnalysis?: Maybe<VideoAnalysis>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** Boolean expression to filter rows from the table "user_notification_entities". All fields are combined with a logical 'AND'. */
export type UserNotificationEntitiesBoolExp = {
  _and?: InputMaybe<Array<UserNotificationEntitiesBoolExp>>;
  _not?: InputMaybe<UserNotificationEntitiesBoolExp>;
  _or?: InputMaybe<Array<UserNotificationEntitiesBoolExp>>;
  actingUser?: InputMaybe<UsersBoolExp>;
  actingUserId?: InputMaybe<UuidComparisonExp>;
  actingUserProfile?: InputMaybe<UserProfilesBoolExp>;
  connectionRequest?: InputMaybe<UserConnectionRequestsBoolExp>;
  connectionRequestId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  eventGroup?: InputMaybe<EventGroupsBoolExp>;
  eventGroupId?: InputMaybe<UuidComparisonExp>;
  eventPlayerInvite?: InputMaybe<EventPlayerInvitesBoolExp>;
  eventPlayerInviteId?: InputMaybe<UuidComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  groupThread?: InputMaybe<GroupThreadsBoolExp>;
  groupThreadComment?: InputMaybe<GroupThreadCommentsBoolExp>;
  groupThreadCommentId?: InputMaybe<UuidComparisonExp>;
  groupThreadId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lesson?: InputMaybe<LessonsBoolExp>;
  lessonId?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  messageId?: InputMaybe<UuidComparisonExp>;
  notificationDetails?: InputMaybe<UserNotificationDetailsBoolExp>;
  partnerBookingOrder?: InputMaybe<PartnerBookingOrdersBoolExp>;
  partnerBookingOrderId?: InputMaybe<UuidComparisonExp>;
  playRequest?: InputMaybe<PlayRequestsBoolExp>;
  playRequestId?: InputMaybe<UuidComparisonExp>;
  playSession?: InputMaybe<PlaySessionsBoolExp>;
  playSessionComment?: InputMaybe<PlaySessionCommentsBoolExp>;
  playSessionCommentId?: InputMaybe<UuidComparisonExp>;
  playSessionId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  videoAnalysis?: InputMaybe<VideoAnalysisBoolExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
};

/** Ordering options when selecting data from "user_notification_entities". */
export type UserNotificationEntitiesOrderBy = {
  actingUser?: InputMaybe<UsersOrderBy>;
  actingUserId?: InputMaybe<OrderBy>;
  actingUserProfile?: InputMaybe<UserProfilesOrderBy>;
  connectionRequest?: InputMaybe<UserConnectionRequestsOrderBy>;
  connectionRequestId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  eventGroup?: InputMaybe<EventGroupsOrderBy>;
  eventGroupId?: InputMaybe<OrderBy>;
  eventPlayerInvite?: InputMaybe<EventPlayerInvitesOrderBy>;
  eventPlayerInviteId?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  groupThread?: InputMaybe<GroupThreadsOrderBy>;
  groupThreadComment?: InputMaybe<GroupThreadCommentsOrderBy>;
  groupThreadCommentId?: InputMaybe<OrderBy>;
  groupThreadId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lesson?: InputMaybe<LessonsOrderBy>;
  lessonId?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  messageId?: InputMaybe<OrderBy>;
  notificationDetails?: InputMaybe<UserNotificationDetailsOrderBy>;
  partnerBookingOrder?: InputMaybe<PartnerBookingOrdersOrderBy>;
  partnerBookingOrderId?: InputMaybe<OrderBy>;
  playRequest?: InputMaybe<PlayRequestsOrderBy>;
  playRequestId?: InputMaybe<OrderBy>;
  playSession?: InputMaybe<PlaySessionsOrderBy>;
  playSessionComment?: InputMaybe<PlaySessionCommentsOrderBy>;
  playSessionCommentId?: InputMaybe<OrderBy>;
  playSessionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysis?: InputMaybe<VideoAnalysisOrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** select columns of table "user_notification_entities" */
export enum UserNotificationEntitiesSelectColumn {
  /** column name */
  ActingUserId = 'actingUserId',
  /** column name */
  ConnectionRequestId = 'connectionRequestId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EventGroupId = 'eventGroupId',
  /** column name */
  EventPlayerInviteId = 'eventPlayerInviteId',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  GroupThreadCommentId = 'groupThreadCommentId',
  /** column name */
  GroupThreadId = 'groupThreadId',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  MessageId = 'messageId',
  /** column name */
  PartnerBookingOrderId = 'partnerBookingOrderId',
  /** column name */
  PlayRequestId = 'playRequestId',
  /** column name */
  PlaySessionCommentId = 'playSessionCommentId',
  /** column name */
  PlaySessionId = 'playSessionId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

/** Streaming cursor of the table "user_notification_entities" */
export type UserNotificationEntitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserNotificationEntitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserNotificationEntitiesStreamCursorValueInput = {
  actingUserId?: InputMaybe<Scalars['uuid']>;
  connectionRequestId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  eventGroupId?: InputMaybe<Scalars['uuid']>;
  eventPlayerInviteId?: InputMaybe<Scalars['uuid']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  groupThreadCommentId?: InputMaybe<Scalars['uuid']>;
  groupThreadId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessonId?: InputMaybe<Scalars['uuid']>;
  messageId?: InputMaybe<Scalars['uuid']>;
  partnerBookingOrderId?: InputMaybe<Scalars['uuid']>;
  playRequestId?: InputMaybe<Scalars['uuid']>;
  playSessionCommentId?: InputMaybe<Scalars['uuid']>;
  playSessionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "user_notifications" */
export type UserNotifications = {
  __typename?: 'UserNotifications';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  notificationDetails: UserNotificationDetails;
  readAt?: Maybe<Scalars['timestamptz']>;
  status: NotificationStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  userNotificationDetailId: Scalars['uuid'];
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "user_notifications" */
export type UserNotificationsAggregate = {
  __typename?: 'UserNotificationsAggregate';
  aggregate?: Maybe<UserNotificationsAggregateFields>;
  nodes: Array<UserNotifications>;
};

export type UserNotificationsAggregateBoolExp = {
  count?: InputMaybe<UserNotificationsAggregateBoolExpCount>;
};

/** aggregate fields of "user_notifications" */
export type UserNotificationsAggregateFields = {
  __typename?: 'UserNotificationsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserNotificationsMaxFields>;
  min?: Maybe<UserNotificationsMinFields>;
};


/** aggregate fields of "user_notifications" */
export type UserNotificationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_notifications" */
export type UserNotificationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserNotificationsMaxOrderBy>;
  min?: InputMaybe<UserNotificationsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "user_notifications". All fields are combined with a logical 'AND'. */
export type UserNotificationsBoolExp = {
  _and?: InputMaybe<Array<UserNotificationsBoolExp>>;
  _not?: InputMaybe<UserNotificationsBoolExp>;
  _or?: InputMaybe<Array<UserNotificationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  notificationDetails?: InputMaybe<UserNotificationDetailsBoolExp>;
  readAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<NotificationStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userNotificationDetailId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
};

/** aggregate max on columns */
export type UserNotificationsMaxFields = {
  __typename?: 'UserNotificationsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  readAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  userNotificationDetailId?: Maybe<Scalars['uuid']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_notifications" */
export type UserNotificationsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  readAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userNotificationDetailId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserNotificationsMinFields = {
  __typename?: 'UserNotificationsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  readAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  userNotificationDetailId?: Maybe<Scalars['uuid']>;
  videoAnalysisId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_notifications" */
export type UserNotificationsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  readAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userNotificationDetailId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_notifications" */
export type UserNotificationsMutationResponse = {
  __typename?: 'UserNotificationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserNotifications>;
};

/** Ordering options when selecting data from "user_notifications". */
export type UserNotificationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  notificationDetails?: InputMaybe<UserNotificationDetailsOrderBy>;
  readAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userNotificationDetailId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_notifications */
export type UserNotificationsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_notifications" */
export enum UserNotificationsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  ReadAt = 'readAt',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  UserNotificationDetailId = 'userNotificationDetailId',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

/** input type for updating data in table "user_notifications" */
export type UserNotificationsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  readAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<NotificationStatusesEnum>;
};

/** Streaming cursor of the table "user_notifications" */
export type UserNotificationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserNotificationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserNotificationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  readAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<NotificationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  userNotificationDetailId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

export type UserNotificationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserNotificationsSetInput>;
  /** filter the rows which have to be updated */
  where: UserNotificationsBoolExp;
};

/** columns and relationships of "user_padel_rating_scales" */
export type UserPadelRatingScales = {
  __typename?: 'UserPadelRatingScales';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  padelRatingScaleId: Scalars['uuid'];
  rating: Scalars['numeric'];
  /** An object relationship */
  scale: PadelRatingScales;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "user_padel_rating_scales" */
export type UserPadelRatingScalesAggregateOrderBy = {
  avg?: InputMaybe<UserPadelRatingScalesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserPadelRatingScalesMaxOrderBy>;
  min?: InputMaybe<UserPadelRatingScalesMinOrderBy>;
  stddev?: InputMaybe<UserPadelRatingScalesStddevOrderBy>;
  stddevPop?: InputMaybe<UserPadelRatingScalesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserPadelRatingScalesStddevSampOrderBy>;
  sum?: InputMaybe<UserPadelRatingScalesSumOrderBy>;
  varPop?: InputMaybe<UserPadelRatingScalesVarPopOrderBy>;
  varSamp?: InputMaybe<UserPadelRatingScalesVarSampOrderBy>;
  variance?: InputMaybe<UserPadelRatingScalesVarianceOrderBy>;
};

/** order by avg() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesAvgOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_padel_rating_scales". All fields are combined with a logical 'AND'. */
export type UserPadelRatingScalesBoolExp = {
  _and?: InputMaybe<Array<UserPadelRatingScalesBoolExp>>;
  _not?: InputMaybe<UserPadelRatingScalesBoolExp>;
  _or?: InputMaybe<Array<UserPadelRatingScalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  padelRatingScaleId?: InputMaybe<UuidComparisonExp>;
  rating?: InputMaybe<NumericComparisonExp>;
  scale?: InputMaybe<PadelRatingScalesBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_padel_rating_scales" */
export enum UserPadelRatingScalesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserPadelRatingScalesPkey = 'user_padel_rating_scales_pkey',
  /** unique or primary key constraint on columns "user_id", "padel_rating_scale_id" */
  UserPadelRatingScalesUserIdPadelRatingScaleIdKey = 'user_padel_rating_scales_user_id_padel_rating_scale_id_key'
}

/** input type for incrementing numeric columns in table "user_padel_rating_scales" */
export type UserPadelRatingScalesIncInput = {
  rating?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "user_padel_rating_scales" */
export type UserPadelRatingScalesInsertInput = {
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_padel_rating_scales" */
export type UserPadelRatingScalesMutationResponse = {
  __typename?: 'UserPadelRatingScalesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPadelRatingScales>;
};

/** on_conflict condition type for table "user_padel_rating_scales" */
export type UserPadelRatingScalesOnConflict = {
  constraint: UserPadelRatingScalesConstraint;
  updateColumns?: Array<UserPadelRatingScalesUpdateColumn>;
  where?: InputMaybe<UserPadelRatingScalesBoolExp>;
};

/** Ordering options when selecting data from "user_padel_rating_scales". */
export type UserPadelRatingScalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  padelRatingScaleId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  scale?: InputMaybe<PadelRatingScalesOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_padel_rating_scales */
export type UserPadelRatingScalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_padel_rating_scales" */
export enum UserPadelRatingScalesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  Rating = 'rating',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_padel_rating_scales" */
export type UserPadelRatingScalesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesStddevOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesStddevPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesStddevSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_padel_rating_scales" */
export type UserPadelRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPadelRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPadelRatingScalesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  padelRatingScaleId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesSumOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** update columns of table "user_padel_rating_scales" */
export enum UserPadelRatingScalesUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  PadelRatingScaleId = 'padelRatingScaleId',
  /** column name */
  Rating = 'rating'
}

export type UserPadelRatingScalesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserPadelRatingScalesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserPadelRatingScalesSetInput>;
  /** filter the rows which have to be updated */
  where: UserPadelRatingScalesBoolExp;
};

/** order by varPop() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesVarPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesVarSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "user_padel_rating_scales" */
export type UserPadelRatingScalesVarianceOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_pickleball_rating_scales" */
export type UserPickleballRatingScales = {
  __typename?: 'UserPickleballRatingScales';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  pickleballRatingScaleId: Scalars['uuid'];
  rating: Scalars['numeric'];
  /** An object relationship */
  scale: PickleballRatingScales;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesAggregateOrderBy = {
  avg?: InputMaybe<UserPickleballRatingScalesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserPickleballRatingScalesMaxOrderBy>;
  min?: InputMaybe<UserPickleballRatingScalesMinOrderBy>;
  stddev?: InputMaybe<UserPickleballRatingScalesStddevOrderBy>;
  stddevPop?: InputMaybe<UserPickleballRatingScalesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserPickleballRatingScalesStddevSampOrderBy>;
  sum?: InputMaybe<UserPickleballRatingScalesSumOrderBy>;
  varPop?: InputMaybe<UserPickleballRatingScalesVarPopOrderBy>;
  varSamp?: InputMaybe<UserPickleballRatingScalesVarSampOrderBy>;
  variance?: InputMaybe<UserPickleballRatingScalesVarianceOrderBy>;
};

/** order by avg() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesAvgOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_pickleball_rating_scales". All fields are combined with a logical 'AND'. */
export type UserPickleballRatingScalesBoolExp = {
  _and?: InputMaybe<Array<UserPickleballRatingScalesBoolExp>>;
  _not?: InputMaybe<UserPickleballRatingScalesBoolExp>;
  _or?: InputMaybe<Array<UserPickleballRatingScalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  pickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  rating?: InputMaybe<NumericComparisonExp>;
  scale?: InputMaybe<PickleballRatingScalesBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_pickleball_rating_scales" */
export enum UserPickleballRatingScalesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserPickleballRatingScalesPkey = 'user_pickleball_rating_scales_pkey',
  /** unique or primary key constraint on columns "pickleball_rating_scale_id", "user_id" */
  UserPickleballRatingScalesUserIdPickleballRatingScaKey = 'user_pickleball_rating_scales_user_id_pickleball_rating_sca_key'
}

/** input type for incrementing numeric columns in table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesIncInput = {
  rating?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesInsertInput = {
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesMutationResponse = {
  __typename?: 'UserPickleballRatingScalesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPickleballRatingScales>;
};

/** on_conflict condition type for table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesOnConflict = {
  constraint: UserPickleballRatingScalesConstraint;
  updateColumns?: Array<UserPickleballRatingScalesUpdateColumn>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};

/** Ordering options when selecting data from "user_pickleball_rating_scales". */
export type UserPickleballRatingScalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pickleballRatingScaleId?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  scale?: InputMaybe<PickleballRatingScalesOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_pickleball_rating_scales */
export type UserPickleballRatingScalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_pickleball_rating_scales" */
export enum UserPickleballRatingScalesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  Rating = 'rating',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesStddevOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesStddevPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesStddevSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPickleballRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPickleballRatingScalesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesSumOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** update columns of table "user_pickleball_rating_scales" */
export enum UserPickleballRatingScalesUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  PickleballRatingScaleId = 'pickleballRatingScaleId',
  /** column name */
  Rating = 'rating'
}

export type UserPickleballRatingScalesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserPickleballRatingScalesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserPickleballRatingScalesSetInput>;
  /** filter the rows which have to be updated */
  where: UserPickleballRatingScalesBoolExp;
};

/** order by varPop() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesVarPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesVarSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "user_pickleball_rating_scales" */
export type UserPickleballRatingScalesVarianceOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_played_with" */
export type UserPlayedWith = {
  __typename?: 'UserPlayedWith';
  /** An array relationship */
  games: Array<UserPlayedWithGames>;
  /** An aggregate relationship */
  gamesAggregate: UserPlayedWithGamesAggregate;
  gamesTogether?: Maybe<Scalars['Int']>;
  lastPlayedAt?: Maybe<Scalars['timestamptz']>;
  otherUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  otherUserProfile?: Maybe<UserProfiles>;
  userId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "user_played_with" */
export type UserPlayedWithGamesArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithGamesOrderBy>>;
  where?: InputMaybe<UserPlayedWithGamesBoolExp>;
};


/** columns and relationships of "user_played_with" */
export type UserPlayedWithGamesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithGamesOrderBy>>;
  where?: InputMaybe<UserPlayedWithGamesBoolExp>;
};

/** aggregated selection of "user_played_with" */
export type UserPlayedWithAggregate = {
  __typename?: 'UserPlayedWithAggregate';
  aggregate?: Maybe<UserPlayedWithAggregateFields>;
  nodes: Array<UserPlayedWith>;
};

/** aggregate fields of "user_played_with" */
export type UserPlayedWithAggregateFields = {
  __typename?: 'UserPlayedWithAggregateFields';
  avg?: Maybe<UserPlayedWithAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserPlayedWithMaxFields>;
  min?: Maybe<UserPlayedWithMinFields>;
  stddev?: Maybe<UserPlayedWithStddevFields>;
  stddevPop?: Maybe<UserPlayedWithStddevPopFields>;
  stddevSamp?: Maybe<UserPlayedWithStddevSampFields>;
  sum?: Maybe<UserPlayedWithSumFields>;
  varPop?: Maybe<UserPlayedWithVarPopFields>;
  varSamp?: Maybe<UserPlayedWithVarSampFields>;
  variance?: Maybe<UserPlayedWithVarianceFields>;
};


/** aggregate fields of "user_played_with" */
export type UserPlayedWithAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserPlayedWithSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UserPlayedWithAvgFields = {
  __typename?: 'UserPlayedWithAvgFields';
  gamesTogether?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_played_with". All fields are combined with a logical 'AND'. */
export type UserPlayedWithBoolExp = {
  _and?: InputMaybe<Array<UserPlayedWithBoolExp>>;
  _not?: InputMaybe<UserPlayedWithBoolExp>;
  _or?: InputMaybe<Array<UserPlayedWithBoolExp>>;
  games?: InputMaybe<UserPlayedWithGamesBoolExp>;
  gamesAggregate?: InputMaybe<UserPlayedWithGamesAggregateBoolExp>;
  gamesTogether?: InputMaybe<IntComparisonExp>;
  lastPlayedAt?: InputMaybe<TimestamptzComparisonExp>;
  otherUserId?: InputMaybe<UuidComparisonExp>;
  otherUserProfile?: InputMaybe<UserProfilesBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** columns and relationships of "user_played_with_dismissals" */
export type UserPlayedWithDismissals = {
  __typename?: 'UserPlayedWithDismissals';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  dismissedUser: Users;
  dismissedUserId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** Boolean expression to filter rows from the table "user_played_with_dismissals". All fields are combined with a logical 'AND'. */
export type UserPlayedWithDismissalsBoolExp = {
  _and?: InputMaybe<Array<UserPlayedWithDismissalsBoolExp>>;
  _not?: InputMaybe<UserPlayedWithDismissalsBoolExp>;
  _or?: InputMaybe<Array<UserPlayedWithDismissalsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dismissedUser?: InputMaybe<UsersBoolExp>;
  dismissedUserId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** Ordering options when selecting data from "user_played_with_dismissals". */
export type UserPlayedWithDismissalsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dismissedUser?: InputMaybe<UsersOrderBy>;
  dismissedUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "user_played_with_dismissals" */
export enum UserPlayedWithDismissalsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DismissedUserId = 'dismissedUserId',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "user_played_with_dismissals" */
export type UserPlayedWithDismissalsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPlayedWithDismissalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPlayedWithDismissalsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dismissedUserId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "user_played_with_games" */
export type UserPlayedWithGames = {
  __typename?: 'UserPlayedWithGames';
  /** An object relationship */
  event?: Maybe<Events>;
  eventId?: Maybe<Scalars['uuid']>;
  otherUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  otherUserProfile?: Maybe<UserProfiles>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "user_played_with_games" */
export type UserPlayedWithGamesAggregate = {
  __typename?: 'UserPlayedWithGamesAggregate';
  aggregate?: Maybe<UserPlayedWithGamesAggregateFields>;
  nodes: Array<UserPlayedWithGames>;
};

export type UserPlayedWithGamesAggregateBoolExp = {
  count?: InputMaybe<UserPlayedWithGamesAggregateBoolExpCount>;
};

/** aggregate fields of "user_played_with_games" */
export type UserPlayedWithGamesAggregateFields = {
  __typename?: 'UserPlayedWithGamesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserPlayedWithGamesMaxFields>;
  min?: Maybe<UserPlayedWithGamesMinFields>;
};


/** aggregate fields of "user_played_with_games" */
export type UserPlayedWithGamesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_played_with_games" */
export type UserPlayedWithGamesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserPlayedWithGamesMaxOrderBy>;
  min?: InputMaybe<UserPlayedWithGamesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "user_played_with_games". All fields are combined with a logical 'AND'. */
export type UserPlayedWithGamesBoolExp = {
  _and?: InputMaybe<Array<UserPlayedWithGamesBoolExp>>;
  _not?: InputMaybe<UserPlayedWithGamesBoolExp>;
  _or?: InputMaybe<Array<UserPlayedWithGamesBoolExp>>;
  event?: InputMaybe<EventsBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  otherUserId?: InputMaybe<UuidComparisonExp>;
  otherUserProfile?: InputMaybe<UserProfilesBoolExp>;
  startDateTime?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** aggregate max on columns */
export type UserPlayedWithGamesMaxFields = {
  __typename?: 'UserPlayedWithGamesMaxFields';
  eventId?: Maybe<Scalars['uuid']>;
  otherUserId?: Maybe<Scalars['uuid']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_played_with_games" */
export type UserPlayedWithGamesMaxOrderBy = {
  eventId?: InputMaybe<OrderBy>;
  otherUserId?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserPlayedWithGamesMinFields = {
  __typename?: 'UserPlayedWithGamesMinFields';
  eventId?: Maybe<Scalars['uuid']>;
  otherUserId?: Maybe<Scalars['uuid']>;
  startDateTime?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_played_with_games" */
export type UserPlayedWithGamesMinOrderBy = {
  eventId?: InputMaybe<OrderBy>;
  otherUserId?: InputMaybe<OrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "user_played_with_games". */
export type UserPlayedWithGamesOrderBy = {
  event?: InputMaybe<EventsOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  otherUserId?: InputMaybe<OrderBy>;
  otherUserProfile?: InputMaybe<UserProfilesOrderBy>;
  startDateTime?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "user_played_with_games" */
export enum UserPlayedWithGamesSelectColumn {
  /** column name */
  EventId = 'eventId',
  /** column name */
  OtherUserId = 'otherUserId',
  /** column name */
  StartDateTime = 'startDateTime',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "user_played_with_games" */
export type UserPlayedWithGamesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPlayedWithGamesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPlayedWithGamesStreamCursorValueInput = {
  eventId?: InputMaybe<Scalars['uuid']>;
  otherUserId?: InputMaybe<Scalars['uuid']>;
  startDateTime?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserPlayedWithMaxFields = {
  __typename?: 'UserPlayedWithMaxFields';
  gamesTogether?: Maybe<Scalars['Int']>;
  lastPlayedAt?: Maybe<Scalars['timestamptz']>;
  otherUserId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserPlayedWithMinFields = {
  __typename?: 'UserPlayedWithMinFields';
  gamesTogether?: Maybe<Scalars['Int']>;
  lastPlayedAt?: Maybe<Scalars['timestamptz']>;
  otherUserId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "user_played_with". */
export type UserPlayedWithOrderBy = {
  gamesAggregate?: InputMaybe<UserPlayedWithGamesAggregateOrderBy>;
  gamesTogether?: InputMaybe<OrderBy>;
  lastPlayedAt?: InputMaybe<OrderBy>;
  otherUserId?: InputMaybe<OrderBy>;
  otherUserProfile?: InputMaybe<UserProfilesOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "user_played_with" */
export enum UserPlayedWithSelectColumn {
  /** column name */
  GamesTogether = 'gamesTogether',
  /** column name */
  LastPlayedAt = 'lastPlayedAt',
  /** column name */
  OtherUserId = 'otherUserId',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type UserPlayedWithStddevFields = {
  __typename?: 'UserPlayedWithStddevFields';
  gamesTogether?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type UserPlayedWithStddevPopFields = {
  __typename?: 'UserPlayedWithStddevPopFields';
  gamesTogether?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type UserPlayedWithStddevSampFields = {
  __typename?: 'UserPlayedWithStddevSampFields';
  gamesTogether?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_played_with" */
export type UserPlayedWithStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPlayedWithStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPlayedWithStreamCursorValueInput = {
  gamesTogether?: InputMaybe<Scalars['Int']>;
  lastPlayedAt?: InputMaybe<Scalars['timestamptz']>;
  otherUserId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type UserPlayedWithSumFields = {
  __typename?: 'UserPlayedWithSumFields';
  gamesTogether?: Maybe<Scalars['Int']>;
};

/** aggregate varPop on columns */
export type UserPlayedWithVarPopFields = {
  __typename?: 'UserPlayedWithVarPopFields';
  gamesTogether?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type UserPlayedWithVarSampFields = {
  __typename?: 'UserPlayedWithVarSampFields';
  gamesTogether?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserPlayedWithVarianceFields = {
  __typename?: 'UserPlayedWithVarianceFields';
  gamesTogether?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_player_finder_availability" */
export type UserPlayerFinderAvailability = {
  __typename?: 'UserPlayerFinderAvailability';
  createdAt: Scalars['timestamptz'];
  dayOfWeek: DayOfWeekEnum;
  timeOfDay: PlayerFinderTimeOfDayEnum;
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserPlayerFinderAvailabilityMaxOrderBy>;
  min?: InputMaybe<UserPlayerFinderAvailabilityMinOrderBy>;
};

/** Boolean expression to filter rows from the table "user_player_finder_availability". All fields are combined with a logical 'AND'. */
export type UserPlayerFinderAvailabilityBoolExp = {
  _and?: InputMaybe<Array<UserPlayerFinderAvailabilityBoolExp>>;
  _not?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
  _or?: InputMaybe<Array<UserPlayerFinderAvailabilityBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dayOfWeek?: InputMaybe<DayOfWeekEnumComparisonExp>;
  timeOfDay?: InputMaybe<PlayerFinderTimeOfDayEnumComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_player_finder_availability" */
export enum UserPlayerFinderAvailabilityConstraint {
  /** unique or primary key constraint on columns "day_of_week", "user_id", "time_of_day" */
  UserPlayerFinderAvailabilityPkey = 'user_player_finder_availability_pkey'
}

/** input type for inserting data into table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityInsertInput = {
  dayOfWeek?: InputMaybe<DayOfWeekEnum>;
  timeOfDay?: InputMaybe<PlayerFinderTimeOfDayEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityMutationResponse = {
  __typename?: 'UserPlayerFinderAvailabilityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPlayerFinderAvailability>;
};

/** on_conflict condition type for table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityOnConflict = {
  constraint: UserPlayerFinderAvailabilityConstraint;
  updateColumns?: Array<UserPlayerFinderAvailabilityUpdateColumn>;
  where?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
};

/** Ordering options when selecting data from "user_player_finder_availability". */
export type UserPlayerFinderAvailabilityOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  timeOfDay?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "user_player_finder_availability" */
export enum UserPlayerFinderAvailabilitySelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DayOfWeek = 'dayOfWeek',
  /** column name */
  TimeOfDay = 'timeOfDay',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "user_player_finder_availability" */
export type UserPlayerFinderAvailabilityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPlayerFinderAvailabilityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPlayerFinderAvailabilityStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<DayOfWeekEnum>;
  timeOfDay?: InputMaybe<PlayerFinderTimeOfDayEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** placeholder for update columns of table "user_player_finder_availability" (current role has no relevant permissions) */
export enum UserPlayerFinderAvailabilityUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "user_player_finder_goals" */
export type UserPlayerFinderGoals = {
  __typename?: 'UserPlayerFinderGoals';
  createdAt: Scalars['timestamptz'];
  goal: PlayerFinderGoalsEnum;
  userId: Scalars['uuid'];
};

/** Boolean expression to filter rows from the table "user_player_finder_goals". All fields are combined with a logical 'AND'. */
export type UserPlayerFinderGoalsBoolExp = {
  _and?: InputMaybe<Array<UserPlayerFinderGoalsBoolExp>>;
  _not?: InputMaybe<UserPlayerFinderGoalsBoolExp>;
  _or?: InputMaybe<Array<UserPlayerFinderGoalsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  goal?: InputMaybe<PlayerFinderGoalsEnumComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_player_finder_goals" */
export enum UserPlayerFinderGoalsConstraint {
  /** unique or primary key constraint on columns "user_id", "goal" */
  UserPlayerFinderGoalsPkey = 'user_player_finder_goals_pkey'
}

/** input type for inserting data into table "user_player_finder_goals" */
export type UserPlayerFinderGoalsInsertInput = {
  goal?: InputMaybe<PlayerFinderGoalsEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_player_finder_goals" */
export type UserPlayerFinderGoalsMutationResponse = {
  __typename?: 'UserPlayerFinderGoalsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPlayerFinderGoals>;
};

/** on_conflict condition type for table "user_player_finder_goals" */
export type UserPlayerFinderGoalsOnConflict = {
  constraint: UserPlayerFinderGoalsConstraint;
  updateColumns?: Array<UserPlayerFinderGoalsUpdateColumn>;
  where?: InputMaybe<UserPlayerFinderGoalsBoolExp>;
};

/** Ordering options when selecting data from "user_player_finder_goals". */
export type UserPlayerFinderGoalsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  goal?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "user_player_finder_goals" */
export enum UserPlayerFinderGoalsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Goal = 'goal',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "user_player_finder_goals" */
export type UserPlayerFinderGoalsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPlayerFinderGoalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPlayerFinderGoalsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  goal?: InputMaybe<PlayerFinderGoalsEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** placeholder for update columns of table "user_player_finder_goals" (current role has no relevant permissions) */
export enum UserPlayerFinderGoalsUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "user_profiles" */
export type UserProfiles = {
  __typename?: 'UserProfiles';
  aboutMe?: Maybe<Scalars['String']>;
  aboutMeVideoUrl?: Maybe<Scalars['String']>;
  /** An object relationship */
  activeCity?: Maybe<Cities>;
  activeCityId?: Maybe<Scalars['uuid']>;
  birthdayDay?: Maybe<Scalars['Int']>;
  birthdayMonth?: Maybe<Scalars['Int']>;
  birthdayVisibility?: Maybe<Scalars['String']>;
  birthdayYear?: Maybe<Scalars['Int']>;
  cityName?: Maybe<Scalars['String']>;
  /** An array relationship */
  coachAvailability: Array<CoachAvailability>;
  coachExternalBookingUrl?: Maybe<Scalars['String']>;
  /** An array relationship */
  coachFaqs: Array<CoachFaqs>;
  /** An array relationship */
  coachLessonAgeGroups: Array<CoachLessonAgeGroups>;
  coachLessonDescription?: Maybe<Scalars['String']>;
  coachLessonHowToPrepare?: Maybe<Scalars['String']>;
  /** An array relationship */
  coachLessonReflections: Array<LessonReflections>;
  /** An array relationship */
  coachLessonSkillLevels: Array<CoachLessonSkillLevels>;
  /** An array relationship */
  coachLessons: Array<Lessons>;
  /** An aggregate relationship */
  coachLessonsAggregate: LessonsAggregate;
  /** An array relationship */
  coachQualifications: Array<UsersCoachQualifications>;
  /** An array relationship */
  coachReviews: Array<Reviews>;
  /** An aggregate relationship */
  coachReviewsAggregate: ReviewsAggregate;
  /** An array relationship */
  coachServices: Array<UserCoachServices>;
  /** An array relationship */
  coachSports: Array<CoachSports>;
  coachStatus?: Maybe<Scalars['String']>;
  coachingStartYear?: Maybe<Scalars['Int']>;
  /** An object relationship */
  country?: Maybe<Countries>;
  countryId?: Maybe<Scalars['String']>;
  /** An object relationship */
  countrySubdivision?: Maybe<CountrySubdivisions>;
  countrySubdivisionId?: Maybe<Scalars['uuid']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currencyCoachDefault?: Maybe<Scalars['String']>;
  /** An object relationship */
  defaultCoachCustomCourt?: Maybe<UserCustomCourts>;
  defaultCoachUserCustomCourtId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  defaultCoachVenue?: Maybe<Venues>;
  defaultCoachVenueId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  defaultPickleballRatingScale?: Maybe<PickleballRatingScales>;
  defaultPickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  defaultSport?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprId?: Maybe<Scalars['String']>;
  eventOrganizerAccountType?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  /** An array relationship */
  followers: Array<UserFollows>;
  /** An aggregate relationship */
  followersAggregate: UserFollowsAggregate;
  /** An array relationship */
  following: Array<UserFollows>;
  /** An aggregate relationship */
  followingAggregate: UserFollowsAggregate;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderPreference?: Maybe<Scalars['String']>;
  geometry?: Maybe<Scalars['geography']>;
  id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  identityVerifications: Array<UserIdentityVerifications>;
  instagramUrl?: Maybe<Scalars['String']>;
  iptpaId?: Maybe<Scalars['String']>;
  isIptpaMember?: Maybe<Scalars['Boolean']>;
  isPciMember?: Maybe<Scalars['Boolean']>;
  isPicklrP4Member?: Maybe<Scalars['Boolean']>;
  isPprMember?: Maybe<Scalars['Boolean']>;
  isProfessionalRacquetRegistryActive?: Maybe<Scalars['Boolean']>;
  isQuatroPickleballMember?: Maybe<Scalars['Boolean']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  normalizedTennisRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  normalizedTennisRatingScale?: Maybe<TennisRatingScales>;
  normalizedTennisRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  padelRatingScales: Array<UserPadelRatingScales>;
  /** An object relationship */
  padelSkillLevel?: Maybe<SkillLevels>;
  padelSkillLevelId?: Maybe<Scalars['String']>;
  pciId?: Maybe<Scalars['String']>;
  /** An array relationship */
  pickleballRatingScales: Array<UserPickleballRatingScales>;
  /** An object relationship */
  pickleballSkillLevel?: Maybe<SkillLevels>;
  pickleballSkillLevelId?: Maybe<Scalars['String']>;
  /** An array relationship */
  playerFinderAvailability: Array<UserPlayerFinderAvailability>;
  /** An array relationship */
  playerLessonReflections: Array<LessonReflections>;
  /** An array relationship */
  playerReviews: Array<Reviews>;
  /** An aggregate relationship */
  playerReviewsAggregate: ReviewsAggregate;
  pprId?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  premiumContentDescription?: Maybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Int']>;
  profileImageFileName?: Maybe<Scalars['String']>;
  profileImagePath?: Maybe<Scalars['String']>;
  profileImageProvider?: Maybe<Scalars['String']>;
  profileImageProviderId?: Maybe<Scalars['String']>;
  profileImageProviderUrl?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  quatroPickleballMemberId?: Maybe<Scalars['String']>;
  /** An array relationship */
  sports: Array<UserSports>;
  stripeMerchantChargesEnabled?: Maybe<Scalars['Boolean']>;
  stripeMerchantCurrency?: Maybe<Scalars['String']>;
  stripeMerchantDetailsSubmitted?: Maybe<Scalars['Boolean']>;
  tennisRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  tennisRatingScale?: Maybe<TennisRatingScales>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  tennisRatingScales: Array<UserTennisRatingScales>;
  /** An object relationship */
  tennisSkillLevel?: Maybe<SkillLevels>;
  tennisSkillLevelId?: Maybe<Scalars['String']>;
  tiktokUrl?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  userFiles: Array<UserFiles>;
  username?: Maybe<Scalars['String']>;
  /** An array relationship */
  venueFollows: Array<VenueFollows>;
  /** An aggregate relationship */
  venueFollowsAggregate: VenueFollowsAggregate;
  websiteUrl?: Maybe<Scalars['String']>;
  xUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachAvailabilityArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityOrderBy>>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachFaqsArgs = {
  distinctOn?: InputMaybe<Array<CoachFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachFaqsOrderBy>>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachLessonAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonAgeGroupsOrderBy>>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachLessonReflectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachLessonSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonSkillLevelsOrderBy>>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachQualificationsArgs = {
  distinctOn?: InputMaybe<Array<UsersCoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersCoachQualificationsOrderBy>>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachReviewsArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachServicesArgs = {
  distinctOn?: InputMaybe<Array<UserCoachServicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCoachServicesOrderBy>>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesCoachSportsArgs = {
  distinctOn?: InputMaybe<Array<CoachSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportsOrderBy>>;
  where?: InputMaybe<CoachSportsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesFollowersArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesFollowersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesFollowingArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesFollowingAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesIdentityVerificationsArgs = {
  distinctOn?: InputMaybe<Array<UserIdentityVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserIdentityVerificationsOrderBy>>;
  where?: InputMaybe<UserIdentityVerificationsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPadelRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserPadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPadelRatingScalesOrderBy>>;
  where?: InputMaybe<UserPadelRatingScalesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPickleballRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserPickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPickleballRatingScalesOrderBy>>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPlayerFinderAvailabilityArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderAvailabilityOrderBy>>;
  where?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPlayerLessonReflectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPlayerReviewsArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesPlayerReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesSportsArgs = {
  distinctOn?: InputMaybe<Array<UserSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSportsOrderBy>>;
  where?: InputMaybe<UserSportsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesTennisRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserTennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTennisRatingScalesOrderBy>>;
  where?: InputMaybe<UserTennisRatingScalesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesUserFilesArgs = {
  distinctOn?: InputMaybe<Array<UserFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFilesOrderBy>>;
  where?: InputMaybe<UserFilesBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesVenueFollowsArgs = {
  distinctOn?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFollowsOrderBy>>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};


/** columns and relationships of "user_profiles" */
export type UserProfilesVenueFollowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFollowsOrderBy>>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};

/** aggregated selection of "user_profiles" */
export type UserProfilesAggregate = {
  __typename?: 'UserProfilesAggregate';
  aggregate?: Maybe<UserProfilesAggregateFields>;
  nodes: Array<UserProfiles>;
};

/** aggregate fields of "user_profiles" */
export type UserProfilesAggregateFields = {
  __typename?: 'UserProfilesAggregateFields';
  avg?: Maybe<UserProfilesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserProfilesMaxFields>;
  min?: Maybe<UserProfilesMinFields>;
  stddev?: Maybe<UserProfilesStddevFields>;
  stddevPop?: Maybe<UserProfilesStddevPopFields>;
  stddevSamp?: Maybe<UserProfilesStddevSampFields>;
  sum?: Maybe<UserProfilesSumFields>;
  varPop?: Maybe<UserProfilesVarPopFields>;
  varSamp?: Maybe<UserProfilesVarSampFields>;
  variance?: Maybe<UserProfilesVarianceFields>;
};


/** aggregate fields of "user_profiles" */
export type UserProfilesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserProfilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UserProfilesAvgFields = {
  __typename?: 'UserProfilesAvgFields';
  birthdayDay?: Maybe<Scalars['Float']>;
  birthdayMonth?: Maybe<Scalars['Float']>;
  birthdayYear?: Maybe<Scalars['Float']>;
  coachingStartYear?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_profiles". All fields are combined with a logical 'AND'. */
export type UserProfilesBoolExp = {
  _and?: InputMaybe<Array<UserProfilesBoolExp>>;
  _not?: InputMaybe<UserProfilesBoolExp>;
  _or?: InputMaybe<Array<UserProfilesBoolExp>>;
  aboutMe?: InputMaybe<StringComparisonExp>;
  aboutMeVideoUrl?: InputMaybe<StringComparisonExp>;
  activeCity?: InputMaybe<CitiesBoolExp>;
  activeCityId?: InputMaybe<UuidComparisonExp>;
  birthdayDay?: InputMaybe<IntComparisonExp>;
  birthdayMonth?: InputMaybe<IntComparisonExp>;
  birthdayVisibility?: InputMaybe<StringComparisonExp>;
  birthdayYear?: InputMaybe<IntComparisonExp>;
  cityName?: InputMaybe<StringComparisonExp>;
  coachAvailability?: InputMaybe<CoachAvailabilityBoolExp>;
  coachExternalBookingUrl?: InputMaybe<StringComparisonExp>;
  coachFaqs?: InputMaybe<CoachFaqsBoolExp>;
  coachLessonAgeGroups?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
  coachLessonDescription?: InputMaybe<StringComparisonExp>;
  coachLessonHowToPrepare?: InputMaybe<StringComparisonExp>;
  coachLessonReflections?: InputMaybe<LessonReflectionsBoolExp>;
  coachLessonSkillLevels?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
  coachLessons?: InputMaybe<LessonsBoolExp>;
  coachLessonsAggregate?: InputMaybe<LessonsAggregateBoolExp>;
  coachQualifications?: InputMaybe<UsersCoachQualificationsBoolExp>;
  coachReviews?: InputMaybe<ReviewsBoolExp>;
  coachReviewsAggregate?: InputMaybe<ReviewsAggregateBoolExp>;
  coachServices?: InputMaybe<UserCoachServicesBoolExp>;
  coachSports?: InputMaybe<CoachSportsBoolExp>;
  coachStatus?: InputMaybe<StringComparisonExp>;
  coachingStartYear?: InputMaybe<IntComparisonExp>;
  country?: InputMaybe<CountriesBoolExp>;
  countryId?: InputMaybe<StringComparisonExp>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsBoolExp>;
  countrySubdivisionId?: InputMaybe<UuidComparisonExp>;
  coverImageFileName?: InputMaybe<StringComparisonExp>;
  coverImagePath?: InputMaybe<StringComparisonExp>;
  coverImageProvider?: InputMaybe<StringComparisonExp>;
  coverImageProviderUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currencyCoachDefault?: InputMaybe<StringComparisonExp>;
  defaultCoachCustomCourt?: InputMaybe<UserCustomCourtsBoolExp>;
  defaultCoachUserCustomCourtId?: InputMaybe<UuidComparisonExp>;
  defaultCoachVenue?: InputMaybe<VenuesBoolExp>;
  defaultCoachVenueId?: InputMaybe<UuidComparisonExp>;
  defaultPickleballRatingScale?: InputMaybe<PickleballRatingScalesBoolExp>;
  defaultPickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  defaultSport?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  duprId?: InputMaybe<StringComparisonExp>;
  eventOrganizerAccountType?: InputMaybe<StringComparisonExp>;
  facebookUrl?: InputMaybe<StringComparisonExp>;
  followers?: InputMaybe<UserFollowsBoolExp>;
  followersAggregate?: InputMaybe<UserFollowsAggregateBoolExp>;
  following?: InputMaybe<UserFollowsBoolExp>;
  followingAggregate?: InputMaybe<UserFollowsAggregateBoolExp>;
  fullName?: InputMaybe<StringComparisonExp>;
  gender?: InputMaybe<StringComparisonExp>;
  genderPreference?: InputMaybe<StringComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  identityVerifications?: InputMaybe<UserIdentityVerificationsBoolExp>;
  instagramUrl?: InputMaybe<StringComparisonExp>;
  iptpaId?: InputMaybe<StringComparisonExp>;
  isIptpaMember?: InputMaybe<BooleanComparisonExp>;
  isPciMember?: InputMaybe<BooleanComparisonExp>;
  isPicklrP4Member?: InputMaybe<BooleanComparisonExp>;
  isPprMember?: InputMaybe<BooleanComparisonExp>;
  isProfessionalRacquetRegistryActive?: InputMaybe<BooleanComparisonExp>;
  isQuatroPickleballMember?: InputMaybe<BooleanComparisonExp>;
  linkedinUrl?: InputMaybe<StringComparisonExp>;
  locale?: InputMaybe<StringComparisonExp>;
  normalizedTennisRating?: InputMaybe<NumericComparisonExp>;
  normalizedTennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  normalizedTennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  padelRatingScales?: InputMaybe<UserPadelRatingScalesBoolExp>;
  padelSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  padelSkillLevelId?: InputMaybe<StringComparisonExp>;
  pciId?: InputMaybe<StringComparisonExp>;
  pickleballRatingScales?: InputMaybe<UserPickleballRatingScalesBoolExp>;
  pickleballSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  pickleballSkillLevelId?: InputMaybe<StringComparisonExp>;
  playerFinderAvailability?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
  playerLessonReflections?: InputMaybe<LessonReflectionsBoolExp>;
  playerReviews?: InputMaybe<ReviewsBoolExp>;
  playerReviewsAggregate?: InputMaybe<ReviewsAggregateBoolExp>;
  pprId?: InputMaybe<StringComparisonExp>;
  preferredName?: InputMaybe<StringComparisonExp>;
  premiumContentDescription?: InputMaybe<StringComparisonExp>;
  priceUnitAmountCoachDefault?: InputMaybe<IntComparisonExp>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<IntComparisonExp>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<IntComparisonExp>;
  profileImageFileName?: InputMaybe<StringComparisonExp>;
  profileImagePath?: InputMaybe<StringComparisonExp>;
  profileImageProvider?: InputMaybe<StringComparisonExp>;
  profileImageProviderId?: InputMaybe<StringComparisonExp>;
  profileImageProviderUrl?: InputMaybe<StringComparisonExp>;
  profileImageUrl?: InputMaybe<StringComparisonExp>;
  quatroPickleballMemberId?: InputMaybe<StringComparisonExp>;
  sports?: InputMaybe<UserSportsBoolExp>;
  stripeMerchantChargesEnabled?: InputMaybe<BooleanComparisonExp>;
  stripeMerchantCurrency?: InputMaybe<StringComparisonExp>;
  stripeMerchantDetailsSubmitted?: InputMaybe<BooleanComparisonExp>;
  tennisRating?: InputMaybe<NumericComparisonExp>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  tennisRatingScales?: InputMaybe<UserTennisRatingScalesBoolExp>;
  tennisSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  tennisSkillLevelId?: InputMaybe<StringComparisonExp>;
  tiktokUrl?: InputMaybe<StringComparisonExp>;
  timezone?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userFiles?: InputMaybe<UserFilesBoolExp>;
  username?: InputMaybe<StringComparisonExp>;
  venueFollows?: InputMaybe<VenueFollowsBoolExp>;
  venueFollowsAggregate?: InputMaybe<VenueFollowsAggregateBoolExp>;
  websiteUrl?: InputMaybe<StringComparisonExp>;
  xUrl?: InputMaybe<StringComparisonExp>;
  youtubeUrl?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type UserProfilesMaxFields = {
  __typename?: 'UserProfilesMaxFields';
  aboutMe?: Maybe<Scalars['String']>;
  aboutMeVideoUrl?: Maybe<Scalars['String']>;
  activeCityId?: Maybe<Scalars['uuid']>;
  birthdayDay?: Maybe<Scalars['Int']>;
  birthdayMonth?: Maybe<Scalars['Int']>;
  birthdayVisibility?: Maybe<Scalars['String']>;
  birthdayYear?: Maybe<Scalars['Int']>;
  cityName?: Maybe<Scalars['String']>;
  coachExternalBookingUrl?: Maybe<Scalars['String']>;
  coachLessonDescription?: Maybe<Scalars['String']>;
  coachLessonHowToPrepare?: Maybe<Scalars['String']>;
  coachStatus?: Maybe<Scalars['String']>;
  coachingStartYear?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['String']>;
  countrySubdivisionId?: Maybe<Scalars['uuid']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currencyCoachDefault?: Maybe<Scalars['String']>;
  defaultCoachUserCustomCourtId?: Maybe<Scalars['uuid']>;
  defaultCoachVenueId?: Maybe<Scalars['uuid']>;
  defaultPickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  defaultSport?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprId?: Maybe<Scalars['String']>;
  eventOrganizerAccountType?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderPreference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagramUrl?: Maybe<Scalars['String']>;
  iptpaId?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  normalizedTennisRating?: Maybe<Scalars['numeric']>;
  normalizedTennisRatingScaleId?: Maybe<Scalars['uuid']>;
  padelSkillLevelId?: Maybe<Scalars['String']>;
  pciId?: Maybe<Scalars['String']>;
  pickleballSkillLevelId?: Maybe<Scalars['String']>;
  pprId?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  premiumContentDescription?: Maybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Int']>;
  profileImageFileName?: Maybe<Scalars['String']>;
  profileImagePath?: Maybe<Scalars['String']>;
  profileImageProvider?: Maybe<Scalars['String']>;
  profileImageProviderId?: Maybe<Scalars['String']>;
  profileImageProviderUrl?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  quatroPickleballMemberId?: Maybe<Scalars['String']>;
  stripeMerchantCurrency?: Maybe<Scalars['String']>;
  tennisRating?: Maybe<Scalars['numeric']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  tennisSkillLevelId?: Maybe<Scalars['String']>;
  tiktokUrl?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  xUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UserProfilesMinFields = {
  __typename?: 'UserProfilesMinFields';
  aboutMe?: Maybe<Scalars['String']>;
  aboutMeVideoUrl?: Maybe<Scalars['String']>;
  activeCityId?: Maybe<Scalars['uuid']>;
  birthdayDay?: Maybe<Scalars['Int']>;
  birthdayMonth?: Maybe<Scalars['Int']>;
  birthdayVisibility?: Maybe<Scalars['String']>;
  birthdayYear?: Maybe<Scalars['Int']>;
  cityName?: Maybe<Scalars['String']>;
  coachExternalBookingUrl?: Maybe<Scalars['String']>;
  coachLessonDescription?: Maybe<Scalars['String']>;
  coachLessonHowToPrepare?: Maybe<Scalars['String']>;
  coachStatus?: Maybe<Scalars['String']>;
  coachingStartYear?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['String']>;
  countrySubdivisionId?: Maybe<Scalars['uuid']>;
  coverImageFileName?: Maybe<Scalars['String']>;
  coverImagePath?: Maybe<Scalars['String']>;
  coverImageProvider?: Maybe<Scalars['String']>;
  coverImageProviderUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currencyCoachDefault?: Maybe<Scalars['String']>;
  defaultCoachUserCustomCourtId?: Maybe<Scalars['uuid']>;
  defaultCoachVenueId?: Maybe<Scalars['uuid']>;
  defaultPickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  defaultSport?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  duprId?: Maybe<Scalars['String']>;
  eventOrganizerAccountType?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderPreference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagramUrl?: Maybe<Scalars['String']>;
  iptpaId?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  normalizedTennisRating?: Maybe<Scalars['numeric']>;
  normalizedTennisRatingScaleId?: Maybe<Scalars['uuid']>;
  padelSkillLevelId?: Maybe<Scalars['String']>;
  pciId?: Maybe<Scalars['String']>;
  pickleballSkillLevelId?: Maybe<Scalars['String']>;
  pprId?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  premiumContentDescription?: Maybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Int']>;
  profileImageFileName?: Maybe<Scalars['String']>;
  profileImagePath?: Maybe<Scalars['String']>;
  profileImageProvider?: Maybe<Scalars['String']>;
  profileImageProviderId?: Maybe<Scalars['String']>;
  profileImageProviderUrl?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  quatroPickleballMemberId?: Maybe<Scalars['String']>;
  stripeMerchantCurrency?: Maybe<Scalars['String']>;
  tennisRating?: Maybe<Scalars['numeric']>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  tennisSkillLevelId?: Maybe<Scalars['String']>;
  tiktokUrl?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  xUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "user_profiles". */
export type UserProfilesOrderBy = {
  aboutMe?: InputMaybe<OrderBy>;
  aboutMeVideoUrl?: InputMaybe<OrderBy>;
  activeCity?: InputMaybe<CitiesOrderBy>;
  activeCityId?: InputMaybe<OrderBy>;
  birthdayDay?: InputMaybe<OrderBy>;
  birthdayMonth?: InputMaybe<OrderBy>;
  birthdayVisibility?: InputMaybe<OrderBy>;
  birthdayYear?: InputMaybe<OrderBy>;
  cityName?: InputMaybe<OrderBy>;
  coachAvailabilityAggregate?: InputMaybe<CoachAvailabilityAggregateOrderBy>;
  coachExternalBookingUrl?: InputMaybe<OrderBy>;
  coachFaqsAggregate?: InputMaybe<CoachFaqsAggregateOrderBy>;
  coachLessonAgeGroupsAggregate?: InputMaybe<CoachLessonAgeGroupsAggregateOrderBy>;
  coachLessonDescription?: InputMaybe<OrderBy>;
  coachLessonHowToPrepare?: InputMaybe<OrderBy>;
  coachLessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateOrderBy>;
  coachLessonSkillLevelsAggregate?: InputMaybe<CoachLessonSkillLevelsAggregateOrderBy>;
  coachLessonsAggregate?: InputMaybe<LessonsAggregateOrderBy>;
  coachQualificationsAggregate?: InputMaybe<UsersCoachQualificationsAggregateOrderBy>;
  coachReviewsAggregate?: InputMaybe<ReviewsAggregateOrderBy>;
  coachServicesAggregate?: InputMaybe<UserCoachServicesAggregateOrderBy>;
  coachSportsAggregate?: InputMaybe<CoachSportsAggregateOrderBy>;
  coachStatus?: InputMaybe<OrderBy>;
  coachingStartYear?: InputMaybe<OrderBy>;
  country?: InputMaybe<CountriesOrderBy>;
  countryId?: InputMaybe<OrderBy>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsOrderBy>;
  countrySubdivisionId?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyCoachDefault?: InputMaybe<OrderBy>;
  defaultCoachCustomCourt?: InputMaybe<UserCustomCourtsOrderBy>;
  defaultCoachUserCustomCourtId?: InputMaybe<OrderBy>;
  defaultCoachVenue?: InputMaybe<VenuesOrderBy>;
  defaultCoachVenueId?: InputMaybe<OrderBy>;
  defaultPickleballRatingScale?: InputMaybe<PickleballRatingScalesOrderBy>;
  defaultPickleballRatingScaleId?: InputMaybe<OrderBy>;
  defaultSport?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duprId?: InputMaybe<OrderBy>;
  eventOrganizerAccountType?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  followersAggregate?: InputMaybe<UserFollowsAggregateOrderBy>;
  followingAggregate?: InputMaybe<UserFollowsAggregateOrderBy>;
  fullName?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  genderPreference?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  identityVerificationsAggregate?: InputMaybe<UserIdentityVerificationsAggregateOrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  iptpaId?: InputMaybe<OrderBy>;
  isIptpaMember?: InputMaybe<OrderBy>;
  isPciMember?: InputMaybe<OrderBy>;
  isPicklrP4Member?: InputMaybe<OrderBy>;
  isPprMember?: InputMaybe<OrderBy>;
  isProfessionalRacquetRegistryActive?: InputMaybe<OrderBy>;
  isQuatroPickleballMember?: InputMaybe<OrderBy>;
  linkedinUrl?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  normalizedTennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  normalizedTennisRatingScaleId?: InputMaybe<OrderBy>;
  padelRatingScalesAggregate?: InputMaybe<UserPadelRatingScalesAggregateOrderBy>;
  padelSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  padelSkillLevelId?: InputMaybe<OrderBy>;
  pciId?: InputMaybe<OrderBy>;
  pickleballRatingScalesAggregate?: InputMaybe<UserPickleballRatingScalesAggregateOrderBy>;
  pickleballSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  pickleballSkillLevelId?: InputMaybe<OrderBy>;
  playerFinderAvailabilityAggregate?: InputMaybe<UserPlayerFinderAvailabilityAggregateOrderBy>;
  playerLessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateOrderBy>;
  playerReviewsAggregate?: InputMaybe<ReviewsAggregateOrderBy>;
  pprId?: InputMaybe<OrderBy>;
  preferredName?: InputMaybe<OrderBy>;
  premiumContentDescription?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  profileImageFileName?: InputMaybe<OrderBy>;
  profileImagePath?: InputMaybe<OrderBy>;
  profileImageProvider?: InputMaybe<OrderBy>;
  profileImageProviderId?: InputMaybe<OrderBy>;
  profileImageProviderUrl?: InputMaybe<OrderBy>;
  profileImageUrl?: InputMaybe<OrderBy>;
  quatroPickleballMemberId?: InputMaybe<OrderBy>;
  sportsAggregate?: InputMaybe<UserSportsAggregateOrderBy>;
  stripeMerchantChargesEnabled?: InputMaybe<OrderBy>;
  stripeMerchantCurrency?: InputMaybe<OrderBy>;
  stripeMerchantDetailsSubmitted?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  tennisRatingScalesAggregate?: InputMaybe<UserTennisRatingScalesAggregateOrderBy>;
  tennisSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  tennisSkillLevelId?: InputMaybe<OrderBy>;
  tiktokUrl?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userFilesAggregate?: InputMaybe<UserFilesAggregateOrderBy>;
  username?: InputMaybe<OrderBy>;
  venueFollowsAggregate?: InputMaybe<VenueFollowsAggregateOrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  xUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** select columns of table "user_profiles" */
export enum UserProfilesSelectColumn {
  /** column name */
  AboutMe = 'aboutMe',
  /** column name */
  AboutMeVideoUrl = 'aboutMeVideoUrl',
  /** column name */
  ActiveCityId = 'activeCityId',
  /** column name */
  BirthdayDay = 'birthdayDay',
  /** column name */
  BirthdayMonth = 'birthdayMonth',
  /** column name */
  BirthdayVisibility = 'birthdayVisibility',
  /** column name */
  BirthdayYear = 'birthdayYear',
  /** column name */
  CityName = 'cityName',
  /** column name */
  CoachExternalBookingUrl = 'coachExternalBookingUrl',
  /** column name */
  CoachLessonDescription = 'coachLessonDescription',
  /** column name */
  CoachLessonHowToPrepare = 'coachLessonHowToPrepare',
  /** column name */
  CoachStatus = 'coachStatus',
  /** column name */
  CoachingStartYear = 'coachingStartYear',
  /** column name */
  CountryId = 'countryId',
  /** column name */
  CountrySubdivisionId = 'countrySubdivisionId',
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrencyCoachDefault = 'currencyCoachDefault',
  /** column name */
  DefaultCoachUserCustomCourtId = 'defaultCoachUserCustomCourtId',
  /** column name */
  DefaultCoachVenueId = 'defaultCoachVenueId',
  /** column name */
  DefaultPickleballRatingScaleId = 'defaultPickleballRatingScaleId',
  /** column name */
  DefaultSport = 'defaultSport',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DuprId = 'duprId',
  /** column name */
  EventOrganizerAccountType = 'eventOrganizerAccountType',
  /** column name */
  FacebookUrl = 'facebookUrl',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Gender = 'gender',
  /** column name */
  GenderPreference = 'genderPreference',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  InstagramUrl = 'instagramUrl',
  /** column name */
  IptpaId = 'iptpaId',
  /** column name */
  IsIptpaMember = 'isIptpaMember',
  /** column name */
  IsPciMember = 'isPciMember',
  /** column name */
  IsPicklrP4Member = 'isPicklrP4Member',
  /** column name */
  IsPprMember = 'isPprMember',
  /** column name */
  IsProfessionalRacquetRegistryActive = 'isProfessionalRacquetRegistryActive',
  /** column name */
  IsQuatroPickleballMember = 'isQuatroPickleballMember',
  /** column name */
  LinkedinUrl = 'linkedinUrl',
  /** column name */
  Locale = 'locale',
  /** column name */
  NormalizedTennisRating = 'normalizedTennisRating',
  /** column name */
  NormalizedTennisRatingScaleId = 'normalizedTennisRatingScaleId',
  /** column name */
  PadelSkillLevelId = 'padelSkillLevelId',
  /** column name */
  PciId = 'pciId',
  /** column name */
  PickleballSkillLevelId = 'pickleballSkillLevelId',
  /** column name */
  PprId = 'pprId',
  /** column name */
  PreferredName = 'preferredName',
  /** column name */
  PremiumContentDescription = 'premiumContentDescription',
  /** column name */
  PriceUnitAmountCoachDefault = 'priceUnitAmountCoachDefault',
  /** column name */
  PriceUnitAmountPremiumContentDefault = 'priceUnitAmountPremiumContentDefault',
  /** column name */
  PriceUnitAmountRemoteCoachDefault = 'priceUnitAmountRemoteCoachDefault',
  /** column name */
  ProfileImageFileName = 'profileImageFileName',
  /** column name */
  ProfileImagePath = 'profileImagePath',
  /** column name */
  ProfileImageProvider = 'profileImageProvider',
  /** column name */
  ProfileImageProviderId = 'profileImageProviderId',
  /** column name */
  ProfileImageProviderUrl = 'profileImageProviderUrl',
  /** column name */
  ProfileImageUrl = 'profileImageUrl',
  /** column name */
  QuatroPickleballMemberId = 'quatroPickleballMemberId',
  /** column name */
  StripeMerchantChargesEnabled = 'stripeMerchantChargesEnabled',
  /** column name */
  StripeMerchantCurrency = 'stripeMerchantCurrency',
  /** column name */
  StripeMerchantDetailsSubmitted = 'stripeMerchantDetailsSubmitted',
  /** column name */
  TennisRating = 'tennisRating',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  TennisSkillLevelId = 'tennisSkillLevelId',
  /** column name */
  TiktokUrl = 'tiktokUrl',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Username = 'username',
  /** column name */
  WebsiteUrl = 'websiteUrl',
  /** column name */
  XUrl = 'xUrl',
  /** column name */
  YoutubeUrl = 'youtubeUrl'
}

/** aggregate stddev on columns */
export type UserProfilesStddevFields = {
  __typename?: 'UserProfilesStddevFields';
  birthdayDay?: Maybe<Scalars['Float']>;
  birthdayMonth?: Maybe<Scalars['Float']>;
  birthdayYear?: Maybe<Scalars['Float']>;
  coachingStartYear?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type UserProfilesStddevPopFields = {
  __typename?: 'UserProfilesStddevPopFields';
  birthdayDay?: Maybe<Scalars['Float']>;
  birthdayMonth?: Maybe<Scalars['Float']>;
  birthdayYear?: Maybe<Scalars['Float']>;
  coachingStartYear?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type UserProfilesStddevSampFields = {
  __typename?: 'UserProfilesStddevSampFields';
  birthdayDay?: Maybe<Scalars['Float']>;
  birthdayMonth?: Maybe<Scalars['Float']>;
  birthdayYear?: Maybe<Scalars['Float']>;
  coachingStartYear?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_profiles" */
export type UserProfilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserProfilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserProfilesStreamCursorValueInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutMeVideoUrl?: InputMaybe<Scalars['String']>;
  activeCityId?: InputMaybe<Scalars['uuid']>;
  birthdayDay?: InputMaybe<Scalars['Int']>;
  birthdayMonth?: InputMaybe<Scalars['Int']>;
  birthdayVisibility?: InputMaybe<Scalars['String']>;
  birthdayYear?: InputMaybe<Scalars['Int']>;
  cityName?: InputMaybe<Scalars['String']>;
  coachExternalBookingUrl?: InputMaybe<Scalars['String']>;
  coachLessonDescription?: InputMaybe<Scalars['String']>;
  coachLessonHowToPrepare?: InputMaybe<Scalars['String']>;
  coachStatus?: InputMaybe<Scalars['String']>;
  coachingStartYear?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['String']>;
  countrySubdivisionId?: InputMaybe<Scalars['uuid']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currencyCoachDefault?: InputMaybe<Scalars['String']>;
  defaultCoachUserCustomCourtId?: InputMaybe<Scalars['uuid']>;
  defaultCoachVenueId?: InputMaybe<Scalars['uuid']>;
  defaultPickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  defaultSport?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  duprId?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  genderPreference?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  iptpaId?: InputMaybe<Scalars['String']>;
  isIptpaMember?: InputMaybe<Scalars['Boolean']>;
  isPciMember?: InputMaybe<Scalars['Boolean']>;
  isPicklrP4Member?: InputMaybe<Scalars['Boolean']>;
  isPprMember?: InputMaybe<Scalars['Boolean']>;
  isProfessionalRacquetRegistryActive?: InputMaybe<Scalars['Boolean']>;
  isQuatroPickleballMember?: InputMaybe<Scalars['Boolean']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  normalizedTennisRating?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  padelSkillLevelId?: InputMaybe<Scalars['String']>;
  pciId?: InputMaybe<Scalars['String']>;
  pickleballSkillLevelId?: InputMaybe<Scalars['String']>;
  pprId?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  premiumContentDescription?: InputMaybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<Scalars['Int']>;
  profileImageFileName?: InputMaybe<Scalars['String']>;
  profileImagePath?: InputMaybe<Scalars['String']>;
  profileImageProvider?: InputMaybe<Scalars['String']>;
  profileImageProviderId?: InputMaybe<Scalars['String']>;
  profileImageProviderUrl?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  quatroPickleballMemberId?: InputMaybe<Scalars['String']>;
  stripeMerchantChargesEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeMerchantCurrency?: InputMaybe<Scalars['String']>;
  stripeMerchantDetailsSubmitted?: InputMaybe<Scalars['Boolean']>;
  tennisRating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisSkillLevelId?: InputMaybe<Scalars['String']>;
  tiktokUrl?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  xUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UserProfilesSumFields = {
  __typename?: 'UserProfilesSumFields';
  birthdayDay?: Maybe<Scalars['Int']>;
  birthdayMonth?: Maybe<Scalars['Int']>;
  birthdayYear?: Maybe<Scalars['Int']>;
  coachingStartYear?: Maybe<Scalars['Int']>;
  normalizedTennisRating?: Maybe<Scalars['numeric']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Int']>;
  tennisRating?: Maybe<Scalars['numeric']>;
};

/** aggregate varPop on columns */
export type UserProfilesVarPopFields = {
  __typename?: 'UserProfilesVarPopFields';
  birthdayDay?: Maybe<Scalars['Float']>;
  birthdayMonth?: Maybe<Scalars['Float']>;
  birthdayYear?: Maybe<Scalars['Float']>;
  coachingStartYear?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type UserProfilesVarSampFields = {
  __typename?: 'UserProfilesVarSampFields';
  birthdayDay?: Maybe<Scalars['Float']>;
  birthdayMonth?: Maybe<Scalars['Float']>;
  birthdayYear?: Maybe<Scalars['Float']>;
  coachingStartYear?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserProfilesVarianceFields = {
  __typename?: 'UserProfilesVarianceFields';
  birthdayDay?: Maybe<Scalars['Float']>;
  birthdayMonth?: Maybe<Scalars['Float']>;
  birthdayYear?: Maybe<Scalars['Float']>;
  coachingStartYear?: Maybe<Scalars['Float']>;
  normalizedTennisRating?: Maybe<Scalars['Float']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Float']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Float']>;
  tennisRating?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_sports" */
export type UserSports = {
  __typename?: 'UserSports';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  sport: SportsEnum;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "user_sports" */
export type UserSportsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserSportsMaxOrderBy>;
  min?: InputMaybe<UserSportsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "user_sports". All fields are combined with a logical 'AND'. */
export type UserSportsBoolExp = {
  _and?: InputMaybe<Array<UserSportsBoolExp>>;
  _not?: InputMaybe<UserSportsBoolExp>;
  _or?: InputMaybe<Array<UserSportsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_sports" */
export enum UserSportsConstraint {
  /** unique or primary key constraint on columns "id" */
  UserSportsPkey = 'user_sports_pkey',
  /** unique or primary key constraint on columns "sport", "user_id" */
  UserSportsUserIdSportKey = 'user_sports_user_id_sport_key'
}

/** input type for inserting data into table "user_sports" */
export type UserSportsInsertInput = {
  sport?: InputMaybe<SportsEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_sports" */
export type UserSportsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_sports" */
export type UserSportsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_sports" */
export type UserSportsMutationResponse = {
  __typename?: 'UserSportsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserSports>;
};

/** on_conflict condition type for table "user_sports" */
export type UserSportsOnConflict = {
  constraint: UserSportsConstraint;
  updateColumns?: Array<UserSportsUpdateColumn>;
  where?: InputMaybe<UserSportsBoolExp>;
};

/** Ordering options when selecting data from "user_sports". */
export type UserSportsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sport?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_sports */
export type UserSportsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_sports" */
export enum UserSportsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Sport = 'sport',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_sports" */
export type UserSportsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "user_sports" */
export type UserSportsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserSportsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserSportsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  sport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_sports" */
export enum UserSportsUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt'
}

export type UserSportsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserSportsSetInput>;
  /** filter the rows which have to be updated */
  where: UserSportsBoolExp;
};

/** columns and relationships of "user_tennis_rating_scales" */
export type UserTennisRatingScales = {
  __typename?: 'UserTennisRatingScales';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  rating: Scalars['numeric'];
  /** An object relationship */
  scale: TennisRatingScales;
  tennisRatingScaleId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesAggregateOrderBy = {
  avg?: InputMaybe<UserTennisRatingScalesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserTennisRatingScalesMaxOrderBy>;
  min?: InputMaybe<UserTennisRatingScalesMinOrderBy>;
  stddev?: InputMaybe<UserTennisRatingScalesStddevOrderBy>;
  stddevPop?: InputMaybe<UserTennisRatingScalesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserTennisRatingScalesStddevSampOrderBy>;
  sum?: InputMaybe<UserTennisRatingScalesSumOrderBy>;
  varPop?: InputMaybe<UserTennisRatingScalesVarPopOrderBy>;
  varSamp?: InputMaybe<UserTennisRatingScalesVarSampOrderBy>;
  variance?: InputMaybe<UserTennisRatingScalesVarianceOrderBy>;
};

/** order by avg() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesAvgOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_tennis_rating_scales". All fields are combined with a logical 'AND'. */
export type UserTennisRatingScalesBoolExp = {
  _and?: InputMaybe<Array<UserTennisRatingScalesBoolExp>>;
  _not?: InputMaybe<UserTennisRatingScalesBoolExp>;
  _or?: InputMaybe<Array<UserTennisRatingScalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  rating?: InputMaybe<NumericComparisonExp>;
  scale?: InputMaybe<TennisRatingScalesBoolExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_tennis_rating_scales" */
export enum UserTennisRatingScalesConstraint {
  /** unique or primary key constraint on columns "id" */
  UserTennisRatingScalesPkey = 'user_tennis_rating_scales_pkey',
  /** unique or primary key constraint on columns "tennis_rating_scale_id", "user_id" */
  UserTennisRatingScalesUserIdTennisRatingScaleIdKey = 'user_tennis_rating_scales_user_id_tennis_rating_scale_id_key'
}

/** input type for incrementing numeric columns in table "user_tennis_rating_scales" */
export type UserTennisRatingScalesIncInput = {
  rating?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "user_tennis_rating_scales" */
export type UserTennisRatingScalesInsertInput = {
  rating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_tennis_rating_scales" */
export type UserTennisRatingScalesMutationResponse = {
  __typename?: 'UserTennisRatingScalesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserTennisRatingScales>;
};

/** on_conflict condition type for table "user_tennis_rating_scales" */
export type UserTennisRatingScalesOnConflict = {
  constraint: UserTennisRatingScalesConstraint;
  updateColumns?: Array<UserTennisRatingScalesUpdateColumn>;
  where?: InputMaybe<UserTennisRatingScalesBoolExp>;
};

/** Ordering options when selecting data from "user_tennis_rating_scales". */
export type UserTennisRatingScalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  scale?: InputMaybe<TennisRatingScalesOrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_tennis_rating_scales */
export type UserTennisRatingScalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user_tennis_rating_scales" */
export enum UserTennisRatingScalesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Rating = 'rating',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_tennis_rating_scales" */
export type UserTennisRatingScalesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  rating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
};

/** order by stddev() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesStddevOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesStddevPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesStddevSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_tennis_rating_scales" */
export type UserTennisRatingScalesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserTennisRatingScalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserTennisRatingScalesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesSumOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** update columns of table "user_tennis_rating_scales" */
export enum UserTennisRatingScalesUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Rating = 'rating',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId'
}

export type UserTennisRatingScalesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserTennisRatingScalesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserTennisRatingScalesSetInput>;
  /** filter the rows which have to be updated */
  where: UserTennisRatingScalesBoolExp;
};

/** order by varPop() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesVarPopOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesVarSampOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "user_tennis_rating_scales" */
export type UserTennisRatingScalesVarianceOrderBy = {
  rating?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_terms_of_service" */
export type UserTermsOfService = {
  __typename?: 'UserTermsOfService';
  acceptedAt: Scalars['timestamptz'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  ip: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userAgent: Scalars['String'];
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "user_terms_of_service" */
export type UserTermsOfServiceAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserTermsOfServiceMaxOrderBy>;
  min?: InputMaybe<UserTermsOfServiceMinOrderBy>;
};

/** Boolean expression to filter rows from the table "user_terms_of_service". All fields are combined with a logical 'AND'. */
export type UserTermsOfServiceBoolExp = {
  _and?: InputMaybe<Array<UserTermsOfServiceBoolExp>>;
  _not?: InputMaybe<UserTermsOfServiceBoolExp>;
  _or?: InputMaybe<Array<UserTermsOfServiceBoolExp>>;
  acceptedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  ip?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userAgent?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_terms_of_service" */
export enum UserTermsOfServiceConstraint {
  /** unique or primary key constraint on columns "id" */
  UserTermsOfServicePkey = 'user_terms_of_service_pkey'
}

/** input type for inserting data into table "user_terms_of_service" */
export type UserTermsOfServiceInsertInput = {
  acceptedAt?: InputMaybe<Scalars['timestamptz']>;
  ip?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_terms_of_service" */
export type UserTermsOfServiceMaxOrderBy = {
  acceptedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userAgent?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_terms_of_service" */
export type UserTermsOfServiceMinOrderBy = {
  acceptedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userAgent?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_terms_of_service" */
export type UserTermsOfServiceMutationResponse = {
  __typename?: 'UserTermsOfServiceMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserTermsOfService>;
};

/** on_conflict condition type for table "user_terms_of_service" */
export type UserTermsOfServiceOnConflict = {
  constraint: UserTermsOfServiceConstraint;
  updateColumns?: Array<UserTermsOfServiceUpdateColumn>;
  where?: InputMaybe<UserTermsOfServiceBoolExp>;
};

/** Ordering options when selecting data from "user_terms_of_service". */
export type UserTermsOfServiceOrderBy = {
  acceptedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ip?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userAgent?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "user_terms_of_service" */
export enum UserTermsOfServiceSelectColumn {
  /** column name */
  AcceptedAt = 'acceptedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAgent = 'userAgent',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "user_terms_of_service" */
export type UserTermsOfServiceStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserTermsOfServiceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserTermsOfServiceStreamCursorValueInput = {
  acceptedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** placeholder for update columns of table "user_terms_of_service" (current role has no relevant permissions) */
export enum UserTermsOfServiceUpdateColumn {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "user_vair_connections" */
export type UserVairConnections = {
  __typename?: 'UserVairConnections';
  clerkId?: Maybe<Scalars['String']>;
  connectedAt: Scalars['timestamptz'];
  email: Scalars['String'];
  id: Scalars['uuid'];
  lastSyncedAt: Scalars['timestamptz'];
  memberId: Scalars['String'];
  name: Scalars['String'];
  userId: Scalars['uuid'];
};

/** Boolean expression to filter rows from the table "user_vair_connections". All fields are combined with a logical 'AND'. */
export type UserVairConnectionsBoolExp = {
  _and?: InputMaybe<Array<UserVairConnectionsBoolExp>>;
  _not?: InputMaybe<UserVairConnectionsBoolExp>;
  _or?: InputMaybe<Array<UserVairConnectionsBoolExp>>;
  clerkId?: InputMaybe<StringComparisonExp>;
  connectedAt?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lastSyncedAt?: InputMaybe<TimestamptzComparisonExp>;
  memberId?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** Ordering options when selecting data from "user_vair_connections". */
export type UserVairConnectionsOrderBy = {
  clerkId?: InputMaybe<OrderBy>;
  connectedAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSyncedAt?: InputMaybe<OrderBy>;
  memberId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "user_vair_connections" */
export enum UserVairConnectionsSelectColumn {
  /** column name */
  ClerkId = 'clerkId',
  /** column name */
  ConnectedAt = 'connectedAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  LastSyncedAt = 'lastSyncedAt',
  /** column name */
  MemberId = 'memberId',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'userId'
}

/** Streaming cursor of the table "user_vair_connections" */
export type UserVairConnectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserVairConnectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserVairConnectionsStreamCursorValueInput = {
  clerkId?: InputMaybe<Scalars['String']>;
  connectedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastSyncedAt?: InputMaybe<Scalars['timestamptz']>;
  memberId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "usernames_active" */
export type UsernamesActive = {
  __typename?: 'UsernamesActive';
  username?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "usernames_active". All fields are combined with a logical 'AND'. */
export type UsernamesActiveBoolExp = {
  _and?: InputMaybe<Array<UsernamesActiveBoolExp>>;
  _not?: InputMaybe<UsernamesActiveBoolExp>;
  _or?: InputMaybe<Array<UsernamesActiveBoolExp>>;
  username?: InputMaybe<StringComparisonExp>;
};

/** Ordering options when selecting data from "usernames_active". */
export type UsernamesActiveOrderBy = {
  username?: InputMaybe<OrderBy>;
};

/** select columns of table "usernames_active" */
export enum UsernamesActiveSelectColumn {
  /** column name */
  Username = 'username'
}

/** Streaming cursor of the table "usernames_active" */
export type UsernamesActiveStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UsernamesActiveStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsernamesActiveStreamCursorValueInput = {
  username?: InputMaybe<Scalars['String']>;
};

/** This table prevents reserved words from being used or old usernames being claimed for where identity takeover can happen */
export type UsernamesClaimed = {
  __typename?: 'UsernamesClaimed';
  id: Scalars['uuid'];
  username: Scalars['String'];
};

/** order by aggregate values of table "usernames_claimed" */
export type UsernamesClaimedAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UsernamesClaimedMaxOrderBy>;
  min?: InputMaybe<UsernamesClaimedMinOrderBy>;
};

/** Boolean expression to filter rows from the table "usernames_claimed". All fields are combined with a logical 'AND'. */
export type UsernamesClaimedBoolExp = {
  _and?: InputMaybe<Array<UsernamesClaimedBoolExp>>;
  _not?: InputMaybe<UsernamesClaimedBoolExp>;
  _or?: InputMaybe<Array<UsernamesClaimedBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  username?: InputMaybe<StringComparisonExp>;
};

/** order by max() on columns of table "usernames_claimed" */
export type UsernamesClaimedMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "usernames_claimed" */
export type UsernamesClaimedMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "usernames_claimed". */
export type UsernamesClaimedOrderBy = {
  id?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** select columns of table "usernames_claimed" */
export enum UsernamesClaimedSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Username = 'username'
}

/** Streaming cursor of the table "usernames_claimed" */
export type UsernamesClaimedStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UsernamesClaimedStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsernamesClaimedStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
  username?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'Users';
  aboutMe?: Maybe<Scalars['String']>;
  aboutMeVideoUrl: Scalars['String'];
  /** An object relationship */
  activeCity?: Maybe<Cities>;
  activeCityId?: Maybe<Scalars['uuid']>;
  adminVenueId?: Maybe<Scalars['uuid']>;
  birthday?: Maybe<Scalars['date']>;
  birthdayVisibility: BirthdayVisibilityEnum;
  cityName: Scalars['String'];
  /** An array relationship */
  coachAvailability: Array<CoachAvailability>;
  coachExternalBookingUrl?: Maybe<Scalars['String']>;
  /** An array relationship */
  coachFaqs: Array<CoachFaqs>;
  /** An array relationship */
  coachLessonAgeGroups: Array<CoachLessonAgeGroups>;
  coachLessonDescription?: Maybe<Scalars['String']>;
  coachLessonHowToPrepare?: Maybe<Scalars['String']>;
  /** An array relationship */
  coachLessonReflections: Array<LessonReflections>;
  /** An array relationship */
  coachLessonSkillLevels: Array<CoachLessonSkillLevels>;
  /** An array relationship */
  coachLessons: Array<Lessons>;
  /** An aggregate relationship */
  coachLessonsAggregate: LessonsAggregate;
  /** An array relationship */
  coachQualifications: Array<UsersCoachQualifications>;
  /** An array relationship */
  coachServices: Array<UserCoachServices>;
  /** An array relationship */
  coachSports: Array<CoachSports>;
  coachStatus?: Maybe<CoachStatusEnum>;
  coachStatusUpdatedAt?: Maybe<Scalars['timestamptz']>;
  coachingStartYear?: Maybe<Scalars['Int']>;
  /** An object relationship */
  communicationPreferences?: Maybe<UserCommunicationPreferences>;
  /** An object relationship */
  country?: Maybe<Countries>;
  countryId?: Maybe<Scalars['String']>;
  /** An object relationship */
  countrySubdivision?: Maybe<CountrySubdivisions>;
  countrySubdivisionId?: Maybe<Scalars['uuid']>;
  coverImageFileName: Scalars['String'];
  coverImagePath: Scalars['String'];
  coverImageProvider: Scalars['String'];
  coverImageProviderId: Scalars['String'];
  coverImageProviderUrl: Scalars['String'];
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  coverImageUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  creditCards: Array<UserCreditCards>;
  currencyCoachDefault: Scalars['String'];
  /** An array relationship */
  customCourts: Array<UserCustomCourts>;
  /** An object relationship */
  defaultCoachCustomCourt?: Maybe<UserCustomCourts>;
  defaultCoachPaymentFulfillmentChannel?: Maybe<PaymentFulfillmentChannelsEnum>;
  defaultCoachUserCustomCourtId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  defaultCoachVenue?: Maybe<Venues>;
  defaultCoachVenueId?: Maybe<Scalars['uuid']>;
  defaultCreditCardId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  defaultPickleballRatingScale?: Maybe<PickleballRatingScales>;
  defaultPickleballRatingScaleId?: Maybe<Scalars['uuid']>;
  defaultSport?: Maybe<SportsEnum>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  derfaultCreditCard?: Maybe<UserCreditCards>;
  didSkipStripeSetup: Scalars['Boolean'];
  duprId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  eventOrganizerAccountType: EventOrganizerAccountTypesEnum;
  facebookUrl?: Maybe<Scalars['String']>;
  firebaseId: Scalars['String'];
  /** An array relationship */
  followers: Array<UserFollows>;
  /** An aggregate relationship */
  followersAggregate: UserFollowsAggregate;
  /** An array relationship */
  following: Array<UserFollows>;
  /** An aggregate relationship */
  followingAggregate: UserFollowsAggregate;
  fullName: Scalars['String'];
  gender?: Maybe<GenderEnum>;
  genderPreference: Scalars['String'];
  geometry?: Maybe<Scalars['geography']>;
  /** An array relationship */
  groups: Array<GroupMembers>;
  /** An aggregate relationship */
  groupsAggregate: GroupMembersAggregate;
  id: Scalars['uuid'];
  instagramUrl?: Maybe<Scalars['String']>;
  iptpaId?: Maybe<Scalars['String']>;
  isIptpaMember: Scalars['Boolean'];
  isMarketingRegistered?: Maybe<Scalars['Boolean']>;
  isOnboardComplete: Scalars['Boolean'];
  isPciMember: Scalars['Boolean'];
  isPendingAccountDetails?: Maybe<Scalars['Boolean']>;
  isPicklrP4Member: Scalars['Boolean'];
  isPprMember: Scalars['Boolean'];
  isProfessionalRacquetRegistryActive: Scalars['Boolean'];
  isProfessionalRacquetRegistryInvite: Scalars['Boolean'];
  isQuatroPickleballMember: Scalars['Boolean'];
  isRemoteCoachingEnabled?: Maybe<Scalars['Boolean']>;
  isSafePlayCertified?: Maybe<Scalars['Boolean']>;
  lastLoginAt?: Maybe<Scalars['timestamptz']>;
  lastSessionAt?: Maybe<Scalars['timestamptz']>;
  latestAuthProvider: Scalars['String'];
  latitude?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  lessonTemplates: Array<LessonTemplates>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  normalizedTennisRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  normalizedTennisRatingScale?: Maybe<TennisRatingScales>;
  normalizedTennisRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  notifications: Array<UserNotifications>;
  /** An aggregate relationship */
  notificationsAggregate: UserNotificationsAggregate;
  originalAuthProvider: Scalars['String'];
  padelSkillLevelId?: Maybe<Scalars['String']>;
  /** An array relationship */
  paidInvoices: Array<Invoices>;
  /** An array relationship */
  participantLessons: Array<LessonParticipants>;
  /** An aggregate relationship */
  participantLessonsAggregate: LessonParticipantsAggregate;
  pciId?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneVerifiedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  pickleballRatingScales: Array<UserPickleballRatingScales>;
  /** An object relationship */
  pickleballSkillLevel?: Maybe<SkillLevels>;
  pickleballSkillLevelId?: Maybe<Scalars['String']>;
  /** An array relationship */
  platformSubscriptions: Array<PlatformSubscriptions>;
  playerFinderOnboardedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  playerLessonReflections: Array<LessonReflections>;
  pprId?: Maybe<Scalars['String']>;
  preferredName: Scalars['String'];
  premiumContentDescription?: Maybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: Maybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: Maybe<Scalars['Int']>;
  professionalRacquetRegistryId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  profile?: Maybe<UserProfiles>;
  profileImageFileName: Scalars['String'];
  profileImagePath: Scalars['String'];
  profileImageProvider: Scalars['String'];
  profileImageProviderId: Scalars['String'];
  profileImageProviderUrl: Scalars['String'];
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  profileImageUrl: Scalars['String'];
  /** An array relationship */
  purchases: Array<Sales>;
  quatroPickleballMemberId?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  stripeMerchantBusinessType?: Maybe<Scalars['String']>;
  stripeMerchantChargesEnabled: Scalars['Boolean'];
  stripeMerchantCountry?: Maybe<Scalars['String']>;
  stripeMerchantCurrency?: Maybe<Scalars['String']>;
  stripeMerchantCurrentlyDue?: Maybe<Scalars['jsonb']>;
  stripeMerchantDetailsSubmitted: Scalars['Boolean'];
  stripeMerchantEventuallyDue?: Maybe<Scalars['jsonb']>;
  stripeMerchantId?: Maybe<Scalars['String']>;
  stripeMerchantPastDue?: Maybe<Scalars['jsonb']>;
  stripeMerchantPayoutsEnabled: Scalars['Boolean'];
  tennisRating?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  tennisRatingScale?: Maybe<TennisRatingScales>;
  tennisRatingScaleId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  tennisSkillLevel?: Maybe<SkillLevels>;
  tennisSkillLevelId?: Maybe<Scalars['String']>;
  /** An array relationship */
  termsOfService: Array<UserTermsOfService>;
  tiktokUrl: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  userFiles: Array<UserFiles>;
  /** An object relationship */
  userVairConnection?: Maybe<UserVairConnections>;
  username?: Maybe<Scalars['String']>;
  /** An array relationship */
  usernamesClaimed: Array<UsernamesClaimed>;
  /** An array relationship */
  venueStaffRosters: Array<VenueStaffCoaches>;
  /** An aggregate relationship */
  venueStaffRostersAggregate: VenueStaffCoachesAggregate;
  /** An array relationship */
  videoAnalysisFiles: Array<VideoAnalysisFiles>;
  /** An array relationship */
  videoAnalysisReviewer: Array<VideoAnalysis>;
  /** An aggregate relationship */
  videoAnalysisReviewerAggregate: VideoAnalysisAggregate;
  /** An array relationship */
  videoAnalysisSubmission: Array<VideoAnalysis>;
  /** An aggregate relationship */
  videoAnalysisSubmissionAggregate: VideoAnalysisAggregate;
  websiteUrl?: Maybe<Scalars['String']>;
  xUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersCoachAvailabilityArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityOrderBy>>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachFaqsArgs = {
  distinctOn?: InputMaybe<Array<CoachFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachFaqsOrderBy>>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachLessonAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonAgeGroupsOrderBy>>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachLessonReflectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachLessonSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonSkillLevelsOrderBy>>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachQualificationsArgs = {
  distinctOn?: InputMaybe<Array<UsersCoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersCoachQualificationsOrderBy>>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachServicesArgs = {
  distinctOn?: InputMaybe<Array<UserCoachServicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCoachServicesOrderBy>>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCoachSportsArgs = {
  distinctOn?: InputMaybe<Array<CoachSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportsOrderBy>>;
  where?: InputMaybe<CoachSportsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCreditCardsArgs = {
  distinctOn?: InputMaybe<Array<UserCreditCardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCreditCardsOrderBy>>;
  where?: InputMaybe<UserCreditCardsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCustomCourtsArgs = {
  distinctOn?: InputMaybe<Array<UserCustomCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCustomCourtsOrderBy>>;
  where?: InputMaybe<UserCustomCourtsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersFollowersArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersFollowersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersFollowingArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersFollowingAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersGroupsArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


/** columns and relationships of "users" */
export type UsersGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


/** columns and relationships of "users" */
export type UsersLessonTemplatesArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplatesOrderBy>>;
  where?: InputMaybe<LessonTemplatesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersNotificationsArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersNotificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPaidInvoicesArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersParticipantLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersParticipantLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPickleballRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserPickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPickleballRatingScalesOrderBy>>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPlatformSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPlayerLessonReflectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersPurchasesArgs = {
  distinctOn?: InputMaybe<Array<SalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SalesOrderBy>>;
  where?: InputMaybe<SalesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersStripeMerchantCurrentlyDueArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersStripeMerchantEventuallyDueArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersStripeMerchantPastDueArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersTermsOfServiceArgs = {
  distinctOn?: InputMaybe<Array<UserTermsOfServiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTermsOfServiceOrderBy>>;
  where?: InputMaybe<UserTermsOfServiceBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUserFilesArgs = {
  distinctOn?: InputMaybe<Array<UserFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFilesOrderBy>>;
  where?: InputMaybe<UserFilesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUsernamesClaimedArgs = {
  distinctOn?: InputMaybe<Array<UsernamesClaimedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesClaimedOrderBy>>;
  where?: InputMaybe<UsernamesClaimedBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVenueStaffRostersArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVenueStaffRostersAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVideoAnalysisFilesArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisFilesOrderBy>>;
  where?: InputMaybe<VideoAnalysisFilesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVideoAnalysisReviewerArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVideoAnalysisReviewerAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVideoAnalysisSubmissionArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


/** columns and relationships of "users" */
export type UsersVideoAnalysisSubmissionAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};

/** order by aggregate values of table "users" */
export type UsersAggregateOrderBy = {
  avg?: InputMaybe<UsersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UsersMaxOrderBy>;
  min?: InputMaybe<UsersMinOrderBy>;
  stddev?: InputMaybe<UsersStddevOrderBy>;
  stddevPop?: InputMaybe<UsersStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UsersStddevSampOrderBy>;
  sum?: InputMaybe<UsersSumOrderBy>;
  varPop?: InputMaybe<UsersVarPopOrderBy>;
  varSamp?: InputMaybe<UsersVarSampOrderBy>;
  variance?: InputMaybe<UsersVarianceOrderBy>;
};

/** order by avg() on columns of table "users" */
export type UsersAvgOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: InputMaybe<Array<UsersBoolExp>>;
  _not?: InputMaybe<UsersBoolExp>;
  _or?: InputMaybe<Array<UsersBoolExp>>;
  aboutMe?: InputMaybe<StringComparisonExp>;
  aboutMeVideoUrl?: InputMaybe<StringComparisonExp>;
  activeCity?: InputMaybe<CitiesBoolExp>;
  activeCityId?: InputMaybe<UuidComparisonExp>;
  adminVenueId?: InputMaybe<UuidComparisonExp>;
  birthday?: InputMaybe<DateComparisonExp>;
  birthdayVisibility?: InputMaybe<BirthdayVisibilityEnumComparisonExp>;
  cityName?: InputMaybe<StringComparisonExp>;
  coachAvailability?: InputMaybe<CoachAvailabilityBoolExp>;
  coachExternalBookingUrl?: InputMaybe<StringComparisonExp>;
  coachFaqs?: InputMaybe<CoachFaqsBoolExp>;
  coachLessonAgeGroups?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
  coachLessonDescription?: InputMaybe<StringComparisonExp>;
  coachLessonHowToPrepare?: InputMaybe<StringComparisonExp>;
  coachLessonReflections?: InputMaybe<LessonReflectionsBoolExp>;
  coachLessonSkillLevels?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
  coachLessons?: InputMaybe<LessonsBoolExp>;
  coachLessonsAggregate?: InputMaybe<LessonsAggregateBoolExp>;
  coachQualifications?: InputMaybe<UsersCoachQualificationsBoolExp>;
  coachServices?: InputMaybe<UserCoachServicesBoolExp>;
  coachSports?: InputMaybe<CoachSportsBoolExp>;
  coachStatus?: InputMaybe<CoachStatusEnumComparisonExp>;
  coachStatusUpdatedAt?: InputMaybe<TimestamptzComparisonExp>;
  coachingStartYear?: InputMaybe<IntComparisonExp>;
  communicationPreferences?: InputMaybe<UserCommunicationPreferencesBoolExp>;
  country?: InputMaybe<CountriesBoolExp>;
  countryId?: InputMaybe<StringComparisonExp>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsBoolExp>;
  countrySubdivisionId?: InputMaybe<UuidComparisonExp>;
  coverImageFileName?: InputMaybe<StringComparisonExp>;
  coverImagePath?: InputMaybe<StringComparisonExp>;
  coverImageProvider?: InputMaybe<StringComparisonExp>;
  coverImageProviderId?: InputMaybe<StringComparisonExp>;
  coverImageProviderUrl?: InputMaybe<StringComparisonExp>;
  coverImageUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  creditCards?: InputMaybe<UserCreditCardsBoolExp>;
  currencyCoachDefault?: InputMaybe<StringComparisonExp>;
  customCourts?: InputMaybe<UserCustomCourtsBoolExp>;
  defaultCoachCustomCourt?: InputMaybe<UserCustomCourtsBoolExp>;
  defaultCoachPaymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnumComparisonExp>;
  defaultCoachUserCustomCourtId?: InputMaybe<UuidComparisonExp>;
  defaultCoachVenue?: InputMaybe<VenuesBoolExp>;
  defaultCoachVenueId?: InputMaybe<UuidComparisonExp>;
  defaultCreditCardId?: InputMaybe<UuidComparisonExp>;
  defaultPickleballRatingScale?: InputMaybe<PickleballRatingScalesBoolExp>;
  defaultPickleballRatingScaleId?: InputMaybe<UuidComparisonExp>;
  defaultSport?: InputMaybe<SportsEnumComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  derfaultCreditCard?: InputMaybe<UserCreditCardsBoolExp>;
  didSkipStripeSetup?: InputMaybe<BooleanComparisonExp>;
  duprId?: InputMaybe<StringComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  eventOrganizerAccountType?: InputMaybe<EventOrganizerAccountTypesEnumComparisonExp>;
  facebookUrl?: InputMaybe<StringComparisonExp>;
  firebaseId?: InputMaybe<StringComparisonExp>;
  followers?: InputMaybe<UserFollowsBoolExp>;
  followersAggregate?: InputMaybe<UserFollowsAggregateBoolExp>;
  following?: InputMaybe<UserFollowsBoolExp>;
  followingAggregate?: InputMaybe<UserFollowsAggregateBoolExp>;
  fullName?: InputMaybe<StringComparisonExp>;
  gender?: InputMaybe<GenderEnumComparisonExp>;
  genderPreference?: InputMaybe<StringComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  groups?: InputMaybe<GroupMembersBoolExp>;
  groupsAggregate?: InputMaybe<GroupMembersAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  instagramUrl?: InputMaybe<StringComparisonExp>;
  iptpaId?: InputMaybe<StringComparisonExp>;
  isIptpaMember?: InputMaybe<BooleanComparisonExp>;
  isMarketingRegistered?: InputMaybe<BooleanComparisonExp>;
  isOnboardComplete?: InputMaybe<BooleanComparisonExp>;
  isPciMember?: InputMaybe<BooleanComparisonExp>;
  isPendingAccountDetails?: InputMaybe<BooleanComparisonExp>;
  isPicklrP4Member?: InputMaybe<BooleanComparisonExp>;
  isPprMember?: InputMaybe<BooleanComparisonExp>;
  isProfessionalRacquetRegistryActive?: InputMaybe<BooleanComparisonExp>;
  isProfessionalRacquetRegistryInvite?: InputMaybe<BooleanComparisonExp>;
  isQuatroPickleballMember?: InputMaybe<BooleanComparisonExp>;
  isRemoteCoachingEnabled?: InputMaybe<BooleanComparisonExp>;
  isSafePlayCertified?: InputMaybe<BooleanComparisonExp>;
  lastLoginAt?: InputMaybe<TimestamptzComparisonExp>;
  lastSessionAt?: InputMaybe<TimestamptzComparisonExp>;
  latestAuthProvider?: InputMaybe<StringComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  lessonTemplates?: InputMaybe<LessonTemplatesBoolExp>;
  linkedinUrl?: InputMaybe<StringComparisonExp>;
  locale?: InputMaybe<StringComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  normalizedTennisRating?: InputMaybe<NumericComparisonExp>;
  normalizedTennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  normalizedTennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  notifications?: InputMaybe<UserNotificationsBoolExp>;
  notificationsAggregate?: InputMaybe<UserNotificationsAggregateBoolExp>;
  originalAuthProvider?: InputMaybe<StringComparisonExp>;
  padelSkillLevelId?: InputMaybe<StringComparisonExp>;
  paidInvoices?: InputMaybe<InvoicesBoolExp>;
  participantLessons?: InputMaybe<LessonParticipantsBoolExp>;
  participantLessonsAggregate?: InputMaybe<LessonParticipantsAggregateBoolExp>;
  pciId?: InputMaybe<StringComparisonExp>;
  phoneCountryCode?: InputMaybe<StringComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  phoneVerifiedAt?: InputMaybe<TimestamptzComparisonExp>;
  pickleballRatingScales?: InputMaybe<UserPickleballRatingScalesBoolExp>;
  pickleballSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  pickleballSkillLevelId?: InputMaybe<StringComparisonExp>;
  platformSubscriptions?: InputMaybe<PlatformSubscriptionsBoolExp>;
  playerFinderOnboardedAt?: InputMaybe<TimestamptzComparisonExp>;
  playerLessonReflections?: InputMaybe<LessonReflectionsBoolExp>;
  pprId?: InputMaybe<StringComparisonExp>;
  preferredName?: InputMaybe<StringComparisonExp>;
  premiumContentDescription?: InputMaybe<StringComparisonExp>;
  priceUnitAmountCoachDefault?: InputMaybe<IntComparisonExp>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<IntComparisonExp>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<IntComparisonExp>;
  professionalRacquetRegistryId?: InputMaybe<IntComparisonExp>;
  profile?: InputMaybe<UserProfilesBoolExp>;
  profileImageFileName?: InputMaybe<StringComparisonExp>;
  profileImagePath?: InputMaybe<StringComparisonExp>;
  profileImageProvider?: InputMaybe<StringComparisonExp>;
  profileImageProviderId?: InputMaybe<StringComparisonExp>;
  profileImageProviderUrl?: InputMaybe<StringComparisonExp>;
  profileImageUrl?: InputMaybe<StringComparisonExp>;
  purchases?: InputMaybe<SalesBoolExp>;
  quatroPickleballMemberId?: InputMaybe<StringComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripeMerchantBusinessType?: InputMaybe<StringComparisonExp>;
  stripeMerchantChargesEnabled?: InputMaybe<BooleanComparisonExp>;
  stripeMerchantCountry?: InputMaybe<StringComparisonExp>;
  stripeMerchantCurrency?: InputMaybe<StringComparisonExp>;
  stripeMerchantCurrentlyDue?: InputMaybe<JsonbComparisonExp>;
  stripeMerchantDetailsSubmitted?: InputMaybe<BooleanComparisonExp>;
  stripeMerchantEventuallyDue?: InputMaybe<JsonbComparisonExp>;
  stripeMerchantId?: InputMaybe<StringComparisonExp>;
  stripeMerchantPastDue?: InputMaybe<JsonbComparisonExp>;
  stripeMerchantPayoutsEnabled?: InputMaybe<BooleanComparisonExp>;
  tennisRating?: InputMaybe<NumericComparisonExp>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesBoolExp>;
  tennisRatingScaleId?: InputMaybe<UuidComparisonExp>;
  tennisSkillLevel?: InputMaybe<SkillLevelsBoolExp>;
  tennisSkillLevelId?: InputMaybe<StringComparisonExp>;
  termsOfService?: InputMaybe<UserTermsOfServiceBoolExp>;
  tiktokUrl?: InputMaybe<StringComparisonExp>;
  timezone?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userFiles?: InputMaybe<UserFilesBoolExp>;
  userVairConnection?: InputMaybe<UserVairConnectionsBoolExp>;
  username?: InputMaybe<StringComparisonExp>;
  usernamesClaimed?: InputMaybe<UsernamesClaimedBoolExp>;
  venueStaffRosters?: InputMaybe<VenueStaffCoachesBoolExp>;
  venueStaffRostersAggregate?: InputMaybe<VenueStaffCoachesAggregateBoolExp>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesBoolExp>;
  videoAnalysisReviewer?: InputMaybe<VideoAnalysisBoolExp>;
  videoAnalysisReviewerAggregate?: InputMaybe<VideoAnalysisAggregateBoolExp>;
  videoAnalysisSubmission?: InputMaybe<VideoAnalysisBoolExp>;
  videoAnalysisSubmissionAggregate?: InputMaybe<VideoAnalysisAggregateBoolExp>;
  websiteUrl?: InputMaybe<StringComparisonExp>;
  xUrl?: InputMaybe<StringComparisonExp>;
  youtubeUrl?: InputMaybe<StringComparisonExp>;
};

/** columns and relationships of "users_coach_qualifications" */
export type UsersCoachQualifications = {
  __typename?: 'UsersCoachQualifications';
  coachQualificationId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  qualification: CoachQualifications;
  status: CoachQualificationStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "users_coach_qualifications" */
export type UsersCoachQualificationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UsersCoachQualificationsMaxOrderBy>;
  min?: InputMaybe<UsersCoachQualificationsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "users_coach_qualifications". All fields are combined with a logical 'AND'. */
export type UsersCoachQualificationsBoolExp = {
  _and?: InputMaybe<Array<UsersCoachQualificationsBoolExp>>;
  _not?: InputMaybe<UsersCoachQualificationsBoolExp>;
  _or?: InputMaybe<Array<UsersCoachQualificationsBoolExp>>;
  coachQualificationId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  qualification?: InputMaybe<CoachQualificationsBoolExp>;
  status?: InputMaybe<CoachQualificationStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "users_coach_qualifications" */
export enum UsersCoachQualificationsConstraint {
  /** unique or primary key constraint on columns "id" */
  UsersCoachQualificationsPkey = 'users_coach_qualifications_pkey',
  /** unique or primary key constraint on columns "user_id", "coach_qualification_id" */
  UsersCoachQualificationsUserIdCoachQualificationIdKey = 'users_coach_qualifications_user_id_coach_qualification_id_key'
}

/** input type for inserting data into table "users_coach_qualifications" */
export type UsersCoachQualificationsInsertInput = {
  coachQualificationId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<CoachQualificationStatusesEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "users_coach_qualifications" */
export type UsersCoachQualificationsMaxOrderBy = {
  coachQualificationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "users_coach_qualifications" */
export type UsersCoachQualificationsMinOrderBy = {
  coachQualificationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "users_coach_qualifications" */
export type UsersCoachQualificationsMutationResponse = {
  __typename?: 'UsersCoachQualificationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsersCoachQualifications>;
};

/** on_conflict condition type for table "users_coach_qualifications" */
export type UsersCoachQualificationsOnConflict = {
  constraint: UsersCoachQualificationsConstraint;
  updateColumns?: Array<UsersCoachQualificationsUpdateColumn>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};

/** Ordering options when selecting data from "users_coach_qualifications". */
export type UsersCoachQualificationsOrderBy = {
  coachQualificationId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  qualification?: InputMaybe<CoachQualificationsOrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: users_coach_qualifications */
export type UsersCoachQualificationsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "users_coach_qualifications" */
export enum UsersCoachQualificationsSelectColumn {
  /** column name */
  CoachQualificationId = 'coachQualificationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "users_coach_qualifications" */
export type UsersCoachQualificationsSetInput = {
  status?: InputMaybe<CoachQualificationStatusesEnum>;
};

/** Streaming cursor of the table "users_coach_qualifications" */
export type UsersCoachQualificationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UsersCoachQualificationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersCoachQualificationsStreamCursorValueInput = {
  coachQualificationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<CoachQualificationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "users_coach_qualifications" */
export enum UsersCoachQualificationsUpdateColumn {
  /** column name */
  Status = 'status'
}

export type UsersCoachQualificationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersCoachQualificationsSetInput>;
  /** filter the rows which have to be updated */
  where: UsersCoachQualificationsBoolExp;
};

/** input type for incrementing numeric columns in table "users" */
export type UsersIncInput = {
  coachingStartYear?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRating?: InputMaybe<Scalars['numeric']>;
  priceUnitAmountCoachDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<Scalars['Int']>;
  tennisRating?: InputMaybe<Scalars['numeric']>;
};

/** order by max() on columns of table "users" */
export type UsersMaxOrderBy = {
  aboutMe?: InputMaybe<OrderBy>;
  aboutMeVideoUrl?: InputMaybe<OrderBy>;
  activeCityId?: InputMaybe<OrderBy>;
  adminVenueId?: InputMaybe<OrderBy>;
  birthday?: InputMaybe<OrderBy>;
  cityName?: InputMaybe<OrderBy>;
  coachExternalBookingUrl?: InputMaybe<OrderBy>;
  coachLessonDescription?: InputMaybe<OrderBy>;
  coachLessonHowToPrepare?: InputMaybe<OrderBy>;
  coachStatusUpdatedAt?: InputMaybe<OrderBy>;
  coachingStartYear?: InputMaybe<OrderBy>;
  countryId?: InputMaybe<OrderBy>;
  countrySubdivisionId?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyCoachDefault?: InputMaybe<OrderBy>;
  defaultCoachUserCustomCourtId?: InputMaybe<OrderBy>;
  defaultCoachVenueId?: InputMaybe<OrderBy>;
  defaultCreditCardId?: InputMaybe<OrderBy>;
  defaultPickleballRatingScaleId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duprId?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  firebaseId?: InputMaybe<OrderBy>;
  fullName?: InputMaybe<OrderBy>;
  genderPreference?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  iptpaId?: InputMaybe<OrderBy>;
  lastLoginAt?: InputMaybe<OrderBy>;
  lastSessionAt?: InputMaybe<OrderBy>;
  latestAuthProvider?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  linkedinUrl?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  normalizedTennisRatingScaleId?: InputMaybe<OrderBy>;
  originalAuthProvider?: InputMaybe<OrderBy>;
  padelSkillLevelId?: InputMaybe<OrderBy>;
  pciId?: InputMaybe<OrderBy>;
  phoneCountryCode?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneVerifiedAt?: InputMaybe<OrderBy>;
  pickleballSkillLevelId?: InputMaybe<OrderBy>;
  playerFinderOnboardedAt?: InputMaybe<OrderBy>;
  pprId?: InputMaybe<OrderBy>;
  preferredName?: InputMaybe<OrderBy>;
  premiumContentDescription?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  profileImageFileName?: InputMaybe<OrderBy>;
  profileImagePath?: InputMaybe<OrderBy>;
  profileImageProvider?: InputMaybe<OrderBy>;
  profileImageProviderId?: InputMaybe<OrderBy>;
  profileImageProviderUrl?: InputMaybe<OrderBy>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  profileImageUrl?: InputMaybe<OrderBy>;
  quatroPickleballMemberId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantBusinessType?: InputMaybe<OrderBy>;
  stripeMerchantCountry?: InputMaybe<OrderBy>;
  stripeMerchantCurrency?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  tennisSkillLevelId?: InputMaybe<OrderBy>;
  tiktokUrl?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  xUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "users" */
export type UsersMinOrderBy = {
  aboutMe?: InputMaybe<OrderBy>;
  aboutMeVideoUrl?: InputMaybe<OrderBy>;
  activeCityId?: InputMaybe<OrderBy>;
  adminVenueId?: InputMaybe<OrderBy>;
  birthday?: InputMaybe<OrderBy>;
  cityName?: InputMaybe<OrderBy>;
  coachExternalBookingUrl?: InputMaybe<OrderBy>;
  coachLessonDescription?: InputMaybe<OrderBy>;
  coachLessonHowToPrepare?: InputMaybe<OrderBy>;
  coachStatusUpdatedAt?: InputMaybe<OrderBy>;
  coachingStartYear?: InputMaybe<OrderBy>;
  countryId?: InputMaybe<OrderBy>;
  countrySubdivisionId?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyCoachDefault?: InputMaybe<OrderBy>;
  defaultCoachUserCustomCourtId?: InputMaybe<OrderBy>;
  defaultCoachVenueId?: InputMaybe<OrderBy>;
  defaultCreditCardId?: InputMaybe<OrderBy>;
  defaultPickleballRatingScaleId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duprId?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  firebaseId?: InputMaybe<OrderBy>;
  fullName?: InputMaybe<OrderBy>;
  genderPreference?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  iptpaId?: InputMaybe<OrderBy>;
  lastLoginAt?: InputMaybe<OrderBy>;
  lastSessionAt?: InputMaybe<OrderBy>;
  latestAuthProvider?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  linkedinUrl?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  normalizedTennisRatingScaleId?: InputMaybe<OrderBy>;
  originalAuthProvider?: InputMaybe<OrderBy>;
  padelSkillLevelId?: InputMaybe<OrderBy>;
  pciId?: InputMaybe<OrderBy>;
  phoneCountryCode?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneVerifiedAt?: InputMaybe<OrderBy>;
  pickleballSkillLevelId?: InputMaybe<OrderBy>;
  playerFinderOnboardedAt?: InputMaybe<OrderBy>;
  pprId?: InputMaybe<OrderBy>;
  preferredName?: InputMaybe<OrderBy>;
  premiumContentDescription?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  profileImageFileName?: InputMaybe<OrderBy>;
  profileImagePath?: InputMaybe<OrderBy>;
  profileImageProvider?: InputMaybe<OrderBy>;
  profileImageProviderId?: InputMaybe<OrderBy>;
  profileImageProviderUrl?: InputMaybe<OrderBy>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  profileImageUrl?: InputMaybe<OrderBy>;
  quatroPickleballMemberId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantBusinessType?: InputMaybe<OrderBy>;
  stripeMerchantCountry?: InputMaybe<OrderBy>;
  stripeMerchantCurrency?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  tennisSkillLevelId?: InputMaybe<OrderBy>;
  tiktokUrl?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  xUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "users" */
export type UsersMutationResponse = {
  __typename?: 'UsersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** Ordering options when selecting data from "users". */
export type UsersOrderBy = {
  aboutMe?: InputMaybe<OrderBy>;
  aboutMeVideoUrl?: InputMaybe<OrderBy>;
  activeCity?: InputMaybe<CitiesOrderBy>;
  activeCityId?: InputMaybe<OrderBy>;
  adminVenueId?: InputMaybe<OrderBy>;
  birthday?: InputMaybe<OrderBy>;
  birthdayVisibility?: InputMaybe<OrderBy>;
  cityName?: InputMaybe<OrderBy>;
  coachAvailabilityAggregate?: InputMaybe<CoachAvailabilityAggregateOrderBy>;
  coachExternalBookingUrl?: InputMaybe<OrderBy>;
  coachFaqsAggregate?: InputMaybe<CoachFaqsAggregateOrderBy>;
  coachLessonAgeGroupsAggregate?: InputMaybe<CoachLessonAgeGroupsAggregateOrderBy>;
  coachLessonDescription?: InputMaybe<OrderBy>;
  coachLessonHowToPrepare?: InputMaybe<OrderBy>;
  coachLessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateOrderBy>;
  coachLessonSkillLevelsAggregate?: InputMaybe<CoachLessonSkillLevelsAggregateOrderBy>;
  coachLessonsAggregate?: InputMaybe<LessonsAggregateOrderBy>;
  coachQualificationsAggregate?: InputMaybe<UsersCoachQualificationsAggregateOrderBy>;
  coachServicesAggregate?: InputMaybe<UserCoachServicesAggregateOrderBy>;
  coachSportsAggregate?: InputMaybe<CoachSportsAggregateOrderBy>;
  coachStatus?: InputMaybe<OrderBy>;
  coachStatusUpdatedAt?: InputMaybe<OrderBy>;
  coachingStartYear?: InputMaybe<OrderBy>;
  communicationPreferences?: InputMaybe<UserCommunicationPreferencesOrderBy>;
  country?: InputMaybe<CountriesOrderBy>;
  countryId?: InputMaybe<OrderBy>;
  countrySubdivision?: InputMaybe<CountrySubdivisionsOrderBy>;
  countrySubdivisionId?: InputMaybe<OrderBy>;
  coverImageFileName?: InputMaybe<OrderBy>;
  coverImagePath?: InputMaybe<OrderBy>;
  coverImageProvider?: InputMaybe<OrderBy>;
  coverImageProviderId?: InputMaybe<OrderBy>;
  coverImageProviderUrl?: InputMaybe<OrderBy>;
  coverImageUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  creditCardsAggregate?: InputMaybe<UserCreditCardsAggregateOrderBy>;
  currencyCoachDefault?: InputMaybe<OrderBy>;
  customCourtsAggregate?: InputMaybe<UserCustomCourtsAggregateOrderBy>;
  defaultCoachCustomCourt?: InputMaybe<UserCustomCourtsOrderBy>;
  defaultCoachPaymentFulfillmentChannel?: InputMaybe<OrderBy>;
  defaultCoachUserCustomCourtId?: InputMaybe<OrderBy>;
  defaultCoachVenue?: InputMaybe<VenuesOrderBy>;
  defaultCoachVenueId?: InputMaybe<OrderBy>;
  defaultCreditCardId?: InputMaybe<OrderBy>;
  defaultPickleballRatingScale?: InputMaybe<PickleballRatingScalesOrderBy>;
  defaultPickleballRatingScaleId?: InputMaybe<OrderBy>;
  defaultSport?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  derfaultCreditCard?: InputMaybe<UserCreditCardsOrderBy>;
  didSkipStripeSetup?: InputMaybe<OrderBy>;
  duprId?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  eventOrganizerAccountType?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  firebaseId?: InputMaybe<OrderBy>;
  followersAggregate?: InputMaybe<UserFollowsAggregateOrderBy>;
  followingAggregate?: InputMaybe<UserFollowsAggregateOrderBy>;
  fullName?: InputMaybe<OrderBy>;
  gender?: InputMaybe<OrderBy>;
  genderPreference?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  groupsAggregate?: InputMaybe<GroupMembersAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  iptpaId?: InputMaybe<OrderBy>;
  isIptpaMember?: InputMaybe<OrderBy>;
  isMarketingRegistered?: InputMaybe<OrderBy>;
  isOnboardComplete?: InputMaybe<OrderBy>;
  isPciMember?: InputMaybe<OrderBy>;
  isPendingAccountDetails?: InputMaybe<OrderBy>;
  isPicklrP4Member?: InputMaybe<OrderBy>;
  isPprMember?: InputMaybe<OrderBy>;
  isProfessionalRacquetRegistryActive?: InputMaybe<OrderBy>;
  isProfessionalRacquetRegistryInvite?: InputMaybe<OrderBy>;
  isQuatroPickleballMember?: InputMaybe<OrderBy>;
  isRemoteCoachingEnabled?: InputMaybe<OrderBy>;
  isSafePlayCertified?: InputMaybe<OrderBy>;
  lastLoginAt?: InputMaybe<OrderBy>;
  lastSessionAt?: InputMaybe<OrderBy>;
  latestAuthProvider?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  lessonTemplatesAggregate?: InputMaybe<LessonTemplatesAggregateOrderBy>;
  linkedinUrl?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  normalizedTennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  normalizedTennisRatingScaleId?: InputMaybe<OrderBy>;
  notificationsAggregate?: InputMaybe<UserNotificationsAggregateOrderBy>;
  originalAuthProvider?: InputMaybe<OrderBy>;
  padelSkillLevelId?: InputMaybe<OrderBy>;
  paidInvoicesAggregate?: InputMaybe<InvoicesAggregateOrderBy>;
  participantLessonsAggregate?: InputMaybe<LessonParticipantsAggregateOrderBy>;
  pciId?: InputMaybe<OrderBy>;
  phoneCountryCode?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneVerifiedAt?: InputMaybe<OrderBy>;
  pickleballRatingScalesAggregate?: InputMaybe<UserPickleballRatingScalesAggregateOrderBy>;
  pickleballSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  pickleballSkillLevelId?: InputMaybe<OrderBy>;
  platformSubscriptionsAggregate?: InputMaybe<PlatformSubscriptionsAggregateOrderBy>;
  playerFinderOnboardedAt?: InputMaybe<OrderBy>;
  playerLessonReflectionsAggregate?: InputMaybe<LessonReflectionsAggregateOrderBy>;
  pprId?: InputMaybe<OrderBy>;
  preferredName?: InputMaybe<OrderBy>;
  premiumContentDescription?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  profile?: InputMaybe<UserProfilesOrderBy>;
  profileImageFileName?: InputMaybe<OrderBy>;
  profileImagePath?: InputMaybe<OrderBy>;
  profileImageProvider?: InputMaybe<OrderBy>;
  profileImageProviderId?: InputMaybe<OrderBy>;
  profileImageProviderUrl?: InputMaybe<OrderBy>;
  profileImageUrl?: InputMaybe<OrderBy>;
  purchasesAggregate?: InputMaybe<SalesAggregateOrderBy>;
  quatroPickleballMemberId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantBusinessType?: InputMaybe<OrderBy>;
  stripeMerchantChargesEnabled?: InputMaybe<OrderBy>;
  stripeMerchantCountry?: InputMaybe<OrderBy>;
  stripeMerchantCurrency?: InputMaybe<OrderBy>;
  stripeMerchantCurrentlyDue?: InputMaybe<OrderBy>;
  stripeMerchantDetailsSubmitted?: InputMaybe<OrderBy>;
  stripeMerchantEventuallyDue?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripeMerchantPastDue?: InputMaybe<OrderBy>;
  stripeMerchantPayoutsEnabled?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
  tennisRatingScale?: InputMaybe<TennisRatingScalesOrderBy>;
  tennisRatingScaleId?: InputMaybe<OrderBy>;
  tennisSkillLevel?: InputMaybe<SkillLevelsOrderBy>;
  tennisSkillLevelId?: InputMaybe<OrderBy>;
  termsOfServiceAggregate?: InputMaybe<UserTermsOfServiceAggregateOrderBy>;
  tiktokUrl?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userFilesAggregate?: InputMaybe<UserFilesAggregateOrderBy>;
  userVairConnection?: InputMaybe<UserVairConnectionsOrderBy>;
  username?: InputMaybe<OrderBy>;
  usernamesClaimedAggregate?: InputMaybe<UsernamesClaimedAggregateOrderBy>;
  venueStaffRostersAggregate?: InputMaybe<VenueStaffCoachesAggregateOrderBy>;
  videoAnalysisFilesAggregate?: InputMaybe<VideoAnalysisFilesAggregateOrderBy>;
  videoAnalysisReviewerAggregate?: InputMaybe<VideoAnalysisAggregateOrderBy>;
  videoAnalysisSubmissionAggregate?: InputMaybe<VideoAnalysisAggregateOrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  xUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: users */
export type UsersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "users" */
export enum UsersSelectColumn {
  /** column name */
  AboutMe = 'aboutMe',
  /** column name */
  AboutMeVideoUrl = 'aboutMeVideoUrl',
  /** column name */
  ActiveCityId = 'activeCityId',
  /** column name */
  AdminVenueId = 'adminVenueId',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  BirthdayVisibility = 'birthdayVisibility',
  /** column name */
  CityName = 'cityName',
  /** column name */
  CoachExternalBookingUrl = 'coachExternalBookingUrl',
  /** column name */
  CoachLessonDescription = 'coachLessonDescription',
  /** column name */
  CoachLessonHowToPrepare = 'coachLessonHowToPrepare',
  /** column name */
  CoachStatus = 'coachStatus',
  /** column name */
  CoachStatusUpdatedAt = 'coachStatusUpdatedAt',
  /** column name */
  CoachingStartYear = 'coachingStartYear',
  /** column name */
  CountryId = 'countryId',
  /** column name */
  CountrySubdivisionId = 'countrySubdivisionId',
  /** column name */
  CoverImageFileName = 'coverImageFileName',
  /** column name */
  CoverImagePath = 'coverImagePath',
  /** column name */
  CoverImageProvider = 'coverImageProvider',
  /** column name */
  CoverImageProviderId = 'coverImageProviderId',
  /** column name */
  CoverImageProviderUrl = 'coverImageProviderUrl',
  /** column name */
  CoverImageUrl = 'coverImageUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrencyCoachDefault = 'currencyCoachDefault',
  /** column name */
  DefaultCoachPaymentFulfillmentChannel = 'defaultCoachPaymentFulfillmentChannel',
  /** column name */
  DefaultCoachUserCustomCourtId = 'defaultCoachUserCustomCourtId',
  /** column name */
  DefaultCoachVenueId = 'defaultCoachVenueId',
  /** column name */
  DefaultCreditCardId = 'defaultCreditCardId',
  /** column name */
  DefaultPickleballRatingScaleId = 'defaultPickleballRatingScaleId',
  /** column name */
  DefaultSport = 'defaultSport',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DidSkipStripeSetup = 'didSkipStripeSetup',
  /** column name */
  DuprId = 'duprId',
  /** column name */
  Email = 'email',
  /** column name */
  EventOrganizerAccountType = 'eventOrganizerAccountType',
  /** column name */
  FacebookUrl = 'facebookUrl',
  /** column name */
  FirebaseId = 'firebaseId',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Gender = 'gender',
  /** column name */
  GenderPreference = 'genderPreference',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  InstagramUrl = 'instagramUrl',
  /** column name */
  IptpaId = 'iptpaId',
  /** column name */
  IsIptpaMember = 'isIptpaMember',
  /** column name */
  IsMarketingRegistered = 'isMarketingRegistered',
  /** column name */
  IsOnboardComplete = 'isOnboardComplete',
  /** column name */
  IsPciMember = 'isPciMember',
  /** column name */
  IsPendingAccountDetails = 'isPendingAccountDetails',
  /** column name */
  IsPicklrP4Member = 'isPicklrP4Member',
  /** column name */
  IsPprMember = 'isPprMember',
  /** column name */
  IsProfessionalRacquetRegistryActive = 'isProfessionalRacquetRegistryActive',
  /** column name */
  IsProfessionalRacquetRegistryInvite = 'isProfessionalRacquetRegistryInvite',
  /** column name */
  IsQuatroPickleballMember = 'isQuatroPickleballMember',
  /** column name */
  IsRemoteCoachingEnabled = 'isRemoteCoachingEnabled',
  /** column name */
  IsSafePlayCertified = 'isSafePlayCertified',
  /** column name */
  LastLoginAt = 'lastLoginAt',
  /** column name */
  LastSessionAt = 'lastSessionAt',
  /** column name */
  LatestAuthProvider = 'latestAuthProvider',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LinkedinUrl = 'linkedinUrl',
  /** column name */
  Locale = 'locale',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  NormalizedTennisRating = 'normalizedTennisRating',
  /** column name */
  NormalizedTennisRatingScaleId = 'normalizedTennisRatingScaleId',
  /** column name */
  OriginalAuthProvider = 'originalAuthProvider',
  /** column name */
  PadelSkillLevelId = 'padelSkillLevelId',
  /** column name */
  PciId = 'pciId',
  /** column name */
  PhoneCountryCode = 'phoneCountryCode',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneVerifiedAt = 'phoneVerifiedAt',
  /** column name */
  PickleballSkillLevelId = 'pickleballSkillLevelId',
  /** column name */
  PlayerFinderOnboardedAt = 'playerFinderOnboardedAt',
  /** column name */
  PprId = 'pprId',
  /** column name */
  PreferredName = 'preferredName',
  /** column name */
  PremiumContentDescription = 'premiumContentDescription',
  /** column name */
  PriceUnitAmountCoachDefault = 'priceUnitAmountCoachDefault',
  /** column name */
  PriceUnitAmountPremiumContentDefault = 'priceUnitAmountPremiumContentDefault',
  /** column name */
  PriceUnitAmountRemoteCoachDefault = 'priceUnitAmountRemoteCoachDefault',
  /** column name */
  ProfessionalRacquetRegistryId = 'professionalRacquetRegistryId',
  /** column name */
  ProfileImageFileName = 'profileImageFileName',
  /** column name */
  ProfileImagePath = 'profileImagePath',
  /** column name */
  ProfileImageProvider = 'profileImageProvider',
  /** column name */
  ProfileImageProviderId = 'profileImageProviderId',
  /** column name */
  ProfileImageProviderUrl = 'profileImageProviderUrl',
  /** column name */
  ProfileImageUrl = 'profileImageUrl',
  /** column name */
  QuatroPickleballMemberId = 'quatroPickleballMemberId',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantBusinessType = 'stripeMerchantBusinessType',
  /** column name */
  StripeMerchantChargesEnabled = 'stripeMerchantChargesEnabled',
  /** column name */
  StripeMerchantCountry = 'stripeMerchantCountry',
  /** column name */
  StripeMerchantCurrency = 'stripeMerchantCurrency',
  /** column name */
  StripeMerchantCurrentlyDue = 'stripeMerchantCurrentlyDue',
  /** column name */
  StripeMerchantDetailsSubmitted = 'stripeMerchantDetailsSubmitted',
  /** column name */
  StripeMerchantEventuallyDue = 'stripeMerchantEventuallyDue',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripeMerchantPastDue = 'stripeMerchantPastDue',
  /** column name */
  StripeMerchantPayoutsEnabled = 'stripeMerchantPayoutsEnabled',
  /** column name */
  TennisRating = 'tennisRating',
  /** column name */
  TennisRatingScaleId = 'tennisRatingScaleId',
  /** column name */
  TennisSkillLevelId = 'tennisSkillLevelId',
  /** column name */
  TiktokUrl = 'tiktokUrl',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Username = 'username',
  /** column name */
  WebsiteUrl = 'websiteUrl',
  /** column name */
  XUrl = 'xUrl',
  /** column name */
  YoutubeUrl = 'youtubeUrl'
}

/** input type for updating data in table "users" */
export type UsersSetInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutMeVideoUrl?: InputMaybe<Scalars['String']>;
  activeCityId?: InputMaybe<Scalars['uuid']>;
  birthday?: InputMaybe<Scalars['date']>;
  birthdayVisibility?: InputMaybe<BirthdayVisibilityEnum>;
  cityName?: InputMaybe<Scalars['String']>;
  coachExternalBookingUrl?: InputMaybe<Scalars['String']>;
  coachLessonDescription?: InputMaybe<Scalars['String']>;
  coachLessonHowToPrepare?: InputMaybe<Scalars['String']>;
  coachStatus?: InputMaybe<CoachStatusEnum>;
  coachStatusUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  coachingStartYear?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['String']>;
  countrySubdivisionId?: InputMaybe<Scalars['uuid']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  coverImageUrl?: InputMaybe<Scalars['String']>;
  currencyCoachDefault?: InputMaybe<Scalars['String']>;
  defaultCoachPaymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  defaultCoachUserCustomCourtId?: InputMaybe<Scalars['uuid']>;
  defaultCoachVenueId?: InputMaybe<Scalars['uuid']>;
  defaultCreditCardId?: InputMaybe<Scalars['uuid']>;
  defaultPickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  defaultSport?: InputMaybe<SportsEnum>;
  didSkipStripeSetup?: InputMaybe<Scalars['Boolean']>;
  duprId?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<EventOrganizerAccountTypesEnum>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderEnum>;
  genderPreference?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  iptpaId?: InputMaybe<Scalars['String']>;
  isIptpaMember?: InputMaybe<Scalars['Boolean']>;
  isMarketingRegistered?: InputMaybe<Scalars['Boolean']>;
  isOnboardComplete?: InputMaybe<Scalars['Boolean']>;
  isPciMember?: InputMaybe<Scalars['Boolean']>;
  isPendingAccountDetails?: InputMaybe<Scalars['Boolean']>;
  isPprMember?: InputMaybe<Scalars['Boolean']>;
  isQuatroPickleballMember?: InputMaybe<Scalars['Boolean']>;
  isRemoteCoachingEnabled?: InputMaybe<Scalars['Boolean']>;
  lastLoginAt?: InputMaybe<Scalars['timestamptz']>;
  lastSessionAt?: InputMaybe<Scalars['timestamptz']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRating?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  padelSkillLevelId?: InputMaybe<Scalars['String']>;
  pciId?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pickleballSkillLevelId?: InputMaybe<Scalars['String']>;
  playerFinderOnboardedAt?: InputMaybe<Scalars['timestamptz']>;
  pprId?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  premiumContentDescription?: InputMaybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<Scalars['Int']>;
  profileImageFileName?: InputMaybe<Scalars['String']>;
  profileImagePath?: InputMaybe<Scalars['String']>;
  profileImageProvider?: InputMaybe<Scalars['String']>;
  profileImageProviderId?: InputMaybe<Scalars['String']>;
  profileImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  profileImageUrl?: InputMaybe<Scalars['String']>;
  quatroPickleballMemberId?: InputMaybe<Scalars['String']>;
  tennisRating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisSkillLevelId?: InputMaybe<Scalars['String']>;
  tiktokUrl?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  xUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "users" */
export type UsersStddevOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "users" */
export type UsersStddevPopOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "users" */
export type UsersStddevSampOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "users" */
export type UsersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersStreamCursorValueInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutMeVideoUrl?: InputMaybe<Scalars['String']>;
  activeCityId?: InputMaybe<Scalars['uuid']>;
  adminVenueId?: InputMaybe<Scalars['uuid']>;
  birthday?: InputMaybe<Scalars['date']>;
  birthdayVisibility?: InputMaybe<BirthdayVisibilityEnum>;
  cityName?: InputMaybe<Scalars['String']>;
  coachExternalBookingUrl?: InputMaybe<Scalars['String']>;
  coachLessonDescription?: InputMaybe<Scalars['String']>;
  coachLessonHowToPrepare?: InputMaybe<Scalars['String']>;
  coachStatus?: InputMaybe<CoachStatusEnum>;
  coachStatusUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  coachingStartYear?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['String']>;
  countrySubdivisionId?: InputMaybe<Scalars['uuid']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currencyCoachDefault?: InputMaybe<Scalars['String']>;
  defaultCoachPaymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  defaultCoachUserCustomCourtId?: InputMaybe<Scalars['uuid']>;
  defaultCoachVenueId?: InputMaybe<Scalars['uuid']>;
  defaultCreditCardId?: InputMaybe<Scalars['uuid']>;
  defaultPickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  defaultSport?: InputMaybe<SportsEnum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  didSkipStripeSetup?: InputMaybe<Scalars['Boolean']>;
  duprId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<EventOrganizerAccountTypesEnum>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  firebaseId?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderEnum>;
  genderPreference?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['geography']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  iptpaId?: InputMaybe<Scalars['String']>;
  isIptpaMember?: InputMaybe<Scalars['Boolean']>;
  isMarketingRegistered?: InputMaybe<Scalars['Boolean']>;
  isOnboardComplete?: InputMaybe<Scalars['Boolean']>;
  isPciMember?: InputMaybe<Scalars['Boolean']>;
  isPendingAccountDetails?: InputMaybe<Scalars['Boolean']>;
  isPicklrP4Member?: InputMaybe<Scalars['Boolean']>;
  isPprMember?: InputMaybe<Scalars['Boolean']>;
  isProfessionalRacquetRegistryActive?: InputMaybe<Scalars['Boolean']>;
  isProfessionalRacquetRegistryInvite?: InputMaybe<Scalars['Boolean']>;
  isQuatroPickleballMember?: InputMaybe<Scalars['Boolean']>;
  isRemoteCoachingEnabled?: InputMaybe<Scalars['Boolean']>;
  isSafePlayCertified?: InputMaybe<Scalars['Boolean']>;
  lastLoginAt?: InputMaybe<Scalars['timestamptz']>;
  lastSessionAt?: InputMaybe<Scalars['timestamptz']>;
  latestAuthProvider?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRating?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  originalAuthProvider?: InputMaybe<Scalars['String']>;
  padelSkillLevelId?: InputMaybe<Scalars['String']>;
  pciId?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneVerifiedAt?: InputMaybe<Scalars['timestamptz']>;
  pickleballSkillLevelId?: InputMaybe<Scalars['String']>;
  playerFinderOnboardedAt?: InputMaybe<Scalars['timestamptz']>;
  pprId?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  premiumContentDescription?: InputMaybe<Scalars['String']>;
  priceUnitAmountCoachDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<Scalars['Int']>;
  professionalRacquetRegistryId?: InputMaybe<Scalars['Int']>;
  profileImageFileName?: InputMaybe<Scalars['String']>;
  profileImagePath?: InputMaybe<Scalars['String']>;
  profileImageProvider?: InputMaybe<Scalars['String']>;
  profileImageProviderId?: InputMaybe<Scalars['String']>;
  profileImageProviderUrl?: InputMaybe<Scalars['String']>;
  /** NOTE: Keeping this field empty for now until we serve from our own custom domain */
  profileImageUrl?: InputMaybe<Scalars['String']>;
  quatroPickleballMemberId?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantBusinessType?: InputMaybe<Scalars['String']>;
  stripeMerchantChargesEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeMerchantCountry?: InputMaybe<Scalars['String']>;
  stripeMerchantCurrency?: InputMaybe<Scalars['String']>;
  stripeMerchantCurrentlyDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantDetailsSubmitted?: InputMaybe<Scalars['Boolean']>;
  stripeMerchantEventuallyDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripeMerchantPastDue?: InputMaybe<Scalars['jsonb']>;
  stripeMerchantPayoutsEnabled?: InputMaybe<Scalars['Boolean']>;
  tennisRating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisSkillLevelId?: InputMaybe<Scalars['String']>;
  tiktokUrl?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  xUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "users" */
export type UsersSumOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

export type UsersUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UsersIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersSetInput>;
  /** filter the rows which have to be updated */
  where: UsersBoolExp;
};

/** order by varPop() on columns of table "users" */
export type UsersVarPopOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "users" */
export type UsersVarSampOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "users" */
export type UsersVarianceOrderBy = {
  coachingStartYear?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  normalizedTennisRating?: InputMaybe<OrderBy>;
  priceUnitAmountCoachDefault?: InputMaybe<OrderBy>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<OrderBy>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<OrderBy>;
  professionalRacquetRegistryId?: InputMaybe<OrderBy>;
  tennisRating?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "venue_access_types" */
export type VenueAccessTypes = {
  __typename?: 'VenueAccessTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "venue_access_types". All fields are combined with a logical 'AND'. */
export type VenueAccessTypesBoolExp = {
  _and?: InputMaybe<Array<VenueAccessTypesBoolExp>>;
  _not?: InputMaybe<VenueAccessTypesBoolExp>;
  _or?: InputMaybe<Array<VenueAccessTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum VenueAccessTypesEnum {
  Free = 'FREE',
  Membership = 'MEMBERSHIP',
  NeedsAudit = 'NEEDS_AUDIT',
  OneTime = 'ONE_TIME',
  Private = 'PRIVATE'
}

/** Boolean expression to compare columns of type "VenueAccessTypesEnum". All fields are combined with logical 'AND'. */
export type VenueAccessTypesEnumComparisonExp = {
  _eq?: InputMaybe<VenueAccessTypesEnum>;
  _in?: InputMaybe<Array<VenueAccessTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VenueAccessTypesEnum>;
  _nin?: InputMaybe<Array<VenueAccessTypesEnum>>;
};

/** Ordering options when selecting data from "venue_access_types". */
export type VenueAccessTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_access_types" */
export enum VenueAccessTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "venue_access_types" */
export type VenueAccessTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueAccessTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueAccessTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "venue_admin_claim_statuses" */
export type VenueAdminClaimStatuses = {
  __typename?: 'VenueAdminClaimStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "venue_admin_claim_statuses". All fields are combined with a logical 'AND'. */
export type VenueAdminClaimStatusesBoolExp = {
  _and?: InputMaybe<Array<VenueAdminClaimStatusesBoolExp>>;
  _not?: InputMaybe<VenueAdminClaimStatusesBoolExp>;
  _or?: InputMaybe<Array<VenueAdminClaimStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum VenueAdminClaimStatusesEnum {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "VenueAdminClaimStatusesEnum". All fields are combined with logical 'AND'. */
export type VenueAdminClaimStatusesEnumComparisonExp = {
  _eq?: InputMaybe<VenueAdminClaimStatusesEnum>;
  _in?: InputMaybe<Array<VenueAdminClaimStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VenueAdminClaimStatusesEnum>;
  _nin?: InputMaybe<Array<VenueAdminClaimStatusesEnum>>;
};

/** Ordering options when selecting data from "venue_admin_claim_statuses". */
export type VenueAdminClaimStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_admin_claim_statuses" */
export enum VenueAdminClaimStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "venue_admin_claim_statuses" */
export type VenueAdminClaimStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueAdminClaimStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueAdminClaimStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "venue_admin_claims" */
export type VenueAdminClaims = {
  __typename?: 'VenueAdminClaims';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  notes?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  reviewedByUser?: Maybe<Users>;
  reviewedByUserId?: Maybe<Scalars['uuid']>;
  status: VenueAdminClaimStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** Boolean expression to filter rows from the table "venue_admin_claims". All fields are combined with a logical 'AND'. */
export type VenueAdminClaimsBoolExp = {
  _and?: InputMaybe<Array<VenueAdminClaimsBoolExp>>;
  _not?: InputMaybe<VenueAdminClaimsBoolExp>;
  _or?: InputMaybe<Array<VenueAdminClaimsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  notes?: InputMaybe<StringComparisonExp>;
  reviewedAt?: InputMaybe<TimestamptzComparisonExp>;
  reviewedByUser?: InputMaybe<UsersBoolExp>;
  reviewedByUserId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<VenueAdminClaimStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** Ordering options when selecting data from "venue_admin_claims". */
export type VenueAdminClaimsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  notes?: InputMaybe<OrderBy>;
  reviewedAt?: InputMaybe<OrderBy>;
  reviewedByUser?: InputMaybe<UsersOrderBy>;
  reviewedByUserId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_admin_claims" */
export enum VenueAdminClaimsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ReviewedAt = 'reviewedAt',
  /** column name */
  ReviewedByUserId = 'reviewedByUserId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VenueId = 'venueId'
}

/** Streaming cursor of the table "venue_admin_claims" */
export type VenueAdminClaimsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueAdminClaimsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueAdminClaimsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Scalars['String']>;
  reviewedAt?: InputMaybe<Scalars['timestamptz']>;
  reviewedByUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<VenueAdminClaimStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "venue_amenities" */
export type VenueAmenities = {
  __typename?: 'VenueAmenities';
  amenity: AmenitiesEnum;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** order by aggregate values of table "venue_amenities" */
export type VenueAmenitiesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueAmenitiesMaxOrderBy>;
  min?: InputMaybe<VenueAmenitiesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "venue_amenities". All fields are combined with a logical 'AND'. */
export type VenueAmenitiesBoolExp = {
  _and?: InputMaybe<Array<VenueAmenitiesBoolExp>>;
  _not?: InputMaybe<VenueAmenitiesBoolExp>;
  _or?: InputMaybe<Array<VenueAmenitiesBoolExp>>;
  amenity?: InputMaybe<AmenitiesEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "venue_amenities" */
export type VenueAmenitiesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "venue_amenities" */
export type VenueAmenitiesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "venue_amenities". */
export type VenueAmenitiesOrderBy = {
  amenity?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_amenities" */
export enum VenueAmenitiesSelectColumn {
  /** column name */
  Amenity = 'amenity',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** Streaming cursor of the table "venue_amenities" */
export type VenueAmenitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueAmenitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueAmenitiesStreamCursorValueInput = {
  amenity?: InputMaybe<AmenitiesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "venue_booking_config_versions" */
export type VenueBookingConfigVersions = {
  __typename?: 'VenueBookingConfigVersions';
  changeType: BookingConfigChangeTypesEnum;
  changedAt: Scalars['timestamptz'];
  changedBy: Scalars['uuid'];
  /** An object relationship */
  changedByUser: Users;
  id: Scalars['uuid'];
  /** An object relationship */
  integration: VenueBookingIntegrations;
  integrationId: Scalars['uuid'];
  snapshot: Scalars['jsonb'];
  termsVersion?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
};


/** columns and relationships of "venue_booking_config_versions" */
export type VenueBookingConfigVersionsSnapshotArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsAggregateOrderBy = {
  avg?: InputMaybe<VenueBookingConfigVersionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueBookingConfigVersionsMaxOrderBy>;
  min?: InputMaybe<VenueBookingConfigVersionsMinOrderBy>;
  stddev?: InputMaybe<VenueBookingConfigVersionsStddevOrderBy>;
  stddevPop?: InputMaybe<VenueBookingConfigVersionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VenueBookingConfigVersionsStddevSampOrderBy>;
  sum?: InputMaybe<VenueBookingConfigVersionsSumOrderBy>;
  varPop?: InputMaybe<VenueBookingConfigVersionsVarPopOrderBy>;
  varSamp?: InputMaybe<VenueBookingConfigVersionsVarSampOrderBy>;
  variance?: InputMaybe<VenueBookingConfigVersionsVarianceOrderBy>;
};

/** order by avg() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsAvgOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "venue_booking_config_versions". All fields are combined with a logical 'AND'. */
export type VenueBookingConfigVersionsBoolExp = {
  _and?: InputMaybe<Array<VenueBookingConfigVersionsBoolExp>>;
  _not?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
  _or?: InputMaybe<Array<VenueBookingConfigVersionsBoolExp>>;
  changeType?: InputMaybe<BookingConfigChangeTypesEnumComparisonExp>;
  changedAt?: InputMaybe<TimestamptzComparisonExp>;
  changedBy?: InputMaybe<UuidComparisonExp>;
  changedByUser?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<VenueBookingIntegrationsBoolExp>;
  integrationId?: InputMaybe<UuidComparisonExp>;
  snapshot?: InputMaybe<JsonbComparisonExp>;
  termsVersion?: InputMaybe<StringComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
};

/** order by max() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsMaxOrderBy = {
  changedAt?: InputMaybe<OrderBy>;
  changedBy?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  termsVersion?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsMinOrderBy = {
  changedAt?: InputMaybe<OrderBy>;
  changedBy?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  termsVersion?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "venue_booking_config_versions". */
export type VenueBookingConfigVersionsOrderBy = {
  changeType?: InputMaybe<OrderBy>;
  changedAt?: InputMaybe<OrderBy>;
  changedBy?: InputMaybe<OrderBy>;
  changedByUser?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<VenueBookingIntegrationsOrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  snapshot?: InputMaybe<OrderBy>;
  termsVersion?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_booking_config_versions" */
export enum VenueBookingConfigVersionsSelectColumn {
  /** column name */
  ChangeType = 'changeType',
  /** column name */
  ChangedAt = 'changedAt',
  /** column name */
  ChangedBy = 'changedBy',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  Snapshot = 'snapshot',
  /** column name */
  TermsVersion = 'termsVersion',
  /** column name */
  Version = 'version'
}

/** order by stddev() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsStddevOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsStddevPopOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsStddevSampOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingConfigVersionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingConfigVersionsStreamCursorValueInput = {
  changeType?: InputMaybe<BookingConfigChangeTypesEnum>;
  changedAt?: InputMaybe<Scalars['timestamptz']>;
  changedBy?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  snapshot?: InputMaybe<Scalars['jsonb']>;
  termsVersion?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsSumOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsVarPopOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsVarSampOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "venue_booking_config_versions" */
export type VenueBookingConfigVersionsVarianceOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** columns and relationships of "venue_booking_connection_check_statuses" */
export type VenueBookingConnectionCheckStatuses = {
  __typename?: 'VenueBookingConnectionCheckStatuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "venue_booking_connection_check_statuses". All fields are combined with a logical 'AND'. */
export type VenueBookingConnectionCheckStatusesBoolExp = {
  _and?: InputMaybe<Array<VenueBookingConnectionCheckStatusesBoolExp>>;
  _not?: InputMaybe<VenueBookingConnectionCheckStatusesBoolExp>;
  _or?: InputMaybe<Array<VenueBookingConnectionCheckStatusesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum VenueBookingConnectionCheckStatusesEnum {
  /** Sent; waiting for the engine to report */
  Dispatched = 'DISPATCHED',
  /** The engine could not sign in or could not see courts */
  Failed = 'FAILED',
  /** Waiting to be sent to the booking engine */
  Queued = 'QUEUED',
  /** The engine never reported */
  Unknown = 'UNKNOWN',
  /** The engine signed in as the booking account and saw the club's courts */
  Verified = 'VERIFIED'
}

/** Boolean expression to compare columns of type "VenueBookingConnectionCheckStatusesEnum". All fields are combined with logical 'AND'. */
export type VenueBookingConnectionCheckStatusesEnumComparisonExp = {
  _eq?: InputMaybe<VenueBookingConnectionCheckStatusesEnum>;
  _in?: InputMaybe<Array<VenueBookingConnectionCheckStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VenueBookingConnectionCheckStatusesEnum>;
  _nin?: InputMaybe<Array<VenueBookingConnectionCheckStatusesEnum>>;
};

/** Ordering options when selecting data from "venue_booking_connection_check_statuses". */
export type VenueBookingConnectionCheckStatusesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_booking_connection_check_statuses" */
export enum VenueBookingConnectionCheckStatusesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "venue_booking_connection_check_statuses" */
export type VenueBookingConnectionCheckStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingConnectionCheckStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingConnectionCheckStatusesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "venue_booking_connection_checks" */
export type VenueBookingConnectionChecks = {
  __typename?: 'VenueBookingConnectionChecks';
  completedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  dispatchedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  integration: VenueBookingIntegrations;
  integrationId: Scalars['uuid'];
  /** An object relationship */
  requestedByUser?: Maybe<Users>;
  status: VenueBookingConnectionCheckStatusesEnum;
  trigger: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueBookingConnectionChecksMaxOrderBy>;
  min?: InputMaybe<VenueBookingConnectionChecksMinOrderBy>;
};

/** Boolean expression to filter rows from the table "venue_booking_connection_checks". All fields are combined with a logical 'AND'. */
export type VenueBookingConnectionChecksBoolExp = {
  _and?: InputMaybe<Array<VenueBookingConnectionChecksBoolExp>>;
  _not?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
  _or?: InputMaybe<Array<VenueBookingConnectionChecksBoolExp>>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dispatchedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<VenueBookingIntegrationsBoolExp>;
  integrationId?: InputMaybe<UuidComparisonExp>;
  requestedByUser?: InputMaybe<UsersBoolExp>;
  status?: InputMaybe<VenueBookingConnectionCheckStatusesEnumComparisonExp>;
  trigger?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksMaxOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dispatchedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  trigger?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksMinOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dispatchedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  trigger?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "venue_booking_connection_checks". */
export type VenueBookingConnectionChecksOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dispatchedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<VenueBookingIntegrationsOrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  requestedByUser?: InputMaybe<UsersOrderBy>;
  status?: InputMaybe<OrderBy>;
  trigger?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_booking_connection_checks" */
export enum VenueBookingConnectionChecksSelectColumn {
  /** column name */
  CompletedAt = 'completedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DispatchedAt = 'dispatchedAt',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  Status = 'status',
  /** column name */
  Trigger = 'trigger',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "venue_booking_connection_checks" */
export type VenueBookingConnectionChecksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingConnectionChecksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingConnectionChecksStreamCursorValueInput = {
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dispatchedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<VenueBookingConnectionCheckStatusesEnum>;
  trigger?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "venue_booking_court_rates" */
export type VenueBookingCourtRates = {
  __typename?: 'VenueBookingCourtRates';
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  hourlyUnitAmount: Scalars['Int'];
  id: Scalars['uuid'];
  /** An object relationship */
  integration: VenueBookingIntegrations;
  integrationId: Scalars['uuid'];
  peakHourlyUnitAmount?: Maybe<Scalars['Int']>;
  sport?: Maybe<SportsEnum>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updatedByUser?: Maybe<Users>;
};

/** order by aggregate values of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesAggregateOrderBy = {
  avg?: InputMaybe<VenueBookingCourtRatesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueBookingCourtRatesMaxOrderBy>;
  min?: InputMaybe<VenueBookingCourtRatesMinOrderBy>;
  stddev?: InputMaybe<VenueBookingCourtRatesStddevOrderBy>;
  stddevPop?: InputMaybe<VenueBookingCourtRatesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VenueBookingCourtRatesStddevSampOrderBy>;
  sum?: InputMaybe<VenueBookingCourtRatesSumOrderBy>;
  varPop?: InputMaybe<VenueBookingCourtRatesVarPopOrderBy>;
  varSamp?: InputMaybe<VenueBookingCourtRatesVarSampOrderBy>;
  variance?: InputMaybe<VenueBookingCourtRatesVarianceOrderBy>;
};

/** order by avg() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesAvgOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "venue_booking_court_rates". All fields are combined with a logical 'AND'. */
export type VenueBookingCourtRatesBoolExp = {
  _and?: InputMaybe<Array<VenueBookingCourtRatesBoolExp>>;
  _not?: InputMaybe<VenueBookingCourtRatesBoolExp>;
  _or?: InputMaybe<Array<VenueBookingCourtRatesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  hourlyUnitAmount?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<VenueBookingIntegrationsBoolExp>;
  integrationId?: InputMaybe<UuidComparisonExp>;
  peakHourlyUnitAmount?: InputMaybe<IntComparisonExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updatedByUser?: InputMaybe<UsersBoolExp>;
};

/** order by max() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "venue_booking_court_rates". */
export type VenueBookingCourtRatesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<VenueBookingIntegrationsOrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
  sport?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  updatedByUser?: InputMaybe<UsersOrderBy>;
};

/** select columns of table "venue_booking_court_rates" */
export enum VenueBookingCourtRatesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  HourlyUnitAmount = 'hourlyUnitAmount',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  PeakHourlyUnitAmount = 'peakHourlyUnitAmount',
  /** column name */
  Sport = 'sport',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** order by stddev() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesStddevOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesStddevPopOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesStddevSampOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "venue_booking_court_rates" */
export type VenueBookingCourtRatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingCourtRatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingCourtRatesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  hourlyUnitAmount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  peakHourlyUnitAmount?: InputMaybe<Scalars['Int']>;
  sport?: InputMaybe<SportsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesSumOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesVarPopOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesVarSampOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "venue_booking_court_rates" */
export type VenueBookingCourtRatesVarianceOrderBy = {
  hourlyUnitAmount?: InputMaybe<OrderBy>;
  peakHourlyUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrations = {
  __typename?: 'VenueBookingIntegrations';
  accountAddedConfirmedAt?: Maybe<Scalars['timestamptz']>;
  accountAddedConfirmedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  accountAddedConfirmedByUser?: Maybe<Users>;
  activatedAt?: Maybe<Scalars['timestamptz']>;
  bookingAccountEmail: Scalars['String'];
  bookingSystem: BookingSystemsEnum;
  /** An array relationship */
  configVersions: Array<VenueBookingConfigVersions>;
  confirmationNote?: Maybe<Scalars['String']>;
  /** An array relationship */
  connectionChecks: Array<VenueBookingConnectionChecks>;
  connectionStatus: BookingConnectionStatusesEnum;
  /** An array relationship */
  courtRates: Array<VenueBookingCourtRates>;
  createdAt: Scalars['timestamptz'];
  currentVersion: Scalars['Int'];
  externalOrgId?: Maybe<Scalars['String']>;
  helpRequestedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  isPreferredPartner: Scalars['Boolean'];
  maxAdvanceBookingDays?: Maybe<Scalars['Int']>;
  partnerPricingEnabled: Scalars['Boolean'];
  pausedAt?: Maybe<Scalars['timestamptz']>;
  promoCode?: Maybe<Scalars['String']>;
  readVerifiedAt?: Maybe<Scalars['timestamptz']>;
  referralFeeCents: Scalars['Int'];
  referralFeeEnabled: Scalars['Boolean'];
  /** An array relationship */
  rules: Array<VenueBookingRules>;
  status: BookingIntegrationStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
  verifiedAt?: Maybe<Scalars['timestamptz']>;
  verifiedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  verifiedByUser?: Maybe<Users>;
  /** An array relationship */
  windows: Array<VenueBookingWindows>;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsConfigVersionsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConfigVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConfigVersionsOrderBy>>;
  where?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsConnectionChecksArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionChecksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionChecksOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsCourtRatesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingCourtRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingCourtRatesOrderBy>>;
  where?: InputMaybe<VenueBookingCourtRatesBoolExp>;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsRulesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRulesOrderBy>>;
  where?: InputMaybe<VenueBookingRulesBoolExp>;
};


/** columns and relationships of "venue_booking_integrations" */
export type VenueBookingIntegrationsWindowsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingWindowsOrderBy>>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};

/** Boolean expression to filter rows from the table "venue_booking_integrations". All fields are combined with a logical 'AND'. */
export type VenueBookingIntegrationsBoolExp = {
  _and?: InputMaybe<Array<VenueBookingIntegrationsBoolExp>>;
  _not?: InputMaybe<VenueBookingIntegrationsBoolExp>;
  _or?: InputMaybe<Array<VenueBookingIntegrationsBoolExp>>;
  accountAddedConfirmedAt?: InputMaybe<TimestamptzComparisonExp>;
  accountAddedConfirmedBy?: InputMaybe<UuidComparisonExp>;
  accountAddedConfirmedByUser?: InputMaybe<UsersBoolExp>;
  activatedAt?: InputMaybe<TimestamptzComparisonExp>;
  bookingAccountEmail?: InputMaybe<StringComparisonExp>;
  bookingSystem?: InputMaybe<BookingSystemsEnumComparisonExp>;
  configVersions?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
  confirmationNote?: InputMaybe<StringComparisonExp>;
  connectionChecks?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
  connectionStatus?: InputMaybe<BookingConnectionStatusesEnumComparisonExp>;
  courtRates?: InputMaybe<VenueBookingCourtRatesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currentVersion?: InputMaybe<IntComparisonExp>;
  externalOrgId?: InputMaybe<StringComparisonExp>;
  helpRequestedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPreferredPartner?: InputMaybe<BooleanComparisonExp>;
  maxAdvanceBookingDays?: InputMaybe<IntComparisonExp>;
  partnerPricingEnabled?: InputMaybe<BooleanComparisonExp>;
  pausedAt?: InputMaybe<TimestamptzComparisonExp>;
  promoCode?: InputMaybe<StringComparisonExp>;
  readVerifiedAt?: InputMaybe<TimestamptzComparisonExp>;
  referralFeeCents?: InputMaybe<IntComparisonExp>;
  referralFeeEnabled?: InputMaybe<BooleanComparisonExp>;
  rules?: InputMaybe<VenueBookingRulesBoolExp>;
  status?: InputMaybe<BookingIntegrationStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
  verifiedAt?: InputMaybe<TimestamptzComparisonExp>;
  verifiedBy?: InputMaybe<UuidComparisonExp>;
  verifiedByUser?: InputMaybe<UsersBoolExp>;
  windows?: InputMaybe<VenueBookingWindowsBoolExp>;
};

/** Ordering options when selecting data from "venue_booking_integrations". */
export type VenueBookingIntegrationsOrderBy = {
  accountAddedConfirmedAt?: InputMaybe<OrderBy>;
  accountAddedConfirmedBy?: InputMaybe<OrderBy>;
  accountAddedConfirmedByUser?: InputMaybe<UsersOrderBy>;
  activatedAt?: InputMaybe<OrderBy>;
  bookingAccountEmail?: InputMaybe<OrderBy>;
  bookingSystem?: InputMaybe<OrderBy>;
  configVersionsAggregate?: InputMaybe<VenueBookingConfigVersionsAggregateOrderBy>;
  confirmationNote?: InputMaybe<OrderBy>;
  connectionChecksAggregate?: InputMaybe<VenueBookingConnectionChecksAggregateOrderBy>;
  connectionStatus?: InputMaybe<OrderBy>;
  courtRatesAggregate?: InputMaybe<VenueBookingCourtRatesAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currentVersion?: InputMaybe<OrderBy>;
  externalOrgId?: InputMaybe<OrderBy>;
  helpRequestedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isPreferredPartner?: InputMaybe<OrderBy>;
  maxAdvanceBookingDays?: InputMaybe<OrderBy>;
  partnerPricingEnabled?: InputMaybe<OrderBy>;
  pausedAt?: InputMaybe<OrderBy>;
  promoCode?: InputMaybe<OrderBy>;
  readVerifiedAt?: InputMaybe<OrderBy>;
  referralFeeCents?: InputMaybe<OrderBy>;
  referralFeeEnabled?: InputMaybe<OrderBy>;
  rulesAggregate?: InputMaybe<VenueBookingRulesAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
  verifiedAt?: InputMaybe<OrderBy>;
  verifiedBy?: InputMaybe<OrderBy>;
  verifiedByUser?: InputMaybe<UsersOrderBy>;
  windowsAggregate?: InputMaybe<VenueBookingWindowsAggregateOrderBy>;
};

/** select columns of table "venue_booking_integrations" */
export enum VenueBookingIntegrationsSelectColumn {
  /** column name */
  AccountAddedConfirmedAt = 'accountAddedConfirmedAt',
  /** column name */
  AccountAddedConfirmedBy = 'accountAddedConfirmedBy',
  /** column name */
  ActivatedAt = 'activatedAt',
  /** column name */
  BookingAccountEmail = 'bookingAccountEmail',
  /** column name */
  BookingSystem = 'bookingSystem',
  /** column name */
  ConfirmationNote = 'confirmationNote',
  /** column name */
  ConnectionStatus = 'connectionStatus',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentVersion = 'currentVersion',
  /** column name */
  ExternalOrgId = 'externalOrgId',
  /** column name */
  HelpRequestedAt = 'helpRequestedAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsPreferredPartner = 'isPreferredPartner',
  /** column name */
  MaxAdvanceBookingDays = 'maxAdvanceBookingDays',
  /** column name */
  PartnerPricingEnabled = 'partnerPricingEnabled',
  /** column name */
  PausedAt = 'pausedAt',
  /** column name */
  PromoCode = 'promoCode',
  /** column name */
  ReadVerifiedAt = 'readVerifiedAt',
  /** column name */
  ReferralFeeCents = 'referralFeeCents',
  /** column name */
  ReferralFeeEnabled = 'referralFeeEnabled',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VerifiedAt = 'verifiedAt',
  /** column name */
  VerifiedBy = 'verifiedBy'
}

/** Streaming cursor of the table "venue_booking_integrations" */
export type VenueBookingIntegrationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingIntegrationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingIntegrationsStreamCursorValueInput = {
  accountAddedConfirmedAt?: InputMaybe<Scalars['timestamptz']>;
  accountAddedConfirmedBy?: InputMaybe<Scalars['uuid']>;
  activatedAt?: InputMaybe<Scalars['timestamptz']>;
  bookingAccountEmail?: InputMaybe<Scalars['String']>;
  bookingSystem?: InputMaybe<BookingSystemsEnum>;
  confirmationNote?: InputMaybe<Scalars['String']>;
  connectionStatus?: InputMaybe<BookingConnectionStatusesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentVersion?: InputMaybe<Scalars['Int']>;
  externalOrgId?: InputMaybe<Scalars['String']>;
  helpRequestedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPreferredPartner?: InputMaybe<Scalars['Boolean']>;
  maxAdvanceBookingDays?: InputMaybe<Scalars['Int']>;
  partnerPricingEnabled?: InputMaybe<Scalars['Boolean']>;
  pausedAt?: InputMaybe<Scalars['timestamptz']>;
  promoCode?: InputMaybe<Scalars['String']>;
  readVerifiedAt?: InputMaybe<Scalars['timestamptz']>;
  referralFeeCents?: InputMaybe<Scalars['Int']>;
  referralFeeEnabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<BookingIntegrationStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  verifiedBy?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "venue_booking_rule_tiers" */
export type VenueBookingRuleTiers = {
  __typename?: 'VenueBookingRuleTiers';
  createdAt: Scalars['timestamptz'];
  discountPercent: Scalars['numeric'];
  id: Scalars['uuid'];
  isEnabled: Scalars['Boolean'];
  leadTimeHours: Scalars['Int'];
  /** An object relationship */
  rule: VenueBookingRules;
  ruleId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersAggregateOrderBy = {
  avg?: InputMaybe<VenueBookingRuleTiersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueBookingRuleTiersMaxOrderBy>;
  min?: InputMaybe<VenueBookingRuleTiersMinOrderBy>;
  stddev?: InputMaybe<VenueBookingRuleTiersStddevOrderBy>;
  stddevPop?: InputMaybe<VenueBookingRuleTiersStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VenueBookingRuleTiersStddevSampOrderBy>;
  sum?: InputMaybe<VenueBookingRuleTiersSumOrderBy>;
  varPop?: InputMaybe<VenueBookingRuleTiersVarPopOrderBy>;
  varSamp?: InputMaybe<VenueBookingRuleTiersVarSampOrderBy>;
  variance?: InputMaybe<VenueBookingRuleTiersVarianceOrderBy>;
};

/** order by avg() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersAvgOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "venue_booking_rule_tiers". All fields are combined with a logical 'AND'. */
export type VenueBookingRuleTiersBoolExp = {
  _and?: InputMaybe<Array<VenueBookingRuleTiersBoolExp>>;
  _not?: InputMaybe<VenueBookingRuleTiersBoolExp>;
  _or?: InputMaybe<Array<VenueBookingRuleTiersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  discountPercent?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isEnabled?: InputMaybe<BooleanComparisonExp>;
  leadTimeHours?: InputMaybe<IntComparisonExp>;
  rule?: InputMaybe<VenueBookingRulesBoolExp>;
  ruleId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  discountPercent?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
  ruleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  discountPercent?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
  ruleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "venue_booking_rule_tiers". */
export type VenueBookingRuleTiersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  discountPercent?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isEnabled?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
  rule?: InputMaybe<VenueBookingRulesOrderBy>;
  ruleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_booking_rule_tiers" */
export enum VenueBookingRuleTiersSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiscountPercent = 'discountPercent',
  /** column name */
  Id = 'id',
  /** column name */
  IsEnabled = 'isEnabled',
  /** column name */
  LeadTimeHours = 'leadTimeHours',
  /** column name */
  RuleId = 'ruleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** order by stddev() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersStddevOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersStddevPopOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersStddevSampOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingRuleTiersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingRuleTiersStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountPercent?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  leadTimeHours?: InputMaybe<Scalars['Int']>;
  ruleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersSumOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersVarPopOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersVarSampOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "venue_booking_rule_tiers" */
export type VenueBookingRuleTiersVarianceOrderBy = {
  discountPercent?: InputMaybe<OrderBy>;
  leadTimeHours?: InputMaybe<OrderBy>;
};

/** columns and relationships of "venue_booking_rules" */
export type VenueBookingRules = {
  __typename?: 'VenueBookingRules';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  integration: VenueBookingIntegrations;
  integrationId: Scalars['uuid'];
  inventoryType: BookingInventoryTypesEnum;
  isCustomPricing: Scalars['Boolean'];
  scheduleMode: BookingScheduleModesEnum;
  /** An array relationship */
  tiers: Array<VenueBookingRuleTiers>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  windows: Array<VenueBookingWindows>;
};


/** columns and relationships of "venue_booking_rules" */
export type VenueBookingRulesTiersArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRuleTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRuleTiersOrderBy>>;
  where?: InputMaybe<VenueBookingRuleTiersBoolExp>;
};


/** columns and relationships of "venue_booking_rules" */
export type VenueBookingRulesWindowsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingWindowsOrderBy>>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};

/** order by aggregate values of table "venue_booking_rules" */
export type VenueBookingRulesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueBookingRulesMaxOrderBy>;
  min?: InputMaybe<VenueBookingRulesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "venue_booking_rules". All fields are combined with a logical 'AND'. */
export type VenueBookingRulesBoolExp = {
  _and?: InputMaybe<Array<VenueBookingRulesBoolExp>>;
  _not?: InputMaybe<VenueBookingRulesBoolExp>;
  _or?: InputMaybe<Array<VenueBookingRulesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<VenueBookingIntegrationsBoolExp>;
  integrationId?: InputMaybe<UuidComparisonExp>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnumComparisonExp>;
  isCustomPricing?: InputMaybe<BooleanComparisonExp>;
  scheduleMode?: InputMaybe<BookingScheduleModesEnumComparisonExp>;
  tiers?: InputMaybe<VenueBookingRuleTiersBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  windows?: InputMaybe<VenueBookingWindowsBoolExp>;
};

/** order by max() on columns of table "venue_booking_rules" */
export type VenueBookingRulesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "venue_booking_rules" */
export type VenueBookingRulesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "venue_booking_rules". */
export type VenueBookingRulesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<VenueBookingIntegrationsOrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  inventoryType?: InputMaybe<OrderBy>;
  isCustomPricing?: InputMaybe<OrderBy>;
  scheduleMode?: InputMaybe<OrderBy>;
  tiersAggregate?: InputMaybe<VenueBookingRuleTiersAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  windowsAggregate?: InputMaybe<VenueBookingWindowsAggregateOrderBy>;
};

/** select columns of table "venue_booking_rules" */
export enum VenueBookingRulesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  InventoryType = 'inventoryType',
  /** column name */
  IsCustomPricing = 'isCustomPricing',
  /** column name */
  ScheduleMode = 'scheduleMode',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "venue_booking_rules" */
export type VenueBookingRulesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingRulesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingRulesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnum>;
  isCustomPricing?: InputMaybe<Scalars['Boolean']>;
  scheduleMode?: InputMaybe<BookingScheduleModesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "venue_booking_windows" */
export type VenueBookingWindows = {
  __typename?: 'VenueBookingWindows';
  createdAt: Scalars['timestamptz'];
  dayOfWeek: DayOfWeekEnum;
  endTime: Scalars['time'];
  id: Scalars['uuid'];
  /** An object relationship */
  integration: VenueBookingIntegrations;
  integrationId: Scalars['uuid'];
  inventoryType?: Maybe<BookingInventoryTypesEnum>;
  kind: BookingWindowKindsEnum;
  sport?: Maybe<SportsEnum>;
  startTime: Scalars['time'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "venue_booking_windows" */
export type VenueBookingWindowsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueBookingWindowsMaxOrderBy>;
  min?: InputMaybe<VenueBookingWindowsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "venue_booking_windows". All fields are combined with a logical 'AND'. */
export type VenueBookingWindowsBoolExp = {
  _and?: InputMaybe<Array<VenueBookingWindowsBoolExp>>;
  _not?: InputMaybe<VenueBookingWindowsBoolExp>;
  _or?: InputMaybe<Array<VenueBookingWindowsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dayOfWeek?: InputMaybe<DayOfWeekEnumComparisonExp>;
  endTime?: InputMaybe<TimeComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<VenueBookingIntegrationsBoolExp>;
  integrationId?: InputMaybe<UuidComparisonExp>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnumComparisonExp>;
  kind?: InputMaybe<BookingWindowKindsEnumComparisonExp>;
  sport?: InputMaybe<SportsEnumComparisonExp>;
  startTime?: InputMaybe<TimeComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "venue_booking_windows" */
export type VenueBookingWindowsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "venue_booking_windows" */
export type VenueBookingWindowsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "venue_booking_windows". */
export type VenueBookingWindowsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  endTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<VenueBookingIntegrationsOrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  inventoryType?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  sport?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_booking_windows" */
export enum VenueBookingWindowsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DayOfWeek = 'dayOfWeek',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationId = 'integrationId',
  /** column name */
  InventoryType = 'inventoryType',
  /** column name */
  Kind = 'kind',
  /** column name */
  Sport = 'sport',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "venue_booking_windows" */
export type VenueBookingWindowsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueBookingWindowsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueBookingWindowsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dayOfWeek?: InputMaybe<DayOfWeekEnum>;
  endTime?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['uuid']>;
  integrationId?: InputMaybe<Scalars['uuid']>;
  inventoryType?: InputMaybe<BookingInventoryTypesEnum>;
  kind?: InputMaybe<BookingWindowKindsEnum>;
  sport?: InputMaybe<SportsEnum>;
  startTime?: InputMaybe<Scalars['time']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "venue_court_surfaces" */
export type VenueCourtSurfaces = {
  __typename?: 'VenueCourtSurfaces';
  courtSurface: CourtSurfacesEnum;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** order by aggregate values of table "venue_court_surfaces" */
export type VenueCourtSurfacesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueCourtSurfacesMaxOrderBy>;
  min?: InputMaybe<VenueCourtSurfacesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "venue_court_surfaces". All fields are combined with a logical 'AND'. */
export type VenueCourtSurfacesBoolExp = {
  _and?: InputMaybe<Array<VenueCourtSurfacesBoolExp>>;
  _not?: InputMaybe<VenueCourtSurfacesBoolExp>;
  _or?: InputMaybe<Array<VenueCourtSurfacesBoolExp>>;
  courtSurface?: InputMaybe<CourtSurfacesEnumComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "venue_court_surfaces" */
export type VenueCourtSurfacesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "venue_court_surfaces" */
export type VenueCourtSurfacesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "venue_court_surfaces". */
export type VenueCourtSurfacesOrderBy = {
  courtSurface?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_court_surfaces" */
export enum VenueCourtSurfacesSelectColumn {
  /** column name */
  CourtSurface = 'courtSurface',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** Streaming cursor of the table "venue_court_surfaces" */
export type VenueCourtSurfacesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueCourtSurfacesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueCourtSurfacesStreamCursorValueInput = {
  courtSurface?: InputMaybe<CourtSurfacesEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "venue_custom_amenities" */
export type VenueCustomAmenities = {
  __typename?: 'VenueCustomAmenities';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** order by aggregate values of table "venue_custom_amenities" */
export type VenueCustomAmenitiesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueCustomAmenitiesMaxOrderBy>;
  min?: InputMaybe<VenueCustomAmenitiesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "venue_custom_amenities". All fields are combined with a logical 'AND'. */
export type VenueCustomAmenitiesBoolExp = {
  _and?: InputMaybe<Array<VenueCustomAmenitiesBoolExp>>;
  _not?: InputMaybe<VenueCustomAmenitiesBoolExp>;
  _or?: InputMaybe<Array<VenueCustomAmenitiesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "venue_custom_amenities" */
export type VenueCustomAmenitiesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "venue_custom_amenities" */
export type VenueCustomAmenitiesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "venue_custom_amenities". */
export type VenueCustomAmenitiesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_custom_amenities" */
export enum VenueCustomAmenitiesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** Streaming cursor of the table "venue_custom_amenities" */
export type VenueCustomAmenitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueCustomAmenitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueCustomAmenitiesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "venue_equipment" */
export type VenueEquipment = {
  __typename?: 'VenueEquipment';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  equipment: EquipmentAvailabilitiesEnum;
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** order by aggregate values of table "venue_equipment" */
export type VenueEquipmentAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueEquipmentMaxOrderBy>;
  min?: InputMaybe<VenueEquipmentMinOrderBy>;
};

/** Boolean expression to filter rows from the table "venue_equipment". All fields are combined with a logical 'AND'. */
export type VenueEquipmentBoolExp = {
  _and?: InputMaybe<Array<VenueEquipmentBoolExp>>;
  _not?: InputMaybe<VenueEquipmentBoolExp>;
  _or?: InputMaybe<Array<VenueEquipmentBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  equipment?: InputMaybe<EquipmentAvailabilitiesEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "venue_equipment" */
export type VenueEquipmentMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "venue_equipment" */
export type VenueEquipmentMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "venue_equipment". */
export type VenueEquipmentOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  equipment?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_equipment" */
export enum VenueEquipmentSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Equipment = 'equipment',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** Streaming cursor of the table "venue_equipment" */
export type VenueEquipmentStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueEquipmentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueEquipmentStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  equipment?: InputMaybe<EquipmentAvailabilitiesEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "venue_facility_types" */
export type VenueFacilityTypes = {
  __typename?: 'VenueFacilityTypes';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "venue_facility_types". All fields are combined with a logical 'AND'. */
export type VenueFacilityTypesBoolExp = {
  _and?: InputMaybe<Array<VenueFacilityTypesBoolExp>>;
  _not?: InputMaybe<VenueFacilityTypesBoolExp>;
  _or?: InputMaybe<Array<VenueFacilityTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum VenueFacilityTypesEnum {
  Club = 'CLUB',
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  School = 'SCHOOL'
}

/** Boolean expression to compare columns of type "VenueFacilityTypesEnum". All fields are combined with logical 'AND'. */
export type VenueFacilityTypesEnumComparisonExp = {
  _eq?: InputMaybe<VenueFacilityTypesEnum>;
  _in?: InputMaybe<Array<VenueFacilityTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VenueFacilityTypesEnum>;
  _nin?: InputMaybe<Array<VenueFacilityTypesEnum>>;
};

/** Ordering options when selecting data from "venue_facility_types". */
export type VenueFacilityTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_facility_types" */
export enum VenueFacilityTypesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "venue_facility_types" */
export type VenueFacilityTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueFacilityTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueFacilityTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "venue_faqs" */
export type VenueFaqs = {
  __typename?: 'VenueFaqs';
  answer: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  position: Scalars['Int'];
  question: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** order by aggregate values of table "venue_faqs" */
export type VenueFaqsAggregateOrderBy = {
  avg?: InputMaybe<VenueFaqsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueFaqsMaxOrderBy>;
  min?: InputMaybe<VenueFaqsMinOrderBy>;
  stddev?: InputMaybe<VenueFaqsStddevOrderBy>;
  stddevPop?: InputMaybe<VenueFaqsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VenueFaqsStddevSampOrderBy>;
  sum?: InputMaybe<VenueFaqsSumOrderBy>;
  varPop?: InputMaybe<VenueFaqsVarPopOrderBy>;
  varSamp?: InputMaybe<VenueFaqsVarSampOrderBy>;
  variance?: InputMaybe<VenueFaqsVarianceOrderBy>;
};

/** order by avg() on columns of table "venue_faqs" */
export type VenueFaqsAvgOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "venue_faqs". All fields are combined with a logical 'AND'. */
export type VenueFaqsBoolExp = {
  _and?: InputMaybe<Array<VenueFaqsBoolExp>>;
  _not?: InputMaybe<VenueFaqsBoolExp>;
  _or?: InputMaybe<Array<VenueFaqsBoolExp>>;
  answer?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  position?: InputMaybe<IntComparisonExp>;
  question?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "venue_faqs" */
export type VenueFaqsMaxOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "venue_faqs" */
export type VenueFaqsMinOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "venue_faqs". */
export type VenueFaqsOrderBy = {
  answer?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  question?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_faqs" */
export enum VenueFaqsSelectColumn {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Position = 'position',
  /** column name */
  Question = 'question',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venueId'
}

/** order by stddev() on columns of table "venue_faqs" */
export type VenueFaqsStddevOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "venue_faqs" */
export type VenueFaqsStddevPopOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "venue_faqs" */
export type VenueFaqsStddevSampOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "venue_faqs" */
export type VenueFaqsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueFaqsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueFaqsStreamCursorValueInput = {
  answer?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  position?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "venue_faqs" */
export type VenueFaqsSumOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "venue_faqs" */
export type VenueFaqsVarPopOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "venue_faqs" */
export type VenueFaqsVarSampOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "venue_faqs" */
export type VenueFaqsVarianceOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** columns and relationships of "venue_follows" */
export type VenueFollows = {
  __typename?: 'VenueFollows';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  status: FollowStatusesEnum;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An object relationship */
  userProfile?: Maybe<UserProfiles>;
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "venue_follows" */
export type VenueFollowsAggregate = {
  __typename?: 'VenueFollowsAggregate';
  aggregate?: Maybe<VenueFollowsAggregateFields>;
  nodes: Array<VenueFollows>;
};

export type VenueFollowsAggregateBoolExp = {
  count?: InputMaybe<VenueFollowsAggregateBoolExpCount>;
};

/** aggregate fields of "venue_follows" */
export type VenueFollowsAggregateFields = {
  __typename?: 'VenueFollowsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueFollowsMaxFields>;
  min?: Maybe<VenueFollowsMinFields>;
};


/** aggregate fields of "venue_follows" */
export type VenueFollowsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_follows" */
export type VenueFollowsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueFollowsMaxOrderBy>;
  min?: InputMaybe<VenueFollowsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "venue_follows". All fields are combined with a logical 'AND'. */
export type VenueFollowsBoolExp = {
  _and?: InputMaybe<Array<VenueFollowsBoolExp>>;
  _not?: InputMaybe<VenueFollowsBoolExp>;
  _or?: InputMaybe<Array<VenueFollowsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<FollowStatusesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userProfile?: InputMaybe<UserProfilesBoolExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "venue_follows" */
export enum VenueFollowsConstraint {
  /** unique or primary key constraint on columns "id" */
  VenueFollowsPkey = 'venue_follows_pkey',
  /** unique or primary key constraint on columns "venue_id", "user_id" */
  VenueFollowsVenueIdUserIdKey = 'venue_follows_venue_id_user_id_key'
}

/** input type for inserting data into table "venue_follows" */
export type VenueFollowsInsertInput = {
  status?: InputMaybe<FollowStatusesEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VenueFollowsMaxFields = {
  __typename?: 'VenueFollowsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "venue_follows" */
export type VenueFollowsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueFollowsMinFields = {
  __typename?: 'VenueFollowsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "venue_follows" */
export type VenueFollowsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_follows" */
export type VenueFollowsMutationResponse = {
  __typename?: 'VenueFollowsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueFollows>;
};

/** on_conflict condition type for table "venue_follows" */
export type VenueFollowsOnConflict = {
  constraint: VenueFollowsConstraint;
  updateColumns?: Array<VenueFollowsUpdateColumn>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};

/** Ordering options when selecting data from "venue_follows". */
export type VenueFollowsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  userProfile?: InputMaybe<UserProfilesOrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_follows */
export type VenueFollowsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_follows" */
export enum VenueFollowsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "venue_follows" */
export type VenueFollowsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<FollowStatusesEnum>;
};

/** Streaming cursor of the table "venue_follows" */
export type VenueFollowsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueFollowsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueFollowsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<FollowStatusesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "venue_follows" */
export enum VenueFollowsUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Status = 'status'
}

export type VenueFollowsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueFollowsSetInput>;
  /** filter the rows which have to be updated */
  where: VenueFollowsBoolExp;
};

/** columns and relationships of "venue_images" */
export type VenueImages = {
  __typename?: 'VenueImages';
  attributionHtml: Scalars['String'];
  attributionName: Scalars['String'];
  attributionUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileName: Scalars['String'];
  id: Scalars['uuid'];
  isCover: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  path: Scalars['String'];
  provider: Scalars['String'];
  providerId: Scalars['String'];
  providerUrl: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** order by aggregate values of table "venue_images" */
export type VenueImagesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueImagesMaxOrderBy>;
  min?: InputMaybe<VenueImagesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "venue_images". All fields are combined with a logical 'AND'. */
export type VenueImagesBoolExp = {
  _and?: InputMaybe<Array<VenueImagesBoolExp>>;
  _not?: InputMaybe<VenueImagesBoolExp>;
  _or?: InputMaybe<Array<VenueImagesBoolExp>>;
  attributionHtml?: InputMaybe<StringComparisonExp>;
  attributionName?: InputMaybe<StringComparisonExp>;
  attributionUrl?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isCover?: InputMaybe<BooleanComparisonExp>;
  isVisible?: InputMaybe<BooleanComparisonExp>;
  path?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "venue_images" */
export type VenueImagesMaxOrderBy = {
  attributionHtml?: InputMaybe<OrderBy>;
  attributionName?: InputMaybe<OrderBy>;
  attributionUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "venue_images" */
export type VenueImagesMinOrderBy = {
  attributionHtml?: InputMaybe<OrderBy>;
  attributionName?: InputMaybe<OrderBy>;
  attributionUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "venue_images". */
export type VenueImagesOrderBy = {
  attributionHtml?: InputMaybe<OrderBy>;
  attributionName?: InputMaybe<OrderBy>;
  attributionUrl?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isCover?: InputMaybe<OrderBy>;
  isVisible?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_images" */
export enum VenueImagesSelectColumn {
  /** column name */
  AttributionHtml = 'attributionHtml',
  /** column name */
  AttributionName = 'attributionName',
  /** column name */
  AttributionUrl = 'attributionUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileName = 'fileName',
  /** column name */
  Id = 'id',
  /** column name */
  IsCover = 'isCover',
  /** column name */
  IsVisible = 'isVisible',
  /** column name */
  Path = 'path',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  VenueId = 'venueId'
}

/** Streaming cursor of the table "venue_images" */
export type VenueImagesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueImagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueImagesStreamCursorValueInput = {
  attributionHtml?: InputMaybe<Scalars['String']>;
  attributionName?: InputMaybe<Scalars['String']>;
  attributionUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isCover?: InputMaybe<Scalars['Boolean']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  path?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "venue_lines" */
export type VenueLines = {
  __typename?: 'VenueLines';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "venue_lines". All fields are combined with a logical 'AND'. */
export type VenueLinesBoolExp = {
  _and?: InputMaybe<Array<VenueLinesBoolExp>>;
  _not?: InputMaybe<VenueLinesBoolExp>;
  _or?: InputMaybe<Array<VenueLinesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum VenueLinesEnum {
  Chalk = 'CHALK',
  Permanent = 'PERMANENT',
  Tape = 'TAPE',
  Temporary = 'TEMPORARY'
}

/** Boolean expression to compare columns of type "VenueLinesEnum". All fields are combined with logical 'AND'. */
export type VenueLinesEnumComparisonExp = {
  _eq?: InputMaybe<VenueLinesEnum>;
  _in?: InputMaybe<Array<VenueLinesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VenueLinesEnum>;
  _nin?: InputMaybe<Array<VenueLinesEnum>>;
};

/** Ordering options when selecting data from "venue_lines". */
export type VenueLinesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_lines" */
export enum VenueLinesSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "venue_lines" */
export type VenueLinesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueLinesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueLinesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "venue_nets" */
export type VenueNets = {
  __typename?: 'VenueNets';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "venue_nets". All fields are combined with a logical 'AND'. */
export type VenueNetsBoolExp = {
  _and?: InputMaybe<Array<VenueNetsBoolExp>>;
  _not?: InputMaybe<VenueNetsBoolExp>;
  _or?: InputMaybe<Array<VenueNetsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum VenueNetsEnum {
  BringYourOwn = 'BRING_YOUR_OWN',
  Permanent = 'PERMANENT',
  Portable = 'PORTABLE',
  Tennis = 'TENNIS'
}

/** Boolean expression to compare columns of type "VenueNetsEnum". All fields are combined with logical 'AND'. */
export type VenueNetsEnumComparisonExp = {
  _eq?: InputMaybe<VenueNetsEnum>;
  _in?: InputMaybe<Array<VenueNetsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VenueNetsEnum>;
  _nin?: InputMaybe<Array<VenueNetsEnum>>;
};

/** Ordering options when selecting data from "venue_nets". */
export type VenueNetsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_nets" */
export enum VenueNetsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "venue_nets" */
export type VenueNetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueNetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueNetsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "venue_partner_booking_statuses" */
export type VenuePartnerBookingStatuses = {
  __typename?: 'VenuePartnerBookingStatuses';
  isBookable?: Maybe<Scalars['Boolean']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** Boolean expression to filter rows from the table "venue_partner_booking_statuses". All fields are combined with a logical 'AND'. */
export type VenuePartnerBookingStatusesBoolExp = {
  _and?: InputMaybe<Array<VenuePartnerBookingStatusesBoolExp>>;
  _not?: InputMaybe<VenuePartnerBookingStatusesBoolExp>;
  _or?: InputMaybe<Array<VenuePartnerBookingStatusesBoolExp>>;
  isBookable?: InputMaybe<BooleanComparisonExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** Ordering options when selecting data from "venue_partner_booking_statuses". */
export type VenuePartnerBookingStatusesOrderBy = {
  isBookable?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** select columns of table "venue_partner_booking_statuses" */
export enum VenuePartnerBookingStatusesSelectColumn {
  /** column name */
  IsBookable = 'isBookable',
  /** column name */
  VenueId = 'venueId'
}

/** Streaming cursor of the table "venue_partner_booking_statuses" */
export type VenuePartnerBookingStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenuePartnerBookingStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenuePartnerBookingStatusesStreamCursorValueInput = {
  isBookable?: InputMaybe<Scalars['Boolean']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "venue_staff_coaches" */
export type VenueStaffCoaches = {
  __typename?: 'VenueStaffCoaches';
  addedByUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  addedByUserProfile?: Maybe<UserProfiles>;
  /** An object relationship */
  coachProfile?: Maybe<UserProfiles>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
  /** An object relationship */
  venue: Venues;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "venue_staff_coaches" */
export type VenueStaffCoachesAggregate = {
  __typename?: 'VenueStaffCoachesAggregate';
  aggregate?: Maybe<VenueStaffCoachesAggregateFields>;
  nodes: Array<VenueStaffCoaches>;
};

export type VenueStaffCoachesAggregateBoolExp = {
  count?: InputMaybe<VenueStaffCoachesAggregateBoolExpCount>;
};

/** aggregate fields of "venue_staff_coaches" */
export type VenueStaffCoachesAggregateFields = {
  __typename?: 'VenueStaffCoachesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<VenueStaffCoachesMaxFields>;
  min?: Maybe<VenueStaffCoachesMinFields>;
};


/** aggregate fields of "venue_staff_coaches" */
export type VenueStaffCoachesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue_staff_coaches" */
export type VenueStaffCoachesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenueStaffCoachesMaxOrderBy>;
  min?: InputMaybe<VenueStaffCoachesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "venue_staff_coaches". All fields are combined with a logical 'AND'. */
export type VenueStaffCoachesBoolExp = {
  _and?: InputMaybe<Array<VenueStaffCoachesBoolExp>>;
  _not?: InputMaybe<VenueStaffCoachesBoolExp>;
  _or?: InputMaybe<Array<VenueStaffCoachesBoolExp>>;
  addedByUserId?: InputMaybe<UuidComparisonExp>;
  addedByUserProfile?: InputMaybe<UserProfilesBoolExp>;
  coachProfile?: InputMaybe<UserProfilesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  venue?: InputMaybe<VenuesBoolExp>;
  venueId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "venue_staff_coaches" */
export enum VenueStaffCoachesConstraint {
  /** unique or primary key constraint on columns "id" */
  VenueStaffCoachesPkey = 'venue_staff_coaches_pkey',
  /** unique or primary key constraint on columns "venue_id", "user_id" */
  VenueStaffCoachesVenueIdUserIdActiveIdx = 'venue_staff_coaches_venue_id_user_id_active_idx'
}

/** input type for inserting data into table "venue_staff_coaches" */
export type VenueStaffCoachesInsertInput = {
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type VenueStaffCoachesMaxFields = {
  __typename?: 'VenueStaffCoachesMaxFields';
  addedByUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "venue_staff_coaches" */
export type VenueStaffCoachesMaxOrderBy = {
  addedByUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VenueStaffCoachesMinFields = {
  __typename?: 'VenueStaffCoachesMinFields';
  addedByUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "venue_staff_coaches" */
export type VenueStaffCoachesMinOrderBy = {
  addedByUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "venue_staff_coaches" */
export type VenueStaffCoachesMutationResponse = {
  __typename?: 'VenueStaffCoachesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VenueStaffCoaches>;
};

/** on_conflict condition type for table "venue_staff_coaches" */
export type VenueStaffCoachesOnConflict = {
  constraint: VenueStaffCoachesConstraint;
  updateColumns?: Array<VenueStaffCoachesUpdateColumn>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};

/** Ordering options when selecting data from "venue_staff_coaches". */
export type VenueStaffCoachesOrderBy = {
  addedByUserId?: InputMaybe<OrderBy>;
  addedByUserProfile?: InputMaybe<UserProfilesOrderBy>;
  coachProfile?: InputMaybe<UserProfilesOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  venue?: InputMaybe<VenuesOrderBy>;
  venueId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: venue_staff_coaches */
export type VenueStaffCoachesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_staff_coaches" */
export enum VenueStaffCoachesSelectColumn {
  /** column name */
  AddedByUserId = 'addedByUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "venue_staff_coaches" */
export type VenueStaffCoachesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "venue_staff_coaches" */
export type VenueStaffCoachesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenueStaffCoachesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenueStaffCoachesStreamCursorValueInput = {
  addedByUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "venue_staff_coaches" */
export enum VenueStaffCoachesUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt'
}

export type VenueStaffCoachesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VenueStaffCoachesSetInput>;
  /** filter the rows which have to be updated */
  where: VenueStaffCoachesBoolExp;
};

/** columns and relationships of "venues" */
export type Venues = {
  __typename?: 'Venues';
  accessDetails: Scalars['String'];
  accessType?: Maybe<VenueAccessTypesEnum>;
  addressString: Scalars['String'];
  /** An object relationship */
  adminUser?: Maybe<Users>;
  /** An array relationship */
  amenities: Array<VenueAmenities>;
  /** An object relationship */
  city?: Maybe<Cities>;
  cityId?: Maybe<Scalars['uuid']>;
  coordinatesWkb: Scalars['String'];
  /** An array relationship */
  courtSurfaces: Array<VenueCourtSurfaces>;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  customAmenities: Array<VenueCustomAmenities>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  /** An array relationship */
  equipment: Array<VenueEquipment>;
  facebookUrl?: Maybe<Scalars['String']>;
  facilityType?: Maybe<VenueFacilityTypesEnum>;
  /** An array relationship */
  faqs: Array<VenueFaqs>;
  featuredPriority?: Maybe<Scalars['Int']>;
  geometry?: Maybe<Scalars['geography']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  /** An array relationship */
  groups: Array<GroupVenues>;
  /** An aggregate relationship */
  groupsAggregate: GroupVenuesAggregate;
  hasPadel: Scalars['Boolean'];
  hasPickleball: Scalars['Boolean'];
  hasPlatformTennis: Scalars['Boolean'];
  hasReservations?: Maybe<Scalars['Boolean']>;
  hasTennis: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An array relationship */
  images: Array<VenueImages>;
  indoorCourtCount: Scalars['Int'];
  instagramUrl?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  latitude: Scalars['numeric'];
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An aggregate relationship */
  lessonsAggregate: LessonsAggregate;
  linkedinUrl?: Maybe<Scalars['String']>;
  longitude: Scalars['numeric'];
  outdoorCourtCount: Scalars['Int'];
  /** An object relationship */
  partnerBookingStatus?: Maybe<VenuePartnerBookingStatuses>;
  pickleballLines?: Maybe<VenueLinesEnum>;
  pickleballNets?: Maybe<VenueNetsEnum>;
  /** An array relationship */
  playSessions: Array<PlaySessions>;
  /** An aggregate relationship */
  playSessionsAggregate: PlaySessionsAggregate;
  scheduleDetails: Scalars['String'];
  shouldHideDefaultDescription: Scalars['Boolean'];
  slug: Scalars['String'];
  /** An array relationship */
  staffCoaches: Array<VenueStaffCoaches>;
  /** An aggregate relationship */
  staffCoachesAggregate: VenueStaffCoachesAggregate;
  timezone: Scalars['String'];
  title: Scalars['String'];
  totalCourtCount: Scalars['Int'];
  twitterUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  venueSlug: Scalars['String'];
  websiteUrl: Scalars['String'];
  youtubeUrl?: Maybe<Scalars['String']>;
};


/** columns and relationships of "venues" */
export type VenuesAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<VenueAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAmenitiesOrderBy>>;
  where?: InputMaybe<VenueAmenitiesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesCourtSurfacesArgs = {
  distinctOn?: InputMaybe<Array<VenueCourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCourtSurfacesOrderBy>>;
  where?: InputMaybe<VenueCourtSurfacesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesCustomAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<VenueCustomAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCustomAmenitiesOrderBy>>;
  where?: InputMaybe<VenueCustomAmenitiesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesEquipmentArgs = {
  distinctOn?: InputMaybe<Array<VenueEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueEquipmentOrderBy>>;
  where?: InputMaybe<VenueEquipmentBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesFaqsArgs = {
  distinctOn?: InputMaybe<Array<VenueFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFaqsOrderBy>>;
  where?: InputMaybe<VenueFaqsBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesGroupsArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesImagesArgs = {
  distinctOn?: InputMaybe<Array<VenueImagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueImagesOrderBy>>;
  where?: InputMaybe<VenueImagesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesPlaySessionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesStaffCoachesArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


/** columns and relationships of "venues" */
export type VenuesStaffCoachesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};

/** order by aggregate values of table "venues" */
export type VenuesAggregateOrderBy = {
  avg?: InputMaybe<VenuesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VenuesMaxOrderBy>;
  min?: InputMaybe<VenuesMinOrderBy>;
  stddev?: InputMaybe<VenuesStddevOrderBy>;
  stddevPop?: InputMaybe<VenuesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VenuesStddevSampOrderBy>;
  sum?: InputMaybe<VenuesSumOrderBy>;
  varPop?: InputMaybe<VenuesVarPopOrderBy>;
  varSamp?: InputMaybe<VenuesVarSampOrderBy>;
  variance?: InputMaybe<VenuesVarianceOrderBy>;
};

/** order by avg() on columns of table "venues" */
export type VenuesAvgOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "venues". All fields are combined with a logical 'AND'. */
export type VenuesBoolExp = {
  _and?: InputMaybe<Array<VenuesBoolExp>>;
  _not?: InputMaybe<VenuesBoolExp>;
  _or?: InputMaybe<Array<VenuesBoolExp>>;
  accessDetails?: InputMaybe<StringComparisonExp>;
  accessType?: InputMaybe<VenueAccessTypesEnumComparisonExp>;
  addressString?: InputMaybe<StringComparisonExp>;
  adminUser?: InputMaybe<UsersBoolExp>;
  amenities?: InputMaybe<VenueAmenitiesBoolExp>;
  city?: InputMaybe<CitiesBoolExp>;
  cityId?: InputMaybe<UuidComparisonExp>;
  coordinatesWkb?: InputMaybe<StringComparisonExp>;
  courtSurfaces?: InputMaybe<VenueCourtSurfacesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customAmenities?: InputMaybe<VenueCustomAmenitiesBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  equipment?: InputMaybe<VenueEquipmentBoolExp>;
  facebookUrl?: InputMaybe<StringComparisonExp>;
  facilityType?: InputMaybe<VenueFacilityTypesEnumComparisonExp>;
  faqs?: InputMaybe<VenueFaqsBoolExp>;
  featuredPriority?: InputMaybe<IntComparisonExp>;
  geometry?: InputMaybe<GeographyComparisonExp>;
  googlePlaceId?: InputMaybe<StringComparisonExp>;
  groups?: InputMaybe<GroupVenuesBoolExp>;
  groupsAggregate?: InputMaybe<GroupVenuesAggregateBoolExp>;
  hasPadel?: InputMaybe<BooleanComparisonExp>;
  hasPickleball?: InputMaybe<BooleanComparisonExp>;
  hasPlatformTennis?: InputMaybe<BooleanComparisonExp>;
  hasReservations?: InputMaybe<BooleanComparisonExp>;
  hasTennis?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  images?: InputMaybe<VenueImagesBoolExp>;
  indoorCourtCount?: InputMaybe<IntComparisonExp>;
  instagramUrl?: InputMaybe<StringComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  latitude?: InputMaybe<NumericComparisonExp>;
  lessons?: InputMaybe<LessonsBoolExp>;
  lessonsAggregate?: InputMaybe<LessonsAggregateBoolExp>;
  linkedinUrl?: InputMaybe<StringComparisonExp>;
  longitude?: InputMaybe<NumericComparisonExp>;
  outdoorCourtCount?: InputMaybe<IntComparisonExp>;
  partnerBookingStatus?: InputMaybe<VenuePartnerBookingStatusesBoolExp>;
  pickleballLines?: InputMaybe<VenueLinesEnumComparisonExp>;
  pickleballNets?: InputMaybe<VenueNetsEnumComparisonExp>;
  playSessions?: InputMaybe<PlaySessionsBoolExp>;
  playSessionsAggregate?: InputMaybe<PlaySessionsAggregateBoolExp>;
  scheduleDetails?: InputMaybe<StringComparisonExp>;
  shouldHideDefaultDescription?: InputMaybe<BooleanComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  staffCoaches?: InputMaybe<VenueStaffCoachesBoolExp>;
  staffCoachesAggregate?: InputMaybe<VenueStaffCoachesAggregateBoolExp>;
  timezone?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  totalCourtCount?: InputMaybe<IntComparisonExp>;
  twitterUrl?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  venueSlug?: InputMaybe<StringComparisonExp>;
  websiteUrl?: InputMaybe<StringComparisonExp>;
  youtubeUrl?: InputMaybe<StringComparisonExp>;
};

/** order by max() on columns of table "venues" */
export type VenuesMaxOrderBy = {
  accessDetails?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  coordinatesWkb?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  featuredPriority?: InputMaybe<OrderBy>;
  googlePlaceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  linkedinUrl?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  scheduleDetails?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
  twitterUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueSlug?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "venues" */
export type VenuesMinOrderBy = {
  accessDetails?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  cityId?: InputMaybe<OrderBy>;
  coordinatesWkb?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  featuredPriority?: InputMaybe<OrderBy>;
  googlePlaceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  linkedinUrl?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  scheduleDetails?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
  twitterUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueSlug?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "venues". */
export type VenuesOrderBy = {
  accessDetails?: InputMaybe<OrderBy>;
  accessType?: InputMaybe<OrderBy>;
  addressString?: InputMaybe<OrderBy>;
  adminUser?: InputMaybe<UsersOrderBy>;
  amenitiesAggregate?: InputMaybe<VenueAmenitiesAggregateOrderBy>;
  city?: InputMaybe<CitiesOrderBy>;
  cityId?: InputMaybe<OrderBy>;
  coordinatesWkb?: InputMaybe<OrderBy>;
  courtSurfacesAggregate?: InputMaybe<VenueCourtSurfacesAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customAmenitiesAggregate?: InputMaybe<VenueCustomAmenitiesAggregateOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  equipmentAggregate?: InputMaybe<VenueEquipmentAggregateOrderBy>;
  facebookUrl?: InputMaybe<OrderBy>;
  facilityType?: InputMaybe<OrderBy>;
  faqsAggregate?: InputMaybe<VenueFaqsAggregateOrderBy>;
  featuredPriority?: InputMaybe<OrderBy>;
  geometry?: InputMaybe<OrderBy>;
  googlePlaceId?: InputMaybe<OrderBy>;
  groupsAggregate?: InputMaybe<GroupVenuesAggregateOrderBy>;
  hasPadel?: InputMaybe<OrderBy>;
  hasPickleball?: InputMaybe<OrderBy>;
  hasPlatformTennis?: InputMaybe<OrderBy>;
  hasReservations?: InputMaybe<OrderBy>;
  hasTennis?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imagesAggregate?: InputMaybe<VenueImagesAggregateOrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  instagramUrl?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  lessonsAggregate?: InputMaybe<LessonsAggregateOrderBy>;
  linkedinUrl?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  partnerBookingStatus?: InputMaybe<VenuePartnerBookingStatusesOrderBy>;
  pickleballLines?: InputMaybe<OrderBy>;
  pickleballNets?: InputMaybe<OrderBy>;
  playSessionsAggregate?: InputMaybe<PlaySessionsAggregateOrderBy>;
  scheduleDetails?: InputMaybe<OrderBy>;
  shouldHideDefaultDescription?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  staffCoachesAggregate?: InputMaybe<VenueStaffCoachesAggregateOrderBy>;
  timezone?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
  twitterUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  venueSlug?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  youtubeUrl?: InputMaybe<OrderBy>;
};

/** select columns of table "venues" */
export enum VenuesSelectColumn {
  /** column name */
  AccessDetails = 'accessDetails',
  /** column name */
  AccessType = 'accessType',
  /** column name */
  AddressString = 'addressString',
  /** column name */
  CityId = 'cityId',
  /** column name */
  CoordinatesWkb = 'coordinatesWkb',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  FacebookUrl = 'facebookUrl',
  /** column name */
  FacilityType = 'facilityType',
  /** column name */
  FeaturedPriority = 'featuredPriority',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  GooglePlaceId = 'googlePlaceId',
  /** column name */
  HasPadel = 'hasPadel',
  /** column name */
  HasPickleball = 'hasPickleball',
  /** column name */
  HasPlatformTennis = 'hasPlatformTennis',
  /** column name */
  HasReservations = 'hasReservations',
  /** column name */
  HasTennis = 'hasTennis',
  /** column name */
  Id = 'id',
  /** column name */
  IndoorCourtCount = 'indoorCourtCount',
  /** column name */
  InstagramUrl = 'instagramUrl',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LinkedinUrl = 'linkedinUrl',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  OutdoorCourtCount = 'outdoorCourtCount',
  /** column name */
  PickleballLines = 'pickleballLines',
  /** column name */
  PickleballNets = 'pickleballNets',
  /** column name */
  ScheduleDetails = 'scheduleDetails',
  /** column name */
  ShouldHideDefaultDescription = 'shouldHideDefaultDescription',
  /** column name */
  Slug = 'slug',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Title = 'title',
  /** column name */
  TotalCourtCount = 'totalCourtCount',
  /** column name */
  TwitterUrl = 'twitterUrl',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueSlug = 'venueSlug',
  /** column name */
  WebsiteUrl = 'websiteUrl',
  /** column name */
  YoutubeUrl = 'youtubeUrl'
}

/** order by stddev() on columns of table "venues" */
export type VenuesStddevOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "venues" */
export type VenuesStddevPopOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "venues" */
export type VenuesStddevSampOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "venues" */
export type VenuesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VenuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VenuesStreamCursorValueInput = {
  accessDetails?: InputMaybe<Scalars['String']>;
  accessType?: InputMaybe<VenueAccessTypesEnum>;
  addressString?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  coordinatesWkb?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  facilityType?: InputMaybe<VenueFacilityTypesEnum>;
  featuredPriority?: InputMaybe<Scalars['Int']>;
  geometry?: InputMaybe<Scalars['geography']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  hasPadel?: InputMaybe<Scalars['Boolean']>;
  hasPickleball?: InputMaybe<Scalars['Boolean']>;
  hasPlatformTennis?: InputMaybe<Scalars['Boolean']>;
  hasReservations?: InputMaybe<Scalars['Boolean']>;
  hasTennis?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  indoorCourtCount?: InputMaybe<Scalars['Int']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  outdoorCourtCount?: InputMaybe<Scalars['Int']>;
  pickleballLines?: InputMaybe<VenueLinesEnum>;
  pickleballNets?: InputMaybe<VenueNetsEnum>;
  scheduleDetails?: InputMaybe<Scalars['String']>;
  shouldHideDefaultDescription?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalCourtCount?: InputMaybe<Scalars['Int']>;
  twitterUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venueSlug?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "venues" */
export type VenuesSumOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "venues" */
export type VenuesVarPopOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "venues" */
export type VenuesVarSampOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "venues" */
export type VenuesVarianceOrderBy = {
  featuredPriority?: InputMaybe<OrderBy>;
  indoorCourtCount?: InputMaybe<OrderBy>;
  latitude?: InputMaybe<OrderBy>;
  longitude?: InputMaybe<OrderBy>;
  outdoorCourtCount?: InputMaybe<OrderBy>;
  totalCourtCount?: InputMaybe<OrderBy>;
};

/** table for coach video content analysis from player */
export type VideoAnalysis = {
  __typename?: 'VideoAnalysis';
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  locale: Scalars['String'];
  /** An array relationship */
  orders: Array<VideoAnalysisOrders>;
  paymentFulfillmentChannel?: Maybe<PaymentFulfillmentChannelsEnum>;
  priceUnitAmount: Scalars['Int'];
  reviewStatus?: Maybe<VideoAnalysisReviewStatusesEnum>;
  reviewerUserId: Scalars['uuid'];
  submissionRequestedFeedback: Scalars['String'];
  submissionUserId: Scalars['uuid'];
  timezoneAbbreviation: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  videoAnalysisComments: Array<VideoAnalysisComments>;
  videoAnalysisFileId: Scalars['uuid'];
  /** An object relationship */
  videoAnalysisFiles: VideoAnalysisFiles;
  /** An array relationship */
  videoAnalysisRequestedSkillsReviews: Array<VideoAnalysisRequestedSkillsReview>;
  /** An object relationship */
  videoAnalysisReviewer?: Maybe<UserProfiles>;
  /** An object relationship */
  videoAnalysisSubmission?: Maybe<UserProfiles>;
  /** An object relationship */
  videoAnalysisUserReview?: Maybe<Users>;
  /** An object relationship */
  videoAnalysisUserSubmitter?: Maybe<Users>;
};


/** table for coach video content analysis from player */
export type VideoAnalysisOrdersArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrdersOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrdersBoolExp>;
};


/** table for coach video content analysis from player */
export type VideoAnalysisVideoAnalysisCommentsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisCommentsBoolExp>;
};


/** table for coach video content analysis from player */
export type VideoAnalysisVideoAnalysisRequestedSkillsReviewsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewOrderBy>>;
  where?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
};

/** aggregated selection of "video_analysis" */
export type VideoAnalysisAggregate = {
  __typename?: 'VideoAnalysisAggregate';
  aggregate?: Maybe<VideoAnalysisAggregateFields>;
  nodes: Array<VideoAnalysis>;
};

export type VideoAnalysisAggregateBoolExp = {
  count?: InputMaybe<VideoAnalysisAggregateBoolExpCount>;
};

/** aggregate fields of "video_analysis" */
export type VideoAnalysisAggregateFields = {
  __typename?: 'VideoAnalysisAggregateFields';
  avg?: Maybe<VideoAnalysisAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VideoAnalysisMaxFields>;
  min?: Maybe<VideoAnalysisMinFields>;
  stddev?: Maybe<VideoAnalysisStddevFields>;
  stddevPop?: Maybe<VideoAnalysisStddevPopFields>;
  stddevSamp?: Maybe<VideoAnalysisStddevSampFields>;
  sum?: Maybe<VideoAnalysisSumFields>;
  varPop?: Maybe<VideoAnalysisVarPopFields>;
  varSamp?: Maybe<VideoAnalysisVarSampFields>;
  variance?: Maybe<VideoAnalysisVarianceFields>;
};


/** aggregate fields of "video_analysis" */
export type VideoAnalysisAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "video_analysis" */
export type VideoAnalysisAggregateOrderBy = {
  avg?: InputMaybe<VideoAnalysisAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoAnalysisMaxOrderBy>;
  min?: InputMaybe<VideoAnalysisMinOrderBy>;
  stddev?: InputMaybe<VideoAnalysisStddevOrderBy>;
  stddevPop?: InputMaybe<VideoAnalysisStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VideoAnalysisStddevSampOrderBy>;
  sum?: InputMaybe<VideoAnalysisSumOrderBy>;
  varPop?: InputMaybe<VideoAnalysisVarPopOrderBy>;
  varSamp?: InputMaybe<VideoAnalysisVarSampOrderBy>;
  variance?: InputMaybe<VideoAnalysisVarianceOrderBy>;
};

/** aggregate avg on columns */
export type VideoAnalysisAvgFields = {
  __typename?: 'VideoAnalysisAvgFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "video_analysis" */
export type VideoAnalysisAvgOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "video_analysis". All fields are combined with a logical 'AND'. */
export type VideoAnalysisBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisBoolExp>>;
  _not?: InputMaybe<VideoAnalysisBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  locale?: InputMaybe<StringComparisonExp>;
  orders?: InputMaybe<VideoAnalysisOrdersBoolExp>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnumComparisonExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnumComparisonExp>;
  reviewerUserId?: InputMaybe<UuidComparisonExp>;
  submissionRequestedFeedback?: InputMaybe<StringComparisonExp>;
  submissionUserId?: InputMaybe<UuidComparisonExp>;
  timezoneAbbreviation?: InputMaybe<StringComparisonExp>;
  timezoneName?: InputMaybe<StringComparisonExp>;
  timezoneOffsetMinutes?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  videoAnalysisComments?: InputMaybe<VideoAnalysisCommentsBoolExp>;
  videoAnalysisFileId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesBoolExp>;
  videoAnalysisRequestedSkillsReviews?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
  videoAnalysisReviewer?: InputMaybe<UserProfilesBoolExp>;
  videoAnalysisSubmission?: InputMaybe<UserProfilesBoolExp>;
  videoAnalysisUserReview?: InputMaybe<UsersBoolExp>;
  videoAnalysisUserSubmitter?: InputMaybe<UsersBoolExp>;
};

/** columns and relationships of "video_analysis_comments" */
export type VideoAnalysisComments = {
  __typename?: 'VideoAnalysisComments';
  /** An object relationship */
  commenterUserId: Users;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  details: Scalars['String'];
  endTimestamp?: Maybe<Scalars['String']>;
  endTimestampSeconds?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  sentiment: FeedbackSentimentEnum;
  startTimestamp?: Maybe<Scalars['String']>;
  startTimestampSeconds?: Maybe<Scalars['numeric']>;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
  /** An object relationship */
  videoAnalysis: VideoAnalysis;
  videoAnalysisFileId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  videoAnalysisFiles?: Maybe<VideoAnalysisFiles>;
  videoAnalysisId: Scalars['uuid'];
  /** An array relationship */
  videoAnalysisSkillsComments: Array<VideoAnalysisSkillsComments>;
};


/** columns and relationships of "video_analysis_comments" */
export type VideoAnalysisCommentsVideoAnalysisSkillsCommentsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSkillsCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSkillsCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};

/** order by aggregate values of table "video_analysis_comments" */
export type VideoAnalysisCommentsAggregateOrderBy = {
  avg?: InputMaybe<VideoAnalysisCommentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoAnalysisCommentsMaxOrderBy>;
  min?: InputMaybe<VideoAnalysisCommentsMinOrderBy>;
  stddev?: InputMaybe<VideoAnalysisCommentsStddevOrderBy>;
  stddevPop?: InputMaybe<VideoAnalysisCommentsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VideoAnalysisCommentsStddevSampOrderBy>;
  sum?: InputMaybe<VideoAnalysisCommentsSumOrderBy>;
  varPop?: InputMaybe<VideoAnalysisCommentsVarPopOrderBy>;
  varSamp?: InputMaybe<VideoAnalysisCommentsVarSampOrderBy>;
  variance?: InputMaybe<VideoAnalysisCommentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "video_analysis_comments" */
export type VideoAnalysisCommentsArrRelInsertInput = {
  data: Array<VideoAnalysisCommentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisCommentsOnConflict>;
};

/** order by avg() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsAvgOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "video_analysis_comments". All fields are combined with a logical 'AND'. */
export type VideoAnalysisCommentsBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisCommentsBoolExp>>;
  _not?: InputMaybe<VideoAnalysisCommentsBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisCommentsBoolExp>>;
  commenterUserId?: InputMaybe<UsersBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  details?: InputMaybe<StringComparisonExp>;
  endTimestamp?: InputMaybe<StringComparisonExp>;
  endTimestampSeconds?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  sentiment?: InputMaybe<FeedbackSentimentEnumComparisonExp>;
  startTimestamp?: InputMaybe<StringComparisonExp>;
  startTimestampSeconds?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  videoAnalysis?: InputMaybe<VideoAnalysisBoolExp>;
  videoAnalysisFileId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesBoolExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisSkillsComments?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};

/** unique or primary key constraints on table "video_analysis_comments" */
export enum VideoAnalysisCommentsConstraint {
  /** unique or primary key constraint on columns "id" */
  VideoAnalysisCommentsPkey = 'video_analysis_comments_pkey'
}

/** input type for incrementing numeric columns in table "video_analysis_comments" */
export type VideoAnalysisCommentsIncInput = {
  endTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  startTimestampSeconds?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "video_analysis_comments" */
export type VideoAnalysisCommentsInsertInput = {
  details?: InputMaybe<Scalars['String']>;
  endTimestamp?: InputMaybe<Scalars['String']>;
  endTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  sentiment?: InputMaybe<FeedbackSentimentEnum>;
  startTimestamp?: InputMaybe<Scalars['String']>;
  startTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  userId?: InputMaybe<Scalars['uuid']>;
  videoAnalysis?: InputMaybe<VideoAnalysisObjRelInsertInput>;
  videoAnalysisFileId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesObjRelInsertInput>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisSkillsComments?: InputMaybe<VideoAnalysisSkillsCommentsArrRelInsertInput>;
};

/** order by max() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  endTimestamp?: InputMaybe<OrderBy>;
  endTimestampSeconds?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startTimestamp?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  videoAnalysisFileId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  endTimestamp?: InputMaybe<OrderBy>;
  endTimestampSeconds?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startTimestamp?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  videoAnalysisFileId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "video_analysis_comments" */
export type VideoAnalysisCommentsMutationResponse = {
  __typename?: 'VideoAnalysisCommentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysisComments>;
};

/** input type for inserting object relation for remote table "video_analysis_comments" */
export type VideoAnalysisCommentsObjRelInsertInput = {
  data: VideoAnalysisCommentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisCommentsOnConflict>;
};

/** on_conflict condition type for table "video_analysis_comments" */
export type VideoAnalysisCommentsOnConflict = {
  constraint: VideoAnalysisCommentsConstraint;
  updateColumns?: Array<VideoAnalysisCommentsUpdateColumn>;
  where?: InputMaybe<VideoAnalysisCommentsBoolExp>;
};

/** Ordering options when selecting data from "video_analysis_comments". */
export type VideoAnalysisCommentsOrderBy = {
  commenterUserId?: InputMaybe<UsersOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  endTimestamp?: InputMaybe<OrderBy>;
  endTimestampSeconds?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sentiment?: InputMaybe<OrderBy>;
  startTimestamp?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  videoAnalysis?: InputMaybe<VideoAnalysisOrderBy>;
  videoAnalysisFileId?: InputMaybe<OrderBy>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesOrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
  videoAnalysisSkillsCommentsAggregate?: InputMaybe<VideoAnalysisSkillsCommentsAggregateOrderBy>;
};

/** primary key columns input for table: video_analysis_comments */
export type VideoAnalysisCommentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "video_analysis_comments" */
export enum VideoAnalysisCommentsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Details = 'details',
  /** column name */
  EndTimestamp = 'endTimestamp',
  /** column name */
  EndTimestampSeconds = 'endTimestampSeconds',
  /** column name */
  Id = 'id',
  /** column name */
  Sentiment = 'sentiment',
  /** column name */
  StartTimestamp = 'startTimestamp',
  /** column name */
  StartTimestampSeconds = 'startTimestampSeconds',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VideoAnalysisFileId = 'videoAnalysisFileId',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

/** input type for updating data in table "video_analysis_comments" */
export type VideoAnalysisCommentsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  details?: InputMaybe<Scalars['String']>;
  endTimestamp?: InputMaybe<Scalars['String']>;
  endTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  sentiment?: InputMaybe<FeedbackSentimentEnum>;
  startTimestamp?: InputMaybe<Scalars['String']>;
  startTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  videoAnalysisFileId?: InputMaybe<Scalars['uuid']>;
};

/** order by stddev() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsStddevOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsStddevPopOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsStddevSampOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "video_analysis_comments" */
export type VideoAnalysisCommentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisCommentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisCommentsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  details?: InputMaybe<Scalars['String']>;
  endTimestamp?: InputMaybe<Scalars['String']>;
  endTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  sentiment?: InputMaybe<FeedbackSentimentEnum>;
  startTimestamp?: InputMaybe<Scalars['String']>;
  startTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisFileId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsSumOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** update columns of table "video_analysis_comments" */
export enum VideoAnalysisCommentsUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Details = 'details',
  /** column name */
  EndTimestamp = 'endTimestamp',
  /** column name */
  EndTimestampSeconds = 'endTimestampSeconds',
  /** column name */
  Sentiment = 'sentiment',
  /** column name */
  StartTimestamp = 'startTimestamp',
  /** column name */
  StartTimestampSeconds = 'startTimestampSeconds',
  /** column name */
  VideoAnalysisFileId = 'videoAnalysisFileId'
}

export type VideoAnalysisCommentsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<VideoAnalysisCommentsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisCommentsSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisCommentsBoolExp;
};

/** order by varPop() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsVarPopOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsVarSampOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "video_analysis_comments" */
export type VideoAnalysisCommentsVarianceOrderBy = {
  endTimestampSeconds?: InputMaybe<OrderBy>;
  startTimestampSeconds?: InputMaybe<OrderBy>;
};

/** unique or primary key constraints on table "video_analysis" */
export enum VideoAnalysisConstraint {
  /** unique or primary key constraint on columns "id" */
  VideoAnalysisPkey = 'video_analysis_pkey'
}

/** columns and relationships of "video_analysis_files" */
export type VideoAnalysisFiles = {
  __typename?: 'VideoAnalysisFiles';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileCategory: FileCategoryEnum;
  fileFormat: FileFormatEnum;
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  host: Scalars['String'];
  id: Scalars['uuid'];
  originalFileName?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  providerId: Scalars['String'];
  providerUrl: Scalars['String'];
  transcript: Scalars['String'];
  transcriptionCompletedAt?: Maybe<Scalars['timestamptz']>;
  transcriptionStartedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
  uploadStatus: VideoAnalysisFilesUploadStatusesEnum;
  url: Scalars['String'];
  userId: Scalars['uuid'];
};

/** order by aggregate values of table "video_analysis_files" */
export type VideoAnalysisFilesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoAnalysisFilesMaxOrderBy>;
  min?: InputMaybe<VideoAnalysisFilesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "video_analysis_files". All fields are combined with a logical 'AND'. */
export type VideoAnalysisFilesBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisFilesBoolExp>>;
  _not?: InputMaybe<VideoAnalysisFilesBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisFilesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  fileCategory?: InputMaybe<FileCategoryEnumComparisonExp>;
  fileFormat?: InputMaybe<FileFormatEnumComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileType?: InputMaybe<StringComparisonExp>;
  host?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  originalFileName?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerUrl?: InputMaybe<StringComparisonExp>;
  transcript?: InputMaybe<StringComparisonExp>;
  transcriptionCompletedAt?: InputMaybe<TimestamptzComparisonExp>;
  transcriptionStartedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  uploadStatus?: InputMaybe<VideoAnalysisFilesUploadStatusesEnumComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "video_analysis_files" */
export enum VideoAnalysisFilesConstraint {
  /** unique or primary key constraint on columns "id" */
  VideoAnalysisFilesPkey = 'video_analysis_files_pkey'
}

/** input type for inserting data into table "video_analysis_files" */
export type VideoAnalysisFilesInsertInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  uploadStatus?: InputMaybe<VideoAnalysisFilesUploadStatusesEnum>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "video_analysis_files" */
export type VideoAnalysisFilesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  transcript?: InputMaybe<OrderBy>;
  transcriptionCompletedAt?: InputMaybe<OrderBy>;
  transcriptionStartedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "video_analysis_files" */
export type VideoAnalysisFilesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  transcript?: InputMaybe<OrderBy>;
  transcriptionCompletedAt?: InputMaybe<OrderBy>;
  transcriptionStartedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "video_analysis_files" */
export type VideoAnalysisFilesMutationResponse = {
  __typename?: 'VideoAnalysisFilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysisFiles>;
};

/** input type for inserting object relation for remote table "video_analysis_files" */
export type VideoAnalysisFilesObjRelInsertInput = {
  data: VideoAnalysisFilesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisFilesOnConflict>;
};

/** on_conflict condition type for table "video_analysis_files" */
export type VideoAnalysisFilesOnConflict = {
  constraint: VideoAnalysisFilesConstraint;
  updateColumns?: Array<VideoAnalysisFilesUpdateColumn>;
  where?: InputMaybe<VideoAnalysisFilesBoolExp>;
};

/** Ordering options when selecting data from "video_analysis_files". */
export type VideoAnalysisFilesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileCategory?: InputMaybe<OrderBy>;
  fileFormat?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileType?: InputMaybe<OrderBy>;
  host?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originalFileName?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerUrl?: InputMaybe<OrderBy>;
  transcript?: InputMaybe<OrderBy>;
  transcriptionCompletedAt?: InputMaybe<OrderBy>;
  transcriptionStartedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  uploadStatus?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: video_analysis_files */
export type VideoAnalysisFilesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "video_analysis_files" */
export enum VideoAnalysisFilesSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  Transcript = 'transcript',
  /** column name */
  TranscriptionCompletedAt = 'transcriptionCompletedAt',
  /** column name */
  TranscriptionStartedAt = 'transcriptionStartedAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadStatus = 'uploadStatus',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "video_analysis_files" */
export type VideoAnalysisFilesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  uploadStatus?: InputMaybe<VideoAnalysisFilesUploadStatusesEnum>;
  url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "video_analysis_files" */
export type VideoAnalysisFilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisFilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisFilesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileCategory?: InputMaybe<FileCategoryEnum>;
  fileFormat?: InputMaybe<FileFormatEnum>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUrl?: InputMaybe<Scalars['String']>;
  transcript?: InputMaybe<Scalars['String']>;
  transcriptionCompletedAt?: InputMaybe<Scalars['timestamptz']>;
  transcriptionStartedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadStatus?: InputMaybe<VideoAnalysisFilesUploadStatusesEnum>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "video_analysis_files" */
export enum VideoAnalysisFilesUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FileCategory = 'fileCategory',
  /** column name */
  FileFormat = 'fileFormat',
  /** column name */
  FileName = 'fileName',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Host = 'host',
  /** column name */
  OriginalFileName = 'originalFileName',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderUrl = 'providerUrl',
  /** column name */
  UploadStatus = 'uploadStatus',
  /** column name */
  Url = 'url'
}

export type VideoAnalysisFilesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisFilesSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisFilesBoolExp;
};

export enum VideoAnalysisFilesUploadStatusesEnum {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "VideoAnalysisFilesUploadStatusesEnum". All fields are combined with logical 'AND'. */
export type VideoAnalysisFilesUploadStatusesEnumComparisonExp = {
  _eq?: InputMaybe<VideoAnalysisFilesUploadStatusesEnum>;
  _in?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VideoAnalysisFilesUploadStatusesEnum>;
  _nin?: InputMaybe<Array<VideoAnalysisFilesUploadStatusesEnum>>;
};

/** input type for inserting data into table "video_analysis" */
export type VideoAnalysisInsertInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  submissionRequestedFeedback?: InputMaybe<Scalars['String']>;
  submissionUserId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisComments?: InputMaybe<VideoAnalysisCommentsArrRelInsertInput>;
  videoAnalysisFileId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesObjRelInsertInput>;
};

/** aggregate max on columns */
export type VideoAnalysisMaxFields = {
  __typename?: 'VideoAnalysisMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  submissionRequestedFeedback?: Maybe<Scalars['String']>;
  submissionUserId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisFileId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "video_analysis" */
export type VideoAnalysisMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  submissionRequestedFeedback?: InputMaybe<OrderBy>;
  submissionUserId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisFileId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VideoAnalysisMinFields = {
  __typename?: 'VideoAnalysisMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  priceUnitAmount?: Maybe<Scalars['Int']>;
  reviewerUserId?: Maybe<Scalars['uuid']>;
  submissionRequestedFeedback?: Maybe<Scalars['String']>;
  submissionUserId?: Maybe<Scalars['uuid']>;
  timezoneAbbreviation?: Maybe<Scalars['String']>;
  timezoneName?: Maybe<Scalars['String']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisFileId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "video_analysis" */
export type VideoAnalysisMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  submissionRequestedFeedback?: InputMaybe<OrderBy>;
  submissionUserId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisFileId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "video_analysis" */
export type VideoAnalysisMutationResponse = {
  __typename?: 'VideoAnalysisMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysis>;
};

/** input type for inserting object relation for remote table "video_analysis" */
export type VideoAnalysisObjRelInsertInput = {
  data: VideoAnalysisInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisOnConflict>;
};

/** on_conflict condition type for table "video_analysis" */
export type VideoAnalysisOnConflict = {
  constraint: VideoAnalysisConstraint;
  updateColumns?: Array<VideoAnalysisUpdateColumn>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};

/** Ordering options when selecting data from "video_analysis". */
export type VideoAnalysisOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  ordersAggregate?: InputMaybe<VideoAnalysisOrdersAggregateOrderBy>;
  paymentFulfillmentChannel?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  reviewStatus?: InputMaybe<OrderBy>;
  reviewerUserId?: InputMaybe<OrderBy>;
  submissionRequestedFeedback?: InputMaybe<OrderBy>;
  submissionUserId?: InputMaybe<OrderBy>;
  timezoneAbbreviation?: InputMaybe<OrderBy>;
  timezoneName?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisCommentsAggregate?: InputMaybe<VideoAnalysisCommentsAggregateOrderBy>;
  videoAnalysisFileId?: InputMaybe<OrderBy>;
  videoAnalysisFiles?: InputMaybe<VideoAnalysisFilesOrderBy>;
  videoAnalysisRequestedSkillsReviewsAggregate?: InputMaybe<VideoAnalysisRequestedSkillsReviewAggregateOrderBy>;
  videoAnalysisReviewer?: InputMaybe<UserProfilesOrderBy>;
  videoAnalysisSubmission?: InputMaybe<UserProfilesOrderBy>;
  videoAnalysisUserReview?: InputMaybe<UsersOrderBy>;
  videoAnalysisUserSubmitter?: InputMaybe<UsersOrderBy>;
};

/** columns and relationships of "video_analysis_order_items" */
export type VideoAnalysisOrderItems = {
  __typename?: 'VideoAnalysisOrderItems';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  order?: Maybe<VideoAnalysisOrders>;
  priceUnitAmount: Scalars['Int'];
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  status: OrderStatusesEnum;
  totalUnitAmount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  videoAnalysisOrderId: Scalars['uuid'];
};

/** order by aggregate values of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsAggregateOrderBy = {
  avg?: InputMaybe<VideoAnalysisOrderItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoAnalysisOrderItemsMaxOrderBy>;
  min?: InputMaybe<VideoAnalysisOrderItemsMinOrderBy>;
  stddev?: InputMaybe<VideoAnalysisOrderItemsStddevOrderBy>;
  stddevPop?: InputMaybe<VideoAnalysisOrderItemsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VideoAnalysisOrderItemsStddevSampOrderBy>;
  sum?: InputMaybe<VideoAnalysisOrderItemsSumOrderBy>;
  varPop?: InputMaybe<VideoAnalysisOrderItemsVarPopOrderBy>;
  varSamp?: InputMaybe<VideoAnalysisOrderItemsVarSampOrderBy>;
  variance?: InputMaybe<VideoAnalysisOrderItemsVarianceOrderBy>;
};

/** order by avg() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsAvgOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "video_analysis_order_items". All fields are combined with a logical 'AND'. */
export type VideoAnalysisOrderItemsBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisOrderItemsBoolExp>>;
  _not?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisOrderItemsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  order?: InputMaybe<VideoAnalysisOrdersBoolExp>;
  priceUnitAmount?: InputMaybe<IntComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  totalUnitAmount?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  videoAnalysisOrderId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisOrderId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisOrderId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "video_analysis_order_items". */
export type VideoAnalysisOrderItemsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  order?: InputMaybe<VideoAnalysisOrdersOrderBy>;
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisOrderId?: InputMaybe<OrderBy>;
};

/** select columns of table "video_analysis_order_items" */
export enum VideoAnalysisOrderItemsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  Status = 'status',
  /** column name */
  TotalUnitAmount = 'totalUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisOrderId = 'videoAnalysisOrderId'
}

/** order by stddev() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsStddevOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsStddevPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsStddevSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisOrderItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisOrderItemsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  status?: InputMaybe<OrderStatusesEnum>;
  totalUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisOrderId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsSumOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsVarPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsVarSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "video_analysis_order_items" */
export type VideoAnalysisOrderItemsVarianceOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  totalUnitAmount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "video_analysis_orders" */
export type VideoAnalysisOrders = {
  __typename?: 'VideoAnalysisOrders';
  applicationFeeTotalUnitAmount: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  creditCard?: Maybe<UserCreditCards>;
  /** An object relationship */
  customer: Users;
  customerApplicationFeeUnitAmount: Scalars['Int'];
  customerUserId: Scalars['uuid'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId: Scalars['String'];
  id: Scalars['uuid'];
  internalStripePaymentIntentId: Scalars['uuid'];
  /** An array relationship */
  items: Array<VideoAnalysisOrderItems>;
  orderSubtotalUnitAmount: Scalars['Int'];
  orderTotalUnitAmount: Scalars['Int'];
  paidUnitAmount: Scalars['Int'];
  paymentProcessor: PaymentProcessorsEnum;
  refundUnitAmount: Scalars['Int'];
  refundedAt?: Maybe<Scalars['timestamptz']>;
  refundedByPersona?: Maybe<AppPersonasEnum>;
  /** An object relationship */
  seller: Users;
  sellerApplicationFeeUnitAmount: Scalars['Int'];
  sellerUserId: Scalars['uuid'];
  status: OrderStatusesEnum;
  stripeCustomerId: Scalars['String'];
  stripeMerchantId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  transferUnitAmount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  userCreditCardId?: Maybe<Scalars['uuid']>;
  videoAnalysisId: Scalars['uuid'];
};


/** columns and relationships of "video_analysis_orders" */
export type VideoAnalysisOrdersItemsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderItemsOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
};

/** order by aggregate values of table "video_analysis_orders" */
export type VideoAnalysisOrdersAggregateOrderBy = {
  avg?: InputMaybe<VideoAnalysisOrdersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoAnalysisOrdersMaxOrderBy>;
  min?: InputMaybe<VideoAnalysisOrdersMinOrderBy>;
  stddev?: InputMaybe<VideoAnalysisOrdersStddevOrderBy>;
  stddevPop?: InputMaybe<VideoAnalysisOrdersStddevPopOrderBy>;
  stddevSamp?: InputMaybe<VideoAnalysisOrdersStddevSampOrderBy>;
  sum?: InputMaybe<VideoAnalysisOrdersSumOrderBy>;
  varPop?: InputMaybe<VideoAnalysisOrdersVarPopOrderBy>;
  varSamp?: InputMaybe<VideoAnalysisOrdersVarSampOrderBy>;
  variance?: InputMaybe<VideoAnalysisOrdersVarianceOrderBy>;
};

/** order by avg() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersAvgOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "video_analysis_orders". All fields are combined with a logical 'AND'. */
export type VideoAnalysisOrdersBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisOrdersBoolExp>>;
  _not?: InputMaybe<VideoAnalysisOrdersBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisOrdersBoolExp>>;
  applicationFeeTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  creditCard?: InputMaybe<UserCreditCardsBoolExp>;
  customer?: InputMaybe<UsersBoolExp>;
  customerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  customerUserId?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  externalStripePaymentIntentId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalStripePaymentIntentId?: InputMaybe<UuidComparisonExp>;
  items?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
  orderSubtotalUnitAmount?: InputMaybe<IntComparisonExp>;
  orderTotalUnitAmount?: InputMaybe<IntComparisonExp>;
  paidUnitAmount?: InputMaybe<IntComparisonExp>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnumComparisonExp>;
  refundUnitAmount?: InputMaybe<IntComparisonExp>;
  refundedAt?: InputMaybe<TimestamptzComparisonExp>;
  refundedByPersona?: InputMaybe<AppPersonasEnumComparisonExp>;
  seller?: InputMaybe<UsersBoolExp>;
  sellerApplicationFeeUnitAmount?: InputMaybe<IntComparisonExp>;
  sellerUserId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<OrderStatusesEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  stripeMerchantId?: InputMaybe<StringComparisonExp>;
  stripePaymentStatus?: InputMaybe<StringComparisonExp>;
  transferUnitAmount?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userCreditCardId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersMaxOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersMinOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "video_analysis_orders". */
export type VideoAnalysisOrdersOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  creditCard?: InputMaybe<UserCreditCardsOrderBy>;
  customer?: InputMaybe<UsersOrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalStripePaymentIntentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalStripePaymentIntentId?: InputMaybe<OrderBy>;
  itemsAggregate?: InputMaybe<VideoAnalysisOrderItemsAggregateOrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  paymentProcessor?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  refundedAt?: InputMaybe<OrderBy>;
  refundedByPersona?: InputMaybe<OrderBy>;
  seller?: InputMaybe<UsersOrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  sellerUserId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  stripeMerchantId?: InputMaybe<OrderBy>;
  stripePaymentStatus?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userCreditCardId?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
};

/** select columns of table "video_analysis_orders" */
export enum VideoAnalysisOrdersSelectColumn {
  /** column name */
  ApplicationFeeTotalUnitAmount = 'applicationFeeTotalUnitAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerApplicationFeeUnitAmount = 'customerApplicationFeeUnitAmount',
  /** column name */
  CustomerUserId = 'customerUserId',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExternalStripePaymentIntentId = 'externalStripePaymentIntentId',
  /** column name */
  Id = 'id',
  /** column name */
  InternalStripePaymentIntentId = 'internalStripePaymentIntentId',
  /** column name */
  OrderSubtotalUnitAmount = 'orderSubtotalUnitAmount',
  /** column name */
  OrderTotalUnitAmount = 'orderTotalUnitAmount',
  /** column name */
  PaidUnitAmount = 'paidUnitAmount',
  /** column name */
  PaymentProcessor = 'paymentProcessor',
  /** column name */
  RefundUnitAmount = 'refundUnitAmount',
  /** column name */
  RefundedAt = 'refundedAt',
  /** column name */
  RefundedByPersona = 'refundedByPersona',
  /** column name */
  SellerApplicationFeeUnitAmount = 'sellerApplicationFeeUnitAmount',
  /** column name */
  SellerUserId = 'sellerUserId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripeMerchantId = 'stripeMerchantId',
  /** column name */
  StripePaymentStatus = 'stripePaymentStatus',
  /** column name */
  TransferUnitAmount = 'transferUnitAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserCreditCardId = 'userCreditCardId',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId'
}

/** order by stddev() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersStddevOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevPop() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersStddevPopOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** order by stddevSamp() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersStddevSampOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "video_analysis_orders" */
export type VideoAnalysisOrdersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisOrdersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisOrdersStreamCursorValueInput = {
  applicationFeeTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  customerUserId?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  externalStripePaymentIntentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internalStripePaymentIntentId?: InputMaybe<Scalars['uuid']>;
  orderSubtotalUnitAmount?: InputMaybe<Scalars['Int']>;
  orderTotalUnitAmount?: InputMaybe<Scalars['Int']>;
  paidUnitAmount?: InputMaybe<Scalars['Int']>;
  paymentProcessor?: InputMaybe<PaymentProcessorsEnum>;
  refundUnitAmount?: InputMaybe<Scalars['Int']>;
  refundedAt?: InputMaybe<Scalars['timestamptz']>;
  refundedByPersona?: InputMaybe<AppPersonasEnum>;
  sellerApplicationFeeUnitAmount?: InputMaybe<Scalars['Int']>;
  sellerUserId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<OrderStatusesEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripeMerchantId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  transferUnitAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userCreditCardId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersSumOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varPop() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersVarPopOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** order by varSamp() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersVarSampOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "video_analysis_orders" */
export type VideoAnalysisOrdersVarianceOrderBy = {
  applicationFeeTotalUnitAmount?: InputMaybe<OrderBy>;
  customerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  orderSubtotalUnitAmount?: InputMaybe<OrderBy>;
  orderTotalUnitAmount?: InputMaybe<OrderBy>;
  paidUnitAmount?: InputMaybe<OrderBy>;
  refundUnitAmount?: InputMaybe<OrderBy>;
  sellerApplicationFeeUnitAmount?: InputMaybe<OrderBy>;
  transferUnitAmount?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: video_analysis */
export type VideoAnalysisPkColumnsInput = {
  id: Scalars['uuid'];
};

/** columns and relationships of "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReview = {
  __typename?: 'VideoAnalysisRequestedSkillsReview';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  videoAnalysis: VideoAnalysis;
  videoAnalysisId: Scalars['uuid'];
  videoLessonSkillId: Scalars['uuid'];
  /** An object relationship */
  videoLessonSkills: VideoLessonSkills;
};

/** order by aggregate values of table "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoAnalysisRequestedSkillsReviewMaxOrderBy>;
  min?: InputMaybe<VideoAnalysisRequestedSkillsReviewMinOrderBy>;
};

/** Boolean expression to filter rows from the table "video_analysis_requested_skills_review". All fields are combined with a logical 'AND'. */
export type VideoAnalysisRequestedSkillsReviewBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewBoolExp>>;
  _not?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  videoAnalysis?: InputMaybe<VideoAnalysisBoolExp>;
  videoAnalysisId?: InputMaybe<UuidComparisonExp>;
  videoLessonSkillId?: InputMaybe<UuidComparisonExp>;
  videoLessonSkills?: InputMaybe<VideoLessonSkillsBoolExp>;
};

/** order by max() on columns of table "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
  videoLessonSkillId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
  videoLessonSkillId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "video_analysis_requested_skills_review". */
export type VideoAnalysisRequestedSkillsReviewOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysis?: InputMaybe<VideoAnalysisOrderBy>;
  videoAnalysisId?: InputMaybe<OrderBy>;
  videoLessonSkillId?: InputMaybe<OrderBy>;
  videoLessonSkills?: InputMaybe<VideoLessonSkillsOrderBy>;
};

/** select columns of table "video_analysis_requested_skills_review" */
export enum VideoAnalysisRequestedSkillsReviewSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId',
  /** column name */
  VideoLessonSkillId = 'videoLessonSkillId'
}

/** Streaming cursor of the table "video_analysis_requested_skills_review" */
export type VideoAnalysisRequestedSkillsReviewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisRequestedSkillsReviewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisRequestedSkillsReviewStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  videoLessonSkillId?: InputMaybe<Scalars['uuid']>;
};

export enum VideoAnalysisReviewStatusesEnum {
  Complete = 'COMPLETE',
  Draft = 'DRAFT',
  Pending = 'PENDING',
  Reviewed = 'REVIEWED'
}

/** Boolean expression to compare columns of type "VideoAnalysisReviewStatusesEnum". All fields are combined with logical 'AND'. */
export type VideoAnalysisReviewStatusesEnumComparisonExp = {
  _eq?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  _in?: InputMaybe<Array<VideoAnalysisReviewStatusesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  _nin?: InputMaybe<Array<VideoAnalysisReviewStatusesEnum>>;
};

/** select columns of table "video_analysis" */
export enum VideoAnalysisSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Locale = 'locale',
  /** column name */
  PaymentFulfillmentChannel = 'paymentFulfillmentChannel',
  /** column name */
  PriceUnitAmount = 'priceUnitAmount',
  /** column name */
  ReviewStatus = 'reviewStatus',
  /** column name */
  ReviewerUserId = 'reviewerUserId',
  /** column name */
  SubmissionRequestedFeedback = 'submissionRequestedFeedback',
  /** column name */
  SubmissionUserId = 'submissionUserId',
  /** column name */
  TimezoneAbbreviation = 'timezoneAbbreviation',
  /** column name */
  TimezoneName = 'timezoneName',
  /** column name */
  TimezoneOffsetMinutes = 'timezoneOffsetMinutes',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisFileId = 'videoAnalysisFileId'
}

/** input type for updating data in table "video_analysis" */
export type VideoAnalysisSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
};

/** columns and relationships of "video_analysis_skills_comments" */
export type VideoAnalysisSkillsComments = {
  __typename?: 'VideoAnalysisSkillsComments';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
  videoAnalysisCommentId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  videoAnalysisComments?: Maybe<VideoAnalysisComments>;
  videoLessonSkillId: Scalars['uuid'];
  /** An object relationship */
  videoLessonSkills: VideoLessonSkills;
};

/** order by aggregate values of table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoAnalysisSkillsCommentsMaxOrderBy>;
  min?: InputMaybe<VideoAnalysisSkillsCommentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsArrRelInsertInput = {
  data: Array<VideoAnalysisSkillsCommentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VideoAnalysisSkillsCommentsOnConflict>;
};

/** Boolean expression to filter rows from the table "video_analysis_skills_comments". All fields are combined with a logical 'AND'. */
export type VideoAnalysisSkillsCommentsBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisSkillsCommentsBoolExp>>;
  _not?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisSkillsCommentsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  videoAnalysisCommentId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisComments?: InputMaybe<VideoAnalysisCommentsBoolExp>;
  videoLessonSkillId?: InputMaybe<UuidComparisonExp>;
  videoLessonSkills?: InputMaybe<VideoLessonSkillsBoolExp>;
};

/** unique or primary key constraints on table "video_analysis_skills_comments" */
export enum VideoAnalysisSkillsCommentsConstraint {
  /** unique or primary key constraint on columns "id" */
  VideoAnalysisSkillsCommentsPkey = 'video_analysis_skills_comments_pkey',
  /** unique or primary key constraint on columns "video_lesson_skill_id", "video_analysis_comment_id" */
  VideoAnalysisSkillsCommentsVideoLessonSkillIdVideoAnay = 'video_analysis_skills_comments_video_lesson_skill_id_video_anay'
}

/** input type for inserting data into table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsInsertInput = {
  videoAnalysisCommentId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisComments?: InputMaybe<VideoAnalysisCommentsObjRelInsertInput>;
  videoLessonSkillId?: InputMaybe<Scalars['uuid']>;
  videoLessonSkills?: InputMaybe<VideoLessonSkillsObjRelInsertInput>;
};

/** order by max() on columns of table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisCommentId?: InputMaybe<OrderBy>;
  videoLessonSkillId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisCommentId?: InputMaybe<OrderBy>;
  videoLessonSkillId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsMutationResponse = {
  __typename?: 'VideoAnalysisSkillsCommentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysisSkillsComments>;
};

/** on_conflict condition type for table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsOnConflict = {
  constraint: VideoAnalysisSkillsCommentsConstraint;
  updateColumns?: Array<VideoAnalysisSkillsCommentsUpdateColumn>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};

/** Ordering options when selecting data from "video_analysis_skills_comments". */
export type VideoAnalysisSkillsCommentsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  videoAnalysisCommentId?: InputMaybe<OrderBy>;
  videoAnalysisComments?: InputMaybe<VideoAnalysisCommentsOrderBy>;
  videoLessonSkillId?: InputMaybe<OrderBy>;
  videoLessonSkills?: InputMaybe<VideoLessonSkillsOrderBy>;
};

/** primary key columns input for table: video_analysis_skills_comments */
export type VideoAnalysisSkillsCommentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "video_analysis_skills_comments" */
export enum VideoAnalysisSkillsCommentsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoAnalysisCommentId = 'videoAnalysisCommentId',
  /** column name */
  VideoLessonSkillId = 'videoLessonSkillId'
}

/** input type for updating data in table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "video_analysis_skills_comments" */
export type VideoAnalysisSkillsCommentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisSkillsCommentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisSkillsCommentsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisCommentId?: InputMaybe<Scalars['uuid']>;
  videoLessonSkillId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "video_analysis_skills_comments" */
export enum VideoAnalysisSkillsCommentsUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt'
}

export type VideoAnalysisSkillsCommentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisSkillsCommentsSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisSkillsCommentsBoolExp;
};

/** aggregate stddev on columns */
export type VideoAnalysisStddevFields = {
  __typename?: 'VideoAnalysisStddevFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "video_analysis" */
export type VideoAnalysisStddevOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type VideoAnalysisStddevPopFields = {
  __typename?: 'VideoAnalysisStddevPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "video_analysis" */
export type VideoAnalysisStddevPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type VideoAnalysisStddevSampFields = {
  __typename?: 'VideoAnalysisStddevSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "video_analysis" */
export type VideoAnalysisStddevSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "video_analysis" */
export type VideoAnalysisStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  locale?: InputMaybe<Scalars['String']>;
  paymentFulfillmentChannel?: InputMaybe<PaymentFulfillmentChannelsEnum>;
  priceUnitAmount?: InputMaybe<Scalars['Int']>;
  reviewStatus?: InputMaybe<VideoAnalysisReviewStatusesEnum>;
  reviewerUserId?: InputMaybe<Scalars['uuid']>;
  submissionRequestedFeedback?: InputMaybe<Scalars['String']>;
  submissionUserId?: InputMaybe<Scalars['uuid']>;
  timezoneAbbreviation?: InputMaybe<Scalars['String']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  videoAnalysisFileId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLog = {
  __typename?: 'VideoAnalysisSubmissionLog';
  id: Scalars['uuid'];
};

/** Boolean expression to filter rows from the table "video_analysis_submission_log". All fields are combined with a logical 'AND'. */
export type VideoAnalysisSubmissionLogBoolExp = {
  _and?: InputMaybe<Array<VideoAnalysisSubmissionLogBoolExp>>;
  _not?: InputMaybe<VideoAnalysisSubmissionLogBoolExp>;
  _or?: InputMaybe<Array<VideoAnalysisSubmissionLogBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "video_analysis_submission_log" */
export enum VideoAnalysisSubmissionLogConstraint {
  /** unique or primary key constraint on columns "id" */
  VideoAnalysisSubmissionLogPkey = 'video_analysis_submission_log_pkey'
}

/** input type for inserting data into table "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLogInsertInput = {
  userId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  videoName?: InputMaybe<Scalars['String']>;
  videoPath?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLogMutationResponse = {
  __typename?: 'VideoAnalysisSubmissionLogMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoAnalysisSubmissionLog>;
};

/** on_conflict condition type for table "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLogOnConflict = {
  constraint: VideoAnalysisSubmissionLogConstraint;
  updateColumns?: Array<VideoAnalysisSubmissionLogUpdateColumn>;
  where?: InputMaybe<VideoAnalysisSubmissionLogBoolExp>;
};

/** Ordering options when selecting data from "video_analysis_submission_log". */
export type VideoAnalysisSubmissionLogOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: video_analysis_submission_log */
export type VideoAnalysisSubmissionLogPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "video_analysis_submission_log" */
export enum VideoAnalysisSubmissionLogSelectColumn {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLogSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  videoName?: InputMaybe<Scalars['String']>;
  videoPath?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "video_analysis_submission_log" */
export type VideoAnalysisSubmissionLogStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoAnalysisSubmissionLogStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoAnalysisSubmissionLogStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "video_analysis_submission_log" */
export enum VideoAnalysisSubmissionLogUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VideoAnalysisId = 'videoAnalysisId',
  /** column name */
  VideoName = 'videoName',
  /** column name */
  VideoPath = 'videoPath'
}

export type VideoAnalysisSubmissionLogUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisSubmissionLogSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisSubmissionLogBoolExp;
};

/** aggregate sum on columns */
export type VideoAnalysisSumFields = {
  __typename?: 'VideoAnalysisSumFields';
  priceUnitAmount?: Maybe<Scalars['Int']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "video_analysis" */
export type VideoAnalysisSumOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** update columns of table "video_analysis" */
export enum VideoAnalysisUpdateColumn {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ReviewStatus = 'reviewStatus'
}

export type VideoAnalysisUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoAnalysisSetInput>;
  /** filter the rows which have to be updated */
  where: VideoAnalysisBoolExp;
};

/** aggregate varPop on columns */
export type VideoAnalysisVarPopFields = {
  __typename?: 'VideoAnalysisVarPopFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "video_analysis" */
export type VideoAnalysisVarPopOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type VideoAnalysisVarSampFields = {
  __typename?: 'VideoAnalysisVarSampFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "video_analysis" */
export type VideoAnalysisVarSampOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type VideoAnalysisVarianceFields = {
  __typename?: 'VideoAnalysisVarianceFields';
  priceUnitAmount?: Maybe<Scalars['Float']>;
  timezoneOffsetMinutes?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "video_analysis" */
export type VideoAnalysisVarianceOrderBy = {
  priceUnitAmount?: InputMaybe<OrderBy>;
  timezoneOffsetMinutes?: InputMaybe<OrderBy>;
};

/** columns and relationships of "video_lesson_skills" */
export type VideoLessonSkills = {
  __typename?: 'VideoLessonSkills';
  createdAt: Scalars['timestamptz'];
  customSkill?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  skill?: Maybe<LessonSkillsEnum>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  /** An array relationship */
  videoAnalysisSkillsComments: Array<VideoAnalysisSkillsComments>;
};


/** columns and relationships of "video_lesson_skills" */
export type VideoLessonSkillsVideoAnalysisSkillsCommentsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSkillsCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSkillsCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};

/** Boolean expression to filter rows from the table "video_lesson_skills". All fields are combined with a logical 'AND'. */
export type VideoLessonSkillsBoolExp = {
  _and?: InputMaybe<Array<VideoLessonSkillsBoolExp>>;
  _not?: InputMaybe<VideoLessonSkillsBoolExp>;
  _or?: InputMaybe<Array<VideoLessonSkillsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customSkill?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  skill?: InputMaybe<LessonSkillsEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  videoAnalysisSkillsComments?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};

/** unique or primary key constraints on table "video_lesson_skills" */
export enum VideoLessonSkillsConstraint {
  /** unique or primary key constraint on columns "id" */
  VideoLessonSkillsPkey = 'video_lesson_skills_pkey'
}

/** input type for inserting data into table "video_lesson_skills" */
export type VideoLessonSkillsInsertInput = {
  customSkill?: InputMaybe<Scalars['String']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisSkillsComments?: InputMaybe<VideoAnalysisSkillsCommentsArrRelInsertInput>;
};

/** response of any mutation on the table "video_lesson_skills" */
export type VideoLessonSkillsMutationResponse = {
  __typename?: 'VideoLessonSkillsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<VideoLessonSkills>;
};

/** input type for inserting object relation for remote table "video_lesson_skills" */
export type VideoLessonSkillsObjRelInsertInput = {
  data: VideoLessonSkillsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<VideoLessonSkillsOnConflict>;
};

/** on_conflict condition type for table "video_lesson_skills" */
export type VideoLessonSkillsOnConflict = {
  constraint: VideoLessonSkillsConstraint;
  updateColumns?: Array<VideoLessonSkillsUpdateColumn>;
  where?: InputMaybe<VideoLessonSkillsBoolExp>;
};

/** Ordering options when selecting data from "video_lesson_skills". */
export type VideoLessonSkillsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customSkill?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  skill?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  videoAnalysisSkillsCommentsAggregate?: InputMaybe<VideoAnalysisSkillsCommentsAggregateOrderBy>;
};

/** primary key columns input for table: video_lesson_skills */
export type VideoLessonSkillsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "video_lesson_skills" */
export enum VideoLessonSkillsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomSkill = 'customSkill',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Skill = 'skill',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "video_lesson_skills" */
export type VideoLessonSkillsSetInput = {
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  skill?: InputMaybe<LessonSkillsEnum>;
};

/** Streaming cursor of the table "video_lesson_skills" */
export type VideoLessonSkillsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoLessonSkillsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoLessonSkillsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customSkill?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  skill?: InputMaybe<LessonSkillsEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "video_lesson_skills" */
export enum VideoLessonSkillsUpdateColumn {
  /** column name */
  CustomSkill = 'customSkill',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Skill = 'skill'
}

export type VideoLessonSkillsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VideoLessonSkillsSetInput>;
  /** filter the rows which have to be updated */
  where: VideoLessonSkillsBoolExp;
};

/** columns and relationships of "win_reasons" */
export type WinReasons = {
  __typename?: 'WinReasons';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** Boolean expression to filter rows from the table "win_reasons". All fields are combined with a logical 'AND'. */
export type WinReasonsBoolExp = {
  _and?: InputMaybe<Array<WinReasonsBoolExp>>;
  _not?: InputMaybe<WinReasonsBoolExp>;
  _or?: InputMaybe<Array<WinReasonsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum WinReasonsEnum {
  Forfeit = 'FORFEIT',
  OrganizerSelected = 'ORGANIZER_SELECTED',
  Retire = 'RETIRE',
  Score = 'SCORE'
}

/** Boolean expression to compare columns of type "WinReasonsEnum". All fields are combined with logical 'AND'. */
export type WinReasonsEnumComparisonExp = {
  _eq?: InputMaybe<WinReasonsEnum>;
  _in?: InputMaybe<Array<WinReasonsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<WinReasonsEnum>;
  _nin?: InputMaybe<Array<WinReasonsEnum>>;
};

/** Ordering options when selecting data from "win_reasons". */
export type WinReasonsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "win_reasons" */
export enum WinReasonsSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "win_reasons" */
export type WinReasonsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: WinReasonsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WinReasonsStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type EventAcceptedPlayRequestsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventCouponRedemptionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventCouponRedemptionsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventRegistrationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventRegistrationsBoolExp>;
  predicate: IntComparisonExp;
};

export type EventsAggregateBoolExpBool_And = {
  arguments: EventsSelectColumnEventsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventsAggregateBoolExpBool_Or = {
  arguments: EventsSelectColumnEventsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventsBoolExp>;
  predicate: IntComparisonExp;
};

export type GroupCommentVotesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupCommentVotesBoolExp>;
  predicate: IntComparisonExp;
};

export type GroupMembersAggregateBoolExpBool_And = {
  arguments: GroupMembersSelectColumnGroupMembersAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupMembersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type GroupMembersAggregateBoolExpBool_Or = {
  arguments: GroupMembersSelectColumnGroupMembersAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupMembersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type GroupMembersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GroupMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupMembersBoolExp>;
  predicate: IntComparisonExp;
};

export type GroupThreadCommentsAggregateBoolExpBool_And = {
  arguments: GroupThreadCommentsSelectColumnGroupThreadCommentsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupThreadCommentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type GroupThreadCommentsAggregateBoolExpBool_Or = {
  arguments: GroupThreadCommentsSelectColumnGroupThreadCommentsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupThreadCommentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type GroupThreadCommentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupThreadCommentsBoolExp>;
  predicate: IntComparisonExp;
};

export type GroupVenuesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GroupVenuesBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonOrdersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonOrdersBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonParticipantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonParticipantsBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonWaitlistsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonWaitlistsBoolExp>;
  predicate: IntComparisonExp;
};

export type LessonsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LessonsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LessonsBoolExp>;
  predicate: IntComparisonExp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "coach_availability" */
  deleteCoachAvailability?: Maybe<CoachAvailabilityMutationResponse>;
  /** delete single row from the table: "coach_availability" */
  deleteCoachAvailabilityByPk?: Maybe<CoachAvailability>;
  /** delete data from the table: "coach_lesson_age_groups" */
  deleteCoachLessonAgeGroups?: Maybe<CoachLessonAgeGroupsMutationResponse>;
  /** delete single row from the table: "coach_lesson_age_groups" */
  deleteCoachLessonAgeGroupsByPk?: Maybe<CoachLessonAgeGroups>;
  /** delete data from the table: "coach_lesson_skill_levels" */
  deleteCoachLessonSkillLevels?: Maybe<CoachLessonSkillLevelsMutationResponse>;
  /** delete single row from the table: "coach_lesson_skill_levels" */
  deleteCoachLessonSkillLevelsByPk?: Maybe<CoachLessonSkillLevels>;
  /** delete data from the table: "event_faqs" */
  deleteEventFaqs?: Maybe<EventFaqsMutationResponse>;
  /** delete single row from the table: "event_faqs" */
  deleteEventFaqsByPk?: Maybe<EventFaqs>;
  /** delete data from the table: "event_group_rating_scales" */
  deleteEventGroupRatingScales?: Maybe<EventGroupRatingScalesMutationResponse>;
  /** delete single row from the table: "event_group_rating_scales" */
  deleteEventGroupRatingScalesByPk?: Maybe<EventGroupRatingScales>;
  /** delete data from the table: "event_group_time_slots" */
  deleteEventGroupTimeSlots?: Maybe<EventGroupTimeSlotsMutationResponse>;
  /** delete single row from the table: "event_group_time_slots" */
  deleteEventGroupTimeSlotsByPk?: Maybe<EventGroupTimeSlots>;
  /** delete data from the table: "event_skill_levels" */
  deleteEventSkillLevels?: Maybe<EventSkillLevelsMutationResponse>;
  /** delete single row from the table: "event_skill_levels" */
  deleteEventSkillLevelsByPk?: Maybe<EventSkillLevels>;
  /** delete data from the table: "event_sponsors" */
  deleteEventSponsors?: Maybe<EventSponsorsMutationResponse>;
  /** delete single row from the table: "event_sponsors" */
  deleteEventSponsorsByPk?: Maybe<EventSponsors>;
  /** delete data from the table: "learning_program_enrollment_schedule_media_watched" */
  deleteLearningProgramEnrollmentScheduleMediaWatched?: Maybe<LearningProgramEnrollmentScheduleMediaWatchedMutationResponse>;
  /** delete single row from the table: "learning_program_enrollment_schedule_media_watched" */
  deleteLearningProgramEnrollmentScheduleMediaWatchedByPk?: Maybe<LearningProgramEnrollmentScheduleMediaWatched>;
  /** delete data from the table: "lesson_equipment" */
  deleteLessonEquipment?: Maybe<LessonEquipmentMutationResponse>;
  /** delete single row from the table: "lesson_equipment" */
  deleteLessonEquipmentByPk?: Maybe<LessonEquipment>;
  /** delete data from the table: "lesson_player_skill_assessments_skills" */
  deleteLessonPlayerSkillAssessmentsSkills?: Maybe<LessonPlayerSkillAssessmentsSkillsMutationResponse>;
  /** delete single row from the table: "lesson_player_skill_assessments_skills" */
  deleteLessonPlayerSkillAssessmentsSkillsByPk?: Maybe<LessonPlayerSkillAssessmentsSkills>;
  /** delete data from the table: "lesson_reflection_comments" */
  deleteLessonReflectionComments?: Maybe<LessonReflectionCommentsMutationResponse>;
  /** delete single row from the table: "lesson_reflection_comments" */
  deleteLessonReflectionCommentsByPk?: Maybe<LessonReflectionComments>;
  /** delete data from the table: "lesson_reflection_files" */
  deleteLessonReflectionFiles?: Maybe<LessonReflectionFilesMutationResponse>;
  /** delete single row from the table: "lesson_reflection_files" */
  deleteLessonReflectionFilesByPk?: Maybe<LessonReflectionFiles>;
  /** delete data from the table: "lesson_reflections" */
  deleteLessonReflections?: Maybe<LessonReflectionsMutationResponse>;
  /** delete single row from the table: "lesson_reflections" */
  deleteLessonReflectionsByPk?: Maybe<LessonReflections>;
  /** delete data from the table: "lesson_skill_levels" */
  deleteLessonSkillLevels?: Maybe<LessonSkillLevelsMutationResponse>;
  /** delete single row from the table: "lesson_skill_levels" */
  deleteLessonSkillLevelsByPk?: Maybe<LessonSkillLevels>;
  /** delete data from the table: "lesson_template_skill_levels" */
  deleteLessonTemplateSkillLevels?: Maybe<LessonTemplateSkillLevelsMutationResponse>;
  /** delete single row from the table: "lesson_template_skill_levels" */
  deleteLessonTemplateSkillLevelsByPk?: Maybe<LessonTemplateSkillLevels>;
  /** delete data from the table: "lesson_times" */
  deleteLessonTimes?: Maybe<LessonTimesMutationResponse>;
  /** delete single row from the table: "lesson_times" */
  deleteLessonTimesByPk?: Maybe<LessonTimes>;
  /** delete data from the table: "player_availabilities" */
  deletePlayerAvailabilities?: Maybe<PlayerAvailabilitiesMutationResponse>;
  /** delete single row from the table: "player_availabilities" */
  deletePlayerAvailabilitiesByPk?: Maybe<PlayerAvailabilities>;
  /** delete data from the table: "player_availability_neighborhoods" */
  deletePlayerAvailabilityNeighborhoods?: Maybe<PlayerAvailabilityNeighborhoodsMutationResponse>;
  /** delete single row from the table: "player_availability_neighborhoods" */
  deletePlayerAvailabilityNeighborhoodsByPk?: Maybe<PlayerAvailabilityNeighborhoods>;
  /** delete data from the table: "player_availability_rating_scales" */
  deletePlayerAvailabilityRatingScales?: Maybe<PlayerAvailabilityRatingScalesMutationResponse>;
  /** delete single row from the table: "player_availability_rating_scales" */
  deletePlayerAvailabilityRatingScalesByPk?: Maybe<PlayerAvailabilityRatingScales>;
  /** delete data from the table: "player_availability_slots" */
  deletePlayerAvailabilitySlots?: Maybe<PlayerAvailabilitySlotsMutationResponse>;
  /** delete single row from the table: "player_availability_slots" */
  deletePlayerAvailabilitySlotsByPk?: Maybe<PlayerAvailabilitySlots>;
  /** delete data from the table: "player_availability_venues" */
  deletePlayerAvailabilityVenues?: Maybe<PlayerAvailabilityVenuesMutationResponse>;
  /** delete single row from the table: "player_availability_venues" */
  deletePlayerAvailabilityVenuesByPk?: Maybe<PlayerAvailabilityVenues>;
  /** delete data from the table: "user_content_files" */
  deleteUserContentFiles?: Maybe<UserContentFilesMutationResponse>;
  /** delete single row from the table: "user_content_files" */
  deleteUserContentFilesByPk?: Maybe<UserContentFiles>;
  /** delete data from the table: "user_content_files_skills" */
  deleteUserContentFilesSkills?: Maybe<UserContentFilesSkillsMutationResponse>;
  /** delete single row from the table: "user_content_files_skills" */
  deleteUserContentFilesSkillsByPk?: Maybe<UserContentFilesSkills>;
  /** delete data from the table: "user_content_skills" */
  deleteUserContentSkills?: Maybe<UserContentSkillsMutationResponse>;
  /** delete single row from the table: "user_content_skills" */
  deleteUserContentSkillsByPk?: Maybe<UserContentSkills>;
  /** delete data from the table: "user_files" */
  deleteUserFiles?: Maybe<UserFilesMutationResponse>;
  /** delete single row from the table: "user_files" */
  deleteUserFilesByPk?: Maybe<UserFiles>;
  /** delete data from the table: "user_padel_rating_scales" */
  deleteUserPadelRatingScales?: Maybe<UserPadelRatingScalesMutationResponse>;
  /** delete single row from the table: "user_padel_rating_scales" */
  deleteUserPadelRatingScalesByPk?: Maybe<UserPadelRatingScales>;
  /** delete data from the table: "user_pickleball_rating_scales" */
  deleteUserPickleballRatingScales?: Maybe<UserPickleballRatingScalesMutationResponse>;
  /** delete single row from the table: "user_pickleball_rating_scales" */
  deleteUserPickleballRatingScalesByPk?: Maybe<UserPickleballRatingScales>;
  /** delete data from the table: "user_player_finder_availability" */
  deleteUserPlayerFinderAvailability?: Maybe<UserPlayerFinderAvailabilityMutationResponse>;
  /** delete single row from the table: "user_player_finder_availability" */
  deleteUserPlayerFinderAvailabilityByPk?: Maybe<UserPlayerFinderAvailability>;
  /** delete data from the table: "user_player_finder_goals" */
  deleteUserPlayerFinderGoals?: Maybe<UserPlayerFinderGoalsMutationResponse>;
  /** delete single row from the table: "user_player_finder_goals" */
  deleteUserPlayerFinderGoalsByPk?: Maybe<UserPlayerFinderGoals>;
  /** delete data from the table: "user_sports" */
  deleteUserSports?: Maybe<UserSportsMutationResponse>;
  /** delete single row from the table: "user_sports" */
  deleteUserSportsByPk?: Maybe<UserSports>;
  /** delete data from the table: "user_tennis_rating_scales" */
  deleteUserTennisRatingScales?: Maybe<UserTennisRatingScalesMutationResponse>;
  /** delete single row from the table: "user_tennis_rating_scales" */
  deleteUserTennisRatingScalesByPk?: Maybe<UserTennisRatingScales>;
  /** delete data from the table: "video_analysis_comments" */
  deleteVideoAnalysisComments?: Maybe<VideoAnalysisCommentsMutationResponse>;
  /** delete single row from the table: "video_analysis_comments" */
  deleteVideoAnalysisCommentsByPk?: Maybe<VideoAnalysisComments>;
  /** delete data from the table: "video_analysis_files" */
  deleteVideoAnalysisFiles?: Maybe<VideoAnalysisFilesMutationResponse>;
  /** delete single row from the table: "video_analysis_files" */
  deleteVideoAnalysisFilesByPk?: Maybe<VideoAnalysisFiles>;
  /** delete data from the table: "video_analysis_skills_comments" */
  deleteVideoAnalysisSkillsComments?: Maybe<VideoAnalysisSkillsCommentsMutationResponse>;
  /** delete single row from the table: "video_analysis_skills_comments" */
  deleteVideoAnalysisSkillsCommentsByPk?: Maybe<VideoAnalysisSkillsComments>;
  /** delete data from the table: "video_lesson_skills" */
  deleteVideoLessonSkills?: Maybe<VideoLessonSkillsMutationResponse>;
  /** delete single row from the table: "video_lesson_skills" */
  deleteVideoLessonSkillsByPk?: Maybe<VideoLessonSkills>;
  /** insert data into the table: "app_pings" */
  insertAppPings?: Maybe<AppPingsMutationResponse>;
  /** insert a single row into the table: "app_pings" */
  insertAppPingsOne?: Maybe<AppPings>;
  /** insert data into the table: "coach_availability" */
  insertCoachAvailability?: Maybe<CoachAvailabilityMutationResponse>;
  /** insert a single row into the table: "coach_availability" */
  insertCoachAvailabilityOne?: Maybe<CoachAvailability>;
  /** insert data into the table: "coach_booking_requests" */
  insertCoachBookingRequests?: Maybe<CoachBookingRequestsMutationResponse>;
  /** insert a single row into the table: "coach_booking_requests" */
  insertCoachBookingRequestsOne?: Maybe<CoachBookingRequests>;
  /** insert data into the table: "coach_faqs" */
  insertCoachFaqs?: Maybe<CoachFaqsMutationResponse>;
  /** insert a single row into the table: "coach_faqs" */
  insertCoachFaqsOne?: Maybe<CoachFaqs>;
  /** insert data into the table: "coach_lesson_age_groups" */
  insertCoachLessonAgeGroups?: Maybe<CoachLessonAgeGroupsMutationResponse>;
  /** insert a single row into the table: "coach_lesson_age_groups" */
  insertCoachLessonAgeGroupsOne?: Maybe<CoachLessonAgeGroups>;
  /** insert data into the table: "coach_lesson_skill_levels" */
  insertCoachLessonSkillLevels?: Maybe<CoachLessonSkillLevelsMutationResponse>;
  /** insert a single row into the table: "coach_lesson_skill_levels" */
  insertCoachLessonSkillLevelsOne?: Maybe<CoachLessonSkillLevels>;
  /** insert data into the table: "coach_sports" */
  insertCoachSports?: Maybe<CoachSportsMutationResponse>;
  /** insert a single row into the table: "coach_sports" */
  insertCoachSportsOne?: Maybe<CoachSports>;
  /** insert data into the table: "coach_tips" */
  insertCoachTips?: Maybe<CoachTipsMutationResponse>;
  /** insert data into the table: "event_collections" */
  insertEventCollections?: Maybe<EventCollectionsMutationResponse>;
  /** insert a single row into the table: "event_collections" */
  insertEventCollectionsOne?: Maybe<EventCollections>;
  /** insert data into the table: "event_faqs" */
  insertEventFaqs?: Maybe<EventFaqsMutationResponse>;
  /** insert a single row into the table: "event_faqs" */
  insertEventFaqsOne?: Maybe<EventFaqs>;
  /** insert data into the table: "event_game_scores" */
  insertEventGameScores?: Maybe<EventGameScoresMutationResponse>;
  /** insert a single row into the table: "event_game_scores" */
  insertEventGameScoresOne?: Maybe<EventGameScores>;
  /** insert data into the table: "event_group_merges" */
  insertEventGroupMerges?: Maybe<EventGroupMergesMutationResponse>;
  /** insert a single row into the table: "event_group_merges" */
  insertEventGroupMergesOne?: Maybe<EventGroupMerges>;
  /** insert data into the table: "event_group_rating_scales" */
  insertEventGroupRatingScales?: Maybe<EventGroupRatingScalesMutationResponse>;
  /** insert a single row into the table: "event_group_rating_scales" */
  insertEventGroupRatingScalesOne?: Maybe<EventGroupRatingScales>;
  /** insert data into the table: "event_group_time_slots" */
  insertEventGroupTimeSlots?: Maybe<EventGroupTimeSlotsMutationResponse>;
  /** insert a single row into the table: "event_group_time_slots" */
  insertEventGroupTimeSlotsOne?: Maybe<EventGroupTimeSlots>;
  /** insert data into the table: "event_groups" */
  insertEventGroups?: Maybe<EventGroupsMutationResponse>;
  /** insert a single row into the table: "event_groups" */
  insertEventGroupsOne?: Maybe<EventGroups>;
  /** insert data into the table: "event_invitations" */
  insertEventInvitations?: Maybe<EventInvitationsMutationResponse>;
  /** insert a single row into the table: "event_invitations" */
  insertEventInvitationsOne?: Maybe<EventInvitations>;
  /** insert data into the table: "event_match_games" */
  insertEventMatchGames?: Maybe<EventMatchGamesMutationResponse>;
  /** insert a single row into the table: "event_match_games" */
  insertEventMatchGamesOne?: Maybe<EventMatchGames>;
  /** insert data into the table: "event_registration_details" */
  insertEventRegistrationDetails?: Maybe<EventRegistrationDetailsMutationResponse>;
  /** insert a single row into the table: "event_registration_details" */
  insertEventRegistrationDetailsOne?: Maybe<EventRegistrationDetails>;
  /** insert data into the table: "event_skill_levels" */
  insertEventSkillLevels?: Maybe<EventSkillLevelsMutationResponse>;
  /** insert a single row into the table: "event_skill_levels" */
  insertEventSkillLevelsOne?: Maybe<EventSkillLevels>;
  /** insert data into the table: "event_sponsors" */
  insertEventSponsors?: Maybe<EventSponsorsMutationResponse>;
  /** insert a single row into the table: "event_sponsors" */
  insertEventSponsorsOne?: Maybe<EventSponsors>;
  /** insert data into the table: "events" */
  insertEvents?: Maybe<EventsMutationResponse>;
  /** insert a single row into the table: "events" */
  insertEventsOne?: Maybe<Events>;
  /** insert data into the table: "group_comment_votes" */
  insertGroupCommentVotes?: Maybe<GroupCommentVotesMutationResponse>;
  /** insert a single row into the table: "group_comment_votes" */
  insertGroupCommentVotesOne?: Maybe<GroupCommentVotes>;
  /** insert data into the table: "group_members" */
  insertGroupMembers?: Maybe<GroupMembersMutationResponse>;
  /** insert a single row into the table: "group_members" */
  insertGroupMembersOne?: Maybe<GroupMembers>;
  /** insert data into the table: "group_thread_comment_files" */
  insertGroupThreadCommentFiles?: Maybe<GroupThreadCommentFilesMutationResponse>;
  /** insert a single row into the table: "group_thread_comment_files" */
  insertGroupThreadCommentFilesOne?: Maybe<GroupThreadCommentFiles>;
  /** insert data into the table: "group_thread_comments" */
  insertGroupThreadComments?: Maybe<GroupThreadCommentsMutationResponse>;
  /** insert a single row into the table: "group_thread_comments" */
  insertGroupThreadCommentsOne?: Maybe<GroupThreadComments>;
  /** insert data into the table: "group_threads" */
  insertGroupThreads?: Maybe<GroupThreadsMutationResponse>;
  /** insert a single row into the table: "group_threads" */
  insertGroupThreadsOne?: Maybe<GroupThreads>;
  /** insert data into the table: "groups_play_sessions" */
  insertGroupsPlaySessions?: Maybe<GroupsPlaySessionsMutationResponse>;
  /** insert a single row into the table: "groups_play_sessions" */
  insertGroupsPlaySessionsOne?: Maybe<GroupsPlaySessions>;
  /** insert data into the table: "learning_program_enrollment_schedule_media_watched" */
  insertLearningProgramEnrollmentScheduleMediaWatched?: Maybe<LearningProgramEnrollmentScheduleMediaWatchedMutationResponse>;
  /** insert a single row into the table: "learning_program_enrollment_schedule_media_watched" */
  insertLearningProgramEnrollmentScheduleMediaWatchedOne?: Maybe<LearningProgramEnrollmentScheduleMediaWatched>;
  /** insert data into the table: "learning_program_enrollment_schedule_progress" */
  insertLearningProgramEnrollmentScheduleProgress?: Maybe<LearningProgramEnrollmentScheduleProgressMutationResponse>;
  /** insert a single row into the table: "learning_program_enrollment_schedule_progress" */
  insertLearningProgramEnrollmentScheduleProgressOne?: Maybe<LearningProgramEnrollmentScheduleProgress>;
  /** insert data into the table: "learning_program_enrollments" */
  insertLearningProgramEnrollments?: Maybe<LearningProgramEnrollmentsMutationResponse>;
  /** insert a single row into the table: "learning_program_enrollments" */
  insertLearningProgramEnrollmentsOne?: Maybe<LearningProgramEnrollments>;
  /** insert data into the table: "lesson_collections" */
  insertLessonCollections?: Maybe<LessonCollectionsMutationResponse>;
  /** insert a single row into the table: "lesson_collections" */
  insertLessonCollectionsOne?: Maybe<LessonCollections>;
  /** insert data into the table: "lesson_equipment" */
  insertLessonEquipment?: Maybe<LessonEquipmentMutationResponse>;
  /** insert a single row into the table: "lesson_equipment" */
  insertLessonEquipmentOne?: Maybe<LessonEquipment>;
  /** insert data into the table: "lesson_participants" */
  insertLessonParticipants?: Maybe<LessonParticipantsMutationResponse>;
  /** insert a single row into the table: "lesson_participants" */
  insertLessonParticipantsOne?: Maybe<LessonParticipants>;
  /** insert data into the table: "lesson_player_skill_assessments" */
  insertLessonPlayerSkillAssessments?: Maybe<LessonPlayerSkillAssessmentsMutationResponse>;
  /** insert a single row into the table: "lesson_player_skill_assessments" */
  insertLessonPlayerSkillAssessmentsOne?: Maybe<LessonPlayerSkillAssessments>;
  /** insert data into the table: "lesson_player_skill_assessments_skills" */
  insertLessonPlayerSkillAssessmentsSkills?: Maybe<LessonPlayerSkillAssessmentsSkillsMutationResponse>;
  /** insert a single row into the table: "lesson_player_skill_assessments_skills" */
  insertLessonPlayerSkillAssessmentsSkillsOne?: Maybe<LessonPlayerSkillAssessmentsSkills>;
  /** insert data into the table: "lesson_reflection_comments" */
  insertLessonReflectionComments?: Maybe<LessonReflectionCommentsMutationResponse>;
  /** insert a single row into the table: "lesson_reflection_comments" */
  insertLessonReflectionCommentsOne?: Maybe<LessonReflectionComments>;
  /** insert data into the table: "lesson_reflection_files" */
  insertLessonReflectionFiles?: Maybe<LessonReflectionFilesMutationResponse>;
  /** insert a single row into the table: "lesson_reflection_files" */
  insertLessonReflectionFilesOne?: Maybe<LessonReflectionFiles>;
  /** insert data into the table: "lesson_reflections" */
  insertLessonReflections?: Maybe<LessonReflectionsMutationResponse>;
  /** insert a single row into the table: "lesson_reflections" */
  insertLessonReflectionsOne?: Maybe<LessonReflections>;
  /** insert data into the table: "lesson_skill_levels" */
  insertLessonSkillLevels?: Maybe<LessonSkillLevelsMutationResponse>;
  /** insert a single row into the table: "lesson_skill_levels" */
  insertLessonSkillLevelsOne?: Maybe<LessonSkillLevels>;
  /** insert data into the table: "lesson_template_skill_levels" */
  insertLessonTemplateSkillLevels?: Maybe<LessonTemplateSkillLevelsMutationResponse>;
  /** insert a single row into the table: "lesson_template_skill_levels" */
  insertLessonTemplateSkillLevelsOne?: Maybe<LessonTemplateSkillLevels>;
  /** insert data into the table: "lesson_templates" */
  insertLessonTemplates?: Maybe<LessonTemplatesMutationResponse>;
  /** insert a single row into the table: "lesson_templates" */
  insertLessonTemplatesOne?: Maybe<LessonTemplates>;
  /** insert data into the table: "lesson_times" */
  insertLessonTimes?: Maybe<LessonTimesMutationResponse>;
  /** insert a single row into the table: "lesson_times" */
  insertLessonTimesOne?: Maybe<LessonTimes>;
  /** insert data into the table: "lesson_waitlists" */
  insertLessonWaitlists?: Maybe<LessonWaitlistsMutationResponse>;
  /** insert a single row into the table: "lesson_waitlists" */
  insertLessonWaitlistsOne?: Maybe<LessonWaitlists>;
  /** insert data into the table: "lessons" */
  insertLessons?: Maybe<LessonsMutationResponse>;
  /** insert a single row into the table: "lessons" */
  insertLessonsOne?: Maybe<Lessons>;
  /** insert data into the table: "play_session_comments" */
  insertPlaySessionComments?: Maybe<PlaySessionCommentsMutationResponse>;
  /** insert a single row into the table: "play_session_comments" */
  insertPlaySessionCommentsOne?: Maybe<PlaySessionComments>;
  /** insert data into the table: "play_session_participants" */
  insertPlaySessionParticipants?: Maybe<PlaySessionParticipantsMutationResponse>;
  /** insert a single row into the table: "play_session_participants" */
  insertPlaySessionParticipantsOne?: Maybe<PlaySessionParticipants>;
  /** insert data into the table: "play_sessions" */
  insertPlaySessions?: Maybe<PlaySessionsMutationResponse>;
  /** insert a single row into the table: "play_sessions" */
  insertPlaySessionsOne?: Maybe<PlaySessions>;
  /** insert data into the table: "player_availabilities" */
  insertPlayerAvailabilities?: Maybe<PlayerAvailabilitiesMutationResponse>;
  /** insert a single row into the table: "player_availabilities" */
  insertPlayerAvailabilitiesOne?: Maybe<PlayerAvailabilities>;
  /** insert data into the table: "player_availability_neighborhoods" */
  insertPlayerAvailabilityNeighborhoods?: Maybe<PlayerAvailabilityNeighborhoodsMutationResponse>;
  /** insert a single row into the table: "player_availability_neighborhoods" */
  insertPlayerAvailabilityNeighborhoodsOne?: Maybe<PlayerAvailabilityNeighborhoods>;
  /** insert data into the table: "player_availability_rating_scales" */
  insertPlayerAvailabilityRatingScales?: Maybe<PlayerAvailabilityRatingScalesMutationResponse>;
  /** insert a single row into the table: "player_availability_rating_scales" */
  insertPlayerAvailabilityRatingScalesOne?: Maybe<PlayerAvailabilityRatingScales>;
  /** insert data into the table: "player_availability_slots" */
  insertPlayerAvailabilitySlots?: Maybe<PlayerAvailabilitySlotsMutationResponse>;
  /** insert a single row into the table: "player_availability_slots" */
  insertPlayerAvailabilitySlotsOne?: Maybe<PlayerAvailabilitySlots>;
  /** insert data into the table: "player_availability_venues" */
  insertPlayerAvailabilityVenues?: Maybe<PlayerAvailabilityVenuesMutationResponse>;
  /** insert a single row into the table: "player_availability_venues" */
  insertPlayerAvailabilityVenuesOne?: Maybe<PlayerAvailabilityVenues>;
  /** insert data into the table: "reviews" */
  insertReviews?: Maybe<ReviewsMutationResponse>;
  /** insert a single row into the table: "reviews" */
  insertReviewsOne?: Maybe<Reviews>;
  /** insert data into the table: "signup_requests" */
  insertSignupRequests?: Maybe<SignupRequestsMutationResponse>;
  /** insert a single row into the table: "signup_requests" */
  insertSignupRequestsOne?: Maybe<SignupRequests>;
  /** insert data into the table: "twilio_group_texts" */
  insertTwilioGroupTexts?: Maybe<TwilioGroupTextsMutationResponse>;
  /** insert a single row into the table: "twilio_group_texts" */
  insertTwilioGroupTextsOne?: Maybe<TwilioGroupTexts>;
  /** insert data into the table: "upload_review_requests" */
  insertUploadReviewRequests?: Maybe<UploadReviewRequestsMutationResponse>;
  /** insert a single row into the table: "upload_review_requests" */
  insertUploadReviewRequestsOne?: Maybe<UploadReviewRequests>;
  /** insert data into the table: "user_coach_services" */
  insertUserCoachServices?: Maybe<UserCoachServicesMutationResponse>;
  /** insert a single row into the table: "user_coach_services" */
  insertUserCoachServicesOne?: Maybe<UserCoachServices>;
  /** insert data into the table: "user_content_files" */
  insertUserContentFiles?: Maybe<UserContentFilesMutationResponse>;
  /** insert a single row into the table: "user_content_files" */
  insertUserContentFilesOne?: Maybe<UserContentFiles>;
  /** insert data into the table: "user_content_files_skills" */
  insertUserContentFilesSkills?: Maybe<UserContentFilesSkillsMutationResponse>;
  /** insert a single row into the table: "user_content_files_skills" */
  insertUserContentFilesSkillsOne?: Maybe<UserContentFilesSkills>;
  /** insert data into the table: "user_content_skills" */
  insertUserContentSkills?: Maybe<UserContentSkillsMutationResponse>;
  /** insert a single row into the table: "user_content_skills" */
  insertUserContentSkillsOne?: Maybe<UserContentSkills>;
  /** insert data into the table: "user_custom_courts" */
  insertUserCustomCourts?: Maybe<UserCustomCourtsMutationResponse>;
  /** insert a single row into the table: "user_custom_courts" */
  insertUserCustomCourtsOne?: Maybe<UserCustomCourts>;
  /** insert data into the table: "user_files" */
  insertUserFiles?: Maybe<UserFilesMutationResponse>;
  /** insert a single row into the table: "user_files" */
  insertUserFilesOne?: Maybe<UserFiles>;
  /** insert data into the table: "user_follows" */
  insertUserFollows?: Maybe<UserFollowsMutationResponse>;
  /** insert a single row into the table: "user_follows" */
  insertUserFollowsOne?: Maybe<UserFollows>;
  /** insert data into the table: "user_image_log" */
  insertUserImageLog?: Maybe<UserImageLogMutationResponse>;
  /** insert a single row into the table: "user_image_log" */
  insertUserImageLogOne?: Maybe<UserImageLog>;
  /** insert data into the table: "user_padel_rating_scales" */
  insertUserPadelRatingScales?: Maybe<UserPadelRatingScalesMutationResponse>;
  /** insert a single row into the table: "user_padel_rating_scales" */
  insertUserPadelRatingScalesOne?: Maybe<UserPadelRatingScales>;
  /** insert data into the table: "user_pickleball_rating_scales" */
  insertUserPickleballRatingScales?: Maybe<UserPickleballRatingScalesMutationResponse>;
  /** insert a single row into the table: "user_pickleball_rating_scales" */
  insertUserPickleballRatingScalesOne?: Maybe<UserPickleballRatingScales>;
  /** insert data into the table: "user_player_finder_availability" */
  insertUserPlayerFinderAvailability?: Maybe<UserPlayerFinderAvailabilityMutationResponse>;
  /** insert a single row into the table: "user_player_finder_availability" */
  insertUserPlayerFinderAvailabilityOne?: Maybe<UserPlayerFinderAvailability>;
  /** insert data into the table: "user_player_finder_goals" */
  insertUserPlayerFinderGoals?: Maybe<UserPlayerFinderGoalsMutationResponse>;
  /** insert a single row into the table: "user_player_finder_goals" */
  insertUserPlayerFinderGoalsOne?: Maybe<UserPlayerFinderGoals>;
  /** insert data into the table: "user_sports" */
  insertUserSports?: Maybe<UserSportsMutationResponse>;
  /** insert a single row into the table: "user_sports" */
  insertUserSportsOne?: Maybe<UserSports>;
  /** insert data into the table: "user_tennis_rating_scales" */
  insertUserTennisRatingScales?: Maybe<UserTennisRatingScalesMutationResponse>;
  /** insert a single row into the table: "user_tennis_rating_scales" */
  insertUserTennisRatingScalesOne?: Maybe<UserTennisRatingScales>;
  /** insert data into the table: "user_terms_of_service" */
  insertUserTermsOfService?: Maybe<UserTermsOfServiceMutationResponse>;
  /** insert a single row into the table: "user_terms_of_service" */
  insertUserTermsOfServiceOne?: Maybe<UserTermsOfService>;
  /** insert data into the table: "users_coach_qualifications" */
  insertUsersCoachQualifications?: Maybe<UsersCoachQualificationsMutationResponse>;
  /** insert a single row into the table: "users_coach_qualifications" */
  insertUsersCoachQualificationsOne?: Maybe<UsersCoachQualifications>;
  /** insert data into the table: "venue_follows" */
  insertVenueFollows?: Maybe<VenueFollowsMutationResponse>;
  /** insert a single row into the table: "venue_follows" */
  insertVenueFollowsOne?: Maybe<VenueFollows>;
  /** insert data into the table: "venue_staff_coaches" */
  insertVenueStaffCoaches?: Maybe<VenueStaffCoachesMutationResponse>;
  /** insert a single row into the table: "venue_staff_coaches" */
  insertVenueStaffCoachesOne?: Maybe<VenueStaffCoaches>;
  /** insert data into the table: "video_analysis" */
  insertVideoAnalysis?: Maybe<VideoAnalysisMutationResponse>;
  /** insert data into the table: "video_analysis_comments" */
  insertVideoAnalysisComments?: Maybe<VideoAnalysisCommentsMutationResponse>;
  /** insert a single row into the table: "video_analysis_comments" */
  insertVideoAnalysisCommentsOne?: Maybe<VideoAnalysisComments>;
  /** insert data into the table: "video_analysis_files" */
  insertVideoAnalysisFiles?: Maybe<VideoAnalysisFilesMutationResponse>;
  /** insert a single row into the table: "video_analysis_files" */
  insertVideoAnalysisFilesOne?: Maybe<VideoAnalysisFiles>;
  /** insert a single row into the table: "video_analysis" */
  insertVideoAnalysisOne?: Maybe<VideoAnalysis>;
  /** insert data into the table: "video_analysis_skills_comments" */
  insertVideoAnalysisSkillsComments?: Maybe<VideoAnalysisSkillsCommentsMutationResponse>;
  /** insert a single row into the table: "video_analysis_skills_comments" */
  insertVideoAnalysisSkillsCommentsOne?: Maybe<VideoAnalysisSkillsComments>;
  /** insert data into the table: "video_analysis_submission_log" */
  insertVideoAnalysisSubmissionLog?: Maybe<VideoAnalysisSubmissionLogMutationResponse>;
  /** insert a single row into the table: "video_analysis_submission_log" */
  insertVideoAnalysisSubmissionLogOne?: Maybe<VideoAnalysisSubmissionLog>;
  /** insert data into the table: "video_lesson_skills" */
  insertVideoLessonSkills?: Maybe<VideoLessonSkillsMutationResponse>;
  /** insert a single row into the table: "video_lesson_skills" */
  insertVideoLessonSkillsOne?: Maybe<VideoLessonSkills>;
  /** update data of the table: "calendar_accounts" */
  updateCalendarAccounts?: Maybe<CalendarAccountsMutationResponse>;
  /** update single row of the table: "calendar_accounts" */
  updateCalendarAccountsByPk?: Maybe<CalendarAccounts>;
  /** update multiples rows of table: "calendar_accounts" */
  updateCalendarAccountsMany?: Maybe<Array<Maybe<CalendarAccountsMutationResponse>>>;
  /** update data of the table: "calendar_preferences" */
  updateCalendarPreferences?: Maybe<CalendarPreferencesMutationResponse>;
  /** update single row of the table: "calendar_preferences" */
  updateCalendarPreferencesByPk?: Maybe<CalendarPreferences>;
  /** update multiples rows of table: "calendar_preferences" */
  updateCalendarPreferencesMany?: Maybe<Array<Maybe<CalendarPreferencesMutationResponse>>>;
  /** update data of the table: "coach_availability" */
  updateCoachAvailability?: Maybe<CoachAvailabilityMutationResponse>;
  /** update single row of the table: "coach_availability" */
  updateCoachAvailabilityByPk?: Maybe<CoachAvailability>;
  /** update multiples rows of table: "coach_availability" */
  updateCoachAvailabilityMany?: Maybe<Array<Maybe<CoachAvailabilityMutationResponse>>>;
  /** update data of the table: "coach_booking_requests" */
  updateCoachBookingRequests?: Maybe<CoachBookingRequestsMutationResponse>;
  /** update single row of the table: "coach_booking_requests" */
  updateCoachBookingRequestsByPk?: Maybe<CoachBookingRequests>;
  /** update multiples rows of table: "coach_booking_requests" */
  updateCoachBookingRequestsMany?: Maybe<Array<Maybe<CoachBookingRequestsMutationResponse>>>;
  /** update data of the table: "coach_faqs" */
  updateCoachFaqs?: Maybe<CoachFaqsMutationResponse>;
  /** update single row of the table: "coach_faqs" */
  updateCoachFaqsByPk?: Maybe<CoachFaqs>;
  /** update multiples rows of table: "coach_faqs" */
  updateCoachFaqsMany?: Maybe<Array<Maybe<CoachFaqsMutationResponse>>>;
  /** update data of the table: "coach_lesson_age_groups" */
  updateCoachLessonAgeGroups?: Maybe<CoachLessonAgeGroupsMutationResponse>;
  /** update single row of the table: "coach_lesson_age_groups" */
  updateCoachLessonAgeGroupsByPk?: Maybe<CoachLessonAgeGroups>;
  /** update multiples rows of table: "coach_lesson_age_groups" */
  updateCoachLessonAgeGroupsMany?: Maybe<Array<Maybe<CoachLessonAgeGroupsMutationResponse>>>;
  /** update data of the table: "coach_lesson_skill_levels" */
  updateCoachLessonSkillLevels?: Maybe<CoachLessonSkillLevelsMutationResponse>;
  /** update single row of the table: "coach_lesson_skill_levels" */
  updateCoachLessonSkillLevelsByPk?: Maybe<CoachLessonSkillLevels>;
  /** update multiples rows of table: "coach_lesson_skill_levels" */
  updateCoachLessonSkillLevelsMany?: Maybe<Array<Maybe<CoachLessonSkillLevelsMutationResponse>>>;
  /** update data of the table: "coach_sports" */
  updateCoachSports?: Maybe<CoachSportsMutationResponse>;
  /** update single row of the table: "coach_sports" */
  updateCoachSportsByPk?: Maybe<CoachSports>;
  /** update multiples rows of table: "coach_sports" */
  updateCoachSportsMany?: Maybe<Array<Maybe<CoachSportsMutationResponse>>>;
  /** update data of the table: "conversation_participants" */
  updateConversationParticipants?: Maybe<ConversationParticipantsMutationResponse>;
  /** update single row of the table: "conversation_participants" */
  updateConversationParticipantsByPk?: Maybe<ConversationParticipants>;
  /** update multiples rows of table: "conversation_participants" */
  updateConversationParticipantsMany?: Maybe<Array<Maybe<ConversationParticipantsMutationResponse>>>;
  /** update data of the table: "event_collections" */
  updateEventCollections?: Maybe<EventCollectionsMutationResponse>;
  /** update single row of the table: "event_collections" */
  updateEventCollectionsByPk?: Maybe<EventCollections>;
  /** update multiples rows of table: "event_collections" */
  updateEventCollectionsMany?: Maybe<Array<Maybe<EventCollectionsMutationResponse>>>;
  /** update data of the table: "event_contact_details" */
  updateEventContactDetails?: Maybe<EventContactDetailsMutationResponse>;
  /** update single row of the table: "event_contact_details" */
  updateEventContactDetailsByPk?: Maybe<EventContactDetails>;
  /** update multiples rows of table: "event_contact_details" */
  updateEventContactDetailsMany?: Maybe<Array<Maybe<EventContactDetailsMutationResponse>>>;
  /** update data of the table: "event_courts" */
  updateEventCourts?: Maybe<EventCourtsMutationResponse>;
  /** update single row of the table: "event_courts" */
  updateEventCourtsByPk?: Maybe<EventCourts>;
  /** update multiples rows of table: "event_courts" */
  updateEventCourtsMany?: Maybe<Array<Maybe<EventCourtsMutationResponse>>>;
  /** update data of the table: "event_faqs" */
  updateEventFaqs?: Maybe<EventFaqsMutationResponse>;
  /** update single row of the table: "event_faqs" */
  updateEventFaqsByPk?: Maybe<EventFaqs>;
  /** update multiples rows of table: "event_faqs" */
  updateEventFaqsMany?: Maybe<Array<Maybe<EventFaqsMutationResponse>>>;
  /** update data of the table: "event_game_scores" */
  updateEventGameScores?: Maybe<EventGameScoresMutationResponse>;
  /** update single row of the table: "event_game_scores" */
  updateEventGameScoresByPk?: Maybe<EventGameScores>;
  /** update multiples rows of table: "event_game_scores" */
  updateEventGameScoresMany?: Maybe<Array<Maybe<EventGameScoresMutationResponse>>>;
  /** update data of the table: "event_group_merges" */
  updateEventGroupMerges?: Maybe<EventGroupMergesMutationResponse>;
  /** update single row of the table: "event_group_merges" */
  updateEventGroupMergesByPk?: Maybe<EventGroupMerges>;
  /** update multiples rows of table: "event_group_merges" */
  updateEventGroupMergesMany?: Maybe<Array<Maybe<EventGroupMergesMutationResponse>>>;
  /** update data of the table: "event_group_rating_scales" */
  updateEventGroupRatingScales?: Maybe<EventGroupRatingScalesMutationResponse>;
  /** update single row of the table: "event_group_rating_scales" */
  updateEventGroupRatingScalesByPk?: Maybe<EventGroupRatingScales>;
  /** update multiples rows of table: "event_group_rating_scales" */
  updateEventGroupRatingScalesMany?: Maybe<Array<Maybe<EventGroupRatingScalesMutationResponse>>>;
  /** update data of the table: "event_group_sequences" */
  updateEventGroupSequences?: Maybe<EventGroupSequencesMutationResponse>;
  /** update single row of the table: "event_group_sequences" */
  updateEventGroupSequencesByPk?: Maybe<EventGroupSequences>;
  /** update multiples rows of table: "event_group_sequences" */
  updateEventGroupSequencesMany?: Maybe<Array<Maybe<EventGroupSequencesMutationResponse>>>;
  /** update data of the table: "event_group_time_slots" */
  updateEventGroupTimeSlots?: Maybe<EventGroupTimeSlotsMutationResponse>;
  /** update single row of the table: "event_group_time_slots" */
  updateEventGroupTimeSlotsByPk?: Maybe<EventGroupTimeSlots>;
  /** update multiples rows of table: "event_group_time_slots" */
  updateEventGroupTimeSlotsMany?: Maybe<Array<Maybe<EventGroupTimeSlotsMutationResponse>>>;
  /** update data of the table: "event_groups" */
  updateEventGroups?: Maybe<EventGroupsMutationResponse>;
  /** update single row of the table: "event_groups" */
  updateEventGroupsByPk?: Maybe<EventGroups>;
  /** update multiples rows of table: "event_groups" */
  updateEventGroupsMany?: Maybe<Array<Maybe<EventGroupsMutationResponse>>>;
  /** update data of the table: "event_match_games" */
  updateEventMatchGames?: Maybe<EventMatchGamesMutationResponse>;
  /** update single row of the table: "event_match_games" */
  updateEventMatchGamesByPk?: Maybe<EventMatchGames>;
  /** update multiples rows of table: "event_match_games" */
  updateEventMatchGamesMany?: Maybe<Array<Maybe<EventMatchGamesMutationResponse>>>;
  /** update data of the table: "event_matches" */
  updateEventMatches?: Maybe<EventMatchesMutationResponse>;
  /** update single row of the table: "event_matches" */
  updateEventMatchesByPk?: Maybe<EventMatches>;
  /** update multiples rows of table: "event_matches" */
  updateEventMatchesMany?: Maybe<Array<Maybe<EventMatchesMutationResponse>>>;
  /** update data of the table: "event_sponsors" */
  updateEventSponsors?: Maybe<EventSponsorsMutationResponse>;
  /** update single row of the table: "event_sponsors" */
  updateEventSponsorsByPk?: Maybe<EventSponsors>;
  /** update multiples rows of table: "event_sponsors" */
  updateEventSponsorsMany?: Maybe<Array<Maybe<EventSponsorsMutationResponse>>>;
  /** update data of the table: "events" */
  updateEvents?: Maybe<EventsMutationResponse>;
  /** update single row of the table: "events" */
  updateEventsByPk?: Maybe<Events>;
  /** update multiples rows of table: "events" */
  updateEventsMany?: Maybe<Array<Maybe<EventsMutationResponse>>>;
  /** update data of the table: "group_comment_votes" */
  updateGroupCommentVotes?: Maybe<GroupCommentVotesMutationResponse>;
  /** update single row of the table: "group_comment_votes" */
  updateGroupCommentVotesByPk?: Maybe<GroupCommentVotes>;
  /** update multiples rows of table: "group_comment_votes" */
  updateGroupCommentVotesMany?: Maybe<Array<Maybe<GroupCommentVotesMutationResponse>>>;
  /** update data of the table: "group_members" */
  updateGroupMembers?: Maybe<GroupMembersMutationResponse>;
  /** update single row of the table: "group_members" */
  updateGroupMembersByPk?: Maybe<GroupMembers>;
  /** update multiples rows of table: "group_members" */
  updateGroupMembersMany?: Maybe<Array<Maybe<GroupMembersMutationResponse>>>;
  /** update data of the table: "group_thread_comment_files" */
  updateGroupThreadCommentFiles?: Maybe<GroupThreadCommentFilesMutationResponse>;
  /** update single row of the table: "group_thread_comment_files" */
  updateGroupThreadCommentFilesByPk?: Maybe<GroupThreadCommentFiles>;
  /** update multiples rows of table: "group_thread_comment_files" */
  updateGroupThreadCommentFilesMany?: Maybe<Array<Maybe<GroupThreadCommentFilesMutationResponse>>>;
  /** update data of the table: "group_thread_comments" */
  updateGroupThreadComments?: Maybe<GroupThreadCommentsMutationResponse>;
  /** update single row of the table: "group_thread_comments" */
  updateGroupThreadCommentsByPk?: Maybe<GroupThreadComments>;
  /** update multiples rows of table: "group_thread_comments" */
  updateGroupThreadCommentsMany?: Maybe<Array<Maybe<GroupThreadCommentsMutationResponse>>>;
  /** update data of the table: "groups_play_sessions" */
  updateGroupsPlaySessions?: Maybe<GroupsPlaySessionsMutationResponse>;
  /** update single row of the table: "groups_play_sessions" */
  updateGroupsPlaySessionsByPk?: Maybe<GroupsPlaySessions>;
  /** update multiples rows of table: "groups_play_sessions" */
  updateGroupsPlaySessionsMany?: Maybe<Array<Maybe<GroupsPlaySessionsMutationResponse>>>;
  /** update data of the table: "learning_program_enrollment_schedule_media_watched" */
  updateLearningProgramEnrollmentScheduleMediaWatched?: Maybe<LearningProgramEnrollmentScheduleMediaWatchedMutationResponse>;
  /** update single row of the table: "learning_program_enrollment_schedule_media_watched" */
  updateLearningProgramEnrollmentScheduleMediaWatchedByPk?: Maybe<LearningProgramEnrollmentScheduleMediaWatched>;
  /** update multiples rows of table: "learning_program_enrollment_schedule_media_watched" */
  updateLearningProgramEnrollmentScheduleMediaWatchedMany?: Maybe<Array<Maybe<LearningProgramEnrollmentScheduleMediaWatchedMutationResponse>>>;
  /** update data of the table: "learning_program_enrollment_schedule_progress" */
  updateLearningProgramEnrollmentScheduleProgress?: Maybe<LearningProgramEnrollmentScheduleProgressMutationResponse>;
  /** update single row of the table: "learning_program_enrollment_schedule_progress" */
  updateLearningProgramEnrollmentScheduleProgressByPk?: Maybe<LearningProgramEnrollmentScheduleProgress>;
  /** update multiples rows of table: "learning_program_enrollment_schedule_progress" */
  updateLearningProgramEnrollmentScheduleProgressMany?: Maybe<Array<Maybe<LearningProgramEnrollmentScheduleProgressMutationResponse>>>;
  /** update data of the table: "lesson_collections" */
  updateLessonCollections?: Maybe<LessonCollectionsMutationResponse>;
  /** update single row of the table: "lesson_collections" */
  updateLessonCollectionsByPk?: Maybe<LessonCollections>;
  /** update multiples rows of table: "lesson_collections" */
  updateLessonCollectionsMany?: Maybe<Array<Maybe<LessonCollectionsMutationResponse>>>;
  /** update data of the table: "lesson_equipment" */
  updateLessonEquipment?: Maybe<LessonEquipmentMutationResponse>;
  /** update single row of the table: "lesson_equipment" */
  updateLessonEquipmentByPk?: Maybe<LessonEquipment>;
  /** update multiples rows of table: "lesson_equipment" */
  updateLessonEquipmentMany?: Maybe<Array<Maybe<LessonEquipmentMutationResponse>>>;
  /** update data of the table: "lesson_participants" */
  updateLessonParticipants?: Maybe<LessonParticipantsMutationResponse>;
  /** update single row of the table: "lesson_participants" */
  updateLessonParticipantsByPk?: Maybe<LessonParticipants>;
  /** update multiples rows of table: "lesson_participants" */
  updateLessonParticipantsMany?: Maybe<Array<Maybe<LessonParticipantsMutationResponse>>>;
  /** update data of the table: "lesson_player_skill_assessments" */
  updateLessonPlayerSkillAssessments?: Maybe<LessonPlayerSkillAssessmentsMutationResponse>;
  /** update single row of the table: "lesson_player_skill_assessments" */
  updateLessonPlayerSkillAssessmentsByPk?: Maybe<LessonPlayerSkillAssessments>;
  /** update multiples rows of table: "lesson_player_skill_assessments" */
  updateLessonPlayerSkillAssessmentsMany?: Maybe<Array<Maybe<LessonPlayerSkillAssessmentsMutationResponse>>>;
  /** update data of the table: "lesson_player_skill_assessments_skills" */
  updateLessonPlayerSkillAssessmentsSkills?: Maybe<LessonPlayerSkillAssessmentsSkillsMutationResponse>;
  /** update single row of the table: "lesson_player_skill_assessments_skills" */
  updateLessonPlayerSkillAssessmentsSkillsByPk?: Maybe<LessonPlayerSkillAssessmentsSkills>;
  /** update multiples rows of table: "lesson_player_skill_assessments_skills" */
  updateLessonPlayerSkillAssessmentsSkillsMany?: Maybe<Array<Maybe<LessonPlayerSkillAssessmentsSkillsMutationResponse>>>;
  /** update data of the table: "lesson_reflection_comments" */
  updateLessonReflectionComments?: Maybe<LessonReflectionCommentsMutationResponse>;
  /** update single row of the table: "lesson_reflection_comments" */
  updateLessonReflectionCommentsByPk?: Maybe<LessonReflectionComments>;
  /** update multiples rows of table: "lesson_reflection_comments" */
  updateLessonReflectionCommentsMany?: Maybe<Array<Maybe<LessonReflectionCommentsMutationResponse>>>;
  /** update data of the table: "lesson_reflection_files" */
  updateLessonReflectionFiles?: Maybe<LessonReflectionFilesMutationResponse>;
  /** update single row of the table: "lesson_reflection_files" */
  updateLessonReflectionFilesByPk?: Maybe<LessonReflectionFiles>;
  /** update multiples rows of table: "lesson_reflection_files" */
  updateLessonReflectionFilesMany?: Maybe<Array<Maybe<LessonReflectionFilesMutationResponse>>>;
  /** update data of the table: "lesson_reflections" */
  updateLessonReflections?: Maybe<LessonReflectionsMutationResponse>;
  /** update single row of the table: "lesson_reflections" */
  updateLessonReflectionsByPk?: Maybe<LessonReflections>;
  /** update multiples rows of table: "lesson_reflections" */
  updateLessonReflectionsMany?: Maybe<Array<Maybe<LessonReflectionsMutationResponse>>>;
  /** update data of the table: "lesson_templates" */
  updateLessonTemplates?: Maybe<LessonTemplatesMutationResponse>;
  /** update single row of the table: "lesson_templates" */
  updateLessonTemplatesByPk?: Maybe<LessonTemplates>;
  /** update multiples rows of table: "lesson_templates" */
  updateLessonTemplatesMany?: Maybe<Array<Maybe<LessonTemplatesMutationResponse>>>;
  /** update data of the table: "lesson_times" */
  updateLessonTimes?: Maybe<LessonTimesMutationResponse>;
  /** update single row of the table: "lesson_times" */
  updateLessonTimesByPk?: Maybe<LessonTimes>;
  /** update multiples rows of table: "lesson_times" */
  updateLessonTimesMany?: Maybe<Array<Maybe<LessonTimesMutationResponse>>>;
  /** update data of the table: "lesson_waitlists" */
  updateLessonWaitlists?: Maybe<LessonWaitlistsMutationResponse>;
  /** update single row of the table: "lesson_waitlists" */
  updateLessonWaitlistsByPk?: Maybe<LessonWaitlists>;
  /** update multiples rows of table: "lesson_waitlists" */
  updateLessonWaitlistsMany?: Maybe<Array<Maybe<LessonWaitlistsMutationResponse>>>;
  /** update data of the table: "lessons" */
  updateLessons?: Maybe<LessonsMutationResponse>;
  /** update single row of the table: "lessons" */
  updateLessonsByPk?: Maybe<Lessons>;
  /** update multiples rows of table: "lessons" */
  updateLessonsMany?: Maybe<Array<Maybe<LessonsMutationResponse>>>;
  /** update data of the table: "play_session_comments" */
  updatePlaySessionComments?: Maybe<PlaySessionCommentsMutationResponse>;
  /** update single row of the table: "play_session_comments" */
  updatePlaySessionCommentsByPk?: Maybe<PlaySessionComments>;
  /** update multiples rows of table: "play_session_comments" */
  updatePlaySessionCommentsMany?: Maybe<Array<Maybe<PlaySessionCommentsMutationResponse>>>;
  /** update data of the table: "play_sessions" */
  updatePlaySessions?: Maybe<PlaySessionsMutationResponse>;
  /** update single row of the table: "play_sessions" */
  updatePlaySessionsByPk?: Maybe<PlaySessions>;
  /** update multiples rows of table: "play_sessions" */
  updatePlaySessionsMany?: Maybe<Array<Maybe<PlaySessionsMutationResponse>>>;
  /** update data of the table: "player_availabilities" */
  updatePlayerAvailabilities?: Maybe<PlayerAvailabilitiesMutationResponse>;
  /** update single row of the table: "player_availabilities" */
  updatePlayerAvailabilitiesByPk?: Maybe<PlayerAvailabilities>;
  /** update multiples rows of table: "player_availabilities" */
  updatePlayerAvailabilitiesMany?: Maybe<Array<Maybe<PlayerAvailabilitiesMutationResponse>>>;
  /** update data of the table: "player_availability_rating_scales" */
  updatePlayerAvailabilityRatingScales?: Maybe<PlayerAvailabilityRatingScalesMutationResponse>;
  /** update single row of the table: "player_availability_rating_scales" */
  updatePlayerAvailabilityRatingScalesByPk?: Maybe<PlayerAvailabilityRatingScales>;
  /** update multiples rows of table: "player_availability_rating_scales" */
  updatePlayerAvailabilityRatingScalesMany?: Maybe<Array<Maybe<PlayerAvailabilityRatingScalesMutationResponse>>>;
  /** update data of the table: "user_coach_services" */
  updateUserCoachServices?: Maybe<UserCoachServicesMutationResponse>;
  /** update single row of the table: "user_coach_services" */
  updateUserCoachServicesByPk?: Maybe<UserCoachServices>;
  /** update multiples rows of table: "user_coach_services" */
  updateUserCoachServicesMany?: Maybe<Array<Maybe<UserCoachServicesMutationResponse>>>;
  /** update data of the table: "user_communication_preferences" */
  updateUserCommunicationPreferences?: Maybe<UserCommunicationPreferencesMutationResponse>;
  /** update single row of the table: "user_communication_preferences" */
  updateUserCommunicationPreferencesByPk?: Maybe<UserCommunicationPreferences>;
  /** update multiples rows of table: "user_communication_preferences" */
  updateUserCommunicationPreferencesMany?: Maybe<Array<Maybe<UserCommunicationPreferencesMutationResponse>>>;
  /** update data of the table: "user_content_files" */
  updateUserContentFiles?: Maybe<UserContentFilesMutationResponse>;
  /** update single row of the table: "user_content_files" */
  updateUserContentFilesByPk?: Maybe<UserContentFiles>;
  /** update multiples rows of table: "user_content_files" */
  updateUserContentFilesMany?: Maybe<Array<Maybe<UserContentFilesMutationResponse>>>;
  /** update data of the table: "user_content_skills" */
  updateUserContentSkills?: Maybe<UserContentSkillsMutationResponse>;
  /** update single row of the table: "user_content_skills" */
  updateUserContentSkillsByPk?: Maybe<UserContentSkills>;
  /** update multiples rows of table: "user_content_skills" */
  updateUserContentSkillsMany?: Maybe<Array<Maybe<UserContentSkillsMutationResponse>>>;
  /** update data of the table: "user_custom_courts" */
  updateUserCustomCourts?: Maybe<UserCustomCourtsMutationResponse>;
  /** update single row of the table: "user_custom_courts" */
  updateUserCustomCourtsByPk?: Maybe<UserCustomCourts>;
  /** update multiples rows of table: "user_custom_courts" */
  updateUserCustomCourtsMany?: Maybe<Array<Maybe<UserCustomCourtsMutationResponse>>>;
  /** update data of the table: "user_files" */
  updateUserFiles?: Maybe<UserFilesMutationResponse>;
  /** update single row of the table: "user_files" */
  updateUserFilesByPk?: Maybe<UserFiles>;
  /** update multiples rows of table: "user_files" */
  updateUserFilesMany?: Maybe<Array<Maybe<UserFilesMutationResponse>>>;
  /** update data of the table: "user_follows" */
  updateUserFollows?: Maybe<UserFollowsMutationResponse>;
  /** update single row of the table: "user_follows" */
  updateUserFollowsByPk?: Maybe<UserFollows>;
  /** update multiples rows of table: "user_follows" */
  updateUserFollowsMany?: Maybe<Array<Maybe<UserFollowsMutationResponse>>>;
  /** update data of the table: "user_notifications" */
  updateUserNotifications?: Maybe<UserNotificationsMutationResponse>;
  /** update single row of the table: "user_notifications" */
  updateUserNotificationsByPk?: Maybe<UserNotifications>;
  /** update multiples rows of table: "user_notifications" */
  updateUserNotificationsMany?: Maybe<Array<Maybe<UserNotificationsMutationResponse>>>;
  /** update data of the table: "user_padel_rating_scales" */
  updateUserPadelRatingScales?: Maybe<UserPadelRatingScalesMutationResponse>;
  /** update single row of the table: "user_padel_rating_scales" */
  updateUserPadelRatingScalesByPk?: Maybe<UserPadelRatingScales>;
  /** update multiples rows of table: "user_padel_rating_scales" */
  updateUserPadelRatingScalesMany?: Maybe<Array<Maybe<UserPadelRatingScalesMutationResponse>>>;
  /** update data of the table: "user_pickleball_rating_scales" */
  updateUserPickleballRatingScales?: Maybe<UserPickleballRatingScalesMutationResponse>;
  /** update single row of the table: "user_pickleball_rating_scales" */
  updateUserPickleballRatingScalesByPk?: Maybe<UserPickleballRatingScales>;
  /** update multiples rows of table: "user_pickleball_rating_scales" */
  updateUserPickleballRatingScalesMany?: Maybe<Array<Maybe<UserPickleballRatingScalesMutationResponse>>>;
  /** update data of the table: "user_sports" */
  updateUserSports?: Maybe<UserSportsMutationResponse>;
  /** update single row of the table: "user_sports" */
  updateUserSportsByPk?: Maybe<UserSports>;
  /** update multiples rows of table: "user_sports" */
  updateUserSportsMany?: Maybe<Array<Maybe<UserSportsMutationResponse>>>;
  /** update data of the table: "user_tennis_rating_scales" */
  updateUserTennisRatingScales?: Maybe<UserTennisRatingScalesMutationResponse>;
  /** update single row of the table: "user_tennis_rating_scales" */
  updateUserTennisRatingScalesByPk?: Maybe<UserTennisRatingScales>;
  /** update multiples rows of table: "user_tennis_rating_scales" */
  updateUserTennisRatingScalesMany?: Maybe<Array<Maybe<UserTennisRatingScalesMutationResponse>>>;
  /** update data of the table: "users" */
  updateUsers?: Maybe<UsersMutationResponse>;
  /** update single row of the table: "users" */
  updateUsersByPk?: Maybe<Users>;
  /** update data of the table: "users_coach_qualifications" */
  updateUsersCoachQualifications?: Maybe<UsersCoachQualificationsMutationResponse>;
  /** update single row of the table: "users_coach_qualifications" */
  updateUsersCoachQualificationsByPk?: Maybe<UsersCoachQualifications>;
  /** update multiples rows of table: "users_coach_qualifications" */
  updateUsersCoachQualificationsMany?: Maybe<Array<Maybe<UsersCoachQualificationsMutationResponse>>>;
  /** update multiples rows of table: "users" */
  updateUsersMany?: Maybe<Array<Maybe<UsersMutationResponse>>>;
  /** update data of the table: "venue_follows" */
  updateVenueFollows?: Maybe<VenueFollowsMutationResponse>;
  /** update single row of the table: "venue_follows" */
  updateVenueFollowsByPk?: Maybe<VenueFollows>;
  /** update multiples rows of table: "venue_follows" */
  updateVenueFollowsMany?: Maybe<Array<Maybe<VenueFollowsMutationResponse>>>;
  /** update data of the table: "venue_staff_coaches" */
  updateVenueStaffCoaches?: Maybe<VenueStaffCoachesMutationResponse>;
  /** update single row of the table: "venue_staff_coaches" */
  updateVenueStaffCoachesByPk?: Maybe<VenueStaffCoaches>;
  /** update multiples rows of table: "venue_staff_coaches" */
  updateVenueStaffCoachesMany?: Maybe<Array<Maybe<VenueStaffCoachesMutationResponse>>>;
  /** update data of the table: "video_analysis" */
  updateVideoAnalysis?: Maybe<VideoAnalysisMutationResponse>;
  /** update single row of the table: "video_analysis" */
  updateVideoAnalysisByPk?: Maybe<VideoAnalysis>;
  /** update data of the table: "video_analysis_comments" */
  updateVideoAnalysisComments?: Maybe<VideoAnalysisCommentsMutationResponse>;
  /** update single row of the table: "video_analysis_comments" */
  updateVideoAnalysisCommentsByPk?: Maybe<VideoAnalysisComments>;
  /** update multiples rows of table: "video_analysis_comments" */
  updateVideoAnalysisCommentsMany?: Maybe<Array<Maybe<VideoAnalysisCommentsMutationResponse>>>;
  /** update data of the table: "video_analysis_files" */
  updateVideoAnalysisFiles?: Maybe<VideoAnalysisFilesMutationResponse>;
  /** update single row of the table: "video_analysis_files" */
  updateVideoAnalysisFilesByPk?: Maybe<VideoAnalysisFiles>;
  /** update multiples rows of table: "video_analysis_files" */
  updateVideoAnalysisFilesMany?: Maybe<Array<Maybe<VideoAnalysisFilesMutationResponse>>>;
  /** update multiples rows of table: "video_analysis" */
  updateVideoAnalysisMany?: Maybe<Array<Maybe<VideoAnalysisMutationResponse>>>;
  /** update data of the table: "video_analysis_skills_comments" */
  updateVideoAnalysisSkillsComments?: Maybe<VideoAnalysisSkillsCommentsMutationResponse>;
  /** update single row of the table: "video_analysis_skills_comments" */
  updateVideoAnalysisSkillsCommentsByPk?: Maybe<VideoAnalysisSkillsComments>;
  /** update multiples rows of table: "video_analysis_skills_comments" */
  updateVideoAnalysisSkillsCommentsMany?: Maybe<Array<Maybe<VideoAnalysisSkillsCommentsMutationResponse>>>;
  /** update data of the table: "video_analysis_submission_log" */
  updateVideoAnalysisSubmissionLog?: Maybe<VideoAnalysisSubmissionLogMutationResponse>;
  /** update single row of the table: "video_analysis_submission_log" */
  updateVideoAnalysisSubmissionLogByPk?: Maybe<VideoAnalysisSubmissionLog>;
  /** update multiples rows of table: "video_analysis_submission_log" */
  updateVideoAnalysisSubmissionLogMany?: Maybe<Array<Maybe<VideoAnalysisSubmissionLogMutationResponse>>>;
  /** update data of the table: "video_lesson_skills" */
  updateVideoLessonSkills?: Maybe<VideoLessonSkillsMutationResponse>;
  /** update single row of the table: "video_lesson_skills" */
  updateVideoLessonSkillsByPk?: Maybe<VideoLessonSkills>;
  /** update multiples rows of table: "video_lesson_skills" */
  updateVideoLessonSkillsMany?: Maybe<Array<Maybe<VideoLessonSkillsMutationResponse>>>;
};


/** mutation root */
export type Mutation_RootDeleteCoachAvailabilityArgs = {
  where: CoachAvailabilityBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachAvailabilityByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCoachLessonAgeGroupsArgs = {
  where: CoachLessonAgeGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachLessonAgeGroupsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCoachLessonSkillLevelsArgs = {
  where: CoachLessonSkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCoachLessonSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventFaqsArgs = {
  where: EventFaqsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventFaqsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventGroupRatingScalesArgs = {
  where: EventGroupRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventGroupRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventGroupTimeSlotsArgs = {
  where: EventGroupTimeSlotsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventGroupTimeSlotsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventSkillLevelsArgs = {
  where: EventSkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventSponsorsArgs = {
  where: EventSponsorsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventSponsorsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramEnrollmentScheduleMediaWatchedArgs = {
  where: LearningProgramEnrollmentScheduleMediaWatchedBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLearningProgramEnrollmentScheduleMediaWatchedByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonEquipmentArgs = {
  where: LessonEquipmentBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonEquipmentByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonPlayerSkillAssessmentsSkillsArgs = {
  where: LessonPlayerSkillAssessmentsSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonPlayerSkillAssessmentsSkillsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonReflectionCommentsArgs = {
  where: LessonReflectionCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonReflectionCommentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonReflectionFilesArgs = {
  where: LessonReflectionFilesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonReflectionFilesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonReflectionsArgs = {
  where: LessonReflectionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonReflectionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonSkillLevelsArgs = {
  where: LessonSkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonTemplateSkillLevelsArgs = {
  where: LessonTemplateSkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonTemplateSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLessonTimesArgs = {
  where: LessonTimesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLessonTimesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilitiesArgs = {
  where: PlayerAvailabilitiesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilitiesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilityNeighborhoodsArgs = {
  where: PlayerAvailabilityNeighborhoodsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilityNeighborhoodsByPkArgs = {
  availabilityId: Scalars['uuid'];
  neighborhoodId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilityRatingScalesArgs = {
  where: PlayerAvailabilityRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilityRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilitySlotsArgs = {
  where: PlayerAvailabilitySlotsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilitySlotsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilityVenuesArgs = {
  where: PlayerAvailabilityVenuesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePlayerAvailabilityVenuesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserContentFilesArgs = {
  where: UserContentFilesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserContentFilesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserContentFilesSkillsArgs = {
  where: UserContentFilesSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserContentFilesSkillsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserContentSkillsArgs = {
  where: UserContentSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserContentSkillsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserFilesArgs = {
  where: UserFilesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserFilesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserPadelRatingScalesArgs = {
  where: UserPadelRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserPadelRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserPickleballRatingScalesArgs = {
  where: UserPickleballRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserPickleballRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserPlayerFinderAvailabilityArgs = {
  where: UserPlayerFinderAvailabilityBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserPlayerFinderAvailabilityByPkArgs = {
  dayOfWeek: DayOfWeekEnum;
  timeOfDay: PlayerFinderTimeOfDayEnum;
  userId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserPlayerFinderGoalsArgs = {
  where: UserPlayerFinderGoalsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserPlayerFinderGoalsByPkArgs = {
  goal: PlayerFinderGoalsEnum;
  userId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserSportsArgs = {
  where: UserSportsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserSportsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserTennisRatingScalesArgs = {
  where: UserTennisRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserTennisRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisCommentsArgs = {
  where: VideoAnalysisCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisCommentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisFilesArgs = {
  where: VideoAnalysisFilesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisFilesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisSkillsCommentsArgs = {
  where: VideoAnalysisSkillsCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoAnalysisSkillsCommentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVideoLessonSkillsArgs = {
  where: VideoLessonSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVideoLessonSkillsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootInsertAppPingsArgs = {
  objects: Array<AppPingsInsertInput>;
  onConflict?: InputMaybe<AppPingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAppPingsOneArgs = {
  object: AppPingsInsertInput;
  onConflict?: InputMaybe<AppPingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachAvailabilityArgs = {
  objects: Array<CoachAvailabilityInsertInput>;
  onConflict?: InputMaybe<CoachAvailabilityOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachAvailabilityOneArgs = {
  object: CoachAvailabilityInsertInput;
  onConflict?: InputMaybe<CoachAvailabilityOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachBookingRequestsArgs = {
  objects: Array<CoachBookingRequestsInsertInput>;
  onConflict?: InputMaybe<CoachBookingRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachBookingRequestsOneArgs = {
  object: CoachBookingRequestsInsertInput;
  onConflict?: InputMaybe<CoachBookingRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachFaqsArgs = {
  objects: Array<CoachFaqsInsertInput>;
  onConflict?: InputMaybe<CoachFaqsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachFaqsOneArgs = {
  object: CoachFaqsInsertInput;
  onConflict?: InputMaybe<CoachFaqsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachLessonAgeGroupsArgs = {
  objects: Array<CoachLessonAgeGroupsInsertInput>;
  onConflict?: InputMaybe<CoachLessonAgeGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachLessonAgeGroupsOneArgs = {
  object: CoachLessonAgeGroupsInsertInput;
  onConflict?: InputMaybe<CoachLessonAgeGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachLessonSkillLevelsArgs = {
  objects: Array<CoachLessonSkillLevelsInsertInput>;
  onConflict?: InputMaybe<CoachLessonSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachLessonSkillLevelsOneArgs = {
  object: CoachLessonSkillLevelsInsertInput;
  onConflict?: InputMaybe<CoachLessonSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachSportsArgs = {
  objects: Array<CoachSportsInsertInput>;
  onConflict?: InputMaybe<CoachSportsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachSportsOneArgs = {
  object: CoachSportsInsertInput;
  onConflict?: InputMaybe<CoachSportsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCoachTipsArgs = {
  objects: Array<CoachTipsInsertInput>;
  onConflict?: InputMaybe<CoachTipsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCollectionsArgs = {
  objects: Array<EventCollectionsInsertInput>;
  onConflict?: InputMaybe<EventCollectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventCollectionsOneArgs = {
  object: EventCollectionsInsertInput;
  onConflict?: InputMaybe<EventCollectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventFaqsArgs = {
  objects: Array<EventFaqsInsertInput>;
  onConflict?: InputMaybe<EventFaqsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventFaqsOneArgs = {
  object: EventFaqsInsertInput;
  onConflict?: InputMaybe<EventFaqsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGameScoresArgs = {
  objects: Array<EventGameScoresInsertInput>;
  onConflict?: InputMaybe<EventGameScoresOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGameScoresOneArgs = {
  object: EventGameScoresInsertInput;
  onConflict?: InputMaybe<EventGameScoresOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupMergesArgs = {
  objects: Array<EventGroupMergesInsertInput>;
  onConflict?: InputMaybe<EventGroupMergesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupMergesOneArgs = {
  object: EventGroupMergesInsertInput;
  onConflict?: InputMaybe<EventGroupMergesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupRatingScalesArgs = {
  objects: Array<EventGroupRatingScalesInsertInput>;
  onConflict?: InputMaybe<EventGroupRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupRatingScalesOneArgs = {
  object: EventGroupRatingScalesInsertInput;
  onConflict?: InputMaybe<EventGroupRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupTimeSlotsArgs = {
  objects: Array<EventGroupTimeSlotsInsertInput>;
  onConflict?: InputMaybe<EventGroupTimeSlotsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupTimeSlotsOneArgs = {
  object: EventGroupTimeSlotsInsertInput;
  onConflict?: InputMaybe<EventGroupTimeSlotsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupsArgs = {
  objects: Array<EventGroupsInsertInput>;
  onConflict?: InputMaybe<EventGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventGroupsOneArgs = {
  object: EventGroupsInsertInput;
  onConflict?: InputMaybe<EventGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventInvitationsArgs = {
  objects: Array<EventInvitationsInsertInput>;
  onConflict?: InputMaybe<EventInvitationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventInvitationsOneArgs = {
  object: EventInvitationsInsertInput;
  onConflict?: InputMaybe<EventInvitationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventMatchGamesArgs = {
  objects: Array<EventMatchGamesInsertInput>;
  onConflict?: InputMaybe<EventMatchGamesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventMatchGamesOneArgs = {
  object: EventMatchGamesInsertInput;
  onConflict?: InputMaybe<EventMatchGamesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventRegistrationDetailsArgs = {
  objects: Array<EventRegistrationDetailsInsertInput>;
  onConflict?: InputMaybe<EventRegistrationDetailsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventRegistrationDetailsOneArgs = {
  object: EventRegistrationDetailsInsertInput;
  onConflict?: InputMaybe<EventRegistrationDetailsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventSkillLevelsArgs = {
  objects: Array<EventSkillLevelsInsertInput>;
  onConflict?: InputMaybe<EventSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventSkillLevelsOneArgs = {
  object: EventSkillLevelsInsertInput;
  onConflict?: InputMaybe<EventSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventSponsorsArgs = {
  objects: Array<EventSponsorsInsertInput>;
  onConflict?: InputMaybe<EventSponsorsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventSponsorsOneArgs = {
  object: EventSponsorsInsertInput;
  onConflict?: InputMaybe<EventSponsorsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventsArgs = {
  objects: Array<EventsInsertInput>;
  onConflict?: InputMaybe<EventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventsOneArgs = {
  object: EventsInsertInput;
  onConflict?: InputMaybe<EventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupCommentVotesArgs = {
  objects: Array<GroupCommentVotesInsertInput>;
  onConflict?: InputMaybe<GroupCommentVotesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupCommentVotesOneArgs = {
  object: GroupCommentVotesInsertInput;
  onConflict?: InputMaybe<GroupCommentVotesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupMembersArgs = {
  objects: Array<GroupMembersInsertInput>;
  onConflict?: InputMaybe<GroupMembersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupMembersOneArgs = {
  object: GroupMembersInsertInput;
  onConflict?: InputMaybe<GroupMembersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupThreadCommentFilesArgs = {
  objects: Array<GroupThreadCommentFilesInsertInput>;
  onConflict?: InputMaybe<GroupThreadCommentFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupThreadCommentFilesOneArgs = {
  object: GroupThreadCommentFilesInsertInput;
  onConflict?: InputMaybe<GroupThreadCommentFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupThreadCommentsArgs = {
  objects: Array<GroupThreadCommentsInsertInput>;
  onConflict?: InputMaybe<GroupThreadCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupThreadCommentsOneArgs = {
  object: GroupThreadCommentsInsertInput;
  onConflict?: InputMaybe<GroupThreadCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupThreadsArgs = {
  objects: Array<GroupThreadsInsertInput>;
  onConflict?: InputMaybe<GroupThreadsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupThreadsOneArgs = {
  object: GroupThreadsInsertInput;
  onConflict?: InputMaybe<GroupThreadsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupsPlaySessionsArgs = {
  objects: Array<GroupsPlaySessionsInsertInput>;
  onConflict?: InputMaybe<GroupsPlaySessionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertGroupsPlaySessionsOneArgs = {
  object: GroupsPlaySessionsInsertInput;
  onConflict?: InputMaybe<GroupsPlaySessionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramEnrollmentScheduleMediaWatchedArgs = {
  objects: Array<LearningProgramEnrollmentScheduleMediaWatchedInsertInput>;
  onConflict?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramEnrollmentScheduleMediaWatchedOneArgs = {
  object: LearningProgramEnrollmentScheduleMediaWatchedInsertInput;
  onConflict?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramEnrollmentScheduleProgressArgs = {
  objects: Array<LearningProgramEnrollmentScheduleProgressInsertInput>;
  onConflict?: InputMaybe<LearningProgramEnrollmentScheduleProgressOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramEnrollmentScheduleProgressOneArgs = {
  object: LearningProgramEnrollmentScheduleProgressInsertInput;
  onConflict?: InputMaybe<LearningProgramEnrollmentScheduleProgressOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramEnrollmentsArgs = {
  objects: Array<LearningProgramEnrollmentsInsertInput>;
  onConflict?: InputMaybe<LearningProgramEnrollmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLearningProgramEnrollmentsOneArgs = {
  object: LearningProgramEnrollmentsInsertInput;
  onConflict?: InputMaybe<LearningProgramEnrollmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonCollectionsArgs = {
  objects: Array<LessonCollectionsInsertInput>;
  onConflict?: InputMaybe<LessonCollectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonCollectionsOneArgs = {
  object: LessonCollectionsInsertInput;
  onConflict?: InputMaybe<LessonCollectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonEquipmentArgs = {
  objects: Array<LessonEquipmentInsertInput>;
  onConflict?: InputMaybe<LessonEquipmentOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonEquipmentOneArgs = {
  object: LessonEquipmentInsertInput;
  onConflict?: InputMaybe<LessonEquipmentOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonParticipantsArgs = {
  objects: Array<LessonParticipantsInsertInput>;
  onConflict?: InputMaybe<LessonParticipantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonParticipantsOneArgs = {
  object: LessonParticipantsInsertInput;
  onConflict?: InputMaybe<LessonParticipantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonPlayerSkillAssessmentsArgs = {
  objects: Array<LessonPlayerSkillAssessmentsInsertInput>;
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonPlayerSkillAssessmentsOneArgs = {
  object: LessonPlayerSkillAssessmentsInsertInput;
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonPlayerSkillAssessmentsSkillsArgs = {
  objects: Array<LessonPlayerSkillAssessmentsSkillsInsertInput>;
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentsSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonPlayerSkillAssessmentsSkillsOneArgs = {
  object: LessonPlayerSkillAssessmentsSkillsInsertInput;
  onConflict?: InputMaybe<LessonPlayerSkillAssessmentsSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonReflectionCommentsArgs = {
  objects: Array<LessonReflectionCommentsInsertInput>;
  onConflict?: InputMaybe<LessonReflectionCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonReflectionCommentsOneArgs = {
  object: LessonReflectionCommentsInsertInput;
  onConflict?: InputMaybe<LessonReflectionCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonReflectionFilesArgs = {
  objects: Array<LessonReflectionFilesInsertInput>;
  onConflict?: InputMaybe<LessonReflectionFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonReflectionFilesOneArgs = {
  object: LessonReflectionFilesInsertInput;
  onConflict?: InputMaybe<LessonReflectionFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonReflectionsArgs = {
  objects: Array<LessonReflectionsInsertInput>;
  onConflict?: InputMaybe<LessonReflectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonReflectionsOneArgs = {
  object: LessonReflectionsInsertInput;
  onConflict?: InputMaybe<LessonReflectionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonSkillLevelsArgs = {
  objects: Array<LessonSkillLevelsInsertInput>;
  onConflict?: InputMaybe<LessonSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonSkillLevelsOneArgs = {
  object: LessonSkillLevelsInsertInput;
  onConflict?: InputMaybe<LessonSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonTemplateSkillLevelsArgs = {
  objects: Array<LessonTemplateSkillLevelsInsertInput>;
  onConflict?: InputMaybe<LessonTemplateSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonTemplateSkillLevelsOneArgs = {
  object: LessonTemplateSkillLevelsInsertInput;
  onConflict?: InputMaybe<LessonTemplateSkillLevelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonTemplatesArgs = {
  objects: Array<LessonTemplatesInsertInput>;
  onConflict?: InputMaybe<LessonTemplatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonTemplatesOneArgs = {
  object: LessonTemplatesInsertInput;
  onConflict?: InputMaybe<LessonTemplatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonTimesArgs = {
  objects: Array<LessonTimesInsertInput>;
  onConflict?: InputMaybe<LessonTimesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonTimesOneArgs = {
  object: LessonTimesInsertInput;
  onConflict?: InputMaybe<LessonTimesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonWaitlistsArgs = {
  objects: Array<LessonWaitlistsInsertInput>;
  onConflict?: InputMaybe<LessonWaitlistsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonWaitlistsOneArgs = {
  object: LessonWaitlistsInsertInput;
  onConflict?: InputMaybe<LessonWaitlistsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonsArgs = {
  objects: Array<LessonsInsertInput>;
  onConflict?: InputMaybe<LessonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLessonsOneArgs = {
  object: LessonsInsertInput;
  onConflict?: InputMaybe<LessonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionCommentsArgs = {
  objects: Array<PlaySessionCommentsInsertInput>;
  onConflict?: InputMaybe<PlaySessionCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionCommentsOneArgs = {
  object: PlaySessionCommentsInsertInput;
  onConflict?: InputMaybe<PlaySessionCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionParticipantsArgs = {
  objects: Array<PlaySessionParticipantsInsertInput>;
  onConflict?: InputMaybe<PlaySessionParticipantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionParticipantsOneArgs = {
  object: PlaySessionParticipantsInsertInput;
  onConflict?: InputMaybe<PlaySessionParticipantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionsArgs = {
  objects: Array<PlaySessionsInsertInput>;
  onConflict?: InputMaybe<PlaySessionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlaySessionsOneArgs = {
  object: PlaySessionsInsertInput;
  onConflict?: InputMaybe<PlaySessionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilitiesArgs = {
  objects: Array<PlayerAvailabilitiesInsertInput>;
  onConflict?: InputMaybe<PlayerAvailabilitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilitiesOneArgs = {
  object: PlayerAvailabilitiesInsertInput;
  onConflict?: InputMaybe<PlayerAvailabilitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilityNeighborhoodsArgs = {
  objects: Array<PlayerAvailabilityNeighborhoodsInsertInput>;
  onConflict?: InputMaybe<PlayerAvailabilityNeighborhoodsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilityNeighborhoodsOneArgs = {
  object: PlayerAvailabilityNeighborhoodsInsertInput;
  onConflict?: InputMaybe<PlayerAvailabilityNeighborhoodsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilityRatingScalesArgs = {
  objects: Array<PlayerAvailabilityRatingScalesInsertInput>;
  onConflict?: InputMaybe<PlayerAvailabilityRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilityRatingScalesOneArgs = {
  object: PlayerAvailabilityRatingScalesInsertInput;
  onConflict?: InputMaybe<PlayerAvailabilityRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilitySlotsArgs = {
  objects: Array<PlayerAvailabilitySlotsInsertInput>;
  onConflict?: InputMaybe<PlayerAvailabilitySlotsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilitySlotsOneArgs = {
  object: PlayerAvailabilitySlotsInsertInput;
  onConflict?: InputMaybe<PlayerAvailabilitySlotsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilityVenuesArgs = {
  objects: Array<PlayerAvailabilityVenuesInsertInput>;
  onConflict?: InputMaybe<PlayerAvailabilityVenuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPlayerAvailabilityVenuesOneArgs = {
  object: PlayerAvailabilityVenuesInsertInput;
  onConflict?: InputMaybe<PlayerAvailabilityVenuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReviewsArgs = {
  objects: Array<ReviewsInsertInput>;
  onConflict?: InputMaybe<ReviewsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReviewsOneArgs = {
  object: ReviewsInsertInput;
  onConflict?: InputMaybe<ReviewsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSignupRequestsArgs = {
  objects: Array<SignupRequestsInsertInput>;
  onConflict?: InputMaybe<SignupRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSignupRequestsOneArgs = {
  object: SignupRequestsInsertInput;
  onConflict?: InputMaybe<SignupRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTwilioGroupTextsArgs = {
  objects: Array<TwilioGroupTextsInsertInput>;
  onConflict?: InputMaybe<TwilioGroupTextsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTwilioGroupTextsOneArgs = {
  object: TwilioGroupTextsInsertInput;
  onConflict?: InputMaybe<TwilioGroupTextsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUploadReviewRequestsArgs = {
  objects: Array<UploadReviewRequestsInsertInput>;
  onConflict?: InputMaybe<UploadReviewRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUploadReviewRequestsOneArgs = {
  object: UploadReviewRequestsInsertInput;
  onConflict?: InputMaybe<UploadReviewRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserCoachServicesArgs = {
  objects: Array<UserCoachServicesInsertInput>;
  onConflict?: InputMaybe<UserCoachServicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserCoachServicesOneArgs = {
  object: UserCoachServicesInsertInput;
  onConflict?: InputMaybe<UserCoachServicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentFilesArgs = {
  objects: Array<UserContentFilesInsertInput>;
  onConflict?: InputMaybe<UserContentFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentFilesOneArgs = {
  object: UserContentFilesInsertInput;
  onConflict?: InputMaybe<UserContentFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentFilesSkillsArgs = {
  objects: Array<UserContentFilesSkillsInsertInput>;
  onConflict?: InputMaybe<UserContentFilesSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentFilesSkillsOneArgs = {
  object: UserContentFilesSkillsInsertInput;
  onConflict?: InputMaybe<UserContentFilesSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentSkillsArgs = {
  objects: Array<UserContentSkillsInsertInput>;
  onConflict?: InputMaybe<UserContentSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserContentSkillsOneArgs = {
  object: UserContentSkillsInsertInput;
  onConflict?: InputMaybe<UserContentSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserCustomCourtsArgs = {
  objects: Array<UserCustomCourtsInsertInput>;
  onConflict?: InputMaybe<UserCustomCourtsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserCustomCourtsOneArgs = {
  object: UserCustomCourtsInsertInput;
  onConflict?: InputMaybe<UserCustomCourtsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserFilesArgs = {
  objects: Array<UserFilesInsertInput>;
  onConflict?: InputMaybe<UserFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserFilesOneArgs = {
  object: UserFilesInsertInput;
  onConflict?: InputMaybe<UserFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserFollowsArgs = {
  objects: Array<UserFollowsInsertInput>;
  onConflict?: InputMaybe<UserFollowsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserFollowsOneArgs = {
  object: UserFollowsInsertInput;
  onConflict?: InputMaybe<UserFollowsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserImageLogArgs = {
  objects: Array<UserImageLogInsertInput>;
  onConflict?: InputMaybe<UserImageLogOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserImageLogOneArgs = {
  object: UserImageLogInsertInput;
  onConflict?: InputMaybe<UserImageLogOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPadelRatingScalesArgs = {
  objects: Array<UserPadelRatingScalesInsertInput>;
  onConflict?: InputMaybe<UserPadelRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPadelRatingScalesOneArgs = {
  object: UserPadelRatingScalesInsertInput;
  onConflict?: InputMaybe<UserPadelRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPickleballRatingScalesArgs = {
  objects: Array<UserPickleballRatingScalesInsertInput>;
  onConflict?: InputMaybe<UserPickleballRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPickleballRatingScalesOneArgs = {
  object: UserPickleballRatingScalesInsertInput;
  onConflict?: InputMaybe<UserPickleballRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPlayerFinderAvailabilityArgs = {
  objects: Array<UserPlayerFinderAvailabilityInsertInput>;
  onConflict?: InputMaybe<UserPlayerFinderAvailabilityOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPlayerFinderAvailabilityOneArgs = {
  object: UserPlayerFinderAvailabilityInsertInput;
  onConflict?: InputMaybe<UserPlayerFinderAvailabilityOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPlayerFinderGoalsArgs = {
  objects: Array<UserPlayerFinderGoalsInsertInput>;
  onConflict?: InputMaybe<UserPlayerFinderGoalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPlayerFinderGoalsOneArgs = {
  object: UserPlayerFinderGoalsInsertInput;
  onConflict?: InputMaybe<UserPlayerFinderGoalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserSportsArgs = {
  objects: Array<UserSportsInsertInput>;
  onConflict?: InputMaybe<UserSportsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserSportsOneArgs = {
  object: UserSportsInsertInput;
  onConflict?: InputMaybe<UserSportsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserTennisRatingScalesArgs = {
  objects: Array<UserTennisRatingScalesInsertInput>;
  onConflict?: InputMaybe<UserTennisRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserTennisRatingScalesOneArgs = {
  object: UserTennisRatingScalesInsertInput;
  onConflict?: InputMaybe<UserTennisRatingScalesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserTermsOfServiceArgs = {
  objects: Array<UserTermsOfServiceInsertInput>;
  onConflict?: InputMaybe<UserTermsOfServiceOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserTermsOfServiceOneArgs = {
  object: UserTermsOfServiceInsertInput;
  onConflict?: InputMaybe<UserTermsOfServiceOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersCoachQualificationsArgs = {
  objects: Array<UsersCoachQualificationsInsertInput>;
  onConflict?: InputMaybe<UsersCoachQualificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersCoachQualificationsOneArgs = {
  object: UsersCoachQualificationsInsertInput;
  onConflict?: InputMaybe<UsersCoachQualificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueFollowsArgs = {
  objects: Array<VenueFollowsInsertInput>;
  onConflict?: InputMaybe<VenueFollowsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueFollowsOneArgs = {
  object: VenueFollowsInsertInput;
  onConflict?: InputMaybe<VenueFollowsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueStaffCoachesArgs = {
  objects: Array<VenueStaffCoachesInsertInput>;
  onConflict?: InputMaybe<VenueStaffCoachesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVenueStaffCoachesOneArgs = {
  object: VenueStaffCoachesInsertInput;
  onConflict?: InputMaybe<VenueStaffCoachesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisArgs = {
  objects: Array<VideoAnalysisInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisCommentsArgs = {
  objects: Array<VideoAnalysisCommentsInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisCommentsOneArgs = {
  object: VideoAnalysisCommentsInsertInput;
  onConflict?: InputMaybe<VideoAnalysisCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisFilesArgs = {
  objects: Array<VideoAnalysisFilesInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisFilesOneArgs = {
  object: VideoAnalysisFilesInsertInput;
  onConflict?: InputMaybe<VideoAnalysisFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisOneArgs = {
  object: VideoAnalysisInsertInput;
  onConflict?: InputMaybe<VideoAnalysisOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisSkillsCommentsArgs = {
  objects: Array<VideoAnalysisSkillsCommentsInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisSkillsCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisSkillsCommentsOneArgs = {
  object: VideoAnalysisSkillsCommentsInsertInput;
  onConflict?: InputMaybe<VideoAnalysisSkillsCommentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisSubmissionLogArgs = {
  objects: Array<VideoAnalysisSubmissionLogInsertInput>;
  onConflict?: InputMaybe<VideoAnalysisSubmissionLogOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoAnalysisSubmissionLogOneArgs = {
  object: VideoAnalysisSubmissionLogInsertInput;
  onConflict?: InputMaybe<VideoAnalysisSubmissionLogOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoLessonSkillsArgs = {
  objects: Array<VideoLessonSkillsInsertInput>;
  onConflict?: InputMaybe<VideoLessonSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVideoLessonSkillsOneArgs = {
  object: VideoLessonSkillsInsertInput;
  onConflict?: InputMaybe<VideoLessonSkillsOnConflict>;
};


/** mutation root */
export type Mutation_RootUpdateCalendarAccountsArgs = {
  _set?: InputMaybe<CalendarAccountsSetInput>;
  where: CalendarAccountsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCalendarAccountsByPkArgs = {
  _set?: InputMaybe<CalendarAccountsSetInput>;
  pkColumns: CalendarAccountsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCalendarAccountsManyArgs = {
  updates: Array<CalendarAccountsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCalendarPreferencesArgs = {
  _set?: InputMaybe<CalendarPreferencesSetInput>;
  where: CalendarPreferencesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCalendarPreferencesByPkArgs = {
  _set?: InputMaybe<CalendarPreferencesSetInput>;
  pkColumns: CalendarPreferencesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCalendarPreferencesManyArgs = {
  updates: Array<CalendarPreferencesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachAvailabilityArgs = {
  _inc?: InputMaybe<CoachAvailabilityIncInput>;
  _set?: InputMaybe<CoachAvailabilitySetInput>;
  where: CoachAvailabilityBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachAvailabilityByPkArgs = {
  _inc?: InputMaybe<CoachAvailabilityIncInput>;
  _set?: InputMaybe<CoachAvailabilitySetInput>;
  pkColumns: CoachAvailabilityPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachAvailabilityManyArgs = {
  updates: Array<CoachAvailabilityUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachBookingRequestsArgs = {
  _set?: InputMaybe<CoachBookingRequestsSetInput>;
  where: CoachBookingRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachBookingRequestsByPkArgs = {
  _set?: InputMaybe<CoachBookingRequestsSetInput>;
  pkColumns: CoachBookingRequestsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachBookingRequestsManyArgs = {
  updates: Array<CoachBookingRequestsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachFaqsArgs = {
  _set?: InputMaybe<CoachFaqsSetInput>;
  where: CoachFaqsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachFaqsByPkArgs = {
  _set?: InputMaybe<CoachFaqsSetInput>;
  pkColumns: CoachFaqsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachFaqsManyArgs = {
  updates: Array<CoachFaqsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachLessonAgeGroupsArgs = {
  _set?: InputMaybe<CoachLessonAgeGroupsSetInput>;
  where: CoachLessonAgeGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachLessonAgeGroupsByPkArgs = {
  _set?: InputMaybe<CoachLessonAgeGroupsSetInput>;
  pkColumns: CoachLessonAgeGroupsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachLessonAgeGroupsManyArgs = {
  updates: Array<CoachLessonAgeGroupsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachLessonSkillLevelsArgs = {
  _set?: InputMaybe<CoachLessonSkillLevelsSetInput>;
  where: CoachLessonSkillLevelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachLessonSkillLevelsByPkArgs = {
  _set?: InputMaybe<CoachLessonSkillLevelsSetInput>;
  pkColumns: CoachLessonSkillLevelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachLessonSkillLevelsManyArgs = {
  updates: Array<CoachLessonSkillLevelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCoachSportsArgs = {
  _set?: InputMaybe<CoachSportsSetInput>;
  where: CoachSportsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCoachSportsByPkArgs = {
  _set?: InputMaybe<CoachSportsSetInput>;
  pkColumns: CoachSportsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCoachSportsManyArgs = {
  updates: Array<CoachSportsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateConversationParticipantsArgs = {
  _set?: InputMaybe<ConversationParticipantsSetInput>;
  where: ConversationParticipantsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateConversationParticipantsByPkArgs = {
  _set?: InputMaybe<ConversationParticipantsSetInput>;
  pkColumns: ConversationParticipantsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateConversationParticipantsManyArgs = {
  updates: Array<ConversationParticipantsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventCollectionsArgs = {
  _set?: InputMaybe<EventCollectionsSetInput>;
  where: EventCollectionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventCollectionsByPkArgs = {
  _set?: InputMaybe<EventCollectionsSetInput>;
  pkColumns: EventCollectionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventCollectionsManyArgs = {
  updates: Array<EventCollectionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventContactDetailsArgs = {
  _set?: InputMaybe<EventContactDetailsSetInput>;
  where: EventContactDetailsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventContactDetailsByPkArgs = {
  _set?: InputMaybe<EventContactDetailsSetInput>;
  pkColumns: EventContactDetailsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventContactDetailsManyArgs = {
  updates: Array<EventContactDetailsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventCourtsArgs = {
  _set?: InputMaybe<EventCourtsSetInput>;
  where: EventCourtsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventCourtsByPkArgs = {
  _set?: InputMaybe<EventCourtsSetInput>;
  pkColumns: EventCourtsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventCourtsManyArgs = {
  updates: Array<EventCourtsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventFaqsArgs = {
  _set?: InputMaybe<EventFaqsSetInput>;
  where: EventFaqsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventFaqsByPkArgs = {
  _set?: InputMaybe<EventFaqsSetInput>;
  pkColumns: EventFaqsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventFaqsManyArgs = {
  updates: Array<EventFaqsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGameScoresArgs = {
  _inc?: InputMaybe<EventGameScoresIncInput>;
  _set?: InputMaybe<EventGameScoresSetInput>;
  where: EventGameScoresBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGameScoresByPkArgs = {
  _inc?: InputMaybe<EventGameScoresIncInput>;
  _set?: InputMaybe<EventGameScoresSetInput>;
  pkColumns: EventGameScoresPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGameScoresManyArgs = {
  updates: Array<EventGameScoresUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupMergesArgs = {
  _set?: InputMaybe<EventGroupMergesSetInput>;
  where: EventGroupMergesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupMergesByPkArgs = {
  _set?: InputMaybe<EventGroupMergesSetInput>;
  pkColumns: EventGroupMergesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupMergesManyArgs = {
  updates: Array<EventGroupMergesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupRatingScalesArgs = {
  _inc?: InputMaybe<EventGroupRatingScalesIncInput>;
  _set?: InputMaybe<EventGroupRatingScalesSetInput>;
  where: EventGroupRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupRatingScalesByPkArgs = {
  _inc?: InputMaybe<EventGroupRatingScalesIncInput>;
  _set?: InputMaybe<EventGroupRatingScalesSetInput>;
  pkColumns: EventGroupRatingScalesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupRatingScalesManyArgs = {
  updates: Array<EventGroupRatingScalesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupSequencesArgs = {
  _set?: InputMaybe<EventGroupSequencesSetInput>;
  where: EventGroupSequencesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupSequencesByPkArgs = {
  _set?: InputMaybe<EventGroupSequencesSetInput>;
  pkColumns: EventGroupSequencesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupSequencesManyArgs = {
  updates: Array<EventGroupSequencesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupTimeSlotsArgs = {
  _set?: InputMaybe<EventGroupTimeSlotsSetInput>;
  where: EventGroupTimeSlotsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupTimeSlotsByPkArgs = {
  _set?: InputMaybe<EventGroupTimeSlotsSetInput>;
  pkColumns: EventGroupTimeSlotsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupTimeSlotsManyArgs = {
  updates: Array<EventGroupTimeSlotsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupsArgs = {
  _append?: InputMaybe<EventGroupsAppendInput>;
  _deleteAtPath?: InputMaybe<EventGroupsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<EventGroupsDeleteElemInput>;
  _deleteKey?: InputMaybe<EventGroupsDeleteKeyInput>;
  _inc?: InputMaybe<EventGroupsIncInput>;
  _prepend?: InputMaybe<EventGroupsPrependInput>;
  _set?: InputMaybe<EventGroupsSetInput>;
  where: EventGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupsByPkArgs = {
  _append?: InputMaybe<EventGroupsAppendInput>;
  _deleteAtPath?: InputMaybe<EventGroupsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<EventGroupsDeleteElemInput>;
  _deleteKey?: InputMaybe<EventGroupsDeleteKeyInput>;
  _inc?: InputMaybe<EventGroupsIncInput>;
  _prepend?: InputMaybe<EventGroupsPrependInput>;
  _set?: InputMaybe<EventGroupsSetInput>;
  pkColumns: EventGroupsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventGroupsManyArgs = {
  updates: Array<EventGroupsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchGamesArgs = {
  _inc?: InputMaybe<EventMatchGamesIncInput>;
  _set?: InputMaybe<EventMatchGamesSetInput>;
  where: EventMatchGamesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchGamesByPkArgs = {
  _inc?: InputMaybe<EventMatchGamesIncInput>;
  _set?: InputMaybe<EventMatchGamesSetInput>;
  pkColumns: EventMatchGamesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchGamesManyArgs = {
  updates: Array<EventMatchGamesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchesArgs = {
  _inc?: InputMaybe<EventMatchesIncInput>;
  _set?: InputMaybe<EventMatchesSetInput>;
  where: EventMatchesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchesByPkArgs = {
  _inc?: InputMaybe<EventMatchesIncInput>;
  _set?: InputMaybe<EventMatchesSetInput>;
  pkColumns: EventMatchesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventMatchesManyArgs = {
  updates: Array<EventMatchesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventSponsorsArgs = {
  _set?: InputMaybe<EventSponsorsSetInput>;
  where: EventSponsorsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventSponsorsByPkArgs = {
  _set?: InputMaybe<EventSponsorsSetInput>;
  pkColumns: EventSponsorsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventSponsorsManyArgs = {
  updates: Array<EventSponsorsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventsArgs = {
  _inc?: InputMaybe<EventsIncInput>;
  _set?: InputMaybe<EventsSetInput>;
  where: EventsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventsByPkArgs = {
  _inc?: InputMaybe<EventsIncInput>;
  _set?: InputMaybe<EventsSetInput>;
  pkColumns: EventsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventsManyArgs = {
  updates: Array<EventsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGroupCommentVotesArgs = {
  _set?: InputMaybe<GroupCommentVotesSetInput>;
  where: GroupCommentVotesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGroupCommentVotesByPkArgs = {
  _set?: InputMaybe<GroupCommentVotesSetInput>;
  pkColumns: GroupCommentVotesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGroupCommentVotesManyArgs = {
  updates: Array<GroupCommentVotesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGroupMembersArgs = {
  _set?: InputMaybe<GroupMembersSetInput>;
  where: GroupMembersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGroupMembersByPkArgs = {
  _set?: InputMaybe<GroupMembersSetInput>;
  pkColumns: GroupMembersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGroupMembersManyArgs = {
  updates: Array<GroupMembersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadCommentFilesArgs = {
  _set?: InputMaybe<GroupThreadCommentFilesSetInput>;
  where: GroupThreadCommentFilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadCommentFilesByPkArgs = {
  _set?: InputMaybe<GroupThreadCommentFilesSetInput>;
  pkColumns: GroupThreadCommentFilesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadCommentFilesManyArgs = {
  updates: Array<GroupThreadCommentFilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadCommentsArgs = {
  _set?: InputMaybe<GroupThreadCommentsSetInput>;
  where: GroupThreadCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadCommentsByPkArgs = {
  _set?: InputMaybe<GroupThreadCommentsSetInput>;
  pkColumns: GroupThreadCommentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGroupThreadCommentsManyArgs = {
  updates: Array<GroupThreadCommentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateGroupsPlaySessionsArgs = {
  _set?: InputMaybe<GroupsPlaySessionsSetInput>;
  where: GroupsPlaySessionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateGroupsPlaySessionsByPkArgs = {
  _set?: InputMaybe<GroupsPlaySessionsSetInput>;
  pkColumns: GroupsPlaySessionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateGroupsPlaySessionsManyArgs = {
  updates: Array<GroupsPlaySessionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentScheduleMediaWatchedArgs = {
  _set?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedSetInput>;
  where: LearningProgramEnrollmentScheduleMediaWatchedBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentScheduleMediaWatchedByPkArgs = {
  _set?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedSetInput>;
  pkColumns: LearningProgramEnrollmentScheduleMediaWatchedPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentScheduleMediaWatchedManyArgs = {
  updates: Array<LearningProgramEnrollmentScheduleMediaWatchedUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentScheduleProgressArgs = {
  _inc?: InputMaybe<LearningProgramEnrollmentScheduleProgressIncInput>;
  _set?: InputMaybe<LearningProgramEnrollmentScheduleProgressSetInput>;
  where: LearningProgramEnrollmentScheduleProgressBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentScheduleProgressByPkArgs = {
  _inc?: InputMaybe<LearningProgramEnrollmentScheduleProgressIncInput>;
  _set?: InputMaybe<LearningProgramEnrollmentScheduleProgressSetInput>;
  pkColumns: LearningProgramEnrollmentScheduleProgressPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLearningProgramEnrollmentScheduleProgressManyArgs = {
  updates: Array<LearningProgramEnrollmentScheduleProgressUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonCollectionsArgs = {
  _set?: InputMaybe<LessonCollectionsSetInput>;
  where: LessonCollectionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonCollectionsByPkArgs = {
  _set?: InputMaybe<LessonCollectionsSetInput>;
  pkColumns: LessonCollectionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonCollectionsManyArgs = {
  updates: Array<LessonCollectionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonEquipmentArgs = {
  _set?: InputMaybe<LessonEquipmentSetInput>;
  where: LessonEquipmentBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonEquipmentByPkArgs = {
  _set?: InputMaybe<LessonEquipmentSetInput>;
  pkColumns: LessonEquipmentPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonEquipmentManyArgs = {
  updates: Array<LessonEquipmentUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonParticipantsArgs = {
  _set?: InputMaybe<LessonParticipantsSetInput>;
  where: LessonParticipantsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonParticipantsByPkArgs = {
  _set?: InputMaybe<LessonParticipantsSetInput>;
  pkColumns: LessonParticipantsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonParticipantsManyArgs = {
  updates: Array<LessonParticipantsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentsArgs = {
  _set?: InputMaybe<LessonPlayerSkillAssessmentsSetInput>;
  where: LessonPlayerSkillAssessmentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentsByPkArgs = {
  _set?: InputMaybe<LessonPlayerSkillAssessmentsSetInput>;
  pkColumns: LessonPlayerSkillAssessmentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentsManyArgs = {
  updates: Array<LessonPlayerSkillAssessmentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentsSkillsArgs = {
  _set?: InputMaybe<LessonPlayerSkillAssessmentsSkillsSetInput>;
  where: LessonPlayerSkillAssessmentsSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentsSkillsByPkArgs = {
  _set?: InputMaybe<LessonPlayerSkillAssessmentsSkillsSetInput>;
  pkColumns: LessonPlayerSkillAssessmentsSkillsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonPlayerSkillAssessmentsSkillsManyArgs = {
  updates: Array<LessonPlayerSkillAssessmentsSkillsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionCommentsArgs = {
  _inc?: InputMaybe<LessonReflectionCommentsIncInput>;
  _set?: InputMaybe<LessonReflectionCommentsSetInput>;
  where: LessonReflectionCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionCommentsByPkArgs = {
  _inc?: InputMaybe<LessonReflectionCommentsIncInput>;
  _set?: InputMaybe<LessonReflectionCommentsSetInput>;
  pkColumns: LessonReflectionCommentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionCommentsManyArgs = {
  updates: Array<LessonReflectionCommentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionFilesArgs = {
  _set?: InputMaybe<LessonReflectionFilesSetInput>;
  where: LessonReflectionFilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionFilesByPkArgs = {
  _set?: InputMaybe<LessonReflectionFilesSetInput>;
  pkColumns: LessonReflectionFilesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionFilesManyArgs = {
  updates: Array<LessonReflectionFilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionsArgs = {
  _set?: InputMaybe<LessonReflectionsSetInput>;
  where: LessonReflectionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionsByPkArgs = {
  _set?: InputMaybe<LessonReflectionsSetInput>;
  pkColumns: LessonReflectionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonReflectionsManyArgs = {
  updates: Array<LessonReflectionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonTemplatesArgs = {
  _inc?: InputMaybe<LessonTemplatesIncInput>;
  _set?: InputMaybe<LessonTemplatesSetInput>;
  where: LessonTemplatesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonTemplatesByPkArgs = {
  _inc?: InputMaybe<LessonTemplatesIncInput>;
  _set?: InputMaybe<LessonTemplatesSetInput>;
  pkColumns: LessonTemplatesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonTemplatesManyArgs = {
  updates: Array<LessonTemplatesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonTimesArgs = {
  _set?: InputMaybe<LessonTimesSetInput>;
  where: LessonTimesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonTimesByPkArgs = {
  _set?: InputMaybe<LessonTimesSetInput>;
  pkColumns: LessonTimesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonTimesManyArgs = {
  updates: Array<LessonTimesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonWaitlistsArgs = {
  _set?: InputMaybe<LessonWaitlistsSetInput>;
  where: LessonWaitlistsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonWaitlistsByPkArgs = {
  _set?: InputMaybe<LessonWaitlistsSetInput>;
  pkColumns: LessonWaitlistsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonWaitlistsManyArgs = {
  updates: Array<LessonWaitlistsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLessonsArgs = {
  _inc?: InputMaybe<LessonsIncInput>;
  _set?: InputMaybe<LessonsSetInput>;
  where: LessonsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLessonsByPkArgs = {
  _inc?: InputMaybe<LessonsIncInput>;
  _set?: InputMaybe<LessonsSetInput>;
  pkColumns: LessonsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLessonsManyArgs = {
  updates: Array<LessonsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionCommentsArgs = {
  _set?: InputMaybe<PlaySessionCommentsSetInput>;
  where: PlaySessionCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionCommentsByPkArgs = {
  _set?: InputMaybe<PlaySessionCommentsSetInput>;
  pkColumns: PlaySessionCommentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionCommentsManyArgs = {
  updates: Array<PlaySessionCommentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionsArgs = {
  _inc?: InputMaybe<PlaySessionsIncInput>;
  _set?: InputMaybe<PlaySessionsSetInput>;
  where: PlaySessionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionsByPkArgs = {
  _inc?: InputMaybe<PlaySessionsIncInput>;
  _set?: InputMaybe<PlaySessionsSetInput>;
  pkColumns: PlaySessionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlaySessionsManyArgs = {
  updates: Array<PlaySessionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilitiesArgs = {
  _inc?: InputMaybe<PlayerAvailabilitiesIncInput>;
  _set?: InputMaybe<PlayerAvailabilitiesSetInput>;
  where: PlayerAvailabilitiesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilitiesByPkArgs = {
  _inc?: InputMaybe<PlayerAvailabilitiesIncInput>;
  _set?: InputMaybe<PlayerAvailabilitiesSetInput>;
  pkColumns: PlayerAvailabilitiesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilitiesManyArgs = {
  updates: Array<PlayerAvailabilitiesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilityRatingScalesArgs = {
  _inc?: InputMaybe<PlayerAvailabilityRatingScalesIncInput>;
  _set?: InputMaybe<PlayerAvailabilityRatingScalesSetInput>;
  where: PlayerAvailabilityRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilityRatingScalesByPkArgs = {
  _inc?: InputMaybe<PlayerAvailabilityRatingScalesIncInput>;
  _set?: InputMaybe<PlayerAvailabilityRatingScalesSetInput>;
  pkColumns: PlayerAvailabilityRatingScalesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePlayerAvailabilityRatingScalesManyArgs = {
  updates: Array<PlayerAvailabilityRatingScalesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserCoachServicesArgs = {
  _inc?: InputMaybe<UserCoachServicesIncInput>;
  _set?: InputMaybe<UserCoachServicesSetInput>;
  where: UserCoachServicesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserCoachServicesByPkArgs = {
  _inc?: InputMaybe<UserCoachServicesIncInput>;
  _set?: InputMaybe<UserCoachServicesSetInput>;
  pkColumns: UserCoachServicesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserCoachServicesManyArgs = {
  updates: Array<UserCoachServicesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserCommunicationPreferencesArgs = {
  _set?: InputMaybe<UserCommunicationPreferencesSetInput>;
  where: UserCommunicationPreferencesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserCommunicationPreferencesByPkArgs = {
  _set?: InputMaybe<UserCommunicationPreferencesSetInput>;
  pkColumns: UserCommunicationPreferencesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserCommunicationPreferencesManyArgs = {
  updates: Array<UserCommunicationPreferencesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserContentFilesArgs = {
  _set?: InputMaybe<UserContentFilesSetInput>;
  where: UserContentFilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserContentFilesByPkArgs = {
  _set?: InputMaybe<UserContentFilesSetInput>;
  pkColumns: UserContentFilesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserContentFilesManyArgs = {
  updates: Array<UserContentFilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserContentSkillsArgs = {
  _set?: InputMaybe<UserContentSkillsSetInput>;
  where: UserContentSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserContentSkillsByPkArgs = {
  _set?: InputMaybe<UserContentSkillsSetInput>;
  pkColumns: UserContentSkillsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserContentSkillsManyArgs = {
  updates: Array<UserContentSkillsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserCustomCourtsArgs = {
  _inc?: InputMaybe<UserCustomCourtsIncInput>;
  _set?: InputMaybe<UserCustomCourtsSetInput>;
  where: UserCustomCourtsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserCustomCourtsByPkArgs = {
  _inc?: InputMaybe<UserCustomCourtsIncInput>;
  _set?: InputMaybe<UserCustomCourtsSetInput>;
  pkColumns: UserCustomCourtsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserCustomCourtsManyArgs = {
  updates: Array<UserCustomCourtsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserFilesArgs = {
  _set?: InputMaybe<UserFilesSetInput>;
  where: UserFilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserFilesByPkArgs = {
  _set?: InputMaybe<UserFilesSetInput>;
  pkColumns: UserFilesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserFilesManyArgs = {
  updates: Array<UserFilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserFollowsArgs = {
  _set?: InputMaybe<UserFollowsSetInput>;
  where: UserFollowsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserFollowsByPkArgs = {
  _set?: InputMaybe<UserFollowsSetInput>;
  pkColumns: UserFollowsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserFollowsManyArgs = {
  updates: Array<UserFollowsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserNotificationsArgs = {
  _set?: InputMaybe<UserNotificationsSetInput>;
  where: UserNotificationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserNotificationsByPkArgs = {
  _set?: InputMaybe<UserNotificationsSetInput>;
  pkColumns: UserNotificationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserNotificationsManyArgs = {
  updates: Array<UserNotificationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserPadelRatingScalesArgs = {
  _inc?: InputMaybe<UserPadelRatingScalesIncInput>;
  _set?: InputMaybe<UserPadelRatingScalesSetInput>;
  where: UserPadelRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserPadelRatingScalesByPkArgs = {
  _inc?: InputMaybe<UserPadelRatingScalesIncInput>;
  _set?: InputMaybe<UserPadelRatingScalesSetInput>;
  pkColumns: UserPadelRatingScalesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserPadelRatingScalesManyArgs = {
  updates: Array<UserPadelRatingScalesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserPickleballRatingScalesArgs = {
  _inc?: InputMaybe<UserPickleballRatingScalesIncInput>;
  _set?: InputMaybe<UserPickleballRatingScalesSetInput>;
  where: UserPickleballRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserPickleballRatingScalesByPkArgs = {
  _inc?: InputMaybe<UserPickleballRatingScalesIncInput>;
  _set?: InputMaybe<UserPickleballRatingScalesSetInput>;
  pkColumns: UserPickleballRatingScalesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserPickleballRatingScalesManyArgs = {
  updates: Array<UserPickleballRatingScalesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserSportsArgs = {
  _set?: InputMaybe<UserSportsSetInput>;
  where: UserSportsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserSportsByPkArgs = {
  _set?: InputMaybe<UserSportsSetInput>;
  pkColumns: UserSportsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserSportsManyArgs = {
  updates: Array<UserSportsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserTennisRatingScalesArgs = {
  _inc?: InputMaybe<UserTennisRatingScalesIncInput>;
  _set?: InputMaybe<UserTennisRatingScalesSetInput>;
  where: UserTennisRatingScalesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserTennisRatingScalesByPkArgs = {
  _inc?: InputMaybe<UserTennisRatingScalesIncInput>;
  _set?: InputMaybe<UserTennisRatingScalesSetInput>;
  pkColumns: UserTennisRatingScalesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserTennisRatingScalesManyArgs = {
  updates: Array<UserTennisRatingScalesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _inc?: InputMaybe<UsersIncInput>;
  _set?: InputMaybe<UsersSetInput>;
  where: UsersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUsersByPkArgs = {
  _inc?: InputMaybe<UsersIncInput>;
  _set?: InputMaybe<UsersSetInput>;
  pkColumns: UsersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUsersCoachQualificationsArgs = {
  _set?: InputMaybe<UsersCoachQualificationsSetInput>;
  where: UsersCoachQualificationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUsersCoachQualificationsByPkArgs = {
  _set?: InputMaybe<UsersCoachQualificationsSetInput>;
  pkColumns: UsersCoachQualificationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUsersCoachQualificationsManyArgs = {
  updates: Array<UsersCoachQualificationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUsersManyArgs = {
  updates: Array<UsersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueFollowsArgs = {
  _set?: InputMaybe<VenueFollowsSetInput>;
  where: VenueFollowsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueFollowsByPkArgs = {
  _set?: InputMaybe<VenueFollowsSetInput>;
  pkColumns: VenueFollowsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueFollowsManyArgs = {
  updates: Array<VenueFollowsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVenueStaffCoachesArgs = {
  _set?: InputMaybe<VenueStaffCoachesSetInput>;
  where: VenueStaffCoachesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVenueStaffCoachesByPkArgs = {
  _set?: InputMaybe<VenueStaffCoachesSetInput>;
  pkColumns: VenueStaffCoachesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVenueStaffCoachesManyArgs = {
  updates: Array<VenueStaffCoachesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisArgs = {
  _set?: InputMaybe<VideoAnalysisSetInput>;
  where: VideoAnalysisBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisByPkArgs = {
  _set?: InputMaybe<VideoAnalysisSetInput>;
  pkColumns: VideoAnalysisPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisCommentsArgs = {
  _inc?: InputMaybe<VideoAnalysisCommentsIncInput>;
  _set?: InputMaybe<VideoAnalysisCommentsSetInput>;
  where: VideoAnalysisCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisCommentsByPkArgs = {
  _inc?: InputMaybe<VideoAnalysisCommentsIncInput>;
  _set?: InputMaybe<VideoAnalysisCommentsSetInput>;
  pkColumns: VideoAnalysisCommentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisCommentsManyArgs = {
  updates: Array<VideoAnalysisCommentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisFilesArgs = {
  _set?: InputMaybe<VideoAnalysisFilesSetInput>;
  where: VideoAnalysisFilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisFilesByPkArgs = {
  _set?: InputMaybe<VideoAnalysisFilesSetInput>;
  pkColumns: VideoAnalysisFilesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisFilesManyArgs = {
  updates: Array<VideoAnalysisFilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisManyArgs = {
  updates: Array<VideoAnalysisUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisSkillsCommentsArgs = {
  _set?: InputMaybe<VideoAnalysisSkillsCommentsSetInput>;
  where: VideoAnalysisSkillsCommentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisSkillsCommentsByPkArgs = {
  _set?: InputMaybe<VideoAnalysisSkillsCommentsSetInput>;
  pkColumns: VideoAnalysisSkillsCommentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisSkillsCommentsManyArgs = {
  updates: Array<VideoAnalysisSkillsCommentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisSubmissionLogArgs = {
  _set?: InputMaybe<VideoAnalysisSubmissionLogSetInput>;
  where: VideoAnalysisSubmissionLogBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisSubmissionLogByPkArgs = {
  _set?: InputMaybe<VideoAnalysisSubmissionLogSetInput>;
  pkColumns: VideoAnalysisSubmissionLogPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoAnalysisSubmissionLogManyArgs = {
  updates: Array<VideoAnalysisSubmissionLogUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVideoLessonSkillsArgs = {
  _set?: InputMaybe<VideoLessonSkillsSetInput>;
  where: VideoLessonSkillsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVideoLessonSkillsByPkArgs = {
  _set?: InputMaybe<VideoLessonSkillsSetInput>;
  pkColumns: VideoLessonSkillsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVideoLessonSkillsManyArgs = {
  updates: Array<VideoLessonSkillsUpdates>;
};

export type PlaySessionCommentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlaySessionCommentsBoolExp>;
  predicate: IntComparisonExp;
};

export type PlaySessionParticipantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlaySessionParticipantsBoolExp>;
  predicate: IntComparisonExp;
};

export type PlaySessionsAggregateBoolExpBool_And = {
  arguments: PlaySessionsSelectColumnPlaySessionsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlaySessionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PlaySessionsAggregateBoolExpBool_Or = {
  arguments: PlaySessionsSelectColumnPlaySessionsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlaySessionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PlaySessionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlaySessionsBoolExp>;
  predicate: IntComparisonExp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "amenities" */
  amenities: Array<Amenities>;
  /** fetch data from the table: "amenities" using primary key columns */
  amenitiesByPk?: Maybe<Amenities>;
  /** fetch data from the table: "app_personas" */
  appPersonas: Array<AppPersonas>;
  /** fetch data from the table: "app_personas" using primary key columns */
  appPersonasByPk?: Maybe<AppPersonas>;
  /** fetch data from the table: "app_pings" */
  appPings: Array<AppPings>;
  /** fetch data from the table: "app_pings" using primary key columns */
  appPingsByPk?: Maybe<AppPings>;
  /** fetch data from the table: "ball_types" */
  ballTypes: Array<BallTypes>;
  /** fetch data from the table: "ball_types" using primary key columns */
  ballTypesByPk?: Maybe<BallTypes>;
  /** fetch data from the table: "birthday_visibility" */
  birthdayVisibility: Array<BirthdayVisibility>;
  /** fetch data from the table: "birthday_visibility" using primary key columns */
  birthdayVisibilityByPk?: Maybe<BirthdayVisibility>;
  /** fetch data from the table: "booking_config_change_types" */
  bookingConfigChangeTypes: Array<BookingConfigChangeTypes>;
  /** fetch data from the table: "booking_config_change_types" using primary key columns */
  bookingConfigChangeTypesByPk?: Maybe<BookingConfigChangeTypes>;
  /** fetch data from the table: "booking_connection_statuses" */
  bookingConnectionStatuses: Array<BookingConnectionStatuses>;
  /** fetch data from the table: "booking_connection_statuses" using primary key columns */
  bookingConnectionStatusesByPk?: Maybe<BookingConnectionStatuses>;
  /** fetch data from the table: "booking_integration_statuses" */
  bookingIntegrationStatuses: Array<BookingIntegrationStatuses>;
  /** fetch data from the table: "booking_integration_statuses" using primary key columns */
  bookingIntegrationStatusesByPk?: Maybe<BookingIntegrationStatuses>;
  /** fetch data from the table: "booking_inventory_types" */
  bookingInventoryTypes: Array<BookingInventoryTypes>;
  /** fetch data from the table: "booking_inventory_types" using primary key columns */
  bookingInventoryTypesByPk?: Maybe<BookingInventoryTypes>;
  /** fetch data from the table: "booking_schedule_modes" */
  bookingScheduleModes: Array<BookingScheduleModes>;
  /** fetch data from the table: "booking_schedule_modes" using primary key columns */
  bookingScheduleModesByPk?: Maybe<BookingScheduleModes>;
  /** fetch data from the table: "booking_systems" */
  bookingSystems: Array<BookingSystems>;
  /** fetch data from the table: "booking_systems" using primary key columns */
  bookingSystemsByPk?: Maybe<BookingSystems>;
  /** fetch data from the table: "booking_window_kinds" */
  bookingWindowKinds: Array<BookingWindowKinds>;
  /** fetch data from the table: "booking_window_kinds" using primary key columns */
  bookingWindowKindsByPk?: Maybe<BookingWindowKinds>;
  /** fetch data from the table: "boost_channels" */
  boostChannels: Array<BoostChannels>;
  /** fetch data from the table: "boost_channels" using primary key columns */
  boostChannelsByPk?: Maybe<BoostChannels>;
  /** fetch data from the table: "boost_statuses" */
  boostStatuses: Array<BoostStatuses>;
  /** fetch data from the table: "boost_statuses" using primary key columns */
  boostStatusesByPk?: Maybe<BoostStatuses>;
  /** fetch data from the table: "boosts" */
  boosts: Array<Boosts>;
  /** fetch data from the table: "boosts" using primary key columns */
  boostsByPk?: Maybe<Boosts>;
  /** fetch data from the table: "bracket_ranking_mechanism" */
  bracketRankingMechanism: Array<BracketRankingMechanism>;
  /** fetch data from the table: "bracket_ranking_mechanism" using primary key columns */
  bracketRankingMechanismByPk?: Maybe<BracketRankingMechanism>;
  /** fetch data from the table: "calendar_accounts" */
  calendarAccounts: Array<CalendarAccounts>;
  /** fetch data from the table: "calendar_accounts" using primary key columns */
  calendarAccountsByPk?: Maybe<CalendarAccounts>;
  /** An array relationship */
  calendarPreferences: Array<CalendarPreferences>;
  /** fetch data from the table: "calendar_preferences" using primary key columns */
  calendarPreferencesByPk?: Maybe<CalendarPreferences>;
  /** An array relationship */
  cities: Array<Cities>;
  /** fetch data from the table: "cities" using primary key columns */
  citiesByPk?: Maybe<Cities>;
  /** An array relationship */
  coachAvailability: Array<CoachAvailability>;
  /** fetch data from the table: "coach_availability" using primary key columns */
  coachAvailabilityByPk?: Maybe<CoachAvailability>;
  /** fetch data from the table: "coach_booking_requests" */
  coachBookingRequests: Array<CoachBookingRequests>;
  /** fetch data from the table: "coach_booking_requests" using primary key columns */
  coachBookingRequestsByPk?: Maybe<CoachBookingRequests>;
  /** An array relationship */
  coachFaqs: Array<CoachFaqs>;
  /** fetch data from the table: "coach_faqs" using primary key columns */
  coachFaqsByPk?: Maybe<CoachFaqs>;
  /** An array relationship */
  coachLessonAgeGroups: Array<CoachLessonAgeGroups>;
  /** fetch data from the table: "coach_lesson_age_groups" using primary key columns */
  coachLessonAgeGroupsByPk?: Maybe<CoachLessonAgeGroups>;
  /** An array relationship */
  coachLessonSkillLevels: Array<CoachLessonSkillLevels>;
  /** fetch data from the table: "coach_lesson_skill_levels" using primary key columns */
  coachLessonSkillLevelsByPk?: Maybe<CoachLessonSkillLevels>;
  /** fetch data from the table: "coach_qualification_groups" */
  coachQualificationGroups: Array<CoachQualificationGroups>;
  /** fetch data from the table: "coach_qualification_groups" using primary key columns */
  coachQualificationGroupsByPk?: Maybe<CoachQualificationGroups>;
  /** fetch data from the table: "coach_qualifications" */
  coachQualifications: Array<CoachQualifications>;
  /** fetch data from the table: "coach_qualifications" using primary key columns */
  coachQualificationsByPk?: Maybe<CoachQualifications>;
  /** fetch data from the table: "coach_sport_statuses" */
  coachSportStatuses: Array<CoachSportStatuses>;
  /** fetch data from the table: "coach_sport_statuses" using primary key columns */
  coachSportStatusesByPk?: Maybe<CoachSportStatuses>;
  /** An array relationship */
  coachSports: Array<CoachSports>;
  /** fetch data from the table: "coach_sports" using primary key columns */
  coachSportsByPk?: Maybe<CoachSports>;
  /** An array relationship */
  coachStarterProfiles: Array<CoachStarterProfiles>;
  /** fetch data from the table: "coach_starter_profiles" using primary key columns */
  coachStarterProfilesByPk?: Maybe<CoachStarterProfiles>;
  /** fetch data from the table: "coach_status" */
  coachStatus: Array<CoachStatus>;
  /** fetch data from the table: "coach_status" using primary key columns */
  coachStatusByPk?: Maybe<CoachStatus>;
  /** fetch data from the table: "comment_vote" */
  commentVote: Array<CommentVote>;
  /** fetch data from the table: "comment_vote" using primary key columns */
  commentVoteByPk?: Maybe<CommentVote>;
  /** fetch data from the table: "communication_preference_statuses" */
  communicationPreferenceStatuses: Array<CommunicationPreferenceStatuses>;
  /** fetch data from the table: "communication_preference_statuses" using primary key columns */
  communicationPreferenceStatusesByPk?: Maybe<CommunicationPreferenceStatuses>;
  /** fetch data from the table: "competition_formats" */
  competitionFormats: Array<CompetitionFormats>;
  /** fetch data from the table: "competition_formats" using primary key columns */
  competitionFormatsByPk?: Maybe<CompetitionFormats>;
  /** fetch data from the table: "competition_gender" */
  competitionGender: Array<CompetitionGender>;
  /** fetch data from the table: "competition_gender" using primary key columns */
  competitionGenderByPk?: Maybe<CompetitionGender>;
  /** fetch data from the table: "content_reports" */
  contentReports: Array<ContentReports>;
  /** fetch data from the table: "content_reports" using primary key columns */
  contentReportsByPk?: Maybe<ContentReports>;
  /** fetch data from the table: "conversation_participants" */
  conversationParticipants: Array<ConversationParticipants>;
  /** fetch data from the table: "conversation_participants" using primary key columns */
  conversationParticipantsByPk?: Maybe<ConversationParticipants>;
  /** fetch data from the table: "conversation_types" */
  conversationTypes: Array<ConversationTypes>;
  /** fetch data from the table: "conversation_types" using primary key columns */
  conversationTypesByPk?: Maybe<ConversationTypes>;
  /** An array relationship */
  conversations: Array<Conversations>;
  /** fetch data from the table: "conversations" using primary key columns */
  conversationsByPk?: Maybe<Conversations>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch data from the table: "countries" using primary key columns */
  countriesByPk?: Maybe<Countries>;
  /** fetch data from the table: "country_subdivisions" */
  countrySubdivisions: Array<CountrySubdivisions>;
  /** fetch data from the table: "country_subdivisions" using primary key columns */
  countrySubdivisionsByPk?: Maybe<CountrySubdivisions>;
  /** fetch data from the table: "court_surfaces" */
  courtSurfaces: Array<CourtSurfaces>;
  /** fetch data from the table: "court_surfaces" using primary key columns */
  courtSurfacesByPk?: Maybe<CourtSurfaces>;
  /** fetch data from the table: "day_of_week" */
  dayOfWeek: Array<DayOfWeek>;
  /** fetch data from the table: "day_of_week" using primary key columns */
  dayOfWeekByPk?: Maybe<DayOfWeek>;
  /** fetch data from the table: "engagement_entity_types" */
  engagementEntityTypes: Array<EngagementEntityTypes>;
  /** fetch data from the table: "engagement_entity_types" using primary key columns */
  engagementEntityTypesByPk?: Maybe<EngagementEntityTypes>;
  /** fetch data from the table: "engagement_event_types" */
  engagementEventTypes: Array<EngagementEventTypes>;
  /** fetch data from the table: "engagement_event_types" using primary key columns */
  engagementEventTypesByPk?: Maybe<EngagementEventTypes>;
  /** fetch data from the table: "engagement_sources" */
  engagementSources: Array<EngagementSources>;
  /** fetch data from the table: "engagement_sources" using primary key columns */
  engagementSourcesByPk?: Maybe<EngagementSources>;
  /** fetch data from the table: "equipment_availabilities" */
  equipmentAvailabilities: Array<EquipmentAvailabilities>;
  /** fetch data from the table: "equipment_availabilities" using primary key columns */
  equipmentAvailabilitiesByPk?: Maybe<EquipmentAvailabilities>;
  /** fetch data from the table: "event_accepted_play_requests" */
  eventAcceptedPlayRequests: Array<EventAcceptedPlayRequests>;
  /** fetch aggregated fields from the table: "event_accepted_play_requests" */
  eventAcceptedPlayRequestsAggregate: EventAcceptedPlayRequestsAggregate;
  /** fetch data from the table: "event_age_groups" */
  eventAgeGroups: Array<EventAgeGroups>;
  /** fetch data from the table: "event_age_groups" using primary key columns */
  eventAgeGroupsByPk?: Maybe<EventAgeGroups>;
  /** fetch data from the table: "event_collections" */
  eventCollections: Array<EventCollections>;
  /** fetch data from the table: "event_collections" using primary key columns */
  eventCollectionsByPk?: Maybe<EventCollections>;
  /** fetch data from the table: "event_competitiveness" */
  eventCompetitiveness: Array<EventCompetitiveness>;
  /** fetch data from the table: "event_competitiveness" using primary key columns */
  eventCompetitivenessByPk?: Maybe<EventCompetitiveness>;
  /** fetch data from the table: "event_contact_details" */
  eventContactDetails: Array<EventContactDetails>;
  /** fetch data from the table: "event_contact_details" using primary key columns */
  eventContactDetailsByPk?: Maybe<EventContactDetails>;
  /** fetch data from the table: "event_coupon_groups" */
  eventCouponGroups: Array<EventCouponGroups>;
  /** fetch data from the table: "event_coupon_groups" using primary key columns */
  eventCouponGroupsByPk?: Maybe<EventCouponGroups>;
  /** fetch data from the table: "event_coupon_redemptions" */
  eventCouponRedemptions: Array<EventCouponRedemptions>;
  /** fetch aggregated fields from the table: "event_coupon_redemptions" */
  eventCouponRedemptionsAggregate: EventCouponRedemptionsAggregate;
  /** fetch data from the table: "event_coupon_redemptions" using primary key columns */
  eventCouponRedemptionsByPk?: Maybe<EventCouponRedemptions>;
  /** fetch data from the table: "event_coupon_source" */
  eventCouponSource: Array<EventCouponSource>;
  /** fetch data from the table: "event_coupon_source" using primary key columns */
  eventCouponSourceByPk?: Maybe<EventCouponSource>;
  /** fetch data from the table: "event_coupon_type" */
  eventCouponType: Array<EventCouponType>;
  /** fetch data from the table: "event_coupon_type" using primary key columns */
  eventCouponTypeByPk?: Maybe<EventCouponType>;
  /** fetch data from the table: "event_coupons" */
  eventCoupons: Array<EventCoupons>;
  /** fetch data from the table: "event_coupons" using primary key columns */
  eventCouponsByPk?: Maybe<EventCoupons>;
  /** fetch data from the table: "event_court_statuses" */
  eventCourtStatuses: Array<EventCourtStatuses>;
  /** fetch data from the table: "event_court_statuses" using primary key columns */
  eventCourtStatusesByPk?: Maybe<EventCourtStatuses>;
  /** fetch data from the table: "event_courts" */
  eventCourts: Array<EventCourts>;
  /** fetch data from the table: "event_courts" using primary key columns */
  eventCourtsByPk?: Maybe<EventCourts>;
  /** fetch data from the table: "event_faqs" */
  eventFaqs: Array<EventFaqs>;
  /** fetch data from the table: "event_faqs" using primary key columns */
  eventFaqsByPk?: Maybe<EventFaqs>;
  /** fetch data from the table: "event_game_scores" */
  eventGameScores: Array<EventGameScores>;
  /** fetch data from the table: "event_game_scores" using primary key columns */
  eventGameScoresByPk?: Maybe<EventGameScores>;
  /** fetch data from the table: "event_group_formats" */
  eventGroupFormats: Array<EventGroupFormats>;
  /** fetch data from the table: "event_group_formats" using primary key columns */
  eventGroupFormatsByPk?: Maybe<EventGroupFormats>;
  /** fetch data from the table: "event_group_merges" */
  eventGroupMerges: Array<EventGroupMerges>;
  /** fetch data from the table: "event_group_merges" using primary key columns */
  eventGroupMergesByPk?: Maybe<EventGroupMerges>;
  /** fetch data from the table: "event_group_pools" */
  eventGroupPools: Array<EventGroupPools>;
  /** fetch data from the table: "event_group_pools" using primary key columns */
  eventGroupPoolsByPk?: Maybe<EventGroupPools>;
  /** fetch data from the table: "event_group_rating_scales" */
  eventGroupRatingScales: Array<EventGroupRatingScales>;
  /** fetch data from the table: "event_group_rating_scales" using primary key columns */
  eventGroupRatingScalesByPk?: Maybe<EventGroupRatingScales>;
  /** fetch data from the table: "event_group_registration_statuses" */
  eventGroupRegistrationStatuses: Array<EventGroupRegistrationStatuses>;
  /** fetch data from the table: "event_group_registration_statuses" using primary key columns */
  eventGroupRegistrationStatusesByPk?: Maybe<EventGroupRegistrationStatuses>;
  /** fetch data from the table: "event_group_registrations" */
  eventGroupRegistrations: Array<EventGroupRegistrations>;
  /** fetch data from the table: "event_group_registrations" using primary key columns */
  eventGroupRegistrationsByPk?: Maybe<EventGroupRegistrations>;
  /** fetch data from the table: "event_group_sequence_seeding" */
  eventGroupSequenceSeeding: Array<EventGroupSequenceSeeding>;
  /** fetch data from the table: "event_group_sequence_seeding" using primary key columns */
  eventGroupSequenceSeedingByPk?: Maybe<EventGroupSequenceSeeding>;
  /** fetch data from the table: "event_group_sequences" */
  eventGroupSequences: Array<EventGroupSequences>;
  /** fetch data from the table: "event_group_sequences" using primary key columns */
  eventGroupSequencesByPk?: Maybe<EventGroupSequences>;
  /** fetch data from the table: "event_group_time_slots" */
  eventGroupTimeSlots: Array<EventGroupTimeSlots>;
  /** fetch data from the table: "event_group_time_slots" using primary key columns */
  eventGroupTimeSlotsByPk?: Maybe<EventGroupTimeSlots>;
  /** fetch data from the table: "event_groups" */
  eventGroups: Array<EventGroups>;
  /** fetch data from the table: "event_groups" using primary key columns */
  eventGroupsByPk?: Maybe<EventGroups>;
  /** fetch data from the table: "event_invitation_statuses" */
  eventInvitationStatuses: Array<EventInvitationStatuses>;
  /** fetch data from the table: "event_invitation_statuses" using primary key columns */
  eventInvitationStatusesByPk?: Maybe<EventInvitationStatuses>;
  /** fetch data from the table: "event_invitation_types" */
  eventInvitationTypes: Array<EventInvitationTypes>;
  /** fetch data from the table: "event_invitation_types" using primary key columns */
  eventInvitationTypesByPk?: Maybe<EventInvitationTypes>;
  /** fetch data from the table: "event_invitations" */
  eventInvitations: Array<EventInvitations>;
  /** fetch data from the table: "event_invitations" using primary key columns */
  eventInvitationsByPk?: Maybe<EventInvitations>;
  /** fetch data from the table: "event_listing_fees" */
  eventListingFees: Array<EventListingFees>;
  /** fetch data from the table: "event_listing_fees" using primary key columns */
  eventListingFeesByPk?: Maybe<EventListingFees>;
  /** fetch data from the table: "event_match_games" */
  eventMatchGames: Array<EventMatchGames>;
  /** fetch data from the table: "event_match_games" using primary key columns */
  eventMatchGamesByPk?: Maybe<EventMatchGames>;
  /** fetch data from the table: "event_matches" */
  eventMatches: Array<EventMatches>;
  /** fetch data from the table: "event_matches" using primary key columns */
  eventMatchesByPk?: Maybe<EventMatches>;
  /** fetch data from the table: "event_matches_teams" */
  eventMatchesTeams: Array<EventMatchesTeams>;
  /** fetch data from the table: "event_matches_teams" using primary key columns */
  eventMatchesTeamsByPk?: Maybe<EventMatchesTeams>;
  /** fetch data from the table: "event_organizer_account_types" */
  eventOrganizerAccountTypes: Array<EventOrganizerAccountTypes>;
  /** fetch data from the table: "event_organizer_account_types" using primary key columns */
  eventOrganizerAccountTypesByPk?: Maybe<EventOrganizerAccountTypes>;
  /** fetch data from the table: "event_player_invite_statuses" */
  eventPlayerInviteStatuses: Array<EventPlayerInviteStatuses>;
  /** fetch data from the table: "event_player_invite_statuses" using primary key columns */
  eventPlayerInviteStatusesByPk?: Maybe<EventPlayerInviteStatuses>;
  /** fetch data from the table: "event_player_invites" */
  eventPlayerInvites: Array<EventPlayerInvites>;
  /** fetch aggregated fields from the table: "event_player_invites" */
  eventPlayerInvitesAggregate: EventPlayerInvitesAggregate;
  /** fetch data from the table: "event_player_invites" using primary key columns */
  eventPlayerInvitesByPk?: Maybe<EventPlayerInvites>;
  /** fetch data from the table: "event_pool_rounds" */
  eventPoolRounds: Array<EventPoolRounds>;
  /** fetch data from the table: "event_pool_rounds" using primary key columns */
  eventPoolRoundsByPk?: Maybe<EventPoolRounds>;
  /** fetch data from the table: "event_pools_teams" */
  eventPoolsTeams: Array<EventPoolsTeams>;
  /** fetch data from the table: "event_pools_teams" using primary key columns */
  eventPoolsTeamsByPk?: Maybe<EventPoolsTeams>;
  /** fetch data from the table: "event_privacy" */
  eventPrivacy: Array<EventPrivacy>;
  /** fetch data from the table: "event_privacy" using primary key columns */
  eventPrivacyByPk?: Maybe<EventPrivacy>;
  /** fetch data from the table: "event_registration_details" */
  eventRegistrationDetails: Array<EventRegistrationDetails>;
  /** fetch data from the table: "event_registration_details" using primary key columns */
  eventRegistrationDetailsByPk?: Maybe<EventRegistrationDetails>;
  /** fetch data from the table: "event_registrations" */
  eventRegistrations: Array<EventRegistrations>;
  /** fetch aggregated fields from the table: "event_registrations" */
  eventRegistrationsAggregate: EventRegistrationsAggregate;
  /** fetch data from the table: "event_registrations" using primary key columns */
  eventRegistrationsByPk?: Maybe<EventRegistrations>;
  /** fetch data from the table: "event_sequence_complete_reasons" */
  eventSequenceCompleteReasons: Array<EventSequenceCompleteReasons>;
  /** fetch data from the table: "event_sequence_complete_reasons" using primary key columns */
  eventSequenceCompleteReasonsByPk?: Maybe<EventSequenceCompleteReasons>;
  /** fetch data from the table: "event_skill_levels" */
  eventSkillLevels: Array<EventSkillLevels>;
  /** fetch data from the table: "event_skill_levels" using primary key columns */
  eventSkillLevelsByPk?: Maybe<EventSkillLevels>;
  /** fetch data from the table: "event_sponsors" */
  eventSponsors: Array<EventSponsors>;
  /** fetch data from the table: "event_sponsors" using primary key columns */
  eventSponsorsByPk?: Maybe<EventSponsors>;
  /** fetch data from the table: "event_statuses" */
  eventStatuses: Array<EventStatuses>;
  /** fetch data from the table: "event_statuses" using primary key columns */
  eventStatusesByPk?: Maybe<EventStatuses>;
  /** fetch data from the table: "event_team_member_statuses" */
  eventTeamMemberStatuses: Array<EventTeamMemberStatuses>;
  /** fetch data from the table: "event_team_member_statuses" using primary key columns */
  eventTeamMemberStatusesByPk?: Maybe<EventTeamMemberStatuses>;
  /** fetch data from the table: "event_team_members" */
  eventTeamMembers: Array<EventTeamMembers>;
  /** fetch data from the table: "event_team_members" using primary key columns */
  eventTeamMembersByPk?: Maybe<EventTeamMembers>;
  /** fetch data from the table: "event_team_statuses" */
  eventTeamStatuses: Array<EventTeamStatuses>;
  /** fetch data from the table: "event_team_statuses" using primary key columns */
  eventTeamStatusesByPk?: Maybe<EventTeamStatuses>;
  /** fetch data from the table: "event_teams" */
  eventTeams: Array<EventTeams>;
  /** fetch data from the table: "event_teams" using primary key columns */
  eventTeamsByPk?: Maybe<EventTeams>;
  /** fetch data from the table: "event_transaction_item_types" */
  eventTransactionItemTypes: Array<EventTransactionItemTypes>;
  /** fetch data from the table: "event_transaction_item_types" using primary key columns */
  eventTransactionItemTypesByPk?: Maybe<EventTransactionItemTypes>;
  /** fetch data from the table: "event_transaction_items" */
  eventTransactionItems: Array<EventTransactionItems>;
  /** fetch data from the table: "event_transaction_items" using primary key columns */
  eventTransactionItemsByPk?: Maybe<EventTransactionItems>;
  /** fetch data from the table: "event_transactions" */
  eventTransactions: Array<EventTransactions>;
  /** fetch data from the table: "event_transactions" using primary key columns */
  eventTransactionsByPk?: Maybe<EventTransactions>;
  /** fetch data from the table: "event_types" */
  eventTypes: Array<EventTypes>;
  /** fetch data from the table: "event_types" using primary key columns */
  eventTypesByPk?: Maybe<EventTypes>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  eventsAggregate: EventsAggregate;
  /** fetch data from the table: "events" using primary key columns */
  eventsByPk?: Maybe<Events>;
  /** fetch data from the table: "file_category" */
  fileCategory: Array<FileCategory>;
  /** fetch data from the table: "file_category" using primary key columns */
  fileCategoryByPk?: Maybe<FileCategory>;
  /** fetch data from the table: "file_format" */
  fileFormat: Array<FileFormat>;
  /** fetch data from the table: "file_format" using primary key columns */
  fileFormatByPk?: Maybe<FileFormat>;
  /** fetch data from the table: "game_net_statuses" */
  gameNetStatuses: Array<GameNetStatuses>;
  /** fetch data from the table: "game_net_statuses" using primary key columns */
  gameNetStatusesByPk?: Maybe<GameNetStatuses>;
  /** fetch data from the table: "gender" */
  gender: Array<Gender>;
  /** fetch data from the table: "gender" using primary key columns */
  genderByPk?: Maybe<Gender>;
  /** fetch data from the table: "group_comment_votes" */
  groupCommentVotes: Array<GroupCommentVotes>;
  /** fetch aggregated fields from the table: "group_comment_votes" */
  groupCommentVotesAggregate: GroupCommentVotesAggregate;
  /** fetch data from the table: "group_comment_votes" using primary key columns */
  groupCommentVotesByPk?: Maybe<GroupCommentVotes>;
  /** fetch data from the table: "group_members" */
  groupMembers: Array<GroupMembers>;
  /** fetch aggregated fields from the table: "group_members" */
  groupMembersAggregate: GroupMembersAggregate;
  /** fetch data from the table: "group_members" using primary key columns */
  groupMembersByPk?: Maybe<GroupMembers>;
  /** fetch data from the table: "group_thread_comment_files" */
  groupThreadCommentFiles: Array<GroupThreadCommentFiles>;
  /** fetch data from the table: "group_thread_comment_files" using primary key columns */
  groupThreadCommentFilesByPk?: Maybe<GroupThreadCommentFiles>;
  /** fetch data from the table: "group_thread_comments" */
  groupThreadComments: Array<GroupThreadComments>;
  /** fetch aggregated fields from the table: "group_thread_comments" */
  groupThreadCommentsAggregate: GroupThreadCommentsAggregate;
  /** fetch data from the table: "group_thread_comments" using primary key columns */
  groupThreadCommentsByPk?: Maybe<GroupThreadComments>;
  /** fetch data from the table: "group_threads" */
  groupThreads: Array<GroupThreads>;
  /** fetch data from the table: "group_threads" using primary key columns */
  groupThreadsByPk?: Maybe<GroupThreads>;
  /** fetch data from the table: "group_types" */
  groupTypes: Array<GroupTypes>;
  /** fetch data from the table: "group_types" using primary key columns */
  groupTypesByPk?: Maybe<GroupTypes>;
  /** fetch data from the table: "group_venues" */
  groupVenues: Array<GroupVenues>;
  /** fetch aggregated fields from the table: "group_venues" */
  groupVenuesAggregate: GroupVenuesAggregate;
  /** fetch data from the table: "group_venues" using primary key columns */
  groupVenuesByPk?: Maybe<GroupVenues>;
  /** An array relationship */
  groups: Array<Groups>;
  /** fetch data from the table: "groups" using primary key columns */
  groupsByPk?: Maybe<Groups>;
  /** An array relationship */
  groupsPlaySessions: Array<GroupsPlaySessions>;
  /** fetch data from the table: "groups_play_sessions" using primary key columns */
  groupsPlaySessionsByPk?: Maybe<GroupsPlaySessions>;
  /** fetch data from the table: "identity_verification_providers" */
  identityVerificationProviders: Array<IdentityVerificationProviders>;
  /** fetch data from the table: "identity_verification_providers" using primary key columns */
  identityVerificationProvidersByPk?: Maybe<IdentityVerificationProviders>;
  /** fetch data from the table: "identity_verification_statuses" */
  identityVerificationStatuses: Array<IdentityVerificationStatuses>;
  /** fetch data from the table: "identity_verification_statuses" using primary key columns */
  identityVerificationStatusesByPk?: Maybe<IdentityVerificationStatuses>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** fetch data from the table: "invoices" using primary key columns */
  invoicesByPk?: Maybe<Invoices>;
  /** fetch data from the table: "learning_program_enrollment_schedule_media_watched" */
  learningProgramEnrollmentScheduleMediaWatched: Array<LearningProgramEnrollmentScheduleMediaWatched>;
  /** fetch data from the table: "learning_program_enrollment_schedule_media_watched" using primary key columns */
  learningProgramEnrollmentScheduleMediaWatchedByPk?: Maybe<LearningProgramEnrollmentScheduleMediaWatched>;
  /** fetch data from the table: "learning_program_enrollment_schedule_progress" */
  learningProgramEnrollmentScheduleProgress: Array<LearningProgramEnrollmentScheduleProgress>;
  /** fetch data from the table: "learning_program_enrollment_schedule_progress" using primary key columns */
  learningProgramEnrollmentScheduleProgressByPk?: Maybe<LearningProgramEnrollmentScheduleProgress>;
  /** fetch data from the table: "learning_program_enrollments" */
  learningProgramEnrollments: Array<LearningProgramEnrollments>;
  /** fetch data from the table: "learning_program_enrollments" using primary key columns */
  learningProgramEnrollmentsByPk?: Maybe<LearningProgramEnrollments>;
  /** fetch data from the table: "learning_program_media" */
  learningProgramMedia: Array<LearningProgramMedia>;
  /** fetch data from the table: "learning_program_media" using primary key columns */
  learningProgramMediaByPk?: Maybe<LearningProgramMedia>;
  /** fetch data from the table: "learning_program_media_categories" */
  learningProgramMediaCategories: Array<LearningProgramMediaCategories>;
  /** fetch data from the table: "learning_program_media_categories" using primary key columns */
  learningProgramMediaCategoriesByPk?: Maybe<LearningProgramMediaCategories>;
  /** fetch data from the table: "learning_program_schedule_media" */
  learningProgramScheduleMedia: Array<LearningProgramScheduleMedia>;
  /** fetch data from the table: "learning_program_schedule_media" using primary key columns */
  learningProgramScheduleMediaByPk?: Maybe<LearningProgramScheduleMedia>;
  /** fetch data from the table: "learning_program_schedule_units" */
  learningProgramScheduleUnits: Array<LearningProgramScheduleUnits>;
  /** fetch data from the table: "learning_program_schedule_units" using primary key columns */
  learningProgramScheduleUnitsByPk?: Maybe<LearningProgramScheduleUnits>;
  /** fetch data from the table: "learning_program_schedule_video_submissions" */
  learningProgramScheduleVideoSubmissions: Array<LearningProgramScheduleVideoSubmissions>;
  /** fetch data from the table: "learning_program_schedule_video_submissions" using primary key columns */
  learningProgramScheduleVideoSubmissionsByPk?: Maybe<LearningProgramScheduleVideoSubmissions>;
  /** fetch data from the table: "learning_program_schedules" */
  learningProgramSchedules: Array<LearningProgramSchedules>;
  /** fetch data from the table: "learning_program_schedules" using primary key columns */
  learningProgramSchedulesByPk?: Maybe<LearningProgramSchedules>;
  /** fetch data from the table: "learning_program_skill_level_values" */
  learningProgramSkillLevelValues: Array<LearningProgramSkillLevelValues>;
  /** fetch data from the table: "learning_program_skill_level_values" using primary key columns */
  learningProgramSkillLevelValuesByPk?: Maybe<LearningProgramSkillLevelValues>;
  /** fetch data from the table: "learning_program_skills" */
  learningProgramSkills: Array<LearningProgramSkills>;
  /** fetch data from the table: "learning_program_skills" using primary key columns */
  learningProgramSkillsByPk?: Maybe<LearningProgramSkills>;
  /** fetch data from the table: "learning_programs" */
  learningPrograms: Array<LearningPrograms>;
  /** fetch aggregated fields from the table: "learning_programs" */
  learningProgramsAggregate: LearningProgramsAggregate;
  /** fetch data from the table: "learning_programs" using primary key columns */
  learningProgramsByPk?: Maybe<LearningPrograms>;
  /** fetch data from the table: "lesson_age_groups" */
  lessonAgeGroups: Array<LessonAgeGroups>;
  /** fetch data from the table: "lesson_age_groups" using primary key columns */
  lessonAgeGroupsByPk?: Maybe<LessonAgeGroups>;
  /** fetch data from the table: "lesson_collections" */
  lessonCollections: Array<LessonCollections>;
  /** fetch data from the table: "lesson_collections" using primary key columns */
  lessonCollectionsByPk?: Maybe<LessonCollections>;
  /** fetch data from the table: "lesson_equipment" */
  lessonEquipment: Array<LessonEquipment>;
  /** fetch data from the table: "lesson_equipment" using primary key columns */
  lessonEquipmentByPk?: Maybe<LessonEquipment>;
  /** fetch data from the table: "lesson_equipment_options" */
  lessonEquipmentOptions: Array<LessonEquipmentOptions>;
  /** fetch data from the table: "lesson_equipment_options" using primary key columns */
  lessonEquipmentOptionsByPk?: Maybe<LessonEquipmentOptions>;
  /** fetch data from the table: "lesson_order_items" */
  lessonOrderItems: Array<LessonOrderItems>;
  /** fetch data from the table: "lesson_order_items" using primary key columns */
  lessonOrderItemsByPk?: Maybe<LessonOrderItems>;
  /** fetch data from the table: "lesson_orders" */
  lessonOrders: Array<LessonOrders>;
  /** fetch aggregated fields from the table: "lesson_orders" */
  lessonOrdersAggregate: LessonOrdersAggregate;
  /** fetch data from the table: "lesson_orders" using primary key columns */
  lessonOrdersByPk?: Maybe<LessonOrders>;
  /** fetch data from the table: "lesson_participant_statuses" */
  lessonParticipantStatuses: Array<LessonParticipantStatuses>;
  /** fetch data from the table: "lesson_participant_statuses" using primary key columns */
  lessonParticipantStatusesByPk?: Maybe<LessonParticipantStatuses>;
  /** fetch data from the table: "lesson_participants" */
  lessonParticipants: Array<LessonParticipants>;
  /** fetch aggregated fields from the table: "lesson_participants" */
  lessonParticipantsAggregate: LessonParticipantsAggregate;
  /** fetch data from the table: "lesson_participants" using primary key columns */
  lessonParticipantsByPk?: Maybe<LessonParticipants>;
  /** An array relationship */
  lessonPlayerSkillAssessments: Array<LessonPlayerSkillAssessments>;
  /** fetch data from the table: "lesson_player_skill_assessments" using primary key columns */
  lessonPlayerSkillAssessmentsByPk?: Maybe<LessonPlayerSkillAssessments>;
  /** An array relationship */
  lessonPlayerSkillAssessmentsSkills: Array<LessonPlayerSkillAssessmentsSkills>;
  /** fetch data from the table: "lesson_player_skill_assessments_skills" using primary key columns */
  lessonPlayerSkillAssessmentsSkillsByPk?: Maybe<LessonPlayerSkillAssessmentsSkills>;
  /** fetch data from the table: "lesson_privacy" */
  lessonPrivacy: Array<LessonPrivacy>;
  /** fetch data from the table: "lesson_privacy" using primary key columns */
  lessonPrivacyByPk?: Maybe<LessonPrivacy>;
  /** fetch data from the table: "lesson_reflection_comment_types" */
  lessonReflectionCommentTypes: Array<LessonReflectionCommentTypes>;
  /** fetch data from the table: "lesson_reflection_comment_types" using primary key columns */
  lessonReflectionCommentTypesByPk?: Maybe<LessonReflectionCommentTypes>;
  /** An array relationship */
  lessonReflectionComments: Array<LessonReflectionComments>;
  /** fetch data from the table: "lesson_reflection_comments" using primary key columns */
  lessonReflectionCommentsByPk?: Maybe<LessonReflectionComments>;
  /** An array relationship */
  lessonReflectionFiles: Array<LessonReflectionFiles>;
  /** fetch data from the table: "lesson_reflection_files" using primary key columns */
  lessonReflectionFilesByPk?: Maybe<LessonReflectionFiles>;
  /** An array relationship */
  lessonReflections: Array<LessonReflections>;
  /** fetch data from the table: "lesson_reflections" using primary key columns */
  lessonReflectionsByPk?: Maybe<LessonReflections>;
  /** fetch data from the table: "lesson_skill_display_names" */
  lessonSkillDisplayNames: Array<LessonSkillDisplayNames>;
  /** fetch data from the table: "lesson_skill_display_names" using primary key columns */
  lessonSkillDisplayNamesByPk?: Maybe<LessonSkillDisplayNames>;
  /** fetch data from the table: "lesson_skill_levels" */
  lessonSkillLevels: Array<LessonSkillLevels>;
  /** fetch data from the table: "lesson_skill_levels" using primary key columns */
  lessonSkillLevelsByPk?: Maybe<LessonSkillLevels>;
  /** fetch data from the table: "lesson_skill_mappings" */
  lessonSkillMappings: Array<LessonSkillMappings>;
  /** fetch data from the table: "lesson_skill_mappings" using primary key columns */
  lessonSkillMappingsByPk?: Maybe<LessonSkillMappings>;
  /** fetch data from the table: "lesson_skills" */
  lessonSkills: Array<LessonSkills>;
  /** fetch data from the table: "lesson_skills" using primary key columns */
  lessonSkillsByPk?: Maybe<LessonSkills>;
  /** fetch data from the table: "lesson_statuses" */
  lessonStatuses: Array<LessonStatuses>;
  /** fetch data from the table: "lesson_statuses" using primary key columns */
  lessonStatusesByPk?: Maybe<LessonStatuses>;
  /** fetch data from the table: "lesson_template_skill_levels" */
  lessonTemplateSkillLevels: Array<LessonTemplateSkillLevels>;
  /** fetch data from the table: "lesson_template_skill_levels" using primary key columns */
  lessonTemplateSkillLevelsByPk?: Maybe<LessonTemplateSkillLevels>;
  /** An array relationship */
  lessonTemplates: Array<LessonTemplates>;
  /** fetch data from the table: "lesson_templates" using primary key columns */
  lessonTemplatesByPk?: Maybe<LessonTemplates>;
  /** fetch data from the table: "lesson_times" */
  lessonTimes: Array<LessonTimes>;
  /** fetch data from the table: "lesson_times" using primary key columns */
  lessonTimesByPk?: Maybe<LessonTimes>;
  /** fetch data from the table: "lesson_types" */
  lessonTypes: Array<LessonTypes>;
  /** fetch data from the table: "lesson_types" using primary key columns */
  lessonTypesByPk?: Maybe<LessonTypes>;
  /** fetch data from the table: "lesson_waitlist_statuses" */
  lessonWaitlistStatuses: Array<LessonWaitlistStatuses>;
  /** fetch data from the table: "lesson_waitlist_statuses" using primary key columns */
  lessonWaitlistStatusesByPk?: Maybe<LessonWaitlistStatuses>;
  /** fetch data from the table: "lesson_waitlists" */
  lessonWaitlists: Array<LessonWaitlists>;
  /** fetch aggregated fields from the table: "lesson_waitlists" */
  lessonWaitlistsAggregate: LessonWaitlistsAggregate;
  /** fetch data from the table: "lesson_waitlists" using primary key columns */
  lessonWaitlistsByPk?: Maybe<LessonWaitlists>;
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An aggregate relationship */
  lessonsAggregate: LessonsAggregate;
  /** fetch data from the table: "lessons" using primary key columns */
  lessonsByPk?: Maybe<Lessons>;
  /** fetch data from the table: "match_selection_criteria" */
  matchSelectionCriteria: Array<MatchSelectionCriteria>;
  /** fetch data from the table: "match_selection_criteria" using primary key columns */
  matchSelectionCriteriaByPk?: Maybe<MatchSelectionCriteria>;
  /** An array relationship */
  messages: Array<Messages>;
  /** fetch data from the table: "messages" using primary key columns */
  messagesByPk?: Maybe<Messages>;
  /** fetch data from the table: "neighborhoods" */
  neighborhoods: Array<Neighborhoods>;
  /** fetch data from the table: "neighborhoods" using primary key columns */
  neighborhoodsByPk?: Maybe<Neighborhoods>;
  /** fetch data from the table: "padel_rating_scales" */
  padelRatingScales: Array<PadelRatingScales>;
  /** fetch data from the table: "padel_rating_scales" using primary key columns */
  padelRatingScalesByPk?: Maybe<PadelRatingScales>;
  /** fetch data from the table: "participant_roles" */
  participantRoles: Array<ParticipantRoles>;
  /** fetch data from the table: "participant_roles" using primary key columns */
  participantRolesByPk?: Maybe<ParticipantRoles>;
  /** fetch data from the table: "partner_booking_order_statuses" */
  partnerBookingOrderStatuses: Array<PartnerBookingOrderStatuses>;
  /** fetch data from the table: "partner_booking_order_statuses" using primary key columns */
  partnerBookingOrderStatusesByPk?: Maybe<PartnerBookingOrderStatuses>;
  /** fetch data from the table: "partner_booking_orders" */
  partnerBookingOrders: Array<PartnerBookingOrders>;
  /** fetch data from the table: "partner_booking_orders" using primary key columns */
  partnerBookingOrdersByPk?: Maybe<PartnerBookingOrders>;
  /** fetch data from the table: "payment_fulfillment_channels" */
  paymentFulfillmentChannels: Array<PaymentFulfillmentChannels>;
  /** fetch data from the table: "payment_fulfillment_channels" using primary key columns */
  paymentFulfillmentChannelsByPk?: Maybe<PaymentFulfillmentChannels>;
  /** fetch data from the table: "pickleball_rating_scales" */
  pickleballRatingScales: Array<PickleballRatingScales>;
  /** fetch data from the table: "pickleball_rating_scales" using primary key columns */
  pickleballRatingScalesByPk?: Maybe<PickleballRatingScales>;
  /** fetch data from the table: "platform_subscription_intervals" */
  platformSubscriptionIntervals: Array<PlatformSubscriptionIntervals>;
  /** fetch data from the table: "platform_subscription_intervals" using primary key columns */
  platformSubscriptionIntervalsByPk?: Maybe<PlatformSubscriptionIntervals>;
  /** fetch data from the table: "platform_subscription_personas" */
  platformSubscriptionPersonas: Array<PlatformSubscriptionPersonas>;
  /** fetch data from the table: "platform_subscription_personas" using primary key columns */
  platformSubscriptionPersonasByPk?: Maybe<PlatformSubscriptionPersonas>;
  /** fetch data from the table: "platform_subscription_plan_prices" */
  platformSubscriptionPlanPrices: Array<PlatformSubscriptionPlanPrices>;
  /** fetch data from the table: "platform_subscription_plan_prices" using primary key columns */
  platformSubscriptionPlanPricesByPk?: Maybe<PlatformSubscriptionPlanPrices>;
  /** fetch data from the table: "platform_subscription_plans" */
  platformSubscriptionPlans: Array<PlatformSubscriptionPlans>;
  /** fetch data from the table: "platform_subscription_plans" using primary key columns */
  platformSubscriptionPlansByPk?: Maybe<PlatformSubscriptionPlans>;
  /** An array relationship */
  platformSubscriptions: Array<PlatformSubscriptions>;
  /** fetch data from the table: "platform_subscriptions" using primary key columns */
  platformSubscriptionsByPk?: Maybe<PlatformSubscriptions>;
  /** fetch data from the table: "play_request_neighborhoods" */
  playRequestNeighborhoods: Array<PlayRequestNeighborhoods>;
  /** fetch data from the table: "play_request_neighborhoods" using primary key columns */
  playRequestNeighborhoodsByPk?: Maybe<PlayRequestNeighborhoods>;
  /** fetch data from the table: "play_request_slots" */
  playRequestSlots: Array<PlayRequestSlots>;
  /** fetch data from the table: "play_request_slots" using primary key columns */
  playRequestSlotsByPk?: Maybe<PlayRequestSlots>;
  /** fetch data from the table: "play_request_statuses" */
  playRequestStatuses: Array<PlayRequestStatuses>;
  /** fetch data from the table: "play_request_statuses" using primary key columns */
  playRequestStatusesByPk?: Maybe<PlayRequestStatuses>;
  /** fetch data from the table: "play_request_venues" */
  playRequestVenues: Array<PlayRequestVenues>;
  /** fetch data from the table: "play_request_venues" using primary key columns */
  playRequestVenuesByPk?: Maybe<PlayRequestVenues>;
  /** An array relationship */
  playRequests: Array<PlayRequests>;
  /** fetch data from the table: "play_requests" using primary key columns */
  playRequestsByPk?: Maybe<PlayRequests>;
  /** fetch data from the table: "play_session_comments" */
  playSessionComments: Array<PlaySessionComments>;
  /** fetch aggregated fields from the table: "play_session_comments" */
  playSessionCommentsAggregate: PlaySessionCommentsAggregate;
  /** fetch data from the table: "play_session_comments" using primary key columns */
  playSessionCommentsByPk?: Maybe<PlaySessionComments>;
  /** fetch data from the table: "play_session_court_booking_statuses" */
  playSessionCourtBookingStatuses: Array<PlaySessionCourtBookingStatuses>;
  /** fetch data from the table: "play_session_court_booking_statuses" using primary key columns */
  playSessionCourtBookingStatusesByPk?: Maybe<PlaySessionCourtBookingStatuses>;
  /** fetch data from the table: "play_session_formats" */
  playSessionFormats: Array<PlaySessionFormats>;
  /** fetch data from the table: "play_session_formats" using primary key columns */
  playSessionFormatsByPk?: Maybe<PlaySessionFormats>;
  /** fetch data from the table: "play_session_match_competitiveness" */
  playSessionMatchCompetitiveness: Array<PlaySessionMatchCompetitiveness>;
  /** fetch data from the table: "play_session_match_competitiveness" using primary key columns */
  playSessionMatchCompetitivenessByPk?: Maybe<PlaySessionMatchCompetitiveness>;
  /** fetch data from the table: "play_session_participant_statuses" */
  playSessionParticipantStatuses: Array<PlaySessionParticipantStatuses>;
  /** fetch data from the table: "play_session_participant_statuses" using primary key columns */
  playSessionParticipantStatusesByPk?: Maybe<PlaySessionParticipantStatuses>;
  /** fetch data from the table: "play_session_participants" */
  playSessionParticipants: Array<PlaySessionParticipants>;
  /** fetch aggregated fields from the table: "play_session_participants" */
  playSessionParticipantsAggregate: PlaySessionParticipantsAggregate;
  /** fetch data from the table: "play_session_participants" using primary key columns */
  playSessionParticipantsByPk?: Maybe<PlaySessionParticipants>;
  /** fetch data from the table: "play_session_privacy" */
  playSessionPrivacy: Array<PlaySessionPrivacy>;
  /** fetch data from the table: "play_session_privacy" using primary key columns */
  playSessionPrivacyByPk?: Maybe<PlaySessionPrivacy>;
  /** fetch data from the table: "play_session_statuses" */
  playSessionStatuses: Array<PlaySessionStatuses>;
  /** fetch data from the table: "play_session_statuses" using primary key columns */
  playSessionStatusesByPk?: Maybe<PlaySessionStatuses>;
  /** An array relationship */
  playSessions: Array<PlaySessions>;
  /** An aggregate relationship */
  playSessionsAggregate: PlaySessionsAggregate;
  /** fetch data from the table: "play_sessions" using primary key columns */
  playSessionsByPk?: Maybe<PlaySessions>;
  /** fetch data from the table: "player_availabilities" */
  playerAvailabilities: Array<PlayerAvailabilities>;
  /** fetch aggregated fields from the table: "player_availabilities" */
  playerAvailabilitiesAggregate: PlayerAvailabilitiesAggregate;
  /** fetch data from the table: "player_availabilities" using primary key columns */
  playerAvailabilitiesByPk?: Maybe<PlayerAvailabilities>;
  /** fetch data from the table: "player_availability_neighborhoods" */
  playerAvailabilityNeighborhoods: Array<PlayerAvailabilityNeighborhoods>;
  /** fetch data from the table: "player_availability_neighborhoods" using primary key columns */
  playerAvailabilityNeighborhoodsByPk?: Maybe<PlayerAvailabilityNeighborhoods>;
  /** fetch data from the table: "player_availability_rating_scales" */
  playerAvailabilityRatingScales: Array<PlayerAvailabilityRatingScales>;
  /** fetch data from the table: "player_availability_rating_scales" using primary key columns */
  playerAvailabilityRatingScalesByPk?: Maybe<PlayerAvailabilityRatingScales>;
  /** fetch data from the table: "player_availability_slots" */
  playerAvailabilitySlots: Array<PlayerAvailabilitySlots>;
  /** fetch data from the table: "player_availability_slots" using primary key columns */
  playerAvailabilitySlotsByPk?: Maybe<PlayerAvailabilitySlots>;
  /** fetch data from the table: "player_availability_venues" */
  playerAvailabilityVenues: Array<PlayerAvailabilityVenues>;
  /** fetch data from the table: "player_availability_venues" using primary key columns */
  playerAvailabilityVenuesByPk?: Maybe<PlayerAvailabilityVenues>;
  /** fetch data from the table: "player_finder_goals" */
  playerFinderGoals: Array<PlayerFinderGoals>;
  /** fetch data from the table: "player_finder_goals" using primary key columns */
  playerFinderGoalsByPk?: Maybe<PlayerFinderGoals>;
  /** fetch data from the table: "player_finder_time_of_day" */
  playerFinderTimeOfDay: Array<PlayerFinderTimeOfDay>;
  /** fetch data from the table: "player_finder_time_of_day" using primary key columns */
  playerFinderTimeOfDayByPk?: Maybe<PlayerFinderTimeOfDay>;
  /** fetch data from the table: "recurrence_kinds" */
  recurrenceKinds: Array<RecurrenceKinds>;
  /** fetch data from the table: "recurrence_kinds" using primary key columns */
  recurrenceKindsByPk?: Maybe<RecurrenceKinds>;
  /** fetch data from the table: "report_reasons" */
  reportReasons: Array<ReportReasons>;
  /** fetch data from the table: "report_reasons" using primary key columns */
  reportReasonsByPk?: Maybe<ReportReasons>;
  /** fetch data from the table: "report_statuses" */
  reportStatuses: Array<ReportStatuses>;
  /** fetch data from the table: "report_statuses" using primary key columns */
  reportStatusesByPk?: Maybe<ReportStatuses>;
  /** fetch data from the table: "reviews" */
  reviews: Array<Reviews>;
  /** fetch aggregated fields from the table: "reviews" */
  reviewsAggregate: ReviewsAggregate;
  /** fetch data from the table: "reviews" using primary key columns */
  reviewsByPk?: Maybe<Reviews>;
  /** An array relationship */
  sales: Array<Sales>;
  /** fetch data from the table: "sales" using primary key columns */
  salesByPk?: Maybe<Sales>;
  /** fetch data from the table: "scoring_format" */
  scoringFormat: Array<ScoringFormat>;
  /** fetch data from the table: "scoring_format" using primary key columns */
  scoringFormatByPk?: Maybe<ScoringFormat>;
  /** fetch data from the table: "signup_requests" */
  signupRequests: Array<SignupRequests>;
  /** fetch data from the table: "signup_requests" using primary key columns */
  signupRequestsByPk?: Maybe<SignupRequests>;
  /** fetch data from the table: "skill_level_values" */
  skillLevelValues: Array<SkillLevelValues>;
  /** fetch data from the table: "skill_level_values" using primary key columns */
  skillLevelValuesByPk?: Maybe<SkillLevelValues>;
  /** fetch data from the table: "skill_levels" */
  skillLevels: Array<SkillLevels>;
  /** fetch data from the table: "skill_levels" using primary key columns */
  skillLevelsByPk?: Maybe<SkillLevels>;
  /** fetch data from the table: "sports" */
  sports: Array<Sports>;
  /** fetch data from the table: "sports" using primary key columns */
  sportsByPk?: Maybe<Sports>;
  /** fetch data from the table: "subscription_statuses" */
  subscriptionStatuses: Array<SubscriptionStatuses>;
  /** fetch data from the table: "subscription_statuses" using primary key columns */
  subscriptionStatusesByPk?: Maybe<SubscriptionStatuses>;
  /** fetch data from the table: "team_types" */
  teamTypes: Array<TeamTypes>;
  /** fetch data from the table: "team_types" using primary key columns */
  teamTypesByPk?: Maybe<TeamTypes>;
  /** fetch data from the table: "tennis_rating_scales" */
  tennisRatingScales: Array<TennisRatingScales>;
  /** fetch data from the table: "tennis_rating_scales" using primary key columns */
  tennisRatingScalesByPk?: Maybe<TennisRatingScales>;
  /** fetch data from the table: "twilio_group_texts" */
  twilioGroupTexts: Array<TwilioGroupTexts>;
  /** fetch data from the table: "twilio_group_texts" using primary key columns */
  twilioGroupTextsByPk?: Maybe<TwilioGroupTexts>;
  /** fetch data from the table: "upload_review_requests" */
  uploadReviewRequests: Array<UploadReviewRequests>;
  /** fetch data from the table: "upload_review_requests" using primary key columns */
  uploadReviewRequestsByPk?: Maybe<UploadReviewRequests>;
  /** fetch data from the table: "user_blocks" */
  userBlocks: Array<UserBlocks>;
  /** fetch data from the table: "user_blocks" using primary key columns */
  userBlocksByPk?: Maybe<UserBlocks>;
  /** fetch data from the table: "user_coach_services" */
  userCoachServices: Array<UserCoachServices>;
  /** fetch data from the table: "user_coach_services" using primary key columns */
  userCoachServicesByPk?: Maybe<UserCoachServices>;
  /** fetch data from the table: "user_communication_preferences" */
  userCommunicationPreferences: Array<UserCommunicationPreferences>;
  /** fetch data from the table: "user_communication_preferences" using primary key columns */
  userCommunicationPreferencesByPk?: Maybe<UserCommunicationPreferences>;
  /** fetch data from the table: "user_connection_request_statuses" */
  userConnectionRequestStatuses: Array<UserConnectionRequestStatuses>;
  /** fetch data from the table: "user_connection_request_statuses" using primary key columns */
  userConnectionRequestStatusesByPk?: Maybe<UserConnectionRequestStatuses>;
  /** fetch data from the table: "user_connection_requests" */
  userConnectionRequests: Array<UserConnectionRequests>;
  /** fetch aggregated fields from the table: "user_connection_requests" */
  userConnectionRequestsAggregate: UserConnectionRequestsAggregate;
  /** fetch data from the table: "user_connection_requests" using primary key columns */
  userConnectionRequestsByPk?: Maybe<UserConnectionRequests>;
  /** fetch data from the table: "user_connections" */
  userConnections: Array<UserConnections>;
  /** fetch aggregated fields from the table: "user_connections" */
  userConnectionsAggregate: UserConnectionsAggregate;
  /** fetch data from the table: "user_connections" using primary key columns */
  userConnectionsByPk?: Maybe<UserConnections>;
  /** fetch data from the table: "user_content_beta_subscriptions" */
  userContentBetaSubscriptions: Array<UserContentBetaSubscriptions>;
  /** fetch data from the table: "user_content_beta_subscriptions" using primary key columns */
  userContentBetaSubscriptionsByPk?: Maybe<UserContentBetaSubscriptions>;
  /** fetch data from the table: "user_content_files" */
  userContentFiles: Array<UserContentFiles>;
  /** fetch data from the table: "user_content_files" using primary key columns */
  userContentFilesByPk?: Maybe<UserContentFiles>;
  /** An array relationship */
  userContentFilesSkills: Array<UserContentFilesSkills>;
  /** fetch data from the table: "user_content_files_skills" using primary key columns */
  userContentFilesSkillsByPk?: Maybe<UserContentFilesSkills>;
  /** fetch data from the table: "user_content_skills" */
  userContentSkills: Array<UserContentSkills>;
  /** fetch data from the table: "user_content_skills" using primary key columns */
  userContentSkillsByPk?: Maybe<UserContentSkills>;
  /** fetch data from the table: "user_credit_cards" */
  userCreditCards: Array<UserCreditCards>;
  /** fetch data from the table: "user_credit_cards" using primary key columns */
  userCreditCardsByPk?: Maybe<UserCreditCards>;
  /** fetch data from the table: "user_custom_courts" */
  userCustomCourts: Array<UserCustomCourts>;
  /** fetch data from the table: "user_custom_courts" using primary key columns */
  userCustomCourtsByPk?: Maybe<UserCustomCourts>;
  /** An array relationship */
  userFiles: Array<UserFiles>;
  /** fetch data from the table: "user_files" using primary key columns */
  userFilesByPk?: Maybe<UserFiles>;
  /** fetch data from the table: "user_follows" */
  userFollows: Array<UserFollows>;
  /** fetch aggregated fields from the table: "user_follows" */
  userFollowsAggregate: UserFollowsAggregate;
  /** fetch data from the table: "user_follows" using primary key columns */
  userFollowsByPk?: Maybe<UserFollows>;
  /** fetch data from the table: "user_identity_verifications" */
  userIdentityVerifications: Array<UserIdentityVerifications>;
  /** fetch data from the table: "user_identity_verifications" using primary key columns */
  userIdentityVerificationsByPk?: Maybe<UserIdentityVerifications>;
  /** fetch data from the table: "user_image_log" */
  userImageLog: Array<UserImageLog>;
  /** fetch data from the table: "user_image_log" using primary key columns */
  userImageLogByPk?: Maybe<UserImageLog>;
  /** fetch data from the table: "user_notification_details" */
  userNotificationDetails: Array<UserNotificationDetails>;
  /** fetch data from the table: "user_notification_details" using primary key columns */
  userNotificationDetailsByPk?: Maybe<UserNotificationDetails>;
  /** fetch data from the table: "user_notification_entities" */
  userNotificationEntities: Array<UserNotificationEntities>;
  /** fetch data from the table: "user_notification_entities" using primary key columns */
  userNotificationEntitiesByPk?: Maybe<UserNotificationEntities>;
  /** An array relationship */
  userNotifications: Array<UserNotifications>;
  /** An aggregate relationship */
  userNotificationsAggregate: UserNotificationsAggregate;
  /** fetch data from the table: "user_notifications" using primary key columns */
  userNotificationsByPk?: Maybe<UserNotifications>;
  /** fetch data from the table: "user_padel_rating_scales" */
  userPadelRatingScales: Array<UserPadelRatingScales>;
  /** fetch data from the table: "user_padel_rating_scales" using primary key columns */
  userPadelRatingScalesByPk?: Maybe<UserPadelRatingScales>;
  /** fetch data from the table: "user_pickleball_rating_scales" */
  userPickleballRatingScales: Array<UserPickleballRatingScales>;
  /** fetch data from the table: "user_pickleball_rating_scales" using primary key columns */
  userPickleballRatingScalesByPk?: Maybe<UserPickleballRatingScales>;
  /** fetch data from the table: "user_played_with" */
  userPlayedWith: Array<UserPlayedWith>;
  /** fetch aggregated fields from the table: "user_played_with" */
  userPlayedWithAggregate: UserPlayedWithAggregate;
  /** fetch data from the table: "user_played_with_dismissals" */
  userPlayedWithDismissals: Array<UserPlayedWithDismissals>;
  /** fetch data from the table: "user_played_with_dismissals" using primary key columns */
  userPlayedWithDismissalsByPk?: Maybe<UserPlayedWithDismissals>;
  /** fetch data from the table: "user_played_with_games" */
  userPlayedWithGames: Array<UserPlayedWithGames>;
  /** fetch aggregated fields from the table: "user_played_with_games" */
  userPlayedWithGamesAggregate: UserPlayedWithGamesAggregate;
  /** fetch data from the table: "user_player_finder_availability" */
  userPlayerFinderAvailability: Array<UserPlayerFinderAvailability>;
  /** fetch data from the table: "user_player_finder_availability" using primary key columns */
  userPlayerFinderAvailabilityByPk?: Maybe<UserPlayerFinderAvailability>;
  /** fetch data from the table: "user_player_finder_goals" */
  userPlayerFinderGoals: Array<UserPlayerFinderGoals>;
  /** fetch data from the table: "user_player_finder_goals" using primary key columns */
  userPlayerFinderGoalsByPk?: Maybe<UserPlayerFinderGoals>;
  /** fetch data from the table: "user_profiles" */
  userProfiles: Array<UserProfiles>;
  /** fetch aggregated fields from the table: "user_profiles" */
  userProfilesAggregate: UserProfilesAggregate;
  /** fetch data from the table: "user_sports" */
  userSports: Array<UserSports>;
  /** fetch data from the table: "user_sports" using primary key columns */
  userSportsByPk?: Maybe<UserSports>;
  /** fetch data from the table: "user_tennis_rating_scales" */
  userTennisRatingScales: Array<UserTennisRatingScales>;
  /** fetch data from the table: "user_tennis_rating_scales" using primary key columns */
  userTennisRatingScalesByPk?: Maybe<UserTennisRatingScales>;
  /** fetch data from the table: "user_terms_of_service" */
  userTermsOfService: Array<UserTermsOfService>;
  /** fetch data from the table: "user_terms_of_service" using primary key columns */
  userTermsOfServiceByPk?: Maybe<UserTermsOfService>;
  /** fetch data from the table: "user_vair_connections" */
  userVairConnections: Array<UserVairConnections>;
  /** fetch data from the table: "user_vair_connections" using primary key columns */
  userVairConnectionsByPk?: Maybe<UserVairConnections>;
  /** fetch data from the table: "usernames_active" */
  usernamesActive: Array<UsernamesActive>;
  /** An array relationship */
  usernamesClaimed: Array<UsernamesClaimed>;
  /** fetch data from the table: "usernames_claimed" using primary key columns */
  usernamesClaimedByPk?: Maybe<UsernamesClaimed>;
  /** An array relationship */
  users: Array<Users>;
  /** fetch data from the table: "users" using primary key columns */
  usersByPk?: Maybe<Users>;
  /** fetch data from the table: "users_coach_qualifications" */
  usersCoachQualifications: Array<UsersCoachQualifications>;
  /** fetch data from the table: "users_coach_qualifications" using primary key columns */
  usersCoachQualificationsByPk?: Maybe<UsersCoachQualifications>;
  /** fetch data from the table: "venue_access_types" */
  venueAccessTypes: Array<VenueAccessTypes>;
  /** fetch data from the table: "venue_access_types" using primary key columns */
  venueAccessTypesByPk?: Maybe<VenueAccessTypes>;
  /** fetch data from the table: "venue_admin_claim_statuses" */
  venueAdminClaimStatuses: Array<VenueAdminClaimStatuses>;
  /** fetch data from the table: "venue_admin_claim_statuses" using primary key columns */
  venueAdminClaimStatusesByPk?: Maybe<VenueAdminClaimStatuses>;
  /** fetch data from the table: "venue_admin_claims" */
  venueAdminClaims: Array<VenueAdminClaims>;
  /** fetch data from the table: "venue_admin_claims" using primary key columns */
  venueAdminClaimsByPk?: Maybe<VenueAdminClaims>;
  /** fetch data from the table: "venue_amenities" */
  venueAmenities: Array<VenueAmenities>;
  /** fetch data from the table: "venue_amenities" using primary key columns */
  venueAmenitiesByPk?: Maybe<VenueAmenities>;
  /** fetch data from the table: "venue_booking_config_versions" */
  venueBookingConfigVersions: Array<VenueBookingConfigVersions>;
  /** fetch data from the table: "venue_booking_config_versions" using primary key columns */
  venueBookingConfigVersionsByPk?: Maybe<VenueBookingConfigVersions>;
  /** fetch data from the table: "venue_booking_connection_check_statuses" */
  venueBookingConnectionCheckStatuses: Array<VenueBookingConnectionCheckStatuses>;
  /** fetch data from the table: "venue_booking_connection_check_statuses" using primary key columns */
  venueBookingConnectionCheckStatusesByPk?: Maybe<VenueBookingConnectionCheckStatuses>;
  /** fetch data from the table: "venue_booking_connection_checks" */
  venueBookingConnectionChecks: Array<VenueBookingConnectionChecks>;
  /** fetch data from the table: "venue_booking_connection_checks" using primary key columns */
  venueBookingConnectionChecksByPk?: Maybe<VenueBookingConnectionChecks>;
  /** fetch data from the table: "venue_booking_court_rates" */
  venueBookingCourtRates: Array<VenueBookingCourtRates>;
  /** fetch data from the table: "venue_booking_court_rates" using primary key columns */
  venueBookingCourtRatesByPk?: Maybe<VenueBookingCourtRates>;
  /** fetch data from the table: "venue_booking_integrations" */
  venueBookingIntegrations: Array<VenueBookingIntegrations>;
  /** fetch data from the table: "venue_booking_integrations" using primary key columns */
  venueBookingIntegrationsByPk?: Maybe<VenueBookingIntegrations>;
  /** fetch data from the table: "venue_booking_rule_tiers" */
  venueBookingRuleTiers: Array<VenueBookingRuleTiers>;
  /** fetch data from the table: "venue_booking_rule_tiers" using primary key columns */
  venueBookingRuleTiersByPk?: Maybe<VenueBookingRuleTiers>;
  /** fetch data from the table: "venue_booking_rules" */
  venueBookingRules: Array<VenueBookingRules>;
  /** fetch data from the table: "venue_booking_rules" using primary key columns */
  venueBookingRulesByPk?: Maybe<VenueBookingRules>;
  /** fetch data from the table: "venue_booking_windows" */
  venueBookingWindows: Array<VenueBookingWindows>;
  /** fetch data from the table: "venue_booking_windows" using primary key columns */
  venueBookingWindowsByPk?: Maybe<VenueBookingWindows>;
  /** fetch data from the table: "venue_court_surfaces" */
  venueCourtSurfaces: Array<VenueCourtSurfaces>;
  /** fetch data from the table: "venue_court_surfaces" using primary key columns */
  venueCourtSurfacesByPk?: Maybe<VenueCourtSurfaces>;
  /** fetch data from the table: "venue_custom_amenities" */
  venueCustomAmenities: Array<VenueCustomAmenities>;
  /** fetch data from the table: "venue_custom_amenities" using primary key columns */
  venueCustomAmenitiesByPk?: Maybe<VenueCustomAmenities>;
  /** fetch data from the table: "venue_equipment" */
  venueEquipment: Array<VenueEquipment>;
  /** fetch data from the table: "venue_equipment" using primary key columns */
  venueEquipmentByPk?: Maybe<VenueEquipment>;
  /** fetch data from the table: "venue_facility_types" */
  venueFacilityTypes: Array<VenueFacilityTypes>;
  /** fetch data from the table: "venue_facility_types" using primary key columns */
  venueFacilityTypesByPk?: Maybe<VenueFacilityTypes>;
  /** fetch data from the table: "venue_faqs" */
  venueFaqs: Array<VenueFaqs>;
  /** fetch data from the table: "venue_faqs" using primary key columns */
  venueFaqsByPk?: Maybe<VenueFaqs>;
  /** An array relationship */
  venueFollows: Array<VenueFollows>;
  /** An aggregate relationship */
  venueFollowsAggregate: VenueFollowsAggregate;
  /** fetch data from the table: "venue_follows" using primary key columns */
  venueFollowsByPk?: Maybe<VenueFollows>;
  /** fetch data from the table: "venue_images" */
  venueImages: Array<VenueImages>;
  /** fetch data from the table: "venue_images" using primary key columns */
  venueImagesByPk?: Maybe<VenueImages>;
  /** fetch data from the table: "venue_lines" */
  venueLines: Array<VenueLines>;
  /** fetch data from the table: "venue_lines" using primary key columns */
  venueLinesByPk?: Maybe<VenueLines>;
  /** fetch data from the table: "venue_nets" */
  venueNets: Array<VenueNets>;
  /** fetch data from the table: "venue_nets" using primary key columns */
  venueNetsByPk?: Maybe<VenueNets>;
  /** fetch data from the table: "venue_partner_booking_statuses" */
  venuePartnerBookingStatuses: Array<VenuePartnerBookingStatuses>;
  /** fetch data from the table: "venue_staff_coaches" */
  venueStaffCoaches: Array<VenueStaffCoaches>;
  /** fetch aggregated fields from the table: "venue_staff_coaches" */
  venueStaffCoachesAggregate: VenueStaffCoachesAggregate;
  /** fetch data from the table: "venue_staff_coaches" using primary key columns */
  venueStaffCoachesByPk?: Maybe<VenueStaffCoaches>;
  /** An array relationship */
  venues: Array<Venues>;
  /** fetch data from the table: "venues" using primary key columns */
  venuesByPk?: Maybe<Venues>;
  /** fetch data from the table: "video_analysis" */
  videoAnalysis: Array<VideoAnalysis>;
  /** fetch aggregated fields from the table: "video_analysis" */
  videoAnalysisAggregate: VideoAnalysisAggregate;
  /** fetch data from the table: "video_analysis" using primary key columns */
  videoAnalysisByPk?: Maybe<VideoAnalysis>;
  /** An array relationship */
  videoAnalysisComments: Array<VideoAnalysisComments>;
  /** fetch data from the table: "video_analysis_comments" using primary key columns */
  videoAnalysisCommentsByPk?: Maybe<VideoAnalysisComments>;
  /** An array relationship */
  videoAnalysisFiles: Array<VideoAnalysisFiles>;
  /** fetch data from the table: "video_analysis_files" using primary key columns */
  videoAnalysisFilesByPk?: Maybe<VideoAnalysisFiles>;
  /** fetch data from the table: "video_analysis_order_items" */
  videoAnalysisOrderItems: Array<VideoAnalysisOrderItems>;
  /** fetch data from the table: "video_analysis_order_items" using primary key columns */
  videoAnalysisOrderItemsByPk?: Maybe<VideoAnalysisOrderItems>;
  /** fetch data from the table: "video_analysis_orders" */
  videoAnalysisOrders: Array<VideoAnalysisOrders>;
  /** fetch data from the table: "video_analysis_orders" using primary key columns */
  videoAnalysisOrdersByPk?: Maybe<VideoAnalysisOrders>;
  /** fetch data from the table: "video_analysis_requested_skills_review" */
  videoAnalysisRequestedSkillsReview: Array<VideoAnalysisRequestedSkillsReview>;
  /** fetch data from the table: "video_analysis_requested_skills_review" using primary key columns */
  videoAnalysisRequestedSkillsReviewByPk?: Maybe<VideoAnalysisRequestedSkillsReview>;
  /** An array relationship */
  videoAnalysisSkillsComments: Array<VideoAnalysisSkillsComments>;
  /** fetch data from the table: "video_analysis_skills_comments" using primary key columns */
  videoAnalysisSkillsCommentsByPk?: Maybe<VideoAnalysisSkillsComments>;
  /** fetch data from the table: "video_analysis_submission_log" */
  videoAnalysisSubmissionLog: Array<VideoAnalysisSubmissionLog>;
  /** fetch data from the table: "video_analysis_submission_log" using primary key columns */
  videoAnalysisSubmissionLogByPk?: Maybe<VideoAnalysisSubmissionLog>;
  /** fetch data from the table: "video_lesson_skills" */
  videoLessonSkills: Array<VideoLessonSkills>;
  /** fetch data from the table: "video_lesson_skills" using primary key columns */
  videoLessonSkillsByPk?: Maybe<VideoLessonSkills>;
  /** fetch data from the table: "win_reasons" */
  winReasons: Array<WinReasons>;
  /** fetch data from the table: "win_reasons" using primary key columns */
  winReasonsByPk?: Maybe<WinReasons>;
};


export type Query_RootAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<AmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AmenitiesOrderBy>>;
  where?: InputMaybe<AmenitiesBoolExp>;
};


export type Query_RootAmenitiesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootAppPersonasArgs = {
  distinctOn?: InputMaybe<Array<AppPersonasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppPersonasOrderBy>>;
  where?: InputMaybe<AppPersonasBoolExp>;
};


export type Query_RootAppPersonasByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootAppPingsArgs = {
  distinctOn?: InputMaybe<Array<AppPingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppPingsOrderBy>>;
  where?: InputMaybe<AppPingsBoolExp>;
};


export type Query_RootAppPingsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootBallTypesArgs = {
  distinctOn?: InputMaybe<Array<BallTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BallTypesOrderBy>>;
  where?: InputMaybe<BallTypesBoolExp>;
};


export type Query_RootBallTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBirthdayVisibilityArgs = {
  distinctOn?: InputMaybe<Array<BirthdayVisibilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BirthdayVisibilityOrderBy>>;
  where?: InputMaybe<BirthdayVisibilityBoolExp>;
};


export type Query_RootBirthdayVisibilityByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingConfigChangeTypesArgs = {
  distinctOn?: InputMaybe<Array<BookingConfigChangeTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingConfigChangeTypesOrderBy>>;
  where?: InputMaybe<BookingConfigChangeTypesBoolExp>;
};


export type Query_RootBookingConfigChangeTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingConnectionStatusesArgs = {
  distinctOn?: InputMaybe<Array<BookingConnectionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingConnectionStatusesOrderBy>>;
  where?: InputMaybe<BookingConnectionStatusesBoolExp>;
};


export type Query_RootBookingConnectionStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingIntegrationStatusesArgs = {
  distinctOn?: InputMaybe<Array<BookingIntegrationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingIntegrationStatusesOrderBy>>;
  where?: InputMaybe<BookingIntegrationStatusesBoolExp>;
};


export type Query_RootBookingIntegrationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingInventoryTypesArgs = {
  distinctOn?: InputMaybe<Array<BookingInventoryTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingInventoryTypesOrderBy>>;
  where?: InputMaybe<BookingInventoryTypesBoolExp>;
};


export type Query_RootBookingInventoryTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingScheduleModesArgs = {
  distinctOn?: InputMaybe<Array<BookingScheduleModesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingScheduleModesOrderBy>>;
  where?: InputMaybe<BookingScheduleModesBoolExp>;
};


export type Query_RootBookingScheduleModesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingSystemsArgs = {
  distinctOn?: InputMaybe<Array<BookingSystemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingSystemsOrderBy>>;
  where?: InputMaybe<BookingSystemsBoolExp>;
};


export type Query_RootBookingSystemsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBookingWindowKindsArgs = {
  distinctOn?: InputMaybe<Array<BookingWindowKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingWindowKindsOrderBy>>;
  where?: InputMaybe<BookingWindowKindsBoolExp>;
};


export type Query_RootBookingWindowKindsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBoostChannelsArgs = {
  distinctOn?: InputMaybe<Array<BoostChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostChannelsOrderBy>>;
  where?: InputMaybe<BoostChannelsBoolExp>;
};


export type Query_RootBoostChannelsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBoostStatusesArgs = {
  distinctOn?: InputMaybe<Array<BoostStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostStatusesOrderBy>>;
  where?: InputMaybe<BoostStatusesBoolExp>;
};


export type Query_RootBoostStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootBoostsArgs = {
  distinctOn?: InputMaybe<Array<BoostsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostsOrderBy>>;
  where?: InputMaybe<BoostsBoolExp>;
};


export type Query_RootBoostsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootBracketRankingMechanismArgs = {
  distinctOn?: InputMaybe<Array<BracketRankingMechanismSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BracketRankingMechanismOrderBy>>;
  where?: InputMaybe<BracketRankingMechanismBoolExp>;
};


export type Query_RootBracketRankingMechanismByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCalendarAccountsArgs = {
  distinctOn?: InputMaybe<Array<CalendarAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarAccountsOrderBy>>;
  where?: InputMaybe<CalendarAccountsBoolExp>;
};


export type Query_RootCalendarAccountsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCalendarPreferencesArgs = {
  distinctOn?: InputMaybe<Array<CalendarPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarPreferencesOrderBy>>;
  where?: InputMaybe<CalendarPreferencesBoolExp>;
};


export type Query_RootCalendarPreferencesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCitiesArgs = {
  distinctOn?: InputMaybe<Array<CitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CitiesOrderBy>>;
  where?: InputMaybe<CitiesBoolExp>;
};


export type Query_RootCitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachAvailabilityArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityOrderBy>>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};


export type Query_RootCoachAvailabilityByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachBookingRequestsArgs = {
  distinctOn?: InputMaybe<Array<CoachBookingRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachBookingRequestsOrderBy>>;
  where?: InputMaybe<CoachBookingRequestsBoolExp>;
};


export type Query_RootCoachBookingRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachFaqsArgs = {
  distinctOn?: InputMaybe<Array<CoachFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachFaqsOrderBy>>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};


export type Query_RootCoachFaqsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachLessonAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonAgeGroupsOrderBy>>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};


export type Query_RootCoachLessonAgeGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachLessonSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonSkillLevelsOrderBy>>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};


export type Query_RootCoachLessonSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachQualificationGroupsArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationGroupsOrderBy>>;
  where?: InputMaybe<CoachQualificationGroupsBoolExp>;
};


export type Query_RootCoachQualificationGroupsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCoachQualificationsArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationsOrderBy>>;
  where?: InputMaybe<CoachQualificationsBoolExp>;
};


export type Query_RootCoachQualificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachSportStatusesArgs = {
  distinctOn?: InputMaybe<Array<CoachSportStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportStatusesOrderBy>>;
  where?: InputMaybe<CoachSportStatusesBoolExp>;
};


export type Query_RootCoachSportStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCoachSportsArgs = {
  distinctOn?: InputMaybe<Array<CoachSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportsOrderBy>>;
  where?: InputMaybe<CoachSportsBoolExp>;
};


export type Query_RootCoachSportsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachStarterProfilesArgs = {
  distinctOn?: InputMaybe<Array<CoachStarterProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStarterProfilesOrderBy>>;
  where?: InputMaybe<CoachStarterProfilesBoolExp>;
};


export type Query_RootCoachStarterProfilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoachStatusArgs = {
  distinctOn?: InputMaybe<Array<CoachStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStatusOrderBy>>;
  where?: InputMaybe<CoachStatusBoolExp>;
};


export type Query_RootCoachStatusByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCommentVoteArgs = {
  distinctOn?: InputMaybe<Array<CommentVoteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentVoteOrderBy>>;
  where?: InputMaybe<CommentVoteBoolExp>;
};


export type Query_RootCommentVoteByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCommunicationPreferenceStatusesArgs = {
  distinctOn?: InputMaybe<Array<CommunicationPreferenceStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommunicationPreferenceStatusesOrderBy>>;
  where?: InputMaybe<CommunicationPreferenceStatusesBoolExp>;
};


export type Query_RootCommunicationPreferenceStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCompetitionFormatsArgs = {
  distinctOn?: InputMaybe<Array<CompetitionFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetitionFormatsOrderBy>>;
  where?: InputMaybe<CompetitionFormatsBoolExp>;
};


export type Query_RootCompetitionFormatsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootCompetitionGenderArgs = {
  distinctOn?: InputMaybe<Array<CompetitionGenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetitionGenderOrderBy>>;
  where?: InputMaybe<CompetitionGenderBoolExp>;
};


export type Query_RootCompetitionGenderByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootContentReportsArgs = {
  distinctOn?: InputMaybe<Array<ContentReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContentReportsOrderBy>>;
  where?: InputMaybe<ContentReportsBoolExp>;
};


export type Query_RootContentReportsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootConversationParticipantsArgs = {
  distinctOn?: InputMaybe<Array<ConversationParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationParticipantsOrderBy>>;
  where?: InputMaybe<ConversationParticipantsBoolExp>;
};


export type Query_RootConversationParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootConversationTypesArgs = {
  distinctOn?: InputMaybe<Array<ConversationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationTypesOrderBy>>;
  where?: InputMaybe<ConversationTypesBoolExp>;
};


export type Query_RootConversationTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootConversationsArgs = {
  distinctOn?: InputMaybe<Array<ConversationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
  where?: InputMaybe<ConversationsBoolExp>;
};


export type Query_RootConversationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCountriesArgs = {
  distinctOn?: InputMaybe<Array<CountriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
  where?: InputMaybe<CountriesBoolExp>;
};


export type Query_RootCountriesByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootCountrySubdivisionsArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


export type Query_RootCountrySubdivisionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourtSurfacesArgs = {
  distinctOn?: InputMaybe<Array<CourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CourtSurfacesOrderBy>>;
  where?: InputMaybe<CourtSurfacesBoolExp>;
};


export type Query_RootCourtSurfacesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootDayOfWeekArgs = {
  distinctOn?: InputMaybe<Array<DayOfWeekSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DayOfWeekOrderBy>>;
  where?: InputMaybe<DayOfWeekBoolExp>;
};


export type Query_RootDayOfWeekByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEngagementEntityTypesArgs = {
  distinctOn?: InputMaybe<Array<EngagementEntityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementEntityTypesOrderBy>>;
  where?: InputMaybe<EngagementEntityTypesBoolExp>;
};


export type Query_RootEngagementEntityTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEngagementEventTypesArgs = {
  distinctOn?: InputMaybe<Array<EngagementEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementEventTypesOrderBy>>;
  where?: InputMaybe<EngagementEventTypesBoolExp>;
};


export type Query_RootEngagementEventTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEngagementSourcesArgs = {
  distinctOn?: InputMaybe<Array<EngagementSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementSourcesOrderBy>>;
  where?: InputMaybe<EngagementSourcesBoolExp>;
};


export type Query_RootEngagementSourcesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEquipmentAvailabilitiesArgs = {
  distinctOn?: InputMaybe<Array<EquipmentAvailabilitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentAvailabilitiesOrderBy>>;
  where?: InputMaybe<EquipmentAvailabilitiesBoolExp>;
};


export type Query_RootEquipmentAvailabilitiesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventAcceptedPlayRequestsArgs = {
  distinctOn?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAcceptedPlayRequestsOrderBy>>;
  where?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
};


export type Query_RootEventAcceptedPlayRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAcceptedPlayRequestsOrderBy>>;
  where?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
};


export type Query_RootEventAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAgeGroupsOrderBy>>;
  where?: InputMaybe<EventAgeGroupsBoolExp>;
};


export type Query_RootEventAgeGroupsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventCollectionsArgs = {
  distinctOn?: InputMaybe<Array<EventCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCollectionsOrderBy>>;
  where?: InputMaybe<EventCollectionsBoolExp>;
};


export type Query_RootEventCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventCompetitivenessArgs = {
  distinctOn?: InputMaybe<Array<EventCompetitivenessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCompetitivenessOrderBy>>;
  where?: InputMaybe<EventCompetitivenessBoolExp>;
};


export type Query_RootEventCompetitivenessByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventContactDetailsArgs = {
  distinctOn?: InputMaybe<Array<EventContactDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventContactDetailsOrderBy>>;
  where?: InputMaybe<EventContactDetailsBoolExp>;
};


export type Query_RootEventContactDetailsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventCouponGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponGroupsOrderBy>>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};


export type Query_RootEventCouponGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventCouponRedemptionsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponRedemptionsOrderBy>>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};


export type Query_RootEventCouponRedemptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponRedemptionsOrderBy>>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};


export type Query_RootEventCouponRedemptionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventCouponSourceArgs = {
  distinctOn?: InputMaybe<Array<EventCouponSourceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponSourceOrderBy>>;
  where?: InputMaybe<EventCouponSourceBoolExp>;
};


export type Query_RootEventCouponSourceByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventCouponTypeArgs = {
  distinctOn?: InputMaybe<Array<EventCouponTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponTypeOrderBy>>;
  where?: InputMaybe<EventCouponTypeBoolExp>;
};


export type Query_RootEventCouponTypeByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventCouponsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponsOrderBy>>;
  where?: InputMaybe<EventCouponsBoolExp>;
};


export type Query_RootEventCouponsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventCourtStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventCourtStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtStatusesOrderBy>>;
  where?: InputMaybe<EventCourtStatusesBoolExp>;
};


export type Query_RootEventCourtStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventCourtsArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


export type Query_RootEventCourtsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventFaqsArgs = {
  distinctOn?: InputMaybe<Array<EventFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventFaqsOrderBy>>;
  where?: InputMaybe<EventFaqsBoolExp>;
};


export type Query_RootEventFaqsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGameScoresArgs = {
  distinctOn?: InputMaybe<Array<EventGameScoresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGameScoresOrderBy>>;
  where?: InputMaybe<EventGameScoresBoolExp>;
};


export type Query_RootEventGameScoresByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupFormatsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupFormatsOrderBy>>;
  where?: InputMaybe<EventGroupFormatsBoolExp>;
};


export type Query_RootEventGroupFormatsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventGroupMergesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupMergesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupMergesOrderBy>>;
  where?: InputMaybe<EventGroupMergesBoolExp>;
};


export type Query_RootEventGroupMergesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupPoolsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupPoolsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupPoolsOrderBy>>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};


export type Query_RootEventGroupPoolsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRatingScalesOrderBy>>;
  where?: InputMaybe<EventGroupRatingScalesBoolExp>;
};


export type Query_RootEventGroupRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupRegistrationStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationStatusesOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationStatusesBoolExp>;
};


export type Query_RootEventGroupRegistrationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventGroupRegistrationsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationsOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};


export type Query_RootEventGroupRegistrationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupSequenceSeedingArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequenceSeedingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequenceSeedingOrderBy>>;
  where?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
};


export type Query_RootEventGroupSequenceSeedingByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupSequencesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequencesOrderBy>>;
  where?: InputMaybe<EventGroupSequencesBoolExp>;
};


export type Query_RootEventGroupSequencesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupTimeSlotsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupTimeSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupTimeSlotsOrderBy>>;
  where?: InputMaybe<EventGroupTimeSlotsBoolExp>;
};


export type Query_RootEventGroupTimeSlotsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupsOrderBy>>;
  where?: InputMaybe<EventGroupsBoolExp>;
};


export type Query_RootEventGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventInvitationStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationStatusesOrderBy>>;
  where?: InputMaybe<EventInvitationStatusesBoolExp>;
};


export type Query_RootEventInvitationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventInvitationTypesArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationTypesOrderBy>>;
  where?: InputMaybe<EventInvitationTypesBoolExp>;
};


export type Query_RootEventInvitationTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventInvitationsArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationsOrderBy>>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};


export type Query_RootEventInvitationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventListingFeesArgs = {
  distinctOn?: InputMaybe<Array<EventListingFeesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventListingFeesOrderBy>>;
  where?: InputMaybe<EventListingFeesBoolExp>;
};


export type Query_RootEventListingFeesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventMatchGamesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchGamesOrderBy>>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};


export type Query_RootEventMatchGamesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventMatchesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


export type Query_RootEventMatchesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventMatchesTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesTeamsOrderBy>>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};


export type Query_RootEventMatchesTeamsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventOrganizerAccountTypesArgs = {
  distinctOn?: InputMaybe<Array<EventOrganizerAccountTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventOrganizerAccountTypesOrderBy>>;
  where?: InputMaybe<EventOrganizerAccountTypesBoolExp>;
};


export type Query_RootEventOrganizerAccountTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventPlayerInviteStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventPlayerInviteStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPlayerInviteStatusesOrderBy>>;
  where?: InputMaybe<EventPlayerInviteStatusesBoolExp>;
};


export type Query_RootEventPlayerInviteStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventPlayerInvitesArgs = {
  distinctOn?: InputMaybe<Array<EventPlayerInvitesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPlayerInvitesOrderBy>>;
  where?: InputMaybe<EventPlayerInvitesBoolExp>;
};


export type Query_RootEventPlayerInvitesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPlayerInvitesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPlayerInvitesOrderBy>>;
  where?: InputMaybe<EventPlayerInvitesBoolExp>;
};


export type Query_RootEventPlayerInvitesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventPoolRoundsArgs = {
  distinctOn?: InputMaybe<Array<EventPoolRoundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolRoundsOrderBy>>;
  where?: InputMaybe<EventPoolRoundsBoolExp>;
};


export type Query_RootEventPoolRoundsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventPoolsTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventPoolsTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolsTeamsOrderBy>>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};


export type Query_RootEventPoolsTeamsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventPrivacyArgs = {
  distinctOn?: InputMaybe<Array<EventPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPrivacyOrderBy>>;
  where?: InputMaybe<EventPrivacyBoolExp>;
};


export type Query_RootEventPrivacyByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventRegistrationDetailsArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationDetailsOrderBy>>;
  where?: InputMaybe<EventRegistrationDetailsBoolExp>;
};


export type Query_RootEventRegistrationDetailsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventRegistrationsArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationsOrderBy>>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};


export type Query_RootEventRegistrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationsOrderBy>>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};


export type Query_RootEventRegistrationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventSequenceCompleteReasonsArgs = {
  distinctOn?: InputMaybe<Array<EventSequenceCompleteReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSequenceCompleteReasonsOrderBy>>;
  where?: InputMaybe<EventSequenceCompleteReasonsBoolExp>;
};


export type Query_RootEventSequenceCompleteReasonsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<EventSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSkillLevelsOrderBy>>;
  where?: InputMaybe<EventSkillLevelsBoolExp>;
};


export type Query_RootEventSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventSponsorsArgs = {
  distinctOn?: InputMaybe<Array<EventSponsorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSponsorsOrderBy>>;
  where?: InputMaybe<EventSponsorsBoolExp>;
};


export type Query_RootEventSponsorsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventStatusesOrderBy>>;
  where?: InputMaybe<EventStatusesBoolExp>;
};


export type Query_RootEventStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventTeamMemberStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMemberStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMemberStatusesOrderBy>>;
  where?: InputMaybe<EventTeamMemberStatusesBoolExp>;
};


export type Query_RootEventTeamMemberStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventTeamMembersArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMembersOrderBy>>;
  where?: InputMaybe<EventTeamMembersBoolExp>;
};


export type Query_RootEventTeamMembersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventTeamStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventTeamStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamStatusesOrderBy>>;
  where?: InputMaybe<EventTeamStatusesBoolExp>;
};


export type Query_RootEventTeamStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamsOrderBy>>;
  where?: InputMaybe<EventTeamsBoolExp>;
};


export type Query_RootEventTeamsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventTransactionItemTypesArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemTypesOrderBy>>;
  where?: InputMaybe<EventTransactionItemTypesBoolExp>;
};


export type Query_RootEventTransactionItemTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventTransactionItemsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};


export type Query_RootEventTransactionItemsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventTransactionsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionsOrderBy>>;
  where?: InputMaybe<EventTransactionsBoolExp>;
};


export type Query_RootEventTransactionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventTypesArgs = {
  distinctOn?: InputMaybe<Array<EventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTypesOrderBy>>;
  where?: InputMaybe<EventTypesBoolExp>;
};


export type Query_RootEventTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootEventsArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


export type Query_RootEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


export type Query_RootEventsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFileCategoryArgs = {
  distinctOn?: InputMaybe<Array<FileCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileCategoryOrderBy>>;
  where?: InputMaybe<FileCategoryBoolExp>;
};


export type Query_RootFileCategoryByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootFileFormatArgs = {
  distinctOn?: InputMaybe<Array<FileFormatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileFormatOrderBy>>;
  where?: InputMaybe<FileFormatBoolExp>;
};


export type Query_RootFileFormatByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootGameNetStatusesArgs = {
  distinctOn?: InputMaybe<Array<GameNetStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GameNetStatusesOrderBy>>;
  where?: InputMaybe<GameNetStatusesBoolExp>;
};


export type Query_RootGameNetStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootGenderArgs = {
  distinctOn?: InputMaybe<Array<GenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GenderOrderBy>>;
  where?: InputMaybe<GenderBoolExp>;
};


export type Query_RootGenderByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootGroupCommentVotesArgs = {
  distinctOn?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupCommentVotesOrderBy>>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};


export type Query_RootGroupCommentVotesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupCommentVotesOrderBy>>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};


export type Query_RootGroupCommentVotesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupMembersArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


export type Query_RootGroupMembersAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


export type Query_RootGroupMembersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupThreadCommentFilesArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentFilesOrderBy>>;
  where?: InputMaybe<GroupThreadCommentFilesBoolExp>;
};


export type Query_RootGroupThreadCommentFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupThreadCommentsArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


export type Query_RootGroupThreadCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


export type Query_RootGroupThreadCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupThreadsArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadsOrderBy>>;
  where?: InputMaybe<GroupThreadsBoolExp>;
};


export type Query_RootGroupThreadsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupTypesArgs = {
  distinctOn?: InputMaybe<Array<GroupTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupTypesOrderBy>>;
  where?: InputMaybe<GroupTypesBoolExp>;
};


export type Query_RootGroupTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootGroupVenuesArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


export type Query_RootGroupVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


export type Query_RootGroupVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupsArgs = {
  distinctOn?: InputMaybe<Array<GroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
  where?: InputMaybe<GroupsBoolExp>;
};


export type Query_RootGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGroupsPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<GroupsPlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsPlaySessionsOrderBy>>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};


export type Query_RootGroupsPlaySessionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootIdentityVerificationProvidersArgs = {
  distinctOn?: InputMaybe<Array<IdentityVerificationProvidersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IdentityVerificationProvidersOrderBy>>;
  where?: InputMaybe<IdentityVerificationProvidersBoolExp>;
};


export type Query_RootIdentityVerificationProvidersByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootIdentityVerificationStatusesArgs = {
  distinctOn?: InputMaybe<Array<IdentityVerificationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IdentityVerificationStatusesOrderBy>>;
  where?: InputMaybe<IdentityVerificationStatusesBoolExp>;
};


export type Query_RootIdentityVerificationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootInvoicesArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


export type Query_RootInvoicesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramEnrollmentScheduleMediaWatchedArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
};


export type Query_RootLearningProgramEnrollmentScheduleMediaWatchedByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramEnrollmentScheduleProgressArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};


export type Query_RootLearningProgramEnrollmentScheduleProgressByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramEnrollmentsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentsOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
};


export type Query_RootLearningProgramEnrollmentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramMediaArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramMediaOrderBy>>;
  where?: InputMaybe<LearningProgramMediaBoolExp>;
};


export type Query_RootLearningProgramMediaByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramMediaCategoriesArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramMediaCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramMediaCategoriesOrderBy>>;
  where?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
};


export type Query_RootLearningProgramMediaCategoriesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramScheduleMediaArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleMediaOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};


export type Query_RootLearningProgramScheduleMediaByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramScheduleUnitsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleUnitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleUnitsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleUnitsBoolExp>;
};


export type Query_RootLearningProgramScheduleUnitsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLearningProgramScheduleVideoSubmissionsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};


export type Query_RootLearningProgramScheduleVideoSubmissionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramSchedulesArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSchedulesOrderBy>>;
  where?: InputMaybe<LearningProgramSchedulesBoolExp>;
};


export type Query_RootLearningProgramSchedulesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramSkillLevelValuesArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillLevelValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillLevelValuesOrderBy>>;
  where?: InputMaybe<LearningProgramSkillLevelValuesBoolExp>;
};


export type Query_RootLearningProgramSkillLevelValuesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLearningProgramSkillsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillsOrderBy>>;
  where?: InputMaybe<LearningProgramSkillsBoolExp>;
};


export type Query_RootLearningProgramSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLearningProgramsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramsOrderBy>>;
  where?: InputMaybe<LearningProgramsBoolExp>;
};


export type Query_RootLearningProgramsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramsOrderBy>>;
  where?: InputMaybe<LearningProgramsBoolExp>;
};


export type Query_RootLearningProgramsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<LessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonAgeGroupsOrderBy>>;
  where?: InputMaybe<LessonAgeGroupsBoolExp>;
};


export type Query_RootLessonAgeGroupsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonCollectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonCollectionsOrderBy>>;
  where?: InputMaybe<LessonCollectionsBoolExp>;
};


export type Query_RootLessonCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonEquipmentArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOrderBy>>;
  where?: InputMaybe<LessonEquipmentBoolExp>;
};


export type Query_RootLessonEquipmentByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonEquipmentOptionsArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOptionsOrderBy>>;
  where?: InputMaybe<LessonEquipmentOptionsBoolExp>;
};


export type Query_RootLessonEquipmentOptionsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonOrderItemsArgs = {
  distinctOn?: InputMaybe<Array<LessonOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrderItemsOrderBy>>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};


export type Query_RootLessonOrderItemsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonOrdersArgs = {
  distinctOn?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrdersOrderBy>>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};


export type Query_RootLessonOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrdersOrderBy>>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};


export type Query_RootLessonOrdersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonParticipantStatusesArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantStatusesOrderBy>>;
  where?: InputMaybe<LessonParticipantStatusesBoolExp>;
};


export type Query_RootLessonParticipantStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonParticipantsArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


export type Query_RootLessonParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


export type Query_RootLessonParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonPlayerSkillAssessmentsArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
};


export type Query_RootLessonPlayerSkillAssessmentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonPlayerSkillAssessmentsSkillsArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
};


export type Query_RootLessonPlayerSkillAssessmentsSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonPrivacyArgs = {
  distinctOn?: InputMaybe<Array<LessonPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPrivacyOrderBy>>;
  where?: InputMaybe<LessonPrivacyBoolExp>;
};


export type Query_RootLessonPrivacyByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonReflectionCommentTypesArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentTypesOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentTypesBoolExp>;
};


export type Query_RootLessonReflectionCommentTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonReflectionCommentsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentsOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentsBoolExp>;
};


export type Query_RootLessonReflectionCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonReflectionFilesArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionFilesOrderBy>>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};


export type Query_RootLessonReflectionFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonReflectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


export type Query_RootLessonReflectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonSkillDisplayNamesArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillDisplayNamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillDisplayNamesOrderBy>>;
  where?: InputMaybe<LessonSkillDisplayNamesBoolExp>;
};


export type Query_RootLessonSkillDisplayNamesByPkArgs = {
  id: LessonSkillsEnum;
};


export type Query_RootLessonSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonSkillLevelsBoolExp>;
};


export type Query_RootLessonSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonSkillMappingsArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillMappingsOrderBy>>;
  where?: InputMaybe<LessonSkillMappingsBoolExp>;
};


export type Query_RootLessonSkillMappingsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonSkillsArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillsOrderBy>>;
  where?: InputMaybe<LessonSkillsBoolExp>;
};


export type Query_RootLessonSkillsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonStatusesArgs = {
  distinctOn?: InputMaybe<Array<LessonStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonStatusesOrderBy>>;
  where?: InputMaybe<LessonStatusesBoolExp>;
};


export type Query_RootLessonStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonTemplateSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplateSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplateSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
};


export type Query_RootLessonTemplateSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonTemplatesArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplatesOrderBy>>;
  where?: InputMaybe<LessonTemplatesBoolExp>;
};


export type Query_RootLessonTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonTimesArgs = {
  distinctOn?: InputMaybe<Array<LessonTimesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTimesOrderBy>>;
  where?: InputMaybe<LessonTimesBoolExp>;
};


export type Query_RootLessonTimesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonTypesArgs = {
  distinctOn?: InputMaybe<Array<LessonTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTypesOrderBy>>;
  where?: InputMaybe<LessonTypesBoolExp>;
};


export type Query_RootLessonTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonWaitlistStatusesArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistStatusesOrderBy>>;
  where?: InputMaybe<LessonWaitlistStatusesBoolExp>;
};


export type Query_RootLessonWaitlistStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootLessonWaitlistsArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistsOrderBy>>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};


export type Query_RootLessonWaitlistsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistsOrderBy>>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};


export type Query_RootLessonWaitlistsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


export type Query_RootLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


export type Query_RootLessonsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMatchSelectionCriteriaArgs = {
  distinctOn?: InputMaybe<Array<MatchSelectionCriteriaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MatchSelectionCriteriaOrderBy>>;
  where?: InputMaybe<MatchSelectionCriteriaBoolExp>;
};


export type Query_RootMatchSelectionCriteriaByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootMessagesArgs = {
  distinctOn?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


export type Query_RootMessagesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<NeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NeighborhoodsOrderBy>>;
  where?: InputMaybe<NeighborhoodsBoolExp>;
};


export type Query_RootNeighborhoodsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPadelRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<PadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PadelRatingScalesOrderBy>>;
  where?: InputMaybe<PadelRatingScalesBoolExp>;
};


export type Query_RootPadelRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootParticipantRolesArgs = {
  distinctOn?: InputMaybe<Array<ParticipantRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ParticipantRolesOrderBy>>;
  where?: InputMaybe<ParticipantRolesBoolExp>;
};


export type Query_RootParticipantRolesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPartnerBookingOrderStatusesArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingOrderStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingOrderStatusesOrderBy>>;
  where?: InputMaybe<PartnerBookingOrderStatusesBoolExp>;
};


export type Query_RootPartnerBookingOrderStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPartnerBookingOrdersArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingOrdersOrderBy>>;
  where?: InputMaybe<PartnerBookingOrdersBoolExp>;
};


export type Query_RootPartnerBookingOrdersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPaymentFulfillmentChannelsArgs = {
  distinctOn?: InputMaybe<Array<PaymentFulfillmentChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentFulfillmentChannelsOrderBy>>;
  where?: InputMaybe<PaymentFulfillmentChannelsBoolExp>;
};


export type Query_RootPaymentFulfillmentChannelsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPickleballRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<PickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PickleballRatingScalesOrderBy>>;
  where?: InputMaybe<PickleballRatingScalesBoolExp>;
};


export type Query_RootPickleballRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlatformSubscriptionIntervalsArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionIntervalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionIntervalsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionIntervalsBoolExp>;
};


export type Query_RootPlatformSubscriptionIntervalsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlatformSubscriptionPersonasArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPersonasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPersonasOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPersonasBoolExp>;
};


export type Query_RootPlatformSubscriptionPersonasByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlatformSubscriptionPlanPricesArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlanPricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlanPricesOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
};


export type Query_RootPlatformSubscriptionPlanPricesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlatformSubscriptionPlansArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlansOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlansBoolExp>;
};


export type Query_RootPlatformSubscriptionPlansByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlatformSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};


export type Query_RootPlatformSubscriptionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayRequestNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
};


export type Query_RootPlayRequestNeighborhoodsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayRequestSlotsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestSlotsOrderBy>>;
  where?: InputMaybe<PlayRequestSlotsBoolExp>;
};


export type Query_RootPlayRequestSlotsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayRequestStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestStatusesOrderBy>>;
  where?: InputMaybe<PlayRequestStatusesBoolExp>;
};


export type Query_RootPlayRequestStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlayRequestVenuesArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestVenuesOrderBy>>;
  where?: InputMaybe<PlayRequestVenuesBoolExp>;
};


export type Query_RootPlayRequestVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayRequestsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestsOrderBy>>;
  where?: InputMaybe<PlayRequestsBoolExp>;
};


export type Query_RootPlayRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlaySessionCommentsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


export type Query_RootPlaySessionCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


export type Query_RootPlaySessionCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlaySessionCourtBookingStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCourtBookingStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCourtBookingStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionCourtBookingStatusesBoolExp>;
};


export type Query_RootPlaySessionCourtBookingStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlaySessionFormatsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionFormatsOrderBy>>;
  where?: InputMaybe<PlaySessionFormatsBoolExp>;
};


export type Query_RootPlaySessionFormatsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlaySessionMatchCompetitivenessArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionMatchCompetitivenessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionMatchCompetitivenessOrderBy>>;
  where?: InputMaybe<PlaySessionMatchCompetitivenessBoolExp>;
};


export type Query_RootPlaySessionMatchCompetitivenessByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlaySessionParticipantStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantStatusesBoolExp>;
};


export type Query_RootPlaySessionParticipantStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlaySessionParticipantsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantsOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};


export type Query_RootPlaySessionParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantsOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};


export type Query_RootPlaySessionParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlaySessionPrivacyArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionPrivacyOrderBy>>;
  where?: InputMaybe<PlaySessionPrivacyBoolExp>;
};


export type Query_RootPlaySessionPrivacyByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlaySessionStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionStatusesBoolExp>;
};


export type Query_RootPlaySessionStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


export type Query_RootPlaySessionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


export type Query_RootPlaySessionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayerAvailabilitiesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitiesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitiesBoolExp>;
};


export type Query_RootPlayerAvailabilitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitiesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitiesBoolExp>;
};


export type Query_RootPlayerAvailabilitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayerAvailabilityNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
};


export type Query_RootPlayerAvailabilityNeighborhoodsByPkArgs = {
  availabilityId: Scalars['uuid'];
  neighborhoodId: Scalars['uuid'];
};


export type Query_RootPlayerAvailabilityRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityRatingScalesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
};


export type Query_RootPlayerAvailabilityRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayerAvailabilitySlotsArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitySlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitySlotsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
};


export type Query_RootPlayerAvailabilitySlotsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayerAvailabilityVenuesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityVenuesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
};


export type Query_RootPlayerAvailabilityVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlayerFinderGoalsArgs = {
  distinctOn?: InputMaybe<Array<PlayerFinderGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerFinderGoalsOrderBy>>;
  where?: InputMaybe<PlayerFinderGoalsBoolExp>;
};


export type Query_RootPlayerFinderGoalsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPlayerFinderTimeOfDayArgs = {
  distinctOn?: InputMaybe<Array<PlayerFinderTimeOfDaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerFinderTimeOfDayOrderBy>>;
  where?: InputMaybe<PlayerFinderTimeOfDayBoolExp>;
};


export type Query_RootPlayerFinderTimeOfDayByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootRecurrenceKindsArgs = {
  distinctOn?: InputMaybe<Array<RecurrenceKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurrenceKindsOrderBy>>;
  where?: InputMaybe<RecurrenceKindsBoolExp>;
};


export type Query_RootRecurrenceKindsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootReportReasonsArgs = {
  distinctOn?: InputMaybe<Array<ReportReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportReasonsOrderBy>>;
  where?: InputMaybe<ReportReasonsBoolExp>;
};


export type Query_RootReportReasonsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootReportStatusesArgs = {
  distinctOn?: InputMaybe<Array<ReportStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportStatusesOrderBy>>;
  where?: InputMaybe<ReportStatusesBoolExp>;
};


export type Query_RootReportStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootReviewsArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


export type Query_RootReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


export type Query_RootReviewsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSalesArgs = {
  distinctOn?: InputMaybe<Array<SalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SalesOrderBy>>;
  where?: InputMaybe<SalesBoolExp>;
};


export type Query_RootSalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootScoringFormatArgs = {
  distinctOn?: InputMaybe<Array<ScoringFormatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScoringFormatOrderBy>>;
  where?: InputMaybe<ScoringFormatBoolExp>;
};


export type Query_RootScoringFormatByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootSignupRequestsArgs = {
  distinctOn?: InputMaybe<Array<SignupRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SignupRequestsOrderBy>>;
  where?: InputMaybe<SignupRequestsBoolExp>;
};


export type Query_RootSignupRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSkillLevelValuesArgs = {
  distinctOn?: InputMaybe<Array<SkillLevelValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SkillLevelValuesOrderBy>>;
  where?: InputMaybe<SkillLevelValuesBoolExp>;
};


export type Query_RootSkillLevelValuesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<SkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SkillLevelsOrderBy>>;
  where?: InputMaybe<SkillLevelsBoolExp>;
};


export type Query_RootSkillLevelsByPkArgs = {
  id: SkillLevelValuesEnum;
};


export type Query_RootSportsArgs = {
  distinctOn?: InputMaybe<Array<SportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SportsOrderBy>>;
  where?: InputMaybe<SportsBoolExp>;
};


export type Query_RootSportsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootSubscriptionStatusesArgs = {
  distinctOn?: InputMaybe<Array<SubscriptionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SubscriptionStatusesOrderBy>>;
  where?: InputMaybe<SubscriptionStatusesBoolExp>;
};


export type Query_RootSubscriptionStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootTeamTypesArgs = {
  distinctOn?: InputMaybe<Array<TeamTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TeamTypesOrderBy>>;
  where?: InputMaybe<TeamTypesBoolExp>;
};


export type Query_RootTeamTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootTennisRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<TennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TennisRatingScalesOrderBy>>;
  where?: InputMaybe<TennisRatingScalesBoolExp>;
};


export type Query_RootTennisRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTwilioGroupTextsArgs = {
  distinctOn?: InputMaybe<Array<TwilioGroupTextsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TwilioGroupTextsOrderBy>>;
  where?: InputMaybe<TwilioGroupTextsBoolExp>;
};


export type Query_RootTwilioGroupTextsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUploadReviewRequestsArgs = {
  distinctOn?: InputMaybe<Array<UploadReviewRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UploadReviewRequestsOrderBy>>;
  where?: InputMaybe<UploadReviewRequestsBoolExp>;
};


export type Query_RootUploadReviewRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserBlocksArgs = {
  distinctOn?: InputMaybe<Array<UserBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBlocksOrderBy>>;
  where?: InputMaybe<UserBlocksBoolExp>;
};


export type Query_RootUserBlocksByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserCoachServicesArgs = {
  distinctOn?: InputMaybe<Array<UserCoachServicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCoachServicesOrderBy>>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};


export type Query_RootUserCoachServicesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserCommunicationPreferencesArgs = {
  distinctOn?: InputMaybe<Array<UserCommunicationPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCommunicationPreferencesOrderBy>>;
  where?: InputMaybe<UserCommunicationPreferencesBoolExp>;
};


export type Query_RootUserCommunicationPreferencesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserConnectionRequestStatusesArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionRequestStatusesOrderBy>>;
  where?: InputMaybe<UserConnectionRequestStatusesBoolExp>;
};


export type Query_RootUserConnectionRequestStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootUserConnectionRequestsArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionRequestsOrderBy>>;
  where?: InputMaybe<UserConnectionRequestsBoolExp>;
};


export type Query_RootUserConnectionRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionRequestsOrderBy>>;
  where?: InputMaybe<UserConnectionRequestsBoolExp>;
};


export type Query_RootUserConnectionRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserConnectionsArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionsOrderBy>>;
  where?: InputMaybe<UserConnectionsBoolExp>;
};


export type Query_RootUserConnectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionsOrderBy>>;
  where?: InputMaybe<UserConnectionsBoolExp>;
};


export type Query_RootUserConnectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserContentBetaSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<UserContentBetaSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentBetaSubscriptionsOrderBy>>;
  where?: InputMaybe<UserContentBetaSubscriptionsBoolExp>;
};


export type Query_RootUserContentBetaSubscriptionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserContentFilesArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesOrderBy>>;
  where?: InputMaybe<UserContentFilesBoolExp>;
};


export type Query_RootUserContentFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserContentFilesSkillsArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesSkillsOrderBy>>;
  where?: InputMaybe<UserContentFilesSkillsBoolExp>;
};


export type Query_RootUserContentFilesSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserContentSkillsArgs = {
  distinctOn?: InputMaybe<Array<UserContentSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentSkillsOrderBy>>;
  where?: InputMaybe<UserContentSkillsBoolExp>;
};


export type Query_RootUserContentSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserCreditCardsArgs = {
  distinctOn?: InputMaybe<Array<UserCreditCardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCreditCardsOrderBy>>;
  where?: InputMaybe<UserCreditCardsBoolExp>;
};


export type Query_RootUserCreditCardsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserCustomCourtsArgs = {
  distinctOn?: InputMaybe<Array<UserCustomCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCustomCourtsOrderBy>>;
  where?: InputMaybe<UserCustomCourtsBoolExp>;
};


export type Query_RootUserCustomCourtsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserFilesArgs = {
  distinctOn?: InputMaybe<Array<UserFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFilesOrderBy>>;
  where?: InputMaybe<UserFilesBoolExp>;
};


export type Query_RootUserFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserFollowsArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


export type Query_RootUserFollowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


export type Query_RootUserFollowsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserIdentityVerificationsArgs = {
  distinctOn?: InputMaybe<Array<UserIdentityVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserIdentityVerificationsOrderBy>>;
  where?: InputMaybe<UserIdentityVerificationsBoolExp>;
};


export type Query_RootUserIdentityVerificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserImageLogArgs = {
  distinctOn?: InputMaybe<Array<UserImageLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserImageLogOrderBy>>;
  where?: InputMaybe<UserImageLogBoolExp>;
};


export type Query_RootUserImageLogByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserNotificationDetailsArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationDetailsOrderBy>>;
  where?: InputMaybe<UserNotificationDetailsBoolExp>;
};


export type Query_RootUserNotificationDetailsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserNotificationEntitiesArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationEntitiesOrderBy>>;
  where?: InputMaybe<UserNotificationEntitiesBoolExp>;
};


export type Query_RootUserNotificationEntitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserNotificationsArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


export type Query_RootUserNotificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


export type Query_RootUserNotificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserPadelRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserPadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPadelRatingScalesOrderBy>>;
  where?: InputMaybe<UserPadelRatingScalesBoolExp>;
};


export type Query_RootUserPadelRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserPickleballRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserPickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPickleballRatingScalesOrderBy>>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};


export type Query_RootUserPickleballRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserPlayedWithArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithOrderBy>>;
  where?: InputMaybe<UserPlayedWithBoolExp>;
};


export type Query_RootUserPlayedWithAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithOrderBy>>;
  where?: InputMaybe<UserPlayedWithBoolExp>;
};


export type Query_RootUserPlayedWithDismissalsArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithDismissalsOrderBy>>;
  where?: InputMaybe<UserPlayedWithDismissalsBoolExp>;
};


export type Query_RootUserPlayedWithDismissalsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserPlayedWithGamesArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithGamesOrderBy>>;
  where?: InputMaybe<UserPlayedWithGamesBoolExp>;
};


export type Query_RootUserPlayedWithGamesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithGamesOrderBy>>;
  where?: InputMaybe<UserPlayedWithGamesBoolExp>;
};


export type Query_RootUserPlayerFinderAvailabilityArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderAvailabilityOrderBy>>;
  where?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
};


export type Query_RootUserPlayerFinderAvailabilityByPkArgs = {
  dayOfWeek: DayOfWeekEnum;
  timeOfDay: PlayerFinderTimeOfDayEnum;
  userId: Scalars['uuid'];
};


export type Query_RootUserPlayerFinderGoalsArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderGoalsOrderBy>>;
  where?: InputMaybe<UserPlayerFinderGoalsBoolExp>;
};


export type Query_RootUserPlayerFinderGoalsByPkArgs = {
  goal: PlayerFinderGoalsEnum;
  userId: Scalars['uuid'];
};


export type Query_RootUserProfilesArgs = {
  distinctOn?: InputMaybe<Array<UserProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
  where?: InputMaybe<UserProfilesBoolExp>;
};


export type Query_RootUserProfilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
  where?: InputMaybe<UserProfilesBoolExp>;
};


export type Query_RootUserSportsArgs = {
  distinctOn?: InputMaybe<Array<UserSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSportsOrderBy>>;
  where?: InputMaybe<UserSportsBoolExp>;
};


export type Query_RootUserSportsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserTennisRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserTennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTennisRatingScalesOrderBy>>;
  where?: InputMaybe<UserTennisRatingScalesBoolExp>;
};


export type Query_RootUserTennisRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserTermsOfServiceArgs = {
  distinctOn?: InputMaybe<Array<UserTermsOfServiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTermsOfServiceOrderBy>>;
  where?: InputMaybe<UserTermsOfServiceBoolExp>;
};


export type Query_RootUserTermsOfServiceByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserVairConnectionsArgs = {
  distinctOn?: InputMaybe<Array<UserVairConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserVairConnectionsOrderBy>>;
  where?: InputMaybe<UserVairConnectionsBoolExp>;
};


export type Query_RootUserVairConnectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsernamesActiveArgs = {
  distinctOn?: InputMaybe<Array<UsernamesActiveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesActiveOrderBy>>;
  where?: InputMaybe<UsernamesActiveBoolExp>;
};


export type Query_RootUsernamesClaimedArgs = {
  distinctOn?: InputMaybe<Array<UsernamesClaimedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesClaimedOrderBy>>;
  where?: InputMaybe<UsernamesClaimedBoolExp>;
};


export type Query_RootUsernamesClaimedByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Query_RootUsersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsersCoachQualificationsArgs = {
  distinctOn?: InputMaybe<Array<UsersCoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersCoachQualificationsOrderBy>>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};


export type Query_RootUsersCoachQualificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueAccessTypesArgs = {
  distinctOn?: InputMaybe<Array<VenueAccessTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAccessTypesOrderBy>>;
  where?: InputMaybe<VenueAccessTypesBoolExp>;
};


export type Query_RootVenueAccessTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootVenueAdminClaimStatusesArgs = {
  distinctOn?: InputMaybe<Array<VenueAdminClaimStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAdminClaimStatusesOrderBy>>;
  where?: InputMaybe<VenueAdminClaimStatusesBoolExp>;
};


export type Query_RootVenueAdminClaimStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootVenueAdminClaimsArgs = {
  distinctOn?: InputMaybe<Array<VenueAdminClaimsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAdminClaimsOrderBy>>;
  where?: InputMaybe<VenueAdminClaimsBoolExp>;
};


export type Query_RootVenueAdminClaimsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<VenueAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAmenitiesOrderBy>>;
  where?: InputMaybe<VenueAmenitiesBoolExp>;
};


export type Query_RootVenueAmenitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueBookingConfigVersionsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConfigVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConfigVersionsOrderBy>>;
  where?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
};


export type Query_RootVenueBookingConfigVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueBookingConnectionCheckStatusesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionCheckStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionCheckStatusesOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionCheckStatusesBoolExp>;
};


export type Query_RootVenueBookingConnectionCheckStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootVenueBookingConnectionChecksArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionChecksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionChecksOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
};


export type Query_RootVenueBookingConnectionChecksByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueBookingCourtRatesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingCourtRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingCourtRatesOrderBy>>;
  where?: InputMaybe<VenueBookingCourtRatesBoolExp>;
};


export type Query_RootVenueBookingCourtRatesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueBookingIntegrationsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingIntegrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingIntegrationsOrderBy>>;
  where?: InputMaybe<VenueBookingIntegrationsBoolExp>;
};


export type Query_RootVenueBookingIntegrationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueBookingRuleTiersArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRuleTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRuleTiersOrderBy>>;
  where?: InputMaybe<VenueBookingRuleTiersBoolExp>;
};


export type Query_RootVenueBookingRuleTiersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueBookingRulesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRulesOrderBy>>;
  where?: InputMaybe<VenueBookingRulesBoolExp>;
};


export type Query_RootVenueBookingRulesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueBookingWindowsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingWindowsOrderBy>>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};


export type Query_RootVenueBookingWindowsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueCourtSurfacesArgs = {
  distinctOn?: InputMaybe<Array<VenueCourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCourtSurfacesOrderBy>>;
  where?: InputMaybe<VenueCourtSurfacesBoolExp>;
};


export type Query_RootVenueCourtSurfacesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueCustomAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<VenueCustomAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCustomAmenitiesOrderBy>>;
  where?: InputMaybe<VenueCustomAmenitiesBoolExp>;
};


export type Query_RootVenueCustomAmenitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueEquipmentArgs = {
  distinctOn?: InputMaybe<Array<VenueEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueEquipmentOrderBy>>;
  where?: InputMaybe<VenueEquipmentBoolExp>;
};


export type Query_RootVenueEquipmentByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueFacilityTypesArgs = {
  distinctOn?: InputMaybe<Array<VenueFacilityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFacilityTypesOrderBy>>;
  where?: InputMaybe<VenueFacilityTypesBoolExp>;
};


export type Query_RootVenueFacilityTypesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootVenueFaqsArgs = {
  distinctOn?: InputMaybe<Array<VenueFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFaqsOrderBy>>;
  where?: InputMaybe<VenueFaqsBoolExp>;
};


export type Query_RootVenueFaqsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueFollowsArgs = {
  distinctOn?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFollowsOrderBy>>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};


export type Query_RootVenueFollowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFollowsOrderBy>>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};


export type Query_RootVenueFollowsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueImagesArgs = {
  distinctOn?: InputMaybe<Array<VenueImagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueImagesOrderBy>>;
  where?: InputMaybe<VenueImagesBoolExp>;
};


export type Query_RootVenueImagesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueLinesArgs = {
  distinctOn?: InputMaybe<Array<VenueLinesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueLinesOrderBy>>;
  where?: InputMaybe<VenueLinesBoolExp>;
};


export type Query_RootVenueLinesByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootVenueNetsArgs = {
  distinctOn?: InputMaybe<Array<VenueNetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueNetsOrderBy>>;
  where?: InputMaybe<VenueNetsBoolExp>;
};


export type Query_RootVenueNetsByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootVenuePartnerBookingStatusesArgs = {
  distinctOn?: InputMaybe<Array<VenuePartnerBookingStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuePartnerBookingStatusesOrderBy>>;
  where?: InputMaybe<VenuePartnerBookingStatusesBoolExp>;
};


export type Query_RootVenueStaffCoachesArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


export type Query_RootVenueStaffCoachesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


export type Query_RootVenueStaffCoachesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenuesArgs = {
  distinctOn?: InputMaybe<Array<VenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuesOrderBy>>;
  where?: InputMaybe<VenuesBoolExp>;
};


export type Query_RootVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


export type Query_RootVideoAnalysisAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


export type Query_RootVideoAnalysisByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisCommentsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisCommentsBoolExp>;
};


export type Query_RootVideoAnalysisCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisFilesArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisFilesOrderBy>>;
  where?: InputMaybe<VideoAnalysisFilesBoolExp>;
};


export type Query_RootVideoAnalysisFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisOrderItemsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderItemsOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
};


export type Query_RootVideoAnalysisOrderItemsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisOrdersArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrdersOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrdersBoolExp>;
};


export type Query_RootVideoAnalysisOrdersByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisRequestedSkillsReviewArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewOrderBy>>;
  where?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
};


export type Query_RootVideoAnalysisRequestedSkillsReviewByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisSkillsCommentsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSkillsCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSkillsCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};


export type Query_RootVideoAnalysisSkillsCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoAnalysisSubmissionLogArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSubmissionLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSubmissionLogOrderBy>>;
  where?: InputMaybe<VideoAnalysisSubmissionLogBoolExp>;
};


export type Query_RootVideoAnalysisSubmissionLogByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVideoLessonSkillsArgs = {
  distinctOn?: InputMaybe<Array<VideoLessonSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoLessonSkillsOrderBy>>;
  where?: InputMaybe<VideoLessonSkillsBoolExp>;
};


export type Query_RootVideoLessonSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWinReasonsArgs = {
  distinctOn?: InputMaybe<Array<WinReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WinReasonsOrderBy>>;
  where?: InputMaybe<WinReasonsBoolExp>;
};


export type Query_RootWinReasonsByPkArgs = {
  value: Scalars['String'];
};

export type ReviewsAggregateBoolExpBool_And = {
  arguments: ReviewsSelectColumnReviewsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ReviewsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ReviewsAggregateBoolExpBool_Or = {
  arguments: ReviewsSelectColumnReviewsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ReviewsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ReviewsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ReviewsBoolExp>;
  predicate: IntComparisonExp;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: InputMaybe<Scalars['Boolean']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "amenities" */
  amenities: Array<Amenities>;
  /** fetch data from the table: "amenities" using primary key columns */
  amenitiesByPk?: Maybe<Amenities>;
  /** fetch data from the table in a streaming manner: "amenities" */
  amenitiesStream: Array<Amenities>;
  /** fetch data from the table: "app_personas" */
  appPersonas: Array<AppPersonas>;
  /** fetch data from the table: "app_personas" using primary key columns */
  appPersonasByPk?: Maybe<AppPersonas>;
  /** fetch data from the table in a streaming manner: "app_personas" */
  appPersonasStream: Array<AppPersonas>;
  /** fetch data from the table: "app_pings" */
  appPings: Array<AppPings>;
  /** fetch data from the table: "app_pings" using primary key columns */
  appPingsByPk?: Maybe<AppPings>;
  /** fetch data from the table in a streaming manner: "app_pings" */
  appPingsStream: Array<AppPings>;
  /** fetch data from the table: "ball_types" */
  ballTypes: Array<BallTypes>;
  /** fetch data from the table: "ball_types" using primary key columns */
  ballTypesByPk?: Maybe<BallTypes>;
  /** fetch data from the table in a streaming manner: "ball_types" */
  ballTypesStream: Array<BallTypes>;
  /** fetch data from the table: "birthday_visibility" */
  birthdayVisibility: Array<BirthdayVisibility>;
  /** fetch data from the table: "birthday_visibility" using primary key columns */
  birthdayVisibilityByPk?: Maybe<BirthdayVisibility>;
  /** fetch data from the table in a streaming manner: "birthday_visibility" */
  birthdayVisibilityStream: Array<BirthdayVisibility>;
  /** fetch data from the table: "booking_config_change_types" */
  bookingConfigChangeTypes: Array<BookingConfigChangeTypes>;
  /** fetch data from the table: "booking_config_change_types" using primary key columns */
  bookingConfigChangeTypesByPk?: Maybe<BookingConfigChangeTypes>;
  /** fetch data from the table in a streaming manner: "booking_config_change_types" */
  bookingConfigChangeTypesStream: Array<BookingConfigChangeTypes>;
  /** fetch data from the table: "booking_connection_statuses" */
  bookingConnectionStatuses: Array<BookingConnectionStatuses>;
  /** fetch data from the table: "booking_connection_statuses" using primary key columns */
  bookingConnectionStatusesByPk?: Maybe<BookingConnectionStatuses>;
  /** fetch data from the table in a streaming manner: "booking_connection_statuses" */
  bookingConnectionStatusesStream: Array<BookingConnectionStatuses>;
  /** fetch data from the table: "booking_integration_statuses" */
  bookingIntegrationStatuses: Array<BookingIntegrationStatuses>;
  /** fetch data from the table: "booking_integration_statuses" using primary key columns */
  bookingIntegrationStatusesByPk?: Maybe<BookingIntegrationStatuses>;
  /** fetch data from the table in a streaming manner: "booking_integration_statuses" */
  bookingIntegrationStatusesStream: Array<BookingIntegrationStatuses>;
  /** fetch data from the table: "booking_inventory_types" */
  bookingInventoryTypes: Array<BookingInventoryTypes>;
  /** fetch data from the table: "booking_inventory_types" using primary key columns */
  bookingInventoryTypesByPk?: Maybe<BookingInventoryTypes>;
  /** fetch data from the table in a streaming manner: "booking_inventory_types" */
  bookingInventoryTypesStream: Array<BookingInventoryTypes>;
  /** fetch data from the table: "booking_schedule_modes" */
  bookingScheduleModes: Array<BookingScheduleModes>;
  /** fetch data from the table: "booking_schedule_modes" using primary key columns */
  bookingScheduleModesByPk?: Maybe<BookingScheduleModes>;
  /** fetch data from the table in a streaming manner: "booking_schedule_modes" */
  bookingScheduleModesStream: Array<BookingScheduleModes>;
  /** fetch data from the table: "booking_systems" */
  bookingSystems: Array<BookingSystems>;
  /** fetch data from the table: "booking_systems" using primary key columns */
  bookingSystemsByPk?: Maybe<BookingSystems>;
  /** fetch data from the table in a streaming manner: "booking_systems" */
  bookingSystemsStream: Array<BookingSystems>;
  /** fetch data from the table: "booking_window_kinds" */
  bookingWindowKinds: Array<BookingWindowKinds>;
  /** fetch data from the table: "booking_window_kinds" using primary key columns */
  bookingWindowKindsByPk?: Maybe<BookingWindowKinds>;
  /** fetch data from the table in a streaming manner: "booking_window_kinds" */
  bookingWindowKindsStream: Array<BookingWindowKinds>;
  /** fetch data from the table: "boost_channels" */
  boostChannels: Array<BoostChannels>;
  /** fetch data from the table: "boost_channels" using primary key columns */
  boostChannelsByPk?: Maybe<BoostChannels>;
  /** fetch data from the table in a streaming manner: "boost_channels" */
  boostChannelsStream: Array<BoostChannels>;
  /** fetch data from the table: "boost_statuses" */
  boostStatuses: Array<BoostStatuses>;
  /** fetch data from the table: "boost_statuses" using primary key columns */
  boostStatusesByPk?: Maybe<BoostStatuses>;
  /** fetch data from the table in a streaming manner: "boost_statuses" */
  boostStatusesStream: Array<BoostStatuses>;
  /** fetch data from the table: "boosts" */
  boosts: Array<Boosts>;
  /** fetch data from the table: "boosts" using primary key columns */
  boostsByPk?: Maybe<Boosts>;
  /** fetch data from the table in a streaming manner: "boosts" */
  boostsStream: Array<Boosts>;
  /** fetch data from the table: "bracket_ranking_mechanism" */
  bracketRankingMechanism: Array<BracketRankingMechanism>;
  /** fetch data from the table: "bracket_ranking_mechanism" using primary key columns */
  bracketRankingMechanismByPk?: Maybe<BracketRankingMechanism>;
  /** fetch data from the table in a streaming manner: "bracket_ranking_mechanism" */
  bracketRankingMechanismStream: Array<BracketRankingMechanism>;
  /** fetch data from the table: "calendar_accounts" */
  calendarAccounts: Array<CalendarAccounts>;
  /** fetch data from the table: "calendar_accounts" using primary key columns */
  calendarAccountsByPk?: Maybe<CalendarAccounts>;
  /** fetch data from the table in a streaming manner: "calendar_accounts" */
  calendarAccountsStream: Array<CalendarAccounts>;
  /** An array relationship */
  calendarPreferences: Array<CalendarPreferences>;
  /** fetch data from the table: "calendar_preferences" using primary key columns */
  calendarPreferencesByPk?: Maybe<CalendarPreferences>;
  /** fetch data from the table in a streaming manner: "calendar_preferences" */
  calendarPreferencesStream: Array<CalendarPreferences>;
  /** An array relationship */
  cities: Array<Cities>;
  /** fetch data from the table: "cities" using primary key columns */
  citiesByPk?: Maybe<Cities>;
  /** fetch data from the table in a streaming manner: "cities" */
  citiesStream: Array<Cities>;
  /** An array relationship */
  coachAvailability: Array<CoachAvailability>;
  /** fetch data from the table: "coach_availability" using primary key columns */
  coachAvailabilityByPk?: Maybe<CoachAvailability>;
  /** fetch data from the table in a streaming manner: "coach_availability" */
  coachAvailabilityStream: Array<CoachAvailability>;
  /** fetch data from the table: "coach_booking_requests" */
  coachBookingRequests: Array<CoachBookingRequests>;
  /** fetch data from the table: "coach_booking_requests" using primary key columns */
  coachBookingRequestsByPk?: Maybe<CoachBookingRequests>;
  /** fetch data from the table in a streaming manner: "coach_booking_requests" */
  coachBookingRequestsStream: Array<CoachBookingRequests>;
  /** An array relationship */
  coachFaqs: Array<CoachFaqs>;
  /** fetch data from the table: "coach_faqs" using primary key columns */
  coachFaqsByPk?: Maybe<CoachFaqs>;
  /** fetch data from the table in a streaming manner: "coach_faqs" */
  coachFaqsStream: Array<CoachFaqs>;
  /** An array relationship */
  coachLessonAgeGroups: Array<CoachLessonAgeGroups>;
  /** fetch data from the table: "coach_lesson_age_groups" using primary key columns */
  coachLessonAgeGroupsByPk?: Maybe<CoachLessonAgeGroups>;
  /** fetch data from the table in a streaming manner: "coach_lesson_age_groups" */
  coachLessonAgeGroupsStream: Array<CoachLessonAgeGroups>;
  /** An array relationship */
  coachLessonSkillLevels: Array<CoachLessonSkillLevels>;
  /** fetch data from the table: "coach_lesson_skill_levels" using primary key columns */
  coachLessonSkillLevelsByPk?: Maybe<CoachLessonSkillLevels>;
  /** fetch data from the table in a streaming manner: "coach_lesson_skill_levels" */
  coachLessonSkillLevelsStream: Array<CoachLessonSkillLevels>;
  /** fetch data from the table: "coach_qualification_groups" */
  coachQualificationGroups: Array<CoachQualificationGroups>;
  /** fetch data from the table: "coach_qualification_groups" using primary key columns */
  coachQualificationGroupsByPk?: Maybe<CoachQualificationGroups>;
  /** fetch data from the table in a streaming manner: "coach_qualification_groups" */
  coachQualificationGroupsStream: Array<CoachQualificationGroups>;
  /** fetch data from the table: "coach_qualifications" */
  coachQualifications: Array<CoachQualifications>;
  /** fetch data from the table: "coach_qualifications" using primary key columns */
  coachQualificationsByPk?: Maybe<CoachQualifications>;
  /** fetch data from the table in a streaming manner: "coach_qualifications" */
  coachQualificationsStream: Array<CoachQualifications>;
  /** fetch data from the table: "coach_sport_statuses" */
  coachSportStatuses: Array<CoachSportStatuses>;
  /** fetch data from the table: "coach_sport_statuses" using primary key columns */
  coachSportStatusesByPk?: Maybe<CoachSportStatuses>;
  /** fetch data from the table in a streaming manner: "coach_sport_statuses" */
  coachSportStatusesStream: Array<CoachSportStatuses>;
  /** An array relationship */
  coachSports: Array<CoachSports>;
  /** fetch data from the table: "coach_sports" using primary key columns */
  coachSportsByPk?: Maybe<CoachSports>;
  /** fetch data from the table in a streaming manner: "coach_sports" */
  coachSportsStream: Array<CoachSports>;
  /** An array relationship */
  coachStarterProfiles: Array<CoachStarterProfiles>;
  /** fetch data from the table: "coach_starter_profiles" using primary key columns */
  coachStarterProfilesByPk?: Maybe<CoachStarterProfiles>;
  /** fetch data from the table in a streaming manner: "coach_starter_profiles" */
  coachStarterProfilesStream: Array<CoachStarterProfiles>;
  /** fetch data from the table: "coach_status" */
  coachStatus: Array<CoachStatus>;
  /** fetch data from the table: "coach_status" using primary key columns */
  coachStatusByPk?: Maybe<CoachStatus>;
  /** fetch data from the table in a streaming manner: "coach_status" */
  coachStatusStream: Array<CoachStatus>;
  /** fetch data from the table: "comment_vote" */
  commentVote: Array<CommentVote>;
  /** fetch data from the table: "comment_vote" using primary key columns */
  commentVoteByPk?: Maybe<CommentVote>;
  /** fetch data from the table in a streaming manner: "comment_vote" */
  commentVoteStream: Array<CommentVote>;
  /** fetch data from the table: "communication_preference_statuses" */
  communicationPreferenceStatuses: Array<CommunicationPreferenceStatuses>;
  /** fetch data from the table: "communication_preference_statuses" using primary key columns */
  communicationPreferenceStatusesByPk?: Maybe<CommunicationPreferenceStatuses>;
  /** fetch data from the table in a streaming manner: "communication_preference_statuses" */
  communicationPreferenceStatusesStream: Array<CommunicationPreferenceStatuses>;
  /** fetch data from the table: "competition_formats" */
  competitionFormats: Array<CompetitionFormats>;
  /** fetch data from the table: "competition_formats" using primary key columns */
  competitionFormatsByPk?: Maybe<CompetitionFormats>;
  /** fetch data from the table in a streaming manner: "competition_formats" */
  competitionFormatsStream: Array<CompetitionFormats>;
  /** fetch data from the table: "competition_gender" */
  competitionGender: Array<CompetitionGender>;
  /** fetch data from the table: "competition_gender" using primary key columns */
  competitionGenderByPk?: Maybe<CompetitionGender>;
  /** fetch data from the table in a streaming manner: "competition_gender" */
  competitionGenderStream: Array<CompetitionGender>;
  /** fetch data from the table: "content_reports" */
  contentReports: Array<ContentReports>;
  /** fetch data from the table: "content_reports" using primary key columns */
  contentReportsByPk?: Maybe<ContentReports>;
  /** fetch data from the table in a streaming manner: "content_reports" */
  contentReportsStream: Array<ContentReports>;
  /** fetch data from the table: "conversation_participants" */
  conversationParticipants: Array<ConversationParticipants>;
  /** fetch data from the table: "conversation_participants" using primary key columns */
  conversationParticipantsByPk?: Maybe<ConversationParticipants>;
  /** fetch data from the table in a streaming manner: "conversation_participants" */
  conversationParticipantsStream: Array<ConversationParticipants>;
  /** fetch data from the table: "conversation_types" */
  conversationTypes: Array<ConversationTypes>;
  /** fetch data from the table: "conversation_types" using primary key columns */
  conversationTypesByPk?: Maybe<ConversationTypes>;
  /** fetch data from the table in a streaming manner: "conversation_types" */
  conversationTypesStream: Array<ConversationTypes>;
  /** An array relationship */
  conversations: Array<Conversations>;
  /** fetch data from the table: "conversations" using primary key columns */
  conversationsByPk?: Maybe<Conversations>;
  /** fetch data from the table in a streaming manner: "conversations" */
  conversationsStream: Array<Conversations>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch data from the table: "countries" using primary key columns */
  countriesByPk?: Maybe<Countries>;
  /** fetch data from the table in a streaming manner: "countries" */
  countriesStream: Array<Countries>;
  /** fetch data from the table: "country_subdivisions" */
  countrySubdivisions: Array<CountrySubdivisions>;
  /** fetch data from the table: "country_subdivisions" using primary key columns */
  countrySubdivisionsByPk?: Maybe<CountrySubdivisions>;
  /** fetch data from the table in a streaming manner: "country_subdivisions" */
  countrySubdivisionsStream: Array<CountrySubdivisions>;
  /** fetch data from the table: "court_surfaces" */
  courtSurfaces: Array<CourtSurfaces>;
  /** fetch data from the table: "court_surfaces" using primary key columns */
  courtSurfacesByPk?: Maybe<CourtSurfaces>;
  /** fetch data from the table in a streaming manner: "court_surfaces" */
  courtSurfacesStream: Array<CourtSurfaces>;
  /** fetch data from the table: "day_of_week" */
  dayOfWeek: Array<DayOfWeek>;
  /** fetch data from the table: "day_of_week" using primary key columns */
  dayOfWeekByPk?: Maybe<DayOfWeek>;
  /** fetch data from the table in a streaming manner: "day_of_week" */
  dayOfWeekStream: Array<DayOfWeek>;
  /** fetch data from the table: "engagement_entity_types" */
  engagementEntityTypes: Array<EngagementEntityTypes>;
  /** fetch data from the table: "engagement_entity_types" using primary key columns */
  engagementEntityTypesByPk?: Maybe<EngagementEntityTypes>;
  /** fetch data from the table in a streaming manner: "engagement_entity_types" */
  engagementEntityTypesStream: Array<EngagementEntityTypes>;
  /** fetch data from the table: "engagement_event_types" */
  engagementEventTypes: Array<EngagementEventTypes>;
  /** fetch data from the table: "engagement_event_types" using primary key columns */
  engagementEventTypesByPk?: Maybe<EngagementEventTypes>;
  /** fetch data from the table in a streaming manner: "engagement_event_types" */
  engagementEventTypesStream: Array<EngagementEventTypes>;
  /** fetch data from the table: "engagement_sources" */
  engagementSources: Array<EngagementSources>;
  /** fetch data from the table: "engagement_sources" using primary key columns */
  engagementSourcesByPk?: Maybe<EngagementSources>;
  /** fetch data from the table in a streaming manner: "engagement_sources" */
  engagementSourcesStream: Array<EngagementSources>;
  /** fetch data from the table: "equipment_availabilities" */
  equipmentAvailabilities: Array<EquipmentAvailabilities>;
  /** fetch data from the table: "equipment_availabilities" using primary key columns */
  equipmentAvailabilitiesByPk?: Maybe<EquipmentAvailabilities>;
  /** fetch data from the table in a streaming manner: "equipment_availabilities" */
  equipmentAvailabilitiesStream: Array<EquipmentAvailabilities>;
  /** fetch data from the table: "event_accepted_play_requests" */
  eventAcceptedPlayRequests: Array<EventAcceptedPlayRequests>;
  /** fetch aggregated fields from the table: "event_accepted_play_requests" */
  eventAcceptedPlayRequestsAggregate: EventAcceptedPlayRequestsAggregate;
  /** fetch data from the table in a streaming manner: "event_accepted_play_requests" */
  eventAcceptedPlayRequestsStream: Array<EventAcceptedPlayRequests>;
  /** fetch data from the table: "event_age_groups" */
  eventAgeGroups: Array<EventAgeGroups>;
  /** fetch data from the table: "event_age_groups" using primary key columns */
  eventAgeGroupsByPk?: Maybe<EventAgeGroups>;
  /** fetch data from the table in a streaming manner: "event_age_groups" */
  eventAgeGroupsStream: Array<EventAgeGroups>;
  /** fetch data from the table: "event_collections" */
  eventCollections: Array<EventCollections>;
  /** fetch data from the table: "event_collections" using primary key columns */
  eventCollectionsByPk?: Maybe<EventCollections>;
  /** fetch data from the table in a streaming manner: "event_collections" */
  eventCollectionsStream: Array<EventCollections>;
  /** fetch data from the table: "event_competitiveness" */
  eventCompetitiveness: Array<EventCompetitiveness>;
  /** fetch data from the table: "event_competitiveness" using primary key columns */
  eventCompetitivenessByPk?: Maybe<EventCompetitiveness>;
  /** fetch data from the table in a streaming manner: "event_competitiveness" */
  eventCompetitivenessStream: Array<EventCompetitiveness>;
  /** fetch data from the table: "event_contact_details" */
  eventContactDetails: Array<EventContactDetails>;
  /** fetch data from the table: "event_contact_details" using primary key columns */
  eventContactDetailsByPk?: Maybe<EventContactDetails>;
  /** fetch data from the table in a streaming manner: "event_contact_details" */
  eventContactDetailsStream: Array<EventContactDetails>;
  /** fetch data from the table: "event_coupon_groups" */
  eventCouponGroups: Array<EventCouponGroups>;
  /** fetch data from the table: "event_coupon_groups" using primary key columns */
  eventCouponGroupsByPk?: Maybe<EventCouponGroups>;
  /** fetch data from the table in a streaming manner: "event_coupon_groups" */
  eventCouponGroupsStream: Array<EventCouponGroups>;
  /** fetch data from the table: "event_coupon_redemptions" */
  eventCouponRedemptions: Array<EventCouponRedemptions>;
  /** fetch aggregated fields from the table: "event_coupon_redemptions" */
  eventCouponRedemptionsAggregate: EventCouponRedemptionsAggregate;
  /** fetch data from the table: "event_coupon_redemptions" using primary key columns */
  eventCouponRedemptionsByPk?: Maybe<EventCouponRedemptions>;
  /** fetch data from the table in a streaming manner: "event_coupon_redemptions" */
  eventCouponRedemptionsStream: Array<EventCouponRedemptions>;
  /** fetch data from the table: "event_coupon_source" */
  eventCouponSource: Array<EventCouponSource>;
  /** fetch data from the table: "event_coupon_source" using primary key columns */
  eventCouponSourceByPk?: Maybe<EventCouponSource>;
  /** fetch data from the table in a streaming manner: "event_coupon_source" */
  eventCouponSourceStream: Array<EventCouponSource>;
  /** fetch data from the table: "event_coupon_type" */
  eventCouponType: Array<EventCouponType>;
  /** fetch data from the table: "event_coupon_type" using primary key columns */
  eventCouponTypeByPk?: Maybe<EventCouponType>;
  /** fetch data from the table in a streaming manner: "event_coupon_type" */
  eventCouponTypeStream: Array<EventCouponType>;
  /** fetch data from the table: "event_coupons" */
  eventCoupons: Array<EventCoupons>;
  /** fetch data from the table: "event_coupons" using primary key columns */
  eventCouponsByPk?: Maybe<EventCoupons>;
  /** fetch data from the table in a streaming manner: "event_coupons" */
  eventCouponsStream: Array<EventCoupons>;
  /** fetch data from the table: "event_court_statuses" */
  eventCourtStatuses: Array<EventCourtStatuses>;
  /** fetch data from the table: "event_court_statuses" using primary key columns */
  eventCourtStatusesByPk?: Maybe<EventCourtStatuses>;
  /** fetch data from the table in a streaming manner: "event_court_statuses" */
  eventCourtStatusesStream: Array<EventCourtStatuses>;
  /** fetch data from the table: "event_courts" */
  eventCourts: Array<EventCourts>;
  /** fetch data from the table: "event_courts" using primary key columns */
  eventCourtsByPk?: Maybe<EventCourts>;
  /** fetch data from the table in a streaming manner: "event_courts" */
  eventCourtsStream: Array<EventCourts>;
  /** fetch data from the table: "event_faqs" */
  eventFaqs: Array<EventFaqs>;
  /** fetch data from the table: "event_faqs" using primary key columns */
  eventFaqsByPk?: Maybe<EventFaqs>;
  /** fetch data from the table in a streaming manner: "event_faqs" */
  eventFaqsStream: Array<EventFaqs>;
  /** fetch data from the table: "event_game_scores" */
  eventGameScores: Array<EventGameScores>;
  /** fetch data from the table: "event_game_scores" using primary key columns */
  eventGameScoresByPk?: Maybe<EventGameScores>;
  /** fetch data from the table in a streaming manner: "event_game_scores" */
  eventGameScoresStream: Array<EventGameScores>;
  /** fetch data from the table: "event_group_formats" */
  eventGroupFormats: Array<EventGroupFormats>;
  /** fetch data from the table: "event_group_formats" using primary key columns */
  eventGroupFormatsByPk?: Maybe<EventGroupFormats>;
  /** fetch data from the table in a streaming manner: "event_group_formats" */
  eventGroupFormatsStream: Array<EventGroupFormats>;
  /** fetch data from the table: "event_group_merges" */
  eventGroupMerges: Array<EventGroupMerges>;
  /** fetch data from the table: "event_group_merges" using primary key columns */
  eventGroupMergesByPk?: Maybe<EventGroupMerges>;
  /** fetch data from the table in a streaming manner: "event_group_merges" */
  eventGroupMergesStream: Array<EventGroupMerges>;
  /** fetch data from the table: "event_group_pools" */
  eventGroupPools: Array<EventGroupPools>;
  /** fetch data from the table: "event_group_pools" using primary key columns */
  eventGroupPoolsByPk?: Maybe<EventGroupPools>;
  /** fetch data from the table in a streaming manner: "event_group_pools" */
  eventGroupPoolsStream: Array<EventGroupPools>;
  /** fetch data from the table: "event_group_rating_scales" */
  eventGroupRatingScales: Array<EventGroupRatingScales>;
  /** fetch data from the table: "event_group_rating_scales" using primary key columns */
  eventGroupRatingScalesByPk?: Maybe<EventGroupRatingScales>;
  /** fetch data from the table in a streaming manner: "event_group_rating_scales" */
  eventGroupRatingScalesStream: Array<EventGroupRatingScales>;
  /** fetch data from the table: "event_group_registration_statuses" */
  eventGroupRegistrationStatuses: Array<EventGroupRegistrationStatuses>;
  /** fetch data from the table: "event_group_registration_statuses" using primary key columns */
  eventGroupRegistrationStatusesByPk?: Maybe<EventGroupRegistrationStatuses>;
  /** fetch data from the table in a streaming manner: "event_group_registration_statuses" */
  eventGroupRegistrationStatusesStream: Array<EventGroupRegistrationStatuses>;
  /** fetch data from the table: "event_group_registrations" */
  eventGroupRegistrations: Array<EventGroupRegistrations>;
  /** fetch data from the table: "event_group_registrations" using primary key columns */
  eventGroupRegistrationsByPk?: Maybe<EventGroupRegistrations>;
  /** fetch data from the table in a streaming manner: "event_group_registrations" */
  eventGroupRegistrationsStream: Array<EventGroupRegistrations>;
  /** fetch data from the table: "event_group_sequence_seeding" */
  eventGroupSequenceSeeding: Array<EventGroupSequenceSeeding>;
  /** fetch data from the table: "event_group_sequence_seeding" using primary key columns */
  eventGroupSequenceSeedingByPk?: Maybe<EventGroupSequenceSeeding>;
  /** fetch data from the table in a streaming manner: "event_group_sequence_seeding" */
  eventGroupSequenceSeedingStream: Array<EventGroupSequenceSeeding>;
  /** fetch data from the table: "event_group_sequences" */
  eventGroupSequences: Array<EventGroupSequences>;
  /** fetch data from the table: "event_group_sequences" using primary key columns */
  eventGroupSequencesByPk?: Maybe<EventGroupSequences>;
  /** fetch data from the table in a streaming manner: "event_group_sequences" */
  eventGroupSequencesStream: Array<EventGroupSequences>;
  /** fetch data from the table: "event_group_time_slots" */
  eventGroupTimeSlots: Array<EventGroupTimeSlots>;
  /** fetch data from the table: "event_group_time_slots" using primary key columns */
  eventGroupTimeSlotsByPk?: Maybe<EventGroupTimeSlots>;
  /** fetch data from the table in a streaming manner: "event_group_time_slots" */
  eventGroupTimeSlotsStream: Array<EventGroupTimeSlots>;
  /** fetch data from the table: "event_groups" */
  eventGroups: Array<EventGroups>;
  /** fetch data from the table: "event_groups" using primary key columns */
  eventGroupsByPk?: Maybe<EventGroups>;
  /** fetch data from the table in a streaming manner: "event_groups" */
  eventGroupsStream: Array<EventGroups>;
  /** fetch data from the table: "event_invitation_statuses" */
  eventInvitationStatuses: Array<EventInvitationStatuses>;
  /** fetch data from the table: "event_invitation_statuses" using primary key columns */
  eventInvitationStatusesByPk?: Maybe<EventInvitationStatuses>;
  /** fetch data from the table in a streaming manner: "event_invitation_statuses" */
  eventInvitationStatusesStream: Array<EventInvitationStatuses>;
  /** fetch data from the table: "event_invitation_types" */
  eventInvitationTypes: Array<EventInvitationTypes>;
  /** fetch data from the table: "event_invitation_types" using primary key columns */
  eventInvitationTypesByPk?: Maybe<EventInvitationTypes>;
  /** fetch data from the table in a streaming manner: "event_invitation_types" */
  eventInvitationTypesStream: Array<EventInvitationTypes>;
  /** fetch data from the table: "event_invitations" */
  eventInvitations: Array<EventInvitations>;
  /** fetch data from the table: "event_invitations" using primary key columns */
  eventInvitationsByPk?: Maybe<EventInvitations>;
  /** fetch data from the table in a streaming manner: "event_invitations" */
  eventInvitationsStream: Array<EventInvitations>;
  /** fetch data from the table: "event_listing_fees" */
  eventListingFees: Array<EventListingFees>;
  /** fetch data from the table: "event_listing_fees" using primary key columns */
  eventListingFeesByPk?: Maybe<EventListingFees>;
  /** fetch data from the table in a streaming manner: "event_listing_fees" */
  eventListingFeesStream: Array<EventListingFees>;
  /** fetch data from the table: "event_match_games" */
  eventMatchGames: Array<EventMatchGames>;
  /** fetch data from the table: "event_match_games" using primary key columns */
  eventMatchGamesByPk?: Maybe<EventMatchGames>;
  /** fetch data from the table in a streaming manner: "event_match_games" */
  eventMatchGamesStream: Array<EventMatchGames>;
  /** fetch data from the table: "event_matches" */
  eventMatches: Array<EventMatches>;
  /** fetch data from the table: "event_matches" using primary key columns */
  eventMatchesByPk?: Maybe<EventMatches>;
  /** fetch data from the table in a streaming manner: "event_matches" */
  eventMatchesStream: Array<EventMatches>;
  /** fetch data from the table: "event_matches_teams" */
  eventMatchesTeams: Array<EventMatchesTeams>;
  /** fetch data from the table: "event_matches_teams" using primary key columns */
  eventMatchesTeamsByPk?: Maybe<EventMatchesTeams>;
  /** fetch data from the table in a streaming manner: "event_matches_teams" */
  eventMatchesTeamsStream: Array<EventMatchesTeams>;
  /** fetch data from the table: "event_organizer_account_types" */
  eventOrganizerAccountTypes: Array<EventOrganizerAccountTypes>;
  /** fetch data from the table: "event_organizer_account_types" using primary key columns */
  eventOrganizerAccountTypesByPk?: Maybe<EventOrganizerAccountTypes>;
  /** fetch data from the table in a streaming manner: "event_organizer_account_types" */
  eventOrganizerAccountTypesStream: Array<EventOrganizerAccountTypes>;
  /** fetch data from the table: "event_player_invite_statuses" */
  eventPlayerInviteStatuses: Array<EventPlayerInviteStatuses>;
  /** fetch data from the table: "event_player_invite_statuses" using primary key columns */
  eventPlayerInviteStatusesByPk?: Maybe<EventPlayerInviteStatuses>;
  /** fetch data from the table in a streaming manner: "event_player_invite_statuses" */
  eventPlayerInviteStatusesStream: Array<EventPlayerInviteStatuses>;
  /** fetch data from the table: "event_player_invites" */
  eventPlayerInvites: Array<EventPlayerInvites>;
  /** fetch aggregated fields from the table: "event_player_invites" */
  eventPlayerInvitesAggregate: EventPlayerInvitesAggregate;
  /** fetch data from the table: "event_player_invites" using primary key columns */
  eventPlayerInvitesByPk?: Maybe<EventPlayerInvites>;
  /** fetch data from the table in a streaming manner: "event_player_invites" */
  eventPlayerInvitesStream: Array<EventPlayerInvites>;
  /** fetch data from the table: "event_pool_rounds" */
  eventPoolRounds: Array<EventPoolRounds>;
  /** fetch data from the table: "event_pool_rounds" using primary key columns */
  eventPoolRoundsByPk?: Maybe<EventPoolRounds>;
  /** fetch data from the table in a streaming manner: "event_pool_rounds" */
  eventPoolRoundsStream: Array<EventPoolRounds>;
  /** fetch data from the table: "event_pools_teams" */
  eventPoolsTeams: Array<EventPoolsTeams>;
  /** fetch data from the table: "event_pools_teams" using primary key columns */
  eventPoolsTeamsByPk?: Maybe<EventPoolsTeams>;
  /** fetch data from the table in a streaming manner: "event_pools_teams" */
  eventPoolsTeamsStream: Array<EventPoolsTeams>;
  /** fetch data from the table: "event_privacy" */
  eventPrivacy: Array<EventPrivacy>;
  /** fetch data from the table: "event_privacy" using primary key columns */
  eventPrivacyByPk?: Maybe<EventPrivacy>;
  /** fetch data from the table in a streaming manner: "event_privacy" */
  eventPrivacyStream: Array<EventPrivacy>;
  /** fetch data from the table: "event_registration_details" */
  eventRegistrationDetails: Array<EventRegistrationDetails>;
  /** fetch data from the table: "event_registration_details" using primary key columns */
  eventRegistrationDetailsByPk?: Maybe<EventRegistrationDetails>;
  /** fetch data from the table in a streaming manner: "event_registration_details" */
  eventRegistrationDetailsStream: Array<EventRegistrationDetails>;
  /** fetch data from the table: "event_registrations" */
  eventRegistrations: Array<EventRegistrations>;
  /** fetch aggregated fields from the table: "event_registrations" */
  eventRegistrationsAggregate: EventRegistrationsAggregate;
  /** fetch data from the table: "event_registrations" using primary key columns */
  eventRegistrationsByPk?: Maybe<EventRegistrations>;
  /** fetch data from the table in a streaming manner: "event_registrations" */
  eventRegistrationsStream: Array<EventRegistrations>;
  /** fetch data from the table: "event_sequence_complete_reasons" */
  eventSequenceCompleteReasons: Array<EventSequenceCompleteReasons>;
  /** fetch data from the table: "event_sequence_complete_reasons" using primary key columns */
  eventSequenceCompleteReasonsByPk?: Maybe<EventSequenceCompleteReasons>;
  /** fetch data from the table in a streaming manner: "event_sequence_complete_reasons" */
  eventSequenceCompleteReasonsStream: Array<EventSequenceCompleteReasons>;
  /** fetch data from the table: "event_skill_levels" */
  eventSkillLevels: Array<EventSkillLevels>;
  /** fetch data from the table: "event_skill_levels" using primary key columns */
  eventSkillLevelsByPk?: Maybe<EventSkillLevels>;
  /** fetch data from the table in a streaming manner: "event_skill_levels" */
  eventSkillLevelsStream: Array<EventSkillLevels>;
  /** fetch data from the table: "event_sponsors" */
  eventSponsors: Array<EventSponsors>;
  /** fetch data from the table: "event_sponsors" using primary key columns */
  eventSponsorsByPk?: Maybe<EventSponsors>;
  /** fetch data from the table in a streaming manner: "event_sponsors" */
  eventSponsorsStream: Array<EventSponsors>;
  /** fetch data from the table: "event_statuses" */
  eventStatuses: Array<EventStatuses>;
  /** fetch data from the table: "event_statuses" using primary key columns */
  eventStatusesByPk?: Maybe<EventStatuses>;
  /** fetch data from the table in a streaming manner: "event_statuses" */
  eventStatusesStream: Array<EventStatuses>;
  /** fetch data from the table: "event_team_member_statuses" */
  eventTeamMemberStatuses: Array<EventTeamMemberStatuses>;
  /** fetch data from the table: "event_team_member_statuses" using primary key columns */
  eventTeamMemberStatusesByPk?: Maybe<EventTeamMemberStatuses>;
  /** fetch data from the table in a streaming manner: "event_team_member_statuses" */
  eventTeamMemberStatusesStream: Array<EventTeamMemberStatuses>;
  /** fetch data from the table: "event_team_members" */
  eventTeamMembers: Array<EventTeamMembers>;
  /** fetch data from the table: "event_team_members" using primary key columns */
  eventTeamMembersByPk?: Maybe<EventTeamMembers>;
  /** fetch data from the table in a streaming manner: "event_team_members" */
  eventTeamMembersStream: Array<EventTeamMembers>;
  /** fetch data from the table: "event_team_statuses" */
  eventTeamStatuses: Array<EventTeamStatuses>;
  /** fetch data from the table: "event_team_statuses" using primary key columns */
  eventTeamStatusesByPk?: Maybe<EventTeamStatuses>;
  /** fetch data from the table in a streaming manner: "event_team_statuses" */
  eventTeamStatusesStream: Array<EventTeamStatuses>;
  /** fetch data from the table: "event_teams" */
  eventTeams: Array<EventTeams>;
  /** fetch data from the table: "event_teams" using primary key columns */
  eventTeamsByPk?: Maybe<EventTeams>;
  /** fetch data from the table in a streaming manner: "event_teams" */
  eventTeamsStream: Array<EventTeams>;
  /** fetch data from the table: "event_transaction_item_types" */
  eventTransactionItemTypes: Array<EventTransactionItemTypes>;
  /** fetch data from the table: "event_transaction_item_types" using primary key columns */
  eventTransactionItemTypesByPk?: Maybe<EventTransactionItemTypes>;
  /** fetch data from the table in a streaming manner: "event_transaction_item_types" */
  eventTransactionItemTypesStream: Array<EventTransactionItemTypes>;
  /** fetch data from the table: "event_transaction_items" */
  eventTransactionItems: Array<EventTransactionItems>;
  /** fetch data from the table: "event_transaction_items" using primary key columns */
  eventTransactionItemsByPk?: Maybe<EventTransactionItems>;
  /** fetch data from the table in a streaming manner: "event_transaction_items" */
  eventTransactionItemsStream: Array<EventTransactionItems>;
  /** fetch data from the table: "event_transactions" */
  eventTransactions: Array<EventTransactions>;
  /** fetch data from the table: "event_transactions" using primary key columns */
  eventTransactionsByPk?: Maybe<EventTransactions>;
  /** fetch data from the table in a streaming manner: "event_transactions" */
  eventTransactionsStream: Array<EventTransactions>;
  /** fetch data from the table: "event_types" */
  eventTypes: Array<EventTypes>;
  /** fetch data from the table: "event_types" using primary key columns */
  eventTypesByPk?: Maybe<EventTypes>;
  /** fetch data from the table in a streaming manner: "event_types" */
  eventTypesStream: Array<EventTypes>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  eventsAggregate: EventsAggregate;
  /** fetch data from the table: "events" using primary key columns */
  eventsByPk?: Maybe<Events>;
  /** fetch data from the table in a streaming manner: "events" */
  eventsStream: Array<Events>;
  /** fetch data from the table: "file_category" */
  fileCategory: Array<FileCategory>;
  /** fetch data from the table: "file_category" using primary key columns */
  fileCategoryByPk?: Maybe<FileCategory>;
  /** fetch data from the table in a streaming manner: "file_category" */
  fileCategoryStream: Array<FileCategory>;
  /** fetch data from the table: "file_format" */
  fileFormat: Array<FileFormat>;
  /** fetch data from the table: "file_format" using primary key columns */
  fileFormatByPk?: Maybe<FileFormat>;
  /** fetch data from the table in a streaming manner: "file_format" */
  fileFormatStream: Array<FileFormat>;
  /** fetch data from the table: "game_net_statuses" */
  gameNetStatuses: Array<GameNetStatuses>;
  /** fetch data from the table: "game_net_statuses" using primary key columns */
  gameNetStatusesByPk?: Maybe<GameNetStatuses>;
  /** fetch data from the table in a streaming manner: "game_net_statuses" */
  gameNetStatusesStream: Array<GameNetStatuses>;
  /** fetch data from the table: "gender" */
  gender: Array<Gender>;
  /** fetch data from the table: "gender" using primary key columns */
  genderByPk?: Maybe<Gender>;
  /** fetch data from the table in a streaming manner: "gender" */
  genderStream: Array<Gender>;
  /** fetch data from the table: "group_comment_votes" */
  groupCommentVotes: Array<GroupCommentVotes>;
  /** fetch aggregated fields from the table: "group_comment_votes" */
  groupCommentVotesAggregate: GroupCommentVotesAggregate;
  /** fetch data from the table: "group_comment_votes" using primary key columns */
  groupCommentVotesByPk?: Maybe<GroupCommentVotes>;
  /** fetch data from the table in a streaming manner: "group_comment_votes" */
  groupCommentVotesStream: Array<GroupCommentVotes>;
  /** fetch data from the table: "group_members" */
  groupMembers: Array<GroupMembers>;
  /** fetch aggregated fields from the table: "group_members" */
  groupMembersAggregate: GroupMembersAggregate;
  /** fetch data from the table: "group_members" using primary key columns */
  groupMembersByPk?: Maybe<GroupMembers>;
  /** fetch data from the table in a streaming manner: "group_members" */
  groupMembersStream: Array<GroupMembers>;
  /** fetch data from the table: "group_thread_comment_files" */
  groupThreadCommentFiles: Array<GroupThreadCommentFiles>;
  /** fetch data from the table: "group_thread_comment_files" using primary key columns */
  groupThreadCommentFilesByPk?: Maybe<GroupThreadCommentFiles>;
  /** fetch data from the table in a streaming manner: "group_thread_comment_files" */
  groupThreadCommentFilesStream: Array<GroupThreadCommentFiles>;
  /** fetch data from the table: "group_thread_comments" */
  groupThreadComments: Array<GroupThreadComments>;
  /** fetch aggregated fields from the table: "group_thread_comments" */
  groupThreadCommentsAggregate: GroupThreadCommentsAggregate;
  /** fetch data from the table: "group_thread_comments" using primary key columns */
  groupThreadCommentsByPk?: Maybe<GroupThreadComments>;
  /** fetch data from the table in a streaming manner: "group_thread_comments" */
  groupThreadCommentsStream: Array<GroupThreadComments>;
  /** fetch data from the table: "group_threads" */
  groupThreads: Array<GroupThreads>;
  /** fetch data from the table: "group_threads" using primary key columns */
  groupThreadsByPk?: Maybe<GroupThreads>;
  /** fetch data from the table in a streaming manner: "group_threads" */
  groupThreadsStream: Array<GroupThreads>;
  /** fetch data from the table: "group_types" */
  groupTypes: Array<GroupTypes>;
  /** fetch data from the table: "group_types" using primary key columns */
  groupTypesByPk?: Maybe<GroupTypes>;
  /** fetch data from the table in a streaming manner: "group_types" */
  groupTypesStream: Array<GroupTypes>;
  /** fetch data from the table: "group_venues" */
  groupVenues: Array<GroupVenues>;
  /** fetch aggregated fields from the table: "group_venues" */
  groupVenuesAggregate: GroupVenuesAggregate;
  /** fetch data from the table: "group_venues" using primary key columns */
  groupVenuesByPk?: Maybe<GroupVenues>;
  /** fetch data from the table in a streaming manner: "group_venues" */
  groupVenuesStream: Array<GroupVenues>;
  /** An array relationship */
  groups: Array<Groups>;
  /** fetch data from the table: "groups" using primary key columns */
  groupsByPk?: Maybe<Groups>;
  /** An array relationship */
  groupsPlaySessions: Array<GroupsPlaySessions>;
  /** fetch data from the table: "groups_play_sessions" using primary key columns */
  groupsPlaySessionsByPk?: Maybe<GroupsPlaySessions>;
  /** fetch data from the table in a streaming manner: "groups_play_sessions" */
  groupsPlaySessionsStream: Array<GroupsPlaySessions>;
  /** fetch data from the table in a streaming manner: "groups" */
  groupsStream: Array<Groups>;
  /** fetch data from the table: "identity_verification_providers" */
  identityVerificationProviders: Array<IdentityVerificationProviders>;
  /** fetch data from the table: "identity_verification_providers" using primary key columns */
  identityVerificationProvidersByPk?: Maybe<IdentityVerificationProviders>;
  /** fetch data from the table in a streaming manner: "identity_verification_providers" */
  identityVerificationProvidersStream: Array<IdentityVerificationProviders>;
  /** fetch data from the table: "identity_verification_statuses" */
  identityVerificationStatuses: Array<IdentityVerificationStatuses>;
  /** fetch data from the table: "identity_verification_statuses" using primary key columns */
  identityVerificationStatusesByPk?: Maybe<IdentityVerificationStatuses>;
  /** fetch data from the table in a streaming manner: "identity_verification_statuses" */
  identityVerificationStatusesStream: Array<IdentityVerificationStatuses>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** fetch data from the table: "invoices" using primary key columns */
  invoicesByPk?: Maybe<Invoices>;
  /** fetch data from the table in a streaming manner: "invoices" */
  invoicesStream: Array<Invoices>;
  /** fetch data from the table: "learning_program_enrollment_schedule_media_watched" */
  learningProgramEnrollmentScheduleMediaWatched: Array<LearningProgramEnrollmentScheduleMediaWatched>;
  /** fetch data from the table: "learning_program_enrollment_schedule_media_watched" using primary key columns */
  learningProgramEnrollmentScheduleMediaWatchedByPk?: Maybe<LearningProgramEnrollmentScheduleMediaWatched>;
  /** fetch data from the table in a streaming manner: "learning_program_enrollment_schedule_media_watched" */
  learningProgramEnrollmentScheduleMediaWatchedStream: Array<LearningProgramEnrollmentScheduleMediaWatched>;
  /** fetch data from the table: "learning_program_enrollment_schedule_progress" */
  learningProgramEnrollmentScheduleProgress: Array<LearningProgramEnrollmentScheduleProgress>;
  /** fetch data from the table: "learning_program_enrollment_schedule_progress" using primary key columns */
  learningProgramEnrollmentScheduleProgressByPk?: Maybe<LearningProgramEnrollmentScheduleProgress>;
  /** fetch data from the table in a streaming manner: "learning_program_enrollment_schedule_progress" */
  learningProgramEnrollmentScheduleProgressStream: Array<LearningProgramEnrollmentScheduleProgress>;
  /** fetch data from the table: "learning_program_enrollments" */
  learningProgramEnrollments: Array<LearningProgramEnrollments>;
  /** fetch data from the table: "learning_program_enrollments" using primary key columns */
  learningProgramEnrollmentsByPk?: Maybe<LearningProgramEnrollments>;
  /** fetch data from the table in a streaming manner: "learning_program_enrollments" */
  learningProgramEnrollmentsStream: Array<LearningProgramEnrollments>;
  /** fetch data from the table: "learning_program_media" */
  learningProgramMedia: Array<LearningProgramMedia>;
  /** fetch data from the table: "learning_program_media" using primary key columns */
  learningProgramMediaByPk?: Maybe<LearningProgramMedia>;
  /** fetch data from the table: "learning_program_media_categories" */
  learningProgramMediaCategories: Array<LearningProgramMediaCategories>;
  /** fetch data from the table: "learning_program_media_categories" using primary key columns */
  learningProgramMediaCategoriesByPk?: Maybe<LearningProgramMediaCategories>;
  /** fetch data from the table in a streaming manner: "learning_program_media_categories" */
  learningProgramMediaCategoriesStream: Array<LearningProgramMediaCategories>;
  /** fetch data from the table in a streaming manner: "learning_program_media" */
  learningProgramMediaStream: Array<LearningProgramMedia>;
  /** fetch data from the table: "learning_program_schedule_media" */
  learningProgramScheduleMedia: Array<LearningProgramScheduleMedia>;
  /** fetch data from the table: "learning_program_schedule_media" using primary key columns */
  learningProgramScheduleMediaByPk?: Maybe<LearningProgramScheduleMedia>;
  /** fetch data from the table in a streaming manner: "learning_program_schedule_media" */
  learningProgramScheduleMediaStream: Array<LearningProgramScheduleMedia>;
  /** fetch data from the table: "learning_program_schedule_units" */
  learningProgramScheduleUnits: Array<LearningProgramScheduleUnits>;
  /** fetch data from the table: "learning_program_schedule_units" using primary key columns */
  learningProgramScheduleUnitsByPk?: Maybe<LearningProgramScheduleUnits>;
  /** fetch data from the table in a streaming manner: "learning_program_schedule_units" */
  learningProgramScheduleUnitsStream: Array<LearningProgramScheduleUnits>;
  /** fetch data from the table: "learning_program_schedule_video_submissions" */
  learningProgramScheduleVideoSubmissions: Array<LearningProgramScheduleVideoSubmissions>;
  /** fetch data from the table: "learning_program_schedule_video_submissions" using primary key columns */
  learningProgramScheduleVideoSubmissionsByPk?: Maybe<LearningProgramScheduleVideoSubmissions>;
  /** fetch data from the table in a streaming manner: "learning_program_schedule_video_submissions" */
  learningProgramScheduleVideoSubmissionsStream: Array<LearningProgramScheduleVideoSubmissions>;
  /** fetch data from the table: "learning_program_schedules" */
  learningProgramSchedules: Array<LearningProgramSchedules>;
  /** fetch data from the table: "learning_program_schedules" using primary key columns */
  learningProgramSchedulesByPk?: Maybe<LearningProgramSchedules>;
  /** fetch data from the table in a streaming manner: "learning_program_schedules" */
  learningProgramSchedulesStream: Array<LearningProgramSchedules>;
  /** fetch data from the table: "learning_program_skill_level_values" */
  learningProgramSkillLevelValues: Array<LearningProgramSkillLevelValues>;
  /** fetch data from the table: "learning_program_skill_level_values" using primary key columns */
  learningProgramSkillLevelValuesByPk?: Maybe<LearningProgramSkillLevelValues>;
  /** fetch data from the table in a streaming manner: "learning_program_skill_level_values" */
  learningProgramSkillLevelValuesStream: Array<LearningProgramSkillLevelValues>;
  /** fetch data from the table: "learning_program_skills" */
  learningProgramSkills: Array<LearningProgramSkills>;
  /** fetch data from the table: "learning_program_skills" using primary key columns */
  learningProgramSkillsByPk?: Maybe<LearningProgramSkills>;
  /** fetch data from the table in a streaming manner: "learning_program_skills" */
  learningProgramSkillsStream: Array<LearningProgramSkills>;
  /** fetch data from the table: "learning_programs" */
  learningPrograms: Array<LearningPrograms>;
  /** fetch aggregated fields from the table: "learning_programs" */
  learningProgramsAggregate: LearningProgramsAggregate;
  /** fetch data from the table: "learning_programs" using primary key columns */
  learningProgramsByPk?: Maybe<LearningPrograms>;
  /** fetch data from the table in a streaming manner: "learning_programs" */
  learningProgramsStream: Array<LearningPrograms>;
  /** fetch data from the table: "lesson_age_groups" */
  lessonAgeGroups: Array<LessonAgeGroups>;
  /** fetch data from the table: "lesson_age_groups" using primary key columns */
  lessonAgeGroupsByPk?: Maybe<LessonAgeGroups>;
  /** fetch data from the table in a streaming manner: "lesson_age_groups" */
  lessonAgeGroupsStream: Array<LessonAgeGroups>;
  /** fetch data from the table: "lesson_collections" */
  lessonCollections: Array<LessonCollections>;
  /** fetch data from the table: "lesson_collections" using primary key columns */
  lessonCollectionsByPk?: Maybe<LessonCollections>;
  /** fetch data from the table in a streaming manner: "lesson_collections" */
  lessonCollectionsStream: Array<LessonCollections>;
  /** fetch data from the table: "lesson_equipment" */
  lessonEquipment: Array<LessonEquipment>;
  /** fetch data from the table: "lesson_equipment" using primary key columns */
  lessonEquipmentByPk?: Maybe<LessonEquipment>;
  /** fetch data from the table: "lesson_equipment_options" */
  lessonEquipmentOptions: Array<LessonEquipmentOptions>;
  /** fetch data from the table: "lesson_equipment_options" using primary key columns */
  lessonEquipmentOptionsByPk?: Maybe<LessonEquipmentOptions>;
  /** fetch data from the table in a streaming manner: "lesson_equipment_options" */
  lessonEquipmentOptionsStream: Array<LessonEquipmentOptions>;
  /** fetch data from the table in a streaming manner: "lesson_equipment" */
  lessonEquipmentStream: Array<LessonEquipment>;
  /** fetch data from the table: "lesson_order_items" */
  lessonOrderItems: Array<LessonOrderItems>;
  /** fetch data from the table: "lesson_order_items" using primary key columns */
  lessonOrderItemsByPk?: Maybe<LessonOrderItems>;
  /** fetch data from the table in a streaming manner: "lesson_order_items" */
  lessonOrderItemsStream: Array<LessonOrderItems>;
  /** fetch data from the table: "lesson_orders" */
  lessonOrders: Array<LessonOrders>;
  /** fetch aggregated fields from the table: "lesson_orders" */
  lessonOrdersAggregate: LessonOrdersAggregate;
  /** fetch data from the table: "lesson_orders" using primary key columns */
  lessonOrdersByPk?: Maybe<LessonOrders>;
  /** fetch data from the table in a streaming manner: "lesson_orders" */
  lessonOrdersStream: Array<LessonOrders>;
  /** fetch data from the table: "lesson_participant_statuses" */
  lessonParticipantStatuses: Array<LessonParticipantStatuses>;
  /** fetch data from the table: "lesson_participant_statuses" using primary key columns */
  lessonParticipantStatusesByPk?: Maybe<LessonParticipantStatuses>;
  /** fetch data from the table in a streaming manner: "lesson_participant_statuses" */
  lessonParticipantStatusesStream: Array<LessonParticipantStatuses>;
  /** fetch data from the table: "lesson_participants" */
  lessonParticipants: Array<LessonParticipants>;
  /** fetch aggregated fields from the table: "lesson_participants" */
  lessonParticipantsAggregate: LessonParticipantsAggregate;
  /** fetch data from the table: "lesson_participants" using primary key columns */
  lessonParticipantsByPk?: Maybe<LessonParticipants>;
  /** fetch data from the table in a streaming manner: "lesson_participants" */
  lessonParticipantsStream: Array<LessonParticipants>;
  /** An array relationship */
  lessonPlayerSkillAssessments: Array<LessonPlayerSkillAssessments>;
  /** fetch data from the table: "lesson_player_skill_assessments" using primary key columns */
  lessonPlayerSkillAssessmentsByPk?: Maybe<LessonPlayerSkillAssessments>;
  /** An array relationship */
  lessonPlayerSkillAssessmentsSkills: Array<LessonPlayerSkillAssessmentsSkills>;
  /** fetch data from the table: "lesson_player_skill_assessments_skills" using primary key columns */
  lessonPlayerSkillAssessmentsSkillsByPk?: Maybe<LessonPlayerSkillAssessmentsSkills>;
  /** fetch data from the table in a streaming manner: "lesson_player_skill_assessments_skills" */
  lessonPlayerSkillAssessmentsSkillsStream: Array<LessonPlayerSkillAssessmentsSkills>;
  /** fetch data from the table in a streaming manner: "lesson_player_skill_assessments" */
  lessonPlayerSkillAssessmentsStream: Array<LessonPlayerSkillAssessments>;
  /** fetch data from the table: "lesson_privacy" */
  lessonPrivacy: Array<LessonPrivacy>;
  /** fetch data from the table: "lesson_privacy" using primary key columns */
  lessonPrivacyByPk?: Maybe<LessonPrivacy>;
  /** fetch data from the table in a streaming manner: "lesson_privacy" */
  lessonPrivacyStream: Array<LessonPrivacy>;
  /** fetch data from the table: "lesson_reflection_comment_types" */
  lessonReflectionCommentTypes: Array<LessonReflectionCommentTypes>;
  /** fetch data from the table: "lesson_reflection_comment_types" using primary key columns */
  lessonReflectionCommentTypesByPk?: Maybe<LessonReflectionCommentTypes>;
  /** fetch data from the table in a streaming manner: "lesson_reflection_comment_types" */
  lessonReflectionCommentTypesStream: Array<LessonReflectionCommentTypes>;
  /** An array relationship */
  lessonReflectionComments: Array<LessonReflectionComments>;
  /** fetch data from the table: "lesson_reflection_comments" using primary key columns */
  lessonReflectionCommentsByPk?: Maybe<LessonReflectionComments>;
  /** fetch data from the table in a streaming manner: "lesson_reflection_comments" */
  lessonReflectionCommentsStream: Array<LessonReflectionComments>;
  /** An array relationship */
  lessonReflectionFiles: Array<LessonReflectionFiles>;
  /** fetch data from the table: "lesson_reflection_files" using primary key columns */
  lessonReflectionFilesByPk?: Maybe<LessonReflectionFiles>;
  /** fetch data from the table in a streaming manner: "lesson_reflection_files" */
  lessonReflectionFilesStream: Array<LessonReflectionFiles>;
  /** An array relationship */
  lessonReflections: Array<LessonReflections>;
  /** fetch data from the table: "lesson_reflections" using primary key columns */
  lessonReflectionsByPk?: Maybe<LessonReflections>;
  /** fetch data from the table in a streaming manner: "lesson_reflections" */
  lessonReflectionsStream: Array<LessonReflections>;
  /** fetch data from the table: "lesson_skill_display_names" */
  lessonSkillDisplayNames: Array<LessonSkillDisplayNames>;
  /** fetch data from the table: "lesson_skill_display_names" using primary key columns */
  lessonSkillDisplayNamesByPk?: Maybe<LessonSkillDisplayNames>;
  /** fetch data from the table in a streaming manner: "lesson_skill_display_names" */
  lessonSkillDisplayNamesStream: Array<LessonSkillDisplayNames>;
  /** fetch data from the table: "lesson_skill_levels" */
  lessonSkillLevels: Array<LessonSkillLevels>;
  /** fetch data from the table: "lesson_skill_levels" using primary key columns */
  lessonSkillLevelsByPk?: Maybe<LessonSkillLevels>;
  /** fetch data from the table in a streaming manner: "lesson_skill_levels" */
  lessonSkillLevelsStream: Array<LessonSkillLevels>;
  /** fetch data from the table: "lesson_skill_mappings" */
  lessonSkillMappings: Array<LessonSkillMappings>;
  /** fetch data from the table: "lesson_skill_mappings" using primary key columns */
  lessonSkillMappingsByPk?: Maybe<LessonSkillMappings>;
  /** fetch data from the table in a streaming manner: "lesson_skill_mappings" */
  lessonSkillMappingsStream: Array<LessonSkillMappings>;
  /** fetch data from the table: "lesson_skills" */
  lessonSkills: Array<LessonSkills>;
  /** fetch data from the table: "lesson_skills" using primary key columns */
  lessonSkillsByPk?: Maybe<LessonSkills>;
  /** fetch data from the table in a streaming manner: "lesson_skills" */
  lessonSkillsStream: Array<LessonSkills>;
  /** fetch data from the table: "lesson_statuses" */
  lessonStatuses: Array<LessonStatuses>;
  /** fetch data from the table: "lesson_statuses" using primary key columns */
  lessonStatusesByPk?: Maybe<LessonStatuses>;
  /** fetch data from the table in a streaming manner: "lesson_statuses" */
  lessonStatusesStream: Array<LessonStatuses>;
  /** fetch data from the table: "lesson_template_skill_levels" */
  lessonTemplateSkillLevels: Array<LessonTemplateSkillLevels>;
  /** fetch data from the table: "lesson_template_skill_levels" using primary key columns */
  lessonTemplateSkillLevelsByPk?: Maybe<LessonTemplateSkillLevels>;
  /** fetch data from the table in a streaming manner: "lesson_template_skill_levels" */
  lessonTemplateSkillLevelsStream: Array<LessonTemplateSkillLevels>;
  /** An array relationship */
  lessonTemplates: Array<LessonTemplates>;
  /** fetch data from the table: "lesson_templates" using primary key columns */
  lessonTemplatesByPk?: Maybe<LessonTemplates>;
  /** fetch data from the table in a streaming manner: "lesson_templates" */
  lessonTemplatesStream: Array<LessonTemplates>;
  /** fetch data from the table: "lesson_times" */
  lessonTimes: Array<LessonTimes>;
  /** fetch data from the table: "lesson_times" using primary key columns */
  lessonTimesByPk?: Maybe<LessonTimes>;
  /** fetch data from the table in a streaming manner: "lesson_times" */
  lessonTimesStream: Array<LessonTimes>;
  /** fetch data from the table: "lesson_types" */
  lessonTypes: Array<LessonTypes>;
  /** fetch data from the table: "lesson_types" using primary key columns */
  lessonTypesByPk?: Maybe<LessonTypes>;
  /** fetch data from the table in a streaming manner: "lesson_types" */
  lessonTypesStream: Array<LessonTypes>;
  /** fetch data from the table: "lesson_waitlist_statuses" */
  lessonWaitlistStatuses: Array<LessonWaitlistStatuses>;
  /** fetch data from the table: "lesson_waitlist_statuses" using primary key columns */
  lessonWaitlistStatusesByPk?: Maybe<LessonWaitlistStatuses>;
  /** fetch data from the table in a streaming manner: "lesson_waitlist_statuses" */
  lessonWaitlistStatusesStream: Array<LessonWaitlistStatuses>;
  /** fetch data from the table: "lesson_waitlists" */
  lessonWaitlists: Array<LessonWaitlists>;
  /** fetch aggregated fields from the table: "lesson_waitlists" */
  lessonWaitlistsAggregate: LessonWaitlistsAggregate;
  /** fetch data from the table: "lesson_waitlists" using primary key columns */
  lessonWaitlistsByPk?: Maybe<LessonWaitlists>;
  /** fetch data from the table in a streaming manner: "lesson_waitlists" */
  lessonWaitlistsStream: Array<LessonWaitlists>;
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An aggregate relationship */
  lessonsAggregate: LessonsAggregate;
  /** fetch data from the table: "lessons" using primary key columns */
  lessonsByPk?: Maybe<Lessons>;
  /** fetch data from the table in a streaming manner: "lessons" */
  lessonsStream: Array<Lessons>;
  /** fetch data from the table: "match_selection_criteria" */
  matchSelectionCriteria: Array<MatchSelectionCriteria>;
  /** fetch data from the table: "match_selection_criteria" using primary key columns */
  matchSelectionCriteriaByPk?: Maybe<MatchSelectionCriteria>;
  /** fetch data from the table in a streaming manner: "match_selection_criteria" */
  matchSelectionCriteriaStream: Array<MatchSelectionCriteria>;
  /** An array relationship */
  messages: Array<Messages>;
  /** fetch data from the table: "messages" using primary key columns */
  messagesByPk?: Maybe<Messages>;
  /** fetch data from the table in a streaming manner: "messages" */
  messagesStream: Array<Messages>;
  /** fetch data from the table: "neighborhoods" */
  neighborhoods: Array<Neighborhoods>;
  /** fetch data from the table: "neighborhoods" using primary key columns */
  neighborhoodsByPk?: Maybe<Neighborhoods>;
  /** fetch data from the table in a streaming manner: "neighborhoods" */
  neighborhoodsStream: Array<Neighborhoods>;
  /** fetch data from the table: "padel_rating_scales" */
  padelRatingScales: Array<PadelRatingScales>;
  /** fetch data from the table: "padel_rating_scales" using primary key columns */
  padelRatingScalesByPk?: Maybe<PadelRatingScales>;
  /** fetch data from the table in a streaming manner: "padel_rating_scales" */
  padelRatingScalesStream: Array<PadelRatingScales>;
  /** fetch data from the table: "participant_roles" */
  participantRoles: Array<ParticipantRoles>;
  /** fetch data from the table: "participant_roles" using primary key columns */
  participantRolesByPk?: Maybe<ParticipantRoles>;
  /** fetch data from the table in a streaming manner: "participant_roles" */
  participantRolesStream: Array<ParticipantRoles>;
  /** fetch data from the table: "partner_booking_order_statuses" */
  partnerBookingOrderStatuses: Array<PartnerBookingOrderStatuses>;
  /** fetch data from the table: "partner_booking_order_statuses" using primary key columns */
  partnerBookingOrderStatusesByPk?: Maybe<PartnerBookingOrderStatuses>;
  /** fetch data from the table in a streaming manner: "partner_booking_order_statuses" */
  partnerBookingOrderStatusesStream: Array<PartnerBookingOrderStatuses>;
  /** fetch data from the table: "partner_booking_orders" */
  partnerBookingOrders: Array<PartnerBookingOrders>;
  /** fetch data from the table: "partner_booking_orders" using primary key columns */
  partnerBookingOrdersByPk?: Maybe<PartnerBookingOrders>;
  /** fetch data from the table in a streaming manner: "partner_booking_orders" */
  partnerBookingOrdersStream: Array<PartnerBookingOrders>;
  /** fetch data from the table: "payment_fulfillment_channels" */
  paymentFulfillmentChannels: Array<PaymentFulfillmentChannels>;
  /** fetch data from the table: "payment_fulfillment_channels" using primary key columns */
  paymentFulfillmentChannelsByPk?: Maybe<PaymentFulfillmentChannels>;
  /** fetch data from the table in a streaming manner: "payment_fulfillment_channels" */
  paymentFulfillmentChannelsStream: Array<PaymentFulfillmentChannels>;
  /** fetch data from the table: "pickleball_rating_scales" */
  pickleballRatingScales: Array<PickleballRatingScales>;
  /** fetch data from the table: "pickleball_rating_scales" using primary key columns */
  pickleballRatingScalesByPk?: Maybe<PickleballRatingScales>;
  /** fetch data from the table in a streaming manner: "pickleball_rating_scales" */
  pickleballRatingScalesStream: Array<PickleballRatingScales>;
  /** fetch data from the table: "platform_subscription_intervals" */
  platformSubscriptionIntervals: Array<PlatformSubscriptionIntervals>;
  /** fetch data from the table: "platform_subscription_intervals" using primary key columns */
  platformSubscriptionIntervalsByPk?: Maybe<PlatformSubscriptionIntervals>;
  /** fetch data from the table in a streaming manner: "platform_subscription_intervals" */
  platformSubscriptionIntervalsStream: Array<PlatformSubscriptionIntervals>;
  /** fetch data from the table: "platform_subscription_personas" */
  platformSubscriptionPersonas: Array<PlatformSubscriptionPersonas>;
  /** fetch data from the table: "platform_subscription_personas" using primary key columns */
  platformSubscriptionPersonasByPk?: Maybe<PlatformSubscriptionPersonas>;
  /** fetch data from the table in a streaming manner: "platform_subscription_personas" */
  platformSubscriptionPersonasStream: Array<PlatformSubscriptionPersonas>;
  /** fetch data from the table: "platform_subscription_plan_prices" */
  platformSubscriptionPlanPrices: Array<PlatformSubscriptionPlanPrices>;
  /** fetch data from the table: "platform_subscription_plan_prices" using primary key columns */
  platformSubscriptionPlanPricesByPk?: Maybe<PlatformSubscriptionPlanPrices>;
  /** fetch data from the table in a streaming manner: "platform_subscription_plan_prices" */
  platformSubscriptionPlanPricesStream: Array<PlatformSubscriptionPlanPrices>;
  /** fetch data from the table: "platform_subscription_plans" */
  platformSubscriptionPlans: Array<PlatformSubscriptionPlans>;
  /** fetch data from the table: "platform_subscription_plans" using primary key columns */
  platformSubscriptionPlansByPk?: Maybe<PlatformSubscriptionPlans>;
  /** fetch data from the table in a streaming manner: "platform_subscription_plans" */
  platformSubscriptionPlansStream: Array<PlatformSubscriptionPlans>;
  /** An array relationship */
  platformSubscriptions: Array<PlatformSubscriptions>;
  /** fetch data from the table: "platform_subscriptions" using primary key columns */
  platformSubscriptionsByPk?: Maybe<PlatformSubscriptions>;
  /** fetch data from the table in a streaming manner: "platform_subscriptions" */
  platformSubscriptionsStream: Array<PlatformSubscriptions>;
  /** fetch data from the table: "play_request_neighborhoods" */
  playRequestNeighborhoods: Array<PlayRequestNeighborhoods>;
  /** fetch data from the table: "play_request_neighborhoods" using primary key columns */
  playRequestNeighborhoodsByPk?: Maybe<PlayRequestNeighborhoods>;
  /** fetch data from the table in a streaming manner: "play_request_neighborhoods" */
  playRequestNeighborhoodsStream: Array<PlayRequestNeighborhoods>;
  /** fetch data from the table: "play_request_slots" */
  playRequestSlots: Array<PlayRequestSlots>;
  /** fetch data from the table: "play_request_slots" using primary key columns */
  playRequestSlotsByPk?: Maybe<PlayRequestSlots>;
  /** fetch data from the table in a streaming manner: "play_request_slots" */
  playRequestSlotsStream: Array<PlayRequestSlots>;
  /** fetch data from the table: "play_request_statuses" */
  playRequestStatuses: Array<PlayRequestStatuses>;
  /** fetch data from the table: "play_request_statuses" using primary key columns */
  playRequestStatusesByPk?: Maybe<PlayRequestStatuses>;
  /** fetch data from the table in a streaming manner: "play_request_statuses" */
  playRequestStatusesStream: Array<PlayRequestStatuses>;
  /** fetch data from the table: "play_request_venues" */
  playRequestVenues: Array<PlayRequestVenues>;
  /** fetch data from the table: "play_request_venues" using primary key columns */
  playRequestVenuesByPk?: Maybe<PlayRequestVenues>;
  /** fetch data from the table in a streaming manner: "play_request_venues" */
  playRequestVenuesStream: Array<PlayRequestVenues>;
  /** An array relationship */
  playRequests: Array<PlayRequests>;
  /** fetch data from the table: "play_requests" using primary key columns */
  playRequestsByPk?: Maybe<PlayRequests>;
  /** fetch data from the table in a streaming manner: "play_requests" */
  playRequestsStream: Array<PlayRequests>;
  /** fetch data from the table: "play_session_comments" */
  playSessionComments: Array<PlaySessionComments>;
  /** fetch aggregated fields from the table: "play_session_comments" */
  playSessionCommentsAggregate: PlaySessionCommentsAggregate;
  /** fetch data from the table: "play_session_comments" using primary key columns */
  playSessionCommentsByPk?: Maybe<PlaySessionComments>;
  /** fetch data from the table in a streaming manner: "play_session_comments" */
  playSessionCommentsStream: Array<PlaySessionComments>;
  /** fetch data from the table: "play_session_court_booking_statuses" */
  playSessionCourtBookingStatuses: Array<PlaySessionCourtBookingStatuses>;
  /** fetch data from the table: "play_session_court_booking_statuses" using primary key columns */
  playSessionCourtBookingStatusesByPk?: Maybe<PlaySessionCourtBookingStatuses>;
  /** fetch data from the table in a streaming manner: "play_session_court_booking_statuses" */
  playSessionCourtBookingStatusesStream: Array<PlaySessionCourtBookingStatuses>;
  /** fetch data from the table: "play_session_formats" */
  playSessionFormats: Array<PlaySessionFormats>;
  /** fetch data from the table: "play_session_formats" using primary key columns */
  playSessionFormatsByPk?: Maybe<PlaySessionFormats>;
  /** fetch data from the table in a streaming manner: "play_session_formats" */
  playSessionFormatsStream: Array<PlaySessionFormats>;
  /** fetch data from the table: "play_session_match_competitiveness" */
  playSessionMatchCompetitiveness: Array<PlaySessionMatchCompetitiveness>;
  /** fetch data from the table: "play_session_match_competitiveness" using primary key columns */
  playSessionMatchCompetitivenessByPk?: Maybe<PlaySessionMatchCompetitiveness>;
  /** fetch data from the table in a streaming manner: "play_session_match_competitiveness" */
  playSessionMatchCompetitivenessStream: Array<PlaySessionMatchCompetitiveness>;
  /** fetch data from the table: "play_session_participant_statuses" */
  playSessionParticipantStatuses: Array<PlaySessionParticipantStatuses>;
  /** fetch data from the table: "play_session_participant_statuses" using primary key columns */
  playSessionParticipantStatusesByPk?: Maybe<PlaySessionParticipantStatuses>;
  /** fetch data from the table in a streaming manner: "play_session_participant_statuses" */
  playSessionParticipantStatusesStream: Array<PlaySessionParticipantStatuses>;
  /** fetch data from the table: "play_session_participants" */
  playSessionParticipants: Array<PlaySessionParticipants>;
  /** fetch aggregated fields from the table: "play_session_participants" */
  playSessionParticipantsAggregate: PlaySessionParticipantsAggregate;
  /** fetch data from the table: "play_session_participants" using primary key columns */
  playSessionParticipantsByPk?: Maybe<PlaySessionParticipants>;
  /** fetch data from the table in a streaming manner: "play_session_participants" */
  playSessionParticipantsStream: Array<PlaySessionParticipants>;
  /** fetch data from the table: "play_session_privacy" */
  playSessionPrivacy: Array<PlaySessionPrivacy>;
  /** fetch data from the table: "play_session_privacy" using primary key columns */
  playSessionPrivacyByPk?: Maybe<PlaySessionPrivacy>;
  /** fetch data from the table in a streaming manner: "play_session_privacy" */
  playSessionPrivacyStream: Array<PlaySessionPrivacy>;
  /** fetch data from the table: "play_session_statuses" */
  playSessionStatuses: Array<PlaySessionStatuses>;
  /** fetch data from the table: "play_session_statuses" using primary key columns */
  playSessionStatusesByPk?: Maybe<PlaySessionStatuses>;
  /** fetch data from the table in a streaming manner: "play_session_statuses" */
  playSessionStatusesStream: Array<PlaySessionStatuses>;
  /** An array relationship */
  playSessions: Array<PlaySessions>;
  /** An aggregate relationship */
  playSessionsAggregate: PlaySessionsAggregate;
  /** fetch data from the table: "play_sessions" using primary key columns */
  playSessionsByPk?: Maybe<PlaySessions>;
  /** fetch data from the table in a streaming manner: "play_sessions" */
  playSessionsStream: Array<PlaySessions>;
  /** fetch data from the table: "player_availabilities" */
  playerAvailabilities: Array<PlayerAvailabilities>;
  /** fetch aggregated fields from the table: "player_availabilities" */
  playerAvailabilitiesAggregate: PlayerAvailabilitiesAggregate;
  /** fetch data from the table: "player_availabilities" using primary key columns */
  playerAvailabilitiesByPk?: Maybe<PlayerAvailabilities>;
  /** fetch data from the table in a streaming manner: "player_availabilities" */
  playerAvailabilitiesStream: Array<PlayerAvailabilities>;
  /** fetch data from the table: "player_availability_neighborhoods" */
  playerAvailabilityNeighborhoods: Array<PlayerAvailabilityNeighborhoods>;
  /** fetch data from the table: "player_availability_neighborhoods" using primary key columns */
  playerAvailabilityNeighborhoodsByPk?: Maybe<PlayerAvailabilityNeighborhoods>;
  /** fetch data from the table in a streaming manner: "player_availability_neighborhoods" */
  playerAvailabilityNeighborhoodsStream: Array<PlayerAvailabilityNeighborhoods>;
  /** fetch data from the table: "player_availability_rating_scales" */
  playerAvailabilityRatingScales: Array<PlayerAvailabilityRatingScales>;
  /** fetch data from the table: "player_availability_rating_scales" using primary key columns */
  playerAvailabilityRatingScalesByPk?: Maybe<PlayerAvailabilityRatingScales>;
  /** fetch data from the table in a streaming manner: "player_availability_rating_scales" */
  playerAvailabilityRatingScalesStream: Array<PlayerAvailabilityRatingScales>;
  /** fetch data from the table: "player_availability_slots" */
  playerAvailabilitySlots: Array<PlayerAvailabilitySlots>;
  /** fetch data from the table: "player_availability_slots" using primary key columns */
  playerAvailabilitySlotsByPk?: Maybe<PlayerAvailabilitySlots>;
  /** fetch data from the table in a streaming manner: "player_availability_slots" */
  playerAvailabilitySlotsStream: Array<PlayerAvailabilitySlots>;
  /** fetch data from the table: "player_availability_venues" */
  playerAvailabilityVenues: Array<PlayerAvailabilityVenues>;
  /** fetch data from the table: "player_availability_venues" using primary key columns */
  playerAvailabilityVenuesByPk?: Maybe<PlayerAvailabilityVenues>;
  /** fetch data from the table in a streaming manner: "player_availability_venues" */
  playerAvailabilityVenuesStream: Array<PlayerAvailabilityVenues>;
  /** fetch data from the table: "player_finder_goals" */
  playerFinderGoals: Array<PlayerFinderGoals>;
  /** fetch data from the table: "player_finder_goals" using primary key columns */
  playerFinderGoalsByPk?: Maybe<PlayerFinderGoals>;
  /** fetch data from the table in a streaming manner: "player_finder_goals" */
  playerFinderGoalsStream: Array<PlayerFinderGoals>;
  /** fetch data from the table: "player_finder_time_of_day" */
  playerFinderTimeOfDay: Array<PlayerFinderTimeOfDay>;
  /** fetch data from the table: "player_finder_time_of_day" using primary key columns */
  playerFinderTimeOfDayByPk?: Maybe<PlayerFinderTimeOfDay>;
  /** fetch data from the table in a streaming manner: "player_finder_time_of_day" */
  playerFinderTimeOfDayStream: Array<PlayerFinderTimeOfDay>;
  /** fetch data from the table: "recurrence_kinds" */
  recurrenceKinds: Array<RecurrenceKinds>;
  /** fetch data from the table: "recurrence_kinds" using primary key columns */
  recurrenceKindsByPk?: Maybe<RecurrenceKinds>;
  /** fetch data from the table in a streaming manner: "recurrence_kinds" */
  recurrenceKindsStream: Array<RecurrenceKinds>;
  /** fetch data from the table: "report_reasons" */
  reportReasons: Array<ReportReasons>;
  /** fetch data from the table: "report_reasons" using primary key columns */
  reportReasonsByPk?: Maybe<ReportReasons>;
  /** fetch data from the table in a streaming manner: "report_reasons" */
  reportReasonsStream: Array<ReportReasons>;
  /** fetch data from the table: "report_statuses" */
  reportStatuses: Array<ReportStatuses>;
  /** fetch data from the table: "report_statuses" using primary key columns */
  reportStatusesByPk?: Maybe<ReportStatuses>;
  /** fetch data from the table in a streaming manner: "report_statuses" */
  reportStatusesStream: Array<ReportStatuses>;
  /** fetch data from the table: "reviews" */
  reviews: Array<Reviews>;
  /** fetch aggregated fields from the table: "reviews" */
  reviewsAggregate: ReviewsAggregate;
  /** fetch data from the table: "reviews" using primary key columns */
  reviewsByPk?: Maybe<Reviews>;
  /** fetch data from the table in a streaming manner: "reviews" */
  reviewsStream: Array<Reviews>;
  /** An array relationship */
  sales: Array<Sales>;
  /** fetch data from the table: "sales" using primary key columns */
  salesByPk?: Maybe<Sales>;
  /** fetch data from the table in a streaming manner: "sales" */
  salesStream: Array<Sales>;
  /** fetch data from the table: "scoring_format" */
  scoringFormat: Array<ScoringFormat>;
  /** fetch data from the table: "scoring_format" using primary key columns */
  scoringFormatByPk?: Maybe<ScoringFormat>;
  /** fetch data from the table in a streaming manner: "scoring_format" */
  scoringFormatStream: Array<ScoringFormat>;
  /** fetch data from the table: "signup_requests" */
  signupRequests: Array<SignupRequests>;
  /** fetch data from the table: "signup_requests" using primary key columns */
  signupRequestsByPk?: Maybe<SignupRequests>;
  /** fetch data from the table in a streaming manner: "signup_requests" */
  signupRequestsStream: Array<SignupRequests>;
  /** fetch data from the table: "skill_level_values" */
  skillLevelValues: Array<SkillLevelValues>;
  /** fetch data from the table: "skill_level_values" using primary key columns */
  skillLevelValuesByPk?: Maybe<SkillLevelValues>;
  /** fetch data from the table in a streaming manner: "skill_level_values" */
  skillLevelValuesStream: Array<SkillLevelValues>;
  /** fetch data from the table: "skill_levels" */
  skillLevels: Array<SkillLevels>;
  /** fetch data from the table: "skill_levels" using primary key columns */
  skillLevelsByPk?: Maybe<SkillLevels>;
  /** fetch data from the table in a streaming manner: "skill_levels" */
  skillLevelsStream: Array<SkillLevels>;
  /** fetch data from the table: "sports" */
  sports: Array<Sports>;
  /** fetch data from the table: "sports" using primary key columns */
  sportsByPk?: Maybe<Sports>;
  /** fetch data from the table in a streaming manner: "sports" */
  sportsStream: Array<Sports>;
  /** fetch data from the table: "subscription_statuses" */
  subscriptionStatuses: Array<SubscriptionStatuses>;
  /** fetch data from the table: "subscription_statuses" using primary key columns */
  subscriptionStatusesByPk?: Maybe<SubscriptionStatuses>;
  /** fetch data from the table in a streaming manner: "subscription_statuses" */
  subscriptionStatusesStream: Array<SubscriptionStatuses>;
  /** fetch data from the table: "team_types" */
  teamTypes: Array<TeamTypes>;
  /** fetch data from the table: "team_types" using primary key columns */
  teamTypesByPk?: Maybe<TeamTypes>;
  /** fetch data from the table in a streaming manner: "team_types" */
  teamTypesStream: Array<TeamTypes>;
  /** fetch data from the table: "tennis_rating_scales" */
  tennisRatingScales: Array<TennisRatingScales>;
  /** fetch data from the table: "tennis_rating_scales" using primary key columns */
  tennisRatingScalesByPk?: Maybe<TennisRatingScales>;
  /** fetch data from the table in a streaming manner: "tennis_rating_scales" */
  tennisRatingScalesStream: Array<TennisRatingScales>;
  /** fetch data from the table: "twilio_group_texts" */
  twilioGroupTexts: Array<TwilioGroupTexts>;
  /** fetch data from the table: "twilio_group_texts" using primary key columns */
  twilioGroupTextsByPk?: Maybe<TwilioGroupTexts>;
  /** fetch data from the table in a streaming manner: "twilio_group_texts" */
  twilioGroupTextsStream: Array<TwilioGroupTexts>;
  /** fetch data from the table: "upload_review_requests" */
  uploadReviewRequests: Array<UploadReviewRequests>;
  /** fetch data from the table: "upload_review_requests" using primary key columns */
  uploadReviewRequestsByPk?: Maybe<UploadReviewRequests>;
  /** fetch data from the table in a streaming manner: "upload_review_requests" */
  uploadReviewRequestsStream: Array<UploadReviewRequests>;
  /** fetch data from the table: "user_blocks" */
  userBlocks: Array<UserBlocks>;
  /** fetch data from the table: "user_blocks" using primary key columns */
  userBlocksByPk?: Maybe<UserBlocks>;
  /** fetch data from the table in a streaming manner: "user_blocks" */
  userBlocksStream: Array<UserBlocks>;
  /** fetch data from the table: "user_coach_services" */
  userCoachServices: Array<UserCoachServices>;
  /** fetch data from the table: "user_coach_services" using primary key columns */
  userCoachServicesByPk?: Maybe<UserCoachServices>;
  /** fetch data from the table in a streaming manner: "user_coach_services" */
  userCoachServicesStream: Array<UserCoachServices>;
  /** fetch data from the table: "user_communication_preferences" */
  userCommunicationPreferences: Array<UserCommunicationPreferences>;
  /** fetch data from the table: "user_communication_preferences" using primary key columns */
  userCommunicationPreferencesByPk?: Maybe<UserCommunicationPreferences>;
  /** fetch data from the table in a streaming manner: "user_communication_preferences" */
  userCommunicationPreferencesStream: Array<UserCommunicationPreferences>;
  /** fetch data from the table: "user_connection_request_statuses" */
  userConnectionRequestStatuses: Array<UserConnectionRequestStatuses>;
  /** fetch data from the table: "user_connection_request_statuses" using primary key columns */
  userConnectionRequestStatusesByPk?: Maybe<UserConnectionRequestStatuses>;
  /** fetch data from the table in a streaming manner: "user_connection_request_statuses" */
  userConnectionRequestStatusesStream: Array<UserConnectionRequestStatuses>;
  /** fetch data from the table: "user_connection_requests" */
  userConnectionRequests: Array<UserConnectionRequests>;
  /** fetch aggregated fields from the table: "user_connection_requests" */
  userConnectionRequestsAggregate: UserConnectionRequestsAggregate;
  /** fetch data from the table: "user_connection_requests" using primary key columns */
  userConnectionRequestsByPk?: Maybe<UserConnectionRequests>;
  /** fetch data from the table in a streaming manner: "user_connection_requests" */
  userConnectionRequestsStream: Array<UserConnectionRequests>;
  /** fetch data from the table: "user_connections" */
  userConnections: Array<UserConnections>;
  /** fetch aggregated fields from the table: "user_connections" */
  userConnectionsAggregate: UserConnectionsAggregate;
  /** fetch data from the table: "user_connections" using primary key columns */
  userConnectionsByPk?: Maybe<UserConnections>;
  /** fetch data from the table in a streaming manner: "user_connections" */
  userConnectionsStream: Array<UserConnections>;
  /** fetch data from the table: "user_content_beta_subscriptions" */
  userContentBetaSubscriptions: Array<UserContentBetaSubscriptions>;
  /** fetch data from the table: "user_content_beta_subscriptions" using primary key columns */
  userContentBetaSubscriptionsByPk?: Maybe<UserContentBetaSubscriptions>;
  /** fetch data from the table in a streaming manner: "user_content_beta_subscriptions" */
  userContentBetaSubscriptionsStream: Array<UserContentBetaSubscriptions>;
  /** fetch data from the table: "user_content_files" */
  userContentFiles: Array<UserContentFiles>;
  /** fetch data from the table: "user_content_files" using primary key columns */
  userContentFilesByPk?: Maybe<UserContentFiles>;
  /** An array relationship */
  userContentFilesSkills: Array<UserContentFilesSkills>;
  /** fetch data from the table: "user_content_files_skills" using primary key columns */
  userContentFilesSkillsByPk?: Maybe<UserContentFilesSkills>;
  /** fetch data from the table in a streaming manner: "user_content_files_skills" */
  userContentFilesSkillsStream: Array<UserContentFilesSkills>;
  /** fetch data from the table in a streaming manner: "user_content_files" */
  userContentFilesStream: Array<UserContentFiles>;
  /** fetch data from the table: "user_content_skills" */
  userContentSkills: Array<UserContentSkills>;
  /** fetch data from the table: "user_content_skills" using primary key columns */
  userContentSkillsByPk?: Maybe<UserContentSkills>;
  /** fetch data from the table in a streaming manner: "user_content_skills" */
  userContentSkillsStream: Array<UserContentSkills>;
  /** fetch data from the table: "user_credit_cards" */
  userCreditCards: Array<UserCreditCards>;
  /** fetch data from the table: "user_credit_cards" using primary key columns */
  userCreditCardsByPk?: Maybe<UserCreditCards>;
  /** fetch data from the table in a streaming manner: "user_credit_cards" */
  userCreditCardsStream: Array<UserCreditCards>;
  /** fetch data from the table: "user_custom_courts" */
  userCustomCourts: Array<UserCustomCourts>;
  /** fetch data from the table: "user_custom_courts" using primary key columns */
  userCustomCourtsByPk?: Maybe<UserCustomCourts>;
  /** fetch data from the table in a streaming manner: "user_custom_courts" */
  userCustomCourtsStream: Array<UserCustomCourts>;
  /** An array relationship */
  userFiles: Array<UserFiles>;
  /** fetch data from the table: "user_files" using primary key columns */
  userFilesByPk?: Maybe<UserFiles>;
  /** fetch data from the table in a streaming manner: "user_files" */
  userFilesStream: Array<UserFiles>;
  /** fetch data from the table: "user_follows" */
  userFollows: Array<UserFollows>;
  /** fetch aggregated fields from the table: "user_follows" */
  userFollowsAggregate: UserFollowsAggregate;
  /** fetch data from the table: "user_follows" using primary key columns */
  userFollowsByPk?: Maybe<UserFollows>;
  /** fetch data from the table in a streaming manner: "user_follows" */
  userFollowsStream: Array<UserFollows>;
  /** fetch data from the table: "user_identity_verifications" */
  userIdentityVerifications: Array<UserIdentityVerifications>;
  /** fetch data from the table: "user_identity_verifications" using primary key columns */
  userIdentityVerificationsByPk?: Maybe<UserIdentityVerifications>;
  /** fetch data from the table in a streaming manner: "user_identity_verifications" */
  userIdentityVerificationsStream: Array<UserIdentityVerifications>;
  /** fetch data from the table: "user_image_log" */
  userImageLog: Array<UserImageLog>;
  /** fetch data from the table: "user_image_log" using primary key columns */
  userImageLogByPk?: Maybe<UserImageLog>;
  /** fetch data from the table in a streaming manner: "user_image_log" */
  userImageLogStream: Array<UserImageLog>;
  /** fetch data from the table: "user_notification_details" */
  userNotificationDetails: Array<UserNotificationDetails>;
  /** fetch data from the table: "user_notification_details" using primary key columns */
  userNotificationDetailsByPk?: Maybe<UserNotificationDetails>;
  /** fetch data from the table in a streaming manner: "user_notification_details" */
  userNotificationDetailsStream: Array<UserNotificationDetails>;
  /** fetch data from the table: "user_notification_entities" */
  userNotificationEntities: Array<UserNotificationEntities>;
  /** fetch data from the table: "user_notification_entities" using primary key columns */
  userNotificationEntitiesByPk?: Maybe<UserNotificationEntities>;
  /** fetch data from the table in a streaming manner: "user_notification_entities" */
  userNotificationEntitiesStream: Array<UserNotificationEntities>;
  /** An array relationship */
  userNotifications: Array<UserNotifications>;
  /** An aggregate relationship */
  userNotificationsAggregate: UserNotificationsAggregate;
  /** fetch data from the table: "user_notifications" using primary key columns */
  userNotificationsByPk?: Maybe<UserNotifications>;
  /** fetch data from the table in a streaming manner: "user_notifications" */
  userNotificationsStream: Array<UserNotifications>;
  /** fetch data from the table: "user_padel_rating_scales" */
  userPadelRatingScales: Array<UserPadelRatingScales>;
  /** fetch data from the table: "user_padel_rating_scales" using primary key columns */
  userPadelRatingScalesByPk?: Maybe<UserPadelRatingScales>;
  /** fetch data from the table in a streaming manner: "user_padel_rating_scales" */
  userPadelRatingScalesStream: Array<UserPadelRatingScales>;
  /** fetch data from the table: "user_pickleball_rating_scales" */
  userPickleballRatingScales: Array<UserPickleballRatingScales>;
  /** fetch data from the table: "user_pickleball_rating_scales" using primary key columns */
  userPickleballRatingScalesByPk?: Maybe<UserPickleballRatingScales>;
  /** fetch data from the table in a streaming manner: "user_pickleball_rating_scales" */
  userPickleballRatingScalesStream: Array<UserPickleballRatingScales>;
  /** fetch data from the table: "user_played_with" */
  userPlayedWith: Array<UserPlayedWith>;
  /** fetch aggregated fields from the table: "user_played_with" */
  userPlayedWithAggregate: UserPlayedWithAggregate;
  /** fetch data from the table: "user_played_with_dismissals" */
  userPlayedWithDismissals: Array<UserPlayedWithDismissals>;
  /** fetch data from the table: "user_played_with_dismissals" using primary key columns */
  userPlayedWithDismissalsByPk?: Maybe<UserPlayedWithDismissals>;
  /** fetch data from the table in a streaming manner: "user_played_with_dismissals" */
  userPlayedWithDismissalsStream: Array<UserPlayedWithDismissals>;
  /** fetch data from the table: "user_played_with_games" */
  userPlayedWithGames: Array<UserPlayedWithGames>;
  /** fetch aggregated fields from the table: "user_played_with_games" */
  userPlayedWithGamesAggregate: UserPlayedWithGamesAggregate;
  /** fetch data from the table in a streaming manner: "user_played_with_games" */
  userPlayedWithGamesStream: Array<UserPlayedWithGames>;
  /** fetch data from the table in a streaming manner: "user_played_with" */
  userPlayedWithStream: Array<UserPlayedWith>;
  /** fetch data from the table: "user_player_finder_availability" */
  userPlayerFinderAvailability: Array<UserPlayerFinderAvailability>;
  /** fetch data from the table: "user_player_finder_availability" using primary key columns */
  userPlayerFinderAvailabilityByPk?: Maybe<UserPlayerFinderAvailability>;
  /** fetch data from the table in a streaming manner: "user_player_finder_availability" */
  userPlayerFinderAvailabilityStream: Array<UserPlayerFinderAvailability>;
  /** fetch data from the table: "user_player_finder_goals" */
  userPlayerFinderGoals: Array<UserPlayerFinderGoals>;
  /** fetch data from the table: "user_player_finder_goals" using primary key columns */
  userPlayerFinderGoalsByPk?: Maybe<UserPlayerFinderGoals>;
  /** fetch data from the table in a streaming manner: "user_player_finder_goals" */
  userPlayerFinderGoalsStream: Array<UserPlayerFinderGoals>;
  /** fetch data from the table: "user_profiles" */
  userProfiles: Array<UserProfiles>;
  /** fetch aggregated fields from the table: "user_profiles" */
  userProfilesAggregate: UserProfilesAggregate;
  /** fetch data from the table in a streaming manner: "user_profiles" */
  userProfilesStream: Array<UserProfiles>;
  /** fetch data from the table: "user_sports" */
  userSports: Array<UserSports>;
  /** fetch data from the table: "user_sports" using primary key columns */
  userSportsByPk?: Maybe<UserSports>;
  /** fetch data from the table in a streaming manner: "user_sports" */
  userSportsStream: Array<UserSports>;
  /** fetch data from the table: "user_tennis_rating_scales" */
  userTennisRatingScales: Array<UserTennisRatingScales>;
  /** fetch data from the table: "user_tennis_rating_scales" using primary key columns */
  userTennisRatingScalesByPk?: Maybe<UserTennisRatingScales>;
  /** fetch data from the table in a streaming manner: "user_tennis_rating_scales" */
  userTennisRatingScalesStream: Array<UserTennisRatingScales>;
  /** fetch data from the table: "user_terms_of_service" */
  userTermsOfService: Array<UserTermsOfService>;
  /** fetch data from the table: "user_terms_of_service" using primary key columns */
  userTermsOfServiceByPk?: Maybe<UserTermsOfService>;
  /** fetch data from the table in a streaming manner: "user_terms_of_service" */
  userTermsOfServiceStream: Array<UserTermsOfService>;
  /** fetch data from the table: "user_vair_connections" */
  userVairConnections: Array<UserVairConnections>;
  /** fetch data from the table: "user_vair_connections" using primary key columns */
  userVairConnectionsByPk?: Maybe<UserVairConnections>;
  /** fetch data from the table in a streaming manner: "user_vair_connections" */
  userVairConnectionsStream: Array<UserVairConnections>;
  /** fetch data from the table: "usernames_active" */
  usernamesActive: Array<UsernamesActive>;
  /** fetch data from the table in a streaming manner: "usernames_active" */
  usernamesActiveStream: Array<UsernamesActive>;
  /** An array relationship */
  usernamesClaimed: Array<UsernamesClaimed>;
  /** fetch data from the table: "usernames_claimed" using primary key columns */
  usernamesClaimedByPk?: Maybe<UsernamesClaimed>;
  /** fetch data from the table in a streaming manner: "usernames_claimed" */
  usernamesClaimedStream: Array<UsernamesClaimed>;
  /** An array relationship */
  users: Array<Users>;
  /** fetch data from the table: "users" using primary key columns */
  usersByPk?: Maybe<Users>;
  /** fetch data from the table: "users_coach_qualifications" */
  usersCoachQualifications: Array<UsersCoachQualifications>;
  /** fetch data from the table: "users_coach_qualifications" using primary key columns */
  usersCoachQualificationsByPk?: Maybe<UsersCoachQualifications>;
  /** fetch data from the table in a streaming manner: "users_coach_qualifications" */
  usersCoachQualificationsStream: Array<UsersCoachQualifications>;
  /** fetch data from the table in a streaming manner: "users" */
  usersStream: Array<Users>;
  /** fetch data from the table: "venue_access_types" */
  venueAccessTypes: Array<VenueAccessTypes>;
  /** fetch data from the table: "venue_access_types" using primary key columns */
  venueAccessTypesByPk?: Maybe<VenueAccessTypes>;
  /** fetch data from the table in a streaming manner: "venue_access_types" */
  venueAccessTypesStream: Array<VenueAccessTypes>;
  /** fetch data from the table: "venue_admin_claim_statuses" */
  venueAdminClaimStatuses: Array<VenueAdminClaimStatuses>;
  /** fetch data from the table: "venue_admin_claim_statuses" using primary key columns */
  venueAdminClaimStatusesByPk?: Maybe<VenueAdminClaimStatuses>;
  /** fetch data from the table in a streaming manner: "venue_admin_claim_statuses" */
  venueAdminClaimStatusesStream: Array<VenueAdminClaimStatuses>;
  /** fetch data from the table: "venue_admin_claims" */
  venueAdminClaims: Array<VenueAdminClaims>;
  /** fetch data from the table: "venue_admin_claims" using primary key columns */
  venueAdminClaimsByPk?: Maybe<VenueAdminClaims>;
  /** fetch data from the table in a streaming manner: "venue_admin_claims" */
  venueAdminClaimsStream: Array<VenueAdminClaims>;
  /** fetch data from the table: "venue_amenities" */
  venueAmenities: Array<VenueAmenities>;
  /** fetch data from the table: "venue_amenities" using primary key columns */
  venueAmenitiesByPk?: Maybe<VenueAmenities>;
  /** fetch data from the table in a streaming manner: "venue_amenities" */
  venueAmenitiesStream: Array<VenueAmenities>;
  /** fetch data from the table: "venue_booking_config_versions" */
  venueBookingConfigVersions: Array<VenueBookingConfigVersions>;
  /** fetch data from the table: "venue_booking_config_versions" using primary key columns */
  venueBookingConfigVersionsByPk?: Maybe<VenueBookingConfigVersions>;
  /** fetch data from the table in a streaming manner: "venue_booking_config_versions" */
  venueBookingConfigVersionsStream: Array<VenueBookingConfigVersions>;
  /** fetch data from the table: "venue_booking_connection_check_statuses" */
  venueBookingConnectionCheckStatuses: Array<VenueBookingConnectionCheckStatuses>;
  /** fetch data from the table: "venue_booking_connection_check_statuses" using primary key columns */
  venueBookingConnectionCheckStatusesByPk?: Maybe<VenueBookingConnectionCheckStatuses>;
  /** fetch data from the table in a streaming manner: "venue_booking_connection_check_statuses" */
  venueBookingConnectionCheckStatusesStream: Array<VenueBookingConnectionCheckStatuses>;
  /** fetch data from the table: "venue_booking_connection_checks" */
  venueBookingConnectionChecks: Array<VenueBookingConnectionChecks>;
  /** fetch data from the table: "venue_booking_connection_checks" using primary key columns */
  venueBookingConnectionChecksByPk?: Maybe<VenueBookingConnectionChecks>;
  /** fetch data from the table in a streaming manner: "venue_booking_connection_checks" */
  venueBookingConnectionChecksStream: Array<VenueBookingConnectionChecks>;
  /** fetch data from the table: "venue_booking_court_rates" */
  venueBookingCourtRates: Array<VenueBookingCourtRates>;
  /** fetch data from the table: "venue_booking_court_rates" using primary key columns */
  venueBookingCourtRatesByPk?: Maybe<VenueBookingCourtRates>;
  /** fetch data from the table in a streaming manner: "venue_booking_court_rates" */
  venueBookingCourtRatesStream: Array<VenueBookingCourtRates>;
  /** fetch data from the table: "venue_booking_integrations" */
  venueBookingIntegrations: Array<VenueBookingIntegrations>;
  /** fetch data from the table: "venue_booking_integrations" using primary key columns */
  venueBookingIntegrationsByPk?: Maybe<VenueBookingIntegrations>;
  /** fetch data from the table in a streaming manner: "venue_booking_integrations" */
  venueBookingIntegrationsStream: Array<VenueBookingIntegrations>;
  /** fetch data from the table: "venue_booking_rule_tiers" */
  venueBookingRuleTiers: Array<VenueBookingRuleTiers>;
  /** fetch data from the table: "venue_booking_rule_tiers" using primary key columns */
  venueBookingRuleTiersByPk?: Maybe<VenueBookingRuleTiers>;
  /** fetch data from the table in a streaming manner: "venue_booking_rule_tiers" */
  venueBookingRuleTiersStream: Array<VenueBookingRuleTiers>;
  /** fetch data from the table: "venue_booking_rules" */
  venueBookingRules: Array<VenueBookingRules>;
  /** fetch data from the table: "venue_booking_rules" using primary key columns */
  venueBookingRulesByPk?: Maybe<VenueBookingRules>;
  /** fetch data from the table in a streaming manner: "venue_booking_rules" */
  venueBookingRulesStream: Array<VenueBookingRules>;
  /** fetch data from the table: "venue_booking_windows" */
  venueBookingWindows: Array<VenueBookingWindows>;
  /** fetch data from the table: "venue_booking_windows" using primary key columns */
  venueBookingWindowsByPk?: Maybe<VenueBookingWindows>;
  /** fetch data from the table in a streaming manner: "venue_booking_windows" */
  venueBookingWindowsStream: Array<VenueBookingWindows>;
  /** fetch data from the table: "venue_court_surfaces" */
  venueCourtSurfaces: Array<VenueCourtSurfaces>;
  /** fetch data from the table: "venue_court_surfaces" using primary key columns */
  venueCourtSurfacesByPk?: Maybe<VenueCourtSurfaces>;
  /** fetch data from the table in a streaming manner: "venue_court_surfaces" */
  venueCourtSurfacesStream: Array<VenueCourtSurfaces>;
  /** fetch data from the table: "venue_custom_amenities" */
  venueCustomAmenities: Array<VenueCustomAmenities>;
  /** fetch data from the table: "venue_custom_amenities" using primary key columns */
  venueCustomAmenitiesByPk?: Maybe<VenueCustomAmenities>;
  /** fetch data from the table in a streaming manner: "venue_custom_amenities" */
  venueCustomAmenitiesStream: Array<VenueCustomAmenities>;
  /** fetch data from the table: "venue_equipment" */
  venueEquipment: Array<VenueEquipment>;
  /** fetch data from the table: "venue_equipment" using primary key columns */
  venueEquipmentByPk?: Maybe<VenueEquipment>;
  /** fetch data from the table in a streaming manner: "venue_equipment" */
  venueEquipmentStream: Array<VenueEquipment>;
  /** fetch data from the table: "venue_facility_types" */
  venueFacilityTypes: Array<VenueFacilityTypes>;
  /** fetch data from the table: "venue_facility_types" using primary key columns */
  venueFacilityTypesByPk?: Maybe<VenueFacilityTypes>;
  /** fetch data from the table in a streaming manner: "venue_facility_types" */
  venueFacilityTypesStream: Array<VenueFacilityTypes>;
  /** fetch data from the table: "venue_faqs" */
  venueFaqs: Array<VenueFaqs>;
  /** fetch data from the table: "venue_faqs" using primary key columns */
  venueFaqsByPk?: Maybe<VenueFaqs>;
  /** fetch data from the table in a streaming manner: "venue_faqs" */
  venueFaqsStream: Array<VenueFaqs>;
  /** An array relationship */
  venueFollows: Array<VenueFollows>;
  /** An aggregate relationship */
  venueFollowsAggregate: VenueFollowsAggregate;
  /** fetch data from the table: "venue_follows" using primary key columns */
  venueFollowsByPk?: Maybe<VenueFollows>;
  /** fetch data from the table in a streaming manner: "venue_follows" */
  venueFollowsStream: Array<VenueFollows>;
  /** fetch data from the table: "venue_images" */
  venueImages: Array<VenueImages>;
  /** fetch data from the table: "venue_images" using primary key columns */
  venueImagesByPk?: Maybe<VenueImages>;
  /** fetch data from the table in a streaming manner: "venue_images" */
  venueImagesStream: Array<VenueImages>;
  /** fetch data from the table: "venue_lines" */
  venueLines: Array<VenueLines>;
  /** fetch data from the table: "venue_lines" using primary key columns */
  venueLinesByPk?: Maybe<VenueLines>;
  /** fetch data from the table in a streaming manner: "venue_lines" */
  venueLinesStream: Array<VenueLines>;
  /** fetch data from the table: "venue_nets" */
  venueNets: Array<VenueNets>;
  /** fetch data from the table: "venue_nets" using primary key columns */
  venueNetsByPk?: Maybe<VenueNets>;
  /** fetch data from the table in a streaming manner: "venue_nets" */
  venueNetsStream: Array<VenueNets>;
  /** fetch data from the table: "venue_partner_booking_statuses" */
  venuePartnerBookingStatuses: Array<VenuePartnerBookingStatuses>;
  /** fetch data from the table in a streaming manner: "venue_partner_booking_statuses" */
  venuePartnerBookingStatusesStream: Array<VenuePartnerBookingStatuses>;
  /** fetch data from the table: "venue_staff_coaches" */
  venueStaffCoaches: Array<VenueStaffCoaches>;
  /** fetch aggregated fields from the table: "venue_staff_coaches" */
  venueStaffCoachesAggregate: VenueStaffCoachesAggregate;
  /** fetch data from the table: "venue_staff_coaches" using primary key columns */
  venueStaffCoachesByPk?: Maybe<VenueStaffCoaches>;
  /** fetch data from the table in a streaming manner: "venue_staff_coaches" */
  venueStaffCoachesStream: Array<VenueStaffCoaches>;
  /** An array relationship */
  venues: Array<Venues>;
  /** fetch data from the table: "venues" using primary key columns */
  venuesByPk?: Maybe<Venues>;
  /** fetch data from the table in a streaming manner: "venues" */
  venuesStream: Array<Venues>;
  /** fetch data from the table: "video_analysis" */
  videoAnalysis: Array<VideoAnalysis>;
  /** fetch aggregated fields from the table: "video_analysis" */
  videoAnalysisAggregate: VideoAnalysisAggregate;
  /** fetch data from the table: "video_analysis" using primary key columns */
  videoAnalysisByPk?: Maybe<VideoAnalysis>;
  /** An array relationship */
  videoAnalysisComments: Array<VideoAnalysisComments>;
  /** fetch data from the table: "video_analysis_comments" using primary key columns */
  videoAnalysisCommentsByPk?: Maybe<VideoAnalysisComments>;
  /** fetch data from the table in a streaming manner: "video_analysis_comments" */
  videoAnalysisCommentsStream: Array<VideoAnalysisComments>;
  /** An array relationship */
  videoAnalysisFiles: Array<VideoAnalysisFiles>;
  /** fetch data from the table: "video_analysis_files" using primary key columns */
  videoAnalysisFilesByPk?: Maybe<VideoAnalysisFiles>;
  /** fetch data from the table in a streaming manner: "video_analysis_files" */
  videoAnalysisFilesStream: Array<VideoAnalysisFiles>;
  /** fetch data from the table: "video_analysis_order_items" */
  videoAnalysisOrderItems: Array<VideoAnalysisOrderItems>;
  /** fetch data from the table: "video_analysis_order_items" using primary key columns */
  videoAnalysisOrderItemsByPk?: Maybe<VideoAnalysisOrderItems>;
  /** fetch data from the table in a streaming manner: "video_analysis_order_items" */
  videoAnalysisOrderItemsStream: Array<VideoAnalysisOrderItems>;
  /** fetch data from the table: "video_analysis_orders" */
  videoAnalysisOrders: Array<VideoAnalysisOrders>;
  /** fetch data from the table: "video_analysis_orders" using primary key columns */
  videoAnalysisOrdersByPk?: Maybe<VideoAnalysisOrders>;
  /** fetch data from the table in a streaming manner: "video_analysis_orders" */
  videoAnalysisOrdersStream: Array<VideoAnalysisOrders>;
  /** fetch data from the table: "video_analysis_requested_skills_review" */
  videoAnalysisRequestedSkillsReview: Array<VideoAnalysisRequestedSkillsReview>;
  /** fetch data from the table: "video_analysis_requested_skills_review" using primary key columns */
  videoAnalysisRequestedSkillsReviewByPk?: Maybe<VideoAnalysisRequestedSkillsReview>;
  /** fetch data from the table in a streaming manner: "video_analysis_requested_skills_review" */
  videoAnalysisRequestedSkillsReviewStream: Array<VideoAnalysisRequestedSkillsReview>;
  /** An array relationship */
  videoAnalysisSkillsComments: Array<VideoAnalysisSkillsComments>;
  /** fetch data from the table: "video_analysis_skills_comments" using primary key columns */
  videoAnalysisSkillsCommentsByPk?: Maybe<VideoAnalysisSkillsComments>;
  /** fetch data from the table in a streaming manner: "video_analysis_skills_comments" */
  videoAnalysisSkillsCommentsStream: Array<VideoAnalysisSkillsComments>;
  /** fetch data from the table in a streaming manner: "video_analysis" */
  videoAnalysisStream: Array<VideoAnalysis>;
  /** fetch data from the table: "video_analysis_submission_log" */
  videoAnalysisSubmissionLog: Array<VideoAnalysisSubmissionLog>;
  /** fetch data from the table: "video_analysis_submission_log" using primary key columns */
  videoAnalysisSubmissionLogByPk?: Maybe<VideoAnalysisSubmissionLog>;
  /** fetch data from the table in a streaming manner: "video_analysis_submission_log" */
  videoAnalysisSubmissionLogStream: Array<VideoAnalysisSubmissionLog>;
  /** fetch data from the table: "video_lesson_skills" */
  videoLessonSkills: Array<VideoLessonSkills>;
  /** fetch data from the table: "video_lesson_skills" using primary key columns */
  videoLessonSkillsByPk?: Maybe<VideoLessonSkills>;
  /** fetch data from the table in a streaming manner: "video_lesson_skills" */
  videoLessonSkillsStream: Array<VideoLessonSkills>;
  /** fetch data from the table: "win_reasons" */
  winReasons: Array<WinReasons>;
  /** fetch data from the table: "win_reasons" using primary key columns */
  winReasonsByPk?: Maybe<WinReasons>;
  /** fetch data from the table in a streaming manner: "win_reasons" */
  winReasonsStream: Array<WinReasons>;
};


export type Subscription_RootAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<AmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AmenitiesOrderBy>>;
  where?: InputMaybe<AmenitiesBoolExp>;
};


export type Subscription_RootAmenitiesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootAmenitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AmenitiesStreamCursorInput>>;
  where?: InputMaybe<AmenitiesBoolExp>;
};


export type Subscription_RootAppPersonasArgs = {
  distinctOn?: InputMaybe<Array<AppPersonasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppPersonasOrderBy>>;
  where?: InputMaybe<AppPersonasBoolExp>;
};


export type Subscription_RootAppPersonasByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootAppPersonasStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AppPersonasStreamCursorInput>>;
  where?: InputMaybe<AppPersonasBoolExp>;
};


export type Subscription_RootAppPingsArgs = {
  distinctOn?: InputMaybe<Array<AppPingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppPingsOrderBy>>;
  where?: InputMaybe<AppPingsBoolExp>;
};


export type Subscription_RootAppPingsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAppPingsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AppPingsStreamCursorInput>>;
  where?: InputMaybe<AppPingsBoolExp>;
};


export type Subscription_RootBallTypesArgs = {
  distinctOn?: InputMaybe<Array<BallTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BallTypesOrderBy>>;
  where?: InputMaybe<BallTypesBoolExp>;
};


export type Subscription_RootBallTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBallTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BallTypesStreamCursorInput>>;
  where?: InputMaybe<BallTypesBoolExp>;
};


export type Subscription_RootBirthdayVisibilityArgs = {
  distinctOn?: InputMaybe<Array<BirthdayVisibilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BirthdayVisibilityOrderBy>>;
  where?: InputMaybe<BirthdayVisibilityBoolExp>;
};


export type Subscription_RootBirthdayVisibilityByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBirthdayVisibilityStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BirthdayVisibilityStreamCursorInput>>;
  where?: InputMaybe<BirthdayVisibilityBoolExp>;
};


export type Subscription_RootBookingConfigChangeTypesArgs = {
  distinctOn?: InputMaybe<Array<BookingConfigChangeTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingConfigChangeTypesOrderBy>>;
  where?: InputMaybe<BookingConfigChangeTypesBoolExp>;
};


export type Subscription_RootBookingConfigChangeTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBookingConfigChangeTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BookingConfigChangeTypesStreamCursorInput>>;
  where?: InputMaybe<BookingConfigChangeTypesBoolExp>;
};


export type Subscription_RootBookingConnectionStatusesArgs = {
  distinctOn?: InputMaybe<Array<BookingConnectionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingConnectionStatusesOrderBy>>;
  where?: InputMaybe<BookingConnectionStatusesBoolExp>;
};


export type Subscription_RootBookingConnectionStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBookingConnectionStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BookingConnectionStatusesStreamCursorInput>>;
  where?: InputMaybe<BookingConnectionStatusesBoolExp>;
};


export type Subscription_RootBookingIntegrationStatusesArgs = {
  distinctOn?: InputMaybe<Array<BookingIntegrationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingIntegrationStatusesOrderBy>>;
  where?: InputMaybe<BookingIntegrationStatusesBoolExp>;
};


export type Subscription_RootBookingIntegrationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBookingIntegrationStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BookingIntegrationStatusesStreamCursorInput>>;
  where?: InputMaybe<BookingIntegrationStatusesBoolExp>;
};


export type Subscription_RootBookingInventoryTypesArgs = {
  distinctOn?: InputMaybe<Array<BookingInventoryTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingInventoryTypesOrderBy>>;
  where?: InputMaybe<BookingInventoryTypesBoolExp>;
};


export type Subscription_RootBookingInventoryTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBookingInventoryTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BookingInventoryTypesStreamCursorInput>>;
  where?: InputMaybe<BookingInventoryTypesBoolExp>;
};


export type Subscription_RootBookingScheduleModesArgs = {
  distinctOn?: InputMaybe<Array<BookingScheduleModesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingScheduleModesOrderBy>>;
  where?: InputMaybe<BookingScheduleModesBoolExp>;
};


export type Subscription_RootBookingScheduleModesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBookingScheduleModesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BookingScheduleModesStreamCursorInput>>;
  where?: InputMaybe<BookingScheduleModesBoolExp>;
};


export type Subscription_RootBookingSystemsArgs = {
  distinctOn?: InputMaybe<Array<BookingSystemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingSystemsOrderBy>>;
  where?: InputMaybe<BookingSystemsBoolExp>;
};


export type Subscription_RootBookingSystemsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBookingSystemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BookingSystemsStreamCursorInput>>;
  where?: InputMaybe<BookingSystemsBoolExp>;
};


export type Subscription_RootBookingWindowKindsArgs = {
  distinctOn?: InputMaybe<Array<BookingWindowKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BookingWindowKindsOrderBy>>;
  where?: InputMaybe<BookingWindowKindsBoolExp>;
};


export type Subscription_RootBookingWindowKindsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBookingWindowKindsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BookingWindowKindsStreamCursorInput>>;
  where?: InputMaybe<BookingWindowKindsBoolExp>;
};


export type Subscription_RootBoostChannelsArgs = {
  distinctOn?: InputMaybe<Array<BoostChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostChannelsOrderBy>>;
  where?: InputMaybe<BoostChannelsBoolExp>;
};


export type Subscription_RootBoostChannelsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBoostChannelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BoostChannelsStreamCursorInput>>;
  where?: InputMaybe<BoostChannelsBoolExp>;
};


export type Subscription_RootBoostStatusesArgs = {
  distinctOn?: InputMaybe<Array<BoostStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostStatusesOrderBy>>;
  where?: InputMaybe<BoostStatusesBoolExp>;
};


export type Subscription_RootBoostStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBoostStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BoostStatusesStreamCursorInput>>;
  where?: InputMaybe<BoostStatusesBoolExp>;
};


export type Subscription_RootBoostsArgs = {
  distinctOn?: InputMaybe<Array<BoostsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BoostsOrderBy>>;
  where?: InputMaybe<BoostsBoolExp>;
};


export type Subscription_RootBoostsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootBoostsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BoostsStreamCursorInput>>;
  where?: InputMaybe<BoostsBoolExp>;
};


export type Subscription_RootBracketRankingMechanismArgs = {
  distinctOn?: InputMaybe<Array<BracketRankingMechanismSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BracketRankingMechanismOrderBy>>;
  where?: InputMaybe<BracketRankingMechanismBoolExp>;
};


export type Subscription_RootBracketRankingMechanismByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootBracketRankingMechanismStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BracketRankingMechanismStreamCursorInput>>;
  where?: InputMaybe<BracketRankingMechanismBoolExp>;
};


export type Subscription_RootCalendarAccountsArgs = {
  distinctOn?: InputMaybe<Array<CalendarAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarAccountsOrderBy>>;
  where?: InputMaybe<CalendarAccountsBoolExp>;
};


export type Subscription_RootCalendarAccountsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCalendarAccountsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CalendarAccountsStreamCursorInput>>;
  where?: InputMaybe<CalendarAccountsBoolExp>;
};


export type Subscription_RootCalendarPreferencesArgs = {
  distinctOn?: InputMaybe<Array<CalendarPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CalendarPreferencesOrderBy>>;
  where?: InputMaybe<CalendarPreferencesBoolExp>;
};


export type Subscription_RootCalendarPreferencesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCalendarPreferencesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CalendarPreferencesStreamCursorInput>>;
  where?: InputMaybe<CalendarPreferencesBoolExp>;
};


export type Subscription_RootCitiesArgs = {
  distinctOn?: InputMaybe<Array<CitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CitiesOrderBy>>;
  where?: InputMaybe<CitiesBoolExp>;
};


export type Subscription_RootCitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CitiesStreamCursorInput>>;
  where?: InputMaybe<CitiesBoolExp>;
};


export type Subscription_RootCoachAvailabilityArgs = {
  distinctOn?: InputMaybe<Array<CoachAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachAvailabilityOrderBy>>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};


export type Subscription_RootCoachAvailabilityByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachAvailabilityStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachAvailabilityStreamCursorInput>>;
  where?: InputMaybe<CoachAvailabilityBoolExp>;
};


export type Subscription_RootCoachBookingRequestsArgs = {
  distinctOn?: InputMaybe<Array<CoachBookingRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachBookingRequestsOrderBy>>;
  where?: InputMaybe<CoachBookingRequestsBoolExp>;
};


export type Subscription_RootCoachBookingRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachBookingRequestsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachBookingRequestsStreamCursorInput>>;
  where?: InputMaybe<CoachBookingRequestsBoolExp>;
};


export type Subscription_RootCoachFaqsArgs = {
  distinctOn?: InputMaybe<Array<CoachFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachFaqsOrderBy>>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};


export type Subscription_RootCoachFaqsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachFaqsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachFaqsStreamCursorInput>>;
  where?: InputMaybe<CoachFaqsBoolExp>;
};


export type Subscription_RootCoachLessonAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonAgeGroupsOrderBy>>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};


export type Subscription_RootCoachLessonAgeGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachLessonAgeGroupsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachLessonAgeGroupsStreamCursorInput>>;
  where?: InputMaybe<CoachLessonAgeGroupsBoolExp>;
};


export type Subscription_RootCoachLessonSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<CoachLessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachLessonSkillLevelsOrderBy>>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};


export type Subscription_RootCoachLessonSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachLessonSkillLevelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachLessonSkillLevelsStreamCursorInput>>;
  where?: InputMaybe<CoachLessonSkillLevelsBoolExp>;
};


export type Subscription_RootCoachQualificationGroupsArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationGroupsOrderBy>>;
  where?: InputMaybe<CoachQualificationGroupsBoolExp>;
};


export type Subscription_RootCoachQualificationGroupsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCoachQualificationGroupsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachQualificationGroupsStreamCursorInput>>;
  where?: InputMaybe<CoachQualificationGroupsBoolExp>;
};


export type Subscription_RootCoachQualificationsArgs = {
  distinctOn?: InputMaybe<Array<CoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachQualificationsOrderBy>>;
  where?: InputMaybe<CoachQualificationsBoolExp>;
};


export type Subscription_RootCoachQualificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachQualificationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachQualificationsStreamCursorInput>>;
  where?: InputMaybe<CoachQualificationsBoolExp>;
};


export type Subscription_RootCoachSportStatusesArgs = {
  distinctOn?: InputMaybe<Array<CoachSportStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportStatusesOrderBy>>;
  where?: InputMaybe<CoachSportStatusesBoolExp>;
};


export type Subscription_RootCoachSportStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCoachSportStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachSportStatusesStreamCursorInput>>;
  where?: InputMaybe<CoachSportStatusesBoolExp>;
};


export type Subscription_RootCoachSportsArgs = {
  distinctOn?: InputMaybe<Array<CoachSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachSportsOrderBy>>;
  where?: InputMaybe<CoachSportsBoolExp>;
};


export type Subscription_RootCoachSportsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachSportsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachSportsStreamCursorInput>>;
  where?: InputMaybe<CoachSportsBoolExp>;
};


export type Subscription_RootCoachStarterProfilesArgs = {
  distinctOn?: InputMaybe<Array<CoachStarterProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStarterProfilesOrderBy>>;
  where?: InputMaybe<CoachStarterProfilesBoolExp>;
};


export type Subscription_RootCoachStarterProfilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCoachStarterProfilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachStarterProfilesStreamCursorInput>>;
  where?: InputMaybe<CoachStarterProfilesBoolExp>;
};


export type Subscription_RootCoachStatusArgs = {
  distinctOn?: InputMaybe<Array<CoachStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CoachStatusOrderBy>>;
  where?: InputMaybe<CoachStatusBoolExp>;
};


export type Subscription_RootCoachStatusByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCoachStatusStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CoachStatusStreamCursorInput>>;
  where?: InputMaybe<CoachStatusBoolExp>;
};


export type Subscription_RootCommentVoteArgs = {
  distinctOn?: InputMaybe<Array<CommentVoteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentVoteOrderBy>>;
  where?: InputMaybe<CommentVoteBoolExp>;
};


export type Subscription_RootCommentVoteByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCommentVoteStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CommentVoteStreamCursorInput>>;
  where?: InputMaybe<CommentVoteBoolExp>;
};


export type Subscription_RootCommunicationPreferenceStatusesArgs = {
  distinctOn?: InputMaybe<Array<CommunicationPreferenceStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommunicationPreferenceStatusesOrderBy>>;
  where?: InputMaybe<CommunicationPreferenceStatusesBoolExp>;
};


export type Subscription_RootCommunicationPreferenceStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCommunicationPreferenceStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CommunicationPreferenceStatusesStreamCursorInput>>;
  where?: InputMaybe<CommunicationPreferenceStatusesBoolExp>;
};


export type Subscription_RootCompetitionFormatsArgs = {
  distinctOn?: InputMaybe<Array<CompetitionFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetitionFormatsOrderBy>>;
  where?: InputMaybe<CompetitionFormatsBoolExp>;
};


export type Subscription_RootCompetitionFormatsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCompetitionFormatsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompetitionFormatsStreamCursorInput>>;
  where?: InputMaybe<CompetitionFormatsBoolExp>;
};


export type Subscription_RootCompetitionGenderArgs = {
  distinctOn?: InputMaybe<Array<CompetitionGenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetitionGenderOrderBy>>;
  where?: InputMaybe<CompetitionGenderBoolExp>;
};


export type Subscription_RootCompetitionGenderByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCompetitionGenderStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompetitionGenderStreamCursorInput>>;
  where?: InputMaybe<CompetitionGenderBoolExp>;
};


export type Subscription_RootContentReportsArgs = {
  distinctOn?: InputMaybe<Array<ContentReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContentReportsOrderBy>>;
  where?: InputMaybe<ContentReportsBoolExp>;
};


export type Subscription_RootContentReportsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootContentReportsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ContentReportsStreamCursorInput>>;
  where?: InputMaybe<ContentReportsBoolExp>;
};


export type Subscription_RootConversationParticipantsArgs = {
  distinctOn?: InputMaybe<Array<ConversationParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationParticipantsOrderBy>>;
  where?: InputMaybe<ConversationParticipantsBoolExp>;
};


export type Subscription_RootConversationParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootConversationParticipantsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ConversationParticipantsStreamCursorInput>>;
  where?: InputMaybe<ConversationParticipantsBoolExp>;
};


export type Subscription_RootConversationTypesArgs = {
  distinctOn?: InputMaybe<Array<ConversationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationTypesOrderBy>>;
  where?: InputMaybe<ConversationTypesBoolExp>;
};


export type Subscription_RootConversationTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootConversationTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ConversationTypesStreamCursorInput>>;
  where?: InputMaybe<ConversationTypesBoolExp>;
};


export type Subscription_RootConversationsArgs = {
  distinctOn?: InputMaybe<Array<ConversationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
  where?: InputMaybe<ConversationsBoolExp>;
};


export type Subscription_RootConversationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootConversationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ConversationsStreamCursorInput>>;
  where?: InputMaybe<ConversationsBoolExp>;
};


export type Subscription_RootCountriesArgs = {
  distinctOn?: InputMaybe<Array<CountriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
  where?: InputMaybe<CountriesBoolExp>;
};


export type Subscription_RootCountriesByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCountriesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CountriesStreamCursorInput>>;
  where?: InputMaybe<CountriesBoolExp>;
};


export type Subscription_RootCountrySubdivisionsArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


export type Subscription_RootCountrySubdivisionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCountrySubdivisionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CountrySubdivisionsStreamCursorInput>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


export type Subscription_RootCourtSurfacesArgs = {
  distinctOn?: InputMaybe<Array<CourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CourtSurfacesOrderBy>>;
  where?: InputMaybe<CourtSurfacesBoolExp>;
};


export type Subscription_RootCourtSurfacesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCourtSurfacesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CourtSurfacesStreamCursorInput>>;
  where?: InputMaybe<CourtSurfacesBoolExp>;
};


export type Subscription_RootDayOfWeekArgs = {
  distinctOn?: InputMaybe<Array<DayOfWeekSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DayOfWeekOrderBy>>;
  where?: InputMaybe<DayOfWeekBoolExp>;
};


export type Subscription_RootDayOfWeekByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootDayOfWeekStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<DayOfWeekStreamCursorInput>>;
  where?: InputMaybe<DayOfWeekBoolExp>;
};


export type Subscription_RootEngagementEntityTypesArgs = {
  distinctOn?: InputMaybe<Array<EngagementEntityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementEntityTypesOrderBy>>;
  where?: InputMaybe<EngagementEntityTypesBoolExp>;
};


export type Subscription_RootEngagementEntityTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEngagementEntityTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EngagementEntityTypesStreamCursorInput>>;
  where?: InputMaybe<EngagementEntityTypesBoolExp>;
};


export type Subscription_RootEngagementEventTypesArgs = {
  distinctOn?: InputMaybe<Array<EngagementEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementEventTypesOrderBy>>;
  where?: InputMaybe<EngagementEventTypesBoolExp>;
};


export type Subscription_RootEngagementEventTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEngagementEventTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EngagementEventTypesStreamCursorInput>>;
  where?: InputMaybe<EngagementEventTypesBoolExp>;
};


export type Subscription_RootEngagementSourcesArgs = {
  distinctOn?: InputMaybe<Array<EngagementSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementSourcesOrderBy>>;
  where?: InputMaybe<EngagementSourcesBoolExp>;
};


export type Subscription_RootEngagementSourcesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEngagementSourcesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EngagementSourcesStreamCursorInput>>;
  where?: InputMaybe<EngagementSourcesBoolExp>;
};


export type Subscription_RootEquipmentAvailabilitiesArgs = {
  distinctOn?: InputMaybe<Array<EquipmentAvailabilitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentAvailabilitiesOrderBy>>;
  where?: InputMaybe<EquipmentAvailabilitiesBoolExp>;
};


export type Subscription_RootEquipmentAvailabilitiesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEquipmentAvailabilitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EquipmentAvailabilitiesStreamCursorInput>>;
  where?: InputMaybe<EquipmentAvailabilitiesBoolExp>;
};


export type Subscription_RootEventAcceptedPlayRequestsArgs = {
  distinctOn?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAcceptedPlayRequestsOrderBy>>;
  where?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
};


export type Subscription_RootEventAcceptedPlayRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventAcceptedPlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAcceptedPlayRequestsOrderBy>>;
  where?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
};


export type Subscription_RootEventAcceptedPlayRequestsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventAcceptedPlayRequestsStreamCursorInput>>;
  where?: InputMaybe<EventAcceptedPlayRequestsBoolExp>;
};


export type Subscription_RootEventAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventAgeGroupsOrderBy>>;
  where?: InputMaybe<EventAgeGroupsBoolExp>;
};


export type Subscription_RootEventAgeGroupsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventAgeGroupsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventAgeGroupsStreamCursorInput>>;
  where?: InputMaybe<EventAgeGroupsBoolExp>;
};


export type Subscription_RootEventCollectionsArgs = {
  distinctOn?: InputMaybe<Array<EventCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCollectionsOrderBy>>;
  where?: InputMaybe<EventCollectionsBoolExp>;
};


export type Subscription_RootEventCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventCollectionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCollectionsStreamCursorInput>>;
  where?: InputMaybe<EventCollectionsBoolExp>;
};


export type Subscription_RootEventCompetitivenessArgs = {
  distinctOn?: InputMaybe<Array<EventCompetitivenessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCompetitivenessOrderBy>>;
  where?: InputMaybe<EventCompetitivenessBoolExp>;
};


export type Subscription_RootEventCompetitivenessByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventCompetitivenessStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCompetitivenessStreamCursorInput>>;
  where?: InputMaybe<EventCompetitivenessBoolExp>;
};


export type Subscription_RootEventContactDetailsArgs = {
  distinctOn?: InputMaybe<Array<EventContactDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventContactDetailsOrderBy>>;
  where?: InputMaybe<EventContactDetailsBoolExp>;
};


export type Subscription_RootEventContactDetailsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventContactDetailsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventContactDetailsStreamCursorInput>>;
  where?: InputMaybe<EventContactDetailsBoolExp>;
};


export type Subscription_RootEventCouponGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponGroupsOrderBy>>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};


export type Subscription_RootEventCouponGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventCouponGroupsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCouponGroupsStreamCursorInput>>;
  where?: InputMaybe<EventCouponGroupsBoolExp>;
};


export type Subscription_RootEventCouponRedemptionsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponRedemptionsOrderBy>>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};


export type Subscription_RootEventCouponRedemptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventCouponRedemptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponRedemptionsOrderBy>>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};


export type Subscription_RootEventCouponRedemptionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventCouponRedemptionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCouponRedemptionsStreamCursorInput>>;
  where?: InputMaybe<EventCouponRedemptionsBoolExp>;
};


export type Subscription_RootEventCouponSourceArgs = {
  distinctOn?: InputMaybe<Array<EventCouponSourceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponSourceOrderBy>>;
  where?: InputMaybe<EventCouponSourceBoolExp>;
};


export type Subscription_RootEventCouponSourceByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventCouponSourceStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCouponSourceStreamCursorInput>>;
  where?: InputMaybe<EventCouponSourceBoolExp>;
};


export type Subscription_RootEventCouponTypeArgs = {
  distinctOn?: InputMaybe<Array<EventCouponTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponTypeOrderBy>>;
  where?: InputMaybe<EventCouponTypeBoolExp>;
};


export type Subscription_RootEventCouponTypeByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventCouponTypeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCouponTypeStreamCursorInput>>;
  where?: InputMaybe<EventCouponTypeBoolExp>;
};


export type Subscription_RootEventCouponsArgs = {
  distinctOn?: InputMaybe<Array<EventCouponsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCouponsOrderBy>>;
  where?: InputMaybe<EventCouponsBoolExp>;
};


export type Subscription_RootEventCouponsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventCouponsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCouponsStreamCursorInput>>;
  where?: InputMaybe<EventCouponsBoolExp>;
};


export type Subscription_RootEventCourtStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventCourtStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtStatusesOrderBy>>;
  where?: InputMaybe<EventCourtStatusesBoolExp>;
};


export type Subscription_RootEventCourtStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventCourtStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCourtStatusesStreamCursorInput>>;
  where?: InputMaybe<EventCourtStatusesBoolExp>;
};


export type Subscription_RootEventCourtsArgs = {
  distinctOn?: InputMaybe<Array<EventCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventCourtsOrderBy>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


export type Subscription_RootEventCourtsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventCourtsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventCourtsStreamCursorInput>>;
  where?: InputMaybe<EventCourtsBoolExp>;
};


export type Subscription_RootEventFaqsArgs = {
  distinctOn?: InputMaybe<Array<EventFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventFaqsOrderBy>>;
  where?: InputMaybe<EventFaqsBoolExp>;
};


export type Subscription_RootEventFaqsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventFaqsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventFaqsStreamCursorInput>>;
  where?: InputMaybe<EventFaqsBoolExp>;
};


export type Subscription_RootEventGameScoresArgs = {
  distinctOn?: InputMaybe<Array<EventGameScoresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGameScoresOrderBy>>;
  where?: InputMaybe<EventGameScoresBoolExp>;
};


export type Subscription_RootEventGameScoresByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGameScoresStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGameScoresStreamCursorInput>>;
  where?: InputMaybe<EventGameScoresBoolExp>;
};


export type Subscription_RootEventGroupFormatsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupFormatsOrderBy>>;
  where?: InputMaybe<EventGroupFormatsBoolExp>;
};


export type Subscription_RootEventGroupFormatsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventGroupFormatsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupFormatsStreamCursorInput>>;
  where?: InputMaybe<EventGroupFormatsBoolExp>;
};


export type Subscription_RootEventGroupMergesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupMergesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupMergesOrderBy>>;
  where?: InputMaybe<EventGroupMergesBoolExp>;
};


export type Subscription_RootEventGroupMergesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupMergesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupMergesStreamCursorInput>>;
  where?: InputMaybe<EventGroupMergesBoolExp>;
};


export type Subscription_RootEventGroupPoolsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupPoolsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupPoolsOrderBy>>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};


export type Subscription_RootEventGroupPoolsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupPoolsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupPoolsStreamCursorInput>>;
  where?: InputMaybe<EventGroupPoolsBoolExp>;
};


export type Subscription_RootEventGroupRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRatingScalesOrderBy>>;
  where?: InputMaybe<EventGroupRatingScalesBoolExp>;
};


export type Subscription_RootEventGroupRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupRatingScalesStreamCursorInput>>;
  where?: InputMaybe<EventGroupRatingScalesBoolExp>;
};


export type Subscription_RootEventGroupRegistrationStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationStatusesOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationStatusesBoolExp>;
};


export type Subscription_RootEventGroupRegistrationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventGroupRegistrationStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupRegistrationStatusesStreamCursorInput>>;
  where?: InputMaybe<EventGroupRegistrationStatusesBoolExp>;
};


export type Subscription_RootEventGroupRegistrationsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupRegistrationsOrderBy>>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};


export type Subscription_RootEventGroupRegistrationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupRegistrationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupRegistrationsStreamCursorInput>>;
  where?: InputMaybe<EventGroupRegistrationsBoolExp>;
};


export type Subscription_RootEventGroupSequenceSeedingArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequenceSeedingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequenceSeedingOrderBy>>;
  where?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
};


export type Subscription_RootEventGroupSequenceSeedingByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupSequenceSeedingStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupSequenceSeedingStreamCursorInput>>;
  where?: InputMaybe<EventGroupSequenceSeedingBoolExp>;
};


export type Subscription_RootEventGroupSequencesArgs = {
  distinctOn?: InputMaybe<Array<EventGroupSequencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupSequencesOrderBy>>;
  where?: InputMaybe<EventGroupSequencesBoolExp>;
};


export type Subscription_RootEventGroupSequencesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupSequencesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupSequencesStreamCursorInput>>;
  where?: InputMaybe<EventGroupSequencesBoolExp>;
};


export type Subscription_RootEventGroupTimeSlotsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupTimeSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupTimeSlotsOrderBy>>;
  where?: InputMaybe<EventGroupTimeSlotsBoolExp>;
};


export type Subscription_RootEventGroupTimeSlotsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupTimeSlotsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupTimeSlotsStreamCursorInput>>;
  where?: InputMaybe<EventGroupTimeSlotsBoolExp>;
};


export type Subscription_RootEventGroupsArgs = {
  distinctOn?: InputMaybe<Array<EventGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventGroupsOrderBy>>;
  where?: InputMaybe<EventGroupsBoolExp>;
};


export type Subscription_RootEventGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventGroupsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventGroupsStreamCursorInput>>;
  where?: InputMaybe<EventGroupsBoolExp>;
};


export type Subscription_RootEventInvitationStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationStatusesOrderBy>>;
  where?: InputMaybe<EventInvitationStatusesBoolExp>;
};


export type Subscription_RootEventInvitationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventInvitationStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventInvitationStatusesStreamCursorInput>>;
  where?: InputMaybe<EventInvitationStatusesBoolExp>;
};


export type Subscription_RootEventInvitationTypesArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationTypesOrderBy>>;
  where?: InputMaybe<EventInvitationTypesBoolExp>;
};


export type Subscription_RootEventInvitationTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventInvitationTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventInvitationTypesStreamCursorInput>>;
  where?: InputMaybe<EventInvitationTypesBoolExp>;
};


export type Subscription_RootEventInvitationsArgs = {
  distinctOn?: InputMaybe<Array<EventInvitationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventInvitationsOrderBy>>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};


export type Subscription_RootEventInvitationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventInvitationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventInvitationsStreamCursorInput>>;
  where?: InputMaybe<EventInvitationsBoolExp>;
};


export type Subscription_RootEventListingFeesArgs = {
  distinctOn?: InputMaybe<Array<EventListingFeesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventListingFeesOrderBy>>;
  where?: InputMaybe<EventListingFeesBoolExp>;
};


export type Subscription_RootEventListingFeesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventListingFeesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventListingFeesStreamCursorInput>>;
  where?: InputMaybe<EventListingFeesBoolExp>;
};


export type Subscription_RootEventMatchGamesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchGamesOrderBy>>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};


export type Subscription_RootEventMatchGamesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventMatchGamesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventMatchGamesStreamCursorInput>>;
  where?: InputMaybe<EventMatchGamesBoolExp>;
};


export type Subscription_RootEventMatchesArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesOrderBy>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


export type Subscription_RootEventMatchesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventMatchesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventMatchesStreamCursorInput>>;
  where?: InputMaybe<EventMatchesBoolExp>;
};


export type Subscription_RootEventMatchesTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventMatchesTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventMatchesTeamsOrderBy>>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};


export type Subscription_RootEventMatchesTeamsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventMatchesTeamsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventMatchesTeamsStreamCursorInput>>;
  where?: InputMaybe<EventMatchesTeamsBoolExp>;
};


export type Subscription_RootEventOrganizerAccountTypesArgs = {
  distinctOn?: InputMaybe<Array<EventOrganizerAccountTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventOrganizerAccountTypesOrderBy>>;
  where?: InputMaybe<EventOrganizerAccountTypesBoolExp>;
};


export type Subscription_RootEventOrganizerAccountTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventOrganizerAccountTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventOrganizerAccountTypesStreamCursorInput>>;
  where?: InputMaybe<EventOrganizerAccountTypesBoolExp>;
};


export type Subscription_RootEventPlayerInviteStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventPlayerInviteStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPlayerInviteStatusesOrderBy>>;
  where?: InputMaybe<EventPlayerInviteStatusesBoolExp>;
};


export type Subscription_RootEventPlayerInviteStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventPlayerInviteStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventPlayerInviteStatusesStreamCursorInput>>;
  where?: InputMaybe<EventPlayerInviteStatusesBoolExp>;
};


export type Subscription_RootEventPlayerInvitesArgs = {
  distinctOn?: InputMaybe<Array<EventPlayerInvitesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPlayerInvitesOrderBy>>;
  where?: InputMaybe<EventPlayerInvitesBoolExp>;
};


export type Subscription_RootEventPlayerInvitesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventPlayerInvitesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPlayerInvitesOrderBy>>;
  where?: InputMaybe<EventPlayerInvitesBoolExp>;
};


export type Subscription_RootEventPlayerInvitesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventPlayerInvitesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventPlayerInvitesStreamCursorInput>>;
  where?: InputMaybe<EventPlayerInvitesBoolExp>;
};


export type Subscription_RootEventPoolRoundsArgs = {
  distinctOn?: InputMaybe<Array<EventPoolRoundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolRoundsOrderBy>>;
  where?: InputMaybe<EventPoolRoundsBoolExp>;
};


export type Subscription_RootEventPoolRoundsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventPoolRoundsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventPoolRoundsStreamCursorInput>>;
  where?: InputMaybe<EventPoolRoundsBoolExp>;
};


export type Subscription_RootEventPoolsTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventPoolsTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPoolsTeamsOrderBy>>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};


export type Subscription_RootEventPoolsTeamsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventPoolsTeamsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventPoolsTeamsStreamCursorInput>>;
  where?: InputMaybe<EventPoolsTeamsBoolExp>;
};


export type Subscription_RootEventPrivacyArgs = {
  distinctOn?: InputMaybe<Array<EventPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventPrivacyOrderBy>>;
  where?: InputMaybe<EventPrivacyBoolExp>;
};


export type Subscription_RootEventPrivacyByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventPrivacyStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventPrivacyStreamCursorInput>>;
  where?: InputMaybe<EventPrivacyBoolExp>;
};


export type Subscription_RootEventRegistrationDetailsArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationDetailsOrderBy>>;
  where?: InputMaybe<EventRegistrationDetailsBoolExp>;
};


export type Subscription_RootEventRegistrationDetailsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventRegistrationDetailsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventRegistrationDetailsStreamCursorInput>>;
  where?: InputMaybe<EventRegistrationDetailsBoolExp>;
};


export type Subscription_RootEventRegistrationsArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationsOrderBy>>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};


export type Subscription_RootEventRegistrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventRegistrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventRegistrationsOrderBy>>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};


export type Subscription_RootEventRegistrationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventRegistrationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventRegistrationsStreamCursorInput>>;
  where?: InputMaybe<EventRegistrationsBoolExp>;
};


export type Subscription_RootEventSequenceCompleteReasonsArgs = {
  distinctOn?: InputMaybe<Array<EventSequenceCompleteReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSequenceCompleteReasonsOrderBy>>;
  where?: InputMaybe<EventSequenceCompleteReasonsBoolExp>;
};


export type Subscription_RootEventSequenceCompleteReasonsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventSequenceCompleteReasonsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventSequenceCompleteReasonsStreamCursorInput>>;
  where?: InputMaybe<EventSequenceCompleteReasonsBoolExp>;
};


export type Subscription_RootEventSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<EventSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSkillLevelsOrderBy>>;
  where?: InputMaybe<EventSkillLevelsBoolExp>;
};


export type Subscription_RootEventSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventSkillLevelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventSkillLevelsStreamCursorInput>>;
  where?: InputMaybe<EventSkillLevelsBoolExp>;
};


export type Subscription_RootEventSponsorsArgs = {
  distinctOn?: InputMaybe<Array<EventSponsorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventSponsorsOrderBy>>;
  where?: InputMaybe<EventSponsorsBoolExp>;
};


export type Subscription_RootEventSponsorsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventSponsorsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventSponsorsStreamCursorInput>>;
  where?: InputMaybe<EventSponsorsBoolExp>;
};


export type Subscription_RootEventStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventStatusesOrderBy>>;
  where?: InputMaybe<EventStatusesBoolExp>;
};


export type Subscription_RootEventStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventStatusesStreamCursorInput>>;
  where?: InputMaybe<EventStatusesBoolExp>;
};


export type Subscription_RootEventTeamMemberStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMemberStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMemberStatusesOrderBy>>;
  where?: InputMaybe<EventTeamMemberStatusesBoolExp>;
};


export type Subscription_RootEventTeamMemberStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventTeamMemberStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTeamMemberStatusesStreamCursorInput>>;
  where?: InputMaybe<EventTeamMemberStatusesBoolExp>;
};


export type Subscription_RootEventTeamMembersArgs = {
  distinctOn?: InputMaybe<Array<EventTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamMembersOrderBy>>;
  where?: InputMaybe<EventTeamMembersBoolExp>;
};


export type Subscription_RootEventTeamMembersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventTeamMembersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTeamMembersStreamCursorInput>>;
  where?: InputMaybe<EventTeamMembersBoolExp>;
};


export type Subscription_RootEventTeamStatusesArgs = {
  distinctOn?: InputMaybe<Array<EventTeamStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamStatusesOrderBy>>;
  where?: InputMaybe<EventTeamStatusesBoolExp>;
};


export type Subscription_RootEventTeamStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventTeamStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTeamStatusesStreamCursorInput>>;
  where?: InputMaybe<EventTeamStatusesBoolExp>;
};


export type Subscription_RootEventTeamsArgs = {
  distinctOn?: InputMaybe<Array<EventTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTeamsOrderBy>>;
  where?: InputMaybe<EventTeamsBoolExp>;
};


export type Subscription_RootEventTeamsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventTeamsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTeamsStreamCursorInput>>;
  where?: InputMaybe<EventTeamsBoolExp>;
};


export type Subscription_RootEventTransactionItemTypesArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemTypesOrderBy>>;
  where?: InputMaybe<EventTransactionItemTypesBoolExp>;
};


export type Subscription_RootEventTransactionItemTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventTransactionItemTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTransactionItemTypesStreamCursorInput>>;
  where?: InputMaybe<EventTransactionItemTypesBoolExp>;
};


export type Subscription_RootEventTransactionItemsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionItemsOrderBy>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};


export type Subscription_RootEventTransactionItemsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventTransactionItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTransactionItemsStreamCursorInput>>;
  where?: InputMaybe<EventTransactionItemsBoolExp>;
};


export type Subscription_RootEventTransactionsArgs = {
  distinctOn?: InputMaybe<Array<EventTransactionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTransactionsOrderBy>>;
  where?: InputMaybe<EventTransactionsBoolExp>;
};


export type Subscription_RootEventTransactionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventTransactionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTransactionsStreamCursorInput>>;
  where?: InputMaybe<EventTransactionsBoolExp>;
};


export type Subscription_RootEventTypesArgs = {
  distinctOn?: InputMaybe<Array<EventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventTypesOrderBy>>;
  where?: InputMaybe<EventTypesBoolExp>;
};


export type Subscription_RootEventTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEventTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventTypesStreamCursorInput>>;
  where?: InputMaybe<EventTypesBoolExp>;
};


export type Subscription_RootEventsArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


export type Subscription_RootEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
  where?: InputMaybe<EventsBoolExp>;
};


export type Subscription_RootEventsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventsStreamCursorInput>>;
  where?: InputMaybe<EventsBoolExp>;
};


export type Subscription_RootFileCategoryArgs = {
  distinctOn?: InputMaybe<Array<FileCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileCategoryOrderBy>>;
  where?: InputMaybe<FileCategoryBoolExp>;
};


export type Subscription_RootFileCategoryByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootFileCategoryStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<FileCategoryStreamCursorInput>>;
  where?: InputMaybe<FileCategoryBoolExp>;
};


export type Subscription_RootFileFormatArgs = {
  distinctOn?: InputMaybe<Array<FileFormatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileFormatOrderBy>>;
  where?: InputMaybe<FileFormatBoolExp>;
};


export type Subscription_RootFileFormatByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootFileFormatStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<FileFormatStreamCursorInput>>;
  where?: InputMaybe<FileFormatBoolExp>;
};


export type Subscription_RootGameNetStatusesArgs = {
  distinctOn?: InputMaybe<Array<GameNetStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GameNetStatusesOrderBy>>;
  where?: InputMaybe<GameNetStatusesBoolExp>;
};


export type Subscription_RootGameNetStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootGameNetStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GameNetStatusesStreamCursorInput>>;
  where?: InputMaybe<GameNetStatusesBoolExp>;
};


export type Subscription_RootGenderArgs = {
  distinctOn?: InputMaybe<Array<GenderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GenderOrderBy>>;
  where?: InputMaybe<GenderBoolExp>;
};


export type Subscription_RootGenderByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootGenderStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GenderStreamCursorInput>>;
  where?: InputMaybe<GenderBoolExp>;
};


export type Subscription_RootGroupCommentVotesArgs = {
  distinctOn?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupCommentVotesOrderBy>>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};


export type Subscription_RootGroupCommentVotesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupCommentVotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupCommentVotesOrderBy>>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};


export type Subscription_RootGroupCommentVotesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupCommentVotesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupCommentVotesStreamCursorInput>>;
  where?: InputMaybe<GroupCommentVotesBoolExp>;
};


export type Subscription_RootGroupMembersArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


export type Subscription_RootGroupMembersAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembersOrderBy>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


export type Subscription_RootGroupMembersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupMembersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupMembersStreamCursorInput>>;
  where?: InputMaybe<GroupMembersBoolExp>;
};


export type Subscription_RootGroupThreadCommentFilesArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentFilesOrderBy>>;
  where?: InputMaybe<GroupThreadCommentFilesBoolExp>;
};


export type Subscription_RootGroupThreadCommentFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupThreadCommentFilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupThreadCommentFilesStreamCursorInput>>;
  where?: InputMaybe<GroupThreadCommentFilesBoolExp>;
};


export type Subscription_RootGroupThreadCommentsArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


export type Subscription_RootGroupThreadCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadCommentsOrderBy>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


export type Subscription_RootGroupThreadCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupThreadCommentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupThreadCommentsStreamCursorInput>>;
  where?: InputMaybe<GroupThreadCommentsBoolExp>;
};


export type Subscription_RootGroupThreadsArgs = {
  distinctOn?: InputMaybe<Array<GroupThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupThreadsOrderBy>>;
  where?: InputMaybe<GroupThreadsBoolExp>;
};


export type Subscription_RootGroupThreadsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupThreadsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupThreadsStreamCursorInput>>;
  where?: InputMaybe<GroupThreadsBoolExp>;
};


export type Subscription_RootGroupTypesArgs = {
  distinctOn?: InputMaybe<Array<GroupTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupTypesOrderBy>>;
  where?: InputMaybe<GroupTypesBoolExp>;
};


export type Subscription_RootGroupTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootGroupTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupTypesStreamCursorInput>>;
  where?: InputMaybe<GroupTypesBoolExp>;
};


export type Subscription_RootGroupVenuesArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


export type Subscription_RootGroupVenuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GroupVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupVenuesOrderBy>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


export type Subscription_RootGroupVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupVenuesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupVenuesStreamCursorInput>>;
  where?: InputMaybe<GroupVenuesBoolExp>;
};


export type Subscription_RootGroupsArgs = {
  distinctOn?: InputMaybe<Array<GroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
  where?: InputMaybe<GroupsBoolExp>;
};


export type Subscription_RootGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupsPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<GroupsPlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsPlaySessionsOrderBy>>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};


export type Subscription_RootGroupsPlaySessionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGroupsPlaySessionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupsPlaySessionsStreamCursorInput>>;
  where?: InputMaybe<GroupsPlaySessionsBoolExp>;
};


export type Subscription_RootGroupsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<GroupsStreamCursorInput>>;
  where?: InputMaybe<GroupsBoolExp>;
};


export type Subscription_RootIdentityVerificationProvidersArgs = {
  distinctOn?: InputMaybe<Array<IdentityVerificationProvidersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IdentityVerificationProvidersOrderBy>>;
  where?: InputMaybe<IdentityVerificationProvidersBoolExp>;
};


export type Subscription_RootIdentityVerificationProvidersByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootIdentityVerificationProvidersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IdentityVerificationProvidersStreamCursorInput>>;
  where?: InputMaybe<IdentityVerificationProvidersBoolExp>;
};


export type Subscription_RootIdentityVerificationStatusesArgs = {
  distinctOn?: InputMaybe<Array<IdentityVerificationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IdentityVerificationStatusesOrderBy>>;
  where?: InputMaybe<IdentityVerificationStatusesBoolExp>;
};


export type Subscription_RootIdentityVerificationStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootIdentityVerificationStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IdentityVerificationStatusesStreamCursorInput>>;
  where?: InputMaybe<IdentityVerificationStatusesBoolExp>;
};


export type Subscription_RootInvoicesArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


export type Subscription_RootInvoicesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootInvoicesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoicesStreamCursorInput>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentScheduleMediaWatchedArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleMediaWatchedOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentScheduleMediaWatchedByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramEnrollmentScheduleMediaWatchedStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedStreamCursorInput>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleMediaWatchedBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentScheduleProgressArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentScheduleProgressOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentScheduleProgressByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramEnrollmentScheduleProgressStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramEnrollmentScheduleProgressStreamCursorInput>>;
  where?: InputMaybe<LearningProgramEnrollmentScheduleProgressBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramEnrollmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramEnrollmentsOrderBy>>;
  where?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
};


export type Subscription_RootLearningProgramEnrollmentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramEnrollmentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramEnrollmentsStreamCursorInput>>;
  where?: InputMaybe<LearningProgramEnrollmentsBoolExp>;
};


export type Subscription_RootLearningProgramMediaArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramMediaOrderBy>>;
  where?: InputMaybe<LearningProgramMediaBoolExp>;
};


export type Subscription_RootLearningProgramMediaByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramMediaCategoriesArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramMediaCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramMediaCategoriesOrderBy>>;
  where?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
};


export type Subscription_RootLearningProgramMediaCategoriesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramMediaCategoriesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramMediaCategoriesStreamCursorInput>>;
  where?: InputMaybe<LearningProgramMediaCategoriesBoolExp>;
};


export type Subscription_RootLearningProgramMediaStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramMediaStreamCursorInput>>;
  where?: InputMaybe<LearningProgramMediaBoolExp>;
};


export type Subscription_RootLearningProgramScheduleMediaArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleMediaOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};


export type Subscription_RootLearningProgramScheduleMediaByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramScheduleMediaStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramScheduleMediaStreamCursorInput>>;
  where?: InputMaybe<LearningProgramScheduleMediaBoolExp>;
};


export type Subscription_RootLearningProgramScheduleUnitsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleUnitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleUnitsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleUnitsBoolExp>;
};


export type Subscription_RootLearningProgramScheduleUnitsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLearningProgramScheduleUnitsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramScheduleUnitsStreamCursorInput>>;
  where?: InputMaybe<LearningProgramScheduleUnitsBoolExp>;
};


export type Subscription_RootLearningProgramScheduleVideoSubmissionsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramScheduleVideoSubmissionsOrderBy>>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};


export type Subscription_RootLearningProgramScheduleVideoSubmissionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramScheduleVideoSubmissionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramScheduleVideoSubmissionsStreamCursorInput>>;
  where?: InputMaybe<LearningProgramScheduleVideoSubmissionsBoolExp>;
};


export type Subscription_RootLearningProgramSchedulesArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSchedulesOrderBy>>;
  where?: InputMaybe<LearningProgramSchedulesBoolExp>;
};


export type Subscription_RootLearningProgramSchedulesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramSchedulesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramSchedulesStreamCursorInput>>;
  where?: InputMaybe<LearningProgramSchedulesBoolExp>;
};


export type Subscription_RootLearningProgramSkillLevelValuesArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillLevelValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillLevelValuesOrderBy>>;
  where?: InputMaybe<LearningProgramSkillLevelValuesBoolExp>;
};


export type Subscription_RootLearningProgramSkillLevelValuesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLearningProgramSkillLevelValuesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramSkillLevelValuesStreamCursorInput>>;
  where?: InputMaybe<LearningProgramSkillLevelValuesBoolExp>;
};


export type Subscription_RootLearningProgramSkillsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramSkillsOrderBy>>;
  where?: InputMaybe<LearningProgramSkillsBoolExp>;
};


export type Subscription_RootLearningProgramSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramSkillsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramSkillsStreamCursorInput>>;
  where?: InputMaybe<LearningProgramSkillsBoolExp>;
};


export type Subscription_RootLearningProgramsArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramsOrderBy>>;
  where?: InputMaybe<LearningProgramsBoolExp>;
};


export type Subscription_RootLearningProgramsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LearningProgramsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LearningProgramsOrderBy>>;
  where?: InputMaybe<LearningProgramsBoolExp>;
};


export type Subscription_RootLearningProgramsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLearningProgramsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LearningProgramsStreamCursorInput>>;
  where?: InputMaybe<LearningProgramsBoolExp>;
};


export type Subscription_RootLessonAgeGroupsArgs = {
  distinctOn?: InputMaybe<Array<LessonAgeGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonAgeGroupsOrderBy>>;
  where?: InputMaybe<LessonAgeGroupsBoolExp>;
};


export type Subscription_RootLessonAgeGroupsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonAgeGroupsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonAgeGroupsStreamCursorInput>>;
  where?: InputMaybe<LessonAgeGroupsBoolExp>;
};


export type Subscription_RootLessonCollectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonCollectionsOrderBy>>;
  where?: InputMaybe<LessonCollectionsBoolExp>;
};


export type Subscription_RootLessonCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonCollectionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonCollectionsStreamCursorInput>>;
  where?: InputMaybe<LessonCollectionsBoolExp>;
};


export type Subscription_RootLessonEquipmentArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOrderBy>>;
  where?: InputMaybe<LessonEquipmentBoolExp>;
};


export type Subscription_RootLessonEquipmentByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonEquipmentOptionsArgs = {
  distinctOn?: InputMaybe<Array<LessonEquipmentOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonEquipmentOptionsOrderBy>>;
  where?: InputMaybe<LessonEquipmentOptionsBoolExp>;
};


export type Subscription_RootLessonEquipmentOptionsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonEquipmentOptionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonEquipmentOptionsStreamCursorInput>>;
  where?: InputMaybe<LessonEquipmentOptionsBoolExp>;
};


export type Subscription_RootLessonEquipmentStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonEquipmentStreamCursorInput>>;
  where?: InputMaybe<LessonEquipmentBoolExp>;
};


export type Subscription_RootLessonOrderItemsArgs = {
  distinctOn?: InputMaybe<Array<LessonOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrderItemsOrderBy>>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};


export type Subscription_RootLessonOrderItemsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonOrderItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonOrderItemsStreamCursorInput>>;
  where?: InputMaybe<LessonOrderItemsBoolExp>;
};


export type Subscription_RootLessonOrdersArgs = {
  distinctOn?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrdersOrderBy>>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};


export type Subscription_RootLessonOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonOrdersOrderBy>>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};


export type Subscription_RootLessonOrdersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonOrdersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonOrdersStreamCursorInput>>;
  where?: InputMaybe<LessonOrdersBoolExp>;
};


export type Subscription_RootLessonParticipantStatusesArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantStatusesOrderBy>>;
  where?: InputMaybe<LessonParticipantStatusesBoolExp>;
};


export type Subscription_RootLessonParticipantStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonParticipantStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonParticipantStatusesStreamCursorInput>>;
  where?: InputMaybe<LessonParticipantStatusesBoolExp>;
};


export type Subscription_RootLessonParticipantsArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


export type Subscription_RootLessonParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonParticipantsOrderBy>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


export type Subscription_RootLessonParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonParticipantsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonParticipantsStreamCursorInput>>;
  where?: InputMaybe<LessonParticipantsBoolExp>;
};


export type Subscription_RootLessonPlayerSkillAssessmentsArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
};


export type Subscription_RootLessonPlayerSkillAssessmentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonPlayerSkillAssessmentsSkillsArgs = {
  distinctOn?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPlayerSkillAssessmentsSkillsOrderBy>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
};


export type Subscription_RootLessonPlayerSkillAssessmentsSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonPlayerSkillAssessmentsSkillsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonPlayerSkillAssessmentsSkillsStreamCursorInput>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsSkillsBoolExp>;
};


export type Subscription_RootLessonPlayerSkillAssessmentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonPlayerSkillAssessmentsStreamCursorInput>>;
  where?: InputMaybe<LessonPlayerSkillAssessmentsBoolExp>;
};


export type Subscription_RootLessonPrivacyArgs = {
  distinctOn?: InputMaybe<Array<LessonPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonPrivacyOrderBy>>;
  where?: InputMaybe<LessonPrivacyBoolExp>;
};


export type Subscription_RootLessonPrivacyByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonPrivacyStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonPrivacyStreamCursorInput>>;
  where?: InputMaybe<LessonPrivacyBoolExp>;
};


export type Subscription_RootLessonReflectionCommentTypesArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentTypesOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentTypesBoolExp>;
};


export type Subscription_RootLessonReflectionCommentTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonReflectionCommentTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonReflectionCommentTypesStreamCursorInput>>;
  where?: InputMaybe<LessonReflectionCommentTypesBoolExp>;
};


export type Subscription_RootLessonReflectionCommentsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionCommentsOrderBy>>;
  where?: InputMaybe<LessonReflectionCommentsBoolExp>;
};


export type Subscription_RootLessonReflectionCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonReflectionCommentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonReflectionCommentsStreamCursorInput>>;
  where?: InputMaybe<LessonReflectionCommentsBoolExp>;
};


export type Subscription_RootLessonReflectionFilesArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionFilesOrderBy>>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};


export type Subscription_RootLessonReflectionFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonReflectionFilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonReflectionFilesStreamCursorInput>>;
  where?: InputMaybe<LessonReflectionFilesBoolExp>;
};


export type Subscription_RootLessonReflectionsArgs = {
  distinctOn?: InputMaybe<Array<LessonReflectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonReflectionsOrderBy>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


export type Subscription_RootLessonReflectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonReflectionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonReflectionsStreamCursorInput>>;
  where?: InputMaybe<LessonReflectionsBoolExp>;
};


export type Subscription_RootLessonSkillDisplayNamesArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillDisplayNamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillDisplayNamesOrderBy>>;
  where?: InputMaybe<LessonSkillDisplayNamesBoolExp>;
};


export type Subscription_RootLessonSkillDisplayNamesByPkArgs = {
  id: LessonSkillsEnum;
};


export type Subscription_RootLessonSkillDisplayNamesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonSkillDisplayNamesStreamCursorInput>>;
  where?: InputMaybe<LessonSkillDisplayNamesBoolExp>;
};


export type Subscription_RootLessonSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonSkillLevelsBoolExp>;
};


export type Subscription_RootLessonSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonSkillLevelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonSkillLevelsStreamCursorInput>>;
  where?: InputMaybe<LessonSkillLevelsBoolExp>;
};


export type Subscription_RootLessonSkillMappingsArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillMappingsOrderBy>>;
  where?: InputMaybe<LessonSkillMappingsBoolExp>;
};


export type Subscription_RootLessonSkillMappingsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonSkillMappingsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonSkillMappingsStreamCursorInput>>;
  where?: InputMaybe<LessonSkillMappingsBoolExp>;
};


export type Subscription_RootLessonSkillsArgs = {
  distinctOn?: InputMaybe<Array<LessonSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonSkillsOrderBy>>;
  where?: InputMaybe<LessonSkillsBoolExp>;
};


export type Subscription_RootLessonSkillsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonSkillsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonSkillsStreamCursorInput>>;
  where?: InputMaybe<LessonSkillsBoolExp>;
};


export type Subscription_RootLessonStatusesArgs = {
  distinctOn?: InputMaybe<Array<LessonStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonStatusesOrderBy>>;
  where?: InputMaybe<LessonStatusesBoolExp>;
};


export type Subscription_RootLessonStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonStatusesStreamCursorInput>>;
  where?: InputMaybe<LessonStatusesBoolExp>;
};


export type Subscription_RootLessonTemplateSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplateSkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplateSkillLevelsOrderBy>>;
  where?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
};


export type Subscription_RootLessonTemplateSkillLevelsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonTemplateSkillLevelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonTemplateSkillLevelsStreamCursorInput>>;
  where?: InputMaybe<LessonTemplateSkillLevelsBoolExp>;
};


export type Subscription_RootLessonTemplatesArgs = {
  distinctOn?: InputMaybe<Array<LessonTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTemplatesOrderBy>>;
  where?: InputMaybe<LessonTemplatesBoolExp>;
};


export type Subscription_RootLessonTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonTemplatesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonTemplatesStreamCursorInput>>;
  where?: InputMaybe<LessonTemplatesBoolExp>;
};


export type Subscription_RootLessonTimesArgs = {
  distinctOn?: InputMaybe<Array<LessonTimesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTimesOrderBy>>;
  where?: InputMaybe<LessonTimesBoolExp>;
};


export type Subscription_RootLessonTimesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonTimesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonTimesStreamCursorInput>>;
  where?: InputMaybe<LessonTimesBoolExp>;
};


export type Subscription_RootLessonTypesArgs = {
  distinctOn?: InputMaybe<Array<LessonTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonTypesOrderBy>>;
  where?: InputMaybe<LessonTypesBoolExp>;
};


export type Subscription_RootLessonTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonTypesStreamCursorInput>>;
  where?: InputMaybe<LessonTypesBoolExp>;
};


export type Subscription_RootLessonWaitlistStatusesArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistStatusesOrderBy>>;
  where?: InputMaybe<LessonWaitlistStatusesBoolExp>;
};


export type Subscription_RootLessonWaitlistStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLessonWaitlistStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonWaitlistStatusesStreamCursorInput>>;
  where?: InputMaybe<LessonWaitlistStatusesBoolExp>;
};


export type Subscription_RootLessonWaitlistsArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistsOrderBy>>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};


export type Subscription_RootLessonWaitlistsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonWaitlistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonWaitlistsOrderBy>>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};


export type Subscription_RootLessonWaitlistsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonWaitlistsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonWaitlistsStreamCursorInput>>;
  where?: InputMaybe<LessonWaitlistsBoolExp>;
};


export type Subscription_RootLessonsArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


export type Subscription_RootLessonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LessonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LessonsOrderBy>>;
  where?: InputMaybe<LessonsBoolExp>;
};


export type Subscription_RootLessonsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLessonsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LessonsStreamCursorInput>>;
  where?: InputMaybe<LessonsBoolExp>;
};


export type Subscription_RootMatchSelectionCriteriaArgs = {
  distinctOn?: InputMaybe<Array<MatchSelectionCriteriaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MatchSelectionCriteriaOrderBy>>;
  where?: InputMaybe<MatchSelectionCriteriaBoolExp>;
};


export type Subscription_RootMatchSelectionCriteriaByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootMatchSelectionCriteriaStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MatchSelectionCriteriaStreamCursorInput>>;
  where?: InputMaybe<MatchSelectionCriteriaBoolExp>;
};


export type Subscription_RootMessagesArgs = {
  distinctOn?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


export type Subscription_RootMessagesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMessagesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MessagesStreamCursorInput>>;
  where?: InputMaybe<MessagesBoolExp>;
};


export type Subscription_RootNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<NeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NeighborhoodsOrderBy>>;
  where?: InputMaybe<NeighborhoodsBoolExp>;
};


export type Subscription_RootNeighborhoodsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNeighborhoodsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<NeighborhoodsStreamCursorInput>>;
  where?: InputMaybe<NeighborhoodsBoolExp>;
};


export type Subscription_RootPadelRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<PadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PadelRatingScalesOrderBy>>;
  where?: InputMaybe<PadelRatingScalesBoolExp>;
};


export type Subscription_RootPadelRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPadelRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PadelRatingScalesStreamCursorInput>>;
  where?: InputMaybe<PadelRatingScalesBoolExp>;
};


export type Subscription_RootParticipantRolesArgs = {
  distinctOn?: InputMaybe<Array<ParticipantRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ParticipantRolesOrderBy>>;
  where?: InputMaybe<ParticipantRolesBoolExp>;
};


export type Subscription_RootParticipantRolesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootParticipantRolesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ParticipantRolesStreamCursorInput>>;
  where?: InputMaybe<ParticipantRolesBoolExp>;
};


export type Subscription_RootPartnerBookingOrderStatusesArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingOrderStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingOrderStatusesOrderBy>>;
  where?: InputMaybe<PartnerBookingOrderStatusesBoolExp>;
};


export type Subscription_RootPartnerBookingOrderStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPartnerBookingOrderStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerBookingOrderStatusesStreamCursorInput>>;
  where?: InputMaybe<PartnerBookingOrderStatusesBoolExp>;
};


export type Subscription_RootPartnerBookingOrdersArgs = {
  distinctOn?: InputMaybe<Array<PartnerBookingOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerBookingOrdersOrderBy>>;
  where?: InputMaybe<PartnerBookingOrdersBoolExp>;
};


export type Subscription_RootPartnerBookingOrdersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPartnerBookingOrdersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerBookingOrdersStreamCursorInput>>;
  where?: InputMaybe<PartnerBookingOrdersBoolExp>;
};


export type Subscription_RootPaymentFulfillmentChannelsArgs = {
  distinctOn?: InputMaybe<Array<PaymentFulfillmentChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentFulfillmentChannelsOrderBy>>;
  where?: InputMaybe<PaymentFulfillmentChannelsBoolExp>;
};


export type Subscription_RootPaymentFulfillmentChannelsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPaymentFulfillmentChannelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentFulfillmentChannelsStreamCursorInput>>;
  where?: InputMaybe<PaymentFulfillmentChannelsBoolExp>;
};


export type Subscription_RootPickleballRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<PickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PickleballRatingScalesOrderBy>>;
  where?: InputMaybe<PickleballRatingScalesBoolExp>;
};


export type Subscription_RootPickleballRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPickleballRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PickleballRatingScalesStreamCursorInput>>;
  where?: InputMaybe<PickleballRatingScalesBoolExp>;
};


export type Subscription_RootPlatformSubscriptionIntervalsArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionIntervalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionIntervalsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionIntervalsBoolExp>;
};


export type Subscription_RootPlatformSubscriptionIntervalsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlatformSubscriptionIntervalsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlatformSubscriptionIntervalsStreamCursorInput>>;
  where?: InputMaybe<PlatformSubscriptionIntervalsBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPersonasArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPersonasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPersonasOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPersonasBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPersonasByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlatformSubscriptionPersonasStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlatformSubscriptionPersonasStreamCursorInput>>;
  where?: InputMaybe<PlatformSubscriptionPersonasBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPlanPricesArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlanPricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlanPricesOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPlanPricesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlatformSubscriptionPlanPricesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlatformSubscriptionPlanPricesStreamCursorInput>>;
  where?: InputMaybe<PlatformSubscriptionPlanPricesBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPlansArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionPlansOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionPlansBoolExp>;
};


export type Subscription_RootPlatformSubscriptionPlansByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlatformSubscriptionPlansStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlatformSubscriptionPlansStreamCursorInput>>;
  where?: InputMaybe<PlatformSubscriptionPlansBoolExp>;
};


export type Subscription_RootPlatformSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<PlatformSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlatformSubscriptionsOrderBy>>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};


export type Subscription_RootPlatformSubscriptionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlatformSubscriptionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlatformSubscriptionsStreamCursorInput>>;
  where?: InputMaybe<PlatformSubscriptionsBoolExp>;
};


export type Subscription_RootPlayRequestNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
};


export type Subscription_RootPlayRequestNeighborhoodsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayRequestNeighborhoodsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayRequestNeighborhoodsStreamCursorInput>>;
  where?: InputMaybe<PlayRequestNeighborhoodsBoolExp>;
};


export type Subscription_RootPlayRequestSlotsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestSlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestSlotsOrderBy>>;
  where?: InputMaybe<PlayRequestSlotsBoolExp>;
};


export type Subscription_RootPlayRequestSlotsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayRequestSlotsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayRequestSlotsStreamCursorInput>>;
  where?: InputMaybe<PlayRequestSlotsBoolExp>;
};


export type Subscription_RootPlayRequestStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestStatusesOrderBy>>;
  where?: InputMaybe<PlayRequestStatusesBoolExp>;
};


export type Subscription_RootPlayRequestStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlayRequestStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayRequestStatusesStreamCursorInput>>;
  where?: InputMaybe<PlayRequestStatusesBoolExp>;
};


export type Subscription_RootPlayRequestVenuesArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestVenuesOrderBy>>;
  where?: InputMaybe<PlayRequestVenuesBoolExp>;
};


export type Subscription_RootPlayRequestVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayRequestVenuesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayRequestVenuesStreamCursorInput>>;
  where?: InputMaybe<PlayRequestVenuesBoolExp>;
};


export type Subscription_RootPlayRequestsArgs = {
  distinctOn?: InputMaybe<Array<PlayRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayRequestsOrderBy>>;
  where?: InputMaybe<PlayRequestsBoolExp>;
};


export type Subscription_RootPlayRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayRequestsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayRequestsStreamCursorInput>>;
  where?: InputMaybe<PlayRequestsBoolExp>;
};


export type Subscription_RootPlaySessionCommentsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


export type Subscription_RootPlaySessionCommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCommentsOrderBy>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


export type Subscription_RootPlaySessionCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlaySessionCommentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionCommentsStreamCursorInput>>;
  where?: InputMaybe<PlaySessionCommentsBoolExp>;
};


export type Subscription_RootPlaySessionCourtBookingStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionCourtBookingStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionCourtBookingStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionCourtBookingStatusesBoolExp>;
};


export type Subscription_RootPlaySessionCourtBookingStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlaySessionCourtBookingStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionCourtBookingStatusesStreamCursorInput>>;
  where?: InputMaybe<PlaySessionCourtBookingStatusesBoolExp>;
};


export type Subscription_RootPlaySessionFormatsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionFormatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionFormatsOrderBy>>;
  where?: InputMaybe<PlaySessionFormatsBoolExp>;
};


export type Subscription_RootPlaySessionFormatsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlaySessionFormatsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionFormatsStreamCursorInput>>;
  where?: InputMaybe<PlaySessionFormatsBoolExp>;
};


export type Subscription_RootPlaySessionMatchCompetitivenessArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionMatchCompetitivenessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionMatchCompetitivenessOrderBy>>;
  where?: InputMaybe<PlaySessionMatchCompetitivenessBoolExp>;
};


export type Subscription_RootPlaySessionMatchCompetitivenessByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlaySessionMatchCompetitivenessStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionMatchCompetitivenessStreamCursorInput>>;
  where?: InputMaybe<PlaySessionMatchCompetitivenessBoolExp>;
};


export type Subscription_RootPlaySessionParticipantStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantStatusesBoolExp>;
};


export type Subscription_RootPlaySessionParticipantStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlaySessionParticipantStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionParticipantStatusesStreamCursorInput>>;
  where?: InputMaybe<PlaySessionParticipantStatusesBoolExp>;
};


export type Subscription_RootPlaySessionParticipantsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantsOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};


export type Subscription_RootPlaySessionParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionParticipantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionParticipantsOrderBy>>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};


export type Subscription_RootPlaySessionParticipantsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlaySessionParticipantsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionParticipantsStreamCursorInput>>;
  where?: InputMaybe<PlaySessionParticipantsBoolExp>;
};


export type Subscription_RootPlaySessionPrivacyArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionPrivacySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionPrivacyOrderBy>>;
  where?: InputMaybe<PlaySessionPrivacyBoolExp>;
};


export type Subscription_RootPlaySessionPrivacyByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlaySessionPrivacyStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionPrivacyStreamCursorInput>>;
  where?: InputMaybe<PlaySessionPrivacyBoolExp>;
};


export type Subscription_RootPlaySessionStatusesArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionStatusesOrderBy>>;
  where?: InputMaybe<PlaySessionStatusesBoolExp>;
};


export type Subscription_RootPlaySessionStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlaySessionStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionStatusesStreamCursorInput>>;
  where?: InputMaybe<PlaySessionStatusesBoolExp>;
};


export type Subscription_RootPlaySessionsArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


export type Subscription_RootPlaySessionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlaySessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlaySessionsOrderBy>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


export type Subscription_RootPlaySessionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlaySessionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlaySessionsStreamCursorInput>>;
  where?: InputMaybe<PlaySessionsBoolExp>;
};


export type Subscription_RootPlayerAvailabilitiesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitiesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitiesBoolExp>;
};


export type Subscription_RootPlayerAvailabilitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitiesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitiesBoolExp>;
};


export type Subscription_RootPlayerAvailabilitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayerAvailabilitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayerAvailabilitiesStreamCursorInput>>;
  where?: InputMaybe<PlayerAvailabilitiesBoolExp>;
};


export type Subscription_RootPlayerAvailabilityNeighborhoodsArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityNeighborhoodsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
};


export type Subscription_RootPlayerAvailabilityNeighborhoodsByPkArgs = {
  availabilityId: Scalars['uuid'];
  neighborhoodId: Scalars['uuid'];
};


export type Subscription_RootPlayerAvailabilityNeighborhoodsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayerAvailabilityNeighborhoodsStreamCursorInput>>;
  where?: InputMaybe<PlayerAvailabilityNeighborhoodsBoolExp>;
};


export type Subscription_RootPlayerAvailabilityRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityRatingScalesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
};


export type Subscription_RootPlayerAvailabilityRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayerAvailabilityRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayerAvailabilityRatingScalesStreamCursorInput>>;
  where?: InputMaybe<PlayerAvailabilityRatingScalesBoolExp>;
};


export type Subscription_RootPlayerAvailabilitySlotsArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilitySlotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilitySlotsOrderBy>>;
  where?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
};


export type Subscription_RootPlayerAvailabilitySlotsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayerAvailabilitySlotsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayerAvailabilitySlotsStreamCursorInput>>;
  where?: InputMaybe<PlayerAvailabilitySlotsBoolExp>;
};


export type Subscription_RootPlayerAvailabilityVenuesArgs = {
  distinctOn?: InputMaybe<Array<PlayerAvailabilityVenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerAvailabilityVenuesOrderBy>>;
  where?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
};


export type Subscription_RootPlayerAvailabilityVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlayerAvailabilityVenuesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayerAvailabilityVenuesStreamCursorInput>>;
  where?: InputMaybe<PlayerAvailabilityVenuesBoolExp>;
};


export type Subscription_RootPlayerFinderGoalsArgs = {
  distinctOn?: InputMaybe<Array<PlayerFinderGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerFinderGoalsOrderBy>>;
  where?: InputMaybe<PlayerFinderGoalsBoolExp>;
};


export type Subscription_RootPlayerFinderGoalsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlayerFinderGoalsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayerFinderGoalsStreamCursorInput>>;
  where?: InputMaybe<PlayerFinderGoalsBoolExp>;
};


export type Subscription_RootPlayerFinderTimeOfDayArgs = {
  distinctOn?: InputMaybe<Array<PlayerFinderTimeOfDaySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PlayerFinderTimeOfDayOrderBy>>;
  where?: InputMaybe<PlayerFinderTimeOfDayBoolExp>;
};


export type Subscription_RootPlayerFinderTimeOfDayByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPlayerFinderTimeOfDayStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PlayerFinderTimeOfDayStreamCursorInput>>;
  where?: InputMaybe<PlayerFinderTimeOfDayBoolExp>;
};


export type Subscription_RootRecurrenceKindsArgs = {
  distinctOn?: InputMaybe<Array<RecurrenceKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurrenceKindsOrderBy>>;
  where?: InputMaybe<RecurrenceKindsBoolExp>;
};


export type Subscription_RootRecurrenceKindsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootRecurrenceKindsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RecurrenceKindsStreamCursorInput>>;
  where?: InputMaybe<RecurrenceKindsBoolExp>;
};


export type Subscription_RootReportReasonsArgs = {
  distinctOn?: InputMaybe<Array<ReportReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportReasonsOrderBy>>;
  where?: InputMaybe<ReportReasonsBoolExp>;
};


export type Subscription_RootReportReasonsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootReportReasonsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ReportReasonsStreamCursorInput>>;
  where?: InputMaybe<ReportReasonsBoolExp>;
};


export type Subscription_RootReportStatusesArgs = {
  distinctOn?: InputMaybe<Array<ReportStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportStatusesOrderBy>>;
  where?: InputMaybe<ReportStatusesBoolExp>;
};


export type Subscription_RootReportStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootReportStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ReportStatusesStreamCursorInput>>;
  where?: InputMaybe<ReportStatusesBoolExp>;
};


export type Subscription_RootReviewsArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


export type Subscription_RootReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReviewsOrderBy>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


export type Subscription_RootReviewsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootReviewsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ReviewsStreamCursorInput>>;
  where?: InputMaybe<ReviewsBoolExp>;
};


export type Subscription_RootSalesArgs = {
  distinctOn?: InputMaybe<Array<SalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SalesOrderBy>>;
  where?: InputMaybe<SalesBoolExp>;
};


export type Subscription_RootSalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SalesStreamCursorInput>>;
  where?: InputMaybe<SalesBoolExp>;
};


export type Subscription_RootScoringFormatArgs = {
  distinctOn?: InputMaybe<Array<ScoringFormatSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScoringFormatOrderBy>>;
  where?: InputMaybe<ScoringFormatBoolExp>;
};


export type Subscription_RootScoringFormatByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootScoringFormatStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ScoringFormatStreamCursorInput>>;
  where?: InputMaybe<ScoringFormatBoolExp>;
};


export type Subscription_RootSignupRequestsArgs = {
  distinctOn?: InputMaybe<Array<SignupRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SignupRequestsOrderBy>>;
  where?: InputMaybe<SignupRequestsBoolExp>;
};


export type Subscription_RootSignupRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSignupRequestsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SignupRequestsStreamCursorInput>>;
  where?: InputMaybe<SignupRequestsBoolExp>;
};


export type Subscription_RootSkillLevelValuesArgs = {
  distinctOn?: InputMaybe<Array<SkillLevelValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SkillLevelValuesOrderBy>>;
  where?: InputMaybe<SkillLevelValuesBoolExp>;
};


export type Subscription_RootSkillLevelValuesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootSkillLevelValuesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SkillLevelValuesStreamCursorInput>>;
  where?: InputMaybe<SkillLevelValuesBoolExp>;
};


export type Subscription_RootSkillLevelsArgs = {
  distinctOn?: InputMaybe<Array<SkillLevelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SkillLevelsOrderBy>>;
  where?: InputMaybe<SkillLevelsBoolExp>;
};


export type Subscription_RootSkillLevelsByPkArgs = {
  id: SkillLevelValuesEnum;
};


export type Subscription_RootSkillLevelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SkillLevelsStreamCursorInput>>;
  where?: InputMaybe<SkillLevelsBoolExp>;
};


export type Subscription_RootSportsArgs = {
  distinctOn?: InputMaybe<Array<SportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SportsOrderBy>>;
  where?: InputMaybe<SportsBoolExp>;
};


export type Subscription_RootSportsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootSportsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SportsStreamCursorInput>>;
  where?: InputMaybe<SportsBoolExp>;
};


export type Subscription_RootSubscriptionStatusesArgs = {
  distinctOn?: InputMaybe<Array<SubscriptionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SubscriptionStatusesOrderBy>>;
  where?: InputMaybe<SubscriptionStatusesBoolExp>;
};


export type Subscription_RootSubscriptionStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootSubscriptionStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SubscriptionStatusesStreamCursorInput>>;
  where?: InputMaybe<SubscriptionStatusesBoolExp>;
};


export type Subscription_RootTeamTypesArgs = {
  distinctOn?: InputMaybe<Array<TeamTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TeamTypesOrderBy>>;
  where?: InputMaybe<TeamTypesBoolExp>;
};


export type Subscription_RootTeamTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootTeamTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TeamTypesStreamCursorInput>>;
  where?: InputMaybe<TeamTypesBoolExp>;
};


export type Subscription_RootTennisRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<TennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TennisRatingScalesOrderBy>>;
  where?: InputMaybe<TennisRatingScalesBoolExp>;
};


export type Subscription_RootTennisRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTennisRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TennisRatingScalesStreamCursorInput>>;
  where?: InputMaybe<TennisRatingScalesBoolExp>;
};


export type Subscription_RootTwilioGroupTextsArgs = {
  distinctOn?: InputMaybe<Array<TwilioGroupTextsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TwilioGroupTextsOrderBy>>;
  where?: InputMaybe<TwilioGroupTextsBoolExp>;
};


export type Subscription_RootTwilioGroupTextsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTwilioGroupTextsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TwilioGroupTextsStreamCursorInput>>;
  where?: InputMaybe<TwilioGroupTextsBoolExp>;
};


export type Subscription_RootUploadReviewRequestsArgs = {
  distinctOn?: InputMaybe<Array<UploadReviewRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UploadReviewRequestsOrderBy>>;
  where?: InputMaybe<UploadReviewRequestsBoolExp>;
};


export type Subscription_RootUploadReviewRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUploadReviewRequestsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UploadReviewRequestsStreamCursorInput>>;
  where?: InputMaybe<UploadReviewRequestsBoolExp>;
};


export type Subscription_RootUserBlocksArgs = {
  distinctOn?: InputMaybe<Array<UserBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBlocksOrderBy>>;
  where?: InputMaybe<UserBlocksBoolExp>;
};


export type Subscription_RootUserBlocksByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserBlocksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserBlocksStreamCursorInput>>;
  where?: InputMaybe<UserBlocksBoolExp>;
};


export type Subscription_RootUserCoachServicesArgs = {
  distinctOn?: InputMaybe<Array<UserCoachServicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCoachServicesOrderBy>>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};


export type Subscription_RootUserCoachServicesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserCoachServicesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserCoachServicesStreamCursorInput>>;
  where?: InputMaybe<UserCoachServicesBoolExp>;
};


export type Subscription_RootUserCommunicationPreferencesArgs = {
  distinctOn?: InputMaybe<Array<UserCommunicationPreferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCommunicationPreferencesOrderBy>>;
  where?: InputMaybe<UserCommunicationPreferencesBoolExp>;
};


export type Subscription_RootUserCommunicationPreferencesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserCommunicationPreferencesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserCommunicationPreferencesStreamCursorInput>>;
  where?: InputMaybe<UserCommunicationPreferencesBoolExp>;
};


export type Subscription_RootUserConnectionRequestStatusesArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionRequestStatusesOrderBy>>;
  where?: InputMaybe<UserConnectionRequestStatusesBoolExp>;
};


export type Subscription_RootUserConnectionRequestStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUserConnectionRequestStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserConnectionRequestStatusesStreamCursorInput>>;
  where?: InputMaybe<UserConnectionRequestStatusesBoolExp>;
};


export type Subscription_RootUserConnectionRequestsArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionRequestsOrderBy>>;
  where?: InputMaybe<UserConnectionRequestsBoolExp>;
};


export type Subscription_RootUserConnectionRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionRequestsOrderBy>>;
  where?: InputMaybe<UserConnectionRequestsBoolExp>;
};


export type Subscription_RootUserConnectionRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserConnectionRequestsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserConnectionRequestsStreamCursorInput>>;
  where?: InputMaybe<UserConnectionRequestsBoolExp>;
};


export type Subscription_RootUserConnectionsArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionsOrderBy>>;
  where?: InputMaybe<UserConnectionsBoolExp>;
};


export type Subscription_RootUserConnectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserConnectionsOrderBy>>;
  where?: InputMaybe<UserConnectionsBoolExp>;
};


export type Subscription_RootUserConnectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserConnectionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserConnectionsStreamCursorInput>>;
  where?: InputMaybe<UserConnectionsBoolExp>;
};


export type Subscription_RootUserContentBetaSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<UserContentBetaSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentBetaSubscriptionsOrderBy>>;
  where?: InputMaybe<UserContentBetaSubscriptionsBoolExp>;
};


export type Subscription_RootUserContentBetaSubscriptionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserContentBetaSubscriptionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserContentBetaSubscriptionsStreamCursorInput>>;
  where?: InputMaybe<UserContentBetaSubscriptionsBoolExp>;
};


export type Subscription_RootUserContentFilesArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesOrderBy>>;
  where?: InputMaybe<UserContentFilesBoolExp>;
};


export type Subscription_RootUserContentFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserContentFilesSkillsArgs = {
  distinctOn?: InputMaybe<Array<UserContentFilesSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentFilesSkillsOrderBy>>;
  where?: InputMaybe<UserContentFilesSkillsBoolExp>;
};


export type Subscription_RootUserContentFilesSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserContentFilesSkillsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserContentFilesSkillsStreamCursorInput>>;
  where?: InputMaybe<UserContentFilesSkillsBoolExp>;
};


export type Subscription_RootUserContentFilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserContentFilesStreamCursorInput>>;
  where?: InputMaybe<UserContentFilesBoolExp>;
};


export type Subscription_RootUserContentSkillsArgs = {
  distinctOn?: InputMaybe<Array<UserContentSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserContentSkillsOrderBy>>;
  where?: InputMaybe<UserContentSkillsBoolExp>;
};


export type Subscription_RootUserContentSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserContentSkillsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserContentSkillsStreamCursorInput>>;
  where?: InputMaybe<UserContentSkillsBoolExp>;
};


export type Subscription_RootUserCreditCardsArgs = {
  distinctOn?: InputMaybe<Array<UserCreditCardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCreditCardsOrderBy>>;
  where?: InputMaybe<UserCreditCardsBoolExp>;
};


export type Subscription_RootUserCreditCardsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserCreditCardsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserCreditCardsStreamCursorInput>>;
  where?: InputMaybe<UserCreditCardsBoolExp>;
};


export type Subscription_RootUserCustomCourtsArgs = {
  distinctOn?: InputMaybe<Array<UserCustomCourtsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCustomCourtsOrderBy>>;
  where?: InputMaybe<UserCustomCourtsBoolExp>;
};


export type Subscription_RootUserCustomCourtsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserCustomCourtsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserCustomCourtsStreamCursorInput>>;
  where?: InputMaybe<UserCustomCourtsBoolExp>;
};


export type Subscription_RootUserFilesArgs = {
  distinctOn?: InputMaybe<Array<UserFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFilesOrderBy>>;
  where?: InputMaybe<UserFilesBoolExp>;
};


export type Subscription_RootUserFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserFilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserFilesStreamCursorInput>>;
  where?: InputMaybe<UserFilesBoolExp>;
};


export type Subscription_RootUserFollowsArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


export type Subscription_RootUserFollowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserFollowsOrderBy>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


export type Subscription_RootUserFollowsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserFollowsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserFollowsStreamCursorInput>>;
  where?: InputMaybe<UserFollowsBoolExp>;
};


export type Subscription_RootUserIdentityVerificationsArgs = {
  distinctOn?: InputMaybe<Array<UserIdentityVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserIdentityVerificationsOrderBy>>;
  where?: InputMaybe<UserIdentityVerificationsBoolExp>;
};


export type Subscription_RootUserIdentityVerificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserIdentityVerificationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserIdentityVerificationsStreamCursorInput>>;
  where?: InputMaybe<UserIdentityVerificationsBoolExp>;
};


export type Subscription_RootUserImageLogArgs = {
  distinctOn?: InputMaybe<Array<UserImageLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserImageLogOrderBy>>;
  where?: InputMaybe<UserImageLogBoolExp>;
};


export type Subscription_RootUserImageLogByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserImageLogStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserImageLogStreamCursorInput>>;
  where?: InputMaybe<UserImageLogBoolExp>;
};


export type Subscription_RootUserNotificationDetailsArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationDetailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationDetailsOrderBy>>;
  where?: InputMaybe<UserNotificationDetailsBoolExp>;
};


export type Subscription_RootUserNotificationDetailsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserNotificationDetailsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserNotificationDetailsStreamCursorInput>>;
  where?: InputMaybe<UserNotificationDetailsBoolExp>;
};


export type Subscription_RootUserNotificationEntitiesArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationEntitiesOrderBy>>;
  where?: InputMaybe<UserNotificationEntitiesBoolExp>;
};


export type Subscription_RootUserNotificationEntitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserNotificationEntitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserNotificationEntitiesStreamCursorInput>>;
  where?: InputMaybe<UserNotificationEntitiesBoolExp>;
};


export type Subscription_RootUserNotificationsArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


export type Subscription_RootUserNotificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


export type Subscription_RootUserNotificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserNotificationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserNotificationsStreamCursorInput>>;
  where?: InputMaybe<UserNotificationsBoolExp>;
};


export type Subscription_RootUserPadelRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserPadelRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPadelRatingScalesOrderBy>>;
  where?: InputMaybe<UserPadelRatingScalesBoolExp>;
};


export type Subscription_RootUserPadelRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserPadelRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPadelRatingScalesStreamCursorInput>>;
  where?: InputMaybe<UserPadelRatingScalesBoolExp>;
};


export type Subscription_RootUserPickleballRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserPickleballRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPickleballRatingScalesOrderBy>>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};


export type Subscription_RootUserPickleballRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserPickleballRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPickleballRatingScalesStreamCursorInput>>;
  where?: InputMaybe<UserPickleballRatingScalesBoolExp>;
};


export type Subscription_RootUserPlayedWithArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithOrderBy>>;
  where?: InputMaybe<UserPlayedWithBoolExp>;
};


export type Subscription_RootUserPlayedWithAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithOrderBy>>;
  where?: InputMaybe<UserPlayedWithBoolExp>;
};


export type Subscription_RootUserPlayedWithDismissalsArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithDismissalsOrderBy>>;
  where?: InputMaybe<UserPlayedWithDismissalsBoolExp>;
};


export type Subscription_RootUserPlayedWithDismissalsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserPlayedWithDismissalsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPlayedWithDismissalsStreamCursorInput>>;
  where?: InputMaybe<UserPlayedWithDismissalsBoolExp>;
};


export type Subscription_RootUserPlayedWithGamesArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithGamesOrderBy>>;
  where?: InputMaybe<UserPlayedWithGamesBoolExp>;
};


export type Subscription_RootUserPlayedWithGamesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayedWithGamesOrderBy>>;
  where?: InputMaybe<UserPlayedWithGamesBoolExp>;
};


export type Subscription_RootUserPlayedWithGamesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPlayedWithGamesStreamCursorInput>>;
  where?: InputMaybe<UserPlayedWithGamesBoolExp>;
};


export type Subscription_RootUserPlayedWithStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPlayedWithStreamCursorInput>>;
  where?: InputMaybe<UserPlayedWithBoolExp>;
};


export type Subscription_RootUserPlayerFinderAvailabilityArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderAvailabilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderAvailabilityOrderBy>>;
  where?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
};


export type Subscription_RootUserPlayerFinderAvailabilityByPkArgs = {
  dayOfWeek: DayOfWeekEnum;
  timeOfDay: PlayerFinderTimeOfDayEnum;
  userId: Scalars['uuid'];
};


export type Subscription_RootUserPlayerFinderAvailabilityStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPlayerFinderAvailabilityStreamCursorInput>>;
  where?: InputMaybe<UserPlayerFinderAvailabilityBoolExp>;
};


export type Subscription_RootUserPlayerFinderGoalsArgs = {
  distinctOn?: InputMaybe<Array<UserPlayerFinderGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPlayerFinderGoalsOrderBy>>;
  where?: InputMaybe<UserPlayerFinderGoalsBoolExp>;
};


export type Subscription_RootUserPlayerFinderGoalsByPkArgs = {
  goal: PlayerFinderGoalsEnum;
  userId: Scalars['uuid'];
};


export type Subscription_RootUserPlayerFinderGoalsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPlayerFinderGoalsStreamCursorInput>>;
  where?: InputMaybe<UserPlayerFinderGoalsBoolExp>;
};


export type Subscription_RootUserProfilesArgs = {
  distinctOn?: InputMaybe<Array<UserProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
  where?: InputMaybe<UserProfilesBoolExp>;
};


export type Subscription_RootUserProfilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
  where?: InputMaybe<UserProfilesBoolExp>;
};


export type Subscription_RootUserProfilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserProfilesStreamCursorInput>>;
  where?: InputMaybe<UserProfilesBoolExp>;
};


export type Subscription_RootUserSportsArgs = {
  distinctOn?: InputMaybe<Array<UserSportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSportsOrderBy>>;
  where?: InputMaybe<UserSportsBoolExp>;
};


export type Subscription_RootUserSportsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserSportsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserSportsStreamCursorInput>>;
  where?: InputMaybe<UserSportsBoolExp>;
};


export type Subscription_RootUserTennisRatingScalesArgs = {
  distinctOn?: InputMaybe<Array<UserTennisRatingScalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTennisRatingScalesOrderBy>>;
  where?: InputMaybe<UserTennisRatingScalesBoolExp>;
};


export type Subscription_RootUserTennisRatingScalesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserTennisRatingScalesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserTennisRatingScalesStreamCursorInput>>;
  where?: InputMaybe<UserTennisRatingScalesBoolExp>;
};


export type Subscription_RootUserTermsOfServiceArgs = {
  distinctOn?: InputMaybe<Array<UserTermsOfServiceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserTermsOfServiceOrderBy>>;
  where?: InputMaybe<UserTermsOfServiceBoolExp>;
};


export type Subscription_RootUserTermsOfServiceByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserTermsOfServiceStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserTermsOfServiceStreamCursorInput>>;
  where?: InputMaybe<UserTermsOfServiceBoolExp>;
};


export type Subscription_RootUserVairConnectionsArgs = {
  distinctOn?: InputMaybe<Array<UserVairConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserVairConnectionsOrderBy>>;
  where?: InputMaybe<UserVairConnectionsBoolExp>;
};


export type Subscription_RootUserVairConnectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserVairConnectionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserVairConnectionsStreamCursorInput>>;
  where?: InputMaybe<UserVairConnectionsBoolExp>;
};


export type Subscription_RootUsernamesActiveArgs = {
  distinctOn?: InputMaybe<Array<UsernamesActiveSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesActiveOrderBy>>;
  where?: InputMaybe<UsernamesActiveBoolExp>;
};


export type Subscription_RootUsernamesActiveStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UsernamesActiveStreamCursorInput>>;
  where?: InputMaybe<UsernamesActiveBoolExp>;
};


export type Subscription_RootUsernamesClaimedArgs = {
  distinctOn?: InputMaybe<Array<UsernamesClaimedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsernamesClaimedOrderBy>>;
  where?: InputMaybe<UsernamesClaimedBoolExp>;
};


export type Subscription_RootUsernamesClaimedByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsernamesClaimedStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UsernamesClaimedStreamCursorInput>>;
  where?: InputMaybe<UsernamesClaimedBoolExp>;
};


export type Subscription_RootUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootUsersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsersCoachQualificationsArgs = {
  distinctOn?: InputMaybe<Array<UsersCoachQualificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersCoachQualificationsOrderBy>>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};


export type Subscription_RootUsersCoachQualificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsersCoachQualificationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UsersCoachQualificationsStreamCursorInput>>;
  where?: InputMaybe<UsersCoachQualificationsBoolExp>;
};


export type Subscription_RootUsersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UsersStreamCursorInput>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootVenueAccessTypesArgs = {
  distinctOn?: InputMaybe<Array<VenueAccessTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAccessTypesOrderBy>>;
  where?: InputMaybe<VenueAccessTypesBoolExp>;
};


export type Subscription_RootVenueAccessTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootVenueAccessTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueAccessTypesStreamCursorInput>>;
  where?: InputMaybe<VenueAccessTypesBoolExp>;
};


export type Subscription_RootVenueAdminClaimStatusesArgs = {
  distinctOn?: InputMaybe<Array<VenueAdminClaimStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAdminClaimStatusesOrderBy>>;
  where?: InputMaybe<VenueAdminClaimStatusesBoolExp>;
};


export type Subscription_RootVenueAdminClaimStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootVenueAdminClaimStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueAdminClaimStatusesStreamCursorInput>>;
  where?: InputMaybe<VenueAdminClaimStatusesBoolExp>;
};


export type Subscription_RootVenueAdminClaimsArgs = {
  distinctOn?: InputMaybe<Array<VenueAdminClaimsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAdminClaimsOrderBy>>;
  where?: InputMaybe<VenueAdminClaimsBoolExp>;
};


export type Subscription_RootVenueAdminClaimsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueAdminClaimsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueAdminClaimsStreamCursorInput>>;
  where?: InputMaybe<VenueAdminClaimsBoolExp>;
};


export type Subscription_RootVenueAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<VenueAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueAmenitiesOrderBy>>;
  where?: InputMaybe<VenueAmenitiesBoolExp>;
};


export type Subscription_RootVenueAmenitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueAmenitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueAmenitiesStreamCursorInput>>;
  where?: InputMaybe<VenueAmenitiesBoolExp>;
};


export type Subscription_RootVenueBookingConfigVersionsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConfigVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConfigVersionsOrderBy>>;
  where?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
};


export type Subscription_RootVenueBookingConfigVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueBookingConfigVersionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingConfigVersionsStreamCursorInput>>;
  where?: InputMaybe<VenueBookingConfigVersionsBoolExp>;
};


export type Subscription_RootVenueBookingConnectionCheckStatusesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionCheckStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionCheckStatusesOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionCheckStatusesBoolExp>;
};


export type Subscription_RootVenueBookingConnectionCheckStatusesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootVenueBookingConnectionCheckStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingConnectionCheckStatusesStreamCursorInput>>;
  where?: InputMaybe<VenueBookingConnectionCheckStatusesBoolExp>;
};


export type Subscription_RootVenueBookingConnectionChecksArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingConnectionChecksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingConnectionChecksOrderBy>>;
  where?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
};


export type Subscription_RootVenueBookingConnectionChecksByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueBookingConnectionChecksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingConnectionChecksStreamCursorInput>>;
  where?: InputMaybe<VenueBookingConnectionChecksBoolExp>;
};


export type Subscription_RootVenueBookingCourtRatesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingCourtRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingCourtRatesOrderBy>>;
  where?: InputMaybe<VenueBookingCourtRatesBoolExp>;
};


export type Subscription_RootVenueBookingCourtRatesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueBookingCourtRatesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingCourtRatesStreamCursorInput>>;
  where?: InputMaybe<VenueBookingCourtRatesBoolExp>;
};


export type Subscription_RootVenueBookingIntegrationsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingIntegrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingIntegrationsOrderBy>>;
  where?: InputMaybe<VenueBookingIntegrationsBoolExp>;
};


export type Subscription_RootVenueBookingIntegrationsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueBookingIntegrationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingIntegrationsStreamCursorInput>>;
  where?: InputMaybe<VenueBookingIntegrationsBoolExp>;
};


export type Subscription_RootVenueBookingRuleTiersArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRuleTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRuleTiersOrderBy>>;
  where?: InputMaybe<VenueBookingRuleTiersBoolExp>;
};


export type Subscription_RootVenueBookingRuleTiersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueBookingRuleTiersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingRuleTiersStreamCursorInput>>;
  where?: InputMaybe<VenueBookingRuleTiersBoolExp>;
};


export type Subscription_RootVenueBookingRulesArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingRulesOrderBy>>;
  where?: InputMaybe<VenueBookingRulesBoolExp>;
};


export type Subscription_RootVenueBookingRulesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueBookingRulesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingRulesStreamCursorInput>>;
  where?: InputMaybe<VenueBookingRulesBoolExp>;
};


export type Subscription_RootVenueBookingWindowsArgs = {
  distinctOn?: InputMaybe<Array<VenueBookingWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueBookingWindowsOrderBy>>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};


export type Subscription_RootVenueBookingWindowsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueBookingWindowsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueBookingWindowsStreamCursorInput>>;
  where?: InputMaybe<VenueBookingWindowsBoolExp>;
};


export type Subscription_RootVenueCourtSurfacesArgs = {
  distinctOn?: InputMaybe<Array<VenueCourtSurfacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCourtSurfacesOrderBy>>;
  where?: InputMaybe<VenueCourtSurfacesBoolExp>;
};


export type Subscription_RootVenueCourtSurfacesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueCourtSurfacesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueCourtSurfacesStreamCursorInput>>;
  where?: InputMaybe<VenueCourtSurfacesBoolExp>;
};


export type Subscription_RootVenueCustomAmenitiesArgs = {
  distinctOn?: InputMaybe<Array<VenueCustomAmenitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueCustomAmenitiesOrderBy>>;
  where?: InputMaybe<VenueCustomAmenitiesBoolExp>;
};


export type Subscription_RootVenueCustomAmenitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueCustomAmenitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueCustomAmenitiesStreamCursorInput>>;
  where?: InputMaybe<VenueCustomAmenitiesBoolExp>;
};


export type Subscription_RootVenueEquipmentArgs = {
  distinctOn?: InputMaybe<Array<VenueEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueEquipmentOrderBy>>;
  where?: InputMaybe<VenueEquipmentBoolExp>;
};


export type Subscription_RootVenueEquipmentByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueEquipmentStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueEquipmentStreamCursorInput>>;
  where?: InputMaybe<VenueEquipmentBoolExp>;
};


export type Subscription_RootVenueFacilityTypesArgs = {
  distinctOn?: InputMaybe<Array<VenueFacilityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFacilityTypesOrderBy>>;
  where?: InputMaybe<VenueFacilityTypesBoolExp>;
};


export type Subscription_RootVenueFacilityTypesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootVenueFacilityTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueFacilityTypesStreamCursorInput>>;
  where?: InputMaybe<VenueFacilityTypesBoolExp>;
};


export type Subscription_RootVenueFaqsArgs = {
  distinctOn?: InputMaybe<Array<VenueFaqsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFaqsOrderBy>>;
  where?: InputMaybe<VenueFaqsBoolExp>;
};


export type Subscription_RootVenueFaqsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueFaqsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueFaqsStreamCursorInput>>;
  where?: InputMaybe<VenueFaqsBoolExp>;
};


export type Subscription_RootVenueFollowsArgs = {
  distinctOn?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFollowsOrderBy>>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};


export type Subscription_RootVenueFollowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueFollowsOrderBy>>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};


export type Subscription_RootVenueFollowsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueFollowsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueFollowsStreamCursorInput>>;
  where?: InputMaybe<VenueFollowsBoolExp>;
};


export type Subscription_RootVenueImagesArgs = {
  distinctOn?: InputMaybe<Array<VenueImagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueImagesOrderBy>>;
  where?: InputMaybe<VenueImagesBoolExp>;
};


export type Subscription_RootVenueImagesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueImagesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueImagesStreamCursorInput>>;
  where?: InputMaybe<VenueImagesBoolExp>;
};


export type Subscription_RootVenueLinesArgs = {
  distinctOn?: InputMaybe<Array<VenueLinesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueLinesOrderBy>>;
  where?: InputMaybe<VenueLinesBoolExp>;
};


export type Subscription_RootVenueLinesByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootVenueLinesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueLinesStreamCursorInput>>;
  where?: InputMaybe<VenueLinesBoolExp>;
};


export type Subscription_RootVenueNetsArgs = {
  distinctOn?: InputMaybe<Array<VenueNetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueNetsOrderBy>>;
  where?: InputMaybe<VenueNetsBoolExp>;
};


export type Subscription_RootVenueNetsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootVenueNetsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueNetsStreamCursorInput>>;
  where?: InputMaybe<VenueNetsBoolExp>;
};


export type Subscription_RootVenuePartnerBookingStatusesArgs = {
  distinctOn?: InputMaybe<Array<VenuePartnerBookingStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuePartnerBookingStatusesOrderBy>>;
  where?: InputMaybe<VenuePartnerBookingStatusesBoolExp>;
};


export type Subscription_RootVenuePartnerBookingStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenuePartnerBookingStatusesStreamCursorInput>>;
  where?: InputMaybe<VenuePartnerBookingStatusesBoolExp>;
};


export type Subscription_RootVenueStaffCoachesArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


export type Subscription_RootVenueStaffCoachesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenueStaffCoachesOrderBy>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


export type Subscription_RootVenueStaffCoachesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenueStaffCoachesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenueStaffCoachesStreamCursorInput>>;
  where?: InputMaybe<VenueStaffCoachesBoolExp>;
};


export type Subscription_RootVenuesArgs = {
  distinctOn?: InputMaybe<Array<VenuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VenuesOrderBy>>;
  where?: InputMaybe<VenuesBoolExp>;
};


export type Subscription_RootVenuesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenuesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VenuesStreamCursorInput>>;
  where?: InputMaybe<VenuesBoolExp>;
};


export type Subscription_RootVideoAnalysisArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


export type Subscription_RootVideoAnalysisAggregateArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderBy>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


export type Subscription_RootVideoAnalysisByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisCommentsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisCommentsBoolExp>;
};


export type Subscription_RootVideoAnalysisCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisCommentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisCommentsStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisCommentsBoolExp>;
};


export type Subscription_RootVideoAnalysisFilesArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisFilesOrderBy>>;
  where?: InputMaybe<VideoAnalysisFilesBoolExp>;
};


export type Subscription_RootVideoAnalysisFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisFilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisFilesStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisFilesBoolExp>;
};


export type Subscription_RootVideoAnalysisOrderItemsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrderItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrderItemsOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
};


export type Subscription_RootVideoAnalysisOrderItemsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisOrderItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisOrderItemsStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisOrderItemsBoolExp>;
};


export type Subscription_RootVideoAnalysisOrdersArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisOrdersOrderBy>>;
  where?: InputMaybe<VideoAnalysisOrdersBoolExp>;
};


export type Subscription_RootVideoAnalysisOrdersByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisOrdersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisOrdersStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisOrdersBoolExp>;
};


export type Subscription_RootVideoAnalysisRequestedSkillsReviewArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisRequestedSkillsReviewOrderBy>>;
  where?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
};


export type Subscription_RootVideoAnalysisRequestedSkillsReviewByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisRequestedSkillsReviewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisRequestedSkillsReviewStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisRequestedSkillsReviewBoolExp>;
};


export type Subscription_RootVideoAnalysisSkillsCommentsArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSkillsCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSkillsCommentsOrderBy>>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};


export type Subscription_RootVideoAnalysisSkillsCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisSkillsCommentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisSkillsCommentsStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisSkillsCommentsBoolExp>;
};


export type Subscription_RootVideoAnalysisStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisBoolExp>;
};


export type Subscription_RootVideoAnalysisSubmissionLogArgs = {
  distinctOn?: InputMaybe<Array<VideoAnalysisSubmissionLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoAnalysisSubmissionLogOrderBy>>;
  where?: InputMaybe<VideoAnalysisSubmissionLogBoolExp>;
};


export type Subscription_RootVideoAnalysisSubmissionLogByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoAnalysisSubmissionLogStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoAnalysisSubmissionLogStreamCursorInput>>;
  where?: InputMaybe<VideoAnalysisSubmissionLogBoolExp>;
};


export type Subscription_RootVideoLessonSkillsArgs = {
  distinctOn?: InputMaybe<Array<VideoLessonSkillsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VideoLessonSkillsOrderBy>>;
  where?: InputMaybe<VideoLessonSkillsBoolExp>;
};


export type Subscription_RootVideoLessonSkillsByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideoLessonSkillsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<VideoLessonSkillsStreamCursorInput>>;
  where?: InputMaybe<VideoLessonSkillsBoolExp>;
};


export type Subscription_RootWinReasonsArgs = {
  distinctOn?: InputMaybe<Array<WinReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WinReasonsOrderBy>>;
  where?: InputMaybe<WinReasonsBoolExp>;
};


export type Subscription_RootWinReasonsByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootWinReasonsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<WinReasonsStreamCursorInput>>;
  where?: InputMaybe<WinReasonsBoolExp>;
};

export type UserFollowsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserFollowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserFollowsBoolExp>;
  predicate: IntComparisonExp;
};

export type UserNotificationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserNotificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserNotificationsBoolExp>;
  predicate: IntComparisonExp;
};

export type UserPlayedWithGamesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserPlayedWithGamesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserPlayedWithGamesBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueFollowsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueFollowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueFollowsBoolExp>;
  predicate: IntComparisonExp;
};

export type VenueStaffCoachesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VenueStaffCoachesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VenueStaffCoachesBoolExp>;
  predicate: IntComparisonExp;
};

export type VideoAnalysisAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VideoAnalysisSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VideoAnalysisBoolExp>;
  predicate: IntComparisonExp;
};

export type CheckUserFollowsCoachQueryVariables = Exact<{
  coachId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type CheckUserFollowsCoachQuery = { __typename?: 'query_root', userFollows: Array<{ __typename?: 'UserFollows', id: any, followerUserId: any, followedUserId: any, status: FollowStatusesEnum, followerProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageUrl?: string | null, fullName?: string | null } | null }> };

export type TournamentCardFieldsFragment = { __typename?: 'Events', id: any, slug: string, title: string, sport: SportsEnum, coverImagePath?: string | null, organizerImagePath?: string | null, displayLocation: string, startDateTime: any, endDateTime: any, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, groupFormat?: EventGroupFormatsEnum | null, scoringFormat?: ScoringFormatEnum | null, hasPrizes: boolean, isExternal: boolean, isVairRequired?: boolean | null, currency: string, latitude?: any | null, longitude?: any | null, locale: string, status: EventStatusesEnum, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, venue?: { __typename?: 'Venues', id: any, timezone: string, addressString: string } | null, city?: { __typename?: 'Cities', id: any, name: string, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, code: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null } };

export type GetFeaturedTournamentBoostsQueryVariables = Exact<{
  now: Scalars['timestamptz'];
}>;


export type GetFeaturedTournamentBoostsQuery = { __typename?: 'query_root', boosts: Array<{ __typename?: 'Boosts', id: any, event?: { __typename?: 'Events', id: any, slug: string, title: string, sport: SportsEnum, coverImagePath?: string | null, organizerImagePath?: string | null, displayLocation: string, startDateTime: any, endDateTime: any, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, groupFormat?: EventGroupFormatsEnum | null, scoringFormat?: ScoringFormatEnum | null, hasPrizes: boolean, isExternal: boolean, isVairRequired?: boolean | null, currency: string, latitude?: any | null, longitude?: any | null, locale: string, status: EventStatusesEnum, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, venue?: { __typename?: 'Venues', id: any, timezone: string, addressString: string } | null, city?: { __typename?: 'Cities', id: any, name: string, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, code: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null } } | null }> };

export type UpsertUserFollowsBatchMutationVariables = Exact<{
  objects: Array<UserFollowsInsertInput> | UserFollowsInsertInput;
}>;


export type UpsertUserFollowsBatchMutation = { __typename?: 'mutation_root', insertUserFollows?: { __typename?: 'UserFollowsMutationResponse', affectedRows: number } | null };

export type UpsertVenueFollowsBatchMutationVariables = Exact<{
  objects: Array<VenueFollowsInsertInput> | VenueFollowsInsertInput;
}>;


export type UpsertVenueFollowsBatchMutation = { __typename?: 'mutation_root', insertVenueFollows?: { __typename?: 'VenueFollowsMutationResponse', affectedRows: number } | null };

export type GetVenuesByNameSearchQueryVariables = Exact<{
  search: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetVenuesByNameSearchQuery = { __typename?: 'query_root', venues: Array<{ __typename?: 'Venues', id: any, slug: string, title: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, images: Array<{ __typename?: 'VenueImages', id: any, url: string, isVisible: boolean }> }> };

export type GetMyFavoritesQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetMyFavoritesQuery = { __typename?: 'query_root', userFollows: Array<{ __typename?: 'UserFollows', id: any, followerUserId: any, followedUserId: any, followedProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, username?: string | null, profileImageProviderUrl?: string | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, priceUnitAmountCoachDefault?: number | null, isProfessionalRacquetRegistryActive?: boolean | null, coachSports: Array<{ __typename?: 'CoachSports', id: any, sport: SportsEnum }> } | null }>, venueFollows: Array<{ __typename?: 'VenueFollows', id: any, venue: { __typename?: 'Venues', id: any, title: string, slug: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string }> } }> };

export type GetHomeForYouPreferencesQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetHomeForYouPreferencesQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: any, pickleballSkillLevelId?: string | null, tennisSkillLevelId?: string | null, padelSkillLevelId?: string | null } | null, userPlayerFinderAvailability: Array<{ __typename?: 'UserPlayerFinderAvailability', dayOfWeek: DayOfWeekEnum, timeOfDay: PlayerFinderTimeOfDayEnum }>, venueFollows: Array<{ __typename?: 'VenueFollows', id: any, venue: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, accessType?: VenueAccessTypesEnum | null, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string }> } }> };

export type GetNeighborhoodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNeighborhoodsQuery = { __typename?: 'query_root', neighborhoods: Array<{ __typename?: 'Neighborhoods', id: any, slug: string, name: string, latitude: any, longitude: any, radiusMiles: any, city: { __typename?: 'Cities', id: any, slug: string, name: string } }> };

export type GetNearbyPlayersCountQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  viewerId: Scalars['uuid'];
}>;


export type GetNearbyPlayersCountQuery = { __typename?: 'query_root', playerAvailabilitiesAggregate: { __typename?: 'PlayerAvailabilitiesAggregate', aggregate?: { __typename?: 'PlayerAvailabilitiesAggregateFields', count: number } | null }, userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, cityName?: string | null }> };

export type GetReceivedPlayRequestsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetReceivedPlayRequestsQuery = { __typename?: 'query_root', playRequests: Array<{ __typename?: 'PlayRequests', id: any, eventId?: any | null, availabilityId?: any | null, createdAt: any, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null } | null, event?: { __typename?: 'Events', id: any, sport: SportsEnum, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }> } | null, availability?: { __typename?: 'PlayerAvailabilities', id: any, sport: SportsEnum, teamType: TeamTypesEnum, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'PlayerAvailabilityRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> } | null }> };

export type GetUpcomingHostedEventsQueryVariables = Exact<{
  userId: Scalars['uuid'];
  startDate: Scalars['timestamptz'];
  types?: InputMaybe<Array<EventTypesEnum> | EventTypesEnum>;
}>;


export type GetUpcomingHostedEventsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, type: EventTypesEnum, title: string, slug: string, coverImagePath?: string | null, startDateTime: any, endDateTime: any, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationDeadlineDateTime?: any | null, status: EventStatusesEnum, currency: string, isExternal: boolean, isVairRequired?: boolean | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, groups: Array<{ __typename?: 'EventGroups', id: any, teamLimit?: number | null, teamType?: TeamTypesEnum | null, registrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, userId: any }>, teams: Array<{ __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', id: any, userId: any }> }> }> }> };

export type UserNotificationFieldsFragment = { __typename?: 'UserNotifications', id: any, status: NotificationStatusesEnum, videoAnalysisId?: any | null, notificationDetails: { __typename?: 'UserNotificationDetails', actionType: NotificationActionTypesEnum, id: any, primaryEntity: { __typename?: 'UserNotificationEntities', actingUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, coachStatus?: string | null } | null, videoAnalysis?: { __typename?: 'VideoAnalysis', id: any, currency: string, createdAt: any, reviewStatus?: VideoAnalysisReviewStatusesEnum | null, submissionUserId: any, reviewerUserId: any, orders: Array<{ __typename?: 'VideoAnalysisOrders', paidUnitAmount: number, orderTotalUnitAmount: number, orderSubtotalUnitAmount: number }>, videoAnalysisSubmission?: { __typename?: 'UserProfiles', username?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, id?: any | null } | null, videoAnalysisReviewer?: { __typename?: 'UserProfiles', username?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, id?: any | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null } | null } | null, lesson?: { __typename?: 'Lessons', id: any, ownerUserId?: any | null, startDateTime?: any | null, endDateTime?: any | null, title: string, status: LessonStatusesEnum, ownerProfile?: { __typename?: 'UserProfiles', username?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, id?: any | null } | null } | null, playSession?: { __typename?: 'PlaySessions', id: any, startDateTime?: any | null, endDateTime?: any | null, title: string, status: PlaySessionStatusesEnum, organizerUserId?: any | null, format: PlaySessionFormatsEnum, sport: SportsEnum, targetSkillLevel?: string | null, organizerProfile?: { __typename?: 'UserProfiles', username?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, id?: any | null } | null } | null, eventGroup?: { __typename?: 'EventGroups', event: { __typename?: 'Events', id: any } } | null, group?: { __typename?: 'Groups', id: any, title: string, slug: string } | null, groupThread?: { __typename?: 'GroupThreads', groupId: any, id: any, comments: Array<{ __typename?: 'GroupThreadComments', id: any, content: string }> } | null, partnerBookingOrder?: { __typename?: 'PartnerBookingOrders', id: any, status: PartnerBookingOrderStatusesEnum, failureReason?: string | null, startAt: any, endAt: any, timezone: string, venue: { __typename?: 'Venues', id: any, title: string } } | null, playRequest?: { __typename?: 'PlayRequests', id: any, status: PlayRequestStatusesEnum, eventId?: any | null, availabilityId?: any | null, requestMessage?: string | null, responseMessage?: string | null, event?: { __typename?: 'Events', id: any, title: string, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, venue?: { __typename?: 'Venues', id: any, timezone: string } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, competitiveness?: EventCompetitivenessEnum | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }> } | null, availability?: { __typename?: 'PlayerAvailabilities', id: any, sport: SportsEnum, teamType: TeamTypesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null, activeCity?: { __typename?: 'Cities', id: any, name: string } | null } | null } | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null, activeCity?: { __typename?: 'Cities', id: any, name: string } | null } | null } | null, connectionRequest?: { __typename?: 'UserConnectionRequests', id: any, status: UserConnectionRequestStatusesEnum, message?: string | null, requesterUserId: any, recipientUserId: any, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null } | null, recipientProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null } | null } | null, eventPlayerInvite?: { __typename?: 'EventPlayerInvites', id: any, status: EventPlayerInviteStatusesEnum, eventId: any, inviterUserId: any, invitedUserId: any, inviterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, event: { __typename?: 'Events', id: any, title: string, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, displayLocation: string, venue?: { __typename?: 'Venues', id: any, timezone: string } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, competitiveness?: EventCompetitivenessEnum | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }> } } | null } } };

export type GetUserNotificationsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  userId: Scalars['uuid'];
}>;


export type GetUserNotificationsQuery = { __typename?: 'query_root', userNotifications: Array<{ __typename?: 'UserNotifications', id: any, status: NotificationStatusesEnum, videoAnalysisId?: any | null, notificationDetails: { __typename?: 'UserNotificationDetails', actionType: NotificationActionTypesEnum, id: any, primaryEntity: { __typename?: 'UserNotificationEntities', actingUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, coachStatus?: string | null } | null, videoAnalysis?: { __typename?: 'VideoAnalysis', id: any, currency: string, createdAt: any, reviewStatus?: VideoAnalysisReviewStatusesEnum | null, submissionUserId: any, reviewerUserId: any, orders: Array<{ __typename?: 'VideoAnalysisOrders', paidUnitAmount: number, orderTotalUnitAmount: number, orderSubtotalUnitAmount: number }>, videoAnalysisSubmission?: { __typename?: 'UserProfiles', username?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, id?: any | null } | null, videoAnalysisReviewer?: { __typename?: 'UserProfiles', username?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, id?: any | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null } | null } | null, lesson?: { __typename?: 'Lessons', id: any, ownerUserId?: any | null, startDateTime?: any | null, endDateTime?: any | null, title: string, status: LessonStatusesEnum, ownerProfile?: { __typename?: 'UserProfiles', username?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, id?: any | null } | null } | null, playSession?: { __typename?: 'PlaySessions', id: any, startDateTime?: any | null, endDateTime?: any | null, title: string, status: PlaySessionStatusesEnum, organizerUserId?: any | null, format: PlaySessionFormatsEnum, sport: SportsEnum, targetSkillLevel?: string | null, organizerProfile?: { __typename?: 'UserProfiles', username?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, id?: any | null } | null } | null, eventGroup?: { __typename?: 'EventGroups', event: { __typename?: 'Events', id: any } } | null, group?: { __typename?: 'Groups', id: any, title: string, slug: string } | null, groupThread?: { __typename?: 'GroupThreads', groupId: any, id: any, comments: Array<{ __typename?: 'GroupThreadComments', id: any, content: string }> } | null, partnerBookingOrder?: { __typename?: 'PartnerBookingOrders', id: any, status: PartnerBookingOrderStatusesEnum, failureReason?: string | null, startAt: any, endAt: any, timezone: string, venue: { __typename?: 'Venues', id: any, title: string } } | null, playRequest?: { __typename?: 'PlayRequests', id: any, status: PlayRequestStatusesEnum, eventId?: any | null, availabilityId?: any | null, requestMessage?: string | null, responseMessage?: string | null, event?: { __typename?: 'Events', id: any, title: string, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, venue?: { __typename?: 'Venues', id: any, timezone: string } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, competitiveness?: EventCompetitivenessEnum | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }> } | null, availability?: { __typename?: 'PlayerAvailabilities', id: any, sport: SportsEnum, teamType: TeamTypesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null, activeCity?: { __typename?: 'Cities', id: any, name: string } | null } | null } | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null, activeCity?: { __typename?: 'Cities', id: any, name: string } | null } | null } | null, connectionRequest?: { __typename?: 'UserConnectionRequests', id: any, status: UserConnectionRequestStatusesEnum, message?: string | null, requesterUserId: any, recipientUserId: any, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null } | null, recipientProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null } | null } | null, eventPlayerInvite?: { __typename?: 'EventPlayerInvites', id: any, status: EventPlayerInviteStatusesEnum, eventId: any, inviterUserId: any, invitedUserId: any, inviterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, event: { __typename?: 'Events', id: any, title: string, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, displayLocation: string, venue?: { __typename?: 'Venues', id: any, timezone: string } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, competitiveness?: EventCompetitivenessEnum | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }> } } | null } } }> };

export type GetUnreadNotificationsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetUnreadNotificationsQuery = { __typename?: 'query_root', userNotificationsAggregate: { __typename?: 'UserNotificationsAggregate', aggregate?: { __typename?: 'UserNotificationsAggregateFields', count: number } | null }, userNotifications: Array<{ __typename?: 'UserNotifications', createdAt: any, id: any, status: NotificationStatusesEnum, videoAnalysisId?: any | null, notificationDetails: { __typename?: 'UserNotificationDetails', actionType: NotificationActionTypesEnum, id: any, primaryEntity: { __typename?: 'UserNotificationEntities', actingUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, coachStatus?: string | null } | null, videoAnalysis?: { __typename?: 'VideoAnalysis', id: any, currency: string, createdAt: any, reviewStatus?: VideoAnalysisReviewStatusesEnum | null, submissionUserId: any, reviewerUserId: any, orders: Array<{ __typename?: 'VideoAnalysisOrders', paidUnitAmount: number, orderTotalUnitAmount: number, orderSubtotalUnitAmount: number }>, videoAnalysisSubmission?: { __typename?: 'UserProfiles', username?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, id?: any | null } | null, videoAnalysisReviewer?: { __typename?: 'UserProfiles', username?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, id?: any | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null } | null } | null, lesson?: { __typename?: 'Lessons', id: any, ownerUserId?: any | null, startDateTime?: any | null, endDateTime?: any | null, title: string, status: LessonStatusesEnum, ownerProfile?: { __typename?: 'UserProfiles', username?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, id?: any | null } | null } | null, playSession?: { __typename?: 'PlaySessions', id: any, startDateTime?: any | null, endDateTime?: any | null, title: string, status: PlaySessionStatusesEnum, organizerUserId?: any | null, format: PlaySessionFormatsEnum, sport: SportsEnum, targetSkillLevel?: string | null, organizerProfile?: { __typename?: 'UserProfiles', username?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, id?: any | null } | null } | null, eventGroup?: { __typename?: 'EventGroups', event: { __typename?: 'Events', id: any } } | null, group?: { __typename?: 'Groups', id: any, title: string, slug: string } | null, groupThread?: { __typename?: 'GroupThreads', groupId: any, id: any, comments: Array<{ __typename?: 'GroupThreadComments', id: any, content: string }> } | null, partnerBookingOrder?: { __typename?: 'PartnerBookingOrders', id: any, status: PartnerBookingOrderStatusesEnum, failureReason?: string | null, startAt: any, endAt: any, timezone: string, venue: { __typename?: 'Venues', id: any, title: string } } | null, playRequest?: { __typename?: 'PlayRequests', id: any, status: PlayRequestStatusesEnum, eventId?: any | null, availabilityId?: any | null, requestMessage?: string | null, responseMessage?: string | null, event?: { __typename?: 'Events', id: any, title: string, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, venue?: { __typename?: 'Venues', id: any, timezone: string } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, competitiveness?: EventCompetitivenessEnum | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }> } | null, availability?: { __typename?: 'PlayerAvailabilities', id: any, sport: SportsEnum, teamType: TeamTypesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null, activeCity?: { __typename?: 'Cities', id: any, name: string } | null } | null } | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null, activeCity?: { __typename?: 'Cities', id: any, name: string } | null } | null } | null, connectionRequest?: { __typename?: 'UserConnectionRequests', id: any, status: UserConnectionRequestStatusesEnum, message?: string | null, requesterUserId: any, recipientUserId: any, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null } | null, recipientProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null } | null } | null, eventPlayerInvite?: { __typename?: 'EventPlayerInvites', id: any, status: EventPlayerInviteStatusesEnum, eventId: any, inviterUserId: any, invitedUserId: any, inviterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, event: { __typename?: 'Events', id: any, title: string, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, displayLocation: string, venue?: { __typename?: 'Venues', id: any, timezone: string } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, competitiveness?: EventCompetitivenessEnum | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }> } } | null } } }> };

export type GetUserNotificationsCountQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetUserNotificationsCountQuery = { __typename?: 'query_root', userNotificationsAggregate: { __typename?: 'UserNotificationsAggregate', aggregate?: { __typename?: 'UserNotificationsAggregateFields', count: number } | null } };

export type UpdateNotificationsAsReadMutationVariables = Exact<{
  updates: Array<UserNotificationsUpdates> | UserNotificationsUpdates;
}>;


export type UpdateNotificationsAsReadMutation = { __typename?: 'mutation_root', updateUserNotificationsMany?: Array<{ __typename?: 'UserNotificationsMutationResponse', returning: Array<{ __typename?: 'UserNotifications', id: any, status: NotificationStatusesEnum }> } | null> | null };

export type InsertUserReviewMutationVariables = Exact<{
  lessonId?: InputMaybe<Scalars['uuid']>;
  rating: Scalars['Int'];
  review?: InputMaybe<Scalars['String']>;
  reviewerUserId: Scalars['uuid'];
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  type: CoachReviewTypesEnum;
  externalUrl?: InputMaybe<Scalars['String']>;
  externalSource: CoachExternalReviewSourcesEnum;
  externalImageUrl?: InputMaybe<Scalars['String']>;
  externalImageFileName?: InputMaybe<Scalars['String']>;
  externalDomain?: InputMaybe<Scalars['String']>;
  coachUserId: Scalars['uuid'];
}>;


export type InsertUserReviewMutation = { __typename?: 'mutation_root', insertReviewsOne?: { __typename?: 'Reviews', coachUserId?: any | null, createdAt: any, deletedAt?: any | null, externalDomain?: string | null, externalImageFileName?: string | null, externalImageUrl?: string | null, externalSource?: CoachExternalReviewSourcesEnum | null, externalUrl?: string | null, lessonId?: any | null, review?: string | null, rating: number, reviewerUserId?: any | null, type?: CoachReviewTypesEnum | null, videoAnalysisId?: any | null } | null };

export type GetUserDefaultCreditCardQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetUserDefaultCreditCardQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', defaultCreditCardId?: any | null } | null };

export type UpdateUserCityMutationVariables = Exact<{
  id: Scalars['uuid'];
  activeCityId?: InputMaybe<Scalars['uuid']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  geometry?: InputMaybe<Scalars['geography']>;
}>;


export type UpdateUserCityMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, activeCityId?: any | null, latitude?: any | null, longitude?: any | null, geometry?: any | null } | null };

export type GetActiveCityQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetActiveCityQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: any, activeCity?: { __typename?: 'Cities', id: any, name: string, latitude: any, longitude: any, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string } } | null } | null };

export type SearchCitiesQueryVariables = Exact<{
  name: Scalars['String'];
  limit: Scalars['Int'];
}>;


export type SearchCitiesQuery = { __typename?: 'query_root', cities: Array<{ __typename?: 'Cities', id: any, name: string, latitude: any, longitude: any, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string } }> };

export type InsertUserGroupMembershipMutationVariables = Exact<{
  groupId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type InsertUserGroupMembershipMutation = { __typename?: 'mutation_root', insertGroupMembersOne?: { __typename?: 'GroupMembers', id: any } | null };

export type GetClosestCitiesQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
}>;


export type GetClosestCitiesQuery = { __typename?: 'query_root', cities: Array<{ __typename?: 'Cities', id: any, name: string, geometry?: any | null, latitude: any, longitude: any, slug: string }> };

export type UpdateCoachSettingsQuickMutationVariables = Exact<{
  userId: Scalars['uuid'];
  defaultSport: SportsEnum;
  sports: Array<CoachSportsInsertInput> | CoachSportsInsertInput;
  profileImageFileName: Scalars['String'];
  profileImagePath?: InputMaybe<Scalars['String']>;
  profileImageProvider?: InputMaybe<Scalars['String']>;
  profileImageProviderId?: InputMaybe<Scalars['String']>;
  profileImageProviderUrl?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  priceUnitAmountRemoteCoachDefault?: InputMaybe<Scalars['Int']>;
  priceUnitAmountCoachDefault?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<GenderEnum>;
  images?: InputMaybe<Array<UserFilesInsertInput> | UserFilesInsertInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCoachSettingsQuickMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any } | null, insertCoachSports?: { __typename?: 'CoachSportsMutationResponse', returning: Array<{ __typename?: 'CoachSports', id: any, sport: SportsEnum, status: CoachSportStatusesEnum, userId: any }> } | null };

export type InsertPlayerReviewMutationVariables = Exact<{
  playerUserId: Scalars['uuid'];
  reviewerUserId: Scalars['uuid'];
  rating: Scalars['Int'];
  review?: InputMaybe<Scalars['String']>;
  isPlayerSkillLevelAccurate?: InputMaybe<Scalars['Boolean']>;
}>;


export type InsertPlayerReviewMutation = { __typename?: 'mutation_root', insertReviewsOne?: { __typename?: 'Reviews', id: any, rating: number, review?: string | null, createdAt: any, playerUserId?: any | null, reviewerUserId?: any | null } | null };

export type GetCoachReviewsByCoachIdQueryVariables = Exact<{
  coachUserId: Scalars['uuid'];
  orderBy?: InputMaybe<Array<ReviewsOrderBy> | ReviewsOrderBy>;
}>;


export type GetCoachReviewsByCoachIdQuery = { __typename?: 'query_root', reviews: Array<{ __typename?: 'Reviews', createdAt: any, externalDomain?: string | null, externalImageFileName?: string | null, externalImageUrl?: string | null, externalSource?: CoachExternalReviewSourcesEnum | null, externalUrl?: string | null, externalFullName?: string | null, id: any, rating: number, review?: string | null, type?: CoachReviewTypesEnum | null, coach?: { __typename?: 'UserProfiles', profileImagePath?: string | null, profileImageFileName?: string | null, profileImageProviderUrl?: string | null, profileImageProvider?: string | null, id?: any | null, username?: string | null, fullName?: string | null } | null, reviewer?: { __typename?: 'UserProfiles', profileImagePath?: string | null, profileImageFileName?: string | null, profileImageProviderUrl?: string | null, profileImageProvider?: string | null, id?: any | null, username?: string | null, fullName?: string | null } | null }> };

export type GetCoachReviewCheckQueryVariables = Exact<{
  coachUserId: Scalars['uuid'];
  playerUserId: Scalars['uuid'];
}>;


export type GetCoachReviewCheckQuery = { __typename?: 'query_root', coach: Array<{ __typename?: 'UserProfiles', profileImagePath?: string | null, profileImageFileName?: string | null, profileImageProviderUrl?: string | null, profileImageProvider?: string | null, id?: any | null, username?: string | null, fullName?: string | null }>, player: Array<{ __typename?: 'UserProfiles', profileImagePath?: string | null, profileImageFileName?: string | null, profileImageProviderUrl?: string | null, profileImageProvider?: string | null, id?: any | null, username?: string | null, fullName?: string | null }>, reviews: Array<{ __typename?: 'Reviews', id: any }> };

export type InsertUsagePingMutationVariables = Exact<{
  pathname?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
  firebaseId?: InputMaybe<Scalars['String']>;
  queryString?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
  ipResponse?: InputMaybe<Scalars['jsonb']>;
}>;


export type InsertUsagePingMutation = { __typename?: 'mutation_root', insertAppPingsOne?: { __typename?: 'AppPings', id: any } | null };

export type UpdateUserLocaleAndTimezoneMutationVariables = Exact<{
  id: Scalars['uuid'];
  locale?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserLocaleAndTimezoneMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, locale?: string | null, timezone?: string | null } | null };

export type GetCalendarAccountsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetCalendarAccountsQuery = { __typename?: 'query_root', calendarAccounts: Array<{ __typename?: 'CalendarAccounts', id: any, email?: string | null, provider: CalendarAuthProviderEnum, connected: boolean, createdAt: any, updatedAt: any, calendarPreferences: Array<{ __typename?: 'CalendarPreferences', id: any, calendarId: string, calendarName: string, isEnabled: boolean, isDefault?: boolean | null, isWritable: boolean }> }> };

export type UpdateCalendarAccountStatusMutationVariables = Exact<{
  id: Scalars['uuid'];
  connected: Scalars['Boolean'];
}>;


export type UpdateCalendarAccountStatusMutation = { __typename?: 'mutation_root', updateCalendarAccounts?: { __typename?: 'CalendarAccountsMutationResponse', returning: Array<{ __typename?: 'CalendarAccounts', id: any }> } | null };

export type UpdateCalendarPreferenceMutationVariables = Exact<{
  id: Scalars['uuid'];
  isEnabled: Scalars['Boolean'];
}>;


export type UpdateCalendarPreferenceMutation = { __typename?: 'mutation_root', updateCalendarPreferences?: { __typename?: 'CalendarPreferencesMutationResponse', returning: Array<{ __typename?: 'CalendarPreferences', id: any, isEnabled: boolean }> } | null };

export type UpdateDefaultCalendarPreferenceMutationVariables = Exact<{
  userId: Scalars['uuid'];
  preferenceId: Scalars['uuid'];
}>;


export type UpdateDefaultCalendarPreferenceMutation = { __typename?: 'mutation_root', updateCalendarPreferences?: { __typename?: 'CalendarPreferencesMutationResponse', affectedRows: number } | null, updateCalendarPreferencesByPk?: { __typename?: 'CalendarPreferences', id: any, isDefault?: boolean | null } | null };

export type ActivityEventCardFieldsFragment = { __typename?: 'Events', id: any, slug: string, title: string, sport: SportsEnum, type: EventTypesEnum, isRfx: boolean, startDateTime: any, endDateTime: any, timezoneName: string, registrationDeadlineDateTime?: any | null, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, isExternal: boolean, sourceRegistrationCount: number, hostUserId?: any | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string }> } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, groups: Array<{ __typename?: 'EventGroups', id: any, startsAt?: any | null, endsAt?: any | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }> };

export type ConnectionPlayerProfileFieldsFragment = { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, gender?: string | null, defaultSport?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, padelSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null };

export type ConnectionSharedGameFieldsFragment = { __typename?: 'UserPlayedWithGames', eventId?: any | null, startDateTime?: any | null, event?: { __typename?: 'Events', id: any, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, courtCostPerPlayerUnitAmount?: number | null, displayLocation: string, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, competitiveness?: EventCompetitivenessEnum | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', shortName: string } | null }> }> } | null };

export type GameInviteEventFieldsFragment = { __typename?: 'Events', id: any, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, displayLocation: string, courtCostPerPlayerUnitAmount?: number | null, participantLimit?: number | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, competitiveness?: EventCompetitivenessEnum | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', shortName: string } | null }> }> };

export type LessonFieldsFragment = { __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> };

export type PlaySessionFieldsFragment = { __typename?: 'PlaySessions', cancelReason: string, canceledAt?: any | null, deletedAt?: any | null, competitiveness?: PlaySessionMatchCompetitivenessEnum | null, courtBookingStatus: PlaySessionCourtBookingStatusesEnum, createdAt: any, currency: string, description: string, endDateTime?: any | null, extraRacketCount?: number | null, format: PlaySessionFormatsEnum, groupId?: any | null, id: any, isBringingNet: boolean, participantLimit?: number | null, sport: SportsEnum, startDateTime?: any | null, status: PlaySessionStatusesEnum, targetSkillLevel?: string | null, title: string, userCustomCourtId?: any | null, locale: string, timezoneOffsetMinutes: number, timezoneName: string, timezoneAbbreviation: string, publishedAt?: any | null, priceUnitAmount: number, updatedAt: any, organizerUserId?: any | null, privacy: PlaySessionPrivacyEnum, skillRatingMaximum?: any | null, skillRatingMinimum?: any | null, organizerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any } | null, participantsAggregate: { __typename?: 'PlaySessionParticipantsAggregate', aggregate?: { __typename?: 'PlaySessionParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'PlaySessionParticipants', id: any, playSessionId: any, userId: any, status: PlaySessionParticipantStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, providerUrl: string, path: string, url: string }> } | null };

export type UserProfileFieldsFragment = { __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, aboutMe?: string | null, aboutMeVideoUrl?: string | null, cityName?: string | null, gender?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null, coachingStartYear?: number | null, normalizedTennisRating?: any | null, tennisRating?: any | null, country?: { __typename?: 'Countries', id: string, iso2: string, iso3: string, name: string } | null, countrySubdivision?: { __typename?: 'CountrySubdivisions', code: string, id: any, name: string, type: string } | null, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, followers: Array<{ __typename?: 'UserFollows', followerUserId: any, followedUserId: any, followerProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, preferredName?: string | null } | null }>, coachServices: Array<{ __typename?: 'UserCoachServices', currency: string, description: string, id: any, title: string, priceUnitAmount: number, type?: LessonTypesEnum | null, coverImageFileName: string, coverImagePath: string, coverImageProviderUrl: string }>, coachQualifications: Array<{ __typename?: 'UsersCoachQualifications', id: any, status: CoachQualificationStatusesEnum, qualification: { __typename?: 'CoachQualifications', id: any, name: string, order: number, groupId?: CoachQualificationGroupsEnum | null, displayKey: string } }>, normalizedTennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, name: string, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, name: string, shortName: string } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null };

export type UpdateUserSessionTimestampsMutationVariables = Exact<{
  id: Scalars['uuid'];
  lastLoginAt: Scalars['timestamptz'];
}>;


export type UpdateUserSessionTimestampsMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, lastSessionAt?: any | null, lastLoginAt?: any | null } | null };

export type InsertCoachPremiumContentMutationVariables = Exact<{
  skills: Array<UserContentFilesSkillsInsertInput> | UserContentFilesSkillsInsertInput;
  description: Scalars['String'];
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  host: Scalars['String'];
  fileFormat: FileFormatEnum;
  originalFileName: Scalars['String'];
  provider: Scalars['String'];
  providerUrl: Scalars['String'];
  providerId: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
  userId: Scalars['uuid'];
  tier: UserContentTiersEnum;
}>;


export type InsertCoachPremiumContentMutation = { __typename?: 'mutation_root', insertUserContentFilesOne?: { __typename?: 'UserContentFiles', id: any, createdAt: any, updatedAt: any } | null };

export type InsertPlaySessionCommentMutationVariables = Exact<{
  content: Scalars['String'];
  playSessionId: Scalars['uuid'];
  playSessionCommentId?: InputMaybe<Scalars['uuid']>;
  playSessionRootCommentId?: InputMaybe<Scalars['uuid']>;
  userId: Scalars['uuid'];
}>;


export type InsertPlaySessionCommentMutation = { __typename?: 'mutation_root', insertPlaySessionCommentsOne?: { __typename?: 'PlaySessionComments', content: string, id: any, createdAt: any, deletedAt?: any | null, playSessionCommentId?: any | null, playSessionId: any, playSessionRootCommentId?: any | null, updatedAt: any, userId: any } | null };

export type InsertVideoAnalysisCommentMutationVariables = Exact<{
  skills?: InputMaybe<Array<VideoAnalysisSkillsCommentsInsertInput> | VideoAnalysisSkillsCommentsInsertInput>;
  details: Scalars['String'];
  feedbackType: FeedbackSentimentEnum;
  videoAnalysisId: Scalars['uuid'];
  videoImageFileId?: InputMaybe<Scalars['uuid']>;
  userId: Scalars['uuid'];
  startTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  endTimestampSeconds?: InputMaybe<Scalars['numeric']>;
}>;


export type InsertVideoAnalysisCommentMutation = { __typename?: 'mutation_root', insertVideoAnalysisCommentsOne?: { __typename?: 'VideoAnalysisComments', id: any, createdAt: any, updatedAt: any, details: string, sentiment: FeedbackSentimentEnum, userId: any } | null };

export type InsertVideoAnalysisFileMutationVariables = Exact<{
  videoImageFile: VideoAnalysisFilesInsertInput;
}>;


export type InsertVideoAnalysisFileMutation = { __typename?: 'mutation_root', insertVideoAnalysisFilesOne?: { __typename?: 'VideoAnalysisFiles', id: any } | null };

export type UpdateFollowerInactiveMutationVariables = Exact<{
  followedUserId: Scalars['uuid'];
  followerUserId: Scalars['uuid'];
}>;


export type UpdateFollowerInactiveMutation = { __typename?: 'mutation_root', updateUserFollows?: { __typename?: 'UserFollowsMutationResponse', returning: Array<{ __typename?: 'UserFollows', followerUserId: any, followedUserId: any, status: FollowStatusesEnum }> } | null };

export type UpdateFollowerActiveMutationVariables = Exact<{
  followedUserId: Scalars['uuid'];
  followerUserId: Scalars['uuid'];
}>;


export type UpdateFollowerActiveMutation = { __typename?: 'mutation_root', updateUserFollows?: { __typename?: 'UserFollowsMutationResponse', returning: Array<{ __typename?: 'UserFollows', followerUserId: any, followedUserId: any, status: FollowStatusesEnum }> } | null };

export type UpdateUserBasicFieldsMutationVariables = Exact<{
  id: Scalars['uuid'];
  activeCityId?: InputMaybe<Scalars['uuid']>;
  fullName: Scalars['String'];
  username?: InputMaybe<Scalars['String']>;
  isPendingAccountDetails?: InputMaybe<Scalars['Boolean']>;
  coachStatus?: InputMaybe<CoachStatusEnum>;
}>;


export type UpdateUserBasicFieldsMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, activeCityId?: any | null, fullName: string, username?: string | null, isPendingAccountDetails?: boolean | null, coachStatus?: CoachStatusEnum | null, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string } } | null } | null };

export type UpdateUserCoverImageMutationVariables = Exact<{
  id: Scalars['uuid'];
  coverImageFileName: Scalars['String'];
  coverImagePath: Scalars['String'];
  coverImageProvider: Scalars['String'];
  coverImageProviderId: Scalars['String'];
  coverImageProviderUrl: Scalars['String'];
  coverImageUrl: Scalars['String'];
}>;


export type UpdateUserCoverImageMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, profile?: { __typename?: 'UserProfiles', id?: any | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProvider?: string | null, coverImageProviderUrl?: string | null } | null } | null, insertUserImageLogOne?: { __typename?: 'UserImageLog', id: any } | null };

export type UpdateUserDefaultSportMutationVariables = Exact<{
  id: Scalars['uuid'];
  defaultSport: SportsEnum;
}>;


export type UpdateUserDefaultSportMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', defaultSport?: SportsEnum | null, id: any } | null };

export type UpdateUserProfileImageMutationVariables = Exact<{
  id: Scalars['uuid'];
  profileImageFileName: Scalars['String'];
  profileImagePath: Scalars['String'];
  profileImageProvider: Scalars['String'];
  profileImageProviderId: Scalars['String'];
  profileImageProviderUrl: Scalars['String'];
  profileImageUrl: Scalars['String'];
}>;


export type UpdateUserProfileImageMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, profileImageFileName: string, profileImagePath: string, profileImageProvider: string, profileImageProviderId: string, profileImageProviderUrl: string, profile?: { __typename?: 'UserProfiles', id?: any | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null } | null, insertUserImageLogOne?: { __typename?: 'UserImageLog', id: any } | null };

export type UpdateUserTimezoneMutationVariables = Exact<{
  id: Scalars['uuid'];
  timezone: Scalars['String'];
}>;


export type UpdateUserTimezoneMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, timezone?: string | null } | null };

export type UpdateVideoAnalysisCommentMutationVariables = Exact<{
  skills?: InputMaybe<Array<VideoAnalysisSkillsCommentsInsertInput> | VideoAnalysisSkillsCommentsInsertInput>;
  details?: InputMaybe<Scalars['String']>;
  feedbackType?: InputMaybe<FeedbackSentimentEnum>;
  videoImageFileId?: InputMaybe<Scalars['uuid']>;
  commentId: Scalars['uuid'];
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  startTimestampSeconds?: InputMaybe<Scalars['numeric']>;
  endTimestampSeconds?: InputMaybe<Scalars['numeric']>;
}>;


export type UpdateVideoAnalysisCommentMutation = { __typename?: 'mutation_root', updateVideoLessonSkills?: { __typename?: 'VideoLessonSkillsMutationResponse', returning: Array<{ __typename?: 'VideoLessonSkills', id: any }> } | null, updateVideoAnalysisSkillsComments?: { __typename?: 'VideoAnalysisSkillsCommentsMutationResponse', returning: Array<{ __typename?: 'VideoAnalysisSkillsComments', id: any }> } | null, updateVideoAnalysisComments?: { __typename?: 'VideoAnalysisCommentsMutationResponse', returning: Array<{ __typename?: 'VideoAnalysisComments', id: any, createdAt: any, updatedAt: any, details: string, sentiment: FeedbackSentimentEnum, userId: any }> } | null, insertVideoAnalysisSkillsComments?: { __typename?: 'VideoAnalysisSkillsCommentsMutationResponse', returning: Array<{ __typename?: 'VideoAnalysisSkillsComments', id: any }> } | null };

export type UpsertFollowerConnectionMutationVariables = Exact<{
  followedUserId: Scalars['uuid'];
  followerUserId: Scalars['uuid'];
  status: FollowStatusesEnum;
}>;


export type UpsertFollowerConnectionMutation = { __typename?: 'mutation_root', insertUserFollowsOne?: { __typename?: 'UserFollows', followerUserId: any, followedUserId: any, status: FollowStatusesEnum } | null };

export type UpsertGroupThreadVoteMutationVariables = Exact<{
  groupThreadCommentId: Scalars['uuid'];
  userId: Scalars['uuid'];
  vote: CommentVoteEnum;
}>;


export type UpsertGroupThreadVoteMutation = { __typename?: 'mutation_root', insertGroupCommentVotesOne?: { __typename?: 'GroupCommentVotes', id: any, userId: any, groupThreadCommentId: any, vote: CommentVoteEnum } | null };

export type GetActiveCoachProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveCoachProfilesQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', coachStatus?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, fullName?: string | null, gender?: string | null, genderPreference?: string | null, id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, username?: string | null }> };

export type GetActiveOwnerLessonsByIdQueryVariables = Exact<{
  ownerUserId: Scalars['uuid'];
}>;


export type GetActiveOwnerLessonsByIdQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> }> };

export type GetActiveOwnerLessonsByIdWithDateRangeQueryVariables = Exact<{
  ownerUserId: Scalars['uuid'];
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type GetActiveOwnerLessonsByIdWithDateRangeQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> }> };

export type GetAllActiveLessonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllActiveLessonsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, startDateTime?: any | null, endDateTime?: any | null, description: string, coverImageFileName: string, coverImagePath: string, coverImageProviderUrl: string, currency: string, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, status: LessonStatusesEnum, type: LessonTypesEnum, typeCustom: string, userCustomCourt?: { __typename?: 'UserCustomCourts', id: any, title: string, fullAddress: string } | null, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, coachStatus?: string | null, gender?: string | null, genderPreference?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, username?: string | null } | null }> };

export type GetConnectionsSummaryQueryVariables = Exact<{
  userId: Scalars['uuid'];
  sharedGameLimit: Scalars['Int'];
}>;


export type GetConnectionsSummaryQuery = { __typename?: 'query_root', userConnections: Array<{ __typename?: 'UserConnections', id: any, createdAt: any, userAId: any, userBId: any, userAProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, gender?: string | null, defaultSport?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, padelSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null, userBProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, gender?: string | null, defaultSport?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, padelSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null }>, userPlayedWith: Array<{ __typename?: 'UserPlayedWith', otherUserId?: any | null, gamesTogether?: number | null, lastPlayedAt?: any | null, otherUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, gender?: string | null, defaultSport?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, padelSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null, games: Array<{ __typename?: 'UserPlayedWithGames', eventId?: any | null, startDateTime?: any | null, event?: { __typename?: 'Events', id: any, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, courtCostPerPlayerUnitAmount?: number | null, displayLocation: string, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, competitiveness?: EventCompetitivenessEnum | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', shortName: string } | null }> }> } | null }> }>, userPlayedWithDismissals: Array<{ __typename?: 'UserPlayedWithDismissals', id: any, dismissedUserId: any }>, userBlocks: Array<{ __typename?: 'UserBlocks', id: any, blockedUserId: any, blockedProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, gender?: string | null, defaultSport?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, padelSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null }>, userConnectionRequests: Array<{ __typename?: 'UserConnectionRequests', id: any, createdAt: any, message?: string | null, requesterUserId: any, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, gender?: string | null, defaultSport?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, padelSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null }>, declinedConnectionRequests: Array<{ __typename?: 'UserConnectionRequests', id: any, requesterUserId: any }>, sentConnectionRequests: Array<{ __typename?: 'UserConnectionRequests', id: any, recipientUserId: any, status: UserConnectionRequestStatusesEnum, attemptNumber: any }> };

export type GetCurrentUserQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetCurrentUserQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: any, createdAt: any, coachStatus?: CoachStatusEnum | null, email: string, firebaseId: string, fullName: string, preferredName: string, birthday?: any | null, duprId?: string | null, gender?: GenderEnum | null, playerFinderOnboardedAt?: any | null, geometry?: any | null, lastLoginAt?: any | null, lastSessionAt?: any | null, genderPreference: string, stripeCustomerId: string, adminVenueId?: any | null, isPendingAccountDetails?: boolean | null, priceUnitAmountCoachDefault?: number | null, stripeMerchantChargesEnabled: boolean, stripeMerchantDetailsSubmitted: boolean, stripeMerchantId?: string | null, stripeMerchantPayoutsEnabled: boolean, stripeMerchantCurrency?: string | null, currencyCoachDefault: string, username?: string | null, locale?: string | null, timezone?: string | null, profileImageFileName: string, profileImagePath: string, profileImageProviderUrl: string, coverImageFileName: string, coverImagePath: string, coverImageProviderUrl: string, defaultCreditCardId?: any | null, tennisRatingScaleId?: any | null, tennisRating?: any | null, defaultSport?: SportsEnum | null, phoneNumber?: string | null, defaultCoachPaymentFulfillmentChannel?: PaymentFulfillmentChannelsEnum | null, didSkipStripeSetup: boolean, isQuatroPickleballMember: boolean, isPicklrP4Member: boolean, coachSports: Array<{ __typename?: 'CoachSports', id: any }>, activeCity?: { __typename?: 'Cities', id: any, name: string, longitude: any, latitude: any, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null, groups: Array<{ __typename?: 'GroupMembers', id: any, isActive: boolean, groupId: any, group: { __typename?: 'Groups', id: any, primarySport?: SportsEnum | null } }>, followingCoachesAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, activePlatformSubscriptions: Array<{ __typename?: 'PlatformSubscriptions', id: any, status: SubscriptionStatusesEnum, cancelAtPeriodEnd?: boolean | null, canceledAt?: any | null, currentPeriodEndAt?: any | null, currentPeriodStartAt?: any | null, externalSubscriptionId: string, planPrice: { __typename?: 'PlatformSubscriptionPlanPrices', id: any, persona: PlatformSubscriptionPersonasEnum } }>, userVairConnection?: { __typename?: 'UserVairConnections', id: any, userId: any, memberId: string, clerkId?: string | null, name: string, email: string, connectedAt: any, lastSyncedAt: any } | null } | null };

export type GetEventPlayerInvitesQueryVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type GetEventPlayerInvitesQuery = { __typename?: 'query_root', eventPlayerInvites: Array<{ __typename?: 'EventPlayerInvites', id: any, status: EventPlayerInviteStatusesEnum, invitedUserId: any, invitedUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, gender?: string | null, defaultSport?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, padelSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null }> };

export type GetGroupByAccessCodeQueryVariables = Exact<{
  accessCode: Scalars['String'];
}>;


export type GetGroupByAccessCodeQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'Groups', id: any, accessCode?: string | null, headline: string, title: string, city?: { __typename?: 'Cities', id: any, name: string } | null, ownerUserProfile?: { __typename?: 'UserProfiles', fullName?: string | null, id?: any | null } | null }> };

export type GetGroupVenuesQueryVariables = Exact<{
  groupId: Scalars['uuid'];
}>;


export type GetGroupVenuesQuery = { __typename?: 'query_root', groupVenues: Array<{ __typename?: 'GroupVenues', id: any, venue: { __typename?: 'Venues', id: any, createdAt: any, title: string, slug: string, outdoorCourtCount: number, indoorCourtCount: number, isActive: boolean, accessType?: VenueAccessTypesEnum | null, addressString: string, totalCourtCount: number, facilityType?: VenueFacilityTypesEnum | null, pickleballNets?: VenueNetsEnum | null, images: Array<{ __typename?: 'VenueImages', providerUrl: string, id: any, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } }> };

export type GetLessonByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetLessonByIdQuery = { __typename?: 'query_root', lessonsByPk?: { __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> } | null };

export type GetMyGameInvitesQueryVariables = Exact<{
  userId: Scalars['uuid'];
  now: Scalars['timestamptz'];
}>;


export type GetMyGameInvitesQuery = { __typename?: 'query_root', eventPlayerInvites: Array<{ __typename?: 'EventPlayerInvites', id: any, createdAt: any, eventId: any, inviterUserId: any, inviterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, gender?: string | null, defaultSport?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, padelSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null, event: { __typename?: 'Events', id: any, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, displayLocation: string, courtCostPerPlayerUnitAmount?: number | null, participantLimit?: number | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, competitiveness?: EventCompetitivenessEnum | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', shortName: string } | null }> }> } }> };

export type GetTournamentStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTournamentStatsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any }>, venues: Array<{ __typename?: 'Venues', id: any }>, groups: Array<{ __typename?: 'Groups', id: any }>, userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null }> };

export type GetPlaySessionByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetPlaySessionByIdQuery = { __typename?: 'query_root', playSessionsByPk?: { __typename?: 'PlaySessions', cancelReason: string, canceledAt?: any | null, deletedAt?: any | null, competitiveness?: PlaySessionMatchCompetitivenessEnum | null, courtBookingStatus: PlaySessionCourtBookingStatusesEnum, createdAt: any, currency: string, description: string, endDateTime?: any | null, extraRacketCount?: number | null, format: PlaySessionFormatsEnum, groupId?: any | null, id: any, isBringingNet: boolean, participantLimit?: number | null, sport: SportsEnum, startDateTime?: any | null, status: PlaySessionStatusesEnum, targetSkillLevel?: string | null, title: string, userCustomCourtId?: any | null, locale: string, timezoneOffsetMinutes: number, timezoneName: string, timezoneAbbreviation: string, publishedAt?: any | null, priceUnitAmount: number, updatedAt: any, organizerUserId?: any | null, privacy: PlaySessionPrivacyEnum, skillRatingMaximum?: any | null, skillRatingMinimum?: any | null, organizerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any } | null, participantsAggregate: { __typename?: 'PlaySessionParticipantsAggregate', aggregate?: { __typename?: 'PlaySessionParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'PlaySessionParticipants', id: any, playSessionId: any, userId: any, status: PlaySessionParticipantStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, providerUrl: string, path: string, url: string }> } | null } | null };

export type GetPlaySessionCommentsQueryVariables = Exact<{
  playSessionId: Scalars['uuid'];
}>;


export type GetPlaySessionCommentsQuery = { __typename?: 'query_root', playSessionComments: Array<{ __typename?: 'PlaySessionComments', id: any, createdAt: any, content: string, playSessionCommentId?: any | null, playSessionId: any, playSessionRootCommentId?: any | null, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, username?: string | null } | null }> };

export type GetPlayerLessonsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetPlayerLessonsQuery = { __typename?: 'query_root', lessonParticipants: Array<{ __typename?: 'LessonParticipants', id: any, status: LessonParticipantStatusesEnum, lesson: { __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> } }> };

export type GetPlayerPlaySessionsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetPlayerPlaySessionsQuery = { __typename?: 'query_root', playSessionParticipants: Array<{ __typename?: 'PlaySessionParticipants', id: any, status: PlaySessionParticipantStatusesEnum, playSession: { __typename?: 'PlaySessions', cancelReason: string, canceledAt?: any | null, deletedAt?: any | null, competitiveness?: PlaySessionMatchCompetitivenessEnum | null, courtBookingStatus: PlaySessionCourtBookingStatusesEnum, createdAt: any, currency: string, description: string, endDateTime?: any | null, extraRacketCount?: number | null, format: PlaySessionFormatsEnum, groupId?: any | null, id: any, isBringingNet: boolean, participantLimit?: number | null, sport: SportsEnum, startDateTime?: any | null, status: PlaySessionStatusesEnum, targetSkillLevel?: string | null, title: string, userCustomCourtId?: any | null, locale: string, timezoneOffsetMinutes: number, timezoneName: string, timezoneAbbreviation: string, publishedAt?: any | null, priceUnitAmount: number, updatedAt: any, organizerUserId?: any | null, privacy: PlaySessionPrivacyEnum, skillRatingMaximum?: any | null, skillRatingMinimum?: any | null, organizerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any } | null, participantsAggregate: { __typename?: 'PlaySessionParticipantsAggregate', aggregate?: { __typename?: 'PlaySessionParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'PlaySessionParticipants', id: any, playSessionId: any, userId: any, status: PlaySessionParticipantStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, providerUrl: string, path: string, url: string }> } | null } }>, playSessions: Array<{ __typename?: 'PlaySessions', cancelReason: string, canceledAt?: any | null, deletedAt?: any | null, competitiveness?: PlaySessionMatchCompetitivenessEnum | null, courtBookingStatus: PlaySessionCourtBookingStatusesEnum, createdAt: any, currency: string, description: string, endDateTime?: any | null, extraRacketCount?: number | null, format: PlaySessionFormatsEnum, groupId?: any | null, id: any, isBringingNet: boolean, participantLimit?: number | null, sport: SportsEnum, startDateTime?: any | null, status: PlaySessionStatusesEnum, targetSkillLevel?: string | null, title: string, userCustomCourtId?: any | null, locale: string, timezoneOffsetMinutes: number, timezoneName: string, timezoneAbbreviation: string, publishedAt?: any | null, priceUnitAmount: number, updatedAt: any, organizerUserId?: any | null, privacy: PlaySessionPrivacyEnum, skillRatingMaximum?: any | null, skillRatingMinimum?: any | null, organizerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any } | null, participantsAggregate: { __typename?: 'PlaySessionParticipantsAggregate', aggregate?: { __typename?: 'PlaySessionParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'PlaySessionParticipants', id: any, playSessionId: any, userId: any, status: PlaySessionParticipantStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, providerUrl: string, path: string, url: string }> } | null }> };

export type GetSportsRatingScalesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSportsRatingScalesQuery = { __typename?: 'query_root', pickleballRatingScales: Array<{ __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string }>, tennisRatingScales: Array<{ __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string }> };

export type GetTopCourtsByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTopCourtsByGeoQuery = { __typename?: 'query_root', venues: Array<{ __typename?: 'Venues', id: any, title: string, geometry?: any | null, slug: string, timezone: string, pickleballLines?: VenueLinesEnum | null, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, hasPickleball: boolean, hasTennis: boolean, hasPadel: boolean, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, path: string, provider: string, url: string }>, city?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string } } | null, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> }> };

export type GetTournamentsByLocationQueryVariables = Exact<{
  limit: Scalars['Int'];
  distance: Scalars['Float'];
  from: Scalars['geography'];
}>;


export type GetTournamentsByLocationQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', coverImagePath?: string | null, displayLocation: string, endDateTime: any, hasPrizes: boolean, currency: string, id: any, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, slug: string, sport: SportsEnum, isExternal: boolean, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, startDateTime: any, status: EventStatusesEnum, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, city?: { __typename?: 'Cities', name: string, id: any, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null } }> };

export type GetTournamentsForMarketplaceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTournamentsForMarketplaceQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', coverImagePath?: string | null, displayLocation: string, endDateTime: any, hasPrizes: boolean, id: any, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, groupFormat?: EventGroupFormatsEnum | null, scoringFormat?: ScoringFormatEnum | null, slug: string, sport: SportsEnum, source?: string | null, isExternal: boolean, isVairRequired?: boolean | null, currency: string, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, startDateTime: any, status: EventStatusesEnum, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, city?: { __typename?: 'Cities', name: string, id: any, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string } } | null, groups: Array<{ __typename?: 'EventGroups', id: any, gender: CompetitionGenderEnum, teamType?: TeamTypesEnum | null, format?: EventGroupFormatsEnum | null, isMoneyBall?: boolean | null, minimumAge?: number | null, maximumAge?: number | null }>, venue?: { __typename?: 'Venues', id: any, timezone: string, addressString: string } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null } }> };

export type GetUserFollowerProfilesQueryVariables = Exact<{
  followedUserId: Scalars['uuid'];
}>;


export type GetUserFollowerProfilesQuery = { __typename?: 'query_root', userFollows: Array<{ __typename?: 'UserFollows', status: FollowStatusesEnum, followerUserId: any, followedUserId: any, followerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null } | null }> };

export type GetUserFollowingIdsQueryVariables = Exact<{
  followerUserId: Scalars['uuid'];
}>;


export type GetUserFollowingIdsQuery = { __typename?: 'query_root', userFollows: Array<{ __typename?: 'UserFollows', status: FollowStatusesEnum, followerUserId: any, followedUserId: any }> };

export type GetUserProfileByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserProfileByIdQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, aboutMe?: string | null, aboutMeVideoUrl?: string | null, cityName?: string | null, gender?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null, coachingStartYear?: number | null, normalizedTennisRating?: any | null, tennisRating?: any | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, playerReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number } | null }, country?: { __typename?: 'Countries', id: string, iso2: string, iso3: string, name: string } | null, countrySubdivision?: { __typename?: 'CountrySubdivisions', code: string, id: any, name: string, type: string } | null, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, followers: Array<{ __typename?: 'UserFollows', followerUserId: any, followedUserId: any, followerProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, preferredName?: string | null } | null }>, coachServices: Array<{ __typename?: 'UserCoachServices', currency: string, description: string, id: any, title: string, priceUnitAmount: number, type?: LessonTypesEnum | null, coverImageFileName: string, coverImagePath: string, coverImageProviderUrl: string }>, coachQualifications: Array<{ __typename?: 'UsersCoachQualifications', id: any, status: CoachQualificationStatusesEnum, qualification: { __typename?: 'CoachQualifications', id: any, name: string, order: number, groupId?: CoachQualificationGroupsEnum | null, displayKey: string } }>, normalizedTennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, name: string, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, name: string, shortName: string } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null }> };

export type GetUserProfileByUsernameQueryVariables = Exact<{
  username: Scalars['String'];
  viewerId: Scalars['uuid'];
}>;


export type GetUserProfileByUsernameQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, aboutMe?: string | null, aboutMeVideoUrl?: string | null, cityName?: string | null, gender?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null, coachingStartYear?: number | null, normalizedTennisRating?: any | null, tennisRating?: any | null, country?: { __typename?: 'Countries', id: string, iso2: string, iso3: string, name: string } | null, countrySubdivision?: { __typename?: 'CountrySubdivisions', code: string, id: any, name: string, type: string } | null, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, followers: Array<{ __typename?: 'UserFollows', followerUserId: any, followedUserId: any, followerProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, preferredName?: string | null } | null }>, coachServices: Array<{ __typename?: 'UserCoachServices', currency: string, description: string, id: any, title: string, priceUnitAmount: number, type?: LessonTypesEnum | null, coverImageFileName: string, coverImagePath: string, coverImageProviderUrl: string }>, coachQualifications: Array<{ __typename?: 'UsersCoachQualifications', id: any, status: CoachQualificationStatusesEnum, qualification: { __typename?: 'CoachQualifications', id: any, name: string, order: number, groupId?: CoachQualificationGroupsEnum | null, displayKey: string } }>, normalizedTennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, name: string, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, name: string, shortName: string } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null }>, userFollows: Array<{ __typename?: 'UserFollows', status: FollowStatusesEnum, followedUserId: any, followerUserId: any }> };

export type GetUserPublicProfileByUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type GetUserPublicProfileByUsernameQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, aboutMe?: string | null, aboutMeVideoUrl?: string | null, cityName?: string | null, gender?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null, coachingStartYear?: number | null, normalizedTennisRating?: any | null, tennisRating?: any | null, country?: { __typename?: 'Countries', id: string, iso2: string, iso3: string, name: string } | null, countrySubdivision?: { __typename?: 'CountrySubdivisions', code: string, id: any, name: string, type: string } | null, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, followers: Array<{ __typename?: 'UserFollows', followerUserId: any, followedUserId: any, followerProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, preferredName?: string | null } | null }>, coachServices: Array<{ __typename?: 'UserCoachServices', currency: string, description: string, id: any, title: string, priceUnitAmount: number, type?: LessonTypesEnum | null, coverImageFileName: string, coverImagePath: string, coverImageProviderUrl: string }>, coachQualifications: Array<{ __typename?: 'UsersCoachQualifications', id: any, status: CoachQualificationStatusesEnum, qualification: { __typename?: 'CoachQualifications', id: any, name: string, order: number, groupId?: CoachQualificationGroupsEnum | null, displayKey: string } }>, normalizedTennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, name: string, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, name: string, shortName: string } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null }> };

export type GetUserProfilesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetUserProfilesByIdsQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, fullName?: string | null, coachStatus?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, aboutMe?: string | null, aboutMeVideoUrl?: string | null, cityName?: string | null, gender?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null, coachingStartYear?: number | null, normalizedTennisRating?: any | null, tennisRating?: any | null, country?: { __typename?: 'Countries', id: string, iso2: string, iso3: string, name: string } | null, countrySubdivision?: { __typename?: 'CountrySubdivisions', code: string, id: any, name: string, type: string } | null, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, followers: Array<{ __typename?: 'UserFollows', followerUserId: any, followedUserId: any, followerProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, preferredName?: string | null } | null }>, coachServices: Array<{ __typename?: 'UserCoachServices', currency: string, description: string, id: any, title: string, priceUnitAmount: number, type?: LessonTypesEnum | null, coverImageFileName: string, coverImagePath: string, coverImageProviderUrl: string }>, coachQualifications: Array<{ __typename?: 'UsersCoachQualifications', id: any, status: CoachQualificationStatusesEnum, qualification: { __typename?: 'CoachQualifications', id: any, name: string, order: number, groupId?: CoachQualificationGroupsEnum | null, displayKey: string } }>, normalizedTennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, name: string, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, name: string, shortName: string } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null }> };

export type GetVairConnectionQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetVairConnectionQuery = { __typename?: 'query_root', userVairConnections: Array<{ __typename?: 'UserVairConnections', id: any, userId: any, memberId: string, clerkId?: string | null, name: string, email: string, connectedAt: any, lastSyncedAt: any }> };

export type GetVairConnectionsByUserIdsQueryVariables = Exact<{
  userIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetVairConnectionsByUserIdsQuery = { __typename?: 'query_root', userVairConnections: Array<{ __typename?: 'UserVairConnections', id: any, userId: any, memberId: string, name: string, email: string }> };

export type GetVenueBookingIntegrationQueryVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type GetVenueBookingIntegrationQuery = { __typename?: 'query_root', venueBookingIntegrations: Array<{ __typename?: 'VenueBookingIntegrations', id: any, bookingSystem: BookingSystemsEnum, bookingAccountEmail: string, accountAddedConfirmedAt?: any | null, helpRequestedAt?: any | null, connectionStatus: BookingConnectionStatusesEnum, externalOrgId?: string | null, readVerifiedAt?: any | null, promoCode?: string | null, maxAdvanceBookingDays?: number | null, confirmationNote?: string | null, status: BookingIntegrationStatusesEnum, isPreferredPartner: boolean, partnerPricingEnabled: boolean, referralFeeEnabled: boolean, referralFeeCents: number, currentVersion: number, activatedAt?: any | null, pausedAt?: any | null, configVersions: Array<{ __typename?: 'VenueBookingConfigVersions', id: any, version: number, termsVersion?: string | null, changedAt: any }>, windows: Array<{ __typename?: 'VenueBookingWindows', id: any, kind: BookingWindowKindsEnum, inventoryType?: BookingInventoryTypesEnum | null, sport?: SportsEnum | null, dayOfWeek: DayOfWeekEnum, startTime: any, endTime: any }>, courtRates: Array<{ __typename?: 'VenueBookingCourtRates', id: any, sport?: SportsEnum | null, currency: string, hourlyUnitAmount: number, peakHourlyUnitAmount?: number | null }>, rules: Array<{ __typename?: 'VenueBookingRules', id: any, inventoryType: BookingInventoryTypesEnum, scheduleMode: BookingScheduleModesEnum, isCustomPricing: boolean, tiers: Array<{ __typename?: 'VenueBookingRuleTiers', id: any, leadTimeHours: number, discountPercent: any, isEnabled: boolean }>, windows: Array<{ __typename?: 'VenueBookingWindows', id: any, dayOfWeek: DayOfWeekEnum, startTime: any, endTime: any }> }> }> };

export type GetExistingUserQueryVariables = Exact<{
  firebaseId: Scalars['String'];
}>;


export type GetExistingUserQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, email: string, username?: string | null, fullName: string, coachStatus?: CoachStatusEnum | null }> };

export type InsertSignupRequestMutationVariables = Exact<{
  accountType: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  preferredName: Scalars['String'];
  username: Scalars['String'];
  ip?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  fullDetails?: InputMaybe<Scalars['jsonb']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  cityId?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  eventOrganizerAccountType?: InputMaybe<EventOrganizerAccountTypesEnum>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
}>;


export type InsertSignupRequestMutation = { __typename?: 'mutation_root', insertSignupRequestsOne?: { __typename?: 'SignupRequests', id: any } | null };

export type CheckUsernameAvailabilityQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type CheckUsernameAvailabilityQuery = { __typename?: 'query_root', usernamesActive: Array<{ __typename?: 'UsernamesActive', username?: string | null }>, usernamesClaimed: Array<{ __typename?: 'UsernamesClaimed', id: any, username: string }> };

export type GetVenueLessonsQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetVenueLessonsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, description: string, sport: SportsEnum, type: LessonTypesEnum, typeCustom: string, status: LessonStatusesEnum, privacy: LessonPrivacyEnum, startDateTime?: any | null, endDateTime?: any | null, participantLimit?: number | null, priceUnitAmount: number, currency: string, coverImageUrl: string, externalBookingUrl: string, ownerUserId?: any | null, venueId?: any | null, createdAt: any, publishedAt?: any | null, canceledAt?: any | null, cancelReason: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coachStatus?: string | null } | null, participants: Array<{ __typename?: 'LessonParticipants', id: any, status: LessonParticipantStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, username?: string | null, profileImageUrl?: string | null } | null }>, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, times: Array<{ __typename?: 'LessonTimes', id: any, startDateTime: any, endDateTime: any }> }> };

export type GetVenueLessonsAggregateQueryVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type GetVenueLessonsAggregateQuery = { __typename?: 'query_root', lessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null } };

export type GetVenueStaffCoachesQueryVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type GetVenueStaffCoachesQuery = { __typename?: 'query_root', venueStaffCoaches: Array<{ __typename?: 'VenueStaffCoaches', id: any, userId: any, venueId: any, addedByUserId?: any | null, createdAt: any, coachProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, username?: string | null, profileImageUrl?: string | null, coachStatus?: string | null } | null, addedByUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null } | null }> };

export type InsertVenueStaffCoachMutationVariables = Exact<{
  venueId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type InsertVenueStaffCoachMutation = { __typename?: 'mutation_root', insertVenueStaffCoachesOne?: { __typename?: 'VenueStaffCoaches', id: any, venueId: any, userId: any, addedByUserId?: any | null, createdAt: any, coachProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, username?: string | null, profileImageUrl?: string | null, coachStatus?: string | null } | null } | null };

export type SoftDeleteVenueStaffCoachMutationVariables = Exact<{
  venueId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type SoftDeleteVenueStaffCoachMutation = { __typename?: 'mutation_root', updateVenueStaffCoaches?: { __typename?: 'VenueStaffCoachesMutationResponse', affectedRows: number, returning: Array<{ __typename?: 'VenueStaffCoaches', id: any, deletedAt?: any | null }> } | null };

export type GetCoachRosterVenuesQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetCoachRosterVenuesQuery = { __typename?: 'query_root', venueStaffCoaches: Array<{ __typename?: 'VenueStaffCoaches', id: any, venueId: any, venue: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, timezone: string, pickleballNets?: VenueNetsEnum | null, outdoorCourtCount: number, indoorCourtCount: number, accessType?: VenueAccessTypesEnum | null, images: Array<{ __typename?: 'VenueImages', id: any, url: string }> } }> };

export type SearchCoachesQueryVariables = Exact<{
  searchTerm: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  excludeIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type SearchCoachesQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, fullName: string, username?: string | null, email: string, profileImageUrl: string, coachStatus?: CoachStatusEnum | null, cityName: string }> };

export type GetEventHostForCouponCreateQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventHostForCouponCreateQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', hostUserId?: any | null } | null };

export type GetCouponOwnerForDeleteQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetCouponOwnerForDeleteQuery = { __typename?: 'query_root', eventCouponsByPk?: { __typename?: 'EventCoupons', event: { __typename?: 'Events', hostUserId?: any | null } } | null };

export type GetCouponOwnerForUpdateQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetCouponOwnerForUpdateQuery = { __typename?: 'query_root', eventCouponsByPk?: { __typename?: 'EventCoupons', event: { __typename?: 'Events', hostUserId?: any | null } } | null };

export type GetCoachBookingRequestsQueryVariables = Exact<{
  coachUserId: Scalars['uuid'];
}>;


export type GetCoachBookingRequestsQuery = { __typename?: 'query_root', coachBookingRequests: Array<{ __typename?: 'CoachBookingRequests', id: any, message?: string | null, createdAt: any, playerUserId: any, playerUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null } | null }> };

export type GetTournamentsForStateQueryVariables = Exact<{
  stateId: Scalars['uuid'];
}>;


export type GetTournamentsForStateQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', addressString?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, displayLocation: string, description: string, endDateTime: any, hasPrizes: boolean, id: any, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, slug: string, isExternal: boolean, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, startDateTime: any, status: EventStatusesEnum, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, geometry?: any | null, city?: { __typename?: 'Cities', name: string, id: any, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, venue?: { __typename?: 'Venues', id: any, title: string, venueSlug: string, slug: string, addressString: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, longitude: any, latitude: any, geometry?: any | null, outdoorCourtCount: number, indoorCourtCount: number, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null }> };

export type GetCoachBookingPageQueryVariables = Exact<{
  username: Scalars['String'];
  id: Scalars['uuid'];
  startDateTime: Scalars['timestamptz'];
}>;


export type GetCoachBookingPageQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, username?: string | null, defaultSport?: string | null, stripeMerchantChargesEnabled?: boolean | null, timezone?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, profileImageProvider?: string | null, profileImageProviderId?: string | null, profileImageUrl?: string | null, preferredName?: string | null, tiktokUrl?: string | null, xUrl?: string | null, websiteUrl?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, fullName?: string | null, coachStatus?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, aboutMe?: string | null, aboutMeVideoUrl?: string | null, cityName?: string | null, gender?: string | null, coachExternalBookingUrl?: string | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachingStartYear?: number | null, normalizedTennisRating?: any | null, tennisRating?: any | null, pciId?: string | null, pprId?: string | null, isPciMember?: boolean | null, isIptpaMember?: boolean | null, iptpaId?: string | null, isQuatroPickleballMember?: boolean | null, quatroPickleballMemberId?: string | null, coachLessonDescription?: string | null, coachLessonHowToPrepare?: string | null, priceUnitAmountCoachDefault?: number | null, priceUnitAmountRemoteCoachDefault?: number | null, stripeMerchantDetailsSubmitted?: boolean | null, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum }>, activeCity?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null, country?: { __typename?: 'Countries', id: string, iso2: string, iso3: string, name: string } | null, countrySubdivision?: { __typename?: 'CountrySubdivisions', code: string, id: any, name: string, type: string } | null, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, followers: Array<{ __typename?: 'UserFollows', followerUserId: any, followedUserId: any, followerProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, preferredName?: string | null } | null }>, coachServices: Array<{ __typename?: 'UserCoachServices', currency: string, description: string, id: any, title: string, priceUnitAmount: number, type?: LessonTypesEnum | null, coverImageFileName: string, coverImagePath: string, coverImageProviderUrl: string }>, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, endTimeMinutes: number, dayOfWeek: DayOfWeekEnum, startTimeMinutes: number, status: CoachAvailabilityStatusesEnum, coachAvailabilityCustomCourt?: { __typename?: 'UserCustomCourts', id: any } | null, coachAvailabilityVenueId?: { __typename?: 'Venues', id: any } | null }>, coachQualifications: Array<{ __typename?: 'UsersCoachQualifications', id: any, status: CoachQualificationStatusesEnum, qualification: { __typename?: 'CoachQualifications', id: any, name: string, order: number, groupId?: CoachQualificationGroupsEnum | null, displayKey: string } }>, normalizedTennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, name: string, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, name: string, shortName: string } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number, displayName: string } | null, coachLessonAgeGroups: Array<{ __typename?: 'CoachLessonAgeGroups', id: any, lessonAgeGroup: LessonAgeGroupsEnum }>, coachLessonSkillLevels: Array<{ __typename?: 'CoachLessonSkillLevels', id: any, skillLevel: string }>, defaultCoachVenue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, pickleballRatingScales: Array<{ __typename?: 'UserPickleballRatingScales', id: any, rating: any, pickleballRatingScaleId: any, scale: { __typename?: 'PickleballRatingScales', name: string, id: any, shortName: string } }>, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', id: any, fullAddress: string, title: string, latitude?: any | null, longitude?: any | null } | null, coachLessons: Array<{ __typename?: 'Lessons', id: any, ownerUserId?: any | null, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, participantLimit?: number | null, currency: string }>, userFiles: Array<{ __typename?: 'UserFiles', fileCategory: FileCategoryEnum, fileFormat: FileFormatEnum, fileName: string, fileType: string, host: string, path: string, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, url: string }> }>, coachStarterProfilesByPk?: { __typename?: 'CoachStarterProfiles', aboutMe?: string | null, aboutPhotoImageUrl?: string | null, age?: string | null, birthdate?: string | null, addressDisplay?: string | null, addressString?: string | null, addressType?: string | null, cityName?: string | null, company?: string | null, countryName?: string | null, geometry?: any | null, id: any, gender?: string | null, latitude?: any | null, longitude?: any | null, logoImageUrl?: string | null, name?: string | null, profileImageUrl?: string | null, stateName?: string | null, usapRating?: string | null } | null };

export type InsertCoachBookingRequestMutationVariables = Exact<{
  coachStarterProfileId?: InputMaybe<Scalars['uuid']>;
  coachUserId?: InputMaybe<Scalars['uuid']>;
  playerUserId: Scalars['uuid'];
}>;


export type InsertCoachBookingRequestMutation = { __typename?: 'mutation_root', insertCoachBookingRequestsOne?: { __typename?: 'CoachBookingRequests', id: any } | null };

export type GetActiveOwnerUpcomingLessonsByIdQueryVariables = Exact<{
  ownerUserId: Scalars['uuid'];
  limit: Scalars['Int'];
}>;


export type GetActiveOwnerUpcomingLessonsByIdQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> }> };

export type GetLessonRevenueByCoachIdQueryVariables = Exact<{
  coachId: Scalars['uuid'];
  dateFilter: Scalars['timestamptz'];
}>;


export type GetLessonRevenueByCoachIdQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, type: LessonTypesEnum, ownerProfile?: { __typename?: 'UserProfiles', cityName?: string | null, activeCity?: { __typename?: 'Cities', name: string, id: any } | null } | null, orders: Array<{ __typename?: 'LessonOrders', customerUserId: any, sellerUserId: any, createdAt: any, orderTotalUnitAmount: number, sellerProfile?: { __typename?: 'UserProfiles', id?: any | null, coachStatus?: string | null, activeCity?: { __typename?: 'Cities', name: string } | null } | null, customerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null } | null }> }> };

export type GetCoachCityRankQueryVariables = Exact<{
  cityId: Scalars['uuid'];
}>;


export type GetCoachCityRankQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', createdAt: any, ownerUserId?: any | null, ordersAggregate: { __typename?: 'LessonOrdersAggregate', aggregate?: { __typename?: 'LessonOrdersAggregateFields', count: number } | null } }> };

export type GetWeeklyLessonsBookedQueryVariables = Exact<{
  dateFrom: Scalars['timestamptz'];
}>;


export type GetWeeklyLessonsBookedQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, ordersAggregate: { __typename?: 'LessonOrdersAggregate', aggregate?: { __typename?: 'LessonOrdersAggregateFields', count: number } | null } }> };

export type GetCoachVideoAnalysisPendingQueryVariables = Exact<{
  reviewerId: Scalars['uuid'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetCoachVideoAnalysisPendingQuery = { __typename?: 'query_root', videoAnalysis: Array<{ __typename?: 'VideoAnalysis', id: any, submissionRequestedFeedback: string, createdAt: any, videoAnalysisRequestedSkillsReviews: Array<{ __typename?: 'VideoAnalysisRequestedSkillsReview', id: any, videoLessonSkills: { __typename?: 'VideoLessonSkills', customSkill?: string | null, id: any, skill?: LessonSkillsEnum | null } }>, videoAnalysisFiles: { __typename?: 'VideoAnalysisFiles', id: any, host: string, fileType: string, fileName: string, fileFormat: FileFormatEnum, fileCategory: FileCategoryEnum, createdAt: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, updatedAt: any, url: string }, videoAnalysisSubmission?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, videoAnalysisReviewer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null }>, videoAnalysisAggregate: { __typename?: 'VideoAnalysisAggregate', aggregate?: { __typename?: 'VideoAnalysisAggregateFields', count: number } | null } };

export type GetCoachVideoAnalysisReviewedQueryVariables = Exact<{
  reviewerId: Scalars['uuid'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetCoachVideoAnalysisReviewedQuery = { __typename?: 'query_root', videoAnalysis: Array<{ __typename?: 'VideoAnalysis', id: any, submissionRequestedFeedback: string, createdAt: any, videoAnalysisRequestedSkillsReviews: Array<{ __typename?: 'VideoAnalysisRequestedSkillsReview', id: any, videoLessonSkills: { __typename?: 'VideoLessonSkills', customSkill?: string | null, id: any, skill?: LessonSkillsEnum | null } }>, videoAnalysisFiles: { __typename?: 'VideoAnalysisFiles', id: any, host: string, fileType: string, fileName: string, fileFormat: FileFormatEnum, fileCategory: FileCategoryEnum, createdAt: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, updatedAt: any, url: string }, videoAnalysisSubmission?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null }>, videoAnalysisAggregate: { __typename?: 'VideoAnalysisAggregate', aggregate?: { __typename?: 'VideoAnalysisAggregateFields', count: number } | null } };

export type GetCoachUpcomingClinicLessonsByIdQueryVariables = Exact<{
  ownerUserId: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetCoachUpcomingClinicLessonsByIdQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> }>, lessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null } };

export type GetCoachVideoAnalysisBySubmitterIdQueryVariables = Exact<{
  reviewerId: Scalars['uuid'];
  submissionUserId: Scalars['uuid'];
}>;


export type GetCoachVideoAnalysisBySubmitterIdQuery = { __typename?: 'query_root', videoAnalysis: Array<{ __typename?: 'VideoAnalysis', id: any, submissionRequestedFeedback: string, reviewStatus?: VideoAnalysisReviewStatusesEnum | null, createdAt: any, videoAnalysisComments: Array<{ __typename?: 'VideoAnalysisComments', sentiment: FeedbackSentimentEnum, id: any, videoAnalysisSkillsComments: Array<{ __typename?: 'VideoAnalysisSkillsComments', videoLessonSkills: { __typename?: 'VideoLessonSkills', skill?: LessonSkillsEnum | null, customSkill?: string | null }, videoAnalysisComments?: { __typename?: 'VideoAnalysisComments', details: string, id: any, videoAnalysisFiles?: { __typename?: 'VideoAnalysisFiles', id: any, host: string, fileType: string, fileName: string, fileFormat: FileFormatEnum, fileCategory: FileCategoryEnum, createdAt: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, updatedAt: any, url: string } | null } | null }> }>, videoAnalysisRequestedSkillsReviews: Array<{ __typename?: 'VideoAnalysisRequestedSkillsReview', id: any, videoLessonSkills: { __typename?: 'VideoLessonSkills', customSkill?: string | null, id: any, skill?: LessonSkillsEnum | null } }>, videoAnalysisFiles: { __typename?: 'VideoAnalysisFiles', id: any, host: string, fileType: string, fileName: string, fileFormat: FileFormatEnum, fileCategory: FileCategoryEnum, createdAt: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, updatedAt: any, url: string }, videoAnalysisSubmission?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, videoAnalysisReviewer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null }>, videoAnalysisAggregate: { __typename?: 'VideoAnalysisAggregate', aggregate?: { __typename?: 'VideoAnalysisAggregateFields', count: number } | null }, pendingVideoAnalysisCount: { __typename?: 'VideoAnalysisAggregate', aggregate?: { __typename?: 'VideoAnalysisAggregateFields', count: number } | null } };

export type GetCoachReflectionsBySubmitterIdQueryVariables = Exact<{
  coachId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetCoachReflectionsBySubmitterIdQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, type: LessonTypesEnum, venue?: { __typename?: 'Venues', addressString: string } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', fullAddress: string } | null, times: Array<{ __typename?: 'LessonTimes', startDateTime: any, endDateTime: any }>, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, recapSkippedAt?: any | null, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null }>, lessonReflections: Array<{ __typename?: 'LessonReflections', createdAt: any, details?: string | null, upcomingCategory?: LessonSkillCategoriesEnum | null, upcomingSport?: SportsEnum | null, completedCategory?: LessonSkillCategoriesEnum | null, completedSport?: SportsEnum | null, assignmentCategory?: LessonSkillCategoriesEnum | null, assignmentSport?: SportsEnum | null, id: any, lessonId: any, submissionRequestedFeedback?: string | null, updatedAt: any, reviewStatus: VideoAnalysisReviewStatusesEnum, files: Array<{ __typename?: 'LessonReflectionFiles', createdAt: any, fileCategory: string, fileFormat: string, fileName: string, fileType: string, host: string, id: any, provider: string, providerId: string, providerUrl: string, url: string, userId: any, originalFileName: string }>, lessonPlayer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonCoach?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonReflectionComments: Array<{ __typename?: 'LessonReflectionComments', createdAt: any, id: any, order?: number | null, sentiment?: FeedbackSentimentEnum | null, skill?: LessonSkillsEnum | null, customSkill?: string | null, updatedAt: any, details?: string | null, type: LessonReflectionCommentTypesEnum, lessonReflectionFiles: Array<{ __typename?: 'LessonReflectionFiles', createdAt: any, fileCategory: string, fileFormat: string, fileName: string, fileType: string, host: string, id: any, provider: string, providerId: string, providerUrl: string, url: string, userId: any, originalFileName: string }> }> }> }>, lessonPlayerSkillAssessments: Array<{ __typename?: 'LessonPlayerSkillAssessments', playerUserId: any, coachUserId: any, lessonCoach?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonPlayer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonPlayerSkillAssessmentsSkills: Array<{ __typename?: 'LessonPlayerSkillAssessmentsSkills', category: LessonPlayerSkillAssessmentCategoriesEnum, createdAt: any, skill: LessonSkillsEnum }> }>, lessonReflections: Array<{ __typename?: 'LessonReflections', createdAt: any, details?: string | null, id: any, lessonId: any, submissionRequestedFeedback?: string | null, updatedAt: any, reviewStatus: VideoAnalysisReviewStatusesEnum, files: Array<{ __typename?: 'LessonReflectionFiles', createdAt: any, fileCategory: string, fileFormat: string, fileName: string, fileType: string, host: string, id: any, provider: string, providerId: string, providerUrl: string, url: string, userId: any, originalFileName: string }>, lessonPlayer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonCoach?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonReflectionComments: Array<{ __typename?: 'LessonReflectionComments', type: LessonReflectionCommentTypesEnum, createdAt: any, id: any, order?: number | null, sentiment?: FeedbackSentimentEnum | null, skill?: LessonSkillsEnum | null, customSkill?: string | null, updatedAt: any, lessonReflectionFiles: Array<{ __typename?: 'LessonReflectionFiles', createdAt: any, fileCategory: string, fileFormat: string, fileName: string, fileType: string, host: string, id: any, provider: string, providerId: string, providerUrl: string, transcript: string, transcriptEndedAt?: any | null, transcriptStartedAt?: any | null, url: string }> }> }> };

export type UpdateCoachLessonReflectionMutationVariables = Exact<{
  reflectionId: Scalars['uuid'];
  comments: Array<LessonReflectionCommentsInsertInput> | LessonReflectionCommentsInsertInput;
  files: Array<LessonReflectionFilesInsertInput> | LessonReflectionFilesInsertInput;
  details?: InputMaybe<Scalars['String']>;
  completedCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  completedSport?: InputMaybe<SportsEnum>;
  upcomingCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  upcomingSport?: InputMaybe<SportsEnum>;
  assignmentCategory?: InputMaybe<LessonSkillCategoriesEnum>;
  assignmentSport?: InputMaybe<SportsEnum>;
}>;


export type UpdateCoachLessonReflectionMutation = { __typename?: 'mutation_root', deleteLessonReflectionComments?: { __typename?: 'LessonReflectionCommentsMutationResponse', returning: Array<{ __typename?: 'LessonReflectionComments', id: any }> } | null, deleteLessonReflectionFiles?: { __typename?: 'LessonReflectionFilesMutationResponse', returning: Array<{ __typename?: 'LessonReflectionFiles', id: any }> } | null, updateLessonReflectionsByPk?: { __typename?: 'LessonReflections', id: any } | null, insertLessonReflectionFiles?: { __typename?: 'LessonReflectionFilesMutationResponse', affectedRows: number } | null, insertLessonReflectionComments?: { __typename?: 'LessonReflectionCommentsMutationResponse', affectedRows: number } | null };

export type UpdateOnboardingStep1MutationVariables = Exact<{
  userId: Scalars['uuid'];
  gender: GenderEnum;
  phoneNumber: Scalars['String'];
  phoneCountryCode: Scalars['String'];
  defaultSport: SportsEnum;
  profileImageProviderUrl: Scalars['String'];
  profileImageUrl: Scalars['String'];
  profileImageProviderId: Scalars['String'];
  profileImagePath: Scalars['String'];
  profileImageProvider: Scalars['String'];
  profileImageFileName: Scalars['String'];
  sports: Array<CoachSportsInsertInput> | CoachSportsInsertInput;
}>;


export type UpdateOnboardingStep1Mutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, gender?: GenderEnum | null, phoneNumber?: string | null, phoneCountryCode?: string | null, defaultSport?: SportsEnum | null, profileImageUrl: string, profileImageProviderUrl: string, profileImageProviderId: string, profileImagePath: string, profileImageProvider: string, profileImageFileName: string } | null, insertCoachSports?: { __typename?: 'CoachSportsMutationResponse', returning: Array<{ __typename?: 'CoachSports', id: any, sport: SportsEnum, status: CoachSportStatusesEnum, userId: any }> } | null };

export type GetCoachDashboardStatsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetCoachDashboardStatsQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null }, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null } }> };

export type GetCoachDashboardMetricsQueryVariables = Exact<{
  userId: Scalars['uuid'];
  currentMonthStart: Scalars['timestamptz'];
  previousMonthStart: Scalars['timestamptz'];
  previousMonthEnd: Scalars['timestamptz'];
}>;


export type GetCoachDashboardMetricsQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null }, previousMonthReviews: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null }, currentMonthReviews: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null } }>, currentMonthLessons: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, previousMonthLessons: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, currentMonthClientLessons: Array<{ __typename?: 'LessonParticipants', userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImagePath?: string | null } | null }>, previousMonthClientLessons: Array<{ __typename?: 'LessonParticipants', userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null }> };

export type InsertUploadReviewRequestsMutationVariables = Exact<{
  objects: Array<UploadReviewRequestsInsertInput> | UploadReviewRequestsInsertInput;
}>;


export type InsertUploadReviewRequestsMutation = { __typename?: 'mutation_root', insertUploadReviewRequests?: { __typename?: 'UploadReviewRequestsMutationResponse', returning: Array<{ __typename?: 'UploadReviewRequests', id: any, userId: any, url: string, createdAt: any }> } | null };

export type GetProfileCompletenessProgressQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetProfileCompletenessProgressQuery = { __typename?: 'query_root', userFollowsAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, profileImageProviderUrl?: string | null, aboutMe?: string | null, coachingStartYear?: number | null }>, reviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number } | null } };

export type UpdateUserDidSkipStripeSetupMutationVariables = Exact<{
  id: Scalars['uuid'];
  didSkipStripeSetup: Scalars['Boolean'];
}>;


export type UpdateUserDidSkipStripeSetupMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, didSkipStripeSetup: boolean } | null };

export type GetCoachAllPlayersReflectionsQueryVariables = Exact<{
  coachId: Scalars['uuid'];
}>;


export type GetCoachAllPlayersReflectionsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', endDateTime?: any | null, id: any, title: string, type: LessonTypesEnum, venue?: { __typename?: 'Venues', addressString: string } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', fullAddress: string } | null, times: Array<{ __typename?: 'LessonTimes', startDateTime: any, endDateTime: any }>, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, recapSkippedAt?: any | null, userProfile?: { __typename?: 'UserProfiles', id?: any | null, profileImageProvider?: string | null, profileImagePath?: string | null, profileImageFileName?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null } | null }>, lessonReflections: Array<{ __typename?: 'LessonReflections', createdAt: any, details?: string | null, id: any, lessonId: any, submissionRequestedFeedback?: string | null, updatedAt: any, reviewStatus: VideoAnalysisReviewStatusesEnum, upcomingCategory?: LessonSkillCategoriesEnum | null, upcomingSport?: SportsEnum | null, completedCategory?: LessonSkillCategoriesEnum | null, completedSport?: SportsEnum | null, files: Array<{ __typename?: 'LessonReflectionFiles', createdAt: any, fileCategory: string, fileFormat: string, fileName: string, fileType: string, host: string, id: any, provider: string, providerId: string, providerUrl: string, url: string, userId: any, originalFileName: string }>, lessonReflectionComments: Array<{ __typename?: 'LessonReflectionComments', createdAt: any, id: any, order?: number | null, sentiment?: FeedbackSentimentEnum | null, skill?: LessonSkillsEnum | null, customSkill?: string | null, updatedAt: any, details?: string | null, type: LessonReflectionCommentTypesEnum, lessonReflectionFiles: Array<{ __typename?: 'LessonReflectionFiles', createdAt: any, fileCategory: string, fileFormat: string, fileName: string, fileType: string, host: string, id: any, provider: string, providerId: string, providerUrl: string, url: string, userId: any, originalFileName: string }> }>, lessonPlayer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonCoach?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null }> }>, lessonReflections: Array<{ __typename?: 'LessonReflections', createdAt: any, details?: string | null, id: any, lessonId: any, submissionRequestedFeedback?: string | null, updatedAt: any, reviewStatus: VideoAnalysisReviewStatusesEnum, lessonPlayer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonCoach?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonReflectionComments: Array<{ __typename?: 'LessonReflectionComments', createdAt: any, id: any, order?: number | null, sentiment?: FeedbackSentimentEnum | null, skill?: LessonSkillsEnum | null, customSkill?: string | null, updatedAt: any, lessonReflectionFiles: Array<{ __typename?: 'LessonReflectionFiles', createdAt: any, fileCategory: string, fileFormat: string, fileName: string, fileType: string, host: string, id: any, provider: string, providerId: string, providerUrl: string, url: string, userId: any, originalFileName: string }> }> }> };

export type GetCoachAllPlayersVideoAnalysisQueryVariables = Exact<{
  reviewerId: Scalars['uuid'];
}>;


export type GetCoachAllPlayersVideoAnalysisQuery = { __typename?: 'query_root', videoAnalysis: Array<{ __typename?: 'VideoAnalysis', id: any, submissionRequestedFeedback: string, reviewStatus?: VideoAnalysisReviewStatusesEnum | null, createdAt: any, videoAnalysisComments: Array<{ __typename?: 'VideoAnalysisComments', sentiment: FeedbackSentimentEnum, id: any, videoAnalysisSkillsComments: Array<{ __typename?: 'VideoAnalysisSkillsComments', videoLessonSkills: { __typename?: 'VideoLessonSkills', skill?: LessonSkillsEnum | null, customSkill?: string | null }, videoAnalysisComments?: { __typename?: 'VideoAnalysisComments', details: string, id: any } | null }> }>, videoAnalysisFiles: { __typename?: 'VideoAnalysisFiles', id: any, host: string, fileType: string, fileName: string, fileFormat: FileFormatEnum, fileCategory: FileCategoryEnum, createdAt: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, updatedAt: any, url: string }, videoAnalysisRequestedSkillsReviews: Array<{ __typename?: 'VideoAnalysisRequestedSkillsReview', id: any, videoLessonSkills: { __typename?: 'VideoLessonSkills', customSkill?: string | null, id: any, skill?: LessonSkillsEnum | null } }>, videoAnalysisSubmission?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, videoAnalysisReviewer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null }>, videoAnalysisAggregate: { __typename?: 'VideoAnalysisAggregate', aggregate?: { __typename?: 'VideoAnalysisAggregateFields', count: number } | null }, pendingVideoAnalysisCount: { __typename?: 'VideoAnalysisAggregate', aggregate?: { __typename?: 'VideoAnalysisAggregateFields', count: number } | null } };

export type SkipReflectionMutationVariables = Exact<{
  userId: Scalars['uuid'];
  lessonId: Scalars['uuid'];
}>;


export type SkipReflectionMutation = { __typename?: 'mutation_root', updateLessonParticipants?: { __typename?: 'LessonParticipantsMutationResponse', returning: Array<{ __typename?: 'LessonParticipants', id: any }> } | null };

export type GetCoachPremiumContentQueryVariables = Exact<{
  coachId: Scalars['uuid'];
}>;


export type GetCoachPremiumContentQuery = { __typename?: 'query_root', userContentFiles: Array<{ __typename?: 'UserContentFiles', createdAt: any, description: string, fileCategory: FileCategoryEnum, fileFormat: FileFormatEnum, fileName: string, fileType: string, host: string, id: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, tier: UserContentTiersEnum, title: string, url: string, user?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, fullName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null, userContentFilesSkills: Array<{ __typename?: 'UserContentFilesSkills', userContentSkills: { __typename?: 'UserContentSkills', skill?: LessonSkillsEnum | null, customSkill?: string | null, id: any, userId: any } }> }>, userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, priceUnitAmountPremiumContentDefault?: number | null, premiumContentDescription?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null }>, userContentBetaSubscriptions: Array<{ __typename?: 'UserContentBetaSubscriptions', id: any, subscriberUserId: any, createdAt: any }> };

export type UpdateCoachPremiumCoachMutationVariables = Exact<{
  coachId: Scalars['uuid'];
  premiumContentDescription?: InputMaybe<Scalars['String']>;
  priceUnitAmountPremiumContentDefault?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateCoachPremiumCoachMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', priceUnitAmountPremiumContentDefault?: number | null, premiumContentDescription?: string | null, id: any } | null };

export type GetCoachPremiumContentForPlayerQueryVariables = Exact<{
  coachId: Scalars['uuid'];
  tier: Array<UserContentTiersEnum> | UserContentTiersEnum;
  playerId: Scalars['uuid'];
}>;


export type GetCoachPremiumContentForPlayerQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, priceUnitAmountPremiumContentDefault?: number | null, premiumContentDescription?: string | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null }>, userContentFiles: Array<{ __typename?: 'UserContentFiles', createdAt: any, description: string, fileCategory: FileCategoryEnum, fileFormat: FileFormatEnum, fileName: string, fileType: string, host: string, id: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, tier: UserContentTiersEnum, title: string, url: string, user?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, fullName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null, userContentFilesSkills: Array<{ __typename?: 'UserContentFilesSkills', userContentSkills: { __typename?: 'UserContentSkills', skill?: LessonSkillsEnum | null, customSkill?: string | null, id: any, userId: any } }> }>, userContentBetaSubscriptions: Array<{ __typename?: 'UserContentBetaSubscriptions', id: any, createdAt: any }>, mySubscriptions: Array<{ __typename?: 'UserContentBetaSubscriptions', id: any, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImagePath?: string | null, profileImageFileName?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null } | null }> };

export type GetUserContentByIdQueryVariables = Exact<{
  contentId: Scalars['uuid'];
}>;


export type GetUserContentByIdQuery = { __typename?: 'query_root', userContentFiles: Array<{ __typename?: 'UserContentFiles', createdAt: any, description: string, fileCategory: FileCategoryEnum, fileFormat: FileFormatEnum, fileName: string, fileType: string, host: string, id: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, tier: UserContentTiersEnum, title: string, url: string, user?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, fullName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null, userContentFilesSkills: Array<{ __typename?: 'UserContentFilesSkills', userContentSkills: { __typename?: 'UserContentSkills', skill?: LessonSkillsEnum | null, customSkill?: string | null, id: any, userId: any } }> }> };

export type GetCoachPremiumContentForAnonymousUserQueryVariables = Exact<{
  coachId: Scalars['uuid'];
}>;


export type GetCoachPremiumContentForAnonymousUserQuery = { __typename?: 'query_root', userContentFiles: Array<{ __typename?: 'UserContentFiles', createdAt: any, description: string, fileCategory: FileCategoryEnum, fileFormat: FileFormatEnum, fileName: string, fileType: string, host: string, id: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, tier: UserContentTiersEnum, title: string, url: string, user?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, fullName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null, userContentFilesSkills: Array<{ __typename?: 'UserContentFilesSkills', userContentSkills: { __typename?: 'UserContentSkills', skill?: LessonSkillsEnum | null, customSkill?: string | null, id: any, userId: any } }> }>, userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, priceUnitAmountPremiumContentDefault?: number | null, premiumContentDescription?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null }> };

export type GetPlayerSubscribersQueryVariables = Exact<{
  playerId: Scalars['uuid'];
}>;


export type GetPlayerSubscribersQuery = { __typename?: 'query_root', mySubscriptions: Array<{ __typename?: 'UserContentBetaSubscriptions', id: any, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImagePath?: string | null, profileImageFileName?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null } | null }> };

export type UpdateCoachPremiumContentMutationVariables = Exact<{
  id: Scalars['uuid'];
  skills: Array<UserContentFilesSkillsInsertInput> | UserContentFilesSkillsInsertInput;
  description: Scalars['String'];
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  host: Scalars['String'];
  fileFormat: FileFormatEnum;
  originalFileName: Scalars['String'];
  provider: Scalars['String'];
  providerUrl: Scalars['String'];
  providerId: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
  tier: UserContentTiersEnum;
}>;


export type UpdateCoachPremiumContentMutation = { __typename?: 'mutation_root', deleteUserContentFilesSkills?: { __typename?: 'UserContentFilesSkillsMutationResponse', returning: Array<{ __typename?: 'UserContentFilesSkills', id: any }> } | null, insertUserContentFilesSkills?: { __typename?: 'UserContentFilesSkillsMutationResponse', returning: Array<{ __typename?: 'UserContentFilesSkills', id: any }> } | null, updateUserContentFilesByPk?: { __typename?: 'UserContentFiles', id: any } | null };

export type GetCoachesByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetCoachesByGeoQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, priceUnitAmountRemoteCoachDefault?: number | null, priceUnitAmountCoachDefault?: number | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, username?: string | null, defaultSport?: string | null, geometry?: any | null, isPprMember?: boolean | null, isPciMember?: boolean | null, isProfessionalRacquetRegistryActive?: boolean | null, gender?: string | null, stripeMerchantChargesEnabled?: boolean | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null }, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum }>, coachLessonSkillLevels: Array<{ __typename?: 'CoachLessonSkillLevels', skillLevel: string }>, coachLessonAgeGroups: Array<{ __typename?: 'CoachLessonAgeGroups', lessonAgeGroup: LessonAgeGroupsEnum }>, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, status: CoachAvailabilityStatusesEnum }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }>, coachStarterProfiles: Array<{ __typename?: 'CoachStarterProfiles', id: any, name?: string | null, profileImageUrl?: string | null, aboutPhotoImageUrl?: string | null, logoImageUrl?: string | null, geometry?: any | null }> };

export type GetFollowedCoachesQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetFollowedCoachesQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, priceUnitAmountCoachDefault?: number | null, priceUnitAmountRemoteCoachDefault?: number | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, username?: string | null, geometry?: any | null, defaultSport?: string | null, isPciMember?: boolean | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, stripeMerchantChargesEnabled?: boolean | null, coachExternalBookingUrl?: string | null, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, endTimeMinutes: number, dayOfWeek: DayOfWeekEnum, startTimeMinutes: number, status: CoachAvailabilityStatusesEnum, coachAvailabilityCustomCourt?: { __typename?: 'UserCustomCourts', id: any } | null, coachAvailabilityVenueId?: { __typename?: 'Venues', id: any } | null }>, coachLessons: Array<{ __typename?: 'Lessons', id: any, ownerUserId?: any | null, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, participantLimit?: number | null, currency: string }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }> };

export type GetRemoteCoachesByGeoQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetRemoteCoachesByGeoQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, priceUnitAmountRemoteCoachDefault?: number | null, priceUnitAmountCoachDefault?: number | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, username?: string | null, defaultSport?: string | null, geometry?: any | null, isPciMember?: boolean | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }> };

export type GetGroupThreadByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetGroupThreadByIdQuery = { __typename?: 'query_root', groupThreadsByPk?: { __typename?: 'GroupThreads', group: { __typename?: 'Groups', id: any, title: string, isPrivate: boolean }, comments: Array<{ __typename?: 'GroupThreadComments', content: string, createdAt: any, groupCommentId?: any | null, groupRootCommentId?: any | null, id: any, isOriginalThreadComment: boolean, updatedAt: any, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, username?: string | null } | null, votesAggregate: { __typename?: 'GroupCommentVotesAggregate', aggregate?: { __typename?: 'GroupCommentVotesAggregateFields', count: number } | null }, votes: Array<{ __typename?: 'GroupCommentVotes', id: any, userId: any, groupThreadCommentId: any, vote: CommentVoteEnum }>, files: Array<{ __typename?: 'GroupThreadCommentFiles', id: any, url: string, path: string }> }> } | null };

export type InsertGroupThreadCommentMutationVariables = Exact<{
  userId: Scalars['uuid'];
  groupThreadId: Scalars['uuid'];
  content: Scalars['String'];
  groupCommentId?: InputMaybe<Scalars['uuid']>;
  groupRootCommentId?: InputMaybe<Scalars['uuid']>;
}>;


export type InsertGroupThreadCommentMutation = { __typename?: 'mutation_root', insertGroupThreadCommentsOne?: { __typename?: 'GroupThreadComments', id: any, groupThreadId: any, content: string } | null };

export type GetGroupThreadByIdAnonymousQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetGroupThreadByIdAnonymousQuery = { __typename?: 'query_root', groupThreadsByPk?: { __typename?: 'GroupThreads', id: any, group: { __typename?: 'Groups', id: any, title: string, isPrivate: boolean }, comments: Array<{ __typename?: 'GroupThreadComments', content: string, createdAt: any, groupCommentId?: any | null, groupRootCommentId?: any | null, id: any, isOriginalThreadComment: boolean, updatedAt: any, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, username?: string | null } | null, votesAggregate: { __typename?: 'GroupCommentVotesAggregate', aggregate?: { __typename?: 'GroupCommentVotesAggregateFields', count: number } | null }, files: Array<{ __typename?: 'GroupThreadCommentFiles', id: any, url: string, path: string }> }> } | null };

export type GetVenuesByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetVenuesByGeoQuery = { __typename?: 'query_root', venues: Array<{ __typename?: 'Venues', id: any, title: string, geometry?: any | null, slug: string, pickleballLines?: VenueLinesEnum | null, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, hasPickleball: boolean, hasTennis: boolean, hasPadel: boolean, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, path: string, provider: string, url: string }>, city?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string } } | null, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> }> };

export type GetCourtPageUpcomingLessonsQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetCourtPageUpcomingLessonsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, startDateTime?: any | null, endDateTime?: any | null, sport: SportsEnum, type: LessonTypesEnum, coverImageProviderUrl: string, priceUnitAmount: number, currency: string, participantLimit?: number | null, participants: Array<{ __typename?: 'LessonParticipants', id: any, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, profileImagePath?: string | null } | null }>, ownerProfile?: { __typename?: 'UserProfiles', fullName?: string | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string }> } | null }> };

export type GetCourtPageUpcomingEventsQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  now: Scalars['timestamptz'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetCourtPageUpcomingEventsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, title: string, slug: string, startDateTime: any, endDateTime: any, sport: SportsEnum, type: EventTypesEnum, isRfx: boolean, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, sourceOrganizerTitle?: string | null, participantLimit?: number | null, externalUrl?: string | null, groups: Array<{ __typename?: 'EventGroups', id: any, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null } | null }>, venue?: { __typename?: 'Venues', id: any, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string }> } | null }> };

export type CourtPageCoachCardFieldsFragment = { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, defaultSport?: string | null, isPciMember?: boolean | null, isProfessionalRacquetRegistryActive?: boolean | null, priceUnitAmountCoachDefault?: number | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null }, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum }> };

export type GetCourtPageV2StaffCoachesQueryVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type GetCourtPageV2StaffCoachesQuery = { __typename?: 'query_root', venueStaffCoaches: Array<{ __typename?: 'VenueStaffCoaches', id: any, userId: any, coachProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, defaultSport?: string | null, isPciMember?: boolean | null, isProfessionalRacquetRegistryActive?: boolean | null, priceUnitAmountCoachDefault?: number | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null }, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum }> } | null }> };

export type GetCourtPageV2AvailabilityCoachesQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  excludeUserIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetCourtPageV2AvailabilityCoachesQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, defaultSport?: string | null, isPciMember?: boolean | null, isProfessionalRacquetRegistryActive?: boolean | null, priceUnitAmountCoachDefault?: number | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null }, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum }> }> };

export type GetCourtPageV2CoachReviewsQueryVariables = Exact<{
  coachUserIds: Array<Scalars['uuid']> | Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetCourtPageV2CoachReviewsQuery = { __typename?: 'query_root', reviews: Array<{ __typename?: 'Reviews', createdAt: any, externalDomain?: string | null, externalImageFileName?: string | null, externalImageUrl?: string | null, externalSource?: CoachExternalReviewSourcesEnum | null, externalUrl?: string | null, externalFullName?: string | null, id: any, rating: number, review?: string | null, type?: CoachReviewTypesEnum | null, coach?: { __typename?: 'UserProfiles', profileImagePath?: string | null, profileImageFileName?: string | null, profileImageProviderUrl?: string | null, profileImageProvider?: string | null, id?: any | null, username?: string | null, fullName?: string | null } | null, reviewer?: { __typename?: 'UserProfiles', profileImagePath?: string | null, profileImageFileName?: string | null, profileImageProviderUrl?: string | null, profileImageProvider?: string | null, id?: any | null, username?: string | null, fullName?: string | null } | null }> };

export type UpsertVenueFollowMutationVariables = Exact<{
  userId: Scalars['uuid'];
  venueId: Scalars['uuid'];
  status: FollowStatusesEnum;
}>;


export type UpsertVenueFollowMutation = { __typename?: 'mutation_root', insertVenueFollowsOne?: { __typename?: 'VenueFollows', status: FollowStatusesEnum, id: any, userId: any, venueId: any } | null };

export type GetUserVenueFollowQueryVariables = Exact<{
  userId: Scalars['uuid'];
  venueId: Scalars['uuid'];
}>;


export type GetUserVenueFollowQuery = { __typename?: 'query_root', venueFollows: Array<{ __typename?: 'VenueFollows', id: any, userId: any, venueId: any, status: FollowStatusesEnum }> };

export type GetGamedayByEventIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetGamedayByEventIdQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', id: any, title: string, hostUserId?: any | null, isShowCourtAssignments: boolean, isVairRequired?: boolean | null, groups: Array<{ __typename?: 'EventGroups', id: any, title: string, winBy?: number | null, totalPoints?: number | null, teamLimit?: number | null, teamType?: TeamTypesEnum | null, startsAt?: any | null, endsAt?: any | null, scoringFormat?: ScoringFormatEnum | null, gamesPerMatch: number, format?: EventGroupFormatsEnum | null, minimumNumberOfGames: number, numberOfEliminationTeams?: number | null, numberOfEstimatedCourts?: number | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }>, registrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, userId: any, createdAt: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null } | null }>, teams: Array<{ __typename?: 'EventTeams', id: any, matches: Array<{ __typename?: 'EventMatchesTeams', id: any, match: { __typename?: 'EventMatches', id: any, roundId: any } }>, members: Array<{ __typename?: 'EventTeamMembers', id: any, userId: any, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, id?: any | null, preferredName?: string | null } | null }> }>, sequences: Array<{ __typename?: 'EventGroupSequences', id: any, nextSequenceId?: any | null, order: number, groupId: any, competitionFormat: CompetitionFormatsEnum, completeReason: EventSequenceCompleteReasonsEnum, isSequenceComplete: boolean, pools: Array<{ __typename?: 'EventGroupPools', id: any, title: string, startsAt?: any | null, endsAt?: any | null, rounds: Array<{ __typename?: 'EventPoolRounds', id: any, roundOrder: number, title: string, matches: Array<{ __typename?: 'EventMatches', courtNumber?: number | null, eventCourtId?: any | null, id: any, matchOrder: number, isBye: boolean, isVairScoreSubmitted?: boolean | null, winningTeamId?: any | null, losingTeamId?: any | null, team1Id?: any | null, team2Id?: any | null, previousMatch1Id?: any | null, previousMatch2Id?: any | null, selectionCriteriaPreviousMatch1?: MatchSelectionCriteriaEnum | null, selectionCriteriaPreviousMatch2?: MatchSelectionCriteriaEnum | null, winReason?: WinReasonsEnum | null, court?: { __typename?: 'EventCourts', courtName?: string | null } | null, team1?: { __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', id: any, userId: any, status: EventTeamMemberStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null } | null }> } | null, team2?: { __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', id: any, userId: any, status: EventTeamMemberStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null } | null }> } | null, games: Array<{ __typename?: 'EventMatchGames', id: any, losingTeamId: any, team1Id: any, team1Score: any, team2Id: any, team2Score: any, winReason: WinReasonsEnum, winningTeamId: any, scores: Array<{ __typename?: 'EventGameScores', id: any, score: number, teamId: any }> }> }> }> }>, seeding: Array<{ __typename?: 'EventGroupSequenceSeeding', id: any, eventTeamId: any, seed: number }> }>, courts: Array<{ __typename?: 'EventCourts', id: any, updatedAt: any, courtNumber: number, courtName?: string | null, courtStatus: EventCourtStatusesEnum, activeMatchId?: any | null, activeMatch?: { __typename?: 'EventMatches', id: any, teams: Array<{ __typename?: 'EventMatchesTeams', id: any, team: { __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null } | null }> } }> } | null }> }>, courts: Array<{ __typename?: 'EventCourts', id: any, updatedAt: any, activeMatchId?: any | null, courtStatus: EventCourtStatusesEnum, courtNumber: number, courtName?: string | null, activeEventGroupId?: any | null, activeEventGroupPoolId?: any | null }>, titleSponsor: Array<{ __typename?: 'EventSponsors', id: any, categoryName: string, imageFileName: string, imageFileType: string, imageHost: string, imagePath: string, imageProvider: string, imageProviderUrl: string, imageUrl: string, isTitleSponsor: boolean, name: string }> } | null };

export type AssignCourtToMatchMutationVariables = Exact<{
  matchId: Scalars['uuid'];
  courtId: Scalars['uuid'];
  courtNumber: Scalars['Int'];
}>;


export type AssignCourtToMatchMutation = { __typename?: 'mutation_root', updateEventMatchesByPk?: { __typename?: 'EventMatches', id: any, eventCourtId?: any | null, courtNumber?: number | null } | null, updateEventCourtsByPk?: { __typename?: 'EventCourts', id: any, updatedAt: any, courtNumber: number, courtStatus: EventCourtStatusesEnum, activeMatchId?: any | null, activeMatch?: { __typename?: 'EventMatches', id: any, team1?: { __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', id: any, status: EventTeamMemberStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null } | null }> } | null, team2?: { __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', id: any, status: EventTeamMemberStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null } | null }> } | null, teams: Array<{ __typename?: 'EventMatchesTeams', id: any, team: { __typename?: 'EventTeams', members: Array<{ __typename?: 'EventTeamMembers', userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null } | null }> } }> } | null } | null };

export type AssignCourtToMatchOnlyMutationVariables = Exact<{
  matchId: Scalars['uuid'];
  courtId: Scalars['uuid'];
  courtNumber: Scalars['Int'];
}>;


export type AssignCourtToMatchOnlyMutation = { __typename?: 'mutation_root', updateEventMatchesByPk?: { __typename?: 'EventMatches', id: any, eventCourtId?: any | null, courtNumber?: number | null } | null };

export type SetMatchScoresFreeCourtMutationVariables = Exact<{
  losingTeamId: Scalars['uuid'];
  matchId: Scalars['uuid'];
  team1Id: Scalars['uuid'];
  team1Score: Scalars['numeric'];
  team2Id: Scalars['uuid'];
  team2Score: Scalars['numeric'];
  winReason: WinReasonsEnum;
  winningTeamId: Scalars['uuid'];
  data?: InputMaybe<Array<EventGameScoresInsertInput> | EventGameScoresInsertInput>;
  courtId: Scalars['uuid'];
}>;


export type SetMatchScoresFreeCourtMutation = { __typename?: 'mutation_root', insertEventMatchGamesOne?: { __typename?: 'EventMatchGames', id: any, matchId: any, team1Score: any, team2Score: any, team1Id: any, team2Id: any, winReason: WinReasonsEnum, winningTeamId: any, losingTeamId: any } | null, updateEventMatchesByPk?: { __typename?: 'EventMatches', id: any, losingTeamId?: any | null, winReason?: WinReasonsEnum | null, winningTeamId?: any | null, courtNumber?: number | null } | null, updateEventCourtsByPk?: { __typename?: 'EventCourts', id: any, activeMatchId?: any | null } | null };

export type SetMatchScoresUpdateNextMatchCourtMutationVariables = Exact<{
  losingTeamId: Scalars['uuid'];
  matchId: Scalars['uuid'];
  team1Id: Scalars['uuid'];
  team1Score: Scalars['numeric'];
  team2Id: Scalars['uuid'];
  team2Score: Scalars['numeric'];
  winReason: WinReasonsEnum;
  winningTeamId: Scalars['uuid'];
  data?: InputMaybe<Array<EventGameScoresInsertInput> | EventGameScoresInsertInput>;
  courtId: Scalars['uuid'];
  courtNumber: Scalars['Int'];
  nextMatchId: Scalars['uuid'];
}>;


export type SetMatchScoresUpdateNextMatchCourtMutation = { __typename?: 'mutation_root', insertEventMatchGamesOne?: { __typename?: 'EventMatchGames', id: any, matchId: any, team1Score: any, team2Score: any, winReason: WinReasonsEnum, winningTeamId: any, losingTeamId: any } | null, updatePreviousMatch?: { __typename?: 'EventMatches', id: any, losingTeamId?: any | null, winReason?: WinReasonsEnum | null, winningTeamId?: any | null, courtNumber?: number | null, eventCourtId?: any | null } | null, updateNextMatch?: { __typename?: 'EventMatches', id: any, losingTeamId?: any | null, winReason?: WinReasonsEnum | null, winningTeamId?: any | null, courtNumber?: number | null, eventCourtId?: any | null } | null, updateEventCourtsByPk?: { __typename?: 'EventCourts', id: any, activeMatchId?: any | null } | null };

export type SetMatchScoresMutationVariables = Exact<{
  losingTeamId: Scalars['uuid'];
  matchId: Scalars['uuid'];
  team1Id: Scalars['uuid'];
  team1Score: Scalars['numeric'];
  team2Id: Scalars['uuid'];
  team2Score: Scalars['numeric'];
  winReason: WinReasonsEnum;
  winningTeamId: Scalars['uuid'];
  data?: InputMaybe<Array<EventGameScoresInsertInput> | EventGameScoresInsertInput>;
}>;


export type SetMatchScoresMutation = { __typename?: 'mutation_root', insertEventMatchGamesOne?: { __typename?: 'EventMatchGames', id: any, matchId: any, team1Score: any, team2Score: any, winReason: WinReasonsEnum, winningTeamId: any, losingTeamId: any } | null, updatePreviousMatch?: { __typename?: 'EventMatches', id: any, losingTeamId?: any | null, winReason?: WinReasonsEnum | null, winningTeamId?: any | null, courtNumber?: number | null, eventCourtId?: any | null } | null };

export type UpdateGameScoreMutationVariables = Exact<{
  gameId: Scalars['uuid'];
  team1Score: Scalars['numeric'];
  team2Score: Scalars['numeric'];
  losingTeamId: Scalars['uuid'];
  winningTeamId: Scalars['uuid'];
  matchId: Scalars['uuid'];
  matchWinningTeamId: Scalars['uuid'];
  matchLosingTeamId: Scalars['uuid'];
  updates?: InputMaybe<Array<EventGameScoresUpdates> | EventGameScoresUpdates>;
}>;


export type UpdateGameScoreMutation = { __typename?: 'mutation_root', updateEventMatchGamesByPk?: { __typename?: 'EventMatchGames', id: any, team2Id: any, team2Score: any, team1Id: any, team1Score: any, losingTeamId: any } | null, updateEventMatchesByPk?: { __typename?: 'EventMatches', id: any, losingTeamId?: any | null, winningTeamId?: any | null } | null, updateEventGameScoresMany?: Array<{ __typename?: 'EventGameScoresMutationResponse', returning: Array<{ __typename?: 'EventGameScores', id: any, score: number }> } | null> | null };

export type UpdateSingleEliminationMatchProgressionMutationVariables = Exact<{
  updates?: InputMaybe<Array<EventMatchesUpdates> | EventMatchesUpdates>;
}>;


export type UpdateSingleEliminationMatchProgressionMutation = { __typename?: 'mutation_root', updateEventMatchesMany?: Array<{ __typename?: 'EventMatchesMutationResponse', returning: Array<{ __typename?: 'EventMatches', team1Id?: any | null, team2Id?: any | null }> } | null> | null };

export type UpdatedUnassignCourtMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type UpdatedUnassignCourtMutation = { __typename?: 'mutation_root', updateEventCourtsByPk?: { __typename?: 'EventCourts', id: any, courtNumber: number, courtStatus: EventCourtStatusesEnum, activeMatchId?: any | null, activeEventGroupId?: any | null, activeEventGroupPoolId?: any | null } | null };

export type UpdateCourtsStartGroupMutationVariables = Exact<{
  courtUpdates?: InputMaybe<Array<EventCourtsUpdates> | EventCourtsUpdates>;
  matchUpdates?: InputMaybe<Array<EventMatchesUpdates> | EventMatchesUpdates>;
}>;


export type UpdateCourtsStartGroupMutation = { __typename?: 'mutation_root', updateEventCourtsMany?: Array<{ __typename?: 'EventCourtsMutationResponse', returning: Array<{ __typename?: 'EventCourts', id: any, updatedAt: any, courtNumber: number, courtStatus: EventCourtStatusesEnum, activeMatchId?: any | null, activeMatch?: { __typename?: 'EventMatches', id: any, teams: Array<{ __typename?: 'EventMatchesTeams', id: any, team: { __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null } | null }> } }> } | null }> } | null> | null, updateEventMatchesMany?: Array<{ __typename?: 'EventMatchesMutationResponse', returning: Array<{ __typename?: 'EventMatches', id: any, isBye: boolean, matchOrder: number, courtNumber?: number | null, eventCourtId?: any | null }> } | null> | null };

export type UpdateRemoveCourtFromMatchMutationVariables = Exact<{
  matchId: Scalars['uuid'];
  courtId: Scalars['uuid'];
}>;


export type UpdateRemoveCourtFromMatchMutation = { __typename?: 'mutation_root', updateEventMatchesByPk?: { __typename?: 'EventMatches', id: any, eventCourtId?: any | null, courtNumber?: number | null } | null, updateEventCourtsByPk?: { __typename?: 'EventCourts', activeMatchId?: any | null, id: any } | null };

export type UpdateReleaseCourtsFromGroupMutationVariables = Exact<{
  activeEventGroupId: Scalars['uuid'];
}>;


export type UpdateReleaseCourtsFromGroupMutation = { __typename?: 'mutation_root', updateEventCourts?: { __typename?: 'EventCourtsMutationResponse', returning: Array<{ __typename?: 'EventCourts', id: any, activeEventGroupId?: any | null, activeEventGroupPoolId?: any | null, activeMatchId?: any | null }> } | null };

export type UpdateCompleteSequenceMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type UpdateCompleteSequenceMutation = { __typename?: 'mutation_root', updateEventGroupSequencesByPk?: { __typename?: 'EventGroupSequences', id: any, isSequenceComplete: boolean, completeReason: EventSequenceCompleteReasonsEnum } | null };

export type GetClinicsActivitiesByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
  sport: SportsEnum;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetClinicsActivitiesByGeoQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, type: LessonTypesEnum, sport: SportsEnum, startDateTime?: any | null, timezoneName: string, timezoneAbbreviation: string, priceUnitAmount: number, currency: string, coverImageProviderUrl: string, userCustomCourt?: { __typename?: 'UserCustomCourts', id: any, title: string } | null, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, images: Array<{ __typename?: 'VenueImages', url: string, path: string }> } | null, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null } | null }> };

export type GetLeaguesActivitiesByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
  sport: SportsEnum;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetLeaguesActivitiesByGeoQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, type: EventTypesEnum, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, registrationPriceUnitAmount: number, currency: string, coverImageProviderUrl?: string | null, displayLocation: string, sourceOrganizerTitle?: string | null, groups: Array<{ __typename?: 'EventGroups', id: any, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, images: Array<{ __typename?: 'VenueImages', url: string, path: string }> } | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null } | null }> };

export type GetOpenPlaysActivitiesByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
  sport: SportsEnum;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetOpenPlaysActivitiesByGeoQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, type: EventTypesEnum, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, registrationPriceUnitAmount: number, currency: string, coverImageProviderUrl?: string | null, displayLocation: string, sourceOrganizerTitle?: string | null, groups: Array<{ __typename?: 'EventGroups', id: any, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, images: Array<{ __typename?: 'VenueImages', url: string, path: string }> } | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null } | null }> };

export type GetSocialsActivitiesByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
  sport: SportsEnum;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetSocialsActivitiesByGeoQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, type: EventTypesEnum, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, registrationPriceUnitAmount: number, currency: string, coverImageProviderUrl?: string | null, displayLocation: string, sourceOrganizerTitle?: string | null, groups: Array<{ __typename?: 'EventGroups', id: any, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, images: Array<{ __typename?: 'VenueImages', url: string, path: string }> } | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null } | null }> };

export type GetTournamentsActivitiesByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
  sport: SportsEnum;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTournamentsActivitiesByGeoQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, type: EventTypesEnum, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, registrationPriceUnitAmount: number, currency: string, coverImageProviderUrl?: string | null, displayLocation: string, sourceOrganizerTitle?: string | null, groups: Array<{ __typename?: 'EventGroups', id: any, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, images: Array<{ __typename?: 'VenueImages', url: string, path: string }> } | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null } | null }> };

export type GetTrendingActivitiesLessonsByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
  sport: SportsEnum;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTrendingActivitiesLessonsByGeoQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, type: LessonTypesEnum, sport: SportsEnum, startDateTime?: any | null, timezoneName: string, timezoneAbbreviation: string, priceUnitAmount: number, currency: string, coverImageProviderUrl: string, userCustomCourt?: { __typename?: 'UserCustomCourts', id: any, title: string } | null, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, images: Array<{ __typename?: 'VenueImages', url: string, path: string }> } | null, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null } | null }> };

export type GetTrendingActivitiesEventsByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
  sport: SportsEnum;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTrendingActivitiesEventsByGeoQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, type: EventTypesEnum, isRfx: boolean, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, registrationPriceUnitAmount: number, currency: string, coverImageProviderUrl?: string | null, displayLocation: string, groups: Array<{ __typename?: 'EventGroups', id: any, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, images: Array<{ __typename?: 'VenueImages', url: string, path: string }> } | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null } | null }> };

export type ClinicLessonFieldsFragment = { __typename?: 'Lessons', title: string, id: any, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, timezoneAbbreviation: string, description: string, sport: SportsEnum, type: LessonTypesEnum, intendedAgeGroup?: EventAgeGroupsEnum | null, externalBookingUrl: string, externalSource?: string | null, coverImageProviderUrl: string, priceUnitAmount: number, currency: string, participantLimit?: number | null, skillLevels: Array<{ __typename?: 'LessonSkillLevels', id: any, skillLevel: string }>, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageUrl?: string | null, username?: string | null, isProfessionalRacquetRegistryActive?: boolean | null, priceUnitAmountCoachDefault?: number | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null } } | null, participants: Array<{ __typename?: 'LessonParticipants', id: any, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, profileImagePath?: string | null } | null }>, userCustomCourt?: { __typename?: 'UserCustomCourts', fullAddress: string } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, title: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null };

export type GetClinicsByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  limit?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type GetClinicsByGeoQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', title: string, id: any, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, timezoneAbbreviation: string, description: string, sport: SportsEnum, type: LessonTypesEnum, intendedAgeGroup?: EventAgeGroupsEnum | null, externalBookingUrl: string, externalSource?: string | null, coverImageProviderUrl: string, priceUnitAmount: number, currency: string, participantLimit?: number | null, skillLevels: Array<{ __typename?: 'LessonSkillLevels', id: any, skillLevel: string }>, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageUrl?: string | null, username?: string | null, isProfessionalRacquetRegistryActive?: boolean | null, priceUnitAmountCoachDefault?: number | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null } } | null, participants: Array<{ __typename?: 'LessonParticipants', id: any, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, profileImagePath?: string | null } | null }>, userCustomCourt?: { __typename?: 'UserCustomCourts', fullAddress: string } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, title: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null }> };

export type GetFeaturedClinicBoostsQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  now: Scalars['timestamptz'];
}>;


export type GetFeaturedClinicBoostsQuery = { __typename?: 'query_root', boosts: Array<{ __typename?: 'Boosts', id: any, lesson?: { __typename?: 'Lessons', title: string, id: any, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, timezoneAbbreviation: string, description: string, sport: SportsEnum, type: LessonTypesEnum, intendedAgeGroup?: EventAgeGroupsEnum | null, externalBookingUrl: string, externalSource?: string | null, coverImageProviderUrl: string, priceUnitAmount: number, currency: string, participantLimit?: number | null, skillLevels: Array<{ __typename?: 'LessonSkillLevels', id: any, skillLevel: string }>, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageUrl?: string | null, username?: string | null, isProfessionalRacquetRegistryActive?: boolean | null, priceUnitAmountCoachDefault?: number | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null } } | null, participants: Array<{ __typename?: 'LessonParticipants', id: any, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, profileImagePath?: string | null } | null }>, userCustomCourt?: { __typename?: 'UserCustomCourts', fullAddress: string } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, title: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null } | null }> };

export type GetClinicsByFollowedCoachesQueryVariables = Exact<{
  followedCoachesIds: Array<Scalars['uuid']> | Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type GetClinicsByFollowedCoachesQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', title: string, id: any, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, timezoneAbbreviation: string, description: string, sport: SportsEnum, type: LessonTypesEnum, intendedAgeGroup?: EventAgeGroupsEnum | null, externalBookingUrl: string, externalSource?: string | null, coverImageProviderUrl: string, priceUnitAmount: number, currency: string, participantLimit?: number | null, skillLevels: Array<{ __typename?: 'LessonSkillLevels', id: any, skillLevel: string }>, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageUrl?: string | null, username?: string | null, isProfessionalRacquetRegistryActive?: boolean | null, priceUnitAmountCoachDefault?: number | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null } } | null, participants: Array<{ __typename?: 'LessonParticipants', id: any, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, profileImagePath?: string | null } | null }>, userCustomCourt?: { __typename?: 'UserCustomCourts', fullAddress: string } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, title: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null }> };

export type GetRfxClassesByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  limit?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type GetRfxClassesByGeoQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, description: string, sport: SportsEnum, type: EventTypesEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, participantLimit?: number | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageUrl?: string | null, username?: string | null } | null, groups: Array<{ __typename?: 'EventGroups', id: any, startsAt?: any | null, endsAt?: any | null, priceUnitAmount: number, teamLimit?: number | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, profileImagePath?: string | null } | null }>, venue?: { __typename?: 'Venues', id: any, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, title: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null }> };

export type LeagueEventFieldsFragment = { __typename?: 'Events', id: any, slug: string, title: string, description: string, sport: SportsEnum, type: EventTypesEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, registrationClosedAt?: any | null, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, participantLimit?: number | null, isExternal: boolean, externalUrl?: string | null, isVairRequired?: boolean | null, prizeDescription: string, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, minimumRating?: any | null, maximumRating?: any | null, teamType?: TeamTypesEnum | null, minimumAge?: number | null, maximumAge?: number | null }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null }> };

export type GetLeaguesByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  limit?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type GetLeaguesByGeoQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, description: string, sport: SportsEnum, type: EventTypesEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, registrationClosedAt?: any | null, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, participantLimit?: number | null, isExternal: boolean, externalUrl?: string | null, isVairRequired?: boolean | null, prizeDescription: string, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, minimumRating?: any | null, maximumRating?: any | null, teamType?: TeamTypesEnum | null, minimumAge?: number | null, maximumAge?: number | null }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null }> }> };

export type GetFeaturedLeagueBoostsQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  now: Scalars['timestamptz'];
}>;


export type GetFeaturedLeagueBoostsQuery = { __typename?: 'query_root', boosts: Array<{ __typename?: 'Boosts', id: any, event?: { __typename?: 'Events', id: any, slug: string, title: string, description: string, sport: SportsEnum, type: EventTypesEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, registrationClosedAt?: any | null, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, participantLimit?: number | null, isExternal: boolean, externalUrl?: string | null, isVairRequired?: boolean | null, prizeDescription: string, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, minimumRating?: any | null, maximumRating?: any | null, teamType?: TeamTypesEnum | null, minimumAge?: number | null, maximumAge?: number | null }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null }> } | null }> };

export type OpenPlayEventFieldsFragment = { __typename?: 'Events', id: any, slug: string, title: string, description: string, sport: SportsEnum, type: EventTypesEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, participantLimit?: number | null, isExternal: boolean, externalUrl?: string | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, minimumRating?: any | null, maximumRating?: any | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null }> };

export type GetOpenPlaysByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  limit?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type GetOpenPlaysByGeoQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, description: string, sport: SportsEnum, type: EventTypesEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, participantLimit?: number | null, isExternal: boolean, externalUrl?: string | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, minimumRating?: any | null, maximumRating?: any | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null }> }> };

export type GetFeaturedOpenPlayBoostsQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  now: Scalars['timestamptz'];
}>;


export type GetFeaturedOpenPlayBoostsQuery = { __typename?: 'query_root', boosts: Array<{ __typename?: 'Boosts', id: any, event?: { __typename?: 'Events', id: any, slug: string, title: string, description: string, sport: SportsEnum, type: EventTypesEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, participantLimit?: number | null, isExternal: boolean, externalUrl?: string | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, minimumRating?: any | null, maximumRating?: any | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null }> } | null }> };

export type SocialEventFieldsFragment = { __typename?: 'Events', id: any, slug: string, title: string, description: string, sport: SportsEnum, type: EventTypesEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, participantLimit?: number | null, isExternal: boolean, externalUrl?: string | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, minimumRating?: any | null, maximumRating?: any | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null }> };

export type GetSocialsByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  limit?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type GetSocialsByGeoQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, description: string, sport: SportsEnum, type: EventTypesEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, participantLimit?: number | null, isExternal: boolean, externalUrl?: string | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, minimumRating?: any | null, maximumRating?: any | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null }> }> };

export type GetFeaturedSocialBoostsQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  now: Scalars['timestamptz'];
}>;


export type GetFeaturedSocialBoostsQuery = { __typename?: 'query_root', boosts: Array<{ __typename?: 'Boosts', id: any, event?: { __typename?: 'Events', id: any, slug: string, title: string, description: string, sport: SportsEnum, type: EventTypesEnum, startDateTime: any, endDateTime: any, timezoneName: string, timezoneAbbreviation: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, participantLimit?: number | null, isExternal: boolean, externalUrl?: string | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, geometry?: any | null, timezone: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, minimumRating?: any | null, maximumRating?: any | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null } | null }> } | null }> };

export type GetHostGameQueryVariables = Exact<{
  eventId: Scalars['uuid'];
  viewerUserId: Scalars['uuid'];
}>;


export type GetHostGameQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, participantLimit?: number | null, privacy: EventPrivacyEnum, status: EventStatusesEnum, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, description: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, isCourtBooked?: boolean | null, courtCostPerPlayerUnitAmount?: number | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, gender: CompetitionGenderEnum, competitiveness?: EventCompetitivenessEnum | null, netStatus?: GameNetStatusesEnum | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }>, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }>, acceptedPlayRequests: Array<{ __typename?: 'EventAcceptedPlayRequests', id?: any | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null }>, viewerRequests: Array<{ __typename?: 'PlayRequests', id: any }> }> };

export type GetHostGameRequestsQueryVariables = Exact<{
  userId: Scalars['uuid'];
  eventId: Scalars['uuid'];
}>;


export type GetHostGameRequestsQuery = { __typename?: 'query_root', playRequests: Array<{ __typename?: 'PlayRequests', id: any, requestMessage?: string | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null }> };

export type GetHostAvailabilityQueryVariables = Exact<{
  availabilityId: Scalars['uuid'];
}>;


export type GetHostAvailabilityQuery = { __typename?: 'query_root', playerAvailabilities: Array<{ __typename?: 'PlayerAvailabilities', id: any, sport: SportsEnum, teamType: TeamTypesEnum, gender: CompetitionGenderEnum, competitiveness: EventCompetitivenessEnum, wantsRegularPartner: boolean, description: string, travelRadiusMiles: number, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, activeCity?: { __typename?: 'Cities', id: any, name: string } | null } | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'PlayerAvailabilityRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }>, slots: Array<{ __typename?: 'PlayerAvailabilitySlots', id: any, dayOfWeek: string, startTime: any, endTime: any }>, neighborhoods: Array<{ __typename?: 'PlayerAvailabilityNeighborhoods', neighborhood: { __typename?: 'Neighborhoods', id: any, name: string, latitude: any, longitude: any, radiusMiles: any, city: { __typename?: 'Cities', id: any, timezone?: string | null } } }>, venues: Array<{ __typename?: 'PlayerAvailabilityVenues', id: any, userCustomCourt?: { __typename?: 'UserCustomCourts', id: any, title: string, fullAddress: string, latitude?: any | null, longitude?: any | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } | null }> }> };

export type GetHostAvailabilityRequestsQueryVariables = Exact<{
  userId: Scalars['uuid'];
  availabilityId: Scalars['uuid'];
}>;


export type GetHostAvailabilityRequestsQuery = { __typename?: 'query_root', playRequests: Array<{ __typename?: 'PlayRequests', id: any, requestMessage?: string | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null, slots: Array<{ __typename?: 'PlayRequestSlots', id: any, requestedStartAt?: any | null, requestedEndAt?: any | null, availabilitySlot: { __typename?: 'PlayerAvailabilitySlots', id: any, dayOfWeek: string, startTime: any, endTime: any } }>, neighborhoods: Array<{ __typename?: 'PlayRequestNeighborhoods', id: any, neighborhood: { __typename?: 'Neighborhoods', id: any, name: string } }>, venues: Array<{ __typename?: 'PlayRequestVenues', id: any, venue: { __typename?: 'Venues', id: any, title: string, addressString: string, accessType?: VenueAccessTypesEnum | null, pickleballNets?: VenueNetsEnum | null, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } }> }> };

export type GetMyGameRequestQueryVariables = Exact<{
  eventId: Scalars['uuid'];
  userId: Scalars['uuid'];
  status: PlayRequestStatusesEnum;
}>;


export type GetMyGameRequestQuery = { __typename?: 'query_root', playRequests: Array<{ __typename?: 'PlayRequests', id: any, requestMessage?: string | null, createdAt: any, status: PlayRequestStatusesEnum }> };

export type GetMyPendingPlayRequestsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetMyPendingPlayRequestsQuery = { __typename?: 'query_root', playRequests: Array<{ __typename?: 'PlayRequests', id: any, availabilityId?: any | null }> };

export type FindPlayerAvailabilityFieldsFragment = { __typename?: 'PlayerAvailabilities', id: any, sport: SportsEnum, teamType: TeamTypesEnum, gender: CompetitionGenderEnum, competitiveness: EventCompetitivenessEnum, wantsRegularPartner: boolean, description: string, travelRadiusMiles: number, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, activeCity?: { __typename?: 'Cities', id: any, name: string } | null } | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'PlayerAvailabilityRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }>, slots: Array<{ __typename?: 'PlayerAvailabilitySlots', id: any, dayOfWeek: string, startTime: any, endTime: any }>, neighborhoods: Array<{ __typename?: 'PlayerAvailabilityNeighborhoods', neighborhood: { __typename?: 'Neighborhoods', id: any, name: string, latitude: any, longitude: any, radiusMiles: any, city: { __typename?: 'Cities', id: any, timezone?: string | null } } }>, venues: Array<{ __typename?: 'PlayerAvailabilityVenues', id: any, userCustomCourt?: { __typename?: 'UserCustomCourts', id: any, title: string, fullAddress: string, latitude?: any | null, longitude?: any | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } | null }> };

export type GetFindPlayersQueryVariables = Exact<{
  area: PlayerAvailabilitiesBoolExp;
}>;


export type GetFindPlayersQuery = { __typename?: 'query_root', playerAvailabilities: Array<{ __typename?: 'PlayerAvailabilities', id: any, sport: SportsEnum, teamType: TeamTypesEnum, gender: CompetitionGenderEnum, competitiveness: EventCompetitivenessEnum, wantsRegularPartner: boolean, description: string, travelRadiusMiles: number, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, activeCity?: { __typename?: 'Cities', id: any, name: string } | null } | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'PlayerAvailabilityRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }>, slots: Array<{ __typename?: 'PlayerAvailabilitySlots', id: any, dayOfWeek: string, startTime: any, endTime: any }>, neighborhoods: Array<{ __typename?: 'PlayerAvailabilityNeighborhoods', neighborhood: { __typename?: 'Neighborhoods', id: any, name: string, latitude: any, longitude: any, radiusMiles: any, city: { __typename?: 'Cities', id: any, timezone?: string | null } } }>, venues: Array<{ __typename?: 'PlayerAvailabilityVenues', id: any, userCustomCourt?: { __typename?: 'UserCustomCourts', id: any, title: string, fullAddress: string, latitude?: any | null, longitude?: any | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } | null }> }> };

export type FindGameEventFieldsFragment = { __typename?: 'Events', id: any, participantLimit?: number | null, privacy: EventPrivacyEnum, status: EventStatusesEnum, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, description: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, isCourtBooked?: boolean | null, courtCostPerPlayerUnitAmount?: number | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, gender: CompetitionGenderEnum, competitiveness?: EventCompetitivenessEnum | null, netStatus?: GameNetStatusesEnum | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }>, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }>, acceptedPlayRequests: Array<{ __typename?: 'EventAcceptedPlayRequests', id?: any | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null }> };

export type FindGameRosterFieldsFragment = { __typename?: 'Events', id: any, viewerRequests: Array<{ __typename?: 'PlayRequests', id: any }> };

export type GetFindGamesQueryVariables = Exact<{
  area: EventsBoolExp;
  now: Scalars['timestamptz'];
}>;


export type GetFindGamesQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, participantLimit?: number | null, privacy: EventPrivacyEnum, status: EventStatusesEnum, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, description: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, isCourtBooked?: boolean | null, courtCostPerPlayerUnitAmount?: number | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, gender: CompetitionGenderEnum, competitiveness?: EventCompetitivenessEnum | null, netStatus?: GameNetStatusesEnum | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }>, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }>, acceptedPlayRequests: Array<{ __typename?: 'EventAcceptedPlayRequests', id?: any | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null }> }> };

export type GetFindGamesWithRosterQueryVariables = Exact<{
  area: EventsBoolExp;
  now: Scalars['timestamptz'];
  viewerUserId: Scalars['uuid'];
}>;


export type GetFindGamesWithRosterQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, participantLimit?: number | null, privacy: EventPrivacyEnum, status: EventStatusesEnum, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, description: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, isCourtBooked?: boolean | null, courtCostPerPlayerUnitAmount?: number | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, gender: CompetitionGenderEnum, competitiveness?: EventCompetitivenessEnum | null, netStatus?: GameNetStatusesEnum | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }>, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }>, acceptedPlayRequests: Array<{ __typename?: 'EventAcceptedPlayRequests', id?: any | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null }>, viewerRequests: Array<{ __typename?: 'PlayRequests', id: any }> }> };

export type SetPlayerFinderOnboardedMutationVariables = Exact<{
  id: Scalars['uuid'];
  onboardedAt: Scalars['timestamptz'];
}>;


export type SetPlayerFinderOnboardedMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, playerFinderOnboardedAt?: any | null } | null };

export type UpdatePlayerUserMutationVariables = Exact<{
  id: Scalars['uuid'];
  set: UsersSetInput;
}>;


export type UpdatePlayerUserMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any } | null };

export type SavePlayerFinderGoalsMutationVariables = Exact<{
  userId: Scalars['uuid'];
  goals: Array<UserPlayerFinderGoalsInsertInput> | UserPlayerFinderGoalsInsertInput;
}>;


export type SavePlayerFinderGoalsMutation = { __typename?: 'mutation_root', deleteUserPlayerFinderGoals?: { __typename?: 'UserPlayerFinderGoalsMutationResponse', affectedRows: number } | null, insertUserPlayerFinderGoals?: { __typename?: 'UserPlayerFinderGoalsMutationResponse', affectedRows: number } | null };

export type SavePlayerSportsMutationVariables = Exact<{
  userId: Scalars['uuid'];
  sports: Array<UserSportsInsertInput> | UserSportsInsertInput;
}>;


export type SavePlayerSportsMutation = { __typename?: 'mutation_root', deleteUserSports?: { __typename?: 'UserSportsMutationResponse', affectedRows: number } | null, insertUserSports?: { __typename?: 'UserSportsMutationResponse', affectedRows: number } | null };

export type GetPlayerFinderProfileQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetPlayerFinderProfileQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: any, aboutMe?: string | null, gender?: GenderEnum | null, birthday?: any | null, birthdayVisibility: BirthdayVisibilityEnum, instagramUrl?: string | null, facebookUrl?: string | null, tiktokUrl: string, linkedinUrl?: string | null, xUrl?: string | null, profileImageFileName: string, profileImagePath: string, profileImageProvider: string, profileImageProviderId: string, profileImageProviderUrl: string, profileImageUrl: string, pickleballSkillLevelId?: string | null, tennisSkillLevelId?: string | null, padelSkillLevelId?: string | null } | null, userPlayerFinderGoals: Array<{ __typename?: 'UserPlayerFinderGoals', goal: PlayerFinderGoalsEnum }>, userSports: Array<{ __typename?: 'UserSports', sport: SportsEnum }>, userPickleballRatingScales: Array<{ __typename?: 'UserPickleballRatingScales', rating: any, scale: { __typename?: 'PickleballRatingScales', shortName: string } }>, userTennisRatingScales: Array<{ __typename?: 'UserTennisRatingScales', rating: any, scale: { __typename?: 'TennisRatingScales', shortName: string } }>, userPadelRatingScales: Array<{ __typename?: 'UserPadelRatingScales', rating: any, scale: { __typename?: 'PadelRatingScales', shortName: string } }>, userPlayerFinderAvailability: Array<{ __typename?: 'UserPlayerFinderAvailability', dayOfWeek: DayOfWeekEnum, timeOfDay: PlayerFinderTimeOfDayEnum }>, userIdentityVerifications: Array<{ __typename?: 'UserIdentityVerifications', id: any }>, userFiles: Array<{ __typename?: 'UserFiles', id: any, fileName: string, originalFileName?: string | null, path: string, provider: string, providerUrl: string, url: string, fileType: string, host: string }>, venueFollows: Array<{ __typename?: 'VenueFollows', venue: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, accessType?: VenueAccessTypesEnum | null, timezone: string, city?: { __typename?: 'Cities', name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string } } | null, images: Array<{ __typename?: 'VenueImages', url: string }> } }> };

export type GetPlayerFinderRatingScalesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlayerFinderRatingScalesQuery = { __typename?: 'query_root', pickleballRatingScales: Array<{ __typename?: 'PickleballRatingScales', id: any, shortName: string }>, tennisRatingScales: Array<{ __typename?: 'TennisRatingScales', id: any, shortName: string }>, padelRatingScales: Array<{ __typename?: 'PadelRatingScales', id: any, shortName: string }> };

export type SavePlayerRatingScalesMutationVariables = Exact<{
  pickleball: Array<UserPickleballRatingScalesInsertInput> | UserPickleballRatingScalesInsertInput;
  tennis: Array<UserTennisRatingScalesInsertInput> | UserTennisRatingScalesInsertInput;
  padel: Array<UserPadelRatingScalesInsertInput> | UserPadelRatingScalesInsertInput;
}>;


export type SavePlayerRatingScalesMutation = { __typename?: 'mutation_root', insertUserPickleballRatingScales?: { __typename?: 'UserPickleballRatingScalesMutationResponse', affectedRows: number } | null, insertUserTennisRatingScales?: { __typename?: 'UserTennisRatingScalesMutationResponse', affectedRows: number } | null, insertUserPadelRatingScales?: { __typename?: 'UserPadelRatingScalesMutationResponse', affectedRows: number } | null };

export type SavePlayerFinderAvailabilityMutationVariables = Exact<{
  userId: Scalars['uuid'];
  windows: Array<UserPlayerFinderAvailabilityInsertInput> | UserPlayerFinderAvailabilityInsertInput;
}>;


export type SavePlayerFinderAvailabilityMutation = { __typename?: 'mutation_root', deleteUserPlayerFinderAvailability?: { __typename?: 'UserPlayerFinderAvailabilityMutationResponse', affectedRows: number } | null, insertUserPlayerFinderAvailability?: { __typename?: 'UserPlayerFinderAvailabilityMutationResponse', affectedRows: number } | null };

export type InsertPlayerGalleryPhotosMutationVariables = Exact<{
  files: Array<UserFilesInsertInput> | UserFilesInsertInput;
}>;


export type InsertPlayerGalleryPhotosMutation = { __typename?: 'mutation_root', insertUserFiles?: { __typename?: 'UserFilesMutationResponse', affectedRows: number } | null };

export type SavePreferredVenuesMutationVariables = Exact<{
  venues: Array<VenueFollowsInsertInput> | VenueFollowsInsertInput;
}>;


export type SavePreferredVenuesMutation = { __typename?: 'mutation_root', insertVenueFollows?: { __typename?: 'VenueFollowsMutationResponse', affectedRows: number } | null };

export type DeactivatePreferredVenuesMutationVariables = Exact<{
  userId: Scalars['uuid'];
  venueIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type DeactivatePreferredVenuesMutation = { __typename?: 'mutation_root', updateVenueFollows?: { __typename?: 'VenueFollowsMutationResponse', affectedRows: number } | null };

export type DeletePlayerGalleryPhotosMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type DeletePlayerGalleryPhotosMutation = { __typename?: 'mutation_root', deleteUserFiles?: { __typename?: 'UserFilesMutationResponse', affectedRows: number } | null };

export type GetQuatroLessonByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetQuatroLessonByIdQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> }> };

export type GetUserGroupsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserGroupsQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: any, groups: Array<{ __typename?: 'GroupMembers', id: any, isActive: boolean, groupId: any }> } | null };

export type GetGroupByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetGroupByIdQuery = { __typename?: 'query_root', groupsByPk?: { __typename?: 'Groups', contactMessage?: string | null, contactUrl?: string | null, coverPhotoUrl: string, createdAt: any, description: string, displayOwnerContactInfo: boolean, headline: string, id: any, isPrivate: boolean, ownerUserId?: any | null, profilePhotoUrl: string, skillLevelMaximum?: any | null, skillLevelMinimum?: any | null, slug: string, title: string, allowMemberInvites: boolean, allowMemberSessionInvites: boolean, accessCode?: string | null, city?: { __typename?: 'Cities', id: any, name: string } | null, threads: Array<{ __typename?: 'GroupThreads', createdAt: any, id: any, comments: Array<{ __typename?: 'GroupThreadComments', createdAt: any, content: string, groupCommentId?: any | null, groupRootCommentId?: any | null, groupThreadId: any, id: any, isOriginalThreadComment: boolean, votesAggregate: { __typename?: 'GroupCommentVotesAggregate', aggregate?: { __typename?: 'GroupCommentVotesAggregateFields', count: number } | null }, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, username?: string | null, defaultSport?: string | null } | null, votes: Array<{ __typename?: 'GroupCommentVotes', id: any, userId: any, groupThreadCommentId: any, vote: CommentVoteEnum }>, files: Array<{ __typename?: 'GroupThreadCommentFiles', id: any, url: string, path: string }> }>, commentsAggregate: { __typename?: 'GroupThreadCommentsAggregate', aggregate?: { __typename?: 'GroupThreadCommentsAggregateFields', count: number } | null } }>, membersAggregate: { __typename?: 'GroupMembersAggregate', aggregate?: { __typename?: 'GroupMembersAggregateFields', count: number } | null }, ownerUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null } | null, venuesAggregate: { __typename?: 'GroupVenuesAggregate', aggregate?: { __typename?: 'GroupVenuesAggregateFields', count: number } | null } } | null };

export type InsertThreadWithCommentMutationVariables = Exact<{
  groupId: Scalars['uuid'];
  userId: Scalars['uuid'];
  content?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<GroupThreadCommentFilesInsertInput> | GroupThreadCommentFilesInsertInput>;
}>;


export type InsertThreadWithCommentMutation = { __typename?: 'mutation_root', insertGroupThreadsOne?: { __typename?: 'GroupThreads', id: any } | null };

export type UpdateCommentFileAsDeletedMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type UpdateCommentFileAsDeletedMutation = { __typename?: 'mutation_root', updateGroupThreadCommentFilesByPk?: { __typename?: 'GroupThreadCommentFiles', id: any, deletedAt?: any | null } | null };

export type GetGroupDiscussionsQueryVariables = Exact<{
  groupId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetGroupDiscussionsQuery = { __typename?: 'query_root', groupThreads: Array<{ __typename?: 'GroupThreads', id: any, createdAt: any, comments: Array<{ __typename?: 'GroupThreadComments', id: any, content: string, createdAt: any, groupCommentId?: any | null, groupRootCommentId?: any | null, isOriginalThreadComment: boolean, updatedAt: any, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, username?: string | null } | null, votesAggregate: { __typename?: 'GroupCommentVotesAggregate', aggregate?: { __typename?: 'GroupCommentVotesAggregateFields', count: number } | null }, votes: Array<{ __typename?: 'GroupCommentVotes', id: any, userId: any, groupThreadCommentId: any, vote: CommentVoteEnum }>, files: Array<{ __typename?: 'GroupThreadCommentFiles', id: any, url: string, path: string }> }>, commentsAggregate: { __typename?: 'GroupThreadCommentsAggregate', aggregate?: { __typename?: 'GroupThreadCommentsAggregateFields', count: number } | null } }> };

export type GetGroupDiscussionsAnonymousQueryVariables = Exact<{
  groupId: Scalars['uuid'];
}>;


export type GetGroupDiscussionsAnonymousQuery = { __typename?: 'query_root', groupThreads: Array<{ __typename?: 'GroupThreads', id: any, createdAt: any, comments: Array<{ __typename?: 'GroupThreadComments', id: any, content: string, createdAt: any, groupCommentId?: any | null, groupRootCommentId?: any | null, isOriginalThreadComment: boolean, updatedAt: any, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, username?: string | null } | null, votesAggregate: { __typename?: 'GroupCommentVotesAggregate', aggregate?: { __typename?: 'GroupCommentVotesAggregateFields', count: number } | null }, files: Array<{ __typename?: 'GroupThreadCommentFiles', id: any, url: string, path: string }> }>, commentsAggregate: { __typename?: 'GroupThreadCommentsAggregate', aggregate?: { __typename?: 'GroupThreadCommentsAggregateFields', count: number } | null } }> };

export type GetGroupBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetGroupBySlugQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'Groups', id: any, title: string, slug: string, isPrivate: boolean }> };

export type GetGroupMembersQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetGroupMembersQuery = { __typename?: 'query_root', groupsByPk?: { __typename?: 'Groups', id: any, members: Array<{ __typename?: 'GroupMembers', userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, profileImagePath?: string | null, username?: string | null } | null }> } | null };

export type GetUserGroupMembershipQueryVariables = Exact<{
  userId: Scalars['uuid'];
  groupId: Scalars['uuid'];
}>;


export type GetUserGroupMembershipQuery = { __typename?: 'query_root', groupMembers: Array<{ __typename?: 'GroupMembers', id: any, userId: any, isActive: boolean }> };

export type UpsertUsersGroupMembershipMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']>;
  groupId: Scalars['uuid'];
  isActive: Scalars['Boolean'];
}>;


export type UpsertUsersGroupMembershipMutation = { __typename?: 'mutation_root', insertGroupMembersOne?: { __typename?: 'GroupMembers', userId: any, groupId: any, isActive: boolean } | null };

export type GetGroupPageContentByGroupSlugQueryVariables = Exact<{
  groupId: Scalars['uuid'];
}>;


export type GetGroupPageContentByGroupSlugQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'Groups', id: any, members: Array<{ __typename?: 'GroupMembers', id: any, userProfile?: { __typename?: 'UserProfiles', coachStatus?: string | null, aboutMe?: string | null, cityName?: string | null, fullName?: string | null, id?: any | null, geometry?: any | null, priceUnitAmountCoachDefault?: number | null, username?: string | null, profileImagePath?: string | null, profileImageFileName?: string | null, profileImageProviderUrl?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null }>, membersAggregate: { __typename?: 'GroupMembersAggregate', aggregate?: { __typename?: 'GroupMembersAggregateFields', count: number } | null } }> };

export type GetGroupsQueryVariables = Exact<{
  limit: Scalars['Int'];
  distance: Scalars['Float'];
  from: Scalars['geography'];
}>;


export type GetGroupsQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'Groups', id: any, slug: string, memberDisplayCount?: number | null, profilePhotoProviderUrl: string, title: string, addressString: string, latitude?: any | null, longitude?: any | null, membersAggregate: { __typename?: 'GroupMembersAggregate', aggregate?: { __typename?: 'GroupMembersAggregateFields', count: number } | null }, members: Array<{ __typename?: 'GroupMembers', id: any, userProfile?: { __typename?: 'UserProfiles', preferredName?: string | null, id?: any | null } | null }>, events: Array<{ __typename?: 'Events', id: any }> }> };

export type GetGroupRecentCommentsQueryVariables = Exact<{
  groupId: Scalars['uuid'];
  limit: Scalars['Int'];
  userId?: InputMaybe<Scalars['uuid']>;
}>;


export type GetGroupRecentCommentsQuery = { __typename?: 'query_root', groupThreads: Array<{ __typename?: 'GroupThreads', id: any, comments: Array<{ __typename?: 'GroupThreadComments', id: any, content: string, createdAt: any, groupCommentId?: any | null, groupRootCommentId?: any | null, isOriginalThreadComment: boolean, updatedAt: any, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, username?: string | null } | null, votesAggregate: { __typename?: 'GroupCommentVotesAggregate', aggregate?: { __typename?: 'GroupCommentVotesAggregateFields', count: number } | null }, votes: Array<{ __typename?: 'GroupCommentVotes', id: any, userId: any, groupThreadCommentId: any, vote: CommentVoteEnum }>, files: Array<{ __typename?: 'GroupThreadCommentFiles', id: any, url: string, path: string }> }>, commentsAggregate: { __typename?: 'GroupThreadCommentsAggregate', aggregate?: { __typename?: 'GroupThreadCommentsAggregateFields', count: number } | null } }> };

export type GetGroupRecentCommentsAnonymousQueryVariables = Exact<{
  groupId: Scalars['uuid'];
  limit: Scalars['Int'];
}>;


export type GetGroupRecentCommentsAnonymousQuery = { __typename?: 'query_root', groupThreads: Array<{ __typename?: 'GroupThreads', id: any, comments: Array<{ __typename?: 'GroupThreadComments', id: any, content: string, createdAt: any, groupCommentId?: any | null, groupRootCommentId?: any | null, isOriginalThreadComment: boolean, updatedAt: any, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, username?: string | null } | null, votesAggregate: { __typename?: 'GroupCommentVotesAggregate', aggregate?: { __typename?: 'GroupCommentVotesAggregateFields', count: number } | null }, files: Array<{ __typename?: 'GroupThreadCommentFiles', id: any, url: string, path: string }> }>, commentsAggregate: { __typename?: 'GroupThreadCommentsAggregate', aggregate?: { __typename?: 'GroupThreadCommentsAggregateFields', count: number } | null } }> };

export type GetLearningProgramByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetLearningProgramByIdQuery = { __typename?: 'query_root', learningProgramsByPk?: { __typename?: 'LearningPrograms', id: any, title: string, description?: string | null, sportId: SportsEnum, skillLevelId?: LearningProgramSkillLevelValuesEnum | null, totalSchedules: number, scheduleUnit: LearningProgramScheduleUnitsEnum, thumbnailUrl?: string | null, coverImageUrl?: string | null, totalEnrollments: number, averageRating?: any | null, createdAt: any, sport: { __typename?: 'Sports', value: string, description?: string | null }, skillLevel?: { __typename?: 'LearningProgramSkillLevelValues', value: string, description?: string | null } | null, skills: Array<{ __typename?: 'LearningProgramSkills', id: any, skillId: LessonSkillsEnum, isPrimary: boolean, skill: { __typename?: 'LessonSkills', value: string, description?: string | null } }>, schedules: Array<{ __typename?: 'LearningProgramSchedules', id: any, scheduleNumber: number, title: string, primarySkillId?: LessonSkillsEnum | null, focus?: string | null, lessonObjective?: string | null, practicePlan?: string | null, commonMistakes?: string | null, media: Array<{ __typename?: 'LearningProgramScheduleMedia', id: any, orderIndex: number, media: { __typename?: 'LearningProgramMedia', id: any, url: string, fileName: string, fileType: string, fileFormat: string, fileCategory: string, host: string, provider: string, providerId: string, providerUrl: string, originalFileName?: string | null }, mediaCategory: { __typename?: 'LearningProgramMediaCategories', id: any, name: string, code: string, description?: string | null } }> }> } | null };

export type GetUserEnrollmentWithProgressQueryVariables = Exact<{
  learningProgramId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetUserEnrollmentWithProgressQuery = { __typename?: 'query_root', learningProgramEnrollments: Array<{ __typename?: 'LearningProgramEnrollments', id: any, status: string, enrolledAt: any, currentSchedule: number, scheduleProgress: Array<{ __typename?: 'LearningProgramEnrollmentScheduleProgress', id: any, scheduleNumber: number, learningProgramScheduleId: any, completedAt?: any | null, mediaWatched: Array<{ __typename?: 'LearningProgramEnrollmentScheduleMediaWatched', id: any, watchedAt: any, mediaCategory: { __typename?: 'LearningProgramMediaCategories', id: any, code: string } }>, learningProgramSchedule: { __typename?: 'LearningProgramSchedules', id: any, scheduleNumber: number, title: string } }>, videoSubmissions: Array<{ __typename?: 'LearningProgramScheduleVideoSubmissions', id: any, learningProgramScheduleId: any, videoAnalysisId?: any | null, videoAnalysis?: { __typename?: 'VideoAnalysis', id: any, createdAt: any, reviewStatus?: VideoAnalysisReviewStatusesEnum | null } | null, learningProgramSchedule: { __typename?: 'LearningProgramSchedules', scheduleNumber: number } }> }> };

export type UpsertScheduleProgressMediaWatchedMutationVariables = Exact<{
  learningProgramEnrollmentScheduleProgressId: Scalars['uuid'];
  mediaCategoryId: Scalars['uuid'];
  watchedAt: Scalars['timestamptz'];
}>;


export type UpsertScheduleProgressMediaWatchedMutation = { __typename?: 'mutation_root', insertLearningProgramEnrollmentScheduleMediaWatchedOne?: { __typename?: 'LearningProgramEnrollmentScheduleMediaWatched', id: any, watchedAt: any } | null };

export type DeleteScheduleProgressMediaWatchedMutationVariables = Exact<{
  learningProgramEnrollmentScheduleProgressId: Scalars['uuid'];
  mediaCategoryId: Scalars['uuid'];
}>;


export type DeleteScheduleProgressMediaWatchedMutation = { __typename?: 'mutation_root', deleteLearningProgramEnrollmentScheduleMediaWatched?: { __typename?: 'LearningProgramEnrollmentScheduleMediaWatchedMutationResponse', affectedRows: number } | null };

export type CreateScheduleProgressMutationVariables = Exact<{
  enrollmentId: Scalars['uuid'];
  scheduleId: Scalars['uuid'];
  scheduleNumber: Scalars['Int'];
}>;


export type CreateScheduleProgressMutation = { __typename?: 'mutation_root', insertLearningProgramEnrollmentScheduleProgressOne?: { __typename?: 'LearningProgramEnrollmentScheduleProgress', id: any, scheduleNumber: number, learningProgramScheduleId: any } | null };

export type GetLearningProgramsMarketplaceQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetLearningProgramsMarketplaceQuery = { __typename?: 'query_root', learningPrograms: Array<{ __typename?: 'LearningPrograms', id: any, title: string, description?: string | null, sportId: SportsEnum, skillLevelId?: LearningProgramSkillLevelValuesEnum | null, totalSchedules: number, scheduleUnit: LearningProgramScheduleUnitsEnum, thumbnailUrl?: string | null, coverImageUrl?: string | null, totalEnrollments: number, averageRating?: any | null, createdAt: any, sport: { __typename?: 'Sports', value: string, description?: string | null }, skills: Array<{ __typename?: 'LearningProgramSkills', id: any, skillId: LessonSkillsEnum, isPrimary: boolean }>, schedules: Array<{ __typename?: 'LearningProgramSchedules', id: any, scheduleNumber: number, title: string }> }> };

export type InsertLearningProgramEnrollmentMutationVariables = Exact<{
  learningProgramId: Scalars['uuid'];
  userId: Scalars['uuid'];
  enrolledAt: Scalars['date'];
  status: Scalars['String'];
  currentSchedule: Scalars['Int'];
}>;


export type InsertLearningProgramEnrollmentMutation = { __typename?: 'mutation_root', insertLearningProgramEnrollmentsOne?: { __typename?: 'LearningProgramEnrollments', id: any, learningProgramId: any, userId: any, status: string, enrolledAt: any, currentSchedule: number } | null };

export type GetUserEnrollmentQueryVariables = Exact<{
  learningProgramId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetUserEnrollmentQuery = { __typename?: 'query_root', learningProgramEnrollments: Array<{ __typename?: 'LearningProgramEnrollments', id: any, status: string, enrolledAt: any, currentSchedule: number }> };

export type GetUserAvailableLessonContentQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserAvailableLessonContentQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: any, customCourts: Array<{ __typename?: 'UserCustomCourts', createdAt: any, deletedAt?: any | null, fullAddress: string, id: any, title: string }>, lessonTemplates: Array<{ __typename?: 'LessonTemplates', coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, id: any, originalLessonId?: any | null, participantLimit: number, priceUnitAmount: number, privacy?: LessonPrivacyEnum | null, templateName: string, title: string, type?: LessonTypesEnum | null, typeCustom: string, updatedAt: any, userId?: any | null, userCustomCourtId?: any | null, sport?: SportsEnum | null, originalLesson?: { __typename?: 'Lessons', userCustomCourtId?: any | null, venue?: { __typename?: 'Venues', addressString: string, id: any, timezone: string } | null } | null }> } | null };

export type InsertNewLessonWithNewCourtMutationVariables = Exact<{
  title: Scalars['String'];
  type: LessonTypesEnum;
  typeCustom?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LessonStatusesEnum>;
  description: Scalars['String'];
  startDateTime: Scalars['timestamptz'];
  endDateTime: Scalars['timestamptz'];
  ownerUserId: Scalars['uuid'];
  participantLimit: Scalars['Int'];
  paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum;
  priceUnitAmount: Scalars['Int'];
  privacy?: InputMaybe<LessonPrivacyEnum>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  usedTemplateId?: InputMaybe<Scalars['uuid']>;
  lessonTimeData: Array<LessonTimesInsertInput> | LessonTimesInsertInput;
  customCourtData: UserCustomCourtsInsertInput;
  lessonEquipment?: InputMaybe<Array<LessonEquipmentInsertInput> | LessonEquipmentInsertInput>;
  locale: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneAbbreviation: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
  sport: SportsEnum;
  currency: Scalars['String'];
}>;


export type InsertNewLessonWithNewCourtMutation = { __typename?: 'mutation_root', insertLessonsOne?: { __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> } | null };

export type InsertNewLessonWithExistingCourtMutationVariables = Exact<{
  title: Scalars['String'];
  sport: SportsEnum;
  type: LessonTypesEnum;
  typeCustom?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LessonStatusesEnum>;
  description: Scalars['String'];
  startDateTime: Scalars['timestamptz'];
  endDateTime: Scalars['timestamptz'];
  ownerUserId: Scalars['uuid'];
  participantLimit: Scalars['Int'];
  paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum;
  priceUnitAmount: Scalars['Int'];
  privacy?: InputMaybe<LessonPrivacyEnum>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  usedTemplateId?: InputMaybe<Scalars['uuid']>;
  lessonTimeData: Array<LessonTimesInsertInput> | LessonTimesInsertInput;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  lessonEquipment?: InputMaybe<Array<LessonEquipmentInsertInput> | LessonEquipmentInsertInput>;
  locale: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneAbbreviation: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
  venueId?: InputMaybe<Scalars['uuid']>;
  currency: Scalars['String'];
}>;


export type InsertNewLessonWithExistingCourtMutation = { __typename?: 'mutation_root', insertLessonsOne?: { __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> } | null };

export type InsertUserCustomCourtMutationVariables = Exact<{
  customCourtData: UserCustomCourtsInsertInput;
}>;


export type InsertUserCustomCourtMutation = { __typename?: 'mutation_root', insertUserCustomCourtsOne?: { __typename?: 'UserCustomCourts', id: any } | null };

export type UpdateLessonTimesMutationVariables = Exact<{
  lessonId: Scalars['uuid'];
  lessonTimeData: Array<LessonTimesInsertInput> | LessonTimesInsertInput;
}>;


export type UpdateLessonTimesMutation = { __typename?: 'mutation_root', deleteLessonTimes?: { __typename?: 'LessonTimesMutationResponse', affectedRows: number } | null, insertLessonTimes?: { __typename?: 'LessonTimesMutationResponse', affectedRows: number } | null };

export type UpdateLessonEquipmentMutationVariables = Exact<{
  lessonId: Scalars['uuid'];
  lessonEquipmentData?: InputMaybe<Array<LessonEquipmentInsertInput> | LessonEquipmentInsertInput>;
}>;


export type UpdateLessonEquipmentMutation = { __typename?: 'mutation_root', deleteLessonEquipment?: { __typename?: 'LessonEquipmentMutationResponse', affectedRows: number } | null, insertLessonEquipment?: { __typename?: 'LessonEquipmentMutationResponse', affectedRows: number } | null };

export type UpdateNewLessonByIdMutationVariables = Exact<{
  lessonId: Scalars['uuid'];
  title: Scalars['String'];
  sport: SportsEnum;
  type: LessonTypesEnum;
  typeCustom?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LessonStatusesEnum>;
  description: Scalars['String'];
  startDateTime: Scalars['timestamptz'];
  endDateTime: Scalars['timestamptz'];
  participantLimit: Scalars['Int'];
  paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum;
  priceUnitAmount: Scalars['Int'];
  privacy?: InputMaybe<LessonPrivacyEnum>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  usedTemplateId?: InputMaybe<Scalars['uuid']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  currency: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneAbbreviation: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
}>;


export type UpdateNewLessonByIdMutation = { __typename?: 'mutation_root', updateLessonsByPk?: { __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> } | null };

export type UpdateExistingLessonByIdMutationVariables = Exact<{
  lessonId: Scalars['uuid'];
  title: Scalars['String'];
  description: Scalars['String'];
  sport?: InputMaybe<SportsEnum>;
  paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum;
  participantLimit: Scalars['Int'];
  priceUnitAmount: Scalars['Int'];
  currency: Scalars['String'];
  startDateTime: Scalars['timestamptz'];
  endDateTime: Scalars['timestamptz'];
  type: LessonTypesEnum;
  privacy?: InputMaybe<LessonPrivacyEnum>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  externalBookingUrl?: InputMaybe<Scalars['String']>;
  timezoneName: Scalars['String'];
  timezoneAbbreviation: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
}>;


export type UpdateExistingLessonByIdMutation = { __typename?: 'mutation_root', updateLessonsByPk?: { __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> } | null };

export type UpdateUserDefaultCoachPaymentFulfillmentChannelMutationVariables = Exact<{
  id: Scalars['uuid'];
  defaultCoachPaymentFulfillmentChannel: PaymentFulfillmentChannelsEnum;
}>;


export type UpdateUserDefaultCoachPaymentFulfillmentChannelMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', defaultCoachPaymentFulfillmentChannel?: PaymentFulfillmentChannelsEnum | null, id: any } | null };

export type GetUserCreditCardsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetUserCreditCardsQuery = { __typename?: 'query_root', userCreditCards: Array<{ __typename?: 'UserCreditCards', id: any, last4: string, provider: string, providerCardId: string, expireYear: number, expireMonth: number, brand: string, billingName?: string | null, billingPostalCode?: string | null }> };

export type SetLessonAsActiveMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SetLessonAsActiveMutation = { __typename?: 'mutation_root', updateLessonsByPk?: { __typename?: 'Lessons', id: any, status: LessonStatusesEnum, publishedAt?: any | null } | null };

export type InsertLessonTemplateMutationVariables = Exact<{
  coverImageUrl?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  description: Scalars['String'];
  originalLessonId?: InputMaybe<Scalars['uuid']>;
  originalEventId?: InputMaybe<Scalars['uuid']>;
  participantLimit: Scalars['Int'];
  priceUnitAmount: Scalars['Int'];
  privacy: LessonPrivacyEnum;
  templateName: Scalars['String'];
  title: Scalars['String'];
  type?: InputMaybe<LessonTypesEnum>;
  eventType?: InputMaybe<EventTypesEnum>;
  typeCustom: Scalars['String'];
  userId: Scalars['uuid'];
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  sport: SportsEnum;
  externalUrl?: InputMaybe<Scalars['String']>;
  intendedAgeGroup?: InputMaybe<EventAgeGroupsEnum>;
  skillLevels?: InputMaybe<Array<LessonTemplateSkillLevelsInsertInput> | LessonTemplateSkillLevelsInsertInput>;
}>;


export type InsertLessonTemplateMutation = { __typename?: 'mutation_root', insertLessonTemplatesOne?: { __typename?: 'LessonTemplates', id: any, type?: LessonTypesEnum | null, eventType?: EventTypesEnum | null, title: string, templateName: string, coverImageUrl: string, currency: string, description: string, originalLessonId?: any | null, originalEventId?: any | null, participantLimit: number, priceUnitAmount: number, privacy?: LessonPrivacyEnum | null, typeCustom: string, userId?: any | null, userCustomCourtId?: any | null, sport?: SportsEnum | null, intendedAgeGroup?: EventAgeGroupsEnum | null, skillLevels: Array<{ __typename?: 'LessonTemplateSkillLevels', skillLevel: string }> } | null };

export type GetLessonParticipantOrderDetailsQueryVariables = Exact<{
  userId: Scalars['uuid'];
  lessonId: Scalars['uuid'];
}>;


export type GetLessonParticipantOrderDetailsQuery = { __typename?: 'query_root', lessonParticipants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, status: LessonParticipantStatusesEnum, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, orderItems: Array<{ __typename?: 'LessonOrderItems', id: any, status: OrderStatusesEnum, totalUnitAmount: number, priceUnitAmount: number, order: { __typename?: 'LessonOrders', paidUnitAmount: number, refundUnitAmount: number, status: OrderStatusesEnum, orderTotalUnitAmount: number, orderSubtotalUnitAmount: number } }> }> };

export type GetLessonWaitlistQueryVariables = Exact<{
  lessonId: Scalars['uuid'];
}>;


export type GetLessonWaitlistQuery = { __typename?: 'query_root', lessonWaitlists: Array<{ __typename?: 'LessonWaitlists', id: any, status: LessonWaitlistStatusesEnum, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, username?: string | null } | null }> };

export type UpsertLessonWaitlistMutationVariables = Exact<{
  userId: Scalars['uuid'];
  lessonId: Scalars['uuid'];
  status: LessonWaitlistStatusesEnum;
}>;


export type UpsertLessonWaitlistMutation = { __typename?: 'mutation_root', insertLessonWaitlistsOne?: { __typename?: 'LessonWaitlists', lessonId: any, status: LessonWaitlistStatusesEnum, userId: any, id: any } | null };

export type InsertVideoAnalysisSubmissionLogMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  videoName: Scalars['String'];
  videoPath?: InputMaybe<Scalars['String']>;
}>;


export type InsertVideoAnalysisSubmissionLogMutation = { __typename?: 'mutation_root', insertVideoAnalysisSubmissionLogOne?: { __typename?: 'VideoAnalysisSubmissionLog', id: any } | null };

export type UpdateVideoAnalysisSubmissionLogMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']>;
  videoAnalysisId?: InputMaybe<Scalars['uuid']>;
  videoName?: InputMaybe<Scalars['String']>;
  videoPath?: InputMaybe<Scalars['String']>;
  id: Scalars['uuid'];
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type UpdateVideoAnalysisSubmissionLogMutation = { __typename?: 'mutation_root', updateVideoAnalysisSubmissionLog?: { __typename?: 'VideoAnalysisSubmissionLogMutationResponse', returning: Array<{ __typename?: 'VideoAnalysisSubmissionLog', id: any }> } | null };

export type InsertLessonParticipantsAsCoachMutationVariables = Exact<{
  objects?: InputMaybe<Array<LessonParticipantsInsertInput> | LessonParticipantsInsertInput>;
}>;


export type InsertLessonParticipantsAsCoachMutation = { __typename?: 'mutation_root', insertLessonParticipants?: { __typename?: 'LessonParticipantsMutationResponse', affectedRows: number } | null };

export type UpdateLessonParticipantLimitMutationVariables = Exact<{
  lessonId: Scalars['uuid'];
  participantLimit: Scalars['Int'];
}>;


export type UpdateLessonParticipantLimitMutation = { __typename?: 'mutation_root', updateLessonsByPk?: { __typename?: 'Lessons', id: any, participantLimit?: number | null } | null };

export type InsertPlayerAvailabilityMutationVariables = Exact<{
  object: PlayerAvailabilitiesInsertInput;
}>;


export type InsertPlayerAvailabilityMutation = { __typename?: 'mutation_root', insertPlayerAvailabilitiesOne?: { __typename?: 'PlayerAvailabilities', id: any } | null };

export type DeactivatePlayerAvailabilityMutationVariables = Exact<{
  userId: Scalars['uuid'];
  sport: SportsEnum;
}>;


export type DeactivatePlayerAvailabilityMutation = { __typename?: 'mutation_root', updatePlayerAvailabilities?: { __typename?: 'PlayerAvailabilitiesMutationResponse', affectedRows: number } | null };

export type GetEditAvailabilityQueryVariables = Exact<{
  availabilityId: Scalars['uuid'];
}>;


export type GetEditAvailabilityQuery = { __typename?: 'query_root', playerAvailabilitiesByPk?: { __typename?: 'PlayerAvailabilities', id: any, userId: any, sport: SportsEnum, teamType: TeamTypesEnum, gender: CompetitionGenderEnum, competitiveness: EventCompetitivenessEnum, wantsRegularPartner: boolean, description: string, travelRadiusMiles: number, selfRatedMinSkillLevelId?: string | null, selfRatedMaxSkillLevelId?: string | null, slots: Array<{ __typename?: 'PlayerAvailabilitySlots', id: any, dayOfWeek: string, startTime: any, endTime: any }>, neighborhoods: Array<{ __typename?: 'PlayerAvailabilityNeighborhoods', neighborhoodId: any }>, venues: Array<{ __typename?: 'PlayerAvailabilityVenues', id: any, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, latitude: any, longitude: any, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', id: any, title: string, fullAddress: string, latitude?: any | null, longitude?: any | null } | null }>, ratingScales: Array<{ __typename?: 'PlayerAvailabilityRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> } | null };

export type UpdateListedAvailabilityMutationVariables = Exact<{
  id: Scalars['uuid'];
  input: PlayerAvailabilitiesSetInput;
}>;


export type UpdateListedAvailabilityMutation = { __typename?: 'mutation_root', updatePlayerAvailabilitiesByPk?: { __typename?: 'PlayerAvailabilities', id: any } | null };

export type DeleteListedAvailabilitySlotsMutationVariables = Exact<{
  availabilityId: Scalars['uuid'];
}>;


export type DeleteListedAvailabilitySlotsMutation = { __typename?: 'mutation_root', deletePlayerAvailabilitySlots?: { __typename?: 'PlayerAvailabilitySlotsMutationResponse', affectedRows: number } | null };

export type InsertListedAvailabilitySlotsMutationVariables = Exact<{
  objects: Array<PlayerAvailabilitySlotsInsertInput> | PlayerAvailabilitySlotsInsertInput;
}>;


export type InsertListedAvailabilitySlotsMutation = { __typename?: 'mutation_root', insertPlayerAvailabilitySlots?: { __typename?: 'PlayerAvailabilitySlotsMutationResponse', affectedRows: number } | null };

export type DeleteListedAvailabilityVenuesMutationVariables = Exact<{
  availabilityId: Scalars['uuid'];
}>;


export type DeleteListedAvailabilityVenuesMutation = { __typename?: 'mutation_root', deletePlayerAvailabilityVenues?: { __typename?: 'PlayerAvailabilityVenuesMutationResponse', affectedRows: number } | null };

export type InsertListedAvailabilityVenuesMutationVariables = Exact<{
  objects: Array<PlayerAvailabilityVenuesInsertInput> | PlayerAvailabilityVenuesInsertInput;
}>;


export type InsertListedAvailabilityVenuesMutation = { __typename?: 'mutation_root', insertPlayerAvailabilityVenues?: { __typename?: 'PlayerAvailabilityVenuesMutationResponse', affectedRows: number } | null };

export type DeleteListedAvailabilityRatingScalesMutationVariables = Exact<{
  availabilityId: Scalars['uuid'];
}>;


export type DeleteListedAvailabilityRatingScalesMutation = { __typename?: 'mutation_root', deletePlayerAvailabilityRatingScales?: { __typename?: 'PlayerAvailabilityRatingScalesMutationResponse', affectedRows: number } | null };

export type InsertListedAvailabilityRatingScalesMutationVariables = Exact<{
  objects: Array<PlayerAvailabilityRatingScalesInsertInput> | PlayerAvailabilityRatingScalesInsertInput;
}>;


export type InsertListedAvailabilityRatingScalesMutation = { __typename?: 'mutation_root', insertPlayerAvailabilityRatingScales?: { __typename?: 'PlayerAvailabilityRatingScalesMutationResponse', affectedRows: number } | null };

export type GetMyActiveAvailabilitySportsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetMyActiveAvailabilitySportsQuery = { __typename?: 'query_root', playerAvailabilities: Array<{ __typename?: 'PlayerAvailabilities', id: any, sport: SportsEnum }> };

export type InsertAvailabilityCustomCourtMutationVariables = Exact<{
  object: UserCustomCourtsInsertInput;
}>;


export type InsertAvailabilityCustomCourtMutation = { __typename?: 'mutation_root', insertUserCustomCourtsOne?: { __typename?: 'UserCustomCourts', id: any, title: string, fullAddress: string, latitude?: any | null, longitude?: any | null } | null };

export type DeleteListedAvailabilityNeighborhoodsMutationVariables = Exact<{
  availabilityId: Scalars['uuid'];
}>;


export type DeleteListedAvailabilityNeighborhoodsMutation = { __typename?: 'mutation_root', deletePlayerAvailabilityNeighborhoods?: { __typename?: 'PlayerAvailabilityNeighborhoodsMutationResponse', affectedRows: number } | null };

export type InsertListedAvailabilityNeighborhoodsMutationVariables = Exact<{
  objects: Array<PlayerAvailabilityNeighborhoodsInsertInput> | PlayerAvailabilityNeighborhoodsInsertInput;
}>;


export type InsertListedAvailabilityNeighborhoodsMutation = { __typename?: 'mutation_root', insertPlayerAvailabilityNeighborhoods?: { __typename?: 'PlayerAvailabilityNeighborhoodsMutationResponse', affectedRows: number } | null };

export type GetListGameRatingOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListGameRatingOptionsQuery = { __typename?: 'query_root', pickleballRatingScales: Array<{ __typename?: 'PickleballRatingScales', id: any, shortName: string, minimum: any, maximum: any }>, tennisRatingScales: Array<{ __typename?: 'TennisRatingScales', id: any, shortName: string, minimum: any, maximum: any }>, padelRatingScales: Array<{ __typename?: 'PadelRatingScales', id: any, shortName: string, minimum: any, maximum: any }>, skillLevels: Array<{ __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string }> };

export type GetEditGameQueryVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type GetEditGameQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', id: any, participantLimit?: number | null, hostUserId?: any | null, privacy: EventPrivacyEnum, sport: SportsEnum, startDate: any, startDateTime: any, endDateTime: any, venueId?: any | null, addressString?: string | null, latitude?: any | null, longitude?: any | null, isCourtBooked?: boolean | null, courtCostPerPlayerUnitAmount?: number | null, description: string, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, latitude: any, longitude: any, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, gender: CompetitionGenderEnum, competitiveness?: EventCompetitivenessEnum | null, selfRatedMinSkillLevelId?: string | null, selfRatedMaxSkillLevelId?: string | null, netStatus?: GameNetStatusesEnum | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }> } | null };

export type UpdateListedGameEventMutationVariables = Exact<{
  id: Scalars['uuid'];
  input: EventsSetInput;
}>;


export type UpdateListedGameEventMutation = { __typename?: 'mutation_root', updateEventsByPk?: { __typename?: 'Events', id: any } | null };

export type UpdateListedGameGroupMutationVariables = Exact<{
  id: Scalars['uuid'];
  input: EventGroupsSetInput;
}>;


export type UpdateListedGameGroupMutation = { __typename?: 'mutation_root', updateEventGroupsByPk?: { __typename?: 'EventGroups', id: any } | null };

export type DeleteListedGameGroupRatingScalesMutationVariables = Exact<{
  eventGroupId: Scalars['uuid'];
}>;


export type DeleteListedGameGroupRatingScalesMutation = { __typename?: 'mutation_root', deleteEventGroupRatingScales?: { __typename?: 'EventGroupRatingScalesMutationResponse', affectedRows: number } | null };

export type InsertListedGameGroupRatingScalesMutationVariables = Exact<{
  objects: Array<EventGroupRatingScalesInsertInput> | EventGroupRatingScalesInsertInput;
}>;


export type InsertListedGameGroupRatingScalesMutation = { __typename?: 'mutation_root', insertEventGroupRatingScales?: { __typename?: 'EventGroupRatingScalesMutationResponse', affectedRows: number } | null };

export type GetClosestVenuesForClaimQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  googlePlaceId?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
}>;


export type GetClosestVenuesForClaimQuery = { __typename?: 'query_root', byPlaceId: Array<{ __typename?: 'Venues', id: any, title: string, slug: string, addressString: string, googlePlaceId?: string | null, latitude: any, longitude: any, isActive: boolean, adminUser?: { __typename?: 'Users', id: any } | null, images: Array<{ __typename?: 'VenueImages', id: any, url: string, providerUrl: string }> }>, byDistance: Array<{ __typename?: 'Venues', id: any, title: string, slug: string, addressString: string, googlePlaceId?: string | null, latitude: any, longitude: any, isActive: boolean, adminUser?: { __typename?: 'Users', id: any } | null, images: Array<{ __typename?: 'VenueImages', id: any, url: string, providerUrl: string }> }> };

export type GetMyActivityQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetMyActivityQuery = { __typename?: 'query_root', hostedEvents: Array<{ __typename?: 'Events', id: any, coverImageProviderUrl?: string | null, slug: string, startDate: any, startDateTime: any, endDate: any, endDateTime: any, status: EventStatusesEnum, addressString?: string | null, title: string, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null } }>, attendingEvents: Array<{ __typename?: 'Events', id: any, coverImageProviderUrl?: string | null, slug: string, startDate: any, startDateTime: any, endDate: any, endDateTime: any, status: EventStatusesEnum, addressString?: string | null, title: string, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null } }>, lessons: Array<{ __typename?: 'LessonParticipants', id: any, lesson: { __typename?: 'Lessons', id: any, title: string, type: LessonTypesEnum, typeCustom: string, startDateTime?: any | null, endDateTime?: any | null, sport: SportsEnum, coverImageProviderUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', id: any, title: string, fullAddress: string } | null } }> };

export type GetMyActiveAvailabilitiesQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetMyActiveAvailabilitiesQuery = { __typename?: 'query_root', playerAvailabilities: Array<{ __typename?: 'PlayerAvailabilities', id: any }> };

export type GetMyAvailabilityHistoryQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetMyAvailabilityHistoryQuery = { __typename?: 'query_root', playerAvailabilities: Array<{ __typename?: 'PlayerAvailabilities', id: any, createdAt: any, sport: SportsEnum, teamType: TeamTypesEnum, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'PlayerAvailabilityRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }> };

export type GetMySentAvailabilityRequestsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetMySentAvailabilityRequestsQuery = { __typename?: 'query_root', playRequests: Array<{ __typename?: 'PlayRequests', id: any, status: PlayRequestStatusesEnum, requestMessage?: string | null, createdAt: any, availability?: { __typename?: 'PlayerAvailabilities', id: any, sport: SportsEnum, teamType: TeamTypesEnum, gender: CompetitionGenderEnum, competitiveness: EventCompetitivenessEnum, wantsRegularPartner: boolean, description: string, travelRadiusMiles: number, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, cityName?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, activeCity?: { __typename?: 'Cities', id: any, name: string } | null } | null, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'PlayerAvailabilityRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }>, slots: Array<{ __typename?: 'PlayerAvailabilitySlots', id: any, dayOfWeek: string, startTime: any, endTime: any }>, neighborhoods: Array<{ __typename?: 'PlayerAvailabilityNeighborhoods', neighborhood: { __typename?: 'Neighborhoods', id: any, name: string, latitude: any, longitude: any, radiusMiles: any, city: { __typename?: 'Cities', id: any, timezone?: string | null } } }>, venues: Array<{ __typename?: 'PlayerAvailabilityVenues', id: any, userCustomCourt?: { __typename?: 'UserCustomCourts', id: any, title: string, fullAddress: string, latitude?: any | null, longitude?: any | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } | null }> } | null, slots: Array<{ __typename?: 'PlayRequestSlots', id: any, requestedStartAt?: any | null, requestedEndAt?: any | null, availabilitySlot: { __typename?: 'PlayerAvailabilitySlots', id: any, dayOfWeek: string, startTime: any, endTime: any } }>, neighborhoods: Array<{ __typename?: 'PlayRequestNeighborhoods', id: any, neighborhood: { __typename?: 'Neighborhoods', id: any, name: string } }>, venues: Array<{ __typename?: 'PlayRequestVenues', id: any, venue: { __typename?: 'Venues', id: any, title: string } }> }> };

export type GetMyCompetitionsQueryVariables = Exact<{
  where: EventsBoolExp;
}>;


export type GetMyCompetitionsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, type: EventTypesEnum, sport: SportsEnum, startDateTime: any, registrationPriceUnitAmount: number, currency: string, coverImageProviderUrl?: string | null, displayLocation: string, sourceOrganizerTitle?: string | null, venue?: { __typename?: 'Venues', id: any, title: string, images: Array<{ __typename?: 'VenueImages', url: string, path: string }> } | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null } | null }> };

export type GetUpcomingHostedLessonsQueryVariables = Exact<{
  userId: Scalars['uuid'];
  startDate: Scalars['timestamptz'];
}>;


export type GetUpcomingHostedLessonsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, startDateTime?: any | null, endDateTime?: any | null, description: string, sport: SportsEnum, type: LessonTypesEnum, externalBookingUrl: string, externalSource?: string | null, coverImageProviderUrl: string, priceUnitAmount: number, currency: string, participantLimit?: number | null, ownerProfile?: { __typename?: 'UserProfiles', fullName?: string | null, profileImageUrl?: string | null, username?: string | null, isProfessionalRacquetRegistryActive?: boolean | null, priceUnitAmountCoachDefault?: number | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null } } | null, participants: Array<{ __typename?: 'LessonParticipants', id: any, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, profileImagePath?: string | null } | null }>, userCustomCourt?: { __typename?: 'UserCustomCourts', fullAddress: string } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, latitude: any, longitude: any, geometry?: any | null, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null }> };

export type GetMyAttendedSessionsQueryVariables = Exact<{
  where: EventsBoolExp;
}>;


export type GetMyAttendedSessionsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, sport: SportsEnum, type: EventTypesEnum, startDateTime: any, skillLevels: Array<{ __typename?: 'EventSkillLevels', id: any, skillLevel: string }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null } }> };

export type GetMyUpcomingActivitiesQueryVariables = Exact<{
  eventsWhere: EventsBoolExp;
  lessonsWhere: LessonsBoolExp;
}>;


export type GetMyUpcomingActivitiesQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, sport: SportsEnum, type: EventTypesEnum, isRfx: boolean, startDateTime: any, endDateTime: any, timezoneName: string, registrationDeadlineDateTime?: any | null, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, isExternal: boolean, sourceRegistrationCount: number, hostUserId?: any | null, participantLimit?: number | null, privacy: EventPrivacyEnum, status: EventStatusesEnum, description: string, isCourtBooked?: boolean | null, courtCostPerPlayerUnitAmount?: number | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, timezone: string, title: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string }> } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, groups: Array<{ __typename?: 'EventGroups', id: any, startsAt?: any | null, endsAt?: any | null, teamType?: TeamTypesEnum | null, gender: CompetitionGenderEnum, competitiveness?: EventCompetitivenessEnum | null, netStatus?: GameNetStatusesEnum | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }>, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }>, acceptedPlayRequests: Array<{ __typename?: 'EventAcceptedPlayRequests', id?: any | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null }> }>, lessons: Array<{ __typename?: 'Lessons', id: any, title: string, ownerUserId?: any | null, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, description: string, sport: SportsEnum, type: LessonTypesEnum, externalBookingUrl: string, externalSource?: string | null, coverImageProviderUrl: string, priceUnitAmount: number, currency: string, participantLimit?: number | null, ownerProfile?: { __typename?: 'UserProfiles', fullName?: string | null, profileImageUrl?: string | null, username?: string | null, isProfessionalRacquetRegistryActive?: boolean | null, priceUnitAmountCoachDefault?: number | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null } } | null, participants: Array<{ __typename?: 'LessonParticipants', id: any, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, profileImagePath?: string | null } | null }>, userCustomCourt?: { __typename?: 'UserCustomCourts', fullAddress: string } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, latitude: any, longitude: any, geometry?: any | null, title: string, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null }> };

export type GetMyActivityChatStateQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetMyActivityChatStateQuery = { __typename?: 'query_root', conversationParticipants: Array<{ __typename?: 'ConversationParticipants', id: any, lastReadAt?: any | null, conversation: { __typename?: 'Conversations', id: any, eventId?: any | null, lessonId?: any | null, lastMessageAt?: any | null } }> };

export type GetMyOutgoingGameRequestsQueryVariables = Exact<{
  userId: Scalars['uuid'];
  startDate: Scalars['timestamptz'];
}>;


export type GetMyOutgoingGameRequestsQuery = { __typename?: 'query_root', playRequests: Array<{ __typename?: 'PlayRequests', id: any, status: PlayRequestStatusesEnum, requestMessage?: string | null, createdAt: any, event?: { __typename?: 'Events', id: any, participantLimit?: number | null, privacy: EventPrivacyEnum, status: EventStatusesEnum, sport: SportsEnum, startDateTime: any, endDateTime: any, timezoneName: string, description: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, isCourtBooked?: boolean | null, courtCostPerPlayerUnitAmount?: number | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, teamType?: TeamTypesEnum | null, gender: CompetitionGenderEnum, competitiveness?: EventCompetitivenessEnum | null, netStatus?: GameNetStatusesEnum | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }>, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'EventGroupRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> }>, acceptedPlayRequests: Array<{ __typename?: 'EventAcceptedPlayRequests', id?: any | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null }> } | null }> };

export type GetMyAcceptedAvailabilityMatchesQueryVariables = Exact<{
  userId: Scalars['uuid'];
  startDate: Scalars['timestamptz'];
}>;


export type GetMyAcceptedAvailabilityMatchesQuery = { __typename?: 'query_root', playRequests: Array<{ __typename?: 'PlayRequests', id: any, conversationId?: any | null, requesterUserId: any, recipientUserId: any, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null, recipientProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null } | null, availability?: { __typename?: 'PlayerAvailabilities', id: any, sport: SportsEnum, competitiveness: EventCompetitivenessEnum, teamType: TeamTypesEnum, gender: CompetitionGenderEnum, selfRatedMinSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, selfRatedMaxSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, ratingScales: Array<{ __typename?: 'PlayerAvailabilityRatingScales', id: any, minimumRating?: any | null, maximumRating?: any | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, shortName: string } | null, padelRatingScale?: { __typename?: 'PadelRatingScales', id: any, shortName: string } | null }> } | null, slots: Array<{ __typename?: 'PlayRequestSlots', id: any, requestedStartAt?: any | null, requestedEndAt?: any | null }>, selectedVenue?: { __typename?: 'Venues', id: any, title: string, timezone: string, latitude: any, longitude: any, indoorCourtCount: number, outdoorCourtCount: number } | null }> };

export type AvailabilityMatchPlayerFieldsFragment = { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null };

export type GetMyCourtBookingsQueryVariables = Exact<{
  from: Scalars['timestamptz'];
  statuses: Array<PartnerBookingOrderStatusesEnum> | PartnerBookingOrderStatusesEnum;
}>;


export type GetMyCourtBookingsQuery = { __typename?: 'query_root', partnerBookingOrders: Array<{ __typename?: 'PartnerBookingOrders', id: any, status: PartnerBookingOrderStatusesEnum, startAt: any, endAt: any, timezone: string, providerCourtId?: string | null, venue: { __typename?: 'Venues', id: any, title: string, slug: string, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string }> } }> };

export type GetCoachSettingsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetCoachSettingsQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', aboutMe?: string | null, aboutMeVideoUrl: string, birthday?: any | null, coachLessonDescription?: string | null, coachLessonHowToPrepare?: string | null, coachStatus?: CoachStatusEnum | null, coachExternalBookingUrl?: string | null, defaultSport?: SportsEnum | null, duprId?: string | null, fullName: string, gender?: GenderEnum | null, genderPreference: string, geometry?: any | null, id: any, latitude?: any | null, longitude?: any | null, locale?: string | null, isPciMember: boolean, pciId?: string | null, isIptpaMember: boolean, didSkipStripeSetup: boolean, iptpaId?: string | null, isQuatroPickleballMember: boolean, quatroPickleballMemberId?: string | null, phoneCountryCode?: string | null, phoneNumber?: string | null, pprId?: string | null, preferredName: string, profileImageUrl: string, profileImageProviderUrl: string, profileImageProviderId: string, profileImagePath: string, profileImageProvider: string, profileImageFileName: string, stripeCustomerId: string, stripeMerchantBusinessType?: string | null, stripeMerchantChargesEnabled: boolean, stripeMerchantCountry?: string | null, stripeMerchantCurrency?: string | null, stripeMerchantDetailsSubmitted: boolean, stripeMerchantId?: string | null, stripeMerchantPayoutsEnabled: boolean, timezone?: string | null, username?: string | null, coachingStartYear?: number | null, priceUnitAmountCoachDefault?: number | null, priceUnitAmountRemoteCoachDefault?: number | null, priceUnitAmountPremiumContentDefault?: number | null, premiumContentDescription?: string | null, currencyCoachDefault: string, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, endTimeMinutes: number, dayOfWeek: DayOfWeekEnum, startTimeMinutes: number, status: CoachAvailabilityStatusesEnum, coachAvailabilityCustomCourt?: { __typename?: 'UserCustomCourts', id: any } | null, coachAvailabilityVenueId?: { __typename?: 'Venues', id: any } | null }>, coachLessonAgeGroups: Array<{ __typename?: 'CoachLessonAgeGroups', id: any, lessonAgeGroup: LessonAgeGroupsEnum }>, coachLessonSkillLevels: Array<{ __typename?: 'CoachLessonSkillLevels', id: any, skillLevel: string }>, customCourts: Array<{ __typename?: 'UserCustomCourts', id: any, title: string, fullAddress: string }>, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', id: any, fullAddress: string, title: string, latitude?: any | null, longitude?: any | null } | null, defaultCoachVenue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum }>, pickleballRatingScales: Array<{ __typename?: 'UserPickleballRatingScales', id: any, rating: any, pickleballRatingScaleId: any, scale: { __typename?: 'PickleballRatingScales', name: string, id: any, shortName: string } }>, userFiles: Array<{ __typename?: 'UserFiles', fileCategory: FileCategoryEnum, fileFormat: FileFormatEnum, fileName: string, fileType: string, host: string, path: string, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, url: string }> } | null };

export type UpdateCoachSettingsMutationVariables = Exact<{
  userId: Scalars['uuid'];
  objects?: InputMaybe<Array<CoachAvailabilityInsertInput> | CoachAvailabilityInsertInput>;
  pickleRatingObjects?: InputMaybe<Array<UserPickleballRatingScalesInsertInput> | UserPickleballRatingScalesInsertInput>;
  aboutMe: Scalars['String'];
  gender: GenderEnum;
  profileImageProviderUrl: Scalars['String'];
  profileImageUrl: Scalars['String'];
  profileImageProviderId: Scalars['String'];
  profileImagePath: Scalars['String'];
  profileImageProvider: Scalars['String'];
  profileImageFileName: Scalars['String'];
  priceUnitAmountCoachDefault: Scalars['Int'];
  priceUnitAmountRemoteCoachDefault?: InputMaybe<Scalars['Int']>;
  defaultCoachVenueId?: InputMaybe<Scalars['uuid']>;
  isPciMember?: InputMaybe<Scalars['Boolean']>;
  isIptpaMember?: InputMaybe<Scalars['Boolean']>;
  isQuatroPickleballMember?: InputMaybe<Scalars['Boolean']>;
  iptpaId?: InputMaybe<Scalars['String']>;
  quatroPickleballMemberId?: InputMaybe<Scalars['String']>;
  coachingStartYear?: InputMaybe<Scalars['Int']>;
  coachLessonHowToPrepare: Scalars['String'];
  coachLessonDescription: Scalars['String'];
  coachLessonAgeGroups?: InputMaybe<Array<CoachLessonAgeGroupsInsertInput> | CoachLessonAgeGroupsInsertInput>;
  coachSkillLevelGroups?: InputMaybe<Array<CoachLessonSkillLevelsInsertInput> | CoachLessonSkillLevelsInsertInput>;
  coachStatus: CoachStatusEnum;
  userTimeZone: Scalars['String'];
  defaultCoachUserCustomCourtId?: InputMaybe<Scalars['uuid']>;
  images?: InputMaybe<Array<UserFilesInsertInput> | UserFilesInsertInput>;
  phoneNumber: Scalars['String'];
  phoneCountryCode: Scalars['String'];
  coachExternalBookingUrl?: InputMaybe<Scalars['String']>;
  defaultSport: SportsEnum;
}>;


export type UpdateCoachSettingsMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, aboutMe?: string | null, gender?: GenderEnum | null, profileImageUrl: string, profileImageProviderUrl: string, profileImageProviderId: string, profileImagePath: string, profileImageProvider: string, profileImageFileName: string, priceUnitAmountCoachDefault?: number | null, isPciMember: boolean, coachingStartYear?: number | null, coachLessonHowToPrepare?: string | null, coachLessonDescription?: string | null, coachExternalBookingUrl?: string | null, defaultSport?: SportsEnum | null, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, endTimeMinutes: number, dayOfWeek: DayOfWeekEnum, startTimeMinutes: number }>, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', id: any, fullAddress: string, title: string, latitude?: any | null, longitude?: any | null } | null, defaultCoachVenue?: { __typename?: 'Venues', id: any, addressString: string } | null } | null, deleteCoachAvailability?: { __typename?: 'CoachAvailabilityMutationResponse', returning: Array<{ __typename?: 'CoachAvailability', id: any, startTimeMinutes: number, endTimeMinutes: number, dayOfWeek: DayOfWeekEnum }> } | null, insertCoachAvailability?: { __typename?: 'CoachAvailabilityMutationResponse', returning: Array<{ __typename?: 'CoachAvailability', id: any, endTimeMinutes: number, startTimeMinutes: number, dayOfWeek: DayOfWeekEnum }> } | null, deleteUserPickleballRatingScales?: { __typename?: 'UserPickleballRatingScalesMutationResponse', returning: Array<{ __typename?: 'UserPickleballRatingScales', id: any, pickleballRatingScaleId: any, rating: any, userId: any }> } | null, insertUserPickleballRatingScales?: { __typename?: 'UserPickleballRatingScalesMutationResponse', returning: Array<{ __typename?: 'UserPickleballRatingScales', id: any, pickleballRatingScaleId: any, rating: any, userId: any }> } | null, deleteCoachLessonAgeGroups?: { __typename?: 'CoachLessonAgeGroupsMutationResponse', returning: Array<{ __typename?: 'CoachLessonAgeGroups', id: any, lessonAgeGroup: LessonAgeGroupsEnum, userId: any }> } | null, insertCoachLessonAgeGroups?: { __typename?: 'CoachLessonAgeGroupsMutationResponse', returning: Array<{ __typename?: 'CoachLessonAgeGroups', id: any, lessonAgeGroup: LessonAgeGroupsEnum, userId: any }> } | null, deleteCoachLessonSkillLevels?: { __typename?: 'CoachLessonSkillLevelsMutationResponse', returning: Array<{ __typename?: 'CoachLessonSkillLevels', id: any, skillLevel: string, userId: any }> } | null, insertCoachLessonSkillLevels?: { __typename?: 'CoachLessonSkillLevelsMutationResponse', returning: Array<{ __typename?: 'CoachLessonSkillLevels', id: any, skillLevel: string, userId: any }> } | null, deleteUserFiles?: { __typename?: 'UserFilesMutationResponse', returning: Array<{ __typename?: 'UserFiles', id: any }> } | null, insertUserFiles?: { __typename?: 'UserFilesMutationResponse', returning: Array<{ __typename?: 'UserFiles', id: any, path: string, fileType: string, fileName: string }> } | null };

export type UpdateCoachAvailabilityMutationVariables = Exact<{
  userId: Scalars['uuid'];
  objects?: InputMaybe<Array<CoachAvailabilityInsertInput> | CoachAvailabilityInsertInput>;
}>;


export type UpdateCoachAvailabilityMutation = { __typename?: 'mutation_root', deleteCoachAvailability?: { __typename?: 'CoachAvailabilityMutationResponse', returning: Array<{ __typename?: 'CoachAvailability', id: any, startTimeMinutes: number, endTimeMinutes: number, dayOfWeek: DayOfWeekEnum }> } | null, insertCoachAvailability?: { __typename?: 'CoachAvailabilityMutationResponse', returning: Array<{ __typename?: 'CoachAvailability', id: any, endTimeMinutes: number, startTimeMinutes: number, dayOfWeek: DayOfWeekEnum }> } | null };

export type GetUniqueCoachVenueCourtsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetUniqueCoachVenueCourtsQuery = { __typename?: 'query_root', coachAvailability: Array<{ __typename?: 'CoachAvailability', status: CoachAvailabilityStatusesEnum, userCustomCourtId?: any | null, userId: any, coachAvailabilityCustomCourt?: { __typename?: 'UserCustomCourts', fullAddress: string, id: any, latitude?: any | null, longitude?: any | null } | null, coachAvailabilityVenueId?: { __typename?: 'Venues', addressString: string, id: any, latitude: any, longitude: any, timezone: string, description: string, pickleballNets?: VenueNetsEnum | null, slug: string, outdoorCourtCount: number, indoorCourtCount: number, title: string, accessType?: VenueAccessTypesEnum | null, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, path: string, provider: string, url: string }> } | null }> };

export type UpdateCoachImagesMutationVariables = Exact<{
  userId: Scalars['uuid'];
  profileImageProviderUrl?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  profileImageProviderId?: InputMaybe<Scalars['String']>;
  profileImagePath?: InputMaybe<Scalars['String']>;
  profileImageProvider?: InputMaybe<Scalars['String']>;
  profileImageFileName?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<UserFilesInsertInput> | UserFilesInsertInput>;
}>;


export type UpdateCoachImagesMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, aboutMe?: string | null, gender?: GenderEnum | null, profileImageUrl: string, profileImageProviderUrl: string, profileImageProviderId: string, profileImagePath: string, profileImageProvider: string, profileImageFileName: string, priceUnitAmountCoachDefault?: number | null, isPciMember: boolean, coachingStartYear?: number | null, coachLessonHowToPrepare?: string | null, coachLessonDescription?: string | null, coachExternalBookingUrl?: string | null, defaultSport?: SportsEnum | null } | null, deleteUserFiles?: { __typename?: 'UserFilesMutationResponse', returning: Array<{ __typename?: 'UserFiles', id: any }> } | null, insertUserFiles?: { __typename?: 'UserFilesMutationResponse', returning: Array<{ __typename?: 'UserFiles', id: any, path: string, fileType: string, fileName: string }> } | null };

export type UpdateCoachSocialsMutationVariables = Exact<{
  userId: Scalars['uuid'];
  defaultSport?: InputMaybe<SportsEnum>;
  xUrl?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  sports: Array<CoachSportsInsertInput> | CoachSportsInsertInput;
}>;


export type UpdateCoachSocialsMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, aboutMe?: string | null, gender?: GenderEnum | null, profileImageUrl: string, profileImageProviderUrl: string, profileImageProviderId: string, profileImagePath: string, profileImageProvider: string, profileImageFileName: string, priceUnitAmountCoachDefault?: number | null, isPciMember: boolean, coachingStartYear?: number | null, coachLessonHowToPrepare?: string | null, coachLessonDescription?: string | null, coachExternalBookingUrl?: string | null, defaultSport?: SportsEnum | null, xUrl?: string | null, facebookUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, websiteUrl?: string | null, instagramUrl?: string | null } | null, insertCoachSports?: { __typename?: 'CoachSportsMutationResponse', returning: Array<{ __typename?: 'CoachSports', id: any, sport: SportsEnum, status: CoachSportStatusesEnum, userId: any }> } | null };

export type UpdateCoachAboutMutationVariables = Exact<{
  userId: Scalars['uuid'];
  aboutMe?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCoachAboutMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, aboutMe?: string | null, gender?: GenderEnum | null, profileImageUrl: string, profileImageProviderUrl: string, profileImageProviderId: string, profileImagePath: string, profileImageProvider: string, profileImageFileName: string, priceUnitAmountCoachDefault?: number | null, isPciMember: boolean, coachingStartYear?: number | null, coachLessonHowToPrepare?: string | null, coachLessonDescription?: string | null, coachExternalBookingUrl?: string | null, defaultSport?: SportsEnum | null, xUrl?: string | null, facebookUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, websiteUrl?: string | null } | null };

export type UpdateCoachPrepareMutationVariables = Exact<{
  userId: Scalars['uuid'];
  coachLessonHowToPrepare?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCoachPrepareMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any } | null };

export type UpdateCoachDetailsMutationVariables = Exact<{
  userId: Scalars['uuid'];
  coachLessonDescription?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCoachDetailsMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, aboutMe?: string | null, gender?: GenderEnum | null, profileImageUrl: string, profileImageProviderUrl: string, profileImageProviderId: string, profileImagePath: string, profileImageProvider: string, profileImageFileName: string, priceUnitAmountCoachDefault?: number | null, isPciMember: boolean, coachingStartYear?: number | null, coachLessonHowToPrepare?: string | null, coachLessonDescription?: string | null, coachExternalBookingUrl?: string | null, defaultSport?: SportsEnum | null, xUrl?: string | null, facebookUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, websiteUrl?: string | null } | null };

export type UpdateCoachParamsMutationVariables = Exact<{
  userId: Scalars['uuid'];
  isPciMember?: InputMaybe<Scalars['Boolean']>;
  isIptpaMember?: InputMaybe<Scalars['Boolean']>;
  isQuatroPickleballMember?: InputMaybe<Scalars['Boolean']>;
  iptpaId?: InputMaybe<Scalars['String']>;
  quatroPickleballMemberId?: InputMaybe<Scalars['String']>;
  coachingStartYear?: InputMaybe<Scalars['Int']>;
  pickleRatingObjects?: InputMaybe<Array<UserPickleballRatingScalesInsertInput> | UserPickleballRatingScalesInsertInput>;
}>;


export type UpdateCoachParamsMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, aboutMe?: string | null, gender?: GenderEnum | null, profileImageUrl: string, profileImageProviderUrl: string, profileImageProviderId: string, profileImagePath: string, profileImageProvider: string, profileImageFileName: string, priceUnitAmountCoachDefault?: number | null, isPciMember: boolean, coachingStartYear?: number | null, coachLessonHowToPrepare?: string | null, coachLessonDescription?: string | null, coachExternalBookingUrl?: string | null, defaultSport?: SportsEnum | null } | null, deleteUserPickleballRatingScales?: { __typename?: 'UserPickleballRatingScalesMutationResponse', returning: Array<{ __typename?: 'UserPickleballRatingScales', id: any, pickleballRatingScaleId: any, rating: any, userId: any }> } | null, insertUserPickleballRatingScales?: { __typename?: 'UserPickleballRatingScalesMutationResponse', returning: Array<{ __typename?: 'UserPickleballRatingScales', id: any, pickleballRatingScaleId: any, rating: any, userId: any }> } | null };

export type UpdateCoachLessonAgeGroupsMutationVariables = Exact<{
  userId: Scalars['uuid'];
  coachLessonAgeGroups?: InputMaybe<Array<CoachLessonAgeGroupsInsertInput> | CoachLessonAgeGroupsInsertInput>;
  coachSkillLevelGroups?: InputMaybe<Array<CoachLessonSkillLevelsInsertInput> | CoachLessonSkillLevelsInsertInput>;
}>;


export type UpdateCoachLessonAgeGroupsMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, aboutMe?: string | null, gender?: GenderEnum | null, profileImageUrl: string, profileImageProviderUrl: string, profileImageProviderId: string, profileImagePath: string, profileImageProvider: string, profileImageFileName: string, priceUnitAmountCoachDefault?: number | null, isPciMember: boolean, coachingStartYear?: number | null, coachLessonHowToPrepare?: string | null, coachLessonDescription?: string | null, coachExternalBookingUrl?: string | null, defaultSport?: SportsEnum | null } | null, deleteCoachLessonAgeGroups?: { __typename?: 'CoachLessonAgeGroupsMutationResponse', returning: Array<{ __typename?: 'CoachLessonAgeGroups', id: any, lessonAgeGroup: LessonAgeGroupsEnum, userId: any }> } | null, insertCoachLessonAgeGroups?: { __typename?: 'CoachLessonAgeGroupsMutationResponse', returning: Array<{ __typename?: 'CoachLessonAgeGroups', id: any, lessonAgeGroup: LessonAgeGroupsEnum, userId: any }> } | null, deleteCoachLessonSkillLevels?: { __typename?: 'CoachLessonSkillLevelsMutationResponse', returning: Array<{ __typename?: 'CoachLessonSkillLevels', id: any, skillLevel: string, userId: any }> } | null, insertCoachLessonSkillLevels?: { __typename?: 'CoachLessonSkillLevelsMutationResponse', returning: Array<{ __typename?: 'CoachLessonSkillLevels', id: any, skillLevel: string, userId: any }> } | null };

export type GetUserCommunicationPreferencesQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserCommunicationPreferencesQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: any, coachStatus?: CoachStatusEnum | null, communicationPreferences?: { __typename?: 'UserCommunicationPreferences', id: any, lessonBookedEmail: CommunicationPreferenceStatusesEnum, lessonBookedPush: CommunicationPreferenceStatusesEnum, lessonCanceledEmail: CommunicationPreferenceStatusesEnum, lessonCanceledPushed: CommunicationPreferenceStatusesEnum, lessonReminderEmail: CommunicationPreferenceStatusesEnum, lessonReminderPush: CommunicationPreferenceStatusesEnum, marketingEmail: CommunicationPreferenceStatusesEnum, marketingPush: CommunicationPreferenceStatusesEnum, newFollowerEmail: CommunicationPreferenceStatusesEnum, newFollowerPush: CommunicationPreferenceStatusesEnum, newLessonPublishedEmail: CommunicationPreferenceStatusesEnum, newLessonPublishedPush: CommunicationPreferenceStatusesEnum, participantLeftLessonEmail: CommunicationPreferenceStatusesEnum, participantLeftLessonPush: CommunicationPreferenceStatusesEnum, payoutEmail: CommunicationPreferenceStatusesEnum, payoutPush: CommunicationPreferenceStatusesEnum, playSessionCanceledEmail: CommunicationPreferenceStatusesEnum, playSessionCanceledPush: CommunicationPreferenceStatusesEnum, playSessionParticipantJoinedEmail: CommunicationPreferenceStatusesEnum, playSessionParticipantJoinedPush: CommunicationPreferenceStatusesEnum, playSessionParticipantLeftEmail: CommunicationPreferenceStatusesEnum, playSessionParticipantLeftPush: CommunicationPreferenceStatusesEnum, playSessionReminderEmail: CommunicationPreferenceStatusesEnum, playSessionReminderPush: CommunicationPreferenceStatusesEnum } | null } | null };

export type UpdateUserCommunicationPreferencesMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: UserCommunicationPreferencesSetInput;
}>;


export type UpdateUserCommunicationPreferencesMutation = { __typename?: 'mutation_root', updateUserCommunicationPreferencesByPk?: { __typename?: 'UserCommunicationPreferences', id: any, lessonBookedEmail: CommunicationPreferenceStatusesEnum, lessonBookedPush: CommunicationPreferenceStatusesEnum, lessonCanceledEmail: CommunicationPreferenceStatusesEnum, lessonCanceledPushed: CommunicationPreferenceStatusesEnum, lessonReminderEmail: CommunicationPreferenceStatusesEnum, lessonReminderPush: CommunicationPreferenceStatusesEnum, marketingEmail: CommunicationPreferenceStatusesEnum, marketingPush: CommunicationPreferenceStatusesEnum, newFollowerEmail: CommunicationPreferenceStatusesEnum, newFollowerPush: CommunicationPreferenceStatusesEnum, newLessonPublishedEmail: CommunicationPreferenceStatusesEnum, newLessonPublishedPush: CommunicationPreferenceStatusesEnum, participantLeftLessonEmail: CommunicationPreferenceStatusesEnum, participantLeftLessonPush: CommunicationPreferenceStatusesEnum, payoutEmail: CommunicationPreferenceStatusesEnum, payoutPush: CommunicationPreferenceStatusesEnum, playSessionCanceledEmail: CommunicationPreferenceStatusesEnum, playSessionCanceledPush: CommunicationPreferenceStatusesEnum, playSessionParticipantJoinedEmail: CommunicationPreferenceStatusesEnum, playSessionParticipantJoinedPush: CommunicationPreferenceStatusesEnum, playSessionParticipantLeftEmail: CommunicationPreferenceStatusesEnum, playSessionParticipantLeftPush: CommunicationPreferenceStatusesEnum, playSessionReminderEmail: CommunicationPreferenceStatusesEnum, playSessionReminderPush: CommunicationPreferenceStatusesEnum } | null };

export type UpdateUserGenderMutationVariables = Exact<{
  id: Scalars['uuid'];
  gender: GenderEnum;
  genderPreference: Scalars['String'];
}>;


export type UpdateUserGenderMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, gender?: GenderEnum | null, genderPreference: string } | null };

export type UpdateUserBirthdayMutationVariables = Exact<{
  id: Scalars['uuid'];
  birthday: Scalars['date'];
}>;


export type UpdateUserBirthdayMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, birthday?: any | null } | null };

export type InsertRepeatLessonsMutationVariables = Exact<{
  objects?: InputMaybe<Array<LessonsInsertInput> | LessonsInsertInput>;
}>;


export type InsertRepeatLessonsMutation = { __typename?: 'mutation_root', insertLessons?: { __typename?: 'LessonsMutationResponse', returning: Array<{ __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> }> } | null };

export type UpdateUserOnboardBioMutationVariables = Exact<{
  id: Scalars['uuid'];
  birthday: Scalars['date'];
  gender: GenderEnum;
  genderPreference?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserOnboardBioMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, gender?: GenderEnum | null, genderPreference: string, fullName: string, email: string, birthday?: any | null, normalizedTennisRating?: any | null, normalizedTennisRatingScaleId?: any | null, tennisRating?: any | null, tennisRatingScaleId?: any | null } | null };

export type SetOnboardCompleteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SetOnboardCompleteMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, isOnboardComplete: boolean } | null };

export type UpdateMarketingCommunicationPreferencesMutationVariables = Exact<{
  id: Scalars['uuid'];
  marketingPreference?: InputMaybe<CommunicationPreferenceStatusesEnum>;
}>;


export type UpdateMarketingCommunicationPreferencesMutation = { __typename?: 'mutation_root', updateUserCommunicationPreferencesByPk?: { __typename?: 'UserCommunicationPreferences', id: any, marketingEmail: CommunicationPreferenceStatusesEnum, marketingPush: CommunicationPreferenceStatusesEnum } | null };

export type InsertAcceptTermsOfServiceMutationVariables = Exact<{
  ip?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId: Scalars['uuid'];
}>;


export type InsertAcceptTermsOfServiceMutation = { __typename?: 'mutation_root', insertUserTermsOfServiceOne?: { __typename?: 'UserTermsOfService', id: any, ip: string, acceptedAt: any, userAgent: string, userId: any } | null };

export type SetUserLocationMutationVariables = Exact<{
  id: Scalars['uuid'];
  countryId: Scalars['String'];
  countrySubdivisionId?: InputMaybe<Scalars['uuid']>;
  cityName: Scalars['String'];
}>;


export type SetUserLocationMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, countrySubdivisionId?: any | null, countryId?: string | null } | null };

export type SetUserCoachQualificationsMutationVariables = Exact<{
  userId: Scalars['uuid'];
  coachingStartYear: Scalars['Int'];
  objects?: InputMaybe<Array<UsersCoachQualificationsInsertInput> | UsersCoachQualificationsInsertInput>;
}>;


export type SetUserCoachQualificationsMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, coachingStartYear?: number | null } | null, insertUsersCoachQualifications?: { __typename?: 'UsersCoachQualificationsMutationResponse', returning: Array<{ __typename?: 'UsersCoachQualifications', id: any, status: CoachQualificationStatusesEnum, coachQualificationId: any, userId: any }> } | null };

export type GetSkillLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSkillLevelsQuery = { __typename?: 'query_root', skillLevels: Array<{ __typename?: 'SkillLevels', displayName: string, id: SkillLevelValuesEnum, isDisplayed: boolean, rank: number }> };

export type UpdateUserTennisSkillLevelMutationVariables = Exact<{
  id: Scalars['uuid'];
  tennisSkillLevelId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserTennisSkillLevelMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, tennisSkillLevelId?: string | null } | null };

export type UpdateUserPickleballSkillLevelMutationVariables = Exact<{
  id: Scalars['uuid'];
  pickleballSkillLevelId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserPickleballSkillLevelMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, pickleballSkillLevelId?: string | null } | null };

export type GetPublishedEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublishedEventsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, title: string, cityString: string, startDateTime: any, addressString?: string | null, displayLocation: string, endDate: any, coverImageUrl?: string | null, endDateTime: any, latitude?: any | null, longitude?: any | null, status: EventStatusesEnum, startDate: any, publishedAt?: any | null, city?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, code: string } } | null }> };

export type UpdateEventContentsMutationVariables = Exact<{
  id: Scalars['uuid'];
  input: EventsSetInput;
}>;


export type UpdateEventContentsMutation = { __typename?: 'mutation_root', updateEventsByPk?: { __typename?: 'Events', id: any, title: string, hasPrizes: boolean, isSanctioned: boolean, privacy: EventPrivacyEnum, registrationDeadlineDate: any, registrationPriceUnitAmount: number, coverImageUrl?: string | null } | null };

export type UpdateFaqByIdMutationVariables = Exact<{
  id: Scalars['uuid'];
  input: EventFaqsSetInput;
}>;


export type UpdateFaqByIdMutation = { __typename?: 'mutation_root', updateEventFaqsByPk?: { __typename?: 'EventFaqs', id: any, answer: string, question: string } | null };

export type UpdateEventSponsorsByPkMutationVariables = Exact<{
  id: Scalars['uuid'];
  input: EventSponsorsSetInput;
}>;


export type UpdateEventSponsorsByPkMutation = { __typename?: 'mutation_root', updateEventSponsorsByPk?: { __typename?: 'EventSponsors', id: any, name: string, isTitleSponsor: boolean, categoryName: string, imageUrl: string } | null };

export type UpdateEventGroupsByPkMutationVariables = Exact<{
  id: Scalars['uuid'];
  input: EventGroupsSetInput;
}>;


export type UpdateEventGroupsByPkMutation = { __typename?: 'mutation_root', updateEventGroupsByPk?: { __typename?: 'EventGroups', id: any, title: string, format?: EventGroupFormatsEnum | null, formatCustomName: string, gamesPerMatch: number, gender: CompetitionGenderEnum, maximumAge?: number | null, minimumAge?: number | null, maximumRating?: any | null, minimumRating?: any | null, minimumNumberOfGames: number, priceUnitAmount: number, teamLimit?: number | null, scoringFormat?: ScoringFormatEnum | null, startsAt?: any | null, endsAt?: any | null } | null };

export type GetPartnerBookingOrderQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetPartnerBookingOrderQuery = { __typename?: 'query_root', partnerBookingOrdersByPk?: { __typename?: 'PartnerBookingOrders', id: any, status: PartnerBookingOrderStatusesEnum, localDate: any, startLocal: any, endLocal: any, providerCourtId?: string | null, updatedAt: any } | null };

export type GetPlaySessionFeedQueryVariables = Exact<{
  startDateTime: Scalars['timestamptz'];
  groupId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetPlaySessionFeedQuery = { __typename?: 'query_root', playSessions: Array<{ __typename?: 'PlaySessions', cancelReason: string, canceledAt?: any | null, deletedAt?: any | null, competitiveness?: PlaySessionMatchCompetitivenessEnum | null, courtBookingStatus: PlaySessionCourtBookingStatusesEnum, createdAt: any, currency: string, description: string, endDateTime?: any | null, extraRacketCount?: number | null, format: PlaySessionFormatsEnum, groupId?: any | null, id: any, isBringingNet: boolean, participantLimit?: number | null, sport: SportsEnum, startDateTime?: any | null, status: PlaySessionStatusesEnum, targetSkillLevel?: string | null, title: string, userCustomCourtId?: any | null, locale: string, timezoneOffsetMinutes: number, timezoneName: string, timezoneAbbreviation: string, publishedAt?: any | null, priceUnitAmount: number, updatedAt: any, organizerUserId?: any | null, privacy: PlaySessionPrivacyEnum, skillRatingMaximum?: any | null, skillRatingMinimum?: any | null, commentsAggregate: { __typename?: 'PlaySessionCommentsAggregate', aggregate?: { __typename?: 'PlaySessionCommentsAggregateFields', count: number } | null }, currentUserAsParticipant: Array<{ __typename?: 'PlaySessionParticipants', id: any, status: PlaySessionParticipantStatusesEnum }>, organizerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any } | null, participantsAggregate: { __typename?: 'PlaySessionParticipantsAggregate', aggregate?: { __typename?: 'PlaySessionParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'PlaySessionParticipants', id: any, playSessionId: any, userId: any, status: PlaySessionParticipantStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, providerUrl: string, path: string, url: string }> } | null }> };

export type GetActiveJoinedPlaySessionsQueryVariables = Exact<{
  userId: Scalars['uuid'];
  startDateTime: Scalars['timestamptz'];
}>;


export type GetActiveJoinedPlaySessionsQuery = { __typename?: 'query_root', playSessionParticipants: Array<{ __typename?: 'PlaySessionParticipants', playSession: { __typename?: 'PlaySessions', cancelReason: string, canceledAt?: any | null, deletedAt?: any | null, competitiveness?: PlaySessionMatchCompetitivenessEnum | null, courtBookingStatus: PlaySessionCourtBookingStatusesEnum, createdAt: any, currency: string, description: string, endDateTime?: any | null, extraRacketCount?: number | null, format: PlaySessionFormatsEnum, groupId?: any | null, id: any, isBringingNet: boolean, participantLimit?: number | null, sport: SportsEnum, startDateTime?: any | null, status: PlaySessionStatusesEnum, targetSkillLevel?: string | null, title: string, userCustomCourtId?: any | null, locale: string, timezoneOffsetMinutes: number, timezoneName: string, timezoneAbbreviation: string, publishedAt?: any | null, priceUnitAmount: number, updatedAt: any, organizerUserId?: any | null, privacy: PlaySessionPrivacyEnum, skillRatingMaximum?: any | null, skillRatingMinimum?: any | null, commentsAggregate: { __typename?: 'PlaySessionCommentsAggregate', aggregate?: { __typename?: 'PlaySessionCommentsAggregateFields', count: number } | null }, organizerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any } | null, participantsAggregate: { __typename?: 'PlaySessionParticipantsAggregate', aggregate?: { __typename?: 'PlaySessionParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'PlaySessionParticipants', id: any, playSessionId: any, userId: any, status: PlaySessionParticipantStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, providerUrl: string, path: string, url: string }> } | null } }> };

export type GetUserCustomCourtsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserCustomCourtsQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: any, customCourts: Array<{ __typename?: 'UserCustomCourts', createdAt: any, deletedAt?: any | null, fullAddress: string, id: any, title: string, latitude?: any | null, longitude?: any | null }> } | null };

export type InsertNewPlaySessionMutationVariables = Exact<{
  competitiveness: PlaySessionMatchCompetitivenessEnum;
  courtBookingStatus: PlaySessionCourtBookingStatusesEnum;
  description?: InputMaybe<Scalars['String']>;
  endDateTime: Scalars['timestamptz'];
  extraRacketCount?: InputMaybe<Scalars['Int']>;
  format: PlaySessionFormatsEnum;
  isBringingNet?: InputMaybe<Scalars['Boolean']>;
  locale: Scalars['String'];
  organizerUserId: Scalars['uuid'];
  participantLimit?: InputMaybe<Scalars['Int']>;
  sport: SportsEnum;
  startDateTime: Scalars['timestamptz'];
  status?: InputMaybe<PlaySessionStatusesEnum>;
  targetSkillLevel?: InputMaybe<Scalars['String']>;
  timezoneAbbreviation: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  privacy?: InputMaybe<PlaySessionPrivacyEnum>;
  skillRatingMaximum?: InputMaybe<Scalars['numeric']>;
  skillRatingMinimum?: InputMaybe<Scalars['numeric']>;
  groupId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  commentData?: InputMaybe<Array<PlaySessionCommentsInsertInput> | PlaySessionCommentsInsertInput>;
  data?: InputMaybe<Array<GroupsPlaySessionsInsertInput> | GroupsPlaySessionsInsertInput>;
}>;


export type InsertNewPlaySessionMutation = { __typename?: 'mutation_root', insertPlaySessionsOne?: { __typename?: 'PlaySessions', cancelReason: string, canceledAt?: any | null, deletedAt?: any | null, competitiveness?: PlaySessionMatchCompetitivenessEnum | null, courtBookingStatus: PlaySessionCourtBookingStatusesEnum, createdAt: any, currency: string, description: string, endDateTime?: any | null, extraRacketCount?: number | null, format: PlaySessionFormatsEnum, groupId?: any | null, id: any, isBringingNet: boolean, participantLimit?: number | null, sport: SportsEnum, startDateTime?: any | null, status: PlaySessionStatusesEnum, targetSkillLevel?: string | null, title: string, userCustomCourtId?: any | null, locale: string, timezoneOffsetMinutes: number, timezoneName: string, timezoneAbbreviation: string, publishedAt?: any | null, priceUnitAmount: number, updatedAt: any, organizerUserId?: any | null, privacy: PlaySessionPrivacyEnum, skillRatingMaximum?: any | null, skillRatingMinimum?: any | null, organizerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any } | null, participantsAggregate: { __typename?: 'PlaySessionParticipantsAggregate', aggregate?: { __typename?: 'PlaySessionParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'PlaySessionParticipants', id: any, playSessionId: any, userId: any, status: PlaySessionParticipantStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, providerUrl: string, path: string, url: string }> } | null } | null };

export type UpdateNewPlaySessionByIdMutationVariables = Exact<{
  playSessionId: Scalars['uuid'];
  competitiveness: PlaySessionMatchCompetitivenessEnum;
  courtBookingStatus: PlaySessionCourtBookingStatusesEnum;
  description?: InputMaybe<Scalars['String']>;
  endDateTime: Scalars['timestamptz'];
  extraRacketCount?: InputMaybe<Scalars['Int']>;
  format: PlaySessionFormatsEnum;
  isBringingNet?: InputMaybe<Scalars['Boolean']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  sport: SportsEnum;
  startDateTime: Scalars['timestamptz'];
  status?: InputMaybe<PlaySessionStatusesEnum>;
  targetSkillLevel?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  skillRatingMaximum?: InputMaybe<Scalars['numeric']>;
  skillRatingMinimum?: InputMaybe<Scalars['numeric']>;
  privacy?: InputMaybe<PlaySessionPrivacyEnum>;
  venueId?: InputMaybe<Scalars['uuid']>;
  commentObjects?: InputMaybe<Array<PlaySessionCommentsInsertInput> | PlaySessionCommentsInsertInput>;
}>;


export type UpdateNewPlaySessionByIdMutation = { __typename?: 'mutation_root', updatePlaySessionComments?: { __typename?: 'PlaySessionCommentsMutationResponse', affectedRows: number } | null, updatePlaySessionsByPk?: { __typename?: 'PlaySessions', cancelReason: string, canceledAt?: any | null, deletedAt?: any | null, competitiveness?: PlaySessionMatchCompetitivenessEnum | null, courtBookingStatus: PlaySessionCourtBookingStatusesEnum, createdAt: any, currency: string, description: string, endDateTime?: any | null, extraRacketCount?: number | null, format: PlaySessionFormatsEnum, groupId?: any | null, id: any, isBringingNet: boolean, participantLimit?: number | null, sport: SportsEnum, startDateTime?: any | null, status: PlaySessionStatusesEnum, targetSkillLevel?: string | null, title: string, userCustomCourtId?: any | null, locale: string, timezoneOffsetMinutes: number, timezoneName: string, timezoneAbbreviation: string, publishedAt?: any | null, priceUnitAmount: number, updatedAt: any, organizerUserId?: any | null, privacy: PlaySessionPrivacyEnum, skillRatingMaximum?: any | null, skillRatingMinimum?: any | null, organizerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any } | null, participantsAggregate: { __typename?: 'PlaySessionParticipantsAggregate', aggregate?: { __typename?: 'PlaySessionParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'PlaySessionParticipants', id: any, playSessionId: any, userId: any, status: PlaySessionParticipantStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, providerUrl: string, path: string, url: string }> } | null } | null, insertPlaySessionComments?: { __typename?: 'PlaySessionCommentsMutationResponse', affectedRows: number } | null };

export type UpdateExistingPlaySessionByIdMutationVariables = Exact<{
  playSessionId: Scalars['uuid'];
  title: Scalars['String'];
  description: Scalars['String'];
  sport: SportsEnum;
  format: PlaySessionFormatsEnum;
  targetSkillLevel?: InputMaybe<Scalars['String']>;
  courtBookingStatus: PlaySessionCourtBookingStatusesEnum;
  competitiveness: PlaySessionMatchCompetitivenessEnum;
  extraRacketCount?: InputMaybe<Scalars['Int']>;
  isBringingNet?: InputMaybe<Scalars['Boolean']>;
  participantLimit?: InputMaybe<Scalars['Int']>;
  pickleballRatingScaleId?: InputMaybe<Scalars['uuid']>;
  privacy?: InputMaybe<PlaySessionPrivacyEnum>;
  skillRatingMaximum?: InputMaybe<Scalars['numeric']>;
  skillRatingMinimum?: InputMaybe<Scalars['numeric']>;
  startDateTime: Scalars['timestamptz'];
  endDateTime: Scalars['timestamptz'];
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdateExistingPlaySessionByIdMutation = { __typename?: 'mutation_root', updatePlaySessionsByPk?: { __typename?: 'PlaySessions', cancelReason: string, canceledAt?: any | null, deletedAt?: any | null, competitiveness?: PlaySessionMatchCompetitivenessEnum | null, courtBookingStatus: PlaySessionCourtBookingStatusesEnum, createdAt: any, currency: string, description: string, endDateTime?: any | null, extraRacketCount?: number | null, format: PlaySessionFormatsEnum, groupId?: any | null, id: any, isBringingNet: boolean, participantLimit?: number | null, sport: SportsEnum, startDateTime?: any | null, status: PlaySessionStatusesEnum, targetSkillLevel?: string | null, title: string, userCustomCourtId?: any | null, locale: string, timezoneOffsetMinutes: number, timezoneName: string, timezoneAbbreviation: string, publishedAt?: any | null, priceUnitAmount: number, updatedAt: any, organizerUserId?: any | null, privacy: PlaySessionPrivacyEnum, skillRatingMaximum?: any | null, skillRatingMinimum?: any | null, organizerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any } | null, participantsAggregate: { __typename?: 'PlaySessionParticipantsAggregate', aggregate?: { __typename?: 'PlaySessionParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'PlaySessionParticipants', id: any, playSessionId: any, userId: any, status: PlaySessionParticipantStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, providerUrl: string, path: string, url: string }> } | null } | null };

export type SetPlaySessionAsActiveMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SetPlaySessionAsActiveMutation = { __typename?: 'mutation_root', updatePlaySessionsByPk?: { __typename?: 'PlaySessions', id: any, status: PlaySessionStatusesEnum, publishedAt?: any | null } | null };

export type ChatUserProfileFieldsFragment = { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }> };

export type ChatListRowFieldsFragment = { __typename?: 'ConversationParticipants', id: any, lastReadAt?: any | null, conversation: { __typename?: 'Conversations', id: any, type: ConversationTypesEnum, title?: string | null, imagePath?: string | null, eventId?: any | null, lastMessageAt?: any | null, participants: Array<{ __typename?: 'ConversationParticipants', id: any, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }> } | null }>, messages: Array<{ __typename?: 'Messages', id: any, body: string, createdAt: any, senderUserId: any, senderProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null } | null }> } };

export type GetMyConversationsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetMyConversationsQuery = { __typename?: 'query_root', conversationParticipants: Array<{ __typename?: 'ConversationParticipants', id: any, lastReadAt?: any | null, conversation: { __typename?: 'Conversations', id: any, type: ConversationTypesEnum, title?: string | null, imagePath?: string | null, eventId?: any | null, lastMessageAt?: any | null, participants: Array<{ __typename?: 'ConversationParticipants', id: any, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }> } | null }>, messages: Array<{ __typename?: 'Messages', id: any, body: string, createdAt: any, senderUserId: any, senderProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null } | null }> } }> };

export type SubscribeMyConversationsSubscriptionVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type SubscribeMyConversationsSubscription = { __typename?: 'subscription_root', conversationParticipants: Array<{ __typename?: 'ConversationParticipants', id: any, lastReadAt?: any | null, conversation: { __typename?: 'Conversations', id: any, lastMessageAt?: any | null, messages: Array<{ __typename?: 'Messages', id: any, body: string, createdAt: any, senderUserId: any, senderProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null } | null }> } }> };

export type GetMyPendingChatRequestsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetMyPendingChatRequestsQuery = { __typename?: 'query_root', playRequests: Array<{ __typename?: 'PlayRequests', id: any, createdAt: any, requesterUserId: any, recipientUserId: any, requestMessage?: string | null, eventId?: any | null, availabilityId?: any | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }> } | null, recipientProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }> } | null }> };

export type ChatMessageFieldsFragment = { __typename?: 'Messages', id: any, body: string, createdAt: any, senderUserId: any };

export type GetConversationMessagesQueryVariables = Exact<{
  conversationId: Scalars['uuid'];
  limit: Scalars['Int'];
  before: Scalars['timestamptz'];
}>;


export type GetConversationMessagesQuery = { __typename?: 'query_root', messages: Array<{ __typename?: 'Messages', id: any, body: string, createdAt: any, senderUserId: any }> };

export type StreamConversationMessagesSubscriptionVariables = Exact<{
  conversationId: Scalars['uuid'];
  cursor: Scalars['timestamptz'];
}>;


export type StreamConversationMessagesSubscription = { __typename?: 'subscription_root', messagesStream: Array<{ __typename?: 'Messages', id: any, body: string, createdAt: any, senderUserId: any }> };

export type GetChatConversationQueryVariables = Exact<{
  conversationId: Scalars['uuid'];
}>;


export type GetChatConversationQuery = { __typename?: 'query_root', conversations: Array<{ __typename?: 'Conversations', id: any, type: ConversationTypesEnum, title?: string | null, imagePath?: string | null, eventId?: any | null, lessonId?: any | null, createdByUserId?: any | null, event?: { __typename?: 'Events', id: any, slug: string, title: string, sport: SportsEnum, type: EventTypesEnum, isRfx: boolean, startDateTime: any, endDateTime: any, timezoneName: string, registrationDeadlineDateTime?: any | null, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, isExternal: boolean, sourceRegistrationCount: number, hostUserId?: any | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string }> } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, groups: Array<{ __typename?: 'EventGroups', id: any, startsAt?: any | null, endsAt?: any | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }> } | null, lesson?: { __typename?: 'Lessons', id: any, title: string, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, coverImageProviderUrl: string, venue?: { __typename?: 'Venues', id: any, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null } | null, participants: Array<{ __typename?: 'ConversationParticipants', id: any, userId: any, createdAt: any, lastReadAt?: any | null, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }> } | null }> }> };

export type ChatPlayRequestFieldsFragment = { __typename?: 'PlayRequests', id: any, status: PlayRequestStatusesEnum, createdAt: any, requesterUserId: any, recipientUserId: any, requestMessage?: string | null, responseMessage?: string | null, eventId?: any | null, availabilityId?: any | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }> } | null, recipientProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }> } | null, slots: Array<{ __typename?: 'PlayRequestSlots', id: any, requestedStartAt?: any | null, requestedEndAt?: any | null, availabilitySlot: { __typename?: 'PlayerAvailabilitySlots', id: any, dayOfWeek: string, startTime: any, endTime: any } }>, neighborhoods: Array<{ __typename?: 'PlayRequestNeighborhoods', id: any, neighborhood: { __typename?: 'Neighborhoods', id: any, name: string, city: { __typename?: 'Cities', id: any, timezone?: string | null } } }>, venues: Array<{ __typename?: 'PlayRequestVenues', id: any, venue: { __typename?: 'Venues', id: any, title: string, timezone: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } }> };

export type GetChatPlayRequestForThreadQueryVariables = Exact<{
  conversationId: Scalars['uuid'];
  eventIds: Array<Scalars['uuid']> | Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetChatPlayRequestForThreadQuery = { __typename?: 'query_root', playRequests: Array<{ __typename?: 'PlayRequests', id: any, status: PlayRequestStatusesEnum, createdAt: any, requesterUserId: any, recipientUserId: any, requestMessage?: string | null, responseMessage?: string | null, eventId?: any | null, availabilityId?: any | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }> } | null, recipientProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }> } | null, slots: Array<{ __typename?: 'PlayRequestSlots', id: any, requestedStartAt?: any | null, requestedEndAt?: any | null, availabilitySlot: { __typename?: 'PlayerAvailabilitySlots', id: any, dayOfWeek: string, startTime: any, endTime: any } }>, neighborhoods: Array<{ __typename?: 'PlayRequestNeighborhoods', id: any, neighborhood: { __typename?: 'Neighborhoods', id: any, name: string, city: { __typename?: 'Cities', id: any, timezone?: string | null } } }>, venues: Array<{ __typename?: 'PlayRequestVenues', id: any, venue: { __typename?: 'Venues', id: any, title: string, timezone: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } }> }> };

export type GetChatPlayRequestQueryVariables = Exact<{
  playRequestId: Scalars['uuid'];
}>;


export type GetChatPlayRequestQuery = { __typename?: 'query_root', playRequests: Array<{ __typename?: 'PlayRequests', id: any, status: PlayRequestStatusesEnum, createdAt: any, requesterUserId: any, recipientUserId: any, requestMessage?: string | null, responseMessage?: string | null, eventId?: any | null, availabilityId?: any | null, requesterProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum } | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }> } | null, recipientProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, username?: string | null, profileImagePath?: string | null, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }> } | null, slots: Array<{ __typename?: 'PlayRequestSlots', id: any, requestedStartAt?: any | null, requestedEndAt?: any | null, availabilitySlot: { __typename?: 'PlayerAvailabilitySlots', id: any, dayOfWeek: string, startTime: any, endTime: any } }>, neighborhoods: Array<{ __typename?: 'PlayRequestNeighborhoods', id: any, neighborhood: { __typename?: 'Neighborhoods', id: any, name: string, city: { __typename?: 'Cities', id: any, timezone?: string | null } } }>, venues: Array<{ __typename?: 'PlayRequestVenues', id: any, venue: { __typename?: 'Venues', id: any, title: string, timezone: string, indoorCourtCount: number, outdoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }> } }> }> };

export type MarkConversationReadMutationVariables = Exact<{
  conversationId: Scalars['uuid'];
  userId: Scalars['uuid'];
  readAt: Scalars['timestamptz'];
}>;


export type MarkConversationReadMutation = { __typename?: 'mutation_root', updateConversationParticipants?: { __typename?: 'ConversationParticipantsMutationResponse', returning: Array<{ __typename?: 'ConversationParticipants', id: any, lastReadAt?: any | null }> } | null };

export type GetUserProfileByNameSearchQueryVariables = Exact<{
  name: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetUserProfileByNameSearchQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, username?: string | null, profileImageProviderUrl?: string | null, profileImagePath?: string | null, fullName?: string | null, gender?: string | null, cityName?: string | null }> };

export type GetTrendingLessonsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTrendingLessonsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, type: LessonTypesEnum, sport: SportsEnum, startDateTime?: any | null, priceUnitAmount: number, currency: string, coverImageProviderUrl: string, userCustomCourt?: { __typename?: 'UserCustomCourts', id: any, title: string } | null, venue?: { __typename?: 'Venues', id: any, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string }> } | null, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null } | null }> };

export type GetTrendingLessonsByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTrendingLessonsByGeoQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, type: LessonTypesEnum, sport: SportsEnum, startDateTime?: any | null, priceUnitAmount: number, currency: string, coverImageProviderUrl: string, userCustomCourt?: { __typename?: 'UserCustomCourts', id: any, title: string } | null, venue?: { __typename?: 'Venues', id: any, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string }> } | null, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null } | null }> };

export type GetUpcomingTournamentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetUpcomingTournamentsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, title: string, slug: string, startDateTime: any, registrationPriceUnitAmount: number, currency: string, coverImageProviderUrl?: string | null, displayLocation: string, sourceOrganizerTitle?: string | null, venue?: { __typename?: 'Venues', id: any, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string }> } | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, profileImageProviderUrl?: string | null } | null }> };

export type GetUpcomingTournamentsByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetUpcomingTournamentsByGeoQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, title: string, slug: string, startDateTime: any, registrationPriceUnitAmount: number, currency: string, coverImageProviderUrl?: string | null, displayLocation: string, sourceOrganizerTitle?: string | null, venue?: { __typename?: 'Venues', id: any, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string }> } | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, profileImageProviderUrl?: string | null } | null }> };

export type GetCoachesBySportAndGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  sports: Array<Scalars['String']> | Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetCoachesBySportAndGeoQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, priceUnitAmountRemoteCoachDefault?: number | null, priceUnitAmountCoachDefault?: number | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, username?: string | null, defaultSport?: string | null, geometry?: any | null, isPprMember?: boolean | null, isProfessionalRacquetRegistryActive?: boolean | null, gender?: string | null, aboutMe?: string | null, coachingStartYear?: number | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, stripeMerchantChargesEnabled?: boolean | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null }, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum }>, coachLessonSkillLevels: Array<{ __typename?: 'CoachLessonSkillLevels', skillLevel: string }>, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, status: CoachAvailabilityStatusesEnum }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }> };

export type GetCoachesByNameSearchQueryVariables = Exact<{
  sports: Array<Scalars['String']> | Scalars['String'];
  search: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetCoachesByNameSearchQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, priceUnitAmountRemoteCoachDefault?: number | null, priceUnitAmountCoachDefault?: number | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, username?: string | null, defaultSport?: string | null, geometry?: any | null, isPprMember?: boolean | null, isProfessionalRacquetRegistryActive?: boolean | null, gender?: string | null, aboutMe?: string | null, coachingStartYear?: number | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, stripeMerchantChargesEnabled?: boolean | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null }, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum }>, coachLessonSkillLevels: Array<{ __typename?: 'CoachLessonSkillLevels', skillLevel: string }>, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, status: CoachAvailabilityStatusesEnum }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }> };

export type GetTopRatedCoachesBySportQueryVariables = Exact<{
  sports: Array<Scalars['String']> | Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTopRatedCoachesBySportQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, priceUnitAmountRemoteCoachDefault?: number | null, priceUnitAmountCoachDefault?: number | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, username?: string | null, defaultSport?: string | null, geometry?: any | null, isPprMember?: boolean | null, isProfessionalRacquetRegistryActive?: boolean | null, gender?: string | null, aboutMe?: string | null, coachingStartYear?: number | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, stripeMerchantChargesEnabled?: boolean | null, coachReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null }, coachLessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, coachSports: Array<{ __typename?: 'CoachSports', sport: SportsEnum }>, coachLessonSkillLevels: Array<{ __typename?: 'CoachLessonSkillLevels', skillLevel: string }>, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, status: CoachAvailabilityStatusesEnum }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }> };

export type GetBookableCourtsByGeoQueryVariables = Exact<{
  distance: Scalars['Float'];
  from: Scalars['geography'];
  sportFilter?: InputMaybe<VenuesBoolExp>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetBookableCourtsByGeoQuery = { __typename?: 'query_root', venues: Array<{ __typename?: 'Venues', id: any, title: string, slug: string, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, hasPickleball: boolean, hasTennis: boolean, hasPadel: boolean, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, url: string }> }> };

export type GetTopOpportunityEventsQueryVariables = Exact<{
  area: EventsBoolExp;
  sport: SportsEnum;
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
  venueFilter?: InputMaybe<EventsBoolExp>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTopOpportunityEventsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, slug: string, title: string, sport: SportsEnum, type: EventTypesEnum, isRfx: boolean, groupFormat?: EventGroupFormatsEnum | null, intendedAgeGroup?: EventAgeGroupsEnum | null, startDateTime: any, endDateTime: any, timezoneName: string, description: string, displayLocation: string, addressString?: string | null, latitude?: any | null, longitude?: any | null, coverImageProviderUrl?: string | null, registrationPriceUnitAmount: number, currency: string, participantLimit?: number | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, addressString: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string }> } | null, groups: Array<{ __typename?: 'EventGroups', id: any, competitiveness?: EventCompetitivenessEnum | null, isVairRatingSession?: boolean | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, profileImageProviderUrl?: string | null } | null }> }> };

export type GetTopOpportunityLessonsQueryVariables = Exact<{
  area: LessonsBoolExp;
  sport: SportsEnum;
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
  venueFilter?: InputMaybe<LessonsBoolExp>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTopOpportunityLessonsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, sport: SportsEnum, type: LessonTypesEnum, intendedAgeGroup?: EventAgeGroupsEnum | null, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, description: string, coverImageProviderUrl: string, priceUnitAmount: number, currency: string, participantLimit?: number | null, externalBookingUrl: string, skillLevels: Array<{ __typename?: 'LessonSkillLevels', id: any, skillLevel: string }>, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageUrl?: string | null } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', id: any, title: string, fullAddress: string, latitude?: any | null, longitude?: any | null } | null, venue?: { __typename?: 'Venues', id: any, title: string, timezone: string, addressString: string, latitude: any, longitude: any, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string }> } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, profileImageProviderUrl?: string | null } | null }> }> };

export type GetPlayerVenuesQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetPlayerVenuesQuery = { __typename?: 'query_root', venueFollows: Array<{ __typename?: 'VenueFollows', id: any, venue: { __typename?: 'Venues', id: any, title: string, geometry?: any | null, slug: string, pickleballLines?: VenueLinesEnum | null, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, images: Array<{ __typename?: 'VenueImages', id: any, isVisible: boolean, fileName: string, path: string, provider: string, url: string }>, city?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string } } | null, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } }> };

export type GetLatestRecapQueryVariables = Exact<{
  playerUserId: Scalars['uuid'];
}>;


export type GetLatestRecapQuery = { __typename?: 'query_root', lessonReflections: Array<{ __typename?: 'LessonReflections', id: any, createdAt: any, playerDismissedAt?: any | null, lessonId: any, details?: string | null, lesson: { __typename?: 'Lessons', times: Array<{ __typename?: 'LessonTimes', startDateTime: any }> }, lessonCoach?: { __typename?: 'UserProfiles', fullName?: string | null, profileImageProviderUrl?: string | null, profileImagePath?: string | null, id?: any | null } | null, files: Array<{ __typename?: 'LessonReflectionFiles', providerUrl: string, url: string, transcript: string, fileFormat: string }>, lessonReflectionComments: Array<{ __typename?: 'LessonReflectionComments', skill?: LessonSkillsEnum | null, customSkill?: string | null, type: LessonReflectionCommentTypesEnum }> }> };

export type DismissLatestRecapMutationVariables = Exact<{
  id: Scalars['uuid'];
  playerDismissedAt: Scalars['timestamptz'];
}>;


export type DismissLatestRecapMutation = { __typename?: 'mutation_root', updateLessonReflectionsByPk?: { __typename?: 'LessonReflections', id: any, playerDismissedAt?: any | null } | null };

export type GetPlayerReflectionByLessonIdQueryVariables = Exact<{
  lessonId: Scalars['uuid'];
  playerUserId: Scalars['uuid'];
}>;


export type GetPlayerReflectionByLessonIdQuery = { __typename?: 'query_root', lessonPlayerSkillAssessments: Array<{ __typename?: 'LessonPlayerSkillAssessments', id: any }> };

export type GetParticipatedEventsByUserIdQueryVariables = Exact<{
  userId: Scalars['uuid'];
  startDate: Scalars['timestamptz'];
}>;


export type GetParticipatedEventsByUserIdQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, addressString?: string | null, coverImagePath?: string | null, displayLocation: string, endDateTime: any, hasPrizes: boolean, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, slug: string, isExternal: boolean, currency: string, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, startDateTime: any, status: EventStatusesEnum, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, city?: { __typename?: 'Cities', name: string, id: any, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null } }> };

export type GetHostedEventsByUserIdQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetHostedEventsByUserIdQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'Events', id: any, addressString?: string | null, coverImagePath?: string | null, displayLocation: string, endDateTime: any, hasPrizes: boolean, latitude?: any | null, locale: string, longitude?: any | null, organizerImagePath?: string | null, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, slug: string, isExternal: boolean, currency: string, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, startDateTime: any, status: EventStatusesEnum, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, city?: { __typename?: 'Cities', name: string, id: any, timezone?: string | null, countrySubdivision: { __typename?: 'CountrySubdivisions', name: string, id: any, code: string } } | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null } }> };

export type PlayerProfileFieldsFragment = { __typename?: 'UserProfiles', id?: any | null, username?: string | null, fullName?: string | null, preferredName?: string | null, cityName?: string | null, gender?: string | null, aboutMe?: string | null, coachStatus?: string | null, profileImagePath?: string | null, coverImagePath?: string | null, instagramUrl?: string | null, facebookUrl?: string | null, tiktokUrl?: string | null, linkedinUrl?: string | null, xUrl?: string | null, birthdayMonth?: number | null, birthdayDay?: number | null, birthdayYear?: number | null, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, padelSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, sports: Array<{ __typename?: 'UserSports', id: any, sport: SportsEnum }>, pickleballRatingScales: Array<{ __typename?: 'UserPickleballRatingScales', id: any, rating: any, scale: { __typename?: 'PickleballRatingScales', id: any, shortName: string } }>, tennisRatingScales: Array<{ __typename?: 'UserTennisRatingScales', id: any, rating: any, scale: { __typename?: 'TennisRatingScales', id: any, shortName: string } }>, padelRatingScales: Array<{ __typename?: 'UserPadelRatingScales', id: any, rating: any, scale: { __typename?: 'PadelRatingScales', id: any, shortName: string } }>, playerFinderAvailability: Array<{ __typename?: 'UserPlayerFinderAvailability', dayOfWeek: DayOfWeekEnum, timeOfDay: PlayerFinderTimeOfDayEnum }>, venueFollows: Array<{ __typename?: 'VenueFollows', id: any, venue: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, indoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string }> } }>, userFiles: Array<{ __typename?: 'UserFiles', id: any, url: string, path: string, providerUrl: string, fileFormat: FileFormatEnum }>, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, playerReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null }, playerReviews: Array<{ __typename?: 'Reviews', id: any, rating: number, review?: string | null, createdAt: any, externalFullName?: string | null, reviewer?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null } | null }> };

export type GetPlayerProfilePublicQueryVariables = Exact<{
  username: Scalars['String'];
  now: Scalars['timestamptz'];
}>;


export type GetPlayerProfilePublicQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, username?: string | null, fullName?: string | null, preferredName?: string | null, cityName?: string | null, gender?: string | null, aboutMe?: string | null, coachStatus?: string | null, profileImagePath?: string | null, coverImagePath?: string | null, instagramUrl?: string | null, facebookUrl?: string | null, tiktokUrl?: string | null, linkedinUrl?: string | null, xUrl?: string | null, birthdayMonth?: number | null, birthdayDay?: number | null, birthdayYear?: number | null, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, padelSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, sports: Array<{ __typename?: 'UserSports', id: any, sport: SportsEnum }>, pickleballRatingScales: Array<{ __typename?: 'UserPickleballRatingScales', id: any, rating: any, scale: { __typename?: 'PickleballRatingScales', id: any, shortName: string } }>, tennisRatingScales: Array<{ __typename?: 'UserTennisRatingScales', id: any, rating: any, scale: { __typename?: 'TennisRatingScales', id: any, shortName: string } }>, padelRatingScales: Array<{ __typename?: 'UserPadelRatingScales', id: any, rating: any, scale: { __typename?: 'PadelRatingScales', id: any, shortName: string } }>, playerFinderAvailability: Array<{ __typename?: 'UserPlayerFinderAvailability', dayOfWeek: DayOfWeekEnum, timeOfDay: PlayerFinderTimeOfDayEnum }>, venueFollows: Array<{ __typename?: 'VenueFollows', id: any, venue: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, indoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string }> } }>, userFiles: Array<{ __typename?: 'UserFiles', id: any, url: string, path: string, providerUrl: string, fileFormat: FileFormatEnum }>, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, playerReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null }, playerReviews: Array<{ __typename?: 'Reviews', id: any, rating: number, review?: string | null, createdAt: any, externalFullName?: string | null, reviewer?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null } | null }> }>, hostedGamesAggregate: { __typename?: 'EventsAggregate', aggregate?: { __typename?: 'EventsAggregateFields', count: number } | null }, joinedGamesAggregate: { __typename?: 'EventAcceptedPlayRequestsAggregate', aggregate?: { __typename?: 'EventAcceptedPlayRequestsAggregateFields', count: number } | null } };

export type GetPlayerProfileQueryVariables = Exact<{
  username: Scalars['String'];
  viewerId: Scalars['uuid'];
  now: Scalars['timestamptz'];
}>;


export type GetPlayerProfileQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, username?: string | null, fullName?: string | null, preferredName?: string | null, cityName?: string | null, gender?: string | null, aboutMe?: string | null, coachStatus?: string | null, profileImagePath?: string | null, coverImagePath?: string | null, instagramUrl?: string | null, facebookUrl?: string | null, tiktokUrl?: string | null, linkedinUrl?: string | null, xUrl?: string | null, birthdayMonth?: number | null, birthdayDay?: number | null, birthdayYear?: number | null, viewerReview: Array<{ __typename?: 'Reviews', id: any }>, pickleballSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, tennisSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, padelSkillLevel?: { __typename?: 'SkillLevels', id: SkillLevelValuesEnum, displayName: string } | null, sports: Array<{ __typename?: 'UserSports', id: any, sport: SportsEnum }>, pickleballRatingScales: Array<{ __typename?: 'UserPickleballRatingScales', id: any, rating: any, scale: { __typename?: 'PickleballRatingScales', id: any, shortName: string } }>, tennisRatingScales: Array<{ __typename?: 'UserTennisRatingScales', id: any, rating: any, scale: { __typename?: 'TennisRatingScales', id: any, shortName: string } }>, padelRatingScales: Array<{ __typename?: 'UserPadelRatingScales', id: any, rating: any, scale: { __typename?: 'PadelRatingScales', id: any, shortName: string } }>, playerFinderAvailability: Array<{ __typename?: 'UserPlayerFinderAvailability', dayOfWeek: DayOfWeekEnum, timeOfDay: PlayerFinderTimeOfDayEnum }>, venueFollows: Array<{ __typename?: 'VenueFollows', id: any, venue: { __typename?: 'Venues', id: any, title: string, addressString: string, latitude: any, longitude: any, indoorCourtCount: number, images: Array<{ __typename?: 'VenueImages', id: any, url: string }> } }>, userFiles: Array<{ __typename?: 'UserFiles', id: any, url: string, path: string, providerUrl: string, fileFormat: FileFormatEnum }>, identityVerifications: Array<{ __typename?: 'UserIdentityVerifications', status: IdentityVerificationStatusesEnum }>, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null }, playerReviewsAggregate: { __typename?: 'ReviewsAggregate', aggregate?: { __typename?: 'ReviewsAggregateFields', count: number, avg?: { __typename?: 'ReviewsAvgFields', rating?: number | null } | null } | null }, playerReviews: Array<{ __typename?: 'Reviews', id: any, rating: number, review?: string | null, createdAt: any, externalFullName?: string | null, reviewer?: { __typename?: 'UserProfiles', id?: any | null, username?: string | null, fullName?: string | null, preferredName?: string | null, profileImagePath?: string | null } | null }> }>, userFollows: Array<{ __typename?: 'UserFollows', status: FollowStatusesEnum, followedUserId: any, followerUserId: any }>, acceptedPlayRequests: Array<{ __typename?: 'PlayRequests', id: any }>, hostedGamesAggregate: { __typename?: 'EventsAggregate', aggregate?: { __typename?: 'EventsAggregateFields', count: number } | null }, joinedGamesAggregate: { __typename?: 'EventAcceptedPlayRequestsAggregate', aggregate?: { __typename?: 'EventAcceptedPlayRequestsAggregateFields', count: number } | null } };

export type GetUserEnrolledProgramsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetUserEnrolledProgramsQuery = { __typename?: 'query_root', learningProgramEnrollments: Array<{ __typename?: 'LearningProgramEnrollments', id: any, status: string, enrolledAt: any, currentSchedule: number, learningProgram: { __typename?: 'LearningPrograms', id: any, title: string, sportId: SportsEnum, skillLevelId?: LearningProgramSkillLevelValuesEnum | null, totalSchedules: number, scheduleUnit: LearningProgramScheduleUnitsEnum, sport: { __typename?: 'Sports', value: string, description?: string | null }, skillLevel?: { __typename?: 'LearningProgramSkillLevelValues', value: string, description?: string | null } | null, skills: Array<{ __typename?: 'LearningProgramSkills', id: any, skillId: LessonSkillsEnum, isPrimary: boolean, skill: { __typename?: 'LessonSkills', value: string, description?: string | null } }> }, scheduleProgress: Array<{ __typename?: 'LearningProgramEnrollmentScheduleProgress', id: any, scheduleNumber: number, learningProgramScheduleId: any, completedAt?: any | null, mediaWatched: Array<{ __typename?: 'LearningProgramEnrollmentScheduleMediaWatched', id: any, watchedAt: any, mediaCategory: { __typename?: 'LearningProgramMediaCategories', id: any, code: string } }>, learningProgramSchedule: { __typename?: 'LearningProgramSchedules', id: any, scheduleNumber: number, title: string, media: Array<{ __typename?: 'LearningProgramScheduleMedia', mediaCategory: { __typename?: 'LearningProgramMediaCategories', id: any } }> } }>, videoSubmissions: Array<{ __typename?: 'LearningProgramScheduleVideoSubmissions', learningProgramScheduleId: any, videoAnalysis?: { __typename?: 'VideoAnalysis', id: any, reviewStatus?: VideoAnalysisReviewStatusesEnum | null } | null }> }> };

export type GetPlayerUserContentSubscribeStatusQueryVariables = Exact<{
  coachId: Scalars['uuid'];
  playerId: Scalars['uuid'];
}>;


export type GetPlayerUserContentSubscribeStatusQuery = { __typename?: 'query_root', userContentBetaSubscriptions: Array<{ __typename?: 'UserContentBetaSubscriptions', id: any, createdAt: any, subscriberUserId: any }> };

export type UpdateCoachProfileMutationVariables = Exact<{
  id: Scalars['uuid'];
  fullName?: InputMaybe<Scalars['String']>;
  aboutMe?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  existingCoachServices?: InputMaybe<Array<UserCoachServicesUpdates> | UserCoachServicesUpdates>;
  newCoachServices?: InputMaybe<Array<UserCoachServicesInsertInput> | UserCoachServicesInsertInput>;
  qualificationObjects?: InputMaybe<Array<UsersCoachQualificationsInsertInput> | UsersCoachQualificationsInsertInput>;
}>;


export type UpdateCoachProfileMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, fullName: string, preferredName: string, username?: string | null, aboutMe?: string | null, countryId?: string | null, countrySubdivisionId?: any | null, cityName: string, profile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, aboutMe?: string | null, username?: string | null, countryId?: string | null, countrySubdivisionId?: any | null, cityName?: string | null } | null } | null, updateUserCoachServicesMany?: Array<{ __typename?: 'UserCoachServicesMutationResponse', returning: Array<{ __typename?: 'UserCoachServices', coverImageUrl: string, currency: string, description: string, id: any, priceUnitAmount: number, title: string, type?: LessonTypesEnum | null, userId: any }> } | null> | null, insertUserCoachServices?: { __typename?: 'UserCoachServicesMutationResponse', returning: Array<{ __typename?: 'UserCoachServices', coverImageUrl: string, currency: string, description: string, id: any, priceUnitAmount: number, title: string, type?: LessonTypesEnum | null, userId: any }> } | null, insertUsersCoachQualifications?: { __typename?: 'UsersCoachQualificationsMutationResponse', returning: Array<{ __typename?: 'UsersCoachQualifications', id: any, status: CoachQualificationStatusesEnum, coachQualificationId: any, userId: any }> } | null };

export type UpdatePlayerProfileMutationVariables = Exact<{
  id: Scalars['uuid'];
  fullName?: InputMaybe<Scalars['String']>;
  aboutMe?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  normalizedTennisRating?: InputMaybe<Scalars['numeric']>;
  normalizedTennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
  tennisRating?: InputMaybe<Scalars['numeric']>;
  tennisRatingScaleId?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdatePlayerProfileMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, fullName: string, preferredName: string, username?: string | null, aboutMe?: string | null, countryId?: string | null, countrySubdivisionId?: any | null, cityName: string, normalizedTennisRating?: any | null, normalizedTennisRatingScaleId?: any | null, tennisRating?: any | null, tennisRatingScaleId?: any | null, profile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, aboutMe?: string | null, username?: string | null, countryId?: string | null, countrySubdivisionId?: any | null, cityName?: string | null, normalizedTennisRating?: any | null, normalizedTennisRatingScaleId?: any | null, tennisRating?: any | null, tennisRatingScaleId?: any | null } | null } | null };

export type GetCountriesAndActiveSubdivisionsQueryVariables = Exact<{
  countryId: Scalars['String'];
}>;


export type GetCountriesAndActiveSubdivisionsQuery = { __typename?: 'query_root', countries: Array<{ __typename?: 'Countries', id: string, name: string, slug: string }>, countrySubdivisions: Array<{ __typename?: 'CountrySubdivisions', id: any, name: string, type: string }> };

export type GetAvailableCoachQualificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableCoachQualificationsQuery = { __typename?: 'query_root', coachQualifications: Array<{ __typename?: 'CoachQualifications', id: any, name: string, order: number, groupId?: CoachQualificationGroupsEnum | null, displayKey: string }> };

export type GetTennisRatingScalesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTennisRatingScalesQuery = { __typename?: 'query_root', tennisRatingScales: Array<{ __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string }> };

export type GetCoachEarningsUnitAmountQueryVariables = Exact<{
  sellerUserId: Scalars['uuid'];
}>;


export type GetCoachEarningsUnitAmountQuery = { __typename?: 'query_root', lessonOrdersAggregate: { __typename?: 'LessonOrdersAggregate', aggregate?: { __typename?: 'LessonOrdersAggregateFields', sum?: { __typename?: 'LessonOrdersSumFields', transferUnitAmount?: number | null } | null } | null } };

export type UpdatePlayerPhoneMutationVariables = Exact<{
  id: Scalars['uuid'];
  phoneNumber: Scalars['String'];
  phoneCountryCode: Scalars['String'];
}>;


export type UpdatePlayerPhoneMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, phoneNumber?: string | null, phoneCountryCode?: string | null } | null };

export type GetUserProgramTemplatesQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserProgramTemplatesQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: any, lessonTemplates: Array<{ __typename?: 'LessonTemplates', coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, eventType?: EventTypesEnum | null, externalUrl?: string | null, id: any, originalEventId?: any | null, originalLessonId?: any | null, participantLimit: number, priceUnitAmount: number, privacy?: LessonPrivacyEnum | null, templateName: string, title: string, type?: LessonTypesEnum | null, typeCustom: string, updatedAt: any, userId?: any | null, userCustomCourtId?: any | null, sport?: SportsEnum | null, intendedAgeGroup?: EventAgeGroupsEnum | null, skillLevels: Array<{ __typename?: 'LessonTemplateSkillLevels', skillLevel: string }>, originalLesson?: { __typename?: 'Lessons', userCustomCourtId?: any | null, venue?: { __typename?: 'Venues', addressString: string, id: any } | null } | null, originalEvent?: { __typename?: 'Events', venue?: { __typename?: 'Venues', addressString: string, id: any } | null } | null }> } | null };

export type InsertProgramLessonMutationVariables = Exact<{
  title: Scalars['String'];
  sport: SportsEnum;
  type: LessonTypesEnum;
  typeCustom?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LessonStatusesEnum>;
  description?: InputMaybe<Scalars['String']>;
  startDateTime: Scalars['timestamptz'];
  endDateTime: Scalars['timestamptz'];
  ownerUserId: Scalars['uuid'];
  participantLimit: Scalars['Int'];
  paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum;
  priceUnitAmount: Scalars['Int'];
  privacy?: InputMaybe<LessonPrivacyEnum>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  usedTemplateId?: InputMaybe<Scalars['uuid']>;
  lessonTimeData: Array<LessonTimesInsertInput> | LessonTimesInsertInput;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  locale: Scalars['String'];
  timezoneName: Scalars['String'];
  timezoneAbbreviation: Scalars['String'];
  timezoneOffsetMinutes: Scalars['Int'];
  currency: Scalars['String'];
  externalBookingUrl?: InputMaybe<Scalars['String']>;
}>;


export type InsertProgramLessonMutation = { __typename?: 'mutation_root', insertLessonsOne?: { __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> } | null };

export type UpdateProgramLessonMutationVariables = Exact<{
  lessonId: Scalars['uuid'];
  title: Scalars['String'];
  sport: SportsEnum;
  type: LessonTypesEnum;
  typeCustom?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LessonStatusesEnum>;
  description?: InputMaybe<Scalars['String']>;
  startDateTime: Scalars['timestamptz'];
  endDateTime: Scalars['timestamptz'];
  participantLimit: Scalars['Int'];
  paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum;
  priceUnitAmount: Scalars['Int'];
  privacy?: InputMaybe<LessonPrivacyEnum>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  coverImageFileName?: InputMaybe<Scalars['String']>;
  coverImagePath?: InputMaybe<Scalars['String']>;
  coverImageProvider?: InputMaybe<Scalars['String']>;
  coverImageProviderId?: InputMaybe<Scalars['String']>;
  coverImageProviderUrl?: InputMaybe<Scalars['String']>;
  usedTemplateId?: InputMaybe<Scalars['uuid']>;
  userCustomCourtId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  currency: Scalars['String'];
  externalBookingUrl?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProgramLessonMutation = { __typename?: 'mutation_root', updateLessonsByPk?: { __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> } | null };

export type GetProgramLessonByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetProgramLessonByIdQuery = { __typename?: 'query_root', lessonsByPk?: { __typename?: 'Lessons', id: any, title: string, sport: SportsEnum, type: LessonTypesEnum, typeCustom: string, description: string, startDateTime?: any | null, endDateTime?: any | null, priceUnitAmount: number, currency: string, participantLimit?: number | null, recurrenceKind?: RecurrenceKindsEnum | null, lessonCollectionId?: any | null, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, externalBookingUrl: string, intendedAgeGroup?: EventAgeGroupsEnum | null, coverImageUrl: string, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderUrl: string, venueId?: any | null, ownerProfile?: { __typename?: 'UserProfiles', username?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, latitude: any, longitude: any } | null, times: Array<{ __typename?: 'LessonTimes', id: any, startDateTime: any, endDateTime: any }>, skillLevels: Array<{ __typename?: 'LessonSkillLevels', skillLevel: string }> } | null };

export type InsertProgramEventMutationVariables = Exact<{
  object: EventsInsertInput;
}>;


export type InsertProgramEventMutation = { __typename?: 'mutation_root', insertEventsOne?: { __typename?: 'Events', id: any, slug: string, title: string, type: EventTypesEnum } | null };

export type InsertProgramEventCollectionMutationVariables = Exact<{
  object: EventCollectionsInsertInput;
}>;


export type InsertProgramEventCollectionMutation = { __typename?: 'mutation_root', insertEventCollectionsOne?: { __typename?: 'EventCollections', id: any, slug: string, events: Array<{ __typename?: 'Events', id: any, slug: string }> } | null };

export type InsertProgramLessonV2MutationVariables = Exact<{
  object: LessonsInsertInput;
}>;


export type InsertProgramLessonV2Mutation = { __typename?: 'mutation_root', insertLessonsOne?: { __typename?: 'Lessons', id: any } | null };

export type UpdateProgramLessonV2MutationVariables = Exact<{
  lessonId: Scalars['uuid'];
  set: LessonsSetInput;
  lessonTimes: Array<LessonTimesInsertInput> | LessonTimesInsertInput;
  removedTimeIds: Array<Scalars['uuid']> | Scalars['uuid'];
  skillLevelObjects: Array<LessonSkillLevelsInsertInput> | LessonSkillLevelsInsertInput;
}>;


export type UpdateProgramLessonV2Mutation = { __typename?: 'mutation_root', updateLessonsByPk?: { __typename?: 'Lessons', id: any } | null, insertLessonTimes?: { __typename?: 'LessonTimesMutationResponse', affectedRows: number } | null, softDeleteRemovedLessonTimes?: { __typename?: 'LessonTimesMutationResponse', affectedRows: number } | null, deleteLessonSkillLevels?: { __typename?: 'LessonSkillLevelsMutationResponse', affectedRows: number } | null, insertLessonSkillLevels?: { __typename?: 'LessonSkillLevelsMutationResponse', affectedRows: number } | null };

export type InsertProgramLessonCollectionMutationVariables = Exact<{
  object: LessonCollectionsInsertInput;
}>;


export type InsertProgramLessonCollectionMutation = { __typename?: 'mutation_root', insertLessonCollectionsOne?: { __typename?: 'LessonCollections', id: any, lessons: Array<{ __typename?: 'Lessons', id: any }> } | null };

export type GetProgramEventByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetProgramEventByIdQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', id: any, title: string, type: EventTypesEnum, sport: SportsEnum, description: string, startDateTime: any, endDateTime: any, timezoneName: string, registrationDeadlineDate: any, registrationDeadlineDateTime?: any | null, isRatingRequired: boolean, registrationPriceUnitAmount: number, scheduleInfo?: string | null, intendedAgeGroup?: EventAgeGroupsEnum | null, currency: string, participantLimit?: number | null, externalUrl?: string | null, coverImageUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProvider?: string | null, coverImageProviderUrl?: string | null, venueId?: any | null, addressString?: string | null, displayLocation: string, latitude?: any | null, longitude?: any | null, skillLevels: Array<{ __typename?: 'EventSkillLevels', skillLevel: string }>, venue?: { __typename?: 'Venues', id: any, addressString: string, latitude: any, longitude: any } | null } | null };

export type UpdateProgramEventMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  set: EventsSetInput;
  skillLevelObjects: Array<EventSkillLevelsInsertInput> | EventSkillLevelsInsertInput;
}>;


export type UpdateProgramEventMutation = { __typename?: 'mutation_root', updateEventsByPk?: { __typename?: 'Events', id: any } | null, deleteEventSkillLevels?: { __typename?: 'EventSkillLevelsMutationResponse', affectedRows: number } | null, insertEventSkillLevels?: { __typename?: 'EventSkillLevelsMutationResponse', affectedRows: number } | null };

export type DeleteProgramTemplateMutationVariables = Exact<{
  id: Scalars['uuid'];
  deletedAt: Scalars['timestamptz'];
}>;


export type DeleteProgramTemplateMutation = { __typename?: 'mutation_root', updateLessonTemplatesByPk?: { __typename?: 'LessonTemplates', id: any } | null };

export type SoftDeleteProgramEventMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SoftDeleteProgramEventMutation = { __typename?: 'mutation_root', updateEventsByPk?: { __typename?: 'Events', id: any } | null };

export type GetQuatroUpcomingClinicLessonsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetQuatroUpcomingClinicLessonsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> }>, lessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null } };

export type GetQuatroCoachesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetQuatroCoachesQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, priceUnitAmountRemoteCoachDefault?: number | null, priceUnitAmountCoachDefault?: number | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, username?: string | null, defaultSport?: string | null, geometry?: any | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }>, userProfilesAggregate: { __typename?: 'UserProfilesAggregate', aggregate?: { __typename?: 'UserProfilesAggregateFields', count: number } | null } };

export type GetQuatroCoachesByLocationQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  from: Scalars['geography'];
  distance: Scalars['Float'];
}>;


export type GetQuatroCoachesByLocationQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, priceUnitAmountRemoteCoachDefault?: number | null, priceUnitAmountCoachDefault?: number | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, username?: string | null, defaultSport?: string | null, geometry?: any | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }>, userProfilesAggregate: { __typename?: 'UserProfilesAggregate', aggregate?: { __typename?: 'UserProfilesAggregateFields', count: number } | null } };

export type GetQuatroUpcomingClinicLessonsByLocationQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  from: Scalars['geography'];
  distance: Scalars['Float'];
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetQuatroUpcomingClinicLessonsByLocationQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> }>, lessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null } };

export type GetQuatroUpcomingRetreatLessonsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetQuatroUpcomingRetreatLessonsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> }>, lessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null } };

export type GetFoundingCoachesQueryVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetFoundingCoachesQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, priceUnitAmountRemoteCoachDefault?: number | null, priceUnitAmountCoachDefault?: number | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, username?: string | null, defaultSport?: string | null, geometry?: any | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }> };

export type GetCertifiedCoachesQueryVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetCertifiedCoachesQuery = { __typename?: 'query_root', userProfiles: Array<{ __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, priceUnitAmountRemoteCoachDefault?: number | null, priceUnitAmountCoachDefault?: number | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, username?: string | null, defaultSport?: string | null, geometry?: any | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } }>, userProfilesAggregate: { __typename?: 'UserProfilesAggregate', aggregate?: { __typename?: 'UserProfilesAggregateFields', count: number } | null } };

export type GetCoachServicesStatsQueryVariables = Exact<{
  coachId: Scalars['uuid'];
}>;


export type GetCoachServicesStatsQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, orders: Array<{ __typename?: 'LessonOrders', paidUnitAmount: number }> }>, videoAnalysis: Array<{ __typename?: 'VideoAnalysis', id: any, orders: Array<{ __typename?: 'VideoAnalysisOrders', id: any, paidUnitAmount: number }> }>, userContentBetaSubscriptions: Array<{ __typename?: 'UserContentBetaSubscriptions', id: any }> };

export type UpdateUserOnCourtLessonServiceMutationVariables = Exact<{
  userId: Scalars['uuid'];
  objects?: InputMaybe<Array<CoachAvailabilityInsertInput> | CoachAvailabilityInsertInput>;
  priceUnitAmountCoachDefault: Scalars['Int'];
  coachExternalBookingUrl?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserOnCourtLessonServiceMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, priceUnitAmountCoachDefault?: number | null, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, endTimeMinutes: number, dayOfWeek: DayOfWeekEnum, startTimeMinutes: number }> } | null, deleteCoachAvailability?: { __typename?: 'CoachAvailabilityMutationResponse', returning: Array<{ __typename?: 'CoachAvailability', id: any, startTimeMinutes: number, endTimeMinutes: number, dayOfWeek: DayOfWeekEnum }> } | null, insertCoachAvailability?: { __typename?: 'CoachAvailabilityMutationResponse', returning: Array<{ __typename?: 'CoachAvailability', id: any, endTimeMinutes: number, startTimeMinutes: number, dayOfWeek: DayOfWeekEnum }> } | null };

export type UpdateUserRemoteLessonServiceMutationVariables = Exact<{
  userId: Scalars['uuid'];
  priceUnitAmountRemoteCoachDefault: Scalars['Int'];
}>;


export type UpdateUserRemoteLessonServiceMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, priceUnitAmountRemoteCoachDefault?: number | null } | null };

export type DeleteCoachPremiumContentMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteCoachPremiumContentMutation = { __typename?: 'mutation_root', deleteUserContentFilesByPk?: { __typename?: 'UserContentFiles', id: any } | null };

export type GetMyPastCourtBookingsQueryVariables = Exact<{
  before: Scalars['timestamptz'];
  statuses: Array<PartnerBookingOrderStatusesEnum> | PartnerBookingOrderStatusesEnum;
}>;


export type GetMyPastCourtBookingsQuery = { __typename?: 'query_root', partnerBookingOrders: Array<{ __typename?: 'PartnerBookingOrders', id: any, status: PartnerBookingOrderStatusesEnum, startAt: any, endAt: any, timezone: string, venue: { __typename?: 'Venues', id: any, title: string, slug: string, timezone: string, addressString: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string }> } }> };

export type GetEventCouponsQueryVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type GetEventCouponsQuery = { __typename?: 'query_root', eventCoupons: Array<{ __typename?: 'EventCoupons', id: any, name: string, code: string, source: EventCouponSourceEnum, couponType: EventCouponTypeEnum, percentOff?: any | null, amountOff?: number | null, fixedPrice?: number | null, isAutoApply: boolean, validFrom?: any | null, validUntil?: any | null, tierPriority: number, maxRedemptions?: number | null, isActive: boolean, couponGroups: Array<{ __typename?: 'EventCouponGroups', id: any, eventGroupId: any }>, redemptionsAggregate: { __typename?: 'EventCouponRedemptionsAggregate', aggregate?: { __typename?: 'EventCouponRedemptionsAggregateFields', count: number } | null } }> };

export type GetCheckInParticipantsQueryVariables = Exact<{
  eventId: Scalars['uuid'];
  search: Scalars['String'];
}>;


export type GetCheckInParticipantsQuery = { __typename?: 'query_root', eventGroupRegistrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, userId: any, checkedInAt?: any | null, group: { __typename?: 'EventGroups', id: any, title: string }, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }> };

export type GetEventDetailsQueryVariables = Exact<{
  id: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetEventDetailsQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', addressString?: string | null, cityId?: any | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageUrl?: string | null, currency: string, longitude?: any | null, latitude?: any | null, createdAt: any, description: string, displayLocation: string, endDate: any, endDateTime: any, externalUrl?: string | null, geometry?: any | null, hasPrizes: boolean, id: any, isExternal: boolean, isShowPlayersGoing: boolean, organizerImageUrl?: string | null, organizerImagePath?: string | null, locale: string, isSanctioned: boolean, privacy: EventPrivacyEnum, prizeDescription: string, publishedAt?: any | null, canceledAt?: any | null, cancelReason: string, registrationClosedAt?: any | null, registrationDeadlineDate: any, registrationDeadlineDateTime?: any | null, registrationPriceUnitAmount: number, registrationOpenDate?: any | null, registrationOpenDateTime?: any | null, isRatingRequired: boolean, slug: string, scoringFormat?: ScoringFormatEnum | null, sport: SportsEnum, startDate: any, startDateTime: any, status: EventStatusesEnum, title: string, type: EventTypesEnum, isRfx: boolean, timezoneName: string, timezoneOffsetMinutes: number, timezoneAbbreviation: string, sourceRegistrationCount: number, sourceOrganizerTitle?: string | null, groupFormat?: EventGroupFormatsEnum | null, isQuickCreate: boolean, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, isVairRequired?: boolean | null, ballCustomName: string, ballType: BallTypesEnum, city?: { __typename?: 'Cities', id: any, name: string, slug: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string, slug: string, code: string, country: { __typename?: 'Countries', id: string, name: string, slug: string } } } | null, venue?: { __typename?: 'Venues', id: any, title: string, slug: string, pickleballLines?: VenueLinesEnum | null, pickleballNets?: VenueNetsEnum | null, longitude: any, latitude: any, geometry?: any | null, addressString: string, outdoorCourtCount: number, indoorCourtCount: number, timezone: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, shortName: string } | null, hostUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImageProvider?: string | null, stripeMerchantDetailsSubmitted?: boolean | null } | null, faqs: Array<{ __typename?: 'EventFaqs', id: any, question: string, answer: string }>, registrations: Array<{ __typename?: 'EventRegistrations', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, username?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }>, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, sponsors: Array<{ __typename?: 'EventSponsors', id: any, name: string, imageUrl: string, imagePath: string, imageProvider: string, imageProviderUrl: string, imageHost: string, isTitleSponsor: boolean, categoryName: string }>, groups: Array<{ __typename?: 'EventGroups', id: any, gender: CompetitionGenderEnum, gamesPerMatch: number, formatCustomName: string, format?: EventGroupFormatsEnum | null, endsAt?: any | null, maximumAge?: number | null, maximumRating?: any | null, minimumNumberOfGames: number, minimumAge?: number | null, minimumRating?: any | null, priceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, startsAt?: any | null, teamLimit?: number | null, teamType?: TeamTypesEnum | null, title: string, totalPoints?: number | null, winBy?: number | null, isAgeRestricted: boolean, isWheelchair?: boolean | null, isVairVairifiedRequired?: boolean | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }>, teams: Array<{ __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', id: any, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }> }>, registrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, userId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }>, sequences: Array<{ __typename?: 'EventGroupSequences', id: any, isSequenceComplete: boolean, nextSequenceId?: any | null }> }> } | null };

export type GetUserEventRegistrationQueryVariables = Exact<{
  eventId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type GetUserEventRegistrationQuery = { __typename?: 'query_root', eventRegistrations: Array<{ __typename?: 'EventRegistrations', id: any }>, eventGroupRegistrations: Array<{ __typename?: 'EventGroupRegistrations', id: any, status: EventGroupRegistrationStatusesEnum, group: { __typename?: 'EventGroups', id: any, title: string, format?: EventGroupFormatsEnum | null, formatCustomName: string, maximumAge?: number | null, maximumRating?: any | null, minimumAge?: number | null, minimumNumberOfGames: number, minimumRating?: any | null, teamType?: TeamTypesEnum | null, teams: Array<{ __typename?: 'EventTeams', id: any, members: Array<{ __typename?: 'EventTeamMembers', userId: any, id: any, status: EventTeamMemberStatusesEnum, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }> }> }, invitations: Array<{ __typename?: 'EventInvitations', id: any, invitationEmail?: string | null, invitationType: EventInvitationTypesEnum, status: EventInvitationStatusesEnum, invitedUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null } | null }> }>, receivedPartnerRequests: Array<{ __typename?: 'EventInvitations', id: any, groupId: any, groupRegistrationId?: any | null, senderUserId: any, senderUserProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null } | null }> };

export type GetEventInvitationForRegistrationQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventInvitationForRegistrationQuery = { __typename?: 'query_root', eventInvitationsByPk?: { __typename?: 'EventInvitations', id: any, groupId: any, status: EventInvitationStatusesEnum, deletedAt?: any | null } | null };

export type GetEventTeamInvitationByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventTeamInvitationByIdQuery = { __typename?: 'query_root', eventTeamsByPk?: { __typename?: 'EventTeams', id: any, groupId: any, group: { __typename?: 'EventGroups', id: any }, members: Array<{ __typename?: 'EventTeamMembers', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null } | null }> } | null };

export type GetVenueForEventByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetVenueForEventByIdQuery = { __typename?: 'query_root', venuesByPk?: { __typename?: 'Venues', id: any, geometry?: any | null, addressString: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, path: string, url: string }>, city?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string } } | null } | null };

export type GetEventForBuilderByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventForBuilderByIdQuery = { __typename?: 'query_root', eventsByPk?: { __typename?: 'Events', addressString?: string | null, archivedAt?: any | null, ballCustomName: string, ballType: BallTypesEnum, cancelReason: string, canceledAt?: any | null, createdAt: any, cityId?: any | null, cityString: string, countryString: string, coverImageFileName?: string | null, coverImageFileType?: string | null, coverImageHost?: string | null, coverImageOriginalFileName?: string | null, coverImagePath?: string | null, coverImageProvider?: string | null, coverImageProviderUrl?: string | null, coverImageUrl?: string | null, currency: string, description: string, displayLocation: string, endDate: any, endDateTime: any, isQuickCreate: boolean, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, geometry?: any | null, groupFormat?: EventGroupFormatsEnum | null, hasPrizes: boolean, hostUserId?: any | null, id: any, isRatingRequired: boolean, isSanctioned: boolean, isVairRequired?: boolean | null, latitude?: any | null, isShowPlayersGoing: boolean, isShowCourtAssignments: boolean, locale: string, longitude?: any | null, organizerImageFileName?: string | null, organizerImageHost?: string | null, organizerImageFileType?: string | null, organizerImageOriginalFileName?: string | null, organizerImagePath?: string | null, organizerImageProvider?: string | null, organizerImageProviderUrl?: string | null, organizerImageUrl?: string | null, pickleballRatingScaleId?: any | null, privacy: EventPrivacyEnum, prizeDescription: string, publishedAt?: any | null, regionString: string, registrationDeadlineDate: any, registrationClosedAt?: any | null, registrationDeadlineDateTime?: any | null, registrationOpenDate?: any | null, registrationOpenDateTime?: any | null, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, showInPublicDate?: any | null, showInPublicDateTime?: any | null, slug: string, sport: SportsEnum, startDate: any, startDateTime: any, status: EventStatusesEnum, streetPrimaryString: string, streetSecondaryString: string, tennisRatingScaleId?: any | null, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, type: EventTypesEnum, zipcodeString: string, venueId?: any | null, faqs: Array<{ __typename?: 'EventFaqs', id: any, question: string, answer: string, createdAt: any }>, groups: Array<{ __typename?: 'EventGroups', id: any, bracketRankingMechanism?: BracketRankingMechanismEnum | null, createdAt: any, desiredNumberOfPools?: number | null, endsAt?: any | null, format?: EventGroupFormatsEnum | null, formatCustomName: string, gamesPerMatch: number, gender: CompetitionGenderEnum, maximumAge?: number | null, maximumRating?: any | null, minimumAge?: number | null, minimumNumberOfGames: number, minimumRating?: any | null, numberOfEliminationTeams?: number | null, numberOfEstimatedCourts?: number | null, priceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, startsAt?: any | null, teamLimit?: number | null, teamType?: TeamTypesEnum | null, title: string, totalPoints?: number | null, winBy?: number | null, isAgeRestricted: boolean, isRatingRequired: boolean, isVairVairifiedRequired?: boolean | null, isWheelchair?: boolean | null, isMoneyBall?: boolean | null, moneyBallRewards?: any | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, hostUserProfile?: { __typename?: 'UserProfiles', stripeMerchantCurrency?: string | null, id?: any | null } | null, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, venue?: { __typename?: 'Venues', id: any, title: string, geometry?: any | null, latitude: any, longitude: any, timezone: string, slug: string, pickleballLines?: VenueLinesEnum | null, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, images: Array<{ __typename?: 'VenueImages', id: any, fileName: string, url: string, path: string }>, city?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string } } | null, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null, sponsors: Array<{ __typename?: 'EventSponsors', id: any, categoryName: string, createdAt: any, imageFileName: string, imageFileType: string, imageHost: string, imagePath: string, imageProvider: string, imageProviderUrl: string, imageUrl: string, imageOriginalFileName?: string | null, name: string, isTitleSponsor: boolean }> } | null };

export type InsertDraftEventMutationVariables = Exact<{
  object: EventsInsertInput;
}>;


export type InsertDraftEventMutation = { __typename?: 'mutation_root', insertEventsOne?: { __typename?: 'Events', addressString?: string | null, archivedAt?: any | null, ballCustomName: string, ballType: BallTypesEnum, cancelReason: string, canceledAt?: any | null, cityId?: any | null, cityString: string, countryString: string, coverImageFileName?: string | null, coverImageFileType?: string | null, coverImageHost?: string | null, coverImageOriginalFileName?: string | null, coverImagePath?: string | null, coverImageProvider?: string | null, coverImageProviderUrl?: string | null, communityGroupId?: any | null, coverImageUrl?: string | null, currency: string, createdAt: any, description: string, displayLocation: string, endDate: any, endDateTime: any, externalUrl?: string | null, isExternal: boolean, isQuickCreate: boolean, geometry?: any | null, groupFormat?: EventGroupFormatsEnum | null, hasPrizes: boolean, hostUserId?: any | null, id: any, isRatingRequired: boolean, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, isSanctioned: boolean, isVairRequired?: boolean | null, latitude?: any | null, isShowPlayersGoing: boolean, isShowCourtAssignments: boolean, locale: string, longitude?: any | null, organizerImageFileName?: string | null, organizerImageHost?: string | null, organizerImageFileType?: string | null, organizerImageOriginalFileName?: string | null, organizerImagePath?: string | null, organizerImageProvider?: string | null, organizerImageProviderUrl?: string | null, organizerImageUrl?: string | null, pickleballRatingScaleId?: any | null, privacy: EventPrivacyEnum, prizeDescription: string, publishedAt?: any | null, regionString: string, registrationDeadlineDate: any, registrationClosedAt?: any | null, registrationDeadlineDateTime?: any | null, registrationOpenDate?: any | null, registrationOpenDateTime?: any | null, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, showInPublicDate?: any | null, showInPublicDateTime?: any | null, slug: string, sport: SportsEnum, startDate: any, startDateTime: any, status: EventStatusesEnum, streetPrimaryString: string, streetSecondaryString: string, tennisRatingScaleId?: any | null, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, type: EventTypesEnum, zipcodeString: string, numberOfCourts?: any | null, venueId?: any | null, faqs: Array<{ __typename?: 'EventFaqs', id: any, question: string, answer: string, createdAt: any }>, groups: Array<{ __typename?: 'EventGroups', id: any, bracketRankingMechanism?: BracketRankingMechanismEnum | null, createdAt: any, desiredNumberOfPools?: number | null, endsAt?: any | null, format?: EventGroupFormatsEnum | null, formatCustomName: string, gamesPerMatch: number, gender: CompetitionGenderEnum, maximumAge?: number | null, maximumRating?: any | null, minimumAge?: number | null, minimumNumberOfGames: number, minimumRating?: any | null, numberOfEliminationTeams?: number | null, numberOfEstimatedCourts?: number | null, priceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, startsAt?: any | null, teamLimit?: number | null, teamType?: TeamTypesEnum | null, title: string, totalPoints?: number | null, winBy?: number | null, isAgeRestricted: boolean, isRatingRequired: boolean, isVairVairifiedRequired?: boolean | null, isWheelchair?: boolean | null, isMoneyBall?: boolean | null, moneyBallRewards?: any | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, venue?: { __typename?: 'Venues', id: any, title: string, geometry?: any | null, latitude: any, longitude: any, timezone: string, slug: string, pickleballLines?: VenueLinesEnum | null, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, images: Array<{ __typename?: 'VenueImages', id: any, fileName: string, url: string, path: string }>, city?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string } } | null, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null, sponsors: Array<{ __typename?: 'EventSponsors', id: any, categoryName: string, createdAt: any, imageFileName: string, imageFileType: string, imageHost: string, imagePath: string, imageProvider: string, imageProviderUrl: string, imageUrl: string, imageOriginalFileName?: string | null, name: string, isTitleSponsor: boolean }> } | null };

export type InsertEventGroupMutationVariables = Exact<{
  object: EventGroupsInsertInput;
}>;


export type InsertEventGroupMutation = { __typename?: 'mutation_root', insertEventGroupsOne?: { __typename?: 'EventGroups', id: any, bracketRankingMechanism?: BracketRankingMechanismEnum | null, createdAt: any, desiredNumberOfPools?: number | null, endsAt?: any | null, format?: EventGroupFormatsEnum | null, formatCustomName: string, gamesPerMatch: number, gender: CompetitionGenderEnum, maximumAge?: number | null, maximumRating?: any | null, minimumAge?: number | null, minimumNumberOfGames: number, minimumRating?: any | null, numberOfEliminationTeams?: number | null, numberOfEstimatedCourts?: number | null, priceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, startsAt?: any | null, teamLimit?: number | null, teamType?: TeamTypesEnum | null, title: string, totalPoints?: number | null, winBy?: number | null, isAgeRestricted: boolean, isRatingRequired: boolean, isVairVairifiedRequired?: boolean | null, isWheelchair?: boolean | null, isMoneyBall?: boolean | null, moneyBallRewards?: any | null } | null };

export type InsertEventGroupTimeSlotsMutationVariables = Exact<{
  objects: Array<EventGroupTimeSlotsInsertInput> | EventGroupTimeSlotsInsertInput;
}>;


export type InsertEventGroupTimeSlotsMutation = { __typename?: 'mutation_root', insertEventGroupTimeSlots?: { __typename?: 'EventGroupTimeSlotsMutationResponse', returning: Array<{ __typename?: 'EventGroupTimeSlots', id: any }> } | null };

export type DeleteEventGroupTimeSlotsMutationVariables = Exact<{
  groupId: Scalars['uuid'];
}>;


export type DeleteEventGroupTimeSlotsMutation = { __typename?: 'mutation_root', deleteEventGroupTimeSlots?: { __typename?: 'EventGroupTimeSlotsMutationResponse', affectedRows: number } | null };

export type UpdateEventByIdMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set?: InputMaybe<EventsSetInput>;
  eventFaqObjects?: InputMaybe<Array<EventFaqsInsertInput> | EventFaqsInsertInput>;
  eventSponsorObjects?: InputMaybe<Array<EventSponsorsInsertInput> | EventSponsorsInsertInput>;
}>;


export type UpdateEventByIdMutation = { __typename?: 'mutation_root', deleteEventFaqs?: { __typename?: 'EventFaqsMutationResponse', affectedRows: number } | null, insertEventFaqs?: { __typename?: 'EventFaqsMutationResponse', affectedRows: number } | null, deleteEventSponsors?: { __typename?: 'EventSponsorsMutationResponse', affectedRows: number } | null, insertEventSponsors?: { __typename?: 'EventSponsorsMutationResponse', affectedRows: number } | null, updateEventsByPk?: { __typename?: 'Events', addressString?: string | null, archivedAt?: any | null, ballCustomName: string, ballType: BallTypesEnum, cancelReason: string, canceledAt?: any | null, cityId?: any | null, cityString: string, countryString: string, coverImageFileName?: string | null, coverImageFileType?: string | null, coverImageHost?: string | null, coverImageOriginalFileName?: string | null, coverImagePath?: string | null, coverImageProvider?: string | null, coverImageProviderUrl?: string | null, coverImageUrl?: string | null, currency: string, createdAt: any, description: string, displayLocation: string, endDate: any, endDateTime: any, geometry?: any | null, groupFormat?: EventGroupFormatsEnum | null, hasPrizes: boolean, hostUserId?: any | null, id: any, isRatingRequired: boolean, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, isSanctioned: boolean, isVairRequired?: boolean | null, latitude?: any | null, isShowPlayersGoing: boolean, isShowCourtAssignments: boolean, locale: string, longitude?: any | null, organizerImageFileName?: string | null, organizerImageHost?: string | null, organizerImageFileType?: string | null, organizerImageOriginalFileName?: string | null, organizerImagePath?: string | null, organizerImageProvider?: string | null, organizerImageProviderUrl?: string | null, organizerImageUrl?: string | null, pickleballRatingScaleId?: any | null, privacy: EventPrivacyEnum, prizeDescription: string, publishedAt?: any | null, regionString: string, registrationDeadlineDate: any, registrationClosedAt?: any | null, registrationDeadlineDateTime?: any | null, registrationOpenDate?: any | null, registrationOpenDateTime?: any | null, registrationPriceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, showInPublicDate?: any | null, showInPublicDateTime?: any | null, slug: string, sport: SportsEnum, startDate: any, startDateTime: any, status: EventStatusesEnum, streetPrimaryString: string, streetSecondaryString: string, tennisRatingScaleId?: any | null, timezoneAbbreviation: string, timezoneName: string, timezoneOffsetMinutes: number, title: string, type: EventTypesEnum, zipcodeString: string, venueId?: any | null, faqs: Array<{ __typename?: 'EventFaqs', id: any, question: string, answer: string, createdAt: any }>, groups: Array<{ __typename?: 'EventGroups', id: any, bracketRankingMechanism?: BracketRankingMechanismEnum | null, createdAt: any, desiredNumberOfPools?: number | null, endsAt?: any | null, format?: EventGroupFormatsEnum | null, formatCustomName: string, gamesPerMatch: number, gender: CompetitionGenderEnum, maximumAge?: number | null, maximumRating?: any | null, minimumAge?: number | null, minimumNumberOfGames: number, minimumRating?: any | null, numberOfEliminationTeams?: number | null, numberOfEstimatedCourts?: number | null, priceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, startsAt?: any | null, teamLimit?: number | null, teamType?: TeamTypesEnum | null, title: string, totalPoints?: number | null, winBy?: number | null, isAgeRestricted: boolean, isRatingRequired: boolean, isVairVairifiedRequired?: boolean | null, isWheelchair?: boolean | null, isMoneyBall?: boolean | null, moneyBallRewards?: any | null, timeSlots: Array<{ __typename?: 'EventGroupTimeSlots', id: any, startsAt: any, endsAt: any }> }>, pickleballRatingScale?: { __typename?: 'PickleballRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, tennisRatingScale?: { __typename?: 'TennisRatingScales', id: any, maximum: any, minimum: any, name: string, order: number, shortName: string } | null, venue?: { __typename?: 'Venues', id: any, title: string, latitude: any, longitude: any, timezone: string, geometry?: any | null, slug: string, pickleballLines?: VenueLinesEnum | null, addressString: string, accessType?: VenueAccessTypesEnum | null, indoorCourtCount: number, outdoorCourtCount: number, pickleballNets?: VenueNetsEnum | null, images: Array<{ __typename?: 'VenueImages', id: any, fileName: string, url: string, path: string }>, city?: { __typename?: 'Cities', id: any, name: string, countrySubdivision: { __typename?: 'CountrySubdivisions', id: any, name: string } } | null, courtSurfaces: Array<{ __typename?: 'VenueCourtSurfaces', id: any, courtSurface: CourtSurfacesEnum }> } | null, sponsors: Array<{ __typename?: 'EventSponsors', id: any, categoryName: string, createdAt: any, imageFileName: string, imageFileType: string, imageHost: string, imagePath: string, imageProvider: string, imageProviderUrl: string, imageUrl: string, imageOriginalFileName?: string | null, name: string, isTitleSponsor: boolean }> } | null };

export type UpdateEventGroupByIdMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set?: InputMaybe<EventGroupsSetInput>;
}>;


export type UpdateEventGroupByIdMutation = { __typename?: 'mutation_root', updateEventGroupsByPk?: { __typename?: 'EventGroups', id: any, bracketRankingMechanism?: BracketRankingMechanismEnum | null, createdAt: any, desiredNumberOfPools?: number | null, endsAt?: any | null, format?: EventGroupFormatsEnum | null, formatCustomName: string, gamesPerMatch: number, gender: CompetitionGenderEnum, maximumAge?: number | null, maximumRating?: any | null, minimumAge?: number | null, minimumNumberOfGames: number, minimumRating?: any | null, numberOfEliminationTeams?: number | null, numberOfEstimatedCourts?: number | null, priceUnitAmount: number, scoringFormat?: ScoringFormatEnum | null, startsAt?: any | null, teamLimit?: number | null, teamType?: TeamTypesEnum | null, title: string, totalPoints?: number | null, winBy?: number | null, isAgeRestricted: boolean, isRatingRequired: boolean, isVairVairifiedRequired?: boolean | null, isWheelchair?: boolean | null, isMoneyBall?: boolean | null, moneyBallRewards?: any | null } | null };

export type SoftDeleteEventGroupMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SoftDeleteEventGroupMutation = { __typename?: 'mutation_root', updateEventGroupsByPk?: { __typename?: 'EventGroups', id: any } | null };

export type UpdateTournamentDataFromGroupMutationVariables = Exact<{
  id: Scalars['uuid'];
  scoringFormat?: InputMaybe<ScoringFormatEnum>;
  isRatingRequired?: InputMaybe<Scalars['Boolean']>;
  groupFormat?: InputMaybe<EventGroupFormatsEnum>;
}>;


export type UpdateTournamentDataFromGroupMutation = { __typename?: 'mutation_root', updateEventsByPk?: { __typename?: 'Events', id: any, isRatingRequired: boolean, scoringFormat?: ScoringFormatEnum | null, groupFormat?: EventGroupFormatsEnum | null } | null };

export type GetActiveLessonsFromFollowedCoachesQueryVariables = Exact<{
  followerUserId: Scalars['uuid'];
}>;


export type GetActiveLessonsFromFollowedCoachesQuery = { __typename?: 'query_root', userFollows: Array<{ __typename?: 'UserFollows', id: any, followedUserId: any, followerUserId: any, followedProfile?: { __typename?: 'UserProfiles', coachStatus?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null, fullName?: string | null, id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, username?: string | null, coachLessons: Array<{ __typename?: 'Lessons', cancelReason: string, canceledAt?: any | null, coverImageFileName: string, coverImagePath: string, coverImageProvider: string, coverImageProviderId: string, coverImageProviderUrl: string, coverImageUrl: string, createdAt: any, currency: string, deletedAt?: any | null, description: string, endDateTime?: any | null, id: any, ownerUserId?: any | null, paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum, participantLimit?: number | null, priceUnitAmount: number, privacy: LessonPrivacyEnum, reminderEventId?: any | null, sport: SportsEnum, startDateTime?: any | null, status: LessonStatusesEnum, locale: string, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, title: string, type: LessonTypesEnum, typeCustom: string, updatedAt: any, publishedAt?: any | null, userCustomCourtId?: any | null, usedTemplateId?: any | null, externalBookingUrl: string, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, fullName?: string | null, username?: string | null, currencyCoachDefault?: string | null, stripeMerchantCurrency?: string | null } | null, venue?: { __typename?: 'Venues', id: any, addressString: string, isActive: boolean, latitude: any, longitude: any, outdoorCourtCount: number, geometry?: any | null, indoorCourtCount: number, slug: string, timezone: string, title: string, images: Array<{ __typename?: 'VenueImages', id: any, url: string, path: string, provider: string, fileName: string }> } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', createdAt: any, fullAddress: string, id: any, title: string, updatedAt: any, latitude?: any | null, longitude?: any | null } | null, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, lessonId: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, preferredName?: string | null, fullName?: string | null, username?: string | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProviderUrl?: string | null, coverImageFileName?: string | null, coverImagePath?: string | null, coverImageProviderUrl?: string | null } | null }>, equipment: Array<{ __typename?: 'LessonEquipment', id: any, lessonId: any, equipmentOptionId: LessonEquipmentOptionsEnum }> }> } | null }> };

export type GetPlayerVideoAnalysisBySubmitterIdQueryVariables = Exact<{
  submissionUserId: Scalars['uuid'];
}>;


export type GetPlayerVideoAnalysisBySubmitterIdQuery = { __typename?: 'query_root', videoAnalysis: Array<{ __typename?: 'VideoAnalysis', id: any, submissionRequestedFeedback: string, reviewStatus?: VideoAnalysisReviewStatusesEnum | null, createdAt: any, videoAnalysisComments: Array<{ __typename?: 'VideoAnalysisComments', sentiment: FeedbackSentimentEnum, id: any, videoAnalysisSkillsComments: Array<{ __typename?: 'VideoAnalysisSkillsComments', videoLessonSkills: { __typename?: 'VideoLessonSkills', skill?: LessonSkillsEnum | null, customSkill?: string | null }, videoAnalysisComments?: { __typename?: 'VideoAnalysisComments', details: string, id: any } | null }> }>, videoAnalysisRequestedSkillsReviews: Array<{ __typename?: 'VideoAnalysisRequestedSkillsReview', id: any, videoLessonSkills: { __typename?: 'VideoLessonSkills', customSkill?: string | null, id: any, skill?: LessonSkillsEnum | null } }>, videoAnalysisFiles: { __typename?: 'VideoAnalysisFiles', id: any, host: string, fileType: string, fileName: string, fileFormat: FileFormatEnum, fileCategory: FileCategoryEnum, createdAt: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, updatedAt: any, url: string }, videoAnalysisSubmission?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, videoAnalysisReviewer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null }>, videoAnalysisAggregate: { __typename?: 'VideoAnalysisAggregate', aggregate?: { __typename?: 'VideoAnalysisAggregateFields', count: number } | null }, pendingVideoAnalysisCount: { __typename?: 'VideoAnalysisAggregate', aggregate?: { __typename?: 'VideoAnalysisAggregateFields', count: number } | null } };

export type GetPlayerReflectionByPlayerIdQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetPlayerReflectionByPlayerIdQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'Lessons', id: any, title: string, type: LessonTypesEnum, sport: SportsEnum, participantLimit?: number | null, timezoneName: string, venue?: { __typename?: 'Venues', id: any, slug: string, title: string, timezone: string, addressString: string } | null, userCustomCourt?: { __typename?: 'UserCustomCourts', fullAddress: string } | null, times: Array<{ __typename?: 'LessonTimes', startDateTime: any, endDateTime: any }>, participantsAggregate: { __typename?: 'LessonParticipantsAggregate', aggregate?: { __typename?: 'LessonParticipantsAggregateFields', count: number } | null }, roster: Array<{ __typename?: 'LessonParticipants', id: any, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null } | null }>, lessonPlayerSkillAssessments: Array<{ __typename?: 'LessonPlayerSkillAssessments', id: any }>, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, participants: Array<{ __typename?: 'LessonParticipants', id: any, userId: any, recapSkippedAt?: any | null, userProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null }>, lessonReflections: Array<{ __typename?: 'LessonReflections', upcomingCategory?: LessonSkillCategoriesEnum | null, upcomingSport?: SportsEnum | null, completedCategory?: LessonSkillCategoriesEnum | null, completedSport?: SportsEnum | null, createdAt: any, details?: string | null, id: any, lessonId: any, submissionRequestedFeedback?: string | null, updatedAt: any, reviewStatus: VideoAnalysisReviewStatusesEnum, lesson: { __typename?: 'Lessons', times: Array<{ __typename?: 'LessonTimes', startDateTime: any }> }, files: Array<{ __typename?: 'LessonReflectionFiles', createdAt: any, fileCategory: string, fileFormat: string, fileName: string, fileType: string, host: string, id: any, provider: string, providerId: string, providerUrl: string, url: string, userId: any, originalFileName: string, transcript: string }>, lessonCoach?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, priceUnitAmountCoachDefault?: number | null, priceUnitAmountRemoteCoachDefault?: number | null, profileImageFileName?: string | null, profileImagePath?: string | null, profileImageProvider?: string | null, profileImageProviderUrl?: string | null, preferredName?: string | null, username?: string | null, geometry?: any | null, defaultSport?: string | null, isPciMember?: boolean | null, stripeMerchantCurrency?: string | null, currencyCoachDefault?: string | null, stripeMerchantChargesEnabled?: boolean | null, coachExternalBookingUrl?: string | null, coachAvailability: Array<{ __typename?: 'CoachAvailability', id: any, endTimeMinutes: number, dayOfWeek: DayOfWeekEnum, startTimeMinutes: number, status: CoachAvailabilityStatusesEnum, coachAvailabilityCustomCourt?: { __typename?: 'UserCustomCourts', id: any } | null, coachAvailabilityVenueId?: { __typename?: 'Venues', id: any } | null }>, coachLessons: Array<{ __typename?: 'Lessons', id: any, ownerUserId?: any | null, startDateTime?: any | null, endDateTime?: any | null, timezoneName: string, timezoneAbbreviation: string, timezoneOffsetMinutes: number, participantLimit?: number | null, currency: string }>, defaultCoachVenue?: { __typename?: 'Venues', addressString: string, id: any } | null, defaultCoachCustomCourt?: { __typename?: 'UserCustomCourts', title: string, id: any, fullAddress: string } | null, followersAggregate: { __typename?: 'UserFollowsAggregate', aggregate?: { __typename?: 'UserFollowsAggregateFields', count: number } | null } } | null, lessonPlayer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonReflectionComments: Array<{ __typename?: 'LessonReflectionComments', type: LessonReflectionCommentTypesEnum, createdAt: any, id: any, order?: number | null, sentiment?: FeedbackSentimentEnum | null, skill?: LessonSkillsEnum | null, customSkill?: string | null, updatedAt: any, details?: string | null, lessonReflectionFiles: Array<{ __typename?: 'LessonReflectionFiles', createdAt: any, fileCategory: string, fileFormat: string, fileName: string, fileType: string, host: string, id: any, provider: string, providerId: string, providerUrl: string, transcript: string, transcriptEndedAt?: any | null, transcriptStartedAt?: any | null, url: string }> }> }> }>, lessonPlayerSkillAssessments: Array<{ __typename?: 'LessonPlayerSkillAssessments', coachUserId: any, playerUserId: any, lessonId: any, id: any, lesson: { __typename?: 'Lessons', lessonReflections: Array<{ __typename?: 'LessonReflections', id: any }> }, lessonPlayer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonCoach?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonPlayerSkillAssessmentsSkills: Array<{ __typename?: 'LessonPlayerSkillAssessmentsSkills', category: LessonPlayerSkillAssessmentCategoriesEnum, createdAt: any, skill: LessonSkillsEnum }> }>, lessonReflections: Array<{ __typename?: 'LessonReflections', createdAt: any, details?: string | null, id: any, lessonId: any, submissionRequestedFeedback?: string | null, updatedAt: any, reviewStatus: VideoAnalysisReviewStatusesEnum, upcomingCategory?: LessonSkillCategoriesEnum | null, upcomingSport?: SportsEnum | null, completedCategory?: LessonSkillCategoriesEnum | null, completedSport?: SportsEnum | null, files: Array<{ __typename?: 'LessonReflectionFiles', createdAt: any, fileCategory: string, fileFormat: string, fileName: string, fileType: string, host: string, id: any, provider: string, providerId: string, providerUrl: string, url: string, userId: any, originalFileName: string }>, lesson: { __typename?: 'Lessons', lessonPlayerSkillAssessments: Array<{ __typename?: 'LessonPlayerSkillAssessments', id: any }> }, lessonPlayer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonCoach?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonReflectionComments: Array<{ __typename?: 'LessonReflectionComments', type: LessonReflectionCommentTypesEnum, createdAt: any, id: any, order?: number | null, sentiment?: FeedbackSentimentEnum | null, skill?: LessonSkillsEnum | null, customSkill?: string | null, updatedAt: any, lessonReflectionFiles: Array<{ __typename?: 'LessonReflectionFiles', createdAt: any, fileCategory: string, fileFormat: string, fileName: string, fileType: string, host: string, id: any, provider: string, providerId: string, providerUrl: string, transcript: string, transcriptEndedAt?: any | null, transcriptStartedAt?: any | null, url: string }> }> }> };

export type InsertPlayerLessonReflectionMutationVariables = Exact<{
  playerUserId: Scalars['uuid'];
  coachUserId: Scalars['uuid'];
  lessonId: Scalars['uuid'];
  skills: Array<LessonPlayerSkillAssessmentsSkillsInsertInput> | LessonPlayerSkillAssessmentsSkillsInsertInput;
}>;


export type InsertPlayerLessonReflectionMutation = { __typename?: 'mutation_root', insertLessonPlayerSkillAssessmentsOne?: { __typename?: 'LessonPlayerSkillAssessments', id: any, lessonId: any } | null };

export type UpdatePlayerLessonReflectionMutationVariables = Exact<{
  lessonPlayerReflectionId: Scalars['uuid'];
  lessonId: Scalars['uuid'];
  skills: Array<LessonPlayerSkillAssessmentsSkillsInsertInput> | LessonPlayerSkillAssessmentsSkillsInsertInput;
}>;


export type UpdatePlayerLessonReflectionMutation = { __typename?: 'mutation_root', deleteLessonPlayerSkillAssessmentsSkills?: { __typename?: 'LessonPlayerSkillAssessmentsSkillsMutationResponse', returning: Array<{ __typename?: 'LessonPlayerSkillAssessmentsSkills', id: any }> } | null, insertLessonPlayerSkillAssessmentsSkills?: { __typename?: 'LessonPlayerSkillAssessmentsSkillsMutationResponse', returning: Array<{ __typename?: 'LessonPlayerSkillAssessmentsSkills', skill: LessonSkillsEnum }> } | null };

export type GetTrainingLogsInfoByPlayerIdQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetTrainingLogsInfoByPlayerIdQuery = { __typename?: 'query_root', lessonsAggregate: { __typename?: 'LessonsAggregate', aggregate?: { __typename?: 'LessonsAggregateFields', count: number } | null }, videoAnalysisAggregate: { __typename?: 'VideoAnalysisAggregate', aggregate?: { __typename?: 'VideoAnalysisAggregateFields', count: number } | null }, videoAnalysis: Array<{ __typename?: 'VideoAnalysis', id: any, createdAt: any, videoAnalysisReviewer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, videoAnalysisRequestedSkillsReviews: Array<{ __typename?: 'VideoAnalysisRequestedSkillsReview', id: any, videoLessonSkills: { __typename?: 'VideoLessonSkills', customSkill?: string | null, id: any, skill?: LessonSkillsEnum | null } }>, videoAnalysisComments: Array<{ __typename?: 'VideoAnalysisComments', sentiment: FeedbackSentimentEnum, createdAt: any, details: string, videoAnalysisFiles?: { __typename?: 'VideoAnalysisFiles', fileType: string, fileFormat: FileFormatEnum, fileCategory: FileCategoryEnum, url: string } | null, videoAnalysisSkillsComments: Array<{ __typename?: 'VideoAnalysisSkillsComments', videoLessonSkills: { __typename?: 'VideoLessonSkills', skill?: LessonSkillsEnum | null, customSkill?: string | null } }> }>, videoAnalysisFiles: { __typename?: 'VideoAnalysisFiles', id: any, url: string, fileType: string, fileFormat: FileFormatEnum, fileCategory: FileCategoryEnum } }>, lessons: Array<{ __typename?: 'Lessons', id: any, times: Array<{ __typename?: 'LessonTimes', endDateTime: any, startDateTime: any }>, ownerProfile?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonReflections: Array<{ __typename?: 'LessonReflections', upcomingCategory?: LessonSkillCategoriesEnum | null, upcomingSport?: SportsEnum | null, completedCategory?: LessonSkillCategoriesEnum | null, completedSport?: SportsEnum | null, lessonId: any, details?: string | null, files: Array<{ __typename?: 'LessonReflectionFiles', createdAt: any, fileCategory: string, fileFormat: string, fileName: string, fileType: string, host: string, id: any, provider: string, providerId: string, providerUrl: string, url: string, userId: any, originalFileName: string }>, lessonPlayer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, lessonReflectionComments: Array<{ __typename?: 'LessonReflectionComments', id: any, details?: string | null, createdAt: any, sentiment?: FeedbackSentimentEnum | null, type: LessonReflectionCommentTypesEnum, skill?: LessonSkillsEnum | null, order?: number | null, lessonReflectionFiles: Array<{ __typename?: 'LessonReflectionFiles', id: any, host: string, fileType: string, fileName: string, fileFormat: string, fileCategory: string, deletedAt?: any | null, createdAt: any, originalFileName: string, provider: string, providerId: string, providerUrl: string, url: string }> }> }> }>, lessonPlayerSkillAssessments: Array<{ __typename?: 'LessonPlayerSkillAssessments', id: any, lessonId: any, playerUserId: any, coachUserId: any, lessonPlayerSkillAssessmentsSkills: Array<{ __typename?: 'LessonPlayerSkillAssessmentsSkills', category: LessonPlayerSkillAssessmentCategoriesEnum, createdAt: any, skill: LessonSkillsEnum }> }> };

export type GetVideoAnalysisByIdQueryVariables = Exact<{
  videoAnalysisId: Scalars['uuid'];
}>;


export type GetVideoAnalysisByIdQuery = { __typename?: 'query_root', videoAnalysis: Array<{ __typename?: 'VideoAnalysis', id: any, submissionRequestedFeedback: string, createdAt: any, videoAnalysisRequestedSkillsReviews: Array<{ __typename?: 'VideoAnalysisRequestedSkillsReview', id: any, videoLessonSkills: { __typename?: 'VideoLessonSkills', customSkill?: string | null, id: any, skill?: LessonSkillsEnum | null } }>, videoAnalysisFiles: { __typename?: 'VideoAnalysisFiles', id: any, host: string, fileType: string, fileName: string, fileFormat: FileFormatEnum, fileCategory: FileCategoryEnum, createdAt: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, updatedAt: any, url: string }, videoAnalysisSubmission?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, videoAnalysisReviewer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null }> };

export type GetVideoAnalysisCommentsByIdQueryVariables = Exact<{
  videoAnalysisId: Scalars['uuid'];
}>;


export type GetVideoAnalysisCommentsByIdQuery = { __typename?: 'query_root', videoAnalysisComments: Array<{ __typename?: 'VideoAnalysisComments', createdAt: any, details: string, sentiment: FeedbackSentimentEnum, id: any, endTimestampSeconds?: any | null, startTimestampSeconds?: any | null, videoAnalysisFiles?: { __typename?: 'VideoAnalysisFiles', createdAt: any, deletedAt?: any | null, fileCategory: FileCategoryEnum, fileFormat: FileFormatEnum, fileName: string, fileType: string, host: string, id: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, url: string, userId: any, uploadStatus: VideoAnalysisFilesUploadStatusesEnum, transcript: string, transcriptionStartedAt?: any | null, transcriptionCompletedAt?: any | null } | null, videoAnalysisSkillsComments: Array<{ __typename?: 'VideoAnalysisSkillsComments', id: any, videoLessonSkills: { __typename?: 'VideoLessonSkills', customSkill?: string | null, createdAt: any, updatedAt: any, skill?: LessonSkillsEnum | null, id: any } }> }> };

export type UpdateVideoAnalysisStatusByIdMutationVariables = Exact<{
  videoAnalysisId: Scalars['uuid'];
  status: VideoAnalysisReviewStatusesEnum;
}>;


export type UpdateVideoAnalysisStatusByIdMutation = { __typename?: 'mutation_root', updateVideoAnalysis?: { __typename?: 'VideoAnalysisMutationResponse', returning: Array<{ __typename?: 'VideoAnalysis', id: any }> } | null };

export type GetEventsByPlayerIdQueryVariables = Exact<{
  userId: Scalars['uuid'];
  startDate: Scalars['date'];
}>;


export type GetEventsByPlayerIdQuery = { __typename?: 'query_root', hostingEvents: Array<{ __typename?: 'Events', id: any, coverImageProviderUrl?: string | null, coverImageFileName?: string | null, geometry?: any | null, organizerImageOriginalFileName?: string | null, organizerImageProvider?: string | null, organizerImageProviderUrl?: string | null, slug: string, startDate: any, startDateTime: any, endDate: any, endDateTime: any, status: EventStatusesEnum, addressString?: string | null, title: string, coverImageProvider?: string | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, registrations: Array<{ __typename?: 'EventRegistrations', userId: any, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, id?: any | null } | null }>, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string } | null }>, attendingEvents: Array<{ __typename?: 'Events', id: any, coverImageProviderUrl?: string | null, coverImageFileName?: string | null, geometry?: any | null, organizerImageOriginalFileName?: string | null, organizerImageProvider?: string | null, organizerImageProviderUrl?: string | null, slug: string, startDate: any, startDateTime: any, endDate: any, endDateTime: any, status: EventStatusesEnum, addressString?: string | null, title: string, coverImageProvider?: string | null, registrationsAggregate: { __typename?: 'EventRegistrationsAggregate', aggregate?: { __typename?: 'EventRegistrationsAggregateFields', count: number } | null }, registrations: Array<{ __typename?: 'EventRegistrations', userId: any, userProfile?: { __typename?: 'UserProfiles', fullName?: string | null, id?: any | null } | null }>, venue?: { __typename?: 'Venues', id: any, title: string, addressString: string } | null }> };

export type GetPlayerVideoAnalysisCompletedByPlayerIdQueryVariables = Exact<{
  playerId: Scalars['uuid'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPlayerVideoAnalysisCompletedByPlayerIdQuery = { __typename?: 'query_root', videoAnalysis: Array<{ __typename?: 'VideoAnalysis', id: any, submissionRequestedFeedback: string, createdAt: any, videoAnalysisRequestedSkillsReviews: Array<{ __typename?: 'VideoAnalysisRequestedSkillsReview', id: any, videoLessonSkills: { __typename?: 'VideoLessonSkills', customSkill?: string | null, id: any, skill?: LessonSkillsEnum | null } }>, videoAnalysisFiles: { __typename?: 'VideoAnalysisFiles', id: any, host: string, fileType: string, fileName: string, fileFormat: FileFormatEnum, fileCategory: FileCategoryEnum, createdAt: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, updatedAt: any, url: string }, videoAnalysisSubmission?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, videoAnalysisReviewer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null }>, videoAnalysisAggregate: { __typename?: 'VideoAnalysisAggregate', aggregate?: { __typename?: 'VideoAnalysisAggregateFields', count: number } | null } };

export type GetPlayerVideoAnalysisPendingByPlayerIdQueryVariables = Exact<{
  playerId: Scalars['uuid'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPlayerVideoAnalysisPendingByPlayerIdQuery = { __typename?: 'query_root', videoAnalysis: Array<{ __typename?: 'VideoAnalysis', id: any, submissionRequestedFeedback: string, createdAt: any, videoAnalysisRequestedSkillsReviews: Array<{ __typename?: 'VideoAnalysisRequestedSkillsReview', id: any, videoLessonSkills: { __typename?: 'VideoLessonSkills', customSkill?: string | null, id: any, skill?: LessonSkillsEnum | null } }>, videoAnalysisFiles: { __typename?: 'VideoAnalysisFiles', id: any, host: string, fileType: string, fileName: string, fileFormat: FileFormatEnum, fileCategory: FileCategoryEnum, createdAt: any, originalFileName?: string | null, provider: string, providerId: string, providerUrl: string, updatedAt: any, url: string }, videoAnalysisSubmission?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null, videoAnalysisReviewer?: { __typename?: 'UserProfiles', id?: any | null, fullName?: string | null, profileImageProviderUrl?: string | null, profileImageFileName?: string | null } | null }>, videoAnalysisAggregate: { __typename?: 'VideoAnalysisAggregate', aggregate?: { __typename?: 'VideoAnalysisAggregateFields', count: number } | null } };

export const TournamentCardFieldsFragmentDoc = gql`
    fragment TournamentCardFields on Events {
  id
  slug
  title
  sport
  coverImagePath
  organizerImagePath
  displayLocation
  startDateTime
  endDateTime
  registrationClosedAt
  registrationDeadlineDate
  registrationPriceUnitAmount
  groupFormat
  scoringFormat
  hasPrizes
  isExternal
  isVairRequired
  currency
  latitude
  longitude
  locale
  status
  sourceRegistrationCount
  sourceOrganizerTitle
  timezoneAbbreviation
  timezoneName
  timezoneOffsetMinutes
  venue {
    id
    timezone
    addressString
  }
  city {
    id
    name
    timezone
    countrySubdivision {
      id
      name
      code
    }
  }
  registrationsAggregate {
    aggregate {
      count
    }
  }
}
    `;
export const UserNotificationFieldsFragmentDoc = gql`
    fragment UserNotificationFields on UserNotifications {
  id
  status
  videoAnalysisId
  notificationDetails {
    actionType
    id
    primaryEntity {
      actingUserProfile {
        id
        fullName
        coachStatus
      }
      videoAnalysis {
        id
        currency
        orders {
          paidUnitAmount
          orderTotalUnitAmount
          orderSubtotalUnitAmount
        }
        videoAnalysisSubmission {
          username
          preferredName
          fullName
          coachStatus
          id
        }
        videoAnalysisReviewer {
          username
          preferredName
          fullName
          coachStatus
          id
          stripeMerchantCurrency
          currencyCoachDefault
        }
        createdAt
        reviewStatus
        submissionUserId
        reviewerUserId
      }
      lesson {
        id
        ownerUserId
        ownerProfile {
          username
          preferredName
          fullName
          coachStatus
          id
        }
        startDateTime
        endDateTime
        title
        status
      }
      playSession {
        id
        startDateTime
        endDateTime
        title
        status
        organizerUserId
        organizerProfile {
          username
          preferredName
          fullName
          coachStatus
          id
        }
        format
        sport
        targetSkillLevel
      }
      eventGroup {
        event {
          id
        }
      }
      group {
        id
        title
        slug
      }
      groupThread {
        groupId
        id
        comments(where: {isOriginalThreadComment: {_eq: true}}) {
          id
          content
        }
      }
      partnerBookingOrder {
        id
        status
        failureReason
        startAt
        endAt
        timezone
        venue {
          id
          title
        }
      }
      playRequest {
        id
        status
        eventId
        availabilityId
        requestMessage
        responseMessage
        event {
          id
          title
          sport
          startDateTime
          endDateTime
          timezoneName
          venue {
            id
            timezone
          }
          groups {
            id
            teamType
            competitiveness
            selfRatedMinSkillLevel {
              id
              displayName
            }
            selfRatedMaxSkillLevel {
              id
              displayName
            }
            ratingScales {
              id
              minimumRating
              maximumRating
              pickleballRatingScale {
                id
                shortName
              }
              tennisRatingScale {
                id
                shortName
              }
              padelRatingScale {
                id
                shortName
              }
            }
          }
        }
        availability {
          id
          sport
          teamType
          userProfile {
            id
            fullName
            username
            profileImagePath
            profileImageProviderUrl
            cityName
            activeCity {
              id
              name
            }
          }
        }
        requesterProfile {
          id
          fullName
          username
          profileImagePath
          profileImageProviderUrl
          cityName
          activeCity {
            id
            name
          }
        }
      }
      connectionRequest {
        id
        status
        message
        requesterUserId
        recipientUserId
        requesterProfile {
          id
          fullName
          preferredName
          username
          profileImagePath
          profileImageProviderUrl
          cityName
        }
        recipientProfile {
          id
          fullName
          preferredName
          username
          profileImagePath
          profileImageProviderUrl
          cityName
        }
      }
      eventPlayerInvite {
        id
        status
        eventId
        inviterUserId
        invitedUserId
        inviterProfile {
          id
          fullName
          preferredName
          username
          profileImagePath
          profileImageProviderUrl
        }
        event {
          id
          title
          sport
          startDateTime
          endDateTime
          timezoneName
          displayLocation
          venue {
            id
            timezone
          }
          groups {
            id
            teamType
            competitiveness
            selfRatedMinSkillLevel {
              id
              displayName
            }
            selfRatedMaxSkillLevel {
              id
              displayName
            }
            ratingScales {
              id
              minimumRating
              maximumRating
              pickleballRatingScale {
                id
                shortName
              }
              tennisRatingScale {
                id
                shortName
              }
              padelRatingScale {
                id
                shortName
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const ActivityEventCardFieldsFragmentDoc = gql`
    fragment ActivityEventCardFields on Events {
  id
  slug
  title
  sport
  type
  isRfx
  startDateTime
  endDateTime
  timezoneName
  registrationDeadlineDateTime
  displayLocation
  addressString
  latitude
  longitude
  coverImagePath
  coverImageProviderUrl
  registrationPriceUnitAmount
  currency
  isExternal
  sourceRegistrationCount
  hostUserId
  hostUserProfile {
    id
    fullName
    profileImageProviderUrl
  }
  venue {
    id
    addressString
    timezone
    images(where: {isVisible: {_eq: true}}, limit: 1) {
      id
      url
      path
    }
  }
  registrationsAggregate {
    aggregate {
      count
    }
  }
  groups {
    id
    startsAt
    endsAt
    timeSlots(orderBy: {startsAt: ASC}) {
      id
      startsAt
      endsAt
    }
  }
}
    `;
export const ConnectionPlayerProfileFieldsFragmentDoc = gql`
    fragment ConnectionPlayerProfileFields on UserProfiles {
  id
  fullName
  preferredName
  username
  profileImagePath
  gender
  defaultSport
  identityVerifications(where: {status: {_eq: VERIFIED}}, limit: 1) {
    status
  }
  pickleballSkillLevel {
    id
  }
  tennisSkillLevel {
    id
  }
  padelSkillLevel {
    id
  }
}
    `;
export const ConnectionSharedGameFieldsFragmentDoc = gql`
    fragment ConnectionSharedGameFields on UserPlayedWithGames {
  eventId
  startDateTime
  event {
    id
    sport
    startDateTime
    endDateTime
    timezoneName
    courtCostPerPlayerUnitAmount
    displayLocation
    venue {
      id
      title
      timezone
    }
    groups {
      id
      teamType
      competitiveness
      selfRatedMinSkillLevel {
        id
        displayName
      }
      selfRatedMaxSkillLevel {
        id
        displayName
      }
      ratingScales {
        id
        minimumRating
        maximumRating
        pickleballRatingScale {
          shortName
        }
        tennisRatingScale {
          shortName
        }
        padelRatingScale {
          shortName
        }
      }
    }
  }
}
    `;
export const GameInviteEventFieldsFragmentDoc = gql`
    fragment GameInviteEventFields on Events {
  id
  sport
  startDateTime
  endDateTime
  timezoneName
  displayLocation
  courtCostPerPlayerUnitAmount
  participantLimit
  venue {
    id
    title
    addressString
  }
  groups {
    id
    teamType
    competitiveness
    selfRatedMinSkillLevel {
      id
      displayName
    }
    selfRatedMaxSkillLevel {
      id
      displayName
    }
    ratingScales {
      id
      minimumRating
      maximumRating
      pickleballRatingScale {
        shortName
      }
      tennisRatingScale {
        shortName
      }
      padelRatingScale {
        shortName
      }
    }
  }
}
    `;
export const LessonFieldsFragmentDoc = gql`
    fragment lessonFields on Lessons {
  cancelReason
  canceledAt
  coverImageFileName
  coverImagePath
  coverImageProvider
  coverImageProviderId
  coverImageProviderUrl
  coverImageUrl
  createdAt
  currency
  deletedAt
  description
  endDateTime
  id
  ownerUserId
  paymentFulfillmentChannel
  participantLimit
  priceUnitAmount
  privacy
  reminderEventId
  sport
  startDateTime
  status
  locale
  timezoneName
  timezoneAbbreviation
  timezoneOffsetMinutes
  title
  type
  typeCustom
  updatedAt
  publishedAt
  userCustomCourtId
  usedTemplateId
  externalBookingUrl
  ownerProfile {
    id
    preferredName
    profileImageFileName
    profileImagePath
    profileImageProviderUrl
    fullName
    username
    currencyCoachDefault
    stripeMerchantCurrency
  }
  venue {
    id
    addressString
    images {
      id
      url
      path
      provider
      fileName
    }
    isActive
    latitude
    longitude
    outdoorCourtCount
    geometry
    indoorCourtCount
    slug
    timezone
    title
  }
  userCustomCourt {
    createdAt
    fullAddress
    id
    title
    updatedAt
    latitude
    longitude
  }
  venue {
    id
    addressString
    images {
      id
      url
      path
      provider
      fileName
    }
    isActive
    latitude
    longitude
    outdoorCourtCount
    geometry
    indoorCourtCount
    slug
    timezone
    title
  }
  participantsAggregate(where: {status: {_eq: ACTIVE}}) {
    aggregate {
      count
    }
  }
  participants(where: {status: {_eq: ACTIVE}}) {
    id
    userId
    lessonId
    userProfile {
      id
      preferredName
      fullName
      username
      profileImageFileName
      profileImagePath
      profileImageProviderUrl
      coverImageFileName
      coverImagePath
      coverImageProviderUrl
    }
  }
  equipment {
    id
    lessonId
    equipmentOptionId
  }
}
    `;
export const PlaySessionFieldsFragmentDoc = gql`
    fragment playSessionFields on PlaySessions {
  cancelReason
  canceledAt
  deletedAt
  competitiveness
  courtBookingStatus
  createdAt
  currency
  description
  endDateTime
  extraRacketCount
  format
  groupId
  id
  isBringingNet
  participantLimit
  sport
  startDateTime
  status
  targetSkillLevel
  title
  userCustomCourtId
  locale
  timezoneOffsetMinutes
  timezoneName
  timezoneAbbreviation
  publishedAt
  priceUnitAmount
  updatedAt
  organizerUserId
  privacy
  skillRatingMaximum
  skillRatingMinimum
  organizerProfile {
    id
    preferredName
    profileImageFileName
    profileImagePath
    profileImageProviderUrl
    fullName
    username
  }
  userCustomCourt {
    createdAt
    fullAddress
    id
    title
    updatedAt
  }
  participantsAggregate(where: {status: {_eq: ACTIVE}}) {
    aggregate {
      count
    }
  }
  participants {
    id
    playSessionId
    userId
    status
    userProfile {
      id
      preferredName
      fullName
      username
      profileImageFileName
      profileImagePath
      profileImageProviderUrl
      coverImageFileName
      coverImagePath
      coverImageProviderUrl
    }
  }
  tennisRatingScale {
    id
    maximum
    minimum
    name
    order
    shortName
  }
  pickleballRatingScale {
    id
    maximum
    minimum
    name
    order
    shortName
  }
  venue {
    id
    title
    addressString
    latitude
    longitude
    images(where: {isVisible: {_eq: true}}) {
      id
      providerUrl
      path
      url
    }
  }
}
    `;
export const UserProfileFieldsFragmentDoc = gql`
    fragment userProfileFields on UserProfiles {
  id
  username
  profileImageFileName
  profileImagePath
  profileImageProviderUrl
  preferredName
  fullName
  coachStatus
  coverImageFileName
  coverImagePath
  coverImageProviderUrl
  aboutMe
  aboutMeVideoUrl
  cityName
  gender
  currencyCoachDefault
  stripeMerchantCurrency
  country {
    id
    iso2
    iso3
    name
  }
  countrySubdivision {
    code
    id
    name
    type
  }
  coachingStartYear
  coachLessonsAggregate(where: {status: {_eq: ACTIVE}}) {
    aggregate {
      count
    }
  }
  followersAggregate(where: {status: {_eq: ACTIVE}}) {
    aggregate {
      count
    }
  }
  followers(limit: 5, where: {status: {_eq: ACTIVE}}) {
    followerProfile {
      id
      username
      profileImageFileName
      profileImagePath
      profileImageProviderUrl
      fullName
      preferredName
    }
    followerUserId
    followedUserId
  }
  coachServices {
    currency
    description
    id
    title
    priceUnitAmount
    type
    coverImageFileName
    coverImagePath
    coverImageProviderUrl
  }
  coachQualifications(where: {status: {_eq: ACTIVE}}) {
    id
    status
    qualification {
      id
      name
      order
      groupId
      displayKey
    }
  }
  normalizedTennisRating
  normalizedTennisRatingScale {
    id
    name
    shortName
  }
  tennisRating
  tennisRatingScale {
    id
    name
    shortName
  }
  tennisSkillLevel {
    id
    isDisplayed
    rank
    displayName
  }
  pickleballSkillLevel {
    id
    isDisplayed
    rank
    displayName
  }
}
    `;
export const CourtPageCoachCardFieldsFragmentDoc = gql`
    fragment CourtPageCoachCardFields on UserProfiles {
  id
  fullName
  preferredName
  username
  profileImagePath
  profileImageProviderUrl
  defaultSport
  isPciMember
  isProfessionalRacquetRegistryActive
  priceUnitAmountCoachDefault
  stripeMerchantCurrency
  currencyCoachDefault
  coachReviewsAggregate {
    aggregate {
      count
      avg {
        rating
      }
    }
  }
  coachLessonsAggregate {
    aggregate {
      count
    }
  }
  coachSports(where: {status: {_eq: ACTIVE}}) {
    sport
  }
}
    `;
export const ClinicLessonFieldsFragmentDoc = gql`
    fragment ClinicLessonFields on Lessons {
  title
  id
  startDateTime
  endDateTime
  timezoneName
  timezoneAbbreviation
  description
  sport
  type
  intendedAgeGroup
  skillLevels {
    id
    skillLevel
  }
  externalBookingUrl
  externalSource
  coverImageProviderUrl
  ownerProfile {
    id
    fullName
    profileImageUrl
    username
    isProfessionalRacquetRegistryActive
    priceUnitAmountCoachDefault
    stripeMerchantCurrency
    currencyCoachDefault
    coachReviewsAggregate {
      aggregate {
        count
        avg {
          rating
        }
      }
    }
  }
  priceUnitAmount
  currency
  participantLimit
  participants {
    id
    userProfile {
      fullName
      profileImagePath
    }
  }
  userCustomCourt {
    fullAddress
  }
  venue {
    id
    addressString
    latitude
    longitude
    geometry
    timezone
    title
    indoorCourtCount
    outdoorCourtCount
    images {
      id
      url
      path
      provider
      fileName
    }
  }
}
    `;
export const LeagueEventFieldsFragmentDoc = gql`
    fragment LeagueEventFields on Events {
  id
  slug
  title
  description
  sport
  type
  startDateTime
  endDateTime
  timezoneName
  timezoneAbbreviation
  registrationClosedAt
  displayLocation
  addressString
  latitude
  longitude
  coverImagePath
  coverImageProviderUrl
  registrationPriceUnitAmount
  currency
  participantLimit
  isExternal
  externalUrl
  isVairRequired
  hostUserProfile {
    id
    fullName
    profileImagePath
    profileImageProviderUrl
  }
  venue {
    id
    title
    addressString
    latitude
    longitude
    geometry
    timezone
    images {
      id
      url
      path
      provider
      fileName
    }
  }
  groups {
    id
    minimumRating
    maximumRating
    teamType
    minimumAge
    maximumAge
  }
  prizeDescription
  registrationsAggregate {
    aggregate {
      count
    }
  }
  registrations(limit: 3) {
    id
    userProfile {
      id
      fullName
      profileImagePath
      profileImageProviderUrl
    }
  }
}
    `;
export const OpenPlayEventFieldsFragmentDoc = gql`
    fragment OpenPlayEventFields on Events {
  id
  slug
  title
  description
  sport
  type
  startDateTime
  endDateTime
  timezoneName
  timezoneAbbreviation
  displayLocation
  addressString
  latitude
  longitude
  coverImagePath
  coverImageProviderUrl
  registrationPriceUnitAmount
  currency
  participantLimit
  isExternal
  externalUrl
  hostUserProfile {
    id
    fullName
    profileImagePath
    profileImageProviderUrl
  }
  venue {
    id
    title
    addressString
    latitude
    longitude
    geometry
    timezone
    indoorCourtCount
    outdoorCourtCount
    images {
      id
      url
      path
      provider
      fileName
    }
  }
  groups {
    id
    minimumRating
    maximumRating
    timeSlots(orderBy: {startsAt: ASC}) {
      id
      startsAt
      endsAt
    }
  }
  registrationsAggregate {
    aggregate {
      count
    }
  }
  registrations(limit: 3) {
    id
    userProfile {
      id
      fullName
      profileImagePath
      profileImageProviderUrl
    }
  }
}
    `;
export const SocialEventFieldsFragmentDoc = gql`
    fragment SocialEventFields on Events {
  id
  slug
  title
  description
  sport
  type
  startDateTime
  endDateTime
  timezoneName
  timezoneAbbreviation
  displayLocation
  addressString
  latitude
  longitude
  coverImagePath
  coverImageProviderUrl
  registrationPriceUnitAmount
  currency
  participantLimit
  isExternal
  externalUrl
  hostUserProfile {
    id
    fullName
    profileImagePath
    profileImageProviderUrl
  }
  venue {
    id
    title
    addressString
    latitude
    longitude
    geometry
    timezone
    indoorCourtCount
    outdoorCourtCount
    images {
      id
      url
      path
      provider
      fileName
    }
  }
  groups {
    id
    minimumRating
    maximumRating
    timeSlots(orderBy: {startsAt: ASC}) {
      id
      startsAt
      endsAt
    }
  }
  registrationsAggregate {
    aggregate {
      count
    }
  }
  registrations(limit: 5) {
    id
    userProfile {
      id
      fullName
      profileImagePath
      profileImageProviderUrl
    }
  }
}
    `;
export const FindPlayerAvailabilityFieldsFragmentDoc = gql`
    fragment FindPlayerAvailabilityFields on PlayerAvailabilities {
  id
  sport
  teamType
  gender
  competitiveness
  wantsRegularPartner
  description
  travelRadiusMiles
  userProfile {
    id
    fullName
    preferredName
    username
    profileImagePath
    profileImageProviderUrl
    identityVerifications(where: {status: {_eq: VERIFIED}}, limit: 1) {
      status
    }
    cityName
    activeCity {
      id
      name
    }
  }
  selfRatedMinSkillLevel {
    id
    displayName
  }
  selfRatedMaxSkillLevel {
    id
    displayName
  }
  ratingScales {
    id
    minimumRating
    maximumRating
    pickleballRatingScale {
      id
      shortName
    }
    tennisRatingScale {
      id
      shortName
    }
    padelRatingScale {
      id
      shortName
    }
  }
  slots {
    id
    dayOfWeek
    startTime
    endTime
  }
  neighborhoods(orderBy: {neighborhood: {sortOrder: ASC}}) {
    neighborhood {
      id
      name
      latitude
      longitude
      radiusMiles
      city {
        id
        timezone
      }
    }
  }
  venues {
    id
    userCustomCourt {
      id
      title
      fullAddress
      latitude
      longitude
    }
    venue {
      id
      title
      timezone
      addressString
      accessType
      indoorCourtCount
      outdoorCourtCount
      pickleballNets
      latitude
      longitude
      images(limit: 1) {
        id
        path
        url
      }
    }
  }
}
    `;
export const FindGameEventFieldsFragmentDoc = gql`
    fragment FindGameEventFields on Events {
  id
  participantLimit
  privacy
  status
  sport
  startDateTime
  endDateTime
  timezoneName
  description
  displayLocation
  addressString
  latitude
  longitude
  isCourtBooked
  courtCostPerPlayerUnitAmount
  hostUserProfile {
    id
    fullName
    preferredName
    profileImagePath
    profileImageProviderUrl
    identityVerifications(where: {status: {_eq: VERIFIED}}, limit: 1) {
      status
    }
    pickleballSkillLevel {
      id
    }
    tennisSkillLevel {
      id
    }
  }
  venue {
    id
    title
    timezone
    addressString
    accessType
    indoorCourtCount
    outdoorCourtCount
    pickleballNets
    images(where: {isVisible: {_eq: true}}, limit: 1) {
      id
      path
      url
    }
  }
  groups {
    id
    timeSlots(orderBy: {startsAt: ASC}) {
      id
      startsAt
      endsAt
    }
    teamType
    gender
    competitiveness
    selfRatedMinSkillLevel {
      id
      displayName
    }
    selfRatedMaxSkillLevel {
      id
      displayName
    }
    netStatus
    ratingScales {
      id
      minimumRating
      maximumRating
      pickleballRatingScale {
        id
        shortName
      }
      tennisRatingScale {
        id
        shortName
      }
      padelRatingScale {
        id
        shortName
      }
    }
  }
  acceptedPlayRequests(orderBy: {respondedAt: ASC}) {
    id
    requesterProfile {
      id
      fullName
      preferredName
      profileImagePath
      identityVerifications(where: {status: {_eq: VERIFIED}}, limit: 1) {
        status
      }
      pickleballSkillLevel {
        id
      }
      tennisSkillLevel {
        id
      }
    }
  }
}
    `;
export const FindGameRosterFieldsFragmentDoc = gql`
    fragment FindGameRosterFields on Events {
  id
  viewerRequests: playRequests(
    where: {requesterUserId: {_eq: $viewerUserId}, status: {_eq: PENDING}, deletedAt: {_isNull: true}}
    limit: 1
  ) {
    id
  }
}
    `;
export const AvailabilityMatchPlayerFieldsFragmentDoc = gql`
    fragment AvailabilityMatchPlayerFields on UserProfiles {
  id
  fullName
  preferredName
  profileImagePath
  identityVerifications(where: {status: {_eq: VERIFIED}}, limit: 1) {
    status
  }
  pickleballSkillLevel {
    id
  }
  tennisSkillLevel {
    id
  }
}
    `;
export const ChatUserProfileFieldsFragmentDoc = gql`
    fragment ChatUserProfileFields on UserProfiles {
  id
  fullName
  preferredName
  username
  profileImagePath
  identityVerifications(where: {status: {_eq: VERIFIED}}, limit: 1) {
    status
  }
}
    `;
export const ChatListRowFieldsFragmentDoc = gql`
    fragment ChatListRowFields on ConversationParticipants {
  id
  lastReadAt
  conversation {
    id
    type
    title
    imagePath
    eventId
    lastMessageAt
    participants(where: {deletedAt: {_isNull: true}}) {
      id
      userId
      userProfile {
        ...ChatUserProfileFields
      }
    }
    messages(orderBy: {createdAt: DESC}, limit: 1) {
      id
      body
      createdAt
      senderUserId
      senderProfile {
        id
        fullName
        preferredName
      }
    }
  }
}
    ${ChatUserProfileFieldsFragmentDoc}`;
export const ChatMessageFieldsFragmentDoc = gql`
    fragment ChatMessageFields on Messages {
  id
  body
  createdAt
  senderUserId
}
    `;
export const ChatPlayRequestFieldsFragmentDoc = gql`
    fragment ChatPlayRequestFields on PlayRequests {
  id
  status
  createdAt
  requesterUserId
  recipientUserId
  requestMessage
  responseMessage
  eventId
  availabilityId
  requesterProfile {
    ...ChatUserProfileFields
    pickleballSkillLevel {
      id
    }
    tennisSkillLevel {
      id
    }
  }
  recipientProfile {
    ...ChatUserProfileFields
  }
  slots {
    id
    requestedStartAt
    requestedEndAt
    availabilitySlot {
      id
      dayOfWeek
      startTime
      endTime
    }
  }
  neighborhoods {
    id
    neighborhood {
      id
      name
      city {
        id
        timezone
      }
    }
  }
  venues {
    id
    venue {
      id
      title
      timezone
      indoorCourtCount
      outdoorCourtCount
      images(limit: 1) {
        id
        path
        url
      }
    }
  }
}
    ${ChatUserProfileFieldsFragmentDoc}`;
export const PlayerProfileFieldsFragmentDoc = gql`
    fragment playerProfileFields on UserProfiles {
  id
  username
  fullName
  preferredName
  cityName
  gender
  aboutMe
  coachStatus
  profileImagePath
  coverImagePath
  instagramUrl
  facebookUrl
  tiktokUrl
  linkedinUrl
  xUrl
  birthdayMonth
  birthdayDay
  birthdayYear
  pickleballSkillLevel {
    id
    displayName
  }
  tennisSkillLevel {
    id
    displayName
  }
  padelSkillLevel {
    id
    displayName
  }
  sports {
    id
    sport
  }
  pickleballRatingScales {
    id
    rating
    scale {
      id
      shortName
    }
  }
  tennisRatingScales {
    id
    rating
    scale {
      id
      shortName
    }
  }
  padelRatingScales {
    id
    rating
    scale {
      id
      shortName
    }
  }
  playerFinderAvailability {
    dayOfWeek
    timeOfDay
  }
  venueFollows(where: {status: {_eq: ACTIVE}}) {
    id
    venue {
      id
      title
      addressString
      latitude
      longitude
      indoorCourtCount
      images(where: {isVisible: {_eq: true}}, orderBy: {isCover: DESC}, limit: 1) {
        id
        url
      }
    }
  }
  userFiles(where: {fileCategory: {_eq: PLAYER_GALLERY}}) {
    id
    url
    path
    providerUrl
    fileFormat
  }
  identityVerifications(where: {status: {_eq: VERIFIED}}, limit: 1) {
    status
  }
  followersAggregate(where: {status: {_eq: ACTIVE}}) {
    aggregate {
      count
    }
  }
  playerReviewsAggregate {
    aggregate {
      count
      avg {
        rating
      }
    }
  }
  playerReviews(orderBy: {createdAt: DESC}, limit: 10) {
    id
    rating
    review
    createdAt
    externalFullName
    reviewer {
      id
      username
      fullName
      preferredName
      profileImagePath
    }
  }
}
    `;
export const CheckUserFollowsCoachDocument = gql`
    query checkUserFollowsCoach($coachId: uuid!, $userId: uuid!) {
  userFollows(
    where: {followedUserId: {_eq: $coachId}, followerUserId: {_eq: $userId}, status: {_eq: ACTIVE}}
  ) {
    id
    followerUserId
    followedUserId
    status
    followerProfile {
      id
      username
      profileImageUrl
      fullName
    }
  }
}
    `;

/**
 * __useCheckUserFollowsCoachQuery__
 *
 * To run a query within a React component, call `useCheckUserFollowsCoachQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserFollowsCoachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserFollowsCoachQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCheckUserFollowsCoachQuery(baseOptions: Apollo.QueryHookOptions<CheckUserFollowsCoachQuery, CheckUserFollowsCoachQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUserFollowsCoachQuery, CheckUserFollowsCoachQueryVariables>(CheckUserFollowsCoachDocument, options);
      }
export function useCheckUserFollowsCoachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserFollowsCoachQuery, CheckUserFollowsCoachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUserFollowsCoachQuery, CheckUserFollowsCoachQueryVariables>(CheckUserFollowsCoachDocument, options);
        }
export type CheckUserFollowsCoachQueryHookResult = ReturnType<typeof useCheckUserFollowsCoachQuery>;
export type CheckUserFollowsCoachLazyQueryHookResult = ReturnType<typeof useCheckUserFollowsCoachLazyQuery>;
export type CheckUserFollowsCoachQueryResult = Apollo.QueryResult<CheckUserFollowsCoachQuery, CheckUserFollowsCoachQueryVariables>;
export const GetFeaturedTournamentBoostsDocument = gql`
    query GetFeaturedTournamentBoosts($now: timestamptz!) {
  boosts(
    where: {status: {_eq: ACTIVE}, channel: {_eq: MARKETPLACE}, entityType: {_eq: EVENT}, startsAt: {_lte: $now}, endsAt: {_gte: $now}, event: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, type: {_eq: TOURNAMENT}, status: {_eq: PUBLISHED}, startDateTime: {_gte: $now}}}
    orderBy: {startsAt: DESC}
  ) {
    id
    event {
      ...TournamentCardFields
    }
  }
}
    ${TournamentCardFieldsFragmentDoc}`;

/**
 * __useGetFeaturedTournamentBoostsQuery__
 *
 * To run a query within a React component, call `useGetFeaturedTournamentBoostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedTournamentBoostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedTournamentBoostsQuery({
 *   variables: {
 *      now: // value for 'now'
 *   },
 * });
 */
export function useGetFeaturedTournamentBoostsQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedTournamentBoostsQuery, GetFeaturedTournamentBoostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedTournamentBoostsQuery, GetFeaturedTournamentBoostsQueryVariables>(GetFeaturedTournamentBoostsDocument, options);
      }
export function useGetFeaturedTournamentBoostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedTournamentBoostsQuery, GetFeaturedTournamentBoostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedTournamentBoostsQuery, GetFeaturedTournamentBoostsQueryVariables>(GetFeaturedTournamentBoostsDocument, options);
        }
export type GetFeaturedTournamentBoostsQueryHookResult = ReturnType<typeof useGetFeaturedTournamentBoostsQuery>;
export type GetFeaturedTournamentBoostsLazyQueryHookResult = ReturnType<typeof useGetFeaturedTournamentBoostsLazyQuery>;
export type GetFeaturedTournamentBoostsQueryResult = Apollo.QueryResult<GetFeaturedTournamentBoostsQuery, GetFeaturedTournamentBoostsQueryVariables>;
export const UpsertUserFollowsBatchDocument = gql`
    mutation upsertUserFollowsBatch($objects: [UserFollowsInsertInput!]!) {
  insertUserFollows(
    objects: $objects
    onConflict: {constraint: user_follows_followed_user_id_follower_user_id_key, updateColumns: status}
  ) {
    affectedRows
  }
}
    `;
export type UpsertUserFollowsBatchMutationFn = Apollo.MutationFunction<UpsertUserFollowsBatchMutation, UpsertUserFollowsBatchMutationVariables>;

/**
 * __useUpsertUserFollowsBatchMutation__
 *
 * To run a mutation, you first call `useUpsertUserFollowsBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserFollowsBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserFollowsBatchMutation, { data, loading, error }] = useUpsertUserFollowsBatchMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertUserFollowsBatchMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserFollowsBatchMutation, UpsertUserFollowsBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserFollowsBatchMutation, UpsertUserFollowsBatchMutationVariables>(UpsertUserFollowsBatchDocument, options);
      }
export type UpsertUserFollowsBatchMutationHookResult = ReturnType<typeof useUpsertUserFollowsBatchMutation>;
export type UpsertUserFollowsBatchMutationResult = Apollo.MutationResult<UpsertUserFollowsBatchMutation>;
export type UpsertUserFollowsBatchMutationOptions = Apollo.BaseMutationOptions<UpsertUserFollowsBatchMutation, UpsertUserFollowsBatchMutationVariables>;
export const UpsertVenueFollowsBatchDocument = gql`
    mutation upsertVenueFollowsBatch($objects: [VenueFollowsInsertInput!]!) {
  insertVenueFollows(
    objects: $objects
    onConflict: {constraint: venue_follows_venue_id_user_id_key, updateColumns: status}
  ) {
    affectedRows
  }
}
    `;
export type UpsertVenueFollowsBatchMutationFn = Apollo.MutationFunction<UpsertVenueFollowsBatchMutation, UpsertVenueFollowsBatchMutationVariables>;

/**
 * __useUpsertVenueFollowsBatchMutation__
 *
 * To run a mutation, you first call `useUpsertVenueFollowsBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertVenueFollowsBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertVenueFollowsBatchMutation, { data, loading, error }] = useUpsertVenueFollowsBatchMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertVenueFollowsBatchMutation(baseOptions?: Apollo.MutationHookOptions<UpsertVenueFollowsBatchMutation, UpsertVenueFollowsBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertVenueFollowsBatchMutation, UpsertVenueFollowsBatchMutationVariables>(UpsertVenueFollowsBatchDocument, options);
      }
export type UpsertVenueFollowsBatchMutationHookResult = ReturnType<typeof useUpsertVenueFollowsBatchMutation>;
export type UpsertVenueFollowsBatchMutationResult = Apollo.MutationResult<UpsertVenueFollowsBatchMutation>;
export type UpsertVenueFollowsBatchMutationOptions = Apollo.BaseMutationOptions<UpsertVenueFollowsBatchMutation, UpsertVenueFollowsBatchMutationVariables>;
export const GetVenuesByNameSearchDocument = gql`
    query getVenuesByNameSearch($search: String!, $limit: Int = 20) {
  venues(where: {title: {_ilike: $search}}, orderBy: {title: ASC}, limit: $limit) {
    id
    slug
    title
    addressString
    accessType
    indoorCourtCount
    outdoorCourtCount
    pickleballNets
    images(where: {isVisible: {_eq: true}}, limit: 1) {
      id
      url
      isVisible
    }
  }
}
    `;

/**
 * __useGetVenuesByNameSearchQuery__
 *
 * To run a query within a React component, call `useGetVenuesByNameSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenuesByNameSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenuesByNameSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetVenuesByNameSearchQuery(baseOptions: Apollo.QueryHookOptions<GetVenuesByNameSearchQuery, GetVenuesByNameSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenuesByNameSearchQuery, GetVenuesByNameSearchQueryVariables>(GetVenuesByNameSearchDocument, options);
      }
export function useGetVenuesByNameSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenuesByNameSearchQuery, GetVenuesByNameSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenuesByNameSearchQuery, GetVenuesByNameSearchQueryVariables>(GetVenuesByNameSearchDocument, options);
        }
export type GetVenuesByNameSearchQueryHookResult = ReturnType<typeof useGetVenuesByNameSearchQuery>;
export type GetVenuesByNameSearchLazyQueryHookResult = ReturnType<typeof useGetVenuesByNameSearchLazyQuery>;
export type GetVenuesByNameSearchQueryResult = Apollo.QueryResult<GetVenuesByNameSearchQuery, GetVenuesByNameSearchQueryVariables>;
export const GetMyFavoritesDocument = gql`
    query getMyFavorites($userId: uuid!) {
  userFollows(
    where: {followerUserId: {_eq: $userId}, status: {_eq: ACTIVE}}
    orderBy: {createdAt: DESC}
  ) {
    id
    followerUserId
    followedUserId
    followedProfile {
      id
      fullName
      username
      profileImageProviderUrl
      stripeMerchantCurrency
      currencyCoachDefault
      priceUnitAmountCoachDefault
      isProfessionalRacquetRegistryActive
      coachSports {
        id
        sport
      }
    }
  }
  venueFollows(
    where: {userId: {_eq: $userId}, status: {_eq: ACTIVE}, deletedAt: {_isNull: true}}
    orderBy: {createdAt: DESC}
  ) {
    id
    venue {
      id
      title
      slug
      indoorCourtCount
      outdoorCourtCount
      images(where: {isVisible: {_eq: true}}, limit: 1) {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useGetMyFavoritesQuery__
 *
 * To run a query within a React component, call `useGetMyFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyFavoritesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyFavoritesQuery(baseOptions: Apollo.QueryHookOptions<GetMyFavoritesQuery, GetMyFavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyFavoritesQuery, GetMyFavoritesQueryVariables>(GetMyFavoritesDocument, options);
      }
export function useGetMyFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyFavoritesQuery, GetMyFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyFavoritesQuery, GetMyFavoritesQueryVariables>(GetMyFavoritesDocument, options);
        }
export type GetMyFavoritesQueryHookResult = ReturnType<typeof useGetMyFavoritesQuery>;
export type GetMyFavoritesLazyQueryHookResult = ReturnType<typeof useGetMyFavoritesLazyQuery>;
export type GetMyFavoritesQueryResult = Apollo.QueryResult<GetMyFavoritesQuery, GetMyFavoritesQueryVariables>;
export const GetHomeForYouPreferencesDocument = gql`
    query getHomeForYouPreferences($userId: uuid!) {
  usersByPk(id: $userId) {
    id
    pickleballSkillLevelId
    tennisSkillLevelId
    padelSkillLevelId
  }
  userPlayerFinderAvailability(where: {userId: {_eq: $userId}}) {
    dayOfWeek
    timeOfDay
  }
  venueFollows(
    where: {userId: {_eq: $userId}, status: {_eq: ACTIVE}, deletedAt: {_isNull: true}}
    orderBy: {createdAt: DESC}
    limit: 12
  ) {
    id
    venue {
      id
      title
      addressString
      latitude
      longitude
      indoorCourtCount
      outdoorCourtCount
      pickleballNets
      accessType
      timezone
      images(where: {isVisible: {_eq: true}}, limit: 1) {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useGetHomeForYouPreferencesQuery__
 *
 * To run a query within a React component, call `useGetHomeForYouPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeForYouPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeForYouPreferencesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetHomeForYouPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetHomeForYouPreferencesQuery, GetHomeForYouPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeForYouPreferencesQuery, GetHomeForYouPreferencesQueryVariables>(GetHomeForYouPreferencesDocument, options);
      }
export function useGetHomeForYouPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeForYouPreferencesQuery, GetHomeForYouPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeForYouPreferencesQuery, GetHomeForYouPreferencesQueryVariables>(GetHomeForYouPreferencesDocument, options);
        }
export type GetHomeForYouPreferencesQueryHookResult = ReturnType<typeof useGetHomeForYouPreferencesQuery>;
export type GetHomeForYouPreferencesLazyQueryHookResult = ReturnType<typeof useGetHomeForYouPreferencesLazyQuery>;
export type GetHomeForYouPreferencesQueryResult = Apollo.QueryResult<GetHomeForYouPreferencesQuery, GetHomeForYouPreferencesQueryVariables>;
export const GetNeighborhoodsDocument = gql`
    query GetNeighborhoods {
  neighborhoods(where: {isActive: {_eq: true}}, orderBy: {sortOrder: ASC}) {
    id
    slug
    name
    latitude
    longitude
    radiusMiles
    city {
      id
      slug
      name
    }
  }
}
    `;

/**
 * __useGetNeighborhoodsQuery__
 *
 * To run a query within a React component, call `useGetNeighborhoodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNeighborhoodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNeighborhoodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNeighborhoodsQuery(baseOptions?: Apollo.QueryHookOptions<GetNeighborhoodsQuery, GetNeighborhoodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNeighborhoodsQuery, GetNeighborhoodsQueryVariables>(GetNeighborhoodsDocument, options);
      }
export function useGetNeighborhoodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNeighborhoodsQuery, GetNeighborhoodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNeighborhoodsQuery, GetNeighborhoodsQueryVariables>(GetNeighborhoodsDocument, options);
        }
export type GetNeighborhoodsQueryHookResult = ReturnType<typeof useGetNeighborhoodsQuery>;
export type GetNeighborhoodsLazyQueryHookResult = ReturnType<typeof useGetNeighborhoodsLazyQuery>;
export type GetNeighborhoodsQueryResult = Apollo.QueryResult<GetNeighborhoodsQuery, GetNeighborhoodsQueryVariables>;
export const GetNearbyPlayersCountDocument = gql`
    query GetNearbyPlayersCount($distance: Float!, $from: geography!, $viewerId: uuid!) {
  playerAvailabilitiesAggregate(
    where: {isActive: {_eq: true}, userId: {_neq: $viewerId}, venues: {venue: {geometry: {_stDWithin: {distance: $distance, from: $from}}}}}
  ) {
    aggregate {
      count
    }
  }
  userProfiles(where: {id: {_eq: $viewerId}}, limit: 1) {
    id
    cityName
  }
}
    `;

/**
 * __useGetNearbyPlayersCountQuery__
 *
 * To run a query within a React component, call `useGetNearbyPlayersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNearbyPlayersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNearbyPlayersCountQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      viewerId: // value for 'viewerId'
 *   },
 * });
 */
export function useGetNearbyPlayersCountQuery(baseOptions: Apollo.QueryHookOptions<GetNearbyPlayersCountQuery, GetNearbyPlayersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNearbyPlayersCountQuery, GetNearbyPlayersCountQueryVariables>(GetNearbyPlayersCountDocument, options);
      }
export function useGetNearbyPlayersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNearbyPlayersCountQuery, GetNearbyPlayersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNearbyPlayersCountQuery, GetNearbyPlayersCountQueryVariables>(GetNearbyPlayersCountDocument, options);
        }
export type GetNearbyPlayersCountQueryHookResult = ReturnType<typeof useGetNearbyPlayersCountQuery>;
export type GetNearbyPlayersCountLazyQueryHookResult = ReturnType<typeof useGetNearbyPlayersCountLazyQuery>;
export type GetNearbyPlayersCountQueryResult = Apollo.QueryResult<GetNearbyPlayersCountQuery, GetNearbyPlayersCountQueryVariables>;
export const GetReceivedPlayRequestsDocument = gql`
    query GetReceivedPlayRequests($userId: uuid!) {
  playRequests(
    where: {recipientUserId: {_eq: $userId}, status: {_eq: PENDING}, deletedAt: {_isNull: true}}
    orderBy: {createdAt: DESC}
  ) {
    id
    eventId
    availabilityId
    createdAt
    requesterProfile {
      id
      fullName
      preferredName
      profileImagePath
    }
    event {
      id
      sport
      groups {
        id
        teamType
        selfRatedMinSkillLevel {
          id
          displayName
        }
        selfRatedMaxSkillLevel {
          id
          displayName
        }
        ratingScales {
          id
          minimumRating
          maximumRating
          pickleballRatingScale {
            id
            shortName
          }
          tennisRatingScale {
            id
            shortName
          }
          padelRatingScale {
            id
            shortName
          }
        }
      }
    }
    availability {
      id
      sport
      teamType
      selfRatedMinSkillLevel {
        id
        displayName
      }
      selfRatedMaxSkillLevel {
        id
        displayName
      }
      ratingScales {
        id
        minimumRating
        maximumRating
        pickleballRatingScale {
          id
          shortName
        }
        tennisRatingScale {
          id
          shortName
        }
        padelRatingScale {
          id
          shortName
        }
      }
    }
  }
}
    `;

/**
 * __useGetReceivedPlayRequestsQuery__
 *
 * To run a query within a React component, call `useGetReceivedPlayRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceivedPlayRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceivedPlayRequestsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetReceivedPlayRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetReceivedPlayRequestsQuery, GetReceivedPlayRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceivedPlayRequestsQuery, GetReceivedPlayRequestsQueryVariables>(GetReceivedPlayRequestsDocument, options);
      }
export function useGetReceivedPlayRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceivedPlayRequestsQuery, GetReceivedPlayRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceivedPlayRequestsQuery, GetReceivedPlayRequestsQueryVariables>(GetReceivedPlayRequestsDocument, options);
        }
export type GetReceivedPlayRequestsQueryHookResult = ReturnType<typeof useGetReceivedPlayRequestsQuery>;
export type GetReceivedPlayRequestsLazyQueryHookResult = ReturnType<typeof useGetReceivedPlayRequestsLazyQuery>;
export type GetReceivedPlayRequestsQueryResult = Apollo.QueryResult<GetReceivedPlayRequestsQuery, GetReceivedPlayRequestsQueryVariables>;
export const GetUpcomingHostedEventsDocument = gql`
    query getUpcomingHostedEvents($userId: uuid!, $startDate: timestamptz!, $types: [EventTypesEnum!] = [TOURNAMENT]) {
  events(
    where: {hostUserId: {_eq: $userId}, type: {_in: $types}, status: {_eq: PUBLISHED}, archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, endDateTime: {_gte: $startDate}}
    orderBy: {startDate: ASC}
  ) {
    id
    type
    title
    slug
    coverImagePath
    startDateTime
    endDateTime
    registrationClosedAt
    registrationDeadlineDate
    registrationDeadlineDateTime
    status
    currency
    isExternal
    isVairRequired
    registrationsAggregate {
      aggregate {
        count
      }
    }
    groups {
      id
      teamLimit
      teamType
      registrations(where: {deletedAt: {_isNull: true}}) {
        id
        userId
      }
      teams(where: {deletedAt: {_isNull: true}}) {
        id
        members(where: {deletedAt: {_isNull: true}}) {
          id
          userId
        }
      }
    }
  }
}
    `;

/**
 * __useGetUpcomingHostedEventsQuery__
 *
 * To run a query within a React component, call `useGetUpcomingHostedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingHostedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingHostedEventsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetUpcomingHostedEventsQuery(baseOptions: Apollo.QueryHookOptions<GetUpcomingHostedEventsQuery, GetUpcomingHostedEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpcomingHostedEventsQuery, GetUpcomingHostedEventsQueryVariables>(GetUpcomingHostedEventsDocument, options);
      }
export function useGetUpcomingHostedEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpcomingHostedEventsQuery, GetUpcomingHostedEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpcomingHostedEventsQuery, GetUpcomingHostedEventsQueryVariables>(GetUpcomingHostedEventsDocument, options);
        }
export type GetUpcomingHostedEventsQueryHookResult = ReturnType<typeof useGetUpcomingHostedEventsQuery>;
export type GetUpcomingHostedEventsLazyQueryHookResult = ReturnType<typeof useGetUpcomingHostedEventsLazyQuery>;
export type GetUpcomingHostedEventsQueryResult = Apollo.QueryResult<GetUpcomingHostedEventsQuery, GetUpcomingHostedEventsQueryVariables>;
export const GetUserNotificationsDocument = gql`
    query getUserNotifications($limit: Int!, $offset: Int!, $userId: uuid!) {
  userNotifications(
    limit: $limit
    offset: $offset
    orderBy: {createdAt: DESC_NULLS_LAST}
    where: {userId: {_eq: $userId}, notificationDetails: {actionType: {_neq: MESSAGE_RECEIVED}}}
  ) {
    ...UserNotificationFields
  }
}
    ${UserNotificationFieldsFragmentDoc}`;

/**
 * __useGetUserNotificationsQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, options);
      }
export function useGetUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, options);
        }
export type GetUserNotificationsQueryHookResult = ReturnType<typeof useGetUserNotificationsQuery>;
export type GetUserNotificationsLazyQueryHookResult = ReturnType<typeof useGetUserNotificationsLazyQuery>;
export type GetUserNotificationsQueryResult = Apollo.QueryResult<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>;
export const GetUnreadNotificationsDocument = gql`
    query getUnreadNotifications($userId: uuid!) {
  userNotificationsAggregate(
    where: {userId: {_eq: $userId}, status: {_eq: UNREAD}, notificationDetails: {actionType: {_neq: MESSAGE_RECEIVED}}}
  ) {
    aggregate {
      count
    }
  }
  userNotifications(
    where: {userId: {_eq: $userId}, status: {_eq: UNREAD}, notificationDetails: {actionType: {_nin: [MESSAGE_RECEIVED, FOLLOWER_USER_NEW]}}}
    orderBy: {createdAt: DESC}
    limit: 5
  ) {
    createdAt
    ...UserNotificationFields
  }
}
    ${UserNotificationFieldsFragmentDoc}`;

/**
 * __useGetUnreadNotificationsQuery__
 *
 * To run a query within a React component, call `useGetUnreadNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadNotificationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUnreadNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetUnreadNotificationsQuery, GetUnreadNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadNotificationsQuery, GetUnreadNotificationsQueryVariables>(GetUnreadNotificationsDocument, options);
      }
export function useGetUnreadNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadNotificationsQuery, GetUnreadNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadNotificationsQuery, GetUnreadNotificationsQueryVariables>(GetUnreadNotificationsDocument, options);
        }
export type GetUnreadNotificationsQueryHookResult = ReturnType<typeof useGetUnreadNotificationsQuery>;
export type GetUnreadNotificationsLazyQueryHookResult = ReturnType<typeof useGetUnreadNotificationsLazyQuery>;
export type GetUnreadNotificationsQueryResult = Apollo.QueryResult<GetUnreadNotificationsQuery, GetUnreadNotificationsQueryVariables>;
export const GetUserNotificationsCountDocument = gql`
    query getUserNotificationsCount($userId: uuid!) {
  userNotificationsAggregate(where: {userId: {_eq: $userId}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUserNotificationsCountQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationsCountQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserNotificationsCountQuery(baseOptions: Apollo.QueryHookOptions<GetUserNotificationsCountQuery, GetUserNotificationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNotificationsCountQuery, GetUserNotificationsCountQueryVariables>(GetUserNotificationsCountDocument, options);
      }
export function useGetUserNotificationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotificationsCountQuery, GetUserNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNotificationsCountQuery, GetUserNotificationsCountQueryVariables>(GetUserNotificationsCountDocument, options);
        }
export type GetUserNotificationsCountQueryHookResult = ReturnType<typeof useGetUserNotificationsCountQuery>;
export type GetUserNotificationsCountLazyQueryHookResult = ReturnType<typeof useGetUserNotificationsCountLazyQuery>;
export type GetUserNotificationsCountQueryResult = Apollo.QueryResult<GetUserNotificationsCountQuery, GetUserNotificationsCountQueryVariables>;
export const UpdateNotificationsAsReadDocument = gql`
    mutation updateNotificationsAsRead($updates: [UserNotificationsUpdates!]!) {
  updateUserNotificationsMany(updates: $updates) {
    returning {
      id
      status
    }
  }
}
    `;
export type UpdateNotificationsAsReadMutationFn = Apollo.MutationFunction<UpdateNotificationsAsReadMutation, UpdateNotificationsAsReadMutationVariables>;

/**
 * __useUpdateNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationsAsReadMutation, { data, loading, error }] = useUpdateNotificationsAsReadMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationsAsReadMutation, UpdateNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationsAsReadMutation, UpdateNotificationsAsReadMutationVariables>(UpdateNotificationsAsReadDocument, options);
      }
export type UpdateNotificationsAsReadMutationHookResult = ReturnType<typeof useUpdateNotificationsAsReadMutation>;
export type UpdateNotificationsAsReadMutationResult = Apollo.MutationResult<UpdateNotificationsAsReadMutation>;
export type UpdateNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationsAsReadMutation, UpdateNotificationsAsReadMutationVariables>;
export const InsertUserReviewDocument = gql`
    mutation insertUserReview($lessonId: uuid, $rating: Int!, $review: String, $reviewerUserId: uuid!, $videoAnalysisId: uuid, $type: CoachReviewTypesEnum!, $externalUrl: String, $externalSource: CoachExternalReviewSourcesEnum!, $externalImageUrl: String, $externalImageFileName: String, $externalDomain: String, $coachUserId: uuid!) {
  insertReviewsOne(
    object: {lessonId: $lessonId, rating: $rating, review: $review, reviewerUserId: $reviewerUserId, videoAnalysisId: $videoAnalysisId, type: $type, externalUrl: $externalUrl, externalSource: $externalSource, externalImageUrl: $externalImageUrl, externalImageFileName: $externalImageFileName, externalDomain: $externalDomain, coachUserId: $coachUserId}
  ) {
    coachUserId
    createdAt
    deletedAt
    externalDomain
    externalImageFileName
    externalImageUrl
    externalSource
    externalUrl
    lessonId
    review
    rating
    reviewerUserId
    type
    videoAnalysisId
  }
}
    `;
export type InsertUserReviewMutationFn = Apollo.MutationFunction<InsertUserReviewMutation, InsertUserReviewMutationVariables>;

/**
 * __useInsertUserReviewMutation__
 *
 * To run a mutation, you first call `useInsertUserReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserReviewMutation, { data, loading, error }] = useInsertUserReviewMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      rating: // value for 'rating'
 *      review: // value for 'review'
 *      reviewerUserId: // value for 'reviewerUserId'
 *      videoAnalysisId: // value for 'videoAnalysisId'
 *      type: // value for 'type'
 *      externalUrl: // value for 'externalUrl'
 *      externalSource: // value for 'externalSource'
 *      externalImageUrl: // value for 'externalImageUrl'
 *      externalImageFileName: // value for 'externalImageFileName'
 *      externalDomain: // value for 'externalDomain'
 *      coachUserId: // value for 'coachUserId'
 *   },
 * });
 */
export function useInsertUserReviewMutation(baseOptions?: Apollo.MutationHookOptions<InsertUserReviewMutation, InsertUserReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUserReviewMutation, InsertUserReviewMutationVariables>(InsertUserReviewDocument, options);
      }
export type InsertUserReviewMutationHookResult = ReturnType<typeof useInsertUserReviewMutation>;
export type InsertUserReviewMutationResult = Apollo.MutationResult<InsertUserReviewMutation>;
export type InsertUserReviewMutationOptions = Apollo.BaseMutationOptions<InsertUserReviewMutation, InsertUserReviewMutationVariables>;
export const GetUserDefaultCreditCardDocument = gql`
    query getUserDefaultCreditCard($userId: uuid!) {
  usersByPk(id: $userId) {
    defaultCreditCardId
  }
}
    `;

/**
 * __useGetUserDefaultCreditCardQuery__
 *
 * To run a query within a React component, call `useGetUserDefaultCreditCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDefaultCreditCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDefaultCreditCardQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserDefaultCreditCardQuery(baseOptions: Apollo.QueryHookOptions<GetUserDefaultCreditCardQuery, GetUserDefaultCreditCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDefaultCreditCardQuery, GetUserDefaultCreditCardQueryVariables>(GetUserDefaultCreditCardDocument, options);
      }
export function useGetUserDefaultCreditCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDefaultCreditCardQuery, GetUserDefaultCreditCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDefaultCreditCardQuery, GetUserDefaultCreditCardQueryVariables>(GetUserDefaultCreditCardDocument, options);
        }
export type GetUserDefaultCreditCardQueryHookResult = ReturnType<typeof useGetUserDefaultCreditCardQuery>;
export type GetUserDefaultCreditCardLazyQueryHookResult = ReturnType<typeof useGetUserDefaultCreditCardLazyQuery>;
export type GetUserDefaultCreditCardQueryResult = Apollo.QueryResult<GetUserDefaultCreditCardQuery, GetUserDefaultCreditCardQueryVariables>;
export const UpdateUserCityDocument = gql`
    mutation updateUserCity($id: uuid!, $activeCityId: uuid, $latitude: numeric, $longitude: numeric, $geometry: geography) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {activeCityId: $activeCityId, latitude: $latitude, longitude: $longitude, geometry: $geometry}
  ) {
    id
    activeCityId
    latitude
    longitude
    geometry
  }
}
    `;
export type UpdateUserCityMutationFn = Apollo.MutationFunction<UpdateUserCityMutation, UpdateUserCityMutationVariables>;

/**
 * __useUpdateUserCityMutation__
 *
 * To run a mutation, you first call `useUpdateUserCityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCityMutation, { data, loading, error }] = useUpdateUserCityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      activeCityId: // value for 'activeCityId'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      geometry: // value for 'geometry'
 *   },
 * });
 */
export function useUpdateUserCityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCityMutation, UpdateUserCityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCityMutation, UpdateUserCityMutationVariables>(UpdateUserCityDocument, options);
      }
export type UpdateUserCityMutationHookResult = ReturnType<typeof useUpdateUserCityMutation>;
export type UpdateUserCityMutationResult = Apollo.MutationResult<UpdateUserCityMutation>;
export type UpdateUserCityMutationOptions = Apollo.BaseMutationOptions<UpdateUserCityMutation, UpdateUserCityMutationVariables>;
export const GetActiveCityDocument = gql`
    query getActiveCity($userId: uuid!) {
  usersByPk(id: $userId) {
    id
    activeCity {
      id
      name
      latitude
      longitude
      countrySubdivision {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetActiveCityQuery__
 *
 * To run a query within a React component, call `useGetActiveCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCityQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetActiveCityQuery(baseOptions: Apollo.QueryHookOptions<GetActiveCityQuery, GetActiveCityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveCityQuery, GetActiveCityQueryVariables>(GetActiveCityDocument, options);
      }
export function useGetActiveCityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveCityQuery, GetActiveCityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveCityQuery, GetActiveCityQueryVariables>(GetActiveCityDocument, options);
        }
export type GetActiveCityQueryHookResult = ReturnType<typeof useGetActiveCityQuery>;
export type GetActiveCityLazyQueryHookResult = ReturnType<typeof useGetActiveCityLazyQuery>;
export type GetActiveCityQueryResult = Apollo.QueryResult<GetActiveCityQuery, GetActiveCityQueryVariables>;
export const SearchCitiesDocument = gql`
    query searchCities($name: String!, $limit: Int!) {
  cities(where: {name: {_ilike: $name}}, limit: $limit) {
    id
    name
    latitude
    longitude
    countrySubdivision {
      id
      name
    }
  }
}
    `;

/**
 * __useSearchCitiesQuery__
 *
 * To run a query within a React component, call `useSearchCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCitiesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchCitiesQuery(baseOptions: Apollo.QueryHookOptions<SearchCitiesQuery, SearchCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCitiesQuery, SearchCitiesQueryVariables>(SearchCitiesDocument, options);
      }
export function useSearchCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCitiesQuery, SearchCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCitiesQuery, SearchCitiesQueryVariables>(SearchCitiesDocument, options);
        }
export type SearchCitiesQueryHookResult = ReturnType<typeof useSearchCitiesQuery>;
export type SearchCitiesLazyQueryHookResult = ReturnType<typeof useSearchCitiesLazyQuery>;
export type SearchCitiesQueryResult = Apollo.QueryResult<SearchCitiesQuery, SearchCitiesQueryVariables>;
export const InsertUserGroupMembershipDocument = gql`
    mutation insertUserGroupMembership($groupId: uuid!, $userId: uuid!) {
  insertGroupMembersOne(
    object: {groupId: $groupId, userId: $userId, isActive: true}
  ) {
    id
  }
}
    `;
export type InsertUserGroupMembershipMutationFn = Apollo.MutationFunction<InsertUserGroupMembershipMutation, InsertUserGroupMembershipMutationVariables>;

/**
 * __useInsertUserGroupMembershipMutation__
 *
 * To run a mutation, you first call `useInsertUserGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserGroupMembershipMutation, { data, loading, error }] = useInsertUserGroupMembershipMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInsertUserGroupMembershipMutation(baseOptions?: Apollo.MutationHookOptions<InsertUserGroupMembershipMutation, InsertUserGroupMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUserGroupMembershipMutation, InsertUserGroupMembershipMutationVariables>(InsertUserGroupMembershipDocument, options);
      }
export type InsertUserGroupMembershipMutationHookResult = ReturnType<typeof useInsertUserGroupMembershipMutation>;
export type InsertUserGroupMembershipMutationResult = Apollo.MutationResult<InsertUserGroupMembershipMutation>;
export type InsertUserGroupMembershipMutationOptions = Apollo.BaseMutationOptions<InsertUserGroupMembershipMutation, InsertUserGroupMembershipMutationVariables>;
export const GetClosestCitiesDocument = gql`
    query getClosestCities($distance: Float!, $from: geography!) {
  cities(where: {geometry: {_stDWithin: {distance: $distance, from: $from}}}) {
    id
    name
    geometry
    latitude
    longitude
    slug
  }
}
    `;

/**
 * __useGetClosestCitiesQuery__
 *
 * To run a query within a React component, call `useGetClosestCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClosestCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClosestCitiesQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useGetClosestCitiesQuery(baseOptions: Apollo.QueryHookOptions<GetClosestCitiesQuery, GetClosestCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClosestCitiesQuery, GetClosestCitiesQueryVariables>(GetClosestCitiesDocument, options);
      }
export function useGetClosestCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClosestCitiesQuery, GetClosestCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClosestCitiesQuery, GetClosestCitiesQueryVariables>(GetClosestCitiesDocument, options);
        }
export type GetClosestCitiesQueryHookResult = ReturnType<typeof useGetClosestCitiesQuery>;
export type GetClosestCitiesLazyQueryHookResult = ReturnType<typeof useGetClosestCitiesLazyQuery>;
export type GetClosestCitiesQueryResult = Apollo.QueryResult<GetClosestCitiesQuery, GetClosestCitiesQueryVariables>;
export const UpdateCoachSettingsQuickDocument = gql`
    mutation updateCoachSettingsQuick($userId: uuid!, $defaultSport: SportsEnum!, $sports: [CoachSportsInsertInput!]!, $profileImageFileName: String!, $profileImagePath: String, $profileImageProvider: String, $profileImageProviderId: String, $profileImageProviderUrl: String, $profileImageUrl: String, $priceUnitAmountRemoteCoachDefault: Int, $priceUnitAmountCoachDefault: Int, $gender: GenderEnum, $images: [UserFilesInsertInput!] = [], $phoneNumber: String, $phoneCountryCode: String) {
  updateUsersByPk(
    pkColumns: {id: $userId}
    _set: {defaultSport: $defaultSport, profileImageFileName: $profileImageFileName, profileImagePath: $profileImagePath, profileImageProvider: $profileImageProvider, profileImageProviderId: $profileImageProviderId, profileImageProviderUrl: $profileImageProviderUrl, profileImageUrl: $profileImageUrl, priceUnitAmountRemoteCoachDefault: $priceUnitAmountRemoteCoachDefault, priceUnitAmountCoachDefault: $priceUnitAmountCoachDefault, gender: $gender, phoneNumber: $phoneNumber, phoneCountryCode: $phoneCountryCode}
  ) {
    id
  }
  insertCoachSports(
    objects: $sports
    onConflict: {constraint: coach_sports_user_id_sport_key, updateColumns: status}
  ) {
    returning {
      id
      sport
      status
      userId
    }
  }
}
    `;
export type UpdateCoachSettingsQuickMutationFn = Apollo.MutationFunction<UpdateCoachSettingsQuickMutation, UpdateCoachSettingsQuickMutationVariables>;

/**
 * __useUpdateCoachSettingsQuickMutation__
 *
 * To run a mutation, you first call `useUpdateCoachSettingsQuickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachSettingsQuickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachSettingsQuickMutation, { data, loading, error }] = useUpdateCoachSettingsQuickMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      defaultSport: // value for 'defaultSport'
 *      sports: // value for 'sports'
 *      profileImageFileName: // value for 'profileImageFileName'
 *      profileImagePath: // value for 'profileImagePath'
 *      profileImageProvider: // value for 'profileImageProvider'
 *      profileImageProviderId: // value for 'profileImageProviderId'
 *      profileImageProviderUrl: // value for 'profileImageProviderUrl'
 *      profileImageUrl: // value for 'profileImageUrl'
 *      priceUnitAmountRemoteCoachDefault: // value for 'priceUnitAmountRemoteCoachDefault'
 *      priceUnitAmountCoachDefault: // value for 'priceUnitAmountCoachDefault'
 *      gender: // value for 'gender'
 *      images: // value for 'images'
 *      phoneNumber: // value for 'phoneNumber'
 *      phoneCountryCode: // value for 'phoneCountryCode'
 *   },
 * });
 */
export function useUpdateCoachSettingsQuickMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoachSettingsQuickMutation, UpdateCoachSettingsQuickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoachSettingsQuickMutation, UpdateCoachSettingsQuickMutationVariables>(UpdateCoachSettingsQuickDocument, options);
      }
export type UpdateCoachSettingsQuickMutationHookResult = ReturnType<typeof useUpdateCoachSettingsQuickMutation>;
export type UpdateCoachSettingsQuickMutationResult = Apollo.MutationResult<UpdateCoachSettingsQuickMutation>;
export type UpdateCoachSettingsQuickMutationOptions = Apollo.BaseMutationOptions<UpdateCoachSettingsQuickMutation, UpdateCoachSettingsQuickMutationVariables>;
export const InsertPlayerReviewDocument = gql`
    mutation insertPlayerReview($playerUserId: uuid!, $reviewerUserId: uuid!, $rating: Int!, $review: String, $isPlayerSkillLevelAccurate: Boolean) {
  insertReviewsOne(
    object: {playerUserId: $playerUserId, reviewerUserId: $reviewerUserId, rating: $rating, review: $review, isPlayerSkillLevelAccurate: $isPlayerSkillLevelAccurate}
  ) {
    id
    rating
    review
    createdAt
    playerUserId
    reviewerUserId
  }
}
    `;
export type InsertPlayerReviewMutationFn = Apollo.MutationFunction<InsertPlayerReviewMutation, InsertPlayerReviewMutationVariables>;

/**
 * __useInsertPlayerReviewMutation__
 *
 * To run a mutation, you first call `useInsertPlayerReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPlayerReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPlayerReviewMutation, { data, loading, error }] = useInsertPlayerReviewMutation({
 *   variables: {
 *      playerUserId: // value for 'playerUserId'
 *      reviewerUserId: // value for 'reviewerUserId'
 *      rating: // value for 'rating'
 *      review: // value for 'review'
 *      isPlayerSkillLevelAccurate: // value for 'isPlayerSkillLevelAccurate'
 *   },
 * });
 */
export function useInsertPlayerReviewMutation(baseOptions?: Apollo.MutationHookOptions<InsertPlayerReviewMutation, InsertPlayerReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPlayerReviewMutation, InsertPlayerReviewMutationVariables>(InsertPlayerReviewDocument, options);
      }
export type InsertPlayerReviewMutationHookResult = ReturnType<typeof useInsertPlayerReviewMutation>;
export type InsertPlayerReviewMutationResult = Apollo.MutationResult<InsertPlayerReviewMutation>;
export type InsertPlayerReviewMutationOptions = Apollo.BaseMutationOptions<InsertPlayerReviewMutation, InsertPlayerReviewMutationVariables>;
export const GetCoachReviewsByCoachIdDocument = gql`
    query getCoachReviewsByCoachId($coachUserId: uuid!, $orderBy: [ReviewsOrderBy!] = {createdAt: DESC}) {
  reviews(where: {coachUserId: {_eq: $coachUserId}}, orderBy: $orderBy) {
    coach {
      profileImagePath
      profileImageFileName
      profileImageProviderUrl
      profileImageProvider
      id
      username
      fullName
    }
    createdAt
    externalDomain
    externalImageFileName
    externalImageUrl
    externalSource
    externalUrl
    externalFullName
    id
    rating
    review
    reviewer {
      profileImagePath
      profileImageFileName
      profileImageProviderUrl
      profileImageProvider
      id
      username
      fullName
    }
    type
  }
}
    `;

/**
 * __useGetCoachReviewsByCoachIdQuery__
 *
 * To run a query within a React component, call `useGetCoachReviewsByCoachIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachReviewsByCoachIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachReviewsByCoachIdQuery({
 *   variables: {
 *      coachUserId: // value for 'coachUserId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetCoachReviewsByCoachIdQuery(baseOptions: Apollo.QueryHookOptions<GetCoachReviewsByCoachIdQuery, GetCoachReviewsByCoachIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachReviewsByCoachIdQuery, GetCoachReviewsByCoachIdQueryVariables>(GetCoachReviewsByCoachIdDocument, options);
      }
export function useGetCoachReviewsByCoachIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachReviewsByCoachIdQuery, GetCoachReviewsByCoachIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachReviewsByCoachIdQuery, GetCoachReviewsByCoachIdQueryVariables>(GetCoachReviewsByCoachIdDocument, options);
        }
export type GetCoachReviewsByCoachIdQueryHookResult = ReturnType<typeof useGetCoachReviewsByCoachIdQuery>;
export type GetCoachReviewsByCoachIdLazyQueryHookResult = ReturnType<typeof useGetCoachReviewsByCoachIdLazyQuery>;
export type GetCoachReviewsByCoachIdQueryResult = Apollo.QueryResult<GetCoachReviewsByCoachIdQuery, GetCoachReviewsByCoachIdQueryVariables>;
export const GetCoachReviewCheckDocument = gql`
    query getCoachReviewCheck($coachUserId: uuid!, $playerUserId: uuid!) {
  coach: userProfiles(where: {id: {_eq: $coachUserId}}) {
    profileImagePath
    profileImageFileName
    profileImageProviderUrl
    profileImageProvider
    id
    username
    fullName
  }
  player: userProfiles(where: {id: {_eq: $playerUserId}}) {
    profileImagePath
    profileImageFileName
    profileImageProviderUrl
    profileImageProvider
    id
    username
    fullName
  }
  reviews(
    where: {coachUserId: {_eq: $coachUserId}, reviewerUserId: {_eq: $playerUserId}}
  ) {
    id
  }
}
    `;

/**
 * __useGetCoachReviewCheckQuery__
 *
 * To run a query within a React component, call `useGetCoachReviewCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachReviewCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachReviewCheckQuery({
 *   variables: {
 *      coachUserId: // value for 'coachUserId'
 *      playerUserId: // value for 'playerUserId'
 *   },
 * });
 */
export function useGetCoachReviewCheckQuery(baseOptions: Apollo.QueryHookOptions<GetCoachReviewCheckQuery, GetCoachReviewCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachReviewCheckQuery, GetCoachReviewCheckQueryVariables>(GetCoachReviewCheckDocument, options);
      }
export function useGetCoachReviewCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachReviewCheckQuery, GetCoachReviewCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachReviewCheckQuery, GetCoachReviewCheckQueryVariables>(GetCoachReviewCheckDocument, options);
        }
export type GetCoachReviewCheckQueryHookResult = ReturnType<typeof useGetCoachReviewCheckQuery>;
export type GetCoachReviewCheckLazyQueryHookResult = ReturnType<typeof useGetCoachReviewCheckLazyQuery>;
export type GetCoachReviewCheckQueryResult = Apollo.QueryResult<GetCoachReviewCheckQuery, GetCoachReviewCheckQueryVariables>;
export const InsertUsagePingDocument = gql`
    mutation insertUsagePing($pathname: String = "", $userId: uuid, $firebaseId: String, $queryString: String = "", $platform: String = "", $ip: String = "", $timezone: String = "", $country: String = "", $region: String = "", $city: String = "", $zip: String = "", $ipResponse: jsonb) {
  insertAppPingsOne(
    object: {pathname: $pathname, userId: $userId, firebaseId: $firebaseId, queryString: $queryString, platform: $platform, ip: $ip, timezone: $timezone, country: $country, region: $region, city: $city, zip: $zip, ipResponse: $ipResponse}
  ) {
    id
  }
}
    `;
export type InsertUsagePingMutationFn = Apollo.MutationFunction<InsertUsagePingMutation, InsertUsagePingMutationVariables>;

/**
 * __useInsertUsagePingMutation__
 *
 * To run a mutation, you first call `useInsertUsagePingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUsagePingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUsagePingMutation, { data, loading, error }] = useInsertUsagePingMutation({
 *   variables: {
 *      pathname: // value for 'pathname'
 *      userId: // value for 'userId'
 *      firebaseId: // value for 'firebaseId'
 *      queryString: // value for 'queryString'
 *      platform: // value for 'platform'
 *      ip: // value for 'ip'
 *      timezone: // value for 'timezone'
 *      country: // value for 'country'
 *      region: // value for 'region'
 *      city: // value for 'city'
 *      zip: // value for 'zip'
 *      ipResponse: // value for 'ipResponse'
 *   },
 * });
 */
export function useInsertUsagePingMutation(baseOptions?: Apollo.MutationHookOptions<InsertUsagePingMutation, InsertUsagePingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUsagePingMutation, InsertUsagePingMutationVariables>(InsertUsagePingDocument, options);
      }
export type InsertUsagePingMutationHookResult = ReturnType<typeof useInsertUsagePingMutation>;
export type InsertUsagePingMutationResult = Apollo.MutationResult<InsertUsagePingMutation>;
export type InsertUsagePingMutationOptions = Apollo.BaseMutationOptions<InsertUsagePingMutation, InsertUsagePingMutationVariables>;
export const UpdateUserLocaleAndTimezoneDocument = gql`
    mutation updateUserLocaleAndTimezone($id: uuid!, $locale: String, $timezone: String) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {locale: $locale, timezone: $timezone}
  ) {
    id
    locale
    timezone
  }
}
    `;
export type UpdateUserLocaleAndTimezoneMutationFn = Apollo.MutationFunction<UpdateUserLocaleAndTimezoneMutation, UpdateUserLocaleAndTimezoneMutationVariables>;

/**
 * __useUpdateUserLocaleAndTimezoneMutation__
 *
 * To run a mutation, you first call `useUpdateUserLocaleAndTimezoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLocaleAndTimezoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLocaleAndTimezoneMutation, { data, loading, error }] = useUpdateUserLocaleAndTimezoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      locale: // value for 'locale'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useUpdateUserLocaleAndTimezoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserLocaleAndTimezoneMutation, UpdateUserLocaleAndTimezoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserLocaleAndTimezoneMutation, UpdateUserLocaleAndTimezoneMutationVariables>(UpdateUserLocaleAndTimezoneDocument, options);
      }
export type UpdateUserLocaleAndTimezoneMutationHookResult = ReturnType<typeof useUpdateUserLocaleAndTimezoneMutation>;
export type UpdateUserLocaleAndTimezoneMutationResult = Apollo.MutationResult<UpdateUserLocaleAndTimezoneMutation>;
export type UpdateUserLocaleAndTimezoneMutationOptions = Apollo.BaseMutationOptions<UpdateUserLocaleAndTimezoneMutation, UpdateUserLocaleAndTimezoneMutationVariables>;
export const GetCalendarAccountsDocument = gql`
    query getCalendarAccounts($userId: uuid!) {
  calendarAccounts(where: {userId: {_eq: $userId}}) {
    id
    email
    provider
    connected
    createdAt
    updatedAt
    calendarPreferences(orderBy: {calendarName: ASC}) {
      id
      calendarId
      calendarName
      isEnabled
      isDefault
      isWritable
    }
  }
}
    `;

/**
 * __useGetCalendarAccountsQuery__
 *
 * To run a query within a React component, call `useGetCalendarAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarAccountsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCalendarAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetCalendarAccountsQuery, GetCalendarAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendarAccountsQuery, GetCalendarAccountsQueryVariables>(GetCalendarAccountsDocument, options);
      }
export function useGetCalendarAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarAccountsQuery, GetCalendarAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendarAccountsQuery, GetCalendarAccountsQueryVariables>(GetCalendarAccountsDocument, options);
        }
export type GetCalendarAccountsQueryHookResult = ReturnType<typeof useGetCalendarAccountsQuery>;
export type GetCalendarAccountsLazyQueryHookResult = ReturnType<typeof useGetCalendarAccountsLazyQuery>;
export type GetCalendarAccountsQueryResult = Apollo.QueryResult<GetCalendarAccountsQuery, GetCalendarAccountsQueryVariables>;
export const UpdateCalendarAccountStatusDocument = gql`
    mutation updateCalendarAccountStatus($id: uuid!, $connected: Boolean!) {
  updateCalendarAccounts(where: {id: {_eq: $id}}, _set: {connected: $connected}) {
    returning {
      id
    }
  }
}
    `;
export type UpdateCalendarAccountStatusMutationFn = Apollo.MutationFunction<UpdateCalendarAccountStatusMutation, UpdateCalendarAccountStatusMutationVariables>;

/**
 * __useUpdateCalendarAccountStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarAccountStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarAccountStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarAccountStatusMutation, { data, loading, error }] = useUpdateCalendarAccountStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      connected: // value for 'connected'
 *   },
 * });
 */
export function useUpdateCalendarAccountStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarAccountStatusMutation, UpdateCalendarAccountStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalendarAccountStatusMutation, UpdateCalendarAccountStatusMutationVariables>(UpdateCalendarAccountStatusDocument, options);
      }
export type UpdateCalendarAccountStatusMutationHookResult = ReturnType<typeof useUpdateCalendarAccountStatusMutation>;
export type UpdateCalendarAccountStatusMutationResult = Apollo.MutationResult<UpdateCalendarAccountStatusMutation>;
export type UpdateCalendarAccountStatusMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarAccountStatusMutation, UpdateCalendarAccountStatusMutationVariables>;
export const UpdateCalendarPreferenceDocument = gql`
    mutation updateCalendarPreference($id: uuid!, $isEnabled: Boolean!) {
  updateCalendarPreferences(
    where: {id: {_eq: $id}}
    _set: {isEnabled: $isEnabled}
  ) {
    returning {
      id
      isEnabled
    }
  }
}
    `;
export type UpdateCalendarPreferenceMutationFn = Apollo.MutationFunction<UpdateCalendarPreferenceMutation, UpdateCalendarPreferenceMutationVariables>;

/**
 * __useUpdateCalendarPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarPreferenceMutation, { data, loading, error }] = useUpdateCalendarPreferenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isEnabled: // value for 'isEnabled'
 *   },
 * });
 */
export function useUpdateCalendarPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarPreferenceMutation, UpdateCalendarPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalendarPreferenceMutation, UpdateCalendarPreferenceMutationVariables>(UpdateCalendarPreferenceDocument, options);
      }
export type UpdateCalendarPreferenceMutationHookResult = ReturnType<typeof useUpdateCalendarPreferenceMutation>;
export type UpdateCalendarPreferenceMutationResult = Apollo.MutationResult<UpdateCalendarPreferenceMutation>;
export type UpdateCalendarPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarPreferenceMutation, UpdateCalendarPreferenceMutationVariables>;
export const UpdateDefaultCalendarPreferenceDocument = gql`
    mutation updateDefaultCalendarPreference($userId: uuid!, $preferenceId: uuid!) {
  updateCalendarPreferences(
    where: {calendarAccount: {userId: {_eq: $userId}}}
    _set: {isDefault: false}
  ) {
    affectedRows
  }
  updateCalendarPreferencesByPk(
    pkColumns: {id: $preferenceId}
    _set: {isDefault: true}
  ) {
    id
    isDefault
  }
}
    `;
export type UpdateDefaultCalendarPreferenceMutationFn = Apollo.MutationFunction<UpdateDefaultCalendarPreferenceMutation, UpdateDefaultCalendarPreferenceMutationVariables>;

/**
 * __useUpdateDefaultCalendarPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultCalendarPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultCalendarPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultCalendarPreferenceMutation, { data, loading, error }] = useUpdateDefaultCalendarPreferenceMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      preferenceId: // value for 'preferenceId'
 *   },
 * });
 */
export function useUpdateDefaultCalendarPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultCalendarPreferenceMutation, UpdateDefaultCalendarPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultCalendarPreferenceMutation, UpdateDefaultCalendarPreferenceMutationVariables>(UpdateDefaultCalendarPreferenceDocument, options);
      }
export type UpdateDefaultCalendarPreferenceMutationHookResult = ReturnType<typeof useUpdateDefaultCalendarPreferenceMutation>;
export type UpdateDefaultCalendarPreferenceMutationResult = Apollo.MutationResult<UpdateDefaultCalendarPreferenceMutation>;
export type UpdateDefaultCalendarPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultCalendarPreferenceMutation, UpdateDefaultCalendarPreferenceMutationVariables>;
export const UpdateUserSessionTimestampsDocument = gql`
    mutation UpdateUserSessionTimestamps($id: uuid!, $lastLoginAt: timestamptz!) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {lastLoginAt: $lastLoginAt, lastSessionAt: "now()"}
  ) {
    id
    lastSessionAt
    lastLoginAt
  }
}
    `;
export type UpdateUserSessionTimestampsMutationFn = Apollo.MutationFunction<UpdateUserSessionTimestampsMutation, UpdateUserSessionTimestampsMutationVariables>;

/**
 * __useUpdateUserSessionTimestampsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSessionTimestampsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSessionTimestampsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSessionTimestampsMutation, { data, loading, error }] = useUpdateUserSessionTimestampsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      lastLoginAt: // value for 'lastLoginAt'
 *   },
 * });
 */
export function useUpdateUserSessionTimestampsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSessionTimestampsMutation, UpdateUserSessionTimestampsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSessionTimestampsMutation, UpdateUserSessionTimestampsMutationVariables>(UpdateUserSessionTimestampsDocument, options);
      }
export type UpdateUserSessionTimestampsMutationHookResult = ReturnType<typeof useUpdateUserSessionTimestampsMutation>;
export type UpdateUserSessionTimestampsMutationResult = Apollo.MutationResult<UpdateUserSessionTimestampsMutation>;
export type UpdateUserSessionTimestampsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSessionTimestampsMutation, UpdateUserSessionTimestampsMutationVariables>;
export const InsertCoachPremiumContentDocument = gql`
    mutation insertCoachPremiumContent($skills: [UserContentFilesSkillsInsertInput!]!, $description: String!, $fileName: String!, $fileType: String!, $host: String!, $fileFormat: FileFormatEnum!, $originalFileName: String!, $provider: String!, $providerUrl: String!, $providerId: String!, $title: String!, $url: String!, $userId: uuid!, $tier: UserContentTiersEnum!) {
  insertUserContentFilesOne(
    object: {description: $description, fileCategory: COACH, fileFormat: $fileFormat, fileName: $fileName, fileType: $fileType, host: $host, originalFileName: $originalFileName, provider: $provider, providerUrl: $providerUrl, providerId: $providerId, tier: $tier, title: $title, url: $url, userId: $userId, userContentFilesSkills: {data: $skills, onConflict: {constraint: user_content_files_skills_pkey}}}
  ) {
    id
    createdAt
    updatedAt
  }
}
    `;
export type InsertCoachPremiumContentMutationFn = Apollo.MutationFunction<InsertCoachPremiumContentMutation, InsertCoachPremiumContentMutationVariables>;

/**
 * __useInsertCoachPremiumContentMutation__
 *
 * To run a mutation, you first call `useInsertCoachPremiumContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCoachPremiumContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCoachPremiumContentMutation, { data, loading, error }] = useInsertCoachPremiumContentMutation({
 *   variables: {
 *      skills: // value for 'skills'
 *      description: // value for 'description'
 *      fileName: // value for 'fileName'
 *      fileType: // value for 'fileType'
 *      host: // value for 'host'
 *      fileFormat: // value for 'fileFormat'
 *      originalFileName: // value for 'originalFileName'
 *      provider: // value for 'provider'
 *      providerUrl: // value for 'providerUrl'
 *      providerId: // value for 'providerId'
 *      title: // value for 'title'
 *      url: // value for 'url'
 *      userId: // value for 'userId'
 *      tier: // value for 'tier'
 *   },
 * });
 */
export function useInsertCoachPremiumContentMutation(baseOptions?: Apollo.MutationHookOptions<InsertCoachPremiumContentMutation, InsertCoachPremiumContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCoachPremiumContentMutation, InsertCoachPremiumContentMutationVariables>(InsertCoachPremiumContentDocument, options);
      }
export type InsertCoachPremiumContentMutationHookResult = ReturnType<typeof useInsertCoachPremiumContentMutation>;
export type InsertCoachPremiumContentMutationResult = Apollo.MutationResult<InsertCoachPremiumContentMutation>;
export type InsertCoachPremiumContentMutationOptions = Apollo.BaseMutationOptions<InsertCoachPremiumContentMutation, InsertCoachPremiumContentMutationVariables>;
export const InsertPlaySessionCommentDocument = gql`
    mutation insertPlaySessionComment($content: String!, $playSessionId: uuid!, $playSessionCommentId: uuid = null, $playSessionRootCommentId: uuid = null, $userId: uuid!) {
  insertPlaySessionCommentsOne(
    object: {content: $content, playSessionId: $playSessionId, playSessionCommentId: $playSessionCommentId, playSessionRootCommentId: $playSessionRootCommentId, userId: $userId}
  ) {
    content
    id
    createdAt
    deletedAt
    playSessionCommentId
    playSessionId
    playSessionRootCommentId
    updatedAt
    userId
  }
}
    `;
export type InsertPlaySessionCommentMutationFn = Apollo.MutationFunction<InsertPlaySessionCommentMutation, InsertPlaySessionCommentMutationVariables>;

/**
 * __useInsertPlaySessionCommentMutation__
 *
 * To run a mutation, you first call `useInsertPlaySessionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPlaySessionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPlaySessionCommentMutation, { data, loading, error }] = useInsertPlaySessionCommentMutation({
 *   variables: {
 *      content: // value for 'content'
 *      playSessionId: // value for 'playSessionId'
 *      playSessionCommentId: // value for 'playSessionCommentId'
 *      playSessionRootCommentId: // value for 'playSessionRootCommentId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInsertPlaySessionCommentMutation(baseOptions?: Apollo.MutationHookOptions<InsertPlaySessionCommentMutation, InsertPlaySessionCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPlaySessionCommentMutation, InsertPlaySessionCommentMutationVariables>(InsertPlaySessionCommentDocument, options);
      }
export type InsertPlaySessionCommentMutationHookResult = ReturnType<typeof useInsertPlaySessionCommentMutation>;
export type InsertPlaySessionCommentMutationResult = Apollo.MutationResult<InsertPlaySessionCommentMutation>;
export type InsertPlaySessionCommentMutationOptions = Apollo.BaseMutationOptions<InsertPlaySessionCommentMutation, InsertPlaySessionCommentMutationVariables>;
export const InsertVideoAnalysisCommentDocument = gql`
    mutation insertVideoAnalysisComment($skills: [VideoAnalysisSkillsCommentsInsertInput!] = [], $details: String!, $feedbackType: FeedbackSentimentEnum!, $videoAnalysisId: uuid!, $videoImageFileId: uuid, $userId: uuid!, $startTimestampSeconds: numeric = "", $endTimestampSeconds: numeric = "") {
  insertVideoAnalysisCommentsOne(
    object: {videoAnalysisId: $videoAnalysisId, sentiment: $feedbackType, details: $details, userId: $userId, startTimestampSeconds: $startTimestampSeconds, endTimestampSeconds: $endTimestampSeconds, videoAnalysisSkillsComments: {data: $skills, onConflict: {constraint: video_analysis_skills_comments_pkey, updateColumns: deletedAt}}, videoAnalysisFileId: $videoImageFileId}
  ) {
    id
    createdAt
    updatedAt
    details
    sentiment
    userId
  }
}
    `;
export type InsertVideoAnalysisCommentMutationFn = Apollo.MutationFunction<InsertVideoAnalysisCommentMutation, InsertVideoAnalysisCommentMutationVariables>;

/**
 * __useInsertVideoAnalysisCommentMutation__
 *
 * To run a mutation, you first call `useInsertVideoAnalysisCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertVideoAnalysisCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertVideoAnalysisCommentMutation, { data, loading, error }] = useInsertVideoAnalysisCommentMutation({
 *   variables: {
 *      skills: // value for 'skills'
 *      details: // value for 'details'
 *      feedbackType: // value for 'feedbackType'
 *      videoAnalysisId: // value for 'videoAnalysisId'
 *      videoImageFileId: // value for 'videoImageFileId'
 *      userId: // value for 'userId'
 *      startTimestampSeconds: // value for 'startTimestampSeconds'
 *      endTimestampSeconds: // value for 'endTimestampSeconds'
 *   },
 * });
 */
export function useInsertVideoAnalysisCommentMutation(baseOptions?: Apollo.MutationHookOptions<InsertVideoAnalysisCommentMutation, InsertVideoAnalysisCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertVideoAnalysisCommentMutation, InsertVideoAnalysisCommentMutationVariables>(InsertVideoAnalysisCommentDocument, options);
      }
export type InsertVideoAnalysisCommentMutationHookResult = ReturnType<typeof useInsertVideoAnalysisCommentMutation>;
export type InsertVideoAnalysisCommentMutationResult = Apollo.MutationResult<InsertVideoAnalysisCommentMutation>;
export type InsertVideoAnalysisCommentMutationOptions = Apollo.BaseMutationOptions<InsertVideoAnalysisCommentMutation, InsertVideoAnalysisCommentMutationVariables>;
export const InsertVideoAnalysisFileDocument = gql`
    mutation insertVideoAnalysisFile($videoImageFile: VideoAnalysisFilesInsertInput!) {
  insertVideoAnalysisFilesOne(object: $videoImageFile) {
    id
  }
}
    `;
export type InsertVideoAnalysisFileMutationFn = Apollo.MutationFunction<InsertVideoAnalysisFileMutation, InsertVideoAnalysisFileMutationVariables>;

/**
 * __useInsertVideoAnalysisFileMutation__
 *
 * To run a mutation, you first call `useInsertVideoAnalysisFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertVideoAnalysisFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertVideoAnalysisFileMutation, { data, loading, error }] = useInsertVideoAnalysisFileMutation({
 *   variables: {
 *      videoImageFile: // value for 'videoImageFile'
 *   },
 * });
 */
export function useInsertVideoAnalysisFileMutation(baseOptions?: Apollo.MutationHookOptions<InsertVideoAnalysisFileMutation, InsertVideoAnalysisFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertVideoAnalysisFileMutation, InsertVideoAnalysisFileMutationVariables>(InsertVideoAnalysisFileDocument, options);
      }
export type InsertVideoAnalysisFileMutationHookResult = ReturnType<typeof useInsertVideoAnalysisFileMutation>;
export type InsertVideoAnalysisFileMutationResult = Apollo.MutationResult<InsertVideoAnalysisFileMutation>;
export type InsertVideoAnalysisFileMutationOptions = Apollo.BaseMutationOptions<InsertVideoAnalysisFileMutation, InsertVideoAnalysisFileMutationVariables>;
export const UpdateFollowerInactiveDocument = gql`
    mutation updateFollowerInactive($followedUserId: uuid!, $followerUserId: uuid!) {
  updateUserFollows(
    where: {followedUserId: {_eq: $followedUserId}, followerUserId: {_eq: $followerUserId}}
    _set: {status: INACTIVE}
  ) {
    returning {
      followerUserId
      followedUserId
      status
    }
  }
}
    `;
export type UpdateFollowerInactiveMutationFn = Apollo.MutationFunction<UpdateFollowerInactiveMutation, UpdateFollowerInactiveMutationVariables>;

/**
 * __useUpdateFollowerInactiveMutation__
 *
 * To run a mutation, you first call `useUpdateFollowerInactiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFollowerInactiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFollowerInactiveMutation, { data, loading, error }] = useUpdateFollowerInactiveMutation({
 *   variables: {
 *      followedUserId: // value for 'followedUserId'
 *      followerUserId: // value for 'followerUserId'
 *   },
 * });
 */
export function useUpdateFollowerInactiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFollowerInactiveMutation, UpdateFollowerInactiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFollowerInactiveMutation, UpdateFollowerInactiveMutationVariables>(UpdateFollowerInactiveDocument, options);
      }
export type UpdateFollowerInactiveMutationHookResult = ReturnType<typeof useUpdateFollowerInactiveMutation>;
export type UpdateFollowerInactiveMutationResult = Apollo.MutationResult<UpdateFollowerInactiveMutation>;
export type UpdateFollowerInactiveMutationOptions = Apollo.BaseMutationOptions<UpdateFollowerInactiveMutation, UpdateFollowerInactiveMutationVariables>;
export const UpdateFollowerActiveDocument = gql`
    mutation updateFollowerActive($followedUserId: uuid!, $followerUserId: uuid!) {
  updateUserFollows(
    where: {followedUserId: {_eq: $followedUserId}, followerUserId: {_eq: $followerUserId}}
    _set: {status: ACTIVE}
  ) {
    returning {
      followerUserId
      followedUserId
      status
    }
  }
}
    `;
export type UpdateFollowerActiveMutationFn = Apollo.MutationFunction<UpdateFollowerActiveMutation, UpdateFollowerActiveMutationVariables>;

/**
 * __useUpdateFollowerActiveMutation__
 *
 * To run a mutation, you first call `useUpdateFollowerActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFollowerActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFollowerActiveMutation, { data, loading, error }] = useUpdateFollowerActiveMutation({
 *   variables: {
 *      followedUserId: // value for 'followedUserId'
 *      followerUserId: // value for 'followerUserId'
 *   },
 * });
 */
export function useUpdateFollowerActiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFollowerActiveMutation, UpdateFollowerActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFollowerActiveMutation, UpdateFollowerActiveMutationVariables>(UpdateFollowerActiveDocument, options);
      }
export type UpdateFollowerActiveMutationHookResult = ReturnType<typeof useUpdateFollowerActiveMutation>;
export type UpdateFollowerActiveMutationResult = Apollo.MutationResult<UpdateFollowerActiveMutation>;
export type UpdateFollowerActiveMutationOptions = Apollo.BaseMutationOptions<UpdateFollowerActiveMutation, UpdateFollowerActiveMutationVariables>;
export const UpdateUserBasicFieldsDocument = gql`
    mutation updateUserBasicFields($id: uuid!, $activeCityId: uuid, $fullName: String!, $username: String, $isPendingAccountDetails: Boolean, $coachStatus: CoachStatusEnum) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {activeCityId: $activeCityId, fullName: $fullName, username: $username, isPendingAccountDetails: $isPendingAccountDetails, coachStatus: $coachStatus}
  ) {
    id
    activeCityId
    fullName
    username
    isPendingAccountDetails
    coachStatus
    activeCity {
      id
      name
      countrySubdivision {
        id
        name
      }
    }
  }
}
    `;
export type UpdateUserBasicFieldsMutationFn = Apollo.MutationFunction<UpdateUserBasicFieldsMutation, UpdateUserBasicFieldsMutationVariables>;

/**
 * __useUpdateUserBasicFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateUserBasicFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserBasicFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserBasicFieldsMutation, { data, loading, error }] = useUpdateUserBasicFieldsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      activeCityId: // value for 'activeCityId'
 *      fullName: // value for 'fullName'
 *      username: // value for 'username'
 *      isPendingAccountDetails: // value for 'isPendingAccountDetails'
 *      coachStatus: // value for 'coachStatus'
 *   },
 * });
 */
export function useUpdateUserBasicFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserBasicFieldsMutation, UpdateUserBasicFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserBasicFieldsMutation, UpdateUserBasicFieldsMutationVariables>(UpdateUserBasicFieldsDocument, options);
      }
export type UpdateUserBasicFieldsMutationHookResult = ReturnType<typeof useUpdateUserBasicFieldsMutation>;
export type UpdateUserBasicFieldsMutationResult = Apollo.MutationResult<UpdateUserBasicFieldsMutation>;
export type UpdateUserBasicFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateUserBasicFieldsMutation, UpdateUserBasicFieldsMutationVariables>;
export const UpdateUserCoverImageDocument = gql`
    mutation updateUserCoverImage($id: uuid!, $coverImageFileName: String!, $coverImagePath: String!, $coverImageProvider: String!, $coverImageProviderId: String!, $coverImageProviderUrl: String!, $coverImageUrl: String!) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {coverImageFileName: $coverImageFileName, coverImagePath: $coverImagePath, coverImageProvider: $coverImageProvider, coverImageProviderId: $coverImageProviderId, coverImageProviderUrl: $coverImageProviderUrl, coverImageUrl: $coverImageUrl}
  ) {
    id
    coverImageFileName
    coverImagePath
    coverImageProvider
    coverImageProviderId
    coverImageProviderUrl
    profile {
      id
      coverImageFileName
      coverImagePath
      coverImageProvider
      coverImageProviderUrl
    }
  }
  insertUserImageLogOne(
    object: {fileName: $coverImageFileName, provider: $coverImageProvider, providerId: $coverImageProviderId, providerUrl: $coverImageProviderUrl, userId: $id, path: $coverImagePath}
  ) {
    id
  }
}
    `;
export type UpdateUserCoverImageMutationFn = Apollo.MutationFunction<UpdateUserCoverImageMutation, UpdateUserCoverImageMutationVariables>;

/**
 * __useUpdateUserCoverImageMutation__
 *
 * To run a mutation, you first call `useUpdateUserCoverImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCoverImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCoverImageMutation, { data, loading, error }] = useUpdateUserCoverImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      coverImageFileName: // value for 'coverImageFileName'
 *      coverImagePath: // value for 'coverImagePath'
 *      coverImageProvider: // value for 'coverImageProvider'
 *      coverImageProviderId: // value for 'coverImageProviderId'
 *      coverImageProviderUrl: // value for 'coverImageProviderUrl'
 *      coverImageUrl: // value for 'coverImageUrl'
 *   },
 * });
 */
export function useUpdateUserCoverImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCoverImageMutation, UpdateUserCoverImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCoverImageMutation, UpdateUserCoverImageMutationVariables>(UpdateUserCoverImageDocument, options);
      }
export type UpdateUserCoverImageMutationHookResult = ReturnType<typeof useUpdateUserCoverImageMutation>;
export type UpdateUserCoverImageMutationResult = Apollo.MutationResult<UpdateUserCoverImageMutation>;
export type UpdateUserCoverImageMutationOptions = Apollo.BaseMutationOptions<UpdateUserCoverImageMutation, UpdateUserCoverImageMutationVariables>;
export const UpdateUserDefaultSportDocument = gql`
    mutation updateUserDefaultSport($id: uuid!, $defaultSport: SportsEnum!) {
  updateUsersByPk(pkColumns: {id: $id}, _set: {defaultSport: $defaultSport}) {
    defaultSport
    id
  }
}
    `;
export type UpdateUserDefaultSportMutationFn = Apollo.MutationFunction<UpdateUserDefaultSportMutation, UpdateUserDefaultSportMutationVariables>;

/**
 * __useUpdateUserDefaultSportMutation__
 *
 * To run a mutation, you first call `useUpdateUserDefaultSportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDefaultSportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDefaultSportMutation, { data, loading, error }] = useUpdateUserDefaultSportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      defaultSport: // value for 'defaultSport'
 *   },
 * });
 */
export function useUpdateUserDefaultSportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDefaultSportMutation, UpdateUserDefaultSportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDefaultSportMutation, UpdateUserDefaultSportMutationVariables>(UpdateUserDefaultSportDocument, options);
      }
export type UpdateUserDefaultSportMutationHookResult = ReturnType<typeof useUpdateUserDefaultSportMutation>;
export type UpdateUserDefaultSportMutationResult = Apollo.MutationResult<UpdateUserDefaultSportMutation>;
export type UpdateUserDefaultSportMutationOptions = Apollo.BaseMutationOptions<UpdateUserDefaultSportMutation, UpdateUserDefaultSportMutationVariables>;
export const UpdateUserProfileImageDocument = gql`
    mutation updateUserProfileImage($id: uuid!, $profileImageFileName: String!, $profileImagePath: String!, $profileImageProvider: String!, $profileImageProviderId: String!, $profileImageProviderUrl: String!, $profileImageUrl: String!) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {profileImageFileName: $profileImageFileName, profileImagePath: $profileImagePath, profileImageProvider: $profileImageProvider, profileImageProviderId: $profileImageProviderId, profileImageProviderUrl: $profileImageProviderUrl, profileImageUrl: $profileImageUrl}
  ) {
    id
    profileImageFileName
    profileImagePath
    profileImageProvider
    profileImageProviderId
    profileImageProviderUrl
    profile {
      id
      profileImageFileName
      profileImagePath
      profileImageProvider
      profileImageProviderUrl
    }
  }
  insertUserImageLogOne(
    object: {fileName: $profileImageFileName, provider: $profileImageProvider, providerId: $profileImageProviderId, providerUrl: $profileImageProviderUrl, userId: $id, path: $profileImagePath}
  ) {
    id
  }
}
    `;
export type UpdateUserProfileImageMutationFn = Apollo.MutationFunction<UpdateUserProfileImageMutation, UpdateUserProfileImageMutationVariables>;

/**
 * __useUpdateUserProfileImageMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileImageMutation, { data, loading, error }] = useUpdateUserProfileImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      profileImageFileName: // value for 'profileImageFileName'
 *      profileImagePath: // value for 'profileImagePath'
 *      profileImageProvider: // value for 'profileImageProvider'
 *      profileImageProviderId: // value for 'profileImageProviderId'
 *      profileImageProviderUrl: // value for 'profileImageProviderUrl'
 *      profileImageUrl: // value for 'profileImageUrl'
 *   },
 * });
 */
export function useUpdateUserProfileImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileImageMutation, UpdateUserProfileImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileImageMutation, UpdateUserProfileImageMutationVariables>(UpdateUserProfileImageDocument, options);
      }
export type UpdateUserProfileImageMutationHookResult = ReturnType<typeof useUpdateUserProfileImageMutation>;
export type UpdateUserProfileImageMutationResult = Apollo.MutationResult<UpdateUserProfileImageMutation>;
export type UpdateUserProfileImageMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileImageMutation, UpdateUserProfileImageMutationVariables>;
export const UpdateUserTimezoneDocument = gql`
    mutation updateUserTimezone($id: uuid!, $timezone: String!) {
  updateUsersByPk(pkColumns: {id: $id}, _set: {timezone: $timezone}) {
    id
    timezone
  }
}
    `;
export type UpdateUserTimezoneMutationFn = Apollo.MutationFunction<UpdateUserTimezoneMutation, UpdateUserTimezoneMutationVariables>;

/**
 * __useUpdateUserTimezoneMutation__
 *
 * To run a mutation, you first call `useUpdateUserTimezoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTimezoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTimezoneMutation, { data, loading, error }] = useUpdateUserTimezoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useUpdateUserTimezoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserTimezoneMutation, UpdateUserTimezoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserTimezoneMutation, UpdateUserTimezoneMutationVariables>(UpdateUserTimezoneDocument, options);
      }
export type UpdateUserTimezoneMutationHookResult = ReturnType<typeof useUpdateUserTimezoneMutation>;
export type UpdateUserTimezoneMutationResult = Apollo.MutationResult<UpdateUserTimezoneMutation>;
export type UpdateUserTimezoneMutationOptions = Apollo.BaseMutationOptions<UpdateUserTimezoneMutation, UpdateUserTimezoneMutationVariables>;
export const UpdateVideoAnalysisCommentDocument = gql`
    mutation updateVideoAnalysisComment($skills: [VideoAnalysisSkillsCommentsInsertInput!] = [], $details: String, $feedbackType: FeedbackSentimentEnum, $videoImageFileId: uuid, $commentId: uuid!, $deletedAt: timestamptz, $startTimestampSeconds: numeric = "", $endTimestampSeconds: numeric = "") {
  updateVideoLessonSkills(
    where: {videoAnalysisSkillsComments: {videoAnalysisCommentId: {_eq: $commentId}}}
    _set: {deletedAt: "now()"}
  ) {
    returning {
      id
    }
  }
  updateVideoAnalysisSkillsComments(
    where: {videoAnalysisCommentId: {_eq: $commentId}}
    _set: {deletedAt: "now()"}
  ) {
    returning {
      id
    }
  }
  updateVideoAnalysisComments(
    where: {id: {_eq: $commentId}}
    _set: {sentiment: $feedbackType, details: $details, deletedAt: $deletedAt, videoAnalysisFileId: $videoImageFileId, startTimestampSeconds: $startTimestampSeconds, endTimestampSeconds: $endTimestampSeconds}
  ) {
    returning {
      id
      createdAt
      updatedAt
      details
      sentiment
      userId
    }
  }
  insertVideoAnalysisSkillsComments(objects: $skills) {
    returning {
      id
    }
  }
}
    `;
export type UpdateVideoAnalysisCommentMutationFn = Apollo.MutationFunction<UpdateVideoAnalysisCommentMutation, UpdateVideoAnalysisCommentMutationVariables>;

/**
 * __useUpdateVideoAnalysisCommentMutation__
 *
 * To run a mutation, you first call `useUpdateVideoAnalysisCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoAnalysisCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoAnalysisCommentMutation, { data, loading, error }] = useUpdateVideoAnalysisCommentMutation({
 *   variables: {
 *      skills: // value for 'skills'
 *      details: // value for 'details'
 *      feedbackType: // value for 'feedbackType'
 *      videoImageFileId: // value for 'videoImageFileId'
 *      commentId: // value for 'commentId'
 *      deletedAt: // value for 'deletedAt'
 *      startTimestampSeconds: // value for 'startTimestampSeconds'
 *      endTimestampSeconds: // value for 'endTimestampSeconds'
 *   },
 * });
 */
export function useUpdateVideoAnalysisCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVideoAnalysisCommentMutation, UpdateVideoAnalysisCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVideoAnalysisCommentMutation, UpdateVideoAnalysisCommentMutationVariables>(UpdateVideoAnalysisCommentDocument, options);
      }
export type UpdateVideoAnalysisCommentMutationHookResult = ReturnType<typeof useUpdateVideoAnalysisCommentMutation>;
export type UpdateVideoAnalysisCommentMutationResult = Apollo.MutationResult<UpdateVideoAnalysisCommentMutation>;
export type UpdateVideoAnalysisCommentMutationOptions = Apollo.BaseMutationOptions<UpdateVideoAnalysisCommentMutation, UpdateVideoAnalysisCommentMutationVariables>;
export const UpsertFollowerConnectionDocument = gql`
    mutation upsertFollowerConnection($followedUserId: uuid!, $followerUserId: uuid!, $status: FollowStatusesEnum!) {
  insertUserFollowsOne(
    object: {followedUserId: $followedUserId, followerUserId: $followerUserId, status: $status}
    onConflict: {constraint: user_follows_followed_user_id_follower_user_id_key, updateColumns: status}
  ) {
    followerUserId
    followedUserId
    status
  }
}
    `;
export type UpsertFollowerConnectionMutationFn = Apollo.MutationFunction<UpsertFollowerConnectionMutation, UpsertFollowerConnectionMutationVariables>;

/**
 * __useUpsertFollowerConnectionMutation__
 *
 * To run a mutation, you first call `useUpsertFollowerConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFollowerConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFollowerConnectionMutation, { data, loading, error }] = useUpsertFollowerConnectionMutation({
 *   variables: {
 *      followedUserId: // value for 'followedUserId'
 *      followerUserId: // value for 'followerUserId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpsertFollowerConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertFollowerConnectionMutation, UpsertFollowerConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertFollowerConnectionMutation, UpsertFollowerConnectionMutationVariables>(UpsertFollowerConnectionDocument, options);
      }
export type UpsertFollowerConnectionMutationHookResult = ReturnType<typeof useUpsertFollowerConnectionMutation>;
export type UpsertFollowerConnectionMutationResult = Apollo.MutationResult<UpsertFollowerConnectionMutation>;
export type UpsertFollowerConnectionMutationOptions = Apollo.BaseMutationOptions<UpsertFollowerConnectionMutation, UpsertFollowerConnectionMutationVariables>;
export const UpsertGroupThreadVoteDocument = gql`
    mutation upsertGroupThreadVote($groupThreadCommentId: uuid!, $userId: uuid!, $vote: CommentVoteEnum!) {
  insertGroupCommentVotesOne(
    object: {groupThreadCommentId: $groupThreadCommentId, userId: $userId, vote: $vote}
    onConflict: {constraint: group_comment_votes_group_thread_comment_id_user_id_key, updateColumns: vote}
  ) {
    id
    userId
    groupThreadCommentId
    vote
  }
}
    `;
export type UpsertGroupThreadVoteMutationFn = Apollo.MutationFunction<UpsertGroupThreadVoteMutation, UpsertGroupThreadVoteMutationVariables>;

/**
 * __useUpsertGroupThreadVoteMutation__
 *
 * To run a mutation, you first call `useUpsertGroupThreadVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertGroupThreadVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertGroupThreadVoteMutation, { data, loading, error }] = useUpsertGroupThreadVoteMutation({
 *   variables: {
 *      groupThreadCommentId: // value for 'groupThreadCommentId'
 *      userId: // value for 'userId'
 *      vote: // value for 'vote'
 *   },
 * });
 */
export function useUpsertGroupThreadVoteMutation(baseOptions?: Apollo.MutationHookOptions<UpsertGroupThreadVoteMutation, UpsertGroupThreadVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertGroupThreadVoteMutation, UpsertGroupThreadVoteMutationVariables>(UpsertGroupThreadVoteDocument, options);
      }
export type UpsertGroupThreadVoteMutationHookResult = ReturnType<typeof useUpsertGroupThreadVoteMutation>;
export type UpsertGroupThreadVoteMutationResult = Apollo.MutationResult<UpsertGroupThreadVoteMutation>;
export type UpsertGroupThreadVoteMutationOptions = Apollo.BaseMutationOptions<UpsertGroupThreadVoteMutation, UpsertGroupThreadVoteMutationVariables>;
export const GetActiveCoachProfilesDocument = gql`
    query getActiveCoachProfiles {
  userProfiles(where: {coachStatus: {_eq: "ACTIVE"}}, orderBy: {updatedAt: DESC}) {
    coachStatus
    coverImageFileName
    coverImagePath
    coverImageProviderUrl
    fullName
    gender
    genderPreference
    id
    preferredName
    profileImageFileName
    profileImagePath
    profileImageProviderUrl
    username
  }
}
    `;

/**
 * __useGetActiveCoachProfilesQuery__
 *
 * To run a query within a React component, call `useGetActiveCoachProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCoachProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCoachProfilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveCoachProfilesQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveCoachProfilesQuery, GetActiveCoachProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveCoachProfilesQuery, GetActiveCoachProfilesQueryVariables>(GetActiveCoachProfilesDocument, options);
      }
export function useGetActiveCoachProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveCoachProfilesQuery, GetActiveCoachProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveCoachProfilesQuery, GetActiveCoachProfilesQueryVariables>(GetActiveCoachProfilesDocument, options);
        }
export type GetActiveCoachProfilesQueryHookResult = ReturnType<typeof useGetActiveCoachProfilesQuery>;
export type GetActiveCoachProfilesLazyQueryHookResult = ReturnType<typeof useGetActiveCoachProfilesLazyQuery>;
export type GetActiveCoachProfilesQueryResult = Apollo.QueryResult<GetActiveCoachProfilesQuery, GetActiveCoachProfilesQueryVariables>;
export const GetActiveOwnerLessonsByIdDocument = gql`
    query getActiveOwnerLessonsById($ownerUserId: uuid!) {
  lessons(where: {ownerUserId: {_eq: $ownerUserId}, status: {_eq: ACTIVE}}) {
    ...lessonFields
  }
}
    ${LessonFieldsFragmentDoc}`;

/**
 * __useGetActiveOwnerLessonsByIdQuery__
 *
 * To run a query within a React component, call `useGetActiveOwnerLessonsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveOwnerLessonsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveOwnerLessonsByIdQuery({
 *   variables: {
 *      ownerUserId: // value for 'ownerUserId'
 *   },
 * });
 */
export function useGetActiveOwnerLessonsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetActiveOwnerLessonsByIdQuery, GetActiveOwnerLessonsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveOwnerLessonsByIdQuery, GetActiveOwnerLessonsByIdQueryVariables>(GetActiveOwnerLessonsByIdDocument, options);
      }
export function useGetActiveOwnerLessonsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveOwnerLessonsByIdQuery, GetActiveOwnerLessonsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveOwnerLessonsByIdQuery, GetActiveOwnerLessonsByIdQueryVariables>(GetActiveOwnerLessonsByIdDocument, options);
        }
export type GetActiveOwnerLessonsByIdQueryHookResult = ReturnType<typeof useGetActiveOwnerLessonsByIdQuery>;
export type GetActiveOwnerLessonsByIdLazyQueryHookResult = ReturnType<typeof useGetActiveOwnerLessonsByIdLazyQuery>;
export type GetActiveOwnerLessonsByIdQueryResult = Apollo.QueryResult<GetActiveOwnerLessonsByIdQuery, GetActiveOwnerLessonsByIdQueryVariables>;
export const GetActiveOwnerLessonsByIdWithDateRangeDocument = gql`
    query getActiveOwnerLessonsByIdWithDateRange($ownerUserId: uuid!, $startDate: timestamptz!, $endDate: timestamptz!) {
  lessons(
    where: {ownerUserId: {_eq: $ownerUserId}, status: {_eq: ACTIVE}, startDateTime: {_gte: $startDate, _lte: $endDate}}
  ) {
    ...lessonFields
  }
}
    ${LessonFieldsFragmentDoc}`;

/**
 * __useGetActiveOwnerLessonsByIdWithDateRangeQuery__
 *
 * To run a query within a React component, call `useGetActiveOwnerLessonsByIdWithDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveOwnerLessonsByIdWithDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveOwnerLessonsByIdWithDateRangeQuery({
 *   variables: {
 *      ownerUserId: // value for 'ownerUserId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetActiveOwnerLessonsByIdWithDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetActiveOwnerLessonsByIdWithDateRangeQuery, GetActiveOwnerLessonsByIdWithDateRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveOwnerLessonsByIdWithDateRangeQuery, GetActiveOwnerLessonsByIdWithDateRangeQueryVariables>(GetActiveOwnerLessonsByIdWithDateRangeDocument, options);
      }
export function useGetActiveOwnerLessonsByIdWithDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveOwnerLessonsByIdWithDateRangeQuery, GetActiveOwnerLessonsByIdWithDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveOwnerLessonsByIdWithDateRangeQuery, GetActiveOwnerLessonsByIdWithDateRangeQueryVariables>(GetActiveOwnerLessonsByIdWithDateRangeDocument, options);
        }
export type GetActiveOwnerLessonsByIdWithDateRangeQueryHookResult = ReturnType<typeof useGetActiveOwnerLessonsByIdWithDateRangeQuery>;
export type GetActiveOwnerLessonsByIdWithDateRangeLazyQueryHookResult = ReturnType<typeof useGetActiveOwnerLessonsByIdWithDateRangeLazyQuery>;
export type GetActiveOwnerLessonsByIdWithDateRangeQueryResult = Apollo.QueryResult<GetActiveOwnerLessonsByIdWithDateRangeQuery, GetActiveOwnerLessonsByIdWithDateRangeQueryVariables>;
export const GetAllActiveLessonsDocument = gql`
    query getAllActiveLessons {
  lessons(where: {status: {_eq: ACTIVE}}) {
    id
    title
    startDateTime
    endDateTime
    description
    coverImageFileName
    coverImagePath
    coverImageProviderUrl
    currency
    participantLimit
    priceUnitAmount
    privacy
    status
    type
    typeCustom
    userCustomCourt {
      id
      title
      fullAddress
    }
    ownerProfile {
      id
      fullName
      preferredName
      coverImageFileName
      coverImagePath
      coverImageProviderUrl
      coachStatus
      gender
      genderPreference
      profileImageFileName
      profileImagePath
      profileImageProviderUrl
      username
    }
  }
}
    `;

/**
 * __useGetAllActiveLessonsQuery__
 *
 * To run a query within a React component, call `useGetAllActiveLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllActiveLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllActiveLessonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllActiveLessonsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllActiveLessonsQuery, GetAllActiveLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllActiveLessonsQuery, GetAllActiveLessonsQueryVariables>(GetAllActiveLessonsDocument, options);
      }
export function useGetAllActiveLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllActiveLessonsQuery, GetAllActiveLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllActiveLessonsQuery, GetAllActiveLessonsQueryVariables>(GetAllActiveLessonsDocument, options);
        }
export type GetAllActiveLessonsQueryHookResult = ReturnType<typeof useGetAllActiveLessonsQuery>;
export type GetAllActiveLessonsLazyQueryHookResult = ReturnType<typeof useGetAllActiveLessonsLazyQuery>;
export type GetAllActiveLessonsQueryResult = Apollo.QueryResult<GetAllActiveLessonsQuery, GetAllActiveLessonsQueryVariables>;
export const GetConnectionsSummaryDocument = gql`
    query GetConnectionsSummary($userId: uuid!, $sharedGameLimit: Int!) {
  userConnections(
    where: {_or: [{userAId: {_eq: $userId}}, {userBId: {_eq: $userId}}]}
  ) {
    id
    createdAt
    userAId
    userBId
    userAProfile {
      ...ConnectionPlayerProfileFields
    }
    userBProfile {
      ...ConnectionPlayerProfileFields
    }
  }
  userPlayedWith(orderBy: {gamesTogether: DESC}) {
    otherUserId
    gamesTogether
    lastPlayedAt
    otherUserProfile {
      ...ConnectionPlayerProfileFields
    }
    games(orderBy: {startDateTime: DESC}, limit: $sharedGameLimit) {
      ...ConnectionSharedGameFields
    }
  }
  userPlayedWithDismissals {
    id
    dismissedUserId
  }
  userBlocks {
    id
    blockedUserId
    blockedProfile {
      ...ConnectionPlayerProfileFields
    }
  }
  userConnectionRequests(
    where: {recipientUserId: {_eq: $userId}, status: {_eq: PENDING}}
    orderBy: {createdAt: DESC}
  ) {
    id
    createdAt
    message
    requesterUserId
    requesterProfile {
      ...ConnectionPlayerProfileFields
    }
  }
  declinedConnectionRequests: userConnectionRequests(
    where: {recipientUserId: {_eq: $userId}, status: {_eq: DECLINED}}
  ) {
    id
    requesterUserId
  }
  sentConnectionRequests: userConnectionRequests(
    where: {requesterUserId: {_eq: $userId}}
  ) {
    id
    recipientUserId
    status
    attemptNumber
  }
}
    ${ConnectionPlayerProfileFieldsFragmentDoc}
${ConnectionSharedGameFieldsFragmentDoc}`;

/**
 * __useGetConnectionsSummaryQuery__
 *
 * To run a query within a React component, call `useGetConnectionsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectionsSummaryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      sharedGameLimit: // value for 'sharedGameLimit'
 *   },
 * });
 */
export function useGetConnectionsSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetConnectionsSummaryQuery, GetConnectionsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectionsSummaryQuery, GetConnectionsSummaryQueryVariables>(GetConnectionsSummaryDocument, options);
      }
export function useGetConnectionsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectionsSummaryQuery, GetConnectionsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectionsSummaryQuery, GetConnectionsSummaryQueryVariables>(GetConnectionsSummaryDocument, options);
        }
export type GetConnectionsSummaryQueryHookResult = ReturnType<typeof useGetConnectionsSummaryQuery>;
export type GetConnectionsSummaryLazyQueryHookResult = ReturnType<typeof useGetConnectionsSummaryLazyQuery>;
export type GetConnectionsSummaryQueryResult = Apollo.QueryResult<GetConnectionsSummaryQuery, GetConnectionsSummaryQueryVariables>;
export const GetCurrentUserDocument = gql`
    query getCurrentUser($id: uuid!) {
  usersByPk(id: $id) {
    id
    createdAt
    coachStatus
    email
    firebaseId
    fullName
    preferredName
    birthday
    duprId
    gender
    playerFinderOnboardedAt
    geometry
    lastLoginAt
    lastSessionAt
    genderPreference
    stripeCustomerId
    adminVenueId
    isPendingAccountDetails
    coachSports {
      id
    }
    priceUnitAmountCoachDefault
    stripeMerchantChargesEnabled
    stripeMerchantDetailsSubmitted
    stripeMerchantId
    stripeMerchantPayoutsEnabled
    stripeMerchantCurrency
    currencyCoachDefault
    username
    locale
    timezone
    profileImageFileName
    profileImagePath
    profileImageProviderUrl
    coverImageFileName
    coverImagePath
    coverImageProviderUrl
    defaultCreditCardId
    tennisRatingScaleId
    tennisRating
    defaultSport
    phoneNumber
    defaultCoachPaymentFulfillmentChannel
    didSkipStripeSetup
    isQuatroPickleballMember
    isPicklrP4Member
    email
    activeCity {
      id
      name
      longitude
      latitude
      countrySubdivision {
        name
      }
    }
    tennisSkillLevel {
      id
      isDisplayed
      rank
      displayName
    }
    pickleballSkillLevel {
      id
      isDisplayed
      rank
      displayName
    }
    groups(where: {isActive: {_eq: true}}) {
      id
      isActive
      groupId
      group {
        id
        primarySport
      }
    }
    followingCoachesAggregate: followingAggregate(
      where: {followedProfile: {coachStatus: {_eq: "ACTIVE"}}, status: {_eq: ACTIVE}}
    ) {
      aggregate {
        count
      }
    }
    activePlatformSubscriptions: platformSubscriptions(
      where: {status: {_eq: ACTIVE}}
    ) {
      id
      status
      cancelAtPeriodEnd
      canceledAt
      currentPeriodEndAt
      currentPeriodStartAt
      externalSubscriptionId
      planPrice {
        id
        persona
      }
    }
    userVairConnection {
      id
      userId
      memberId
      clerkId
      name
      email
      connectedAt
      lastSyncedAt
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetEventPlayerInvitesDocument = gql`
    query GetEventPlayerInvites($eventId: uuid!) {
  eventPlayerInvites(
    where: {eventId: {_eq: $eventId}, status: {_in: [PENDING, ACCEPTED]}}
    orderBy: {createdAt: ASC}
  ) {
    id
    status
    invitedUserId
    invitedUserProfile {
      ...ConnectionPlayerProfileFields
    }
  }
}
    ${ConnectionPlayerProfileFieldsFragmentDoc}`;

/**
 * __useGetEventPlayerInvitesQuery__
 *
 * To run a query within a React component, call `useGetEventPlayerInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventPlayerInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventPlayerInvitesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventPlayerInvitesQuery(baseOptions: Apollo.QueryHookOptions<GetEventPlayerInvitesQuery, GetEventPlayerInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventPlayerInvitesQuery, GetEventPlayerInvitesQueryVariables>(GetEventPlayerInvitesDocument, options);
      }
export function useGetEventPlayerInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventPlayerInvitesQuery, GetEventPlayerInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventPlayerInvitesQuery, GetEventPlayerInvitesQueryVariables>(GetEventPlayerInvitesDocument, options);
        }
export type GetEventPlayerInvitesQueryHookResult = ReturnType<typeof useGetEventPlayerInvitesQuery>;
export type GetEventPlayerInvitesLazyQueryHookResult = ReturnType<typeof useGetEventPlayerInvitesLazyQuery>;
export type GetEventPlayerInvitesQueryResult = Apollo.QueryResult<GetEventPlayerInvitesQuery, GetEventPlayerInvitesQueryVariables>;
export const GetGroupByAccessCodeDocument = gql`
    query getGroupByAccessCode($accessCode: String!) {
  groups(where: {accessCode: {_eq: $accessCode}}) {
    id
    accessCode
    headline
    title
    city {
      id
      name
    }
    ownerUserProfile {
      fullName
      id
    }
  }
}
    `;

/**
 * __useGetGroupByAccessCodeQuery__
 *
 * To run a query within a React component, call `useGetGroupByAccessCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupByAccessCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupByAccessCodeQuery({
 *   variables: {
 *      accessCode: // value for 'accessCode'
 *   },
 * });
 */
export function useGetGroupByAccessCodeQuery(baseOptions: Apollo.QueryHookOptions<GetGroupByAccessCodeQuery, GetGroupByAccessCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupByAccessCodeQuery, GetGroupByAccessCodeQueryVariables>(GetGroupByAccessCodeDocument, options);
      }
export function useGetGroupByAccessCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupByAccessCodeQuery, GetGroupByAccessCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupByAccessCodeQuery, GetGroupByAccessCodeQueryVariables>(GetGroupByAccessCodeDocument, options);
        }
export type GetGroupByAccessCodeQueryHookResult = ReturnType<typeof useGetGroupByAccessCodeQuery>;
export type GetGroupByAccessCodeLazyQueryHookResult = ReturnType<typeof useGetGroupByAccessCodeLazyQuery>;
export type GetGroupByAccessCodeQueryResult = Apollo.QueryResult<GetGroupByAccessCodeQuery, GetGroupByAccessCodeQueryVariables>;
export const GetGroupVenuesDocument = gql`
    query getGroupVenues($groupId: uuid!) {
  groupVenues(where: {groupId: {_eq: $groupId}}) {
    id
    venue {
      id
      createdAt
      title
      slug
      outdoorCourtCount
      indoorCourtCount
      isActive
      accessType
      addressString
      totalCourtCount
      facilityType
      pickleballNets
      images {
        providerUrl
        id
        url
      }
      courtSurfaces {
        id
        courtSurface
      }
    }
  }
}
    `;

/**
 * __useGetGroupVenuesQuery__
 *
 * To run a query within a React component, call `useGetGroupVenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupVenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupVenuesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetGroupVenuesQuery(baseOptions: Apollo.QueryHookOptions<GetGroupVenuesQuery, GetGroupVenuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupVenuesQuery, GetGroupVenuesQueryVariables>(GetGroupVenuesDocument, options);
      }
export function useGetGroupVenuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupVenuesQuery, GetGroupVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupVenuesQuery, GetGroupVenuesQueryVariables>(GetGroupVenuesDocument, options);
        }
export type GetGroupVenuesQueryHookResult = ReturnType<typeof useGetGroupVenuesQuery>;
export type GetGroupVenuesLazyQueryHookResult = ReturnType<typeof useGetGroupVenuesLazyQuery>;
export type GetGroupVenuesQueryResult = Apollo.QueryResult<GetGroupVenuesQuery, GetGroupVenuesQueryVariables>;
export const GetLessonByIdDocument = gql`
    query getLessonById($id: uuid!) {
  lessonsByPk(id: $id) {
    ...lessonFields
  }
}
    ${LessonFieldsFragmentDoc}`;

/**
 * __useGetLessonByIdQuery__
 *
 * To run a query within a React component, call `useGetLessonByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLessonByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLessonByIdQuery, GetLessonByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonByIdQuery, GetLessonByIdQueryVariables>(GetLessonByIdDocument, options);
      }
export function useGetLessonByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonByIdQuery, GetLessonByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonByIdQuery, GetLessonByIdQueryVariables>(GetLessonByIdDocument, options);
        }
export type GetLessonByIdQueryHookResult = ReturnType<typeof useGetLessonByIdQuery>;
export type GetLessonByIdLazyQueryHookResult = ReturnType<typeof useGetLessonByIdLazyQuery>;
export type GetLessonByIdQueryResult = Apollo.QueryResult<GetLessonByIdQuery, GetLessonByIdQueryVariables>;
export const GetMyGameInvitesDocument = gql`
    query GetMyGameInvites($userId: uuid!, $now: timestamptz!) {
  eventPlayerInvites(
    where: {invitedUserId: {_eq: $userId}, status: {_eq: PENDING}, event: {startDateTime: {_gt: $now}, status: {_eq: PUBLISHED}}}
    orderBy: {createdAt: DESC}
  ) {
    id
    createdAt
    eventId
    inviterUserId
    inviterProfile {
      ...ConnectionPlayerProfileFields
    }
    event {
      ...GameInviteEventFields
    }
  }
}
    ${ConnectionPlayerProfileFieldsFragmentDoc}
${GameInviteEventFieldsFragmentDoc}`;

/**
 * __useGetMyGameInvitesQuery__
 *
 * To run a query within a React component, call `useGetMyGameInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyGameInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyGameInvitesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useGetMyGameInvitesQuery(baseOptions: Apollo.QueryHookOptions<GetMyGameInvitesQuery, GetMyGameInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyGameInvitesQuery, GetMyGameInvitesQueryVariables>(GetMyGameInvitesDocument, options);
      }
export function useGetMyGameInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyGameInvitesQuery, GetMyGameInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyGameInvitesQuery, GetMyGameInvitesQueryVariables>(GetMyGameInvitesDocument, options);
        }
export type GetMyGameInvitesQueryHookResult = ReturnType<typeof useGetMyGameInvitesQuery>;
export type GetMyGameInvitesLazyQueryHookResult = ReturnType<typeof useGetMyGameInvitesLazyQuery>;
export type GetMyGameInvitesQueryResult = Apollo.QueryResult<GetMyGameInvitesQuery, GetMyGameInvitesQueryVariables>;
export const GetTournamentStatsDocument = gql`
    query getTournamentStats {
  events(where: {type: {_eq: TOURNAMENT}, status: {_eq: PUBLISHED}}) {
    id
  }
  venues(where: {isActive: {_eq: true}}) {
    id
  }
  groups {
    id
  }
  userProfiles(where: {coachStatus: {_eq: "ACTIVE"}}) {
    id
  }
}
    `;

/**
 * __useGetTournamentStatsQuery__
 *
 * To run a query within a React component, call `useGetTournamentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTournamentStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>(GetTournamentStatsDocument, options);
      }
export function useGetTournamentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>(GetTournamentStatsDocument, options);
        }
export type GetTournamentStatsQueryHookResult = ReturnType<typeof useGetTournamentStatsQuery>;
export type GetTournamentStatsLazyQueryHookResult = ReturnType<typeof useGetTournamentStatsLazyQuery>;
export type GetTournamentStatsQueryResult = Apollo.QueryResult<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>;
export const GetPlaySessionByIdDocument = gql`
    query getPlaySessionById($id: uuid!) {
  playSessionsByPk(id: $id) {
    ...playSessionFields
  }
}
    ${PlaySessionFieldsFragmentDoc}`;

/**
 * __useGetPlaySessionByIdQuery__
 *
 * To run a query within a React component, call `useGetPlaySessionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaySessionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaySessionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlaySessionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPlaySessionByIdQuery, GetPlaySessionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaySessionByIdQuery, GetPlaySessionByIdQueryVariables>(GetPlaySessionByIdDocument, options);
      }
export function useGetPlaySessionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaySessionByIdQuery, GetPlaySessionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaySessionByIdQuery, GetPlaySessionByIdQueryVariables>(GetPlaySessionByIdDocument, options);
        }
export type GetPlaySessionByIdQueryHookResult = ReturnType<typeof useGetPlaySessionByIdQuery>;
export type GetPlaySessionByIdLazyQueryHookResult = ReturnType<typeof useGetPlaySessionByIdLazyQuery>;
export type GetPlaySessionByIdQueryResult = Apollo.QueryResult<GetPlaySessionByIdQuery, GetPlaySessionByIdQueryVariables>;
export const GetPlaySessionCommentsDocument = gql`
    query getPlaySessionComments($playSessionId: uuid!) {
  playSessionComments(
    orderBy: {createdAt: ASC}
    where: {playSessionId: {_eq: $playSessionId}}
  ) {
    id
    createdAt
    content
    playSessionCommentId
    playSessionId
    playSessionRootCommentId
    userId
    userProfile {
      id
      fullName
      preferredName
      profileImagePath
      username
    }
  }
}
    `;

/**
 * __useGetPlaySessionCommentsQuery__
 *
 * To run a query within a React component, call `useGetPlaySessionCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaySessionCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaySessionCommentsQuery({
 *   variables: {
 *      playSessionId: // value for 'playSessionId'
 *   },
 * });
 */
export function useGetPlaySessionCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetPlaySessionCommentsQuery, GetPlaySessionCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaySessionCommentsQuery, GetPlaySessionCommentsQueryVariables>(GetPlaySessionCommentsDocument, options);
      }
export function useGetPlaySessionCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaySessionCommentsQuery, GetPlaySessionCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaySessionCommentsQuery, GetPlaySessionCommentsQueryVariables>(GetPlaySessionCommentsDocument, options);
        }
export type GetPlaySessionCommentsQueryHookResult = ReturnType<typeof useGetPlaySessionCommentsQuery>;
export type GetPlaySessionCommentsLazyQueryHookResult = ReturnType<typeof useGetPlaySessionCommentsLazyQuery>;
export type GetPlaySessionCommentsQueryResult = Apollo.QueryResult<GetPlaySessionCommentsQuery, GetPlaySessionCommentsQueryVariables>;
export const GetPlayerLessonsDocument = gql`
    query getPlayerLessons($userId: uuid!) {
  lessonParticipants(
    where: {userId: {_eq: $userId}, status: {_eq: ACTIVE}, lesson: {status: {_eq: ACTIVE}}}
  ) {
    id
    status
    lesson {
      ...lessonFields
    }
  }
}
    ${LessonFieldsFragmentDoc}`;

/**
 * __useGetPlayerLessonsQuery__
 *
 * To run a query within a React component, call `useGetPlayerLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerLessonsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPlayerLessonsQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerLessonsQuery, GetPlayerLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerLessonsQuery, GetPlayerLessonsQueryVariables>(GetPlayerLessonsDocument, options);
      }
export function useGetPlayerLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerLessonsQuery, GetPlayerLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerLessonsQuery, GetPlayerLessonsQueryVariables>(GetPlayerLessonsDocument, options);
        }
export type GetPlayerLessonsQueryHookResult = ReturnType<typeof useGetPlayerLessonsQuery>;
export type GetPlayerLessonsLazyQueryHookResult = ReturnType<typeof useGetPlayerLessonsLazyQuery>;
export type GetPlayerLessonsQueryResult = Apollo.QueryResult<GetPlayerLessonsQuery, GetPlayerLessonsQueryVariables>;
export const GetPlayerPlaySessionsDocument = gql`
    query getPlayerPlaySessions($userId: uuid!) {
  playSessionParticipants(
    where: {userId: {_eq: $userId}, status: {_eq: ACTIVE}, playSession: {status: {_eq: ACTIVE}}}
  ) {
    id
    status
    playSession {
      ...playSessionFields
    }
  }
  playSessions(where: {status: {_eq: ACTIVE}, organizerUserId: {_eq: $userId}}) {
    ...playSessionFields
  }
}
    ${PlaySessionFieldsFragmentDoc}`;

/**
 * __useGetPlayerPlaySessionsQuery__
 *
 * To run a query within a React component, call `useGetPlayerPlaySessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerPlaySessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerPlaySessionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPlayerPlaySessionsQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerPlaySessionsQuery, GetPlayerPlaySessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerPlaySessionsQuery, GetPlayerPlaySessionsQueryVariables>(GetPlayerPlaySessionsDocument, options);
      }
export function useGetPlayerPlaySessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerPlaySessionsQuery, GetPlayerPlaySessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerPlaySessionsQuery, GetPlayerPlaySessionsQueryVariables>(GetPlayerPlaySessionsDocument, options);
        }
export type GetPlayerPlaySessionsQueryHookResult = ReturnType<typeof useGetPlayerPlaySessionsQuery>;
export type GetPlayerPlaySessionsLazyQueryHookResult = ReturnType<typeof useGetPlayerPlaySessionsLazyQuery>;
export type GetPlayerPlaySessionsQueryResult = Apollo.QueryResult<GetPlayerPlaySessionsQuery, GetPlayerPlaySessionsQueryVariables>;
export const GetSportsRatingScalesDocument = gql`
    query getSportsRatingScales {
  pickleballRatingScales {
    id
    maximum
    minimum
    name
    order
    shortName
  }
  tennisRatingScales {
    id
    maximum
    minimum
    name
    order
    shortName
  }
}
    `;

/**
 * __useGetSportsRatingScalesQuery__
 *
 * To run a query within a React component, call `useGetSportsRatingScalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportsRatingScalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportsRatingScalesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSportsRatingScalesQuery(baseOptions?: Apollo.QueryHookOptions<GetSportsRatingScalesQuery, GetSportsRatingScalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportsRatingScalesQuery, GetSportsRatingScalesQueryVariables>(GetSportsRatingScalesDocument, options);
      }
export function useGetSportsRatingScalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportsRatingScalesQuery, GetSportsRatingScalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportsRatingScalesQuery, GetSportsRatingScalesQueryVariables>(GetSportsRatingScalesDocument, options);
        }
export type GetSportsRatingScalesQueryHookResult = ReturnType<typeof useGetSportsRatingScalesQuery>;
export type GetSportsRatingScalesLazyQueryHookResult = ReturnType<typeof useGetSportsRatingScalesLazyQuery>;
export type GetSportsRatingScalesQueryResult = Apollo.QueryResult<GetSportsRatingScalesQuery, GetSportsRatingScalesQueryVariables>;
export const GetTopCourtsByGeoDocument = gql`
    query getTopCourtsByGeo($distance: Float!, $from: geography!, $limit: Int = 20) {
  venues(
    where: {geometry: {_stDWithin: {distance: $distance, from: $from}}}
    limit: $limit
    orderBy: [{imagesAggregate: {count: DESC}}, {geometry: ASC}]
  ) {
    id
    title
    geometry
    slug
    timezone
    pickleballLines
    addressString
    accessType
    indoorCourtCount
    outdoorCourtCount
    pickleballNets
    hasPickleball
    hasTennis
    hasPadel
    images {
      id
      isVisible
      fileName
      path
      provider
      url
    }
    city {
      id
      name
      countrySubdivision {
        id
        name
      }
    }
    courtSurfaces {
      id
      courtSurface
    }
  }
}
    `;

/**
 * __useGetTopCourtsByGeoQuery__
 *
 * To run a query within a React component, call `useGetTopCourtsByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopCourtsByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopCourtsByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTopCourtsByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetTopCourtsByGeoQuery, GetTopCourtsByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopCourtsByGeoQuery, GetTopCourtsByGeoQueryVariables>(GetTopCourtsByGeoDocument, options);
      }
export function useGetTopCourtsByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopCourtsByGeoQuery, GetTopCourtsByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopCourtsByGeoQuery, GetTopCourtsByGeoQueryVariables>(GetTopCourtsByGeoDocument, options);
        }
export type GetTopCourtsByGeoQueryHookResult = ReturnType<typeof useGetTopCourtsByGeoQuery>;
export type GetTopCourtsByGeoLazyQueryHookResult = ReturnType<typeof useGetTopCourtsByGeoLazyQuery>;
export type GetTopCourtsByGeoQueryResult = Apollo.QueryResult<GetTopCourtsByGeoQuery, GetTopCourtsByGeoQueryVariables>;
export const GetTournamentsByLocationDocument = gql`
    query getTournamentsByLocation($limit: Int!, $distance: Float!, $from: geography!) {
  events(
    where: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, type: {_eq: TOURNAMENT}, endDateTime: {_gte: "now()"}, status: {_eq: PUBLISHED}, geometry: {_stDWithin: {distance: $distance, from: $from}}}
    limit: $limit
  ) {
    city {
      name
      id
      countrySubdivision {
        name
        id
        code
      }
      timezone
    }
    coverImagePath
    displayLocation
    endDateTime
    hasPrizes
    currency
    id
    latitude
    locale
    longitude
    organizerImagePath
    registrationClosedAt
    registrationDeadlineDate
    registrationPriceUnitAmount
    scoringFormat
    slug
    sport
    isExternal
    sourceRegistrationCount
    sourceOrganizerTitle
    startDateTime
    status
    timezoneAbbreviation
    timezoneName
    timezoneOffsetMinutes
    title
    registrationsAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetTournamentsByLocationQuery__
 *
 * To run a query within a React component, call `useGetTournamentsByLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentsByLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentsByLocationQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useGetTournamentsByLocationQuery(baseOptions: Apollo.QueryHookOptions<GetTournamentsByLocationQuery, GetTournamentsByLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTournamentsByLocationQuery, GetTournamentsByLocationQueryVariables>(GetTournamentsByLocationDocument, options);
      }
export function useGetTournamentsByLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentsByLocationQuery, GetTournamentsByLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTournamentsByLocationQuery, GetTournamentsByLocationQueryVariables>(GetTournamentsByLocationDocument, options);
        }
export type GetTournamentsByLocationQueryHookResult = ReturnType<typeof useGetTournamentsByLocationQuery>;
export type GetTournamentsByLocationLazyQueryHookResult = ReturnType<typeof useGetTournamentsByLocationLazyQuery>;
export type GetTournamentsByLocationQueryResult = Apollo.QueryResult<GetTournamentsByLocationQuery, GetTournamentsByLocationQueryVariables>;
export const GetTournamentsForMarketplaceDocument = gql`
    query getTournamentsForMarketplace {
  events(
    where: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, type: {_eq: TOURNAMENT}, endDateTime: {_gte: "now()"}, status: {_eq: PUBLISHED}}
  ) {
    city {
      name
      id
      countrySubdivision {
        name
        id
        code
      }
      timezone
    }
    coverImagePath
    displayLocation
    endDateTime
    hasPrizes
    id
    latitude
    locale
    longitude
    organizerImagePath
    registrationClosedAt
    registrationDeadlineDate
    registrationPriceUnitAmount
    groupFormat
    groups {
      id
      gender
      teamType
      format
      isMoneyBall
      minimumAge
      maximumAge
    }
    scoringFormat
    slug
    sport
    source
    isExternal
    isVairRequired
    currency
    sourceRegistrationCount
    sourceOrganizerTitle
    startDateTime
    status
    timezoneAbbreviation
    timezoneName
    timezoneOffsetMinutes
    venue {
      id
      timezone
      addressString
    }
    title
    registrationsAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetTournamentsForMarketplaceQuery__
 *
 * To run a query within a React component, call `useGetTournamentsForMarketplaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentsForMarketplaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentsForMarketplaceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTournamentsForMarketplaceQuery(baseOptions?: Apollo.QueryHookOptions<GetTournamentsForMarketplaceQuery, GetTournamentsForMarketplaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTournamentsForMarketplaceQuery, GetTournamentsForMarketplaceQueryVariables>(GetTournamentsForMarketplaceDocument, options);
      }
export function useGetTournamentsForMarketplaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentsForMarketplaceQuery, GetTournamentsForMarketplaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTournamentsForMarketplaceQuery, GetTournamentsForMarketplaceQueryVariables>(GetTournamentsForMarketplaceDocument, options);
        }
export type GetTournamentsForMarketplaceQueryHookResult = ReturnType<typeof useGetTournamentsForMarketplaceQuery>;
export type GetTournamentsForMarketplaceLazyQueryHookResult = ReturnType<typeof useGetTournamentsForMarketplaceLazyQuery>;
export type GetTournamentsForMarketplaceQueryResult = Apollo.QueryResult<GetTournamentsForMarketplaceQuery, GetTournamentsForMarketplaceQueryVariables>;
export const GetUserFollowerProfilesDocument = gql`
    query getUserFollowerProfiles($followedUserId: uuid!) {
  userFollows(
    where: {followedUserId: {_eq: $followedUserId}, status: {_eq: ACTIVE}, followerUserId: {_neq: $followedUserId}}
  ) {
    status
    followerUserId
    followedUserId
    followerProfile {
      id
      preferredName
      profileImageFileName
      profileImagePath
      profileImageProviderUrl
      fullName
      username
    }
  }
}
    `;

/**
 * __useGetUserFollowerProfilesQuery__
 *
 * To run a query within a React component, call `useGetUserFollowerProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFollowerProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFollowerProfilesQuery({
 *   variables: {
 *      followedUserId: // value for 'followedUserId'
 *   },
 * });
 */
export function useGetUserFollowerProfilesQuery(baseOptions: Apollo.QueryHookOptions<GetUserFollowerProfilesQuery, GetUserFollowerProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFollowerProfilesQuery, GetUserFollowerProfilesQueryVariables>(GetUserFollowerProfilesDocument, options);
      }
export function useGetUserFollowerProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFollowerProfilesQuery, GetUserFollowerProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFollowerProfilesQuery, GetUserFollowerProfilesQueryVariables>(GetUserFollowerProfilesDocument, options);
        }
export type GetUserFollowerProfilesQueryHookResult = ReturnType<typeof useGetUserFollowerProfilesQuery>;
export type GetUserFollowerProfilesLazyQueryHookResult = ReturnType<typeof useGetUserFollowerProfilesLazyQuery>;
export type GetUserFollowerProfilesQueryResult = Apollo.QueryResult<GetUserFollowerProfilesQuery, GetUserFollowerProfilesQueryVariables>;
export const GetUserFollowingIdsDocument = gql`
    query getUserFollowingIds($followerUserId: uuid!) {
  userFollows(
    where: {followerUserId: {_eq: $followerUserId}, status: {_eq: ACTIVE}}
  ) {
    status
    followerUserId
    followedUserId
  }
}
    `;

/**
 * __useGetUserFollowingIdsQuery__
 *
 * To run a query within a React component, call `useGetUserFollowingIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFollowingIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFollowingIdsQuery({
 *   variables: {
 *      followerUserId: // value for 'followerUserId'
 *   },
 * });
 */
export function useGetUserFollowingIdsQuery(baseOptions: Apollo.QueryHookOptions<GetUserFollowingIdsQuery, GetUserFollowingIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFollowingIdsQuery, GetUserFollowingIdsQueryVariables>(GetUserFollowingIdsDocument, options);
      }
export function useGetUserFollowingIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFollowingIdsQuery, GetUserFollowingIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFollowingIdsQuery, GetUserFollowingIdsQueryVariables>(GetUserFollowingIdsDocument, options);
        }
export type GetUserFollowingIdsQueryHookResult = ReturnType<typeof useGetUserFollowingIdsQuery>;
export type GetUserFollowingIdsLazyQueryHookResult = ReturnType<typeof useGetUserFollowingIdsLazyQuery>;
export type GetUserFollowingIdsQueryResult = Apollo.QueryResult<GetUserFollowingIdsQuery, GetUserFollowingIdsQueryVariables>;
export const GetUserProfileByIdDocument = gql`
    query getUserProfileById($id: uuid!) {
  userProfiles(where: {id: {_eq: $id}}) {
    ...userProfileFields
    identityVerifications(where: {status: {_eq: VERIFIED}}, limit: 1) {
      status
    }
    playerReviewsAggregate {
      aggregate {
        count
      }
    }
  }
}
    ${UserProfileFieldsFragmentDoc}`;

/**
 * __useGetUserProfileByIdQuery__
 *
 * To run a query within a React component, call `useGetUserProfileByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserProfileByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserProfileByIdQuery, GetUserProfileByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileByIdQuery, GetUserProfileByIdQueryVariables>(GetUserProfileByIdDocument, options);
      }
export function useGetUserProfileByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileByIdQuery, GetUserProfileByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileByIdQuery, GetUserProfileByIdQueryVariables>(GetUserProfileByIdDocument, options);
        }
export type GetUserProfileByIdQueryHookResult = ReturnType<typeof useGetUserProfileByIdQuery>;
export type GetUserProfileByIdLazyQueryHookResult = ReturnType<typeof useGetUserProfileByIdLazyQuery>;
export type GetUserProfileByIdQueryResult = Apollo.QueryResult<GetUserProfileByIdQuery, GetUserProfileByIdQueryVariables>;
export const GetUserProfileByUsernameDocument = gql`
    query getUserProfileByUsername($username: String!, $viewerId: uuid!) {
  userProfiles(where: {username: {_eq: $username}}) {
    ...userProfileFields
  }
  userFollows(
    where: {followedProfile: {username: {_eq: $username}}, followerUserId: {_eq: $viewerId}}
  ) {
    status
    followedUserId
    followerUserId
  }
}
    ${UserProfileFieldsFragmentDoc}`;

/**
 * __useGetUserProfileByUsernameQuery__
 *
 * To run a query within a React component, call `useGetUserProfileByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileByUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *      viewerId: // value for 'viewerId'
 *   },
 * });
 */
export function useGetUserProfileByUsernameQuery(baseOptions: Apollo.QueryHookOptions<GetUserProfileByUsernameQuery, GetUserProfileByUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileByUsernameQuery, GetUserProfileByUsernameQueryVariables>(GetUserProfileByUsernameDocument, options);
      }
export function useGetUserProfileByUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileByUsernameQuery, GetUserProfileByUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileByUsernameQuery, GetUserProfileByUsernameQueryVariables>(GetUserProfileByUsernameDocument, options);
        }
export type GetUserProfileByUsernameQueryHookResult = ReturnType<typeof useGetUserProfileByUsernameQuery>;
export type GetUserProfileByUsernameLazyQueryHookResult = ReturnType<typeof useGetUserProfileByUsernameLazyQuery>;
export type GetUserProfileByUsernameQueryResult = Apollo.QueryResult<GetUserProfileByUsernameQuery, GetUserProfileByUsernameQueryVariables>;
export const GetUserPublicProfileByUsernameDocument = gql`
    query getUserPublicProfileByUsername($username: String!) {
  userProfiles(where: {username: {_eq: $username}}) {
    ...userProfileFields
  }
}
    ${UserProfileFieldsFragmentDoc}`;

/**
 * __useGetUserPublicProfileByUsernameQuery__
 *
 * To run a query within a React component, call `useGetUserPublicProfileByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPublicProfileByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPublicProfileByUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetUserPublicProfileByUsernameQuery(baseOptions: Apollo.QueryHookOptions<GetUserPublicProfileByUsernameQuery, GetUserPublicProfileByUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPublicProfileByUsernameQuery, GetUserPublicProfileByUsernameQueryVariables>(GetUserPublicProfileByUsernameDocument, options);
      }
export function useGetUserPublicProfileByUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPublicProfileByUsernameQuery, GetUserPublicProfileByUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPublicProfileByUsernameQuery, GetUserPublicProfileByUsernameQueryVariables>(GetUserPublicProfileByUsernameDocument, options);
        }
export type GetUserPublicProfileByUsernameQueryHookResult = ReturnType<typeof useGetUserPublicProfileByUsernameQuery>;
export type GetUserPublicProfileByUsernameLazyQueryHookResult = ReturnType<typeof useGetUserPublicProfileByUsernameLazyQuery>;
export type GetUserPublicProfileByUsernameQueryResult = Apollo.QueryResult<GetUserPublicProfileByUsernameQuery, GetUserPublicProfileByUsernameQueryVariables>;
export const GetUserProfilesByIdsDocument = gql`
    query getUserProfilesByIds($ids: [uuid!]!) {
  userProfiles(where: {id: {_in: $ids}}) {
    ...userProfileFields
  }
}
    ${UserProfileFieldsFragmentDoc}`;

/**
 * __useGetUserProfilesByIdsQuery__
 *
 * To run a query within a React component, call `useGetUserProfilesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfilesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfilesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetUserProfilesByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetUserProfilesByIdsQuery, GetUserProfilesByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfilesByIdsQuery, GetUserProfilesByIdsQueryVariables>(GetUserProfilesByIdsDocument, options);
      }
export function useGetUserProfilesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfilesByIdsQuery, GetUserProfilesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfilesByIdsQuery, GetUserProfilesByIdsQueryVariables>(GetUserProfilesByIdsDocument, options);
        }
export type GetUserProfilesByIdsQueryHookResult = ReturnType<typeof useGetUserProfilesByIdsQuery>;
export type GetUserProfilesByIdsLazyQueryHookResult = ReturnType<typeof useGetUserProfilesByIdsLazyQuery>;
export type GetUserProfilesByIdsQueryResult = Apollo.QueryResult<GetUserProfilesByIdsQuery, GetUserProfilesByIdsQueryVariables>;
export const GetVairConnectionDocument = gql`
    query getVairConnection($userId: uuid!) {
  userVairConnections(where: {userId: {_eq: $userId}}) {
    id
    userId
    memberId
    clerkId
    name
    email
    connectedAt
    lastSyncedAt
  }
}
    `;

/**
 * __useGetVairConnectionQuery__
 *
 * To run a query within a React component, call `useGetVairConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVairConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVairConnectionQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetVairConnectionQuery(baseOptions: Apollo.QueryHookOptions<GetVairConnectionQuery, GetVairConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVairConnectionQuery, GetVairConnectionQueryVariables>(GetVairConnectionDocument, options);
      }
export function useGetVairConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVairConnectionQuery, GetVairConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVairConnectionQuery, GetVairConnectionQueryVariables>(GetVairConnectionDocument, options);
        }
export type GetVairConnectionQueryHookResult = ReturnType<typeof useGetVairConnectionQuery>;
export type GetVairConnectionLazyQueryHookResult = ReturnType<typeof useGetVairConnectionLazyQuery>;
export type GetVairConnectionQueryResult = Apollo.QueryResult<GetVairConnectionQuery, GetVairConnectionQueryVariables>;
export const GetVairConnectionsByUserIdsDocument = gql`
    query getVairConnectionsByUserIds($userIds: [uuid!]!) {
  userVairConnections(where: {userId: {_in: $userIds}}) {
    id
    userId
    memberId
    name
    email
  }
}
    `;

/**
 * __useGetVairConnectionsByUserIdsQuery__
 *
 * To run a query within a React component, call `useGetVairConnectionsByUserIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVairConnectionsByUserIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVairConnectionsByUserIdsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetVairConnectionsByUserIdsQuery(baseOptions: Apollo.QueryHookOptions<GetVairConnectionsByUserIdsQuery, GetVairConnectionsByUserIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVairConnectionsByUserIdsQuery, GetVairConnectionsByUserIdsQueryVariables>(GetVairConnectionsByUserIdsDocument, options);
      }
export function useGetVairConnectionsByUserIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVairConnectionsByUserIdsQuery, GetVairConnectionsByUserIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVairConnectionsByUserIdsQuery, GetVairConnectionsByUserIdsQueryVariables>(GetVairConnectionsByUserIdsDocument, options);
        }
export type GetVairConnectionsByUserIdsQueryHookResult = ReturnType<typeof useGetVairConnectionsByUserIdsQuery>;
export type GetVairConnectionsByUserIdsLazyQueryHookResult = ReturnType<typeof useGetVairConnectionsByUserIdsLazyQuery>;
export type GetVairConnectionsByUserIdsQueryResult = Apollo.QueryResult<GetVairConnectionsByUserIdsQuery, GetVairConnectionsByUserIdsQueryVariables>;
export const GetVenueBookingIntegrationDocument = gql`
    query getVenueBookingIntegration($venueId: uuid!) {
  venueBookingIntegrations(where: {venueId: {_eq: $venueId}}, limit: 1) {
    id
    bookingSystem
    bookingAccountEmail
    accountAddedConfirmedAt
    helpRequestedAt
    connectionStatus
    externalOrgId
    readVerifiedAt
    promoCode
    maxAdvanceBookingDays
    confirmationNote
    status
    isPreferredPartner
    partnerPricingEnabled
    referralFeeEnabled
    referralFeeCents
    currentVersion
    activatedAt
    pausedAt
    configVersions(
      where: {changeType: {_eq: AUTHORIZED}}
      orderBy: {version: DESC}
      limit: 1
    ) {
      id
      version
      termsVersion
      changedAt
    }
    windows {
      id
      kind
      inventoryType
      sport
      dayOfWeek
      startTime
      endTime
    }
    courtRates {
      id
      sport
      currency
      hourlyUnitAmount
      peakHourlyUnitAmount
    }
    rules {
      id
      inventoryType
      scheduleMode
      isCustomPricing
      tiers(orderBy: {leadTimeHours: ASC}) {
        id
        leadTimeHours
        discountPercent
        isEnabled
      }
      windows {
        id
        dayOfWeek
        startTime
        endTime
      }
    }
  }
}
    `;

/**
 * __useGetVenueBookingIntegrationQuery__
 *
 * To run a query within a React component, call `useGetVenueBookingIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenueBookingIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenueBookingIntegrationQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useGetVenueBookingIntegrationQuery(baseOptions: Apollo.QueryHookOptions<GetVenueBookingIntegrationQuery, GetVenueBookingIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenueBookingIntegrationQuery, GetVenueBookingIntegrationQueryVariables>(GetVenueBookingIntegrationDocument, options);
      }
export function useGetVenueBookingIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenueBookingIntegrationQuery, GetVenueBookingIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenueBookingIntegrationQuery, GetVenueBookingIntegrationQueryVariables>(GetVenueBookingIntegrationDocument, options);
        }
export type GetVenueBookingIntegrationQueryHookResult = ReturnType<typeof useGetVenueBookingIntegrationQuery>;
export type GetVenueBookingIntegrationLazyQueryHookResult = ReturnType<typeof useGetVenueBookingIntegrationLazyQuery>;
export type GetVenueBookingIntegrationQueryResult = Apollo.QueryResult<GetVenueBookingIntegrationQuery, GetVenueBookingIntegrationQueryVariables>;
export const GetExistingUserDocument = gql`
    query getExistingUser($firebaseId: String!) {
  users(where: {firebaseId: {_eq: $firebaseId}}) {
    id
    email
    username
    fullName
    coachStatus
  }
}
    `;

/**
 * __useGetExistingUserQuery__
 *
 * To run a query within a React component, call `useGetExistingUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingUserQuery({
 *   variables: {
 *      firebaseId: // value for 'firebaseId'
 *   },
 * });
 */
export function useGetExistingUserQuery(baseOptions: Apollo.QueryHookOptions<GetExistingUserQuery, GetExistingUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExistingUserQuery, GetExistingUserQueryVariables>(GetExistingUserDocument, options);
      }
export function useGetExistingUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExistingUserQuery, GetExistingUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExistingUserQuery, GetExistingUserQueryVariables>(GetExistingUserDocument, options);
        }
export type GetExistingUserQueryHookResult = ReturnType<typeof useGetExistingUserQuery>;
export type GetExistingUserLazyQueryHookResult = ReturnType<typeof useGetExistingUserLazyQuery>;
export type GetExistingUserQueryResult = Apollo.QueryResult<GetExistingUserQuery, GetExistingUserQueryVariables>;
export const InsertSignupRequestDocument = gql`
    mutation insertSignupRequest($accountType: String!, $email: String!, $fullName: String!, $preferredName: String!, $username: String!, $ip: String = "", $timezone: String = "", $country: String = "", $region: String = "", $city: String = "", $zip: String = "", $platform: String = "", $fullDetails: jsonb, $latitude: numeric, $longitude: numeric, $cityId: uuid, $phoneNumber: String, $eventOrganizerAccountType: EventOrganizerAccountTypesEnum, $utmSource: String, $utmMedium: String, $utmCampaign: String, $utmContent: String) {
  insertSignupRequestsOne(
    object: {accountType: $accountType, email: $email, fullName: $fullName, preferredName: $preferredName, username: $username, ip: $ip, timezone: $timezone, country: $country, region: $region, city: $city, zip: $zip, fullDetails: $fullDetails, platform: $platform, latitude: $latitude, longitude: $longitude, cityId: $cityId, phoneNumber: $phoneNumber, eventOrganizerAccountType: $eventOrganizerAccountType, utmSource: $utmSource, utmMedium: $utmMedium, utmCampaign: $utmCampaign, utmContent: $utmContent}
  ) {
    id
  }
}
    `;
export type InsertSignupRequestMutationFn = Apollo.MutationFunction<InsertSignupRequestMutation, InsertSignupRequestMutationVariables>;

/**
 * __useInsertSignupRequestMutation__
 *
 * To run a mutation, you first call `useInsertSignupRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSignupRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSignupRequestMutation, { data, loading, error }] = useInsertSignupRequestMutation({
 *   variables: {
 *      accountType: // value for 'accountType'
 *      email: // value for 'email'
 *      fullName: // value for 'fullName'
 *      preferredName: // value for 'preferredName'
 *      username: // value for 'username'
 *      ip: // value for 'ip'
 *      timezone: // value for 'timezone'
 *      country: // value for 'country'
 *      region: // value for 'region'
 *      city: // value for 'city'
 *      zip: // value for 'zip'
 *      platform: // value for 'platform'
 *      fullDetails: // value for 'fullDetails'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      cityId: // value for 'cityId'
 *      phoneNumber: // value for 'phoneNumber'
 *      eventOrganizerAccountType: // value for 'eventOrganizerAccountType'
 *      utmSource: // value for 'utmSource'
 *      utmMedium: // value for 'utmMedium'
 *      utmCampaign: // value for 'utmCampaign'
 *      utmContent: // value for 'utmContent'
 *   },
 * });
 */
export function useInsertSignupRequestMutation(baseOptions?: Apollo.MutationHookOptions<InsertSignupRequestMutation, InsertSignupRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSignupRequestMutation, InsertSignupRequestMutationVariables>(InsertSignupRequestDocument, options);
      }
export type InsertSignupRequestMutationHookResult = ReturnType<typeof useInsertSignupRequestMutation>;
export type InsertSignupRequestMutationResult = Apollo.MutationResult<InsertSignupRequestMutation>;
export type InsertSignupRequestMutationOptions = Apollo.BaseMutationOptions<InsertSignupRequestMutation, InsertSignupRequestMutationVariables>;
export const CheckUsernameAvailabilityDocument = gql`
    query checkUsernameAvailability($username: String!) {
  usernamesActive(where: {username: {_eq: $username}}) {
    username
  }
  usernamesClaimed(where: {username: {_eq: $username}}) {
    id
    username
  }
}
    `;

/**
 * __useCheckUsernameAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckUsernameAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUsernameAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUsernameAvailabilityQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useCheckUsernameAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<CheckUsernameAvailabilityQuery, CheckUsernameAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUsernameAvailabilityQuery, CheckUsernameAvailabilityQueryVariables>(CheckUsernameAvailabilityDocument, options);
      }
export function useCheckUsernameAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUsernameAvailabilityQuery, CheckUsernameAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUsernameAvailabilityQuery, CheckUsernameAvailabilityQueryVariables>(CheckUsernameAvailabilityDocument, options);
        }
export type CheckUsernameAvailabilityQueryHookResult = ReturnType<typeof useCheckUsernameAvailabilityQuery>;
export type CheckUsernameAvailabilityLazyQueryHookResult = ReturnType<typeof useCheckUsernameAvailabilityLazyQuery>;
export type CheckUsernameAvailabilityQueryResult = Apollo.QueryResult<CheckUsernameAvailabilityQuery, CheckUsernameAvailabilityQueryVariables>;
export const GetVenueLessonsDocument = gql`
    query GetVenueLessons($venueId: uuid!, $limit: Int = 50, $offset: Int = 0) {
  lessons(
    where: {_and: [{venueId: {_eq: $venueId}}, {deletedAt: {_isNull: true}}]}
    orderBy: {startDateTime: DESC}
    limit: $limit
    offset: $offset
  ) {
    id
    title
    description
    sport
    type
    typeCustom
    status
    privacy
    startDateTime
    endDateTime
    participantLimit
    priceUnitAmount
    currency
    coverImageUrl
    externalBookingUrl
    ownerUserId
    venueId
    createdAt
    publishedAt
    canceledAt
    cancelReason
    ownerProfile {
      id
      fullName
      username
      profileImagePath
      profileImageProviderUrl
      coachStatus
    }
    participants(where: {deletedAt: {_isNull: true}}) {
      id
      status
      userProfile {
        id
        fullName
        username
        profileImageUrl
      }
    }
    participantsAggregate(where: {deletedAt: {_isNull: true}}) {
      aggregate {
        count
      }
    }
    times(where: {deletedAt: {_isNull: true}}) {
      id
      startDateTime
      endDateTime
    }
  }
}
    `;

/**
 * __useGetVenueLessonsQuery__
 *
 * To run a query within a React component, call `useGetVenueLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenueLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenueLessonsQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetVenueLessonsQuery(baseOptions: Apollo.QueryHookOptions<GetVenueLessonsQuery, GetVenueLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenueLessonsQuery, GetVenueLessonsQueryVariables>(GetVenueLessonsDocument, options);
      }
export function useGetVenueLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenueLessonsQuery, GetVenueLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenueLessonsQuery, GetVenueLessonsQueryVariables>(GetVenueLessonsDocument, options);
        }
export type GetVenueLessonsQueryHookResult = ReturnType<typeof useGetVenueLessonsQuery>;
export type GetVenueLessonsLazyQueryHookResult = ReturnType<typeof useGetVenueLessonsLazyQuery>;
export type GetVenueLessonsQueryResult = Apollo.QueryResult<GetVenueLessonsQuery, GetVenueLessonsQueryVariables>;
export const GetVenueLessonsAggregateDocument = gql`
    query GetVenueLessonsAggregate($venueId: uuid!) {
  lessonsAggregate(
    where: {_and: [{venueId: {_eq: $venueId}}, {deletedAt: {_isNull: true}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetVenueLessonsAggregateQuery__
 *
 * To run a query within a React component, call `useGetVenueLessonsAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenueLessonsAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenueLessonsAggregateQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useGetVenueLessonsAggregateQuery(baseOptions: Apollo.QueryHookOptions<GetVenueLessonsAggregateQuery, GetVenueLessonsAggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenueLessonsAggregateQuery, GetVenueLessonsAggregateQueryVariables>(GetVenueLessonsAggregateDocument, options);
      }
export function useGetVenueLessonsAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenueLessonsAggregateQuery, GetVenueLessonsAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenueLessonsAggregateQuery, GetVenueLessonsAggregateQueryVariables>(GetVenueLessonsAggregateDocument, options);
        }
export type GetVenueLessonsAggregateQueryHookResult = ReturnType<typeof useGetVenueLessonsAggregateQuery>;
export type GetVenueLessonsAggregateLazyQueryHookResult = ReturnType<typeof useGetVenueLessonsAggregateLazyQuery>;
export type GetVenueLessonsAggregateQueryResult = Apollo.QueryResult<GetVenueLessonsAggregateQuery, GetVenueLessonsAggregateQueryVariables>;
export const GetVenueStaffCoachesDocument = gql`
    query GetVenueStaffCoaches($venueId: uuid!) {
  venueStaffCoaches(
    where: {_and: [{venueId: {_eq: $venueId}}, {deletedAt: {_isNull: true}}]}
    orderBy: {createdAt: DESC}
  ) {
    id
    userId
    venueId
    addedByUserId
    createdAt
    coachProfile {
      id
      fullName
      username
      profileImageUrl
      coachStatus
    }
    addedByUserProfile {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetVenueStaffCoachesQuery__
 *
 * To run a query within a React component, call `useGetVenueStaffCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenueStaffCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenueStaffCoachesQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useGetVenueStaffCoachesQuery(baseOptions: Apollo.QueryHookOptions<GetVenueStaffCoachesQuery, GetVenueStaffCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenueStaffCoachesQuery, GetVenueStaffCoachesQueryVariables>(GetVenueStaffCoachesDocument, options);
      }
export function useGetVenueStaffCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenueStaffCoachesQuery, GetVenueStaffCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenueStaffCoachesQuery, GetVenueStaffCoachesQueryVariables>(GetVenueStaffCoachesDocument, options);
        }
export type GetVenueStaffCoachesQueryHookResult = ReturnType<typeof useGetVenueStaffCoachesQuery>;
export type GetVenueStaffCoachesLazyQueryHookResult = ReturnType<typeof useGetVenueStaffCoachesLazyQuery>;
export type GetVenueStaffCoachesQueryResult = Apollo.QueryResult<GetVenueStaffCoachesQuery, GetVenueStaffCoachesQueryVariables>;
export const InsertVenueStaffCoachDocument = gql`
    mutation InsertVenueStaffCoach($venueId: uuid!, $userId: uuid!) {
  insertVenueStaffCoachesOne(object: {venueId: $venueId, userId: $userId}) {
    id
    venueId
    userId
    addedByUserId
    createdAt
    coachProfile {
      id
      fullName
      username
      profileImageUrl
      coachStatus
    }
  }
}
    `;
export type InsertVenueStaffCoachMutationFn = Apollo.MutationFunction<InsertVenueStaffCoachMutation, InsertVenueStaffCoachMutationVariables>;

/**
 * __useInsertVenueStaffCoachMutation__
 *
 * To run a mutation, you first call `useInsertVenueStaffCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertVenueStaffCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertVenueStaffCoachMutation, { data, loading, error }] = useInsertVenueStaffCoachMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInsertVenueStaffCoachMutation(baseOptions?: Apollo.MutationHookOptions<InsertVenueStaffCoachMutation, InsertVenueStaffCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertVenueStaffCoachMutation, InsertVenueStaffCoachMutationVariables>(InsertVenueStaffCoachDocument, options);
      }
export type InsertVenueStaffCoachMutationHookResult = ReturnType<typeof useInsertVenueStaffCoachMutation>;
export type InsertVenueStaffCoachMutationResult = Apollo.MutationResult<InsertVenueStaffCoachMutation>;
export type InsertVenueStaffCoachMutationOptions = Apollo.BaseMutationOptions<InsertVenueStaffCoachMutation, InsertVenueStaffCoachMutationVariables>;
export const SoftDeleteVenueStaffCoachDocument = gql`
    mutation SoftDeleteVenueStaffCoach($venueId: uuid!, $userId: uuid!) {
  updateVenueStaffCoaches(
    where: {_and: [{venueId: {_eq: $venueId}}, {userId: {_eq: $userId}}, {deletedAt: {_isNull: true}}]}
    _set: {deletedAt: "now()"}
  ) {
    affectedRows
    returning {
      id
      deletedAt
    }
  }
}
    `;
export type SoftDeleteVenueStaffCoachMutationFn = Apollo.MutationFunction<SoftDeleteVenueStaffCoachMutation, SoftDeleteVenueStaffCoachMutationVariables>;

/**
 * __useSoftDeleteVenueStaffCoachMutation__
 *
 * To run a mutation, you first call `useSoftDeleteVenueStaffCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteVenueStaffCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteVenueStaffCoachMutation, { data, loading, error }] = useSoftDeleteVenueStaffCoachMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSoftDeleteVenueStaffCoachMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteVenueStaffCoachMutation, SoftDeleteVenueStaffCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteVenueStaffCoachMutation, SoftDeleteVenueStaffCoachMutationVariables>(SoftDeleteVenueStaffCoachDocument, options);
      }
export type SoftDeleteVenueStaffCoachMutationHookResult = ReturnType<typeof useSoftDeleteVenueStaffCoachMutation>;
export type SoftDeleteVenueStaffCoachMutationResult = Apollo.MutationResult<SoftDeleteVenueStaffCoachMutation>;
export type SoftDeleteVenueStaffCoachMutationOptions = Apollo.BaseMutationOptions<SoftDeleteVenueStaffCoachMutation, SoftDeleteVenueStaffCoachMutationVariables>;
export const GetCoachRosterVenuesDocument = gql`
    query GetCoachRosterVenues($userId: uuid!) {
  venueStaffCoaches(where: {userId: {_eq: $userId}, deletedAt: {_isNull: true}}) {
    id
    venueId
    venue {
      id
      title
      addressString
      latitude
      longitude
      timezone
      pickleballNets
      outdoorCourtCount
      indoorCourtCount
      accessType
      images(where: {isVisible: {_eq: true}}) {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useGetCoachRosterVenuesQuery__
 *
 * To run a query within a React component, call `useGetCoachRosterVenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachRosterVenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachRosterVenuesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCoachRosterVenuesQuery(baseOptions: Apollo.QueryHookOptions<GetCoachRosterVenuesQuery, GetCoachRosterVenuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachRosterVenuesQuery, GetCoachRosterVenuesQueryVariables>(GetCoachRosterVenuesDocument, options);
      }
export function useGetCoachRosterVenuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachRosterVenuesQuery, GetCoachRosterVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachRosterVenuesQuery, GetCoachRosterVenuesQueryVariables>(GetCoachRosterVenuesDocument, options);
        }
export type GetCoachRosterVenuesQueryHookResult = ReturnType<typeof useGetCoachRosterVenuesQuery>;
export type GetCoachRosterVenuesLazyQueryHookResult = ReturnType<typeof useGetCoachRosterVenuesLazyQuery>;
export type GetCoachRosterVenuesQueryResult = Apollo.QueryResult<GetCoachRosterVenuesQuery, GetCoachRosterVenuesQueryVariables>;
export const SearchCoachesDocument = gql`
    query SearchCoaches($searchTerm: String!, $limit: Int = 10, $excludeIds: [uuid!] = []) {
  users(
    where: {_and: [{_or: [{fullName: {_ilike: $searchTerm}}, {username: {_ilike: $searchTerm}}, {email: {_ilike: $searchTerm}}]}, {coachStatus: {_eq: ACTIVE}}, {id: {_nin: $excludeIds}}, {deletedAt: {_isNull: true}}]}
    limit: $limit
    orderBy: {fullName: ASC}
  ) {
    id
    fullName
    username
    email
    profileImageUrl
    coachStatus
    cityName
  }
}
    `;

/**
 * __useSearchCoachesQuery__
 *
 * To run a query within a React component, call `useSearchCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCoachesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *      excludeIds: // value for 'excludeIds'
 *   },
 * });
 */
export function useSearchCoachesQuery(baseOptions: Apollo.QueryHookOptions<SearchCoachesQuery, SearchCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCoachesQuery, SearchCoachesQueryVariables>(SearchCoachesDocument, options);
      }
export function useSearchCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCoachesQuery, SearchCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCoachesQuery, SearchCoachesQueryVariables>(SearchCoachesDocument, options);
        }
export type SearchCoachesQueryHookResult = ReturnType<typeof useSearchCoachesQuery>;
export type SearchCoachesLazyQueryHookResult = ReturnType<typeof useSearchCoachesLazyQuery>;
export type SearchCoachesQueryResult = Apollo.QueryResult<SearchCoachesQuery, SearchCoachesQueryVariables>;
export const GetEventHostForCouponCreateDocument = gql`
    query getEventHostForCouponCreate($id: uuid!) {
  eventsByPk(id: $id) {
    hostUserId
  }
}
    `;

/**
 * __useGetEventHostForCouponCreateQuery__
 *
 * To run a query within a React component, call `useGetEventHostForCouponCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventHostForCouponCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventHostForCouponCreateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventHostForCouponCreateQuery(baseOptions: Apollo.QueryHookOptions<GetEventHostForCouponCreateQuery, GetEventHostForCouponCreateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventHostForCouponCreateQuery, GetEventHostForCouponCreateQueryVariables>(GetEventHostForCouponCreateDocument, options);
      }
export function useGetEventHostForCouponCreateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventHostForCouponCreateQuery, GetEventHostForCouponCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventHostForCouponCreateQuery, GetEventHostForCouponCreateQueryVariables>(GetEventHostForCouponCreateDocument, options);
        }
export type GetEventHostForCouponCreateQueryHookResult = ReturnType<typeof useGetEventHostForCouponCreateQuery>;
export type GetEventHostForCouponCreateLazyQueryHookResult = ReturnType<typeof useGetEventHostForCouponCreateLazyQuery>;
export type GetEventHostForCouponCreateQueryResult = Apollo.QueryResult<GetEventHostForCouponCreateQuery, GetEventHostForCouponCreateQueryVariables>;
export const GetCouponOwnerForDeleteDocument = gql`
    query getCouponOwnerForDelete($id: uuid!) {
  eventCouponsByPk(id: $id) {
    event {
      hostUserId
    }
  }
}
    `;

/**
 * __useGetCouponOwnerForDeleteQuery__
 *
 * To run a query within a React component, call `useGetCouponOwnerForDeleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponOwnerForDeleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouponOwnerForDeleteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCouponOwnerForDeleteQuery(baseOptions: Apollo.QueryHookOptions<GetCouponOwnerForDeleteQuery, GetCouponOwnerForDeleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCouponOwnerForDeleteQuery, GetCouponOwnerForDeleteQueryVariables>(GetCouponOwnerForDeleteDocument, options);
      }
export function useGetCouponOwnerForDeleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouponOwnerForDeleteQuery, GetCouponOwnerForDeleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCouponOwnerForDeleteQuery, GetCouponOwnerForDeleteQueryVariables>(GetCouponOwnerForDeleteDocument, options);
        }
export type GetCouponOwnerForDeleteQueryHookResult = ReturnType<typeof useGetCouponOwnerForDeleteQuery>;
export type GetCouponOwnerForDeleteLazyQueryHookResult = ReturnType<typeof useGetCouponOwnerForDeleteLazyQuery>;
export type GetCouponOwnerForDeleteQueryResult = Apollo.QueryResult<GetCouponOwnerForDeleteQuery, GetCouponOwnerForDeleteQueryVariables>;
export const GetCouponOwnerForUpdateDocument = gql`
    query getCouponOwnerForUpdate($id: uuid!) {
  eventCouponsByPk(id: $id) {
    event {
      hostUserId
    }
  }
}
    `;

/**
 * __useGetCouponOwnerForUpdateQuery__
 *
 * To run a query within a React component, call `useGetCouponOwnerForUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponOwnerForUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouponOwnerForUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCouponOwnerForUpdateQuery(baseOptions: Apollo.QueryHookOptions<GetCouponOwnerForUpdateQuery, GetCouponOwnerForUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCouponOwnerForUpdateQuery, GetCouponOwnerForUpdateQueryVariables>(GetCouponOwnerForUpdateDocument, options);
      }
export function useGetCouponOwnerForUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouponOwnerForUpdateQuery, GetCouponOwnerForUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCouponOwnerForUpdateQuery, GetCouponOwnerForUpdateQueryVariables>(GetCouponOwnerForUpdateDocument, options);
        }
export type GetCouponOwnerForUpdateQueryHookResult = ReturnType<typeof useGetCouponOwnerForUpdateQuery>;
export type GetCouponOwnerForUpdateLazyQueryHookResult = ReturnType<typeof useGetCouponOwnerForUpdateLazyQuery>;
export type GetCouponOwnerForUpdateQueryResult = Apollo.QueryResult<GetCouponOwnerForUpdateQuery, GetCouponOwnerForUpdateQueryVariables>;
export const GetCoachBookingRequestsDocument = gql`
    query getCoachBookingRequests($coachUserId: uuid!) {
  coachBookingRequests(
    where: {coachUserId: {_eq: $coachUserId}, deletedAt: {_isNull: true}}
    orderBy: {createdAt: DESC}
  ) {
    id
    message
    createdAt
    playerUserId
    playerUserProfile {
      id
      fullName
      profileImagePath
    }
  }
}
    `;

/**
 * __useGetCoachBookingRequestsQuery__
 *
 * To run a query within a React component, call `useGetCoachBookingRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachBookingRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachBookingRequestsQuery({
 *   variables: {
 *      coachUserId: // value for 'coachUserId'
 *   },
 * });
 */
export function useGetCoachBookingRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetCoachBookingRequestsQuery, GetCoachBookingRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachBookingRequestsQuery, GetCoachBookingRequestsQueryVariables>(GetCoachBookingRequestsDocument, options);
      }
export function useGetCoachBookingRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachBookingRequestsQuery, GetCoachBookingRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachBookingRequestsQuery, GetCoachBookingRequestsQueryVariables>(GetCoachBookingRequestsDocument, options);
        }
export type GetCoachBookingRequestsQueryHookResult = ReturnType<typeof useGetCoachBookingRequestsQuery>;
export type GetCoachBookingRequestsLazyQueryHookResult = ReturnType<typeof useGetCoachBookingRequestsLazyQuery>;
export type GetCoachBookingRequestsQueryResult = Apollo.QueryResult<GetCoachBookingRequestsQuery, GetCoachBookingRequestsQueryVariables>;
export const GetTournamentsForStateDocument = gql`
    query getTournamentsForState($stateId: uuid!) {
  events(
    where: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, type: {_eq: TOURNAMENT}, endDateTime: {_gte: "now()"}, status: {_eq: PUBLISHED}, city: {countrySubdivisionId: {_eq: $stateId}}}
  ) {
    city {
      name
      id
      countrySubdivision {
        name
        id
        code
      }
      timezone
    }
    addressString
    coverImagePath
    coverImageUrl
    displayLocation
    description
    endDateTime
    hasPrizes
    id
    latitude
    locale
    longitude
    organizerImagePath
    registrationClosedAt
    registrationDeadlineDate
    registrationPriceUnitAmount
    scoringFormat
    slug
    isExternal
    sourceRegistrationCount
    sourceOrganizerTitle
    startDateTime
    status
    timezoneAbbreviation
    timezoneName
    timezoneOffsetMinutes
    title
    geometry
    registrationsAggregate {
      aggregate {
        count
      }
    }
    venue {
      id
      title
      venueSlug
      slug
      addressString
      pickleballLines
      pickleballNets
      longitude
      latitude
      geometry
      addressString
      outdoorCourtCount
      indoorCourtCount
      timezone
      images {
        id
        path
        url
      }
      courtSurfaces {
        id
        courtSurface
      }
    }
  }
}
    `;

/**
 * __useGetTournamentsForStateQuery__
 *
 * To run a query within a React component, call `useGetTournamentsForStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentsForStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentsForStateQuery({
 *   variables: {
 *      stateId: // value for 'stateId'
 *   },
 * });
 */
export function useGetTournamentsForStateQuery(baseOptions: Apollo.QueryHookOptions<GetTournamentsForStateQuery, GetTournamentsForStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTournamentsForStateQuery, GetTournamentsForStateQueryVariables>(GetTournamentsForStateDocument, options);
      }
export function useGetTournamentsForStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentsForStateQuery, GetTournamentsForStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTournamentsForStateQuery, GetTournamentsForStateQueryVariables>(GetTournamentsForStateDocument, options);
        }
export type GetTournamentsForStateQueryHookResult = ReturnType<typeof useGetTournamentsForStateQuery>;
export type GetTournamentsForStateLazyQueryHookResult = ReturnType<typeof useGetTournamentsForStateLazyQuery>;
export type GetTournamentsForStateQueryResult = Apollo.QueryResult<GetTournamentsForStateQuery, GetTournamentsForStateQueryVariables>;
export const GetCoachBookingPageDocument = gql`
    query getCoachBookingPage($username: String!, $id: uuid!, $startDateTime: timestamptz!) {
  userProfiles(
    where: {_or: [{username: {_eq: $username}}, {id: {_eq: $id}}], coachStatus: {_eq: "ACTIVE"}}
  ) {
    id
    username
    defaultSport
    coachSports(where: {status: {_eq: ACTIVE}}) {
      sport
    }
    activeCity {
      id
      name
      countrySubdivision {
        name
      }
    }
    stripeMerchantChargesEnabled
    timezone
    profileImageFileName
    profileImagePath
    profileImageProviderUrl
    profileImageProvider
    profileImageProviderId
    profileImageUrl
    preferredName
    tiktokUrl
    xUrl
    websiteUrl
    facebookUrl
    instagramUrl
    linkedinUrl
    youtubeUrl
    fullName
    coachStatus
    coverImageFileName
    coverImagePath
    coverImageProviderUrl
    aboutMe
    aboutMeVideoUrl
    cityName
    gender
    coachExternalBookingUrl
    stripeMerchantCurrency
    currencyCoachDefault
    country {
      id
      iso2
      iso3
      name
    }
    countrySubdivision {
      code
      id
      name
      type
    }
    coachingStartYear
    coachLessonsAggregate(where: {status: {_eq: ACTIVE}}) {
      aggregate {
        count
      }
    }
    followersAggregate(where: {status: {_eq: ACTIVE}}) {
      aggregate {
        count
      }
    }
    followers(limit: 5, where: {status: {_eq: ACTIVE}}) {
      followerProfile {
        id
        username
        profileImageFileName
        profileImagePath
        profileImageProviderUrl
        fullName
        preferredName
      }
      followerUserId
      followedUserId
    }
    coachServices {
      currency
      description
      id
      title
      priceUnitAmount
      type
      coverImageFileName
      coverImagePath
      coverImageProviderUrl
    }
    coachAvailability {
      id
      endTimeMinutes
      dayOfWeek
      startTimeMinutes
      status
      coachAvailabilityCustomCourt {
        id
      }
      coachAvailabilityVenueId {
        id
      }
    }
    coachQualifications(where: {status: {_eq: ACTIVE}}) {
      id
      status
      qualification {
        id
        name
        order
        groupId
        displayKey
      }
    }
    normalizedTennisRating
    normalizedTennisRatingScale {
      id
      name
      shortName
    }
    tennisRating
    tennisRatingScale {
      id
      name
      shortName
    }
    tennisSkillLevel {
      id
      isDisplayed
      rank
      displayName
    }
    pickleballSkillLevel {
      id
      isDisplayed
      rank
      displayName
    }
    pciId
    pprId
    isPciMember
    isIptpaMember
    iptpaId
    isQuatroPickleballMember
    quatroPickleballMemberId
    coachLessonDescription
    coachLessonHowToPrepare
    coachLessonAgeGroups {
      id
      lessonAgeGroup
    }
    coachLessonSkillLevels {
      id
      skillLevel
    }
    currencyCoachDefault
    priceUnitAmountCoachDefault
    priceUnitAmountRemoteCoachDefault
    defaultCoachVenue {
      id
      addressString
      images {
        id
        url
        path
        provider
        fileName
      }
      isActive
      latitude
      longitude
      outdoorCourtCount
      geometry
      indoorCourtCount
      slug
      timezone
      title
    }
    pickleballRatingScales {
      id
      rating
      pickleballRatingScaleId
      scale {
        name
        id
        shortName
      }
    }
    stripeMerchantDetailsSubmitted
    stripeMerchantCurrency
    defaultCoachCustomCourt {
      id
      fullAddress
      title
      latitude
      longitude
    }
    coachAvailability {
      id
      endTimeMinutes
      dayOfWeek
      startTimeMinutes
      coachAvailabilityCustomCourt {
        id
      }
      coachAvailabilityVenueId {
        id
      }
    }
    coachLessons(where: {startDateTime: {_gte: $startDateTime}}) {
      id
      ownerUserId
      startDateTime
      endDateTime
      timezoneName
      timezoneAbbreviation
      timezoneOffsetMinutes
      participantLimit
      currency
    }
    userFiles {
      fileCategory
      fileFormat
      fileName
      fileType
      host
      path
      originalFileName
      provider
      providerId
      providerUrl
      url
    }
  }
  coachStarterProfilesByPk(id: $id) {
    aboutMe
    aboutPhotoImageUrl
    age
    birthdate
    addressDisplay
    addressString
    addressType
    cityName
    company
    countryName
    geometry
    id
    gender
    latitude
    longitude
    logoImageUrl
    name
    profileImageUrl
    stateName
    usapRating
  }
}
    `;

/**
 * __useGetCoachBookingPageQuery__
 *
 * To run a query within a React component, call `useGetCoachBookingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachBookingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachBookingPageQuery({
 *   variables: {
 *      username: // value for 'username'
 *      id: // value for 'id'
 *      startDateTime: // value for 'startDateTime'
 *   },
 * });
 */
export function useGetCoachBookingPageQuery(baseOptions: Apollo.QueryHookOptions<GetCoachBookingPageQuery, GetCoachBookingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachBookingPageQuery, GetCoachBookingPageQueryVariables>(GetCoachBookingPageDocument, options);
      }
export function useGetCoachBookingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachBookingPageQuery, GetCoachBookingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachBookingPageQuery, GetCoachBookingPageQueryVariables>(GetCoachBookingPageDocument, options);
        }
export type GetCoachBookingPageQueryHookResult = ReturnType<typeof useGetCoachBookingPageQuery>;
export type GetCoachBookingPageLazyQueryHookResult = ReturnType<typeof useGetCoachBookingPageLazyQuery>;
export type GetCoachBookingPageQueryResult = Apollo.QueryResult<GetCoachBookingPageQuery, GetCoachBookingPageQueryVariables>;
export const InsertCoachBookingRequestDocument = gql`
    mutation insertCoachBookingRequest($coachStarterProfileId: uuid, $coachUserId: uuid, $playerUserId: uuid!) {
  insertCoachBookingRequestsOne(
    object: {coachStarterProfileId: $coachStarterProfileId, coachUserId: $coachUserId, playerUserId: $playerUserId}
    onConflict: {constraint: coach_booking_requests_player_user_id_coach_starter_profile_key, updateColumns: updatedAt}
  ) {
    id
  }
}
    `;
export type InsertCoachBookingRequestMutationFn = Apollo.MutationFunction<InsertCoachBookingRequestMutation, InsertCoachBookingRequestMutationVariables>;

/**
 * __useInsertCoachBookingRequestMutation__
 *
 * To run a mutation, you first call `useInsertCoachBookingRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCoachBookingRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCoachBookingRequestMutation, { data, loading, error }] = useInsertCoachBookingRequestMutation({
 *   variables: {
 *      coachStarterProfileId: // value for 'coachStarterProfileId'
 *      coachUserId: // value for 'coachUserId'
 *      playerUserId: // value for 'playerUserId'
 *   },
 * });
 */
export function useInsertCoachBookingRequestMutation(baseOptions?: Apollo.MutationHookOptions<InsertCoachBookingRequestMutation, InsertCoachBookingRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCoachBookingRequestMutation, InsertCoachBookingRequestMutationVariables>(InsertCoachBookingRequestDocument, options);
      }
export type InsertCoachBookingRequestMutationHookResult = ReturnType<typeof useInsertCoachBookingRequestMutation>;
export type InsertCoachBookingRequestMutationResult = Apollo.MutationResult<InsertCoachBookingRequestMutation>;
export type InsertCoachBookingRequestMutationOptions = Apollo.BaseMutationOptions<InsertCoachBookingRequestMutation, InsertCoachBookingRequestMutationVariables>;
export const GetActiveOwnerUpcomingLessonsByIdDocument = gql`
    query getActiveOwnerUpcomingLessonsById($ownerUserId: uuid!, $limit: Int!) {
  lessons(
    where: {ownerUserId: {_eq: $ownerUserId}, status: {_eq: ACTIVE}, endDateTime: {_gt: "now()"}}
    limit: $limit
    orderBy: {startDateTime: ASC}
  ) {
    ...lessonFields
  }
}
    ${LessonFieldsFragmentDoc}`;

/**
 * __useGetActiveOwnerUpcomingLessonsByIdQuery__
 *
 * To run a query within a React component, call `useGetActiveOwnerUpcomingLessonsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveOwnerUpcomingLessonsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveOwnerUpcomingLessonsByIdQuery({
 *   variables: {
 *      ownerUserId: // value for 'ownerUserId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetActiveOwnerUpcomingLessonsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetActiveOwnerUpcomingLessonsByIdQuery, GetActiveOwnerUpcomingLessonsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveOwnerUpcomingLessonsByIdQuery, GetActiveOwnerUpcomingLessonsByIdQueryVariables>(GetActiveOwnerUpcomingLessonsByIdDocument, options);
      }
export function useGetActiveOwnerUpcomingLessonsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveOwnerUpcomingLessonsByIdQuery, GetActiveOwnerUpcomingLessonsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveOwnerUpcomingLessonsByIdQuery, GetActiveOwnerUpcomingLessonsByIdQueryVariables>(GetActiveOwnerUpcomingLessonsByIdDocument, options);
        }
export type GetActiveOwnerUpcomingLessonsByIdQueryHookResult = ReturnType<typeof useGetActiveOwnerUpcomingLessonsByIdQuery>;
export type GetActiveOwnerUpcomingLessonsByIdLazyQueryHookResult = ReturnType<typeof useGetActiveOwnerUpcomingLessonsByIdLazyQuery>;
export type GetActiveOwnerUpcomingLessonsByIdQueryResult = Apollo.QueryResult<GetActiveOwnerUpcomingLessonsByIdQuery, GetActiveOwnerUpcomingLessonsByIdQueryVariables>;
export const GetLessonRevenueByCoachIdDocument = gql`
    query getLessonRevenueByCoachId($coachId: uuid!, $dateFilter: timestamptz!) {
  lessons(where: {ownerUserId: {_eq: $coachId}}) {
    id
    type
    ownerProfile {
      cityName
      activeCity {
        name
        id
      }
    }
    orders(where: {createdAt: {_gte: $dateFilter}, sellerUserId: {_eq: $coachId}}) {
      customerUserId
      sellerUserId
      createdAt
      sellerProfile {
        id
        coachStatus
        activeCity {
          name
        }
      }
      customerProfile {
        id
        fullName
        profileImageProviderUrl
      }
      orderTotalUnitAmount
    }
  }
}
    `;

/**
 * __useGetLessonRevenueByCoachIdQuery__
 *
 * To run a query within a React component, call `useGetLessonRevenueByCoachIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonRevenueByCoachIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonRevenueByCoachIdQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *      dateFilter: // value for 'dateFilter'
 *   },
 * });
 */
export function useGetLessonRevenueByCoachIdQuery(baseOptions: Apollo.QueryHookOptions<GetLessonRevenueByCoachIdQuery, GetLessonRevenueByCoachIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonRevenueByCoachIdQuery, GetLessonRevenueByCoachIdQueryVariables>(GetLessonRevenueByCoachIdDocument, options);
      }
export function useGetLessonRevenueByCoachIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonRevenueByCoachIdQuery, GetLessonRevenueByCoachIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonRevenueByCoachIdQuery, GetLessonRevenueByCoachIdQueryVariables>(GetLessonRevenueByCoachIdDocument, options);
        }
export type GetLessonRevenueByCoachIdQueryHookResult = ReturnType<typeof useGetLessonRevenueByCoachIdQuery>;
export type GetLessonRevenueByCoachIdLazyQueryHookResult = ReturnType<typeof useGetLessonRevenueByCoachIdLazyQuery>;
export type GetLessonRevenueByCoachIdQueryResult = Apollo.QueryResult<GetLessonRevenueByCoachIdQuery, GetLessonRevenueByCoachIdQueryVariables>;
export const GetCoachCityRankDocument = gql`
    query getCoachCityRank($cityId: uuid!) {
  lessons(where: {ownerProfile: {activeCityId: {_eq: $cityId}}}) {
    createdAt
    ownerUserId
    ordersAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetCoachCityRankQuery__
 *
 * To run a query within a React component, call `useGetCoachCityRankQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachCityRankQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachCityRankQuery({
 *   variables: {
 *      cityId: // value for 'cityId'
 *   },
 * });
 */
export function useGetCoachCityRankQuery(baseOptions: Apollo.QueryHookOptions<GetCoachCityRankQuery, GetCoachCityRankQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachCityRankQuery, GetCoachCityRankQueryVariables>(GetCoachCityRankDocument, options);
      }
export function useGetCoachCityRankLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachCityRankQuery, GetCoachCityRankQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachCityRankQuery, GetCoachCityRankQueryVariables>(GetCoachCityRankDocument, options);
        }
export type GetCoachCityRankQueryHookResult = ReturnType<typeof useGetCoachCityRankQuery>;
export type GetCoachCityRankLazyQueryHookResult = ReturnType<typeof useGetCoachCityRankLazyQuery>;
export type GetCoachCityRankQueryResult = Apollo.QueryResult<GetCoachCityRankQuery, GetCoachCityRankQueryVariables>;
export const GetWeeklyLessonsBookedDocument = gql`
    query getWeeklyLessonsBooked($dateFrom: timestamptz!) {
  lessons(
    where: {startDateTime: {_gt: $dateFrom}, ordersAggregate: {count: {predicate: {_gt: 0}}}}
  ) {
    id
    ordersAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetWeeklyLessonsBookedQuery__
 *
 * To run a query within a React component, call `useGetWeeklyLessonsBookedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklyLessonsBookedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklyLessonsBookedQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *   },
 * });
 */
export function useGetWeeklyLessonsBookedQuery(baseOptions: Apollo.QueryHookOptions<GetWeeklyLessonsBookedQuery, GetWeeklyLessonsBookedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWeeklyLessonsBookedQuery, GetWeeklyLessonsBookedQueryVariables>(GetWeeklyLessonsBookedDocument, options);
      }
export function useGetWeeklyLessonsBookedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWeeklyLessonsBookedQuery, GetWeeklyLessonsBookedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWeeklyLessonsBookedQuery, GetWeeklyLessonsBookedQueryVariables>(GetWeeklyLessonsBookedDocument, options);
        }
export type GetWeeklyLessonsBookedQueryHookResult = ReturnType<typeof useGetWeeklyLessonsBookedQuery>;
export type GetWeeklyLessonsBookedLazyQueryHookResult = ReturnType<typeof useGetWeeklyLessonsBookedLazyQuery>;
export type GetWeeklyLessonsBookedQueryResult = Apollo.QueryResult<GetWeeklyLessonsBookedQuery, GetWeeklyLessonsBookedQueryVariables>;
export const GetCoachVideoAnalysisPendingDocument = gql`
    query getCoachVideoAnalysisPending($reviewerId: uuid!, $offset: Int = 0, $limit: Int = 10) {
  videoAnalysis(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, reviewStatus: {_eq: PENDING}, reviewerUserId: {_eq: $reviewerId}}
    orderBy: {createdAt: DESC}
    offset: $offset
    limit: $limit
  ) {
    id
    submissionRequestedFeedback
    videoAnalysisRequestedSkillsReviews {
      id
      videoLessonSkills {
        customSkill
        id
        skill
      }
    }
    videoAnalysisFiles {
      id
      host
      fileType
      fileName
      fileFormat
      fileCategory
      createdAt
      originalFileName
      provider
      providerId
      providerUrl
      updatedAt
      url
    }
    createdAt
    videoAnalysisSubmission {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    videoAnalysisReviewer {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
  }
  videoAnalysisAggregate(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, reviewStatus: {_eq: PENDING}, reviewerUserId: {_eq: $reviewerId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetCoachVideoAnalysisPendingQuery__
 *
 * To run a query within a React component, call `useGetCoachVideoAnalysisPendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachVideoAnalysisPendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachVideoAnalysisPendingQuery({
 *   variables: {
 *      reviewerId: // value for 'reviewerId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCoachVideoAnalysisPendingQuery(baseOptions: Apollo.QueryHookOptions<GetCoachVideoAnalysisPendingQuery, GetCoachVideoAnalysisPendingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachVideoAnalysisPendingQuery, GetCoachVideoAnalysisPendingQueryVariables>(GetCoachVideoAnalysisPendingDocument, options);
      }
export function useGetCoachVideoAnalysisPendingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachVideoAnalysisPendingQuery, GetCoachVideoAnalysisPendingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachVideoAnalysisPendingQuery, GetCoachVideoAnalysisPendingQueryVariables>(GetCoachVideoAnalysisPendingDocument, options);
        }
export type GetCoachVideoAnalysisPendingQueryHookResult = ReturnType<typeof useGetCoachVideoAnalysisPendingQuery>;
export type GetCoachVideoAnalysisPendingLazyQueryHookResult = ReturnType<typeof useGetCoachVideoAnalysisPendingLazyQuery>;
export type GetCoachVideoAnalysisPendingQueryResult = Apollo.QueryResult<GetCoachVideoAnalysisPendingQuery, GetCoachVideoAnalysisPendingQueryVariables>;
export const GetCoachVideoAnalysisReviewedDocument = gql`
    query getCoachVideoAnalysisReviewed($reviewerId: uuid!, $offset: Int = 0, $limit: Int = 10) {
  videoAnalysis(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, reviewStatus: {_in: [REVIEWED, COMPLETE]}, reviewerUserId: {_eq: $reviewerId}}
    orderBy: {createdAt: DESC}
    offset: $offset
    limit: $limit
  ) {
    id
    submissionRequestedFeedback
    videoAnalysisRequestedSkillsReviews {
      id
      videoLessonSkills {
        customSkill
        id
        skill
      }
    }
    videoAnalysisFiles {
      id
      host
      fileType
      fileName
      fileFormat
      fileCategory
      createdAt
      originalFileName
      provider
      providerId
      providerUrl
      updatedAt
      url
    }
    createdAt
    videoAnalysisSubmission {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
  }
  videoAnalysisAggregate(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, reviewStatus: {_in: [REVIEWED, COMPLETE]}, reviewerUserId: {_eq: $reviewerId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetCoachVideoAnalysisReviewedQuery__
 *
 * To run a query within a React component, call `useGetCoachVideoAnalysisReviewedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachVideoAnalysisReviewedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachVideoAnalysisReviewedQuery({
 *   variables: {
 *      reviewerId: // value for 'reviewerId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCoachVideoAnalysisReviewedQuery(baseOptions: Apollo.QueryHookOptions<GetCoachVideoAnalysisReviewedQuery, GetCoachVideoAnalysisReviewedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachVideoAnalysisReviewedQuery, GetCoachVideoAnalysisReviewedQueryVariables>(GetCoachVideoAnalysisReviewedDocument, options);
      }
export function useGetCoachVideoAnalysisReviewedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachVideoAnalysisReviewedQuery, GetCoachVideoAnalysisReviewedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachVideoAnalysisReviewedQuery, GetCoachVideoAnalysisReviewedQueryVariables>(GetCoachVideoAnalysisReviewedDocument, options);
        }
export type GetCoachVideoAnalysisReviewedQueryHookResult = ReturnType<typeof useGetCoachVideoAnalysisReviewedQuery>;
export type GetCoachVideoAnalysisReviewedLazyQueryHookResult = ReturnType<typeof useGetCoachVideoAnalysisReviewedLazyQuery>;
export type GetCoachVideoAnalysisReviewedQueryResult = Apollo.QueryResult<GetCoachVideoAnalysisReviewedQuery, GetCoachVideoAnalysisReviewedQueryVariables>;
export const GetCoachUpcomingClinicLessonsByIdDocument = gql`
    query getCoachUpcomingClinicLessonsById($ownerUserId: uuid!, $limit: Int!, $offset: Int!) {
  lessons(
    where: {ownerUserId: {_eq: $ownerUserId}, status: {_eq: ACTIVE}, startDateTime: {_gt: "now()"}, privacy: {_eq: PUBLIC}, participantLimit: {_gt: 1}}
    limit: $limit
    orderBy: {startDateTime: ASC}
    offset: $offset
  ) {
    ...lessonFields
  }
  lessonsAggregate(
    where: {ownerUserId: {_eq: $ownerUserId}, status: {_eq: ACTIVE}, startDateTime: {_gt: "now()"}, privacy: {_eq: PUBLIC}, participantLimit: {_gt: 1}}
  ) {
    aggregate {
      count
    }
  }
}
    ${LessonFieldsFragmentDoc}`;

/**
 * __useGetCoachUpcomingClinicLessonsByIdQuery__
 *
 * To run a query within a React component, call `useGetCoachUpcomingClinicLessonsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachUpcomingClinicLessonsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachUpcomingClinicLessonsByIdQuery({
 *   variables: {
 *      ownerUserId: // value for 'ownerUserId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCoachUpcomingClinicLessonsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCoachUpcomingClinicLessonsByIdQuery, GetCoachUpcomingClinicLessonsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachUpcomingClinicLessonsByIdQuery, GetCoachUpcomingClinicLessonsByIdQueryVariables>(GetCoachUpcomingClinicLessonsByIdDocument, options);
      }
export function useGetCoachUpcomingClinicLessonsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachUpcomingClinicLessonsByIdQuery, GetCoachUpcomingClinicLessonsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachUpcomingClinicLessonsByIdQuery, GetCoachUpcomingClinicLessonsByIdQueryVariables>(GetCoachUpcomingClinicLessonsByIdDocument, options);
        }
export type GetCoachUpcomingClinicLessonsByIdQueryHookResult = ReturnType<typeof useGetCoachUpcomingClinicLessonsByIdQuery>;
export type GetCoachUpcomingClinicLessonsByIdLazyQueryHookResult = ReturnType<typeof useGetCoachUpcomingClinicLessonsByIdLazyQuery>;
export type GetCoachUpcomingClinicLessonsByIdQueryResult = Apollo.QueryResult<GetCoachUpcomingClinicLessonsByIdQuery, GetCoachUpcomingClinicLessonsByIdQueryVariables>;
export const GetCoachVideoAnalysisBySubmitterIdDocument = gql`
    query getCoachVideoAnalysisBySubmitterId($reviewerId: uuid!, $submissionUserId: uuid!) {
  videoAnalysis(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, reviewerUserId: {_eq: $reviewerId}, submissionUserId: {_eq: $submissionUserId}}
    orderBy: {createdAt: DESC, reviewStatus: DESC}
  ) {
    id
    submissionRequestedFeedback
    reviewStatus
    videoAnalysisComments {
      videoAnalysisSkillsComments {
        videoLessonSkills {
          skill
          customSkill
        }
        videoAnalysisComments {
          details
          id
          videoAnalysisFiles {
            id
            host
            fileType
            fileName
            fileFormat
            fileCategory
            createdAt
            originalFileName
            provider
            providerId
            providerUrl
            updatedAt
            url
          }
        }
      }
      sentiment
      id
    }
    videoAnalysisRequestedSkillsReviews {
      id
      videoLessonSkills {
        customSkill
        id
        skill
      }
    }
    videoAnalysisFiles {
      id
      host
      fileType
      fileName
      fileFormat
      fileCategory
      createdAt
      originalFileName
      provider
      providerId
      providerUrl
      updatedAt
      url
    }
    createdAt
    videoAnalysisSubmission {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    videoAnalysisReviewer {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
  }
  videoAnalysisAggregate(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, reviewerUserId: {_eq: $reviewerId}, submissionUserId: {_eq: $submissionUserId}}
  ) {
    aggregate {
      count
    }
  }
  pendingVideoAnalysisCount: videoAnalysisAggregate(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, reviewerUserId: {_eq: $reviewerId}, submissionUserId: {_eq: $submissionUserId}, reviewStatus: {_eq: PENDING}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetCoachVideoAnalysisBySubmitterIdQuery__
 *
 * To run a query within a React component, call `useGetCoachVideoAnalysisBySubmitterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachVideoAnalysisBySubmitterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachVideoAnalysisBySubmitterIdQuery({
 *   variables: {
 *      reviewerId: // value for 'reviewerId'
 *      submissionUserId: // value for 'submissionUserId'
 *   },
 * });
 */
export function useGetCoachVideoAnalysisBySubmitterIdQuery(baseOptions: Apollo.QueryHookOptions<GetCoachVideoAnalysisBySubmitterIdQuery, GetCoachVideoAnalysisBySubmitterIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachVideoAnalysisBySubmitterIdQuery, GetCoachVideoAnalysisBySubmitterIdQueryVariables>(GetCoachVideoAnalysisBySubmitterIdDocument, options);
      }
export function useGetCoachVideoAnalysisBySubmitterIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachVideoAnalysisBySubmitterIdQuery, GetCoachVideoAnalysisBySubmitterIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachVideoAnalysisBySubmitterIdQuery, GetCoachVideoAnalysisBySubmitterIdQueryVariables>(GetCoachVideoAnalysisBySubmitterIdDocument, options);
        }
export type GetCoachVideoAnalysisBySubmitterIdQueryHookResult = ReturnType<typeof useGetCoachVideoAnalysisBySubmitterIdQuery>;
export type GetCoachVideoAnalysisBySubmitterIdLazyQueryHookResult = ReturnType<typeof useGetCoachVideoAnalysisBySubmitterIdLazyQuery>;
export type GetCoachVideoAnalysisBySubmitterIdQueryResult = Apollo.QueryResult<GetCoachVideoAnalysisBySubmitterIdQuery, GetCoachVideoAnalysisBySubmitterIdQueryVariables>;
export const GetCoachReflectionsBySubmitterIdDocument = gql`
    query getCoachReflectionsBySubmitterId($coachId: uuid!, $userId: uuid!) {
  lessons(
    where: {ownerUserId: {_eq: $coachId}, participants: {userId: {_eq: $userId}}, times: {startDateTime: {_lt: "now()"}}}
    orderBy: {startDateTime: DESC}
  ) {
    id
    title
    type
    venue {
      addressString
    }
    userCustomCourt {
      fullAddress
    }
    times {
      startDateTime
      endDateTime
    }
    ownerProfile {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    participants(where: {userProfile: {id: {_eq: $userId}}}) {
      id
      userId
      recapSkippedAt
      userProfile {
        id
        fullName
        profileImageProviderUrl
        profileImageFileName
      }
    }
    lessonReflections(
      where: {coachUserId: {_eq: $coachId}, playerUserId: {_eq: $userId}}
    ) {
      createdAt
      details
      upcomingCategory
      upcomingSport
      completedCategory
      completedSport
      assignmentCategory
      assignmentSport
      files {
        createdAt
        fileCategory
        fileFormat
        fileName
        fileType
        host
        id
        provider
        providerId
        providerUrl
        url
        userId
        originalFileName
      }
      id
      lessonId
      submissionRequestedFeedback
      updatedAt
      reviewStatus
      lessonPlayer {
        id
        fullName
        profileImageProviderUrl
        profileImageFileName
      }
      lessonCoach {
        id
        fullName
        profileImageProviderUrl
        profileImageFileName
      }
      lessonReflectionComments {
        createdAt
        id
        order
        sentiment
        skill
        customSkill
        updatedAt
        details
        type
        lessonReflectionFiles {
          createdAt
          fileCategory
          fileFormat
          fileName
          fileType
          host
          id
          provider
          providerId
          providerUrl
          url
          userId
          originalFileName
        }
      }
    }
  }
  lessonPlayerSkillAssessments(
    where: {playerUserId: {_eq: $userId}, coachUserId: {_eq: $coachId}}
  ) {
    playerUserId
    coachUserId
    lessonCoach {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    lessonPlayer {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    lessonPlayerSkillAssessmentsSkills {
      category
      createdAt
      skill
    }
  }
  lessonReflections(
    where: {coachUserId: {_eq: $coachId}, playerUserId: {_eq: $userId}}
  ) {
    createdAt
    details
    id
    files {
      createdAt
      fileCategory
      fileFormat
      fileName
      fileType
      host
      id
      provider
      providerId
      providerUrl
      url
      userId
      originalFileName
    }
    lessonId
    submissionRequestedFeedback
    updatedAt
    reviewStatus
    lessonPlayer {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    lessonCoach {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    lessonReflectionComments {
      type
      createdAt
      id
      order
      sentiment
      skill
      customSkill
      updatedAt
      lessonReflectionFiles {
        createdAt
        fileCategory
        fileFormat
        fileName
        fileType
        host
        id
        provider
        providerId
        providerUrl
        transcript
        transcriptEndedAt
        transcriptStartedAt
        url
      }
    }
  }
}
    `;

/**
 * __useGetCoachReflectionsBySubmitterIdQuery__
 *
 * To run a query within a React component, call `useGetCoachReflectionsBySubmitterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachReflectionsBySubmitterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachReflectionsBySubmitterIdQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCoachReflectionsBySubmitterIdQuery(baseOptions: Apollo.QueryHookOptions<GetCoachReflectionsBySubmitterIdQuery, GetCoachReflectionsBySubmitterIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachReflectionsBySubmitterIdQuery, GetCoachReflectionsBySubmitterIdQueryVariables>(GetCoachReflectionsBySubmitterIdDocument, options);
      }
export function useGetCoachReflectionsBySubmitterIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachReflectionsBySubmitterIdQuery, GetCoachReflectionsBySubmitterIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachReflectionsBySubmitterIdQuery, GetCoachReflectionsBySubmitterIdQueryVariables>(GetCoachReflectionsBySubmitterIdDocument, options);
        }
export type GetCoachReflectionsBySubmitterIdQueryHookResult = ReturnType<typeof useGetCoachReflectionsBySubmitterIdQuery>;
export type GetCoachReflectionsBySubmitterIdLazyQueryHookResult = ReturnType<typeof useGetCoachReflectionsBySubmitterIdLazyQuery>;
export type GetCoachReflectionsBySubmitterIdQueryResult = Apollo.QueryResult<GetCoachReflectionsBySubmitterIdQuery, GetCoachReflectionsBySubmitterIdQueryVariables>;
export const UpdateCoachLessonReflectionDocument = gql`
    mutation updateCoachLessonReflection($reflectionId: uuid!, $comments: [LessonReflectionCommentsInsertInput!]!, $files: [LessonReflectionFilesInsertInput!]!, $details: String, $completedCategory: LessonSkillCategoriesEnum, $completedSport: SportsEnum, $upcomingCategory: LessonSkillCategoriesEnum, $upcomingSport: SportsEnum, $assignmentCategory: LessonSkillCategoriesEnum, $assignmentSport: SportsEnum) {
  deleteLessonReflectionComments(
    where: {lessonReflectionId: {_eq: $reflectionId}}
  ) {
    returning {
      id
    }
  }
  deleteLessonReflectionFiles(where: {lessonReflectionId: {_eq: $reflectionId}}) {
    returning {
      id
    }
  }
  updateLessonReflectionsByPk(
    pkColumns: {id: $reflectionId}
    _set: {details: $details, completedCategory: $completedCategory, completedSport: $completedSport, upcomingCategory: $upcomingCategory, upcomingSport: $upcomingSport, assignmentCategory: $assignmentCategory, assignmentSport: $assignmentSport}
  ) {
    id
  }
  insertLessonReflectionFiles(objects: $files) {
    affectedRows
  }
  insertLessonReflectionComments(objects: $comments) {
    affectedRows
  }
}
    `;
export type UpdateCoachLessonReflectionMutationFn = Apollo.MutationFunction<UpdateCoachLessonReflectionMutation, UpdateCoachLessonReflectionMutationVariables>;

/**
 * __useUpdateCoachLessonReflectionMutation__
 *
 * To run a mutation, you first call `useUpdateCoachLessonReflectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachLessonReflectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachLessonReflectionMutation, { data, loading, error }] = useUpdateCoachLessonReflectionMutation({
 *   variables: {
 *      reflectionId: // value for 'reflectionId'
 *      comments: // value for 'comments'
 *      files: // value for 'files'
 *      details: // value for 'details'
 *      completedCategory: // value for 'completedCategory'
 *      completedSport: // value for 'completedSport'
 *      upcomingCategory: // value for 'upcomingCategory'
 *      upcomingSport: // value for 'upcomingSport'
 *      assignmentCategory: // value for 'assignmentCategory'
 *      assignmentSport: // value for 'assignmentSport'
 *   },
 * });
 */
export function useUpdateCoachLessonReflectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoachLessonReflectionMutation, UpdateCoachLessonReflectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoachLessonReflectionMutation, UpdateCoachLessonReflectionMutationVariables>(UpdateCoachLessonReflectionDocument, options);
      }
export type UpdateCoachLessonReflectionMutationHookResult = ReturnType<typeof useUpdateCoachLessonReflectionMutation>;
export type UpdateCoachLessonReflectionMutationResult = Apollo.MutationResult<UpdateCoachLessonReflectionMutation>;
export type UpdateCoachLessonReflectionMutationOptions = Apollo.BaseMutationOptions<UpdateCoachLessonReflectionMutation, UpdateCoachLessonReflectionMutationVariables>;
export const UpdateOnboardingStep1Document = gql`
    mutation updateOnboardingStep1($userId: uuid!, $gender: GenderEnum!, $phoneNumber: String!, $phoneCountryCode: String!, $defaultSport: SportsEnum!, $profileImageProviderUrl: String!, $profileImageUrl: String!, $profileImageProviderId: String!, $profileImagePath: String!, $profileImageProvider: String!, $profileImageFileName: String!, $sports: [CoachSportsInsertInput!]!) {
  updateUsersByPk(
    pkColumns: {id: $userId}
    _set: {gender: $gender, phoneNumber: $phoneNumber, phoneCountryCode: $phoneCountryCode, defaultSport: $defaultSport, profileImageProviderUrl: $profileImageProviderUrl, profileImageUrl: $profileImageUrl, profileImageProviderId: $profileImageProviderId, profileImagePath: $profileImagePath, profileImageProvider: $profileImageProvider, profileImageFileName: $profileImageFileName}
  ) {
    id
    gender
    phoneNumber
    phoneCountryCode
    defaultSport
    profileImageUrl
    profileImageProviderUrl
    profileImageProviderId
    profileImagePath
    profileImageProvider
    profileImageFileName
  }
  insertCoachSports(
    objects: $sports
    onConflict: {constraint: coach_sports_user_id_sport_key, updateColumns: status}
  ) {
    returning {
      id
      sport
      status
      userId
    }
  }
}
    `;
export type UpdateOnboardingStep1MutationFn = Apollo.MutationFunction<UpdateOnboardingStep1Mutation, UpdateOnboardingStep1MutationVariables>;

/**
 * __useUpdateOnboardingStep1Mutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingStep1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingStep1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingStep1Mutation, { data, loading, error }] = useUpdateOnboardingStep1Mutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      gender: // value for 'gender'
 *      phoneNumber: // value for 'phoneNumber'
 *      phoneCountryCode: // value for 'phoneCountryCode'
 *      defaultSport: // value for 'defaultSport'
 *      profileImageProviderUrl: // value for 'profileImageProviderUrl'
 *      profileImageUrl: // value for 'profileImageUrl'
 *      profileImageProviderId: // value for 'profileImageProviderId'
 *      profileImagePath: // value for 'profileImagePath'
 *      profileImageProvider: // value for 'profileImageProvider'
 *      profileImageFileName: // value for 'profileImageFileName'
 *      sports: // value for 'sports'
 *   },
 * });
 */
export function useUpdateOnboardingStep1Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateOnboardingStep1Mutation, UpdateOnboardingStep1MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOnboardingStep1Mutation, UpdateOnboardingStep1MutationVariables>(UpdateOnboardingStep1Document, options);
      }
export type UpdateOnboardingStep1MutationHookResult = ReturnType<typeof useUpdateOnboardingStep1Mutation>;
export type UpdateOnboardingStep1MutationResult = Apollo.MutationResult<UpdateOnboardingStep1Mutation>;
export type UpdateOnboardingStep1MutationOptions = Apollo.BaseMutationOptions<UpdateOnboardingStep1Mutation, UpdateOnboardingStep1MutationVariables>;
export const GetCoachDashboardStatsDocument = gql`
    query getCoachDashboardStats($userId: uuid!) {
  userProfiles(where: {id: {_eq: $userId}}) {
    id
    fullName
    preferredName
    coachReviewsAggregate {
      aggregate {
        count
        avg {
          rating
        }
      }
    }
    followersAggregate {
      aggregate {
        count
      }
    }
    coachLessonsAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetCoachDashboardStatsQuery__
 *
 * To run a query within a React component, call `useGetCoachDashboardStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachDashboardStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachDashboardStatsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCoachDashboardStatsQuery(baseOptions: Apollo.QueryHookOptions<GetCoachDashboardStatsQuery, GetCoachDashboardStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachDashboardStatsQuery, GetCoachDashboardStatsQueryVariables>(GetCoachDashboardStatsDocument, options);
      }
export function useGetCoachDashboardStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachDashboardStatsQuery, GetCoachDashboardStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachDashboardStatsQuery, GetCoachDashboardStatsQueryVariables>(GetCoachDashboardStatsDocument, options);
        }
export type GetCoachDashboardStatsQueryHookResult = ReturnType<typeof useGetCoachDashboardStatsQuery>;
export type GetCoachDashboardStatsLazyQueryHookResult = ReturnType<typeof useGetCoachDashboardStatsLazyQuery>;
export type GetCoachDashboardStatsQueryResult = Apollo.QueryResult<GetCoachDashboardStatsQuery, GetCoachDashboardStatsQueryVariables>;
export const GetCoachDashboardMetricsDocument = gql`
    query getCoachDashboardMetrics($userId: uuid!, $currentMonthStart: timestamptz!, $previousMonthStart: timestamptz!, $previousMonthEnd: timestamptz!) {
  userProfiles(where: {id: {_eq: $userId}}) {
    id
    coachReviewsAggregate {
      aggregate {
        count
        avg {
          rating
        }
      }
    }
    previousMonthReviews: coachReviewsAggregate(
      where: {createdAt: {_gte: $previousMonthStart, _lt: $previousMonthEnd}}
    ) {
      aggregate {
        count
        avg {
          rating
        }
      }
    }
    currentMonthReviews: coachReviewsAggregate(
      where: {createdAt: {_gte: $currentMonthStart}}
    ) {
      aggregate {
        count
        avg {
          rating
        }
      }
    }
  }
  currentMonthLessons: lessonsAggregate(
    where: {ownerUserId: {_eq: $userId}, status: {_eq: ACTIVE}, startDateTime: {_gte: $currentMonthStart}}
  ) {
    aggregate {
      count
    }
  }
  previousMonthLessons: lessonsAggregate(
    where: {ownerUserId: {_eq: $userId}, status: {_eq: ACTIVE}, startDateTime: {_gte: $previousMonthStart, _lt: $previousMonthEnd}}
  ) {
    aggregate {
      count
    }
  }
  currentMonthClientLessons: lessonParticipants(
    where: {lesson: {ownerUserId: {_eq: $userId}, status: {_eq: ACTIVE}, startDateTime: {_gte: $currentMonthStart}}, status: {_eq: ACTIVE}}
  ) {
    userId
    userProfile {
      id
      fullName
      profileImageProviderUrl
      profileImagePath
    }
    lessonId
  }
  previousMonthClientLessons: lessonParticipants(
    where: {lesson: {ownerUserId: {_eq: $userId}, status: {_eq: ACTIVE}, startDateTime: {_gte: $previousMonthStart, _lt: $previousMonthEnd}}, status: {_eq: ACTIVE}}
  ) {
    userId
    userProfile {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    lessonId
  }
}
    `;

/**
 * __useGetCoachDashboardMetricsQuery__
 *
 * To run a query within a React component, call `useGetCoachDashboardMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachDashboardMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachDashboardMetricsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      currentMonthStart: // value for 'currentMonthStart'
 *      previousMonthStart: // value for 'previousMonthStart'
 *      previousMonthEnd: // value for 'previousMonthEnd'
 *   },
 * });
 */
export function useGetCoachDashboardMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetCoachDashboardMetricsQuery, GetCoachDashboardMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachDashboardMetricsQuery, GetCoachDashboardMetricsQueryVariables>(GetCoachDashboardMetricsDocument, options);
      }
export function useGetCoachDashboardMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachDashboardMetricsQuery, GetCoachDashboardMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachDashboardMetricsQuery, GetCoachDashboardMetricsQueryVariables>(GetCoachDashboardMetricsDocument, options);
        }
export type GetCoachDashboardMetricsQueryHookResult = ReturnType<typeof useGetCoachDashboardMetricsQuery>;
export type GetCoachDashboardMetricsLazyQueryHookResult = ReturnType<typeof useGetCoachDashboardMetricsLazyQuery>;
export type GetCoachDashboardMetricsQueryResult = Apollo.QueryResult<GetCoachDashboardMetricsQuery, GetCoachDashboardMetricsQueryVariables>;
export const InsertUploadReviewRequestsDocument = gql`
    mutation insertUploadReviewRequests($objects: [UploadReviewRequestsInsertInput!]!) {
  insertUploadReviewRequests(objects: $objects) {
    returning {
      id
      userId
      url
      createdAt
    }
  }
}
    `;
export type InsertUploadReviewRequestsMutationFn = Apollo.MutationFunction<InsertUploadReviewRequestsMutation, InsertUploadReviewRequestsMutationVariables>;

/**
 * __useInsertUploadReviewRequestsMutation__
 *
 * To run a mutation, you first call `useInsertUploadReviewRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUploadReviewRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUploadReviewRequestsMutation, { data, loading, error }] = useInsertUploadReviewRequestsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertUploadReviewRequestsMutation(baseOptions?: Apollo.MutationHookOptions<InsertUploadReviewRequestsMutation, InsertUploadReviewRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUploadReviewRequestsMutation, InsertUploadReviewRequestsMutationVariables>(InsertUploadReviewRequestsDocument, options);
      }
export type InsertUploadReviewRequestsMutationHookResult = ReturnType<typeof useInsertUploadReviewRequestsMutation>;
export type InsertUploadReviewRequestsMutationResult = Apollo.MutationResult<InsertUploadReviewRequestsMutation>;
export type InsertUploadReviewRequestsMutationOptions = Apollo.BaseMutationOptions<InsertUploadReviewRequestsMutation, InsertUploadReviewRequestsMutationVariables>;
export const GetProfileCompletenessProgressDocument = gql`
    query getProfileCompletenessProgress($userId: uuid!) {
  userFollowsAggregate(
    where: {followedUserId: {_eq: $userId}, status: {_eq: ACTIVE}, followerUserId: {_neq: $userId}}
  ) {
    aggregate {
      count
    }
  }
  userProfiles(where: {id: {_eq: $userId}}) {
    id
    profileImageProviderUrl
    aboutMe
    coachingStartYear
  }
  reviewsAggregate(where: {coachUserId: {_eq: $userId}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetProfileCompletenessProgressQuery__
 *
 * To run a query within a React component, call `useGetProfileCompletenessProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileCompletenessProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileCompletenessProgressQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetProfileCompletenessProgressQuery(baseOptions: Apollo.QueryHookOptions<GetProfileCompletenessProgressQuery, GetProfileCompletenessProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileCompletenessProgressQuery, GetProfileCompletenessProgressQueryVariables>(GetProfileCompletenessProgressDocument, options);
      }
export function useGetProfileCompletenessProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileCompletenessProgressQuery, GetProfileCompletenessProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileCompletenessProgressQuery, GetProfileCompletenessProgressQueryVariables>(GetProfileCompletenessProgressDocument, options);
        }
export type GetProfileCompletenessProgressQueryHookResult = ReturnType<typeof useGetProfileCompletenessProgressQuery>;
export type GetProfileCompletenessProgressLazyQueryHookResult = ReturnType<typeof useGetProfileCompletenessProgressLazyQuery>;
export type GetProfileCompletenessProgressQueryResult = Apollo.QueryResult<GetProfileCompletenessProgressQuery, GetProfileCompletenessProgressQueryVariables>;
export const UpdateUserDidSkipStripeSetupDocument = gql`
    mutation updateUserDidSkipStripeSetup($id: uuid!, $didSkipStripeSetup: Boolean!) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {didSkipStripeSetup: $didSkipStripeSetup}
  ) {
    id
    didSkipStripeSetup
  }
}
    `;
export type UpdateUserDidSkipStripeSetupMutationFn = Apollo.MutationFunction<UpdateUserDidSkipStripeSetupMutation, UpdateUserDidSkipStripeSetupMutationVariables>;

/**
 * __useUpdateUserDidSkipStripeSetupMutation__
 *
 * To run a mutation, you first call `useUpdateUserDidSkipStripeSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDidSkipStripeSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDidSkipStripeSetupMutation, { data, loading, error }] = useUpdateUserDidSkipStripeSetupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      didSkipStripeSetup: // value for 'didSkipStripeSetup'
 *   },
 * });
 */
export function useUpdateUserDidSkipStripeSetupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDidSkipStripeSetupMutation, UpdateUserDidSkipStripeSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDidSkipStripeSetupMutation, UpdateUserDidSkipStripeSetupMutationVariables>(UpdateUserDidSkipStripeSetupDocument, options);
      }
export type UpdateUserDidSkipStripeSetupMutationHookResult = ReturnType<typeof useUpdateUserDidSkipStripeSetupMutation>;
export type UpdateUserDidSkipStripeSetupMutationResult = Apollo.MutationResult<UpdateUserDidSkipStripeSetupMutation>;
export type UpdateUserDidSkipStripeSetupMutationOptions = Apollo.BaseMutationOptions<UpdateUserDidSkipStripeSetupMutation, UpdateUserDidSkipStripeSetupMutationVariables>;
export const GetCoachAllPlayersReflectionsDocument = gql`
    query getCoachAllPlayersReflections($coachId: uuid!) {
  lessons(
    where: {ownerUserId: {_eq: $coachId}, times: {startDateTime: {_lt: "now()"}}, participantsAggregate: {count: {predicate: {_gt: 0}}}}
    orderBy: {endDateTime: DESC}
  ) {
    endDateTime
    id
    title
    type
    venue {
      addressString
    }
    userCustomCourt {
      fullAddress
    }
    times {
      startDateTime
      endDateTime
    }
    ownerProfile {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    participants(where: {userId: {_neq: $coachId}}) {
      id
      userId
      recapSkippedAt
      userProfile {
        id
        profileImageProvider
        profileImagePath
        profileImageFileName
        profileImageProviderUrl
        fullName
      }
    }
    lessonReflections(where: {coachUserId: {_eq: $coachId}}) {
      createdAt
      details
      id
      lessonId
      submissionRequestedFeedback
      updatedAt
      reviewStatus
      upcomingCategory
      upcomingSport
      completedCategory
      completedSport
      files {
        createdAt
        fileCategory
        fileFormat
        fileName
        fileType
        host
        id
        provider
        providerId
        providerUrl
        url
        userId
        originalFileName
      }
      lessonReflectionComments {
        createdAt
        id
        order
        sentiment
        skill
        customSkill
        updatedAt
        details
        type
        lessonReflectionFiles {
          createdAt
          fileCategory
          fileFormat
          fileName
          fileType
          host
          id
          provider
          providerId
          providerUrl
          url
          userId
          originalFileName
        }
      }
      lessonPlayer {
        id
        fullName
        profileImageProviderUrl
        profileImageFileName
      }
      lessonCoach {
        id
        fullName
        profileImageProviderUrl
        profileImageFileName
      }
    }
  }
  lessonReflections(
    where: {coachUserId: {_eq: $coachId}, lesson: {times: {startDateTime: {_lt: "now()"}}}}
  ) {
    createdAt
    details
    id
    lessonId
    submissionRequestedFeedback
    updatedAt
    reviewStatus
    lessonPlayer {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    lessonCoach {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    lessonReflectionComments {
      createdAt
      id
      order
      sentiment
      skill
      customSkill
      updatedAt
      lessonReflectionFiles {
        createdAt
        fileCategory
        fileFormat
        fileName
        fileType
        host
        id
        provider
        providerId
        providerUrl
        url
        userId
        originalFileName
      }
    }
  }
}
    `;

/**
 * __useGetCoachAllPlayersReflectionsQuery__
 *
 * To run a query within a React component, call `useGetCoachAllPlayersReflectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachAllPlayersReflectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachAllPlayersReflectionsQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *   },
 * });
 */
export function useGetCoachAllPlayersReflectionsQuery(baseOptions: Apollo.QueryHookOptions<GetCoachAllPlayersReflectionsQuery, GetCoachAllPlayersReflectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachAllPlayersReflectionsQuery, GetCoachAllPlayersReflectionsQueryVariables>(GetCoachAllPlayersReflectionsDocument, options);
      }
export function useGetCoachAllPlayersReflectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachAllPlayersReflectionsQuery, GetCoachAllPlayersReflectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachAllPlayersReflectionsQuery, GetCoachAllPlayersReflectionsQueryVariables>(GetCoachAllPlayersReflectionsDocument, options);
        }
export type GetCoachAllPlayersReflectionsQueryHookResult = ReturnType<typeof useGetCoachAllPlayersReflectionsQuery>;
export type GetCoachAllPlayersReflectionsLazyQueryHookResult = ReturnType<typeof useGetCoachAllPlayersReflectionsLazyQuery>;
export type GetCoachAllPlayersReflectionsQueryResult = Apollo.QueryResult<GetCoachAllPlayersReflectionsQuery, GetCoachAllPlayersReflectionsQueryVariables>;
export const GetCoachAllPlayersVideoAnalysisDocument = gql`
    query getCoachAllPlayersVideoAnalysis($reviewerId: uuid!) {
  videoAnalysis(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, reviewStatus: {_nin: [REVIEWED, COMPLETE]}, reviewerUserId: {_eq: $reviewerId}}
    orderBy: {createdAt: DESC}
  ) {
    id
    submissionRequestedFeedback
    reviewStatus
    videoAnalysisComments {
      videoAnalysisSkillsComments {
        videoLessonSkills {
          skill
          customSkill
        }
        videoAnalysisComments {
          details
          id
        }
      }
      sentiment
      id
    }
    videoAnalysisFiles {
      id
      host
      fileType
      fileName
      fileFormat
      fileCategory
      createdAt
      originalFileName
      provider
      providerId
      providerUrl
      updatedAt
      url
    }
    videoAnalysisRequestedSkillsReviews {
      id
      videoLessonSkills {
        customSkill
        id
        skill
      }
    }
    createdAt
    videoAnalysisSubmission {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    videoAnalysisReviewer {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
  }
  videoAnalysisAggregate(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, reviewerUserId: {_eq: $reviewerId}}
  ) {
    aggregate {
      count
    }
  }
  pendingVideoAnalysisCount: videoAnalysisAggregate(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, reviewerUserId: {_eq: $reviewerId}, reviewStatus: {_eq: PENDING}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetCoachAllPlayersVideoAnalysisQuery__
 *
 * To run a query within a React component, call `useGetCoachAllPlayersVideoAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachAllPlayersVideoAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachAllPlayersVideoAnalysisQuery({
 *   variables: {
 *      reviewerId: // value for 'reviewerId'
 *   },
 * });
 */
export function useGetCoachAllPlayersVideoAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetCoachAllPlayersVideoAnalysisQuery, GetCoachAllPlayersVideoAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachAllPlayersVideoAnalysisQuery, GetCoachAllPlayersVideoAnalysisQueryVariables>(GetCoachAllPlayersVideoAnalysisDocument, options);
      }
export function useGetCoachAllPlayersVideoAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachAllPlayersVideoAnalysisQuery, GetCoachAllPlayersVideoAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachAllPlayersVideoAnalysisQuery, GetCoachAllPlayersVideoAnalysisQueryVariables>(GetCoachAllPlayersVideoAnalysisDocument, options);
        }
export type GetCoachAllPlayersVideoAnalysisQueryHookResult = ReturnType<typeof useGetCoachAllPlayersVideoAnalysisQuery>;
export type GetCoachAllPlayersVideoAnalysisLazyQueryHookResult = ReturnType<typeof useGetCoachAllPlayersVideoAnalysisLazyQuery>;
export type GetCoachAllPlayersVideoAnalysisQueryResult = Apollo.QueryResult<GetCoachAllPlayersVideoAnalysisQuery, GetCoachAllPlayersVideoAnalysisQueryVariables>;
export const SkipReflectionDocument = gql`
    mutation skipReflection($userId: uuid!, $lessonId: uuid!) {
  updateLessonParticipants(
    where: {userId: {_eq: $userId}, lessonId: {_eq: $lessonId}}
    _set: {recapSkippedAt: "now()"}
  ) {
    returning {
      id
    }
  }
}
    `;
export type SkipReflectionMutationFn = Apollo.MutationFunction<SkipReflectionMutation, SkipReflectionMutationVariables>;

/**
 * __useSkipReflectionMutation__
 *
 * To run a mutation, you first call `useSkipReflectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipReflectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipReflectionMutation, { data, loading, error }] = useSkipReflectionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useSkipReflectionMutation(baseOptions?: Apollo.MutationHookOptions<SkipReflectionMutation, SkipReflectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipReflectionMutation, SkipReflectionMutationVariables>(SkipReflectionDocument, options);
      }
export type SkipReflectionMutationHookResult = ReturnType<typeof useSkipReflectionMutation>;
export type SkipReflectionMutationResult = Apollo.MutationResult<SkipReflectionMutation>;
export type SkipReflectionMutationOptions = Apollo.BaseMutationOptions<SkipReflectionMutation, SkipReflectionMutationVariables>;
export const GetCoachPremiumContentDocument = gql`
    query getCoachPremiumContent($coachId: uuid!) {
  userContentFiles(where: {userId: {_eq: $coachId}}, orderBy: {createdAt: DESC}) {
    createdAt
    description
    fileCategory
    fileFormat
    fileName
    fileType
    host
    id
    originalFileName
    provider
    providerId
    providerUrl
    tier
    title
    url
    user {
      id
      username
      fullName
      profileImageFileName
      profileImagePath
      profileImageProvider
      profileImageProviderUrl
    }
    userContentFilesSkills {
      userContentSkills {
        skill
        customSkill
        id
        userId
      }
    }
  }
  userProfiles(where: {id: {_eq: $coachId}}) {
    id
    priceUnitAmountPremiumContentDefault
    premiumContentDescription
    profileImageProviderUrl
    fullName
    username
    stripeMerchantCurrency
    currencyCoachDefault
  }
  userContentBetaSubscriptions(where: {ownerUserId: {_eq: $coachId}}) {
    id
    subscriberUserId
    createdAt
  }
}
    `;

/**
 * __useGetCoachPremiumContentQuery__
 *
 * To run a query within a React component, call `useGetCoachPremiumContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachPremiumContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachPremiumContentQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *   },
 * });
 */
export function useGetCoachPremiumContentQuery(baseOptions: Apollo.QueryHookOptions<GetCoachPremiumContentQuery, GetCoachPremiumContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachPremiumContentQuery, GetCoachPremiumContentQueryVariables>(GetCoachPremiumContentDocument, options);
      }
export function useGetCoachPremiumContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachPremiumContentQuery, GetCoachPremiumContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachPremiumContentQuery, GetCoachPremiumContentQueryVariables>(GetCoachPremiumContentDocument, options);
        }
export type GetCoachPremiumContentQueryHookResult = ReturnType<typeof useGetCoachPremiumContentQuery>;
export type GetCoachPremiumContentLazyQueryHookResult = ReturnType<typeof useGetCoachPremiumContentLazyQuery>;
export type GetCoachPremiumContentQueryResult = Apollo.QueryResult<GetCoachPremiumContentQuery, GetCoachPremiumContentQueryVariables>;
export const UpdateCoachPremiumCoachDocument = gql`
    mutation updateCoachPremiumCoach($coachId: uuid!, $premiumContentDescription: String, $priceUnitAmountPremiumContentDefault: Int) {
  updateUsersByPk(
    pkColumns: {id: $coachId}
    _set: {premiumContentDescription: $premiumContentDescription, priceUnitAmountPremiumContentDefault: $priceUnitAmountPremiumContentDefault}
  ) {
    priceUnitAmountPremiumContentDefault
    premiumContentDescription
    id
  }
}
    `;
export type UpdateCoachPremiumCoachMutationFn = Apollo.MutationFunction<UpdateCoachPremiumCoachMutation, UpdateCoachPremiumCoachMutationVariables>;

/**
 * __useUpdateCoachPremiumCoachMutation__
 *
 * To run a mutation, you first call `useUpdateCoachPremiumCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachPremiumCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachPremiumCoachMutation, { data, loading, error }] = useUpdateCoachPremiumCoachMutation({
 *   variables: {
 *      coachId: // value for 'coachId'
 *      premiumContentDescription: // value for 'premiumContentDescription'
 *      priceUnitAmountPremiumContentDefault: // value for 'priceUnitAmountPremiumContentDefault'
 *   },
 * });
 */
export function useUpdateCoachPremiumCoachMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoachPremiumCoachMutation, UpdateCoachPremiumCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoachPremiumCoachMutation, UpdateCoachPremiumCoachMutationVariables>(UpdateCoachPremiumCoachDocument, options);
      }
export type UpdateCoachPremiumCoachMutationHookResult = ReturnType<typeof useUpdateCoachPremiumCoachMutation>;
export type UpdateCoachPremiumCoachMutationResult = Apollo.MutationResult<UpdateCoachPremiumCoachMutation>;
export type UpdateCoachPremiumCoachMutationOptions = Apollo.BaseMutationOptions<UpdateCoachPremiumCoachMutation, UpdateCoachPremiumCoachMutationVariables>;
export const GetCoachPremiumContentForPlayerDocument = gql`
    query getCoachPremiumContentForPlayer($coachId: uuid!, $tier: [UserContentTiersEnum!]!, $playerId: uuid!) {
  userProfiles(where: {id: {_eq: $coachId}}) {
    id
    priceUnitAmountPremiumContentDefault
    premiumContentDescription
    stripeMerchantCurrency
    currencyCoachDefault
  }
  userContentFiles(where: {userId: {_eq: $coachId}, tier: {_in: $tier}}) {
    createdAt
    description
    fileCategory
    fileFormat
    fileName
    fileType
    host
    id
    originalFileName
    provider
    providerId
    providerUrl
    tier
    title
    url
    user {
      id
      username
      fullName
      profileImageFileName
      profileImagePath
      profileImageProvider
      profileImageProviderUrl
    }
    userContentFilesSkills {
      userContentSkills {
        skill
        customSkill
        id
        userId
      }
    }
  }
  userContentBetaSubscriptions(
    where: {ownerUserId: {_eq: $coachId}, subscriberUserId: {_eq: $playerId}}
  ) {
    id
    createdAt
  }
  mySubscriptions: userContentBetaSubscriptions(
    where: {subscriberUserId: {_eq: $playerId}}
  ) {
    id
    ownerProfile {
      id
      username
      profileImagePath
      profileImageFileName
      profileImageProvider
      profileImageProviderUrl
      fullName
      stripeMerchantCurrency
      currencyCoachDefault
    }
  }
}
    `;

/**
 * __useGetCoachPremiumContentForPlayerQuery__
 *
 * To run a query within a React component, call `useGetCoachPremiumContentForPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachPremiumContentForPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachPremiumContentForPlayerQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *      tier: // value for 'tier'
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function useGetCoachPremiumContentForPlayerQuery(baseOptions: Apollo.QueryHookOptions<GetCoachPremiumContentForPlayerQuery, GetCoachPremiumContentForPlayerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachPremiumContentForPlayerQuery, GetCoachPremiumContentForPlayerQueryVariables>(GetCoachPremiumContentForPlayerDocument, options);
      }
export function useGetCoachPremiumContentForPlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachPremiumContentForPlayerQuery, GetCoachPremiumContentForPlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachPremiumContentForPlayerQuery, GetCoachPremiumContentForPlayerQueryVariables>(GetCoachPremiumContentForPlayerDocument, options);
        }
export type GetCoachPremiumContentForPlayerQueryHookResult = ReturnType<typeof useGetCoachPremiumContentForPlayerQuery>;
export type GetCoachPremiumContentForPlayerLazyQueryHookResult = ReturnType<typeof useGetCoachPremiumContentForPlayerLazyQuery>;
export type GetCoachPremiumContentForPlayerQueryResult = Apollo.QueryResult<GetCoachPremiumContentForPlayerQuery, GetCoachPremiumContentForPlayerQueryVariables>;
export const GetUserContentByIdDocument = gql`
    query getUserContentById($contentId: uuid!) {
  userContentFiles(where: {id: {_eq: $contentId}}) {
    createdAt
    description
    fileCategory
    fileFormat
    fileName
    fileType
    host
    id
    originalFileName
    provider
    providerId
    providerUrl
    tier
    title
    url
    user {
      id
      username
      fullName
      profileImageFileName
      profileImagePath
      profileImageProvider
      profileImageProviderUrl
    }
    userContentFilesSkills {
      userContentSkills {
        skill
        customSkill
        id
        userId
      }
    }
  }
}
    `;

/**
 * __useGetUserContentByIdQuery__
 *
 * To run a query within a React component, call `useGetUserContentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserContentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserContentByIdQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetUserContentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserContentByIdQuery, GetUserContentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserContentByIdQuery, GetUserContentByIdQueryVariables>(GetUserContentByIdDocument, options);
      }
export function useGetUserContentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserContentByIdQuery, GetUserContentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserContentByIdQuery, GetUserContentByIdQueryVariables>(GetUserContentByIdDocument, options);
        }
export type GetUserContentByIdQueryHookResult = ReturnType<typeof useGetUserContentByIdQuery>;
export type GetUserContentByIdLazyQueryHookResult = ReturnType<typeof useGetUserContentByIdLazyQuery>;
export type GetUserContentByIdQueryResult = Apollo.QueryResult<GetUserContentByIdQuery, GetUserContentByIdQueryVariables>;
export const GetCoachPremiumContentForAnonymousUserDocument = gql`
    query getCoachPremiumContentForAnonymousUser($coachId: uuid!) {
  userContentFiles(where: {userId: {_eq: $coachId}}) {
    createdAt
    description
    fileCategory
    fileFormat
    fileName
    fileType
    host
    id
    originalFileName
    provider
    providerId
    providerUrl
    tier
    title
    url
    user {
      id
      username
      fullName
      profileImageFileName
      profileImagePath
      profileImageProvider
      profileImageProviderUrl
    }
    userContentFilesSkills {
      userContentSkills {
        skill
        customSkill
        id
        userId
      }
    }
  }
  userProfiles(where: {id: {_eq: $coachId}}) {
    id
    priceUnitAmountPremiumContentDefault
    premiumContentDescription
    profileImageProviderUrl
    fullName
    username
    stripeMerchantCurrency
    currencyCoachDefault
  }
}
    `;

/**
 * __useGetCoachPremiumContentForAnonymousUserQuery__
 *
 * To run a query within a React component, call `useGetCoachPremiumContentForAnonymousUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachPremiumContentForAnonymousUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachPremiumContentForAnonymousUserQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *   },
 * });
 */
export function useGetCoachPremiumContentForAnonymousUserQuery(baseOptions: Apollo.QueryHookOptions<GetCoachPremiumContentForAnonymousUserQuery, GetCoachPremiumContentForAnonymousUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachPremiumContentForAnonymousUserQuery, GetCoachPremiumContentForAnonymousUserQueryVariables>(GetCoachPremiumContentForAnonymousUserDocument, options);
      }
export function useGetCoachPremiumContentForAnonymousUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachPremiumContentForAnonymousUserQuery, GetCoachPremiumContentForAnonymousUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachPremiumContentForAnonymousUserQuery, GetCoachPremiumContentForAnonymousUserQueryVariables>(GetCoachPremiumContentForAnonymousUserDocument, options);
        }
export type GetCoachPremiumContentForAnonymousUserQueryHookResult = ReturnType<typeof useGetCoachPremiumContentForAnonymousUserQuery>;
export type GetCoachPremiumContentForAnonymousUserLazyQueryHookResult = ReturnType<typeof useGetCoachPremiumContentForAnonymousUserLazyQuery>;
export type GetCoachPremiumContentForAnonymousUserQueryResult = Apollo.QueryResult<GetCoachPremiumContentForAnonymousUserQuery, GetCoachPremiumContentForAnonymousUserQueryVariables>;
export const GetPlayerSubscribersDocument = gql`
    query getPlayerSubscribers($playerId: uuid!) {
  mySubscriptions: userContentBetaSubscriptions(
    where: {subscriberUserId: {_eq: $playerId}}
  ) {
    id
    ownerProfile {
      id
      username
      profileImagePath
      profileImageFileName
      profileImageProvider
      profileImageProviderUrl
      fullName
      stripeMerchantCurrency
      currencyCoachDefault
    }
  }
}
    `;

/**
 * __useGetPlayerSubscribersQuery__
 *
 * To run a query within a React component, call `useGetPlayerSubscribersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerSubscribersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerSubscribersQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function useGetPlayerSubscribersQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerSubscribersQuery, GetPlayerSubscribersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerSubscribersQuery, GetPlayerSubscribersQueryVariables>(GetPlayerSubscribersDocument, options);
      }
export function useGetPlayerSubscribersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerSubscribersQuery, GetPlayerSubscribersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerSubscribersQuery, GetPlayerSubscribersQueryVariables>(GetPlayerSubscribersDocument, options);
        }
export type GetPlayerSubscribersQueryHookResult = ReturnType<typeof useGetPlayerSubscribersQuery>;
export type GetPlayerSubscribersLazyQueryHookResult = ReturnType<typeof useGetPlayerSubscribersLazyQuery>;
export type GetPlayerSubscribersQueryResult = Apollo.QueryResult<GetPlayerSubscribersQuery, GetPlayerSubscribersQueryVariables>;
export const UpdateCoachPremiumContentDocument = gql`
    mutation updateCoachPremiumContent($id: uuid!, $skills: [UserContentFilesSkillsInsertInput!]!, $description: String!, $fileName: String!, $fileType: String!, $host: String!, $fileFormat: FileFormatEnum!, $originalFileName: String!, $provider: String!, $providerUrl: String!, $providerId: String!, $title: String!, $url: String!, $tier: UserContentTiersEnum!) {
  deleteUserContentFilesSkills(where: {userContentFileId: {_eq: $id}}) {
    returning {
      id
    }
  }
  insertUserContentFilesSkills(
    objects: $skills
    onConflict: {constraint: user_content_files_skills_pkey}
  ) {
    returning {
      id
    }
  }
  updateUserContentFilesByPk(
    pkColumns: {id: $id}
    _set: {description: $description, fileCategory: COACH, fileFormat: $fileFormat, fileName: $fileName, fileType: $fileType, host: $host, originalFileName: $originalFileName, provider: $provider, providerUrl: $providerUrl, providerId: $providerId, tier: $tier, title: $title, url: $url}
  ) {
    id
  }
}
    `;
export type UpdateCoachPremiumContentMutationFn = Apollo.MutationFunction<UpdateCoachPremiumContentMutation, UpdateCoachPremiumContentMutationVariables>;

/**
 * __useUpdateCoachPremiumContentMutation__
 *
 * To run a mutation, you first call `useUpdateCoachPremiumContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachPremiumContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachPremiumContentMutation, { data, loading, error }] = useUpdateCoachPremiumContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      skills: // value for 'skills'
 *      description: // value for 'description'
 *      fileName: // value for 'fileName'
 *      fileType: // value for 'fileType'
 *      host: // value for 'host'
 *      fileFormat: // value for 'fileFormat'
 *      originalFileName: // value for 'originalFileName'
 *      provider: // value for 'provider'
 *      providerUrl: // value for 'providerUrl'
 *      providerId: // value for 'providerId'
 *      title: // value for 'title'
 *      url: // value for 'url'
 *      tier: // value for 'tier'
 *   },
 * });
 */
export function useUpdateCoachPremiumContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoachPremiumContentMutation, UpdateCoachPremiumContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoachPremiumContentMutation, UpdateCoachPremiumContentMutationVariables>(UpdateCoachPremiumContentDocument, options);
      }
export type UpdateCoachPremiumContentMutationHookResult = ReturnType<typeof useUpdateCoachPremiumContentMutation>;
export type UpdateCoachPremiumContentMutationResult = Apollo.MutationResult<UpdateCoachPremiumContentMutation>;
export type UpdateCoachPremiumContentMutationOptions = Apollo.BaseMutationOptions<UpdateCoachPremiumContentMutation, UpdateCoachPremiumContentMutationVariables>;
export const GetCoachesByGeoDocument = gql`
    query getCoachesByGeo($distance: Float!, $from: geography!, $limit: Int = 1000) {
  userProfiles(
    where: {coachStatus: {_eq: "ACTIVE"}, geometry: {_stDWithin: {distance: $distance, from: $from}}}
    limit: $limit
  ) {
    id
    fullName
    priceUnitAmountRemoteCoachDefault
    priceUnitAmountCoachDefault
    profileImageFileName
    profileImagePath
    profileImageProvider
    profileImageProviderUrl
    preferredName
    username
    defaultSport
    geometry
    isPprMember
    isPciMember
    priceUnitAmountCoachDefault
    isProfessionalRacquetRegistryActive
    gender
    stripeMerchantChargesEnabled
    coachReviewsAggregate {
      aggregate {
        count
        avg {
          rating
        }
      }
    }
    coachLessonsAggregate {
      aggregate {
        count
      }
    }
    coachSports {
      sport
    }
    coachLessonSkillLevels {
      skillLevel
    }
    coachLessonAgeGroups {
      lessonAgeGroup
    }
    stripeMerchantCurrency
    currencyCoachDefault
    coachAvailability {
      id
      status
    }
    defaultCoachVenue {
      addressString
      id
    }
    defaultCoachCustomCourt {
      title
      id
      fullAddress
    }
    followersAggregate {
      aggregate {
        count
      }
    }
  }
  coachStarterProfiles(
    where: {geometry: {_stDWithin: {distance: $distance, from: $from}}, type: {_eq: "instructor"}}
    limit: 1000
  ) {
    id
    name
    profileImageUrl
    aboutPhotoImageUrl
    logoImageUrl
    geometry
  }
}
    `;

/**
 * __useGetCoachesByGeoQuery__
 *
 * To run a query within a React component, call `useGetCoachesByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachesByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachesByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCoachesByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetCoachesByGeoQuery, GetCoachesByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachesByGeoQuery, GetCoachesByGeoQueryVariables>(GetCoachesByGeoDocument, options);
      }
export function useGetCoachesByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachesByGeoQuery, GetCoachesByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachesByGeoQuery, GetCoachesByGeoQueryVariables>(GetCoachesByGeoDocument, options);
        }
export type GetCoachesByGeoQueryHookResult = ReturnType<typeof useGetCoachesByGeoQuery>;
export type GetCoachesByGeoLazyQueryHookResult = ReturnType<typeof useGetCoachesByGeoLazyQuery>;
export type GetCoachesByGeoQueryResult = Apollo.QueryResult<GetCoachesByGeoQuery, GetCoachesByGeoQueryVariables>;
export const GetFollowedCoachesDocument = gql`
    query getFollowedCoaches($userId: uuid!) {
  userProfiles(
    where: {coachStatus: {_eq: "ACTIVE"}, followers: {followerUserId: {_eq: $userId}, status: {_eq: ACTIVE}}}
    limit: 20
  ) {
    id
    fullName
    priceUnitAmountCoachDefault
    priceUnitAmountRemoteCoachDefault
    profileImageFileName
    profileImagePath
    profileImageProvider
    profileImageProviderUrl
    preferredName
    username
    geometry
    defaultSport
    isPciMember
    stripeMerchantCurrency
    currencyCoachDefault
    stripeMerchantChargesEnabled
    coachAvailability {
      id
      endTimeMinutes
      dayOfWeek
      startTimeMinutes
      status
      coachAvailabilityCustomCourt {
        id
      }
      coachAvailabilityVenueId {
        id
      }
    }
    coachLessons(where: {startDateTime: {_gte: "NOW()"}}) {
      id
      ownerUserId
      startDateTime
      endDateTime
      timezoneName
      timezoneAbbreviation
      timezoneOffsetMinutes
      participantLimit
      currency
    }
    coachExternalBookingUrl
    defaultCoachVenue {
      addressString
      id
    }
    defaultCoachCustomCourt {
      title
      id
      fullAddress
    }
    followersAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetFollowedCoachesQuery__
 *
 * To run a query within a React component, call `useGetFollowedCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFollowedCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFollowedCoachesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetFollowedCoachesQuery(baseOptions: Apollo.QueryHookOptions<GetFollowedCoachesQuery, GetFollowedCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFollowedCoachesQuery, GetFollowedCoachesQueryVariables>(GetFollowedCoachesDocument, options);
      }
export function useGetFollowedCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFollowedCoachesQuery, GetFollowedCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFollowedCoachesQuery, GetFollowedCoachesQueryVariables>(GetFollowedCoachesDocument, options);
        }
export type GetFollowedCoachesQueryHookResult = ReturnType<typeof useGetFollowedCoachesQuery>;
export type GetFollowedCoachesLazyQueryHookResult = ReturnType<typeof useGetFollowedCoachesLazyQuery>;
export type GetFollowedCoachesQueryResult = Apollo.QueryResult<GetFollowedCoachesQuery, GetFollowedCoachesQueryVariables>;
export const GetRemoteCoachesByGeoDocument = gql`
    query getRemoteCoachesByGeo($limit: Int = 1000) {
  userProfiles(
    where: {coachStatus: {_eq: "ACTIVE"}, stripeMerchantDetailsSubmitted: {_eq: true}, priceUnitAmountRemoteCoachDefault: {_isNull: false, _gt: 0}}
    orderBy: {followersAggregate: {count: DESC}}
    limit: $limit
  ) {
    id
    fullName
    priceUnitAmountRemoteCoachDefault
    priceUnitAmountCoachDefault
    profileImageFileName
    profileImagePath
    profileImageProvider
    profileImageProviderUrl
    preferredName
    username
    defaultSport
    geometry
    isPciMember
    stripeMerchantCurrency
    currencyCoachDefault
    coachAvailability {
      id
    }
    defaultCoachVenue {
      addressString
      id
    }
    defaultCoachCustomCourt {
      title
      id
      fullAddress
    }
    followersAggregate(where: {status: {_eq: ACTIVE}}) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetRemoteCoachesByGeoQuery__
 *
 * To run a query within a React component, call `useGetRemoteCoachesByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemoteCoachesByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemoteCoachesByGeoQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRemoteCoachesByGeoQuery(baseOptions?: Apollo.QueryHookOptions<GetRemoteCoachesByGeoQuery, GetRemoteCoachesByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRemoteCoachesByGeoQuery, GetRemoteCoachesByGeoQueryVariables>(GetRemoteCoachesByGeoDocument, options);
      }
export function useGetRemoteCoachesByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRemoteCoachesByGeoQuery, GetRemoteCoachesByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRemoteCoachesByGeoQuery, GetRemoteCoachesByGeoQueryVariables>(GetRemoteCoachesByGeoDocument, options);
        }
export type GetRemoteCoachesByGeoQueryHookResult = ReturnType<typeof useGetRemoteCoachesByGeoQuery>;
export type GetRemoteCoachesByGeoLazyQueryHookResult = ReturnType<typeof useGetRemoteCoachesByGeoLazyQuery>;
export type GetRemoteCoachesByGeoQueryResult = Apollo.QueryResult<GetRemoteCoachesByGeoQuery, GetRemoteCoachesByGeoQueryVariables>;
export const GetGroupThreadByIdDocument = gql`
    query getGroupThreadById($id: uuid!, $userId: uuid!) {
  groupThreadsByPk(id: $id) {
    group {
      id
      title
      isPrivate
    }
    comments(orderBy: {createdAt: ASC}) {
      content
      createdAt
      groupCommentId
      groupRootCommentId
      id
      isOriginalThreadComment
      updatedAt
      userId
      userProfile {
        id
        fullName
        preferredName
        profileImagePath
        username
      }
      votesAggregate(where: {vote: {_eq: POSITIVE}}) {
        aggregate {
          count
        }
      }
      votes(where: {userId: {_eq: $userId}}) {
        id
        userId
        groupThreadCommentId
        vote
      }
      files {
        id
        url
        path
      }
    }
  }
}
    `;

/**
 * __useGetGroupThreadByIdQuery__
 *
 * To run a query within a React component, call `useGetGroupThreadByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupThreadByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupThreadByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetGroupThreadByIdQuery(baseOptions: Apollo.QueryHookOptions<GetGroupThreadByIdQuery, GetGroupThreadByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupThreadByIdQuery, GetGroupThreadByIdQueryVariables>(GetGroupThreadByIdDocument, options);
      }
export function useGetGroupThreadByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupThreadByIdQuery, GetGroupThreadByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupThreadByIdQuery, GetGroupThreadByIdQueryVariables>(GetGroupThreadByIdDocument, options);
        }
export type GetGroupThreadByIdQueryHookResult = ReturnType<typeof useGetGroupThreadByIdQuery>;
export type GetGroupThreadByIdLazyQueryHookResult = ReturnType<typeof useGetGroupThreadByIdLazyQuery>;
export type GetGroupThreadByIdQueryResult = Apollo.QueryResult<GetGroupThreadByIdQuery, GetGroupThreadByIdQueryVariables>;
export const InsertGroupThreadCommentDocument = gql`
    mutation insertGroupThreadComment($userId: uuid!, $groupThreadId: uuid!, $content: String!, $groupCommentId: uuid, $groupRootCommentId: uuid) {
  insertGroupThreadCommentsOne(
    object: {userId: $userId, groupThreadId: $groupThreadId, content: $content, groupCommentId: $groupCommentId, groupRootCommentId: $groupRootCommentId, isOriginalThreadComment: false, votes: {data: {userId: $userId, vote: POSITIVE}}}
  ) {
    id
    groupThreadId
    content
  }
}
    `;
export type InsertGroupThreadCommentMutationFn = Apollo.MutationFunction<InsertGroupThreadCommentMutation, InsertGroupThreadCommentMutationVariables>;

/**
 * __useInsertGroupThreadCommentMutation__
 *
 * To run a mutation, you first call `useInsertGroupThreadCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertGroupThreadCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertGroupThreadCommentMutation, { data, loading, error }] = useInsertGroupThreadCommentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      groupThreadId: // value for 'groupThreadId'
 *      content: // value for 'content'
 *      groupCommentId: // value for 'groupCommentId'
 *      groupRootCommentId: // value for 'groupRootCommentId'
 *   },
 * });
 */
export function useInsertGroupThreadCommentMutation(baseOptions?: Apollo.MutationHookOptions<InsertGroupThreadCommentMutation, InsertGroupThreadCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertGroupThreadCommentMutation, InsertGroupThreadCommentMutationVariables>(InsertGroupThreadCommentDocument, options);
      }
export type InsertGroupThreadCommentMutationHookResult = ReturnType<typeof useInsertGroupThreadCommentMutation>;
export type InsertGroupThreadCommentMutationResult = Apollo.MutationResult<InsertGroupThreadCommentMutation>;
export type InsertGroupThreadCommentMutationOptions = Apollo.BaseMutationOptions<InsertGroupThreadCommentMutation, InsertGroupThreadCommentMutationVariables>;
export const GetGroupThreadByIdAnonymousDocument = gql`
    query getGroupThreadByIdAnonymous($id: uuid!) {
  groupThreadsByPk(id: $id) {
    id
    group {
      id
      title
      isPrivate
    }
    comments(orderBy: {createdAt: ASC}) {
      content
      createdAt
      groupCommentId
      groupRootCommentId
      id
      isOriginalThreadComment
      updatedAt
      userId
      userProfile {
        id
        fullName
        preferredName
        profileImagePath
        username
      }
      votesAggregate(where: {vote: {_eq: POSITIVE}}) {
        aggregate {
          count
        }
      }
      files {
        id
        url
        path
      }
    }
  }
}
    `;

/**
 * __useGetGroupThreadByIdAnonymousQuery__
 *
 * To run a query within a React component, call `useGetGroupThreadByIdAnonymousQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupThreadByIdAnonymousQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupThreadByIdAnonymousQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupThreadByIdAnonymousQuery(baseOptions: Apollo.QueryHookOptions<GetGroupThreadByIdAnonymousQuery, GetGroupThreadByIdAnonymousQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupThreadByIdAnonymousQuery, GetGroupThreadByIdAnonymousQueryVariables>(GetGroupThreadByIdAnonymousDocument, options);
      }
export function useGetGroupThreadByIdAnonymousLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupThreadByIdAnonymousQuery, GetGroupThreadByIdAnonymousQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupThreadByIdAnonymousQuery, GetGroupThreadByIdAnonymousQueryVariables>(GetGroupThreadByIdAnonymousDocument, options);
        }
export type GetGroupThreadByIdAnonymousQueryHookResult = ReturnType<typeof useGetGroupThreadByIdAnonymousQuery>;
export type GetGroupThreadByIdAnonymousLazyQueryHookResult = ReturnType<typeof useGetGroupThreadByIdAnonymousLazyQuery>;
export type GetGroupThreadByIdAnonymousQueryResult = Apollo.QueryResult<GetGroupThreadByIdAnonymousQuery, GetGroupThreadByIdAnonymousQueryVariables>;
export const GetVenuesByGeoDocument = gql`
    query getVenuesByGeo($distance: Float!, $from: geography!, $limit: Int = 1000) {
  venues(
    where: {geometry: {_stDWithin: {distance: $distance, from: $from}}}
    limit: $limit
    orderBy: {geometry: ASC}
  ) {
    id
    title
    geometry
    slug
    pickleballLines
    addressString
    accessType
    indoorCourtCount
    outdoorCourtCount
    pickleballNets
    hasPickleball
    hasTennis
    hasPadel
    images {
      id
      isVisible
      fileName
      path
      provider
      url
    }
    city {
      id
      name
      countrySubdivision {
        id
        name
      }
    }
    courtSurfaces {
      id
      courtSurface
    }
  }
}
    `;

/**
 * __useGetVenuesByGeoQuery__
 *
 * To run a query within a React component, call `useGetVenuesByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenuesByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenuesByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetVenuesByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetVenuesByGeoQuery, GetVenuesByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenuesByGeoQuery, GetVenuesByGeoQueryVariables>(GetVenuesByGeoDocument, options);
      }
export function useGetVenuesByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenuesByGeoQuery, GetVenuesByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenuesByGeoQuery, GetVenuesByGeoQueryVariables>(GetVenuesByGeoDocument, options);
        }
export type GetVenuesByGeoQueryHookResult = ReturnType<typeof useGetVenuesByGeoQuery>;
export type GetVenuesByGeoLazyQueryHookResult = ReturnType<typeof useGetVenuesByGeoLazyQuery>;
export type GetVenuesByGeoQueryResult = Apollo.QueryResult<GetVenuesByGeoQuery, GetVenuesByGeoQueryVariables>;
export const GetCourtPageUpcomingLessonsDocument = gql`
    query GetCourtPageUpcomingLessons($venueId: uuid!, $limit: Int = 50) {
  lessons(
    where: {status: {_eq: ACTIVE}, privacy: {_eq: PUBLIC}, participantLimit: {_gt: 1}, venue: {id: {_eq: $venueId}}, startDateTime: {_gte: "now()"}}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    title
    startDateTime
    endDateTime
    sport
    type
    coverImageProviderUrl
    priceUnitAmount
    currency
    participantLimit
    participants {
      id
      userProfile {
        fullName
        profileImagePath
      }
    }
    ownerProfile {
      fullName
    }
    venue {
      id
      title
      images {
        id
        url
        path
      }
    }
  }
}
    `;

/**
 * __useGetCourtPageUpcomingLessonsQuery__
 *
 * To run a query within a React component, call `useGetCourtPageUpcomingLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourtPageUpcomingLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourtPageUpcomingLessonsQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCourtPageUpcomingLessonsQuery(baseOptions: Apollo.QueryHookOptions<GetCourtPageUpcomingLessonsQuery, GetCourtPageUpcomingLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourtPageUpcomingLessonsQuery, GetCourtPageUpcomingLessonsQueryVariables>(GetCourtPageUpcomingLessonsDocument, options);
      }
export function useGetCourtPageUpcomingLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourtPageUpcomingLessonsQuery, GetCourtPageUpcomingLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourtPageUpcomingLessonsQuery, GetCourtPageUpcomingLessonsQueryVariables>(GetCourtPageUpcomingLessonsDocument, options);
        }
export type GetCourtPageUpcomingLessonsQueryHookResult = ReturnType<typeof useGetCourtPageUpcomingLessonsQuery>;
export type GetCourtPageUpcomingLessonsLazyQueryHookResult = ReturnType<typeof useGetCourtPageUpcomingLessonsLazyQuery>;
export type GetCourtPageUpcomingLessonsQueryResult = Apollo.QueryResult<GetCourtPageUpcomingLessonsQuery, GetCourtPageUpcomingLessonsQueryVariables>;
export const GetCourtPageUpcomingEventsDocument = gql`
    query GetCourtPageUpcomingEvents($venueId: uuid!, $now: timestamptz!, $limit: Int = 50) {
  events(
    where: {venueId: {_eq: $venueId}, archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, status: {_eq: PUBLISHED}, endDateTime: {_gte: $now}}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    title
    slug
    startDateTime
    endDateTime
    groups {
      id
      timeSlots(orderBy: {startsAt: ASC}) {
        id
        startsAt
        endsAt
      }
    }
    sport
    type
    isRfx
    coverImageProviderUrl
    registrationPriceUnitAmount
    currency
    sourceOrganizerTitle
    participantLimit
    externalUrl
    hostUserProfile {
      id
      fullName
    }
    registrationsAggregate {
      aggregate {
        count
      }
    }
    registrations(limit: 5) {
      id
      userProfile {
        id
        fullName
        profileImagePath
      }
    }
    venue {
      id
      title
      images {
        id
        url
        path
      }
    }
  }
}
    `;

/**
 * __useGetCourtPageUpcomingEventsQuery__
 *
 * To run a query within a React component, call `useGetCourtPageUpcomingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourtPageUpcomingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourtPageUpcomingEventsQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      now: // value for 'now'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCourtPageUpcomingEventsQuery(baseOptions: Apollo.QueryHookOptions<GetCourtPageUpcomingEventsQuery, GetCourtPageUpcomingEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourtPageUpcomingEventsQuery, GetCourtPageUpcomingEventsQueryVariables>(GetCourtPageUpcomingEventsDocument, options);
      }
export function useGetCourtPageUpcomingEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourtPageUpcomingEventsQuery, GetCourtPageUpcomingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourtPageUpcomingEventsQuery, GetCourtPageUpcomingEventsQueryVariables>(GetCourtPageUpcomingEventsDocument, options);
        }
export type GetCourtPageUpcomingEventsQueryHookResult = ReturnType<typeof useGetCourtPageUpcomingEventsQuery>;
export type GetCourtPageUpcomingEventsLazyQueryHookResult = ReturnType<typeof useGetCourtPageUpcomingEventsLazyQuery>;
export type GetCourtPageUpcomingEventsQueryResult = Apollo.QueryResult<GetCourtPageUpcomingEventsQuery, GetCourtPageUpcomingEventsQueryVariables>;
export const GetCourtPageV2StaffCoachesDocument = gql`
    query GetCourtPageV2StaffCoaches($venueId: uuid!) {
  venueStaffCoaches(
    where: {_and: [{venueId: {_eq: $venueId}}, {deletedAt: {_isNull: true}}]}
    orderBy: {createdAt: DESC}
  ) {
    id
    userId
    coachProfile {
      ...CourtPageCoachCardFields
    }
  }
}
    ${CourtPageCoachCardFieldsFragmentDoc}`;

/**
 * __useGetCourtPageV2StaffCoachesQuery__
 *
 * To run a query within a React component, call `useGetCourtPageV2StaffCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourtPageV2StaffCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourtPageV2StaffCoachesQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useGetCourtPageV2StaffCoachesQuery(baseOptions: Apollo.QueryHookOptions<GetCourtPageV2StaffCoachesQuery, GetCourtPageV2StaffCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourtPageV2StaffCoachesQuery, GetCourtPageV2StaffCoachesQueryVariables>(GetCourtPageV2StaffCoachesDocument, options);
      }
export function useGetCourtPageV2StaffCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourtPageV2StaffCoachesQuery, GetCourtPageV2StaffCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourtPageV2StaffCoachesQuery, GetCourtPageV2StaffCoachesQueryVariables>(GetCourtPageV2StaffCoachesDocument, options);
        }
export type GetCourtPageV2StaffCoachesQueryHookResult = ReturnType<typeof useGetCourtPageV2StaffCoachesQuery>;
export type GetCourtPageV2StaffCoachesLazyQueryHookResult = ReturnType<typeof useGetCourtPageV2StaffCoachesLazyQuery>;
export type GetCourtPageV2StaffCoachesQueryResult = Apollo.QueryResult<GetCourtPageV2StaffCoachesQuery, GetCourtPageV2StaffCoachesQueryVariables>;
export const GetCourtPageV2AvailabilityCoachesDocument = gql`
    query GetCourtPageV2AvailabilityCoaches($venueId: uuid!, $excludeUserIds: [uuid!]!) {
  userProfiles(
    where: {coachAvailability: {venueId: {_eq: $venueId}}, coachStatus: {_eq: "ACTIVE"}, id: {_nin: $excludeUserIds}}
  ) {
    ...CourtPageCoachCardFields
  }
}
    ${CourtPageCoachCardFieldsFragmentDoc}`;

/**
 * __useGetCourtPageV2AvailabilityCoachesQuery__
 *
 * To run a query within a React component, call `useGetCourtPageV2AvailabilityCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourtPageV2AvailabilityCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourtPageV2AvailabilityCoachesQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      excludeUserIds: // value for 'excludeUserIds'
 *   },
 * });
 */
export function useGetCourtPageV2AvailabilityCoachesQuery(baseOptions: Apollo.QueryHookOptions<GetCourtPageV2AvailabilityCoachesQuery, GetCourtPageV2AvailabilityCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourtPageV2AvailabilityCoachesQuery, GetCourtPageV2AvailabilityCoachesQueryVariables>(GetCourtPageV2AvailabilityCoachesDocument, options);
      }
export function useGetCourtPageV2AvailabilityCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourtPageV2AvailabilityCoachesQuery, GetCourtPageV2AvailabilityCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourtPageV2AvailabilityCoachesQuery, GetCourtPageV2AvailabilityCoachesQueryVariables>(GetCourtPageV2AvailabilityCoachesDocument, options);
        }
export type GetCourtPageV2AvailabilityCoachesQueryHookResult = ReturnType<typeof useGetCourtPageV2AvailabilityCoachesQuery>;
export type GetCourtPageV2AvailabilityCoachesLazyQueryHookResult = ReturnType<typeof useGetCourtPageV2AvailabilityCoachesLazyQuery>;
export type GetCourtPageV2AvailabilityCoachesQueryResult = Apollo.QueryResult<GetCourtPageV2AvailabilityCoachesQuery, GetCourtPageV2AvailabilityCoachesQueryVariables>;
export const GetCourtPageV2CoachReviewsDocument = gql`
    query GetCourtPageV2CoachReviews($coachUserIds: [uuid!]!, $limit: Int = 50) {
  reviews(
    where: {coachUserId: {_in: $coachUserIds}}
    orderBy: {createdAt: DESC}
    limit: $limit
  ) {
    coach {
      profileImagePath
      profileImageFileName
      profileImageProviderUrl
      profileImageProvider
      id
      username
      fullName
    }
    createdAt
    externalDomain
    externalImageFileName
    externalImageUrl
    externalSource
    externalUrl
    externalFullName
    id
    rating
    review
    reviewer {
      profileImagePath
      profileImageFileName
      profileImageProviderUrl
      profileImageProvider
      id
      username
      fullName
    }
    type
  }
}
    `;

/**
 * __useGetCourtPageV2CoachReviewsQuery__
 *
 * To run a query within a React component, call `useGetCourtPageV2CoachReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourtPageV2CoachReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourtPageV2CoachReviewsQuery({
 *   variables: {
 *      coachUserIds: // value for 'coachUserIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCourtPageV2CoachReviewsQuery(baseOptions: Apollo.QueryHookOptions<GetCourtPageV2CoachReviewsQuery, GetCourtPageV2CoachReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourtPageV2CoachReviewsQuery, GetCourtPageV2CoachReviewsQueryVariables>(GetCourtPageV2CoachReviewsDocument, options);
      }
export function useGetCourtPageV2CoachReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourtPageV2CoachReviewsQuery, GetCourtPageV2CoachReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourtPageV2CoachReviewsQuery, GetCourtPageV2CoachReviewsQueryVariables>(GetCourtPageV2CoachReviewsDocument, options);
        }
export type GetCourtPageV2CoachReviewsQueryHookResult = ReturnType<typeof useGetCourtPageV2CoachReviewsQuery>;
export type GetCourtPageV2CoachReviewsLazyQueryHookResult = ReturnType<typeof useGetCourtPageV2CoachReviewsLazyQuery>;
export type GetCourtPageV2CoachReviewsQueryResult = Apollo.QueryResult<GetCourtPageV2CoachReviewsQuery, GetCourtPageV2CoachReviewsQueryVariables>;
export const UpsertVenueFollowDocument = gql`
    mutation upsertVenueFollow($userId: uuid!, $venueId: uuid!, $status: FollowStatusesEnum!) {
  insertVenueFollowsOne(
    object: {userId: $userId, venueId: $venueId, status: $status}
    onConflict: {constraint: venue_follows_venue_id_user_id_key, updateColumns: status}
  ) {
    status
    id
    userId
    venueId
  }
}
    `;
export type UpsertVenueFollowMutationFn = Apollo.MutationFunction<UpsertVenueFollowMutation, UpsertVenueFollowMutationVariables>;

/**
 * __useUpsertVenueFollowMutation__
 *
 * To run a mutation, you first call `useUpsertVenueFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertVenueFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertVenueFollowMutation, { data, loading, error }] = useUpsertVenueFollowMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      venueId: // value for 'venueId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpsertVenueFollowMutation(baseOptions?: Apollo.MutationHookOptions<UpsertVenueFollowMutation, UpsertVenueFollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertVenueFollowMutation, UpsertVenueFollowMutationVariables>(UpsertVenueFollowDocument, options);
      }
export type UpsertVenueFollowMutationHookResult = ReturnType<typeof useUpsertVenueFollowMutation>;
export type UpsertVenueFollowMutationResult = Apollo.MutationResult<UpsertVenueFollowMutation>;
export type UpsertVenueFollowMutationOptions = Apollo.BaseMutationOptions<UpsertVenueFollowMutation, UpsertVenueFollowMutationVariables>;
export const GetUserVenueFollowDocument = gql`
    query getUserVenueFollow($userId: uuid!, $venueId: uuid!) {
  venueFollows(where: {userId: {_eq: $userId}, venueId: {_eq: $venueId}}) {
    id
    userId
    venueId
    status
  }
}
    `;

/**
 * __useGetUserVenueFollowQuery__
 *
 * To run a query within a React component, call `useGetUserVenueFollowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserVenueFollowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserVenueFollowQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useGetUserVenueFollowQuery(baseOptions: Apollo.QueryHookOptions<GetUserVenueFollowQuery, GetUserVenueFollowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserVenueFollowQuery, GetUserVenueFollowQueryVariables>(GetUserVenueFollowDocument, options);
      }
export function useGetUserVenueFollowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserVenueFollowQuery, GetUserVenueFollowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserVenueFollowQuery, GetUserVenueFollowQueryVariables>(GetUserVenueFollowDocument, options);
        }
export type GetUserVenueFollowQueryHookResult = ReturnType<typeof useGetUserVenueFollowQuery>;
export type GetUserVenueFollowLazyQueryHookResult = ReturnType<typeof useGetUserVenueFollowLazyQuery>;
export type GetUserVenueFollowQueryResult = Apollo.QueryResult<GetUserVenueFollowQuery, GetUserVenueFollowQueryVariables>;
export const GetGamedayByEventIdDocument = gql`
    query getGamedayByEventId($id: uuid!) {
  eventsByPk(id: $id) {
    id
    title
    hostUserId
    isShowCourtAssignments
    isVairRequired
    groups(where: {deletedAt: {_isNull: true}}) {
      id
      title
      winBy
      totalPoints
      teamLimit
      teamType
      startsAt
      endsAt
      timeSlots(where: {deletedAt: {_isNull: true}}, orderBy: {startsAt: ASC}) {
        id
        startsAt
        endsAt
      }
      scoringFormat
      gamesPerMatch
      format
      minimumNumberOfGames
      numberOfEliminationTeams
      numberOfEstimatedCourts
      registrations(orderBy: {createdAt: ASC}, where: {deletedAt: {_isNull: true}}) {
        id
        userId
        createdAt
        userProfile {
          id
          fullName
          preferredName
        }
      }
      teams(where: {deletedAt: {_isNull: true}}) {
        id
        matches(where: {deletedAt: {_isNull: true}}) {
          id
          match {
            id
            roundId
          }
        }
        members(where: {deletedAt: {_isNull: true}, status: {_eq: ACTIVE}}) {
          id
          userId
          userProfile {
            fullName
            id
            preferredName
          }
        }
      }
      sequences(orderBy: {order: ASC}) {
        id
        nextSequenceId
        order
        groupId
        competitionFormat
        completeReason
        isSequenceComplete
        pools {
          id
          title
          startsAt
          endsAt
          rounds(orderBy: {roundOrder: ASC}) {
            id
            roundOrder
            title
            matches(orderBy: {matchOrder: ASC}) {
              courtNumber
              eventCourtId
              court {
                courtName
              }
              id
              matchOrder
              isBye
              isVairScoreSubmitted
              winningTeamId
              losingTeamId
              team1Id
              team2Id
              previousMatch1Id
              previousMatch2Id
              selectionCriteriaPreviousMatch1
              selectionCriteriaPreviousMatch2
              losingTeamId
              winReason
              team1 {
                id
                members(orderBy: {createdAt: ASC}) {
                  id
                  userId
                  status
                  userProfile {
                    id
                    preferredName
                    fullName
                  }
                }
              }
              team2 {
                id
                members(orderBy: {createdAt: ASC}) {
                  id
                  userId
                  status
                  userProfile {
                    id
                    preferredName
                    fullName
                  }
                }
              }
              games {
                id
                scores {
                  id
                  score
                  teamId
                }
                losingTeamId
                team1Id
                team1Score
                team2Id
                team2Score
                winReason
                winningTeamId
              }
            }
          }
        }
        seeding {
          id
          eventTeamId
          seed
        }
      }
      courts {
        id
        updatedAt
        courtNumber
        courtName
        courtStatus
        activeMatchId
        activeMatch {
          id
          teams {
            id
            team {
              id
              members {
                userProfile {
                  id
                  preferredName
                  fullName
                }
              }
            }
          }
        }
      }
    }
    courts {
      id
      updatedAt
      activeMatchId
      courtStatus
      courtNumber
      courtName
      activeEventGroupId
      activeEventGroupPoolId
    }
    titleSponsor: sponsors(limit: 1, where: {isTitleSponsor: {_eq: true}}) {
      id
      categoryName
      imageFileName
      imageFileType
      imageHost
      imagePath
      imageProvider
      imageProviderUrl
      imageUrl
      isTitleSponsor
      name
    }
  }
}
    `;

/**
 * __useGetGamedayByEventIdQuery__
 *
 * To run a query within a React component, call `useGetGamedayByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGamedayByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGamedayByEventIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGamedayByEventIdQuery(baseOptions: Apollo.QueryHookOptions<GetGamedayByEventIdQuery, GetGamedayByEventIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGamedayByEventIdQuery, GetGamedayByEventIdQueryVariables>(GetGamedayByEventIdDocument, options);
      }
export function useGetGamedayByEventIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGamedayByEventIdQuery, GetGamedayByEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGamedayByEventIdQuery, GetGamedayByEventIdQueryVariables>(GetGamedayByEventIdDocument, options);
        }
export type GetGamedayByEventIdQueryHookResult = ReturnType<typeof useGetGamedayByEventIdQuery>;
export type GetGamedayByEventIdLazyQueryHookResult = ReturnType<typeof useGetGamedayByEventIdLazyQuery>;
export type GetGamedayByEventIdQueryResult = Apollo.QueryResult<GetGamedayByEventIdQuery, GetGamedayByEventIdQueryVariables>;
export const AssignCourtToMatchDocument = gql`
    mutation assignCourtToMatch($matchId: uuid!, $courtId: uuid!, $courtNumber: Int!) {
  updateEventMatchesByPk(
    pkColumns: {id: $matchId}
    _set: {eventCourtId: $courtId, courtNumber: $courtNumber}
  ) {
    id
    eventCourtId
    courtNumber
  }
  updateEventCourtsByPk(
    pkColumns: {id: $courtId}
    _set: {activeMatchId: $matchId}
  ) {
    id
    updatedAt
    courtNumber
    courtStatus
    activeMatchId
    activeMatch {
      id
      team1 {
        id
        members(orderBy: {createdAt: ASC}) {
          id
          status
          userProfile {
            id
            preferredName
            fullName
          }
        }
      }
      team2 {
        id
        members(orderBy: {createdAt: ASC}) {
          id
          status
          userProfile {
            id
            preferredName
            fullName
          }
        }
      }
      teams {
        id
        team {
          members {
            userProfile {
              id
              preferredName
              fullName
            }
          }
        }
      }
    }
  }
}
    `;
export type AssignCourtToMatchMutationFn = Apollo.MutationFunction<AssignCourtToMatchMutation, AssignCourtToMatchMutationVariables>;

/**
 * __useAssignCourtToMatchMutation__
 *
 * To run a mutation, you first call `useAssignCourtToMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCourtToMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCourtToMatchMutation, { data, loading, error }] = useAssignCourtToMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      courtId: // value for 'courtId'
 *      courtNumber: // value for 'courtNumber'
 *   },
 * });
 */
export function useAssignCourtToMatchMutation(baseOptions?: Apollo.MutationHookOptions<AssignCourtToMatchMutation, AssignCourtToMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignCourtToMatchMutation, AssignCourtToMatchMutationVariables>(AssignCourtToMatchDocument, options);
      }
export type AssignCourtToMatchMutationHookResult = ReturnType<typeof useAssignCourtToMatchMutation>;
export type AssignCourtToMatchMutationResult = Apollo.MutationResult<AssignCourtToMatchMutation>;
export type AssignCourtToMatchMutationOptions = Apollo.BaseMutationOptions<AssignCourtToMatchMutation, AssignCourtToMatchMutationVariables>;
export const AssignCourtToMatchOnlyDocument = gql`
    mutation assignCourtToMatchOnly($matchId: uuid!, $courtId: uuid!, $courtNumber: Int!) {
  updateEventMatchesByPk(
    pkColumns: {id: $matchId}
    _set: {eventCourtId: $courtId, courtNumber: $courtNumber}
  ) {
    id
    eventCourtId
    courtNumber
  }
}
    `;
export type AssignCourtToMatchOnlyMutationFn = Apollo.MutationFunction<AssignCourtToMatchOnlyMutation, AssignCourtToMatchOnlyMutationVariables>;

/**
 * __useAssignCourtToMatchOnlyMutation__
 *
 * To run a mutation, you first call `useAssignCourtToMatchOnlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCourtToMatchOnlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCourtToMatchOnlyMutation, { data, loading, error }] = useAssignCourtToMatchOnlyMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      courtId: // value for 'courtId'
 *      courtNumber: // value for 'courtNumber'
 *   },
 * });
 */
export function useAssignCourtToMatchOnlyMutation(baseOptions?: Apollo.MutationHookOptions<AssignCourtToMatchOnlyMutation, AssignCourtToMatchOnlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignCourtToMatchOnlyMutation, AssignCourtToMatchOnlyMutationVariables>(AssignCourtToMatchOnlyDocument, options);
      }
export type AssignCourtToMatchOnlyMutationHookResult = ReturnType<typeof useAssignCourtToMatchOnlyMutation>;
export type AssignCourtToMatchOnlyMutationResult = Apollo.MutationResult<AssignCourtToMatchOnlyMutation>;
export type AssignCourtToMatchOnlyMutationOptions = Apollo.BaseMutationOptions<AssignCourtToMatchOnlyMutation, AssignCourtToMatchOnlyMutationVariables>;
export const SetMatchScoresFreeCourtDocument = gql`
    mutation setMatchScoresFreeCourt($losingTeamId: uuid!, $matchId: uuid!, $team1Id: uuid!, $team1Score: numeric!, $team2Id: uuid!, $team2Score: numeric!, $winReason: WinReasonsEnum!, $winningTeamId: uuid!, $data: [EventGameScoresInsertInput!] = [], $courtId: uuid!) {
  insertEventMatchGamesOne(
    object: {losingTeamId: $losingTeamId, matchId: $matchId, team1Id: $team1Id, team1Score: $team1Score, team2Id: $team2Id, team2Score: $team2Score, winReason: $winReason, winningTeamId: $winningTeamId, scores: {data: $data, onConflict: {constraint: event_game_scores_game_id_team_id_key, updateColumns: score}}}
  ) {
    id
    matchId
    team1Score
    team2Score
    team1Id
    team2Id
    winReason
    winningTeamId
    losingTeamId
  }
  updateEventMatchesByPk(
    pkColumns: {id: $matchId}
    _set: {winningTeamId: $winningTeamId, losingTeamId: $losingTeamId, winReason: $winReason}
  ) {
    id
    losingTeamId
    winReason
    winningTeamId
    courtNumber
  }
  updateEventCourtsByPk(pkColumns: {id: $courtId}, _set: {activeMatchId: null}) {
    id
    activeMatchId
  }
}
    `;
export type SetMatchScoresFreeCourtMutationFn = Apollo.MutationFunction<SetMatchScoresFreeCourtMutation, SetMatchScoresFreeCourtMutationVariables>;

/**
 * __useSetMatchScoresFreeCourtMutation__
 *
 * To run a mutation, you first call `useSetMatchScoresFreeCourtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMatchScoresFreeCourtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMatchScoresFreeCourtMutation, { data, loading, error }] = useSetMatchScoresFreeCourtMutation({
 *   variables: {
 *      losingTeamId: // value for 'losingTeamId'
 *      matchId: // value for 'matchId'
 *      team1Id: // value for 'team1Id'
 *      team1Score: // value for 'team1Score'
 *      team2Id: // value for 'team2Id'
 *      team2Score: // value for 'team2Score'
 *      winReason: // value for 'winReason'
 *      winningTeamId: // value for 'winningTeamId'
 *      data: // value for 'data'
 *      courtId: // value for 'courtId'
 *   },
 * });
 */
export function useSetMatchScoresFreeCourtMutation(baseOptions?: Apollo.MutationHookOptions<SetMatchScoresFreeCourtMutation, SetMatchScoresFreeCourtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMatchScoresFreeCourtMutation, SetMatchScoresFreeCourtMutationVariables>(SetMatchScoresFreeCourtDocument, options);
      }
export type SetMatchScoresFreeCourtMutationHookResult = ReturnType<typeof useSetMatchScoresFreeCourtMutation>;
export type SetMatchScoresFreeCourtMutationResult = Apollo.MutationResult<SetMatchScoresFreeCourtMutation>;
export type SetMatchScoresFreeCourtMutationOptions = Apollo.BaseMutationOptions<SetMatchScoresFreeCourtMutation, SetMatchScoresFreeCourtMutationVariables>;
export const SetMatchScoresUpdateNextMatchCourtDocument = gql`
    mutation setMatchScoresUpdateNextMatchCourt($losingTeamId: uuid!, $matchId: uuid!, $team1Id: uuid!, $team1Score: numeric!, $team2Id: uuid!, $team2Score: numeric!, $winReason: WinReasonsEnum!, $winningTeamId: uuid!, $data: [EventGameScoresInsertInput!] = [], $courtId: uuid!, $courtNumber: Int!, $nextMatchId: uuid!) {
  insertEventMatchGamesOne(
    object: {losingTeamId: $losingTeamId, matchId: $matchId, team1Id: $team1Id, team1Score: $team1Score, team2Id: $team2Id, team2Score: $team2Score, winReason: $winReason, winningTeamId: $winningTeamId, scores: {data: $data, onConflict: {constraint: event_game_scores_game_id_team_id_key, updateColumns: score}}}
  ) {
    id
    matchId
    team1Score
    team2Score
    winReason
    winningTeamId
    losingTeamId
  }
  updatePreviousMatch: updateEventMatchesByPk(
    pkColumns: {id: $matchId}
    _set: {winningTeamId: $winningTeamId, losingTeamId: $losingTeamId, winReason: $winReason}
  ) {
    id
    losingTeamId
    winReason
    winningTeamId
    courtNumber
    eventCourtId
  }
  updateNextMatch: updateEventMatchesByPk(
    pkColumns: {id: $nextMatchId}
    _set: {courtNumber: $courtNumber, eventCourtId: $courtId}
  ) {
    id
    losingTeamId
    winReason
    winningTeamId
    courtNumber
    eventCourtId
  }
  updateEventCourtsByPk(
    pkColumns: {id: $courtId}
    _set: {activeMatchId: $nextMatchId}
  ) {
    id
    activeMatchId
  }
}
    `;
export type SetMatchScoresUpdateNextMatchCourtMutationFn = Apollo.MutationFunction<SetMatchScoresUpdateNextMatchCourtMutation, SetMatchScoresUpdateNextMatchCourtMutationVariables>;

/**
 * __useSetMatchScoresUpdateNextMatchCourtMutation__
 *
 * To run a mutation, you first call `useSetMatchScoresUpdateNextMatchCourtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMatchScoresUpdateNextMatchCourtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMatchScoresUpdateNextMatchCourtMutation, { data, loading, error }] = useSetMatchScoresUpdateNextMatchCourtMutation({
 *   variables: {
 *      losingTeamId: // value for 'losingTeamId'
 *      matchId: // value for 'matchId'
 *      team1Id: // value for 'team1Id'
 *      team1Score: // value for 'team1Score'
 *      team2Id: // value for 'team2Id'
 *      team2Score: // value for 'team2Score'
 *      winReason: // value for 'winReason'
 *      winningTeamId: // value for 'winningTeamId'
 *      data: // value for 'data'
 *      courtId: // value for 'courtId'
 *      courtNumber: // value for 'courtNumber'
 *      nextMatchId: // value for 'nextMatchId'
 *   },
 * });
 */
export function useSetMatchScoresUpdateNextMatchCourtMutation(baseOptions?: Apollo.MutationHookOptions<SetMatchScoresUpdateNextMatchCourtMutation, SetMatchScoresUpdateNextMatchCourtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMatchScoresUpdateNextMatchCourtMutation, SetMatchScoresUpdateNextMatchCourtMutationVariables>(SetMatchScoresUpdateNextMatchCourtDocument, options);
      }
export type SetMatchScoresUpdateNextMatchCourtMutationHookResult = ReturnType<typeof useSetMatchScoresUpdateNextMatchCourtMutation>;
export type SetMatchScoresUpdateNextMatchCourtMutationResult = Apollo.MutationResult<SetMatchScoresUpdateNextMatchCourtMutation>;
export type SetMatchScoresUpdateNextMatchCourtMutationOptions = Apollo.BaseMutationOptions<SetMatchScoresUpdateNextMatchCourtMutation, SetMatchScoresUpdateNextMatchCourtMutationVariables>;
export const SetMatchScoresDocument = gql`
    mutation setMatchScores($losingTeamId: uuid!, $matchId: uuid!, $team1Id: uuid!, $team1Score: numeric!, $team2Id: uuid!, $team2Score: numeric!, $winReason: WinReasonsEnum!, $winningTeamId: uuid!, $data: [EventGameScoresInsertInput!] = []) {
  insertEventMatchGamesOne(
    object: {losingTeamId: $losingTeamId, matchId: $matchId, team1Id: $team1Id, team1Score: $team1Score, team2Id: $team2Id, team2Score: $team2Score, winReason: $winReason, winningTeamId: $winningTeamId, scores: {data: $data, onConflict: {constraint: event_game_scores_game_id_team_id_key, updateColumns: score}}}
  ) {
    id
    matchId
    team1Score
    team2Score
    winReason
    winningTeamId
    losingTeamId
  }
  updatePreviousMatch: updateEventMatchesByPk(
    pkColumns: {id: $matchId}
    _set: {winningTeamId: $winningTeamId, losingTeamId: $losingTeamId, winReason: $winReason}
  ) {
    id
    losingTeamId
    winReason
    winningTeamId
    courtNumber
    eventCourtId
  }
}
    `;
export type SetMatchScoresMutationFn = Apollo.MutationFunction<SetMatchScoresMutation, SetMatchScoresMutationVariables>;

/**
 * __useSetMatchScoresMutation__
 *
 * To run a mutation, you first call `useSetMatchScoresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMatchScoresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMatchScoresMutation, { data, loading, error }] = useSetMatchScoresMutation({
 *   variables: {
 *      losingTeamId: // value for 'losingTeamId'
 *      matchId: // value for 'matchId'
 *      team1Id: // value for 'team1Id'
 *      team1Score: // value for 'team1Score'
 *      team2Id: // value for 'team2Id'
 *      team2Score: // value for 'team2Score'
 *      winReason: // value for 'winReason'
 *      winningTeamId: // value for 'winningTeamId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetMatchScoresMutation(baseOptions?: Apollo.MutationHookOptions<SetMatchScoresMutation, SetMatchScoresMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMatchScoresMutation, SetMatchScoresMutationVariables>(SetMatchScoresDocument, options);
      }
export type SetMatchScoresMutationHookResult = ReturnType<typeof useSetMatchScoresMutation>;
export type SetMatchScoresMutationResult = Apollo.MutationResult<SetMatchScoresMutation>;
export type SetMatchScoresMutationOptions = Apollo.BaseMutationOptions<SetMatchScoresMutation, SetMatchScoresMutationVariables>;
export const UpdateGameScoreDocument = gql`
    mutation updateGameScore($gameId: uuid!, $team1Score: numeric!, $team2Score: numeric!, $losingTeamId: uuid!, $winningTeamId: uuid!, $matchId: uuid!, $matchWinningTeamId: uuid!, $matchLosingTeamId: uuid!, $updates: [EventGameScoresUpdates!] = []) {
  updateEventMatchGamesByPk(
    pkColumns: {id: $gameId}
    _set: {team1Score: $team1Score, team2Score: $team2Score, losingTeamId: $losingTeamId, winningTeamId: $winningTeamId}
  ) {
    id
    team2Id
    team2Score
    team1Id
    team1Score
    losingTeamId
  }
  updateEventMatchesByPk(
    pkColumns: {id: $matchId}
    _set: {winningTeamId: $matchWinningTeamId, losingTeamId: $matchLosingTeamId}
  ) {
    id
    losingTeamId
    winningTeamId
  }
  updateEventGameScoresMany(updates: $updates) {
    returning {
      id
      score
    }
  }
}
    `;
export type UpdateGameScoreMutationFn = Apollo.MutationFunction<UpdateGameScoreMutation, UpdateGameScoreMutationVariables>;

/**
 * __useUpdateGameScoreMutation__
 *
 * To run a mutation, you first call `useUpdateGameScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGameScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGameScoreMutation, { data, loading, error }] = useUpdateGameScoreMutation({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      team1Score: // value for 'team1Score'
 *      team2Score: // value for 'team2Score'
 *      losingTeamId: // value for 'losingTeamId'
 *      winningTeamId: // value for 'winningTeamId'
 *      matchId: // value for 'matchId'
 *      matchWinningTeamId: // value for 'matchWinningTeamId'
 *      matchLosingTeamId: // value for 'matchLosingTeamId'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateGameScoreMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGameScoreMutation, UpdateGameScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGameScoreMutation, UpdateGameScoreMutationVariables>(UpdateGameScoreDocument, options);
      }
export type UpdateGameScoreMutationHookResult = ReturnType<typeof useUpdateGameScoreMutation>;
export type UpdateGameScoreMutationResult = Apollo.MutationResult<UpdateGameScoreMutation>;
export type UpdateGameScoreMutationOptions = Apollo.BaseMutationOptions<UpdateGameScoreMutation, UpdateGameScoreMutationVariables>;
export const UpdateSingleEliminationMatchProgressionDocument = gql`
    mutation updateSingleEliminationMatchProgression($updates: [EventMatchesUpdates!] = []) {
  updateEventMatchesMany(updates: $updates) {
    returning {
      team1Id
      team2Id
    }
  }
}
    `;
export type UpdateSingleEliminationMatchProgressionMutationFn = Apollo.MutationFunction<UpdateSingleEliminationMatchProgressionMutation, UpdateSingleEliminationMatchProgressionMutationVariables>;

/**
 * __useUpdateSingleEliminationMatchProgressionMutation__
 *
 * To run a mutation, you first call `useUpdateSingleEliminationMatchProgressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSingleEliminationMatchProgressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSingleEliminationMatchProgressionMutation, { data, loading, error }] = useUpdateSingleEliminationMatchProgressionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateSingleEliminationMatchProgressionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSingleEliminationMatchProgressionMutation, UpdateSingleEliminationMatchProgressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSingleEliminationMatchProgressionMutation, UpdateSingleEliminationMatchProgressionMutationVariables>(UpdateSingleEliminationMatchProgressionDocument, options);
      }
export type UpdateSingleEliminationMatchProgressionMutationHookResult = ReturnType<typeof useUpdateSingleEliminationMatchProgressionMutation>;
export type UpdateSingleEliminationMatchProgressionMutationResult = Apollo.MutationResult<UpdateSingleEliminationMatchProgressionMutation>;
export type UpdateSingleEliminationMatchProgressionMutationOptions = Apollo.BaseMutationOptions<UpdateSingleEliminationMatchProgressionMutation, UpdateSingleEliminationMatchProgressionMutationVariables>;
export const UpdatedUnassignCourtDocument = gql`
    mutation updatedUnassignCourt($id: uuid!) {
  updateEventCourtsByPk(
    pkColumns: {id: $id}
    _set: {activeEventGroupId: null, activeEventGroupPoolId: null, activeMatchId: null}
  ) {
    id
    courtNumber
    courtStatus
    activeMatchId
    activeEventGroupId
    activeEventGroupPoolId
  }
}
    `;
export type UpdatedUnassignCourtMutationFn = Apollo.MutationFunction<UpdatedUnassignCourtMutation, UpdatedUnassignCourtMutationVariables>;

/**
 * __useUpdatedUnassignCourtMutation__
 *
 * To run a mutation, you first call `useUpdatedUnassignCourtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatedUnassignCourtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatedUnassignCourtMutation, { data, loading, error }] = useUpdatedUnassignCourtMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdatedUnassignCourtMutation(baseOptions?: Apollo.MutationHookOptions<UpdatedUnassignCourtMutation, UpdatedUnassignCourtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatedUnassignCourtMutation, UpdatedUnassignCourtMutationVariables>(UpdatedUnassignCourtDocument, options);
      }
export type UpdatedUnassignCourtMutationHookResult = ReturnType<typeof useUpdatedUnassignCourtMutation>;
export type UpdatedUnassignCourtMutationResult = Apollo.MutationResult<UpdatedUnassignCourtMutation>;
export type UpdatedUnassignCourtMutationOptions = Apollo.BaseMutationOptions<UpdatedUnassignCourtMutation, UpdatedUnassignCourtMutationVariables>;
export const UpdateCourtsStartGroupDocument = gql`
    mutation updateCourtsStartGroup($courtUpdates: [EventCourtsUpdates!] = [], $matchUpdates: [EventMatchesUpdates!] = []) {
  updateEventCourtsMany(updates: $courtUpdates) {
    returning {
      id
      updatedAt
      courtNumber
      courtStatus
      activeMatchId
      activeMatch {
        id
        teams {
          id
          team {
            id
            members {
              userProfile {
                id
                preferredName
                fullName
              }
            }
          }
        }
      }
    }
  }
  updateEventMatchesMany(updates: $matchUpdates) {
    returning {
      id
      isBye
      matchOrder
      courtNumber
      eventCourtId
    }
  }
}
    `;
export type UpdateCourtsStartGroupMutationFn = Apollo.MutationFunction<UpdateCourtsStartGroupMutation, UpdateCourtsStartGroupMutationVariables>;

/**
 * __useUpdateCourtsStartGroupMutation__
 *
 * To run a mutation, you first call `useUpdateCourtsStartGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourtsStartGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourtsStartGroupMutation, { data, loading, error }] = useUpdateCourtsStartGroupMutation({
 *   variables: {
 *      courtUpdates: // value for 'courtUpdates'
 *      matchUpdates: // value for 'matchUpdates'
 *   },
 * });
 */
export function useUpdateCourtsStartGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourtsStartGroupMutation, UpdateCourtsStartGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourtsStartGroupMutation, UpdateCourtsStartGroupMutationVariables>(UpdateCourtsStartGroupDocument, options);
      }
export type UpdateCourtsStartGroupMutationHookResult = ReturnType<typeof useUpdateCourtsStartGroupMutation>;
export type UpdateCourtsStartGroupMutationResult = Apollo.MutationResult<UpdateCourtsStartGroupMutation>;
export type UpdateCourtsStartGroupMutationOptions = Apollo.BaseMutationOptions<UpdateCourtsStartGroupMutation, UpdateCourtsStartGroupMutationVariables>;
export const UpdateRemoveCourtFromMatchDocument = gql`
    mutation updateRemoveCourtFromMatch($matchId: uuid!, $courtId: uuid!) {
  updateEventMatchesByPk(
    pkColumns: {id: $matchId}
    _set: {courtNumber: null, eventCourtId: null}
  ) {
    id
    eventCourtId
    courtNumber
  }
  updateEventCourtsByPk(pkColumns: {id: $courtId}, _set: {activeMatchId: null}) {
    activeMatchId
    id
  }
}
    `;
export type UpdateRemoveCourtFromMatchMutationFn = Apollo.MutationFunction<UpdateRemoveCourtFromMatchMutation, UpdateRemoveCourtFromMatchMutationVariables>;

/**
 * __useUpdateRemoveCourtFromMatchMutation__
 *
 * To run a mutation, you first call `useUpdateRemoveCourtFromMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRemoveCourtFromMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRemoveCourtFromMatchMutation, { data, loading, error }] = useUpdateRemoveCourtFromMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      courtId: // value for 'courtId'
 *   },
 * });
 */
export function useUpdateRemoveCourtFromMatchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRemoveCourtFromMatchMutation, UpdateRemoveCourtFromMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRemoveCourtFromMatchMutation, UpdateRemoveCourtFromMatchMutationVariables>(UpdateRemoveCourtFromMatchDocument, options);
      }
export type UpdateRemoveCourtFromMatchMutationHookResult = ReturnType<typeof useUpdateRemoveCourtFromMatchMutation>;
export type UpdateRemoveCourtFromMatchMutationResult = Apollo.MutationResult<UpdateRemoveCourtFromMatchMutation>;
export type UpdateRemoveCourtFromMatchMutationOptions = Apollo.BaseMutationOptions<UpdateRemoveCourtFromMatchMutation, UpdateRemoveCourtFromMatchMutationVariables>;
export const UpdateReleaseCourtsFromGroupDocument = gql`
    mutation updateReleaseCourtsFromGroup($activeEventGroupId: uuid!) {
  updateEventCourts(
    where: {activeEventGroupId: {_eq: $activeEventGroupId}}
    _set: {activeEventGroupId: null, activeEventGroupPoolId: null, activeMatchId: null}
  ) {
    returning {
      id
      activeEventGroupId
      activeEventGroupPoolId
      activeMatchId
    }
  }
}
    `;
export type UpdateReleaseCourtsFromGroupMutationFn = Apollo.MutationFunction<UpdateReleaseCourtsFromGroupMutation, UpdateReleaseCourtsFromGroupMutationVariables>;

/**
 * __useUpdateReleaseCourtsFromGroupMutation__
 *
 * To run a mutation, you first call `useUpdateReleaseCourtsFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReleaseCourtsFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReleaseCourtsFromGroupMutation, { data, loading, error }] = useUpdateReleaseCourtsFromGroupMutation({
 *   variables: {
 *      activeEventGroupId: // value for 'activeEventGroupId'
 *   },
 * });
 */
export function useUpdateReleaseCourtsFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReleaseCourtsFromGroupMutation, UpdateReleaseCourtsFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReleaseCourtsFromGroupMutation, UpdateReleaseCourtsFromGroupMutationVariables>(UpdateReleaseCourtsFromGroupDocument, options);
      }
export type UpdateReleaseCourtsFromGroupMutationHookResult = ReturnType<typeof useUpdateReleaseCourtsFromGroupMutation>;
export type UpdateReleaseCourtsFromGroupMutationResult = Apollo.MutationResult<UpdateReleaseCourtsFromGroupMutation>;
export type UpdateReleaseCourtsFromGroupMutationOptions = Apollo.BaseMutationOptions<UpdateReleaseCourtsFromGroupMutation, UpdateReleaseCourtsFromGroupMutationVariables>;
export const UpdateCompleteSequenceDocument = gql`
    mutation updateCompleteSequence($id: uuid!) {
  updateEventGroupSequencesByPk(
    pkColumns: {id: $id}
    _set: {completeReason: ALL_SCORES, isSequenceComplete: true}
  ) {
    id
    isSequenceComplete
    completeReason
  }
}
    `;
export type UpdateCompleteSequenceMutationFn = Apollo.MutationFunction<UpdateCompleteSequenceMutation, UpdateCompleteSequenceMutationVariables>;

/**
 * __useUpdateCompleteSequenceMutation__
 *
 * To run a mutation, you first call `useUpdateCompleteSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompleteSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompleteSequenceMutation, { data, loading, error }] = useUpdateCompleteSequenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCompleteSequenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompleteSequenceMutation, UpdateCompleteSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompleteSequenceMutation, UpdateCompleteSequenceMutationVariables>(UpdateCompleteSequenceDocument, options);
      }
export type UpdateCompleteSequenceMutationHookResult = ReturnType<typeof useUpdateCompleteSequenceMutation>;
export type UpdateCompleteSequenceMutationResult = Apollo.MutationResult<UpdateCompleteSequenceMutation>;
export type UpdateCompleteSequenceMutationOptions = Apollo.BaseMutationOptions<UpdateCompleteSequenceMutation, UpdateCompleteSequenceMutationVariables>;
export const GetClinicsActivitiesByGeoDocument = gql`
    query GetClinicsActivitiesByGeo($distance: Float!, $from: geography!, $startDate: timestamptz!, $endDate: timestamptz!, $sport: SportsEnum!, $limit: Int = 10) {
  lessons(
    where: {status: {_eq: ACTIVE}, privacy: {_eq: PUBLIC}, participantLimit: {_gt: 1}, sport: {_eq: $sport}, venue: {geometry: {_stDWithin: {distance: $distance, from: $from}}}, startDateTime: {_gte: $startDate, _lte: $endDate}}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    title
    type
    sport
    startDateTime
    timezoneName
    timezoneAbbreviation
    priceUnitAmount
    currency
    coverImageProviderUrl
    userCustomCourt {
      id
      title
    }
    venue {
      id
      title
      timezone
      images {
        url
        path
      }
    }
    ownerProfile {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetClinicsActivitiesByGeoQuery__
 *
 * To run a query within a React component, call `useGetClinicsActivitiesByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicsActivitiesByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicsActivitiesByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sport: // value for 'sport'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetClinicsActivitiesByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetClinicsActivitiesByGeoQuery, GetClinicsActivitiesByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicsActivitiesByGeoQuery, GetClinicsActivitiesByGeoQueryVariables>(GetClinicsActivitiesByGeoDocument, options);
      }
export function useGetClinicsActivitiesByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicsActivitiesByGeoQuery, GetClinicsActivitiesByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicsActivitiesByGeoQuery, GetClinicsActivitiesByGeoQueryVariables>(GetClinicsActivitiesByGeoDocument, options);
        }
export type GetClinicsActivitiesByGeoQueryHookResult = ReturnType<typeof useGetClinicsActivitiesByGeoQuery>;
export type GetClinicsActivitiesByGeoLazyQueryHookResult = ReturnType<typeof useGetClinicsActivitiesByGeoLazyQuery>;
export type GetClinicsActivitiesByGeoQueryResult = Apollo.QueryResult<GetClinicsActivitiesByGeoQuery, GetClinicsActivitiesByGeoQueryVariables>;
export const GetLeaguesActivitiesByGeoDocument = gql`
    query GetLeaguesActivitiesByGeo($distance: Float!, $from: geography!, $startDate: timestamptz!, $endDate: timestamptz!, $sport: SportsEnum!, $limit: Int = 10) {
  events(
    where: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, status: {_eq: PUBLISHED}, type: {_eq: LEAGUE}, sport: {_eq: $sport}, geometry: {_stDWithin: {distance: $distance, from: $from}}, _or: [{startDateTime: {_gte: $startDate, _lte: $endDate}}, {groups: {timeSlots: {startsAt: {_gte: $startDate, _lte: $endDate}}}}]}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    slug
    title
    type
    sport
    startDateTime
    endDateTime
    groups {
      id
      timeSlots(orderBy: {startsAt: ASC}) {
        id
        startsAt
        endsAt
      }
    }
    timezoneName
    timezoneAbbreviation
    registrationPriceUnitAmount
    currency
    coverImageProviderUrl
    displayLocation
    sourceOrganizerTitle
    venue {
      id
      title
      timezone
      images {
        url
        path
      }
    }
    hostUserProfile {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetLeaguesActivitiesByGeoQuery__
 *
 * To run a query within a React component, call `useGetLeaguesActivitiesByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaguesActivitiesByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaguesActivitiesByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sport: // value for 'sport'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetLeaguesActivitiesByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetLeaguesActivitiesByGeoQuery, GetLeaguesActivitiesByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaguesActivitiesByGeoQuery, GetLeaguesActivitiesByGeoQueryVariables>(GetLeaguesActivitiesByGeoDocument, options);
      }
export function useGetLeaguesActivitiesByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaguesActivitiesByGeoQuery, GetLeaguesActivitiesByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaguesActivitiesByGeoQuery, GetLeaguesActivitiesByGeoQueryVariables>(GetLeaguesActivitiesByGeoDocument, options);
        }
export type GetLeaguesActivitiesByGeoQueryHookResult = ReturnType<typeof useGetLeaguesActivitiesByGeoQuery>;
export type GetLeaguesActivitiesByGeoLazyQueryHookResult = ReturnType<typeof useGetLeaguesActivitiesByGeoLazyQuery>;
export type GetLeaguesActivitiesByGeoQueryResult = Apollo.QueryResult<GetLeaguesActivitiesByGeoQuery, GetLeaguesActivitiesByGeoQueryVariables>;
export const GetOpenPlaysActivitiesByGeoDocument = gql`
    query GetOpenPlaysActivitiesByGeo($distance: Float!, $from: geography!, $startDate: timestamptz!, $endDate: timestamptz!, $sport: SportsEnum!, $limit: Int = 10) {
  events(
    where: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, status: {_eq: PUBLISHED}, type: {_eq: OPEN_PLAY}, isPlayerListed: {_eq: false}, sport: {_eq: $sport}, geometry: {_stDWithin: {distance: $distance, from: $from}}, _or: [{startDateTime: {_gte: $startDate, _lte: $endDate}}, {groups: {timeSlots: {startsAt: {_gte: $startDate, _lte: $endDate}}}}]}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    slug
    title
    type
    sport
    startDateTime
    endDateTime
    groups {
      id
      timeSlots(orderBy: {startsAt: ASC}) {
        id
        startsAt
        endsAt
      }
    }
    timezoneName
    timezoneAbbreviation
    registrationPriceUnitAmount
    currency
    coverImageProviderUrl
    displayLocation
    sourceOrganizerTitle
    venue {
      id
      title
      timezone
      images {
        url
        path
      }
    }
    hostUserProfile {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetOpenPlaysActivitiesByGeoQuery__
 *
 * To run a query within a React component, call `useGetOpenPlaysActivitiesByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenPlaysActivitiesByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenPlaysActivitiesByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sport: // value for 'sport'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetOpenPlaysActivitiesByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetOpenPlaysActivitiesByGeoQuery, GetOpenPlaysActivitiesByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpenPlaysActivitiesByGeoQuery, GetOpenPlaysActivitiesByGeoQueryVariables>(GetOpenPlaysActivitiesByGeoDocument, options);
      }
export function useGetOpenPlaysActivitiesByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpenPlaysActivitiesByGeoQuery, GetOpenPlaysActivitiesByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpenPlaysActivitiesByGeoQuery, GetOpenPlaysActivitiesByGeoQueryVariables>(GetOpenPlaysActivitiesByGeoDocument, options);
        }
export type GetOpenPlaysActivitiesByGeoQueryHookResult = ReturnType<typeof useGetOpenPlaysActivitiesByGeoQuery>;
export type GetOpenPlaysActivitiesByGeoLazyQueryHookResult = ReturnType<typeof useGetOpenPlaysActivitiesByGeoLazyQuery>;
export type GetOpenPlaysActivitiesByGeoQueryResult = Apollo.QueryResult<GetOpenPlaysActivitiesByGeoQuery, GetOpenPlaysActivitiesByGeoQueryVariables>;
export const GetSocialsActivitiesByGeoDocument = gql`
    query GetSocialsActivitiesByGeo($distance: Float!, $from: geography!, $startDate: timestamptz!, $endDate: timestamptz!, $sport: SportsEnum!, $limit: Int = 10) {
  events(
    where: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, status: {_eq: PUBLISHED}, type: {_eq: SOCIAL}, sport: {_eq: $sport}, geometry: {_stDWithin: {distance: $distance, from: $from}}, _or: [{startDateTime: {_gte: $startDate, _lte: $endDate}}, {groups: {timeSlots: {startsAt: {_gte: $startDate, _lte: $endDate}}}}]}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    slug
    title
    type
    sport
    startDateTime
    endDateTime
    groups {
      id
      timeSlots(orderBy: {startsAt: ASC}) {
        id
        startsAt
        endsAt
      }
    }
    timezoneName
    timezoneAbbreviation
    registrationPriceUnitAmount
    currency
    coverImageProviderUrl
    displayLocation
    sourceOrganizerTitle
    venue {
      id
      title
      timezone
      images {
        url
        path
      }
    }
    hostUserProfile {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetSocialsActivitiesByGeoQuery__
 *
 * To run a query within a React component, call `useGetSocialsActivitiesByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialsActivitiesByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialsActivitiesByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sport: // value for 'sport'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSocialsActivitiesByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetSocialsActivitiesByGeoQuery, GetSocialsActivitiesByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialsActivitiesByGeoQuery, GetSocialsActivitiesByGeoQueryVariables>(GetSocialsActivitiesByGeoDocument, options);
      }
export function useGetSocialsActivitiesByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialsActivitiesByGeoQuery, GetSocialsActivitiesByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialsActivitiesByGeoQuery, GetSocialsActivitiesByGeoQueryVariables>(GetSocialsActivitiesByGeoDocument, options);
        }
export type GetSocialsActivitiesByGeoQueryHookResult = ReturnType<typeof useGetSocialsActivitiesByGeoQuery>;
export type GetSocialsActivitiesByGeoLazyQueryHookResult = ReturnType<typeof useGetSocialsActivitiesByGeoLazyQuery>;
export type GetSocialsActivitiesByGeoQueryResult = Apollo.QueryResult<GetSocialsActivitiesByGeoQuery, GetSocialsActivitiesByGeoQueryVariables>;
export const GetTournamentsActivitiesByGeoDocument = gql`
    query GetTournamentsActivitiesByGeo($distance: Float!, $from: geography!, $startDate: timestamptz!, $endDate: timestamptz!, $sport: SportsEnum!, $limit: Int = 10) {
  events(
    where: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, status: {_eq: PUBLISHED}, type: {_eq: TOURNAMENT}, sport: {_eq: $sport}, geometry: {_stDWithin: {distance: $distance, from: $from}}, _or: [{startDateTime: {_gte: $startDate, _lte: $endDate}}, {groups: {timeSlots: {startsAt: {_gte: $startDate, _lte: $endDate}}}}]}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    slug
    title
    type
    sport
    startDateTime
    endDateTime
    groups {
      id
      timeSlots(orderBy: {startsAt: ASC}) {
        id
        startsAt
        endsAt
      }
    }
    timezoneName
    timezoneAbbreviation
    registrationPriceUnitAmount
    currency
    coverImageProviderUrl
    displayLocation
    sourceOrganizerTitle
    venue {
      id
      title
      timezone
      images {
        url
        path
      }
    }
    hostUserProfile {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetTournamentsActivitiesByGeoQuery__
 *
 * To run a query within a React component, call `useGetTournamentsActivitiesByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentsActivitiesByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentsActivitiesByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sport: // value for 'sport'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTournamentsActivitiesByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetTournamentsActivitiesByGeoQuery, GetTournamentsActivitiesByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTournamentsActivitiesByGeoQuery, GetTournamentsActivitiesByGeoQueryVariables>(GetTournamentsActivitiesByGeoDocument, options);
      }
export function useGetTournamentsActivitiesByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentsActivitiesByGeoQuery, GetTournamentsActivitiesByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTournamentsActivitiesByGeoQuery, GetTournamentsActivitiesByGeoQueryVariables>(GetTournamentsActivitiesByGeoDocument, options);
        }
export type GetTournamentsActivitiesByGeoQueryHookResult = ReturnType<typeof useGetTournamentsActivitiesByGeoQuery>;
export type GetTournamentsActivitiesByGeoLazyQueryHookResult = ReturnType<typeof useGetTournamentsActivitiesByGeoLazyQuery>;
export type GetTournamentsActivitiesByGeoQueryResult = Apollo.QueryResult<GetTournamentsActivitiesByGeoQuery, GetTournamentsActivitiesByGeoQueryVariables>;
export const GetTrendingActivitiesLessonsByGeoDocument = gql`
    query GetTrendingActivitiesLessonsByGeo($distance: Float!, $from: geography!, $startDate: timestamptz!, $endDate: timestamptz!, $sport: SportsEnum!, $limit: Int = 10) {
  lessons(
    where: {status: {_eq: ACTIVE}, privacy: {_eq: PUBLIC}, participantLimit: {_gt: 1}, sport: {_eq: $sport}, venue: {geometry: {_stDWithin: {distance: $distance, from: $from}}}, startDateTime: {_gte: $startDate, _lte: $endDate}}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    title
    type
    sport
    startDateTime
    timezoneName
    timezoneAbbreviation
    priceUnitAmount
    currency
    coverImageProviderUrl
    userCustomCourt {
      id
      title
    }
    venue {
      id
      title
      timezone
      images {
        url
        path
      }
    }
    ownerProfile {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetTrendingActivitiesLessonsByGeoQuery__
 *
 * To run a query within a React component, call `useGetTrendingActivitiesLessonsByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingActivitiesLessonsByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingActivitiesLessonsByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sport: // value for 'sport'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTrendingActivitiesLessonsByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetTrendingActivitiesLessonsByGeoQuery, GetTrendingActivitiesLessonsByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrendingActivitiesLessonsByGeoQuery, GetTrendingActivitiesLessonsByGeoQueryVariables>(GetTrendingActivitiesLessonsByGeoDocument, options);
      }
export function useGetTrendingActivitiesLessonsByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendingActivitiesLessonsByGeoQuery, GetTrendingActivitiesLessonsByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrendingActivitiesLessonsByGeoQuery, GetTrendingActivitiesLessonsByGeoQueryVariables>(GetTrendingActivitiesLessonsByGeoDocument, options);
        }
export type GetTrendingActivitiesLessonsByGeoQueryHookResult = ReturnType<typeof useGetTrendingActivitiesLessonsByGeoQuery>;
export type GetTrendingActivitiesLessonsByGeoLazyQueryHookResult = ReturnType<typeof useGetTrendingActivitiesLessonsByGeoLazyQuery>;
export type GetTrendingActivitiesLessonsByGeoQueryResult = Apollo.QueryResult<GetTrendingActivitiesLessonsByGeoQuery, GetTrendingActivitiesLessonsByGeoQueryVariables>;
export const GetTrendingActivitiesEventsByGeoDocument = gql`
    query GetTrendingActivitiesEventsByGeo($distance: Float!, $from: geography!, $startDate: timestamptz!, $endDate: timestamptz!, $sport: SportsEnum!, $limit: Int = 10) {
  events(
    where: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, status: {_eq: PUBLISHED}, _and: [{_or: [{type: {_in: [TOURNAMENT, LEAGUE, OPEN_PLAY, SOCIAL]}}, {isRfx: {_eq: true}}]}], isPlayerListed: {_eq: false}, sport: {_eq: $sport}, geometry: {_stDWithin: {distance: $distance, from: $from}}, _or: [{startDateTime: {_gte: $startDate, _lte: $endDate}}, {groups: {timeSlots: {startsAt: {_gte: $startDate, _lte: $endDate}}}}]}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    slug
    title
    type
    isRfx
    sport
    startDateTime
    endDateTime
    groups {
      id
      timeSlots(orderBy: {startsAt: ASC}) {
        id
        startsAt
        endsAt
      }
    }
    timezoneName
    timezoneAbbreviation
    registrationPriceUnitAmount
    currency
    coverImageProviderUrl
    displayLocation
    venue {
      id
      title
      timezone
      images {
        url
        path
      }
    }
    hostUserProfile {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetTrendingActivitiesEventsByGeoQuery__
 *
 * To run a query within a React component, call `useGetTrendingActivitiesEventsByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingActivitiesEventsByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingActivitiesEventsByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sport: // value for 'sport'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTrendingActivitiesEventsByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetTrendingActivitiesEventsByGeoQuery, GetTrendingActivitiesEventsByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrendingActivitiesEventsByGeoQuery, GetTrendingActivitiesEventsByGeoQueryVariables>(GetTrendingActivitiesEventsByGeoDocument, options);
      }
export function useGetTrendingActivitiesEventsByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendingActivitiesEventsByGeoQuery, GetTrendingActivitiesEventsByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrendingActivitiesEventsByGeoQuery, GetTrendingActivitiesEventsByGeoQueryVariables>(GetTrendingActivitiesEventsByGeoDocument, options);
        }
export type GetTrendingActivitiesEventsByGeoQueryHookResult = ReturnType<typeof useGetTrendingActivitiesEventsByGeoQuery>;
export type GetTrendingActivitiesEventsByGeoLazyQueryHookResult = ReturnType<typeof useGetTrendingActivitiesEventsByGeoLazyQuery>;
export type GetTrendingActivitiesEventsByGeoQueryResult = Apollo.QueryResult<GetTrendingActivitiesEventsByGeoQuery, GetTrendingActivitiesEventsByGeoQueryVariables>;
export const GetClinicsByGeoDocument = gql`
    query GetClinicsByGeo($distance: Float!, $from: geography!, $limit: Int = 1000, $startDate: timestamptz!, $endDate: timestamptz!) {
  lessons(
    where: {status: {_eq: ACTIVE}, privacy: {_eq: PUBLIC}, participantLimit: {_gt: 1}, venue: {geometry: {_stDWithin: {distance: $distance, from: $from}}}, startDateTime: {_gte: $startDate, _lte: $endDate}}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    ...ClinicLessonFields
  }
}
    ${ClinicLessonFieldsFragmentDoc}`;

/**
 * __useGetClinicsByGeoQuery__
 *
 * To run a query within a React component, call `useGetClinicsByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicsByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicsByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetClinicsByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetClinicsByGeoQuery, GetClinicsByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicsByGeoQuery, GetClinicsByGeoQueryVariables>(GetClinicsByGeoDocument, options);
      }
export function useGetClinicsByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicsByGeoQuery, GetClinicsByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicsByGeoQuery, GetClinicsByGeoQueryVariables>(GetClinicsByGeoDocument, options);
        }
export type GetClinicsByGeoQueryHookResult = ReturnType<typeof useGetClinicsByGeoQuery>;
export type GetClinicsByGeoLazyQueryHookResult = ReturnType<typeof useGetClinicsByGeoLazyQuery>;
export type GetClinicsByGeoQueryResult = Apollo.QueryResult<GetClinicsByGeoQuery, GetClinicsByGeoQueryVariables>;
export const GetFeaturedClinicBoostsDocument = gql`
    query GetFeaturedClinicBoosts($distance: Float!, $from: geography!, $now: timestamptz!) {
  boosts(
    where: {status: {_eq: ACTIVE}, channel: {_eq: MARKETPLACE}, entityType: {_eq: LESSON}, startsAt: {_lte: $now}, endsAt: {_gte: $now}, lesson: {status: {_eq: ACTIVE}, privacy: {_eq: PUBLIC}, participantLimit: {_gt: 1}, venue: {geometry: {_stDWithin: {distance: $distance, from: $from}}}, startDateTime: {_gte: $now}}}
    orderBy: {startsAt: DESC}
  ) {
    id
    lesson {
      ...ClinicLessonFields
    }
  }
}
    ${ClinicLessonFieldsFragmentDoc}`;

/**
 * __useGetFeaturedClinicBoostsQuery__
 *
 * To run a query within a React component, call `useGetFeaturedClinicBoostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedClinicBoostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedClinicBoostsQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useGetFeaturedClinicBoostsQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedClinicBoostsQuery, GetFeaturedClinicBoostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedClinicBoostsQuery, GetFeaturedClinicBoostsQueryVariables>(GetFeaturedClinicBoostsDocument, options);
      }
export function useGetFeaturedClinicBoostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedClinicBoostsQuery, GetFeaturedClinicBoostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedClinicBoostsQuery, GetFeaturedClinicBoostsQueryVariables>(GetFeaturedClinicBoostsDocument, options);
        }
export type GetFeaturedClinicBoostsQueryHookResult = ReturnType<typeof useGetFeaturedClinicBoostsQuery>;
export type GetFeaturedClinicBoostsLazyQueryHookResult = ReturnType<typeof useGetFeaturedClinicBoostsLazyQuery>;
export type GetFeaturedClinicBoostsQueryResult = Apollo.QueryResult<GetFeaturedClinicBoostsQuery, GetFeaturedClinicBoostsQueryVariables>;
export const GetClinicsByFollowedCoachesDocument = gql`
    query GetClinicsByFollowedCoaches($followedCoachesIds: [uuid!]!, $limit: Int = 1000, $startDate: timestamptz!, $endDate: timestamptz!) {
  lessons(
    where: {status: {_eq: ACTIVE}, privacy: {_eq: PUBLIC}, participantLimit: {_gt: 1}, ownerProfile: {id: {_in: $followedCoachesIds}}, startDateTime: {_gte: $startDate, _lte: $endDate}}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    ...ClinicLessonFields
  }
}
    ${ClinicLessonFieldsFragmentDoc}`;

/**
 * __useGetClinicsByFollowedCoachesQuery__
 *
 * To run a query within a React component, call `useGetClinicsByFollowedCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicsByFollowedCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicsByFollowedCoachesQuery({
 *   variables: {
 *      followedCoachesIds: // value for 'followedCoachesIds'
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetClinicsByFollowedCoachesQuery(baseOptions: Apollo.QueryHookOptions<GetClinicsByFollowedCoachesQuery, GetClinicsByFollowedCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicsByFollowedCoachesQuery, GetClinicsByFollowedCoachesQueryVariables>(GetClinicsByFollowedCoachesDocument, options);
      }
export function useGetClinicsByFollowedCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicsByFollowedCoachesQuery, GetClinicsByFollowedCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicsByFollowedCoachesQuery, GetClinicsByFollowedCoachesQueryVariables>(GetClinicsByFollowedCoachesDocument, options);
        }
export type GetClinicsByFollowedCoachesQueryHookResult = ReturnType<typeof useGetClinicsByFollowedCoachesQuery>;
export type GetClinicsByFollowedCoachesLazyQueryHookResult = ReturnType<typeof useGetClinicsByFollowedCoachesLazyQuery>;
export type GetClinicsByFollowedCoachesQueryResult = Apollo.QueryResult<GetClinicsByFollowedCoachesQuery, GetClinicsByFollowedCoachesQueryVariables>;
export const GetRfxClassesByGeoDocument = gql`
    query GetRfxClassesByGeo($distance: Float!, $from: geography!, $limit: Int = 1000, $startDate: timestamptz!, $endDate: timestamptz!) {
  events(
    where: {isRfx: {_eq: true}, status: {_eq: PUBLISHED}, privacy: {_eq: PUBLIC}, archivedAt: {_isNull: true}, canceledAt: {_isNull: true}, deletedAt: {_isNull: true}, venue: {geometry: {_stDWithin: {distance: $distance, from: $from}}}, _or: [{startDateTime: {_gte: $startDate, _lte: $endDate}}, {groups: {timeSlots: {startsAt: {_gte: $startDate, _lte: $endDate}}}}]}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    slug
    title
    description
    sport
    type
    startDateTime
    endDateTime
    timezoneName
    timezoneAbbreviation
    coverImageProviderUrl
    registrationPriceUnitAmount
    currency
    participantLimit
    hostUserProfile {
      id
      fullName
      profileImageUrl
      username
    }
    groups(where: {deletedAt: {_isNull: true}}, orderBy: {startsAt: ASC}) {
      id
      startsAt
      endsAt
      priceUnitAmount
      teamLimit
      timeSlots(where: {deletedAt: {_isNull: true}}, orderBy: {startsAt: ASC}) {
        id
        startsAt
        endsAt
      }
    }
    registrations(where: {deletedAt: {_isNull: true}}) {
      id
      userProfile {
        fullName
        profileImagePath
      }
    }
    venue {
      id
      addressString
      latitude
      longitude
      geometry
      timezone
      title
      indoorCourtCount
      outdoorCourtCount
      images {
        id
        url
        path
        provider
        fileName
      }
    }
  }
}
    `;

/**
 * __useGetRfxClassesByGeoQuery__
 *
 * To run a query within a React component, call `useGetRfxClassesByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRfxClassesByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRfxClassesByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetRfxClassesByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetRfxClassesByGeoQuery, GetRfxClassesByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRfxClassesByGeoQuery, GetRfxClassesByGeoQueryVariables>(GetRfxClassesByGeoDocument, options);
      }
export function useGetRfxClassesByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRfxClassesByGeoQuery, GetRfxClassesByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRfxClassesByGeoQuery, GetRfxClassesByGeoQueryVariables>(GetRfxClassesByGeoDocument, options);
        }
export type GetRfxClassesByGeoQueryHookResult = ReturnType<typeof useGetRfxClassesByGeoQuery>;
export type GetRfxClassesByGeoLazyQueryHookResult = ReturnType<typeof useGetRfxClassesByGeoLazyQuery>;
export type GetRfxClassesByGeoQueryResult = Apollo.QueryResult<GetRfxClassesByGeoQuery, GetRfxClassesByGeoQueryVariables>;
export const GetLeaguesByGeoDocument = gql`
    query GetLeaguesByGeo($distance: Float!, $from: geography!, $limit: Int = 1000, $startDate: timestamptz!, $endDate: timestamptz!) {
  events(
    where: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, type: {_eq: LEAGUE}, status: {_eq: PUBLISHED}, geometry: {_stDWithin: {distance: $distance, from: $from}}, startDateTime: {_gte: $startDate, _lte: $endDate}}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    ...LeagueEventFields
  }
}
    ${LeagueEventFieldsFragmentDoc}`;

/**
 * __useGetLeaguesByGeoQuery__
 *
 * To run a query within a React component, call `useGetLeaguesByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaguesByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaguesByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetLeaguesByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetLeaguesByGeoQuery, GetLeaguesByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaguesByGeoQuery, GetLeaguesByGeoQueryVariables>(GetLeaguesByGeoDocument, options);
      }
export function useGetLeaguesByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaguesByGeoQuery, GetLeaguesByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaguesByGeoQuery, GetLeaguesByGeoQueryVariables>(GetLeaguesByGeoDocument, options);
        }
export type GetLeaguesByGeoQueryHookResult = ReturnType<typeof useGetLeaguesByGeoQuery>;
export type GetLeaguesByGeoLazyQueryHookResult = ReturnType<typeof useGetLeaguesByGeoLazyQuery>;
export type GetLeaguesByGeoQueryResult = Apollo.QueryResult<GetLeaguesByGeoQuery, GetLeaguesByGeoQueryVariables>;
export const GetFeaturedLeagueBoostsDocument = gql`
    query GetFeaturedLeagueBoosts($distance: Float!, $from: geography!, $now: timestamptz!) {
  boosts(
    where: {status: {_eq: ACTIVE}, channel: {_eq: MARKETPLACE}, entityType: {_eq: EVENT}, startsAt: {_lte: $now}, endsAt: {_gte: $now}, event: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, type: {_eq: LEAGUE}, status: {_eq: PUBLISHED}, geometry: {_stDWithin: {distance: $distance, from: $from}}, startDateTime: {_gte: $now}}}
    orderBy: {startsAt: DESC}
  ) {
    id
    event {
      ...LeagueEventFields
    }
  }
}
    ${LeagueEventFieldsFragmentDoc}`;

/**
 * __useGetFeaturedLeagueBoostsQuery__
 *
 * To run a query within a React component, call `useGetFeaturedLeagueBoostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedLeagueBoostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedLeagueBoostsQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useGetFeaturedLeagueBoostsQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedLeagueBoostsQuery, GetFeaturedLeagueBoostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedLeagueBoostsQuery, GetFeaturedLeagueBoostsQueryVariables>(GetFeaturedLeagueBoostsDocument, options);
      }
export function useGetFeaturedLeagueBoostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedLeagueBoostsQuery, GetFeaturedLeagueBoostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedLeagueBoostsQuery, GetFeaturedLeagueBoostsQueryVariables>(GetFeaturedLeagueBoostsDocument, options);
        }
export type GetFeaturedLeagueBoostsQueryHookResult = ReturnType<typeof useGetFeaturedLeagueBoostsQuery>;
export type GetFeaturedLeagueBoostsLazyQueryHookResult = ReturnType<typeof useGetFeaturedLeagueBoostsLazyQuery>;
export type GetFeaturedLeagueBoostsQueryResult = Apollo.QueryResult<GetFeaturedLeagueBoostsQuery, GetFeaturedLeagueBoostsQueryVariables>;
export const GetOpenPlaysByGeoDocument = gql`
    query GetOpenPlaysByGeo($distance: Float!, $from: geography!, $limit: Int = 1000, $startDate: timestamptz!, $endDate: timestamptz!) {
  events(
    where: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, type: {_eq: OPEN_PLAY}, isPlayerListed: {_eq: false}, status: {_eq: PUBLISHED}, geometry: {_stDWithin: {distance: $distance, from: $from}}, _or: [{startDateTime: {_gte: $startDate, _lte: $endDate}}, {groups: {timeSlots: {startsAt: {_gte: $startDate, _lte: $endDate}}}}]}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    ...OpenPlayEventFields
  }
}
    ${OpenPlayEventFieldsFragmentDoc}`;

/**
 * __useGetOpenPlaysByGeoQuery__
 *
 * To run a query within a React component, call `useGetOpenPlaysByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenPlaysByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenPlaysByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetOpenPlaysByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetOpenPlaysByGeoQuery, GetOpenPlaysByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpenPlaysByGeoQuery, GetOpenPlaysByGeoQueryVariables>(GetOpenPlaysByGeoDocument, options);
      }
export function useGetOpenPlaysByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpenPlaysByGeoQuery, GetOpenPlaysByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpenPlaysByGeoQuery, GetOpenPlaysByGeoQueryVariables>(GetOpenPlaysByGeoDocument, options);
        }
export type GetOpenPlaysByGeoQueryHookResult = ReturnType<typeof useGetOpenPlaysByGeoQuery>;
export type GetOpenPlaysByGeoLazyQueryHookResult = ReturnType<typeof useGetOpenPlaysByGeoLazyQuery>;
export type GetOpenPlaysByGeoQueryResult = Apollo.QueryResult<GetOpenPlaysByGeoQuery, GetOpenPlaysByGeoQueryVariables>;
export const GetFeaturedOpenPlayBoostsDocument = gql`
    query GetFeaturedOpenPlayBoosts($distance: Float!, $from: geography!, $now: timestamptz!) {
  boosts(
    where: {status: {_eq: ACTIVE}, channel: {_eq: MARKETPLACE}, entityType: {_eq: EVENT}, startsAt: {_lte: $now}, endsAt: {_gte: $now}, event: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, type: {_eq: OPEN_PLAY}, isPlayerListed: {_eq: false}, status: {_eq: PUBLISHED}, geometry: {_stDWithin: {distance: $distance, from: $from}}, endDateTime: {_gte: $now}}}
    orderBy: {startsAt: DESC}
  ) {
    id
    event {
      ...OpenPlayEventFields
    }
  }
}
    ${OpenPlayEventFieldsFragmentDoc}`;

/**
 * __useGetFeaturedOpenPlayBoostsQuery__
 *
 * To run a query within a React component, call `useGetFeaturedOpenPlayBoostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedOpenPlayBoostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedOpenPlayBoostsQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useGetFeaturedOpenPlayBoostsQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedOpenPlayBoostsQuery, GetFeaturedOpenPlayBoostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedOpenPlayBoostsQuery, GetFeaturedOpenPlayBoostsQueryVariables>(GetFeaturedOpenPlayBoostsDocument, options);
      }
export function useGetFeaturedOpenPlayBoostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedOpenPlayBoostsQuery, GetFeaturedOpenPlayBoostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedOpenPlayBoostsQuery, GetFeaturedOpenPlayBoostsQueryVariables>(GetFeaturedOpenPlayBoostsDocument, options);
        }
export type GetFeaturedOpenPlayBoostsQueryHookResult = ReturnType<typeof useGetFeaturedOpenPlayBoostsQuery>;
export type GetFeaturedOpenPlayBoostsLazyQueryHookResult = ReturnType<typeof useGetFeaturedOpenPlayBoostsLazyQuery>;
export type GetFeaturedOpenPlayBoostsQueryResult = Apollo.QueryResult<GetFeaturedOpenPlayBoostsQuery, GetFeaturedOpenPlayBoostsQueryVariables>;
export const GetSocialsByGeoDocument = gql`
    query GetSocialsByGeo($distance: Float!, $from: geography!, $limit: Int = 1000, $startDate: timestamptz!, $endDate: timestamptz!) {
  events(
    where: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, type: {_eq: SOCIAL}, status: {_eq: PUBLISHED}, geometry: {_stDWithin: {distance: $distance, from: $from}}, _or: [{startDateTime: {_gte: $startDate, _lte: $endDate}}, {groups: {timeSlots: {startsAt: {_gte: $startDate, _lte: $endDate}}}}]}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    ...SocialEventFields
  }
}
    ${SocialEventFieldsFragmentDoc}`;

/**
 * __useGetSocialsByGeoQuery__
 *
 * To run a query within a React component, call `useGetSocialsByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialsByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialsByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetSocialsByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetSocialsByGeoQuery, GetSocialsByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialsByGeoQuery, GetSocialsByGeoQueryVariables>(GetSocialsByGeoDocument, options);
      }
export function useGetSocialsByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialsByGeoQuery, GetSocialsByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialsByGeoQuery, GetSocialsByGeoQueryVariables>(GetSocialsByGeoDocument, options);
        }
export type GetSocialsByGeoQueryHookResult = ReturnType<typeof useGetSocialsByGeoQuery>;
export type GetSocialsByGeoLazyQueryHookResult = ReturnType<typeof useGetSocialsByGeoLazyQuery>;
export type GetSocialsByGeoQueryResult = Apollo.QueryResult<GetSocialsByGeoQuery, GetSocialsByGeoQueryVariables>;
export const GetFeaturedSocialBoostsDocument = gql`
    query GetFeaturedSocialBoosts($distance: Float!, $from: geography!, $now: timestamptz!) {
  boosts(
    where: {status: {_eq: ACTIVE}, channel: {_eq: MARKETPLACE}, entityType: {_eq: EVENT}, startsAt: {_lte: $now}, endsAt: {_gte: $now}, event: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, type: {_eq: SOCIAL}, status: {_eq: PUBLISHED}, geometry: {_stDWithin: {distance: $distance, from: $from}}, endDateTime: {_gte: $now}}}
    orderBy: {startsAt: DESC}
  ) {
    id
    event {
      ...SocialEventFields
    }
  }
}
    ${SocialEventFieldsFragmentDoc}`;

/**
 * __useGetFeaturedSocialBoostsQuery__
 *
 * To run a query within a React component, call `useGetFeaturedSocialBoostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedSocialBoostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedSocialBoostsQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useGetFeaturedSocialBoostsQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedSocialBoostsQuery, GetFeaturedSocialBoostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedSocialBoostsQuery, GetFeaturedSocialBoostsQueryVariables>(GetFeaturedSocialBoostsDocument, options);
      }
export function useGetFeaturedSocialBoostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedSocialBoostsQuery, GetFeaturedSocialBoostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedSocialBoostsQuery, GetFeaturedSocialBoostsQueryVariables>(GetFeaturedSocialBoostsDocument, options);
        }
export type GetFeaturedSocialBoostsQueryHookResult = ReturnType<typeof useGetFeaturedSocialBoostsQuery>;
export type GetFeaturedSocialBoostsLazyQueryHookResult = ReturnType<typeof useGetFeaturedSocialBoostsLazyQuery>;
export type GetFeaturedSocialBoostsQueryResult = Apollo.QueryResult<GetFeaturedSocialBoostsQuery, GetFeaturedSocialBoostsQueryVariables>;
export const GetHostGameDocument = gql`
    query GetHostGame($eventId: uuid!, $viewerUserId: uuid!) {
  events(where: {id: {_eq: $eventId}}) {
    ...FindGameEventFields
    ...FindGameRosterFields
  }
}
    ${FindGameEventFieldsFragmentDoc}
${FindGameRosterFieldsFragmentDoc}`;

/**
 * __useGetHostGameQuery__
 *
 * To run a query within a React component, call `useGetHostGameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostGameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostGameQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      viewerUserId: // value for 'viewerUserId'
 *   },
 * });
 */
export function useGetHostGameQuery(baseOptions: Apollo.QueryHookOptions<GetHostGameQuery, GetHostGameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHostGameQuery, GetHostGameQueryVariables>(GetHostGameDocument, options);
      }
export function useGetHostGameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHostGameQuery, GetHostGameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHostGameQuery, GetHostGameQueryVariables>(GetHostGameDocument, options);
        }
export type GetHostGameQueryHookResult = ReturnType<typeof useGetHostGameQuery>;
export type GetHostGameLazyQueryHookResult = ReturnType<typeof useGetHostGameLazyQuery>;
export type GetHostGameQueryResult = Apollo.QueryResult<GetHostGameQuery, GetHostGameQueryVariables>;
export const GetHostGameRequestsDocument = gql`
    query GetHostGameRequests($userId: uuid!, $eventId: uuid!) {
  playRequests(
    where: {recipientUserId: {_eq: $userId}, eventId: {_eq: $eventId}, status: {_eq: PENDING}, deletedAt: {_isNull: true}}
    orderBy: {createdAt: DESC}
  ) {
    id
    requestMessage
    requesterProfile {
      id
      fullName
      preferredName
      username
      profileImagePath
      profileImageProviderUrl
      identityVerifications(where: {status: {_eq: VERIFIED}}, limit: 1) {
        status
      }
      pickleballSkillLevel {
        id
      }
      tennisSkillLevel {
        id
      }
    }
  }
}
    `;

/**
 * __useGetHostGameRequestsQuery__
 *
 * To run a query within a React component, call `useGetHostGameRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostGameRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostGameRequestsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetHostGameRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetHostGameRequestsQuery, GetHostGameRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHostGameRequestsQuery, GetHostGameRequestsQueryVariables>(GetHostGameRequestsDocument, options);
      }
export function useGetHostGameRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHostGameRequestsQuery, GetHostGameRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHostGameRequestsQuery, GetHostGameRequestsQueryVariables>(GetHostGameRequestsDocument, options);
        }
export type GetHostGameRequestsQueryHookResult = ReturnType<typeof useGetHostGameRequestsQuery>;
export type GetHostGameRequestsLazyQueryHookResult = ReturnType<typeof useGetHostGameRequestsLazyQuery>;
export type GetHostGameRequestsQueryResult = Apollo.QueryResult<GetHostGameRequestsQuery, GetHostGameRequestsQueryVariables>;
export const GetHostAvailabilityDocument = gql`
    query GetHostAvailability($availabilityId: uuid!) {
  playerAvailabilities(where: {id: {_eq: $availabilityId}}) {
    ...FindPlayerAvailabilityFields
  }
}
    ${FindPlayerAvailabilityFieldsFragmentDoc}`;

/**
 * __useGetHostAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetHostAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostAvailabilityQuery({
 *   variables: {
 *      availabilityId: // value for 'availabilityId'
 *   },
 * });
 */
export function useGetHostAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<GetHostAvailabilityQuery, GetHostAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHostAvailabilityQuery, GetHostAvailabilityQueryVariables>(GetHostAvailabilityDocument, options);
      }
export function useGetHostAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHostAvailabilityQuery, GetHostAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHostAvailabilityQuery, GetHostAvailabilityQueryVariables>(GetHostAvailabilityDocument, options);
        }
export type GetHostAvailabilityQueryHookResult = ReturnType<typeof useGetHostAvailabilityQuery>;
export type GetHostAvailabilityLazyQueryHookResult = ReturnType<typeof useGetHostAvailabilityLazyQuery>;
export type GetHostAvailabilityQueryResult = Apollo.QueryResult<GetHostAvailabilityQuery, GetHostAvailabilityQueryVariables>;
export const GetHostAvailabilityRequestsDocument = gql`
    query GetHostAvailabilityRequests($userId: uuid!, $availabilityId: uuid!) {
  playRequests(
    where: {recipientUserId: {_eq: $userId}, availabilityId: {_eq: $availabilityId}, status: {_eq: PENDING}, deletedAt: {_isNull: true}}
    orderBy: {createdAt: DESC}
  ) {
    id
    requestMessage
    requesterProfile {
      id
      fullName
      preferredName
      username
      profileImagePath
      profileImageProviderUrl
      identityVerifications(where: {status: {_eq: VERIFIED}}, limit: 1) {
        status
      }
      pickleballSkillLevel {
        id
      }
      tennisSkillLevel {
        id
      }
    }
    slots {
      id
      requestedStartAt
      requestedEndAt
      availabilitySlot {
        id
        dayOfWeek
        startTime
        endTime
      }
    }
    neighborhoods {
      id
      neighborhood {
        id
        name
      }
    }
    venues {
      id
      venue {
        id
        title
        addressString
        accessType
        pickleballNets
        indoorCourtCount
        outdoorCourtCount
        images(limit: 1) {
          id
          path
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetHostAvailabilityRequestsQuery__
 *
 * To run a query within a React component, call `useGetHostAvailabilityRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostAvailabilityRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostAvailabilityRequestsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      availabilityId: // value for 'availabilityId'
 *   },
 * });
 */
export function useGetHostAvailabilityRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetHostAvailabilityRequestsQuery, GetHostAvailabilityRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHostAvailabilityRequestsQuery, GetHostAvailabilityRequestsQueryVariables>(GetHostAvailabilityRequestsDocument, options);
      }
export function useGetHostAvailabilityRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHostAvailabilityRequestsQuery, GetHostAvailabilityRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHostAvailabilityRequestsQuery, GetHostAvailabilityRequestsQueryVariables>(GetHostAvailabilityRequestsDocument, options);
        }
export type GetHostAvailabilityRequestsQueryHookResult = ReturnType<typeof useGetHostAvailabilityRequestsQuery>;
export type GetHostAvailabilityRequestsLazyQueryHookResult = ReturnType<typeof useGetHostAvailabilityRequestsLazyQuery>;
export type GetHostAvailabilityRequestsQueryResult = Apollo.QueryResult<GetHostAvailabilityRequestsQuery, GetHostAvailabilityRequestsQueryVariables>;
export const GetMyGameRequestDocument = gql`
    query GetMyGameRequest($eventId: uuid!, $userId: uuid!, $status: PlayRequestStatusesEnum!) {
  playRequests(
    where: {eventId: {_eq: $eventId}, requesterUserId: {_eq: $userId}, status: {_eq: $status}, deletedAt: {_isNull: true}}
    orderBy: {createdAt: DESC}
    limit: 1
  ) {
    id
    requestMessage
    createdAt
    status
  }
}
    `;

/**
 * __useGetMyGameRequestQuery__
 *
 * To run a query within a React component, call `useGetMyGameRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyGameRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyGameRequestQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetMyGameRequestQuery(baseOptions: Apollo.QueryHookOptions<GetMyGameRequestQuery, GetMyGameRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyGameRequestQuery, GetMyGameRequestQueryVariables>(GetMyGameRequestDocument, options);
      }
export function useGetMyGameRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyGameRequestQuery, GetMyGameRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyGameRequestQuery, GetMyGameRequestQueryVariables>(GetMyGameRequestDocument, options);
        }
export type GetMyGameRequestQueryHookResult = ReturnType<typeof useGetMyGameRequestQuery>;
export type GetMyGameRequestLazyQueryHookResult = ReturnType<typeof useGetMyGameRequestLazyQuery>;
export type GetMyGameRequestQueryResult = Apollo.QueryResult<GetMyGameRequestQuery, GetMyGameRequestQueryVariables>;
export const GetMyPendingPlayRequestsDocument = gql`
    query GetMyPendingPlayRequests($userId: uuid!) {
  playRequests(
    where: {requesterUserId: {_eq: $userId}, status: {_eq: PENDING}, deletedAt: {_isNull: true}}
  ) {
    id
    availabilityId
  }
}
    `;

/**
 * __useGetMyPendingPlayRequestsQuery__
 *
 * To run a query within a React component, call `useGetMyPendingPlayRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPendingPlayRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPendingPlayRequestsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyPendingPlayRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetMyPendingPlayRequestsQuery, GetMyPendingPlayRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPendingPlayRequestsQuery, GetMyPendingPlayRequestsQueryVariables>(GetMyPendingPlayRequestsDocument, options);
      }
export function useGetMyPendingPlayRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPendingPlayRequestsQuery, GetMyPendingPlayRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPendingPlayRequestsQuery, GetMyPendingPlayRequestsQueryVariables>(GetMyPendingPlayRequestsDocument, options);
        }
export type GetMyPendingPlayRequestsQueryHookResult = ReturnType<typeof useGetMyPendingPlayRequestsQuery>;
export type GetMyPendingPlayRequestsLazyQueryHookResult = ReturnType<typeof useGetMyPendingPlayRequestsLazyQuery>;
export type GetMyPendingPlayRequestsQueryResult = Apollo.QueryResult<GetMyPendingPlayRequestsQuery, GetMyPendingPlayRequestsQueryVariables>;
export const GetFindPlayersDocument = gql`
    query GetFindPlayers($area: PlayerAvailabilitiesBoolExp!) {
  playerAvailabilities(
    where: {isActive: {_eq: true}, _and: [$area]}
    orderBy: {createdAt: DESC}
    limit: 60
  ) {
    ...FindPlayerAvailabilityFields
  }
}
    ${FindPlayerAvailabilityFieldsFragmentDoc}`;

/**
 * __useGetFindPlayersQuery__
 *
 * To run a query within a React component, call `useGetFindPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFindPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFindPlayersQuery({
 *   variables: {
 *      area: // value for 'area'
 *   },
 * });
 */
export function useGetFindPlayersQuery(baseOptions: Apollo.QueryHookOptions<GetFindPlayersQuery, GetFindPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFindPlayersQuery, GetFindPlayersQueryVariables>(GetFindPlayersDocument, options);
      }
export function useGetFindPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFindPlayersQuery, GetFindPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFindPlayersQuery, GetFindPlayersQueryVariables>(GetFindPlayersDocument, options);
        }
export type GetFindPlayersQueryHookResult = ReturnType<typeof useGetFindPlayersQuery>;
export type GetFindPlayersLazyQueryHookResult = ReturnType<typeof useGetFindPlayersLazyQuery>;
export type GetFindPlayersQueryResult = Apollo.QueryResult<GetFindPlayersQuery, GetFindPlayersQueryVariables>;
export const GetFindGamesDocument = gql`
    query GetFindGames($area: EventsBoolExp!, $now: timestamptz!) {
  events(
    where: {type: {_eq: OPEN_PLAY}, status: {_eq: PUBLISHED}, privacy: {_eq: PUBLIC}, archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, endDateTime: {_gte: $now}, _and: [$area], isPlayerListed: {_eq: true}}
    orderBy: {startDateTime: ASC}
    limit: 60
  ) {
    ...FindGameEventFields
  }
}
    ${FindGameEventFieldsFragmentDoc}`;

/**
 * __useGetFindGamesQuery__
 *
 * To run a query within a React component, call `useGetFindGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFindGamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFindGamesQuery({
 *   variables: {
 *      area: // value for 'area'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useGetFindGamesQuery(baseOptions: Apollo.QueryHookOptions<GetFindGamesQuery, GetFindGamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFindGamesQuery, GetFindGamesQueryVariables>(GetFindGamesDocument, options);
      }
export function useGetFindGamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFindGamesQuery, GetFindGamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFindGamesQuery, GetFindGamesQueryVariables>(GetFindGamesDocument, options);
        }
export type GetFindGamesQueryHookResult = ReturnType<typeof useGetFindGamesQuery>;
export type GetFindGamesLazyQueryHookResult = ReturnType<typeof useGetFindGamesLazyQuery>;
export type GetFindGamesQueryResult = Apollo.QueryResult<GetFindGamesQuery, GetFindGamesQueryVariables>;
export const GetFindGamesWithRosterDocument = gql`
    query GetFindGamesWithRoster($area: EventsBoolExp!, $now: timestamptz!, $viewerUserId: uuid!) {
  events(
    where: {type: {_eq: OPEN_PLAY}, status: {_eq: PUBLISHED}, privacy: {_eq: PUBLIC}, archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, endDateTime: {_gte: $now}, _and: [$area], isPlayerListed: {_eq: true}}
    orderBy: {startDateTime: ASC}
    limit: 60
  ) {
    ...FindGameEventFields
    ...FindGameRosterFields
  }
}
    ${FindGameEventFieldsFragmentDoc}
${FindGameRosterFieldsFragmentDoc}`;

/**
 * __useGetFindGamesWithRosterQuery__
 *
 * To run a query within a React component, call `useGetFindGamesWithRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFindGamesWithRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFindGamesWithRosterQuery({
 *   variables: {
 *      area: // value for 'area'
 *      now: // value for 'now'
 *      viewerUserId: // value for 'viewerUserId'
 *   },
 * });
 */
export function useGetFindGamesWithRosterQuery(baseOptions: Apollo.QueryHookOptions<GetFindGamesWithRosterQuery, GetFindGamesWithRosterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFindGamesWithRosterQuery, GetFindGamesWithRosterQueryVariables>(GetFindGamesWithRosterDocument, options);
      }
export function useGetFindGamesWithRosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFindGamesWithRosterQuery, GetFindGamesWithRosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFindGamesWithRosterQuery, GetFindGamesWithRosterQueryVariables>(GetFindGamesWithRosterDocument, options);
        }
export type GetFindGamesWithRosterQueryHookResult = ReturnType<typeof useGetFindGamesWithRosterQuery>;
export type GetFindGamesWithRosterLazyQueryHookResult = ReturnType<typeof useGetFindGamesWithRosterLazyQuery>;
export type GetFindGamesWithRosterQueryResult = Apollo.QueryResult<GetFindGamesWithRosterQuery, GetFindGamesWithRosterQueryVariables>;
export const SetPlayerFinderOnboardedDocument = gql`
    mutation SetPlayerFinderOnboarded($id: uuid!, $onboardedAt: timestamptz!) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {playerFinderOnboardedAt: $onboardedAt}
  ) {
    id
    playerFinderOnboardedAt
  }
}
    `;
export type SetPlayerFinderOnboardedMutationFn = Apollo.MutationFunction<SetPlayerFinderOnboardedMutation, SetPlayerFinderOnboardedMutationVariables>;

/**
 * __useSetPlayerFinderOnboardedMutation__
 *
 * To run a mutation, you first call `useSetPlayerFinderOnboardedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPlayerFinderOnboardedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPlayerFinderOnboardedMutation, { data, loading, error }] = useSetPlayerFinderOnboardedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      onboardedAt: // value for 'onboardedAt'
 *   },
 * });
 */
export function useSetPlayerFinderOnboardedMutation(baseOptions?: Apollo.MutationHookOptions<SetPlayerFinderOnboardedMutation, SetPlayerFinderOnboardedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPlayerFinderOnboardedMutation, SetPlayerFinderOnboardedMutationVariables>(SetPlayerFinderOnboardedDocument, options);
      }
export type SetPlayerFinderOnboardedMutationHookResult = ReturnType<typeof useSetPlayerFinderOnboardedMutation>;
export type SetPlayerFinderOnboardedMutationResult = Apollo.MutationResult<SetPlayerFinderOnboardedMutation>;
export type SetPlayerFinderOnboardedMutationOptions = Apollo.BaseMutationOptions<SetPlayerFinderOnboardedMutation, SetPlayerFinderOnboardedMutationVariables>;
export const UpdatePlayerUserDocument = gql`
    mutation UpdatePlayerUser($id: uuid!, $set: UsersSetInput!) {
  updateUsersByPk(pkColumns: {id: $id}, _set: $set) {
    id
  }
}
    `;
export type UpdatePlayerUserMutationFn = Apollo.MutationFunction<UpdatePlayerUserMutation, UpdatePlayerUserMutationVariables>;

/**
 * __useUpdatePlayerUserMutation__
 *
 * To run a mutation, you first call `useUpdatePlayerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlayerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlayerUserMutation, { data, loading, error }] = useUpdatePlayerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdatePlayerUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlayerUserMutation, UpdatePlayerUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlayerUserMutation, UpdatePlayerUserMutationVariables>(UpdatePlayerUserDocument, options);
      }
export type UpdatePlayerUserMutationHookResult = ReturnType<typeof useUpdatePlayerUserMutation>;
export type UpdatePlayerUserMutationResult = Apollo.MutationResult<UpdatePlayerUserMutation>;
export type UpdatePlayerUserMutationOptions = Apollo.BaseMutationOptions<UpdatePlayerUserMutation, UpdatePlayerUserMutationVariables>;
export const SavePlayerFinderGoalsDocument = gql`
    mutation SavePlayerFinderGoals($userId: uuid!, $goals: [UserPlayerFinderGoalsInsertInput!]!) {
  deleteUserPlayerFinderGoals(where: {userId: {_eq: $userId}}) {
    affectedRows
  }
  insertUserPlayerFinderGoals(objects: $goals) {
    affectedRows
  }
}
    `;
export type SavePlayerFinderGoalsMutationFn = Apollo.MutationFunction<SavePlayerFinderGoalsMutation, SavePlayerFinderGoalsMutationVariables>;

/**
 * __useSavePlayerFinderGoalsMutation__
 *
 * To run a mutation, you first call `useSavePlayerFinderGoalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlayerFinderGoalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlayerFinderGoalsMutation, { data, loading, error }] = useSavePlayerFinderGoalsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      goals: // value for 'goals'
 *   },
 * });
 */
export function useSavePlayerFinderGoalsMutation(baseOptions?: Apollo.MutationHookOptions<SavePlayerFinderGoalsMutation, SavePlayerFinderGoalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePlayerFinderGoalsMutation, SavePlayerFinderGoalsMutationVariables>(SavePlayerFinderGoalsDocument, options);
      }
export type SavePlayerFinderGoalsMutationHookResult = ReturnType<typeof useSavePlayerFinderGoalsMutation>;
export type SavePlayerFinderGoalsMutationResult = Apollo.MutationResult<SavePlayerFinderGoalsMutation>;
export type SavePlayerFinderGoalsMutationOptions = Apollo.BaseMutationOptions<SavePlayerFinderGoalsMutation, SavePlayerFinderGoalsMutationVariables>;
export const SavePlayerSportsDocument = gql`
    mutation SavePlayerSports($userId: uuid!, $sports: [UserSportsInsertInput!]!) {
  deleteUserSports(where: {userId: {_eq: $userId}}) {
    affectedRows
  }
  insertUserSports(objects: $sports) {
    affectedRows
  }
}
    `;
export type SavePlayerSportsMutationFn = Apollo.MutationFunction<SavePlayerSportsMutation, SavePlayerSportsMutationVariables>;

/**
 * __useSavePlayerSportsMutation__
 *
 * To run a mutation, you first call `useSavePlayerSportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlayerSportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlayerSportsMutation, { data, loading, error }] = useSavePlayerSportsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      sports: // value for 'sports'
 *   },
 * });
 */
export function useSavePlayerSportsMutation(baseOptions?: Apollo.MutationHookOptions<SavePlayerSportsMutation, SavePlayerSportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePlayerSportsMutation, SavePlayerSportsMutationVariables>(SavePlayerSportsDocument, options);
      }
export type SavePlayerSportsMutationHookResult = ReturnType<typeof useSavePlayerSportsMutation>;
export type SavePlayerSportsMutationResult = Apollo.MutationResult<SavePlayerSportsMutation>;
export type SavePlayerSportsMutationOptions = Apollo.BaseMutationOptions<SavePlayerSportsMutation, SavePlayerSportsMutationVariables>;
export const GetPlayerFinderProfileDocument = gql`
    query GetPlayerFinderProfile($id: uuid!) {
  usersByPk(id: $id) {
    id
    aboutMe
    gender
    birthday
    birthdayVisibility
    instagramUrl
    facebookUrl
    tiktokUrl
    linkedinUrl
    xUrl
    profileImageFileName
    profileImagePath
    profileImageProvider
    profileImageProviderId
    profileImageProviderUrl
    profileImageUrl
    pickleballSkillLevelId
    tennisSkillLevelId
    padelSkillLevelId
  }
  userPlayerFinderGoals(where: {userId: {_eq: $id}}) {
    goal
  }
  userSports(where: {userId: {_eq: $id}}) {
    sport
  }
  userPickleballRatingScales(where: {userId: {_eq: $id}}) {
    rating
    scale {
      shortName
    }
  }
  userTennisRatingScales(where: {userId: {_eq: $id}}) {
    rating
    scale {
      shortName
    }
  }
  userPadelRatingScales(where: {userId: {_eq: $id}}) {
    rating
    scale {
      shortName
    }
  }
  userPlayerFinderAvailability(where: {userId: {_eq: $id}}) {
    dayOfWeek
    timeOfDay
  }
  userIdentityVerifications(
    where: {userId: {_eq: $id}, status: {_eq: VERIFIED}}
    limit: 1
  ) {
    id
  }
  userFiles(where: {userId: {_eq: $id}, fileCategory: {_eq: PLAYER_GALLERY}}) {
    id
    fileName
    originalFileName
    path
    provider
    providerUrl
    url
    fileType
    host
  }
  venueFollows(where: {userId: {_eq: $id}, status: {_eq: ACTIVE}}) {
    venue {
      id
      title
      addressString
      latitude
      longitude
      indoorCourtCount
      outdoorCourtCount
      pickleballNets
      accessType
      timezone
      city {
        name
        countrySubdivision {
          name
        }
      }
      images(where: {isVisible: {_eq: true}}, orderBy: {isCover: DESC}, limit: 1) {
        url
      }
    }
  }
}
    `;

/**
 * __useGetPlayerFinderProfileQuery__
 *
 * To run a query within a React component, call `useGetPlayerFinderProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerFinderProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerFinderProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlayerFinderProfileQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerFinderProfileQuery, GetPlayerFinderProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerFinderProfileQuery, GetPlayerFinderProfileQueryVariables>(GetPlayerFinderProfileDocument, options);
      }
export function useGetPlayerFinderProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerFinderProfileQuery, GetPlayerFinderProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerFinderProfileQuery, GetPlayerFinderProfileQueryVariables>(GetPlayerFinderProfileDocument, options);
        }
export type GetPlayerFinderProfileQueryHookResult = ReturnType<typeof useGetPlayerFinderProfileQuery>;
export type GetPlayerFinderProfileLazyQueryHookResult = ReturnType<typeof useGetPlayerFinderProfileLazyQuery>;
export type GetPlayerFinderProfileQueryResult = Apollo.QueryResult<GetPlayerFinderProfileQuery, GetPlayerFinderProfileQueryVariables>;
export const GetPlayerFinderRatingScalesDocument = gql`
    query GetPlayerFinderRatingScales {
  pickleballRatingScales(where: {deletedAt: {_isNull: true}}) {
    id
    shortName
  }
  tennisRatingScales(where: {deletedAt: {_isNull: true}}) {
    id
    shortName
  }
  padelRatingScales(where: {deletedAt: {_isNull: true}}) {
    id
    shortName
  }
}
    `;

/**
 * __useGetPlayerFinderRatingScalesQuery__
 *
 * To run a query within a React component, call `useGetPlayerFinderRatingScalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerFinderRatingScalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerFinderRatingScalesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlayerFinderRatingScalesQuery(baseOptions?: Apollo.QueryHookOptions<GetPlayerFinderRatingScalesQuery, GetPlayerFinderRatingScalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerFinderRatingScalesQuery, GetPlayerFinderRatingScalesQueryVariables>(GetPlayerFinderRatingScalesDocument, options);
      }
export function useGetPlayerFinderRatingScalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerFinderRatingScalesQuery, GetPlayerFinderRatingScalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerFinderRatingScalesQuery, GetPlayerFinderRatingScalesQueryVariables>(GetPlayerFinderRatingScalesDocument, options);
        }
export type GetPlayerFinderRatingScalesQueryHookResult = ReturnType<typeof useGetPlayerFinderRatingScalesQuery>;
export type GetPlayerFinderRatingScalesLazyQueryHookResult = ReturnType<typeof useGetPlayerFinderRatingScalesLazyQuery>;
export type GetPlayerFinderRatingScalesQueryResult = Apollo.QueryResult<GetPlayerFinderRatingScalesQuery, GetPlayerFinderRatingScalesQueryVariables>;
export const SavePlayerRatingScalesDocument = gql`
    mutation SavePlayerRatingScales($pickleball: [UserPickleballRatingScalesInsertInput!]!, $tennis: [UserTennisRatingScalesInsertInput!]!, $padel: [UserPadelRatingScalesInsertInput!]!) {
  insertUserPickleballRatingScales(
    objects: $pickleball
    onConflict: {constraint: user_pickleball_rating_scales_user_id_pickleball_rating_sca_key, updateColumns: rating}
  ) {
    affectedRows
  }
  insertUserTennisRatingScales(
    objects: $tennis
    onConflict: {constraint: user_tennis_rating_scales_user_id_tennis_rating_scale_id_key, updateColumns: rating}
  ) {
    affectedRows
  }
  insertUserPadelRatingScales(
    objects: $padel
    onConflict: {constraint: user_padel_rating_scales_user_id_padel_rating_scale_id_key, updateColumns: rating}
  ) {
    affectedRows
  }
}
    `;
export type SavePlayerRatingScalesMutationFn = Apollo.MutationFunction<SavePlayerRatingScalesMutation, SavePlayerRatingScalesMutationVariables>;

/**
 * __useSavePlayerRatingScalesMutation__
 *
 * To run a mutation, you first call `useSavePlayerRatingScalesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlayerRatingScalesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlayerRatingScalesMutation, { data, loading, error }] = useSavePlayerRatingScalesMutation({
 *   variables: {
 *      pickleball: // value for 'pickleball'
 *      tennis: // value for 'tennis'
 *      padel: // value for 'padel'
 *   },
 * });
 */
export function useSavePlayerRatingScalesMutation(baseOptions?: Apollo.MutationHookOptions<SavePlayerRatingScalesMutation, SavePlayerRatingScalesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePlayerRatingScalesMutation, SavePlayerRatingScalesMutationVariables>(SavePlayerRatingScalesDocument, options);
      }
export type SavePlayerRatingScalesMutationHookResult = ReturnType<typeof useSavePlayerRatingScalesMutation>;
export type SavePlayerRatingScalesMutationResult = Apollo.MutationResult<SavePlayerRatingScalesMutation>;
export type SavePlayerRatingScalesMutationOptions = Apollo.BaseMutationOptions<SavePlayerRatingScalesMutation, SavePlayerRatingScalesMutationVariables>;
export const SavePlayerFinderAvailabilityDocument = gql`
    mutation SavePlayerFinderAvailability($userId: uuid!, $windows: [UserPlayerFinderAvailabilityInsertInput!]!) {
  deleteUserPlayerFinderAvailability(where: {userId: {_eq: $userId}}) {
    affectedRows
  }
  insertUserPlayerFinderAvailability(objects: $windows) {
    affectedRows
  }
}
    `;
export type SavePlayerFinderAvailabilityMutationFn = Apollo.MutationFunction<SavePlayerFinderAvailabilityMutation, SavePlayerFinderAvailabilityMutationVariables>;

/**
 * __useSavePlayerFinderAvailabilityMutation__
 *
 * To run a mutation, you first call `useSavePlayerFinderAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlayerFinderAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlayerFinderAvailabilityMutation, { data, loading, error }] = useSavePlayerFinderAvailabilityMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      windows: // value for 'windows'
 *   },
 * });
 */
export function useSavePlayerFinderAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<SavePlayerFinderAvailabilityMutation, SavePlayerFinderAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePlayerFinderAvailabilityMutation, SavePlayerFinderAvailabilityMutationVariables>(SavePlayerFinderAvailabilityDocument, options);
      }
export type SavePlayerFinderAvailabilityMutationHookResult = ReturnType<typeof useSavePlayerFinderAvailabilityMutation>;
export type SavePlayerFinderAvailabilityMutationResult = Apollo.MutationResult<SavePlayerFinderAvailabilityMutation>;
export type SavePlayerFinderAvailabilityMutationOptions = Apollo.BaseMutationOptions<SavePlayerFinderAvailabilityMutation, SavePlayerFinderAvailabilityMutationVariables>;
export const InsertPlayerGalleryPhotosDocument = gql`
    mutation InsertPlayerGalleryPhotos($files: [UserFilesInsertInput!]!) {
  insertUserFiles(objects: $files) {
    affectedRows
  }
}
    `;
export type InsertPlayerGalleryPhotosMutationFn = Apollo.MutationFunction<InsertPlayerGalleryPhotosMutation, InsertPlayerGalleryPhotosMutationVariables>;

/**
 * __useInsertPlayerGalleryPhotosMutation__
 *
 * To run a mutation, you first call `useInsertPlayerGalleryPhotosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPlayerGalleryPhotosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPlayerGalleryPhotosMutation, { data, loading, error }] = useInsertPlayerGalleryPhotosMutation({
 *   variables: {
 *      files: // value for 'files'
 *   },
 * });
 */
export function useInsertPlayerGalleryPhotosMutation(baseOptions?: Apollo.MutationHookOptions<InsertPlayerGalleryPhotosMutation, InsertPlayerGalleryPhotosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPlayerGalleryPhotosMutation, InsertPlayerGalleryPhotosMutationVariables>(InsertPlayerGalleryPhotosDocument, options);
      }
export type InsertPlayerGalleryPhotosMutationHookResult = ReturnType<typeof useInsertPlayerGalleryPhotosMutation>;
export type InsertPlayerGalleryPhotosMutationResult = Apollo.MutationResult<InsertPlayerGalleryPhotosMutation>;
export type InsertPlayerGalleryPhotosMutationOptions = Apollo.BaseMutationOptions<InsertPlayerGalleryPhotosMutation, InsertPlayerGalleryPhotosMutationVariables>;
export const SavePreferredVenuesDocument = gql`
    mutation SavePreferredVenues($venues: [VenueFollowsInsertInput!]!) {
  insertVenueFollows(
    objects: $venues
    onConflict: {constraint: venue_follows_venue_id_user_id_key, updateColumns: status}
  ) {
    affectedRows
  }
}
    `;
export type SavePreferredVenuesMutationFn = Apollo.MutationFunction<SavePreferredVenuesMutation, SavePreferredVenuesMutationVariables>;

/**
 * __useSavePreferredVenuesMutation__
 *
 * To run a mutation, you first call `useSavePreferredVenuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePreferredVenuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePreferredVenuesMutation, { data, loading, error }] = useSavePreferredVenuesMutation({
 *   variables: {
 *      venues: // value for 'venues'
 *   },
 * });
 */
export function useSavePreferredVenuesMutation(baseOptions?: Apollo.MutationHookOptions<SavePreferredVenuesMutation, SavePreferredVenuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePreferredVenuesMutation, SavePreferredVenuesMutationVariables>(SavePreferredVenuesDocument, options);
      }
export type SavePreferredVenuesMutationHookResult = ReturnType<typeof useSavePreferredVenuesMutation>;
export type SavePreferredVenuesMutationResult = Apollo.MutationResult<SavePreferredVenuesMutation>;
export type SavePreferredVenuesMutationOptions = Apollo.BaseMutationOptions<SavePreferredVenuesMutation, SavePreferredVenuesMutationVariables>;
export const DeactivatePreferredVenuesDocument = gql`
    mutation DeactivatePreferredVenues($userId: uuid!, $venueIds: [uuid!]!) {
  updateVenueFollows(
    where: {userId: {_eq: $userId}, venueId: {_in: $venueIds}}
    _set: {status: INACTIVE}
  ) {
    affectedRows
  }
}
    `;
export type DeactivatePreferredVenuesMutationFn = Apollo.MutationFunction<DeactivatePreferredVenuesMutation, DeactivatePreferredVenuesMutationVariables>;

/**
 * __useDeactivatePreferredVenuesMutation__
 *
 * To run a mutation, you first call `useDeactivatePreferredVenuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivatePreferredVenuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivatePreferredVenuesMutation, { data, loading, error }] = useDeactivatePreferredVenuesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      venueIds: // value for 'venueIds'
 *   },
 * });
 */
export function useDeactivatePreferredVenuesMutation(baseOptions?: Apollo.MutationHookOptions<DeactivatePreferredVenuesMutation, DeactivatePreferredVenuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivatePreferredVenuesMutation, DeactivatePreferredVenuesMutationVariables>(DeactivatePreferredVenuesDocument, options);
      }
export type DeactivatePreferredVenuesMutationHookResult = ReturnType<typeof useDeactivatePreferredVenuesMutation>;
export type DeactivatePreferredVenuesMutationResult = Apollo.MutationResult<DeactivatePreferredVenuesMutation>;
export type DeactivatePreferredVenuesMutationOptions = Apollo.BaseMutationOptions<DeactivatePreferredVenuesMutation, DeactivatePreferredVenuesMutationVariables>;
export const DeletePlayerGalleryPhotosDocument = gql`
    mutation DeletePlayerGalleryPhotos($ids: [uuid!]!) {
  deleteUserFiles(where: {id: {_in: $ids}}) {
    affectedRows
  }
}
    `;
export type DeletePlayerGalleryPhotosMutationFn = Apollo.MutationFunction<DeletePlayerGalleryPhotosMutation, DeletePlayerGalleryPhotosMutationVariables>;

/**
 * __useDeletePlayerGalleryPhotosMutation__
 *
 * To run a mutation, you first call `useDeletePlayerGalleryPhotosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlayerGalleryPhotosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlayerGalleryPhotosMutation, { data, loading, error }] = useDeletePlayerGalleryPhotosMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeletePlayerGalleryPhotosMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlayerGalleryPhotosMutation, DeletePlayerGalleryPhotosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlayerGalleryPhotosMutation, DeletePlayerGalleryPhotosMutationVariables>(DeletePlayerGalleryPhotosDocument, options);
      }
export type DeletePlayerGalleryPhotosMutationHookResult = ReturnType<typeof useDeletePlayerGalleryPhotosMutation>;
export type DeletePlayerGalleryPhotosMutationResult = Apollo.MutationResult<DeletePlayerGalleryPhotosMutation>;
export type DeletePlayerGalleryPhotosMutationOptions = Apollo.BaseMutationOptions<DeletePlayerGalleryPhotosMutation, DeletePlayerGalleryPhotosMutationVariables>;
export const GetQuatroLessonByIdDocument = gql`
    query getQuatroLessonById($id: uuid!) {
  lessons(where: {id: {_eq: $id}}) {
    ...lessonFields
  }
}
    ${LessonFieldsFragmentDoc}`;

/**
 * __useGetQuatroLessonByIdQuery__
 *
 * To run a query within a React component, call `useGetQuatroLessonByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuatroLessonByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuatroLessonByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuatroLessonByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuatroLessonByIdQuery, GetQuatroLessonByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuatroLessonByIdQuery, GetQuatroLessonByIdQueryVariables>(GetQuatroLessonByIdDocument, options);
      }
export function useGetQuatroLessonByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuatroLessonByIdQuery, GetQuatroLessonByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuatroLessonByIdQuery, GetQuatroLessonByIdQueryVariables>(GetQuatroLessonByIdDocument, options);
        }
export type GetQuatroLessonByIdQueryHookResult = ReturnType<typeof useGetQuatroLessonByIdQuery>;
export type GetQuatroLessonByIdLazyQueryHookResult = ReturnType<typeof useGetQuatroLessonByIdLazyQuery>;
export type GetQuatroLessonByIdQueryResult = Apollo.QueryResult<GetQuatroLessonByIdQuery, GetQuatroLessonByIdQueryVariables>;
export const GetUserGroupsDocument = gql`
    query getUserGroups($id: uuid!) {
  usersByPk(id: $id) {
    id
    groups(where: {isActive: {_eq: true}}) {
      id
      isActive
      groupId
    }
  }
}
    `;

/**
 * __useGetUserGroupsQuery__
 *
 * To run a query within a React component, call `useGetUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGroupsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
      }
export function useGetUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
        }
export type GetUserGroupsQueryHookResult = ReturnType<typeof useGetUserGroupsQuery>;
export type GetUserGroupsLazyQueryHookResult = ReturnType<typeof useGetUserGroupsLazyQuery>;
export type GetUserGroupsQueryResult = Apollo.QueryResult<GetUserGroupsQuery, GetUserGroupsQueryVariables>;
export const GetGroupByIdDocument = gql`
    query getGroupById($id: uuid!, $userId: uuid!) {
  groupsByPk(id: $id) {
    contactMessage
    contactUrl
    coverPhotoUrl
    createdAt
    description
    displayOwnerContactInfo
    headline
    id
    isPrivate
    ownerUserId
    profilePhotoUrl
    skillLevelMaximum
    skillLevelMinimum
    slug
    title
    allowMemberInvites
    allowMemberSessionInvites
    accessCode
    city {
      id
      name
    }
    threads(orderBy: {createdAt: DESC}, limit: 50) {
      createdAt
      id
      comments(orderBy: {createdAt: ASC}, limit: 1) {
        createdAt
        content
        groupCommentId
        groupRootCommentId
        groupThreadId
        id
        isOriginalThreadComment
        votesAggregate(where: {vote: {_eq: POSITIVE}}) {
          aggregate {
            count
          }
        }
        userProfile {
          id
          fullName
          preferredName
          profileImagePath
          username
          defaultSport
        }
        votes(where: {userId: {_eq: $userId}}) {
          id
          userId
          groupThreadCommentId
          vote
        }
        files {
          id
          url
          path
        }
      }
      commentsAggregate {
        aggregate {
          count
        }
      }
    }
    membersAggregate {
      aggregate {
        count
      }
    }
    ownerUserProfile {
      id
      fullName
      profileImagePath
    }
    venuesAggregate(where: {venue: {isActive: {_eq: true}}}) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetGroupByIdQuery__
 *
 * To run a query within a React component, call `useGetGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<GetGroupByIdQuery, GetGroupByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupByIdQuery, GetGroupByIdQueryVariables>(GetGroupByIdDocument, options);
      }
export function useGetGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupByIdQuery, GetGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupByIdQuery, GetGroupByIdQueryVariables>(GetGroupByIdDocument, options);
        }
export type GetGroupByIdQueryHookResult = ReturnType<typeof useGetGroupByIdQuery>;
export type GetGroupByIdLazyQueryHookResult = ReturnType<typeof useGetGroupByIdLazyQuery>;
export type GetGroupByIdQueryResult = Apollo.QueryResult<GetGroupByIdQuery, GetGroupByIdQueryVariables>;
export const InsertThreadWithCommentDocument = gql`
    mutation insertThreadWithComment($groupId: uuid!, $userId: uuid!, $content: String = "", $files: [GroupThreadCommentFilesInsertInput!] = []) {
  insertGroupThreadsOne(
    object: {groupId: $groupId, userId: $userId, comments: {data: {userId: $userId, votes: {data: {vote: POSITIVE, userId: $userId}}, isOriginalThreadComment: true, content: $content, files: {data: $files}}}}
  ) {
    id
  }
}
    `;
export type InsertThreadWithCommentMutationFn = Apollo.MutationFunction<InsertThreadWithCommentMutation, InsertThreadWithCommentMutationVariables>;

/**
 * __useInsertThreadWithCommentMutation__
 *
 * To run a mutation, you first call `useInsertThreadWithCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertThreadWithCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertThreadWithCommentMutation, { data, loading, error }] = useInsertThreadWithCommentMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *      content: // value for 'content'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useInsertThreadWithCommentMutation(baseOptions?: Apollo.MutationHookOptions<InsertThreadWithCommentMutation, InsertThreadWithCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertThreadWithCommentMutation, InsertThreadWithCommentMutationVariables>(InsertThreadWithCommentDocument, options);
      }
export type InsertThreadWithCommentMutationHookResult = ReturnType<typeof useInsertThreadWithCommentMutation>;
export type InsertThreadWithCommentMutationResult = Apollo.MutationResult<InsertThreadWithCommentMutation>;
export type InsertThreadWithCommentMutationOptions = Apollo.BaseMutationOptions<InsertThreadWithCommentMutation, InsertThreadWithCommentMutationVariables>;
export const UpdateCommentFileAsDeletedDocument = gql`
    mutation updateCommentFileAsDeleted($id: uuid!) {
  updateGroupThreadCommentFilesByPk(
    pkColumns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
    deletedAt
  }
}
    `;
export type UpdateCommentFileAsDeletedMutationFn = Apollo.MutationFunction<UpdateCommentFileAsDeletedMutation, UpdateCommentFileAsDeletedMutationVariables>;

/**
 * __useUpdateCommentFileAsDeletedMutation__
 *
 * To run a mutation, you first call `useUpdateCommentFileAsDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentFileAsDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentFileAsDeletedMutation, { data, loading, error }] = useUpdateCommentFileAsDeletedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCommentFileAsDeletedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentFileAsDeletedMutation, UpdateCommentFileAsDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentFileAsDeletedMutation, UpdateCommentFileAsDeletedMutationVariables>(UpdateCommentFileAsDeletedDocument, options);
      }
export type UpdateCommentFileAsDeletedMutationHookResult = ReturnType<typeof useUpdateCommentFileAsDeletedMutation>;
export type UpdateCommentFileAsDeletedMutationResult = Apollo.MutationResult<UpdateCommentFileAsDeletedMutation>;
export type UpdateCommentFileAsDeletedMutationOptions = Apollo.BaseMutationOptions<UpdateCommentFileAsDeletedMutation, UpdateCommentFileAsDeletedMutationVariables>;
export const GetGroupDiscussionsDocument = gql`
    query getGroupDiscussions($groupId: uuid!, $userId: uuid!) {
  groupThreads(where: {groupId: {_eq: $groupId}}, orderBy: {createdAt: DESC}) {
    id
    createdAt
    comments(where: {isOriginalThreadComment: {_eq: true}}, limit: 1) {
      id
      content
      createdAt
      groupCommentId
      groupRootCommentId
      isOriginalThreadComment
      updatedAt
      userId
      userProfile {
        id
        fullName
        preferredName
        profileImagePath
        username
      }
      votesAggregate(where: {vote: {_eq: POSITIVE}}) {
        aggregate {
          count
        }
      }
      votes(where: {userId: {_eq: $userId}}) {
        id
        userId
        groupThreadCommentId
        vote
      }
      files {
        id
        url
        path
      }
    }
    commentsAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetGroupDiscussionsQuery__
 *
 * To run a query within a React component, call `useGetGroupDiscussionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupDiscussionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupDiscussionsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetGroupDiscussionsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupDiscussionsQuery, GetGroupDiscussionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupDiscussionsQuery, GetGroupDiscussionsQueryVariables>(GetGroupDiscussionsDocument, options);
      }
export function useGetGroupDiscussionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupDiscussionsQuery, GetGroupDiscussionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupDiscussionsQuery, GetGroupDiscussionsQueryVariables>(GetGroupDiscussionsDocument, options);
        }
export type GetGroupDiscussionsQueryHookResult = ReturnType<typeof useGetGroupDiscussionsQuery>;
export type GetGroupDiscussionsLazyQueryHookResult = ReturnType<typeof useGetGroupDiscussionsLazyQuery>;
export type GetGroupDiscussionsQueryResult = Apollo.QueryResult<GetGroupDiscussionsQuery, GetGroupDiscussionsQueryVariables>;
export const GetGroupDiscussionsAnonymousDocument = gql`
    query getGroupDiscussionsAnonymous($groupId: uuid!) {
  groupThreads(where: {groupId: {_eq: $groupId}}, orderBy: {createdAt: DESC}) {
    id
    createdAt
    comments(where: {isOriginalThreadComment: {_eq: true}}, limit: 1) {
      id
      content
      createdAt
      groupCommentId
      groupRootCommentId
      isOriginalThreadComment
      updatedAt
      userId
      userProfile {
        id
        fullName
        preferredName
        profileImagePath
        username
      }
      votesAggregate(where: {vote: {_eq: POSITIVE}}) {
        aggregate {
          count
        }
      }
      files {
        id
        url
        path
      }
    }
    commentsAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetGroupDiscussionsAnonymousQuery__
 *
 * To run a query within a React component, call `useGetGroupDiscussionsAnonymousQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupDiscussionsAnonymousQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupDiscussionsAnonymousQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetGroupDiscussionsAnonymousQuery(baseOptions: Apollo.QueryHookOptions<GetGroupDiscussionsAnonymousQuery, GetGroupDiscussionsAnonymousQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupDiscussionsAnonymousQuery, GetGroupDiscussionsAnonymousQueryVariables>(GetGroupDiscussionsAnonymousDocument, options);
      }
export function useGetGroupDiscussionsAnonymousLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupDiscussionsAnonymousQuery, GetGroupDiscussionsAnonymousQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupDiscussionsAnonymousQuery, GetGroupDiscussionsAnonymousQueryVariables>(GetGroupDiscussionsAnonymousDocument, options);
        }
export type GetGroupDiscussionsAnonymousQueryHookResult = ReturnType<typeof useGetGroupDiscussionsAnonymousQuery>;
export type GetGroupDiscussionsAnonymousLazyQueryHookResult = ReturnType<typeof useGetGroupDiscussionsAnonymousLazyQuery>;
export type GetGroupDiscussionsAnonymousQueryResult = Apollo.QueryResult<GetGroupDiscussionsAnonymousQuery, GetGroupDiscussionsAnonymousQueryVariables>;
export const GetGroupBySlugDocument = gql`
    query getGroupBySlug($slug: String!) {
  groups(where: {slug: {_eq: $slug}}, limit: 1) {
    id
    title
    slug
    isPrivate
  }
}
    `;

/**
 * __useGetGroupBySlugQuery__
 *
 * To run a query within a React component, call `useGetGroupBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetGroupBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetGroupBySlugQuery, GetGroupBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupBySlugQuery, GetGroupBySlugQueryVariables>(GetGroupBySlugDocument, options);
      }
export function useGetGroupBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupBySlugQuery, GetGroupBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupBySlugQuery, GetGroupBySlugQueryVariables>(GetGroupBySlugDocument, options);
        }
export type GetGroupBySlugQueryHookResult = ReturnType<typeof useGetGroupBySlugQuery>;
export type GetGroupBySlugLazyQueryHookResult = ReturnType<typeof useGetGroupBySlugLazyQuery>;
export type GetGroupBySlugQueryResult = Apollo.QueryResult<GetGroupBySlugQuery, GetGroupBySlugQueryVariables>;
export const GetGroupMembersDocument = gql`
    query getGroupMembers($id: uuid!) {
  groupsByPk(id: $id) {
    id
    members {
      userProfile {
        id
        preferredName
        fullName
        profileImagePath
        username
      }
    }
  }
}
    `;

/**
 * __useGetGroupMembersQuery__
 *
 * To run a query within a React component, call `useGetGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupMembersQuery(baseOptions: Apollo.QueryHookOptions<GetGroupMembersQuery, GetGroupMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupMembersQuery, GetGroupMembersQueryVariables>(GetGroupMembersDocument, options);
      }
export function useGetGroupMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupMembersQuery, GetGroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupMembersQuery, GetGroupMembersQueryVariables>(GetGroupMembersDocument, options);
        }
export type GetGroupMembersQueryHookResult = ReturnType<typeof useGetGroupMembersQuery>;
export type GetGroupMembersLazyQueryHookResult = ReturnType<typeof useGetGroupMembersLazyQuery>;
export type GetGroupMembersQueryResult = Apollo.QueryResult<GetGroupMembersQuery, GetGroupMembersQueryVariables>;
export const GetUserGroupMembershipDocument = gql`
    query getUserGroupMembership($userId: uuid!, $groupId: uuid!) {
  groupMembers(where: {userId: {_eq: $userId}, groupId: {_eq: $groupId}}) {
    id
    userId
    isActive
  }
}
    `;

/**
 * __useGetUserGroupMembershipQuery__
 *
 * To run a query within a React component, call `useGetUserGroupMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGroupMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGroupMembershipQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetUserGroupMembershipQuery(baseOptions: Apollo.QueryHookOptions<GetUserGroupMembershipQuery, GetUserGroupMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserGroupMembershipQuery, GetUserGroupMembershipQueryVariables>(GetUserGroupMembershipDocument, options);
      }
export function useGetUserGroupMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserGroupMembershipQuery, GetUserGroupMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserGroupMembershipQuery, GetUserGroupMembershipQueryVariables>(GetUserGroupMembershipDocument, options);
        }
export type GetUserGroupMembershipQueryHookResult = ReturnType<typeof useGetUserGroupMembershipQuery>;
export type GetUserGroupMembershipLazyQueryHookResult = ReturnType<typeof useGetUserGroupMembershipLazyQuery>;
export type GetUserGroupMembershipQueryResult = Apollo.QueryResult<GetUserGroupMembershipQuery, GetUserGroupMembershipQueryVariables>;
export const UpsertUsersGroupMembershipDocument = gql`
    mutation upsertUsersGroupMembership($userId: uuid, $groupId: uuid!, $isActive: Boolean!) {
  insertGroupMembersOne(
    object: {userId: $userId, groupId: $groupId, isActive: $isActive}
    onConflict: {constraint: group_members_group_id_user_id_key, updateColumns: isActive}
  ) {
    userId
    groupId
    isActive
  }
}
    `;
export type UpsertUsersGroupMembershipMutationFn = Apollo.MutationFunction<UpsertUsersGroupMembershipMutation, UpsertUsersGroupMembershipMutationVariables>;

/**
 * __useUpsertUsersGroupMembershipMutation__
 *
 * To run a mutation, you first call `useUpsertUsersGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUsersGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUsersGroupMembershipMutation, { data, loading, error }] = useUpsertUsersGroupMembershipMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useUpsertUsersGroupMembershipMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUsersGroupMembershipMutation, UpsertUsersGroupMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUsersGroupMembershipMutation, UpsertUsersGroupMembershipMutationVariables>(UpsertUsersGroupMembershipDocument, options);
      }
export type UpsertUsersGroupMembershipMutationHookResult = ReturnType<typeof useUpsertUsersGroupMembershipMutation>;
export type UpsertUsersGroupMembershipMutationResult = Apollo.MutationResult<UpsertUsersGroupMembershipMutation>;
export type UpsertUsersGroupMembershipMutationOptions = Apollo.BaseMutationOptions<UpsertUsersGroupMembershipMutation, UpsertUsersGroupMembershipMutationVariables>;
export const GetGroupPageContentByGroupSlugDocument = gql`
    query getGroupPageContentByGroupSlug($groupId: uuid!) {
  groups(where: {id: {_eq: $groupId}}) {
    id
    members(
      where: {isActive: {_eq: true}, userProfile: {coachStatus: {_eq: "ACTIVE"}}}
    ) {
      id
      userProfile {
        coachStatus
        aboutMe
        cityName
        fullName
        id
        geometry
        priceUnitAmountCoachDefault
        username
        profileImagePath
        profileImageFileName
        profileImageProviderUrl
        currencyCoachDefault
        stripeMerchantCurrency
      }
    }
    membersAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetGroupPageContentByGroupSlugQuery__
 *
 * To run a query within a React component, call `useGetGroupPageContentByGroupSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupPageContentByGroupSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupPageContentByGroupSlugQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetGroupPageContentByGroupSlugQuery(baseOptions: Apollo.QueryHookOptions<GetGroupPageContentByGroupSlugQuery, GetGroupPageContentByGroupSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupPageContentByGroupSlugQuery, GetGroupPageContentByGroupSlugQueryVariables>(GetGroupPageContentByGroupSlugDocument, options);
      }
export function useGetGroupPageContentByGroupSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupPageContentByGroupSlugQuery, GetGroupPageContentByGroupSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupPageContentByGroupSlugQuery, GetGroupPageContentByGroupSlugQueryVariables>(GetGroupPageContentByGroupSlugDocument, options);
        }
export type GetGroupPageContentByGroupSlugQueryHookResult = ReturnType<typeof useGetGroupPageContentByGroupSlugQuery>;
export type GetGroupPageContentByGroupSlugLazyQueryHookResult = ReturnType<typeof useGetGroupPageContentByGroupSlugLazyQuery>;
export type GetGroupPageContentByGroupSlugQueryResult = Apollo.QueryResult<GetGroupPageContentByGroupSlugQuery, GetGroupPageContentByGroupSlugQueryVariables>;
export const GetGroupsDocument = gql`
    query getGroups($limit: Int!, $distance: Float!, $from: geography!) {
  groups(
    where: {geometry: {_stDWithin: {distance: $distance, from: $from}}, isPrivate: {_eq: false}}
    limit: $limit
  ) {
    id
    slug
    membersAggregate {
      aggregate {
        count
      }
    }
    memberDisplayCount
    members(
      where: {isActive: {_eq: true}, userProfile: {coachStatus: {_eq: "ACTIVE"}}}
    ) {
      id
      userProfile {
        preferredName
        id
      }
    }
    profilePhotoProviderUrl
    events {
      id
    }
    title
    addressString
    latitude
    longitude
  }
}
    `;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetGroupRecentCommentsDocument = gql`
    query getGroupRecentComments($groupId: uuid!, $limit: Int!, $userId: uuid) {
  groupThreads(
    where: {groupId: {_eq: $groupId}}
    orderBy: {commentsAggregate: {max: {createdAt: DESC}}}
    limit: $limit
  ) {
    id
    comments(
      orderBy: {createdAt: DESC}
      limit: 1
      where: {isOriginalThreadComment: {_eq: true}}
    ) {
      id
      content
      createdAt
      groupCommentId
      groupRootCommentId
      isOriginalThreadComment
      updatedAt
      userId
      userProfile {
        id
        fullName
        preferredName
        profileImagePath
        username
      }
      votesAggregate(where: {vote: {_eq: POSITIVE}}) {
        aggregate {
          count
        }
      }
      votes(where: {userId: {_eq: $userId}}) {
        id
        userId
        groupThreadCommentId
        vote
      }
      files {
        id
        url
        path
      }
    }
    commentsAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetGroupRecentCommentsQuery__
 *
 * To run a query within a React component, call `useGetGroupRecentCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupRecentCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupRecentCommentsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      limit: // value for 'limit'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetGroupRecentCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupRecentCommentsQuery, GetGroupRecentCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupRecentCommentsQuery, GetGroupRecentCommentsQueryVariables>(GetGroupRecentCommentsDocument, options);
      }
export function useGetGroupRecentCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupRecentCommentsQuery, GetGroupRecentCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupRecentCommentsQuery, GetGroupRecentCommentsQueryVariables>(GetGroupRecentCommentsDocument, options);
        }
export type GetGroupRecentCommentsQueryHookResult = ReturnType<typeof useGetGroupRecentCommentsQuery>;
export type GetGroupRecentCommentsLazyQueryHookResult = ReturnType<typeof useGetGroupRecentCommentsLazyQuery>;
export type GetGroupRecentCommentsQueryResult = Apollo.QueryResult<GetGroupRecentCommentsQuery, GetGroupRecentCommentsQueryVariables>;
export const GetGroupRecentCommentsAnonymousDocument = gql`
    query getGroupRecentCommentsAnonymous($groupId: uuid!, $limit: Int!) {
  groupThreads(
    where: {groupId: {_eq: $groupId}}
    orderBy: {commentsAggregate: {max: {createdAt: DESC}}}
    limit: $limit
  ) {
    id
    comments(
      orderBy: {createdAt: DESC}
      limit: 1
      where: {isOriginalThreadComment: {_eq: true}}
    ) {
      id
      content
      createdAt
      groupCommentId
      groupRootCommentId
      isOriginalThreadComment
      updatedAt
      userId
      userProfile {
        id
        fullName
        preferredName
        profileImagePath
        username
      }
      votesAggregate(where: {vote: {_eq: POSITIVE}}) {
        aggregate {
          count
        }
      }
      files {
        id
        url
        path
      }
    }
    commentsAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetGroupRecentCommentsAnonymousQuery__
 *
 * To run a query within a React component, call `useGetGroupRecentCommentsAnonymousQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupRecentCommentsAnonymousQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupRecentCommentsAnonymousQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGroupRecentCommentsAnonymousQuery(baseOptions: Apollo.QueryHookOptions<GetGroupRecentCommentsAnonymousQuery, GetGroupRecentCommentsAnonymousQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupRecentCommentsAnonymousQuery, GetGroupRecentCommentsAnonymousQueryVariables>(GetGroupRecentCommentsAnonymousDocument, options);
      }
export function useGetGroupRecentCommentsAnonymousLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupRecentCommentsAnonymousQuery, GetGroupRecentCommentsAnonymousQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupRecentCommentsAnonymousQuery, GetGroupRecentCommentsAnonymousQueryVariables>(GetGroupRecentCommentsAnonymousDocument, options);
        }
export type GetGroupRecentCommentsAnonymousQueryHookResult = ReturnType<typeof useGetGroupRecentCommentsAnonymousQuery>;
export type GetGroupRecentCommentsAnonymousLazyQueryHookResult = ReturnType<typeof useGetGroupRecentCommentsAnonymousLazyQuery>;
export type GetGroupRecentCommentsAnonymousQueryResult = Apollo.QueryResult<GetGroupRecentCommentsAnonymousQuery, GetGroupRecentCommentsAnonymousQueryVariables>;
export const GetLearningProgramByIdDocument = gql`
    query GetLearningProgramById($id: uuid!) {
  learningProgramsByPk(id: $id) {
    id
    title
    description
    sportId
    skillLevelId
    totalSchedules
    scheduleUnit
    thumbnailUrl
    coverImageUrl
    totalEnrollments
    averageRating
    createdAt
    sport {
      value
      description
    }
    skillLevel {
      value
      description
    }
    skills {
      id
      skillId
      isPrimary
      skill {
        value
        description
      }
    }
    schedules(orderBy: {scheduleNumber: ASC}) {
      id
      scheduleNumber
      title
      primarySkillId
      focus
      lessonObjective
      practicePlan
      media {
        id
        media {
          id
          url
          fileName
          fileType
          fileFormat
          fileCategory
          host
          provider
          providerId
          providerUrl
          originalFileName
        }
        mediaCategory {
          id
          name
          code
          description
        }
        orderIndex
      }
      commonMistakes
    }
  }
}
    `;

/**
 * __useGetLearningProgramByIdQuery__
 *
 * To run a query within a React component, call `useGetLearningProgramByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningProgramByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningProgramByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLearningProgramByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLearningProgramByIdQuery, GetLearningProgramByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearningProgramByIdQuery, GetLearningProgramByIdQueryVariables>(GetLearningProgramByIdDocument, options);
      }
export function useGetLearningProgramByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearningProgramByIdQuery, GetLearningProgramByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearningProgramByIdQuery, GetLearningProgramByIdQueryVariables>(GetLearningProgramByIdDocument, options);
        }
export type GetLearningProgramByIdQueryHookResult = ReturnType<typeof useGetLearningProgramByIdQuery>;
export type GetLearningProgramByIdLazyQueryHookResult = ReturnType<typeof useGetLearningProgramByIdLazyQuery>;
export type GetLearningProgramByIdQueryResult = Apollo.QueryResult<GetLearningProgramByIdQuery, GetLearningProgramByIdQueryVariables>;
export const GetUserEnrollmentWithProgressDocument = gql`
    query GetUserEnrollmentWithProgress($learningProgramId: uuid!, $userId: uuid!) {
  learningProgramEnrollments(
    where: {learningProgramId: {_eq: $learningProgramId}, userId: {_eq: $userId}}
    limit: 1
  ) {
    id
    status
    enrolledAt
    currentSchedule
    scheduleProgress(orderBy: {scheduleNumber: ASC}) {
      id
      scheduleNumber
      learningProgramScheduleId
      completedAt
      mediaWatched {
        id
        watchedAt
        mediaCategory {
          id
          code
        }
      }
      learningProgramSchedule {
        id
        scheduleNumber
        title
      }
    }
    videoSubmissions(orderBy: {videoAnalysis: {createdAt: DESC}}) {
      id
      learningProgramScheduleId
      videoAnalysisId
      videoAnalysis {
        id
        createdAt
        reviewStatus
      }
      learningProgramSchedule {
        scheduleNumber
      }
    }
  }
}
    `;

/**
 * __useGetUserEnrollmentWithProgressQuery__
 *
 * To run a query within a React component, call `useGetUserEnrollmentWithProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEnrollmentWithProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEnrollmentWithProgressQuery({
 *   variables: {
 *      learningProgramId: // value for 'learningProgramId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserEnrollmentWithProgressQuery(baseOptions: Apollo.QueryHookOptions<GetUserEnrollmentWithProgressQuery, GetUserEnrollmentWithProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEnrollmentWithProgressQuery, GetUserEnrollmentWithProgressQueryVariables>(GetUserEnrollmentWithProgressDocument, options);
      }
export function useGetUserEnrollmentWithProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEnrollmentWithProgressQuery, GetUserEnrollmentWithProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEnrollmentWithProgressQuery, GetUserEnrollmentWithProgressQueryVariables>(GetUserEnrollmentWithProgressDocument, options);
        }
export type GetUserEnrollmentWithProgressQueryHookResult = ReturnType<typeof useGetUserEnrollmentWithProgressQuery>;
export type GetUserEnrollmentWithProgressLazyQueryHookResult = ReturnType<typeof useGetUserEnrollmentWithProgressLazyQuery>;
export type GetUserEnrollmentWithProgressQueryResult = Apollo.QueryResult<GetUserEnrollmentWithProgressQuery, GetUserEnrollmentWithProgressQueryVariables>;
export const UpsertScheduleProgressMediaWatchedDocument = gql`
    mutation UpsertScheduleProgressMediaWatched($learningProgramEnrollmentScheduleProgressId: uuid!, $mediaCategoryId: uuid!, $watchedAt: timestamptz!) {
  insertLearningProgramEnrollmentScheduleMediaWatchedOne(
    object: {learningProgramEnrollmentScheduleProgressId: $learningProgramEnrollmentScheduleProgressId, mediaCategoryId: $mediaCategoryId, watchedAt: $watchedAt}
    onConflict: {constraint: uq_enrollment_schedule_media_watched_progress_category, updateColumns: [watchedAt]}
  ) {
    id
    watchedAt
  }
}
    `;
export type UpsertScheduleProgressMediaWatchedMutationFn = Apollo.MutationFunction<UpsertScheduleProgressMediaWatchedMutation, UpsertScheduleProgressMediaWatchedMutationVariables>;

/**
 * __useUpsertScheduleProgressMediaWatchedMutation__
 *
 * To run a mutation, you first call `useUpsertScheduleProgressMediaWatchedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertScheduleProgressMediaWatchedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertScheduleProgressMediaWatchedMutation, { data, loading, error }] = useUpsertScheduleProgressMediaWatchedMutation({
 *   variables: {
 *      learningProgramEnrollmentScheduleProgressId: // value for 'learningProgramEnrollmentScheduleProgressId'
 *      mediaCategoryId: // value for 'mediaCategoryId'
 *      watchedAt: // value for 'watchedAt'
 *   },
 * });
 */
export function useUpsertScheduleProgressMediaWatchedMutation(baseOptions?: Apollo.MutationHookOptions<UpsertScheduleProgressMediaWatchedMutation, UpsertScheduleProgressMediaWatchedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertScheduleProgressMediaWatchedMutation, UpsertScheduleProgressMediaWatchedMutationVariables>(UpsertScheduleProgressMediaWatchedDocument, options);
      }
export type UpsertScheduleProgressMediaWatchedMutationHookResult = ReturnType<typeof useUpsertScheduleProgressMediaWatchedMutation>;
export type UpsertScheduleProgressMediaWatchedMutationResult = Apollo.MutationResult<UpsertScheduleProgressMediaWatchedMutation>;
export type UpsertScheduleProgressMediaWatchedMutationOptions = Apollo.BaseMutationOptions<UpsertScheduleProgressMediaWatchedMutation, UpsertScheduleProgressMediaWatchedMutationVariables>;
export const DeleteScheduleProgressMediaWatchedDocument = gql`
    mutation DeleteScheduleProgressMediaWatched($learningProgramEnrollmentScheduleProgressId: uuid!, $mediaCategoryId: uuid!) {
  deleteLearningProgramEnrollmentScheduleMediaWatched(
    where: {_and: [{learningProgramEnrollmentScheduleProgressId: {_eq: $learningProgramEnrollmentScheduleProgressId}}, {mediaCategoryId: {_eq: $mediaCategoryId}}]}
  ) {
    affectedRows
  }
}
    `;
export type DeleteScheduleProgressMediaWatchedMutationFn = Apollo.MutationFunction<DeleteScheduleProgressMediaWatchedMutation, DeleteScheduleProgressMediaWatchedMutationVariables>;

/**
 * __useDeleteScheduleProgressMediaWatchedMutation__
 *
 * To run a mutation, you first call `useDeleteScheduleProgressMediaWatchedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduleProgressMediaWatchedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduleProgressMediaWatchedMutation, { data, loading, error }] = useDeleteScheduleProgressMediaWatchedMutation({
 *   variables: {
 *      learningProgramEnrollmentScheduleProgressId: // value for 'learningProgramEnrollmentScheduleProgressId'
 *      mediaCategoryId: // value for 'mediaCategoryId'
 *   },
 * });
 */
export function useDeleteScheduleProgressMediaWatchedMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduleProgressMediaWatchedMutation, DeleteScheduleProgressMediaWatchedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduleProgressMediaWatchedMutation, DeleteScheduleProgressMediaWatchedMutationVariables>(DeleteScheduleProgressMediaWatchedDocument, options);
      }
export type DeleteScheduleProgressMediaWatchedMutationHookResult = ReturnType<typeof useDeleteScheduleProgressMediaWatchedMutation>;
export type DeleteScheduleProgressMediaWatchedMutationResult = Apollo.MutationResult<DeleteScheduleProgressMediaWatchedMutation>;
export type DeleteScheduleProgressMediaWatchedMutationOptions = Apollo.BaseMutationOptions<DeleteScheduleProgressMediaWatchedMutation, DeleteScheduleProgressMediaWatchedMutationVariables>;
export const CreateScheduleProgressDocument = gql`
    mutation CreateScheduleProgress($enrollmentId: uuid!, $scheduleId: uuid!, $scheduleNumber: Int!) {
  insertLearningProgramEnrollmentScheduleProgressOne(
    object: {learningProgramEnrollmentId: $enrollmentId, learningProgramScheduleId: $scheduleId, scheduleNumber: $scheduleNumber}
  ) {
    id
    scheduleNumber
    learningProgramScheduleId
  }
}
    `;
export type CreateScheduleProgressMutationFn = Apollo.MutationFunction<CreateScheduleProgressMutation, CreateScheduleProgressMutationVariables>;

/**
 * __useCreateScheduleProgressMutation__
 *
 * To run a mutation, you first call `useCreateScheduleProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleProgressMutation, { data, loading, error }] = useCreateScheduleProgressMutation({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *      scheduleId: // value for 'scheduleId'
 *      scheduleNumber: // value for 'scheduleNumber'
 *   },
 * });
 */
export function useCreateScheduleProgressMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleProgressMutation, CreateScheduleProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleProgressMutation, CreateScheduleProgressMutationVariables>(CreateScheduleProgressDocument, options);
      }
export type CreateScheduleProgressMutationHookResult = ReturnType<typeof useCreateScheduleProgressMutation>;
export type CreateScheduleProgressMutationResult = Apollo.MutationResult<CreateScheduleProgressMutation>;
export type CreateScheduleProgressMutationOptions = Apollo.BaseMutationOptions<CreateScheduleProgressMutation, CreateScheduleProgressMutationVariables>;
export const GetLearningProgramsMarketplaceDocument = gql`
    query GetLearningProgramsMarketplace($limit: Int) {
  learningPrograms(orderBy: {createdAt: DESC}, limit: $limit) {
    id
    title
    description
    sportId
    skillLevelId
    totalSchedules
    scheduleUnit
    thumbnailUrl
    coverImageUrl
    totalEnrollments
    averageRating
    createdAt
    sport {
      value
      description
    }
    skills {
      id
      skillId
      isPrimary
    }
    schedules {
      id
      scheduleNumber
      title
    }
  }
}
    `;

/**
 * __useGetLearningProgramsMarketplaceQuery__
 *
 * To run a query within a React component, call `useGetLearningProgramsMarketplaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningProgramsMarketplaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningProgramsMarketplaceQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetLearningProgramsMarketplaceQuery(baseOptions?: Apollo.QueryHookOptions<GetLearningProgramsMarketplaceQuery, GetLearningProgramsMarketplaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearningProgramsMarketplaceQuery, GetLearningProgramsMarketplaceQueryVariables>(GetLearningProgramsMarketplaceDocument, options);
      }
export function useGetLearningProgramsMarketplaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearningProgramsMarketplaceQuery, GetLearningProgramsMarketplaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearningProgramsMarketplaceQuery, GetLearningProgramsMarketplaceQueryVariables>(GetLearningProgramsMarketplaceDocument, options);
        }
export type GetLearningProgramsMarketplaceQueryHookResult = ReturnType<typeof useGetLearningProgramsMarketplaceQuery>;
export type GetLearningProgramsMarketplaceLazyQueryHookResult = ReturnType<typeof useGetLearningProgramsMarketplaceLazyQuery>;
export type GetLearningProgramsMarketplaceQueryResult = Apollo.QueryResult<GetLearningProgramsMarketplaceQuery, GetLearningProgramsMarketplaceQueryVariables>;
export const InsertLearningProgramEnrollmentDocument = gql`
    mutation InsertLearningProgramEnrollment($learningProgramId: uuid!, $userId: uuid!, $enrolledAt: date!, $status: String!, $currentSchedule: Int!) {
  insertLearningProgramEnrollmentsOne(
    object: {learningProgramId: $learningProgramId, userId: $userId, enrolledAt: $enrolledAt, status: $status, currentSchedule: $currentSchedule}
  ) {
    id
    learningProgramId
    userId
    status
    enrolledAt
    currentSchedule
  }
}
    `;
export type InsertLearningProgramEnrollmentMutationFn = Apollo.MutationFunction<InsertLearningProgramEnrollmentMutation, InsertLearningProgramEnrollmentMutationVariables>;

/**
 * __useInsertLearningProgramEnrollmentMutation__
 *
 * To run a mutation, you first call `useInsertLearningProgramEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertLearningProgramEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertLearningProgramEnrollmentMutation, { data, loading, error }] = useInsertLearningProgramEnrollmentMutation({
 *   variables: {
 *      learningProgramId: // value for 'learningProgramId'
 *      userId: // value for 'userId'
 *      enrolledAt: // value for 'enrolledAt'
 *      status: // value for 'status'
 *      currentSchedule: // value for 'currentSchedule'
 *   },
 * });
 */
export function useInsertLearningProgramEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<InsertLearningProgramEnrollmentMutation, InsertLearningProgramEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertLearningProgramEnrollmentMutation, InsertLearningProgramEnrollmentMutationVariables>(InsertLearningProgramEnrollmentDocument, options);
      }
export type InsertLearningProgramEnrollmentMutationHookResult = ReturnType<typeof useInsertLearningProgramEnrollmentMutation>;
export type InsertLearningProgramEnrollmentMutationResult = Apollo.MutationResult<InsertLearningProgramEnrollmentMutation>;
export type InsertLearningProgramEnrollmentMutationOptions = Apollo.BaseMutationOptions<InsertLearningProgramEnrollmentMutation, InsertLearningProgramEnrollmentMutationVariables>;
export const GetUserEnrollmentDocument = gql`
    query GetUserEnrollment($learningProgramId: uuid!, $userId: uuid!) {
  learningProgramEnrollments(
    where: {learningProgramId: {_eq: $learningProgramId}, userId: {_eq: $userId}}
    limit: 1
  ) {
    id
    status
    enrolledAt
    currentSchedule
  }
}
    `;

/**
 * __useGetUserEnrollmentQuery__
 *
 * To run a query within a React component, call `useGetUserEnrollmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEnrollmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEnrollmentQuery({
 *   variables: {
 *      learningProgramId: // value for 'learningProgramId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserEnrollmentQuery(baseOptions: Apollo.QueryHookOptions<GetUserEnrollmentQuery, GetUserEnrollmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEnrollmentQuery, GetUserEnrollmentQueryVariables>(GetUserEnrollmentDocument, options);
      }
export function useGetUserEnrollmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEnrollmentQuery, GetUserEnrollmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEnrollmentQuery, GetUserEnrollmentQueryVariables>(GetUserEnrollmentDocument, options);
        }
export type GetUserEnrollmentQueryHookResult = ReturnType<typeof useGetUserEnrollmentQuery>;
export type GetUserEnrollmentLazyQueryHookResult = ReturnType<typeof useGetUserEnrollmentLazyQuery>;
export type GetUserEnrollmentQueryResult = Apollo.QueryResult<GetUserEnrollmentQuery, GetUserEnrollmentQueryVariables>;
export const GetUserAvailableLessonContentDocument = gql`
    query getUserAvailableLessonContent($id: uuid!) {
  usersByPk(id: $id) {
    id
    customCourts(orderBy: {createdAt: DESC}) {
      createdAt
      deletedAt
      fullAddress
      id
      title
    }
    lessonTemplates {
      coverImageUrl
      createdAt
      currency
      deletedAt
      description
      id
      originalLessonId
      participantLimit
      priceUnitAmount
      privacy
      templateName
      title
      type
      typeCustom
      updatedAt
      userId
      userCustomCourtId
      sport
      originalLesson {
        venue {
          addressString
          id
          timezone
        }
        userCustomCourtId
      }
    }
  }
}
    `;

/**
 * __useGetUserAvailableLessonContentQuery__
 *
 * To run a query within a React component, call `useGetUserAvailableLessonContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAvailableLessonContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAvailableLessonContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserAvailableLessonContentQuery(baseOptions: Apollo.QueryHookOptions<GetUserAvailableLessonContentQuery, GetUserAvailableLessonContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAvailableLessonContentQuery, GetUserAvailableLessonContentQueryVariables>(GetUserAvailableLessonContentDocument, options);
      }
export function useGetUserAvailableLessonContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAvailableLessonContentQuery, GetUserAvailableLessonContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAvailableLessonContentQuery, GetUserAvailableLessonContentQueryVariables>(GetUserAvailableLessonContentDocument, options);
        }
export type GetUserAvailableLessonContentQueryHookResult = ReturnType<typeof useGetUserAvailableLessonContentQuery>;
export type GetUserAvailableLessonContentLazyQueryHookResult = ReturnType<typeof useGetUserAvailableLessonContentLazyQuery>;
export type GetUserAvailableLessonContentQueryResult = Apollo.QueryResult<GetUserAvailableLessonContentQuery, GetUserAvailableLessonContentQueryVariables>;
export const InsertNewLessonWithNewCourtDocument = gql`
    mutation insertNewLessonWithNewCourt($title: String!, $type: LessonTypesEnum!, $typeCustom: String = "", $status: LessonStatusesEnum = PENDING, $description: String!, $startDateTime: timestamptz!, $endDateTime: timestamptz!, $ownerUserId: uuid!, $participantLimit: Int!, $paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum!, $priceUnitAmount: Int!, $privacy: LessonPrivacyEnum = PUBLIC, $coverImageUrl: String = "", $usedTemplateId: uuid, $lessonTimeData: [LessonTimesInsertInput!]!, $customCourtData: UserCustomCourtsInsertInput!, $lessonEquipment: [LessonEquipmentInsertInput!] = [], $locale: String!, $timezoneName: String!, $timezoneAbbreviation: String!, $timezoneOffsetMinutes: Int!, $sport: SportsEnum!, $currency: String!) {
  insertLessonsOne(
    object: {title: $title, sport: $sport, type: $type, typeCustom: $typeCustom, status: $status, startDateTime: $startDateTime, endDateTime: $endDateTime, description: $description, ownerUserId: $ownerUserId, participantLimit: $participantLimit, paymentFulfillmentChannel: $paymentFulfillmentChannel, priceUnitAmount: $priceUnitAmount, privacy: $privacy, coverImageUrl: $coverImageUrl, usedTemplateId: $usedTemplateId, locale: $locale, timezoneName: $timezoneName, timezoneAbbreviation: $timezoneAbbreviation, timezoneOffsetMinutes: $timezoneOffsetMinutes, times: {data: $lessonTimeData}, userCustomCourt: {data: $customCourtData}, currency: $currency, equipment: {data: $lessonEquipment, onConflict: {constraint: lesson_equipment_lesson_id_equipment_option_id_key, updateColumns: deletedAt}}}
  ) {
    ...lessonFields
  }
}
    ${LessonFieldsFragmentDoc}`;
export type InsertNewLessonWithNewCourtMutationFn = Apollo.MutationFunction<InsertNewLessonWithNewCourtMutation, InsertNewLessonWithNewCourtMutationVariables>;

/**
 * __useInsertNewLessonWithNewCourtMutation__
 *
 * To run a mutation, you first call `useInsertNewLessonWithNewCourtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNewLessonWithNewCourtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNewLessonWithNewCourtMutation, { data, loading, error }] = useInsertNewLessonWithNewCourtMutation({
 *   variables: {
 *      title: // value for 'title'
 *      type: // value for 'type'
 *      typeCustom: // value for 'typeCustom'
 *      status: // value for 'status'
 *      description: // value for 'description'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      ownerUserId: // value for 'ownerUserId'
 *      participantLimit: // value for 'participantLimit'
 *      paymentFulfillmentChannel: // value for 'paymentFulfillmentChannel'
 *      priceUnitAmount: // value for 'priceUnitAmount'
 *      privacy: // value for 'privacy'
 *      coverImageUrl: // value for 'coverImageUrl'
 *      usedTemplateId: // value for 'usedTemplateId'
 *      lessonTimeData: // value for 'lessonTimeData'
 *      customCourtData: // value for 'customCourtData'
 *      lessonEquipment: // value for 'lessonEquipment'
 *      locale: // value for 'locale'
 *      timezoneName: // value for 'timezoneName'
 *      timezoneAbbreviation: // value for 'timezoneAbbreviation'
 *      timezoneOffsetMinutes: // value for 'timezoneOffsetMinutes'
 *      sport: // value for 'sport'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useInsertNewLessonWithNewCourtMutation(baseOptions?: Apollo.MutationHookOptions<InsertNewLessonWithNewCourtMutation, InsertNewLessonWithNewCourtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertNewLessonWithNewCourtMutation, InsertNewLessonWithNewCourtMutationVariables>(InsertNewLessonWithNewCourtDocument, options);
      }
export type InsertNewLessonWithNewCourtMutationHookResult = ReturnType<typeof useInsertNewLessonWithNewCourtMutation>;
export type InsertNewLessonWithNewCourtMutationResult = Apollo.MutationResult<InsertNewLessonWithNewCourtMutation>;
export type InsertNewLessonWithNewCourtMutationOptions = Apollo.BaseMutationOptions<InsertNewLessonWithNewCourtMutation, InsertNewLessonWithNewCourtMutationVariables>;
export const InsertNewLessonWithExistingCourtDocument = gql`
    mutation insertNewLessonWithExistingCourt($title: String!, $sport: SportsEnum!, $type: LessonTypesEnum!, $typeCustom: String = "", $status: LessonStatusesEnum = PENDING, $description: String!, $startDateTime: timestamptz!, $endDateTime: timestamptz!, $ownerUserId: uuid!, $participantLimit: Int!, $paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum!, $priceUnitAmount: Int!, $privacy: LessonPrivacyEnum = PUBLIC, $coverImageUrl: String = "", $coverImageFileName: String = "", $coverImagePath: String = "", $coverImageProvider: String = "", $coverImageProviderId: String = "", $coverImageProviderUrl: String = "", $externalBookingUrl: String = "", $usedTemplateId: uuid, $lessonTimeData: [LessonTimesInsertInput!]!, $userCustomCourtId: uuid, $lessonEquipment: [LessonEquipmentInsertInput!] = [], $locale: String!, $timezoneName: String!, $timezoneAbbreviation: String!, $timezoneOffsetMinutes: Int!, $venueId: uuid, $currency: String!) {
  insertLessonsOne(
    object: {title: $title, sport: $sport, type: $type, typeCustom: $typeCustom, status: $status, startDateTime: $startDateTime, endDateTime: $endDateTime, description: $description, ownerUserId: $ownerUserId, participantLimit: $participantLimit, paymentFulfillmentChannel: $paymentFulfillmentChannel, priceUnitAmount: $priceUnitAmount, privacy: $privacy, coverImageUrl: $coverImageUrl, coverImageFileName: $coverImageFileName, coverImagePath: $coverImagePath, coverImageProvider: $coverImageProvider, coverImageProviderId: $coverImageProviderId, coverImageProviderUrl: $coverImageProviderUrl, externalBookingUrl: $externalBookingUrl, usedTemplateId: $usedTemplateId, locale: $locale, timezoneName: $timezoneName, timezoneAbbreviation: $timezoneAbbreviation, timezoneOffsetMinutes: $timezoneOffsetMinutes, times: {data: $lessonTimeData}, userCustomCourtId: $userCustomCourtId, venueId: $venueId, currency: $currency, equipment: {data: $lessonEquipment, onConflict: {constraint: lesson_equipment_lesson_id_equipment_option_id_key, updateColumns: deletedAt}}}
  ) {
    ...lessonFields
  }
}
    ${LessonFieldsFragmentDoc}`;
export type InsertNewLessonWithExistingCourtMutationFn = Apollo.MutationFunction<InsertNewLessonWithExistingCourtMutation, InsertNewLessonWithExistingCourtMutationVariables>;

/**
 * __useInsertNewLessonWithExistingCourtMutation__
 *
 * To run a mutation, you first call `useInsertNewLessonWithExistingCourtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNewLessonWithExistingCourtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNewLessonWithExistingCourtMutation, { data, loading, error }] = useInsertNewLessonWithExistingCourtMutation({
 *   variables: {
 *      title: // value for 'title'
 *      sport: // value for 'sport'
 *      type: // value for 'type'
 *      typeCustom: // value for 'typeCustom'
 *      status: // value for 'status'
 *      description: // value for 'description'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      ownerUserId: // value for 'ownerUserId'
 *      participantLimit: // value for 'participantLimit'
 *      paymentFulfillmentChannel: // value for 'paymentFulfillmentChannel'
 *      priceUnitAmount: // value for 'priceUnitAmount'
 *      privacy: // value for 'privacy'
 *      coverImageUrl: // value for 'coverImageUrl'
 *      coverImageFileName: // value for 'coverImageFileName'
 *      coverImagePath: // value for 'coverImagePath'
 *      coverImageProvider: // value for 'coverImageProvider'
 *      coverImageProviderId: // value for 'coverImageProviderId'
 *      coverImageProviderUrl: // value for 'coverImageProviderUrl'
 *      externalBookingUrl: // value for 'externalBookingUrl'
 *      usedTemplateId: // value for 'usedTemplateId'
 *      lessonTimeData: // value for 'lessonTimeData'
 *      userCustomCourtId: // value for 'userCustomCourtId'
 *      lessonEquipment: // value for 'lessonEquipment'
 *      locale: // value for 'locale'
 *      timezoneName: // value for 'timezoneName'
 *      timezoneAbbreviation: // value for 'timezoneAbbreviation'
 *      timezoneOffsetMinutes: // value for 'timezoneOffsetMinutes'
 *      venueId: // value for 'venueId'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useInsertNewLessonWithExistingCourtMutation(baseOptions?: Apollo.MutationHookOptions<InsertNewLessonWithExistingCourtMutation, InsertNewLessonWithExistingCourtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertNewLessonWithExistingCourtMutation, InsertNewLessonWithExistingCourtMutationVariables>(InsertNewLessonWithExistingCourtDocument, options);
      }
export type InsertNewLessonWithExistingCourtMutationHookResult = ReturnType<typeof useInsertNewLessonWithExistingCourtMutation>;
export type InsertNewLessonWithExistingCourtMutationResult = Apollo.MutationResult<InsertNewLessonWithExistingCourtMutation>;
export type InsertNewLessonWithExistingCourtMutationOptions = Apollo.BaseMutationOptions<InsertNewLessonWithExistingCourtMutation, InsertNewLessonWithExistingCourtMutationVariables>;
export const InsertUserCustomCourtDocument = gql`
    mutation insertUserCustomCourt($customCourtData: UserCustomCourtsInsertInput!) {
  insertUserCustomCourtsOne(object: $customCourtData) {
    id
  }
}
    `;
export type InsertUserCustomCourtMutationFn = Apollo.MutationFunction<InsertUserCustomCourtMutation, InsertUserCustomCourtMutationVariables>;

/**
 * __useInsertUserCustomCourtMutation__
 *
 * To run a mutation, you first call `useInsertUserCustomCourtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserCustomCourtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserCustomCourtMutation, { data, loading, error }] = useInsertUserCustomCourtMutation({
 *   variables: {
 *      customCourtData: // value for 'customCourtData'
 *   },
 * });
 */
export function useInsertUserCustomCourtMutation(baseOptions?: Apollo.MutationHookOptions<InsertUserCustomCourtMutation, InsertUserCustomCourtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUserCustomCourtMutation, InsertUserCustomCourtMutationVariables>(InsertUserCustomCourtDocument, options);
      }
export type InsertUserCustomCourtMutationHookResult = ReturnType<typeof useInsertUserCustomCourtMutation>;
export type InsertUserCustomCourtMutationResult = Apollo.MutationResult<InsertUserCustomCourtMutation>;
export type InsertUserCustomCourtMutationOptions = Apollo.BaseMutationOptions<InsertUserCustomCourtMutation, InsertUserCustomCourtMutationVariables>;
export const UpdateLessonTimesDocument = gql`
    mutation updateLessonTimes($lessonId: uuid!, $lessonTimeData: [LessonTimesInsertInput!]!) {
  deleteLessonTimes(where: {lessonId: {_eq: $lessonId}}) {
    affectedRows
  }
  insertLessonTimes(objects: $lessonTimeData) {
    affectedRows
  }
}
    `;
export type UpdateLessonTimesMutationFn = Apollo.MutationFunction<UpdateLessonTimesMutation, UpdateLessonTimesMutationVariables>;

/**
 * __useUpdateLessonTimesMutation__
 *
 * To run a mutation, you first call `useUpdateLessonTimesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLessonTimesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLessonTimesMutation, { data, loading, error }] = useUpdateLessonTimesMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      lessonTimeData: // value for 'lessonTimeData'
 *   },
 * });
 */
export function useUpdateLessonTimesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLessonTimesMutation, UpdateLessonTimesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLessonTimesMutation, UpdateLessonTimesMutationVariables>(UpdateLessonTimesDocument, options);
      }
export type UpdateLessonTimesMutationHookResult = ReturnType<typeof useUpdateLessonTimesMutation>;
export type UpdateLessonTimesMutationResult = Apollo.MutationResult<UpdateLessonTimesMutation>;
export type UpdateLessonTimesMutationOptions = Apollo.BaseMutationOptions<UpdateLessonTimesMutation, UpdateLessonTimesMutationVariables>;
export const UpdateLessonEquipmentDocument = gql`
    mutation updateLessonEquipment($lessonId: uuid!, $lessonEquipmentData: [LessonEquipmentInsertInput!] = []) {
  deleteLessonEquipment(where: {lessonId: {_eq: $lessonId}}) {
    affectedRows
  }
  insertLessonEquipment(objects: $lessonEquipmentData) {
    affectedRows
  }
}
    `;
export type UpdateLessonEquipmentMutationFn = Apollo.MutationFunction<UpdateLessonEquipmentMutation, UpdateLessonEquipmentMutationVariables>;

/**
 * __useUpdateLessonEquipmentMutation__
 *
 * To run a mutation, you first call `useUpdateLessonEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLessonEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLessonEquipmentMutation, { data, loading, error }] = useUpdateLessonEquipmentMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      lessonEquipmentData: // value for 'lessonEquipmentData'
 *   },
 * });
 */
export function useUpdateLessonEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLessonEquipmentMutation, UpdateLessonEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLessonEquipmentMutation, UpdateLessonEquipmentMutationVariables>(UpdateLessonEquipmentDocument, options);
      }
export type UpdateLessonEquipmentMutationHookResult = ReturnType<typeof useUpdateLessonEquipmentMutation>;
export type UpdateLessonEquipmentMutationResult = Apollo.MutationResult<UpdateLessonEquipmentMutation>;
export type UpdateLessonEquipmentMutationOptions = Apollo.BaseMutationOptions<UpdateLessonEquipmentMutation, UpdateLessonEquipmentMutationVariables>;
export const UpdateNewLessonByIdDocument = gql`
    mutation updateNewLessonById($lessonId: uuid!, $title: String!, $sport: SportsEnum!, $type: LessonTypesEnum!, $typeCustom: String = "", $status: LessonStatusesEnum = PENDING, $description: String!, $startDateTime: timestamptz!, $endDateTime: timestamptz!, $participantLimit: Int!, $paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum!, $priceUnitAmount: Int!, $privacy: LessonPrivacyEnum = PUBLIC, $coverImageUrl: String = "", $coverImageFileName: String = "", $coverImagePath: String = "", $coverImageProvider: String = "", $coverImageProviderId: String = "", $coverImageProviderUrl: String = "", $externalBookingUrl: String = "", $usedTemplateId: uuid, $userCustomCourtId: uuid, $venueId: uuid, $currency: String!, $timezoneName: String!, $timezoneAbbreviation: String!, $timezoneOffsetMinutes: Int!) {
  updateLessonsByPk(
    pkColumns: {id: $lessonId}
    _set: {title: $title, sport: $sport, type: $type, typeCustom: $typeCustom, status: $status, startDateTime: $startDateTime, endDateTime: $endDateTime, timezoneName: $timezoneName, timezoneAbbreviation: $timezoneAbbreviation, timezoneOffsetMinutes: $timezoneOffsetMinutes, description: $description, participantLimit: $participantLimit, paymentFulfillmentChannel: $paymentFulfillmentChannel, priceUnitAmount: $priceUnitAmount, privacy: $privacy, coverImageUrl: $coverImageUrl, coverImageFileName: $coverImageFileName, coverImagePath: $coverImagePath, coverImageProvider: $coverImageProvider, coverImageProviderId: $coverImageProviderId, coverImageProviderUrl: $coverImageProviderUrl, externalBookingUrl: $externalBookingUrl, usedTemplateId: $usedTemplateId, userCustomCourtId: $userCustomCourtId, venueId: $venueId, currency: $currency}
  ) {
    ...lessonFields
  }
}
    ${LessonFieldsFragmentDoc}`;
export type UpdateNewLessonByIdMutationFn = Apollo.MutationFunction<UpdateNewLessonByIdMutation, UpdateNewLessonByIdMutationVariables>;

/**
 * __useUpdateNewLessonByIdMutation__
 *
 * To run a mutation, you first call `useUpdateNewLessonByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewLessonByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewLessonByIdMutation, { data, loading, error }] = useUpdateNewLessonByIdMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      title: // value for 'title'
 *      sport: // value for 'sport'
 *      type: // value for 'type'
 *      typeCustom: // value for 'typeCustom'
 *      status: // value for 'status'
 *      description: // value for 'description'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      participantLimit: // value for 'participantLimit'
 *      paymentFulfillmentChannel: // value for 'paymentFulfillmentChannel'
 *      priceUnitAmount: // value for 'priceUnitAmount'
 *      privacy: // value for 'privacy'
 *      coverImageUrl: // value for 'coverImageUrl'
 *      coverImageFileName: // value for 'coverImageFileName'
 *      coverImagePath: // value for 'coverImagePath'
 *      coverImageProvider: // value for 'coverImageProvider'
 *      coverImageProviderId: // value for 'coverImageProviderId'
 *      coverImageProviderUrl: // value for 'coverImageProviderUrl'
 *      externalBookingUrl: // value for 'externalBookingUrl'
 *      usedTemplateId: // value for 'usedTemplateId'
 *      userCustomCourtId: // value for 'userCustomCourtId'
 *      venueId: // value for 'venueId'
 *      currency: // value for 'currency'
 *      timezoneName: // value for 'timezoneName'
 *      timezoneAbbreviation: // value for 'timezoneAbbreviation'
 *      timezoneOffsetMinutes: // value for 'timezoneOffsetMinutes'
 *   },
 * });
 */
export function useUpdateNewLessonByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewLessonByIdMutation, UpdateNewLessonByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNewLessonByIdMutation, UpdateNewLessonByIdMutationVariables>(UpdateNewLessonByIdDocument, options);
      }
export type UpdateNewLessonByIdMutationHookResult = ReturnType<typeof useUpdateNewLessonByIdMutation>;
export type UpdateNewLessonByIdMutationResult = Apollo.MutationResult<UpdateNewLessonByIdMutation>;
export type UpdateNewLessonByIdMutationOptions = Apollo.BaseMutationOptions<UpdateNewLessonByIdMutation, UpdateNewLessonByIdMutationVariables>;
export const UpdateExistingLessonByIdDocument = gql`
    mutation updateExistingLessonById($lessonId: uuid!, $title: String!, $description: String!, $sport: SportsEnum = TENNIS, $paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum!, $participantLimit: Int!, $priceUnitAmount: Int!, $currency: String!, $startDateTime: timestamptz!, $endDateTime: timestamptz!, $type: LessonTypesEnum!, $privacy: LessonPrivacyEnum = PUBLIC, $userCustomCourtId: uuid, $venueId: uuid, $coverImageUrl: String = "", $coverImageFileName: String = "", $coverImagePath: String = "", $coverImageProvider: String = "", $coverImageProviderId: String = "", $coverImageProviderUrl: String = "", $externalBookingUrl: String = "", $timezoneName: String!, $timezoneAbbreviation: String!, $timezoneOffsetMinutes: Int!) {
  updateLessonsByPk(
    pkColumns: {id: $lessonId}
    _set: {title: $title, description: $description, sport: $sport, paymentFulfillmentChannel: $paymentFulfillmentChannel, participantLimit: $participantLimit, priceUnitAmount: $priceUnitAmount, currency: $currency, startDateTime: $startDateTime, endDateTime: $endDateTime, timezoneName: $timezoneName, timezoneAbbreviation: $timezoneAbbreviation, timezoneOffsetMinutes: $timezoneOffsetMinutes, type: $type, privacy: $privacy, userCustomCourtId: $userCustomCourtId, venueId: $venueId, coverImageUrl: $coverImageUrl, coverImageFileName: $coverImageFileName, coverImagePath: $coverImagePath, coverImageProvider: $coverImageProvider, coverImageProviderId: $coverImageProviderId, coverImageProviderUrl: $coverImageProviderUrl, externalBookingUrl: $externalBookingUrl}
  ) {
    ...lessonFields
  }
}
    ${LessonFieldsFragmentDoc}`;
export type UpdateExistingLessonByIdMutationFn = Apollo.MutationFunction<UpdateExistingLessonByIdMutation, UpdateExistingLessonByIdMutationVariables>;

/**
 * __useUpdateExistingLessonByIdMutation__
 *
 * To run a mutation, you first call `useUpdateExistingLessonByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExistingLessonByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExistingLessonByIdMutation, { data, loading, error }] = useUpdateExistingLessonByIdMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      sport: // value for 'sport'
 *      paymentFulfillmentChannel: // value for 'paymentFulfillmentChannel'
 *      participantLimit: // value for 'participantLimit'
 *      priceUnitAmount: // value for 'priceUnitAmount'
 *      currency: // value for 'currency'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      type: // value for 'type'
 *      privacy: // value for 'privacy'
 *      userCustomCourtId: // value for 'userCustomCourtId'
 *      venueId: // value for 'venueId'
 *      coverImageUrl: // value for 'coverImageUrl'
 *      coverImageFileName: // value for 'coverImageFileName'
 *      coverImagePath: // value for 'coverImagePath'
 *      coverImageProvider: // value for 'coverImageProvider'
 *      coverImageProviderId: // value for 'coverImageProviderId'
 *      coverImageProviderUrl: // value for 'coverImageProviderUrl'
 *      externalBookingUrl: // value for 'externalBookingUrl'
 *      timezoneName: // value for 'timezoneName'
 *      timezoneAbbreviation: // value for 'timezoneAbbreviation'
 *      timezoneOffsetMinutes: // value for 'timezoneOffsetMinutes'
 *   },
 * });
 */
export function useUpdateExistingLessonByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExistingLessonByIdMutation, UpdateExistingLessonByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExistingLessonByIdMutation, UpdateExistingLessonByIdMutationVariables>(UpdateExistingLessonByIdDocument, options);
      }
export type UpdateExistingLessonByIdMutationHookResult = ReturnType<typeof useUpdateExistingLessonByIdMutation>;
export type UpdateExistingLessonByIdMutationResult = Apollo.MutationResult<UpdateExistingLessonByIdMutation>;
export type UpdateExistingLessonByIdMutationOptions = Apollo.BaseMutationOptions<UpdateExistingLessonByIdMutation, UpdateExistingLessonByIdMutationVariables>;
export const UpdateUserDefaultCoachPaymentFulfillmentChannelDocument = gql`
    mutation updateUserDefaultCoachPaymentFulfillmentChannel($id: uuid!, $defaultCoachPaymentFulfillmentChannel: PaymentFulfillmentChannelsEnum!) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {defaultCoachPaymentFulfillmentChannel: $defaultCoachPaymentFulfillmentChannel}
  ) {
    defaultCoachPaymentFulfillmentChannel
    id
  }
}
    `;
export type UpdateUserDefaultCoachPaymentFulfillmentChannelMutationFn = Apollo.MutationFunction<UpdateUserDefaultCoachPaymentFulfillmentChannelMutation, UpdateUserDefaultCoachPaymentFulfillmentChannelMutationVariables>;

/**
 * __useUpdateUserDefaultCoachPaymentFulfillmentChannelMutation__
 *
 * To run a mutation, you first call `useUpdateUserDefaultCoachPaymentFulfillmentChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDefaultCoachPaymentFulfillmentChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDefaultCoachPaymentFulfillmentChannelMutation, { data, loading, error }] = useUpdateUserDefaultCoachPaymentFulfillmentChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      defaultCoachPaymentFulfillmentChannel: // value for 'defaultCoachPaymentFulfillmentChannel'
 *   },
 * });
 */
export function useUpdateUserDefaultCoachPaymentFulfillmentChannelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDefaultCoachPaymentFulfillmentChannelMutation, UpdateUserDefaultCoachPaymentFulfillmentChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDefaultCoachPaymentFulfillmentChannelMutation, UpdateUserDefaultCoachPaymentFulfillmentChannelMutationVariables>(UpdateUserDefaultCoachPaymentFulfillmentChannelDocument, options);
      }
export type UpdateUserDefaultCoachPaymentFulfillmentChannelMutationHookResult = ReturnType<typeof useUpdateUserDefaultCoachPaymentFulfillmentChannelMutation>;
export type UpdateUserDefaultCoachPaymentFulfillmentChannelMutationResult = Apollo.MutationResult<UpdateUserDefaultCoachPaymentFulfillmentChannelMutation>;
export type UpdateUserDefaultCoachPaymentFulfillmentChannelMutationOptions = Apollo.BaseMutationOptions<UpdateUserDefaultCoachPaymentFulfillmentChannelMutation, UpdateUserDefaultCoachPaymentFulfillmentChannelMutationVariables>;
export const GetUserCreditCardsDocument = gql`
    query getUserCreditCards($userId: uuid!) {
  userCreditCards(
    where: {userId: {_eq: $userId}, archivedAt: {_isNull: true}}
    orderBy: {updatedAt: DESC}
  ) {
    id
    last4
    provider
    providerCardId
    expireYear
    expireMonth
    brand
    billingName
    billingPostalCode
  }
}
    `;

/**
 * __useGetUserCreditCardsQuery__
 *
 * To run a query within a React component, call `useGetUserCreditCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCreditCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCreditCardsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserCreditCardsQuery(baseOptions: Apollo.QueryHookOptions<GetUserCreditCardsQuery, GetUserCreditCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCreditCardsQuery, GetUserCreditCardsQueryVariables>(GetUserCreditCardsDocument, options);
      }
export function useGetUserCreditCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCreditCardsQuery, GetUserCreditCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCreditCardsQuery, GetUserCreditCardsQueryVariables>(GetUserCreditCardsDocument, options);
        }
export type GetUserCreditCardsQueryHookResult = ReturnType<typeof useGetUserCreditCardsQuery>;
export type GetUserCreditCardsLazyQueryHookResult = ReturnType<typeof useGetUserCreditCardsLazyQuery>;
export type GetUserCreditCardsQueryResult = Apollo.QueryResult<GetUserCreditCardsQuery, GetUserCreditCardsQueryVariables>;
export const SetLessonAsActiveDocument = gql`
    mutation setLessonAsActive($id: uuid!) {
  updateLessonsByPk(
    pkColumns: {id: $id}
    _set: {status: ACTIVE, publishedAt: "now()"}
  ) {
    id
    status
    publishedAt
  }
}
    `;
export type SetLessonAsActiveMutationFn = Apollo.MutationFunction<SetLessonAsActiveMutation, SetLessonAsActiveMutationVariables>;

/**
 * __useSetLessonAsActiveMutation__
 *
 * To run a mutation, you first call `useSetLessonAsActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLessonAsActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLessonAsActiveMutation, { data, loading, error }] = useSetLessonAsActiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetLessonAsActiveMutation(baseOptions?: Apollo.MutationHookOptions<SetLessonAsActiveMutation, SetLessonAsActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLessonAsActiveMutation, SetLessonAsActiveMutationVariables>(SetLessonAsActiveDocument, options);
      }
export type SetLessonAsActiveMutationHookResult = ReturnType<typeof useSetLessonAsActiveMutation>;
export type SetLessonAsActiveMutationResult = Apollo.MutationResult<SetLessonAsActiveMutation>;
export type SetLessonAsActiveMutationOptions = Apollo.BaseMutationOptions<SetLessonAsActiveMutation, SetLessonAsActiveMutationVariables>;
export const InsertLessonTemplateDocument = gql`
    mutation insertLessonTemplate($coverImageUrl: String = "", $currency: String!, $description: String!, $originalLessonId: uuid = null, $originalEventId: uuid = null, $participantLimit: Int!, $priceUnitAmount: Int!, $privacy: LessonPrivacyEnum!, $templateName: String!, $title: String!, $type: LessonTypesEnum = null, $eventType: EventTypesEnum = null, $typeCustom: String!, $userId: uuid!, $userCustomCourtId: uuid = null, $sport: SportsEnum!, $externalUrl: String = null, $intendedAgeGroup: EventAgeGroupsEnum = null, $skillLevels: [LessonTemplateSkillLevelsInsertInput!] = []) {
  insertLessonTemplatesOne(
    object: {coverImageUrl: $coverImageUrl, currency: $currency, description: $description, originalLessonId: $originalLessonId, originalEventId: $originalEventId, participantLimit: $participantLimit, priceUnitAmount: $priceUnitAmount, privacy: $privacy, templateName: $templateName, title: $title, type: $type, eventType: $eventType, typeCustom: $typeCustom, userId: $userId, userCustomCourtId: $userCustomCourtId, sport: $sport, externalUrl: $externalUrl, intendedAgeGroup: $intendedAgeGroup, skillLevels: {data: $skillLevels}}
  ) {
    id
    type
    eventType
    title
    templateName
    coverImageUrl
    currency
    description
    originalLessonId
    originalEventId
    participantLimit
    priceUnitAmount
    privacy
    typeCustom
    userId
    userCustomCourtId
    sport
    intendedAgeGroup
    skillLevels {
      skillLevel
    }
  }
}
    `;
export type InsertLessonTemplateMutationFn = Apollo.MutationFunction<InsertLessonTemplateMutation, InsertLessonTemplateMutationVariables>;

/**
 * __useInsertLessonTemplateMutation__
 *
 * To run a mutation, you first call `useInsertLessonTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertLessonTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertLessonTemplateMutation, { data, loading, error }] = useInsertLessonTemplateMutation({
 *   variables: {
 *      coverImageUrl: // value for 'coverImageUrl'
 *      currency: // value for 'currency'
 *      description: // value for 'description'
 *      originalLessonId: // value for 'originalLessonId'
 *      originalEventId: // value for 'originalEventId'
 *      participantLimit: // value for 'participantLimit'
 *      priceUnitAmount: // value for 'priceUnitAmount'
 *      privacy: // value for 'privacy'
 *      templateName: // value for 'templateName'
 *      title: // value for 'title'
 *      type: // value for 'type'
 *      eventType: // value for 'eventType'
 *      typeCustom: // value for 'typeCustom'
 *      userId: // value for 'userId'
 *      userCustomCourtId: // value for 'userCustomCourtId'
 *      sport: // value for 'sport'
 *      externalUrl: // value for 'externalUrl'
 *      intendedAgeGroup: // value for 'intendedAgeGroup'
 *      skillLevels: // value for 'skillLevels'
 *   },
 * });
 */
export function useInsertLessonTemplateMutation(baseOptions?: Apollo.MutationHookOptions<InsertLessonTemplateMutation, InsertLessonTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertLessonTemplateMutation, InsertLessonTemplateMutationVariables>(InsertLessonTemplateDocument, options);
      }
export type InsertLessonTemplateMutationHookResult = ReturnType<typeof useInsertLessonTemplateMutation>;
export type InsertLessonTemplateMutationResult = Apollo.MutationResult<InsertLessonTemplateMutation>;
export type InsertLessonTemplateMutationOptions = Apollo.BaseMutationOptions<InsertLessonTemplateMutation, InsertLessonTemplateMutationVariables>;
export const GetLessonParticipantOrderDetailsDocument = gql`
    query getLessonParticipantOrderDetails($userId: uuid!, $lessonId: uuid!) {
  lessonParticipants(where: {userId: {_eq: $userId}, lessonId: {_eq: $lessonId}}) {
    id
    userId
    lessonId
    status
    paymentFulfillmentChannel
    orderItems {
      id
      status
      totalUnitAmount
      order {
        paidUnitAmount
        refundUnitAmount
        status
        orderTotalUnitAmount
        orderSubtotalUnitAmount
      }
      priceUnitAmount
    }
  }
}
    `;

/**
 * __useGetLessonParticipantOrderDetailsQuery__
 *
 * To run a query within a React component, call `useGetLessonParticipantOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonParticipantOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonParticipantOrderDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useGetLessonParticipantOrderDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetLessonParticipantOrderDetailsQuery, GetLessonParticipantOrderDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonParticipantOrderDetailsQuery, GetLessonParticipantOrderDetailsQueryVariables>(GetLessonParticipantOrderDetailsDocument, options);
      }
export function useGetLessonParticipantOrderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonParticipantOrderDetailsQuery, GetLessonParticipantOrderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonParticipantOrderDetailsQuery, GetLessonParticipantOrderDetailsQueryVariables>(GetLessonParticipantOrderDetailsDocument, options);
        }
export type GetLessonParticipantOrderDetailsQueryHookResult = ReturnType<typeof useGetLessonParticipantOrderDetailsQuery>;
export type GetLessonParticipantOrderDetailsLazyQueryHookResult = ReturnType<typeof useGetLessonParticipantOrderDetailsLazyQuery>;
export type GetLessonParticipantOrderDetailsQueryResult = Apollo.QueryResult<GetLessonParticipantOrderDetailsQuery, GetLessonParticipantOrderDetailsQueryVariables>;
export const GetLessonWaitlistDocument = gql`
    query getLessonWaitlist($lessonId: uuid!) {
  lessonWaitlists(where: {lessonId: {_eq: $lessonId}, status: {_eq: ACTIVE}}) {
    id
    status
    userId
    userProfile {
      id
      fullName
      profileImageFileName
      profileImagePath
      profileImageProviderUrl
      username
    }
  }
}
    `;

/**
 * __useGetLessonWaitlistQuery__
 *
 * To run a query within a React component, call `useGetLessonWaitlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonWaitlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonWaitlistQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useGetLessonWaitlistQuery(baseOptions: Apollo.QueryHookOptions<GetLessonWaitlistQuery, GetLessonWaitlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonWaitlistQuery, GetLessonWaitlistQueryVariables>(GetLessonWaitlistDocument, options);
      }
export function useGetLessonWaitlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonWaitlistQuery, GetLessonWaitlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonWaitlistQuery, GetLessonWaitlistQueryVariables>(GetLessonWaitlistDocument, options);
        }
export type GetLessonWaitlistQueryHookResult = ReturnType<typeof useGetLessonWaitlistQuery>;
export type GetLessonWaitlistLazyQueryHookResult = ReturnType<typeof useGetLessonWaitlistLazyQuery>;
export type GetLessonWaitlistQueryResult = Apollo.QueryResult<GetLessonWaitlistQuery, GetLessonWaitlistQueryVariables>;
export const UpsertLessonWaitlistDocument = gql`
    mutation upsertLessonWaitlist($userId: uuid!, $lessonId: uuid!, $status: LessonWaitlistStatusesEnum!) {
  insertLessonWaitlistsOne(
    object: {userId: $userId, lessonId: $lessonId, status: $status}
    onConflict: {constraint: lesson_waitlists_user_id_lesson_id_key, updateColumns: status}
  ) {
    lessonId
    status
    userId
    id
  }
}
    `;
export type UpsertLessonWaitlistMutationFn = Apollo.MutationFunction<UpsertLessonWaitlistMutation, UpsertLessonWaitlistMutationVariables>;

/**
 * __useUpsertLessonWaitlistMutation__
 *
 * To run a mutation, you first call `useUpsertLessonWaitlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLessonWaitlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLessonWaitlistMutation, { data, loading, error }] = useUpsertLessonWaitlistMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      lessonId: // value for 'lessonId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpsertLessonWaitlistMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLessonWaitlistMutation, UpsertLessonWaitlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLessonWaitlistMutation, UpsertLessonWaitlistMutationVariables>(UpsertLessonWaitlistDocument, options);
      }
export type UpsertLessonWaitlistMutationHookResult = ReturnType<typeof useUpsertLessonWaitlistMutation>;
export type UpsertLessonWaitlistMutationResult = Apollo.MutationResult<UpsertLessonWaitlistMutation>;
export type UpsertLessonWaitlistMutationOptions = Apollo.BaseMutationOptions<UpsertLessonWaitlistMutation, UpsertLessonWaitlistMutationVariables>;
export const InsertVideoAnalysisSubmissionLogDocument = gql`
    mutation insertVideoAnalysisSubmissionLog($userId: uuid = null, $videoAnalysisId: uuid = null, $videoName: String!, $videoPath: String = "") {
  insertVideoAnalysisSubmissionLogOne(
    object: {userId: $userId, videoAnalysisId: $videoAnalysisId, videoName: $videoName, videoPath: $videoPath}
  ) {
    id
  }
}
    `;
export type InsertVideoAnalysisSubmissionLogMutationFn = Apollo.MutationFunction<InsertVideoAnalysisSubmissionLogMutation, InsertVideoAnalysisSubmissionLogMutationVariables>;

/**
 * __useInsertVideoAnalysisSubmissionLogMutation__
 *
 * To run a mutation, you first call `useInsertVideoAnalysisSubmissionLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertVideoAnalysisSubmissionLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertVideoAnalysisSubmissionLogMutation, { data, loading, error }] = useInsertVideoAnalysisSubmissionLogMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      videoAnalysisId: // value for 'videoAnalysisId'
 *      videoName: // value for 'videoName'
 *      videoPath: // value for 'videoPath'
 *   },
 * });
 */
export function useInsertVideoAnalysisSubmissionLogMutation(baseOptions?: Apollo.MutationHookOptions<InsertVideoAnalysisSubmissionLogMutation, InsertVideoAnalysisSubmissionLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertVideoAnalysisSubmissionLogMutation, InsertVideoAnalysisSubmissionLogMutationVariables>(InsertVideoAnalysisSubmissionLogDocument, options);
      }
export type InsertVideoAnalysisSubmissionLogMutationHookResult = ReturnType<typeof useInsertVideoAnalysisSubmissionLogMutation>;
export type InsertVideoAnalysisSubmissionLogMutationResult = Apollo.MutationResult<InsertVideoAnalysisSubmissionLogMutation>;
export type InsertVideoAnalysisSubmissionLogMutationOptions = Apollo.BaseMutationOptions<InsertVideoAnalysisSubmissionLogMutation, InsertVideoAnalysisSubmissionLogMutationVariables>;
export const UpdateVideoAnalysisSubmissionLogDocument = gql`
    mutation updateVideoAnalysisSubmissionLog($userId: uuid = null, $videoAnalysisId: uuid = null, $videoName: String = "", $videoPath: String = "", $id: uuid!, $deletedAt: timestamptz) {
  updateVideoAnalysisSubmissionLog(
    where: {id: {_eq: $id}}
    _set: {userId: $userId, videoAnalysisId: $videoAnalysisId, videoName: $videoName, videoPath: $videoPath, deletedAt: $deletedAt}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateVideoAnalysisSubmissionLogMutationFn = Apollo.MutationFunction<UpdateVideoAnalysisSubmissionLogMutation, UpdateVideoAnalysisSubmissionLogMutationVariables>;

/**
 * __useUpdateVideoAnalysisSubmissionLogMutation__
 *
 * To run a mutation, you first call `useUpdateVideoAnalysisSubmissionLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoAnalysisSubmissionLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoAnalysisSubmissionLogMutation, { data, loading, error }] = useUpdateVideoAnalysisSubmissionLogMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      videoAnalysisId: // value for 'videoAnalysisId'
 *      videoName: // value for 'videoName'
 *      videoPath: // value for 'videoPath'
 *      id: // value for 'id'
 *      deletedAt: // value for 'deletedAt'
 *   },
 * });
 */
export function useUpdateVideoAnalysisSubmissionLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVideoAnalysisSubmissionLogMutation, UpdateVideoAnalysisSubmissionLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVideoAnalysisSubmissionLogMutation, UpdateVideoAnalysisSubmissionLogMutationVariables>(UpdateVideoAnalysisSubmissionLogDocument, options);
      }
export type UpdateVideoAnalysisSubmissionLogMutationHookResult = ReturnType<typeof useUpdateVideoAnalysisSubmissionLogMutation>;
export type UpdateVideoAnalysisSubmissionLogMutationResult = Apollo.MutationResult<UpdateVideoAnalysisSubmissionLogMutation>;
export type UpdateVideoAnalysisSubmissionLogMutationOptions = Apollo.BaseMutationOptions<UpdateVideoAnalysisSubmissionLogMutation, UpdateVideoAnalysisSubmissionLogMutationVariables>;
export const InsertLessonParticipantsAsCoachDocument = gql`
    mutation insertLessonParticipantsAsCoach($objects: [LessonParticipantsInsertInput!] = {}) {
  insertLessonParticipants(
    objects: $objects
    onConflict: {constraint: lesson_participants_lesson_id_user_id_key, updateColumns: status}
  ) {
    affectedRows
  }
}
    `;
export type InsertLessonParticipantsAsCoachMutationFn = Apollo.MutationFunction<InsertLessonParticipantsAsCoachMutation, InsertLessonParticipantsAsCoachMutationVariables>;

/**
 * __useInsertLessonParticipantsAsCoachMutation__
 *
 * To run a mutation, you first call `useInsertLessonParticipantsAsCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertLessonParticipantsAsCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertLessonParticipantsAsCoachMutation, { data, loading, error }] = useInsertLessonParticipantsAsCoachMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertLessonParticipantsAsCoachMutation(baseOptions?: Apollo.MutationHookOptions<InsertLessonParticipantsAsCoachMutation, InsertLessonParticipantsAsCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertLessonParticipantsAsCoachMutation, InsertLessonParticipantsAsCoachMutationVariables>(InsertLessonParticipantsAsCoachDocument, options);
      }
export type InsertLessonParticipantsAsCoachMutationHookResult = ReturnType<typeof useInsertLessonParticipantsAsCoachMutation>;
export type InsertLessonParticipantsAsCoachMutationResult = Apollo.MutationResult<InsertLessonParticipantsAsCoachMutation>;
export type InsertLessonParticipantsAsCoachMutationOptions = Apollo.BaseMutationOptions<InsertLessonParticipantsAsCoachMutation, InsertLessonParticipantsAsCoachMutationVariables>;
export const UpdateLessonParticipantLimitDocument = gql`
    mutation UpdateLessonParticipantLimit($lessonId: uuid!, $participantLimit: Int!) {
  updateLessonsByPk(
    pkColumns: {id: $lessonId}
    _set: {participantLimit: $participantLimit}
  ) {
    id
    participantLimit
  }
}
    `;
export type UpdateLessonParticipantLimitMutationFn = Apollo.MutationFunction<UpdateLessonParticipantLimitMutation, UpdateLessonParticipantLimitMutationVariables>;

/**
 * __useUpdateLessonParticipantLimitMutation__
 *
 * To run a mutation, you first call `useUpdateLessonParticipantLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLessonParticipantLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLessonParticipantLimitMutation, { data, loading, error }] = useUpdateLessonParticipantLimitMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      participantLimit: // value for 'participantLimit'
 *   },
 * });
 */
export function useUpdateLessonParticipantLimitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLessonParticipantLimitMutation, UpdateLessonParticipantLimitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLessonParticipantLimitMutation, UpdateLessonParticipantLimitMutationVariables>(UpdateLessonParticipantLimitDocument, options);
      }
export type UpdateLessonParticipantLimitMutationHookResult = ReturnType<typeof useUpdateLessonParticipantLimitMutation>;
export type UpdateLessonParticipantLimitMutationResult = Apollo.MutationResult<UpdateLessonParticipantLimitMutation>;
export type UpdateLessonParticipantLimitMutationOptions = Apollo.BaseMutationOptions<UpdateLessonParticipantLimitMutation, UpdateLessonParticipantLimitMutationVariables>;
export const InsertPlayerAvailabilityDocument = gql`
    mutation InsertPlayerAvailability($object: PlayerAvailabilitiesInsertInput!) {
  insertPlayerAvailabilitiesOne(object: $object) {
    id
  }
}
    `;
export type InsertPlayerAvailabilityMutationFn = Apollo.MutationFunction<InsertPlayerAvailabilityMutation, InsertPlayerAvailabilityMutationVariables>;

/**
 * __useInsertPlayerAvailabilityMutation__
 *
 * To run a mutation, you first call `useInsertPlayerAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPlayerAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPlayerAvailabilityMutation, { data, loading, error }] = useInsertPlayerAvailabilityMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertPlayerAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<InsertPlayerAvailabilityMutation, InsertPlayerAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPlayerAvailabilityMutation, InsertPlayerAvailabilityMutationVariables>(InsertPlayerAvailabilityDocument, options);
      }
export type InsertPlayerAvailabilityMutationHookResult = ReturnType<typeof useInsertPlayerAvailabilityMutation>;
export type InsertPlayerAvailabilityMutationResult = Apollo.MutationResult<InsertPlayerAvailabilityMutation>;
export type InsertPlayerAvailabilityMutationOptions = Apollo.BaseMutationOptions<InsertPlayerAvailabilityMutation, InsertPlayerAvailabilityMutationVariables>;
export const DeactivatePlayerAvailabilityDocument = gql`
    mutation DeactivatePlayerAvailability($userId: uuid!, $sport: SportsEnum!) {
  updatePlayerAvailabilities(
    where: {userId: {_eq: $userId}, sport: {_eq: $sport}, isActive: {_eq: true}}
    _set: {isActive: false}
  ) {
    affectedRows
  }
}
    `;
export type DeactivatePlayerAvailabilityMutationFn = Apollo.MutationFunction<DeactivatePlayerAvailabilityMutation, DeactivatePlayerAvailabilityMutationVariables>;

/**
 * __useDeactivatePlayerAvailabilityMutation__
 *
 * To run a mutation, you first call `useDeactivatePlayerAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivatePlayerAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivatePlayerAvailabilityMutation, { data, loading, error }] = useDeactivatePlayerAvailabilityMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      sport: // value for 'sport'
 *   },
 * });
 */
export function useDeactivatePlayerAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<DeactivatePlayerAvailabilityMutation, DeactivatePlayerAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivatePlayerAvailabilityMutation, DeactivatePlayerAvailabilityMutationVariables>(DeactivatePlayerAvailabilityDocument, options);
      }
export type DeactivatePlayerAvailabilityMutationHookResult = ReturnType<typeof useDeactivatePlayerAvailabilityMutation>;
export type DeactivatePlayerAvailabilityMutationResult = Apollo.MutationResult<DeactivatePlayerAvailabilityMutation>;
export type DeactivatePlayerAvailabilityMutationOptions = Apollo.BaseMutationOptions<DeactivatePlayerAvailabilityMutation, DeactivatePlayerAvailabilityMutationVariables>;
export const GetEditAvailabilityDocument = gql`
    query GetEditAvailability($availabilityId: uuid!) {
  playerAvailabilitiesByPk(id: $availabilityId) {
    id
    userId
    sport
    teamType
    gender
    competitiveness
    wantsRegularPartner
    description
    travelRadiusMiles
    selfRatedMinSkillLevelId
    selfRatedMaxSkillLevelId
    slots {
      id
      dayOfWeek
      startTime
      endTime
    }
    neighborhoods {
      neighborhoodId
    }
    venues {
      id
      venue {
        id
        title
        addressString
        accessType
        indoorCourtCount
        outdoorCourtCount
        pickleballNets
        latitude
        longitude
        timezone
        images(limit: 1) {
          id
          path
          url
        }
      }
      userCustomCourt {
        id
        title
        fullAddress
        latitude
        longitude
      }
    }
    ratingScales {
      id
      minimumRating
      maximumRating
      pickleballRatingScale {
        id
        shortName
      }
      tennisRatingScale {
        id
        shortName
      }
      padelRatingScale {
        id
        shortName
      }
    }
  }
}
    `;

/**
 * __useGetEditAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetEditAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditAvailabilityQuery({
 *   variables: {
 *      availabilityId: // value for 'availabilityId'
 *   },
 * });
 */
export function useGetEditAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<GetEditAvailabilityQuery, GetEditAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditAvailabilityQuery, GetEditAvailabilityQueryVariables>(GetEditAvailabilityDocument, options);
      }
export function useGetEditAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditAvailabilityQuery, GetEditAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditAvailabilityQuery, GetEditAvailabilityQueryVariables>(GetEditAvailabilityDocument, options);
        }
export type GetEditAvailabilityQueryHookResult = ReturnType<typeof useGetEditAvailabilityQuery>;
export type GetEditAvailabilityLazyQueryHookResult = ReturnType<typeof useGetEditAvailabilityLazyQuery>;
export type GetEditAvailabilityQueryResult = Apollo.QueryResult<GetEditAvailabilityQuery, GetEditAvailabilityQueryVariables>;
export const UpdateListedAvailabilityDocument = gql`
    mutation UpdateListedAvailability($id: uuid!, $input: PlayerAvailabilitiesSetInput!) {
  updatePlayerAvailabilitiesByPk(pkColumns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export type UpdateListedAvailabilityMutationFn = Apollo.MutationFunction<UpdateListedAvailabilityMutation, UpdateListedAvailabilityMutationVariables>;

/**
 * __useUpdateListedAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpdateListedAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListedAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListedAvailabilityMutation, { data, loading, error }] = useUpdateListedAvailabilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListedAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListedAvailabilityMutation, UpdateListedAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListedAvailabilityMutation, UpdateListedAvailabilityMutationVariables>(UpdateListedAvailabilityDocument, options);
      }
export type UpdateListedAvailabilityMutationHookResult = ReturnType<typeof useUpdateListedAvailabilityMutation>;
export type UpdateListedAvailabilityMutationResult = Apollo.MutationResult<UpdateListedAvailabilityMutation>;
export type UpdateListedAvailabilityMutationOptions = Apollo.BaseMutationOptions<UpdateListedAvailabilityMutation, UpdateListedAvailabilityMutationVariables>;
export const DeleteListedAvailabilitySlotsDocument = gql`
    mutation DeleteListedAvailabilitySlots($availabilityId: uuid!) {
  deletePlayerAvailabilitySlots(where: {availabilityId: {_eq: $availabilityId}}) {
    affectedRows
  }
}
    `;
export type DeleteListedAvailabilitySlotsMutationFn = Apollo.MutationFunction<DeleteListedAvailabilitySlotsMutation, DeleteListedAvailabilitySlotsMutationVariables>;

/**
 * __useDeleteListedAvailabilitySlotsMutation__
 *
 * To run a mutation, you first call `useDeleteListedAvailabilitySlotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListedAvailabilitySlotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListedAvailabilitySlotsMutation, { data, loading, error }] = useDeleteListedAvailabilitySlotsMutation({
 *   variables: {
 *      availabilityId: // value for 'availabilityId'
 *   },
 * });
 */
export function useDeleteListedAvailabilitySlotsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListedAvailabilitySlotsMutation, DeleteListedAvailabilitySlotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListedAvailabilitySlotsMutation, DeleteListedAvailabilitySlotsMutationVariables>(DeleteListedAvailabilitySlotsDocument, options);
      }
export type DeleteListedAvailabilitySlotsMutationHookResult = ReturnType<typeof useDeleteListedAvailabilitySlotsMutation>;
export type DeleteListedAvailabilitySlotsMutationResult = Apollo.MutationResult<DeleteListedAvailabilitySlotsMutation>;
export type DeleteListedAvailabilitySlotsMutationOptions = Apollo.BaseMutationOptions<DeleteListedAvailabilitySlotsMutation, DeleteListedAvailabilitySlotsMutationVariables>;
export const InsertListedAvailabilitySlotsDocument = gql`
    mutation InsertListedAvailabilitySlots($objects: [PlayerAvailabilitySlotsInsertInput!]!) {
  insertPlayerAvailabilitySlots(objects: $objects) {
    affectedRows
  }
}
    `;
export type InsertListedAvailabilitySlotsMutationFn = Apollo.MutationFunction<InsertListedAvailabilitySlotsMutation, InsertListedAvailabilitySlotsMutationVariables>;

/**
 * __useInsertListedAvailabilitySlotsMutation__
 *
 * To run a mutation, you first call `useInsertListedAvailabilitySlotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertListedAvailabilitySlotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertListedAvailabilitySlotsMutation, { data, loading, error }] = useInsertListedAvailabilitySlotsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertListedAvailabilitySlotsMutation(baseOptions?: Apollo.MutationHookOptions<InsertListedAvailabilitySlotsMutation, InsertListedAvailabilitySlotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertListedAvailabilitySlotsMutation, InsertListedAvailabilitySlotsMutationVariables>(InsertListedAvailabilitySlotsDocument, options);
      }
export type InsertListedAvailabilitySlotsMutationHookResult = ReturnType<typeof useInsertListedAvailabilitySlotsMutation>;
export type InsertListedAvailabilitySlotsMutationResult = Apollo.MutationResult<InsertListedAvailabilitySlotsMutation>;
export type InsertListedAvailabilitySlotsMutationOptions = Apollo.BaseMutationOptions<InsertListedAvailabilitySlotsMutation, InsertListedAvailabilitySlotsMutationVariables>;
export const DeleteListedAvailabilityVenuesDocument = gql`
    mutation DeleteListedAvailabilityVenues($availabilityId: uuid!) {
  deletePlayerAvailabilityVenues(where: {availabilityId: {_eq: $availabilityId}}) {
    affectedRows
  }
}
    `;
export type DeleteListedAvailabilityVenuesMutationFn = Apollo.MutationFunction<DeleteListedAvailabilityVenuesMutation, DeleteListedAvailabilityVenuesMutationVariables>;

/**
 * __useDeleteListedAvailabilityVenuesMutation__
 *
 * To run a mutation, you first call `useDeleteListedAvailabilityVenuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListedAvailabilityVenuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListedAvailabilityVenuesMutation, { data, loading, error }] = useDeleteListedAvailabilityVenuesMutation({
 *   variables: {
 *      availabilityId: // value for 'availabilityId'
 *   },
 * });
 */
export function useDeleteListedAvailabilityVenuesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListedAvailabilityVenuesMutation, DeleteListedAvailabilityVenuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListedAvailabilityVenuesMutation, DeleteListedAvailabilityVenuesMutationVariables>(DeleteListedAvailabilityVenuesDocument, options);
      }
export type DeleteListedAvailabilityVenuesMutationHookResult = ReturnType<typeof useDeleteListedAvailabilityVenuesMutation>;
export type DeleteListedAvailabilityVenuesMutationResult = Apollo.MutationResult<DeleteListedAvailabilityVenuesMutation>;
export type DeleteListedAvailabilityVenuesMutationOptions = Apollo.BaseMutationOptions<DeleteListedAvailabilityVenuesMutation, DeleteListedAvailabilityVenuesMutationVariables>;
export const InsertListedAvailabilityVenuesDocument = gql`
    mutation InsertListedAvailabilityVenues($objects: [PlayerAvailabilityVenuesInsertInput!]!) {
  insertPlayerAvailabilityVenues(objects: $objects) {
    affectedRows
  }
}
    `;
export type InsertListedAvailabilityVenuesMutationFn = Apollo.MutationFunction<InsertListedAvailabilityVenuesMutation, InsertListedAvailabilityVenuesMutationVariables>;

/**
 * __useInsertListedAvailabilityVenuesMutation__
 *
 * To run a mutation, you first call `useInsertListedAvailabilityVenuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertListedAvailabilityVenuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertListedAvailabilityVenuesMutation, { data, loading, error }] = useInsertListedAvailabilityVenuesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertListedAvailabilityVenuesMutation(baseOptions?: Apollo.MutationHookOptions<InsertListedAvailabilityVenuesMutation, InsertListedAvailabilityVenuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertListedAvailabilityVenuesMutation, InsertListedAvailabilityVenuesMutationVariables>(InsertListedAvailabilityVenuesDocument, options);
      }
export type InsertListedAvailabilityVenuesMutationHookResult = ReturnType<typeof useInsertListedAvailabilityVenuesMutation>;
export type InsertListedAvailabilityVenuesMutationResult = Apollo.MutationResult<InsertListedAvailabilityVenuesMutation>;
export type InsertListedAvailabilityVenuesMutationOptions = Apollo.BaseMutationOptions<InsertListedAvailabilityVenuesMutation, InsertListedAvailabilityVenuesMutationVariables>;
export const DeleteListedAvailabilityRatingScalesDocument = gql`
    mutation DeleteListedAvailabilityRatingScales($availabilityId: uuid!) {
  deletePlayerAvailabilityRatingScales(
    where: {availabilityId: {_eq: $availabilityId}}
  ) {
    affectedRows
  }
}
    `;
export type DeleteListedAvailabilityRatingScalesMutationFn = Apollo.MutationFunction<DeleteListedAvailabilityRatingScalesMutation, DeleteListedAvailabilityRatingScalesMutationVariables>;

/**
 * __useDeleteListedAvailabilityRatingScalesMutation__
 *
 * To run a mutation, you first call `useDeleteListedAvailabilityRatingScalesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListedAvailabilityRatingScalesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListedAvailabilityRatingScalesMutation, { data, loading, error }] = useDeleteListedAvailabilityRatingScalesMutation({
 *   variables: {
 *      availabilityId: // value for 'availabilityId'
 *   },
 * });
 */
export function useDeleteListedAvailabilityRatingScalesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListedAvailabilityRatingScalesMutation, DeleteListedAvailabilityRatingScalesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListedAvailabilityRatingScalesMutation, DeleteListedAvailabilityRatingScalesMutationVariables>(DeleteListedAvailabilityRatingScalesDocument, options);
      }
export type DeleteListedAvailabilityRatingScalesMutationHookResult = ReturnType<typeof useDeleteListedAvailabilityRatingScalesMutation>;
export type DeleteListedAvailabilityRatingScalesMutationResult = Apollo.MutationResult<DeleteListedAvailabilityRatingScalesMutation>;
export type DeleteListedAvailabilityRatingScalesMutationOptions = Apollo.BaseMutationOptions<DeleteListedAvailabilityRatingScalesMutation, DeleteListedAvailabilityRatingScalesMutationVariables>;
export const InsertListedAvailabilityRatingScalesDocument = gql`
    mutation InsertListedAvailabilityRatingScales($objects: [PlayerAvailabilityRatingScalesInsertInput!]!) {
  insertPlayerAvailabilityRatingScales(objects: $objects) {
    affectedRows
  }
}
    `;
export type InsertListedAvailabilityRatingScalesMutationFn = Apollo.MutationFunction<InsertListedAvailabilityRatingScalesMutation, InsertListedAvailabilityRatingScalesMutationVariables>;

/**
 * __useInsertListedAvailabilityRatingScalesMutation__
 *
 * To run a mutation, you first call `useInsertListedAvailabilityRatingScalesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertListedAvailabilityRatingScalesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertListedAvailabilityRatingScalesMutation, { data, loading, error }] = useInsertListedAvailabilityRatingScalesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertListedAvailabilityRatingScalesMutation(baseOptions?: Apollo.MutationHookOptions<InsertListedAvailabilityRatingScalesMutation, InsertListedAvailabilityRatingScalesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertListedAvailabilityRatingScalesMutation, InsertListedAvailabilityRatingScalesMutationVariables>(InsertListedAvailabilityRatingScalesDocument, options);
      }
export type InsertListedAvailabilityRatingScalesMutationHookResult = ReturnType<typeof useInsertListedAvailabilityRatingScalesMutation>;
export type InsertListedAvailabilityRatingScalesMutationResult = Apollo.MutationResult<InsertListedAvailabilityRatingScalesMutation>;
export type InsertListedAvailabilityRatingScalesMutationOptions = Apollo.BaseMutationOptions<InsertListedAvailabilityRatingScalesMutation, InsertListedAvailabilityRatingScalesMutationVariables>;
export const GetMyActiveAvailabilitySportsDocument = gql`
    query GetMyActiveAvailabilitySports($userId: uuid!) {
  playerAvailabilities(where: {userId: {_eq: $userId}, isActive: {_eq: true}}) {
    id
    sport
  }
}
    `;

/**
 * __useGetMyActiveAvailabilitySportsQuery__
 *
 * To run a query within a React component, call `useGetMyActiveAvailabilitySportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyActiveAvailabilitySportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyActiveAvailabilitySportsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyActiveAvailabilitySportsQuery(baseOptions: Apollo.QueryHookOptions<GetMyActiveAvailabilitySportsQuery, GetMyActiveAvailabilitySportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyActiveAvailabilitySportsQuery, GetMyActiveAvailabilitySportsQueryVariables>(GetMyActiveAvailabilitySportsDocument, options);
      }
export function useGetMyActiveAvailabilitySportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyActiveAvailabilitySportsQuery, GetMyActiveAvailabilitySportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyActiveAvailabilitySportsQuery, GetMyActiveAvailabilitySportsQueryVariables>(GetMyActiveAvailabilitySportsDocument, options);
        }
export type GetMyActiveAvailabilitySportsQueryHookResult = ReturnType<typeof useGetMyActiveAvailabilitySportsQuery>;
export type GetMyActiveAvailabilitySportsLazyQueryHookResult = ReturnType<typeof useGetMyActiveAvailabilitySportsLazyQuery>;
export type GetMyActiveAvailabilitySportsQueryResult = Apollo.QueryResult<GetMyActiveAvailabilitySportsQuery, GetMyActiveAvailabilitySportsQueryVariables>;
export const InsertAvailabilityCustomCourtDocument = gql`
    mutation InsertAvailabilityCustomCourt($object: UserCustomCourtsInsertInput!) {
  insertUserCustomCourtsOne(object: $object) {
    id
    title
    fullAddress
    latitude
    longitude
  }
}
    `;
export type InsertAvailabilityCustomCourtMutationFn = Apollo.MutationFunction<InsertAvailabilityCustomCourtMutation, InsertAvailabilityCustomCourtMutationVariables>;

/**
 * __useInsertAvailabilityCustomCourtMutation__
 *
 * To run a mutation, you first call `useInsertAvailabilityCustomCourtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAvailabilityCustomCourtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAvailabilityCustomCourtMutation, { data, loading, error }] = useInsertAvailabilityCustomCourtMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertAvailabilityCustomCourtMutation(baseOptions?: Apollo.MutationHookOptions<InsertAvailabilityCustomCourtMutation, InsertAvailabilityCustomCourtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAvailabilityCustomCourtMutation, InsertAvailabilityCustomCourtMutationVariables>(InsertAvailabilityCustomCourtDocument, options);
      }
export type InsertAvailabilityCustomCourtMutationHookResult = ReturnType<typeof useInsertAvailabilityCustomCourtMutation>;
export type InsertAvailabilityCustomCourtMutationResult = Apollo.MutationResult<InsertAvailabilityCustomCourtMutation>;
export type InsertAvailabilityCustomCourtMutationOptions = Apollo.BaseMutationOptions<InsertAvailabilityCustomCourtMutation, InsertAvailabilityCustomCourtMutationVariables>;
export const DeleteListedAvailabilityNeighborhoodsDocument = gql`
    mutation DeleteListedAvailabilityNeighborhoods($availabilityId: uuid!) {
  deletePlayerAvailabilityNeighborhoods(
    where: {availabilityId: {_eq: $availabilityId}}
  ) {
    affectedRows
  }
}
    `;
export type DeleteListedAvailabilityNeighborhoodsMutationFn = Apollo.MutationFunction<DeleteListedAvailabilityNeighborhoodsMutation, DeleteListedAvailabilityNeighborhoodsMutationVariables>;

/**
 * __useDeleteListedAvailabilityNeighborhoodsMutation__
 *
 * To run a mutation, you first call `useDeleteListedAvailabilityNeighborhoodsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListedAvailabilityNeighborhoodsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListedAvailabilityNeighborhoodsMutation, { data, loading, error }] = useDeleteListedAvailabilityNeighborhoodsMutation({
 *   variables: {
 *      availabilityId: // value for 'availabilityId'
 *   },
 * });
 */
export function useDeleteListedAvailabilityNeighborhoodsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListedAvailabilityNeighborhoodsMutation, DeleteListedAvailabilityNeighborhoodsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListedAvailabilityNeighborhoodsMutation, DeleteListedAvailabilityNeighborhoodsMutationVariables>(DeleteListedAvailabilityNeighborhoodsDocument, options);
      }
export type DeleteListedAvailabilityNeighborhoodsMutationHookResult = ReturnType<typeof useDeleteListedAvailabilityNeighborhoodsMutation>;
export type DeleteListedAvailabilityNeighborhoodsMutationResult = Apollo.MutationResult<DeleteListedAvailabilityNeighborhoodsMutation>;
export type DeleteListedAvailabilityNeighborhoodsMutationOptions = Apollo.BaseMutationOptions<DeleteListedAvailabilityNeighborhoodsMutation, DeleteListedAvailabilityNeighborhoodsMutationVariables>;
export const InsertListedAvailabilityNeighborhoodsDocument = gql`
    mutation InsertListedAvailabilityNeighborhoods($objects: [PlayerAvailabilityNeighborhoodsInsertInput!]!) {
  insertPlayerAvailabilityNeighborhoods(objects: $objects) {
    affectedRows
  }
}
    `;
export type InsertListedAvailabilityNeighborhoodsMutationFn = Apollo.MutationFunction<InsertListedAvailabilityNeighborhoodsMutation, InsertListedAvailabilityNeighborhoodsMutationVariables>;

/**
 * __useInsertListedAvailabilityNeighborhoodsMutation__
 *
 * To run a mutation, you first call `useInsertListedAvailabilityNeighborhoodsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertListedAvailabilityNeighborhoodsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertListedAvailabilityNeighborhoodsMutation, { data, loading, error }] = useInsertListedAvailabilityNeighborhoodsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertListedAvailabilityNeighborhoodsMutation(baseOptions?: Apollo.MutationHookOptions<InsertListedAvailabilityNeighborhoodsMutation, InsertListedAvailabilityNeighborhoodsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertListedAvailabilityNeighborhoodsMutation, InsertListedAvailabilityNeighborhoodsMutationVariables>(InsertListedAvailabilityNeighborhoodsDocument, options);
      }
export type InsertListedAvailabilityNeighborhoodsMutationHookResult = ReturnType<typeof useInsertListedAvailabilityNeighborhoodsMutation>;
export type InsertListedAvailabilityNeighborhoodsMutationResult = Apollo.MutationResult<InsertListedAvailabilityNeighborhoodsMutation>;
export type InsertListedAvailabilityNeighborhoodsMutationOptions = Apollo.BaseMutationOptions<InsertListedAvailabilityNeighborhoodsMutation, InsertListedAvailabilityNeighborhoodsMutationVariables>;
export const GetListGameRatingOptionsDocument = gql`
    query GetListGameRatingOptions {
  pickleballRatingScales(
    where: {deletedAt: {_isNull: true}}
    orderBy: {order: ASC}
  ) {
    id
    shortName
    minimum
    maximum
  }
  tennisRatingScales(where: {deletedAt: {_isNull: true}}, orderBy: {order: ASC}) {
    id
    shortName
    minimum
    maximum
  }
  padelRatingScales(where: {deletedAt: {_isNull: true}}, orderBy: {order: ASC}) {
    id
    shortName
    minimum
    maximum
  }
  skillLevels(where: {isDisplayed: {_eq: true}}, orderBy: {rank: ASC}) {
    id
    displayName
  }
}
    `;

/**
 * __useGetListGameRatingOptionsQuery__
 *
 * To run a query within a React component, call `useGetListGameRatingOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListGameRatingOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListGameRatingOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListGameRatingOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetListGameRatingOptionsQuery, GetListGameRatingOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListGameRatingOptionsQuery, GetListGameRatingOptionsQueryVariables>(GetListGameRatingOptionsDocument, options);
      }
export function useGetListGameRatingOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListGameRatingOptionsQuery, GetListGameRatingOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListGameRatingOptionsQuery, GetListGameRatingOptionsQueryVariables>(GetListGameRatingOptionsDocument, options);
        }
export type GetListGameRatingOptionsQueryHookResult = ReturnType<typeof useGetListGameRatingOptionsQuery>;
export type GetListGameRatingOptionsLazyQueryHookResult = ReturnType<typeof useGetListGameRatingOptionsLazyQuery>;
export type GetListGameRatingOptionsQueryResult = Apollo.QueryResult<GetListGameRatingOptionsQuery, GetListGameRatingOptionsQueryVariables>;
export const GetEditGameDocument = gql`
    query GetEditGame($eventId: uuid!) {
  eventsByPk(id: $eventId) {
    id
    participantLimit
    hostUserId
    privacy
    sport
    startDate
    startDateTime
    endDateTime
    venueId
    addressString
    latitude
    longitude
    isCourtBooked
    courtCostPerPlayerUnitAmount
    description
    venue {
      id
      title
      addressString
      accessType
      indoorCourtCount
      outdoorCourtCount
      pickleballNets
      latitude
      longitude
      timezone
      images(limit: 1) {
        id
        path
        url
      }
    }
    groups {
      id
      teamType
      gender
      competitiveness
      selfRatedMinSkillLevelId
      selfRatedMaxSkillLevelId
      netStatus
      ratingScales {
        id
        minimumRating
        maximumRating
        pickleballRatingScale {
          id
          shortName
        }
        tennisRatingScale {
          id
          shortName
        }
        padelRatingScale {
          id
          shortName
        }
      }
    }
  }
}
    `;

/**
 * __useGetEditGameQuery__
 *
 * To run a query within a React component, call `useGetEditGameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditGameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditGameQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEditGameQuery(baseOptions: Apollo.QueryHookOptions<GetEditGameQuery, GetEditGameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditGameQuery, GetEditGameQueryVariables>(GetEditGameDocument, options);
      }
export function useGetEditGameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditGameQuery, GetEditGameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditGameQuery, GetEditGameQueryVariables>(GetEditGameDocument, options);
        }
export type GetEditGameQueryHookResult = ReturnType<typeof useGetEditGameQuery>;
export type GetEditGameLazyQueryHookResult = ReturnType<typeof useGetEditGameLazyQuery>;
export type GetEditGameQueryResult = Apollo.QueryResult<GetEditGameQuery, GetEditGameQueryVariables>;
export const UpdateListedGameEventDocument = gql`
    mutation UpdateListedGameEvent($id: uuid!, $input: EventsSetInput!) {
  updateEventsByPk(pkColumns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export type UpdateListedGameEventMutationFn = Apollo.MutationFunction<UpdateListedGameEventMutation, UpdateListedGameEventMutationVariables>;

/**
 * __useUpdateListedGameEventMutation__
 *
 * To run a mutation, you first call `useUpdateListedGameEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListedGameEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListedGameEventMutation, { data, loading, error }] = useUpdateListedGameEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListedGameEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListedGameEventMutation, UpdateListedGameEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListedGameEventMutation, UpdateListedGameEventMutationVariables>(UpdateListedGameEventDocument, options);
      }
export type UpdateListedGameEventMutationHookResult = ReturnType<typeof useUpdateListedGameEventMutation>;
export type UpdateListedGameEventMutationResult = Apollo.MutationResult<UpdateListedGameEventMutation>;
export type UpdateListedGameEventMutationOptions = Apollo.BaseMutationOptions<UpdateListedGameEventMutation, UpdateListedGameEventMutationVariables>;
export const UpdateListedGameGroupDocument = gql`
    mutation UpdateListedGameGroup($id: uuid!, $input: EventGroupsSetInput!) {
  updateEventGroupsByPk(pkColumns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export type UpdateListedGameGroupMutationFn = Apollo.MutationFunction<UpdateListedGameGroupMutation, UpdateListedGameGroupMutationVariables>;

/**
 * __useUpdateListedGameGroupMutation__
 *
 * To run a mutation, you first call `useUpdateListedGameGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListedGameGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListedGameGroupMutation, { data, loading, error }] = useUpdateListedGameGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListedGameGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListedGameGroupMutation, UpdateListedGameGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListedGameGroupMutation, UpdateListedGameGroupMutationVariables>(UpdateListedGameGroupDocument, options);
      }
export type UpdateListedGameGroupMutationHookResult = ReturnType<typeof useUpdateListedGameGroupMutation>;
export type UpdateListedGameGroupMutationResult = Apollo.MutationResult<UpdateListedGameGroupMutation>;
export type UpdateListedGameGroupMutationOptions = Apollo.BaseMutationOptions<UpdateListedGameGroupMutation, UpdateListedGameGroupMutationVariables>;
export const DeleteListedGameGroupRatingScalesDocument = gql`
    mutation DeleteListedGameGroupRatingScales($eventGroupId: uuid!) {
  deleteEventGroupRatingScales(where: {eventGroupId: {_eq: $eventGroupId}}) {
    affectedRows
  }
}
    `;
export type DeleteListedGameGroupRatingScalesMutationFn = Apollo.MutationFunction<DeleteListedGameGroupRatingScalesMutation, DeleteListedGameGroupRatingScalesMutationVariables>;

/**
 * __useDeleteListedGameGroupRatingScalesMutation__
 *
 * To run a mutation, you first call `useDeleteListedGameGroupRatingScalesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListedGameGroupRatingScalesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListedGameGroupRatingScalesMutation, { data, loading, error }] = useDeleteListedGameGroupRatingScalesMutation({
 *   variables: {
 *      eventGroupId: // value for 'eventGroupId'
 *   },
 * });
 */
export function useDeleteListedGameGroupRatingScalesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListedGameGroupRatingScalesMutation, DeleteListedGameGroupRatingScalesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListedGameGroupRatingScalesMutation, DeleteListedGameGroupRatingScalesMutationVariables>(DeleteListedGameGroupRatingScalesDocument, options);
      }
export type DeleteListedGameGroupRatingScalesMutationHookResult = ReturnType<typeof useDeleteListedGameGroupRatingScalesMutation>;
export type DeleteListedGameGroupRatingScalesMutationResult = Apollo.MutationResult<DeleteListedGameGroupRatingScalesMutation>;
export type DeleteListedGameGroupRatingScalesMutationOptions = Apollo.BaseMutationOptions<DeleteListedGameGroupRatingScalesMutation, DeleteListedGameGroupRatingScalesMutationVariables>;
export const InsertListedGameGroupRatingScalesDocument = gql`
    mutation InsertListedGameGroupRatingScales($objects: [EventGroupRatingScalesInsertInput!]!) {
  insertEventGroupRatingScales(objects: $objects) {
    affectedRows
  }
}
    `;
export type InsertListedGameGroupRatingScalesMutationFn = Apollo.MutationFunction<InsertListedGameGroupRatingScalesMutation, InsertListedGameGroupRatingScalesMutationVariables>;

/**
 * __useInsertListedGameGroupRatingScalesMutation__
 *
 * To run a mutation, you first call `useInsertListedGameGroupRatingScalesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertListedGameGroupRatingScalesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertListedGameGroupRatingScalesMutation, { data, loading, error }] = useInsertListedGameGroupRatingScalesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertListedGameGroupRatingScalesMutation(baseOptions?: Apollo.MutationHookOptions<InsertListedGameGroupRatingScalesMutation, InsertListedGameGroupRatingScalesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertListedGameGroupRatingScalesMutation, InsertListedGameGroupRatingScalesMutationVariables>(InsertListedGameGroupRatingScalesDocument, options);
      }
export type InsertListedGameGroupRatingScalesMutationHookResult = ReturnType<typeof useInsertListedGameGroupRatingScalesMutation>;
export type InsertListedGameGroupRatingScalesMutationResult = Apollo.MutationResult<InsertListedGameGroupRatingScalesMutation>;
export type InsertListedGameGroupRatingScalesMutationOptions = Apollo.BaseMutationOptions<InsertListedGameGroupRatingScalesMutation, InsertListedGameGroupRatingScalesMutationVariables>;
export const GetClosestVenuesForClaimDocument = gql`
    query getClosestVenuesForClaim($distance: Float!, $from: geography!, $googlePlaceId: String, $limit: Int! = 10) {
  byPlaceId: venues(
    where: {googlePlaceId: {_eq: $googlePlaceId}, deletedAt: {_isNull: true}}
    limit: 5
  ) {
    id
    title
    slug
    addressString
    googlePlaceId
    latitude
    longitude
    isActive
    adminUser {
      id
    }
    images(where: {isVisible: {_eq: true}}, limit: 1) {
      id
      url
      providerUrl
    }
  }
  byDistance: venues(
    where: {geometry: {_stDWithin: {distance: $distance, from: $from}}, deletedAt: {_isNull: true}}
    limit: $limit
  ) {
    id
    title
    slug
    addressString
    googlePlaceId
    latitude
    longitude
    isActive
    adminUser {
      id
    }
    images(where: {isVisible: {_eq: true}}, limit: 1) {
      id
      url
      providerUrl
    }
  }
}
    `;

/**
 * __useGetClosestVenuesForClaimQuery__
 *
 * To run a query within a React component, call `useGetClosestVenuesForClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClosestVenuesForClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClosestVenuesForClaimQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      googlePlaceId: // value for 'googlePlaceId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetClosestVenuesForClaimQuery(baseOptions: Apollo.QueryHookOptions<GetClosestVenuesForClaimQuery, GetClosestVenuesForClaimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClosestVenuesForClaimQuery, GetClosestVenuesForClaimQueryVariables>(GetClosestVenuesForClaimDocument, options);
      }
export function useGetClosestVenuesForClaimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClosestVenuesForClaimQuery, GetClosestVenuesForClaimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClosestVenuesForClaimQuery, GetClosestVenuesForClaimQueryVariables>(GetClosestVenuesForClaimDocument, options);
        }
export type GetClosestVenuesForClaimQueryHookResult = ReturnType<typeof useGetClosestVenuesForClaimQuery>;
export type GetClosestVenuesForClaimLazyQueryHookResult = ReturnType<typeof useGetClosestVenuesForClaimLazyQuery>;
export type GetClosestVenuesForClaimQueryResult = Apollo.QueryResult<GetClosestVenuesForClaimQuery, GetClosestVenuesForClaimQueryVariables>;
export const GetMyActivityDocument = gql`
    query getMyActivity($userId: uuid!) {
  hostedEvents: events(
    where: {type: {_eq: TOURNAMENT}, status: {_eq: PUBLISHED}, archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, hostUserId: {_eq: $userId}}
    orderBy: {startDate: ASC}
  ) {
    id
    coverImageProviderUrl
    slug
    startDate
    startDateTime
    endDate
    endDateTime
    status
    addressString
    title
    venue {
      id
      title
      addressString
    }
    registrationsAggregate {
      aggregate {
        count
      }
    }
  }
  attendingEvents: events(
    where: {type: {_eq: TOURNAMENT}, status: {_eq: PUBLISHED}, registrations: {userId: {_eq: $userId}}, archivedAt: {_isNull: true}, deletedAt: {_isNull: true}}
    orderBy: {startDate: ASC}
  ) {
    id
    coverImageProviderUrl
    slug
    startDate
    startDateTime
    endDate
    endDateTime
    status
    addressString
    title
    venue {
      id
      title
      addressString
    }
    registrationsAggregate {
      aggregate {
        count
      }
    }
  }
  lessons: lessonParticipants(
    where: {userId: {_eq: $userId}, status: {_eq: ACTIVE}, lesson: {status: {_eq: ACTIVE}}}
    orderBy: {lesson: {startDateTime: ASC}}
  ) {
    id
    lesson {
      id
      title
      type
      typeCustom
      startDateTime
      endDateTime
      sport
      coverImageProviderUrl
      ownerProfile {
        id
        fullName
        profileImageProviderUrl
      }
      venue {
        id
        title
        addressString
      }
      userCustomCourt {
        id
        title
        fullAddress
      }
    }
  }
}
    `;

/**
 * __useGetMyActivityQuery__
 *
 * To run a query within a React component, call `useGetMyActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyActivityQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyActivityQuery(baseOptions: Apollo.QueryHookOptions<GetMyActivityQuery, GetMyActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyActivityQuery, GetMyActivityQueryVariables>(GetMyActivityDocument, options);
      }
export function useGetMyActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyActivityQuery, GetMyActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyActivityQuery, GetMyActivityQueryVariables>(GetMyActivityDocument, options);
        }
export type GetMyActivityQueryHookResult = ReturnType<typeof useGetMyActivityQuery>;
export type GetMyActivityLazyQueryHookResult = ReturnType<typeof useGetMyActivityLazyQuery>;
export type GetMyActivityQueryResult = Apollo.QueryResult<GetMyActivityQuery, GetMyActivityQueryVariables>;
export const GetMyActiveAvailabilitiesDocument = gql`
    query GetMyActiveAvailabilities($userId: uuid!) {
  playerAvailabilities(
    where: {userId: {_eq: $userId}, isActive: {_eq: true}}
    orderBy: {createdAt: DESC}
  ) {
    id
  }
}
    `;

/**
 * __useGetMyActiveAvailabilitiesQuery__
 *
 * To run a query within a React component, call `useGetMyActiveAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyActiveAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyActiveAvailabilitiesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyActiveAvailabilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetMyActiveAvailabilitiesQuery, GetMyActiveAvailabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyActiveAvailabilitiesQuery, GetMyActiveAvailabilitiesQueryVariables>(GetMyActiveAvailabilitiesDocument, options);
      }
export function useGetMyActiveAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyActiveAvailabilitiesQuery, GetMyActiveAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyActiveAvailabilitiesQuery, GetMyActiveAvailabilitiesQueryVariables>(GetMyActiveAvailabilitiesDocument, options);
        }
export type GetMyActiveAvailabilitiesQueryHookResult = ReturnType<typeof useGetMyActiveAvailabilitiesQuery>;
export type GetMyActiveAvailabilitiesLazyQueryHookResult = ReturnType<typeof useGetMyActiveAvailabilitiesLazyQuery>;
export type GetMyActiveAvailabilitiesQueryResult = Apollo.QueryResult<GetMyActiveAvailabilitiesQuery, GetMyActiveAvailabilitiesQueryVariables>;
export const GetMyAvailabilityHistoryDocument = gql`
    query GetMyAvailabilityHistory($userId: uuid!) {
  playerAvailabilities(
    where: {userId: {_eq: $userId}, isActive: {_eq: false}}
    orderBy: {createdAt: DESC}
  ) {
    id
    createdAt
    sport
    teamType
    selfRatedMinSkillLevel {
      id
      displayName
    }
    selfRatedMaxSkillLevel {
      id
      displayName
    }
    ratingScales {
      id
      minimumRating
      maximumRating
      pickleballRatingScale {
        id
        shortName
      }
      tennisRatingScale {
        id
        shortName
      }
      padelRatingScale {
        id
        shortName
      }
    }
  }
}
    `;

/**
 * __useGetMyAvailabilityHistoryQuery__
 *
 * To run a query within a React component, call `useGetMyAvailabilityHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAvailabilityHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAvailabilityHistoryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyAvailabilityHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetMyAvailabilityHistoryQuery, GetMyAvailabilityHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAvailabilityHistoryQuery, GetMyAvailabilityHistoryQueryVariables>(GetMyAvailabilityHistoryDocument, options);
      }
export function useGetMyAvailabilityHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAvailabilityHistoryQuery, GetMyAvailabilityHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAvailabilityHistoryQuery, GetMyAvailabilityHistoryQueryVariables>(GetMyAvailabilityHistoryDocument, options);
        }
export type GetMyAvailabilityHistoryQueryHookResult = ReturnType<typeof useGetMyAvailabilityHistoryQuery>;
export type GetMyAvailabilityHistoryLazyQueryHookResult = ReturnType<typeof useGetMyAvailabilityHistoryLazyQuery>;
export type GetMyAvailabilityHistoryQueryResult = Apollo.QueryResult<GetMyAvailabilityHistoryQuery, GetMyAvailabilityHistoryQueryVariables>;
export const GetMySentAvailabilityRequestsDocument = gql`
    query GetMySentAvailabilityRequests($userId: uuid!) {
  playRequests(
    where: {requesterUserId: {_eq: $userId}, availabilityId: {_isNull: false}, status: {_eq: PENDING}, deletedAt: {_isNull: true}}
    orderBy: {createdAt: DESC}
  ) {
    id
    status
    requestMessage
    createdAt
    availability {
      ...FindPlayerAvailabilityFields
    }
    slots {
      id
      requestedStartAt
      requestedEndAt
      availabilitySlot {
        id
        dayOfWeek
        startTime
        endTime
      }
    }
    neighborhoods {
      id
      neighborhood {
        id
        name
      }
    }
    venues {
      id
      venue {
        id
        title
      }
    }
  }
}
    ${FindPlayerAvailabilityFieldsFragmentDoc}`;

/**
 * __useGetMySentAvailabilityRequestsQuery__
 *
 * To run a query within a React component, call `useGetMySentAvailabilityRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySentAvailabilityRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySentAvailabilityRequestsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMySentAvailabilityRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetMySentAvailabilityRequestsQuery, GetMySentAvailabilityRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySentAvailabilityRequestsQuery, GetMySentAvailabilityRequestsQueryVariables>(GetMySentAvailabilityRequestsDocument, options);
      }
export function useGetMySentAvailabilityRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySentAvailabilityRequestsQuery, GetMySentAvailabilityRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySentAvailabilityRequestsQuery, GetMySentAvailabilityRequestsQueryVariables>(GetMySentAvailabilityRequestsDocument, options);
        }
export type GetMySentAvailabilityRequestsQueryHookResult = ReturnType<typeof useGetMySentAvailabilityRequestsQuery>;
export type GetMySentAvailabilityRequestsLazyQueryHookResult = ReturnType<typeof useGetMySentAvailabilityRequestsLazyQuery>;
export type GetMySentAvailabilityRequestsQueryResult = Apollo.QueryResult<GetMySentAvailabilityRequestsQuery, GetMySentAvailabilityRequestsQueryVariables>;
export const GetMyCompetitionsDocument = gql`
    query getMyCompetitions($where: EventsBoolExp!) {
  events(where: $where, orderBy: {startDateTime: DESC}) {
    id
    slug
    title
    type
    sport
    startDateTime
    registrationPriceUnitAmount
    currency
    coverImageProviderUrl
    displayLocation
    sourceOrganizerTitle
    venue {
      id
      title
      images {
        url
        path
      }
    }
    hostUserProfile {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetMyCompetitionsQuery__
 *
 * To run a query within a React component, call `useGetMyCompetitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCompetitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCompetitionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMyCompetitionsQuery(baseOptions: Apollo.QueryHookOptions<GetMyCompetitionsQuery, GetMyCompetitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCompetitionsQuery, GetMyCompetitionsQueryVariables>(GetMyCompetitionsDocument, options);
      }
export function useGetMyCompetitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCompetitionsQuery, GetMyCompetitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCompetitionsQuery, GetMyCompetitionsQueryVariables>(GetMyCompetitionsDocument, options);
        }
export type GetMyCompetitionsQueryHookResult = ReturnType<typeof useGetMyCompetitionsQuery>;
export type GetMyCompetitionsLazyQueryHookResult = ReturnType<typeof useGetMyCompetitionsLazyQuery>;
export type GetMyCompetitionsQueryResult = Apollo.QueryResult<GetMyCompetitionsQuery, GetMyCompetitionsQueryVariables>;
export const GetUpcomingHostedLessonsDocument = gql`
    query getUpcomingHostedLessons($userId: uuid!, $startDate: timestamptz!) {
  lessons(
    where: {ownerUserId: {_eq: $userId}, status: {_eq: ACTIVE}, startDateTime: {_gte: $startDate}}
    orderBy: {startDateTime: ASC}
  ) {
    id
    title
    startDateTime
    endDateTime
    description
    sport
    type
    externalBookingUrl
    externalSource
    coverImageProviderUrl
    priceUnitAmount
    currency
    participantLimit
    ownerProfile {
      fullName
      profileImageUrl
      username
      isProfessionalRacquetRegistryActive
      priceUnitAmountCoachDefault
      stripeMerchantCurrency
      currencyCoachDefault
      coachReviewsAggregate {
        aggregate {
          count
          avg {
            rating
          }
        }
      }
    }
    participants {
      id
      userProfile {
        fullName
        profileImagePath
      }
    }
    userCustomCourt {
      fullAddress
    }
    venue {
      id
      addressString
      latitude
      longitude
      geometry
      title
      images {
        id
        url
        path
        provider
        fileName
      }
    }
  }
}
    `;

/**
 * __useGetUpcomingHostedLessonsQuery__
 *
 * To run a query within a React component, call `useGetUpcomingHostedLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingHostedLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingHostedLessonsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetUpcomingHostedLessonsQuery(baseOptions: Apollo.QueryHookOptions<GetUpcomingHostedLessonsQuery, GetUpcomingHostedLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpcomingHostedLessonsQuery, GetUpcomingHostedLessonsQueryVariables>(GetUpcomingHostedLessonsDocument, options);
      }
export function useGetUpcomingHostedLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpcomingHostedLessonsQuery, GetUpcomingHostedLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpcomingHostedLessonsQuery, GetUpcomingHostedLessonsQueryVariables>(GetUpcomingHostedLessonsDocument, options);
        }
export type GetUpcomingHostedLessonsQueryHookResult = ReturnType<typeof useGetUpcomingHostedLessonsQuery>;
export type GetUpcomingHostedLessonsLazyQueryHookResult = ReturnType<typeof useGetUpcomingHostedLessonsLazyQuery>;
export type GetUpcomingHostedLessonsQueryResult = Apollo.QueryResult<GetUpcomingHostedLessonsQuery, GetUpcomingHostedLessonsQueryVariables>;
export const GetMyAttendedSessionsDocument = gql`
    query GetMyAttendedSessions($where: EventsBoolExp!) {
  events(where: $where, orderBy: {startDateTime: DESC}) {
    id
    slug
    title
    sport
    type
    startDateTime
    skillLevels {
      id
      skillLevel
    }
    registrationsAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetMyAttendedSessionsQuery__
 *
 * To run a query within a React component, call `useGetMyAttendedSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAttendedSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAttendedSessionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMyAttendedSessionsQuery(baseOptions: Apollo.QueryHookOptions<GetMyAttendedSessionsQuery, GetMyAttendedSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAttendedSessionsQuery, GetMyAttendedSessionsQueryVariables>(GetMyAttendedSessionsDocument, options);
      }
export function useGetMyAttendedSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAttendedSessionsQuery, GetMyAttendedSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAttendedSessionsQuery, GetMyAttendedSessionsQueryVariables>(GetMyAttendedSessionsDocument, options);
        }
export type GetMyAttendedSessionsQueryHookResult = ReturnType<typeof useGetMyAttendedSessionsQuery>;
export type GetMyAttendedSessionsLazyQueryHookResult = ReturnType<typeof useGetMyAttendedSessionsLazyQuery>;
export type GetMyAttendedSessionsQueryResult = Apollo.QueryResult<GetMyAttendedSessionsQuery, GetMyAttendedSessionsQueryVariables>;
export const GetMyUpcomingActivitiesDocument = gql`
    query GetMyUpcomingActivities($eventsWhere: EventsBoolExp!, $lessonsWhere: LessonsBoolExp!) {
  events(where: $eventsWhere, orderBy: {startDateTime: ASC}) {
    ...ActivityEventCardFields
    ...FindGameEventFields
  }
  lessons(where: $lessonsWhere, orderBy: {startDateTime: ASC}) {
    id
    title
    ownerUserId
    startDateTime
    endDateTime
    timezoneName
    description
    sport
    type
    externalBookingUrl
    externalSource
    coverImageProviderUrl
    priceUnitAmount
    currency
    participantLimit
    ownerProfile {
      fullName
      profileImageUrl
      username
      isProfessionalRacquetRegistryActive
      priceUnitAmountCoachDefault
      stripeMerchantCurrency
      currencyCoachDefault
      coachReviewsAggregate {
        aggregate {
          count
          avg {
            rating
          }
        }
      }
    }
    participants {
      id
      userProfile {
        fullName
        profileImagePath
      }
    }
    userCustomCourt {
      fullAddress
    }
    venue {
      id
      addressString
      latitude
      longitude
      geometry
      title
      timezone
      images {
        id
        url
        path
        provider
        fileName
      }
    }
  }
}
    ${ActivityEventCardFieldsFragmentDoc}
${FindGameEventFieldsFragmentDoc}`;

/**
 * __useGetMyUpcomingActivitiesQuery__
 *
 * To run a query within a React component, call `useGetMyUpcomingActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyUpcomingActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyUpcomingActivitiesQuery({
 *   variables: {
 *      eventsWhere: // value for 'eventsWhere'
 *      lessonsWhere: // value for 'lessonsWhere'
 *   },
 * });
 */
export function useGetMyUpcomingActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetMyUpcomingActivitiesQuery, GetMyUpcomingActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyUpcomingActivitiesQuery, GetMyUpcomingActivitiesQueryVariables>(GetMyUpcomingActivitiesDocument, options);
      }
export function useGetMyUpcomingActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyUpcomingActivitiesQuery, GetMyUpcomingActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyUpcomingActivitiesQuery, GetMyUpcomingActivitiesQueryVariables>(GetMyUpcomingActivitiesDocument, options);
        }
export type GetMyUpcomingActivitiesQueryHookResult = ReturnType<typeof useGetMyUpcomingActivitiesQuery>;
export type GetMyUpcomingActivitiesLazyQueryHookResult = ReturnType<typeof useGetMyUpcomingActivitiesLazyQuery>;
export type GetMyUpcomingActivitiesQueryResult = Apollo.QueryResult<GetMyUpcomingActivitiesQuery, GetMyUpcomingActivitiesQueryVariables>;
export const GetMyActivityChatStateDocument = gql`
    query GetMyActivityChatState($userId: uuid!) {
  conversationParticipants(
    where: {userId: {_eq: $userId}, deletedAt: {_isNull: true}, conversation: {deletedAt: {_isNull: true}}}
  ) {
    id
    lastReadAt
    conversation {
      id
      eventId
      lessonId
      lastMessageAt
    }
  }
}
    `;

/**
 * __useGetMyActivityChatStateQuery__
 *
 * To run a query within a React component, call `useGetMyActivityChatStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyActivityChatStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyActivityChatStateQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyActivityChatStateQuery(baseOptions: Apollo.QueryHookOptions<GetMyActivityChatStateQuery, GetMyActivityChatStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyActivityChatStateQuery, GetMyActivityChatStateQueryVariables>(GetMyActivityChatStateDocument, options);
      }
export function useGetMyActivityChatStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyActivityChatStateQuery, GetMyActivityChatStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyActivityChatStateQuery, GetMyActivityChatStateQueryVariables>(GetMyActivityChatStateDocument, options);
        }
export type GetMyActivityChatStateQueryHookResult = ReturnType<typeof useGetMyActivityChatStateQuery>;
export type GetMyActivityChatStateLazyQueryHookResult = ReturnType<typeof useGetMyActivityChatStateLazyQuery>;
export type GetMyActivityChatStateQueryResult = Apollo.QueryResult<GetMyActivityChatStateQuery, GetMyActivityChatStateQueryVariables>;
export const GetMyOutgoingGameRequestsDocument = gql`
    query GetMyOutgoingGameRequests($userId: uuid!, $startDate: timestamptz!) {
  playRequests(
    where: {requesterUserId: {_eq: $userId}, status: {_in: [PENDING, ACCEPTED]}, deletedAt: {_isNull: true}, eventId: {_isNull: false}, event: {startDateTime: {_gte: $startDate}, status: {_eq: PUBLISHED}, deletedAt: {_isNull: true}}}
    orderBy: {createdAt: DESC}
  ) {
    id
    status
    requestMessage
    createdAt
    event {
      ...FindGameEventFields
    }
  }
}
    ${FindGameEventFieldsFragmentDoc}`;

/**
 * __useGetMyOutgoingGameRequestsQuery__
 *
 * To run a query within a React component, call `useGetMyOutgoingGameRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOutgoingGameRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOutgoingGameRequestsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetMyOutgoingGameRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetMyOutgoingGameRequestsQuery, GetMyOutgoingGameRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOutgoingGameRequestsQuery, GetMyOutgoingGameRequestsQueryVariables>(GetMyOutgoingGameRequestsDocument, options);
      }
export function useGetMyOutgoingGameRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOutgoingGameRequestsQuery, GetMyOutgoingGameRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOutgoingGameRequestsQuery, GetMyOutgoingGameRequestsQueryVariables>(GetMyOutgoingGameRequestsDocument, options);
        }
export type GetMyOutgoingGameRequestsQueryHookResult = ReturnType<typeof useGetMyOutgoingGameRequestsQuery>;
export type GetMyOutgoingGameRequestsLazyQueryHookResult = ReturnType<typeof useGetMyOutgoingGameRequestsLazyQuery>;
export type GetMyOutgoingGameRequestsQueryResult = Apollo.QueryResult<GetMyOutgoingGameRequestsQuery, GetMyOutgoingGameRequestsQueryVariables>;
export const GetMyAcceptedAvailabilityMatchesDocument = gql`
    query GetMyAcceptedAvailabilityMatches($userId: uuid!, $startDate: timestamptz!) {
  playRequests(
    where: {status: {_eq: ACCEPTED}, availabilityId: {_isNull: false}, deletedAt: {_isNull: true}, _or: [{requesterUserId: {_eq: $userId}}, {recipientUserId: {_eq: $userId}}], slots: {requestedStartAt: {_gte: $startDate}}}
  ) {
    id
    conversationId
    requesterUserId
    recipientUserId
    requesterProfile {
      ...AvailabilityMatchPlayerFields
    }
    recipientProfile {
      ...AvailabilityMatchPlayerFields
    }
    availability {
      id
      sport
      competitiveness
      teamType
      gender
      selfRatedMinSkillLevel {
        id
        displayName
      }
      selfRatedMaxSkillLevel {
        id
        displayName
      }
      ratingScales {
        id
        minimumRating
        maximumRating
        pickleballRatingScale {
          id
          shortName
        }
        tennisRatingScale {
          id
          shortName
        }
        padelRatingScale {
          id
          shortName
        }
      }
    }
    slots {
      id
      requestedStartAt
      requestedEndAt
    }
    selectedVenue {
      id
      title
      timezone
      latitude
      longitude
      indoorCourtCount
      outdoorCourtCount
    }
  }
}
    ${AvailabilityMatchPlayerFieldsFragmentDoc}`;

/**
 * __useGetMyAcceptedAvailabilityMatchesQuery__
 *
 * To run a query within a React component, call `useGetMyAcceptedAvailabilityMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAcceptedAvailabilityMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAcceptedAvailabilityMatchesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetMyAcceptedAvailabilityMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetMyAcceptedAvailabilityMatchesQuery, GetMyAcceptedAvailabilityMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAcceptedAvailabilityMatchesQuery, GetMyAcceptedAvailabilityMatchesQueryVariables>(GetMyAcceptedAvailabilityMatchesDocument, options);
      }
export function useGetMyAcceptedAvailabilityMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAcceptedAvailabilityMatchesQuery, GetMyAcceptedAvailabilityMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAcceptedAvailabilityMatchesQuery, GetMyAcceptedAvailabilityMatchesQueryVariables>(GetMyAcceptedAvailabilityMatchesDocument, options);
        }
export type GetMyAcceptedAvailabilityMatchesQueryHookResult = ReturnType<typeof useGetMyAcceptedAvailabilityMatchesQuery>;
export type GetMyAcceptedAvailabilityMatchesLazyQueryHookResult = ReturnType<typeof useGetMyAcceptedAvailabilityMatchesLazyQuery>;
export type GetMyAcceptedAvailabilityMatchesQueryResult = Apollo.QueryResult<GetMyAcceptedAvailabilityMatchesQuery, GetMyAcceptedAvailabilityMatchesQueryVariables>;
export const GetMyCourtBookingsDocument = gql`
    query GetMyCourtBookings($from: timestamptz!, $statuses: [PartnerBookingOrderStatusesEnum!]!) {
  partnerBookingOrders(
    where: {startAt: {_gte: $from}, status: {_in: $statuses}}
    orderBy: {startAt: ASC}
  ) {
    id
    status
    startAt
    endAt
    timezone
    providerCourtId
    venue {
      id
      title
      slug
      timezone
      images(where: {isVisible: {_eq: true}}, limit: 1) {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useGetMyCourtBookingsQuery__
 *
 * To run a query within a React component, call `useGetMyCourtBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCourtBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCourtBookingsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetMyCourtBookingsQuery(baseOptions: Apollo.QueryHookOptions<GetMyCourtBookingsQuery, GetMyCourtBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCourtBookingsQuery, GetMyCourtBookingsQueryVariables>(GetMyCourtBookingsDocument, options);
      }
export function useGetMyCourtBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCourtBookingsQuery, GetMyCourtBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCourtBookingsQuery, GetMyCourtBookingsQueryVariables>(GetMyCourtBookingsDocument, options);
        }
export type GetMyCourtBookingsQueryHookResult = ReturnType<typeof useGetMyCourtBookingsQuery>;
export type GetMyCourtBookingsLazyQueryHookResult = ReturnType<typeof useGetMyCourtBookingsLazyQuery>;
export type GetMyCourtBookingsQueryResult = Apollo.QueryResult<GetMyCourtBookingsQuery, GetMyCourtBookingsQueryVariables>;
export const GetCoachSettingsDocument = gql`
    query getCoachSettings($id: uuid!) {
  usersByPk(id: $id) {
    aboutMe
    aboutMeVideoUrl
    birthday
    coachAvailability {
      id
      endTimeMinutes
      dayOfWeek
      startTimeMinutes
      coachAvailabilityCustomCourt {
        id
      }
      coachAvailabilityVenueId {
        id
      }
      status
    }
    coachLessonAgeGroups {
      id
      lessonAgeGroup
    }
    coachLessonSkillLevels {
      id
      skillLevel
    }
    coachLessonDescription
    coachLessonHowToPrepare
    coachStatus
    coachExternalBookingUrl
    customCourts {
      id
      title
      fullAddress
    }
    defaultCoachCustomCourt {
      id
      fullAddress
      title
      latitude
      longitude
    }
    defaultCoachVenue {
      id
      addressString
      images {
        id
        url
        path
        provider
        fileName
      }
      isActive
      latitude
      longitude
      outdoorCourtCount
      geometry
      indoorCourtCount
      slug
      timezone
      title
    }
    defaultSport
    coachSports(where: {status: {_eq: ACTIVE}}) {
      sport
    }
    duprId
    fullName
    gender
    genderPreference
    geometry
    id
    latitude
    longitude
    locale
    isPciMember
    pciId
    isIptpaMember
    didSkipStripeSetup
    iptpaId
    isQuatroPickleballMember
    quatroPickleballMemberId
    phoneCountryCode
    phoneNumber
    pprId
    preferredName
    profileImageUrl
    profileImageProviderUrl
    profileImageProviderId
    profileImagePath
    profileImageProvider
    profileImageFileName
    stripeCustomerId
    stripeMerchantBusinessType
    stripeMerchantChargesEnabled
    stripeMerchantCountry
    stripeMerchantCurrency
    stripeMerchantDetailsSubmitted
    stripeMerchantId
    stripeMerchantPayoutsEnabled
    timezone
    username
    coachingStartYear
    priceUnitAmountCoachDefault
    priceUnitAmountRemoteCoachDefault
    priceUnitAmountPremiumContentDefault
    premiumContentDescription
    currencyCoachDefault
    pickleballRatingScales {
      id
      rating
      pickleballRatingScaleId
      scale {
        name
        id
        shortName
      }
    }
    userFiles {
      fileCategory
      fileFormat
      fileName
      fileType
      host
      path
      originalFileName
      provider
      providerId
      providerUrl
      url
    }
  }
}
    `;

/**
 * __useGetCoachSettingsQuery__
 *
 * To run a query within a React component, call `useGetCoachSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCoachSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetCoachSettingsQuery, GetCoachSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachSettingsQuery, GetCoachSettingsQueryVariables>(GetCoachSettingsDocument, options);
      }
export function useGetCoachSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachSettingsQuery, GetCoachSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachSettingsQuery, GetCoachSettingsQueryVariables>(GetCoachSettingsDocument, options);
        }
export type GetCoachSettingsQueryHookResult = ReturnType<typeof useGetCoachSettingsQuery>;
export type GetCoachSettingsLazyQueryHookResult = ReturnType<typeof useGetCoachSettingsLazyQuery>;
export type GetCoachSettingsQueryResult = Apollo.QueryResult<GetCoachSettingsQuery, GetCoachSettingsQueryVariables>;
export const UpdateCoachSettingsDocument = gql`
    mutation updateCoachSettings($userId: uuid!, $objects: [CoachAvailabilityInsertInput!] = [], $pickleRatingObjects: [UserPickleballRatingScalesInsertInput!] = [], $aboutMe: String!, $gender: GenderEnum!, $profileImageProviderUrl: String!, $profileImageUrl: String!, $profileImageProviderId: String!, $profileImagePath: String!, $profileImageProvider: String!, $profileImageFileName: String!, $priceUnitAmountCoachDefault: Int!, $priceUnitAmountRemoteCoachDefault: Int, $defaultCoachVenueId: uuid, $isPciMember: Boolean, $isIptpaMember: Boolean, $isQuatroPickleballMember: Boolean, $iptpaId: String, $quatroPickleballMemberId: String, $coachingStartYear: Int, $coachLessonHowToPrepare: String!, $coachLessonDescription: String!, $coachLessonAgeGroups: [CoachLessonAgeGroupsInsertInput!] = [], $coachSkillLevelGroups: [CoachLessonSkillLevelsInsertInput!] = [], $coachStatus: CoachStatusEnum!, $userTimeZone: String!, $defaultCoachUserCustomCourtId: uuid, $images: [UserFilesInsertInput!] = [], $phoneNumber: String!, $phoneCountryCode: String!, $coachExternalBookingUrl: String, $defaultSport: SportsEnum!) {
  updateUsersByPk(
    pkColumns: {id: $userId}
    _set: {aboutMe: $aboutMe, gender: $gender, profileImageProviderUrl: $profileImageProviderUrl, profileImageUrl: $profileImageUrl, profileImageProviderId: $profileImageProviderId, profileImagePath: $profileImagePath, profileImageProvider: $profileImageProvider, profileImageFileName: $profileImageFileName, priceUnitAmountCoachDefault: $priceUnitAmountCoachDefault, defaultCoachVenueId: $defaultCoachVenueId, isPciMember: $isPciMember, isIptpaMember: $isIptpaMember, isQuatroPickleballMember: $isQuatroPickleballMember, iptpaId: $iptpaId, quatroPickleballMemberId: $quatroPickleballMemberId, coachingStartYear: $coachingStartYear, coachLessonHowToPrepare: $coachLessonHowToPrepare, coachLessonDescription: $coachLessonDescription, coachStatus: $coachStatus, timezone: $userTimeZone, defaultCoachUserCustomCourtId: $defaultCoachUserCustomCourtId, phoneNumber: $phoneNumber, phoneCountryCode: $phoneCountryCode, coachExternalBookingUrl: $coachExternalBookingUrl, defaultSport: $defaultSport, priceUnitAmountRemoteCoachDefault: $priceUnitAmountRemoteCoachDefault}
  ) {
    id
    aboutMe
    gender
    profileImageUrl
    profileImageProviderUrl
    profileImageProviderId
    profileImagePath
    profileImageProvider
    profileImageFileName
    priceUnitAmountCoachDefault
    isPciMember
    coachingStartYear
    coachLessonHowToPrepare
    coachLessonDescription
    coachExternalBookingUrl
    defaultSport
    coachAvailability {
      id
      endTimeMinutes
      dayOfWeek
      startTimeMinutes
    }
    defaultCoachCustomCourt {
      id
      fullAddress
      title
      latitude
      longitude
    }
    defaultCoachVenue {
      id
      addressString
    }
  }
  deleteCoachAvailability(where: {userId: {_eq: $userId}}) {
    returning {
      id
      startTimeMinutes
      endTimeMinutes
      dayOfWeek
    }
  }
  insertCoachAvailability(
    objects: $objects
    onConflict: {constraint: coach_availability_pkey, updateColumns: [startTimeMinutes, endTimeMinutes]}
  ) {
    returning {
      id
      endTimeMinutes
      startTimeMinutes
      dayOfWeek
    }
  }
  deleteUserPickleballRatingScales(where: {userId: {_eq: $userId}}) {
    returning {
      id
      pickleballRatingScaleId
      rating
      userId
    }
  }
  insertUserPickleballRatingScales(
    objects: $pickleRatingObjects
    onConflict: {constraint: user_pickleball_rating_scales_user_id_pickleball_rating_sca_key, updateColumns: [rating]}
  ) {
    returning {
      id
      pickleballRatingScaleId
      rating
      userId
    }
  }
  deleteCoachLessonAgeGroups(where: {userId: {_eq: $userId}}) {
    returning {
      id
      lessonAgeGroup
      userId
    }
  }
  insertCoachLessonAgeGroups(
    objects: $coachLessonAgeGroups
    onConflict: {constraint: coach_lesson_age_groups_user_id_lesson_age_group_key, updateColumns: [lessonAgeGroup]}
  ) {
    returning {
      id
      lessonAgeGroup
      userId
    }
  }
  deleteCoachLessonSkillLevels(where: {userId: {_eq: $userId}}) {
    returning {
      id
      skillLevel
      userId
    }
  }
  insertCoachLessonSkillLevels(
    objects: $coachSkillLevelGroups
    onConflict: {constraint: coach_lesson_skill_levels_skill_level_user_id_key, updateColumns: [skillLevel]}
  ) {
    returning {
      id
      skillLevel
      userId
    }
  }
  deleteUserFiles(where: {userId: {_eq: $userId}}) {
    returning {
      id
    }
  }
  insertUserFiles(
    objects: $images
    onConflict: {constraint: user_files_pkey, updateColumns: [deletedAt]}
  ) {
    returning {
      id
      path
      fileType
      fileName
    }
  }
}
    `;
export type UpdateCoachSettingsMutationFn = Apollo.MutationFunction<UpdateCoachSettingsMutation, UpdateCoachSettingsMutationVariables>;

/**
 * __useUpdateCoachSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCoachSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachSettingsMutation, { data, loading, error }] = useUpdateCoachSettingsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      objects: // value for 'objects'
 *      pickleRatingObjects: // value for 'pickleRatingObjects'
 *      aboutMe: // value for 'aboutMe'
 *      gender: // value for 'gender'
 *      profileImageProviderUrl: // value for 'profileImageProviderUrl'
 *      profileImageUrl: // value for 'profileImageUrl'
 *      profileImageProviderId: // value for 'profileImageProviderId'
 *      profileImagePath: // value for 'profileImagePath'
 *      profileImageProvider: // value for 'profileImageProvider'
 *      profileImageFileName: // value for 'profileImageFileName'
 *      priceUnitAmountCoachDefault: // value for 'priceUnitAmountCoachDefault'
 *      priceUnitAmountRemoteCoachDefault: // value for 'priceUnitAmountRemoteCoachDefault'
 *      defaultCoachVenueId: // value for 'defaultCoachVenueId'
 *      isPciMember: // value for 'isPciMember'
 *      isIptpaMember: // value for 'isIptpaMember'
 *      isQuatroPickleballMember: // value for 'isQuatroPickleballMember'
 *      iptpaId: // value for 'iptpaId'
 *      quatroPickleballMemberId: // value for 'quatroPickleballMemberId'
 *      coachingStartYear: // value for 'coachingStartYear'
 *      coachLessonHowToPrepare: // value for 'coachLessonHowToPrepare'
 *      coachLessonDescription: // value for 'coachLessonDescription'
 *      coachLessonAgeGroups: // value for 'coachLessonAgeGroups'
 *      coachSkillLevelGroups: // value for 'coachSkillLevelGroups'
 *      coachStatus: // value for 'coachStatus'
 *      userTimeZone: // value for 'userTimeZone'
 *      defaultCoachUserCustomCourtId: // value for 'defaultCoachUserCustomCourtId'
 *      images: // value for 'images'
 *      phoneNumber: // value for 'phoneNumber'
 *      phoneCountryCode: // value for 'phoneCountryCode'
 *      coachExternalBookingUrl: // value for 'coachExternalBookingUrl'
 *      defaultSport: // value for 'defaultSport'
 *   },
 * });
 */
export function useUpdateCoachSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoachSettingsMutation, UpdateCoachSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoachSettingsMutation, UpdateCoachSettingsMutationVariables>(UpdateCoachSettingsDocument, options);
      }
export type UpdateCoachSettingsMutationHookResult = ReturnType<typeof useUpdateCoachSettingsMutation>;
export type UpdateCoachSettingsMutationResult = Apollo.MutationResult<UpdateCoachSettingsMutation>;
export type UpdateCoachSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCoachSettingsMutation, UpdateCoachSettingsMutationVariables>;
export const UpdateCoachAvailabilityDocument = gql`
    mutation updateCoachAvailability($userId: uuid!, $objects: [CoachAvailabilityInsertInput!] = []) {
  deleteCoachAvailability(where: {userId: {_eq: $userId}}) {
    returning {
      id
      startTimeMinutes
      endTimeMinutes
      dayOfWeek
    }
  }
  insertCoachAvailability(
    objects: $objects
    onConflict: {constraint: coach_availability_pkey, updateColumns: [startTimeMinutes, endTimeMinutes]}
  ) {
    returning {
      id
      endTimeMinutes
      startTimeMinutes
      dayOfWeek
    }
  }
}
    `;
export type UpdateCoachAvailabilityMutationFn = Apollo.MutationFunction<UpdateCoachAvailabilityMutation, UpdateCoachAvailabilityMutationVariables>;

/**
 * __useUpdateCoachAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpdateCoachAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachAvailabilityMutation, { data, loading, error }] = useUpdateCoachAvailabilityMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpdateCoachAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoachAvailabilityMutation, UpdateCoachAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoachAvailabilityMutation, UpdateCoachAvailabilityMutationVariables>(UpdateCoachAvailabilityDocument, options);
      }
export type UpdateCoachAvailabilityMutationHookResult = ReturnType<typeof useUpdateCoachAvailabilityMutation>;
export type UpdateCoachAvailabilityMutationResult = Apollo.MutationResult<UpdateCoachAvailabilityMutation>;
export type UpdateCoachAvailabilityMutationOptions = Apollo.BaseMutationOptions<UpdateCoachAvailabilityMutation, UpdateCoachAvailabilityMutationVariables>;
export const GetUniqueCoachVenueCourtsDocument = gql`
    query getUniqueCoachVenueCourts($userId: uuid!) {
  coachAvailability(
    distinctOn: [venueId, userCustomCourtId]
    where: {userId: {_eq: $userId}}
  ) {
    status
    userCustomCourtId
    userId
    coachAvailabilityCustomCourt {
      fullAddress
      id
      latitude
      longitude
    }
    coachAvailabilityVenueId {
      addressString
      id
      latitude
      longitude
      timezone
      description
      addressString
      pickleballNets
      slug
      outdoorCourtCount
      indoorCourtCount
      title
      accessType
      images(where: {isVisible: {_eq: true}}) {
        id
        isVisible
        fileName
        path
        provider
        url
      }
    }
  }
}
    `;

/**
 * __useGetUniqueCoachVenueCourtsQuery__
 *
 * To run a query within a React component, call `useGetUniqueCoachVenueCourtsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqueCoachVenueCourtsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqueCoachVenueCourtsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUniqueCoachVenueCourtsQuery(baseOptions: Apollo.QueryHookOptions<GetUniqueCoachVenueCourtsQuery, GetUniqueCoachVenueCourtsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniqueCoachVenueCourtsQuery, GetUniqueCoachVenueCourtsQueryVariables>(GetUniqueCoachVenueCourtsDocument, options);
      }
export function useGetUniqueCoachVenueCourtsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniqueCoachVenueCourtsQuery, GetUniqueCoachVenueCourtsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniqueCoachVenueCourtsQuery, GetUniqueCoachVenueCourtsQueryVariables>(GetUniqueCoachVenueCourtsDocument, options);
        }
export type GetUniqueCoachVenueCourtsQueryHookResult = ReturnType<typeof useGetUniqueCoachVenueCourtsQuery>;
export type GetUniqueCoachVenueCourtsLazyQueryHookResult = ReturnType<typeof useGetUniqueCoachVenueCourtsLazyQuery>;
export type GetUniqueCoachVenueCourtsQueryResult = Apollo.QueryResult<GetUniqueCoachVenueCourtsQuery, GetUniqueCoachVenueCourtsQueryVariables>;
export const UpdateCoachImagesDocument = gql`
    mutation updateCoachImages($userId: uuid!, $profileImageProviderUrl: String, $profileImageUrl: String, $profileImageProviderId: String, $profileImagePath: String, $profileImageProvider: String, $profileImageFileName: String, $images: [UserFilesInsertInput!] = []) {
  updateUsersByPk(
    pkColumns: {id: $userId}
    _set: {profileImageProviderUrl: $profileImageProviderUrl, profileImageUrl: $profileImageUrl, profileImageProviderId: $profileImageProviderId, profileImagePath: $profileImagePath, profileImageProvider: $profileImageProvider, profileImageFileName: $profileImageFileName}
  ) {
    id
    aboutMe
    gender
    profileImageUrl
    profileImageProviderUrl
    profileImageProviderId
    profileImagePath
    profileImageProvider
    profileImageFileName
    priceUnitAmountCoachDefault
    isPciMember
    coachingStartYear
    coachLessonHowToPrepare
    coachLessonDescription
    coachExternalBookingUrl
    defaultSport
  }
  deleteUserFiles(where: {userId: {_eq: $userId}}) {
    returning {
      id
    }
  }
  insertUserFiles(
    objects: $images
    onConflict: {constraint: user_files_pkey, updateColumns: [deletedAt]}
  ) {
    returning {
      id
      path
      fileType
      fileName
    }
  }
}
    `;
export type UpdateCoachImagesMutationFn = Apollo.MutationFunction<UpdateCoachImagesMutation, UpdateCoachImagesMutationVariables>;

/**
 * __useUpdateCoachImagesMutation__
 *
 * To run a mutation, you first call `useUpdateCoachImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachImagesMutation, { data, loading, error }] = useUpdateCoachImagesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      profileImageProviderUrl: // value for 'profileImageProviderUrl'
 *      profileImageUrl: // value for 'profileImageUrl'
 *      profileImageProviderId: // value for 'profileImageProviderId'
 *      profileImagePath: // value for 'profileImagePath'
 *      profileImageProvider: // value for 'profileImageProvider'
 *      profileImageFileName: // value for 'profileImageFileName'
 *      images: // value for 'images'
 *   },
 * });
 */
export function useUpdateCoachImagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoachImagesMutation, UpdateCoachImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoachImagesMutation, UpdateCoachImagesMutationVariables>(UpdateCoachImagesDocument, options);
      }
export type UpdateCoachImagesMutationHookResult = ReturnType<typeof useUpdateCoachImagesMutation>;
export type UpdateCoachImagesMutationResult = Apollo.MutationResult<UpdateCoachImagesMutation>;
export type UpdateCoachImagesMutationOptions = Apollo.BaseMutationOptions<UpdateCoachImagesMutation, UpdateCoachImagesMutationVariables>;
export const UpdateCoachSocialsDocument = gql`
    mutation updateCoachSocials($userId: uuid!, $defaultSport: SportsEnum, $xUrl: String, $facebookUrl: String, $linkedinUrl: String, $youtubeUrl: String, $websiteUrl: String, $instagramUrl: String, $sports: [CoachSportsInsertInput!]!) {
  updateUsersByPk(
    pkColumns: {id: $userId}
    _set: {defaultSport: $defaultSport, xUrl: $xUrl, facebookUrl: $facebookUrl, linkedinUrl: $linkedinUrl, youtubeUrl: $youtubeUrl, websiteUrl: $websiteUrl, instagramUrl: $instagramUrl}
  ) {
    id
    aboutMe
    gender
    profileImageUrl
    profileImageProviderUrl
    profileImageProviderId
    profileImagePath
    profileImageProvider
    profileImageFileName
    priceUnitAmountCoachDefault
    isPciMember
    coachingStartYear
    coachLessonHowToPrepare
    coachLessonDescription
    coachExternalBookingUrl
    defaultSport
    xUrl
    facebookUrl
    linkedinUrl
    youtubeUrl
    websiteUrl
    instagramUrl
  }
  insertCoachSports(
    objects: $sports
    onConflict: {constraint: coach_sports_user_id_sport_key, updateColumns: status}
  ) {
    returning {
      id
      sport
      status
      userId
    }
  }
}
    `;
export type UpdateCoachSocialsMutationFn = Apollo.MutationFunction<UpdateCoachSocialsMutation, UpdateCoachSocialsMutationVariables>;

/**
 * __useUpdateCoachSocialsMutation__
 *
 * To run a mutation, you first call `useUpdateCoachSocialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachSocialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachSocialsMutation, { data, loading, error }] = useUpdateCoachSocialsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      defaultSport: // value for 'defaultSport'
 *      xUrl: // value for 'xUrl'
 *      facebookUrl: // value for 'facebookUrl'
 *      linkedinUrl: // value for 'linkedinUrl'
 *      youtubeUrl: // value for 'youtubeUrl'
 *      websiteUrl: // value for 'websiteUrl'
 *      instagramUrl: // value for 'instagramUrl'
 *      sports: // value for 'sports'
 *   },
 * });
 */
export function useUpdateCoachSocialsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoachSocialsMutation, UpdateCoachSocialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoachSocialsMutation, UpdateCoachSocialsMutationVariables>(UpdateCoachSocialsDocument, options);
      }
export type UpdateCoachSocialsMutationHookResult = ReturnType<typeof useUpdateCoachSocialsMutation>;
export type UpdateCoachSocialsMutationResult = Apollo.MutationResult<UpdateCoachSocialsMutation>;
export type UpdateCoachSocialsMutationOptions = Apollo.BaseMutationOptions<UpdateCoachSocialsMutation, UpdateCoachSocialsMutationVariables>;
export const UpdateCoachAboutDocument = gql`
    mutation updateCoachAbout($userId: uuid!, $aboutMe: String) {
  updateUsersByPk(pkColumns: {id: $userId}, _set: {aboutMe: $aboutMe}) {
    id
    aboutMe
    gender
    profileImageUrl
    profileImageProviderUrl
    profileImageProviderId
    profileImagePath
    profileImageProvider
    profileImageFileName
    priceUnitAmountCoachDefault
    isPciMember
    coachingStartYear
    coachLessonHowToPrepare
    coachLessonDescription
    coachExternalBookingUrl
    defaultSport
    xUrl
    facebookUrl
    linkedinUrl
    youtubeUrl
    websiteUrl
  }
}
    `;
export type UpdateCoachAboutMutationFn = Apollo.MutationFunction<UpdateCoachAboutMutation, UpdateCoachAboutMutationVariables>;

/**
 * __useUpdateCoachAboutMutation__
 *
 * To run a mutation, you first call `useUpdateCoachAboutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachAboutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachAboutMutation, { data, loading, error }] = useUpdateCoachAboutMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      aboutMe: // value for 'aboutMe'
 *   },
 * });
 */
export function useUpdateCoachAboutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoachAboutMutation, UpdateCoachAboutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoachAboutMutation, UpdateCoachAboutMutationVariables>(UpdateCoachAboutDocument, options);
      }
export type UpdateCoachAboutMutationHookResult = ReturnType<typeof useUpdateCoachAboutMutation>;
export type UpdateCoachAboutMutationResult = Apollo.MutationResult<UpdateCoachAboutMutation>;
export type UpdateCoachAboutMutationOptions = Apollo.BaseMutationOptions<UpdateCoachAboutMutation, UpdateCoachAboutMutationVariables>;
export const UpdateCoachPrepareDocument = gql`
    mutation updateCoachPrepare($userId: uuid!, $coachLessonHowToPrepare: String) {
  updateUsersByPk(
    pkColumns: {id: $userId}
    _set: {coachLessonHowToPrepare: $coachLessonHowToPrepare}
  ) {
    id
  }
}
    `;
export type UpdateCoachPrepareMutationFn = Apollo.MutationFunction<UpdateCoachPrepareMutation, UpdateCoachPrepareMutationVariables>;

/**
 * __useUpdateCoachPrepareMutation__
 *
 * To run a mutation, you first call `useUpdateCoachPrepareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachPrepareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachPrepareMutation, { data, loading, error }] = useUpdateCoachPrepareMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      coachLessonHowToPrepare: // value for 'coachLessonHowToPrepare'
 *   },
 * });
 */
export function useUpdateCoachPrepareMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoachPrepareMutation, UpdateCoachPrepareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoachPrepareMutation, UpdateCoachPrepareMutationVariables>(UpdateCoachPrepareDocument, options);
      }
export type UpdateCoachPrepareMutationHookResult = ReturnType<typeof useUpdateCoachPrepareMutation>;
export type UpdateCoachPrepareMutationResult = Apollo.MutationResult<UpdateCoachPrepareMutation>;
export type UpdateCoachPrepareMutationOptions = Apollo.BaseMutationOptions<UpdateCoachPrepareMutation, UpdateCoachPrepareMutationVariables>;
export const UpdateCoachDetailsDocument = gql`
    mutation updateCoachDetails($userId: uuid!, $coachLessonDescription: String) {
  updateUsersByPk(
    pkColumns: {id: $userId}
    _set: {coachLessonDescription: $coachLessonDescription}
  ) {
    id
    aboutMe
    gender
    profileImageUrl
    profileImageProviderUrl
    profileImageProviderId
    profileImagePath
    profileImageProvider
    profileImageFileName
    priceUnitAmountCoachDefault
    isPciMember
    coachingStartYear
    coachLessonHowToPrepare
    coachLessonDescription
    coachExternalBookingUrl
    defaultSport
    xUrl
    facebookUrl
    linkedinUrl
    youtubeUrl
    websiteUrl
  }
}
    `;
export type UpdateCoachDetailsMutationFn = Apollo.MutationFunction<UpdateCoachDetailsMutation, UpdateCoachDetailsMutationVariables>;

/**
 * __useUpdateCoachDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateCoachDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachDetailsMutation, { data, loading, error }] = useUpdateCoachDetailsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      coachLessonDescription: // value for 'coachLessonDescription'
 *   },
 * });
 */
export function useUpdateCoachDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoachDetailsMutation, UpdateCoachDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoachDetailsMutation, UpdateCoachDetailsMutationVariables>(UpdateCoachDetailsDocument, options);
      }
export type UpdateCoachDetailsMutationHookResult = ReturnType<typeof useUpdateCoachDetailsMutation>;
export type UpdateCoachDetailsMutationResult = Apollo.MutationResult<UpdateCoachDetailsMutation>;
export type UpdateCoachDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateCoachDetailsMutation, UpdateCoachDetailsMutationVariables>;
export const UpdateCoachParamsDocument = gql`
    mutation updateCoachParams($userId: uuid!, $isPciMember: Boolean, $isIptpaMember: Boolean, $isQuatroPickleballMember: Boolean, $iptpaId: String, $quatroPickleballMemberId: String, $coachingStartYear: Int, $pickleRatingObjects: [UserPickleballRatingScalesInsertInput!] = []) {
  updateUsersByPk(
    pkColumns: {id: $userId}
    _set: {isPciMember: $isPciMember, isIptpaMember: $isIptpaMember, isQuatroPickleballMember: $isQuatroPickleballMember, iptpaId: $iptpaId, quatroPickleballMemberId: $quatroPickleballMemberId, coachingStartYear: $coachingStartYear}
  ) {
    id
    aboutMe
    gender
    profileImageUrl
    profileImageProviderUrl
    profileImageProviderId
    profileImagePath
    profileImageProvider
    profileImageFileName
    priceUnitAmountCoachDefault
    isPciMember
    coachingStartYear
    coachLessonHowToPrepare
    coachLessonDescription
    coachExternalBookingUrl
    defaultSport
  }
  deleteUserPickleballRatingScales(where: {userId: {_eq: $userId}}) {
    returning {
      id
      pickleballRatingScaleId
      rating
      userId
    }
  }
  insertUserPickleballRatingScales(
    objects: $pickleRatingObjects
    onConflict: {constraint: user_pickleball_rating_scales_user_id_pickleball_rating_sca_key, updateColumns: [rating]}
  ) {
    returning {
      id
      pickleballRatingScaleId
      rating
      userId
    }
  }
}
    `;
export type UpdateCoachParamsMutationFn = Apollo.MutationFunction<UpdateCoachParamsMutation, UpdateCoachParamsMutationVariables>;

/**
 * __useUpdateCoachParamsMutation__
 *
 * To run a mutation, you first call `useUpdateCoachParamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachParamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachParamsMutation, { data, loading, error }] = useUpdateCoachParamsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      isPciMember: // value for 'isPciMember'
 *      isIptpaMember: // value for 'isIptpaMember'
 *      isQuatroPickleballMember: // value for 'isQuatroPickleballMember'
 *      iptpaId: // value for 'iptpaId'
 *      quatroPickleballMemberId: // value for 'quatroPickleballMemberId'
 *      coachingStartYear: // value for 'coachingStartYear'
 *      pickleRatingObjects: // value for 'pickleRatingObjects'
 *   },
 * });
 */
export function useUpdateCoachParamsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoachParamsMutation, UpdateCoachParamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoachParamsMutation, UpdateCoachParamsMutationVariables>(UpdateCoachParamsDocument, options);
      }
export type UpdateCoachParamsMutationHookResult = ReturnType<typeof useUpdateCoachParamsMutation>;
export type UpdateCoachParamsMutationResult = Apollo.MutationResult<UpdateCoachParamsMutation>;
export type UpdateCoachParamsMutationOptions = Apollo.BaseMutationOptions<UpdateCoachParamsMutation, UpdateCoachParamsMutationVariables>;
export const UpdateCoachLessonAgeGroupsDocument = gql`
    mutation updateCoachLessonAgeGroups($userId: uuid!, $coachLessonAgeGroups: [CoachLessonAgeGroupsInsertInput!] = [], $coachSkillLevelGroups: [CoachLessonSkillLevelsInsertInput!] = []) {
  updateUsersByPk(pkColumns: {id: $userId}) {
    id
    aboutMe
    gender
    profileImageUrl
    profileImageProviderUrl
    profileImageProviderId
    profileImagePath
    profileImageProvider
    profileImageFileName
    priceUnitAmountCoachDefault
    isPciMember
    coachingStartYear
    coachLessonHowToPrepare
    coachLessonDescription
    coachExternalBookingUrl
    defaultSport
  }
  deleteCoachLessonAgeGroups(where: {userId: {_eq: $userId}}) {
    returning {
      id
      lessonAgeGroup
      userId
    }
  }
  insertCoachLessonAgeGroups(
    objects: $coachLessonAgeGroups
    onConflict: {constraint: coach_lesson_age_groups_user_id_lesson_age_group_key, updateColumns: [lessonAgeGroup]}
  ) {
    returning {
      id
      lessonAgeGroup
      userId
    }
  }
  deleteCoachLessonSkillLevels(where: {userId: {_eq: $userId}}) {
    returning {
      id
      skillLevel
      userId
    }
  }
  insertCoachLessonSkillLevels(
    objects: $coachSkillLevelGroups
    onConflict: {constraint: coach_lesson_skill_levels_skill_level_user_id_key, updateColumns: [skillLevel]}
  ) {
    returning {
      id
      skillLevel
      userId
    }
  }
}
    `;
export type UpdateCoachLessonAgeGroupsMutationFn = Apollo.MutationFunction<UpdateCoachLessonAgeGroupsMutation, UpdateCoachLessonAgeGroupsMutationVariables>;

/**
 * __useUpdateCoachLessonAgeGroupsMutation__
 *
 * To run a mutation, you first call `useUpdateCoachLessonAgeGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachLessonAgeGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachLessonAgeGroupsMutation, { data, loading, error }] = useUpdateCoachLessonAgeGroupsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      coachLessonAgeGroups: // value for 'coachLessonAgeGroups'
 *      coachSkillLevelGroups: // value for 'coachSkillLevelGroups'
 *   },
 * });
 */
export function useUpdateCoachLessonAgeGroupsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoachLessonAgeGroupsMutation, UpdateCoachLessonAgeGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoachLessonAgeGroupsMutation, UpdateCoachLessonAgeGroupsMutationVariables>(UpdateCoachLessonAgeGroupsDocument, options);
      }
export type UpdateCoachLessonAgeGroupsMutationHookResult = ReturnType<typeof useUpdateCoachLessonAgeGroupsMutation>;
export type UpdateCoachLessonAgeGroupsMutationResult = Apollo.MutationResult<UpdateCoachLessonAgeGroupsMutation>;
export type UpdateCoachLessonAgeGroupsMutationOptions = Apollo.BaseMutationOptions<UpdateCoachLessonAgeGroupsMutation, UpdateCoachLessonAgeGroupsMutationVariables>;
export const GetUserCommunicationPreferencesDocument = gql`
    query getUserCommunicationPreferences($id: uuid!) {
  usersByPk(id: $id) {
    id
    coachStatus
    communicationPreferences {
      id
      lessonBookedEmail
      lessonBookedPush
      lessonCanceledEmail
      lessonCanceledPushed
      lessonReminderEmail
      lessonReminderPush
      marketingEmail
      marketingPush
      newFollowerEmail
      newFollowerPush
      newLessonPublishedEmail
      newLessonPublishedPush
      participantLeftLessonEmail
      participantLeftLessonPush
      payoutEmail
      payoutPush
      playSessionCanceledEmail
      playSessionCanceledPush
      playSessionParticipantJoinedEmail
      playSessionParticipantJoinedPush
      playSessionParticipantLeftEmail
      playSessionParticipantLeftPush
      playSessionReminderEmail
      playSessionReminderPush
    }
  }
}
    `;

/**
 * __useGetUserCommunicationPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUserCommunicationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCommunicationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCommunicationPreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserCommunicationPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetUserCommunicationPreferencesQuery, GetUserCommunicationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCommunicationPreferencesQuery, GetUserCommunicationPreferencesQueryVariables>(GetUserCommunicationPreferencesDocument, options);
      }
export function useGetUserCommunicationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCommunicationPreferencesQuery, GetUserCommunicationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCommunicationPreferencesQuery, GetUserCommunicationPreferencesQueryVariables>(GetUserCommunicationPreferencesDocument, options);
        }
export type GetUserCommunicationPreferencesQueryHookResult = ReturnType<typeof useGetUserCommunicationPreferencesQuery>;
export type GetUserCommunicationPreferencesLazyQueryHookResult = ReturnType<typeof useGetUserCommunicationPreferencesLazyQuery>;
export type GetUserCommunicationPreferencesQueryResult = Apollo.QueryResult<GetUserCommunicationPreferencesQuery, GetUserCommunicationPreferencesQueryVariables>;
export const UpdateUserCommunicationPreferencesDocument = gql`
    mutation updateUserCommunicationPreferences($id: uuid!, $_set: UserCommunicationPreferencesSetInput!) {
  updateUserCommunicationPreferencesByPk(pkColumns: {id: $id}, _set: $_set) {
    id
    lessonBookedEmail
    lessonBookedPush
    lessonCanceledEmail
    lessonCanceledPushed
    lessonReminderEmail
    lessonReminderPush
    marketingEmail
    marketingPush
    newFollowerEmail
    newFollowerPush
    newLessonPublishedEmail
    newLessonPublishedPush
    participantLeftLessonEmail
    participantLeftLessonPush
    payoutEmail
    payoutPush
    playSessionCanceledEmail
    playSessionCanceledPush
    playSessionParticipantJoinedEmail
    playSessionParticipantJoinedPush
    playSessionParticipantLeftEmail
    playSessionParticipantLeftPush
    playSessionReminderEmail
    playSessionReminderPush
  }
}
    `;
export type UpdateUserCommunicationPreferencesMutationFn = Apollo.MutationFunction<UpdateUserCommunicationPreferencesMutation, UpdateUserCommunicationPreferencesMutationVariables>;

/**
 * __useUpdateUserCommunicationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserCommunicationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCommunicationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCommunicationPreferencesMutation, { data, loading, error }] = useUpdateUserCommunicationPreferencesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateUserCommunicationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCommunicationPreferencesMutation, UpdateUserCommunicationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCommunicationPreferencesMutation, UpdateUserCommunicationPreferencesMutationVariables>(UpdateUserCommunicationPreferencesDocument, options);
      }
export type UpdateUserCommunicationPreferencesMutationHookResult = ReturnType<typeof useUpdateUserCommunicationPreferencesMutation>;
export type UpdateUserCommunicationPreferencesMutationResult = Apollo.MutationResult<UpdateUserCommunicationPreferencesMutation>;
export type UpdateUserCommunicationPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateUserCommunicationPreferencesMutation, UpdateUserCommunicationPreferencesMutationVariables>;
export const UpdateUserGenderDocument = gql`
    mutation updateUserGender($id: uuid!, $gender: GenderEnum!, $genderPreference: String!) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {gender: $gender, genderPreference: $genderPreference}
  ) {
    id
    gender
    genderPreference
  }
}
    `;
export type UpdateUserGenderMutationFn = Apollo.MutationFunction<UpdateUserGenderMutation, UpdateUserGenderMutationVariables>;

/**
 * __useUpdateUserGenderMutation__
 *
 * To run a mutation, you first call `useUpdateUserGenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserGenderMutation, { data, loading, error }] = useUpdateUserGenderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      gender: // value for 'gender'
 *      genderPreference: // value for 'genderPreference'
 *   },
 * });
 */
export function useUpdateUserGenderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserGenderMutation, UpdateUserGenderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserGenderMutation, UpdateUserGenderMutationVariables>(UpdateUserGenderDocument, options);
      }
export type UpdateUserGenderMutationHookResult = ReturnType<typeof useUpdateUserGenderMutation>;
export type UpdateUserGenderMutationResult = Apollo.MutationResult<UpdateUserGenderMutation>;
export type UpdateUserGenderMutationOptions = Apollo.BaseMutationOptions<UpdateUserGenderMutation, UpdateUserGenderMutationVariables>;
export const UpdateUserBirthdayDocument = gql`
    mutation updateUserBirthday($id: uuid!, $birthday: date!) {
  updateUsersByPk(pkColumns: {id: $id}, _set: {birthday: $birthday}) {
    id
    birthday
  }
}
    `;
export type UpdateUserBirthdayMutationFn = Apollo.MutationFunction<UpdateUserBirthdayMutation, UpdateUserBirthdayMutationVariables>;

/**
 * __useUpdateUserBirthdayMutation__
 *
 * To run a mutation, you first call `useUpdateUserBirthdayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserBirthdayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserBirthdayMutation, { data, loading, error }] = useUpdateUserBirthdayMutation({
 *   variables: {
 *      id: // value for 'id'
 *      birthday: // value for 'birthday'
 *   },
 * });
 */
export function useUpdateUserBirthdayMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserBirthdayMutation, UpdateUserBirthdayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserBirthdayMutation, UpdateUserBirthdayMutationVariables>(UpdateUserBirthdayDocument, options);
      }
export type UpdateUserBirthdayMutationHookResult = ReturnType<typeof useUpdateUserBirthdayMutation>;
export type UpdateUserBirthdayMutationResult = Apollo.MutationResult<UpdateUserBirthdayMutation>;
export type UpdateUserBirthdayMutationOptions = Apollo.BaseMutationOptions<UpdateUserBirthdayMutation, UpdateUserBirthdayMutationVariables>;
export const InsertRepeatLessonsDocument = gql`
    mutation insertRepeatLessons($objects: [LessonsInsertInput!] = {}) {
  insertLessons(objects: $objects) {
    returning {
      ...lessonFields
    }
  }
}
    ${LessonFieldsFragmentDoc}`;
export type InsertRepeatLessonsMutationFn = Apollo.MutationFunction<InsertRepeatLessonsMutation, InsertRepeatLessonsMutationVariables>;

/**
 * __useInsertRepeatLessonsMutation__
 *
 * To run a mutation, you first call `useInsertRepeatLessonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRepeatLessonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRepeatLessonsMutation, { data, loading, error }] = useInsertRepeatLessonsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertRepeatLessonsMutation(baseOptions?: Apollo.MutationHookOptions<InsertRepeatLessonsMutation, InsertRepeatLessonsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertRepeatLessonsMutation, InsertRepeatLessonsMutationVariables>(InsertRepeatLessonsDocument, options);
      }
export type InsertRepeatLessonsMutationHookResult = ReturnType<typeof useInsertRepeatLessonsMutation>;
export type InsertRepeatLessonsMutationResult = Apollo.MutationResult<InsertRepeatLessonsMutation>;
export type InsertRepeatLessonsMutationOptions = Apollo.BaseMutationOptions<InsertRepeatLessonsMutation, InsertRepeatLessonsMutationVariables>;
export const UpdateUserOnboardBioDocument = gql`
    mutation updateUserOnboardBio($id: uuid!, $birthday: date!, $gender: GenderEnum!, $genderPreference: String = "") {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {birthday: $birthday, gender: $gender, genderPreference: $genderPreference}
  ) {
    id
    gender
    genderPreference
    fullName
    email
    birthday
    normalizedTennisRating
    normalizedTennisRatingScaleId
    tennisRating
    tennisRatingScaleId
  }
}
    `;
export type UpdateUserOnboardBioMutationFn = Apollo.MutationFunction<UpdateUserOnboardBioMutation, UpdateUserOnboardBioMutationVariables>;

/**
 * __useUpdateUserOnboardBioMutation__
 *
 * To run a mutation, you first call `useUpdateUserOnboardBioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOnboardBioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOnboardBioMutation, { data, loading, error }] = useUpdateUserOnboardBioMutation({
 *   variables: {
 *      id: // value for 'id'
 *      birthday: // value for 'birthday'
 *      gender: // value for 'gender'
 *      genderPreference: // value for 'genderPreference'
 *   },
 * });
 */
export function useUpdateUserOnboardBioMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserOnboardBioMutation, UpdateUserOnboardBioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserOnboardBioMutation, UpdateUserOnboardBioMutationVariables>(UpdateUserOnboardBioDocument, options);
      }
export type UpdateUserOnboardBioMutationHookResult = ReturnType<typeof useUpdateUserOnboardBioMutation>;
export type UpdateUserOnboardBioMutationResult = Apollo.MutationResult<UpdateUserOnboardBioMutation>;
export type UpdateUserOnboardBioMutationOptions = Apollo.BaseMutationOptions<UpdateUserOnboardBioMutation, UpdateUserOnboardBioMutationVariables>;
export const SetOnboardCompleteDocument = gql`
    mutation setOnboardComplete($id: uuid!) {
  updateUsersByPk(pkColumns: {id: $id}, _set: {isOnboardComplete: true}) {
    id
    isOnboardComplete
  }
}
    `;
export type SetOnboardCompleteMutationFn = Apollo.MutationFunction<SetOnboardCompleteMutation, SetOnboardCompleteMutationVariables>;

/**
 * __useSetOnboardCompleteMutation__
 *
 * To run a mutation, you first call `useSetOnboardCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOnboardCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOnboardCompleteMutation, { data, loading, error }] = useSetOnboardCompleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetOnboardCompleteMutation(baseOptions?: Apollo.MutationHookOptions<SetOnboardCompleteMutation, SetOnboardCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOnboardCompleteMutation, SetOnboardCompleteMutationVariables>(SetOnboardCompleteDocument, options);
      }
export type SetOnboardCompleteMutationHookResult = ReturnType<typeof useSetOnboardCompleteMutation>;
export type SetOnboardCompleteMutationResult = Apollo.MutationResult<SetOnboardCompleteMutation>;
export type SetOnboardCompleteMutationOptions = Apollo.BaseMutationOptions<SetOnboardCompleteMutation, SetOnboardCompleteMutationVariables>;
export const UpdateMarketingCommunicationPreferencesDocument = gql`
    mutation updateMarketingCommunicationPreferences($id: uuid!, $marketingPreference: CommunicationPreferenceStatusesEnum = ACTIVE) {
  updateUserCommunicationPreferencesByPk(
    pkColumns: {id: $id}
    _set: {marketingEmail: $marketingPreference, marketingPush: $marketingPreference}
  ) {
    id
    marketingEmail
    marketingPush
  }
}
    `;
export type UpdateMarketingCommunicationPreferencesMutationFn = Apollo.MutationFunction<UpdateMarketingCommunicationPreferencesMutation, UpdateMarketingCommunicationPreferencesMutationVariables>;

/**
 * __useUpdateMarketingCommunicationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateMarketingCommunicationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketingCommunicationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketingCommunicationPreferencesMutation, { data, loading, error }] = useUpdateMarketingCommunicationPreferencesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      marketingPreference: // value for 'marketingPreference'
 *   },
 * });
 */
export function useUpdateMarketingCommunicationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketingCommunicationPreferencesMutation, UpdateMarketingCommunicationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketingCommunicationPreferencesMutation, UpdateMarketingCommunicationPreferencesMutationVariables>(UpdateMarketingCommunicationPreferencesDocument, options);
      }
export type UpdateMarketingCommunicationPreferencesMutationHookResult = ReturnType<typeof useUpdateMarketingCommunicationPreferencesMutation>;
export type UpdateMarketingCommunicationPreferencesMutationResult = Apollo.MutationResult<UpdateMarketingCommunicationPreferencesMutation>;
export type UpdateMarketingCommunicationPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateMarketingCommunicationPreferencesMutation, UpdateMarketingCommunicationPreferencesMutationVariables>;
export const InsertAcceptTermsOfServiceDocument = gql`
    mutation insertAcceptTermsOfService($ip: String = "", $userAgent: String = "", $userId: uuid!) {
  insertUserTermsOfServiceOne(
    object: {acceptedAt: "now()", ip: $ip, userAgent: $userAgent, userId: $userId}
  ) {
    id
    ip
    acceptedAt
    userAgent
    userId
  }
}
    `;
export type InsertAcceptTermsOfServiceMutationFn = Apollo.MutationFunction<InsertAcceptTermsOfServiceMutation, InsertAcceptTermsOfServiceMutationVariables>;

/**
 * __useInsertAcceptTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useInsertAcceptTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAcceptTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAcceptTermsOfServiceMutation, { data, loading, error }] = useInsertAcceptTermsOfServiceMutation({
 *   variables: {
 *      ip: // value for 'ip'
 *      userAgent: // value for 'userAgent'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInsertAcceptTermsOfServiceMutation(baseOptions?: Apollo.MutationHookOptions<InsertAcceptTermsOfServiceMutation, InsertAcceptTermsOfServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAcceptTermsOfServiceMutation, InsertAcceptTermsOfServiceMutationVariables>(InsertAcceptTermsOfServiceDocument, options);
      }
export type InsertAcceptTermsOfServiceMutationHookResult = ReturnType<typeof useInsertAcceptTermsOfServiceMutation>;
export type InsertAcceptTermsOfServiceMutationResult = Apollo.MutationResult<InsertAcceptTermsOfServiceMutation>;
export type InsertAcceptTermsOfServiceMutationOptions = Apollo.BaseMutationOptions<InsertAcceptTermsOfServiceMutation, InsertAcceptTermsOfServiceMutationVariables>;
export const SetUserLocationDocument = gql`
    mutation setUserLocation($id: uuid!, $countryId: String!, $countrySubdivisionId: uuid, $cityName: String!) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {countryId: $countryId, countrySubdivisionId: $countrySubdivisionId, cityName: $cityName}
  ) {
    id
    countrySubdivisionId
    countryId
  }
}
    `;
export type SetUserLocationMutationFn = Apollo.MutationFunction<SetUserLocationMutation, SetUserLocationMutationVariables>;

/**
 * __useSetUserLocationMutation__
 *
 * To run a mutation, you first call `useSetUserLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserLocationMutation, { data, loading, error }] = useSetUserLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      countryId: // value for 'countryId'
 *      countrySubdivisionId: // value for 'countrySubdivisionId'
 *      cityName: // value for 'cityName'
 *   },
 * });
 */
export function useSetUserLocationMutation(baseOptions?: Apollo.MutationHookOptions<SetUserLocationMutation, SetUserLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserLocationMutation, SetUserLocationMutationVariables>(SetUserLocationDocument, options);
      }
export type SetUserLocationMutationHookResult = ReturnType<typeof useSetUserLocationMutation>;
export type SetUserLocationMutationResult = Apollo.MutationResult<SetUserLocationMutation>;
export type SetUserLocationMutationOptions = Apollo.BaseMutationOptions<SetUserLocationMutation, SetUserLocationMutationVariables>;
export const SetUserCoachQualificationsDocument = gql`
    mutation setUserCoachQualifications($userId: uuid!, $coachingStartYear: Int!, $objects: [UsersCoachQualificationsInsertInput!] = {}) {
  updateUsersByPk(
    pkColumns: {id: $userId}
    _set: {coachingStartYear: $coachingStartYear}
  ) {
    id
    coachingStartYear
  }
  insertUsersCoachQualifications(
    objects: $objects
    onConflict: {constraint: users_coach_qualifications_user_id_coach_qualification_id_key, updateColumns: status}
  ) {
    returning {
      id
      status
      coachQualificationId
      userId
    }
  }
}
    `;
export type SetUserCoachQualificationsMutationFn = Apollo.MutationFunction<SetUserCoachQualificationsMutation, SetUserCoachQualificationsMutationVariables>;

/**
 * __useSetUserCoachQualificationsMutation__
 *
 * To run a mutation, you first call `useSetUserCoachQualificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserCoachQualificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserCoachQualificationsMutation, { data, loading, error }] = useSetUserCoachQualificationsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      coachingStartYear: // value for 'coachingStartYear'
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useSetUserCoachQualificationsMutation(baseOptions?: Apollo.MutationHookOptions<SetUserCoachQualificationsMutation, SetUserCoachQualificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserCoachQualificationsMutation, SetUserCoachQualificationsMutationVariables>(SetUserCoachQualificationsDocument, options);
      }
export type SetUserCoachQualificationsMutationHookResult = ReturnType<typeof useSetUserCoachQualificationsMutation>;
export type SetUserCoachQualificationsMutationResult = Apollo.MutationResult<SetUserCoachQualificationsMutation>;
export type SetUserCoachQualificationsMutationOptions = Apollo.BaseMutationOptions<SetUserCoachQualificationsMutation, SetUserCoachQualificationsMutationVariables>;
export const GetSkillLevelsDocument = gql`
    query getSkillLevels {
  skillLevels(orderBy: {rank: ASC}) {
    displayName
    id
    isDisplayed
    rank
  }
}
    `;

/**
 * __useGetSkillLevelsQuery__
 *
 * To run a query within a React component, call `useGetSkillLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillLevelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSkillLevelsQuery(baseOptions?: Apollo.QueryHookOptions<GetSkillLevelsQuery, GetSkillLevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkillLevelsQuery, GetSkillLevelsQueryVariables>(GetSkillLevelsDocument, options);
      }
export function useGetSkillLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkillLevelsQuery, GetSkillLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkillLevelsQuery, GetSkillLevelsQueryVariables>(GetSkillLevelsDocument, options);
        }
export type GetSkillLevelsQueryHookResult = ReturnType<typeof useGetSkillLevelsQuery>;
export type GetSkillLevelsLazyQueryHookResult = ReturnType<typeof useGetSkillLevelsLazyQuery>;
export type GetSkillLevelsQueryResult = Apollo.QueryResult<GetSkillLevelsQuery, GetSkillLevelsQueryVariables>;
export const UpdateUserTennisSkillLevelDocument = gql`
    mutation updateUserTennisSkillLevel($id: uuid!, $tennisSkillLevelId: String) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {tennisSkillLevelId: $tennisSkillLevelId}
  ) {
    id
    tennisSkillLevelId
  }
}
    `;
export type UpdateUserTennisSkillLevelMutationFn = Apollo.MutationFunction<UpdateUserTennisSkillLevelMutation, UpdateUserTennisSkillLevelMutationVariables>;

/**
 * __useUpdateUserTennisSkillLevelMutation__
 *
 * To run a mutation, you first call `useUpdateUserTennisSkillLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTennisSkillLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTennisSkillLevelMutation, { data, loading, error }] = useUpdateUserTennisSkillLevelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tennisSkillLevelId: // value for 'tennisSkillLevelId'
 *   },
 * });
 */
export function useUpdateUserTennisSkillLevelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserTennisSkillLevelMutation, UpdateUserTennisSkillLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserTennisSkillLevelMutation, UpdateUserTennisSkillLevelMutationVariables>(UpdateUserTennisSkillLevelDocument, options);
      }
export type UpdateUserTennisSkillLevelMutationHookResult = ReturnType<typeof useUpdateUserTennisSkillLevelMutation>;
export type UpdateUserTennisSkillLevelMutationResult = Apollo.MutationResult<UpdateUserTennisSkillLevelMutation>;
export type UpdateUserTennisSkillLevelMutationOptions = Apollo.BaseMutationOptions<UpdateUserTennisSkillLevelMutation, UpdateUserTennisSkillLevelMutationVariables>;
export const UpdateUserPickleballSkillLevelDocument = gql`
    mutation updateUserPickleballSkillLevel($id: uuid!, $pickleballSkillLevelId: String) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {pickleballSkillLevelId: $pickleballSkillLevelId}
  ) {
    id
    pickleballSkillLevelId
  }
}
    `;
export type UpdateUserPickleballSkillLevelMutationFn = Apollo.MutationFunction<UpdateUserPickleballSkillLevelMutation, UpdateUserPickleballSkillLevelMutationVariables>;

/**
 * __useUpdateUserPickleballSkillLevelMutation__
 *
 * To run a mutation, you first call `useUpdateUserPickleballSkillLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPickleballSkillLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPickleballSkillLevelMutation, { data, loading, error }] = useUpdateUserPickleballSkillLevelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pickleballSkillLevelId: // value for 'pickleballSkillLevelId'
 *   },
 * });
 */
export function useUpdateUserPickleballSkillLevelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPickleballSkillLevelMutation, UpdateUserPickleballSkillLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPickleballSkillLevelMutation, UpdateUserPickleballSkillLevelMutationVariables>(UpdateUserPickleballSkillLevelDocument, options);
      }
export type UpdateUserPickleballSkillLevelMutationHookResult = ReturnType<typeof useUpdateUserPickleballSkillLevelMutation>;
export type UpdateUserPickleballSkillLevelMutationResult = Apollo.MutationResult<UpdateUserPickleballSkillLevelMutation>;
export type UpdateUserPickleballSkillLevelMutationOptions = Apollo.BaseMutationOptions<UpdateUserPickleballSkillLevelMutation, UpdateUserPickleballSkillLevelMutationVariables>;
export const GetPublishedEventsDocument = gql`
    query getPublishedEvents {
  events {
    id
    title
    cityString
    startDateTime
    addressString
    displayLocation
    endDate
    coverImageUrl
    endDateTime
    latitude
    longitude
    status
    startDate
    publishedAt
    city {
      id
      name
      countrySubdivision {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useGetPublishedEventsQuery__
 *
 * To run a query within a React component, call `useGetPublishedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishedEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublishedEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetPublishedEventsQuery, GetPublishedEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishedEventsQuery, GetPublishedEventsQueryVariables>(GetPublishedEventsDocument, options);
      }
export function useGetPublishedEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishedEventsQuery, GetPublishedEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishedEventsQuery, GetPublishedEventsQueryVariables>(GetPublishedEventsDocument, options);
        }
export type GetPublishedEventsQueryHookResult = ReturnType<typeof useGetPublishedEventsQuery>;
export type GetPublishedEventsLazyQueryHookResult = ReturnType<typeof useGetPublishedEventsLazyQuery>;
export type GetPublishedEventsQueryResult = Apollo.QueryResult<GetPublishedEventsQuery, GetPublishedEventsQueryVariables>;
export const UpdateEventContentsDocument = gql`
    mutation UpdateEventContents($id: uuid!, $input: EventsSetInput!) {
  updateEventsByPk(pkColumns: {id: $id}, _set: $input) {
    id
    title
    hasPrizes
    isSanctioned
    privacy
    registrationDeadlineDate
    registrationPriceUnitAmount
    coverImageUrl
  }
}
    `;
export type UpdateEventContentsMutationFn = Apollo.MutationFunction<UpdateEventContentsMutation, UpdateEventContentsMutationVariables>;

/**
 * __useUpdateEventContentsMutation__
 *
 * To run a mutation, you first call `useUpdateEventContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventContentsMutation, { data, loading, error }] = useUpdateEventContentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventContentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventContentsMutation, UpdateEventContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventContentsMutation, UpdateEventContentsMutationVariables>(UpdateEventContentsDocument, options);
      }
export type UpdateEventContentsMutationHookResult = ReturnType<typeof useUpdateEventContentsMutation>;
export type UpdateEventContentsMutationResult = Apollo.MutationResult<UpdateEventContentsMutation>;
export type UpdateEventContentsMutationOptions = Apollo.BaseMutationOptions<UpdateEventContentsMutation, UpdateEventContentsMutationVariables>;
export const UpdateFaqByIdDocument = gql`
    mutation UpdateFaqById($id: uuid!, $input: EventFaqsSetInput!) {
  updateEventFaqsByPk(pkColumns: {id: $id}, _set: $input) {
    id
    answer
    question
  }
}
    `;
export type UpdateFaqByIdMutationFn = Apollo.MutationFunction<UpdateFaqByIdMutation, UpdateFaqByIdMutationVariables>;

/**
 * __useUpdateFaqByIdMutation__
 *
 * To run a mutation, you first call `useUpdateFaqByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFaqByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFaqByIdMutation, { data, loading, error }] = useUpdateFaqByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFaqByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFaqByIdMutation, UpdateFaqByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFaqByIdMutation, UpdateFaqByIdMutationVariables>(UpdateFaqByIdDocument, options);
      }
export type UpdateFaqByIdMutationHookResult = ReturnType<typeof useUpdateFaqByIdMutation>;
export type UpdateFaqByIdMutationResult = Apollo.MutationResult<UpdateFaqByIdMutation>;
export type UpdateFaqByIdMutationOptions = Apollo.BaseMutationOptions<UpdateFaqByIdMutation, UpdateFaqByIdMutationVariables>;
export const UpdateEventSponsorsByPkDocument = gql`
    mutation UpdateEventSponsorsByPk($id: uuid!, $input: EventSponsorsSetInput!) {
  updateEventSponsorsByPk(pkColumns: {id: $id}, _set: $input) {
    id
    name
    isTitleSponsor
    categoryName
    imageUrl
  }
}
    `;
export type UpdateEventSponsorsByPkMutationFn = Apollo.MutationFunction<UpdateEventSponsorsByPkMutation, UpdateEventSponsorsByPkMutationVariables>;

/**
 * __useUpdateEventSponsorsByPkMutation__
 *
 * To run a mutation, you first call `useUpdateEventSponsorsByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventSponsorsByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventSponsorsByPkMutation, { data, loading, error }] = useUpdateEventSponsorsByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventSponsorsByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventSponsorsByPkMutation, UpdateEventSponsorsByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventSponsorsByPkMutation, UpdateEventSponsorsByPkMutationVariables>(UpdateEventSponsorsByPkDocument, options);
      }
export type UpdateEventSponsorsByPkMutationHookResult = ReturnType<typeof useUpdateEventSponsorsByPkMutation>;
export type UpdateEventSponsorsByPkMutationResult = Apollo.MutationResult<UpdateEventSponsorsByPkMutation>;
export type UpdateEventSponsorsByPkMutationOptions = Apollo.BaseMutationOptions<UpdateEventSponsorsByPkMutation, UpdateEventSponsorsByPkMutationVariables>;
export const UpdateEventGroupsByPkDocument = gql`
    mutation UpdateEventGroupsByPk($id: uuid!, $input: EventGroupsSetInput!) {
  updateEventGroupsByPk(pkColumns: {id: $id}, _set: $input) {
    id
    title
    format
    formatCustomName
    gamesPerMatch
    gender
    maximumAge
    minimumAge
    maximumRating
    minimumRating
    minimumNumberOfGames
    priceUnitAmount
    teamLimit
    scoringFormat
    startsAt
    endsAt
  }
}
    `;
export type UpdateEventGroupsByPkMutationFn = Apollo.MutationFunction<UpdateEventGroupsByPkMutation, UpdateEventGroupsByPkMutationVariables>;

/**
 * __useUpdateEventGroupsByPkMutation__
 *
 * To run a mutation, you first call `useUpdateEventGroupsByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventGroupsByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventGroupsByPkMutation, { data, loading, error }] = useUpdateEventGroupsByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventGroupsByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventGroupsByPkMutation, UpdateEventGroupsByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventGroupsByPkMutation, UpdateEventGroupsByPkMutationVariables>(UpdateEventGroupsByPkDocument, options);
      }
export type UpdateEventGroupsByPkMutationHookResult = ReturnType<typeof useUpdateEventGroupsByPkMutation>;
export type UpdateEventGroupsByPkMutationResult = Apollo.MutationResult<UpdateEventGroupsByPkMutation>;
export type UpdateEventGroupsByPkMutationOptions = Apollo.BaseMutationOptions<UpdateEventGroupsByPkMutation, UpdateEventGroupsByPkMutationVariables>;
export const GetPartnerBookingOrderDocument = gql`
    query getPartnerBookingOrder($id: uuid!) {
  partnerBookingOrdersByPk(id: $id) {
    id
    status
    localDate
    startLocal
    endLocal
    providerCourtId
    updatedAt
  }
}
    `;

/**
 * __useGetPartnerBookingOrderQuery__
 *
 * To run a query within a React component, call `useGetPartnerBookingOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerBookingOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerBookingOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPartnerBookingOrderQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerBookingOrderQuery, GetPartnerBookingOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerBookingOrderQuery, GetPartnerBookingOrderQueryVariables>(GetPartnerBookingOrderDocument, options);
      }
export function useGetPartnerBookingOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerBookingOrderQuery, GetPartnerBookingOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerBookingOrderQuery, GetPartnerBookingOrderQueryVariables>(GetPartnerBookingOrderDocument, options);
        }
export type GetPartnerBookingOrderQueryHookResult = ReturnType<typeof useGetPartnerBookingOrderQuery>;
export type GetPartnerBookingOrderLazyQueryHookResult = ReturnType<typeof useGetPartnerBookingOrderLazyQuery>;
export type GetPartnerBookingOrderQueryResult = Apollo.QueryResult<GetPartnerBookingOrderQuery, GetPartnerBookingOrderQueryVariables>;
export const GetPlaySessionFeedDocument = gql`
    query getPlaySessionFeed($startDateTime: timestamptz!, $groupId: uuid!, $userId: uuid!) {
  playSessions(
    where: {startDateTime: {_gte: $startDateTime}, groupId: {_eq: $groupId}, status: {_eq: ACTIVE}, privacy: {_eq: PUBLIC}}
  ) {
    ...playSessionFields
    commentsAggregate {
      aggregate {
        count
      }
    }
    currentUserAsParticipant: participants(
      where: {userId: {_eq: $userId}, status: {_eq: ACTIVE}}
    ) {
      id
      status
    }
  }
}
    ${PlaySessionFieldsFragmentDoc}`;

/**
 * __useGetPlaySessionFeedQuery__
 *
 * To run a query within a React component, call `useGetPlaySessionFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaySessionFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaySessionFeedQuery({
 *   variables: {
 *      startDateTime: // value for 'startDateTime'
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPlaySessionFeedQuery(baseOptions: Apollo.QueryHookOptions<GetPlaySessionFeedQuery, GetPlaySessionFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaySessionFeedQuery, GetPlaySessionFeedQueryVariables>(GetPlaySessionFeedDocument, options);
      }
export function useGetPlaySessionFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaySessionFeedQuery, GetPlaySessionFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaySessionFeedQuery, GetPlaySessionFeedQueryVariables>(GetPlaySessionFeedDocument, options);
        }
export type GetPlaySessionFeedQueryHookResult = ReturnType<typeof useGetPlaySessionFeedQuery>;
export type GetPlaySessionFeedLazyQueryHookResult = ReturnType<typeof useGetPlaySessionFeedLazyQuery>;
export type GetPlaySessionFeedQueryResult = Apollo.QueryResult<GetPlaySessionFeedQuery, GetPlaySessionFeedQueryVariables>;
export const GetActiveJoinedPlaySessionsDocument = gql`
    query getActiveJoinedPlaySessions($userId: uuid!, $startDateTime: timestamptz!) {
  playSessionParticipants(
    where: {userId: {_eq: $userId}, playSession: {status: {_eq: ACTIVE}, startDateTime: {_gte: $startDateTime}}, status: {_eq: ACTIVE}}
  ) {
    playSession {
      ...playSessionFields
      commentsAggregate {
        aggregate {
          count
        }
      }
    }
  }
}
    ${PlaySessionFieldsFragmentDoc}`;

/**
 * __useGetActiveJoinedPlaySessionsQuery__
 *
 * To run a query within a React component, call `useGetActiveJoinedPlaySessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveJoinedPlaySessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveJoinedPlaySessionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDateTime: // value for 'startDateTime'
 *   },
 * });
 */
export function useGetActiveJoinedPlaySessionsQuery(baseOptions: Apollo.QueryHookOptions<GetActiveJoinedPlaySessionsQuery, GetActiveJoinedPlaySessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveJoinedPlaySessionsQuery, GetActiveJoinedPlaySessionsQueryVariables>(GetActiveJoinedPlaySessionsDocument, options);
      }
export function useGetActiveJoinedPlaySessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveJoinedPlaySessionsQuery, GetActiveJoinedPlaySessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveJoinedPlaySessionsQuery, GetActiveJoinedPlaySessionsQueryVariables>(GetActiveJoinedPlaySessionsDocument, options);
        }
export type GetActiveJoinedPlaySessionsQueryHookResult = ReturnType<typeof useGetActiveJoinedPlaySessionsQuery>;
export type GetActiveJoinedPlaySessionsLazyQueryHookResult = ReturnType<typeof useGetActiveJoinedPlaySessionsLazyQuery>;
export type GetActiveJoinedPlaySessionsQueryResult = Apollo.QueryResult<GetActiveJoinedPlaySessionsQuery, GetActiveJoinedPlaySessionsQueryVariables>;
export const GetUserCustomCourtsDocument = gql`
    query getUserCustomCourts($id: uuid!) {
  usersByPk(id: $id) {
    id
    customCourts(orderBy: {createdAt: DESC}) {
      createdAt
      deletedAt
      fullAddress
      id
      title
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetUserCustomCourtsQuery__
 *
 * To run a query within a React component, call `useGetUserCustomCourtsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCustomCourtsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCustomCourtsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserCustomCourtsQuery(baseOptions: Apollo.QueryHookOptions<GetUserCustomCourtsQuery, GetUserCustomCourtsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCustomCourtsQuery, GetUserCustomCourtsQueryVariables>(GetUserCustomCourtsDocument, options);
      }
export function useGetUserCustomCourtsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCustomCourtsQuery, GetUserCustomCourtsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCustomCourtsQuery, GetUserCustomCourtsQueryVariables>(GetUserCustomCourtsDocument, options);
        }
export type GetUserCustomCourtsQueryHookResult = ReturnType<typeof useGetUserCustomCourtsQuery>;
export type GetUserCustomCourtsLazyQueryHookResult = ReturnType<typeof useGetUserCustomCourtsLazyQuery>;
export type GetUserCustomCourtsQueryResult = Apollo.QueryResult<GetUserCustomCourtsQuery, GetUserCustomCourtsQueryVariables>;
export const InsertNewPlaySessionDocument = gql`
    mutation insertNewPlaySession($competitiveness: PlaySessionMatchCompetitivenessEnum!, $courtBookingStatus: PlaySessionCourtBookingStatusesEnum!, $description: String = "", $endDateTime: timestamptz!, $extraRacketCount: Int = null, $format: PlaySessionFormatsEnum!, $isBringingNet: Boolean = false, $locale: String!, $organizerUserId: uuid!, $participantLimit: Int = null, $sport: SportsEnum!, $startDateTime: timestamptz!, $status: PlaySessionStatusesEnum = PENDING, $targetSkillLevel: String, $timezoneAbbreviation: String!, $timezoneName: String!, $timezoneOffsetMinutes: Int!, $title: String = "", $userCustomCourtId: uuid, $tennisRatingScaleId: uuid = null, $pickleballRatingScaleId: uuid = null, $privacy: PlaySessionPrivacyEnum = PRIVATE, $skillRatingMaximum: numeric = null, $skillRatingMinimum: numeric = null, $groupId: uuid = null, $venueId: uuid = null, $commentData: [PlaySessionCommentsInsertInput!] = [], $data: [GroupsPlaySessionsInsertInput!] = []) {
  insertPlaySessionsOne(
    object: {competitiveness: $competitiveness, courtBookingStatus: $courtBookingStatus, description: $description, endDateTime: $endDateTime, extraRacketCount: $extraRacketCount, format: $format, isBringingNet: $isBringingNet, locale: $locale, organizerUserId: $organizerUserId, participantLimit: $participantLimit, sport: $sport, startDateTime: $startDateTime, status: $status, targetSkillLevel: $targetSkillLevel, timezoneAbbreviation: $timezoneAbbreviation, timezoneName: $timezoneName, timezoneOffsetMinutes: $timezoneOffsetMinutes, title: $title, userCustomCourtId: $userCustomCourtId, tennisRatingScaleId: $tennisRatingScaleId, pickleballRatingScaleId: $pickleballRatingScaleId, privacy: $privacy, skillRatingMaximum: $skillRatingMaximum, skillRatingMinimum: $skillRatingMinimum, comments: {data: $commentData}, groupId: $groupId, venueId: $venueId, groupsPlaySessions: {data: $data}, participants: {data: {addedByPersona: PLAYER, addedAt: "now()", status: ACTIVE, addedByUserId: $organizerUserId, userId: $organizerUserId}}}
  ) {
    ...playSessionFields
  }
}
    ${PlaySessionFieldsFragmentDoc}`;
export type InsertNewPlaySessionMutationFn = Apollo.MutationFunction<InsertNewPlaySessionMutation, InsertNewPlaySessionMutationVariables>;

/**
 * __useInsertNewPlaySessionMutation__
 *
 * To run a mutation, you first call `useInsertNewPlaySessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNewPlaySessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNewPlaySessionMutation, { data, loading, error }] = useInsertNewPlaySessionMutation({
 *   variables: {
 *      competitiveness: // value for 'competitiveness'
 *      courtBookingStatus: // value for 'courtBookingStatus'
 *      description: // value for 'description'
 *      endDateTime: // value for 'endDateTime'
 *      extraRacketCount: // value for 'extraRacketCount'
 *      format: // value for 'format'
 *      isBringingNet: // value for 'isBringingNet'
 *      locale: // value for 'locale'
 *      organizerUserId: // value for 'organizerUserId'
 *      participantLimit: // value for 'participantLimit'
 *      sport: // value for 'sport'
 *      startDateTime: // value for 'startDateTime'
 *      status: // value for 'status'
 *      targetSkillLevel: // value for 'targetSkillLevel'
 *      timezoneAbbreviation: // value for 'timezoneAbbreviation'
 *      timezoneName: // value for 'timezoneName'
 *      timezoneOffsetMinutes: // value for 'timezoneOffsetMinutes'
 *      title: // value for 'title'
 *      userCustomCourtId: // value for 'userCustomCourtId'
 *      tennisRatingScaleId: // value for 'tennisRatingScaleId'
 *      pickleballRatingScaleId: // value for 'pickleballRatingScaleId'
 *      privacy: // value for 'privacy'
 *      skillRatingMaximum: // value for 'skillRatingMaximum'
 *      skillRatingMinimum: // value for 'skillRatingMinimum'
 *      groupId: // value for 'groupId'
 *      venueId: // value for 'venueId'
 *      commentData: // value for 'commentData'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInsertNewPlaySessionMutation(baseOptions?: Apollo.MutationHookOptions<InsertNewPlaySessionMutation, InsertNewPlaySessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertNewPlaySessionMutation, InsertNewPlaySessionMutationVariables>(InsertNewPlaySessionDocument, options);
      }
export type InsertNewPlaySessionMutationHookResult = ReturnType<typeof useInsertNewPlaySessionMutation>;
export type InsertNewPlaySessionMutationResult = Apollo.MutationResult<InsertNewPlaySessionMutation>;
export type InsertNewPlaySessionMutationOptions = Apollo.BaseMutationOptions<InsertNewPlaySessionMutation, InsertNewPlaySessionMutationVariables>;
export const UpdateNewPlaySessionByIdDocument = gql`
    mutation updateNewPlaySessionById($playSessionId: uuid!, $competitiveness: PlaySessionMatchCompetitivenessEnum!, $courtBookingStatus: PlaySessionCourtBookingStatusesEnum!, $description: String = "", $endDateTime: timestamptz!, $extraRacketCount: Int = null, $format: PlaySessionFormatsEnum!, $isBringingNet: Boolean = false, $participantLimit: Int = null, $sport: SportsEnum!, $startDateTime: timestamptz!, $status: PlaySessionStatusesEnum = PENDING, $targetSkillLevel: String, $title: String = "", $userCustomCourtId: uuid, $tennisRatingScaleId: uuid, $pickleballRatingScaleId: uuid, $skillRatingMaximum: numeric, $skillRatingMinimum: numeric, $privacy: PlaySessionPrivacyEnum = PRIVATE, $venueId: uuid = null, $commentObjects: [PlaySessionCommentsInsertInput!] = []) {
  updatePlaySessionComments(
    where: {playSessionId: {_eq: $playSessionId}}
    _set: {deletedAt: "now()"}
  ) {
    affectedRows
  }
  updatePlaySessionsByPk(
    pkColumns: {id: $playSessionId}
    _set: {competitiveness: $competitiveness, courtBookingStatus: $courtBookingStatus, description: $description, endDateTime: $endDateTime, extraRacketCount: $extraRacketCount, format: $format, isBringingNet: $isBringingNet, participantLimit: $participantLimit, sport: $sport, startDateTime: $startDateTime, status: $status, targetSkillLevel: $targetSkillLevel, title: $title, userCustomCourtId: $userCustomCourtId, tennisRatingScaleId: $tennisRatingScaleId, pickleballRatingScaleId: $pickleballRatingScaleId, skillRatingMaximum: $skillRatingMaximum, skillRatingMinimum: $skillRatingMinimum, privacy: $privacy, venueId: $venueId}
  ) {
    ...playSessionFields
  }
  insertPlaySessionComments(objects: $commentObjects) {
    affectedRows
  }
}
    ${PlaySessionFieldsFragmentDoc}`;
export type UpdateNewPlaySessionByIdMutationFn = Apollo.MutationFunction<UpdateNewPlaySessionByIdMutation, UpdateNewPlaySessionByIdMutationVariables>;

/**
 * __useUpdateNewPlaySessionByIdMutation__
 *
 * To run a mutation, you first call `useUpdateNewPlaySessionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewPlaySessionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewPlaySessionByIdMutation, { data, loading, error }] = useUpdateNewPlaySessionByIdMutation({
 *   variables: {
 *      playSessionId: // value for 'playSessionId'
 *      competitiveness: // value for 'competitiveness'
 *      courtBookingStatus: // value for 'courtBookingStatus'
 *      description: // value for 'description'
 *      endDateTime: // value for 'endDateTime'
 *      extraRacketCount: // value for 'extraRacketCount'
 *      format: // value for 'format'
 *      isBringingNet: // value for 'isBringingNet'
 *      participantLimit: // value for 'participantLimit'
 *      sport: // value for 'sport'
 *      startDateTime: // value for 'startDateTime'
 *      status: // value for 'status'
 *      targetSkillLevel: // value for 'targetSkillLevel'
 *      title: // value for 'title'
 *      userCustomCourtId: // value for 'userCustomCourtId'
 *      tennisRatingScaleId: // value for 'tennisRatingScaleId'
 *      pickleballRatingScaleId: // value for 'pickleballRatingScaleId'
 *      skillRatingMaximum: // value for 'skillRatingMaximum'
 *      skillRatingMinimum: // value for 'skillRatingMinimum'
 *      privacy: // value for 'privacy'
 *      venueId: // value for 'venueId'
 *      commentObjects: // value for 'commentObjects'
 *   },
 * });
 */
export function useUpdateNewPlaySessionByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewPlaySessionByIdMutation, UpdateNewPlaySessionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNewPlaySessionByIdMutation, UpdateNewPlaySessionByIdMutationVariables>(UpdateNewPlaySessionByIdDocument, options);
      }
export type UpdateNewPlaySessionByIdMutationHookResult = ReturnType<typeof useUpdateNewPlaySessionByIdMutation>;
export type UpdateNewPlaySessionByIdMutationResult = Apollo.MutationResult<UpdateNewPlaySessionByIdMutation>;
export type UpdateNewPlaySessionByIdMutationOptions = Apollo.BaseMutationOptions<UpdateNewPlaySessionByIdMutation, UpdateNewPlaySessionByIdMutationVariables>;
export const UpdateExistingPlaySessionByIdDocument = gql`
    mutation updateExistingPlaySessionById($playSessionId: uuid!, $title: String!, $description: String!, $sport: SportsEnum!, $format: PlaySessionFormatsEnum!, $targetSkillLevel: String, $courtBookingStatus: PlaySessionCourtBookingStatusesEnum!, $competitiveness: PlaySessionMatchCompetitivenessEnum!, $extraRacketCount: Int = 0, $isBringingNet: Boolean = false, $participantLimit: Int = null, $pickleballRatingScaleId: uuid, $privacy: PlaySessionPrivacyEnum = PRIVATE, $skillRatingMaximum: numeric, $skillRatingMinimum: numeric, $startDateTime: timestamptz!, $endDateTime: timestamptz!, $tennisRatingScaleId: uuid, $venueId: uuid = null) {
  updatePlaySessionsByPk(
    pkColumns: {id: $playSessionId}
    _set: {title: $title, description: $description, sport: $sport, format: $format, targetSkillLevel: $targetSkillLevel, courtBookingStatus: $courtBookingStatus, competitiveness: $competitiveness, extraRacketCount: $extraRacketCount, isBringingNet: $isBringingNet, participantLimit: $participantLimit, pickleballRatingScaleId: $pickleballRatingScaleId, privacy: $privacy, skillRatingMaximum: $skillRatingMaximum, skillRatingMinimum: $skillRatingMinimum, startDateTime: $startDateTime, endDateTime: $endDateTime, tennisRatingScaleId: $tennisRatingScaleId, venueId: $venueId}
  ) {
    ...playSessionFields
  }
}
    ${PlaySessionFieldsFragmentDoc}`;
export type UpdateExistingPlaySessionByIdMutationFn = Apollo.MutationFunction<UpdateExistingPlaySessionByIdMutation, UpdateExistingPlaySessionByIdMutationVariables>;

/**
 * __useUpdateExistingPlaySessionByIdMutation__
 *
 * To run a mutation, you first call `useUpdateExistingPlaySessionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExistingPlaySessionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExistingPlaySessionByIdMutation, { data, loading, error }] = useUpdateExistingPlaySessionByIdMutation({
 *   variables: {
 *      playSessionId: // value for 'playSessionId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      sport: // value for 'sport'
 *      format: // value for 'format'
 *      targetSkillLevel: // value for 'targetSkillLevel'
 *      courtBookingStatus: // value for 'courtBookingStatus'
 *      competitiveness: // value for 'competitiveness'
 *      extraRacketCount: // value for 'extraRacketCount'
 *      isBringingNet: // value for 'isBringingNet'
 *      participantLimit: // value for 'participantLimit'
 *      pickleballRatingScaleId: // value for 'pickleballRatingScaleId'
 *      privacy: // value for 'privacy'
 *      skillRatingMaximum: // value for 'skillRatingMaximum'
 *      skillRatingMinimum: // value for 'skillRatingMinimum'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      tennisRatingScaleId: // value for 'tennisRatingScaleId'
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useUpdateExistingPlaySessionByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExistingPlaySessionByIdMutation, UpdateExistingPlaySessionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExistingPlaySessionByIdMutation, UpdateExistingPlaySessionByIdMutationVariables>(UpdateExistingPlaySessionByIdDocument, options);
      }
export type UpdateExistingPlaySessionByIdMutationHookResult = ReturnType<typeof useUpdateExistingPlaySessionByIdMutation>;
export type UpdateExistingPlaySessionByIdMutationResult = Apollo.MutationResult<UpdateExistingPlaySessionByIdMutation>;
export type UpdateExistingPlaySessionByIdMutationOptions = Apollo.BaseMutationOptions<UpdateExistingPlaySessionByIdMutation, UpdateExistingPlaySessionByIdMutationVariables>;
export const SetPlaySessionAsActiveDocument = gql`
    mutation setPlaySessionAsActive($id: uuid!) {
  updatePlaySessionsByPk(
    pkColumns: {id: $id}
    _set: {status: ACTIVE, publishedAt: "now()"}
  ) {
    id
    status
    publishedAt
  }
}
    `;
export type SetPlaySessionAsActiveMutationFn = Apollo.MutationFunction<SetPlaySessionAsActiveMutation, SetPlaySessionAsActiveMutationVariables>;

/**
 * __useSetPlaySessionAsActiveMutation__
 *
 * To run a mutation, you first call `useSetPlaySessionAsActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPlaySessionAsActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPlaySessionAsActiveMutation, { data, loading, error }] = useSetPlaySessionAsActiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetPlaySessionAsActiveMutation(baseOptions?: Apollo.MutationHookOptions<SetPlaySessionAsActiveMutation, SetPlaySessionAsActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPlaySessionAsActiveMutation, SetPlaySessionAsActiveMutationVariables>(SetPlaySessionAsActiveDocument, options);
      }
export type SetPlaySessionAsActiveMutationHookResult = ReturnType<typeof useSetPlaySessionAsActiveMutation>;
export type SetPlaySessionAsActiveMutationResult = Apollo.MutationResult<SetPlaySessionAsActiveMutation>;
export type SetPlaySessionAsActiveMutationOptions = Apollo.BaseMutationOptions<SetPlaySessionAsActiveMutation, SetPlaySessionAsActiveMutationVariables>;
export const GetMyConversationsDocument = gql`
    query GetMyConversations($userId: uuid!) {
  conversationParticipants(
    where: {userId: {_eq: $userId}, deletedAt: {_isNull: true}, archivedAt: {_isNull: true}, conversation: {deletedAt: {_isNull: true}}}
    orderBy: {conversation: {lastMessageAt: DESC_NULLS_LAST}}
  ) {
    ...ChatListRowFields
  }
}
    ${ChatListRowFieldsFragmentDoc}`;

/**
 * __useGetMyConversationsQuery__
 *
 * To run a query within a React component, call `useGetMyConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyConversationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyConversationsQuery(baseOptions: Apollo.QueryHookOptions<GetMyConversationsQuery, GetMyConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyConversationsQuery, GetMyConversationsQueryVariables>(GetMyConversationsDocument, options);
      }
export function useGetMyConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyConversationsQuery, GetMyConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyConversationsQuery, GetMyConversationsQueryVariables>(GetMyConversationsDocument, options);
        }
export type GetMyConversationsQueryHookResult = ReturnType<typeof useGetMyConversationsQuery>;
export type GetMyConversationsLazyQueryHookResult = ReturnType<typeof useGetMyConversationsLazyQuery>;
export type GetMyConversationsQueryResult = Apollo.QueryResult<GetMyConversationsQuery, GetMyConversationsQueryVariables>;
export const SubscribeMyConversationsDocument = gql`
    subscription SubscribeMyConversations($userId: uuid!) {
  conversationParticipants(
    where: {userId: {_eq: $userId}, deletedAt: {_isNull: true}, archivedAt: {_isNull: true}, conversation: {deletedAt: {_isNull: true}}}
    orderBy: {conversation: {lastMessageAt: DESC_NULLS_LAST}}
  ) {
    id
    lastReadAt
    conversation {
      id
      lastMessageAt
      messages(orderBy: {createdAt: DESC}, limit: 1) {
        id
        body
        createdAt
        senderUserId
        senderProfile {
          id
          fullName
          preferredName
        }
      }
    }
  }
}
    `;

/**
 * __useSubscribeMyConversationsSubscription__
 *
 * To run a query within a React component, call `useSubscribeMyConversationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeMyConversationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeMyConversationsSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSubscribeMyConversationsSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeMyConversationsSubscription, SubscribeMyConversationsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeMyConversationsSubscription, SubscribeMyConversationsSubscriptionVariables>(SubscribeMyConversationsDocument, options);
      }
export type SubscribeMyConversationsSubscriptionHookResult = ReturnType<typeof useSubscribeMyConversationsSubscription>;
export type SubscribeMyConversationsSubscriptionResult = Apollo.SubscriptionResult<SubscribeMyConversationsSubscription>;
export const GetMyPendingChatRequestsDocument = gql`
    query GetMyPendingChatRequests($userId: uuid!) {
  playRequests(
    where: {status: {_eq: PENDING}, deletedAt: {_isNull: true}, _or: [{requesterUserId: {_eq: $userId}}, {recipientUserId: {_eq: $userId}}]}
    orderBy: {createdAt: DESC}
  ) {
    id
    createdAt
    requesterUserId
    recipientUserId
    requestMessage
    eventId
    availabilityId
    requesterProfile {
      ...ChatUserProfileFields
    }
    recipientProfile {
      ...ChatUserProfileFields
    }
  }
}
    ${ChatUserProfileFieldsFragmentDoc}`;

/**
 * __useGetMyPendingChatRequestsQuery__
 *
 * To run a query within a React component, call `useGetMyPendingChatRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPendingChatRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPendingChatRequestsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyPendingChatRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetMyPendingChatRequestsQuery, GetMyPendingChatRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPendingChatRequestsQuery, GetMyPendingChatRequestsQueryVariables>(GetMyPendingChatRequestsDocument, options);
      }
export function useGetMyPendingChatRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPendingChatRequestsQuery, GetMyPendingChatRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPendingChatRequestsQuery, GetMyPendingChatRequestsQueryVariables>(GetMyPendingChatRequestsDocument, options);
        }
export type GetMyPendingChatRequestsQueryHookResult = ReturnType<typeof useGetMyPendingChatRequestsQuery>;
export type GetMyPendingChatRequestsLazyQueryHookResult = ReturnType<typeof useGetMyPendingChatRequestsLazyQuery>;
export type GetMyPendingChatRequestsQueryResult = Apollo.QueryResult<GetMyPendingChatRequestsQuery, GetMyPendingChatRequestsQueryVariables>;
export const GetConversationMessagesDocument = gql`
    query GetConversationMessages($conversationId: uuid!, $limit: Int!, $before: timestamptz!) {
  messages(
    where: {conversationId: {_eq: $conversationId}, deletedAt: {_isNull: true}, createdAt: {_lt: $before}}
    orderBy: {createdAt: DESC}
    limit: $limit
  ) {
    ...ChatMessageFields
  }
}
    ${ChatMessageFieldsFragmentDoc}`;

/**
 * __useGetConversationMessagesQuery__
 *
 * To run a query within a React component, call `useGetConversationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationMessagesQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetConversationMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>(GetConversationMessagesDocument, options);
      }
export function useGetConversationMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>(GetConversationMessagesDocument, options);
        }
export type GetConversationMessagesQueryHookResult = ReturnType<typeof useGetConversationMessagesQuery>;
export type GetConversationMessagesLazyQueryHookResult = ReturnType<typeof useGetConversationMessagesLazyQuery>;
export type GetConversationMessagesQueryResult = Apollo.QueryResult<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>;
export const StreamConversationMessagesDocument = gql`
    subscription StreamConversationMessages($conversationId: uuid!, $cursor: timestamptz!) {
  messagesStream(
    cursor: {initialValue: {createdAt: $cursor}, ordering: ASC}
    batchSize: 20
    where: {conversationId: {_eq: $conversationId}, deletedAt: {_isNull: true}}
  ) {
    ...ChatMessageFields
  }
}
    ${ChatMessageFieldsFragmentDoc}`;

/**
 * __useStreamConversationMessagesSubscription__
 *
 * To run a query within a React component, call `useStreamConversationMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStreamConversationMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStreamConversationMessagesSubscription({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useStreamConversationMessagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<StreamConversationMessagesSubscription, StreamConversationMessagesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<StreamConversationMessagesSubscription, StreamConversationMessagesSubscriptionVariables>(StreamConversationMessagesDocument, options);
      }
export type StreamConversationMessagesSubscriptionHookResult = ReturnType<typeof useStreamConversationMessagesSubscription>;
export type StreamConversationMessagesSubscriptionResult = Apollo.SubscriptionResult<StreamConversationMessagesSubscription>;
export const GetChatConversationDocument = gql`
    query GetChatConversation($conversationId: uuid!) {
  conversations(
    where: {id: {_eq: $conversationId}, deletedAt: {_isNull: true}}
    limit: 1
  ) {
    id
    type
    title
    imagePath
    eventId
    lessonId
    createdByUserId
    event {
      ...ActivityEventCardFields
    }
    lesson {
      id
      title
      startDateTime
      endDateTime
      timezoneName
      coverImageProviderUrl
      venue {
        id
        timezone
        images {
          id
          url
          path
          provider
          fileName
        }
      }
    }
    participants(where: {deletedAt: {_isNull: true}}) {
      id
      userId
      createdAt
      lastReadAt
      userProfile {
        ...ChatUserProfileFields
      }
    }
  }
}
    ${ActivityEventCardFieldsFragmentDoc}
${ChatUserProfileFieldsFragmentDoc}`;

/**
 * __useGetChatConversationQuery__
 *
 * To run a query within a React component, call `useGetChatConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatConversationQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useGetChatConversationQuery(baseOptions: Apollo.QueryHookOptions<GetChatConversationQuery, GetChatConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatConversationQuery, GetChatConversationQueryVariables>(GetChatConversationDocument, options);
      }
export function useGetChatConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatConversationQuery, GetChatConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatConversationQuery, GetChatConversationQueryVariables>(GetChatConversationDocument, options);
        }
export type GetChatConversationQueryHookResult = ReturnType<typeof useGetChatConversationQuery>;
export type GetChatConversationLazyQueryHookResult = ReturnType<typeof useGetChatConversationLazyQuery>;
export type GetChatConversationQueryResult = Apollo.QueryResult<GetChatConversationQuery, GetChatConversationQueryVariables>;
export const GetChatPlayRequestForThreadDocument = gql`
    query GetChatPlayRequestForThread($conversationId: uuid!, $eventIds: [uuid!]!, $userId: uuid!) {
  playRequests(
    where: {deletedAt: {_isNull: true}, _or: [{conversationId: {_eq: $conversationId}}, {eventId: {_in: $eventIds}, _or: [{requesterUserId: {_eq: $userId}}, {recipientUserId: {_eq: $userId}}]}]}
    orderBy: {createdAt: DESC}
    limit: 1
  ) {
    ...ChatPlayRequestFields
  }
}
    ${ChatPlayRequestFieldsFragmentDoc}`;

/**
 * __useGetChatPlayRequestForThreadQuery__
 *
 * To run a query within a React component, call `useGetChatPlayRequestForThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatPlayRequestForThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatPlayRequestForThreadQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      eventIds: // value for 'eventIds'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetChatPlayRequestForThreadQuery(baseOptions: Apollo.QueryHookOptions<GetChatPlayRequestForThreadQuery, GetChatPlayRequestForThreadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatPlayRequestForThreadQuery, GetChatPlayRequestForThreadQueryVariables>(GetChatPlayRequestForThreadDocument, options);
      }
export function useGetChatPlayRequestForThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatPlayRequestForThreadQuery, GetChatPlayRequestForThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatPlayRequestForThreadQuery, GetChatPlayRequestForThreadQueryVariables>(GetChatPlayRequestForThreadDocument, options);
        }
export type GetChatPlayRequestForThreadQueryHookResult = ReturnType<typeof useGetChatPlayRequestForThreadQuery>;
export type GetChatPlayRequestForThreadLazyQueryHookResult = ReturnType<typeof useGetChatPlayRequestForThreadLazyQuery>;
export type GetChatPlayRequestForThreadQueryResult = Apollo.QueryResult<GetChatPlayRequestForThreadQuery, GetChatPlayRequestForThreadQueryVariables>;
export const GetChatPlayRequestDocument = gql`
    query GetChatPlayRequest($playRequestId: uuid!) {
  playRequests(
    where: {id: {_eq: $playRequestId}, deletedAt: {_isNull: true}}
    limit: 1
  ) {
    ...ChatPlayRequestFields
  }
}
    ${ChatPlayRequestFieldsFragmentDoc}`;

/**
 * __useGetChatPlayRequestQuery__
 *
 * To run a query within a React component, call `useGetChatPlayRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatPlayRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatPlayRequestQuery({
 *   variables: {
 *      playRequestId: // value for 'playRequestId'
 *   },
 * });
 */
export function useGetChatPlayRequestQuery(baseOptions: Apollo.QueryHookOptions<GetChatPlayRequestQuery, GetChatPlayRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatPlayRequestQuery, GetChatPlayRequestQueryVariables>(GetChatPlayRequestDocument, options);
      }
export function useGetChatPlayRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatPlayRequestQuery, GetChatPlayRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatPlayRequestQuery, GetChatPlayRequestQueryVariables>(GetChatPlayRequestDocument, options);
        }
export type GetChatPlayRequestQueryHookResult = ReturnType<typeof useGetChatPlayRequestQuery>;
export type GetChatPlayRequestLazyQueryHookResult = ReturnType<typeof useGetChatPlayRequestLazyQuery>;
export type GetChatPlayRequestQueryResult = Apollo.QueryResult<GetChatPlayRequestQuery, GetChatPlayRequestQueryVariables>;
export const MarkConversationReadDocument = gql`
    mutation MarkConversationRead($conversationId: uuid!, $userId: uuid!, $readAt: timestamptz!) {
  updateConversationParticipants(
    where: {conversationId: {_eq: $conversationId}, userId: {_eq: $userId}, deletedAt: {_isNull: true}}
    _set: {lastReadAt: $readAt}
  ) {
    returning {
      id
      lastReadAt
    }
  }
}
    `;
export type MarkConversationReadMutationFn = Apollo.MutationFunction<MarkConversationReadMutation, MarkConversationReadMutationVariables>;

/**
 * __useMarkConversationReadMutation__
 *
 * To run a mutation, you first call `useMarkConversationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkConversationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markConversationReadMutation, { data, loading, error }] = useMarkConversationReadMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      userId: // value for 'userId'
 *      readAt: // value for 'readAt'
 *   },
 * });
 */
export function useMarkConversationReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkConversationReadMutation, MarkConversationReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkConversationReadMutation, MarkConversationReadMutationVariables>(MarkConversationReadDocument, options);
      }
export type MarkConversationReadMutationHookResult = ReturnType<typeof useMarkConversationReadMutation>;
export type MarkConversationReadMutationResult = Apollo.MutationResult<MarkConversationReadMutation>;
export type MarkConversationReadMutationOptions = Apollo.BaseMutationOptions<MarkConversationReadMutation, MarkConversationReadMutationVariables>;
export const GetUserProfileByNameSearchDocument = gql`
    query getUserProfileByNameSearch($name: String!, $limit: Int = 10) {
  userProfiles(where: {fullName: {_ilike: $name}}, limit: $limit) {
    id
    username
    profileImageProviderUrl
    profileImagePath
    fullName
    gender
    cityName
  }
}
    `;

/**
 * __useGetUserProfileByNameSearchQuery__
 *
 * To run a query within a React component, call `useGetUserProfileByNameSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileByNameSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileByNameSearchQuery({
 *   variables: {
 *      name: // value for 'name'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserProfileByNameSearchQuery(baseOptions: Apollo.QueryHookOptions<GetUserProfileByNameSearchQuery, GetUserProfileByNameSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileByNameSearchQuery, GetUserProfileByNameSearchQueryVariables>(GetUserProfileByNameSearchDocument, options);
      }
export function useGetUserProfileByNameSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileByNameSearchQuery, GetUserProfileByNameSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileByNameSearchQuery, GetUserProfileByNameSearchQueryVariables>(GetUserProfileByNameSearchDocument, options);
        }
export type GetUserProfileByNameSearchQueryHookResult = ReturnType<typeof useGetUserProfileByNameSearchQuery>;
export type GetUserProfileByNameSearchLazyQueryHookResult = ReturnType<typeof useGetUserProfileByNameSearchLazyQuery>;
export type GetUserProfileByNameSearchQueryResult = Apollo.QueryResult<GetUserProfileByNameSearchQuery, GetUserProfileByNameSearchQueryVariables>;
export const GetTrendingLessonsDocument = gql`
    query getTrendingLessons($limit: Int = 10) {
  lessons(
    where: {status: {_eq: ACTIVE}, startDateTime: {_gte: "now"}, deletedAt: {_isNull: true}}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    title
    type
    sport
    startDateTime
    priceUnitAmount
    currency
    coverImageProviderUrl
    userCustomCourt {
      id
      title
    }
    venue {
      id
      images(where: {isVisible: {_eq: true}}, limit: 1) {
        id
        url
        path
      }
    }
    ownerProfile {
      id
      fullName
      profileImageProviderUrl
    }
  }
}
    `;

/**
 * __useGetTrendingLessonsQuery__
 *
 * To run a query within a React component, call `useGetTrendingLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingLessonsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTrendingLessonsQuery(baseOptions?: Apollo.QueryHookOptions<GetTrendingLessonsQuery, GetTrendingLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrendingLessonsQuery, GetTrendingLessonsQueryVariables>(GetTrendingLessonsDocument, options);
      }
export function useGetTrendingLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendingLessonsQuery, GetTrendingLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrendingLessonsQuery, GetTrendingLessonsQueryVariables>(GetTrendingLessonsDocument, options);
        }
export type GetTrendingLessonsQueryHookResult = ReturnType<typeof useGetTrendingLessonsQuery>;
export type GetTrendingLessonsLazyQueryHookResult = ReturnType<typeof useGetTrendingLessonsLazyQuery>;
export type GetTrendingLessonsQueryResult = Apollo.QueryResult<GetTrendingLessonsQuery, GetTrendingLessonsQueryVariables>;
export const GetTrendingLessonsByGeoDocument = gql`
    query getTrendingLessonsByGeo($distance: Float!, $from: geography!, $limit: Int = 10) {
  lessons(
    where: {status: {_eq: ACTIVE}, startDateTime: {_gte: "now"}, deletedAt: {_isNull: true}, venue: {geometry: {_stDWithin: {distance: $distance, from: $from}}}}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    title
    type
    sport
    startDateTime
    priceUnitAmount
    currency
    coverImageProviderUrl
    userCustomCourt {
      id
      title
    }
    venue {
      id
      images(where: {isVisible: {_eq: true}}, limit: 1) {
        id
        url
        path
      }
    }
    ownerProfile {
      id
      fullName
      profileImageProviderUrl
    }
  }
}
    `;

/**
 * __useGetTrendingLessonsByGeoQuery__
 *
 * To run a query within a React component, call `useGetTrendingLessonsByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingLessonsByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingLessonsByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTrendingLessonsByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetTrendingLessonsByGeoQuery, GetTrendingLessonsByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrendingLessonsByGeoQuery, GetTrendingLessonsByGeoQueryVariables>(GetTrendingLessonsByGeoDocument, options);
      }
export function useGetTrendingLessonsByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendingLessonsByGeoQuery, GetTrendingLessonsByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrendingLessonsByGeoQuery, GetTrendingLessonsByGeoQueryVariables>(GetTrendingLessonsByGeoDocument, options);
        }
export type GetTrendingLessonsByGeoQueryHookResult = ReturnType<typeof useGetTrendingLessonsByGeoQuery>;
export type GetTrendingLessonsByGeoLazyQueryHookResult = ReturnType<typeof useGetTrendingLessonsByGeoLazyQuery>;
export type GetTrendingLessonsByGeoQueryResult = Apollo.QueryResult<GetTrendingLessonsByGeoQuery, GetTrendingLessonsByGeoQueryVariables>;
export const GetUpcomingTournamentsDocument = gql`
    query getUpcomingTournaments($limit: Int = 10) {
  events(
    where: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, type: {_eq: TOURNAMENT}, startDateTime: {_gte: "now"}, status: {_eq: PUBLISHED}}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    title
    slug
    startDateTime
    registrationPriceUnitAmount
    currency
    coverImageProviderUrl
    displayLocation
    sourceOrganizerTitle
    venue {
      id
      images(where: {isVisible: {_eq: true}}, limit: 1) {
        id
        url
        path
      }
    }
    hostUserProfile {
      id
      profileImageProviderUrl
    }
  }
}
    `;

/**
 * __useGetUpcomingTournamentsQuery__
 *
 * To run a query within a React component, call `useGetUpcomingTournamentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingTournamentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingTournamentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUpcomingTournamentsQuery(baseOptions?: Apollo.QueryHookOptions<GetUpcomingTournamentsQuery, GetUpcomingTournamentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpcomingTournamentsQuery, GetUpcomingTournamentsQueryVariables>(GetUpcomingTournamentsDocument, options);
      }
export function useGetUpcomingTournamentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpcomingTournamentsQuery, GetUpcomingTournamentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpcomingTournamentsQuery, GetUpcomingTournamentsQueryVariables>(GetUpcomingTournamentsDocument, options);
        }
export type GetUpcomingTournamentsQueryHookResult = ReturnType<typeof useGetUpcomingTournamentsQuery>;
export type GetUpcomingTournamentsLazyQueryHookResult = ReturnType<typeof useGetUpcomingTournamentsLazyQuery>;
export type GetUpcomingTournamentsQueryResult = Apollo.QueryResult<GetUpcomingTournamentsQuery, GetUpcomingTournamentsQueryVariables>;
export const GetUpcomingTournamentsByGeoDocument = gql`
    query getUpcomingTournamentsByGeo($distance: Float!, $from: geography!, $limit: Int = 10) {
  events(
    where: {archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, type: {_eq: TOURNAMENT}, startDateTime: {_gte: "now"}, status: {_eq: PUBLISHED}, geometry: {_stDWithin: {distance: $distance, from: $from}}}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    title
    slug
    startDateTime
    registrationPriceUnitAmount
    currency
    coverImageProviderUrl
    displayLocation
    sourceOrganizerTitle
    venue {
      id
      images(where: {isVisible: {_eq: true}}, limit: 1) {
        id
        url
        path
      }
    }
    hostUserProfile {
      id
      profileImageProviderUrl
    }
  }
}
    `;

/**
 * __useGetUpcomingTournamentsByGeoQuery__
 *
 * To run a query within a React component, call `useGetUpcomingTournamentsByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingTournamentsByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingTournamentsByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUpcomingTournamentsByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetUpcomingTournamentsByGeoQuery, GetUpcomingTournamentsByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpcomingTournamentsByGeoQuery, GetUpcomingTournamentsByGeoQueryVariables>(GetUpcomingTournamentsByGeoDocument, options);
      }
export function useGetUpcomingTournamentsByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpcomingTournamentsByGeoQuery, GetUpcomingTournamentsByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpcomingTournamentsByGeoQuery, GetUpcomingTournamentsByGeoQueryVariables>(GetUpcomingTournamentsByGeoDocument, options);
        }
export type GetUpcomingTournamentsByGeoQueryHookResult = ReturnType<typeof useGetUpcomingTournamentsByGeoQuery>;
export type GetUpcomingTournamentsByGeoLazyQueryHookResult = ReturnType<typeof useGetUpcomingTournamentsByGeoLazyQuery>;
export type GetUpcomingTournamentsByGeoQueryResult = Apollo.QueryResult<GetUpcomingTournamentsByGeoQuery, GetUpcomingTournamentsByGeoQueryVariables>;
export const GetCoachesBySportAndGeoDocument = gql`
    query getCoachesBySportAndGeo($distance: Float!, $from: geography!, $sports: [String!]!, $limit: Int = 4) {
  userProfiles(
    where: {coachStatus: {_eq: "ACTIVE"}, geometry: {_stDWithin: {distance: $distance, from: $from}}, defaultSport: {_in: $sports}}
    limit: $limit
    orderBy: {profileImageProviderUrl: DESC_NULLS_LAST}
  ) {
    id
    fullName
    priceUnitAmountRemoteCoachDefault
    priceUnitAmountCoachDefault
    profileImageFileName
    profileImagePath
    profileImageProvider
    profileImageProviderUrl
    preferredName
    username
    defaultSport
    geometry
    isPprMember
    priceUnitAmountCoachDefault
    isProfessionalRacquetRegistryActive
    gender
    aboutMe
    coachingStartYear
    coachReviewsAggregate {
      aggregate {
        count
        avg {
          rating
        }
      }
    }
    coachLessonsAggregate {
      aggregate {
        count
      }
    }
    coachSports {
      sport
    }
    coachLessonSkillLevels {
      skillLevel
    }
    stripeMerchantCurrency
    currencyCoachDefault
    stripeMerchantChargesEnabled
    coachAvailability {
      id
      status
    }
    defaultCoachVenue {
      addressString
      id
    }
    defaultCoachCustomCourt {
      title
      id
      fullAddress
    }
    followersAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetCoachesBySportAndGeoQuery__
 *
 * To run a query within a React component, call `useGetCoachesBySportAndGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachesBySportAndGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachesBySportAndGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      sports: // value for 'sports'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCoachesBySportAndGeoQuery(baseOptions: Apollo.QueryHookOptions<GetCoachesBySportAndGeoQuery, GetCoachesBySportAndGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachesBySportAndGeoQuery, GetCoachesBySportAndGeoQueryVariables>(GetCoachesBySportAndGeoDocument, options);
      }
export function useGetCoachesBySportAndGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachesBySportAndGeoQuery, GetCoachesBySportAndGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachesBySportAndGeoQuery, GetCoachesBySportAndGeoQueryVariables>(GetCoachesBySportAndGeoDocument, options);
        }
export type GetCoachesBySportAndGeoQueryHookResult = ReturnType<typeof useGetCoachesBySportAndGeoQuery>;
export type GetCoachesBySportAndGeoLazyQueryHookResult = ReturnType<typeof useGetCoachesBySportAndGeoLazyQuery>;
export type GetCoachesBySportAndGeoQueryResult = Apollo.QueryResult<GetCoachesBySportAndGeoQuery, GetCoachesBySportAndGeoQueryVariables>;
export const GetCoachesByNameSearchDocument = gql`
    query getCoachesByNameSearch($sports: [String!]!, $search: String!, $limit: Int = 20) {
  userProfiles(
    where: {coachStatus: {_eq: "ACTIVE"}, defaultSport: {_in: $sports}, _or: [{fullName: {_ilike: $search}}, {preferredName: {_ilike: $search}}, {username: {_ilike: $search}}]}
    orderBy: {fullName: ASC}
    limit: $limit
  ) {
    id
    fullName
    priceUnitAmountRemoteCoachDefault
    priceUnitAmountCoachDefault
    profileImageFileName
    profileImagePath
    profileImageProvider
    profileImageProviderUrl
    preferredName
    username
    defaultSport
    geometry
    isPprMember
    isProfessionalRacquetRegistryActive
    gender
    aboutMe
    coachingStartYear
    coachReviewsAggregate {
      aggregate {
        count
        avg {
          rating
        }
      }
    }
    coachLessonsAggregate {
      aggregate {
        count
      }
    }
    coachSports {
      sport
    }
    coachLessonSkillLevels {
      skillLevel
    }
    stripeMerchantCurrency
    currencyCoachDefault
    stripeMerchantChargesEnabled
    coachAvailability {
      id
      status
    }
    defaultCoachVenue {
      addressString
      id
    }
    defaultCoachCustomCourt {
      title
      id
      fullAddress
    }
    followersAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetCoachesByNameSearchQuery__
 *
 * To run a query within a React component, call `useGetCoachesByNameSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachesByNameSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachesByNameSearchQuery({
 *   variables: {
 *      sports: // value for 'sports'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCoachesByNameSearchQuery(baseOptions: Apollo.QueryHookOptions<GetCoachesByNameSearchQuery, GetCoachesByNameSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachesByNameSearchQuery, GetCoachesByNameSearchQueryVariables>(GetCoachesByNameSearchDocument, options);
      }
export function useGetCoachesByNameSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachesByNameSearchQuery, GetCoachesByNameSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachesByNameSearchQuery, GetCoachesByNameSearchQueryVariables>(GetCoachesByNameSearchDocument, options);
        }
export type GetCoachesByNameSearchQueryHookResult = ReturnType<typeof useGetCoachesByNameSearchQuery>;
export type GetCoachesByNameSearchLazyQueryHookResult = ReturnType<typeof useGetCoachesByNameSearchLazyQuery>;
export type GetCoachesByNameSearchQueryResult = Apollo.QueryResult<GetCoachesByNameSearchQuery, GetCoachesByNameSearchQueryVariables>;
export const GetTopRatedCoachesBySportDocument = gql`
    query getTopRatedCoachesBySport($sports: [String!]!, $limit: Int = 4) {
  userProfiles(
    where: {coachStatus: {_eq: "ACTIVE"}, defaultSport: {_in: $sports}}
    orderBy: [{coachReviewsAggregate: {count: DESC}}, {coachLessonsAggregate: {count: DESC}}, {profileImageProviderUrl: DESC_NULLS_LAST}]
    limit: $limit
  ) {
    id
    fullName
    priceUnitAmountRemoteCoachDefault
    priceUnitAmountCoachDefault
    profileImageFileName
    profileImagePath
    profileImageProvider
    profileImageProviderUrl
    preferredName
    username
    defaultSport
    geometry
    isPprMember
    priceUnitAmountCoachDefault
    isProfessionalRacquetRegistryActive
    gender
    aboutMe
    coachingStartYear
    coachReviewsAggregate {
      aggregate {
        count
        avg {
          rating
        }
      }
    }
    coachLessonsAggregate {
      aggregate {
        count
      }
    }
    coachSports {
      sport
    }
    coachLessonSkillLevels {
      skillLevel
    }
    stripeMerchantCurrency
    currencyCoachDefault
    stripeMerchantChargesEnabled
    coachAvailability {
      id
      status
    }
    defaultCoachVenue {
      addressString
      id
    }
    defaultCoachCustomCourt {
      title
      id
      fullAddress
    }
    followersAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetTopRatedCoachesBySportQuery__
 *
 * To run a query within a React component, call `useGetTopRatedCoachesBySportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopRatedCoachesBySportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopRatedCoachesBySportQuery({
 *   variables: {
 *      sports: // value for 'sports'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTopRatedCoachesBySportQuery(baseOptions: Apollo.QueryHookOptions<GetTopRatedCoachesBySportQuery, GetTopRatedCoachesBySportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopRatedCoachesBySportQuery, GetTopRatedCoachesBySportQueryVariables>(GetTopRatedCoachesBySportDocument, options);
      }
export function useGetTopRatedCoachesBySportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopRatedCoachesBySportQuery, GetTopRatedCoachesBySportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopRatedCoachesBySportQuery, GetTopRatedCoachesBySportQueryVariables>(GetTopRatedCoachesBySportDocument, options);
        }
export type GetTopRatedCoachesBySportQueryHookResult = ReturnType<typeof useGetTopRatedCoachesBySportQuery>;
export type GetTopRatedCoachesBySportLazyQueryHookResult = ReturnType<typeof useGetTopRatedCoachesBySportLazyQuery>;
export type GetTopRatedCoachesBySportQueryResult = Apollo.QueryResult<GetTopRatedCoachesBySportQuery, GetTopRatedCoachesBySportQueryVariables>;
export const GetBookableCourtsByGeoDocument = gql`
    query getBookableCourtsByGeo($distance: Float!, $from: geography!, $sportFilter: VenuesBoolExp = {}, $limit: Int = 3) {
  venues(
    where: {_and: [$sportFilter, {geometry: {_stDWithin: {distance: $distance, from: $from}}, hasReservations: {_eq: true}}]}
    limit: $limit
    orderBy: [{imagesAggregate: {count: DESC}}, {geometry: ASC}]
  ) {
    id
    title
    slug
    addressString
    accessType
    indoorCourtCount
    outdoorCourtCount
    pickleballNets
    hasPickleball
    hasTennis
    hasPadel
    images {
      id
      isVisible
      url
    }
  }
}
    `;

/**
 * __useGetBookableCourtsByGeoQuery__
 *
 * To run a query within a React component, call `useGetBookableCourtsByGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookableCourtsByGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookableCourtsByGeoQuery({
 *   variables: {
 *      distance: // value for 'distance'
 *      from: // value for 'from'
 *      sportFilter: // value for 'sportFilter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBookableCourtsByGeoQuery(baseOptions: Apollo.QueryHookOptions<GetBookableCourtsByGeoQuery, GetBookableCourtsByGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookableCourtsByGeoQuery, GetBookableCourtsByGeoQueryVariables>(GetBookableCourtsByGeoDocument, options);
      }
export function useGetBookableCourtsByGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookableCourtsByGeoQuery, GetBookableCourtsByGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookableCourtsByGeoQuery, GetBookableCourtsByGeoQueryVariables>(GetBookableCourtsByGeoDocument, options);
        }
export type GetBookableCourtsByGeoQueryHookResult = ReturnType<typeof useGetBookableCourtsByGeoQuery>;
export type GetBookableCourtsByGeoLazyQueryHookResult = ReturnType<typeof useGetBookableCourtsByGeoLazyQuery>;
export type GetBookableCourtsByGeoQueryResult = Apollo.QueryResult<GetBookableCourtsByGeoQuery, GetBookableCourtsByGeoQueryVariables>;
export const GetTopOpportunityEventsDocument = gql`
    query getTopOpportunityEvents($area: EventsBoolExp!, $sport: SportsEnum!, $startDate: timestamptz!, $endDate: timestamptz!, $venueFilter: EventsBoolExp = {}, $limit: Int = 25) {
  events(
    where: {_and: [$venueFilter, $area, {_or: [{type: {_in: [TOURNAMENT, LEAGUE, OPEN_PLAY, SOCIAL]}}, {isRfx: {_eq: true}}]}], archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, privacy: {_eq: PUBLIC}, sport: {_eq: $sport}, isPlayerListed: {_eq: false}, status: {_eq: PUBLISHED}, _or: [{startDateTime: {_gte: $startDate, _lte: $endDate}}, {groups: {timeSlots: {startsAt: {_gte: $startDate, _lte: $endDate}}}}]}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    slug
    title
    sport
    type
    isRfx
    groupFormat
    intendedAgeGroup
    startDateTime
    endDateTime
    timezoneName
    description
    displayLocation
    addressString
    latitude
    longitude
    coverImageProviderUrl
    registrationPriceUnitAmount
    currency
    participantLimit
    hostUserProfile {
      id
      fullName
      profileImageProviderUrl
    }
    venue {
      id
      title
      timezone
      addressString
      images(where: {isVisible: {_eq: true}}, limit: 1) {
        id
        url
        path
      }
    }
    groups {
      id
      competitiveness
      isVairRatingSession
      timeSlots(orderBy: {startsAt: ASC}) {
        id
        startsAt
        endsAt
      }
    }
    registrationsAggregate {
      aggregate {
        count
      }
    }
    registrations(where: {deletedAt: {_isNull: true}}, limit: 12) {
      id
      userProfile {
        id
        profileImageProviderUrl
      }
    }
  }
}
    `;

/**
 * __useGetTopOpportunityEventsQuery__
 *
 * To run a query within a React component, call `useGetTopOpportunityEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopOpportunityEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopOpportunityEventsQuery({
 *   variables: {
 *      area: // value for 'area'
 *      sport: // value for 'sport'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      venueFilter: // value for 'venueFilter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTopOpportunityEventsQuery(baseOptions: Apollo.QueryHookOptions<GetTopOpportunityEventsQuery, GetTopOpportunityEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopOpportunityEventsQuery, GetTopOpportunityEventsQueryVariables>(GetTopOpportunityEventsDocument, options);
      }
export function useGetTopOpportunityEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopOpportunityEventsQuery, GetTopOpportunityEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopOpportunityEventsQuery, GetTopOpportunityEventsQueryVariables>(GetTopOpportunityEventsDocument, options);
        }
export type GetTopOpportunityEventsQueryHookResult = ReturnType<typeof useGetTopOpportunityEventsQuery>;
export type GetTopOpportunityEventsLazyQueryHookResult = ReturnType<typeof useGetTopOpportunityEventsLazyQuery>;
export type GetTopOpportunityEventsQueryResult = Apollo.QueryResult<GetTopOpportunityEventsQuery, GetTopOpportunityEventsQueryVariables>;
export const GetTopOpportunityLessonsDocument = gql`
    query getTopOpportunityLessons($area: LessonsBoolExp!, $sport: SportsEnum!, $startDate: timestamptz!, $endDate: timestamptz!, $venueFilter: LessonsBoolExp = {}, $limit: Int = 25) {
  lessons(
    where: {_and: [$venueFilter, $area], status: {_eq: ACTIVE}, privacy: {_eq: PUBLIC}, deletedAt: {_isNull: true}, sport: {_eq: $sport}, type: {_in: [CLINIC, CAMP, INDIVIDUAL, CARDIO, RFX]}, startDateTime: {_gte: $startDate, _lte: $endDate}}
    orderBy: {startDateTime: ASC}
    limit: $limit
  ) {
    id
    title
    sport
    type
    intendedAgeGroup
    startDateTime
    endDateTime
    timezoneName
    description
    coverImageProviderUrl
    priceUnitAmount
    currency
    participantLimit
    externalBookingUrl
    skillLevels {
      id
      skillLevel
    }
    ownerProfile {
      id
      fullName
      profileImageUrl
    }
    userCustomCourt {
      id
      title
      fullAddress
      latitude
      longitude
    }
    venue {
      id
      title
      timezone
      addressString
      latitude
      longitude
      images(where: {isVisible: {_eq: true}}, limit: 1) {
        id
        url
        path
      }
    }
    participantsAggregate {
      aggregate {
        count
      }
    }
    participants(limit: 12) {
      id
      userProfile {
        id
        profileImageProviderUrl
      }
    }
  }
}
    `;

/**
 * __useGetTopOpportunityLessonsQuery__
 *
 * To run a query within a React component, call `useGetTopOpportunityLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopOpportunityLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopOpportunityLessonsQuery({
 *   variables: {
 *      area: // value for 'area'
 *      sport: // value for 'sport'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      venueFilter: // value for 'venueFilter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTopOpportunityLessonsQuery(baseOptions: Apollo.QueryHookOptions<GetTopOpportunityLessonsQuery, GetTopOpportunityLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopOpportunityLessonsQuery, GetTopOpportunityLessonsQueryVariables>(GetTopOpportunityLessonsDocument, options);
      }
export function useGetTopOpportunityLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopOpportunityLessonsQuery, GetTopOpportunityLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopOpportunityLessonsQuery, GetTopOpportunityLessonsQueryVariables>(GetTopOpportunityLessonsDocument, options);
        }
export type GetTopOpportunityLessonsQueryHookResult = ReturnType<typeof useGetTopOpportunityLessonsQuery>;
export type GetTopOpportunityLessonsLazyQueryHookResult = ReturnType<typeof useGetTopOpportunityLessonsLazyQuery>;
export type GetTopOpportunityLessonsQueryResult = Apollo.QueryResult<GetTopOpportunityLessonsQuery, GetTopOpportunityLessonsQueryVariables>;
export const GetPlayerVenuesDocument = gql`
    query getPlayerVenues($userId: uuid!) {
  venueFollows(where: {userId: {_eq: $userId}}) {
    id
    venue {
      id
      title
      geometry
      slug
      pickleballLines
      addressString
      accessType
      indoorCourtCount
      outdoorCourtCount
      pickleballNets
      images {
        id
        isVisible
        fileName
        path
        provider
        url
      }
      city {
        id
        name
        countrySubdivision {
          id
          name
        }
      }
      courtSurfaces {
        id
        courtSurface
      }
    }
  }
}
    `;

/**
 * __useGetPlayerVenuesQuery__
 *
 * To run a query within a React component, call `useGetPlayerVenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerVenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerVenuesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPlayerVenuesQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerVenuesQuery, GetPlayerVenuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerVenuesQuery, GetPlayerVenuesQueryVariables>(GetPlayerVenuesDocument, options);
      }
export function useGetPlayerVenuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerVenuesQuery, GetPlayerVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerVenuesQuery, GetPlayerVenuesQueryVariables>(GetPlayerVenuesDocument, options);
        }
export type GetPlayerVenuesQueryHookResult = ReturnType<typeof useGetPlayerVenuesQuery>;
export type GetPlayerVenuesLazyQueryHookResult = ReturnType<typeof useGetPlayerVenuesLazyQuery>;
export type GetPlayerVenuesQueryResult = Apollo.QueryResult<GetPlayerVenuesQuery, GetPlayerVenuesQueryVariables>;
export const GetLatestRecapDocument = gql`
    query getLatestRecap($playerUserId: uuid!) {
  lessonReflections(
    where: {playerUserId: {_eq: $playerUserId}}
    orderBy: {createdAt: DESC}
    limit: 1
  ) {
    id
    createdAt
    playerDismissedAt
    lessonId
    details
    lesson {
      times {
        startDateTime
      }
    }
    lessonCoach {
      fullName
      profileImageProviderUrl
      profileImagePath
      id
    }
    files {
      providerUrl
      url
      transcript
      fileFormat
    }
    lessonReflectionComments {
      skill
      customSkill
      type
    }
  }
}
    `;

/**
 * __useGetLatestRecapQuery__
 *
 * To run a query within a React component, call `useGetLatestRecapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestRecapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestRecapQuery({
 *   variables: {
 *      playerUserId: // value for 'playerUserId'
 *   },
 * });
 */
export function useGetLatestRecapQuery(baseOptions: Apollo.QueryHookOptions<GetLatestRecapQuery, GetLatestRecapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestRecapQuery, GetLatestRecapQueryVariables>(GetLatestRecapDocument, options);
      }
export function useGetLatestRecapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestRecapQuery, GetLatestRecapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestRecapQuery, GetLatestRecapQueryVariables>(GetLatestRecapDocument, options);
        }
export type GetLatestRecapQueryHookResult = ReturnType<typeof useGetLatestRecapQuery>;
export type GetLatestRecapLazyQueryHookResult = ReturnType<typeof useGetLatestRecapLazyQuery>;
export type GetLatestRecapQueryResult = Apollo.QueryResult<GetLatestRecapQuery, GetLatestRecapQueryVariables>;
export const DismissLatestRecapDocument = gql`
    mutation dismissLatestRecap($id: uuid!, $playerDismissedAt: timestamptz!) {
  updateLessonReflectionsByPk(
    pkColumns: {id: $id}
    _set: {playerDismissedAt: $playerDismissedAt}
  ) {
    id
    playerDismissedAt
  }
}
    `;
export type DismissLatestRecapMutationFn = Apollo.MutationFunction<DismissLatestRecapMutation, DismissLatestRecapMutationVariables>;

/**
 * __useDismissLatestRecapMutation__
 *
 * To run a mutation, you first call `useDismissLatestRecapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissLatestRecapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissLatestRecapMutation, { data, loading, error }] = useDismissLatestRecapMutation({
 *   variables: {
 *      id: // value for 'id'
 *      playerDismissedAt: // value for 'playerDismissedAt'
 *   },
 * });
 */
export function useDismissLatestRecapMutation(baseOptions?: Apollo.MutationHookOptions<DismissLatestRecapMutation, DismissLatestRecapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissLatestRecapMutation, DismissLatestRecapMutationVariables>(DismissLatestRecapDocument, options);
      }
export type DismissLatestRecapMutationHookResult = ReturnType<typeof useDismissLatestRecapMutation>;
export type DismissLatestRecapMutationResult = Apollo.MutationResult<DismissLatestRecapMutation>;
export type DismissLatestRecapMutationOptions = Apollo.BaseMutationOptions<DismissLatestRecapMutation, DismissLatestRecapMutationVariables>;
export const GetPlayerReflectionByLessonIdDocument = gql`
    query getPlayerReflectionByLessonId($lessonId: uuid!, $playerUserId: uuid!) {
  lessonPlayerSkillAssessments(
    where: {lessonId: {_eq: $lessonId}, playerUserId: {_eq: $playerUserId}}
  ) {
    id
  }
}
    `;

/**
 * __useGetPlayerReflectionByLessonIdQuery__
 *
 * To run a query within a React component, call `useGetPlayerReflectionByLessonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerReflectionByLessonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerReflectionByLessonIdQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      playerUserId: // value for 'playerUserId'
 *   },
 * });
 */
export function useGetPlayerReflectionByLessonIdQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerReflectionByLessonIdQuery, GetPlayerReflectionByLessonIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerReflectionByLessonIdQuery, GetPlayerReflectionByLessonIdQueryVariables>(GetPlayerReflectionByLessonIdDocument, options);
      }
export function useGetPlayerReflectionByLessonIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerReflectionByLessonIdQuery, GetPlayerReflectionByLessonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerReflectionByLessonIdQuery, GetPlayerReflectionByLessonIdQueryVariables>(GetPlayerReflectionByLessonIdDocument, options);
        }
export type GetPlayerReflectionByLessonIdQueryHookResult = ReturnType<typeof useGetPlayerReflectionByLessonIdQuery>;
export type GetPlayerReflectionByLessonIdLazyQueryHookResult = ReturnType<typeof useGetPlayerReflectionByLessonIdLazyQuery>;
export type GetPlayerReflectionByLessonIdQueryResult = Apollo.QueryResult<GetPlayerReflectionByLessonIdQuery, GetPlayerReflectionByLessonIdQueryVariables>;
export const GetParticipatedEventsByUserIdDocument = gql`
    query getParticipatedEventsByUserId($userId: uuid!, $startDate: timestamptz!) {
  events(
    where: {type: {_eq: TOURNAMENT}, status: {_eq: PUBLISHED}, archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, startDateTime: {_gte: $startDate}, registrations: {userId: {_eq: $userId}, deletedAt: {_isNull: true}}}
    orderBy: {startDate: ASC}
  ) {
    id
    addressString
    city {
      name
      id
      countrySubdivision {
        name
        id
        code
      }
      timezone
    }
    coverImagePath
    displayLocation
    endDateTime
    hasPrizes
    latitude
    locale
    longitude
    organizerImagePath
    registrationClosedAt
    registrationDeadlineDate
    registrationPriceUnitAmount
    scoringFormat
    slug
    isExternal
    currency
    sourceRegistrationCount
    sourceOrganizerTitle
    startDateTime
    status
    timezoneAbbreviation
    timezoneName
    timezoneOffsetMinutes
    title
    registrationsAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetParticipatedEventsByUserIdQuery__
 *
 * To run a query within a React component, call `useGetParticipatedEventsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipatedEventsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipatedEventsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetParticipatedEventsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetParticipatedEventsByUserIdQuery, GetParticipatedEventsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipatedEventsByUserIdQuery, GetParticipatedEventsByUserIdQueryVariables>(GetParticipatedEventsByUserIdDocument, options);
      }
export function useGetParticipatedEventsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipatedEventsByUserIdQuery, GetParticipatedEventsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipatedEventsByUserIdQuery, GetParticipatedEventsByUserIdQueryVariables>(GetParticipatedEventsByUserIdDocument, options);
        }
export type GetParticipatedEventsByUserIdQueryHookResult = ReturnType<typeof useGetParticipatedEventsByUserIdQuery>;
export type GetParticipatedEventsByUserIdLazyQueryHookResult = ReturnType<typeof useGetParticipatedEventsByUserIdLazyQuery>;
export type GetParticipatedEventsByUserIdQueryResult = Apollo.QueryResult<GetParticipatedEventsByUserIdQuery, GetParticipatedEventsByUserIdQueryVariables>;
export const GetHostedEventsByUserIdDocument = gql`
    query getHostedEventsByUserId($userId: uuid!) {
  events(
    where: {hostUserId: {_eq: $userId}, type: {_in: [TOURNAMENT, SOCIAL, LEAGUE, OPEN_PLAY, GENERAL_EVENT]}, status: {_eq: PUBLISHED}, archivedAt: {_isNull: true}, deletedAt: {_isNull: true}}
    orderBy: {startDate: ASC}
  ) {
    id
    addressString
    city {
      name
      id
      countrySubdivision {
        name
        id
        code
      }
      timezone
    }
    coverImagePath
    displayLocation
    endDateTime
    hasPrizes
    latitude
    locale
    longitude
    organizerImagePath
    registrationClosedAt
    registrationDeadlineDate
    registrationPriceUnitAmount
    scoringFormat
    slug
    isExternal
    currency
    sourceRegistrationCount
    sourceOrganizerTitle
    startDateTime
    status
    timezoneAbbreviation
    timezoneName
    timezoneOffsetMinutes
    title
    registrationsAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetHostedEventsByUserIdQuery__
 *
 * To run a query within a React component, call `useGetHostedEventsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostedEventsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostedEventsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetHostedEventsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetHostedEventsByUserIdQuery, GetHostedEventsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHostedEventsByUserIdQuery, GetHostedEventsByUserIdQueryVariables>(GetHostedEventsByUserIdDocument, options);
      }
export function useGetHostedEventsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHostedEventsByUserIdQuery, GetHostedEventsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHostedEventsByUserIdQuery, GetHostedEventsByUserIdQueryVariables>(GetHostedEventsByUserIdDocument, options);
        }
export type GetHostedEventsByUserIdQueryHookResult = ReturnType<typeof useGetHostedEventsByUserIdQuery>;
export type GetHostedEventsByUserIdLazyQueryHookResult = ReturnType<typeof useGetHostedEventsByUserIdLazyQuery>;
export type GetHostedEventsByUserIdQueryResult = Apollo.QueryResult<GetHostedEventsByUserIdQuery, GetHostedEventsByUserIdQueryVariables>;
export const GetPlayerProfilePublicDocument = gql`
    query getPlayerProfilePublic($username: String!, $now: timestamptz!) {
  userProfiles(where: {username: {_eq: $username}}) {
    ...playerProfileFields
  }
  hostedGamesAggregate: eventsAggregate(
    where: {hostUserProfile: {username: {_eq: $username}}, isPlayerListed: {_eq: true}, status: {_eq: PUBLISHED}, deletedAt: {_isNull: true}, startDateTime: {_lt: $now}}
  ) {
    aggregate {
      count
    }
  }
  joinedGamesAggregate: eventAcceptedPlayRequestsAggregate(
    where: {requesterProfile: {username: {_eq: $username}}, event: {isPlayerListed: {_eq: true}, status: {_eq: PUBLISHED}, deletedAt: {_isNull: true}, startDateTime: {_lt: $now}}}
  ) {
    aggregate {
      count
    }
  }
}
    ${PlayerProfileFieldsFragmentDoc}`;

/**
 * __useGetPlayerProfilePublicQuery__
 *
 * To run a query within a React component, call `useGetPlayerProfilePublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerProfilePublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerProfilePublicQuery({
 *   variables: {
 *      username: // value for 'username'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useGetPlayerProfilePublicQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerProfilePublicQuery, GetPlayerProfilePublicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerProfilePublicQuery, GetPlayerProfilePublicQueryVariables>(GetPlayerProfilePublicDocument, options);
      }
export function useGetPlayerProfilePublicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerProfilePublicQuery, GetPlayerProfilePublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerProfilePublicQuery, GetPlayerProfilePublicQueryVariables>(GetPlayerProfilePublicDocument, options);
        }
export type GetPlayerProfilePublicQueryHookResult = ReturnType<typeof useGetPlayerProfilePublicQuery>;
export type GetPlayerProfilePublicLazyQueryHookResult = ReturnType<typeof useGetPlayerProfilePublicLazyQuery>;
export type GetPlayerProfilePublicQueryResult = Apollo.QueryResult<GetPlayerProfilePublicQuery, GetPlayerProfilePublicQueryVariables>;
export const GetPlayerProfileDocument = gql`
    query getPlayerProfile($username: String!, $viewerId: uuid!, $now: timestamptz!) {
  userProfiles(where: {username: {_eq: $username}}) {
    ...playerProfileFields
    viewerReview: playerReviews(where: {reviewerUserId: {_eq: $viewerId}}, limit: 1) {
      id
    }
  }
  userFollows(
    where: {followedProfile: {username: {_eq: $username}}, followerUserId: {_eq: $viewerId}}
  ) {
    status
    followedUserId
    followerUserId
  }
  acceptedPlayRequests: playRequests(
    where: {status: {_eq: ACCEPTED}, _and: [{_or: [{requesterUserId: {_eq: $viewerId}}, {recipientUserId: {_eq: $viewerId}}]}, {_or: [{requesterProfile: {username: {_eq: $username}}}, {recipientProfile: {username: {_eq: $username}}}]}]}
    limit: 1
  ) {
    id
  }
  hostedGamesAggregate: eventsAggregate(
    where: {hostUserProfile: {username: {_eq: $username}}, isPlayerListed: {_eq: true}, status: {_eq: PUBLISHED}, deletedAt: {_isNull: true}, startDateTime: {_lt: $now}}
  ) {
    aggregate {
      count
    }
  }
  joinedGamesAggregate: eventAcceptedPlayRequestsAggregate(
    where: {requesterProfile: {username: {_eq: $username}}, event: {isPlayerListed: {_eq: true}, status: {_eq: PUBLISHED}, deletedAt: {_isNull: true}, startDateTime: {_lt: $now}}}
  ) {
    aggregate {
      count
    }
  }
}
    ${PlayerProfileFieldsFragmentDoc}`;

/**
 * __useGetPlayerProfileQuery__
 *
 * To run a query within a React component, call `useGetPlayerProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerProfileQuery({
 *   variables: {
 *      username: // value for 'username'
 *      viewerId: // value for 'viewerId'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useGetPlayerProfileQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerProfileQuery, GetPlayerProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerProfileQuery, GetPlayerProfileQueryVariables>(GetPlayerProfileDocument, options);
      }
export function useGetPlayerProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerProfileQuery, GetPlayerProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerProfileQuery, GetPlayerProfileQueryVariables>(GetPlayerProfileDocument, options);
        }
export type GetPlayerProfileQueryHookResult = ReturnType<typeof useGetPlayerProfileQuery>;
export type GetPlayerProfileLazyQueryHookResult = ReturnType<typeof useGetPlayerProfileLazyQuery>;
export type GetPlayerProfileQueryResult = Apollo.QueryResult<GetPlayerProfileQuery, GetPlayerProfileQueryVariables>;
export const GetUserEnrolledProgramsDocument = gql`
    query GetUserEnrolledPrograms($userId: uuid!) {
  learningProgramEnrollments(
    where: {userId: {_eq: $userId}, status: {_neq: "COMPLETED"}}
    orderBy: {enrolledAt: DESC}
  ) {
    id
    status
    enrolledAt
    currentSchedule
    learningProgram {
      id
      title
      sportId
      skillLevelId
      totalSchedules
      scheduleUnit
      sport {
        value
        description
      }
      skillLevel {
        value
        description
      }
      skills {
        id
        skillId
        isPrimary
        skill {
          value
          description
        }
      }
    }
    scheduleProgress(orderBy: {scheduleNumber: ASC}) {
      id
      scheduleNumber
      learningProgramScheduleId
      completedAt
      mediaWatched {
        id
        watchedAt
        mediaCategory {
          id
          code
        }
      }
      learningProgramSchedule {
        id
        scheduleNumber
        title
        media {
          mediaCategory {
            id
          }
        }
      }
    }
    videoSubmissions(orderBy: {videoAnalysis: {createdAt: DESC}}) {
      learningProgramScheduleId
      videoAnalysis {
        id
        reviewStatus
      }
    }
  }
}
    `;

/**
 * __useGetUserEnrolledProgramsQuery__
 *
 * To run a query within a React component, call `useGetUserEnrolledProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEnrolledProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEnrolledProgramsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserEnrolledProgramsQuery(baseOptions: Apollo.QueryHookOptions<GetUserEnrolledProgramsQuery, GetUserEnrolledProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEnrolledProgramsQuery, GetUserEnrolledProgramsQueryVariables>(GetUserEnrolledProgramsDocument, options);
      }
export function useGetUserEnrolledProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEnrolledProgramsQuery, GetUserEnrolledProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEnrolledProgramsQuery, GetUserEnrolledProgramsQueryVariables>(GetUserEnrolledProgramsDocument, options);
        }
export type GetUserEnrolledProgramsQueryHookResult = ReturnType<typeof useGetUserEnrolledProgramsQuery>;
export type GetUserEnrolledProgramsLazyQueryHookResult = ReturnType<typeof useGetUserEnrolledProgramsLazyQuery>;
export type GetUserEnrolledProgramsQueryResult = Apollo.QueryResult<GetUserEnrolledProgramsQuery, GetUserEnrolledProgramsQueryVariables>;
export const GetPlayerUserContentSubscribeStatusDocument = gql`
    query getPlayerUserContentSubscribeStatus($coachId: uuid!, $playerId: uuid!) {
  userContentBetaSubscriptions(
    where: {ownerUserId: {_eq: $coachId}, subscriberUserId: {_eq: $playerId}}
  ) {
    id
    createdAt
    subscriberUserId
  }
}
    `;

/**
 * __useGetPlayerUserContentSubscribeStatusQuery__
 *
 * To run a query within a React component, call `useGetPlayerUserContentSubscribeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerUserContentSubscribeStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerUserContentSubscribeStatusQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function useGetPlayerUserContentSubscribeStatusQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerUserContentSubscribeStatusQuery, GetPlayerUserContentSubscribeStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerUserContentSubscribeStatusQuery, GetPlayerUserContentSubscribeStatusQueryVariables>(GetPlayerUserContentSubscribeStatusDocument, options);
      }
export function useGetPlayerUserContentSubscribeStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerUserContentSubscribeStatusQuery, GetPlayerUserContentSubscribeStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerUserContentSubscribeStatusQuery, GetPlayerUserContentSubscribeStatusQueryVariables>(GetPlayerUserContentSubscribeStatusDocument, options);
        }
export type GetPlayerUserContentSubscribeStatusQueryHookResult = ReturnType<typeof useGetPlayerUserContentSubscribeStatusQuery>;
export type GetPlayerUserContentSubscribeStatusLazyQueryHookResult = ReturnType<typeof useGetPlayerUserContentSubscribeStatusLazyQuery>;
export type GetPlayerUserContentSubscribeStatusQueryResult = Apollo.QueryResult<GetPlayerUserContentSubscribeStatusQuery, GetPlayerUserContentSubscribeStatusQueryVariables>;
export const UpdateCoachProfileDocument = gql`
    mutation updateCoachProfile($id: uuid!, $fullName: String = "", $aboutMe: String = "", $preferredName: String = "", $existingCoachServices: [UserCoachServicesUpdates!] = [], $newCoachServices: [UserCoachServicesInsertInput!] = [], $qualificationObjects: [UsersCoachQualificationsInsertInput!] = []) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {fullName: $fullName, aboutMe: $aboutMe, preferredName: $preferredName}
  ) {
    id
    fullName
    preferredName
    username
    aboutMe
    countryId
    countrySubdivisionId
    cityName
    profile {
      id
      preferredName
      fullName
      aboutMe
      username
      countryId
      countrySubdivisionId
      cityName
    }
  }
  updateUserCoachServicesMany(updates: $existingCoachServices) {
    returning {
      coverImageUrl
      currency
      description
      id
      priceUnitAmount
      title
      type
      userId
    }
  }
  insertUserCoachServices(
    objects: $newCoachServices
    onConflict: {constraint: user_coach_services_pkey, updateColumns: [title, description, currency, coverImageUrl, priceUnitAmount, type]}
  ) {
    returning {
      coverImageUrl
      currency
      description
      id
      priceUnitAmount
      title
      type
      userId
    }
  }
  insertUsersCoachQualifications(
    objects: $qualificationObjects
    onConflict: {constraint: users_coach_qualifications_user_id_coach_qualification_id_key, updateColumns: status}
  ) {
    returning {
      id
      status
      coachQualificationId
      userId
    }
  }
}
    `;
export type UpdateCoachProfileMutationFn = Apollo.MutationFunction<UpdateCoachProfileMutation, UpdateCoachProfileMutationVariables>;

/**
 * __useUpdateCoachProfileMutation__
 *
 * To run a mutation, you first call `useUpdateCoachProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachProfileMutation, { data, loading, error }] = useUpdateCoachProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fullName: // value for 'fullName'
 *      aboutMe: // value for 'aboutMe'
 *      preferredName: // value for 'preferredName'
 *      existingCoachServices: // value for 'existingCoachServices'
 *      newCoachServices: // value for 'newCoachServices'
 *      qualificationObjects: // value for 'qualificationObjects'
 *   },
 * });
 */
export function useUpdateCoachProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoachProfileMutation, UpdateCoachProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoachProfileMutation, UpdateCoachProfileMutationVariables>(UpdateCoachProfileDocument, options);
      }
export type UpdateCoachProfileMutationHookResult = ReturnType<typeof useUpdateCoachProfileMutation>;
export type UpdateCoachProfileMutationResult = Apollo.MutationResult<UpdateCoachProfileMutation>;
export type UpdateCoachProfileMutationOptions = Apollo.BaseMutationOptions<UpdateCoachProfileMutation, UpdateCoachProfileMutationVariables>;
export const UpdatePlayerProfileDocument = gql`
    mutation updatePlayerProfile($id: uuid!, $fullName: String = "", $aboutMe: String = "", $preferredName: String = "", $normalizedTennisRating: numeric, $normalizedTennisRatingScaleId: uuid, $tennisRating: numeric, $tennisRatingScaleId: uuid) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {fullName: $fullName, aboutMe: $aboutMe, preferredName: $preferredName, normalizedTennisRating: $normalizedTennisRating, normalizedTennisRatingScaleId: $normalizedTennisRatingScaleId, tennisRating: $tennisRating, tennisRatingScaleId: $tennisRatingScaleId}
  ) {
    id
    fullName
    preferredName
    username
    aboutMe
    countryId
    countrySubdivisionId
    cityName
    normalizedTennisRating
    normalizedTennisRatingScaleId
    tennisRating
    tennisRatingScaleId
    profile {
      id
      preferredName
      fullName
      aboutMe
      username
      countryId
      countrySubdivisionId
      cityName
      normalizedTennisRating
      normalizedTennisRatingScaleId
      tennisRating
      tennisRatingScaleId
    }
  }
}
    `;
export type UpdatePlayerProfileMutationFn = Apollo.MutationFunction<UpdatePlayerProfileMutation, UpdatePlayerProfileMutationVariables>;

/**
 * __useUpdatePlayerProfileMutation__
 *
 * To run a mutation, you first call `useUpdatePlayerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlayerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlayerProfileMutation, { data, loading, error }] = useUpdatePlayerProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fullName: // value for 'fullName'
 *      aboutMe: // value for 'aboutMe'
 *      preferredName: // value for 'preferredName'
 *      normalizedTennisRating: // value for 'normalizedTennisRating'
 *      normalizedTennisRatingScaleId: // value for 'normalizedTennisRatingScaleId'
 *      tennisRating: // value for 'tennisRating'
 *      tennisRatingScaleId: // value for 'tennisRatingScaleId'
 *   },
 * });
 */
export function useUpdatePlayerProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlayerProfileMutation, UpdatePlayerProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlayerProfileMutation, UpdatePlayerProfileMutationVariables>(UpdatePlayerProfileDocument, options);
      }
export type UpdatePlayerProfileMutationHookResult = ReturnType<typeof useUpdatePlayerProfileMutation>;
export type UpdatePlayerProfileMutationResult = Apollo.MutationResult<UpdatePlayerProfileMutation>;
export type UpdatePlayerProfileMutationOptions = Apollo.BaseMutationOptions<UpdatePlayerProfileMutation, UpdatePlayerProfileMutationVariables>;
export const GetCountriesAndActiveSubdivisionsDocument = gql`
    query getCountriesAndActiveSubdivisions($countryId: String!) {
  countries {
    id
    name
    slug
  }
  countrySubdivisions(where: {countryId: {_eq: $countryId}}) {
    id
    name
    type
  }
}
    `;

/**
 * __useGetCountriesAndActiveSubdivisionsQuery__
 *
 * To run a query within a React component, call `useGetCountriesAndActiveSubdivisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesAndActiveSubdivisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesAndActiveSubdivisionsQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetCountriesAndActiveSubdivisionsQuery(baseOptions: Apollo.QueryHookOptions<GetCountriesAndActiveSubdivisionsQuery, GetCountriesAndActiveSubdivisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesAndActiveSubdivisionsQuery, GetCountriesAndActiveSubdivisionsQueryVariables>(GetCountriesAndActiveSubdivisionsDocument, options);
      }
export function useGetCountriesAndActiveSubdivisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesAndActiveSubdivisionsQuery, GetCountriesAndActiveSubdivisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesAndActiveSubdivisionsQuery, GetCountriesAndActiveSubdivisionsQueryVariables>(GetCountriesAndActiveSubdivisionsDocument, options);
        }
export type GetCountriesAndActiveSubdivisionsQueryHookResult = ReturnType<typeof useGetCountriesAndActiveSubdivisionsQuery>;
export type GetCountriesAndActiveSubdivisionsLazyQueryHookResult = ReturnType<typeof useGetCountriesAndActiveSubdivisionsLazyQuery>;
export type GetCountriesAndActiveSubdivisionsQueryResult = Apollo.QueryResult<GetCountriesAndActiveSubdivisionsQuery, GetCountriesAndActiveSubdivisionsQueryVariables>;
export const GetAvailableCoachQualificationsDocument = gql`
    query getAvailableCoachQualifications {
  coachQualifications(orderBy: {order: ASC}) {
    id
    name
    order
    groupId
    displayKey
  }
}
    `;

/**
 * __useGetAvailableCoachQualificationsQuery__
 *
 * To run a query within a React component, call `useGetAvailableCoachQualificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableCoachQualificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableCoachQualificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableCoachQualificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableCoachQualificationsQuery, GetAvailableCoachQualificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableCoachQualificationsQuery, GetAvailableCoachQualificationsQueryVariables>(GetAvailableCoachQualificationsDocument, options);
      }
export function useGetAvailableCoachQualificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableCoachQualificationsQuery, GetAvailableCoachQualificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableCoachQualificationsQuery, GetAvailableCoachQualificationsQueryVariables>(GetAvailableCoachQualificationsDocument, options);
        }
export type GetAvailableCoachQualificationsQueryHookResult = ReturnType<typeof useGetAvailableCoachQualificationsQuery>;
export type GetAvailableCoachQualificationsLazyQueryHookResult = ReturnType<typeof useGetAvailableCoachQualificationsLazyQuery>;
export type GetAvailableCoachQualificationsQueryResult = Apollo.QueryResult<GetAvailableCoachQualificationsQuery, GetAvailableCoachQualificationsQueryVariables>;
export const GetTennisRatingScalesDocument = gql`
    query getTennisRatingScales {
  tennisRatingScales(orderBy: {order: ASC}) {
    id
    maximum
    minimum
    name
    order
    shortName
  }
}
    `;

/**
 * __useGetTennisRatingScalesQuery__
 *
 * To run a query within a React component, call `useGetTennisRatingScalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTennisRatingScalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTennisRatingScalesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTennisRatingScalesQuery(baseOptions?: Apollo.QueryHookOptions<GetTennisRatingScalesQuery, GetTennisRatingScalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTennisRatingScalesQuery, GetTennisRatingScalesQueryVariables>(GetTennisRatingScalesDocument, options);
      }
export function useGetTennisRatingScalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTennisRatingScalesQuery, GetTennisRatingScalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTennisRatingScalesQuery, GetTennisRatingScalesQueryVariables>(GetTennisRatingScalesDocument, options);
        }
export type GetTennisRatingScalesQueryHookResult = ReturnType<typeof useGetTennisRatingScalesQuery>;
export type GetTennisRatingScalesLazyQueryHookResult = ReturnType<typeof useGetTennisRatingScalesLazyQuery>;
export type GetTennisRatingScalesQueryResult = Apollo.QueryResult<GetTennisRatingScalesQuery, GetTennisRatingScalesQueryVariables>;
export const GetCoachEarningsUnitAmountDocument = gql`
    query getCoachEarningsUnitAmount($sellerUserId: uuid!) {
  lessonOrdersAggregate(
    where: {sellerUserId: {_eq: $sellerUserId}, status: {_eq: SUCCEEDED}}
  ) {
    aggregate {
      sum {
        transferUnitAmount
      }
    }
  }
}
    `;

/**
 * __useGetCoachEarningsUnitAmountQuery__
 *
 * To run a query within a React component, call `useGetCoachEarningsUnitAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachEarningsUnitAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachEarningsUnitAmountQuery({
 *   variables: {
 *      sellerUserId: // value for 'sellerUserId'
 *   },
 * });
 */
export function useGetCoachEarningsUnitAmountQuery(baseOptions: Apollo.QueryHookOptions<GetCoachEarningsUnitAmountQuery, GetCoachEarningsUnitAmountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachEarningsUnitAmountQuery, GetCoachEarningsUnitAmountQueryVariables>(GetCoachEarningsUnitAmountDocument, options);
      }
export function useGetCoachEarningsUnitAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachEarningsUnitAmountQuery, GetCoachEarningsUnitAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachEarningsUnitAmountQuery, GetCoachEarningsUnitAmountQueryVariables>(GetCoachEarningsUnitAmountDocument, options);
        }
export type GetCoachEarningsUnitAmountQueryHookResult = ReturnType<typeof useGetCoachEarningsUnitAmountQuery>;
export type GetCoachEarningsUnitAmountLazyQueryHookResult = ReturnType<typeof useGetCoachEarningsUnitAmountLazyQuery>;
export type GetCoachEarningsUnitAmountQueryResult = Apollo.QueryResult<GetCoachEarningsUnitAmountQuery, GetCoachEarningsUnitAmountQueryVariables>;
export const UpdatePlayerPhoneDocument = gql`
    mutation updatePlayerPhone($id: uuid!, $phoneNumber: String!, $phoneCountryCode: String!) {
  updateUsersByPk(
    pkColumns: {id: $id}
    _set: {phoneNumber: $phoneNumber, phoneCountryCode: $phoneCountryCode}
  ) {
    id
    phoneNumber
    phoneCountryCode
  }
}
    `;
export type UpdatePlayerPhoneMutationFn = Apollo.MutationFunction<UpdatePlayerPhoneMutation, UpdatePlayerPhoneMutationVariables>;

/**
 * __useUpdatePlayerPhoneMutation__
 *
 * To run a mutation, you first call `useUpdatePlayerPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlayerPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlayerPhoneMutation, { data, loading, error }] = useUpdatePlayerPhoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      phoneNumber: // value for 'phoneNumber'
 *      phoneCountryCode: // value for 'phoneCountryCode'
 *   },
 * });
 */
export function useUpdatePlayerPhoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlayerPhoneMutation, UpdatePlayerPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlayerPhoneMutation, UpdatePlayerPhoneMutationVariables>(UpdatePlayerPhoneDocument, options);
      }
export type UpdatePlayerPhoneMutationHookResult = ReturnType<typeof useUpdatePlayerPhoneMutation>;
export type UpdatePlayerPhoneMutationResult = Apollo.MutationResult<UpdatePlayerPhoneMutation>;
export type UpdatePlayerPhoneMutationOptions = Apollo.BaseMutationOptions<UpdatePlayerPhoneMutation, UpdatePlayerPhoneMutationVariables>;
export const GetUserProgramTemplatesDocument = gql`
    query getUserProgramTemplates($id: uuid!) {
  usersByPk(id: $id) {
    id
    lessonTemplates(where: {deletedAt: {_isNull: true}}) {
      coverImageUrl
      createdAt
      currency
      deletedAt
      description
      eventType
      externalUrl
      id
      originalEventId
      originalLessonId
      participantLimit
      priceUnitAmount
      privacy
      templateName
      title
      type
      typeCustom
      updatedAt
      userId
      userCustomCourtId
      sport
      intendedAgeGroup
      skillLevels {
        skillLevel
      }
      originalLesson {
        venue {
          addressString
          id
        }
        userCustomCourtId
      }
      originalEvent {
        venue {
          addressString
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserProgramTemplatesQuery__
 *
 * To run a query within a React component, call `useGetUserProgramTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProgramTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProgramTemplatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserProgramTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetUserProgramTemplatesQuery, GetUserProgramTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProgramTemplatesQuery, GetUserProgramTemplatesQueryVariables>(GetUserProgramTemplatesDocument, options);
      }
export function useGetUserProgramTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProgramTemplatesQuery, GetUserProgramTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProgramTemplatesQuery, GetUserProgramTemplatesQueryVariables>(GetUserProgramTemplatesDocument, options);
        }
export type GetUserProgramTemplatesQueryHookResult = ReturnType<typeof useGetUserProgramTemplatesQuery>;
export type GetUserProgramTemplatesLazyQueryHookResult = ReturnType<typeof useGetUserProgramTemplatesLazyQuery>;
export type GetUserProgramTemplatesQueryResult = Apollo.QueryResult<GetUserProgramTemplatesQuery, GetUserProgramTemplatesQueryVariables>;
export const InsertProgramLessonDocument = gql`
    mutation insertProgramLesson($title: String!, $sport: SportsEnum!, $type: LessonTypesEnum!, $typeCustom: String = "", $status: LessonStatusesEnum = PENDING, $description: String, $startDateTime: timestamptz!, $endDateTime: timestamptz!, $ownerUserId: uuid!, $participantLimit: Int!, $paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum!, $priceUnitAmount: Int!, $privacy: LessonPrivacyEnum = PUBLIC, $coverImageUrl: String = "", $coverImageFileName: String = "", $coverImagePath: String = "", $coverImageProvider: String = "", $coverImageProviderId: String = "", $coverImageProviderUrl: String = "", $usedTemplateId: uuid, $lessonTimeData: [LessonTimesInsertInput!]!, $userCustomCourtId: uuid, $venueId: uuid, $locale: String!, $timezoneName: String!, $timezoneAbbreviation: String!, $timezoneOffsetMinutes: Int!, $currency: String!, $externalBookingUrl: String = "") {
  insertLessonsOne(
    object: {title: $title, sport: $sport, type: $type, typeCustom: $typeCustom, status: $status, startDateTime: $startDateTime, endDateTime: $endDateTime, description: $description, ownerUserId: $ownerUserId, participantLimit: $participantLimit, paymentFulfillmentChannel: $paymentFulfillmentChannel, priceUnitAmount: $priceUnitAmount, privacy: $privacy, coverImageUrl: $coverImageUrl, coverImageFileName: $coverImageFileName, coverImagePath: $coverImagePath, coverImageProvider: $coverImageProvider, coverImageProviderId: $coverImageProviderId, coverImageProviderUrl: $coverImageProviderUrl, usedTemplateId: $usedTemplateId, locale: $locale, timezoneName: $timezoneName, timezoneAbbreviation: $timezoneAbbreviation, timezoneOffsetMinutes: $timezoneOffsetMinutes, times: {data: $lessonTimeData}, userCustomCourtId: $userCustomCourtId, venueId: $venueId, currency: $currency, externalBookingUrl: $externalBookingUrl}
  ) {
    ...lessonFields
  }
}
    ${LessonFieldsFragmentDoc}`;
export type InsertProgramLessonMutationFn = Apollo.MutationFunction<InsertProgramLessonMutation, InsertProgramLessonMutationVariables>;

/**
 * __useInsertProgramLessonMutation__
 *
 * To run a mutation, you first call `useInsertProgramLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertProgramLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertProgramLessonMutation, { data, loading, error }] = useInsertProgramLessonMutation({
 *   variables: {
 *      title: // value for 'title'
 *      sport: // value for 'sport'
 *      type: // value for 'type'
 *      typeCustom: // value for 'typeCustom'
 *      status: // value for 'status'
 *      description: // value for 'description'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      ownerUserId: // value for 'ownerUserId'
 *      participantLimit: // value for 'participantLimit'
 *      paymentFulfillmentChannel: // value for 'paymentFulfillmentChannel'
 *      priceUnitAmount: // value for 'priceUnitAmount'
 *      privacy: // value for 'privacy'
 *      coverImageUrl: // value for 'coverImageUrl'
 *      coverImageFileName: // value for 'coverImageFileName'
 *      coverImagePath: // value for 'coverImagePath'
 *      coverImageProvider: // value for 'coverImageProvider'
 *      coverImageProviderId: // value for 'coverImageProviderId'
 *      coverImageProviderUrl: // value for 'coverImageProviderUrl'
 *      usedTemplateId: // value for 'usedTemplateId'
 *      lessonTimeData: // value for 'lessonTimeData'
 *      userCustomCourtId: // value for 'userCustomCourtId'
 *      venueId: // value for 'venueId'
 *      locale: // value for 'locale'
 *      timezoneName: // value for 'timezoneName'
 *      timezoneAbbreviation: // value for 'timezoneAbbreviation'
 *      timezoneOffsetMinutes: // value for 'timezoneOffsetMinutes'
 *      currency: // value for 'currency'
 *      externalBookingUrl: // value for 'externalBookingUrl'
 *   },
 * });
 */
export function useInsertProgramLessonMutation(baseOptions?: Apollo.MutationHookOptions<InsertProgramLessonMutation, InsertProgramLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertProgramLessonMutation, InsertProgramLessonMutationVariables>(InsertProgramLessonDocument, options);
      }
export type InsertProgramLessonMutationHookResult = ReturnType<typeof useInsertProgramLessonMutation>;
export type InsertProgramLessonMutationResult = Apollo.MutationResult<InsertProgramLessonMutation>;
export type InsertProgramLessonMutationOptions = Apollo.BaseMutationOptions<InsertProgramLessonMutation, InsertProgramLessonMutationVariables>;
export const UpdateProgramLessonDocument = gql`
    mutation updateProgramLesson($lessonId: uuid!, $title: String!, $sport: SportsEnum!, $type: LessonTypesEnum!, $typeCustom: String = "", $status: LessonStatusesEnum = PENDING, $description: String, $startDateTime: timestamptz!, $endDateTime: timestamptz!, $participantLimit: Int!, $paymentFulfillmentChannel: PaymentFulfillmentChannelsEnum!, $priceUnitAmount: Int!, $privacy: LessonPrivacyEnum = PUBLIC, $coverImageUrl: String = "", $coverImageFileName: String = "", $coverImagePath: String = "", $coverImageProvider: String = "", $coverImageProviderId: String = "", $coverImageProviderUrl: String = "", $usedTemplateId: uuid, $userCustomCourtId: uuid, $venueId: uuid, $currency: String!, $externalBookingUrl: String = "") {
  updateLessonsByPk(
    pkColumns: {id: $lessonId}
    _set: {title: $title, sport: $sport, type: $type, typeCustom: $typeCustom, status: $status, startDateTime: $startDateTime, endDateTime: $endDateTime, description: $description, participantLimit: $participantLimit, paymentFulfillmentChannel: $paymentFulfillmentChannel, priceUnitAmount: $priceUnitAmount, privacy: $privacy, coverImageUrl: $coverImageUrl, coverImageFileName: $coverImageFileName, coverImagePath: $coverImagePath, coverImageProvider: $coverImageProvider, coverImageProviderId: $coverImageProviderId, coverImageProviderUrl: $coverImageProviderUrl, usedTemplateId: $usedTemplateId, userCustomCourtId: $userCustomCourtId, venueId: $venueId, currency: $currency}
  ) {
    ...lessonFields
  }
}
    ${LessonFieldsFragmentDoc}`;
export type UpdateProgramLessonMutationFn = Apollo.MutationFunction<UpdateProgramLessonMutation, UpdateProgramLessonMutationVariables>;

/**
 * __useUpdateProgramLessonMutation__
 *
 * To run a mutation, you first call `useUpdateProgramLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramLessonMutation, { data, loading, error }] = useUpdateProgramLessonMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      title: // value for 'title'
 *      sport: // value for 'sport'
 *      type: // value for 'type'
 *      typeCustom: // value for 'typeCustom'
 *      status: // value for 'status'
 *      description: // value for 'description'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      participantLimit: // value for 'participantLimit'
 *      paymentFulfillmentChannel: // value for 'paymentFulfillmentChannel'
 *      priceUnitAmount: // value for 'priceUnitAmount'
 *      privacy: // value for 'privacy'
 *      coverImageUrl: // value for 'coverImageUrl'
 *      coverImageFileName: // value for 'coverImageFileName'
 *      coverImagePath: // value for 'coverImagePath'
 *      coverImageProvider: // value for 'coverImageProvider'
 *      coverImageProviderId: // value for 'coverImageProviderId'
 *      coverImageProviderUrl: // value for 'coverImageProviderUrl'
 *      usedTemplateId: // value for 'usedTemplateId'
 *      userCustomCourtId: // value for 'userCustomCourtId'
 *      venueId: // value for 'venueId'
 *      currency: // value for 'currency'
 *      externalBookingUrl: // value for 'externalBookingUrl'
 *   },
 * });
 */
export function useUpdateProgramLessonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramLessonMutation, UpdateProgramLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramLessonMutation, UpdateProgramLessonMutationVariables>(UpdateProgramLessonDocument, options);
      }
export type UpdateProgramLessonMutationHookResult = ReturnType<typeof useUpdateProgramLessonMutation>;
export type UpdateProgramLessonMutationResult = Apollo.MutationResult<UpdateProgramLessonMutation>;
export type UpdateProgramLessonMutationOptions = Apollo.BaseMutationOptions<UpdateProgramLessonMutation, UpdateProgramLessonMutationVariables>;
export const GetProgramLessonByIdDocument = gql`
    query getProgramLessonById($id: uuid!) {
  lessonsByPk(id: $id) {
    id
    title
    sport
    type
    typeCustom
    description
    startDateTime
    endDateTime
    priceUnitAmount
    currency
    participantLimit
    recurrenceKind
    lessonCollectionId
    locale
    timezoneName
    timezoneAbbreviation
    timezoneOffsetMinutes
    externalBookingUrl
    intendedAgeGroup
    coverImageUrl
    coverImageFileName
    coverImagePath
    coverImageProvider
    coverImageProviderUrl
    venueId
    ownerProfile {
      username
    }
    venue {
      id
      addressString
      latitude
      longitude
    }
    times(where: {deletedAt: {_isNull: true}}, orderBy: {startDateTime: ASC}) {
      id
      startDateTime
      endDateTime
    }
    skillLevels {
      skillLevel
    }
  }
}
    `;

/**
 * __useGetProgramLessonByIdQuery__
 *
 * To run a query within a React component, call `useGetProgramLessonByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramLessonByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramLessonByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProgramLessonByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProgramLessonByIdQuery, GetProgramLessonByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramLessonByIdQuery, GetProgramLessonByIdQueryVariables>(GetProgramLessonByIdDocument, options);
      }
export function useGetProgramLessonByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramLessonByIdQuery, GetProgramLessonByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramLessonByIdQuery, GetProgramLessonByIdQueryVariables>(GetProgramLessonByIdDocument, options);
        }
export type GetProgramLessonByIdQueryHookResult = ReturnType<typeof useGetProgramLessonByIdQuery>;
export type GetProgramLessonByIdLazyQueryHookResult = ReturnType<typeof useGetProgramLessonByIdLazyQuery>;
export type GetProgramLessonByIdQueryResult = Apollo.QueryResult<GetProgramLessonByIdQuery, GetProgramLessonByIdQueryVariables>;
export const InsertProgramEventDocument = gql`
    mutation insertProgramEvent($object: EventsInsertInput!) {
  insertEventsOne(object: $object) {
    id
    slug
    title
    type
  }
}
    `;
export type InsertProgramEventMutationFn = Apollo.MutationFunction<InsertProgramEventMutation, InsertProgramEventMutationVariables>;

/**
 * __useInsertProgramEventMutation__
 *
 * To run a mutation, you first call `useInsertProgramEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertProgramEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertProgramEventMutation, { data, loading, error }] = useInsertProgramEventMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertProgramEventMutation(baseOptions?: Apollo.MutationHookOptions<InsertProgramEventMutation, InsertProgramEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertProgramEventMutation, InsertProgramEventMutationVariables>(InsertProgramEventDocument, options);
      }
export type InsertProgramEventMutationHookResult = ReturnType<typeof useInsertProgramEventMutation>;
export type InsertProgramEventMutationResult = Apollo.MutationResult<InsertProgramEventMutation>;
export type InsertProgramEventMutationOptions = Apollo.BaseMutationOptions<InsertProgramEventMutation, InsertProgramEventMutationVariables>;
export const InsertProgramEventCollectionDocument = gql`
    mutation insertProgramEventCollection($object: EventCollectionsInsertInput!) {
  insertEventCollectionsOne(object: $object) {
    id
    slug
    events {
      id
      slug
    }
  }
}
    `;
export type InsertProgramEventCollectionMutationFn = Apollo.MutationFunction<InsertProgramEventCollectionMutation, InsertProgramEventCollectionMutationVariables>;

/**
 * __useInsertProgramEventCollectionMutation__
 *
 * To run a mutation, you first call `useInsertProgramEventCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertProgramEventCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertProgramEventCollectionMutation, { data, loading, error }] = useInsertProgramEventCollectionMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertProgramEventCollectionMutation(baseOptions?: Apollo.MutationHookOptions<InsertProgramEventCollectionMutation, InsertProgramEventCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertProgramEventCollectionMutation, InsertProgramEventCollectionMutationVariables>(InsertProgramEventCollectionDocument, options);
      }
export type InsertProgramEventCollectionMutationHookResult = ReturnType<typeof useInsertProgramEventCollectionMutation>;
export type InsertProgramEventCollectionMutationResult = Apollo.MutationResult<InsertProgramEventCollectionMutation>;
export type InsertProgramEventCollectionMutationOptions = Apollo.BaseMutationOptions<InsertProgramEventCollectionMutation, InsertProgramEventCollectionMutationVariables>;
export const InsertProgramLessonV2Document = gql`
    mutation insertProgramLessonV2($object: LessonsInsertInput!) {
  insertLessonsOne(object: $object) {
    id
  }
}
    `;
export type InsertProgramLessonV2MutationFn = Apollo.MutationFunction<InsertProgramLessonV2Mutation, InsertProgramLessonV2MutationVariables>;

/**
 * __useInsertProgramLessonV2Mutation__
 *
 * To run a mutation, you first call `useInsertProgramLessonV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertProgramLessonV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertProgramLessonV2Mutation, { data, loading, error }] = useInsertProgramLessonV2Mutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertProgramLessonV2Mutation(baseOptions?: Apollo.MutationHookOptions<InsertProgramLessonV2Mutation, InsertProgramLessonV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertProgramLessonV2Mutation, InsertProgramLessonV2MutationVariables>(InsertProgramLessonV2Document, options);
      }
export type InsertProgramLessonV2MutationHookResult = ReturnType<typeof useInsertProgramLessonV2Mutation>;
export type InsertProgramLessonV2MutationResult = Apollo.MutationResult<InsertProgramLessonV2Mutation>;
export type InsertProgramLessonV2MutationOptions = Apollo.BaseMutationOptions<InsertProgramLessonV2Mutation, InsertProgramLessonV2MutationVariables>;
export const UpdateProgramLessonV2Document = gql`
    mutation updateProgramLessonV2($lessonId: uuid!, $set: LessonsSetInput!, $lessonTimes: [LessonTimesInsertInput!]!, $removedTimeIds: [uuid!]!, $skillLevelObjects: [LessonSkillLevelsInsertInput!]!) {
  updateLessonsByPk(pkColumns: {id: $lessonId}, _set: $set) {
    id
  }
  insertLessonTimes(
    objects: $lessonTimes
    onConflict: {constraint: lesson_times_pkey, updateColumns: [startDateTime, endDateTime, deletedAt]}
  ) {
    affectedRows
  }
  softDeleteRemovedLessonTimes: updateLessonTimes(
    where: {id: {_in: $removedTimeIds}, deletedAt: {_isNull: true}}
    _set: {deletedAt: "now()"}
  ) {
    affectedRows
  }
  deleteLessonSkillLevels(where: {lessonId: {_eq: $lessonId}}) {
    affectedRows
  }
  insertLessonSkillLevels(objects: $skillLevelObjects) {
    affectedRows
  }
}
    `;
export type UpdateProgramLessonV2MutationFn = Apollo.MutationFunction<UpdateProgramLessonV2Mutation, UpdateProgramLessonV2MutationVariables>;

/**
 * __useUpdateProgramLessonV2Mutation__
 *
 * To run a mutation, you first call `useUpdateProgramLessonV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramLessonV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramLessonV2Mutation, { data, loading, error }] = useUpdateProgramLessonV2Mutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      set: // value for 'set'
 *      lessonTimes: // value for 'lessonTimes'
 *      removedTimeIds: // value for 'removedTimeIds'
 *      skillLevelObjects: // value for 'skillLevelObjects'
 *   },
 * });
 */
export function useUpdateProgramLessonV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramLessonV2Mutation, UpdateProgramLessonV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramLessonV2Mutation, UpdateProgramLessonV2MutationVariables>(UpdateProgramLessonV2Document, options);
      }
export type UpdateProgramLessonV2MutationHookResult = ReturnType<typeof useUpdateProgramLessonV2Mutation>;
export type UpdateProgramLessonV2MutationResult = Apollo.MutationResult<UpdateProgramLessonV2Mutation>;
export type UpdateProgramLessonV2MutationOptions = Apollo.BaseMutationOptions<UpdateProgramLessonV2Mutation, UpdateProgramLessonV2MutationVariables>;
export const InsertProgramLessonCollectionDocument = gql`
    mutation insertProgramLessonCollection($object: LessonCollectionsInsertInput!) {
  insertLessonCollectionsOne(object: $object) {
    id
    lessons {
      id
    }
  }
}
    `;
export type InsertProgramLessonCollectionMutationFn = Apollo.MutationFunction<InsertProgramLessonCollectionMutation, InsertProgramLessonCollectionMutationVariables>;

/**
 * __useInsertProgramLessonCollectionMutation__
 *
 * To run a mutation, you first call `useInsertProgramLessonCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertProgramLessonCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertProgramLessonCollectionMutation, { data, loading, error }] = useInsertProgramLessonCollectionMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertProgramLessonCollectionMutation(baseOptions?: Apollo.MutationHookOptions<InsertProgramLessonCollectionMutation, InsertProgramLessonCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertProgramLessonCollectionMutation, InsertProgramLessonCollectionMutationVariables>(InsertProgramLessonCollectionDocument, options);
      }
export type InsertProgramLessonCollectionMutationHookResult = ReturnType<typeof useInsertProgramLessonCollectionMutation>;
export type InsertProgramLessonCollectionMutationResult = Apollo.MutationResult<InsertProgramLessonCollectionMutation>;
export type InsertProgramLessonCollectionMutationOptions = Apollo.BaseMutationOptions<InsertProgramLessonCollectionMutation, InsertProgramLessonCollectionMutationVariables>;
export const GetProgramEventByIdDocument = gql`
    query getProgramEventById($id: uuid!) {
  eventsByPk(id: $id) {
    id
    title
    type
    sport
    description
    startDateTime
    endDateTime
    timezoneName
    registrationDeadlineDate
    registrationDeadlineDateTime
    isRatingRequired
    registrationPriceUnitAmount
    scheduleInfo
    intendedAgeGroup
    currency
    participantLimit
    externalUrl
    coverImageUrl
    coverImageFileName
    coverImagePath
    coverImageProvider
    coverImageProviderUrl
    venueId
    addressString
    displayLocation
    latitude
    longitude
    skillLevels {
      skillLevel
    }
    venue {
      id
      addressString
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetProgramEventByIdQuery__
 *
 * To run a query within a React component, call `useGetProgramEventByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramEventByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramEventByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProgramEventByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProgramEventByIdQuery, GetProgramEventByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramEventByIdQuery, GetProgramEventByIdQueryVariables>(GetProgramEventByIdDocument, options);
      }
export function useGetProgramEventByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramEventByIdQuery, GetProgramEventByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramEventByIdQuery, GetProgramEventByIdQueryVariables>(GetProgramEventByIdDocument, options);
        }
export type GetProgramEventByIdQueryHookResult = ReturnType<typeof useGetProgramEventByIdQuery>;
export type GetProgramEventByIdLazyQueryHookResult = ReturnType<typeof useGetProgramEventByIdLazyQuery>;
export type GetProgramEventByIdQueryResult = Apollo.QueryResult<GetProgramEventByIdQuery, GetProgramEventByIdQueryVariables>;
export const UpdateProgramEventDocument = gql`
    mutation updateProgramEvent($eventId: uuid!, $set: EventsSetInput!, $skillLevelObjects: [EventSkillLevelsInsertInput!]!) {
  updateEventsByPk(pkColumns: {id: $eventId}, _set: $set) {
    id
  }
  deleteEventSkillLevels(where: {eventId: {_eq: $eventId}}) {
    affectedRows
  }
  insertEventSkillLevels(objects: $skillLevelObjects) {
    affectedRows
  }
}
    `;
export type UpdateProgramEventMutationFn = Apollo.MutationFunction<UpdateProgramEventMutation, UpdateProgramEventMutationVariables>;

/**
 * __useUpdateProgramEventMutation__
 *
 * To run a mutation, you first call `useUpdateProgramEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramEventMutation, { data, loading, error }] = useUpdateProgramEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      set: // value for 'set'
 *      skillLevelObjects: // value for 'skillLevelObjects'
 *   },
 * });
 */
export function useUpdateProgramEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramEventMutation, UpdateProgramEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramEventMutation, UpdateProgramEventMutationVariables>(UpdateProgramEventDocument, options);
      }
export type UpdateProgramEventMutationHookResult = ReturnType<typeof useUpdateProgramEventMutation>;
export type UpdateProgramEventMutationResult = Apollo.MutationResult<UpdateProgramEventMutation>;
export type UpdateProgramEventMutationOptions = Apollo.BaseMutationOptions<UpdateProgramEventMutation, UpdateProgramEventMutationVariables>;
export const DeleteProgramTemplateDocument = gql`
    mutation deleteProgramTemplate($id: uuid!, $deletedAt: timestamptz!) {
  updateLessonTemplatesByPk(pkColumns: {id: $id}, _set: {deletedAt: $deletedAt}) {
    id
  }
}
    `;
export type DeleteProgramTemplateMutationFn = Apollo.MutationFunction<DeleteProgramTemplateMutation, DeleteProgramTemplateMutationVariables>;

/**
 * __useDeleteProgramTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteProgramTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProgramTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProgramTemplateMutation, { data, loading, error }] = useDeleteProgramTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deletedAt: // value for 'deletedAt'
 *   },
 * });
 */
export function useDeleteProgramTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProgramTemplateMutation, DeleteProgramTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProgramTemplateMutation, DeleteProgramTemplateMutationVariables>(DeleteProgramTemplateDocument, options);
      }
export type DeleteProgramTemplateMutationHookResult = ReturnType<typeof useDeleteProgramTemplateMutation>;
export type DeleteProgramTemplateMutationResult = Apollo.MutationResult<DeleteProgramTemplateMutation>;
export type DeleteProgramTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteProgramTemplateMutation, DeleteProgramTemplateMutationVariables>;
export const SoftDeleteProgramEventDocument = gql`
    mutation softDeleteProgramEvent($id: uuid!) {
  updateEventsByPk(pkColumns: {id: $id}, _set: {deletedAt: "now()"}) {
    id
  }
}
    `;
export type SoftDeleteProgramEventMutationFn = Apollo.MutationFunction<SoftDeleteProgramEventMutation, SoftDeleteProgramEventMutationVariables>;

/**
 * __useSoftDeleteProgramEventMutation__
 *
 * To run a mutation, you first call `useSoftDeleteProgramEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteProgramEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteProgramEventMutation, { data, loading, error }] = useSoftDeleteProgramEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftDeleteProgramEventMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteProgramEventMutation, SoftDeleteProgramEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteProgramEventMutation, SoftDeleteProgramEventMutationVariables>(SoftDeleteProgramEventDocument, options);
      }
export type SoftDeleteProgramEventMutationHookResult = ReturnType<typeof useSoftDeleteProgramEventMutation>;
export type SoftDeleteProgramEventMutationResult = Apollo.MutationResult<SoftDeleteProgramEventMutation>;
export type SoftDeleteProgramEventMutationOptions = Apollo.BaseMutationOptions<SoftDeleteProgramEventMutation, SoftDeleteProgramEventMutationVariables>;
export const GetQuatroUpcomingClinicLessonsDocument = gql`
    query getQuatroUpcomingClinicLessons($limit: Int!, $offset: Int!, $ids: [uuid!]!) {
  lessons(
    where: {ownerProfile: {id: {_in: $ids}}, status: {_eq: ACTIVE}, startDateTime: {_gt: "now()"}, type: {_eq: CLINIC}}
    limit: $limit
    orderBy: {startDateTime: ASC}
    offset: $offset
  ) {
    ...lessonFields
  }
  lessonsAggregate(
    where: {ownerProfile: {isQuatroPickleballMember: {_eq: true}}, status: {_eq: ACTIVE}, startDateTime: {_gt: "now()"}, type: {_eq: CLINIC}}
  ) {
    aggregate {
      count
    }
  }
}
    ${LessonFieldsFragmentDoc}`;

/**
 * __useGetQuatroUpcomingClinicLessonsQuery__
 *
 * To run a query within a React component, call `useGetQuatroUpcomingClinicLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuatroUpcomingClinicLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuatroUpcomingClinicLessonsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetQuatroUpcomingClinicLessonsQuery(baseOptions: Apollo.QueryHookOptions<GetQuatroUpcomingClinicLessonsQuery, GetQuatroUpcomingClinicLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuatroUpcomingClinicLessonsQuery, GetQuatroUpcomingClinicLessonsQueryVariables>(GetQuatroUpcomingClinicLessonsDocument, options);
      }
export function useGetQuatroUpcomingClinicLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuatroUpcomingClinicLessonsQuery, GetQuatroUpcomingClinicLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuatroUpcomingClinicLessonsQuery, GetQuatroUpcomingClinicLessonsQueryVariables>(GetQuatroUpcomingClinicLessonsDocument, options);
        }
export type GetQuatroUpcomingClinicLessonsQueryHookResult = ReturnType<typeof useGetQuatroUpcomingClinicLessonsQuery>;
export type GetQuatroUpcomingClinicLessonsLazyQueryHookResult = ReturnType<typeof useGetQuatroUpcomingClinicLessonsLazyQuery>;
export type GetQuatroUpcomingClinicLessonsQueryResult = Apollo.QueryResult<GetQuatroUpcomingClinicLessonsQuery, GetQuatroUpcomingClinicLessonsQueryVariables>;
export const GetQuatroCoachesDocument = gql`
    query getQuatroCoaches($limit: Int = 1000, $offset: Int = 0, $ids: [uuid!]!) {
  userProfiles(
    where: {coachStatus: {_eq: "ACTIVE"}, isQuatroPickleballMember: {_eq: true}}
    limit: $limit
    offset: $offset
  ) {
    id
    fullName
    priceUnitAmountRemoteCoachDefault
    priceUnitAmountCoachDefault
    profileImageFileName
    profileImagePath
    profileImageProvider
    profileImageProviderUrl
    preferredName
    username
    defaultSport
    geometry
    stripeMerchantCurrency
    currencyCoachDefault
    coachAvailability {
      id
    }
    defaultCoachVenue {
      addressString
      id
    }
    defaultCoachCustomCourt {
      title
      id
      fullAddress
    }
    followersAggregate {
      aggregate {
        count
      }
    }
  }
  userProfilesAggregate(
    where: {coachStatus: {_eq: "ACTIVE"}, isQuatroPickleballMember: {_eq: true}, id: {_nin: $ids}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetQuatroCoachesQuery__
 *
 * To run a query within a React component, call `useGetQuatroCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuatroCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuatroCoachesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetQuatroCoachesQuery(baseOptions: Apollo.QueryHookOptions<GetQuatroCoachesQuery, GetQuatroCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuatroCoachesQuery, GetQuatroCoachesQueryVariables>(GetQuatroCoachesDocument, options);
      }
export function useGetQuatroCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuatroCoachesQuery, GetQuatroCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuatroCoachesQuery, GetQuatroCoachesQueryVariables>(GetQuatroCoachesDocument, options);
        }
export type GetQuatroCoachesQueryHookResult = ReturnType<typeof useGetQuatroCoachesQuery>;
export type GetQuatroCoachesLazyQueryHookResult = ReturnType<typeof useGetQuatroCoachesLazyQuery>;
export type GetQuatroCoachesQueryResult = Apollo.QueryResult<GetQuatroCoachesQuery, GetQuatroCoachesQueryVariables>;
export const GetQuatroCoachesByLocationDocument = gql`
    query getQuatroCoachesByLocation($limit: Int = 1000, $offset: Int = 0, $from: geography!, $distance: Float!) {
  userProfiles(
    where: {coachStatus: {_eq: "ACTIVE"}, isQuatroPickleballMember: {_eq: true}, geometry: {_stDWithin: {distance: $distance, from: $from}}}
    orderBy: {geometry: ASC}
    limit: $limit
    offset: $offset
  ) {
    id
    fullName
    priceUnitAmountRemoteCoachDefault
    priceUnitAmountCoachDefault
    profileImageFileName
    profileImagePath
    profileImageProvider
    profileImageProviderUrl
    preferredName
    username
    defaultSport
    geometry
    stripeMerchantCurrency
    currencyCoachDefault
    coachAvailability {
      id
    }
    defaultCoachVenue {
      addressString
      id
    }
    defaultCoachCustomCourt {
      title
      id
      fullAddress
    }
    followersAggregate {
      aggregate {
        count
      }
    }
  }
  userProfilesAggregate(
    where: {coachStatus: {_eq: "ACTIVE"}, isQuatroPickleballMember: {_eq: true}, geometry: {_stDWithin: {distance: $distance, from: $from}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetQuatroCoachesByLocationQuery__
 *
 * To run a query within a React component, call `useGetQuatroCoachesByLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuatroCoachesByLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuatroCoachesByLocationQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      from: // value for 'from'
 *      distance: // value for 'distance'
 *   },
 * });
 */
export function useGetQuatroCoachesByLocationQuery(baseOptions: Apollo.QueryHookOptions<GetQuatroCoachesByLocationQuery, GetQuatroCoachesByLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuatroCoachesByLocationQuery, GetQuatroCoachesByLocationQueryVariables>(GetQuatroCoachesByLocationDocument, options);
      }
export function useGetQuatroCoachesByLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuatroCoachesByLocationQuery, GetQuatroCoachesByLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuatroCoachesByLocationQuery, GetQuatroCoachesByLocationQueryVariables>(GetQuatroCoachesByLocationDocument, options);
        }
export type GetQuatroCoachesByLocationQueryHookResult = ReturnType<typeof useGetQuatroCoachesByLocationQuery>;
export type GetQuatroCoachesByLocationLazyQueryHookResult = ReturnType<typeof useGetQuatroCoachesByLocationLazyQuery>;
export type GetQuatroCoachesByLocationQueryResult = Apollo.QueryResult<GetQuatroCoachesByLocationQuery, GetQuatroCoachesByLocationQueryVariables>;
export const GetQuatroUpcomingClinicLessonsByLocationDocument = gql`
    query getQuatroUpcomingClinicLessonsByLocation($limit: Int!, $offset: Int!, $from: geography!, $distance: Float!, $ids: [uuid!]!) {
  lessons(
    where: {ownerProfile: {id: {_in: $ids}}, status: {_eq: ACTIVE}, startDateTime: {_gt: "now()"}, type: {_eq: CLINIC}, _or: [{venueId: {_isNull: true}}, {venue: {geometry: {_stDWithin: {distance: $distance, from: $from}}}}]}
    limit: $limit
    orderBy: {startDateTime: ASC}
    offset: $offset
  ) {
    ...lessonFields
  }
  lessonsAggregate(
    where: {ownerProfile: {isQuatroPickleballMember: {_eq: true}}, status: {_eq: ACTIVE}, startDateTime: {_gt: "now()"}, type: {_eq: CLINIC}, _or: [{venueId: {_isNull: true}}, {venue: {geometry: {_stDWithin: {distance: $distance, from: $from}}}}]}
  ) {
    aggregate {
      count
    }
  }
}
    ${LessonFieldsFragmentDoc}`;

/**
 * __useGetQuatroUpcomingClinicLessonsByLocationQuery__
 *
 * To run a query within a React component, call `useGetQuatroUpcomingClinicLessonsByLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuatroUpcomingClinicLessonsByLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuatroUpcomingClinicLessonsByLocationQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      from: // value for 'from'
 *      distance: // value for 'distance'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetQuatroUpcomingClinicLessonsByLocationQuery(baseOptions: Apollo.QueryHookOptions<GetQuatroUpcomingClinicLessonsByLocationQuery, GetQuatroUpcomingClinicLessonsByLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuatroUpcomingClinicLessonsByLocationQuery, GetQuatroUpcomingClinicLessonsByLocationQueryVariables>(GetQuatroUpcomingClinicLessonsByLocationDocument, options);
      }
export function useGetQuatroUpcomingClinicLessonsByLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuatroUpcomingClinicLessonsByLocationQuery, GetQuatroUpcomingClinicLessonsByLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuatroUpcomingClinicLessonsByLocationQuery, GetQuatroUpcomingClinicLessonsByLocationQueryVariables>(GetQuatroUpcomingClinicLessonsByLocationDocument, options);
        }
export type GetQuatroUpcomingClinicLessonsByLocationQueryHookResult = ReturnType<typeof useGetQuatroUpcomingClinicLessonsByLocationQuery>;
export type GetQuatroUpcomingClinicLessonsByLocationLazyQueryHookResult = ReturnType<typeof useGetQuatroUpcomingClinicLessonsByLocationLazyQuery>;
export type GetQuatroUpcomingClinicLessonsByLocationQueryResult = Apollo.QueryResult<GetQuatroUpcomingClinicLessonsByLocationQuery, GetQuatroUpcomingClinicLessonsByLocationQueryVariables>;
export const GetQuatroUpcomingRetreatLessonsDocument = gql`
    query getQuatroUpcomingRetreatLessons($limit: Int!, $offset: Int!, $ids: [uuid!]!) {
  lessons(
    where: {ownerProfile: {id: {_in: $ids}}, status: {_eq: ACTIVE}, startDateTime: {_gt: "now()"}, type: {_eq: RETREAT}}
    limit: $limit
    orderBy: {startDateTime: ASC}
    offset: $offset
  ) {
    ...lessonFields
  }
  lessonsAggregate(
    where: {ownerProfile: {id: {_in: $ids}}, status: {_eq: ACTIVE}, startDateTime: {_gt: "now()"}, type: {_eq: RETREAT}}
  ) {
    aggregate {
      count
    }
  }
}
    ${LessonFieldsFragmentDoc}`;

/**
 * __useGetQuatroUpcomingRetreatLessonsQuery__
 *
 * To run a query within a React component, call `useGetQuatroUpcomingRetreatLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuatroUpcomingRetreatLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuatroUpcomingRetreatLessonsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetQuatroUpcomingRetreatLessonsQuery(baseOptions: Apollo.QueryHookOptions<GetQuatroUpcomingRetreatLessonsQuery, GetQuatroUpcomingRetreatLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuatroUpcomingRetreatLessonsQuery, GetQuatroUpcomingRetreatLessonsQueryVariables>(GetQuatroUpcomingRetreatLessonsDocument, options);
      }
export function useGetQuatroUpcomingRetreatLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuatroUpcomingRetreatLessonsQuery, GetQuatroUpcomingRetreatLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuatroUpcomingRetreatLessonsQuery, GetQuatroUpcomingRetreatLessonsQueryVariables>(GetQuatroUpcomingRetreatLessonsDocument, options);
        }
export type GetQuatroUpcomingRetreatLessonsQueryHookResult = ReturnType<typeof useGetQuatroUpcomingRetreatLessonsQuery>;
export type GetQuatroUpcomingRetreatLessonsLazyQueryHookResult = ReturnType<typeof useGetQuatroUpcomingRetreatLessonsLazyQuery>;
export type GetQuatroUpcomingRetreatLessonsQueryResult = Apollo.QueryResult<GetQuatroUpcomingRetreatLessonsQuery, GetQuatroUpcomingRetreatLessonsQueryVariables>;
export const GetFoundingCoachesDocument = gql`
    query getFoundingCoaches($ids: [uuid!]!) {
  userProfiles(where: {id: {_in: $ids}, coachStatus: {_eq: "ACTIVE"}}) {
    id
    fullName
    priceUnitAmountRemoteCoachDefault
    priceUnitAmountCoachDefault
    profileImageFileName
    profileImagePath
    profileImageProvider
    profileImageProviderUrl
    preferredName
    username
    defaultSport
    geometry
    stripeMerchantCurrency
    currencyCoachDefault
    coachAvailability {
      id
    }
    defaultCoachVenue {
      addressString
      id
    }
    defaultCoachCustomCourt {
      title
      id
      fullAddress
    }
    followersAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetFoundingCoachesQuery__
 *
 * To run a query within a React component, call `useGetFoundingCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFoundingCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFoundingCoachesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetFoundingCoachesQuery(baseOptions: Apollo.QueryHookOptions<GetFoundingCoachesQuery, GetFoundingCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFoundingCoachesQuery, GetFoundingCoachesQueryVariables>(GetFoundingCoachesDocument, options);
      }
export function useGetFoundingCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFoundingCoachesQuery, GetFoundingCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFoundingCoachesQuery, GetFoundingCoachesQueryVariables>(GetFoundingCoachesDocument, options);
        }
export type GetFoundingCoachesQueryHookResult = ReturnType<typeof useGetFoundingCoachesQuery>;
export type GetFoundingCoachesLazyQueryHookResult = ReturnType<typeof useGetFoundingCoachesLazyQuery>;
export type GetFoundingCoachesQueryResult = Apollo.QueryResult<GetFoundingCoachesQuery, GetFoundingCoachesQueryVariables>;
export const GetCertifiedCoachesDocument = gql`
    query getCertifiedCoaches($ids: [uuid!]!) {
  userProfiles(
    where: {id: {_nin: $ids}, coachStatus: {_eq: "ACTIVE"}, isQuatroPickleballMember: {_eq: true}}
  ) {
    id
    fullName
    priceUnitAmountRemoteCoachDefault
    priceUnitAmountCoachDefault
    profileImageFileName
    profileImagePath
    profileImageProvider
    profileImageProviderUrl
    preferredName
    username
    defaultSport
    geometry
    stripeMerchantCurrency
    currencyCoachDefault
    coachAvailability {
      id
    }
    defaultCoachVenue {
      addressString
      id
    }
    defaultCoachCustomCourt {
      title
      id
      fullAddress
    }
    followersAggregate {
      aggregate {
        count
      }
    }
  }
  userProfilesAggregate(where: {id: {_nin: $ids}, coachStatus: {_eq: "ACTIVE"}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetCertifiedCoachesQuery__
 *
 * To run a query within a React component, call `useGetCertifiedCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertifiedCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertifiedCoachesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetCertifiedCoachesQuery(baseOptions: Apollo.QueryHookOptions<GetCertifiedCoachesQuery, GetCertifiedCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCertifiedCoachesQuery, GetCertifiedCoachesQueryVariables>(GetCertifiedCoachesDocument, options);
      }
export function useGetCertifiedCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCertifiedCoachesQuery, GetCertifiedCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCertifiedCoachesQuery, GetCertifiedCoachesQueryVariables>(GetCertifiedCoachesDocument, options);
        }
export type GetCertifiedCoachesQueryHookResult = ReturnType<typeof useGetCertifiedCoachesQuery>;
export type GetCertifiedCoachesLazyQueryHookResult = ReturnType<typeof useGetCertifiedCoachesLazyQuery>;
export type GetCertifiedCoachesQueryResult = Apollo.QueryResult<GetCertifiedCoachesQuery, GetCertifiedCoachesQueryVariables>;
export const GetCoachServicesStatsDocument = gql`
    query getCoachServicesStats($coachId: uuid!) {
  lessons(
    where: {ownerUserId: {_eq: $coachId}, orders: {status: {_eq: SUCCEEDED}}}
  ) {
    id
    orders {
      paidUnitAmount
    }
  }
  videoAnalysis(
    where: {reviewerUserId: {_eq: $coachId}, orders: {status: {_eq: SUCCEEDED}}}
  ) {
    id
    orders {
      id
      paidUnitAmount
    }
  }
  userContentBetaSubscriptions(where: {ownerUserId: {_eq: $coachId}}) {
    id
  }
}
    `;

/**
 * __useGetCoachServicesStatsQuery__
 *
 * To run a query within a React component, call `useGetCoachServicesStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachServicesStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachServicesStatsQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *   },
 * });
 */
export function useGetCoachServicesStatsQuery(baseOptions: Apollo.QueryHookOptions<GetCoachServicesStatsQuery, GetCoachServicesStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachServicesStatsQuery, GetCoachServicesStatsQueryVariables>(GetCoachServicesStatsDocument, options);
      }
export function useGetCoachServicesStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachServicesStatsQuery, GetCoachServicesStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachServicesStatsQuery, GetCoachServicesStatsQueryVariables>(GetCoachServicesStatsDocument, options);
        }
export type GetCoachServicesStatsQueryHookResult = ReturnType<typeof useGetCoachServicesStatsQuery>;
export type GetCoachServicesStatsLazyQueryHookResult = ReturnType<typeof useGetCoachServicesStatsLazyQuery>;
export type GetCoachServicesStatsQueryResult = Apollo.QueryResult<GetCoachServicesStatsQuery, GetCoachServicesStatsQueryVariables>;
export const UpdateUserOnCourtLessonServiceDocument = gql`
    mutation updateUserOnCourtLessonService($userId: uuid!, $objects: [CoachAvailabilityInsertInput!] = [], $priceUnitAmountCoachDefault: Int!, $coachExternalBookingUrl: String) {
  updateUsersByPk(
    pkColumns: {id: $userId}
    _set: {priceUnitAmountCoachDefault: $priceUnitAmountCoachDefault, coachExternalBookingUrl: $coachExternalBookingUrl}
  ) {
    id
    priceUnitAmountCoachDefault
    coachAvailability {
      id
      endTimeMinutes
      dayOfWeek
      startTimeMinutes
    }
  }
  deleteCoachAvailability(where: {userId: {_eq: $userId}}) {
    returning {
      id
      startTimeMinutes
      endTimeMinutes
      dayOfWeek
    }
  }
  insertCoachAvailability(
    objects: $objects
    onConflict: {constraint: coach_availability_pkey, updateColumns: [startTimeMinutes, endTimeMinutes]}
  ) {
    returning {
      id
      endTimeMinutes
      startTimeMinutes
      dayOfWeek
    }
  }
}
    `;
export type UpdateUserOnCourtLessonServiceMutationFn = Apollo.MutationFunction<UpdateUserOnCourtLessonServiceMutation, UpdateUserOnCourtLessonServiceMutationVariables>;

/**
 * __useUpdateUserOnCourtLessonServiceMutation__
 *
 * To run a mutation, you first call `useUpdateUserOnCourtLessonServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOnCourtLessonServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOnCourtLessonServiceMutation, { data, loading, error }] = useUpdateUserOnCourtLessonServiceMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      objects: // value for 'objects'
 *      priceUnitAmountCoachDefault: // value for 'priceUnitAmountCoachDefault'
 *      coachExternalBookingUrl: // value for 'coachExternalBookingUrl'
 *   },
 * });
 */
export function useUpdateUserOnCourtLessonServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserOnCourtLessonServiceMutation, UpdateUserOnCourtLessonServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserOnCourtLessonServiceMutation, UpdateUserOnCourtLessonServiceMutationVariables>(UpdateUserOnCourtLessonServiceDocument, options);
      }
export type UpdateUserOnCourtLessonServiceMutationHookResult = ReturnType<typeof useUpdateUserOnCourtLessonServiceMutation>;
export type UpdateUserOnCourtLessonServiceMutationResult = Apollo.MutationResult<UpdateUserOnCourtLessonServiceMutation>;
export type UpdateUserOnCourtLessonServiceMutationOptions = Apollo.BaseMutationOptions<UpdateUserOnCourtLessonServiceMutation, UpdateUserOnCourtLessonServiceMutationVariables>;
export const UpdateUserRemoteLessonServiceDocument = gql`
    mutation updateUserRemoteLessonService($userId: uuid!, $priceUnitAmountRemoteCoachDefault: Int!) {
  updateUsersByPk(
    pkColumns: {id: $userId}
    _set: {priceUnitAmountRemoteCoachDefault: $priceUnitAmountRemoteCoachDefault}
  ) {
    id
    priceUnitAmountRemoteCoachDefault
  }
}
    `;
export type UpdateUserRemoteLessonServiceMutationFn = Apollo.MutationFunction<UpdateUserRemoteLessonServiceMutation, UpdateUserRemoteLessonServiceMutationVariables>;

/**
 * __useUpdateUserRemoteLessonServiceMutation__
 *
 * To run a mutation, you first call `useUpdateUserRemoteLessonServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRemoteLessonServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRemoteLessonServiceMutation, { data, loading, error }] = useUpdateUserRemoteLessonServiceMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      priceUnitAmountRemoteCoachDefault: // value for 'priceUnitAmountRemoteCoachDefault'
 *   },
 * });
 */
export function useUpdateUserRemoteLessonServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRemoteLessonServiceMutation, UpdateUserRemoteLessonServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRemoteLessonServiceMutation, UpdateUserRemoteLessonServiceMutationVariables>(UpdateUserRemoteLessonServiceDocument, options);
      }
export type UpdateUserRemoteLessonServiceMutationHookResult = ReturnType<typeof useUpdateUserRemoteLessonServiceMutation>;
export type UpdateUserRemoteLessonServiceMutationResult = Apollo.MutationResult<UpdateUserRemoteLessonServiceMutation>;
export type UpdateUserRemoteLessonServiceMutationOptions = Apollo.BaseMutationOptions<UpdateUserRemoteLessonServiceMutation, UpdateUserRemoteLessonServiceMutationVariables>;
export const DeleteCoachPremiumContentDocument = gql`
    mutation deleteCoachPremiumContent($id: uuid!) {
  deleteUserContentFilesByPk(id: $id) {
    id
  }
}
    `;
export type DeleteCoachPremiumContentMutationFn = Apollo.MutationFunction<DeleteCoachPremiumContentMutation, DeleteCoachPremiumContentMutationVariables>;

/**
 * __useDeleteCoachPremiumContentMutation__
 *
 * To run a mutation, you first call `useDeleteCoachPremiumContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoachPremiumContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoachPremiumContentMutation, { data, loading, error }] = useDeleteCoachPremiumContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCoachPremiumContentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCoachPremiumContentMutation, DeleteCoachPremiumContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCoachPremiumContentMutation, DeleteCoachPremiumContentMutationVariables>(DeleteCoachPremiumContentDocument, options);
      }
export type DeleteCoachPremiumContentMutationHookResult = ReturnType<typeof useDeleteCoachPremiumContentMutation>;
export type DeleteCoachPremiumContentMutationResult = Apollo.MutationResult<DeleteCoachPremiumContentMutation>;
export type DeleteCoachPremiumContentMutationOptions = Apollo.BaseMutationOptions<DeleteCoachPremiumContentMutation, DeleteCoachPremiumContentMutationVariables>;
export const GetMyPastCourtBookingsDocument = gql`
    query GetMyPastCourtBookings($before: timestamptz!, $statuses: [PartnerBookingOrderStatusesEnum!]!) {
  partnerBookingOrders(
    where: {startAt: {_lt: $before}, status: {_in: $statuses}}
    orderBy: {startAt: DESC}
  ) {
    id
    status
    startAt
    endAt
    timezone
    venue {
      id
      title
      slug
      timezone
      addressString
      images(where: {isVisible: {_eq: true}}, limit: 1) {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useGetMyPastCourtBookingsQuery__
 *
 * To run a query within a React component, call `useGetMyPastCourtBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPastCourtBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPastCourtBookingsQuery({
 *   variables: {
 *      before: // value for 'before'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetMyPastCourtBookingsQuery(baseOptions: Apollo.QueryHookOptions<GetMyPastCourtBookingsQuery, GetMyPastCourtBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPastCourtBookingsQuery, GetMyPastCourtBookingsQueryVariables>(GetMyPastCourtBookingsDocument, options);
      }
export function useGetMyPastCourtBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPastCourtBookingsQuery, GetMyPastCourtBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPastCourtBookingsQuery, GetMyPastCourtBookingsQueryVariables>(GetMyPastCourtBookingsDocument, options);
        }
export type GetMyPastCourtBookingsQueryHookResult = ReturnType<typeof useGetMyPastCourtBookingsQuery>;
export type GetMyPastCourtBookingsLazyQueryHookResult = ReturnType<typeof useGetMyPastCourtBookingsLazyQuery>;
export type GetMyPastCourtBookingsQueryResult = Apollo.QueryResult<GetMyPastCourtBookingsQuery, GetMyPastCourtBookingsQueryVariables>;
export const GetEventCouponsDocument = gql`
    query getEventCoupons($eventId: uuid!) {
  eventCoupons(
    where: {eventId: {_eq: $eventId}, deletedAt: {_isNull: true}}
    orderBy: {createdAt: ASC}
  ) {
    id
    name
    code
    source
    couponType
    percentOff
    amountOff
    fixedPrice
    isAutoApply
    validFrom
    validUntil
    tierPriority
    maxRedemptions
    isActive
    couponGroups {
      id
      eventGroupId
    }
    redemptionsAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetEventCouponsQuery__
 *
 * To run a query within a React component, call `useGetEventCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventCouponsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventCouponsQuery(baseOptions: Apollo.QueryHookOptions<GetEventCouponsQuery, GetEventCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventCouponsQuery, GetEventCouponsQueryVariables>(GetEventCouponsDocument, options);
      }
export function useGetEventCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventCouponsQuery, GetEventCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventCouponsQuery, GetEventCouponsQueryVariables>(GetEventCouponsDocument, options);
        }
export type GetEventCouponsQueryHookResult = ReturnType<typeof useGetEventCouponsQuery>;
export type GetEventCouponsLazyQueryHookResult = ReturnType<typeof useGetEventCouponsLazyQuery>;
export type GetEventCouponsQueryResult = Apollo.QueryResult<GetEventCouponsQuery, GetEventCouponsQueryVariables>;
export const GetCheckInParticipantsDocument = gql`
    query getCheckInParticipants($eventId: uuid!, $search: String!) {
  eventGroupRegistrations(
    where: {deletedAt: {_isNull: true}, group: {eventId: {_eq: $eventId}, deletedAt: {_isNull: true}}, userProfile: {fullName: {_ilike: $search}}}
    distinctOn: [userId]
    limit: 20
  ) {
    id
    userId
    checkedInAt
    group {
      id
      title
    }
    userProfile {
      id
      fullName
      preferredName
      profileImageFileName
      profileImagePath
      profileImageProvider
      profileImageProviderUrl
    }
  }
}
    `;

/**
 * __useGetCheckInParticipantsQuery__
 *
 * To run a query within a React component, call `useGetCheckInParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckInParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckInParticipantsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCheckInParticipantsQuery(baseOptions: Apollo.QueryHookOptions<GetCheckInParticipantsQuery, GetCheckInParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckInParticipantsQuery, GetCheckInParticipantsQueryVariables>(GetCheckInParticipantsDocument, options);
      }
export function useGetCheckInParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckInParticipantsQuery, GetCheckInParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckInParticipantsQuery, GetCheckInParticipantsQueryVariables>(GetCheckInParticipantsDocument, options);
        }
export type GetCheckInParticipantsQueryHookResult = ReturnType<typeof useGetCheckInParticipantsQuery>;
export type GetCheckInParticipantsLazyQueryHookResult = ReturnType<typeof useGetCheckInParticipantsLazyQuery>;
export type GetCheckInParticipantsQueryResult = Apollo.QueryResult<GetCheckInParticipantsQuery, GetCheckInParticipantsQueryVariables>;
export const GetEventDetailsDocument = gql`
    query getEventDetails($id: uuid!, $limit: Int = 12) {
  eventsByPk(id: $id) {
    addressString
    cityId
    coverImageFileName
    coverImagePath
    coverImageUrl
    currency
    longitude
    latitude
    createdAt
    description
    displayLocation
    endDate
    endDateTime
    externalUrl
    geometry
    hasPrizes
    id
    isExternal
    isShowPlayersGoing
    organizerImageUrl
    organizerImagePath
    locale
    isSanctioned
    privacy
    prizeDescription
    publishedAt
    canceledAt
    cancelReason
    registrationClosedAt
    registrationDeadlineDate
    registrationDeadlineDateTime
    registrationPriceUnitAmount
    registrationOpenDate
    registrationOpenDateTime
    isRatingRequired
    slug
    scoringFormat
    sport
    startDate
    startDateTime
    status
    title
    type
    isRfx
    timezoneName
    timezoneOffsetMinutes
    timezoneAbbreviation
    sourceRegistrationCount
    sourceOrganizerTitle
    groupFormat
    isQuickCreate
    paymentFulfillmentChannel
    isVairRequired
    city {
      id
      name
      slug
      countrySubdivision {
        id
        name
        slug
        code
        country {
          id
          name
          slug
        }
      }
    }
    venue {
      id
      title
      slug
      pickleballLines
      pickleballNets
      longitude
      latitude
      geometry
      addressString
      outdoorCourtCount
      indoorCourtCount
      timezone
      images {
        id
        path
        url
      }
      courtSurfaces {
        id
        courtSurface
      }
    }
    pickleballRatingScale {
      id
      maximum
      minimum
      name
      shortName
    }
    hostUserProfile {
      id
      fullName
      profileImagePath
      profileImageProviderUrl
      preferredName
      profileImageFileName
      profileImageProvider
      stripeMerchantDetailsSubmitted
    }
    faqs {
      id
      question
      answer
    }
    ballCustomName
    ballType
    registrations(limit: $limit, where: {deletedAt: {_isNull: true}}) {
      id
      userProfile {
        id
        fullName
        username
        preferredName
        profileImageFileName
        profileImagePath
        profileImageProvider
        profileImageProviderUrl
      }
    }
    registrationsAggregate(where: {deletedAt: {_isNull: true}}) {
      aggregate {
        count
      }
    }
    sponsors(where: {deletedAt: {_isNull: true}}) {
      id
      name
      imageUrl
      imagePath
      imageProvider
      imageProviderUrl
      imageHost
      isTitleSponsor
      categoryName
    }
    groups {
      id
      gender
      gamesPerMatch
      formatCustomName
      format
      endsAt
      timeSlots(where: {deletedAt: {_isNull: true}}, orderBy: {startsAt: ASC}) {
        id
        startsAt
        endsAt
      }
      maximumAge
      maximumRating
      minimumNumberOfGames
      minimumAge
      minimumRating
      priceUnitAmount
      scoringFormat
      startsAt
      teamLimit
      teamType
      title
      totalPoints
      winBy
      isAgeRestricted
      isWheelchair
      isVairVairifiedRequired
      teams(where: {deletedAt: {_isNull: true}}) {
        id
        members(where: {deletedAt: {_isNull: true}}) {
          id
          userId
          userProfile {
            id
            fullName
            preferredName
            profileImageFileName
            profileImagePath
            profileImageProvider
            profileImageProviderUrl
          }
        }
      }
      registrations(where: {deletedAt: {_isNull: true}}) {
        id
        userId
        userProfile {
          id
          preferredName
          profileImageFileName
          profileImagePath
          profileImageProvider
          profileImageProviderUrl
        }
      }
      sequences(where: {deletedAt: {_isNull: true}}) {
        id
        isSequenceComplete
        nextSequenceId
      }
    }
  }
}
    `;

/**
 * __useGetEventDetailsQuery__
 *
 * To run a query within a React component, call `useGetEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetEventDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetEventDetailsQuery, GetEventDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventDetailsQuery, GetEventDetailsQueryVariables>(GetEventDetailsDocument, options);
      }
export function useGetEventDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventDetailsQuery, GetEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventDetailsQuery, GetEventDetailsQueryVariables>(GetEventDetailsDocument, options);
        }
export type GetEventDetailsQueryHookResult = ReturnType<typeof useGetEventDetailsQuery>;
export type GetEventDetailsLazyQueryHookResult = ReturnType<typeof useGetEventDetailsLazyQuery>;
export type GetEventDetailsQueryResult = Apollo.QueryResult<GetEventDetailsQuery, GetEventDetailsQueryVariables>;
export const GetUserEventRegistrationDocument = gql`
    query getUserEventRegistration($eventId: uuid!, $userId: uuid!) {
  eventRegistrations(
    where: {eventId: {_eq: $eventId}, userId: {_eq: $userId}, deletedAt: {_isNull: true}}
  ) {
    id
  }
  eventGroupRegistrations(
    where: {userId: {_eq: $userId}, group: {eventId: {_eq: $eventId}}}
  ) {
    id
    status
    group {
      id
      title
      format
      formatCustomName
      maximumAge
      maximumRating
      minimumAge
      minimumNumberOfGames
      minimumRating
      teamType
      teams(where: {members: {userId: {_eq: $userId}}}) {
        members {
          userId
          id
          status
          userProfile {
            id
            fullName
            preferredName
            profileImageFileName
            profileImagePath
            profileImageProvider
            profileImageProviderUrl
          }
        }
        id
      }
    }
    invitations(where: {senderUserId: {_eq: $userId}, deletedAt: {_isNull: true}}) {
      id
      invitationEmail
      invitationType
      status
      invitedUserProfile {
        id
        fullName
        preferredName
      }
    }
  }
  receivedPartnerRequests: eventInvitations(
    where: {invitedUserId: {_eq: $userId}, invitationType: {_eq: PARTNER_REQUEST}, status: {_eq: PENDING}, deletedAt: {_isNull: true}, group: {eventId: {_eq: $eventId}}}
  ) {
    id
    groupId
    groupRegistrationId
    senderUserId
    senderUserProfile {
      id
      fullName
      preferredName
    }
  }
}
    `;

/**
 * __useGetUserEventRegistrationQuery__
 *
 * To run a query within a React component, call `useGetUserEventRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEventRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEventRegistrationQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserEventRegistrationQuery(baseOptions: Apollo.QueryHookOptions<GetUserEventRegistrationQuery, GetUserEventRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEventRegistrationQuery, GetUserEventRegistrationQueryVariables>(GetUserEventRegistrationDocument, options);
      }
export function useGetUserEventRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEventRegistrationQuery, GetUserEventRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEventRegistrationQuery, GetUserEventRegistrationQueryVariables>(GetUserEventRegistrationDocument, options);
        }
export type GetUserEventRegistrationQueryHookResult = ReturnType<typeof useGetUserEventRegistrationQuery>;
export type GetUserEventRegistrationLazyQueryHookResult = ReturnType<typeof useGetUserEventRegistrationLazyQuery>;
export type GetUserEventRegistrationQueryResult = Apollo.QueryResult<GetUserEventRegistrationQuery, GetUserEventRegistrationQueryVariables>;
export const GetEventInvitationForRegistrationDocument = gql`
    query getEventInvitationForRegistration($id: uuid!) {
  eventInvitationsByPk(id: $id) {
    id
    groupId
    status
    deletedAt
  }
}
    `;

/**
 * __useGetEventInvitationForRegistrationQuery__
 *
 * To run a query within a React component, call `useGetEventInvitationForRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventInvitationForRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventInvitationForRegistrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventInvitationForRegistrationQuery(baseOptions: Apollo.QueryHookOptions<GetEventInvitationForRegistrationQuery, GetEventInvitationForRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventInvitationForRegistrationQuery, GetEventInvitationForRegistrationQueryVariables>(GetEventInvitationForRegistrationDocument, options);
      }
export function useGetEventInvitationForRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventInvitationForRegistrationQuery, GetEventInvitationForRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventInvitationForRegistrationQuery, GetEventInvitationForRegistrationQueryVariables>(GetEventInvitationForRegistrationDocument, options);
        }
export type GetEventInvitationForRegistrationQueryHookResult = ReturnType<typeof useGetEventInvitationForRegistrationQuery>;
export type GetEventInvitationForRegistrationLazyQueryHookResult = ReturnType<typeof useGetEventInvitationForRegistrationLazyQuery>;
export type GetEventInvitationForRegistrationQueryResult = Apollo.QueryResult<GetEventInvitationForRegistrationQuery, GetEventInvitationForRegistrationQueryVariables>;
export const GetEventTeamInvitationByIdDocument = gql`
    query getEventTeamInvitationById($id: uuid!) {
  eventTeamsByPk(id: $id) {
    id
    groupId
    group {
      id
    }
    members {
      id
      userProfile {
        id
        fullName
        preferredName
        profileImageFileName
        profileImagePath
        profileImageProvider
        profileImageProviderUrl
      }
    }
  }
}
    `;

/**
 * __useGetEventTeamInvitationByIdQuery__
 *
 * To run a query within a React component, call `useGetEventTeamInvitationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventTeamInvitationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventTeamInvitationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventTeamInvitationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetEventTeamInvitationByIdQuery, GetEventTeamInvitationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventTeamInvitationByIdQuery, GetEventTeamInvitationByIdQueryVariables>(GetEventTeamInvitationByIdDocument, options);
      }
export function useGetEventTeamInvitationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventTeamInvitationByIdQuery, GetEventTeamInvitationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventTeamInvitationByIdQuery, GetEventTeamInvitationByIdQueryVariables>(GetEventTeamInvitationByIdDocument, options);
        }
export type GetEventTeamInvitationByIdQueryHookResult = ReturnType<typeof useGetEventTeamInvitationByIdQuery>;
export type GetEventTeamInvitationByIdLazyQueryHookResult = ReturnType<typeof useGetEventTeamInvitationByIdLazyQuery>;
export type GetEventTeamInvitationByIdQueryResult = Apollo.QueryResult<GetEventTeamInvitationByIdQuery, GetEventTeamInvitationByIdQueryVariables>;
export const GetVenueForEventByIdDocument = gql`
    query getVenueForEventById($id: uuid!) {
  venuesByPk(id: $id) {
    id
    geometry
    addressString
    timezone
    title
    images(limit: 1) {
      id
      path
      url
    }
    city {
      id
      name
      countrySubdivision {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetVenueForEventByIdQuery__
 *
 * To run a query within a React component, call `useGetVenueForEventByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenueForEventByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenueForEventByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVenueForEventByIdQuery(baseOptions: Apollo.QueryHookOptions<GetVenueForEventByIdQuery, GetVenueForEventByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenueForEventByIdQuery, GetVenueForEventByIdQueryVariables>(GetVenueForEventByIdDocument, options);
      }
export function useGetVenueForEventByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenueForEventByIdQuery, GetVenueForEventByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenueForEventByIdQuery, GetVenueForEventByIdQueryVariables>(GetVenueForEventByIdDocument, options);
        }
export type GetVenueForEventByIdQueryHookResult = ReturnType<typeof useGetVenueForEventByIdQuery>;
export type GetVenueForEventByIdLazyQueryHookResult = ReturnType<typeof useGetVenueForEventByIdLazyQuery>;
export type GetVenueForEventByIdQueryResult = Apollo.QueryResult<GetVenueForEventByIdQuery, GetVenueForEventByIdQueryVariables>;
export const GetEventForBuilderByIdDocument = gql`
    query getEventForBuilderById($id: uuid!) {
  eventsByPk(id: $id) {
    addressString
    archivedAt
    ballCustomName
    ballType
    cancelReason
    canceledAt
    createdAt
    cityId
    cityString
    countryString
    coverImageFileName
    coverImageFileType
    coverImageHost
    coverImageOriginalFileName
    coverImagePath
    coverImageProvider
    coverImageProviderUrl
    coverImageUrl
    currency
    createdAt
    description
    displayLocation
    endDate
    endDateTime
    isQuickCreate
    paymentFulfillmentChannel
    faqs {
      id
      question
      answer
      createdAt
    }
    geometry
    groupFormat
    groups(where: {deletedAt: {_isNull: true}}) {
      id
      bracketRankingMechanism
      createdAt
      desiredNumberOfPools
      endsAt
      format
      formatCustomName
      gamesPerMatch
      gender
      maximumAge
      maximumRating
      minimumAge
      minimumNumberOfGames
      minimumRating
      numberOfEliminationTeams
      numberOfEstimatedCourts
      priceUnitAmount
      scoringFormat
      startsAt
      teamLimit
      teamType
      title
      totalPoints
      winBy
      isAgeRestricted
      isRatingRequired
      isVairVairifiedRequired
      isWheelchair
      isMoneyBall
      moneyBallRewards
      timeSlots(where: {deletedAt: {_isNull: true}}, orderBy: {startsAt: ASC}) {
        id
        startsAt
        endsAt
      }
    }
    hasPrizes
    hostUserId
    hostUserProfile {
      stripeMerchantCurrency
      id
    }
    id
    isRatingRequired
    isSanctioned
    isVairRequired
    latitude
    isShowPlayersGoing
    isShowCourtAssignments
    locale
    longitude
    organizerImageFileName
    organizerImageHost
    organizerImageFileType
    organizerImageOriginalFileName
    organizerImagePath
    organizerImageProvider
    organizerImageProviderUrl
    organizerImageUrl
    pickleballRatingScaleId
    pickleballRatingScale {
      id
      maximum
      minimum
      name
      order
      shortName
    }
    privacy
    prizeDescription
    publishedAt
    regionString
    registrationDeadlineDate
    registrationClosedAt
    registrationDeadlineDateTime
    registrationOpenDate
    registrationOpenDateTime
    registrationPriceUnitAmount
    scoringFormat
    showInPublicDate
    showInPublicDateTime
    slug
    sport
    startDate
    startDateTime
    status
    streetPrimaryString
    streetSecondaryString
    tennisRatingScaleId
    tennisRatingScale {
      id
      maximum
      minimum
      name
      order
      shortName
    }
    timezoneAbbreviation
    timezoneName
    timezoneOffsetMinutes
    title
    type
    zipcodeString
    venueId
    venue {
      id
      title
      geometry
      latitude
      longitude
      timezone
      slug
      pickleballLines
      addressString
      accessType
      indoorCourtCount
      outdoorCourtCount
      pickleballNets
      images {
        id
        fileName
        url
        path
      }
      city {
        id
        name
        countrySubdivision {
          id
          name
        }
      }
      courtSurfaces {
        id
        courtSurface
      }
    }
    sponsors {
      id
      categoryName
      createdAt
      imageFileName
      imageFileType
      imageHost
      imagePath
      imageProvider
      imageProviderUrl
      imageUrl
      imageOriginalFileName
      name
      isTitleSponsor
    }
  }
}
    `;

/**
 * __useGetEventForBuilderByIdQuery__
 *
 * To run a query within a React component, call `useGetEventForBuilderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventForBuilderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventForBuilderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventForBuilderByIdQuery(baseOptions: Apollo.QueryHookOptions<GetEventForBuilderByIdQuery, GetEventForBuilderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventForBuilderByIdQuery, GetEventForBuilderByIdQueryVariables>(GetEventForBuilderByIdDocument, options);
      }
export function useGetEventForBuilderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventForBuilderByIdQuery, GetEventForBuilderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventForBuilderByIdQuery, GetEventForBuilderByIdQueryVariables>(GetEventForBuilderByIdDocument, options);
        }
export type GetEventForBuilderByIdQueryHookResult = ReturnType<typeof useGetEventForBuilderByIdQuery>;
export type GetEventForBuilderByIdLazyQueryHookResult = ReturnType<typeof useGetEventForBuilderByIdLazyQuery>;
export type GetEventForBuilderByIdQueryResult = Apollo.QueryResult<GetEventForBuilderByIdQuery, GetEventForBuilderByIdQueryVariables>;
export const InsertDraftEventDocument = gql`
    mutation insertDraftEvent($object: EventsInsertInput!) {
  insertEventsOne(object: $object) {
    addressString
    archivedAt
    ballCustomName
    ballType
    cancelReason
    canceledAt
    cityId
    cityString
    countryString
    coverImageFileName
    coverImageFileType
    coverImageHost
    coverImageOriginalFileName
    coverImagePath
    coverImageProvider
    coverImageProviderUrl
    communityGroupId
    coverImageUrl
    currency
    createdAt
    description
    displayLocation
    endDate
    endDateTime
    externalUrl
    isExternal
    isQuickCreate
    faqs {
      id
      question
      answer
      createdAt
    }
    geometry
    groupFormat
    groups(where: {deletedAt: {_isNull: true}}) {
      id
      bracketRankingMechanism
      createdAt
      desiredNumberOfPools
      endsAt
      format
      formatCustomName
      gamesPerMatch
      gender
      maximumAge
      maximumRating
      minimumAge
      minimumNumberOfGames
      minimumRating
      numberOfEliminationTeams
      numberOfEstimatedCourts
      priceUnitAmount
      scoringFormat
      startsAt
      teamLimit
      teamType
      title
      totalPoints
      winBy
      isAgeRestricted
      isRatingRequired
      isVairVairifiedRequired
      isWheelchair
      isMoneyBall
      moneyBallRewards
      timeSlots(where: {deletedAt: {_isNull: true}}, orderBy: {startsAt: ASC}) {
        id
        startsAt
        endsAt
      }
    }
    hasPrizes
    hostUserId
    id
    isRatingRequired
    paymentFulfillmentChannel
    isSanctioned
    isVairRequired
    latitude
    isShowPlayersGoing
    isShowCourtAssignments
    locale
    longitude
    organizerImageFileName
    organizerImageHost
    organizerImageFileType
    organizerImageOriginalFileName
    organizerImagePath
    organizerImageProvider
    organizerImageProviderUrl
    organizerImageUrl
    pickleballRatingScaleId
    pickleballRatingScale {
      id
      maximum
      minimum
      name
      order
      shortName
    }
    privacy
    prizeDescription
    publishedAt
    regionString
    registrationDeadlineDate
    registrationClosedAt
    registrationDeadlineDateTime
    registrationOpenDate
    registrationOpenDateTime
    registrationPriceUnitAmount
    scoringFormat
    showInPublicDate
    showInPublicDateTime
    slug
    sport
    startDate
    startDateTime
    status
    streetPrimaryString
    streetSecondaryString
    tennisRatingScaleId
    tennisRatingScale {
      id
      maximum
      minimum
      name
      order
      shortName
    }
    timezoneAbbreviation
    timezoneName
    timezoneOffsetMinutes
    title
    type
    zipcodeString
    numberOfCourts
    addressString
    venueId
    venue {
      id
      title
      geometry
      latitude
      longitude
      timezone
      slug
      pickleballLines
      addressString
      accessType
      indoorCourtCount
      outdoorCourtCount
      pickleballNets
      images {
        id
        fileName
        url
        path
      }
      city {
        id
        name
        countrySubdivision {
          id
          name
        }
      }
      courtSurfaces {
        id
        courtSurface
      }
    }
    sponsors {
      id
      categoryName
      createdAt
      imageFileName
      imageFileType
      imageHost
      imagePath
      imageProvider
      imageProviderUrl
      imageUrl
      imageOriginalFileName
      name
      isTitleSponsor
    }
  }
}
    `;
export type InsertDraftEventMutationFn = Apollo.MutationFunction<InsertDraftEventMutation, InsertDraftEventMutationVariables>;

/**
 * __useInsertDraftEventMutation__
 *
 * To run a mutation, you first call `useInsertDraftEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertDraftEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertDraftEventMutation, { data, loading, error }] = useInsertDraftEventMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertDraftEventMutation(baseOptions?: Apollo.MutationHookOptions<InsertDraftEventMutation, InsertDraftEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertDraftEventMutation, InsertDraftEventMutationVariables>(InsertDraftEventDocument, options);
      }
export type InsertDraftEventMutationHookResult = ReturnType<typeof useInsertDraftEventMutation>;
export type InsertDraftEventMutationResult = Apollo.MutationResult<InsertDraftEventMutation>;
export type InsertDraftEventMutationOptions = Apollo.BaseMutationOptions<InsertDraftEventMutation, InsertDraftEventMutationVariables>;
export const InsertEventGroupDocument = gql`
    mutation insertEventGroup($object: EventGroupsInsertInput!) {
  insertEventGroupsOne(object: $object) {
    id
    bracketRankingMechanism
    createdAt
    desiredNumberOfPools
    endsAt
    format
    formatCustomName
    gamesPerMatch
    gender
    maximumAge
    maximumRating
    minimumAge
    minimumNumberOfGames
    minimumRating
    numberOfEliminationTeams
    numberOfEstimatedCourts
    priceUnitAmount
    scoringFormat
    startsAt
    teamLimit
    teamType
    title
    totalPoints
    winBy
    isAgeRestricted
    isRatingRequired
    isVairVairifiedRequired
    isWheelchair
    isMoneyBall
    moneyBallRewards
  }
}
    `;
export type InsertEventGroupMutationFn = Apollo.MutationFunction<InsertEventGroupMutation, InsertEventGroupMutationVariables>;

/**
 * __useInsertEventGroupMutation__
 *
 * To run a mutation, you first call `useInsertEventGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertEventGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertEventGroupMutation, { data, loading, error }] = useInsertEventGroupMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertEventGroupMutation(baseOptions?: Apollo.MutationHookOptions<InsertEventGroupMutation, InsertEventGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertEventGroupMutation, InsertEventGroupMutationVariables>(InsertEventGroupDocument, options);
      }
export type InsertEventGroupMutationHookResult = ReturnType<typeof useInsertEventGroupMutation>;
export type InsertEventGroupMutationResult = Apollo.MutationResult<InsertEventGroupMutation>;
export type InsertEventGroupMutationOptions = Apollo.BaseMutationOptions<InsertEventGroupMutation, InsertEventGroupMutationVariables>;
export const InsertEventGroupTimeSlotsDocument = gql`
    mutation insertEventGroupTimeSlots($objects: [EventGroupTimeSlotsInsertInput!]!) {
  insertEventGroupTimeSlots(objects: $objects) {
    returning {
      id
    }
  }
}
    `;
export type InsertEventGroupTimeSlotsMutationFn = Apollo.MutationFunction<InsertEventGroupTimeSlotsMutation, InsertEventGroupTimeSlotsMutationVariables>;

/**
 * __useInsertEventGroupTimeSlotsMutation__
 *
 * To run a mutation, you first call `useInsertEventGroupTimeSlotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertEventGroupTimeSlotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertEventGroupTimeSlotsMutation, { data, loading, error }] = useInsertEventGroupTimeSlotsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertEventGroupTimeSlotsMutation(baseOptions?: Apollo.MutationHookOptions<InsertEventGroupTimeSlotsMutation, InsertEventGroupTimeSlotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertEventGroupTimeSlotsMutation, InsertEventGroupTimeSlotsMutationVariables>(InsertEventGroupTimeSlotsDocument, options);
      }
export type InsertEventGroupTimeSlotsMutationHookResult = ReturnType<typeof useInsertEventGroupTimeSlotsMutation>;
export type InsertEventGroupTimeSlotsMutationResult = Apollo.MutationResult<InsertEventGroupTimeSlotsMutation>;
export type InsertEventGroupTimeSlotsMutationOptions = Apollo.BaseMutationOptions<InsertEventGroupTimeSlotsMutation, InsertEventGroupTimeSlotsMutationVariables>;
export const DeleteEventGroupTimeSlotsDocument = gql`
    mutation deleteEventGroupTimeSlots($groupId: uuid!) {
  deleteEventGroupTimeSlots(where: {groupId: {_eq: $groupId}}) {
    affectedRows
  }
}
    `;
export type DeleteEventGroupTimeSlotsMutationFn = Apollo.MutationFunction<DeleteEventGroupTimeSlotsMutation, DeleteEventGroupTimeSlotsMutationVariables>;

/**
 * __useDeleteEventGroupTimeSlotsMutation__
 *
 * To run a mutation, you first call `useDeleteEventGroupTimeSlotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventGroupTimeSlotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventGroupTimeSlotsMutation, { data, loading, error }] = useDeleteEventGroupTimeSlotsMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteEventGroupTimeSlotsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventGroupTimeSlotsMutation, DeleteEventGroupTimeSlotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventGroupTimeSlotsMutation, DeleteEventGroupTimeSlotsMutationVariables>(DeleteEventGroupTimeSlotsDocument, options);
      }
export type DeleteEventGroupTimeSlotsMutationHookResult = ReturnType<typeof useDeleteEventGroupTimeSlotsMutation>;
export type DeleteEventGroupTimeSlotsMutationResult = Apollo.MutationResult<DeleteEventGroupTimeSlotsMutation>;
export type DeleteEventGroupTimeSlotsMutationOptions = Apollo.BaseMutationOptions<DeleteEventGroupTimeSlotsMutation, DeleteEventGroupTimeSlotsMutationVariables>;
export const UpdateEventByIdDocument = gql`
    mutation updateEventById($id: uuid!, $_set: EventsSetInput = {}, $eventFaqObjects: [EventFaqsInsertInput!] = [], $eventSponsorObjects: [EventSponsorsInsertInput!] = []) {
  deleteEventFaqs(where: {eventId: {_eq: $id}}) {
    affectedRows
  }
  insertEventFaqs(objects: $eventFaqObjects) {
    affectedRows
  }
  deleteEventSponsors(where: {eventId: {_eq: $id}}) {
    affectedRows
  }
  insertEventSponsors(objects: $eventSponsorObjects) {
    affectedRows
  }
  updateEventsByPk(pkColumns: {id: $id}, _set: $_set) {
    addressString
    archivedAt
    ballCustomName
    ballType
    cancelReason
    canceledAt
    cityId
    cityString
    countryString
    coverImageFileName
    coverImageFileType
    coverImageHost
    coverImageOriginalFileName
    coverImagePath
    coverImageProvider
    coverImageProviderUrl
    coverImageUrl
    currency
    createdAt
    description
    displayLocation
    endDate
    endDateTime
    faqs {
      id
      question
      answer
      createdAt
    }
    geometry
    groupFormat
    groups(where: {deletedAt: {_isNull: true}}) {
      id
      bracketRankingMechanism
      createdAt
      desiredNumberOfPools
      endsAt
      format
      formatCustomName
      gamesPerMatch
      gender
      maximumAge
      maximumRating
      minimumAge
      minimumNumberOfGames
      minimumRating
      numberOfEliminationTeams
      numberOfEstimatedCourts
      priceUnitAmount
      scoringFormat
      startsAt
      teamLimit
      teamType
      title
      totalPoints
      winBy
      isAgeRestricted
      isRatingRequired
      isVairVairifiedRequired
      isWheelchair
      isMoneyBall
      moneyBallRewards
      timeSlots(where: {deletedAt: {_isNull: true}}, orderBy: {startsAt: ASC}) {
        id
        startsAt
        endsAt
      }
    }
    hasPrizes
    hostUserId
    id
    isRatingRequired
    paymentFulfillmentChannel
    isSanctioned
    isVairRequired
    latitude
    isShowPlayersGoing
    isShowCourtAssignments
    locale
    longitude
    organizerImageFileName
    organizerImageHost
    organizerImageFileType
    organizerImageOriginalFileName
    organizerImagePath
    organizerImageProvider
    organizerImageProviderUrl
    organizerImageUrl
    pickleballRatingScaleId
    pickleballRatingScale {
      id
      maximum
      minimum
      name
      order
      shortName
    }
    privacy
    prizeDescription
    publishedAt
    regionString
    registrationDeadlineDate
    registrationClosedAt
    registrationDeadlineDateTime
    registrationOpenDate
    registrationOpenDateTime
    registrationPriceUnitAmount
    scoringFormat
    showInPublicDate
    showInPublicDateTime
    slug
    sport
    startDate
    startDateTime
    status
    streetPrimaryString
    streetSecondaryString
    tennisRatingScaleId
    tennisRatingScale {
      id
      maximum
      minimum
      name
      order
      shortName
    }
    timezoneAbbreviation
    timezoneName
    timezoneOffsetMinutes
    title
    type
    zipcodeString
    venueId
    venue {
      id
      title
      latitude
      longitude
      timezone
      geometry
      latitude
      longitude
      timezone
      slug
      pickleballLines
      addressString
      accessType
      indoorCourtCount
      outdoorCourtCount
      pickleballNets
      images {
        id
        fileName
        url
        path
      }
      city {
        id
        name
        countrySubdivision {
          id
          name
        }
      }
      courtSurfaces {
        id
        courtSurface
      }
    }
    sponsors {
      id
      categoryName
      createdAt
      imageFileName
      imageFileType
      imageHost
      imagePath
      imageProvider
      imageProviderUrl
      imageUrl
      imageOriginalFileName
      name
      isTitleSponsor
    }
  }
}
    `;
export type UpdateEventByIdMutationFn = Apollo.MutationFunction<UpdateEventByIdMutation, UpdateEventByIdMutationVariables>;

/**
 * __useUpdateEventByIdMutation__
 *
 * To run a mutation, you first call `useUpdateEventByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventByIdMutation, { data, loading, error }] = useUpdateEventByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *      eventFaqObjects: // value for 'eventFaqObjects'
 *      eventSponsorObjects: // value for 'eventSponsorObjects'
 *   },
 * });
 */
export function useUpdateEventByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventByIdMutation, UpdateEventByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventByIdMutation, UpdateEventByIdMutationVariables>(UpdateEventByIdDocument, options);
      }
export type UpdateEventByIdMutationHookResult = ReturnType<typeof useUpdateEventByIdMutation>;
export type UpdateEventByIdMutationResult = Apollo.MutationResult<UpdateEventByIdMutation>;
export type UpdateEventByIdMutationOptions = Apollo.BaseMutationOptions<UpdateEventByIdMutation, UpdateEventByIdMutationVariables>;
export const UpdateEventGroupByIdDocument = gql`
    mutation updateEventGroupById($id: uuid!, $_set: EventGroupsSetInput = {}) {
  updateEventGroupsByPk(pkColumns: {id: $id}, _set: $_set) {
    id
    bracketRankingMechanism
    createdAt
    desiredNumberOfPools
    endsAt
    format
    formatCustomName
    gamesPerMatch
    gender
    maximumAge
    maximumRating
    minimumAge
    minimumNumberOfGames
    minimumRating
    numberOfEliminationTeams
    numberOfEstimatedCourts
    priceUnitAmount
    scoringFormat
    startsAt
    teamLimit
    teamType
    title
    totalPoints
    winBy
    isAgeRestricted
    isRatingRequired
    isVairVairifiedRequired
    isWheelchair
    isMoneyBall
    moneyBallRewards
  }
}
    `;
export type UpdateEventGroupByIdMutationFn = Apollo.MutationFunction<UpdateEventGroupByIdMutation, UpdateEventGroupByIdMutationVariables>;

/**
 * __useUpdateEventGroupByIdMutation__
 *
 * To run a mutation, you first call `useUpdateEventGroupByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventGroupByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventGroupByIdMutation, { data, loading, error }] = useUpdateEventGroupByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateEventGroupByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventGroupByIdMutation, UpdateEventGroupByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventGroupByIdMutation, UpdateEventGroupByIdMutationVariables>(UpdateEventGroupByIdDocument, options);
      }
export type UpdateEventGroupByIdMutationHookResult = ReturnType<typeof useUpdateEventGroupByIdMutation>;
export type UpdateEventGroupByIdMutationResult = Apollo.MutationResult<UpdateEventGroupByIdMutation>;
export type UpdateEventGroupByIdMutationOptions = Apollo.BaseMutationOptions<UpdateEventGroupByIdMutation, UpdateEventGroupByIdMutationVariables>;
export const SoftDeleteEventGroupDocument = gql`
    mutation softDeleteEventGroup($id: uuid!) {
  updateEventGroupsByPk(pkColumns: {id: $id}, _set: {deletedAt: "now()"}) {
    id
  }
}
    `;
export type SoftDeleteEventGroupMutationFn = Apollo.MutationFunction<SoftDeleteEventGroupMutation, SoftDeleteEventGroupMutationVariables>;

/**
 * __useSoftDeleteEventGroupMutation__
 *
 * To run a mutation, you first call `useSoftDeleteEventGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteEventGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteEventGroupMutation, { data, loading, error }] = useSoftDeleteEventGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftDeleteEventGroupMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteEventGroupMutation, SoftDeleteEventGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteEventGroupMutation, SoftDeleteEventGroupMutationVariables>(SoftDeleteEventGroupDocument, options);
      }
export type SoftDeleteEventGroupMutationHookResult = ReturnType<typeof useSoftDeleteEventGroupMutation>;
export type SoftDeleteEventGroupMutationResult = Apollo.MutationResult<SoftDeleteEventGroupMutation>;
export type SoftDeleteEventGroupMutationOptions = Apollo.BaseMutationOptions<SoftDeleteEventGroupMutation, SoftDeleteEventGroupMutationVariables>;
export const UpdateTournamentDataFromGroupDocument = gql`
    mutation updateTournamentDataFromGroup($id: uuid!, $scoringFormat: ScoringFormatEnum = TRADITIONAL, $isRatingRequired: Boolean = false, $groupFormat: EventGroupFormatsEnum = ROUND_ROBIN_SINGLE_ELIMINATION) {
  updateEventsByPk(
    pkColumns: {id: $id}
    _set: {scoringFormat: $scoringFormat, isRatingRequired: $isRatingRequired, groupFormat: $groupFormat}
  ) {
    id
    isRatingRequired
    scoringFormat
    groupFormat
  }
}
    `;
export type UpdateTournamentDataFromGroupMutationFn = Apollo.MutationFunction<UpdateTournamentDataFromGroupMutation, UpdateTournamentDataFromGroupMutationVariables>;

/**
 * __useUpdateTournamentDataFromGroupMutation__
 *
 * To run a mutation, you first call `useUpdateTournamentDataFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTournamentDataFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTournamentDataFromGroupMutation, { data, loading, error }] = useUpdateTournamentDataFromGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      scoringFormat: // value for 'scoringFormat'
 *      isRatingRequired: // value for 'isRatingRequired'
 *      groupFormat: // value for 'groupFormat'
 *   },
 * });
 */
export function useUpdateTournamentDataFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTournamentDataFromGroupMutation, UpdateTournamentDataFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTournamentDataFromGroupMutation, UpdateTournamentDataFromGroupMutationVariables>(UpdateTournamentDataFromGroupDocument, options);
      }
export type UpdateTournamentDataFromGroupMutationHookResult = ReturnType<typeof useUpdateTournamentDataFromGroupMutation>;
export type UpdateTournamentDataFromGroupMutationResult = Apollo.MutationResult<UpdateTournamentDataFromGroupMutation>;
export type UpdateTournamentDataFromGroupMutationOptions = Apollo.BaseMutationOptions<UpdateTournamentDataFromGroupMutation, UpdateTournamentDataFromGroupMutationVariables>;
export const GetActiveLessonsFromFollowedCoachesDocument = gql`
    query getActiveLessonsFromFollowedCoaches($followerUserId: uuid!) {
  userFollows(
    where: {followedProfile: {coachStatus: {_eq: "ACTIVE"}}, status: {_eq: ACTIVE}, followerUserId: {_eq: $followerUserId}}
  ) {
    id
    followedUserId
    followerUserId
    followedProfile {
      coachStatus
      coverImageFileName
      coverImagePath
      coverImageProviderUrl
      fullName
      id
      preferredName
      profileImageFileName
      profileImagePath
      profileImageProviderUrl
      username
      coachLessons(
        where: {status: {_eq: ACTIVE}, startDateTime: {_gte: "now()"}, privacy: {_eq: PUBLIC}}
      ) {
        ...lessonFields
      }
    }
  }
}
    ${LessonFieldsFragmentDoc}`;

/**
 * __useGetActiveLessonsFromFollowedCoachesQuery__
 *
 * To run a query within a React component, call `useGetActiveLessonsFromFollowedCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveLessonsFromFollowedCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveLessonsFromFollowedCoachesQuery({
 *   variables: {
 *      followerUserId: // value for 'followerUserId'
 *   },
 * });
 */
export function useGetActiveLessonsFromFollowedCoachesQuery(baseOptions: Apollo.QueryHookOptions<GetActiveLessonsFromFollowedCoachesQuery, GetActiveLessonsFromFollowedCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveLessonsFromFollowedCoachesQuery, GetActiveLessonsFromFollowedCoachesQueryVariables>(GetActiveLessonsFromFollowedCoachesDocument, options);
      }
export function useGetActiveLessonsFromFollowedCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveLessonsFromFollowedCoachesQuery, GetActiveLessonsFromFollowedCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveLessonsFromFollowedCoachesQuery, GetActiveLessonsFromFollowedCoachesQueryVariables>(GetActiveLessonsFromFollowedCoachesDocument, options);
        }
export type GetActiveLessonsFromFollowedCoachesQueryHookResult = ReturnType<typeof useGetActiveLessonsFromFollowedCoachesQuery>;
export type GetActiveLessonsFromFollowedCoachesLazyQueryHookResult = ReturnType<typeof useGetActiveLessonsFromFollowedCoachesLazyQuery>;
export type GetActiveLessonsFromFollowedCoachesQueryResult = Apollo.QueryResult<GetActiveLessonsFromFollowedCoachesQuery, GetActiveLessonsFromFollowedCoachesQueryVariables>;
export const GetPlayerVideoAnalysisBySubmitterIdDocument = gql`
    query getPlayerVideoAnalysisBySubmitterId($submissionUserId: uuid!) {
  videoAnalysis(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, orders: {status: {_eq: SUCCEEDED}}, submissionUserId: {_eq: $submissionUserId}}
    orderBy: {createdAt: DESC, reviewStatus: ASC}
  ) {
    id
    submissionRequestedFeedback
    reviewStatus
    videoAnalysisComments {
      videoAnalysisSkillsComments {
        videoLessonSkills {
          skill
          customSkill
        }
        videoAnalysisComments {
          details
          id
        }
      }
      sentiment
      id
    }
    videoAnalysisRequestedSkillsReviews {
      id
      videoLessonSkills {
        customSkill
        id
        skill
      }
    }
    videoAnalysisFiles {
      id
      host
      fileType
      fileName
      fileFormat
      fileCategory
      createdAt
      originalFileName
      provider
      providerId
      providerUrl
      updatedAt
      url
    }
    createdAt
    videoAnalysisSubmission {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    videoAnalysisReviewer {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
  }
  videoAnalysisAggregate(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, orders: {status: {_eq: SUCCEEDED}}, submissionUserId: {_eq: $submissionUserId}}
  ) {
    aggregate {
      count
    }
  }
  pendingVideoAnalysisCount: videoAnalysisAggregate(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, orders: {status: {_eq: SUCCEEDED}}, submissionUserId: {_eq: $submissionUserId}, reviewStatus: {_eq: PENDING}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPlayerVideoAnalysisBySubmitterIdQuery__
 *
 * To run a query within a React component, call `useGetPlayerVideoAnalysisBySubmitterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerVideoAnalysisBySubmitterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerVideoAnalysisBySubmitterIdQuery({
 *   variables: {
 *      submissionUserId: // value for 'submissionUserId'
 *   },
 * });
 */
export function useGetPlayerVideoAnalysisBySubmitterIdQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerVideoAnalysisBySubmitterIdQuery, GetPlayerVideoAnalysisBySubmitterIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerVideoAnalysisBySubmitterIdQuery, GetPlayerVideoAnalysisBySubmitterIdQueryVariables>(GetPlayerVideoAnalysisBySubmitterIdDocument, options);
      }
export function useGetPlayerVideoAnalysisBySubmitterIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerVideoAnalysisBySubmitterIdQuery, GetPlayerVideoAnalysisBySubmitterIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerVideoAnalysisBySubmitterIdQuery, GetPlayerVideoAnalysisBySubmitterIdQueryVariables>(GetPlayerVideoAnalysisBySubmitterIdDocument, options);
        }
export type GetPlayerVideoAnalysisBySubmitterIdQueryHookResult = ReturnType<typeof useGetPlayerVideoAnalysisBySubmitterIdQuery>;
export type GetPlayerVideoAnalysisBySubmitterIdLazyQueryHookResult = ReturnType<typeof useGetPlayerVideoAnalysisBySubmitterIdLazyQuery>;
export type GetPlayerVideoAnalysisBySubmitterIdQueryResult = Apollo.QueryResult<GetPlayerVideoAnalysisBySubmitterIdQuery, GetPlayerVideoAnalysisBySubmitterIdQueryVariables>;
export const GetPlayerReflectionByPlayerIdDocument = gql`
    query getPlayerReflectionByPlayerId($userId: uuid!) {
  lessons(
    where: {participants: {userId: {_eq: $userId}}}
    orderBy: {startDateTime: DESC}
  ) {
    id
    title
    type
    sport
    participantLimit
    timezoneName
    venue {
      id
      slug
      title
      timezone
      addressString
    }
    userCustomCourt {
      fullAddress
    }
    times {
      startDateTime
      endDateTime
    }
    participantsAggregate {
      aggregate {
        count
      }
    }
    roster: participants {
      id
      userProfile {
        id
        fullName
        profileImageProviderUrl
      }
    }
    lessonPlayerSkillAssessments {
      id
    }
    ownerProfile {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    participants(where: {userProfile: {id: {_eq: $userId}}}) {
      id
      userId
      recapSkippedAt
      userProfile {
        id
        fullName
        profileImageProviderUrl
        profileImageFileName
      }
    }
    lessonReflections {
      upcomingCategory
      upcomingSport
      completedCategory
      completedSport
      createdAt
      details
      id
      lessonId
      submissionRequestedFeedback
      updatedAt
      reviewStatus
      completedCategory
      completedSport
      lesson {
        times {
          startDateTime
        }
      }
      files {
        createdAt
        fileCategory
        fileFormat
        fileName
        fileType
        host
        id
        provider
        providerId
        providerUrl
        url
        userId
        originalFileName
        transcript
      }
      lessonCoach {
        id
        fullName
        priceUnitAmountCoachDefault
        priceUnitAmountRemoteCoachDefault
        profileImageFileName
        profileImagePath
        profileImageProvider
        profileImageProviderUrl
        preferredName
        username
        geometry
        defaultSport
        isPciMember
        stripeMerchantCurrency
        currencyCoachDefault
        stripeMerchantChargesEnabled
        coachAvailability {
          id
          endTimeMinutes
          dayOfWeek
          startTimeMinutes
          status
          coachAvailabilityCustomCourt {
            id
          }
          coachAvailabilityVenueId {
            id
          }
        }
        coachLessons(where: {startDateTime: {_gte: "NOW()"}}) {
          id
          ownerUserId
          startDateTime
          endDateTime
          timezoneName
          timezoneAbbreviation
          timezoneOffsetMinutes
          participantLimit
          currency
        }
        coachExternalBookingUrl
        defaultCoachVenue {
          addressString
          id
        }
        defaultCoachCustomCourt {
          title
          id
          fullAddress
        }
        followersAggregate {
          aggregate {
            count
          }
        }
      }
      lessonPlayer {
        id
        fullName
        profileImageProviderUrl
        profileImageFileName
      }
      lessonReflectionComments {
        type
        createdAt
        id
        order
        sentiment
        skill
        customSkill
        updatedAt
        details
        lessonReflectionFiles {
          createdAt
          fileCategory
          fileFormat
          fileName
          fileType
          host
          id
          provider
          providerId
          providerUrl
          transcript
          transcriptEndedAt
          transcriptStartedAt
          url
        }
      }
    }
  }
  lessonPlayerSkillAssessments(where: {playerUserId: {_eq: $userId}}) {
    coachUserId
    playerUserId
    lessonId
    id
    lesson {
      lessonReflections {
        id
      }
    }
    lessonPlayer {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    lessonCoach {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    lessonPlayerSkillAssessmentsSkills {
      category
      createdAt
      skill
    }
  }
  lessonReflections(where: {playerUserId: {_eq: $userId}}) {
    createdAt
    details
    id
    lessonId
    submissionRequestedFeedback
    updatedAt
    reviewStatus
    upcomingCategory
    upcomingSport
    completedCategory
    completedSport
    files {
      createdAt
      fileCategory
      fileFormat
      fileName
      fileType
      host
      id
      provider
      providerId
      providerUrl
      url
      userId
      originalFileName
    }
    lesson {
      lessonPlayerSkillAssessments {
        id
      }
    }
    lessonPlayer {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    lessonCoach {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    lessonReflectionComments {
      type
      createdAt
      id
      order
      sentiment
      skill
      customSkill
      updatedAt
      lessonReflectionFiles {
        createdAt
        fileCategory
        fileFormat
        fileName
        fileType
        host
        id
        provider
        providerId
        providerUrl
        transcript
        transcriptEndedAt
        transcriptStartedAt
        url
      }
    }
  }
}
    `;

/**
 * __useGetPlayerReflectionByPlayerIdQuery__
 *
 * To run a query within a React component, call `useGetPlayerReflectionByPlayerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerReflectionByPlayerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerReflectionByPlayerIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPlayerReflectionByPlayerIdQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerReflectionByPlayerIdQuery, GetPlayerReflectionByPlayerIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerReflectionByPlayerIdQuery, GetPlayerReflectionByPlayerIdQueryVariables>(GetPlayerReflectionByPlayerIdDocument, options);
      }
export function useGetPlayerReflectionByPlayerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerReflectionByPlayerIdQuery, GetPlayerReflectionByPlayerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerReflectionByPlayerIdQuery, GetPlayerReflectionByPlayerIdQueryVariables>(GetPlayerReflectionByPlayerIdDocument, options);
        }
export type GetPlayerReflectionByPlayerIdQueryHookResult = ReturnType<typeof useGetPlayerReflectionByPlayerIdQuery>;
export type GetPlayerReflectionByPlayerIdLazyQueryHookResult = ReturnType<typeof useGetPlayerReflectionByPlayerIdLazyQuery>;
export type GetPlayerReflectionByPlayerIdQueryResult = Apollo.QueryResult<GetPlayerReflectionByPlayerIdQuery, GetPlayerReflectionByPlayerIdQueryVariables>;
export const InsertPlayerLessonReflectionDocument = gql`
    mutation insertPlayerLessonReflection($playerUserId: uuid!, $coachUserId: uuid!, $lessonId: uuid!, $skills: [LessonPlayerSkillAssessmentsSkillsInsertInput!]!) {
  insertLessonPlayerSkillAssessmentsOne(
    object: {lessonId: $lessonId, coachUserId: $coachUserId, playerUserId: $playerUserId, lessonPlayerSkillAssessmentsSkills: {data: $skills, onConflict: {constraint: lesson_player_skill_assessments_skills_pkey, updateColumns: deletedAt}}}
  ) {
    id
    lessonId
  }
}
    `;
export type InsertPlayerLessonReflectionMutationFn = Apollo.MutationFunction<InsertPlayerLessonReflectionMutation, InsertPlayerLessonReflectionMutationVariables>;

/**
 * __useInsertPlayerLessonReflectionMutation__
 *
 * To run a mutation, you first call `useInsertPlayerLessonReflectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPlayerLessonReflectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPlayerLessonReflectionMutation, { data, loading, error }] = useInsertPlayerLessonReflectionMutation({
 *   variables: {
 *      playerUserId: // value for 'playerUserId'
 *      coachUserId: // value for 'coachUserId'
 *      lessonId: // value for 'lessonId'
 *      skills: // value for 'skills'
 *   },
 * });
 */
export function useInsertPlayerLessonReflectionMutation(baseOptions?: Apollo.MutationHookOptions<InsertPlayerLessonReflectionMutation, InsertPlayerLessonReflectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPlayerLessonReflectionMutation, InsertPlayerLessonReflectionMutationVariables>(InsertPlayerLessonReflectionDocument, options);
      }
export type InsertPlayerLessonReflectionMutationHookResult = ReturnType<typeof useInsertPlayerLessonReflectionMutation>;
export type InsertPlayerLessonReflectionMutationResult = Apollo.MutationResult<InsertPlayerLessonReflectionMutation>;
export type InsertPlayerLessonReflectionMutationOptions = Apollo.BaseMutationOptions<InsertPlayerLessonReflectionMutation, InsertPlayerLessonReflectionMutationVariables>;
export const UpdatePlayerLessonReflectionDocument = gql`
    mutation updatePlayerLessonReflection($lessonPlayerReflectionId: uuid!, $lessonId: uuid!, $skills: [LessonPlayerSkillAssessmentsSkillsInsertInput!]!) {
  deleteLessonPlayerSkillAssessmentsSkills(
    where: {category: {_eq: NEXT_GOAL}, lessonPlayerSkillAssessmentId: {_eq: $lessonPlayerReflectionId}, lessonPlayerSkilAssessment: {lessonId: {_eq: $lessonId}}}
  ) {
    returning {
      id
    }
  }
  insertLessonPlayerSkillAssessmentsSkills(objects: $skills) {
    returning {
      skill
    }
  }
}
    `;
export type UpdatePlayerLessonReflectionMutationFn = Apollo.MutationFunction<UpdatePlayerLessonReflectionMutation, UpdatePlayerLessonReflectionMutationVariables>;

/**
 * __useUpdatePlayerLessonReflectionMutation__
 *
 * To run a mutation, you first call `useUpdatePlayerLessonReflectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlayerLessonReflectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlayerLessonReflectionMutation, { data, loading, error }] = useUpdatePlayerLessonReflectionMutation({
 *   variables: {
 *      lessonPlayerReflectionId: // value for 'lessonPlayerReflectionId'
 *      lessonId: // value for 'lessonId'
 *      skills: // value for 'skills'
 *   },
 * });
 */
export function useUpdatePlayerLessonReflectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlayerLessonReflectionMutation, UpdatePlayerLessonReflectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlayerLessonReflectionMutation, UpdatePlayerLessonReflectionMutationVariables>(UpdatePlayerLessonReflectionDocument, options);
      }
export type UpdatePlayerLessonReflectionMutationHookResult = ReturnType<typeof useUpdatePlayerLessonReflectionMutation>;
export type UpdatePlayerLessonReflectionMutationResult = Apollo.MutationResult<UpdatePlayerLessonReflectionMutation>;
export type UpdatePlayerLessonReflectionMutationOptions = Apollo.BaseMutationOptions<UpdatePlayerLessonReflectionMutation, UpdatePlayerLessonReflectionMutationVariables>;
export const GetTrainingLogsInfoByPlayerIdDocument = gql`
    query getTrainingLogsInfoByPlayerId($userId: uuid!) {
  lessonsAggregate(where: {participants: {userId: {_eq: $userId}}}) {
    aggregate {
      count
    }
  }
  videoAnalysisAggregate(where: {submissionUserId: {_eq: $userId}}) {
    aggregate {
      count
    }
  }
  videoAnalysis(
    where: {submissionUserId: {_eq: $userId}}
    orderBy: {createdAt: DESC}
  ) {
    id
    videoAnalysisReviewer {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    videoAnalysisRequestedSkillsReviews {
      id
      videoLessonSkills {
        customSkill
        id
        skill
      }
    }
    videoAnalysisComments {
      videoAnalysisFiles {
        fileType
        fileFormat
        fileCategory
        url
      }
      videoAnalysisSkillsComments {
        videoLessonSkills {
          skill
          customSkill
        }
      }
      sentiment
      createdAt
      details
    }
    videoAnalysisFiles {
      id
      url
      fileType
      fileFormat
      fileCategory
    }
    createdAt
  }
  lessons(
    limit: 10
    orderBy: {createdAt: DESC}
    where: {participants: {userId: {_eq: $userId}}, times: {endDateTime: {_lte: "now()"}}}
  ) {
    times {
      endDateTime
      startDateTime
    }
    ownerProfile {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    id
    lessonReflections {
      upcomingCategory
      upcomingSport
      completedCategory
      completedSport
      files {
        createdAt
        fileCategory
        fileFormat
        fileName
        fileType
        host
        id
        provider
        providerId
        providerUrl
        url
        userId
        originalFileName
      }
      lessonPlayer {
        id
        fullName
        profileImageProviderUrl
        profileImageFileName
      }
      lessonReflectionComments {
        lessonReflectionFiles {
          id
          host
          fileType
          fileName
          fileFormat
          fileCategory
          deletedAt
          createdAt
          originalFileName
          provider
          providerId
          providerUrl
          url
        }
        id
        details
        createdAt
        sentiment
        type
        skill
        order
      }
      lessonId
      details
    }
  }
  lessonPlayerSkillAssessments(where: {playerUserId: {_eq: $userId}}) {
    id
    lessonId
    playerUserId
    coachUserId
    lessonPlayerSkillAssessmentsSkills {
      category
      createdAt
      skill
    }
  }
}
    `;

/**
 * __useGetTrainingLogsInfoByPlayerIdQuery__
 *
 * To run a query within a React component, call `useGetTrainingLogsInfoByPlayerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingLogsInfoByPlayerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrainingLogsInfoByPlayerIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetTrainingLogsInfoByPlayerIdQuery(baseOptions: Apollo.QueryHookOptions<GetTrainingLogsInfoByPlayerIdQuery, GetTrainingLogsInfoByPlayerIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrainingLogsInfoByPlayerIdQuery, GetTrainingLogsInfoByPlayerIdQueryVariables>(GetTrainingLogsInfoByPlayerIdDocument, options);
      }
export function useGetTrainingLogsInfoByPlayerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrainingLogsInfoByPlayerIdQuery, GetTrainingLogsInfoByPlayerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrainingLogsInfoByPlayerIdQuery, GetTrainingLogsInfoByPlayerIdQueryVariables>(GetTrainingLogsInfoByPlayerIdDocument, options);
        }
export type GetTrainingLogsInfoByPlayerIdQueryHookResult = ReturnType<typeof useGetTrainingLogsInfoByPlayerIdQuery>;
export type GetTrainingLogsInfoByPlayerIdLazyQueryHookResult = ReturnType<typeof useGetTrainingLogsInfoByPlayerIdLazyQuery>;
export type GetTrainingLogsInfoByPlayerIdQueryResult = Apollo.QueryResult<GetTrainingLogsInfoByPlayerIdQuery, GetTrainingLogsInfoByPlayerIdQueryVariables>;
export const GetVideoAnalysisByIdDocument = gql`
    query getVideoAnalysisById($videoAnalysisId: uuid!) {
  videoAnalysis(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, id: {_eq: $videoAnalysisId}}
  ) {
    id
    submissionRequestedFeedback
    videoAnalysisRequestedSkillsReviews {
      id
      videoLessonSkills {
        customSkill
        id
        skill
      }
    }
    videoAnalysisFiles {
      id
      host
      fileType
      fileName
      fileFormat
      fileCategory
      createdAt
      originalFileName
      provider
      providerId
      providerUrl
      updatedAt
      url
    }
    createdAt
    videoAnalysisSubmission {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    videoAnalysisReviewer {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
  }
}
    `;

/**
 * __useGetVideoAnalysisByIdQuery__
 *
 * To run a query within a React component, call `useGetVideoAnalysisByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoAnalysisByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoAnalysisByIdQuery({
 *   variables: {
 *      videoAnalysisId: // value for 'videoAnalysisId'
 *   },
 * });
 */
export function useGetVideoAnalysisByIdQuery(baseOptions: Apollo.QueryHookOptions<GetVideoAnalysisByIdQuery, GetVideoAnalysisByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoAnalysisByIdQuery, GetVideoAnalysisByIdQueryVariables>(GetVideoAnalysisByIdDocument, options);
      }
export function useGetVideoAnalysisByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoAnalysisByIdQuery, GetVideoAnalysisByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoAnalysisByIdQuery, GetVideoAnalysisByIdQueryVariables>(GetVideoAnalysisByIdDocument, options);
        }
export type GetVideoAnalysisByIdQueryHookResult = ReturnType<typeof useGetVideoAnalysisByIdQuery>;
export type GetVideoAnalysisByIdLazyQueryHookResult = ReturnType<typeof useGetVideoAnalysisByIdLazyQuery>;
export type GetVideoAnalysisByIdQueryResult = Apollo.QueryResult<GetVideoAnalysisByIdQuery, GetVideoAnalysisByIdQueryVariables>;
export const GetVideoAnalysisCommentsByIdDocument = gql`
    query getVideoAnalysisCommentsById($videoAnalysisId: uuid!) {
  videoAnalysisComments(
    where: {videoAnalysisId: {_eq: $videoAnalysisId}}
    orderBy: {startTimestampSeconds: ASC}
  ) {
    createdAt
    details
    sentiment
    id
    endTimestampSeconds
    startTimestampSeconds
    videoAnalysisFiles {
      createdAt
      deletedAt
      fileCategory
      fileFormat
      fileName
      fileType
      host
      id
      originalFileName
      provider
      providerId
      providerUrl
      url
      userId
      uploadStatus
      transcript
      transcriptionStartedAt
      transcriptionCompletedAt
    }
    videoAnalysisSkillsComments(orderBy: {createdAt: DESC}) {
      id
      videoLessonSkills {
        customSkill
        createdAt
        updatedAt
        skill
        id
      }
    }
  }
}
    `;

/**
 * __useGetVideoAnalysisCommentsByIdQuery__
 *
 * To run a query within a React component, call `useGetVideoAnalysisCommentsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoAnalysisCommentsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoAnalysisCommentsByIdQuery({
 *   variables: {
 *      videoAnalysisId: // value for 'videoAnalysisId'
 *   },
 * });
 */
export function useGetVideoAnalysisCommentsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetVideoAnalysisCommentsByIdQuery, GetVideoAnalysisCommentsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoAnalysisCommentsByIdQuery, GetVideoAnalysisCommentsByIdQueryVariables>(GetVideoAnalysisCommentsByIdDocument, options);
      }
export function useGetVideoAnalysisCommentsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoAnalysisCommentsByIdQuery, GetVideoAnalysisCommentsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoAnalysisCommentsByIdQuery, GetVideoAnalysisCommentsByIdQueryVariables>(GetVideoAnalysisCommentsByIdDocument, options);
        }
export type GetVideoAnalysisCommentsByIdQueryHookResult = ReturnType<typeof useGetVideoAnalysisCommentsByIdQuery>;
export type GetVideoAnalysisCommentsByIdLazyQueryHookResult = ReturnType<typeof useGetVideoAnalysisCommentsByIdLazyQuery>;
export type GetVideoAnalysisCommentsByIdQueryResult = Apollo.QueryResult<GetVideoAnalysisCommentsByIdQuery, GetVideoAnalysisCommentsByIdQueryVariables>;
export const UpdateVideoAnalysisStatusByIdDocument = gql`
    mutation updateVideoAnalysisStatusById($videoAnalysisId: uuid!, $status: VideoAnalysisReviewStatusesEnum!) {
  updateVideoAnalysis(
    where: {id: {_eq: $videoAnalysisId}}
    _set: {reviewStatus: $status}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateVideoAnalysisStatusByIdMutationFn = Apollo.MutationFunction<UpdateVideoAnalysisStatusByIdMutation, UpdateVideoAnalysisStatusByIdMutationVariables>;

/**
 * __useUpdateVideoAnalysisStatusByIdMutation__
 *
 * To run a mutation, you first call `useUpdateVideoAnalysisStatusByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoAnalysisStatusByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoAnalysisStatusByIdMutation, { data, loading, error }] = useUpdateVideoAnalysisStatusByIdMutation({
 *   variables: {
 *      videoAnalysisId: // value for 'videoAnalysisId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateVideoAnalysisStatusByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVideoAnalysisStatusByIdMutation, UpdateVideoAnalysisStatusByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVideoAnalysisStatusByIdMutation, UpdateVideoAnalysisStatusByIdMutationVariables>(UpdateVideoAnalysisStatusByIdDocument, options);
      }
export type UpdateVideoAnalysisStatusByIdMutationHookResult = ReturnType<typeof useUpdateVideoAnalysisStatusByIdMutation>;
export type UpdateVideoAnalysisStatusByIdMutationResult = Apollo.MutationResult<UpdateVideoAnalysisStatusByIdMutation>;
export type UpdateVideoAnalysisStatusByIdMutationOptions = Apollo.BaseMutationOptions<UpdateVideoAnalysisStatusByIdMutation, UpdateVideoAnalysisStatusByIdMutationVariables>;
export const GetEventsByPlayerIdDocument = gql`
    query getEventsByPlayerId($userId: uuid!, $startDate: date!) {
  hostingEvents: events(
    where: {type: {_eq: TOURNAMENT}, status: {_eq: PUBLISHED}, archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, startDate: {_gte: $startDate}, hostUserId: {_eq: $userId}}
    orderBy: {startDate: ASC}
  ) {
    id
    registrationsAggregate {
      aggregate {
        count
      }
    }
    registrations {
      userId
      userProfile {
        fullName
        id
      }
    }
    coverImageProviderUrl
    coverImageFileName
    geometry
    organizerImageOriginalFileName
    organizerImageProvider
    organizerImageProviderUrl
    slug
    startDate
    startDateTime
    endDate
    endDateTime
    status
    addressString
    title
    venue {
      id
      title
      addressString
    }
    coverImageProvider
  }
  attendingEvents: events(
    where: {type: {_eq: TOURNAMENT}, status: {_eq: PUBLISHED}, registrations: {userId: {_eq: $userId}}, archivedAt: {_isNull: true}, deletedAt: {_isNull: true}, startDate: {_gte: $startDate}}
    orderBy: {createdAt: ASC}
  ) {
    id
    registrationsAggregate {
      aggregate {
        count
      }
    }
    registrations {
      userId
      userProfile {
        fullName
        id
      }
    }
    coverImageProviderUrl
    coverImageFileName
    geometry
    organizerImageOriginalFileName
    organizerImageProvider
    organizerImageProviderUrl
    slug
    startDate
    startDateTime
    endDate
    endDateTime
    status
    addressString
    title
    venue {
      id
      title
      addressString
    }
    coverImageProvider
  }
}
    `;

/**
 * __useGetEventsByPlayerIdQuery__
 *
 * To run a query within a React component, call `useGetEventsByPlayerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsByPlayerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsByPlayerIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetEventsByPlayerIdQuery(baseOptions: Apollo.QueryHookOptions<GetEventsByPlayerIdQuery, GetEventsByPlayerIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsByPlayerIdQuery, GetEventsByPlayerIdQueryVariables>(GetEventsByPlayerIdDocument, options);
      }
export function useGetEventsByPlayerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsByPlayerIdQuery, GetEventsByPlayerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsByPlayerIdQuery, GetEventsByPlayerIdQueryVariables>(GetEventsByPlayerIdDocument, options);
        }
export type GetEventsByPlayerIdQueryHookResult = ReturnType<typeof useGetEventsByPlayerIdQuery>;
export type GetEventsByPlayerIdLazyQueryHookResult = ReturnType<typeof useGetEventsByPlayerIdLazyQuery>;
export type GetEventsByPlayerIdQueryResult = Apollo.QueryResult<GetEventsByPlayerIdQuery, GetEventsByPlayerIdQueryVariables>;
export const GetPlayerVideoAnalysisCompletedByPlayerIdDocument = gql`
    query getPlayerVideoAnalysisCompletedByPlayerId($playerId: uuid!, $offset: Int = 0, $limit: Int = 10) {
  videoAnalysis(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, submissionUserId: {_eq: $playerId}, reviewStatus: {_in: [COMPLETE, REVIEWED]}}
    orderBy: {reviewStatus: DESC, createdAt: DESC}
    offset: $offset
    limit: $limit
  ) {
    id
    submissionRequestedFeedback
    videoAnalysisRequestedSkillsReviews {
      id
      videoLessonSkills {
        customSkill
        id
        skill
      }
    }
    videoAnalysisFiles {
      id
      host
      fileType
      fileName
      fileFormat
      fileCategory
      createdAt
      originalFileName
      provider
      providerId
      providerUrl
      updatedAt
      url
    }
    createdAt
    videoAnalysisSubmission {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    videoAnalysisReviewer {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
  }
  videoAnalysisAggregate(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, submissionUserId: {_eq: $playerId}, reviewStatus: {_in: [COMPLETE, REVIEWED]}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPlayerVideoAnalysisCompletedByPlayerIdQuery__
 *
 * To run a query within a React component, call `useGetPlayerVideoAnalysisCompletedByPlayerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerVideoAnalysisCompletedByPlayerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerVideoAnalysisCompletedByPlayerIdQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPlayerVideoAnalysisCompletedByPlayerIdQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerVideoAnalysisCompletedByPlayerIdQuery, GetPlayerVideoAnalysisCompletedByPlayerIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerVideoAnalysisCompletedByPlayerIdQuery, GetPlayerVideoAnalysisCompletedByPlayerIdQueryVariables>(GetPlayerVideoAnalysisCompletedByPlayerIdDocument, options);
      }
export function useGetPlayerVideoAnalysisCompletedByPlayerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerVideoAnalysisCompletedByPlayerIdQuery, GetPlayerVideoAnalysisCompletedByPlayerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerVideoAnalysisCompletedByPlayerIdQuery, GetPlayerVideoAnalysisCompletedByPlayerIdQueryVariables>(GetPlayerVideoAnalysisCompletedByPlayerIdDocument, options);
        }
export type GetPlayerVideoAnalysisCompletedByPlayerIdQueryHookResult = ReturnType<typeof useGetPlayerVideoAnalysisCompletedByPlayerIdQuery>;
export type GetPlayerVideoAnalysisCompletedByPlayerIdLazyQueryHookResult = ReturnType<typeof useGetPlayerVideoAnalysisCompletedByPlayerIdLazyQuery>;
export type GetPlayerVideoAnalysisCompletedByPlayerIdQueryResult = Apollo.QueryResult<GetPlayerVideoAnalysisCompletedByPlayerIdQuery, GetPlayerVideoAnalysisCompletedByPlayerIdQueryVariables>;
export const GetPlayerVideoAnalysisPendingByPlayerIdDocument = gql`
    query getPlayerVideoAnalysisPendingByPlayerId($playerId: uuid!, $offset: Int = 0, $limit: Int = 10) {
  videoAnalysis(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, submissionUserId: {_eq: $playerId}, reviewStatus: {_eq: PENDING}}
    orderBy: {reviewStatus: DESC, createdAt: DESC}
    offset: $offset
    limit: $limit
  ) {
    id
    submissionRequestedFeedback
    videoAnalysisRequestedSkillsReviews {
      id
      videoLessonSkills {
        customSkill
        id
        skill
      }
    }
    videoAnalysisFiles {
      id
      host
      fileType
      fileName
      fileFormat
      fileCategory
      createdAt
      originalFileName
      provider
      providerId
      providerUrl
      updatedAt
      url
    }
    createdAt
    videoAnalysisSubmission {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
    videoAnalysisReviewer {
      id
      fullName
      profileImageProviderUrl
      profileImageFileName
    }
  }
  videoAnalysisAggregate(
    where: {videoAnalysisFiles: {uploadStatus: {_eq: COMPLETE}}, submissionUserId: {_eq: $playerId}, reviewStatus: {_eq: PENDING}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPlayerVideoAnalysisPendingByPlayerIdQuery__
 *
 * To run a query within a React component, call `useGetPlayerVideoAnalysisPendingByPlayerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerVideoAnalysisPendingByPlayerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerVideoAnalysisPendingByPlayerIdQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPlayerVideoAnalysisPendingByPlayerIdQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerVideoAnalysisPendingByPlayerIdQuery, GetPlayerVideoAnalysisPendingByPlayerIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerVideoAnalysisPendingByPlayerIdQuery, GetPlayerVideoAnalysisPendingByPlayerIdQueryVariables>(GetPlayerVideoAnalysisPendingByPlayerIdDocument, options);
      }
export function useGetPlayerVideoAnalysisPendingByPlayerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerVideoAnalysisPendingByPlayerIdQuery, GetPlayerVideoAnalysisPendingByPlayerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerVideoAnalysisPendingByPlayerIdQuery, GetPlayerVideoAnalysisPendingByPlayerIdQueryVariables>(GetPlayerVideoAnalysisPendingByPlayerIdDocument, options);
        }
export type GetPlayerVideoAnalysisPendingByPlayerIdQueryHookResult = ReturnType<typeof useGetPlayerVideoAnalysisPendingByPlayerIdQuery>;
export type GetPlayerVideoAnalysisPendingByPlayerIdLazyQueryHookResult = ReturnType<typeof useGetPlayerVideoAnalysisPendingByPlayerIdLazyQuery>;
export type GetPlayerVideoAnalysisPendingByPlayerIdQueryResult = Apollo.QueryResult<GetPlayerVideoAnalysisPendingByPlayerIdQuery, GetPlayerVideoAnalysisPendingByPlayerIdQueryVariables>;